
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("5C8IU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $416744a0a1673bb3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $416744a0a1673bb3$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $416744a0a1673bb3$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("ePWXO")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("aVZKi")).default);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5rflj = parcelRequire("5rflj");

var $8rteH = parcelRequire("8rteH");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $ePWXO = parcelRequire("ePWXO");

var $aVZKi = parcelRequire("aVZKi");
'use client';
function $416744a0a1673bb3$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $416744a0a1673bb3$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $416744a0a1673bb3$var$wrapper = [];
function $416744a0a1673bb3$export$13a2d3ef13012b32(styles) {
    $416744a0a1673bb3$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($416744a0a1673bb3$var$wrapper);
}

});
parcelRegister("5rflj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("ePWXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd3910f2f17ba0e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $acd3910f2f17ba0e$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $a9M6v.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $acd3910f2f17ba0e$var$cacheMap = new Map();
function $acd3910f2f17ba0e$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $acw62.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $acd3910f2f17ba0e$var$cacheMap.has(cacheKey)) return $acd3910f2f17ba0e$var$cacheMap.get(cacheKey);
        const fresh = $acd3910f2f17ba0e$var$getCache(injectFirst, enableCssLayer);
        $acd3910f2f17ba0e$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});


parcelRegister("aVZKi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f5f1fa669ccc202$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $7f5f1fa669ccc202$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $7f5f1fa669ccc202$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($7f5f1fa669ccc202$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("dsPLe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cpmCj")).default);

var $cpmCj = parcelRequire("cpmCj");

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("lYE9x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1jJMI")).default);

var $1jJMI = parcelRequire("1jJMI");

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2A1GY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gxvzd")).default);

var $gxvzd = parcelRequire("gxvzd");

});
parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("eQufN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eWm0o")).default);

var $eWm0o = parcelRequire("eWm0o");
$parcel$exportWildcard(module.exports, $eWm0o);

});
parcelRegister("eWm0o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $ae078d4716220a63$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ae078d4716220a63$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ae078d4716220a63$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ae078d4716220a63$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $ae078d4716220a63$export$aad197c7121a6651(Component) || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jPKB.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});
parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                    case $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});




parcelRegister("c3nGe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8NnpI")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("2F4pg")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("2PWu5")).default);

var $8NnpI = parcelRequire("8NnpI");

var $2F4pg = parcelRequire("2F4pg");

var $2PWu5 = parcelRequire("2PWu5");

});
parcelRegister("8NnpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $66750fd06db62b1c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $2F4pg = parcelRequire("2F4pg");

var $jrZOE = parcelRequire("jrZOE");

var $2YDV9 = parcelRequire("2YDV9");

var $g91qR = parcelRequire("g91qR");

var $5iHq4 = parcelRequire("5iHq4");

var $2PWu5 = parcelRequire("2PWu5");
const $66750fd06db62b1c$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $66750fd06db62b1c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $66750fd06db62b1c$var$_excluded);
    const breakpoints = (0, $2F4pg.default)(breakpointsInput);
    const spacing = (0, $2YDV9.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $jrZOE.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2PWu5.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $5iHq4.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $66750fd06db62b1c$export$2e2bcd8739ae039 = $66750fd06db62b1c$var$createTheme;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("2F4pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f02d41e88337c5c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $1f02d41e88337c5c$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $1f02d41e88337c5c$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $1f02d41e88337c5c$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $1f02d41e88337c5c$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $1f02d41e88337c5c$var$_excluded);
    const sortedValues = $1f02d41e88337c5c$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("jrZOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2907d4f90ca619b$export$2e2bcd8739ae039);
const $e2907d4f90ca619b$var$shape = {
    borderRadius: 4
};
var $e2907d4f90ca619b$export$2e2bcd8739ae039 = $e2907d4f90ca619b$var$shape;

});

parcelRegister("2YDV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b026ca2499c378$export$2e2bcd8739ae039);

var $fbH80 = parcelRequire("fbH80");
function $22b026ca2499c378$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fbH80.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("fbH80", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $b0e9566e383397d0$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $b0e9566e383397d0$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $b0e9566e383397d0$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $b0e9566e383397d0$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $b0e9566e383397d0$export$6f98e8eaf0be1996);


var $lWAfe = parcelRequire("lWAfe");

var $9liTZ = parcelRequire("9liTZ");

var $aliUM = parcelRequire("aliUM");

var $6MB9o = parcelRequire("6MB9o");
const $b0e9566e383397d0$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $b0e9566e383397d0$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $b0e9566e383397d0$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b0e9566e383397d0$var$getCssProperties = (0, $6MB9o.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b0e9566e383397d0$var$aliases[prop]) prop = $b0e9566e383397d0$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $b0e9566e383397d0$var$properties[a];
    const direction = $b0e9566e383397d0$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b0e9566e383397d0$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $b0e9566e383397d0$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $b0e9566e383397d0$var$spacingKeys = [
    ...$b0e9566e383397d0$export$aab52a0dde05ad8a,
    ...$b0e9566e383397d0$export$f8397d44f03ab6ad
];
function $b0e9566e383397d0$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $9liTZ.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $b0e9566e383397d0$export$1def6f833384e3d1(theme) {
    return $b0e9566e383397d0$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $b0e9566e383397d0$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $b0e9566e383397d0$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b0e9566e383397d0$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b0e9566e383397d0$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b0e9566e383397d0$var$getCssProperties(prop);
    const styleFromPropValue = $b0e9566e383397d0$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $lWAfe.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b0e9566e383397d0$var$style(props, keys) {
    const transformer = $b0e9566e383397d0$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b0e9566e383397d0$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aliUM.default), {});
}
function $b0e9566e383397d0$export$7ede87f9b603dd3c(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$export$aab52a0dde05ad8a);
}
$b0e9566e383397d0$export$7ede87f9b603dd3c.propTypes = {};
$b0e9566e383397d0$export$7ede87f9b603dd3c.filterProps = $b0e9566e383397d0$export$aab52a0dde05ad8a;
function $b0e9566e383397d0$export$6f98e8eaf0be1996(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$export$f8397d44f03ab6ad);
}
$b0e9566e383397d0$export$6f98e8eaf0be1996.propTypes = {};
$b0e9566e383397d0$export$6f98e8eaf0be1996.filterProps = $b0e9566e383397d0$export$f8397d44f03ab6ad;
function $b0e9566e383397d0$var$spacing(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$var$spacingKeys);
}
$b0e9566e383397d0$var$spacing.propTypes = {};
$b0e9566e383397d0$var$spacing.filterProps = $b0e9566e383397d0$var$spacingKeys;
var $b0e9566e383397d0$export$2e2bcd8739ae039 = $b0e9566e383397d0$var$spacing;

});
parcelRegister("lWAfe", function(module, exports) {

$parcel$export(module.exports, "values", () => $ff9b2135c2bff8b7$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $ff9b2135c2bff8b7$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $ff9b2135c2bff8b7$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $ff9b2135c2bff8b7$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $ff9b2135c2bff8b7$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $ff9b2135c2bff8b7$export$980e6a259d807490);

var $8nd05 = parcelRequire("8nd05");


var $3z1Ay = parcelRequire("3z1Ay");

var $aliUM = parcelRequire("aliUM");
const $ff9b2135c2bff8b7$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $ff9b2135c2bff8b7$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$ff9b2135c2bff8b7$export$68c286be0e7e55b7[key]}px)`
};
function $ff9b2135c2bff8b7$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $ff9b2135c2bff8b7$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $ff9b2135c2bff8b7$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aliUM.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $ff9b2135c2bff8b7$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ff9b2135c2bff8b7$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ff9b2135c2bff8b7$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $ff9b2135c2bff8b7$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $ff9b2135c2bff8b7$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $ff9b2135c2bff8b7$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ff9b2135c2bff8b7$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $ff9b2135c2bff8b7$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $ff9b2135c2bff8b7$export$2e2bcd8739ae039 = $ff9b2135c2bff8b7$var$breakpoints;

});
parcelRegister("aliUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $787a899efa293fda$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $787a899efa293fda$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $787a899efa293fda$export$2e2bcd8739ae039 = $787a899efa293fda$var$merge;

});


parcelRegister("9liTZ", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $6cd4bcc854268e2d$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $6cd4bcc854268e2d$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $6cd4bcc854268e2d$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $lWAfe = parcelRequire("lWAfe");
function $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $6cd4bcc854268e2d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $6cd4bcc854268e2d$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $6cd4bcc854268e2d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $6cd4bcc854268e2d$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $6cd4bcc854268e2d$export$2e2bcd8739ae039 = $6cd4bcc854268e2d$var$style;

});

parcelRegister("6MB9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f040b160197e08d$export$2e2bcd8739ae039);
function $4f040b160197e08d$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("g91qR", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $bc0e990868bc4709$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $bc0e990868bc4709$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $aliUM = parcelRequire("aliUM");

var $9liTZ = parcelRequire("9liTZ");

var $lWAfe = parcelRequire("lWAfe");

var $5iHq4 = parcelRequire("5iHq4");
function $bc0e990868bc4709$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $bc0e990868bc4709$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $bc0e990868bc4709$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $9liTZ.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $9liTZ.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $9liTZ.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $5iHq4.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $lWAfe.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $bc0e990868bc4709$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $aliUM.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $lWAfe.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($bc0e990868bc4709$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $aliUM.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aliUM.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $lWAfe.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $lWAfe.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $bc0e990868bc4709$var$styleFunctionSx = $bc0e990868bc4709$export$7d53d8bf2911e013();
$bc0e990868bc4709$var$styleFunctionSx.filterProps = [
    'sx'
];
var $bc0e990868bc4709$export$2e2bcd8739ae039 = $bc0e990868bc4709$var$styleFunctionSx;

});
parcelRegister("5iHq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc050675c3a4812$export$2e2bcd8739ae039);

var $fbH80 = parcelRequire("fbH80");

var $876wo = parcelRequire("876wo");

var $7PeCv = parcelRequire("7PeCv");

var $35ILh = parcelRequire("35ILh");

var $cvP8g = parcelRequire("cvP8g");
const $3dc050675c3a4812$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $876wo.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $35ILh.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $35ILh.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $35ILh.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $fbH80.padding)
    },
    pt: {
        style: (0, $fbH80.padding)
    },
    pr: {
        style: (0, $fbH80.padding)
    },
    pb: {
        style: (0, $fbH80.padding)
    },
    pl: {
        style: (0, $fbH80.padding)
    },
    px: {
        style: (0, $fbH80.padding)
    },
    py: {
        style: (0, $fbH80.padding)
    },
    padding: {
        style: (0, $fbH80.padding)
    },
    paddingTop: {
        style: (0, $fbH80.padding)
    },
    paddingRight: {
        style: (0, $fbH80.padding)
    },
    paddingBottom: {
        style: (0, $fbH80.padding)
    },
    paddingLeft: {
        style: (0, $fbH80.padding)
    },
    paddingX: {
        style: (0, $fbH80.padding)
    },
    paddingY: {
        style: (0, $fbH80.padding)
    },
    paddingInline: {
        style: (0, $fbH80.padding)
    },
    paddingInlineStart: {
        style: (0, $fbH80.padding)
    },
    paddingInlineEnd: {
        style: (0, $fbH80.padding)
    },
    paddingBlock: {
        style: (0, $fbH80.padding)
    },
    paddingBlockStart: {
        style: (0, $fbH80.padding)
    },
    paddingBlockEnd: {
        style: (0, $fbH80.padding)
    },
    m: {
        style: (0, $fbH80.margin)
    },
    mt: {
        style: (0, $fbH80.margin)
    },
    mr: {
        style: (0, $fbH80.margin)
    },
    mb: {
        style: (0, $fbH80.margin)
    },
    ml: {
        style: (0, $fbH80.margin)
    },
    mx: {
        style: (0, $fbH80.margin)
    },
    my: {
        style: (0, $fbH80.margin)
    },
    margin: {
        style: (0, $fbH80.margin)
    },
    marginTop: {
        style: (0, $fbH80.margin)
    },
    marginRight: {
        style: (0, $fbH80.margin)
    },
    marginBottom: {
        style: (0, $fbH80.margin)
    },
    marginLeft: {
        style: (0, $fbH80.margin)
    },
    marginX: {
        style: (0, $fbH80.margin)
    },
    marginY: {
        style: (0, $fbH80.margin)
    },
    marginInline: {
        style: (0, $fbH80.margin)
    },
    marginInlineStart: {
        style: (0, $fbH80.margin)
    },
    marginInlineEnd: {
        style: (0, $fbH80.margin)
    },
    marginBlock: {
        style: (0, $fbH80.margin)
    },
    marginBlockStart: {
        style: (0, $fbH80.margin)
    },
    marginBlockEnd: {
        style: (0, $fbH80.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $7PeCv.gap)
    },
    rowGap: {
        style: (0, $7PeCv.rowGap)
    },
    columnGap: {
        style: (0, $7PeCv.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $cvP8g.sizingTransform)
    },
    maxWidth: {
        style: (0, $cvP8g.maxWidth)
    },
    minWidth: {
        transform: (0, $cvP8g.sizingTransform)
    },
    height: {
        transform: (0, $cvP8g.sizingTransform)
    },
    maxHeight: {
        transform: (0, $cvP8g.sizingTransform)
    },
    minHeight: {
        transform: (0, $cvP8g.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $3dc050675c3a4812$export$2e2bcd8739ae039 = $3dc050675c3a4812$var$defaultSxConfig;

});
parcelRegister("876wo", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $5e840933f788805e$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $5e840933f788805e$export$7a57f79000377ca2);


var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $fbH80 = parcelRequire("fbH80");

var $lWAfe = parcelRequire("lWAfe");
function $5e840933f788805e$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $5e840933f788805e$var$createBorderStyle(prop, transform) {
    return (0, $9liTZ.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $5e840933f788805e$export$1edee58a52776cd9 = $5e840933f788805e$var$createBorderStyle('border', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$f9a7b6bd24892946 = $5e840933f788805e$var$createBorderStyle('borderTop', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$5abca33e6be905d2 = $5e840933f788805e$var$createBorderStyle('borderRight', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$e2ce9f12a980a822 = $5e840933f788805e$var$createBorderStyle('borderBottom', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$47658cca1a909427 = $5e840933f788805e$var$createBorderStyle('borderLeft', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$e7fb0694ba2404fc = $5e840933f788805e$var$createBorderStyle('borderColor');
const $5e840933f788805e$export$126a92c968acdb85 = $5e840933f788805e$var$createBorderStyle('borderTopColor');
const $5e840933f788805e$export$85cc51cb8fbb8c0e = $5e840933f788805e$var$createBorderStyle('borderRightColor');
const $5e840933f788805e$export$340b0327727f6d1a = $5e840933f788805e$var$createBorderStyle('borderBottomColor');
const $5e840933f788805e$export$60beef91a985b4bf = $5e840933f788805e$var$createBorderStyle('borderLeftColor');
const $5e840933f788805e$export$f9258c55612cbed7 = $5e840933f788805e$var$createBorderStyle('outline', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$621fe586efeb64b9 = $5e840933f788805e$var$createBorderStyle('outlineColor');
const $5e840933f788805e$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$5e840933f788805e$export$7a57f79000377ca2.propTypes = {};
$5e840933f788805e$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $5e840933f788805e$var$borders = (0, $hLL0Z.default)($5e840933f788805e$export$1edee58a52776cd9, $5e840933f788805e$export$f9a7b6bd24892946, $5e840933f788805e$export$5abca33e6be905d2, $5e840933f788805e$export$e2ce9f12a980a822, $5e840933f788805e$export$47658cca1a909427, $5e840933f788805e$export$e7fb0694ba2404fc, $5e840933f788805e$export$126a92c968acdb85, $5e840933f788805e$export$85cc51cb8fbb8c0e, $5e840933f788805e$export$340b0327727f6d1a, $5e840933f788805e$export$60beef91a985b4bf, $5e840933f788805e$export$7a57f79000377ca2, $5e840933f788805e$export$f9258c55612cbed7, $5e840933f788805e$export$621fe586efeb64b9);
var $5e840933f788805e$export$2e2bcd8739ae039 = $5e840933f788805e$var$borders;

});
parcelRegister("hLL0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $cefb4bab9b5f3b71$export$2e2bcd8739ae039);

var $aliUM = parcelRequire("aliUM");
function $cefb4bab9b5f3b71$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aliUM.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $cefb4bab9b5f3b71$export$2e2bcd8739ae039 = $cefb4bab9b5f3b71$var$compose;

});


parcelRegister("7PeCv", function(module, exports) {

$parcel$export(module.exports, "gap", () => $5b28a3156950b99a$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $5b28a3156950b99a$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $5b28a3156950b99a$export$8a833ffa5f5dbeda);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $fbH80 = parcelRequire("fbH80");

var $lWAfe = parcelRequire("lWAfe");

const $5b28a3156950b99a$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$5b28a3156950b99a$export$5df9adcb0db95e1e.propTypes = {};
$5b28a3156950b99a$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $5b28a3156950b99a$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$5b28a3156950b99a$export$ec60d70ff941a580.propTypes = {};
$5b28a3156950b99a$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $5b28a3156950b99a$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$5b28a3156950b99a$export$8a833ffa5f5dbeda.propTypes = {};
$5b28a3156950b99a$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $5b28a3156950b99a$export$baf44164ca3a34e8 = (0, $9liTZ.default)({
    prop: 'gridColumn'
});
const $5b28a3156950b99a$export$8f7213a1cd01e832 = (0, $9liTZ.default)({
    prop: 'gridRow'
});
const $5b28a3156950b99a$export$b0e0abbc49ba668 = (0, $9liTZ.default)({
    prop: 'gridAutoFlow'
});
const $5b28a3156950b99a$export$bcd8b929d4b4142 = (0, $9liTZ.default)({
    prop: 'gridAutoColumns'
});
const $5b28a3156950b99a$export$e5039a674e14c828 = (0, $9liTZ.default)({
    prop: 'gridAutoRows'
});
const $5b28a3156950b99a$export$42bd9088661ffb03 = (0, $9liTZ.default)({
    prop: 'gridTemplateColumns'
});
const $5b28a3156950b99a$export$920682ae05b999bc = (0, $9liTZ.default)({
    prop: 'gridTemplateRows'
});
const $5b28a3156950b99a$export$1b88fbdd482fd33a = (0, $9liTZ.default)({
    prop: 'gridTemplateAreas'
});
const $5b28a3156950b99a$export$bdb486e40d52d26f = (0, $9liTZ.default)({
    prop: 'gridArea'
});
const $5b28a3156950b99a$var$grid = (0, $hLL0Z.default)($5b28a3156950b99a$export$5df9adcb0db95e1e, $5b28a3156950b99a$export$ec60d70ff941a580, $5b28a3156950b99a$export$8a833ffa5f5dbeda, $5b28a3156950b99a$export$baf44164ca3a34e8, $5b28a3156950b99a$export$8f7213a1cd01e832, $5b28a3156950b99a$export$b0e0abbc49ba668, $5b28a3156950b99a$export$bcd8b929d4b4142, $5b28a3156950b99a$export$e5039a674e14c828, $5b28a3156950b99a$export$42bd9088661ffb03, $5b28a3156950b99a$export$920682ae05b999bc, $5b28a3156950b99a$export$1b88fbdd482fd33a, $5b28a3156950b99a$export$bdb486e40d52d26f);
var $5b28a3156950b99a$export$2e2bcd8739ae039 = $5b28a3156950b99a$var$grid;

});

parcelRegister("35ILh", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $24048f76f475764b$export$dbaffd4420ea0ac6);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");
function $24048f76f475764b$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $24048f76f475764b$export$35e9368ef982300f = (0, $9liTZ.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $24048f76f475764b$export$dbaffd4420ea0ac6
});
const $24048f76f475764b$export$2506f56c10355b33 = (0, $9liTZ.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $24048f76f475764b$export$dbaffd4420ea0ac6
});
const $24048f76f475764b$export$8c5a050822fd698c = (0, $9liTZ.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $24048f76f475764b$export$dbaffd4420ea0ac6
});
const $24048f76f475764b$var$palette = (0, $hLL0Z.default)($24048f76f475764b$export$35e9368ef982300f, $24048f76f475764b$export$2506f56c10355b33, $24048f76f475764b$export$8c5a050822fd698c);
var $24048f76f475764b$export$2e2bcd8739ae039 = $24048f76f475764b$var$palette;

});

parcelRegister("cvP8g", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $91c00b16c070497b$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $91c00b16c070497b$export$488fda99655ff65a);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $lWAfe = parcelRequire("lWAfe");
function $91c00b16c070497b$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $91c00b16c070497b$export$7e3df82ee760448c = (0, $9liTZ.default)({
    prop: 'width',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $lWAfe.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $91c00b16c070497b$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$91c00b16c070497b$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $91c00b16c070497b$export$ee148fbbe8357dd2 = (0, $9liTZ.default)({
    prop: 'minWidth',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$ac607276a8fe9f0a = (0, $9liTZ.default)({
    prop: 'height',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$dc0d8bd0b94f8570 = (0, $9liTZ.default)({
    prop: 'maxHeight',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$a43cf604e12f3b17 = (0, $9liTZ.default)({
    prop: 'minHeight',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$ffed9f14fb65e276 = (0, $9liTZ.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$905076ed6620e671 = (0, $9liTZ.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$6ccc93f785106a58 = (0, $9liTZ.default)({
    prop: 'boxSizing'
});
const $91c00b16c070497b$var$sizing = (0, $hLL0Z.default)($91c00b16c070497b$export$7e3df82ee760448c, $91c00b16c070497b$export$488fda99655ff65a, $91c00b16c070497b$export$ee148fbbe8357dd2, $91c00b16c070497b$export$ac607276a8fe9f0a, $91c00b16c070497b$export$dc0d8bd0b94f8570, $91c00b16c070497b$export$a43cf604e12f3b17, $91c00b16c070497b$export$6ccc93f785106a58);
var $91c00b16c070497b$export$2e2bcd8739ae039 = $91c00b16c070497b$var$sizing;

});



parcelRegister("2PWu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $210db5f09ad53fd7$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $210db5f09ad53fd7$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("jib0t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("g91qR")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("g91qR")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("6hiu6")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("5iHq4")).default);

var $g91qR = parcelRequire("g91qR");

var $6hiu6 = parcelRequire("6hiu6");

var $5iHq4 = parcelRequire("5iHq4");

});
parcelRegister("6hiu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4922ab3f1f5ee220$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $5iHq4 = parcelRequire("5iHq4");
const $4922ab3f1f5ee220$var$_excluded = [
    "sx"
];
const $4922ab3f1f5ee220$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $5iHq4.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $4922ab3f1f5ee220$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $4922ab3f1f5ee220$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $4922ab3f1f5ee220$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $3vMLS = parcelRequire("3vMLS");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3vMLS.default), (0, $8nd05.default)({}, props));
}
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $3vMLS.useDefaultProps)(params);
}

});
parcelRegister("3vMLS", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $28ea194fe257804a$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $28ea194fe257804a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $28ea194fe257804a$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $28ea194fe257804a$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28ea194fe257804a$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $28ea194fe257804a$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $28ea194fe257804a$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($28ea194fe257804a$var$PropsContext);
    return $28ea194fe257804a$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $28ea194fe257804a$export$2e2bcd8739ae039 = $28ea194fe257804a$var$DefaultPropsProvider;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $8nd05.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $8nd05.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $8nd05.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("8Uq77")).default);

var $dO5ga = parcelRequire("dO5ga");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

var $PJRTc = parcelRequire("PJRTc");
'use client';
const $0277c5e26ff0d56c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($dO5ga)))({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("dO5ga", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0d40654cceea0e2$var$createStyled;
module.exports.shouldForwardProp = $a0d40654cceea0e2$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $a0d40654cceea0e2$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2 = $1jnue((parcelRequire("c05no")));

var $a0d40654cceea0e2$var$_styledEngine = $a0d40654cceea0e2$var$_interopRequireWildcard((parcelRequire("5C8IU")));

var $3z1Ay = parcelRequire("3z1Ay");

var $a0d40654cceea0e2$var$_capitalize = $1jnue((parcelRequire("2A1GY")));

var $a0d40654cceea0e2$var$_getDisplayName = $1jnue((parcelRequire("eQufN")));

var $a0d40654cceea0e2$var$_createTheme = $1jnue((parcelRequire("c3nGe")));

var $a0d40654cceea0e2$var$_styleFunctionSx = $1jnue((parcelRequire("jib0t")));
const $a0d40654cceea0e2$var$_excluded = [
    "ownerState"
], $a0d40654cceea0e2$var$_excluded2 = [
    "variants"
], $a0d40654cceea0e2$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $a0d40654cceea0e2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a0d40654cceea0e2$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a0d40654cceea0e2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a0d40654cceea0e2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $a0d40654cceea0e2$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0d40654cceea0e2$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $a0d40654cceea0e2$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $a0d40654cceea0e2$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $a0d40654cceea0e2$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $a0d40654cceea0e2$var$_createTheme.default)();
const $a0d40654cceea0e2$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0d40654cceea0e2$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a0d40654cceea0e2$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a0d40654cceea0e2$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a0d40654cceea0e2$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2.default)(_ref, $a0d40654cceea0e2$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $a0d40654cceea0e2$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a0d40654cceea0e2$var$processStyleArg(resolvedStyle, (0, $a0d40654cceea0e2$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $a0d40654cceea0e2$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $a0d40654cceea0e2$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $a0d40654cceea0e2$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $a0d40654cceea0e2$var$shallowLayer((0, $a0d40654cceea0e2$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $a0d40654cceea0e2$var$shallowLayer((0, $a0d40654cceea0e2$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $a0d40654cceea0e2$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a0d40654cceea0e2$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $a0d40654cceea0e2$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $a0d40654cceea0e2$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $a0d40654cceea0e2$var$_styleFunctionSx.default)((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
            theme: $a0d40654cceea0e2$var$resolveTheme((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $a0d40654cceea0e2$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a0d40654cceea0e2$var$defaultOverridesResolver($a0d40654cceea0e2$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $a0d40654cceea0e2$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0d40654cceea0e2$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0d40654cceea0e2$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $a0d40654cceea0e2$var$_styledEngine.default)(tag, (0, $a0d40654cceea0e2$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $a0d40654cceea0e2$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $a0d40654cceea0e2$var$processStyleArg(stylesArg, (0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0d40654cceea0e2$var$resolveTheme((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a0d40654cceea0e2$var$processStyleArg(slotStyle, (0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a0d40654cceea0e2$var$resolveTheme((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a0d40654cceea0e2$var$processStyleArg({
                    variants: themeVariants
                }, (0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
'use client';
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "createMuiTheme", () => $d5615f18e5cd04fc$export$c469355549431d9b);
$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $g91qR = parcelRequire("g91qR");
var $5iHq4 = parcelRequire("5iHq4");

var $8NnpI = parcelRequire("8NnpI");


var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");
const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $cpmCj.default)(18));
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $8NnpI.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $lhXgK.default))
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $5iHq4.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $kTdcz = parcelRequire("kTdcz");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dzxhF.default).white,
        default: (0, $dzxhF.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dzxhF.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $dzxhF.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $kTdcz.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $kTdcz.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kTdcz.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3z1Ay.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $8nd05.default)({}, (0, $dzxhF.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kTdcz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f3532f4fa6553080$var$alpha;
module.exports.blend = $f3532f4fa6553080$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f3532f4fa6553080$var$darken;
module.exports.decomposeColor = $f3532f4fa6553080$var$decomposeColor;
module.exports.emphasize = $f3532f4fa6553080$var$emphasize;
module.exports.getContrastRatio = $f3532f4fa6553080$var$getContrastRatio;
module.exports.getLuminance = $f3532f4fa6553080$var$getLuminance;
module.exports.hexToRgb = $f3532f4fa6553080$var$hexToRgb;
module.exports.hslToRgb = $f3532f4fa6553080$var$hslToRgb;
module.exports.lighten = $f3532f4fa6553080$var$lighten;
module.exports.private_safeAlpha = $f3532f4fa6553080$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f3532f4fa6553080$var$private_safeDarken;
module.exports.private_safeEmphasize = $f3532f4fa6553080$var$private_safeEmphasize;
module.exports.private_safeLighten = $f3532f4fa6553080$var$private_safeLighten;
module.exports.recomposeColor = $f3532f4fa6553080$var$recomposeColor;
module.exports.rgbToHex = $f3532f4fa6553080$var$rgbToHex;

var $f3532f4fa6553080$var$_formatMuiErrorMessage2 = $1jnue((parcelRequire("dsPLe")));

var $f3532f4fa6553080$var$_clamp = $1jnue((parcelRequire("lYE9x")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f3532f4fa6553080$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $f3532f4fa6553080$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f3532f4fa6553080$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f3532f4fa6553080$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f3532f4fa6553080$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f3532f4fa6553080$var$decomposeColor($f3532f4fa6553080$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $f3532f4fa6553080$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $f3532f4fa6553080$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f3532f4fa6553080$var$colorChannel = (color)=>{
    const decomposedColor = $f3532f4fa6553080$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $f3532f4fa6553080$var$colorChannel;
const $f3532f4fa6553080$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f3532f4fa6553080$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f3532f4fa6553080$var$private_safeColorChannel;
function $f3532f4fa6553080$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f3532f4fa6553080$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $f3532f4fa6553080$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f3532f4fa6553080$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f3532f4fa6553080$var$hslToRgb(color) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f3532f4fa6553080$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f3532f4fa6553080$var$getLuminance(color) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f3532f4fa6553080$var$decomposeColor($f3532f4fa6553080$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f3532f4fa6553080$var$getContrastRatio(foreground, background) {
    const lumA = $f3532f4fa6553080$var$getLuminance(foreground);
    const lumB = $f3532f4fa6553080$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$alpha(color, value) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    value = $f3532f4fa6553080$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f3532f4fa6553080$var$recomposeColor(color);
}
function $f3532f4fa6553080$var$private_safeAlpha(color, value, warning) {
    try {
        return $f3532f4fa6553080$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$darken(color, coefficient) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    coefficient = $f3532f4fa6553080$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f3532f4fa6553080$var$recomposeColor(color);
}
function $f3532f4fa6553080$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f3532f4fa6553080$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$lighten(color, coefficient) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    coefficient = $f3532f4fa6553080$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f3532f4fa6553080$var$recomposeColor(color);
}
function $f3532f4fa6553080$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f3532f4fa6553080$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$emphasize(color, coefficient = 0.15) {
    return $f3532f4fa6553080$var$getLuminance(color) > 0.5 ? $f3532f4fa6553080$var$darken(color, coefficient) : $f3532f4fa6553080$var$lighten(color, coefficient);
}
function $f3532f4fa6553080$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f3532f4fa6553080$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f3532f4fa6553080$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f3532f4fa6553080$var$decomposeColor(background);
    const overlayColor = $f3532f4fa6553080$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f3532f4fa6553080$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "easing", () => $845514f3678d3888$export$24c5ac7c37452e7d);
$parcel$export(module.exports, "duration", () => $845514f3678d3888$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});



parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("aiIP4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);
$parcel$export(module.exports, "default", () => $77fe5ab326d42cdb$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});







parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});



parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});


var $ayMG0 = parcelRequire("ayMG0");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");
/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


// src/store.js

var $ayMG0 = parcelRequire("ayMG0");
// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__defProps = Object.defineProperties;
var $5f9e38360d79f95a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5f9e38360d79f95a$var$__spreadProps = (a, b)=>$5f9e38360d79f95a$var$__defProps(a, $5f9e38360d79f95a$var$__getOwnPropDescs(b));
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$O = Object;
var $5f9e38360d79f95a$var$getPrototypeOf = $5f9e38360d79f95a$var$O.getPrototypeOf;
var $5f9e38360d79f95a$var$CONSTRUCTOR = "constructor";
var $5f9e38360d79f95a$var$PROTOTYPE = "prototype";
var $5f9e38360d79f95a$var$CONFIGURABLE = "configurable";
var $5f9e38360d79f95a$var$ENUMERABLE = "enumerable";
var $5f9e38360d79f95a$var$WRITABLE = "writable";
var $5f9e38360d79f95a$var$VALUE = "value";
var $5f9e38360d79f95a$export$541ac630993a4c84 = (value)=>!!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || $5f9e38360d79f95a$var$isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value[$5f9e38360d79f95a$var$CONSTRUCTOR]) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE][$5f9e38360d79f95a$var$CONSTRUCTOR].toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || !$5f9e38360d79f95a$var$isObjectish(value)) return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null || proto === $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE]) return true;
    const Ctor = $5f9e38360d79f95a$var$O.hasOwnProperty.call(proto, $5f9e38360d79f95a$var$CONSTRUCTOR) && proto[$5f9e38360d79f95a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$5f9e38360d79f95a$var$isFunction(Ctor)) return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $5f9e38360d79f95a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : $5f9e38360d79f95a$var$isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $5f9e38360d79f95a$var$has = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $5f9e38360d79f95a$var$get = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $5f9e38360d79f95a$var$set = (thing, propOrOldValue, value, type = $5f9e38360d79f95a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $5f9e38360d79f95a$var$isArray = Array.isArray;
var $5f9e38360d79f95a$var$isMap = (target)=>target instanceof Map;
var $5f9e38360d79f95a$var$isSet = (target)=>target instanceof Set;
var $5f9e38360d79f95a$var$isObjectish = (target)=>typeof target === "object";
var $5f9e38360d79f95a$var$isFunction = (target)=>typeof target === "function";
var $5f9e38360d79f95a$var$isBoolean = (target)=>typeof target === "boolean";
function $5f9e38360d79f95a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $5f9e38360d79f95a$var$getProxyDraft = (value)=>{
    if (!$5f9e38360d79f95a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$5f9e38360d79f95a$var$DRAFT_STATE];
};
var $5f9e38360d79f95a$var$latest = (state)=>state.copy_ || state.base_;
var $5f9e38360d79f95a$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $5f9e38360d79f95a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if ($5f9e38360d79f95a$var$isArray(base)) return Array[$5f9e38360d79f95a$var$PROTOTYPE].slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $5f9e38360d79f95a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$5f9e38360d79f95a$var$WRITABLE] === false) {
                desc[$5f9e38360d79f95a$var$WRITABLE] = true;
                desc[$5f9e38360d79f95a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$5f9e38360d79f95a$var$CONFIGURABLE]: true,
                [$5f9e38360d79f95a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
                [$5f9e38360d79f95a$var$VALUE]: base[key]
            };
        }
        return $5f9e38360d79f95a$var$O.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = $5f9e38360d79f95a$var$O.create(proto);
        return $5f9e38360d79f95a$var$O.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) $5f9e38360d79f95a$var$O.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    $5f9e38360d79f95a$var$O.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>{
        $5f9e38360d79f95a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    [$5f9e38360d79f95a$var$VALUE]: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || !$5f9e38360d79f95a$var$isObjectish(obj)) return true;
    return $5f9e38360d79f95a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$PluginMapSet = "MapSet";
var $5f9e38360d79f95a$var$PluginPatches = "Patches";
var $5f9e38360d79f95a$var$PluginArrayMethods = "ArrayMethods";
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
var $5f9e38360d79f95a$var$isPluginLoaded = (pluginKey)=>!!$5f9e38360d79f95a$var$plugins[pluginKey];
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$getCurrentScope = ()=>$5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginMapSet) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginArrayMethods) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginArrayMethods) : void 0
    });
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
var $5f9e38360d79f95a$var$enterScope = (immer2)=>$5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) result = $5f9e38360d79f95a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft);
    $5f9e38360d79f95a$var$maybeFreeze(scope, result, true);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $5f9e38360d79f95a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
function $5f9e38360d79f95a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $5f9e38360d79f95a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT = [];
function $5f9e38360d79f95a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $5f9e38360d79f95a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $5f9e38360d79f95a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $5f9e38360d79f95a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $5f9e38360d79f95a$var$each(parentCopy, (key, value)=>{
            if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$5f9e38360d79f95a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
        $5f9e38360d79f95a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $5f9e38360d79f95a$var$markStateFinalized(state);
    }
}
function $5f9e38360d79f95a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
        const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
        if ($5f9e38360d79f95a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $5f9e38360d79f95a$var$prepareCopy(target);
            const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
            $5f9e38360d79f95a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $5f9e38360d79f95a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $5f9e38360d79f95a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($5f9e38360d79f95a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $5f9e38360d79f95a$var$handleValue($5f9e38360d79f95a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $5f9e38360d79f95a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(target) || handledSet.has(target) || !$5f9e38360d79f95a$export$16e3aed3edb85946(target) || $5f9e38360d79f95a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $5f9e38360d79f95a$var$each(target, (key, value)=>{
        if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
            const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
            if ($5f9e38360d79f95a$var$isSameScope(state, rootScope)) {
                const updatedValue = $5f9e38360d79f95a$var$getFinalValue(state);
                $5f9e38360d79f95a$var$set(target, key, updatedValue, target.type_);
                $5f9e38360d79f95a$var$markStateFinalized(state);
            }
        } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) $5f9e38360d79f95a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const baseIsArray = $5f9e38360d79f95a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop, state.type_)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $5f9e38360d79f95a$var$isArrayIndex(prop)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop) || $5f9e38360d79f95a$var$isRelocatedBaseRef(state, prop, value)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop, state.type_))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $5f9e38360d79f95a$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $5f9e38360d79f95a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $5f9e38360d79f95a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$5f9e38360d79f95a$var$WRITABLE]: true,
            [$5f9e38360d79f95a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
            [$5f9e38360d79f95a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
for(let key in $5f9e38360d79f95a$var$objectTraps){
    let fn = $5f9e38360d79f95a$var$objectTraps[key];
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$isRelocatedBaseRef(state, prop, value) {
    var _a;
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || ((_a = state.assigned_) == null ? void 0 : _a.get(prop)) || !$5f9e38360d79f95a$export$16e3aed3edb85946(value) || value[$5f9e38360d79f95a$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? $5f9e38360d79f95a$var$VALUE in desc ? desc[$5f9e38360d79f95a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($5f9e38360d79f95a$var$isFunction(base) && !$5f9e38360d79f95a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$5f9e38360d79f95a$var$isFunction(recipe)) $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && !$5f9e38360d79f95a$var$isFunction(patchListener)) $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || !$5f9e38360d79f95a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($5f9e38360d79f95a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft($5f9e38360d79f95a$var$get(parentCopy, state.key_));
            const valueAtKey = $5f9e38360d79f95a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $5f9e38360d79f95a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $5f9e38360d79f95a$var$get(current2, key);
            if (!$5f9e38360d79f95a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$5f9e38360d79f95a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key, type_);
            const value = $5f9e38360d79f95a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $5f9e38360d79f95a$var$CONSTRUCTOR)) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if ($5f9e38360d79f95a$var$isFunction(base) && p === $5f9e38360d79f95a$var$PROTOTYPE) $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (base === null || !$5f9e38360d79f95a$var$isObjectish(base)) $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if ($5f9e38360d79f95a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $5f9e38360d79f95a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function iteratorFrom(iterable) {
        if (typeof Iterator !== "undefined") return Iterator.from(iterable);
        const iterator = $5f9e38360d79f95a$var$__spreadProps($5f9e38360d79f95a$var$__spreadValues({}, iterable), {
            [Symbol.iterator]: ()=>iterator
        });
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
                $5f9e38360d79f95a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($5f9e38360d79f95a$var$getValue(value));
            });
        }
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $5f9e38360d79f95a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        const result = operation();
        $5f9e38360d79f95a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = "" + (startIndex + i);
            state.assigned_.set(index, true);
            $5f9e38360d79f95a$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c05b21e3257751e5 = (value)=>value;
var $5f9e38360d79f95a$export$20f911b3f8cf0b74 = (value)=>value;


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>$375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = /* @__PURE__ */ Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $375276bea32f9eda$var$StrongRef : WeakRef;
var $375276bea32f9eda$var$Ref = /* @__PURE__ */ $375276bea32f9eda$var$getWeakRef();
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$var$maybeDeref(r) {
    if (r instanceof $375276bea32f9eda$var$Ref) return r.deref();
    return r;
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = $375276bea32f9eda$var$maybeDeref(lastResult);
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? /* @__PURE__ */ new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        const rafId = raf(callback);
        const timerId = setTimeout(callback, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? $d91034f47eb948f2$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        $d91034f47eb948f2$var$__publicField(this, "payload", payload);
        $d91034f47eb948f2$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        $d91034f47eb948f2$var$__publicField(this, "payload", payload);
        $d91034f47eb948f2$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        $d91034f47eb948f2$var$__publicField(this, "code", code);
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = /* @__PURE__ */ Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$emptyObject = {};
var $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}



var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$_connect;
var $55388fc2f116d4d7$export$8807b5ba46f9d0b7 = $55388fc2f116d4d7$var$_connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;


const $2ad2279805e583d1$var$authSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "auth",
    initialState: {
        user: null,
        isAuthenticated: false
    },
    reducers: {
        loginSuccess: (state, action)=>{
            state.user = action.payload;
            state.isAuthenticated = true;
        },
        logout: (state)=>{
            state.user = null;
            state.isAuthenticated = false;
        }
    }
});
const { loginSuccess: $2ad2279805e583d1$export$6c3f5566e4ac0cc6, logout: $2ad2279805e583d1$export$a0973bcfe11b05c9 } = $2ad2279805e583d1$var$authSlice.actions;
const $2ad2279805e583d1$var$store = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: {
        auth: $2ad2279805e583d1$var$authSlice.reducer
    }
});
function $2ad2279805e583d1$export$3b5c74f3f11c675d({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: $2ad2279805e583d1$var$store,
        children: children
    });
}
function $2ad2279805e583d1$export$6ccbb43953eebf8() {
    // Returns { state, dispatch } for compatibility with old code
    const state = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((s)=>s.auth);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    return {
        state: state,
        dispatch: dispatch
    };
}


// src/routes.js

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

// src/LoginPage.js

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = $c319b2c832c2914a$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
const $c319b2c832c2914a$var$isSet = $c319b2c832c2914a$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($c319b2c832c2914a$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                    $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp($fc026bbf9ee156f1$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $f8f5102fdfcbfec9$export$9e344cffce061a22)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $866cce54f6bdfb0c$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $866cce54f6bdfb0c$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $866cce54f6bdfb0c$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $866cce54f6bdfb0c$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $866cce54f6bdfb0c$var$trimOWS(part.slice(0, equals));
        if (!$866cce54f6bdfb0c$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $866cce54f6bdfb0c$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $866cce54f6bdfb0c$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $866cce54f6bdfb0c$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
const $4e2395edb77acf3a$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $4e2395edb77acf3a$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $4e2395edb77acf3a$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $4e2395edb77acf3a$var$stringifySafely(entry.message) : $4e2395edb77acf3a$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $4e2395edb77acf3a$var$aggregateErrorMessage(error);
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



'use strict';
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $e6cbd383b18c9625$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $4023ac50ad132196$export$2e2bcd8739ae039) && (0, $4023ac50ad132196$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $4023ac50ad132196$export$2e2bcd8739ae039).from(value);
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $f66f8c7b4f247caf$var$encode) : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $e6cbd383b18c9625$export$659081b45d03227d);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5f8142930b3b943f$var$MAX_DEPTH, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;



'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn, scheduler = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}


'use strict';
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $598acbfafd2c63c5$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url) {
    return $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url).replace($598acbfafd2c63c5$var$httpProtocolControlCharacters, '');
}
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $598acbfafd2c63c5$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b}`;
    });
}
function $598acbfafd2c63c5$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$598acbfafd2c63c5$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = $598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url);
        if ($598acbfafd2c63c5$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($598acbfafd2c63c5$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $f85fda54cd977b19$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($f85fda54cd977b19$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ff840e6c220d182f$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ab4625fac3104691$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        (0, $ff840e6c220d182f$export$2e2bcd8739ae039)(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;



const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
const $da69a2069c6136ea$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $da69a2069c6136ea$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $da69a2069c6136ea$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $da69a2069c6136ea$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $da69a2069c6136ea$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            code = $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 1)) * 16 + $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($da69a2069c6136ea$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$da69a2069c6136ea$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $da69a2069c6136ea$var$estimateBase64BufferAllocation(body);
    return $da69a2069c6136ea$var$base64Bytes(significant);
};
const $da69a2069c6136ea$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $da69a2069c6136ea$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes);
}
function $da69a2069c6136ea$export$1f39e64b554a246f(url) {
    return $da69a2069c6136ea$var$estimateDataURLBytes(url, $da69a2069c6136ea$var$estimateBase64BufferAllocation);
}


const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.19.0";



const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== undefined && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== null ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $da69a2069c6136ea$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $c9465135abb26626$export$b0119225647bd83)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);




// src/settings.js
// Use environment variable for API base URL, fallback to localhost dev default
const $efa0868a03d524fc$export$c3ee1e672e1e24e7 = "https://appsec-info.waas.barracudanetworks.com";
const $efa0868a03d524fc$export$ff2cc6c005e01ca4 = "https://login.barracudanetworks.com/auth/logout";


function $a348570ca60b2ed3$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { dispatch: dispatch } = (0, $2ad2279805e583d1$export$6ccbb43953eebf8)();
    (0, $acw62.useEffect)(()=>{
        (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/current-user/`, {
            withCredentials: true
        }).then((response)=>{
            dispatch((0, $2ad2279805e583d1$export$6c3f5566e4ac0cc6)(response.data));
            navigate("/scan", {
                replace: true
            });
        }).catch((err)=>{
            console.log("Not logged in, redirecting to login page.");
            if (err.response && err.response.status === 401) {
                console.log("coming here");
                window.location.href = `${0, $efa0868a03d524fc$export$c3ee1e672e1e24e7}/api/login/`;
            } else {
                console.log("Error fetching current user:", err);
                navigate("/scan/error/", {
                    replace: true
                });
            }
            console.log("outsied if");
        });
    }, [
        dispatch,
        navigate
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "login-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
            children: "Redirecting to login..."
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $5C8IU = parcelRequire("5C8IU");

var $g91qR = parcelRequire("g91qR");
var $6hiu6 = parcelRequire("6hiu6");

var $8NnpI = parcelRequire("8NnpI");

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
'use client';
function $3c4de721067b1c27$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $3c4de721067b1c27$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $eP9YU.T));
    return !contextTheme || $3c4de721067b1c27$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $3c4de721067b1c27$export$2e2bcd8739ae039 = $3c4de721067b1c27$var$useTheme;


'use client';
const $fd286b02fb568257$export$35e57303dbd8a66 = (0, $8NnpI.default)();
function $fd286b02fb568257$var$useTheme(defaultTheme = $fd286b02fb568257$export$35e57303dbd8a66) {
    return (0, $3c4de721067b1c27$export$2e2bcd8739ae039)(defaultTheme);
}
var $fd286b02fb568257$export$2e2bcd8739ae039 = $fd286b02fb568257$var$useTheme;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6f004ebeb2f93e73$var$_excluded = [
    "className",
    "component"
];
function $6f004ebeb2f93e73$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5C8IU.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $g91qR.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $6hiu6.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $6f004ebeb2f93e73$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");
var $cf808af3a1d339c9$exports = {};

$parcel$defineInteropFlag($cf808af3a1d339c9$exports);

$parcel$export($cf808af3a1d339c9$exports, "default", () => $cf808af3a1d339c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;


'use client';
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $6f004ebeb2f93e73$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $cf808af3a1d339c9$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bnost.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $27fddc0219860a83$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;


'use client';
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $15e2b45accdb3531$var$hadKeyboardEvent = true;
let $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
const $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
const $15e2b45accdb3531$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $15e2b45accdb3531$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $15e2b45accdb3531$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $15e2b45accdb3531$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $15e2b45accdb3531$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $15e2b45accdb3531$var$handlePointerDown() {
    $15e2b45accdb3531$var$hadKeyboardEvent = false;
}
function $15e2b45accdb3531$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($15e2b45accdb3531$var$hadFocusVisibleRecently) $15e2b45accdb3531$var$hadKeyboardEvent = true;
    }
}
function $15e2b45accdb3531$var$prepare(doc) {
    doc.addEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $15e2b45accdb3531$var$hadKeyboardEvent || $15e2b45accdb3531$var$focusTriggersKeyboardModality(target);
}
function $15e2b45accdb3531$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $15e2b45accdb3531$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $15e2b45accdb3531$var$hadFocusVisibleRecently = true;
            $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($15e2b45accdb3531$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $8fc8239a3939454e$export$2e2bcd8739ae039 = (0, $15e2b45accdb3531$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $9QePP = parcelRequire("9QePP");

var $jjlaj = parcelRequire("jjlaj");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;


var $755fb323846f60d4$exports = {};

$parcel$defineInteropFlag($755fb323846f60d4$exports);

$parcel$export($755fb323846f60d4$exports, "getTouchRippleUtilityClass", () => $755fb323846f60d4$export$b464606f735ab902);
$parcel$export($755fb323846f60d4$exports, "default", () => $755fb323846f60d4$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $855224273a002a0f$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $855224273a002a0f$var$_ = (t)=>t, $855224273a002a0f$var$_t, $855224273a002a0f$var$_t2, $855224273a002a0f$var$_t3, $855224273a002a0f$var$_t4;
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t || ($855224273a002a0f$var$_t = $855224273a002a0f$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $855224273a002a0f$var$exitKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t2 || ($855224273a002a0f$var$_t2 = $855224273a002a0f$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $855224273a002a0f$var$pulsateKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t3 || ($855224273a002a0f$var$_t3 = $855224273a002a0f$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $cb2cd8c78d72bd92$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($855224273a002a0f$var$_t4 || ($855224273a002a0f$var$_t4 = $855224273a002a0f$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible, $855224273a002a0f$var$enterKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving, $855224273a002a0f$var$exitKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate, $855224273a002a0f$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1En50.default)(props, $855224273a002a0f$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, (0, $8nd05.default)({
        className: (0, $9QePP.default)((0, $755fb323846f60d4$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;


var $42d7f65840078ec1$exports = {};

$parcel$defineInteropFlag($42d7f65840078ec1$exports);

$parcel$export($42d7f65840078ec1$exports, "getButtonBaseUtilityClass", () => $42d7f65840078ec1$export$fccb0498dcd99783);
$parcel$export($42d7f65840078ec1$exports, "default", () => $42d7f65840078ec1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a35786d89db9dda$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $42d7f65840078ec1$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $42d7f65840078ec1$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1En50.default)(props, $4a35786d89db9dda$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $8nd05.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, (0, $8nd05.default)({
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $855224273a002a0f$export$2e2bcd8739ae039), (0, $8nd05.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;



var $jTnBY = parcelRequire("jTnBY");
var $11f546081ba06ace$exports = {};

$parcel$defineInteropFlag($11f546081ba06ace$exports);

$parcel$export($11f546081ba06ace$exports, "getButtonUtilityClass", () => $11f546081ba06ace$export$5a6f9035944c8119);
$parcel$export($11f546081ba06ace$exports, "default", () => $11f546081ba06ace$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a02bab8c70a697b$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $11f546081ba06ace$export$5a6f9035944c8119), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $4a02bab8c70a697b$var$commonIconStyles = (ownerState)=>(0, $8nd05.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $8nd05.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $8nd05.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: (0, $8nd05.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $8639dcef822d5d4c$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $25b1293270900846$export$2e2bcd8739ae039));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $4a02bab8c70a697b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $6hiu6 = parcelRequire("6hiu6");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");
var $837556bdf75d281f$exports = {};

$parcel$defineInteropFlag($837556bdf75d281f$exports);

$parcel$export($837556bdf75d281f$exports, "getTypographyUtilityClass", () => $837556bdf75d281f$export$24c1f8f60cbac79e);
$parcel$export($837556bdf75d281f$exports, "default", () => $837556bdf75d281f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $837556bdf75d281f$export$24c1f8f60cbac79e), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $6hiu6.default)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;


var $a0a5450dd7e50a49$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($a0a5450dd7e50a49$exports, "__esModule", {
    value: true
});
$a0a5450dd7e50a49$exports.default = void 0;

var $a0a5450dd7e50a49$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a0a5450dd7e50a49$var$_default = $a0a5450dd7e50a49$exports.default = (0, $a0a5450dd7e50a49$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');


function $05c4794dfd083e32$var$decodeErrorParam(search) {
    const params = new URLSearchParams(search);
    const encoded = params.get("error");
    if (!encoded) return "Unknown error.";
    try {
        return atob(encoded);
    } catch  {
        return "Invalid error message.";
    }
}
function $05c4794dfd083e32$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const errorMsg = "Something went wrong while processing your request. Please try again later.";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f8fafc",
            textAlign: "center",
            p: 3
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a0a5450dd7e50a49$exports))), {
                sx: {
                    fontSize: 120,
                    color: "#e57373",
                    mb: 2
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "h3",
                fontWeight: 700,
                color: "#d32f2f",
                gutterBottom: true,
                children: "Oops! Something went wrong"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "h6",
                color: "text.secondary",
                sx: {
                    mb: 3
                },
                children: errorMsg
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                variant: "contained",
                color: "primary",
                size: "large",
                onClick: ()=>window.location.href = "/scan",
                sx: {
                    mt: 2
                },
                children: "Back to Scan"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "img",
                src: "https://illustrations.popsy.co/gray/error.svg",
                alt: "Error Illustration",
                sx: {
                    width: 340,
                    maxWidth: "90vw",
                    mt: 4
                }
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $87e6acd7396d97dc$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $87e6acd7396d97dc$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $87e6acd7396d97dc$export$869b26d4e1bbdb63(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $87e6acd7396d97dc$export$dbf961a8d278dbef(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $87e6acd7396d97dc$export$aa35ef1f24408ab9(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $87e6acd7396d97dc$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $87e6acd7396d97dc$var$hex = [
    ...'0123456789ABCDEF'
];
const $87e6acd7396d97dc$var$h1 = (b)=>$87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$h2 = (b)=>$87e6acd7396d97dc$var$hex[(b & 0xF0) >> 4] + $87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $87e6acd7396d97dc$var$isShort = (v)=>$87e6acd7396d97dc$var$eq(v.r) && $87e6acd7396d97dc$var$eq(v.g) && $87e6acd7396d97dc$var$eq(v.b) && $87e6acd7396d97dc$var$eq(v.a);
function $87e6acd7396d97dc$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $87e6acd7396d97dc$var$map$1[str[1]] * 17,
            g: 255 & $87e6acd7396d97dc$var$map$1[str[2]] * 17,
            b: 255 & $87e6acd7396d97dc$var$map$1[str[3]] * 17,
            a: len === 5 ? $87e6acd7396d97dc$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $87e6acd7396d97dc$var$map$1[str[1]] << 4 | $87e6acd7396d97dc$var$map$1[str[2]],
            g: $87e6acd7396d97dc$var$map$1[str[3]] << 4 | $87e6acd7396d97dc$var$map$1[str[4]],
            b: $87e6acd7396d97dc$var$map$1[str[5]] << 4 | $87e6acd7396d97dc$var$map$1[str[6]],
            a: len === 9 ? $87e6acd7396d97dc$var$map$1[str[7]] << 4 | $87e6acd7396d97dc$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $87e6acd7396d97dc$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $87e6acd7396d97dc$export$1b06654353ef9f67(v) {
    var f = $87e6acd7396d97dc$var$isShort(v) ? $87e6acd7396d97dc$var$h1 : $87e6acd7396d97dc$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $87e6acd7396d97dc$var$alpha(v.a, f) : undefined;
}
const $87e6acd7396d97dc$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $87e6acd7396d97dc$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $87e6acd7396d97dc$var$hwb2rgbn(h, w, b) {
    const rgb = $87e6acd7396d97dc$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $87e6acd7396d97dc$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $87e6acd7396d97dc$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $87e6acd7396d97dc$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $87e6acd7396d97dc$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($87e6acd7396d97dc$export$ed9bd8dcaeba14f6);
}
function $87e6acd7396d97dc$export$4c15bd42559b811d(h, s, l) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsl2rgbn, h, s, l);
}
function $87e6acd7396d97dc$export$e2710022c70fc9ee(h, w, b) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hwb2rgbn, h, w, b);
}
function $87e6acd7396d97dc$export$b785a357c84e4a04(h, s, v) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsv2rgbn, h, s, v);
}
function $87e6acd7396d97dc$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $87e6acd7396d97dc$export$5e91288c399be4f9(str) {
    const m = $87e6acd7396d97dc$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(+m[5]) : $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $87e6acd7396d97dc$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $87e6acd7396d97dc$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $87e6acd7396d97dc$export$b785a357c84e4a04(h, p1, p2);
    else v = $87e6acd7396d97dc$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $87e6acd7396d97dc$export$bb628a54ab399bc9(v, deg) {
    var h = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    h[0] = $87e6acd7396d97dc$var$hue(h[0] + deg);
    h = $87e6acd7396d97dc$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $87e6acd7396d97dc$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[1]);
    const l = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $87e6acd7396d97dc$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $87e6acd7396d97dc$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $87e6acd7396d97dc$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($87e6acd7396d97dc$var$names$1);
    const tkeys = Object.keys($87e6acd7396d97dc$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $87e6acd7396d97dc$var$map[k]);
        }
        k = parseInt($87e6acd7396d97dc$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $87e6acd7396d97dc$var$names;
function $87e6acd7396d97dc$export$b2f06b640faad956(str) {
    if (!$87e6acd7396d97dc$var$names) {
        $87e6acd7396d97dc$var$names = $87e6acd7396d97dc$var$unpack();
        $87e6acd7396d97dc$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $87e6acd7396d97dc$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $87e6acd7396d97dc$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$export$91aedb20f296e541(str) {
    const m = $87e6acd7396d97dc$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) : $87e6acd7396d97dc$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(r) : $87e6acd7396d97dc$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(g) : $87e6acd7396d97dc$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(b) : $87e6acd7396d97dc$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $87e6acd7396d97dc$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $87e6acd7396d97dc$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $87e6acd7396d97dc$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $87e6acd7396d97dc$var$interpolate(rgb1, rgb2, t) {
    const r = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.r));
    const g = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.g));
    const b = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(r + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(g + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(b + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $87e6acd7396d97dc$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $87e6acd7396d97dc$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $87e6acd7396d97dc$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $87e6acd7396d97dc$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $87e6acd7396d97dc$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $87e6acd7396d97dc$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $87e6acd7396d97dc$export$91aedb20f296e541(str);
    return $87e6acd7396d97dc$export$5e91288c399be4f9(str);
}
class $87e6acd7396d97dc$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $87e6acd7396d97dc$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $87e6acd7396d97dc$var$fromObject(input);
        else if (type === 'string') v = $87e6acd7396d97dc$export$625a38b961e8b5e9(input) || $87e6acd7396d97dc$export$b2f06b640faad956(input) || $87e6acd7396d97dc$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $87e6acd7396d97dc$var$clone(this._rgb);
        if (v) v.a = $87e6acd7396d97dc$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $87e6acd7396d97dc$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $87e6acd7396d97dc$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $87e6acd7396d97dc$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $87e6acd7396d97dc$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $87e6acd7396d97dc$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $87e6acd7396d97dc$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $87e6acd7396d97dc$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $87e6acd7396d97dc$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $87e6acd7396d97dc$export$2e2bcd8739ae039(input) {
    return new $87e6acd7396d97dc$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $84f61e7391a78632$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $84f61e7391a78632$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $84f61e7391a78632$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $84f61e7391a78632$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $84f61e7391a78632$export$c4ce752e73470fba(value, defaultValue) {
    return $84f61e7391a78632$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $84f61e7391a78632$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $84f61e7391a78632$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $84f61e7391a78632$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $84f61e7391a78632$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $84f61e7391a78632$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($84f61e7391a78632$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $84f61e7391a78632$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $84f61e7391a78632$export$667d3bf0c5f83305(source) {
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(source)) return source.map($84f61e7391a78632$export$667d3bf0c5f83305);
    if ($84f61e7391a78632$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $84f61e7391a78632$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $84f61e7391a78632$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $84f61e7391a78632$export$317a3d46287192d8(key, target, source, options) {
    if (!$84f61e7391a78632$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($84f61e7391a78632$export$23f2a1d2818174ef(tval) && $84f61e7391a78632$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $84f61e7391a78632$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $84f61e7391a78632$export$667d3bf0c5f83305(sval);
}
function $84f61e7391a78632$export$efca4cbe5dd06740(target, source, options) {
    const sources = $84f61e7391a78632$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$84f61e7391a78632$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $84f61e7391a78632$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$84f61e7391a78632$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $84f61e7391a78632$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $84f61e7391a78632$export$efca4cbe5dd06740(target, source, {
        merger: $84f61e7391a78632$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $84f61e7391a78632$export$1ee57be6f6687d2c(key, target, source) {
    if (!$84f61e7391a78632$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($84f61e7391a78632$export$23f2a1d2818174ef(tval) && $84f61e7391a78632$export$23f2a1d2818174ef(sval)) $84f61e7391a78632$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $84f61e7391a78632$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $84f61e7391a78632$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $84f61e7391a78632$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $84f61e7391a78632$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $84f61e7391a78632$var$_getKeyResolver(key) {
    const keys = $84f61e7391a78632$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $84f61e7391a78632$export$2d1720544b23b823(obj, key) {
    const resolver = $84f61e7391a78632$var$keyResolvers[key] || ($84f61e7391a78632$var$keyResolvers[key] = $84f61e7391a78632$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $84f61e7391a78632$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $84f61e7391a78632$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $84f61e7391a78632$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $84f61e7391a78632$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $84f61e7391a78632$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $84f61e7391a78632$export$56c0d5a1e737357d = Math.PI;
const $84f61e7391a78632$export$971d5caa766a69d7 = 2 * $84f61e7391a78632$export$56c0d5a1e737357d;
const $84f61e7391a78632$export$2ec5befb9e6c97d4 = $84f61e7391a78632$export$971d5caa766a69d7 + $84f61e7391a78632$export$56c0d5a1e737357d;
const $84f61e7391a78632$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $84f61e7391a78632$export$39c1cc7c062529d4 = $84f61e7391a78632$export$56c0d5a1e737357d / 180;
const $84f61e7391a78632$export$7f8ddf7c7c20b3cd = $84f61e7391a78632$export$56c0d5a1e737357d / 2;
const $84f61e7391a78632$export$7a0bdf7d4a91ea88 = $84f61e7391a78632$export$56c0d5a1e737357d / 4;
const $84f61e7391a78632$export$c18d01048907ea92 = $84f61e7391a78632$export$56c0d5a1e737357d * 2 / 3;
const $84f61e7391a78632$export$faec65b429be379 = Math.log10;
const $84f61e7391a78632$export$2408f22a0fab9ae5 = Math.sign;
function $84f61e7391a78632$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $84f61e7391a78632$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $84f61e7391a78632$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($84f61e7391a78632$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $84f61e7391a78632$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $84f61e7391a78632$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $84f61e7391a78632$export$d141bba7fdc215a3(n) {
    return !$84f61e7391a78632$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $84f61e7391a78632$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $84f61e7391a78632$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $84f61e7391a78632$export$625550452a3fa3ec(degrees) {
    return degrees * ($84f61e7391a78632$export$56c0d5a1e737357d / 180);
}
function $84f61e7391a78632$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $84f61e7391a78632$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $84f61e7391a78632$export$91477dc880baac21(x) {
    if (!$84f61e7391a78632$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $84f61e7391a78632$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $84f61e7391a78632$export$56c0d5a1e737357d) angle += $84f61e7391a78632$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $84f61e7391a78632$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $84f61e7391a78632$export$f074adc9fbd50943(a, b) {
    return (a - b + $84f61e7391a78632$export$2ec5befb9e6c97d4) % $84f61e7391a78632$export$971d5caa766a69d7 - $84f61e7391a78632$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $84f61e7391a78632$export$ab83b03e4111b1d0(a) {
    return (a % $84f61e7391a78632$export$971d5caa766a69d7 + $84f61e7391a78632$export$971d5caa766a69d7) % $84f61e7391a78632$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $84f61e7391a78632$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $84f61e7391a78632$export$ab83b03e4111b1d0(angle);
    const s = $84f61e7391a78632$export$ab83b03e4111b1d0(start);
    const e = $84f61e7391a78632$export$ab83b03e4111b1d0(end);
    const angleToStart = $84f61e7391a78632$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $84f61e7391a78632$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $84f61e7391a78632$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $84f61e7391a78632$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $84f61e7391a78632$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $84f61e7391a78632$export$71cec2538cb2c617(value) {
    return $84f61e7391a78632$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $84f61e7391a78632$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $84f61e7391a78632$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $84f61e7391a78632$export$ef35774e6d314e91 = (table, key, value, last)=>$84f61e7391a78632$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $84f61e7391a78632$export$ebd11618f299a286 = (table, key, value)=>$84f61e7391a78632$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $84f61e7391a78632$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $84f61e7391a78632$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $84f61e7391a78632$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $84f61e7391a78632$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $84f61e7391a78632$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $84f61e7391a78632$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $84f61e7391a78632$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $84f61e7391a78632$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $84f61e7391a78632$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $84f61e7391a78632$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $84f61e7391a78632$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $84f61e7391a78632$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $84f61e7391a78632$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $84f61e7391a78632$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $84f61e7391a78632$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $84f61e7391a78632$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $84f61e7391a78632$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($84f61e7391a78632$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $84f61e7391a78632$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$84f61e7391a78632$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $84f61e7391a78632$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($84f61e7391a78632$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $84f61e7391a78632$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$84f61e7391a78632$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $84f61e7391a78632$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $84f61e7391a78632$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $84f61e7391a78632$var$atEdge = (t)=>t === 0 || t === 1;
const $84f61e7391a78632$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $84f61e7391a78632$export$971d5caa766a69d7 / p));
const $84f61e7391a78632$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $84f61e7391a78632$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $84f61e7391a78632$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $84f61e7391a78632$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $84f61e7391a78632$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($84f61e7391a78632$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : $84f61e7391a78632$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : $84f61e7391a78632$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $84f61e7391a78632$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $84f61e7391a78632$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $84f61e7391a78632$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $84f61e7391a78632$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $84f61e7391a78632$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $84f61e7391a78632$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $84f61e7391a78632$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $84f61e7391a78632$export$db3b6bfb95261072(value) {
    return $84f61e7391a78632$export$738ab4df8bf92ae9(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value);
}
function $84f61e7391a78632$export$d377dcb2b61d6c4e(value) {
    return $84f61e7391a78632$export$738ab4df8bf92ae9(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $84f61e7391a78632$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $84f61e7391a78632$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $84f61e7391a78632$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $84f61e7391a78632$var$colors
        },
        numbers: {
            type: 'number',
            properties: $84f61e7391a78632$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $84f61e7391a78632$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $84f61e7391a78632$var$intlCache = new Map();
function $84f61e7391a78632$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $84f61e7391a78632$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $84f61e7391a78632$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $84f61e7391a78632$export$ae1af26003f05816(num, locale, options) {
    return $84f61e7391a78632$var$getNumberFormat(locale, options).format(num);
}
const $84f61e7391a78632$var$formatters = {
    values (value) {
        return $84f61e7391a78632$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $84f61e7391a78632$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $84f61e7391a78632$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $84f61e7391a78632$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($84f61e7391a78632$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $84f61e7391a78632$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $84f61e7391a78632$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $84f61e7391a78632$export$9f4f30ee63539e24 = {
    formatters: $84f61e7391a78632$var$formatters
};
function $84f61e7391a78632$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $84f61e7391a78632$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $84f61e7391a78632$export$6559d589eb85fbb6 = Object.create(null);
const $84f61e7391a78632$export$2e2af4578d910ddf = Object.create(null);
function $84f61e7391a78632$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $84f61e7391a78632$var$set(root, scope, values) {
    if (typeof scope === 'string') return $84f61e7391a78632$export$efca4cbe5dd06740($84f61e7391a78632$var$getScope$1(root, scope), values);
    return $84f61e7391a78632$export$efca4cbe5dd06740($84f61e7391a78632$var$getScope$1(root, ''), scope);
}
class $84f61e7391a78632$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $84f61e7391a78632$var$set(this, scope, values);
    }
    get(scope) {
        return $84f61e7391a78632$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $84f61e7391a78632$var$set($84f61e7391a78632$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $84f61e7391a78632$var$set($84f61e7391a78632$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $84f61e7391a78632$var$getScope$1(this, scope);
        const targetScopeObject = $84f61e7391a78632$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($84f61e7391a78632$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $84f61e7391a78632$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $84f61e7391a78632$export$4368d992c4eafac0 = /* #__PURE__ */ new $84f61e7391a78632$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $84f61e7391a78632$var$applyAnimationsDefaults,
    $84f61e7391a78632$var$applyLayoutsDefaults,
    $84f61e7391a78632$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $84f61e7391a78632$export$e171bab687b50e0(font) {
    if (!font || $84f61e7391a78632$export$342063e11d6c3cad(font.size) || $84f61e7391a78632$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $84f61e7391a78632$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$84f61e7391a78632$export$8b22cf2602fb60ce(thing)) longest = $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($84f61e7391a78632$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$84f61e7391a78632$export$8b22cf2602fb60ce(nestedThing)) longest = $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $84f61e7391a78632$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $84f61e7391a78632$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $84f61e7391a78632$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $84f61e7391a78632$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $84f61e7391a78632$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $84f61e7391a78632$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $84f61e7391a78632$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $84f61e7391a78632$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $84f61e7391a78632$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $84f61e7391a78632$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $84f61e7391a78632$export$56c0d5a1e737357d, rad - $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $84f61e7391a78632$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $84f61e7391a78632$export$7f8ddf7c7c20b3cd, rad + $84f61e7391a78632$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $84f61e7391a78632$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $84f61e7391a78632$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $84f61e7391a78632$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $84f61e7391a78632$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $84f61e7391a78632$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $84f61e7391a78632$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$84f61e7391a78632$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $84f61e7391a78632$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $84f61e7391a78632$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $84f61e7391a78632$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $84f61e7391a78632$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $84f61e7391a78632$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $84f61e7391a78632$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$84f61e7391a78632$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $84f61e7391a78632$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $84f61e7391a78632$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $84f61e7391a78632$export$56c0d5a1e737357d, $84f61e7391a78632$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $84f61e7391a78632$export$56c0d5a1e737357d, $84f61e7391a78632$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $84f61e7391a78632$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$84f61e7391a78632$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $84f61e7391a78632$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $84f61e7391a78632$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $84f61e7391a78632$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($84f61e7391a78632$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $84f61e7391a78632$var$numberOrZero = (v)=>+v || 0;
function $84f61e7391a78632$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $84f61e7391a78632$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $84f61e7391a78632$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$84f61e7391a78632$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $84f61e7391a78632$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $84f61e7391a78632$export$9fa96a7d116ea3ce(value) {
    return $84f61e7391a78632$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $84f61e7391a78632$export$28f7fcd39efa255(value) {
    return $84f61e7391a78632$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $84f61e7391a78632$export$a9c23c6ac3fc3eca(value) {
    const obj = $84f61e7391a78632$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $84f61e7391a78632$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $84f61e7391a78632$export$4368d992c4eafac0.font;
    let size = $84f61e7391a78632$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $84f61e7391a78632$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($84f61e7391a78632$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $84f61e7391a78632$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $84f61e7391a78632$export$d29e374196577086($84f61e7391a78632$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $84f61e7391a78632$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $84f61e7391a78632$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $84f61e7391a78632$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $84f61e7391a78632$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $84f61e7391a78632$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $84f61e7391a78632$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $84f61e7391a78632$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $84f61e7391a78632$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$84f61e7391a78632$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $84f61e7391a78632$var$_cached(target, prop, ()=>$84f61e7391a78632$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $84f61e7391a78632$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $84f61e7391a78632$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $84f61e7391a78632$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $84f61e7391a78632$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$84f61e7391a78632$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$84f61e7391a78632$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $84f61e7391a78632$var$_cached(target, prop, ()=>$84f61e7391a78632$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $84f61e7391a78632$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $84f61e7391a78632$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $84f61e7391a78632$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $84f61e7391a78632$var$readKey = (prefix, name)=>prefix ? prefix + $84f61e7391a78632$export$a8550f7dbe79f93a(name) : name;
const $84f61e7391a78632$var$needsSubResolver = (prop, value)=>$84f61e7391a78632$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $84f61e7391a78632$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $84f61e7391a78632$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($84f61e7391a78632$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $84f61e7391a78632$var$_resolveScriptable(prop, value, target, receiver);
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(value) && value.length) value = $84f61e7391a78632$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($84f61e7391a78632$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $84f61e7391a78632$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $84f61e7391a78632$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($84f61e7391a78632$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $84f61e7391a78632$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $84f61e7391a78632$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($84f61e7391a78632$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $84f61e7391a78632$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($84f61e7391a78632$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $84f61e7391a78632$var$resolveFallback(fallback, prop, value) {
    return $84f61e7391a78632$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $84f61e7391a78632$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $84f61e7391a78632$export$2d1720544b23b823(parent, key) : undefined;
function $84f61e7391a78632$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $84f61e7391a78632$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $84f61e7391a78632$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $84f61e7391a78632$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $84f61e7391a78632$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $84f61e7391a78632$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $84f61e7391a78632$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $84f61e7391a78632$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$84f61e7391a78632$var$subGetTarget(resolver, prop, value));
}
function $84f61e7391a78632$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $84f61e7391a78632$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $84f61e7391a78632$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(target) && $84f61e7391a78632$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $84f61e7391a78632$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $84f61e7391a78632$var$_resolve($84f61e7391a78632$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $84f61e7391a78632$var$needsSubResolver(prop, value) ? $84f61e7391a78632$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $84f61e7391a78632$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $84f61e7391a78632$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $84f61e7391a78632$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $84f61e7391a78632$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $84f61e7391a78632$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($84f61e7391a78632$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $84f61e7391a78632$var$EPSILON = Number.EPSILON || 1e-14;
const $84f61e7391a78632$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $84f61e7391a78632$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $84f61e7391a78632$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $84f61e7391a78632$export$cf2f7c5792f80b46(current, previous);
    const d12 = $84f61e7391a78632$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $84f61e7391a78632$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($84f61e7391a78632$export$23ebac1979863676(deltaK[i], 0, $84f61e7391a78632$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $84f61e7391a78632$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $84f61e7391a78632$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $84f61e7391a78632$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $84f61e7391a78632$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $84f61e7391a78632$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $84f61e7391a78632$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $84f61e7391a78632$var$monotoneAdjust(points, deltaK, mK);
    $84f61e7391a78632$var$monotoneCompute(points, mK, indexAxis);
}
function $84f61e7391a78632$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $84f61e7391a78632$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $84f61e7391a78632$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $84f61e7391a78632$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $84f61e7391a78632$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $84f61e7391a78632$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $84f61e7391a78632$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $84f61e7391a78632$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $84f61e7391a78632$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $84f61e7391a78632$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $84f61e7391a78632$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $84f61e7391a78632$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $84f61e7391a78632$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $84f61e7391a78632$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $84f61e7391a78632$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $84f61e7391a78632$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $84f61e7391a78632$export$fef3dfd9bad05307(el, property) {
    return $84f61e7391a78632$var$getComputedStyle(el).getPropertyValue(property);
}
const $84f61e7391a78632$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $84f61e7391a78632$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $84f61e7391a78632$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $84f61e7391a78632$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $84f61e7391a78632$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($84f61e7391a78632$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $84f61e7391a78632$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $84f61e7391a78632$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $84f61e7391a78632$var$getPositionedStyle(style, 'padding');
    const borders = $84f61e7391a78632$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $84f61e7391a78632$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $84f61e7391a78632$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $84f61e7391a78632$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $84f61e7391a78632$var$getComputedStyle(container);
            const containerBorder = $84f61e7391a78632$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $84f61e7391a78632$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $84f61e7391a78632$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $84f61e7391a78632$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $84f61e7391a78632$export$53c86fa97d611818,
        maxHeight: maxHeight || $84f61e7391a78632$export$53c86fa97d611818
    };
}
const $84f61e7391a78632$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $84f61e7391a78632$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $84f61e7391a78632$var$getComputedStyle(canvas);
    const margins = $84f61e7391a78632$var$getPositionedStyle(style, 'margin');
    const maxWidth = $84f61e7391a78632$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $84f61e7391a78632$export$53c86fa97d611818;
    const maxHeight = $84f61e7391a78632$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $84f61e7391a78632$export$53c86fa97d611818;
    const containerSize = $84f61e7391a78632$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $84f61e7391a78632$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $84f61e7391a78632$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $84f61e7391a78632$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $84f61e7391a78632$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $84f61e7391a78632$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $84f61e7391a78632$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $84f61e7391a78632$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = $84f61e7391a78632$var$round1(chart.height * pixelRatio);
    const deviceWidth = $84f61e7391a78632$var$round1(chart.width * pixelRatio);
    chart.height = $84f61e7391a78632$var$round1(chart.height);
    chart.width = $84f61e7391a78632$var$round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $84f61e7391a78632$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($84f61e7391a78632$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $84f61e7391a78632$export$b4171a6734a65d42(element, property) {
    const value = $84f61e7391a78632$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $84f61e7391a78632$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $84f61e7391a78632$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $84f61e7391a78632$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $84f61e7391a78632$export$6554612db691658e(p1, cp1, t);
    const b = $84f61e7391a78632$export$6554612db691658e(cp1, cp2, t);
    const c = $84f61e7391a78632$export$6554612db691658e(cp2, p2, t);
    const d = $84f61e7391a78632$export$6554612db691658e(a, b, t);
    const e = $84f61e7391a78632$export$6554612db691658e(b, c, t);
    return $84f61e7391a78632$export$6554612db691658e(d, e, t);
}
const $84f61e7391a78632$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $84f61e7391a78632$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $84f61e7391a78632$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $84f61e7391a78632$var$getRightToLeftAdapter(rectX, width) : $84f61e7391a78632$var$getLeftToRightAdapter();
}
function $84f61e7391a78632$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $84f61e7391a78632$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $84f61e7391a78632$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $84f61e7391a78632$export$ffb5f4729a158638,
        compare: $84f61e7391a78632$export$f074adc9fbd50943,
        normalize: $84f61e7391a78632$export$ab83b03e4111b1d0
    };
    return {
        between: $84f61e7391a78632$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $84f61e7391a78632$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $84f61e7391a78632$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $84f61e7391a78632$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $84f61e7391a78632$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $84f61e7391a78632$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $84f61e7391a78632$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($84f61e7391a78632$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($84f61e7391a78632$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $84f61e7391a78632$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $84f61e7391a78632$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $84f61e7391a78632$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $84f61e7391a78632$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $84f61e7391a78632$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $84f61e7391a78632$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $84f61e7391a78632$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $84f61e7391a78632$var$splitByStyles(line, $84f61e7391a78632$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $84f61e7391a78632$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $84f61e7391a78632$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $84f61e7391a78632$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $84f61e7391a78632$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $84f61e7391a78632$var$readStyle(segmentOptions.setContext($84f61e7391a78632$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($84f61e7391a78632$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $84f61e7391a78632$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $84f61e7391a78632$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$84f61e7391a78632$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $84f61e7391a78632$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $84f61e7391a78632$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $84f61e7391a78632$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $84f61e7391a78632$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $84f61e7391a78632$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $84f61e7391a78632$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $84f61e7391a78632$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $84f61e7391a78632$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $216d2bdc6f281bf6$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $84f61e7391a78632$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $216d2bdc6f281bf6$export$a424a0aa8f687495 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Animator();
const $216d2bdc6f281bf6$var$transparent = 'transparent';
const $216d2bdc6f281bf6$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $84f61e7391a78632$export$db3b6bfb95261072)(from || $216d2bdc6f281bf6$var$transparent);
        const c1 = c0.valid && (0, $84f61e7391a78632$export$db3b6bfb95261072)(to || $216d2bdc6f281bf6$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $216d2bdc6f281bf6$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $84f61e7391a78632$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $84f61e7391a78632$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $216d2bdc6f281bf6$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $84f61e7391a78632$export$f1e1789686576879)[cfg.easing] || (0, $84f61e7391a78632$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $84f61e7391a78632$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $84f61e7391a78632$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $216d2bdc6f281bf6$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $84f61e7391a78632$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $216d2bdc6f281bf6$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $216d2bdc6f281bf6$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $216d2bdc6f281bf6$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $216d2bdc6f281bf6$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $216d2bdc6f281bf6$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $216d2bdc6f281bf6$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $216d2bdc6f281bf6$var$scaleClip(xScale, allowedOverflow);
    const y = $216d2bdc6f281bf6$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $216d2bdc6f281bf6$var$toClip(value) {
    let t, r, b, l;
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $216d2bdc6f281bf6$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(value) === (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $216d2bdc6f281bf6$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $216d2bdc6f281bf6$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $216d2bdc6f281bf6$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $216d2bdc6f281bf6$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $216d2bdc6f281bf6$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $216d2bdc6f281bf6$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $216d2bdc6f281bf6$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $216d2bdc6f281bf6$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $216d2bdc6f281bf6$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $216d2bdc6f281bf6$var$createDatasetContext(parent, index) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $216d2bdc6f281bf6$var$createDataContext(parent, index, element) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $216d2bdc6f281bf6$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $216d2bdc6f281bf6$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $216d2bdc6f281bf6$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $216d2bdc6f281bf6$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $216d2bdc6f281bf6$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.xAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.yAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.rAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $84f61e7391a78632$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $216d2bdc6f281bf6$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $84f61e7391a78632$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $216d2bdc6f281bf6$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $84f61e7391a78632$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $216d2bdc6f281bf6$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $216d2bdc6f281bf6$var$updateStacks(this, meta._parsed);
            meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $216d2bdc6f281bf6$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $216d2bdc6f281bf6$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $216d2bdc6f281bf6$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $216d2bdc6f281bf6$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $216d2bdc6f281bf6$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $84f61e7391a78632$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $216d2bdc6f281bf6$var$toClip((0, $84f61e7391a78632$export$90a7f3efeed30595)(this.options.clip, $216d2bdc6f281bf6$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $216d2bdc6f281bf6$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $216d2bdc6f281bf6$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(index);
        if (cached) return $216d2bdc6f281bf6$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $84f61e7391a78632$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($216d2bdc6f281bf6$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $216d2bdc6f281bf6$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $216d2bdc6f281bf6$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $84f61e7391a78632$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $216d2bdc6f281bf6$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $216d2bdc6f281bf6$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i) {
    if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(entry)) $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $216d2bdc6f281bf6$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $216d2bdc6f281bf6$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $216d2bdc6f281bf6$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$216d2bdc6f281bf6$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$216d2bdc6f281bf6$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $216d2bdc6f281bf6$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $216d2bdc6f281bf6$var$swap(edge, a, b);
        edge = $216d2bdc6f281bf6$var$startEnd(edge, b, a);
    } else edge = $216d2bdc6f281bf6$var$startEnd(edge, a, b);
    return edge;
}
function $216d2bdc6f281bf6$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $216d2bdc6f281bf6$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $216d2bdc6f281bf6$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $216d2bdc6f281bf6$export$e97d5dc64e999004 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($216d2bdc6f281bf6$var$parseValue((0, $84f61e7391a78632$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $216d2bdc6f281bf6$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $216d2bdc6f281bf6$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index);
            $216d2bdc6f281bf6$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $84f61e7391a78632$export$90a7f3efeed30595)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $216d2bdc6f281bf6$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $216d2bdc6f281bf6$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(value) !== (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $84f61e7391a78632$export$90a7f3efeed30595)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $216d2bdc6f281bf6$export$19b5c4773f17abe extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $84f61e7391a78632$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $84f61e7391a78632$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $84f61e7391a78632$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $84f61e7391a78632$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $84f61e7391a78632$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $84f61e7391a78632$export$56c0d5a1e737357d) + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $216d2bdc6f281bf6$export$e04603e7d8b77172 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                fontColor: color,
                                hidden: !chart.getDataVisibility(i),
                                lineDash: style.borderDash,
                                lineDashOffset: style.borderDashOffset,
                                lineJoin: style.borderJoinStyle,
                                lineWidth: style.borderWidth,
                                strokeStyle: style.borderColor,
                                textAlign: textAlign,
                                pointStyle: pointStyle,
                                borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                index: i
                            };
                        });
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $84f61e7391a78632$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $84f61e7391a78632$export$971d5caa766a69d7);
        let max = -(0, $84f61e7391a78632$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $84f61e7391a78632$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $84f61e7391a78632$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $84f61e7391a78632$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $84f61e7391a78632$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $84f61e7391a78632$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $84f61e7391a78632$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $84f61e7391a78632$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $216d2bdc6f281bf6$export$2a270b3a0d973c85 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $84f61e7391a78632$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $84f61e7391a78632$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $84f61e7391a78632$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $216d2bdc6f281bf6$export$b21a3f1286706191 extends $216d2bdc6f281bf6$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $216d2bdc6f281bf6$export$48dbc6ac651bf8be extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $84f61e7391a78632$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $216d2bdc6f281bf6$export$b2f2bae6713db87 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $84f61e7391a78632$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $84f61e7391a78632$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $216d2bdc6f281bf6$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $216d2bdc6f281bf6$export$e97d5dc64e999004,
    BubbleController: $216d2bdc6f281bf6$export$19b5c4773f17abe,
    DoughnutController: $216d2bdc6f281bf6$export$e04603e7d8b77172,
    LineController: $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0,
    PieController: $216d2bdc6f281bf6$export$b21a3f1286706191,
    PolarAreaController: $216d2bdc6f281bf6$export$2a270b3a0d973c85,
    RadarController: $216d2bdc6f281bf6$export$48dbc6ac651bf8be,
    ScatterController: $216d2bdc6f281bf6$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $216d2bdc6f281bf6$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $216d2bdc6f281bf6$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($216d2bdc6f281bf6$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    parse() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    format() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    add() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    diff() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    startOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    endOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
}
var $216d2bdc6f281bf6$export$f32766ea09ec8bc4 = {
    _date: $216d2bdc6f281bf6$var$DateAdapterBase
};
function $216d2bdc6f281bf6$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $84f61e7391a78632$export$ebd11618f299a286) : (0, $84f61e7391a78632$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $84f61e7391a78632$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $84f61e7391a78632$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $216d2bdc6f281bf6$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $84f61e7391a78632$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $84f61e7391a78632$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $216d2bdc6f281bf6$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $216d2bdc6f281bf6$export$a13296960cae0384 = {
    evaluateInteractionItems: $216d2bdc6f281bf6$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $216d2bdc6f281bf6$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $216d2bdc6f281bf6$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$216d2bdc6f281bf6$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $216d2bdc6f281bf6$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $216d2bdc6f281bf6$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $216d2bdc6f281bf6$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$216d2bdc6f281bf6$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$setLayoutDims(layouts, params) {
    const stacks = $216d2bdc6f281bf6$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $216d2bdc6f281bf6$var$wrapBoxes(boxes);
    const fullSize = $216d2bdc6f281bf6$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'right'));
    const top = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $216d2bdc6f281bf6$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $216d2bdc6f281bf6$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $216d2bdc6f281bf6$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $216d2bdc6f281bf6$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $216d2bdc6f281bf6$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $216d2bdc6f281bf6$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $216d2bdc6f281bf6$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $216d2bdc6f281bf6$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $216d2bdc6f281bf6$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $216d2bdc6f281bf6$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $216d2bdc6f281bf6$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $84f61e7391a78632$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $216d2bdc6f281bf6$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $216d2bdc6f281bf6$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($216d2bdc6f281bf6$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$handleMaxPadding(chartArea);
        $216d2bdc6f281bf6$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $216d2bdc6f281bf6$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $84f61e7391a78632$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $216d2bdc6f281bf6$export$a40a96b24b46cf35 extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $216d2bdc6f281bf6$var$EXPANDO_KEY = '$chartjs';
const $216d2bdc6f281bf6$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $216d2bdc6f281bf6$var$isNullOrEmpty = (value)=>value === null || value === '';
function $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $84f61e7391a78632$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $84f61e7391a78632$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $216d2bdc6f281bf6$var$eventListenerOptions = (0, $84f61e7391a78632$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $216d2bdc6f281bf6$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$fromNativeEvent(event, chart) {
    const type = $216d2bdc6f281bf6$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $84f61e7391a78632$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $216d2bdc6f281bf6$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $216d2bdc6f281bf6$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $216d2bdc6f281bf6$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $216d2bdc6f281bf6$var$drpListeningCharts = new Map();
let $216d2bdc6f281bf6$var$oldDevicePixelRatio = 0;
function $216d2bdc6f281bf6$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $216d2bdc6f281bf6$var$oldDevicePixelRatio) return;
    $216d2bdc6f281bf6$var$oldDevicePixelRatio = dpr;
    $216d2bdc6f281bf6$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.addEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
    $216d2bdc6f281bf6$var$drpListeningCharts.set(chart, resize);
}
function $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart) {
    $216d2bdc6f281bf6$var$drpListeningCharts.delete(chart);
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.removeEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
}
function $216d2bdc6f281bf6$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $84f61e7391a78632$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $84f61e7391a78632$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $216d2bdc6f281bf6$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart);
}
function $216d2bdc6f281bf6$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $84f61e7391a78632$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($216d2bdc6f281bf6$var$fromNativeEvent(event, chart));
    }, chart);
    $216d2bdc6f281bf6$var$addListener(canvas, type, proxy);
    return proxy;
}
class $216d2bdc6f281bf6$export$f02da7f882cf6b2e extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY]) return false;
        const initial = canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $216d2bdc6f281bf6$var$createAttachObserver,
            detach: $216d2bdc6f281bf6$var$createDetachObserver,
            resize: $216d2bdc6f281bf6$var$createResizeObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $216d2bdc6f281bf6$var$releaseObserver,
            detach: $216d2bdc6f281bf6$var$releaseObserver,
            resize: $216d2bdc6f281bf6$var$releaseObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $84f61e7391a78632$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $84f61e7391a78632$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $216d2bdc6f281bf6$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $84f61e7391a78632$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $216d2bdc6f281bf6$export$a40a96b24b46cf35;
    return $216d2bdc6f281bf6$export$f02da7f882cf6b2e;
}
class $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $84f61e7391a78632$export$d141bba7fdc215a3)(this.x) && (0, $84f61e7391a78632$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $216d2bdc6f281bf6$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $216d2bdc6f281bf6$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $216d2bdc6f281bf6$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, (0, $84f61e7391a78632$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, last, (0, $84f61e7391a78632$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $216d2bdc6f281bf6$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $216d2bdc6f281bf6$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $84f61e7391a78632$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $216d2bdc6f281bf6$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $84f61e7391a78632$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $84f61e7391a78632$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $216d2bdc6f281bf6$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $216d2bdc6f281bf6$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $216d2bdc6f281bf6$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $216d2bdc6f281bf6$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $216d2bdc6f281bf6$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $216d2bdc6f281bf6$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $216d2bdc6f281bf6$var$garbageCollect(caches, length) {
    (0, $84f61e7391a78632$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $216d2bdc6f281bf6$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $216d2bdc6f281bf6$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $84f61e7391a78632$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $216d2bdc6f281bf6$var$createScaleContext(parent, scale) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $216d2bdc6f281bf6$var$createTickContext(parent, index, tick) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $216d2bdc6f281bf6$var$titleAlign(align, position, reverse) {
    let ret = (0, $84f61e7391a78632$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $216d2bdc6f281bf6$var$reverseAlign(ret);
    return ret;
}
function $216d2bdc6f281bf6$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd) : (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $216d2bdc6f281bf6$export$d60cfc58d3c358b6 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $84f61e7391a78632$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $84f61e7391a78632$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $84f61e7391a78632$export$c4ce752e73470fba)(min, (0, $84f61e7391a78632$export$c4ce752e73470fba)(max, min)),
            max: (0, $84f61e7391a78632$export$c4ce752e73470fba)(max, (0, $84f61e7391a78632$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $84f61e7391a78632$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $216d2bdc6f281bf6$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $216d2bdc6f281bf6$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $216d2bdc6f281bf6$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $84f61e7391a78632$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $216d2bdc6f281bf6$var$getTickMarkLength(options.grid) - tickOpts.padding - $216d2bdc6f281bf6$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $216d2bdc6f281bf6$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $216d2bdc6f281bf6$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $216d2bdc6f281bf6$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(label) && !(0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label)) {
                width = (0, $84f61e7391a78632$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(nestedLabel) && !(0, $84f61e7391a78632$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $84f61e7391a78632$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $216d2bdc6f281bf6$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $84f61e7391a78632$export$71cec2538cb2c617)(this._alignToPixels ? (0, $84f61e7391a78632$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $216d2bdc6f281bf6$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $216d2bdc6f281bf6$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $84f61e7391a78632$export$34aec0b863436764)(title.font);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $216d2bdc6f281bf6$var$titleArgs(this, offset, position, align);
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $216d2bdc6f281bf6$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $84f61e7391a78632$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $84f61e7391a78632$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $216d2bdc6f281bf6$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $216d2bdc6f281bf6$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($216d2bdc6f281bf6$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $84f61e7391a78632$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $84f61e7391a78632$export$4368d992c4eafac0)[scope]) {
            delete (0, $84f61e7391a78632$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $84f61e7391a78632$export$6559d589eb85fbb6)[id];
        }
    }
}
function $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $84f61e7391a78632$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $84f61e7391a78632$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $84f61e7391a78632$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $84f61e7391a78632$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $216d2bdc6f281bf6$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $84f61e7391a78632$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $216d2bdc6f281bf6$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $84f61e7391a78632$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $216d2bdc6f281bf6$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $216d2bdc6f281bf6$var$Registry {
    constructor(){
        this.controllers = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $216d2bdc6f281bf6$var$TypedRegistry(Object, 'plugins');
        this.scales = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $84f61e7391a78632$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $84f61e7391a78632$export$a8550f7dbe79f93a)(method);
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $216d2bdc6f281bf6$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Registry();
class $216d2bdc6f281bf6$var$PluginService {
    constructor(){
        this._init = undefined;
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $84f61e7391a78632$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $84f61e7391a78632$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $216d2bdc6f281bf6$var$allPlugins(config);
        return options === false && !all ? [] : $216d2bdc6f281bf6$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $216d2bdc6f281bf6$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($216d2bdc6f281bf6$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($216d2bdc6f281bf6$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $216d2bdc6f281bf6$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $216d2bdc6f281bf6$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $216d2bdc6f281bf6$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $216d2bdc6f281bf6$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $216d2bdc6f281bf6$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $216d2bdc6f281bf6$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $216d2bdc6f281bf6$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $216d2bdc6f281bf6$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $216d2bdc6f281bf6$var$determineAxis(id, ...scaleOptions) {
    if ($216d2bdc6f281bf6$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $216d2bdc6f281bf6$var$axisFromPosition(opts.position) || id.length > 1 && $216d2bdc6f281bf6$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $216d2bdc6f281bf6$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'x', boundDs[0]) || $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $216d2bdc6f281bf6$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $84f61e7391a78632$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $216d2bdc6f281bf6$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleConf, $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config), (0, $84f61e7391a78632$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $84f61e7391a78632$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $84f61e7391a78632$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $84f61e7391a78632$export$555508cbc6add439)(scale, [
            (0, $84f61e7391a78632$export$4368d992c4eafac0).scales[scale.type],
            (0, $84f61e7391a78632$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $216d2bdc6f281bf6$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $216d2bdc6f281bf6$var$mergeScaleConfig(config, options);
}
function $216d2bdc6f281bf6$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $216d2bdc6f281bf6$var$initConfig(config) {
    config = config || {};
    config.data = $216d2bdc6f281bf6$var$initData(config.data);
    $216d2bdc6f281bf6$var$initOptions(config);
    return config;
}
const $216d2bdc6f281bf6$var$keyCache = new Map();
const $216d2bdc6f281bf6$var$keysCached = new Set();
function $216d2bdc6f281bf6$var$cachedKeys(cacheKey, generate) {
    let keys = $216d2bdc6f281bf6$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $216d2bdc6f281bf6$var$keyCache.set(cacheKey, keys);
        $216d2bdc6f281bf6$var$keysCached.add(keys);
    }
    return keys;
}
const $216d2bdc6f281bf6$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $84f61e7391a78632$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $216d2bdc6f281bf6$var$Config {
    constructor(config){
        this._config = $216d2bdc6f281bf6$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $216d2bdc6f281bf6$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $216d2bdc6f281bf6$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $216d2bdc6f281bf6$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $216d2bdc6f281bf6$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($216d2bdc6f281bf6$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {},
            (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $84f61e7391a78632$export$4368d992c4eafac0),
            (0, $84f61e7391a78632$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($216d2bdc6f281bf6$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $84f61e7391a78632$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $84f61e7391a78632$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $84f61e7391a78632$export$23f2a1d2818174ef)(context) ? (0, $84f61e7391a78632$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $216d2bdc6f281bf6$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $84f61e7391a78632$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $216d2bdc6f281bf6$var$hasFunction = (value)=>(0, $84f61e7391a78632$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $84f61e7391a78632$export$a93c5207d687da10)(value[key]));
function $216d2bdc6f281bf6$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $84f61e7391a78632$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $84f61e7391a78632$export$a93c5207d687da10)(value) || $216d2bdc6f281bf6$var$hasFunction(value)) || indexable && (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $216d2bdc6f281bf6$var$version = "4.5.1";
const $216d2bdc6f281bf6$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $216d2bdc6f281bf6$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $216d2bdc6f281bf6$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $216d2bdc6f281bf6$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $216d2bdc6f281bf6$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $84f61e7391a78632$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $84f61e7391a78632$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$getCanvas(item) {
    if ((0, $84f61e7391a78632$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $216d2bdc6f281bf6$var$instances = {};
const $216d2bdc6f281bf6$var$getChart = (key)=>{
    const canvas = $216d2bdc6f281bf6$var$getCanvas(key);
    return Object.values($216d2bdc6f281bf6$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $216d2bdc6f281bf6$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $216d2bdc6f281bf6$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $216d2bdc6f281bf6$export$acaa6426d77a227e {
    static defaults = (0, $84f61e7391a78632$export$4368d992c4eafac0);
    static instances = $216d2bdc6f281bf6$var$instances;
    static overrides = (0, $84f61e7391a78632$export$6559d589eb85fbb6);
    static registry = $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    static version = $216d2bdc6f281bf6$var$version;
    static getChart = $216d2bdc6f281bf6$var$getChart;
    static register(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.add(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    static unregister(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.remove(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $216d2bdc6f281bf6$var$Config(userConfig);
        const initialCanvas = $216d2bdc6f281bf6$var$getCanvas(item);
        const existingChart = $216d2bdc6f281bf6$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $216d2bdc6f281bf6$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $84f61e7391a78632$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $216d2bdc6f281bf6$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $84f61e7391a78632$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $216d2bdc6f281bf6$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'complete', $216d2bdc6f281bf6$var$onAnimationsComplete);
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'progress', $216d2bdc6f281bf6$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $84f61e7391a78632$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $84f61e7391a78632$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $216d2bdc6f281bf6$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $84f61e7391a78632$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $84f61e7391a78632$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $84f61e7391a78632$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $84f61e7391a78632$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $216d2bdc6f281bf6$var$positionIsHorizontal(scaleOptions.position, axis) !== $216d2bdc6f281bf6$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $84f61e7391a78632$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $84f61e7391a78632$export$d66501df72047452)(scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($216d2bdc6f281bf6$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $84f61e7391a78632$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($216d2bdc6f281bf6$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this.scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $84f61e7391a78632$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $216d2bdc6f281bf6$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $84f61e7391a78632$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $84f61e7391a78632$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $84f61e7391a78632$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($216d2bdc6f281bf6$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) $216d2bdc6f281bf6$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $216d2bdc6f281bf6$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $84f61e7391a78632$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $84f61e7391a78632$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $216d2bdc6f281bf6$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $84f61e7391a78632$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $216d2bdc6f281bf6$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $84f61e7391a78632$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $216d2bdc6f281bf6$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $84f61e7391a78632$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $84f61e7391a78632$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $84f61e7391a78632$export$3b513254972cfc9c)(e);
        const lastEvent = $216d2bdc6f281bf6$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $216d2bdc6f281bf6$var$invalidatePlugins() {
    return (0, $84f61e7391a78632$export$d66501df72047452)($216d2bdc6f281bf6$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $216d2bdc6f281bf6$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2, startAngle + (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$toRadiusCorners(value) {
    return (0, $84f61e7391a78632$export$1a82df3d29112e01)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $216d2bdc6f281bf6$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $216d2bdc6f281bf6$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $84f61e7391a78632$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $84f61e7391a78632$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $84f61e7391a78632$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $216d2bdc6f281bf6$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $84f61e7391a78632$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $216d2bdc6f281bf6$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $216d2bdc6f281bf6$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $84f61e7391a78632$export$971d5caa766a69d7) || (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $216d2bdc6f281bf6$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $84f61e7391a78632$export$971d5caa766a69d7) || (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    if (inner) $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $84f61e7391a78632$export$56c0d5a1e737357d) && borderRadius === 0 && borderJoinStyle !== 'miter') $216d2bdc6f281bf6$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $216d2bdc6f281bf6$export$d48203c759d6a1fc extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $84f61e7391a78632$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $84f61e7391a78632$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $84f61e7391a78632$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $84f61e7391a78632$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $84f61e7391a78632$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $84f61e7391a78632$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $84f61e7391a78632$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $216d2bdc6f281bf6$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $216d2bdc6f281bf6$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $216d2bdc6f281bf6$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $216d2bdc6f281bf6$var$getLineMethod(options) {
    if (options.stepped) return 0, $84f61e7391a78632$export$493d36ec626b6698;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $84f61e7391a78632$export$1fbe638ecf81657e;
    return $216d2bdc6f281bf6$var$lineTo;
}
function $216d2bdc6f281bf6$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $216d2bdc6f281bf6$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const lineMethod = $216d2bdc6f281bf6$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $216d2bdc6f281bf6$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $216d2bdc6f281bf6$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $216d2bdc6f281bf6$var$fastPathSegment : $216d2bdc6f281bf6$var$pathSegment;
}
function $216d2bdc6f281bf6$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $84f61e7391a78632$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $84f61e7391a78632$export$d24c54395ce0c509;
    return 0, $84f61e7391a78632$export$6554612db691658e;
}
function $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $216d2bdc6f281bf6$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(line);
    for (const segment of segments){
        $216d2bdc6f281bf6$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $216d2bdc6f281bf6$var$usePath2D = typeof Path2D === 'function';
function $216d2bdc6f281bf6$var$draw(ctx, line, start, count) {
    if ($216d2bdc6f281bf6$var$usePath2D && !line.options.segment) $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count);
    else $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count);
}
class $216d2bdc6f281bf6$export$55e463fa7bcd3469 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $84f61e7391a78632$export$306ddfe3a8403e2)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $84f61e7391a78632$export$7a38258bbe170828)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $84f61e7391a78632$export$2f6ca3d3b1f80bf5)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $216d2bdc6f281bf6$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $216d2bdc6f281bf6$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $216d2bdc6f281bf6$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $216d2bdc6f281bf6$export$bd159b522b230b7a extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $84f61e7391a78632$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $84f61e7391a78632$export$25ce5a424b770e84)(value, min, max);
}
function $216d2bdc6f281bf6$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(value);
    return {
        t: $216d2bdc6f281bf6$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $216d2bdc6f281bf6$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $216d2bdc6f281bf6$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $216d2bdc6f281bf6$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $216d2bdc6f281bf6$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $84f61e7391a78632$export$28f7fcd39efa255)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $84f61e7391a78632$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $216d2bdc6f281bf6$var$boundingRects(bar) {
    const bounds = $216d2bdc6f281bf6$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $216d2bdc6f281bf6$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $216d2bdc6f281bf6$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $216d2bdc6f281bf6$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $84f61e7391a78632$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $84f61e7391a78632$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $216d2bdc6f281bf6$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $216d2bdc6f281bf6$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $216d2bdc6f281bf6$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $216d2bdc6f281bf6$export$a16ed71bf4b07672 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $216d2bdc6f281bf6$var$boundingRects(this);
        const addRectPath = $216d2bdc6f281bf6$var$hasRadius(outer.radius) ? (0, $84f61e7391a78632$export$92108d983e8ee699) : $216d2bdc6f281bf6$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $216d2bdc6f281bf6$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $216d2bdc6f281bf6$export$d48203c759d6a1fc,
    BarElement: $216d2bdc6f281bf6$export$a16ed71bf4b07672,
    LineElement: $216d2bdc6f281bf6$export$55e463fa7bcd3469,
    PointElement: $216d2bdc6f281bf6$export$bd159b522b230b7a
});
const $216d2bdc6f281bf6$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $216d2bdc6f281bf6$var$BACKGROUND_COLORS = /* #__PURE__ */ $216d2bdc6f281bf6$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $216d2bdc6f281bf6$var$getBorderColor(i) {
    return $216d2bdc6f281bf6$var$BORDER_COLORS[i % $216d2bdc6f281bf6$var$BORDER_COLORS.length];
}
function $216d2bdc6f281bf6$var$getBackgroundColor(i) {
    return $216d2bdc6f281bf6$var$BACKGROUND_COLORS[i % $216d2bdc6f281bf6$var$BACKGROUND_COLORS.length];
}
function $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $216d2bdc6f281bf6$var$getBorderColor(i);
    dataset.backgroundColor = $216d2bdc6f281bf6$var$getBackgroundColor(i);
    return ++i;
}
function $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBorderColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBackgroundColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $216d2bdc6f281bf6$export$e04603e7d8b77172) i = $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $216d2bdc6f281bf6$export$2a270b3a0d973c85) i = $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i);
    };
}
function $216d2bdc6f281bf6$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $216d2bdc6f281bf6$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $216d2bdc6f281bf6$var$containsDefaultColorsDefenitions() {
    return (0, $84f61e7391a78632$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $84f61e7391a78632$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $216d2bdc6f281bf6$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $216d2bdc6f281bf6$var$containsColorsDefinitions(datasets) || $216d2bdc6f281bf6$var$containsColorsDefinition(chartOptions) || elements && $216d2bdc6f281bf6$var$containsColorsDefinitions(elements) || $216d2bdc6f281bf6$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $216d2bdc6f281bf6$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(minIndex) && !(0, $84f61e7391a78632$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $216d2bdc6f281bf6$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
    });
}
function $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $84f61e7391a78632$export$25ce5a424b770e84)((0, $84f61e7391a78632$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $84f61e7391a78632$export$25ce5a424b770e84)((0, $84f61e7391a78632$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $216d2bdc6f281bf6$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $84f61e7391a78632$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
    }
};
function $216d2bdc6f281bf6$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points);
        const bounds = $216d2bdc6f281bf6$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $84f61e7391a78632$export$2f6ca3d3b1f80bf5)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $216d2bdc6f281bf6$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $84f61e7391a78632$export$3d12bd131bb975d1)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $216d2bdc6f281bf6$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(start);
        end = (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $216d2bdc6f281bf6$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line);
    return points.length ? new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $216d2bdc6f281bf6$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $216d2bdc6f281bf6$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $84f61e7391a78632$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $216d2bdc6f281bf6$var$_decodeFill(line, index, count) {
    const fill = $216d2bdc6f281bf6$var$parseFillOption(line);
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $216d2bdc6f281bf6$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $216d2bdc6f281bf6$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $216d2bdc6f281bf6$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $84f61e7391a78632$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $216d2bdc6f281bf6$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $216d2bdc6f281bf6$var$getLinesBelow(scale, index);
    linesBelow.push($216d2bdc6f281bf6$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $216d2bdc6f281bf6$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $84f61e7391a78632$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $216d2bdc6f281bf6$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $84f61e7391a78632$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $216d2bdc6f281bf6$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(fill)) return $216d2bdc6f281bf6$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $216d2bdc6f281bf6$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $216d2bdc6f281bf6$var$computeBoundary(source);
    if (boundary instanceof $216d2bdc6f281bf6$var$simpleArc) return boundary;
    return $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line);
}
function $216d2bdc6f281bf6$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $216d2bdc6f281bf6$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $216d2bdc6f281bf6$var$computeCircularBoundary(source);
    return $216d2bdc6f281bf6$var$computeLinearBoundary(source);
}
function $216d2bdc6f281bf6$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale);
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $216d2bdc6f281bf6$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $216d2bdc6f281bf6$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $216d2bdc6f281bf6$var$_drawfill(ctx, source, area) {
    const target = $216d2bdc6f281bf6$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $84f61e7391a78632$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, area);
        $216d2bdc6f281bf6$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $216d2bdc6f281bf6$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.top);
            $216d2bdc6f281bf6$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $216d2bdc6f281bf6$var$clipHorizontal(ctx, target, area.left);
            $216d2bdc6f281bf6$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $216d2bdc6f281bf6$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $216d2bdc6f281bf6$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $216d2bdc6f281bf6$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $216d2bdc6f281bf6$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $216d2bdc6f281bf6$var$clipBounds(ctx, scale, clip, notShape && $216d2bdc6f281bf6$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $216d2bdc6f281bf6$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $216d2bdc6f281bf6$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $216d2bdc6f281bf6$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $216d2bdc6f281bf6$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($216d2bdc6f281bf6$var$_shouldApplyFill(source)) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$216d2bdc6f281bf6$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $216d2bdc6f281bf6$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $216d2bdc6f281bf6$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $216d2bdc6f281bf6$var$Legend extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $84f61e7391a78632$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $84f61e7391a78632$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $84f61e7391a78632$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $84f61e7391a78632$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $84f61e7391a78632$export$28f7fcd39efa255)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $84f61e7391a78632$export$92108d983e8ee699)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $84f61e7391a78632$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $84f61e7391a78632$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $84f61e7391a78632$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $84f61e7391a78632$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $84f61e7391a78632$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $84f61e7391a78632$export$21579262ef46735b)(x, this.left, this.right) && (0, $84f61e7391a78632$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $84f61e7391a78632$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $84f61e7391a78632$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$216d2bdc6f281bf6$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $216d2bdc6f281bf6$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $216d2bdc6f281bf6$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $216d2bdc6f281bf6$export$ed247974535929c7 = {
    id: 'legend',
    _element: $216d2bdc6f281bf6$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $216d2bdc6f281bf6$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $216d2bdc6f281bf6$var$Title extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $84f61e7391a78632$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $84f61e7391a78632$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $84f61e7391a78632$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $216d2bdc6f281bf6$var$createTitle(chart, titleOpts) {
    const title = new $216d2bdc6f281bf6$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $216d2bdc6f281bf6$export$f99233281efd08a0 = {
    id: 'title',
    _element: $216d2bdc6f281bf6$var$Title,
    start (chart, _args, options) {
        $216d2bdc6f281bf6$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$map = new WeakMap();
var $216d2bdc6f281bf6$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $216d2bdc6f281bf6$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
        $216d2bdc6f281bf6$var$map.set(chart, title);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, $216d2bdc6f281bf6$var$map.get(chart));
        $216d2bdc6f281bf6$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $216d2bdc6f281bf6$var$map.get(chart);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $216d2bdc6f281bf6$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $216d2bdc6f281bf6$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $216d2bdc6f281bf6$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $216d2bdc6f281bf6$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $84f61e7391a78632$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $216d2bdc6f281bf6$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $216d2bdc6f281bf6$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $216d2bdc6f281bf6$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $216d2bdc6f281bf6$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $216d2bdc6f281bf6$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$28f7fcd39efa255)(cornerRadius);
    let x = $216d2bdc6f281bf6$var$alignX(size, xAlign);
    const y = $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $84f61e7391a78632$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $84f61e7391a78632$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $216d2bdc6f281bf6$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $216d2bdc6f281bf6$var$getBeforeAfterBodyLines(callback) {
    return $216d2bdc6f281bf6$var$pushOrConcat([], $216d2bdc6f281bf6$var$splitNewlines(callback));
}
function $216d2bdc6f281bf6$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $216d2bdc6f281bf6$var$defaultCallbacks = {
    beforeTitle: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeBody: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeLabel: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    afterBody: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeFooter: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    footer: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    afterFooter: (0, $84f61e7391a78632$export$53a70dd1ebbae346)
};
function $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $216d2bdc6f281bf6$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $216d2bdc6f281bf6$var$Tooltip extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static positioners = $216d2bdc6f281bf6$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeTitle));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(title));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $84f61e7391a78632$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context);
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.before, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.lines, $216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.after, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeFooter));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(footer));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($216d2bdc6f281bf6$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $84f61e7391a78632$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$28f7fcd39efa255)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
        const colorX = $216d2bdc6f281bf6$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $84f61e7391a78632$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $84f61e7391a78632$export$28f7fcd39efa255)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $84f61e7391a78632$export$92108d983e8ee699)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $84f61e7391a78632$export$92108d983e8ee699)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $84f61e7391a78632$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $84f61e7391a78632$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$28f7fcd39efa255)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(chart, options, positionAndSize);
            const point = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $84f61e7391a78632$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $84f61e7391a78632$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $216d2bdc6f281bf6$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $216d2bdc6f281bf6$var$Tooltip,
    positioners: $216d2bdc6f281bf6$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $216d2bdc6f281bf6$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $216d2bdc6f281bf6$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $216d2bdc6f281bf6$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $216d2bdc6f281bf6$export$c537fa0d021d010b,
    Decimation: $216d2bdc6f281bf6$export$be17f937e9aa7533,
    Filler: $216d2bdc6f281bf6$export$d19ba4d812bed757,
    Legend: $216d2bdc6f281bf6$export$ed247974535929c7,
    SubTitle: $216d2bdc6f281bf6$export$d5c56664638992a4,
    Title: $216d2bdc6f281bf6$export$f99233281efd08a0,
    Tooltip: $216d2bdc6f281bf6$export$28c660c63b792dea
});
const $216d2bdc6f281bf6$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $216d2bdc6f281bf6$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $216d2bdc6f281bf6$var$validIndex = (index, max)=>index === null ? null : (0, $84f61e7391a78632$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $216d2bdc6f281bf6$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $216d2bdc6f281bf6$export$29e663ba4d09fe7 extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $216d2bdc6f281bf6$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, (0, $84f61e7391a78632$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $216d2bdc6f281bf6$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $216d2bdc6f281bf6$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $216d2bdc6f281bf6$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $84f61e7391a78632$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $84f61e7391a78632$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $84f61e7391a78632$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $84f61e7391a78632$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $84f61e7391a78632$export$91477dc880baac21)(spacing), (0, $84f61e7391a78632$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $84f61e7391a78632$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $84f61e7391a78632$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $216d2bdc6f281bf6$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $84f61e7391a78632$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $216d2bdc6f281bf6$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $216d2bdc6f281bf6$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $84f61e7391a78632$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $216d2bdc6f281bf6$var$LinearScaleBase extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $216d2bdc6f281bf6$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $84f61e7391a78632$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $84f61e7391a78632$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $216d2bdc6f281bf6$export$e7f4e5e8656f0b93 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $216d2bdc6f281bf6$var$log10Floor = (v)=>Math.floor((0, $84f61e7391a78632$export$faec65b429be379)(v));
const $216d2bdc6f281bf6$var$changeExponent = (v, m)=>Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(v) + m);
function $216d2bdc6f281bf6$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(tickVal));
    return remain === 1;
}
function $216d2bdc6f281bf6$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $216d2bdc6f281bf6$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $216d2bdc6f281bf6$var$log10Floor(range);
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $216d2bdc6f281bf6$var$log10Floor(min));
}
function $216d2bdc6f281bf6$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $216d2bdc6f281bf6$var$log10Floor(min);
    let exp = $216d2bdc6f281bf6$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $216d2bdc6f281bf6$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $216d2bdc6f281bf6$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $216d2bdc6f281bf6$export$85295eaf7cb3ac3e extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $216d2bdc6f281bf6$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $84f61e7391a78632$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $84f61e7391a78632$export$39b482c5e57630a8)(this._userMin)) this.min = min === $216d2bdc6f281bf6$var$changeExponent(this.min, 0) ? $216d2bdc6f281bf6$var$changeExponent(this.min, -1) : $216d2bdc6f281bf6$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($216d2bdc6f281bf6$var$changeExponent(min, -1));
                setMax($216d2bdc6f281bf6$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($216d2bdc6f281bf6$var$changeExponent(max, -1));
        if (max <= 0) setMax($216d2bdc6f281bf6$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $216d2bdc6f281bf6$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $84f61e7391a78632$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $84f61e7391a78632$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $84f61e7391a78632$export$faec65b429be379)(start);
        this._valueRange = (0, $84f61e7391a78632$export$faec65b429be379)(this.max) - (0, $84f61e7391a78632$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $84f61e7391a78632$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $84f61e7391a78632$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $84f61e7391a78632$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $216d2bdc6f281bf6$var$measureLabelSize(ctx, font, label) {
    label = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $84f61e7391a78632$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $216d2bdc6f281bf6$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $216d2bdc6f281bf6$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $84f61e7391a78632$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
        const textSize = $216d2bdc6f281bf6$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $216d2bdc6f281bf6$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $216d2bdc6f281bf6$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $216d2bdc6f281bf6$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)((0, $84f61e7391a78632$export$ab83b03e4111b1d0)(pointLabelPosition.angle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd))));
    const y = $216d2bdc6f281bf6$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $216d2bdc6f281bf6$var$getTextAlignForAngle(angle);
    const left = $216d2bdc6f281bf6$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $216d2bdc6f281bf6$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $84f61e7391a78632$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $216d2bdc6f281bf6$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $216d2bdc6f281bf6$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $216d2bdc6f281bf6$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $216d2bdc6f281bf6$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $216d2bdc6f281bf6$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $84f61e7391a78632$export$28f7fcd39efa255)(opts.borderRadius);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $84f61e7391a78632$export$92108d983e8ee699)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $216d2bdc6f281bf6$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $84f61e7391a78632$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $84f61e7391a78632$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $216d2bdc6f281bf6$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $216d2bdc6f281bf6$var$createPointLabelContext(parent, index, label) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $216d2bdc6f281bf6$export$cfafc36d95386d38 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)($216d2bdc6f281bf6$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $216d2bdc6f281bf6$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $216d2bdc6f281bf6$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $216d2bdc6f281bf6$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $84f61e7391a78632$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(index * angleMultiplier + (0, $84f61e7391a78632$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $216d2bdc6f281bf6$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $216d2bdc6f281bf6$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $216d2bdc6f281bf6$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $216d2bdc6f281bf6$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $84f61e7391a78632$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $216d2bdc6f281bf6$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $216d2bdc6f281bf6$var$UNITS = /* #__PURE__ */ Object.keys($216d2bdc6f281bf6$var$INTERVALS);
function $216d2bdc6f281bf6$var$sorter(a, b) {
    return a - b;
}
function $216d2bdc6f281bf6$var$parse(scale, input) {
    if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $84f61e7391a78632$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $84f61e7391a78632$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $216d2bdc6f281bf6$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $216d2bdc6f281bf6$var$UNITS.length;
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $216d2bdc6f281bf6$var$UNITS[i];
    }
    return $216d2bdc6f281bf6$var$UNITS[ilen - 1];
}
function $216d2bdc6f281bf6$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.length - 1; i >= $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i--){
        const unit = $216d2bdc6f281bf6$var$UNITS[i];
        if ($216d2bdc6f281bf6$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $216d2bdc6f281bf6$var$UNITS[minUnit ? $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit) : 0];
}
function $216d2bdc6f281bf6$var$determineMajorUnit(unit) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(unit) + 1, ilen = $216d2bdc6f281bf6$var$UNITS.length; i < ilen; ++i){
        if ($216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]].common) return $216d2bdc6f281bf6$var$UNITS[i];
    }
}
function $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $84f61e7391a78632$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $216d2bdc6f281bf6$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $216d2bdc6f281bf6$export$a894c72689ff3ec extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $216d2bdc6f281bf6$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $84f61e7391a78632$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $216d2bdc6f281bf6$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $84f61e7391a78632$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $216d2bdc6f281bf6$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $216d2bdc6f281bf6$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $216d2bdc6f281bf6$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $84f61e7391a78632$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $84f61e7391a78632$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($216d2bdc6f281bf6$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $84f61e7391a78632$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $216d2bdc6f281bf6$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($216d2bdc6f281bf6$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $84f61e7391a78632$export$71511d61b312f219)(values.sort($216d2bdc6f281bf6$var$sorter));
    }
}
function $216d2bdc6f281bf6$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $84f61e7391a78632$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $84f61e7391a78632$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $216d2bdc6f281bf6$export$85df64a8eb6dc986 extends $216d2bdc6f281bf6$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $216d2bdc6f281bf6$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $216d2bdc6f281bf6$var$interpolate(table, this.min);
        this._tableRange = $216d2bdc6f281bf6$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($216d2bdc6f281bf6$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $216d2bdc6f281bf6$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $216d2bdc6f281bf6$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $216d2bdc6f281bf6$export$29e663ba4d09fe7,
    LinearScale: $216d2bdc6f281bf6$export$e7f4e5e8656f0b93,
    LogarithmicScale: $216d2bdc6f281bf6$export$85295eaf7cb3ac3e,
    RadialLinearScale: $216d2bdc6f281bf6$export$cfafc36d95386d38,
    TimeScale: $216d2bdc6f281bf6$export$a894c72689ff3ec,
    TimeSeriesScale: $216d2bdc6f281bf6$export$85df64a8eb6dc986
});
const $216d2bdc6f281bf6$export$e8959e79e3af550f = [
    $216d2bdc6f281bf6$export$a6506504f799c5d5,
    $216d2bdc6f281bf6$export$7a5d735b2ab6389d,
    $216d2bdc6f281bf6$export$8b3ca321c77fdea6,
    $216d2bdc6f281bf6$export$bcac1c16f1530ec2
];


const $e3267dd1fa7af6a7$var$defaultDatasetIdKey = "label";
function $e3267dd1fa7af6a7$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $e3267dd1fa7af6a7$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $e3267dd1fa7af6a7$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $e3267dd1fa7af6a7$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $e3267dd1fa7af6a7$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $e3267dd1fa7af6a7$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e3267dd1fa7af6a7$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $e3267dd1fa7af6a7$var$setLabels(nextData, data.labels);
    $e3267dd1fa7af6a7$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $e3267dd1fa7af6a7$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $e3267dd1fa7af6a7$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $e3267dd1fa7af6a7$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $e3267dd1fa7af6a7$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $acw62.useRef)(null);
    const chartRef = (0, $acw62.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $216d2bdc6f281bf6$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $e3267dd1fa7af6a7$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $e3267dd1fa7af6a7$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $e3267dd1fa7af6a7$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $e3267dd1fa7af6a7$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!redraw && chartRef.current) $e3267dd1fa7af6a7$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $e3267dd1fa7af6a7$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $acw62.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const $e3267dd1fa7af6a7$export$acaa6426d77a227e = /*#__PURE__*/ (0, $acw62.forwardRef)($e3267dd1fa7af6a7$var$ChartComponent);
function $e3267dd1fa7af6a7$var$createTypedChart(type, registerables) {
    (0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e3267dd1fa7af6a7$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $e3267dd1fa7af6a7$export$17d680238e50603e = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("line", (0, $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0));
const $e3267dd1fa7af6a7$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("bar", (0, $216d2bdc6f281bf6$export$e97d5dc64e999004));
const $e3267dd1fa7af6a7$export$bace472c466fdd25 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("radar", (0, $216d2bdc6f281bf6$export$48dbc6ac651bf8be));
const $e3267dd1fa7af6a7$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("doughnut", (0, $216d2bdc6f281bf6$export$e04603e7d8b77172));
const $e3267dd1fa7af6a7$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("polarArea", (0, $216d2bdc6f281bf6$export$2a270b3a0d973c85));
const $e3267dd1fa7af6a7$export$646feb54fbadbe06 = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("bubble", (0, $216d2bdc6f281bf6$export$19b5c4773f17abe));
const $e3267dd1fa7af6a7$export$2ae8800cf67c848c = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("pie", (0, $216d2bdc6f281bf6$export$b21a3f1286706191));
const $e3267dd1fa7af6a7$export$1c460fb4285edadc = /* #__PURE__ */ $e3267dd1fa7af6a7$var$createTypedChart("scatter", (0, $216d2bdc6f281bf6$export$b2f2bae6713db87));



/*!
* chartjs-plugin-annotation v2.2.1
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2023 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */ 



/**
 * @typedef { import("chart.js").ChartEvent } ChartEvent
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $4049e6bf31df43d6$var$interaction = {
    modes: {
        /**
     * Point mode returns all elements that hit test based on the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */ point (state, event) {
            return $4049e6bf31df43d6$var$filterElements(state, event, {
                intersect: true
            });
        },
        /**
     * Nearest mode returns the element closest to the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */ nearest (state, event, options) {
            return $4049e6bf31df43d6$var$getNearestItem(state, event, options);
        },
        /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */ x (state, event, options) {
            return $4049e6bf31df43d6$var$filterElements(state, event, {
                intersect: options.intersect,
                axis: 'x'
            });
        },
        /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */ y (state, event, options) {
            return $4049e6bf31df43d6$var$filterElements(state, event, {
                intersect: options.intersect,
                axis: 'y'
            });
        }
    }
};
/**
 * Returns all elements that hit test based on the event position
 * @param {Object} state - the state of the plugin
 * @param {ChartEvent} event - the event we are find things at
 * @param {Object} options - interaction options to use
 * @return {AnnotationElement[]} - elements that are found
 */ function $4049e6bf31df43d6$var$getElements(state, event, options) {
    const mode = $4049e6bf31df43d6$var$interaction.modes[options.mode] || $4049e6bf31df43d6$var$interaction.modes.nearest;
    return mode(state, event, options);
}
function $4049e6bf31df43d6$var$inRangeByAxis(element, event, axis) {
    if (axis !== 'x' && axis !== 'y') return element.inRange(event.x, event.y, 'x', true) || element.inRange(event.x, event.y, 'y', true);
    return element.inRange(event.x, event.y, axis, true);
}
function $4049e6bf31df43d6$var$getPointByAxis(event, center, axis) {
    if (axis === 'x') return {
        x: event.x,
        y: center.y
    };
    else if (axis === 'y') return {
        x: center.x,
        y: event.y
    };
    return center;
}
function $4049e6bf31df43d6$var$filterElements(state, event, options) {
    return state.visibleElements.filter((element)=>options.intersect ? element.inRange(event.x, event.y) : $4049e6bf31df43d6$var$inRangeByAxis(element, event, options.axis));
}
function $4049e6bf31df43d6$var$getNearestItem(state, event, options) {
    let minDistance = Number.POSITIVE_INFINITY;
    return $4049e6bf31df43d6$var$filterElements(state, event, options).reduce((nearestItems, element)=>{
        const center = element.getCenterPoint();
        const evenPoint = $4049e6bf31df43d6$var$getPointByAxis(event, center, options.axis);
        const distance = (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(event, evenPoint);
        if (distance < minDistance) {
            nearestItems = [
                element
            ];
            minDistance = distance;
        } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
        nearestItems.push(element);
        return nearestItems;
    }, []).sort((a, b)=>a._index - b._index).slice(0, 1); // return only the top item;
}
const $4049e6bf31df43d6$var$isOlderPart = (act, req)=>req > act || act.length > req.length && act.slice(0, req.length) === req;
/**
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('chart.js').InteractionAxis } InteractionAxis
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $4049e6bf31df43d6$var$EPSILON = 0.001;
const $4049e6bf31df43d6$var$clamp = (x, from, to)=>Math.min(to, Math.max(from, x));
/**
 * @param {Object} obj
 * @param {number} from
 * @param {number} to
 * @returns {Object}
 */ function $4049e6bf31df43d6$var$clampAll(obj, from, to) {
    for (const key of Object.keys(obj))obj[key] = $4049e6bf31df43d6$var$clamp(obj[key], from, to);
    return obj;
}
/**
 * @param {Point} point
 * @param {Point} center
 * @param {number} radius
 * @param {number} borderWidth
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$inPointRange(point, center, radius, borderWidth) {
    if (!point || !center || radius <= 0) return false;
    const hBorderWidth = borderWidth / 2;
    return Math.pow(point.x - center.x, 2) + Math.pow(point.y - center.y, 2) <= Math.pow(radius + hBorderWidth, 2);
}
/**
 * @param {Point} point
 * @param {{x: number, y: number, x2: number, y2: number}} rect
 * @param {InteractionAxis} axis
 * @param {number} borderWidth
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$inBoxRange(point, { x: x, y: y, x2: x2, y2: y2 }, axis, borderWidth) {
    const hBorderWidth = borderWidth / 2;
    const inRangeX = point.x >= x - hBorderWidth - $4049e6bf31df43d6$var$EPSILON && point.x <= x2 + hBorderWidth + $4049e6bf31df43d6$var$EPSILON;
    const inRangeY = point.y >= y - hBorderWidth - $4049e6bf31df43d6$var$EPSILON && point.y <= y2 + hBorderWidth + $4049e6bf31df43d6$var$EPSILON;
    if (axis === 'x') return inRangeX;
    else if (axis === 'y') return inRangeY;
    return inRangeX && inRangeY;
}
/**
 * @param {AnnotationElement} element
 * @param {boolean} useFinalPosition
 * @returns {Point}
 */ function $4049e6bf31df43d6$var$getElementCenterPoint(element, useFinalPosition) {
    const { centerX: centerX, centerY: centerY } = element.getProps([
        'centerX',
        'centerY'
    ], useFinalPosition);
    return {
        x: centerX,
        y: centerY
    };
}
/**
 * @param {string} pkg
 * @param {string} min
 * @param {string} ver
 * @param {boolean} [strict=true]
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$requireVersion(pkg, min, ver, strict = true) {
    const parts = ver.split('.');
    let i = 0;
    for (const req of min.split('.')){
        const act = parts[i++];
        if (parseInt(req, 10) < parseInt(act, 10)) break;
        if ($4049e6bf31df43d6$var$isOlderPart(act, req)) {
            if (strict) throw new Error(`${pkg} v${ver} is not supported. v${min} or newer is required.`);
            else return false;
        }
    }
    return true;
}
const $4049e6bf31df43d6$var$isPercentString = (s)=>typeof s === 'string' && s.endsWith('%');
const $4049e6bf31df43d6$var$toPercent = (s)=>parseFloat(s) / 100;
const $4049e6bf31df43d6$var$toPositivePercent = (s)=>$4049e6bf31df43d6$var$clamp($4049e6bf31df43d6$var$toPercent(s), 0, 1);
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import('../../types/element').AnnotationBoxModel } AnnotationBoxModel
 * @typedef { import('../../types/options').AnnotationPointCoordinates } AnnotationPointCoordinates
 * @typedef { import('../../types/label').CoreLabelOptions } CoreLabelOptions
 * @typedef { import('../../types/label').LabelPositionObject } LabelPositionObject
 */ /**
 * @param {number} size
 * @param {number|string} position
 * @returns {number}
 */ function $4049e6bf31df43d6$var$getRelativePosition(size, position) {
    if (position === 'start') return 0;
    if (position === 'end') return size;
    if ($4049e6bf31df43d6$var$isPercentString(position)) return $4049e6bf31df43d6$var$toPositivePercent(position) * size;
    return size / 2;
}
/**
 * @param {number} size
 * @param {number|string} value
 * @param {boolean} [positivePercent=true]
 * @returns {number}
 */ function $4049e6bf31df43d6$var$getSize(size, value, positivePercent = true) {
    if (typeof value === 'number') return value;
    else if ($4049e6bf31df43d6$var$isPercentString(value)) return (positivePercent ? $4049e6bf31df43d6$var$toPositivePercent(value) : $4049e6bf31df43d6$var$toPercent(value)) * size;
    return size;
}
/**
 * @param {{x: number, width: number}} size
 * @param {CoreLabelOptions} options
 * @returns {number}
 */ function $4049e6bf31df43d6$var$calculateTextAlignment(size, options) {
    const { x: x, width: width } = size;
    const textAlign = options.textAlign;
    if (textAlign === 'center') return x + width / 2;
    else if (textAlign === 'end' || textAlign === 'right') return x + width;
    return x;
}
/**
 * @param {{x: number|string, y: number|string}|string|number} value
 * @param {string|number} defaultValue
 * @returns {{x: number|string, y: number|string}}
 */ function $4049e6bf31df43d6$var$toPosition(value, defaultValue = 'center') {
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(value)) return {
        x: (0, $84f61e7391a78632$export$90a7f3efeed30595)(value.x, defaultValue),
        y: (0, $84f61e7391a78632$export$90a7f3efeed30595)(value.y, defaultValue)
    };
    value = (0, $84f61e7391a78632$export$90a7f3efeed30595)(value, defaultValue);
    return {
        x: value,
        y: value
    };
}
/**
 * @param {AnnotationPointCoordinates} options
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$isBoundToPoint(options) {
    return options && ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(options.xValue) || (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(options.yValue));
}
/**
 * @param {Chart} chart
 * @param {AnnotationBoxModel} properties
 * @param {CoreAnnotationOptions} options
 * @param {boolean} [centerBased=false]
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options, centerBased = false) {
    const initAnim = options.init;
    if (!initAnim) return;
    else if (initAnim === true) return $4049e6bf31df43d6$var$applyDefault(properties, centerBased);
    return $4049e6bf31df43d6$var$checkCallbackResult(properties, centerBased, (0, $84f61e7391a78632$export$3722cfe417b6ed86)(initAnim, [
        {
            chart: chart,
            properties: properties,
            options: options
        }
    ]));
}
/**
 * @param {Object} options
 * @param {Array} hooks
 * @param {Object} hooksContainer
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$loadHooks(options, hooks, hooksContainer) {
    let activated = false;
    hooks.forEach((hook)=>{
        if ((0, $84f61e7391a78632$export$a93c5207d687da10)(options[hook])) {
            activated = true;
            hooksContainer[hook] = options[hook];
        } else if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(hooksContainer[hook])) delete hooksContainer[hook];
    });
    return activated;
}
function $4049e6bf31df43d6$var$applyDefault({ centerX: centerX, centerY: centerY }, centerBased) {
    if (centerBased) return {
        centerX: centerX,
        centerY: centerY,
        radius: 0,
        width: 0,
        height: 0
    };
    return {
        x: centerX,
        y: centerY,
        x2: centerX,
        y2: centerY,
        width: 0,
        height: 0
    };
}
function $4049e6bf31df43d6$var$checkCallbackResult(properties, centerBased, result) {
    if (result === true) return $4049e6bf31df43d6$var$applyDefault(properties, centerBased);
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(result)) return result;
}
const $4049e6bf31df43d6$var$widthCache = new Map();
const $4049e6bf31df43d6$var$notRadius = (radius)=>isNaN(radius) || radius <= 0;
const $4049e6bf31df43d6$var$fontsKey = (fonts)=>fonts.reduce(function(prev, item) {
        prev += item.string;
        return prev;
    }, '');
/**
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('../../types/label').CoreLabelOptions } CoreLabelOptions
 * @typedef { import('../../types/options').PointAnnotationOptions } PointAnnotationOptions
 */ /**
 * Determine if content is an image or a canvas.
 * @param {*} content
 * @returns boolean|undefined
 * @todo move this function to chart.js helpers
 */ function $4049e6bf31df43d6$var$isImageOrCanvas(content) {
    if (content && typeof content === 'object') {
        const type = content.toString();
        return type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]';
    }
}
/**
 * Set the translation on the canvas if the rotation must be applied.
 * @param {CanvasRenderingContext2D} ctx - chart canvas context
 * @param {Point} point - the point of translation
 * @param {number} rotation - rotation (in degrees) to apply
 */ function $4049e6bf31df43d6$var$translate(ctx, { x: x, y: y }, rotation) {
    if (rotation) {
        ctx.translate(x, y);
        ctx.rotate((0, $84f61e7391a78632$export$625550452a3fa3ec)(rotation));
        ctx.translate(-x, -y);
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} options
 * @returns {boolean|undefined}
 */ function $4049e6bf31df43d6$var$setBorderStyle(ctx, options) {
    if (options && options.borderWidth) {
        ctx.lineCap = options.borderCapStyle;
        ctx.setLineDash(options.borderDash);
        ctx.lineDashOffset = options.borderDashOffset;
        ctx.lineJoin = options.borderJoinStyle;
        ctx.lineWidth = options.borderWidth;
        ctx.strokeStyle = options.borderColor;
        return true;
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} options
 */ function $4049e6bf31df43d6$var$setShadowStyle(ctx, options) {
    ctx.shadowColor = options.backgroundShadowColor;
    ctx.shadowBlur = options.shadowBlur;
    ctx.shadowOffsetX = options.shadowOffsetX;
    ctx.shadowOffsetY = options.shadowOffsetY;
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {CoreLabelOptions} options
 * @returns {{width: number, height: number}}
 */ function $4049e6bf31df43d6$var$measureLabelSize(ctx, options) {
    const content = options.content;
    if ($4049e6bf31df43d6$var$isImageOrCanvas(content)) return {
        width: $4049e6bf31df43d6$var$getSize(content.width, options.width),
        height: $4049e6bf31df43d6$var$getSize(content.height, options.height)
    };
    const optFont = options.font;
    const fonts = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(optFont) ? optFont.map((f)=>(0, $84f61e7391a78632$export$34aec0b863436764)(f)) : [
        (0, $84f61e7391a78632$export$34aec0b863436764)(optFont)
    ];
    const strokeWidth = options.textStrokeWidth;
    const lines = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(content) ? content : [
        content
    ];
    const mapKey = lines.join() + $4049e6bf31df43d6$var$fontsKey(fonts) + strokeWidth + (ctx._measureText ? '-spriting' : '');
    if (!$4049e6bf31df43d6$var$widthCache.has(mapKey)) $4049e6bf31df43d6$var$widthCache.set(mapKey, $4049e6bf31df43d6$var$calculateLabelSize(ctx, lines, fonts, strokeWidth));
    return $4049e6bf31df43d6$var$widthCache.get(mapKey);
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{x: number, y: number, width: number, height: number}} rect
 * @param {Object} options
 */ function $4049e6bf31df43d6$var$drawBox(ctx, rect, options) {
    const { x: x, y: y, width: width, height: height } = rect;
    ctx.save();
    $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
    const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
    ctx.fillStyle = options.backgroundColor;
    ctx.beginPath();
    (0, $84f61e7391a78632$export$92108d983e8ee699)(ctx, {
        x: x,
        y: y,
        w: width,
        h: height,
        radius: $4049e6bf31df43d6$var$clampAll((0, $84f61e7391a78632$export$28f7fcd39efa255)(options.borderRadius), 0, Math.min(width, height) / 2)
    });
    ctx.closePath();
    ctx.fill();
    if (stroke) {
        ctx.shadowColor = options.borderShadowColor;
        ctx.stroke();
    }
    ctx.restore();
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{x: number, y: number, width: number, height: number}} rect
 * @param {CoreLabelOptions} options
 */ function $4049e6bf31df43d6$var$drawLabel(ctx, rect, options) {
    const content = options.content;
    if ($4049e6bf31df43d6$var$isImageOrCanvas(content)) {
        ctx.save();
        ctx.globalAlpha = $4049e6bf31df43d6$var$getOpacity(options.opacity, content.style.opacity);
        ctx.drawImage(content, rect.x, rect.y, rect.width, rect.height);
        ctx.restore();
        return;
    }
    const labels = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(content) ? content : [
        content
    ];
    const optFont = options.font;
    const fonts = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(optFont) ? optFont.map((f)=>(0, $84f61e7391a78632$export$34aec0b863436764)(f)) : [
        (0, $84f61e7391a78632$export$34aec0b863436764)(optFont)
    ];
    const optColor = options.color;
    const colors = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(optColor) ? optColor : [
        optColor
    ];
    const x = $4049e6bf31df43d6$var$calculateTextAlignment(rect, options);
    const y = rect.y + options.textStrokeWidth / 2;
    ctx.save();
    ctx.textBaseline = 'middle';
    ctx.textAlign = options.textAlign;
    if ($4049e6bf31df43d6$var$setTextStrokeStyle(ctx, options)) $4049e6bf31df43d6$var$applyLabelDecoration(ctx, {
        x: x,
        y: y
    }, labels, fonts);
    $4049e6bf31df43d6$var$applyLabelContent(ctx, {
        x: x,
        y: y
    }, labels, {
        fonts: fonts,
        colors: colors
    });
    ctx.restore();
}
function $4049e6bf31df43d6$var$setTextStrokeStyle(ctx, options) {
    if (options.textStrokeWidth > 0) {
        // https://stackoverflow.com/questions/13627111/drawing-text-with-an-outer-stroke-with-html5s-canvas
        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;
        ctx.lineWidth = options.textStrokeWidth;
        ctx.strokeStyle = options.textStrokeColor;
        return true;
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{radius: number, options: PointAnnotationOptions}} element
 * @param {number} x
 * @param {number} y
 */ function $4049e6bf31df43d6$var$drawPoint(ctx, element, x, y) {
    const { radius: radius, options: options } = element;
    const style = options.pointStyle;
    const rotation = options.rotation;
    let rad = (rotation || 0) * (0, $84f61e7391a78632$export$39c1cc7c062529d4);
    if ($4049e6bf31df43d6$var$isImageOrCanvas(style)) {
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rad);
        ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
        ctx.restore();
        return;
    }
    if ($4049e6bf31df43d6$var$notRadius(radius)) return;
    $4049e6bf31df43d6$var$drawPointStyle(ctx, {
        x: x,
        y: y,
        radius: radius,
        rotation: rotation,
        style: style,
        rad: rad
    });
}
function $4049e6bf31df43d6$var$drawPointStyle(ctx, { x: x, y: y, radius: radius, rotation: rotation, style: style, rad: rad }) {
    let xOffset, yOffset, size, cornerRadius;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            ctx.arc(x, y, radius, 0, (0, $84f61e7391a78632$export$971d5caa766a69d7));
            ctx.closePath();
            break;
        case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += (0, $84f61e7391a78632$export$c18d01048907ea92);
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += (0, $84f61e7391a78632$export$c18d01048907ea92);
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88)) * size;
            yOffset = Math.sin(rad + (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88)) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - (0, $84f61e7391a78632$export$56c0d5a1e737357d), rad - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), rad + (0, $84f61e7391a78632$export$56c0d5a1e737357d));
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                ctx.rect(x - size, y - size, 2 * size, 2 * size);
                break;
            }
            rad += (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88);
        /* falls through */ case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88);
        /* falls through */ case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
}
function $4049e6bf31df43d6$var$calculateLabelSize(ctx, lines, fonts, strokeWidth) {
    ctx.save();
    const count = lines.length;
    let width = 0;
    let height = strokeWidth;
    for(let i = 0; i < count; i++){
        const font = fonts[Math.min(i, fonts.length - 1)];
        ctx.font = font.string;
        const text = lines[i];
        width = Math.max(width, ctx.measureText(text).width + strokeWidth);
        height += font.lineHeight;
    }
    ctx.restore();
    return {
        width: width,
        height: height
    };
}
function $4049e6bf31df43d6$var$applyLabelDecoration(ctx, { x: x, y: y }, labels, fonts) {
    ctx.beginPath();
    let lhs = 0;
    labels.forEach(function(l, i) {
        const f = fonts[Math.min(i, fonts.length - 1)];
        const lh = f.lineHeight;
        ctx.font = f.string;
        ctx.strokeText(l, x, y + lh / 2 + lhs);
        lhs += lh;
    });
    ctx.stroke();
}
function $4049e6bf31df43d6$var$applyLabelContent(ctx, { x: x, y: y }, labels, { fonts: fonts, colors: colors }) {
    let lhs = 0;
    labels.forEach(function(l, i) {
        const c = colors[Math.min(i, colors.length - 1)];
        const f = fonts[Math.min(i, fonts.length - 1)];
        const lh = f.lineHeight;
        ctx.beginPath();
        ctx.font = f.string;
        ctx.fillStyle = c;
        ctx.fillText(l, x, y + lh / 2 + lhs);
        lhs += lh;
        ctx.fill();
    });
}
function $4049e6bf31df43d6$var$getOpacity(value, elementValue) {
    const opacity = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(value) ? value : elementValue;
    return (0, $84f61e7391a78632$export$d141bba7fdc215a3)(opacity) ? $4049e6bf31df43d6$var$clamp(opacity, 0, 1) : 1;
}
const $4049e6bf31df43d6$var$limitedLineScale = {
    xScaleID: {
        min: 'xMin',
        max: 'xMax',
        start: 'left',
        end: 'right',
        startProp: 'x',
        endProp: 'x2'
    },
    yScaleID: {
        min: 'yMin',
        max: 'yMax',
        start: 'bottom',
        end: 'top',
        startProp: 'y',
        endProp: 'y2'
    }
};
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").Scale } Scale
 * @typedef { import("chart.js").Point } Point
 * @typedef { import('../../types/element').AnnotationBoxModel } AnnotationBoxModel
 * @typedef { import('../../types/options').CoreAnnotationOptions } CoreAnnotationOptions
 * @typedef { import('../../types/options').LineAnnotationOptions } LineAnnotationOptions
 * @typedef { import('../../types/options').PointAnnotationOptions } PointAnnotationOptions
 * @typedef { import('../../types/options').PolygonAnnotationOptions } PolygonAnnotationOptions
 */ /**
 * @param {Scale} scale
 * @param {number|string} value
 * @param {number} fallback
 * @returns {number}
 */ function $4049e6bf31df43d6$var$scaleValue(scale, value, fallback) {
    value = typeof value === 'number' ? value : scale.parse(value);
    return (0, $84f61e7391a78632$export$39b482c5e57630a8)(value) ? scale.getPixelForValue(value) : fallback;
}
/**
 * Search the scale defined in chartjs by the axis related to the annotation options key.
 * @param {{ [key: string]: Scale }} scales
 * @param {CoreAnnotationOptions} options
 * @param {string} key
 * @returns {string}
 */ function $4049e6bf31df43d6$var$retrieveScaleID(scales, options, key) {
    const scaleID = options[key];
    if (scaleID || key === 'scaleID') return scaleID;
    const axis = key.charAt(0);
    const axes = Object.values(scales).filter((scale)=>scale.axis && scale.axis === axis);
    if (axes.length) return axes[0].id;
    return axis;
}
/**
 * @param {Scale} scale
 * @param {{min: number, max: number, start: number, end: number}} options
 * @returns {{start: number, end: number}|undefined}
 */ function $4049e6bf31df43d6$var$getDimensionByScale(scale, options) {
    if (scale) {
        const reverse = scale.options.reverse;
        const start = $4049e6bf31df43d6$var$scaleValue(scale, options.min, reverse ? options.end : options.start);
        const end = $4049e6bf31df43d6$var$scaleValue(scale, options.max, reverse ? options.start : options.end);
        return {
            start: start,
            end: end
        };
    }
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @returns {Point}
 */ function $4049e6bf31df43d6$var$getChartPoint(chart, options) {
    const { chartArea: chartArea, scales: scales } = chart;
    const xScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'xScaleID')];
    const yScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'yScaleID')];
    let x = chartArea.width / 2;
    let y = chartArea.height / 2;
    if (xScale) x = $4049e6bf31df43d6$var$scaleValue(xScale, options.xValue, xScale.left + xScale.width / 2);
    if (yScale) y = $4049e6bf31df43d6$var$scaleValue(yScale, options.yValue, yScale.top + yScale.height / 2);
    return {
        x: x,
        y: y
    };
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolveBoxProperties(chart, options) {
    const scales = chart.scales;
    const xScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'xScaleID')];
    const yScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'yScaleID')];
    if (!xScale && !yScale) return {};
    let { left: x, right: x2 } = xScale || chart.chartArea;
    let { top: y, bottom: y2 } = yScale || chart.chartArea;
    const xDim = $4049e6bf31df43d6$var$getChartDimensionByScale(xScale, {
        min: options.xMin,
        max: options.xMax,
        start: x,
        end: x2
    });
    x = xDim.start;
    x2 = xDim.end;
    const yDim = $4049e6bf31df43d6$var$getChartDimensionByScale(yScale, {
        min: options.yMin,
        max: options.yMax,
        start: y2,
        end: y
    });
    y = yDim.start;
    y2 = yDim.end;
    return {
        x: x,
        y: y,
        x2: x2,
        y2: y2,
        width: x2 - x,
        height: y2 - y,
        centerX: x + (x2 - x) / 2,
        centerY: y + (y2 - y) / 2
    };
}
/**
 * @param {Chart} chart
 * @param {PointAnnotationOptions|PolygonAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolvePointProperties(chart, options) {
    if (!$4049e6bf31df43d6$var$isBoundToPoint(options)) {
        const box = $4049e6bf31df43d6$var$resolveBoxProperties(chart, options);
        let radius = options.radius;
        if (!radius || isNaN(radius)) {
            radius = Math.min(box.width, box.height) / 2;
            options.radius = radius;
        }
        const size = radius * 2;
        const adjustCenterX = box.centerX + options.xAdjust;
        const adjustCenterY = box.centerY + options.yAdjust;
        return {
            x: adjustCenterX - radius,
            y: adjustCenterY - radius,
            x2: adjustCenterX + radius,
            y2: adjustCenterY + radius,
            centerX: adjustCenterX,
            centerY: adjustCenterY,
            width: size,
            height: size,
            radius: radius
        };
    }
    return $4049e6bf31df43d6$var$getChartCircle(chart, options);
}
/**
 * @param {Chart} chart
 * @param {LineAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolveLineProperties(chart, options) {
    const { scales: scales, chartArea: chartArea } = chart;
    const scale = scales[options.scaleID];
    const area = {
        x: chartArea.left,
        y: chartArea.top,
        x2: chartArea.right,
        y2: chartArea.bottom
    };
    if (scale) $4049e6bf31df43d6$var$resolveFullLineProperties(scale, area, options);
    else $4049e6bf31df43d6$var$resolveLimitedLineProperties(scales, area, options);
    return area;
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @param {boolean} [centerBased=false]
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolveBoxAndLabelProperties(chart, options, centerBased) {
    const properties = $4049e6bf31df43d6$var$resolveBoxProperties(chart, options);
    properties.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options, centerBased);
    properties.elements = [
        {
            type: 'label',
            optionScope: 'label',
            properties: $4049e6bf31df43d6$var$resolveLabelElementProperties$1(chart, properties, options),
            initProperties: properties.initProperties
        }
    ];
    return properties;
}
function $4049e6bf31df43d6$var$getChartCircle(chart, options) {
    const point = $4049e6bf31df43d6$var$getChartPoint(chart, options);
    const size = options.radius * 2;
    return {
        x: point.x - options.radius + options.xAdjust,
        y: point.y - options.radius + options.yAdjust,
        x2: point.x + options.radius + options.xAdjust,
        y2: point.y + options.radius + options.yAdjust,
        centerX: point.x + options.xAdjust,
        centerY: point.y + options.yAdjust,
        radius: options.radius,
        width: size,
        height: size
    };
}
function $4049e6bf31df43d6$var$getChartDimensionByScale(scale, options) {
    const result = $4049e6bf31df43d6$var$getDimensionByScale(scale, options) || options;
    return {
        start: Math.min(result.start, result.end),
        end: Math.max(result.start, result.end)
    };
}
function $4049e6bf31df43d6$var$resolveFullLineProperties(scale, area, options) {
    const min = $4049e6bf31df43d6$var$scaleValue(scale, options.value, NaN);
    const max = $4049e6bf31df43d6$var$scaleValue(scale, options.endValue, min);
    if (scale.isHorizontal()) {
        area.x = min;
        area.x2 = max;
    } else {
        area.y = min;
        area.y2 = max;
    }
}
function $4049e6bf31df43d6$var$resolveLimitedLineProperties(scales, area, options) {
    for (const scaleId of Object.keys($4049e6bf31df43d6$var$limitedLineScale)){
        const scale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, scaleId)];
        if (scale) {
            const { min: min, max: max, start: start, end: end, startProp: startProp, endProp: endProp } = $4049e6bf31df43d6$var$limitedLineScale[scaleId];
            const dim = $4049e6bf31df43d6$var$getDimensionByScale(scale, {
                min: options[min],
                max: options[max],
                start: scale[start],
                end: scale[end]
            });
            area[startProp] = dim.start;
            area[endProp] = dim.end;
        }
    }
}
function $4049e6bf31df43d6$var$calculateX({ properties: properties, options: options }, labelSize, position, padding) {
    const { x: start, x2: end, width: size } = properties;
    return $4049e6bf31df43d6$var$calculatePosition$1({
        start: start,
        end: end,
        size: size,
        borderWidth: options.borderWidth
    }, {
        position: position.x,
        padding: {
            start: padding.left,
            end: padding.right
        },
        adjust: options.label.xAdjust,
        size: labelSize.width
    });
}
function $4049e6bf31df43d6$var$calculateY({ properties: properties, options: options }, labelSize, position, padding) {
    const { y: start, y2: end, height: size } = properties;
    return $4049e6bf31df43d6$var$calculatePosition$1({
        start: start,
        end: end,
        size: size,
        borderWidth: options.borderWidth
    }, {
        position: position.y,
        padding: {
            start: padding.top,
            end: padding.bottom
        },
        adjust: options.label.yAdjust,
        size: labelSize.height
    });
}
function $4049e6bf31df43d6$var$calculatePosition$1(boxOpts, labelOpts) {
    const { start: start, end: end, borderWidth: borderWidth } = boxOpts;
    const { position: position, padding: { start: padStart, end: padEnd }, adjust: adjust } = labelOpts;
    const availableSize = end - borderWidth - start - padStart - padEnd - labelOpts.size;
    return start + borderWidth / 2 + adjust + $4049e6bf31df43d6$var$getRelativePosition(availableSize, position);
}
function $4049e6bf31df43d6$var$resolveLabelElementProperties$1(chart, properties, options) {
    const label = options.label;
    label.backgroundColor = 'transparent';
    label.callout.display = false;
    const position = $4049e6bf31df43d6$var$toPosition(label.position);
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(label.padding);
    const labelSize = $4049e6bf31df43d6$var$measureLabelSize(chart.ctx, label);
    const x = $4049e6bf31df43d6$var$calculateX({
        properties: properties,
        options: options
    }, labelSize, position, padding);
    const y = $4049e6bf31df43d6$var$calculateY({
        properties: properties,
        options: options
    }, labelSize, position, padding);
    const width = labelSize.width + padding.width;
    const height = labelSize.height + padding.height;
    return {
        x: x,
        y: y,
        x2: x + width,
        y2: y + height,
        width: width,
        height: height,
        centerX: x + width / 2,
        centerY: y + height / 2,
        rotation: label.rotation
    };
}
/**
 * @typedef {import('chart.js').Point} Point
 */ /**
 * Rotate a `point` relative to `center` point by `angle`
 * @param {Point} point - the point to rotate
 * @param {Point} center - center point for rotation
 * @param {number} angle - angle for rotation, in radians
 * @returns {Point} rotated point
 */ function $4049e6bf31df43d6$var$rotated(point, center, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const cx = center.x;
    const cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
const $4049e6bf31df43d6$var$moveHooks = [
    'enter',
    'leave'
];
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 */ const $4049e6bf31df43d6$var$eventHooks = $4049e6bf31df43d6$var$moveHooks.concat('click');
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 */ function $4049e6bf31df43d6$var$updateListeners(chart, state, options) {
    state.listened = $4049e6bf31df43d6$var$loadHooks(options, $4049e6bf31df43d6$var$eventHooks, state.listeners);
    state.moveListened = false;
    state._getElements = $4049e6bf31df43d6$var$getElements; // for testing
    $4049e6bf31df43d6$var$moveHooks.forEach((hook)=>{
        if ((0, $84f61e7391a78632$export$a93c5207d687da10)(options[hook])) state.moveListened = true;
    });
    if (!state.listened || !state.moveListened) state.annotations.forEach((scope)=>{
        if (!state.listened && (0, $84f61e7391a78632$export$a93c5207d687da10)(scope.click)) state.listened = true;
        if (!state.moveListened) $4049e6bf31df43d6$var$moveHooks.forEach((hook)=>{
            if ((0, $84f61e7391a78632$export$a93c5207d687da10)(scope[hook])) {
                state.listened = true;
                state.moveListened = true;
            }
        });
    });
}
/**
 * @param {Object} state
 * @param {ChartEvent} event
 * @param {AnnotationPluginOptions} options
 * @return {boolean|undefined}
 */ function $4049e6bf31df43d6$var$handleEvent(state, event, options) {
    if (state.listened) switch(event.type){
        case 'mousemove':
        case 'mouseout':
            return $4049e6bf31df43d6$var$handleMoveEvents(state, event, options);
        case 'click':
            return $4049e6bf31df43d6$var$handleClickEvents(state, event, options);
    }
}
function $4049e6bf31df43d6$var$handleMoveEvents(state, event, options) {
    if (!state.moveListened) return;
    let elements;
    if (event.type === 'mousemove') elements = $4049e6bf31df43d6$var$getElements(state, event, options.interaction);
    else elements = [];
    const previous = state.hovered;
    state.hovered = elements;
    const context = {
        state: state,
        event: event
    };
    let changed = $4049e6bf31df43d6$var$dispatchMoveEvents(context, 'leave', previous, elements);
    return $4049e6bf31df43d6$var$dispatchMoveEvents(context, 'enter', elements, previous) || changed;
}
function $4049e6bf31df43d6$var$dispatchMoveEvents({ state: state, event: event }, hook, elements, checkElements) {
    let changed;
    for (const element of elements)if (checkElements.indexOf(element) < 0) changed = $4049e6bf31df43d6$var$dispatchEvent(element.options[hook] || state.listeners[hook], element, event) || changed;
    return changed;
}
function $4049e6bf31df43d6$var$handleClickEvents(state, event, options) {
    const listeners = state.listeners;
    const elements = $4049e6bf31df43d6$var$getElements(state, event, options.interaction);
    let changed;
    for (const element of elements)changed = $4049e6bf31df43d6$var$dispatchEvent(element.options.click || listeners.click, element, event) || changed;
    return changed;
}
function $4049e6bf31df43d6$var$dispatchEvent(handler, element, event) {
    return (0, $84f61e7391a78632$export$3722cfe417b6ed86)(handler, [
        element.$context,
        event
    ]) === true;
}
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $4049e6bf31df43d6$var$elementHooks = [
    'afterDraw',
    'beforeDraw'
];
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 */ function $4049e6bf31df43d6$var$updateHooks(chart, state, options) {
    const visibleElements = state.visibleElements;
    state.hooked = $4049e6bf31df43d6$var$loadHooks(options, $4049e6bf31df43d6$var$elementHooks, state.hooks);
    if (!state.hooked) visibleElements.forEach((scope)=>{
        if (!state.hooked) $4049e6bf31df43d6$var$elementHooks.forEach((hook)=>{
            if ((0, $84f61e7391a78632$export$a93c5207d687da10)(scope.options[hook])) state.hooked = true;
        });
    });
}
/**
 * @param {Object} state
 * @param {AnnotationElement} element
 * @param {string} hook
 */ function $4049e6bf31df43d6$var$invokeHook(state, element, hook) {
    if (state.hooked) {
        const callbackHook = element.options[hook] || state.hooks[hook];
        return (0, $84f61e7391a78632$export$3722cfe417b6ed86)(callbackHook, [
            element.$context
        ]);
    }
}
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").Scale } Scale
 * @typedef { import('../../types/options').CoreAnnotationOptions } CoreAnnotationOptions
 */ /**
 * @param {Chart} chart
 * @param {Scale} scale
 * @param {CoreAnnotationOptions[]} annotations
 */ function $4049e6bf31df43d6$var$adjustScaleRange(chart, scale, annotations) {
    const range = $4049e6bf31df43d6$var$getScaleLimits(chart.scales, scale, annotations);
    let changed = $4049e6bf31df43d6$var$changeScaleLimit(scale, range, 'min', 'suggestedMin');
    changed = $4049e6bf31df43d6$var$changeScaleLimit(scale, range, 'max', 'suggestedMax') || changed;
    if (changed && (0, $84f61e7391a78632$export$a93c5207d687da10)(scale.handleTickRangeOptions)) scale.handleTickRangeOptions();
}
/**
 * @param {CoreAnnotationOptions[]} annotations
 * @param {{ [key: string]: Scale }} scales
 */ function $4049e6bf31df43d6$var$verifyScaleOptions(annotations, scales) {
    for (const annotation of annotations)$4049e6bf31df43d6$var$verifyScaleIDs(annotation, scales);
}
function $4049e6bf31df43d6$var$changeScaleLimit(scale, range, limit, suggestedLimit) {
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(range[limit]) && !$4049e6bf31df43d6$var$scaleLimitDefined(scale.options, limit, suggestedLimit)) {
        const changed = scale[limit] !== range[limit];
        scale[limit] = range[limit];
        return changed;
    }
}
function $4049e6bf31df43d6$var$scaleLimitDefined(scaleOptions, limit, suggestedLimit) {
    return (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(scaleOptions[limit]) || (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(scaleOptions[suggestedLimit]);
}
function $4049e6bf31df43d6$var$verifyScaleIDs(annotation, scales) {
    for (const key of [
        'scaleID',
        'xScaleID',
        'yScaleID'
    ]){
        const scaleID = $4049e6bf31df43d6$var$retrieveScaleID(scales, annotation, key);
        if (scaleID && !scales[scaleID] && $4049e6bf31df43d6$var$verifyProperties(annotation, key)) console.warn(`No scale found with id '${scaleID}' for annotation '${annotation.id}'`);
    }
}
function $4049e6bf31df43d6$var$verifyProperties(annotation, key) {
    if (key === 'scaleID') return true;
    const axis = key.charAt(0);
    for (const prop of [
        'Min',
        'Max',
        'Value'
    ]){
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(annotation[axis + prop])) return true;
    }
    return false;
}
function $4049e6bf31df43d6$var$getScaleLimits(scales, scale, annotations) {
    const axis = scale.axis;
    const scaleID = scale.id;
    const scaleIDOption = axis + 'ScaleID';
    const limits = {
        min: (0, $84f61e7391a78632$export$90a7f3efeed30595)(scale.min, Number.NEGATIVE_INFINITY),
        max: (0, $84f61e7391a78632$export$90a7f3efeed30595)(scale.max, Number.POSITIVE_INFINITY)
    };
    for (const annotation of annotations){
        if (annotation.scaleID === scaleID) $4049e6bf31df43d6$var$updateLimits(annotation, scale, [
            'value',
            'endValue'
        ], limits);
        else if ($4049e6bf31df43d6$var$retrieveScaleID(scales, annotation, scaleIDOption) === scaleID) $4049e6bf31df43d6$var$updateLimits(annotation, scale, [
            axis + 'Min',
            axis + 'Max',
            axis + 'Value'
        ], limits);
    }
    return limits;
}
function $4049e6bf31df43d6$var$updateLimits(annotation, scale, props, limits) {
    for (const prop of props){
        const raw = annotation[prop];
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(raw)) {
            const value = scale.parse(raw);
            limits.min = Math.min(limits.min, value);
            limits.max = Math.max(limits.max, value);
        }
    }
}
class $4049e6bf31df43d6$var$BoxAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const { x: x, y: y } = $4049e6bf31df43d6$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-this.options.rotation));
        return $4049e6bf31df43d6$var$inBoxRange({
            x: x,
            y: y
        }, this.getProps([
            'x',
            'y',
            'x2',
            'y2'
        ], useFinalPosition), axis, this.options.borderWidth);
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        ctx.save();
        $4049e6bf31df43d6$var$translate(ctx, this.getCenterPoint(), this.options.rotation);
        $4049e6bf31df43d6$var$drawBox(ctx, this, this.options);
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        return $4049e6bf31df43d6$var$resolveBoxAndLabelProperties(chart, options);
    }
}
$4049e6bf31df43d6$var$BoxAnnotation.id = 'boxAnnotation';
$4049e6bf31df43d6$var$BoxAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderRadius: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    init: undefined,
    label: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        callout: {
            display: false
        },
        color: 'black',
        content: null,
        display: false,
        drawTime: undefined,
        font: {
            family: undefined,
            lineHeight: undefined,
            size: undefined,
            style: undefined,
            weight: 'bold'
        },
        height: undefined,
        opacity: undefined,
        padding: 6,
        position: 'center',
        rotation: undefined,
        textAlign: 'start',
        textStrokeColor: undefined,
        textStrokeWidth: 0,
        width: undefined,
        xAdjust: 0,
        yAdjust: 0,
        z: undefined
    },
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$4049e6bf31df43d6$var$BoxAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
$4049e6bf31df43d6$var$BoxAnnotation.descriptors = {
    label: {
        _fallback: true
    }
};
const $4049e6bf31df43d6$var$positions = [
    'left',
    'bottom',
    'top',
    'right'
];
class $4049e6bf31df43d6$var$LabelAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const { x: x, y: y } = $4049e6bf31df43d6$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-this.rotation));
        return $4049e6bf31df43d6$var$inBoxRange({
            x: x,
            y: y
        }, this.getProps([
            'x',
            'y',
            'x2',
            'y2'
        ], useFinalPosition), axis, this.options.borderWidth);
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        const visible = !(0, $84f61e7391a78632$export$dda1d9f60106f0e9)(this._visible) || this._visible;
        if (!options.display || !options.content || !visible) return;
        ctx.save();
        $4049e6bf31df43d6$var$translate(ctx, this.getCenterPoint(), this.rotation);
        $4049e6bf31df43d6$var$drawCallout(ctx, this);
        $4049e6bf31df43d6$var$drawBox(ctx, this, options);
        $4049e6bf31df43d6$var$drawLabel(ctx, $4049e6bf31df43d6$var$getLabelSize(this), options);
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        let point;
        if (!$4049e6bf31df43d6$var$isBoundToPoint(options)) {
            const { centerX: centerX, centerY: centerY } = $4049e6bf31df43d6$var$resolveBoxProperties(chart, options);
            point = {
                x: centerX,
                y: centerY
            };
        } else point = $4049e6bf31df43d6$var$getChartPoint(chart, options);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
        const labelSize = $4049e6bf31df43d6$var$measureLabelSize(chart.ctx, options);
        const boxSize = $4049e6bf31df43d6$var$measureRect(point, labelSize, options, padding);
        return {
            initProperties: $4049e6bf31df43d6$var$initAnimationProperties(chart, boxSize, options),
            pointX: point.x,
            pointY: point.y,
            ...boxSize,
            rotation: options.rotation
        };
    }
}
$4049e6bf31df43d6$var$LabelAnnotation.id = 'labelAnnotation';
$4049e6bf31df43d6$var$LabelAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundColor: 'transparent',
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderRadius: 0,
    borderShadowColor: 'transparent',
    borderWidth: 0,
    callout: {
        borderCapStyle: 'butt',
        borderColor: undefined,
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 1,
        display: false,
        margin: 5,
        position: 'auto',
        side: 5,
        start: '50%'
    },
    color: 'black',
    content: null,
    display: true,
    font: {
        family: undefined,
        lineHeight: undefined,
        size: undefined,
        style: undefined,
        weight: undefined
    },
    height: undefined,
    init: undefined,
    opacity: undefined,
    padding: 6,
    position: 'center',
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: 'center',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    width: undefined,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$4049e6bf31df43d6$var$LabelAnnotation.defaultRoutes = {
    borderColor: 'color'
};
function $4049e6bf31df43d6$var$measureRect(point, size, options, padding) {
    const width = size.width + padding.width + options.borderWidth;
    const height = size.height + padding.height + options.borderWidth;
    const position = $4049e6bf31df43d6$var$toPosition(options.position, 'center');
    const x = $4049e6bf31df43d6$var$calculatePosition(point.x, width, options.xAdjust, position.x);
    const y = $4049e6bf31df43d6$var$calculatePosition(point.y, height, options.yAdjust, position.y);
    return {
        x: x,
        y: y,
        x2: x + width,
        y2: y + height,
        width: width,
        height: height,
        centerX: x + width / 2,
        centerY: y + height / 2
    };
}
function $4049e6bf31df43d6$var$calculatePosition(start, size, adjust = 0, position) {
    return start - $4049e6bf31df43d6$var$getRelativePosition(size, position) + adjust;
}
function $4049e6bf31df43d6$var$drawCallout(ctx, element) {
    const { pointX: pointX, pointY: pointY, options: options } = element;
    const callout = options.callout;
    const calloutPosition = callout && callout.display && $4049e6bf31df43d6$var$resolveCalloutPosition(element, callout);
    if (!calloutPosition || $4049e6bf31df43d6$var$isPointInRange(element, callout, calloutPosition)) return;
    ctx.save();
    ctx.beginPath();
    const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, callout);
    if (!stroke) return ctx.restore();
    const { separatorStart: separatorStart, separatorEnd: separatorEnd } = $4049e6bf31df43d6$var$getCalloutSeparatorCoord(element, calloutPosition);
    const { sideStart: sideStart, sideEnd: sideEnd } = $4049e6bf31df43d6$var$getCalloutSideCoord(element, calloutPosition, separatorStart);
    if (callout.margin > 0 || options.borderWidth === 0) {
        ctx.moveTo(separatorStart.x, separatorStart.y);
        ctx.lineTo(separatorEnd.x, separatorEnd.y);
    }
    ctx.moveTo(sideStart.x, sideStart.y);
    ctx.lineTo(sideEnd.x, sideEnd.y);
    const rotatedPoint = $4049e6bf31df43d6$var$rotated({
        x: pointX,
        y: pointY
    }, element.getCenterPoint(), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-element.rotation));
    ctx.lineTo(rotatedPoint.x, rotatedPoint.y);
    ctx.stroke();
    ctx.restore();
}
function $4049e6bf31df43d6$var$getCalloutSeparatorCoord(element, position) {
    const { x: x, y: y, x2: x2, y2: y2 } = element;
    const adjust = $4049e6bf31df43d6$var$getCalloutSeparatorAdjust(element, position);
    let separatorStart, separatorEnd;
    if (position === 'left' || position === 'right') {
        separatorStart = {
            x: x + adjust,
            y: y
        };
        separatorEnd = {
            x: separatorStart.x,
            y: y2
        };
    } else {
        //  position 'top' or 'bottom'
        separatorStart = {
            x: x,
            y: y + adjust
        };
        separatorEnd = {
            x: x2,
            y: separatorStart.y
        };
    }
    return {
        separatorStart: separatorStart,
        separatorEnd: separatorEnd
    };
}
function $4049e6bf31df43d6$var$getCalloutSeparatorAdjust(element, position) {
    const { width: width, height: height, options: options } = element;
    const adjust = options.callout.margin + options.borderWidth / 2;
    if (position === 'right') return width + adjust;
    else if (position === 'bottom') return height + adjust;
    return -adjust;
}
function $4049e6bf31df43d6$var$getCalloutSideCoord(element, position, separatorStart) {
    const { y: y, width: width, height: height, options: options } = element;
    const start = options.callout.start;
    const side = $4049e6bf31df43d6$var$getCalloutSideAdjust(position, options.callout);
    let sideStart, sideEnd;
    if (position === 'left' || position === 'right') {
        sideStart = {
            x: separatorStart.x,
            y: y + $4049e6bf31df43d6$var$getSize(height, start)
        };
        sideEnd = {
            x: sideStart.x + side,
            y: sideStart.y
        };
    } else {
        //  position 'top' or 'bottom'
        sideStart = {
            x: separatorStart.x + $4049e6bf31df43d6$var$getSize(width, start),
            y: separatorStart.y
        };
        sideEnd = {
            x: sideStart.x,
            y: sideStart.y + side
        };
    }
    return {
        sideStart: sideStart,
        sideEnd: sideEnd
    };
}
function $4049e6bf31df43d6$var$getCalloutSideAdjust(position, options) {
    const side = options.side;
    if (position === 'left' || position === 'top') return -side;
    return side;
}
function $4049e6bf31df43d6$var$resolveCalloutPosition(element, options) {
    const position = options.position;
    if ($4049e6bf31df43d6$var$positions.includes(position)) return position;
    return $4049e6bf31df43d6$var$resolveCalloutAutoPosition(element, options);
}
function $4049e6bf31df43d6$var$resolveCalloutAutoPosition(element, options) {
    const { x: x, y: y, x2: x2, y2: y2, width: width, height: height, pointX: pointX, pointY: pointY, centerX: centerX, centerY: centerY, rotation: rotation } = element;
    const center = {
        x: centerX,
        y: centerY
    };
    const start = options.start;
    const xAdjust = $4049e6bf31df43d6$var$getSize(width, start);
    const yAdjust = $4049e6bf31df43d6$var$getSize(height, start);
    const xPoints = [
        x,
        x + xAdjust,
        x + xAdjust,
        x2
    ];
    const yPoints = [
        y + yAdjust,
        y2,
        y,
        y2
    ];
    const result = [];
    for(let index = 0; index < 4; index++){
        const rotatedPoint = $4049e6bf31df43d6$var$rotated({
            x: xPoints[index],
            y: yPoints[index]
        }, center, (0, $84f61e7391a78632$export$625550452a3fa3ec)(rotation));
        result.push({
            position: $4049e6bf31df43d6$var$positions[index],
            distance: (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(rotatedPoint, {
                x: pointX,
                y: pointY
            })
        });
    }
    return result.sort((a, b)=>a.distance - b.distance)[0].position;
}
function $4049e6bf31df43d6$var$getLabelSize({ x: x, y: y, width: width, height: height, options: options }) {
    const hBorderWidth = options.borderWidth / 2;
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    return {
        x: x + padding.left + hBorderWidth,
        y: y + padding.top + hBorderWidth,
        width: width - padding.left - padding.right - options.borderWidth,
        height: height - padding.top - padding.bottom - options.borderWidth
    };
}
function $4049e6bf31df43d6$var$isPointInRange(element, callout, position) {
    const { pointX: pointX, pointY: pointY } = element;
    const margin = callout.margin;
    let x = pointX;
    let y = pointY;
    if (position === 'left') x += margin;
    else if (position === 'right') x -= margin;
    else if (position === 'top') y += margin;
    else if (position === 'bottom') y -= margin;
    return element.inRange(x, y);
}
const $4049e6bf31df43d6$var$pointInLine = (p1, p2, t)=>({
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    });
const $4049e6bf31df43d6$var$interpolateX = (y, p1, p2)=>$4049e6bf31df43d6$var$pointInLine(p1, p2, Math.abs((y - p1.y) / (p2.y - p1.y))).x;
const $4049e6bf31df43d6$var$interpolateY = (x, p1, p2)=>$4049e6bf31df43d6$var$pointInLine(p1, p2, Math.abs((x - p1.x) / (p2.x - p1.x))).y;
const $4049e6bf31df43d6$var$sqr = (v)=>v * v;
const $4049e6bf31df43d6$var$rangeLimit = (mouseX, mouseY, { x: x, y: y, x2: x2, y2: y2 }, axis)=>axis === 'y' ? {
        start: Math.min(y, y2),
        end: Math.max(y, y2),
        value: mouseY
    } : {
        start: Math.min(x, x2),
        end: Math.max(x, x2),
        value: mouseX
    };
// http://www.independent-software.com/determining-coordinates-on-a-html-canvas-bezier-curve.html
const $4049e6bf31df43d6$var$coordInCurve = (start, cp, end, t)=>(1 - t) * (1 - t) * start + 2 * (1 - t) * t * cp + t * t * end;
const $4049e6bf31df43d6$var$pointInCurve = (start, cp, end, t)=>({
        x: $4049e6bf31df43d6$var$coordInCurve(start.x, cp.x, end.x, t),
        y: $4049e6bf31df43d6$var$coordInCurve(start.y, cp.y, end.y, t)
    });
const $4049e6bf31df43d6$var$coordAngleInCurve = (start, cp, end, t)=>2 * (1 - t) * (cp - start) + 2 * t * (end - cp);
const $4049e6bf31df43d6$var$angleInCurve = (start, cp, end, t)=>-Math.atan2($4049e6bf31df43d6$var$coordAngleInCurve(start.x, cp.x, end.x, t), $4049e6bf31df43d6$var$coordAngleInCurve(start.y, cp.y, end.y, t)) + 0.5 * (0, $84f61e7391a78632$export$56c0d5a1e737357d);
class $4049e6bf31df43d6$var$LineAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const hBorderWidth = this.options.borderWidth / 2;
        if (axis !== 'x' && axis !== 'y') {
            const point = {
                mouseX: mouseX,
                mouseY: mouseY
            };
            const { path: path, ctx: ctx } = this;
            if (path) {
                $4049e6bf31df43d6$var$setBorderStyle(ctx, this.options);
                const { chart: chart } = this.$context;
                const mx = mouseX * chart.currentDevicePixelRatio;
                const my = mouseY * chart.currentDevicePixelRatio;
                const result = ctx.isPointInStroke(path, mx, my) || $4049e6bf31df43d6$var$isOnLabel(this, point, useFinalPosition);
                ctx.restore();
                return result;
            }
            const epsilon = $4049e6bf31df43d6$var$sqr(hBorderWidth);
            return $4049e6bf31df43d6$var$intersects(this, point, epsilon, useFinalPosition) || $4049e6bf31df43d6$var$isOnLabel(this, point, useFinalPosition);
        }
        return $4049e6bf31df43d6$var$inAxisRange(this, {
            mouseX: mouseX,
            mouseY: mouseY
        }, axis, {
            hBorderWidth: hBorderWidth,
            useFinalPosition: useFinalPosition
        });
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { x: x, y: y, x2: x2, y2: y2, cp: cp, options: options } = this;
        ctx.save();
        if (!$4049e6bf31df43d6$var$setBorderStyle(ctx, options)) // no border width, then line is not drawn
        return ctx.restore();
        $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
        const length = Math.sqrt(Math.pow(x2 - x, 2) + Math.pow(y2 - y, 2));
        if (options.curve && cp) {
            $4049e6bf31df43d6$var$drawCurve(ctx, this, cp, length);
            return ctx.restore();
        }
        const { startOpts: startOpts, endOpts: endOpts, startAdjust: startAdjust, endAdjust: endAdjust } = $4049e6bf31df43d6$var$getArrowHeads(this);
        const angle = Math.atan2(y2 - y, x2 - x);
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.beginPath();
        ctx.moveTo(0 + startAdjust, 0);
        ctx.lineTo(length - endAdjust, 0);
        ctx.shadowColor = options.borderShadowColor;
        ctx.stroke();
        $4049e6bf31df43d6$var$drawArrowHead(ctx, 0, startAdjust, startOpts);
        $4049e6bf31df43d6$var$drawArrowHead(ctx, length, -endAdjust, endOpts);
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        const area = $4049e6bf31df43d6$var$resolveLineProperties(chart, options);
        const { x: x, y: y, x2: x2, y2: y2 } = area;
        const inside = $4049e6bf31df43d6$var$isLineInArea(area, chart.chartArea);
        const properties = inside ? $4049e6bf31df43d6$var$limitLineToArea({
            x: x,
            y: y
        }, {
            x: x2,
            y: y2
        }, chart.chartArea) : {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: Math.abs(x2 - x),
            height: Math.abs(y2 - y)
        };
        properties.centerX = (x2 + x) / 2;
        properties.centerY = (y2 + y) / 2;
        properties.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options);
        if (options.curve) {
            const p1 = {
                x: properties.x,
                y: properties.y
            };
            const p2 = {
                x: properties.x2,
                y: properties.y2
            };
            properties.cp = $4049e6bf31df43d6$var$getControlPoint(properties, options, (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(p1, p2));
        }
        const labelProperties = $4049e6bf31df43d6$var$resolveLabelElementProperties(chart, properties, options.label);
        // additonal prop to manage zoom/pan
        labelProperties._visible = inside;
        properties.elements = [
            {
                type: 'label',
                optionScope: 'label',
                properties: labelProperties,
                initProperties: properties.initProperties
            }
        ];
        return properties;
    }
}
$4049e6bf31df43d6$var$LineAnnotation.id = 'lineAnnotation';
const $4049e6bf31df43d6$var$arrowHeadsDefaults = {
    backgroundColor: undefined,
    backgroundShadowColor: undefined,
    borderColor: undefined,
    borderDash: undefined,
    borderDashOffset: undefined,
    borderShadowColor: undefined,
    borderWidth: undefined,
    display: undefined,
    fill: undefined,
    length: undefined,
    shadowBlur: undefined,
    shadowOffsetX: undefined,
    shadowOffsetY: undefined,
    width: undefined
};
$4049e6bf31df43d6$var$LineAnnotation.defaults = {
    adjustScaleRange: true,
    arrowHeads: {
        display: false,
        end: Object.assign({}, $4049e6bf31df43d6$var$arrowHeadsDefaults),
        fill: false,
        length: 12,
        start: Object.assign({}, $4049e6bf31df43d6$var$arrowHeadsDefaults),
        width: 6
    },
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 2,
    curve: false,
    controlPoint: {
        y: '-50%'
    },
    display: true,
    endValue: undefined,
    init: undefined,
    label: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        backgroundShadowColor: 'transparent',
        borderCapStyle: 'butt',
        borderColor: 'black',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderRadius: 6,
        borderShadowColor: 'transparent',
        borderWidth: 0,
        callout: Object.assign({}, $4049e6bf31df43d6$var$LabelAnnotation.defaults.callout),
        color: '#fff',
        content: null,
        display: false,
        drawTime: undefined,
        font: {
            family: undefined,
            lineHeight: undefined,
            size: undefined,
            style: undefined,
            weight: 'bold'
        },
        height: undefined,
        opacity: undefined,
        padding: 6,
        position: 'center',
        rotation: 0,
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        textAlign: 'center',
        textStrokeColor: undefined,
        textStrokeWidth: 0,
        width: undefined,
        xAdjust: 0,
        yAdjust: 0,
        z: undefined
    },
    scaleID: undefined,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    value: undefined,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$4049e6bf31df43d6$var$LineAnnotation.descriptors = {
    arrowHeads: {
        start: {
            _fallback: true
        },
        end: {
            _fallback: true
        },
        _fallback: true
    }
};
$4049e6bf31df43d6$var$LineAnnotation.defaultRoutes = {
    borderColor: 'color'
};
function $4049e6bf31df43d6$var$inAxisRange(element, { mouseX: mouseX, mouseY: mouseY }, axis, { hBorderWidth: hBorderWidth, useFinalPosition: useFinalPosition }) {
    const limit = $4049e6bf31df43d6$var$rangeLimit(mouseX, mouseY, element.getProps([
        'x',
        'y',
        'x2',
        'y2'
    ], useFinalPosition), axis);
    return limit.value >= limit.start - hBorderWidth && limit.value <= limit.end + hBorderWidth || $4049e6bf31df43d6$var$isOnLabel(element, {
        mouseX: mouseX,
        mouseY: mouseY
    }, useFinalPosition, axis);
}
function $4049e6bf31df43d6$var$isLineInArea({ x: x, y: y, x2: x2, y2: y2 }, { top: top, right: right, bottom: bottom, left: left }) {
    return !(x < left && x2 < left || x > right && x2 > right || y < top && y2 < top || y > bottom && y2 > bottom);
}
function $4049e6bf31df43d6$var$limitPointToArea({ x: x, y: y }, p2, { top: top, right: right, bottom: bottom, left: left }) {
    if (x < left) {
        y = $4049e6bf31df43d6$var$interpolateY(left, {
            x: x,
            y: y
        }, p2);
        x = left;
    }
    if (x > right) {
        y = $4049e6bf31df43d6$var$interpolateY(right, {
            x: x,
            y: y
        }, p2);
        x = right;
    }
    if (y < top) {
        x = $4049e6bf31df43d6$var$interpolateX(top, {
            x: x,
            y: y
        }, p2);
        y = top;
    }
    if (y > bottom) {
        x = $4049e6bf31df43d6$var$interpolateX(bottom, {
            x: x,
            y: y
        }, p2);
        y = bottom;
    }
    return {
        x: x,
        y: y
    };
}
function $4049e6bf31df43d6$var$limitLineToArea(p1, p2, area) {
    const { x: x, y: y } = $4049e6bf31df43d6$var$limitPointToArea(p1, p2, area);
    const { x: x2, y: y2 } = $4049e6bf31df43d6$var$limitPointToArea(p2, p1, area);
    return {
        x: x,
        y: y,
        x2: x2,
        y2: y2,
        width: Math.abs(x2 - x),
        height: Math.abs(y2 - y)
    };
}
function $4049e6bf31df43d6$var$intersects(element, { mouseX: mouseX, mouseY: mouseY }, epsilon = $4049e6bf31df43d6$var$EPSILON, useFinalPosition) {
    // Adapted from https://stackoverflow.com/a/6853926/25507
    const { x: x1, y: y1, x2: x2, y2: y2 } = element.getProps([
        'x',
        'y',
        'x2',
        'y2'
    ], useFinalPosition);
    const dx = x2 - x1;
    const dy = y2 - y1;
    const lenSq = $4049e6bf31df43d6$var$sqr(dx) + $4049e6bf31df43d6$var$sqr(dy);
    const t = lenSq === 0 ? -1 : ((mouseX - x1) * dx + (mouseY - y1) * dy) / lenSq;
    let xx, yy;
    if (t < 0) {
        xx = x1;
        yy = y1;
    } else if (t > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + t * dx;
        yy = y1 + t * dy;
    }
    return $4049e6bf31df43d6$var$sqr(mouseX - xx) + $4049e6bf31df43d6$var$sqr(mouseY - yy) <= epsilon;
}
function $4049e6bf31df43d6$var$isOnLabel(element, { mouseX: mouseX, mouseY: mouseY }, useFinalPosition, axis) {
    const label = element.label;
    return label.options.display && label.inRange(mouseX, mouseY, axis, useFinalPosition);
}
function $4049e6bf31df43d6$var$resolveLabelElementProperties(chart, properties, options) {
    const borderWidth = options.borderWidth;
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    const textSize = $4049e6bf31df43d6$var$measureLabelSize(chart.ctx, options);
    const width = textSize.width + padding.width + borderWidth;
    const height = textSize.height + padding.height + borderWidth;
    return $4049e6bf31df43d6$var$calculateLabelPosition(properties, options, {
        width: width,
        height: height,
        padding: padding
    }, chart.chartArea);
}
function $4049e6bf31df43d6$var$calculateAutoRotation(properties) {
    const { x: x, y: y, x2: x2, y2: y2 } = properties;
    const rotation = Math.atan2(y2 - y, x2 - x);
    // Flip the rotation if it goes > PI/2 or < -PI/2, so label stays upright
    return rotation > (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2 ? rotation - (0, $84f61e7391a78632$export$56c0d5a1e737357d) : rotation < (0, $84f61e7391a78632$export$56c0d5a1e737357d) / -2 ? rotation + (0, $84f61e7391a78632$export$56c0d5a1e737357d) : rotation;
}
function $4049e6bf31df43d6$var$calculateLabelPosition(properties, label, sizes, chartArea) {
    const { width: width, height: height, padding: padding } = sizes;
    const { xAdjust: xAdjust, yAdjust: yAdjust } = label;
    const p1 = {
        x: properties.x,
        y: properties.y
    };
    const p2 = {
        x: properties.x2,
        y: properties.y2
    };
    const rotation = label.rotation === 'auto' ? $4049e6bf31df43d6$var$calculateAutoRotation(properties) : (0, $84f61e7391a78632$export$625550452a3fa3ec)(label.rotation);
    const size = $4049e6bf31df43d6$var$rotatedSize(width, height, rotation);
    const t = $4049e6bf31df43d6$var$calculateT(properties, label, {
        labelSize: size,
        padding: padding
    }, chartArea);
    const pt = properties.cp ? $4049e6bf31df43d6$var$pointInCurve(p1, properties.cp, p2, t) : $4049e6bf31df43d6$var$pointInLine(p1, p2, t);
    const xCoordinateSizes = {
        size: size.w,
        min: chartArea.left,
        max: chartArea.right,
        padding: padding.left
    };
    const yCoordinateSizes = {
        size: size.h,
        min: chartArea.top,
        max: chartArea.bottom,
        padding: padding.top
    };
    const centerX = $4049e6bf31df43d6$var$adjustLabelCoordinate(pt.x, xCoordinateSizes) + xAdjust;
    const centerY = $4049e6bf31df43d6$var$adjustLabelCoordinate(pt.y, yCoordinateSizes) + yAdjust;
    return {
        x: centerX - width / 2,
        y: centerY - height / 2,
        x2: centerX + width / 2,
        y2: centerY + height / 2,
        centerX: centerX,
        centerY: centerY,
        pointX: pt.x,
        pointY: pt.y,
        width: width,
        height: height,
        rotation: (0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(rotation)
    };
}
function $4049e6bf31df43d6$var$rotatedSize(width, height, rotation) {
    const cos = Math.cos(rotation);
    const sin = Math.sin(rotation);
    return {
        w: Math.abs(width * cos) + Math.abs(height * sin),
        h: Math.abs(width * sin) + Math.abs(height * cos)
    };
}
function $4049e6bf31df43d6$var$calculateT(properties, label, sizes, chartArea) {
    let t;
    const space = $4049e6bf31df43d6$var$spaceAround(properties, chartArea);
    if (label.position === 'start') t = $4049e6bf31df43d6$var$calculateTAdjust({
        w: properties.x2 - properties.x,
        h: properties.y2 - properties.y
    }, sizes, label, space);
    else if (label.position === 'end') t = 1 - $4049e6bf31df43d6$var$calculateTAdjust({
        w: properties.x - properties.x2,
        h: properties.y - properties.y2
    }, sizes, label, space);
    else t = $4049e6bf31df43d6$var$getRelativePosition(1, label.position);
    return t;
}
function $4049e6bf31df43d6$var$calculateTAdjust(lineSize, sizes, label, space) {
    const { labelSize: labelSize, padding: padding } = sizes;
    const lineW = lineSize.w * space.dx;
    const lineH = lineSize.h * space.dy;
    const x = lineW > 0 && (labelSize.w / 2 + padding.left - space.x) / lineW;
    const y = lineH > 0 && (labelSize.h / 2 + padding.top - space.y) / lineH;
    return $4049e6bf31df43d6$var$clamp(Math.max(x, y), 0, 0.25);
}
function $4049e6bf31df43d6$var$spaceAround(properties, chartArea) {
    const { x: x, x2: x2, y: y, y2: y2 } = properties;
    const t = Math.min(y, y2) - chartArea.top;
    const l = Math.min(x, x2) - chartArea.left;
    const b = chartArea.bottom - Math.max(y, y2);
    const r = chartArea.right - Math.max(x, x2);
    return {
        x: Math.min(l, r),
        y: Math.min(t, b),
        dx: l <= r ? 1 : -1,
        dy: t <= b ? 1 : -1
    };
}
function $4049e6bf31df43d6$var$adjustLabelCoordinate(coordinate, labelSizes) {
    const { size: size, min: min, max: max, padding: padding } = labelSizes;
    const halfSize = size / 2;
    if (size > max - min) // if it does not fit, display as much as possible
    return (max + min) / 2;
    if (min >= coordinate - padding - halfSize) coordinate = min + padding + halfSize;
    if (max <= coordinate + padding + halfSize) coordinate = max - padding - halfSize;
    return coordinate;
}
function $4049e6bf31df43d6$var$getArrowHeads(line) {
    const options = line.options;
    const arrowStartOpts = options.arrowHeads && options.arrowHeads.start;
    const arrowEndOpts = options.arrowHeads && options.arrowHeads.end;
    return {
        startOpts: arrowStartOpts,
        endOpts: arrowEndOpts,
        startAdjust: $4049e6bf31df43d6$var$getLineAdjust(line, arrowStartOpts),
        endAdjust: $4049e6bf31df43d6$var$getLineAdjust(line, arrowEndOpts)
    };
}
function $4049e6bf31df43d6$var$getLineAdjust(line, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return 0;
    const { length: length, width: width } = arrowOpts;
    const adjust = line.options.borderWidth / 2;
    const p1 = {
        x: length,
        y: width + adjust
    };
    const p2 = {
        x: 0,
        y: adjust
    };
    return Math.abs($4049e6bf31df43d6$var$interpolateX(0, p1, p2));
}
function $4049e6bf31df43d6$var$drawArrowHead(ctx, offset, adjust, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return;
    const { length: length, width: width, fill: fill, backgroundColor: backgroundColor, borderColor: borderColor } = arrowOpts;
    const arrowOffsetX = Math.abs(offset - length) + adjust;
    ctx.beginPath();
    $4049e6bf31df43d6$var$setShadowStyle(ctx, arrowOpts);
    $4049e6bf31df43d6$var$setBorderStyle(ctx, arrowOpts);
    ctx.moveTo(arrowOffsetX, -width);
    ctx.lineTo(offset + adjust, 0);
    ctx.lineTo(arrowOffsetX, width);
    if (fill === true) {
        ctx.fillStyle = backgroundColor || borderColor;
        ctx.closePath();
        ctx.fill();
        ctx.shadowColor = 'transparent';
    } else ctx.shadowColor = arrowOpts.borderShadowColor;
    ctx.stroke();
}
function $4049e6bf31df43d6$var$getControlPoint(properties, options, distance) {
    const { x: x, y: y, x2: x2, y2: y2, centerX: centerX, centerY: centerY } = properties;
    const angle = Math.atan2(y2 - y, x2 - x);
    const cp = $4049e6bf31df43d6$var$toPosition(options.controlPoint, 0);
    const point = {
        x: centerX + $4049e6bf31df43d6$var$getSize(distance, cp.x, false),
        y: centerY + $4049e6bf31df43d6$var$getSize(distance, cp.y, false)
    };
    return $4049e6bf31df43d6$var$rotated(point, {
        x: centerX,
        y: centerY
    }, angle);
}
function $4049e6bf31df43d6$var$drawArrowHeadOnCurve(ctx, { x: x, y: y }, { angle: angle, adjust: adjust }, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    $4049e6bf31df43d6$var$drawArrowHead(ctx, 0, -adjust, arrowOpts);
    ctx.restore();
}
function $4049e6bf31df43d6$var$drawCurve(ctx, element, cp, length) {
    const { x: x, y: y, x2: x2, y2: y2, options: options } = element;
    const { startOpts: startOpts, endOpts: endOpts, startAdjust: startAdjust, endAdjust: endAdjust } = $4049e6bf31df43d6$var$getArrowHeads(element);
    const p1 = {
        x: x,
        y: y
    };
    const p2 = {
        x: x2,
        y: y2
    };
    const startAngle = $4049e6bf31df43d6$var$angleInCurve(p1, cp, p2, 0);
    const endAngle = $4049e6bf31df43d6$var$angleInCurve(p1, cp, p2, 1) - (0, $84f61e7391a78632$export$56c0d5a1e737357d);
    const ps = $4049e6bf31df43d6$var$pointInCurve(p1, cp, p2, startAdjust / length);
    const pe = $4049e6bf31df43d6$var$pointInCurve(p1, cp, p2, 1 - endAdjust / length);
    const path = new Path2D();
    ctx.beginPath();
    path.moveTo(ps.x, ps.y);
    path.quadraticCurveTo(cp.x, cp.y, pe.x, pe.y);
    ctx.shadowColor = options.borderShadowColor;
    ctx.stroke(path);
    element.path = path;
    element.ctx = ctx;
    $4049e6bf31df43d6$var$drawArrowHeadOnCurve(ctx, ps, {
        angle: startAngle,
        adjust: startAdjust
    }, startOpts);
    $4049e6bf31df43d6$var$drawArrowHeadOnCurve(ctx, pe, {
        angle: endAngle,
        adjust: endAdjust
    }, endOpts);
}
class $4049e6bf31df43d6$var$EllipseAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const rotation = this.options.rotation;
        const borderWidth = this.options.borderWidth;
        if (axis !== 'x' && axis !== 'y') return $4049e6bf31df43d6$var$pointInEllipse({
            x: mouseX,
            y: mouseY
        }, this.getProps([
            'width',
            'height',
            'centerX',
            'centerY'
        ], useFinalPosition), rotation, borderWidth);
        const { x: x, y: y, x2: x2, y2: y2 } = this.getProps([
            'x',
            'y',
            'x2',
            'y2'
        ], useFinalPosition);
        const hBorderWidth = borderWidth / 2;
        const limit = axis === 'y' ? {
            start: y,
            end: y2
        } : {
            start: x,
            end: x2
        };
        const rotatedPoint = $4049e6bf31df43d6$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-rotation));
        return rotatedPoint[axis] >= limit.start - hBorderWidth - $4049e6bf31df43d6$var$EPSILON && rotatedPoint[axis] <= limit.end + hBorderWidth + $4049e6bf31df43d6$var$EPSILON;
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { width: width, height: height, centerX: centerX, centerY: centerY, options: options } = this;
        ctx.save();
        $4049e6bf31df43d6$var$translate(ctx, this.getCenterPoint(), options.rotation);
        $4049e6bf31df43d6$var$setShadowStyle(ctx, this.options);
        ctx.beginPath();
        ctx.fillStyle = options.backgroundColor;
        const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
        ctx.ellipse(centerX, centerY, height / 2, width / 2, (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2, 0, 2 * (0, $84f61e7391a78632$export$56c0d5a1e737357d));
        ctx.fill();
        if (stroke) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        return $4049e6bf31df43d6$var$resolveBoxAndLabelProperties(chart, options, true);
    }
}
$4049e6bf31df43d6$var$EllipseAnnotation.id = 'ellipseAnnotation';
$4049e6bf31df43d6$var$EllipseAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    init: undefined,
    label: Object.assign({}, $4049e6bf31df43d6$var$BoxAnnotation.defaults.label),
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$4049e6bf31df43d6$var$EllipseAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
$4049e6bf31df43d6$var$EllipseAnnotation.descriptors = {
    label: {
        _fallback: true
    }
};
function $4049e6bf31df43d6$var$pointInEllipse(p, ellipse, rotation, borderWidth) {
    const { width: width, height: height, centerX: centerX, centerY: centerY } = ellipse;
    const xRadius = width / 2;
    const yRadius = height / 2;
    if (xRadius <= 0 || yRadius <= 0) return false;
    // https://stackoverflow.com/questions/7946187/point-and-ellipse-rotated-position-test-algorithm
    const angle = (0, $84f61e7391a78632$export$625550452a3fa3ec)(rotation || 0);
    const hBorderWidth = borderWidth / 2 || 0;
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const a = Math.pow(cosAngle * (p.x - centerX) + sinAngle * (p.y - centerY), 2);
    const b = Math.pow(sinAngle * (p.x - centerX) - cosAngle * (p.y - centerY), 2);
    return a / Math.pow(xRadius + hBorderWidth, 2) + b / Math.pow(yRadius + hBorderWidth, 2) <= 1.0001;
}
class $4049e6bf31df43d6$var$PointAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const { x: x, y: y, x2: x2, y2: y2, width: width } = this.getProps([
            'x',
            'y',
            'x2',
            'y2',
            'width'
        ], useFinalPosition);
        const borderWidth = this.options.borderWidth;
        if (axis !== 'x' && axis !== 'y') return $4049e6bf31df43d6$var$inPointRange({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), width / 2, borderWidth);
        const hBorderWidth = borderWidth / 2;
        const limit = axis === 'y' ? {
            start: y,
            end: y2,
            value: mouseY
        } : {
            start: x,
            end: x2,
            value: mouseX
        };
        return limit.value >= limit.start - hBorderWidth && limit.value <= limit.end + hBorderWidth;
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        const borderWidth = options.borderWidth;
        if (options.radius < 0.1) return;
        ctx.save();
        ctx.fillStyle = options.backgroundColor;
        $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
        const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
        $4049e6bf31df43d6$var$drawPoint(ctx, this, this.centerX, this.centerY);
        if (stroke && !$4049e6bf31df43d6$var$isImageOrCanvas(options.pointStyle)) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
        options.borderWidth = borderWidth;
    }
    resolveElementProperties(chart, options) {
        const properties = $4049e6bf31df43d6$var$resolvePointProperties(chart, options);
        properties.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options, true);
        return properties;
    }
}
$4049e6bf31df43d6$var$PointAnnotation.id = 'pointAnnotation';
$4049e6bf31df43d6$var$PointAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    init: undefined,
    pointStyle: 'circle',
    radius: 10,
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$4049e6bf31df43d6$var$PointAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
class $4049e6bf31df43d6$var$PolygonAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        if (axis !== 'x' && axis !== 'y') return this.options.radius >= 0.1 && this.elements.length > 1 && $4049e6bf31df43d6$var$pointIsInPolygon(this.elements, mouseX, mouseY, useFinalPosition);
        const rotatedPoint = $4049e6bf31df43d6$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-this.options.rotation));
        const axisPoints = this.elements.map((point)=>axis === 'y' ? point.bY : point.bX);
        const start = Math.min(...axisPoints);
        const end = Math.max(...axisPoints);
        return rotatedPoint[axis] >= start && rotatedPoint[axis] <= end;
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { elements: elements, options: options } = this;
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = options.backgroundColor;
        $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
        const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
        let first = true;
        for (const el of elements)if (first) {
            ctx.moveTo(el.x, el.y);
            first = false;
        } else ctx.lineTo(el.x, el.y);
        ctx.closePath();
        ctx.fill();
        // If no border, don't draw it
        if (stroke) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        const properties = $4049e6bf31df43d6$var$resolvePointProperties(chart, options);
        const { sides: sides, rotation: rotation } = options;
        const elements = [];
        const angle = 2 * (0, $84f61e7391a78632$export$56c0d5a1e737357d) / sides;
        let rad = rotation * (0, $84f61e7391a78632$export$39c1cc7c062529d4);
        for(let i = 0; i < sides; i++, rad += angle){
            const elProps = $4049e6bf31df43d6$var$buildPointElement(properties, options, rad);
            elProps.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options);
            elements.push(elProps);
        }
        properties.elements = elements;
        return properties;
    }
}
$4049e6bf31df43d6$var$PolygonAnnotation.id = 'polygonAnnotation';
$4049e6bf31df43d6$var$PolygonAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    init: undefined,
    point: {
        radius: 0
    },
    radius: 10,
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    sides: 3,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$4049e6bf31df43d6$var$PolygonAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
function $4049e6bf31df43d6$var$buildPointElement({ centerX: centerX, centerY: centerY }, { radius: radius, borderWidth: borderWidth }, rad) {
    const halfBorder = borderWidth / 2;
    const sin = Math.sin(rad);
    const cos = Math.cos(rad);
    const point = {
        x: centerX + sin * radius,
        y: centerY - cos * radius
    };
    return {
        type: 'point',
        optionScope: 'point',
        properties: {
            x: point.x,
            y: point.y,
            centerX: point.x,
            centerY: point.y,
            bX: centerX + sin * (radius + halfBorder),
            bY: centerY - cos * (radius + halfBorder)
        }
    };
}
function $4049e6bf31df43d6$var$pointIsInPolygon(points, x, y, useFinalPosition) {
    let isInside = false;
    let A = points[points.length - 1].getProps([
        'bX',
        'bY'
    ], useFinalPosition);
    for (const point of points){
        const B = point.getProps([
            'bX',
            'bY'
        ], useFinalPosition);
        if (B.bY > y !== A.bY > y && x < (A.bX - B.bX) * (y - B.bY) / (A.bY - B.bY) + B.bX) isInside = !isInside;
        A = B;
    }
    return isInside;
}
const $4049e6bf31df43d6$var$annotationTypes = {
    box: $4049e6bf31df43d6$var$BoxAnnotation,
    ellipse: $4049e6bf31df43d6$var$EllipseAnnotation,
    label: $4049e6bf31df43d6$var$LabelAnnotation,
    line: $4049e6bf31df43d6$var$LineAnnotation,
    point: $4049e6bf31df43d6$var$PointAnnotation,
    polygon: $4049e6bf31df43d6$var$PolygonAnnotation
};
/**
 * Register fallback for annotation elements
 * For example lineAnnotation options would be looked through:
 * - the annotation object (options.plugins.annotation.annotations[id])
 * - element options (options.elements.lineAnnotation)
 * - element defaults (defaults.elements.lineAnnotation)
 * - annotation plugin defaults (defaults.plugins.annotation, this is what we are registering here)
 */ Object.keys($4049e6bf31df43d6$var$annotationTypes).forEach((key)=>{
    (0, $84f61e7391a78632$export$4368d992c4eafac0).describe(`elements.${$4049e6bf31df43d6$var$annotationTypes[key].id}`, {
        _fallback: 'plugins.annotation.common'
    });
});
const $4049e6bf31df43d6$var$directUpdater = {
    update: Object.assign
};
const $4049e6bf31df43d6$var$hooks$1 = $4049e6bf31df43d6$var$eventHooks.concat($4049e6bf31df43d6$var$elementHooks);
const $4049e6bf31df43d6$var$resolve = (value, optDefs)=>(0, $84f61e7391a78632$export$23f2a1d2818174ef)(optDefs) ? $4049e6bf31df43d6$var$resolveObj(value, optDefs) : value;
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").UpdateMode } UpdateMode
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 */ /**
 * @param {string} prop
 * @returns {boolean}
 */ const $4049e6bf31df43d6$var$isIndexable = (prop)=>prop === 'color' || prop === 'font';
/**
 * Resolve the annotation type, checking if is supported.
 * @param {string} [type=line] - annotation type
 * @returns {string} resolved annotation type
 */ function $4049e6bf31df43d6$var$resolveType(type = 'line') {
    if ($4049e6bf31df43d6$var$annotationTypes[type]) return type;
    console.warn(`Unknown annotation type: '${type}', defaulting to 'line'`);
    return 'line';
}
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 * @param {UpdateMode} mode
 */ function $4049e6bf31df43d6$var$updateElements(chart, state, options, mode) {
    const animations = $4049e6bf31df43d6$var$resolveAnimations(chart, options.animations, mode);
    const annotations = state.annotations;
    const elements = $4049e6bf31df43d6$var$resyncElements(state.elements, annotations);
    for(let i = 0; i < annotations.length; i++){
        const annotationOptions = annotations[i];
        const element = $4049e6bf31df43d6$var$getOrCreateElement(elements, i, annotationOptions.type);
        const resolver = annotationOptions.setContext($4049e6bf31df43d6$var$getContext(chart, element, annotationOptions));
        const properties = element.resolveElementProperties(chart, resolver);
        properties.skip = $4049e6bf31df43d6$var$toSkip(properties);
        if ('elements' in properties) {
            $4049e6bf31df43d6$var$updateSubElements(element, properties.elements, resolver, animations);
            // Remove the sub-element definitions from properties, so the actual elements
            // are not overwritten by their definitions
            delete properties.elements;
        }
        if (!(0, $84f61e7391a78632$export$dda1d9f60106f0e9)(element.x)) // If the element is newly created, assing the properties directly - to
        // make them readily awailable to any scriptable options. If we do not do this,
        // the properties retruned by `resolveElementProperties` are available only
        // after options resolution.
        Object.assign(element, properties);
        Object.assign(element, properties.initProperties);
        properties.options = $4049e6bf31df43d6$var$resolveAnnotationOptions(resolver);
        animations.update(element, properties);
    }
}
function $4049e6bf31df43d6$var$toSkip(properties) {
    return isNaN(properties.x) || isNaN(properties.y);
}
function $4049e6bf31df43d6$var$resolveAnimations(chart, animOpts, mode) {
    if (mode === 'reset' || mode === 'none' || mode === 'resize') return $4049e6bf31df43d6$var$directUpdater;
    return new (0, $216d2bdc6f281bf6$export$8ab227dac26677d)(chart, animOpts);
}
function $4049e6bf31df43d6$var$updateSubElements(mainElement, elements, resolver, animations) {
    const subElements = mainElement.elements || (mainElement.elements = []);
    subElements.length = elements.length;
    for(let i = 0; i < elements.length; i++){
        const definition = elements[i];
        const properties = definition.properties;
        const subElement = $4049e6bf31df43d6$var$getOrCreateElement(subElements, i, definition.type, definition.initProperties);
        const subResolver = resolver[definition.optionScope].override(definition);
        properties.options = $4049e6bf31df43d6$var$resolveAnnotationOptions(subResolver);
        animations.update(subElement, properties);
    }
}
function $4049e6bf31df43d6$var$getOrCreateElement(elements, index, type, initProperties) {
    const elementClass = $4049e6bf31df43d6$var$annotationTypes[$4049e6bf31df43d6$var$resolveType(type)];
    let element = elements[index];
    if (!element || !(element instanceof elementClass)) {
        element = elements[index] = new elementClass();
        Object.assign(element, initProperties);
    }
    return element;
}
function $4049e6bf31df43d6$var$resolveAnnotationOptions(resolver) {
    const elementClass = $4049e6bf31df43d6$var$annotationTypes[$4049e6bf31df43d6$var$resolveType(resolver.type)];
    const result = {};
    result.id = resolver.id;
    result.type = resolver.type;
    result.drawTime = resolver.drawTime;
    Object.assign(result, $4049e6bf31df43d6$var$resolveObj(resolver, elementClass.defaults), $4049e6bf31df43d6$var$resolveObj(resolver, elementClass.defaultRoutes));
    for (const hook of $4049e6bf31df43d6$var$hooks$1)result[hook] = resolver[hook];
    return result;
}
function $4049e6bf31df43d6$var$resolveObj(resolver, defs) {
    const result = {};
    for (const prop of Object.keys(defs)){
        const optDefs = defs[prop];
        const value = resolver[prop];
        if ($4049e6bf31df43d6$var$isIndexable(prop) && (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(value)) result[prop] = value.map((item)=>$4049e6bf31df43d6$var$resolve(item, optDefs));
        else result[prop] = $4049e6bf31df43d6$var$resolve(value, optDefs);
    }
    return result;
}
function $4049e6bf31df43d6$var$getContext(chart, element, annotation) {
    return element.$context || (element.$context = Object.assign(Object.create(chart.getContext()), {
        element: element,
        id: annotation.id,
        type: 'annotation'
    }));
}
function $4049e6bf31df43d6$var$resyncElements(elements, annotations) {
    const count = annotations.length;
    const start = elements.length;
    if (start < count) {
        const add = count - start;
        elements.splice(start, 0, ...new Array(add));
    } else if (start > count) elements.splice(count, start - count);
    return elements;
}
var $4049e6bf31df43d6$var$version = "2.2.1";
const $4049e6bf31df43d6$var$chartStates = new Map();
const $4049e6bf31df43d6$var$hooks = $4049e6bf31df43d6$var$eventHooks.concat($4049e6bf31df43d6$var$elementHooks);
var $4049e6bf31df43d6$export$2e2bcd8739ae039 = {
    id: 'annotation',
    version: $4049e6bf31df43d6$var$version,
    beforeRegister () {
        $4049e6bf31df43d6$var$requireVersion('chart.js', '3.7', (0, $216d2bdc6f281bf6$export$acaa6426d77a227e).version);
    },
    afterRegister () {
        (0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register($4049e6bf31df43d6$var$annotationTypes);
    },
    afterUnregister () {
        (0, $216d2bdc6f281bf6$export$acaa6426d77a227e).unregister($4049e6bf31df43d6$var$annotationTypes);
    },
    beforeInit (chart) {
        $4049e6bf31df43d6$var$chartStates.set(chart, {
            annotations: [],
            elements: [],
            visibleElements: [],
            listeners: {},
            listened: false,
            moveListened: false,
            hooks: {},
            hooked: false,
            hovered: []
        });
    },
    beforeUpdate (chart, args, options) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        const annotations = state.annotations = [];
        let annotationOptions = options.annotations;
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(annotationOptions)) Object.keys(annotationOptions).forEach((key)=>{
            const value = annotationOptions[key];
            if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(value)) {
                value.id = key;
                annotations.push(value);
            }
        });
        else if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(annotationOptions)) annotations.push(...annotationOptions);
        $4049e6bf31df43d6$var$verifyScaleOptions(annotations, chart.scales);
    },
    afterDataLimits (chart, args) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        $4049e6bf31df43d6$var$adjustScaleRange(chart, args.scale, state.annotations.filter((a)=>a.display && a.adjustScaleRange));
    },
    afterUpdate (chart, args, options) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        $4049e6bf31df43d6$var$updateListeners(chart, state, options);
        $4049e6bf31df43d6$var$updateElements(chart, state, options, args.mode);
        state.visibleElements = state.elements.filter((el)=>!el.skip && el.options.display);
        $4049e6bf31df43d6$var$updateHooks(chart, state, options);
    },
    beforeDatasetsDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'beforeDatasetsDraw', options.clip);
    },
    afterDatasetsDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'afterDatasetsDraw', options.clip);
    },
    beforeDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'beforeDraw', options.clip);
    },
    afterDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'afterDraw', options.clip);
    },
    beforeEvent (chart, args, options) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        if ($4049e6bf31df43d6$var$handleEvent(state, args.event, options)) args.changed = true;
    },
    afterDestroy (chart) {
        $4049e6bf31df43d6$var$chartStates.delete(chart);
    },
    _getState (chart) {
        return $4049e6bf31df43d6$var$chartStates.get(chart);
    },
    defaults: {
        animations: {
            numbers: {
                properties: [
                    'x',
                    'y',
                    'x2',
                    'y2',
                    'width',
                    'height',
                    'centerX',
                    'centerY',
                    'pointX',
                    'pointY',
                    'radius'
                ],
                type: 'number'
            }
        },
        clip: true,
        interaction: {
            mode: undefined,
            axis: undefined,
            intersect: undefined
        },
        common: {
            drawTime: 'afterDatasetsDraw',
            init: false,
            label: {}
        }
    },
    descriptors: {
        _indexable: false,
        _scriptable: (prop)=>!$4049e6bf31df43d6$var$hooks.includes(prop) && prop !== 'init',
        annotations: {
            _allKeys: false,
            _fallback: (prop, opts)=>`elements.${$4049e6bf31df43d6$var$annotationTypes[$4049e6bf31df43d6$var$resolveType(opts.type)].id}`
        },
        interaction: {
            _fallback: true
        },
        common: {
            label: {
                _indexable: $4049e6bf31df43d6$var$isIndexable,
                _fallback: true
            },
            _indexable: $4049e6bf31df43d6$var$isIndexable
        }
    },
    additionalOptionScopes: [
        ''
    ]
};
function $4049e6bf31df43d6$var$draw(chart, caller, clip) {
    const { ctx: ctx, chartArea: chartArea } = chart;
    const state = $4049e6bf31df43d6$var$chartStates.get(chart);
    if (clip) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, chartArea);
    const drawableElements = $4049e6bf31df43d6$var$getDrawableElements(state.visibleElements, caller).sort((a, b)=>a.element.options.z - b.element.options.z);
    for (const item of drawableElements)$4049e6bf31df43d6$var$drawElement(ctx, chartArea, state, item);
    if (clip) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
}
function $4049e6bf31df43d6$var$getDrawableElements(elements, caller) {
    const drawableElements = [];
    for (const el of elements){
        if (el.options.drawTime === caller) drawableElements.push({
            element: el,
            main: true
        });
        if (el.elements && el.elements.length) {
            for (const sub of el.elements)if (sub.options.display && sub.options.drawTime === caller) drawableElements.push({
                element: sub
            });
        }
    }
    return drawableElements;
}
function $4049e6bf31df43d6$var$drawElement(ctx, chartArea, state, item) {
    const el = item.element;
    if (item.main) {
        $4049e6bf31df43d6$var$invokeHook(state, el, 'beforeDraw');
        el.draw(ctx, chartArea);
        $4049e6bf31df43d6$var$invokeHook(state, el, 'afterDraw');
    } else el.draw(ctx, chartArea);
}


var $82652140c2d744c1$exports = {};
'use strict';
var $82652140c2d744c1$var$isMergeableObject = function isMergeableObject(value) {
    return $82652140c2d744c1$var$isNonNullObject(value) && !$82652140c2d744c1$var$isSpecial(value);
};
function $82652140c2d744c1$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $82652140c2d744c1$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $82652140c2d744c1$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $82652140c2d744c1$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $82652140c2d744c1$var$REACT_ELEMENT_TYPE = $82652140c2d744c1$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $82652140c2d744c1$var$isReactElement(value) {
    return value.$$typeof === $82652140c2d744c1$var$REACT_ELEMENT_TYPE;
}
function $82652140c2d744c1$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $82652140c2d744c1$var$deepmerge($82652140c2d744c1$var$emptyTarget(value), value, options) : value;
}
function $82652140c2d744c1$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $82652140c2d744c1$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $82652140c2d744c1$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : $82652140c2d744c1$var$deepmerge;
}
function $82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $82652140c2d744c1$var$getKeys(target) {
    return Object.keys(target).concat($82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target));
}
function $82652140c2d744c1$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $82652140c2d744c1$var$propertyIsUnsafe(target, key) {
    return $82652140c2d744c1$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $82652140c2d744c1$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $82652140c2d744c1$var$getKeys(target).forEach(function(key) {
        destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $82652140c2d744c1$var$getKeys(source).forEach(function(key) {
        if ($82652140c2d744c1$var$propertyIsUnsafe(target, key)) return;
        if ($82652140c2d744c1$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $82652140c2d744c1$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $82652140c2d744c1$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $82652140c2d744c1$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $82652140c2d744c1$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $82652140c2d744c1$var$mergeObject(target, source, options);
}
$82652140c2d744c1$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $82652140c2d744c1$var$deepmerge(prev, next, options);
    }, {});
};
var $82652140c2d744c1$var$deepmerge_1 = $82652140c2d744c1$var$deepmerge;
$82652140c2d744c1$exports = $82652140c2d744c1$var$deepmerge_1;


parcelRequire("acw62");


var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)((0, $jR9F1.default));
    return theme[0, $4jPsi.default] || theme;
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $lWAfe = parcelRequire("lWAfe");

var $6hiu6 = parcelRequire("6hiu6");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;


var $f35b8acab3fc2f62$exports = {};

$parcel$defineInteropFlag($f35b8acab3fc2f62$exports);

$parcel$export($f35b8acab3fc2f62$exports, "getGridUtilityClass", () => $f35b8acab3fc2f62$export$9973ac5fd0181f33);
$parcel$export($f35b8acab3fc2f62$exports, "default", () => $f35b8acab3fc2f62$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $beCSm.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $lWAfe.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $lWAfe.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $lWAfe.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const props = (0, $6hiu6.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $8nd05.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;


var $4556e4fc82adeb27$export$2e2bcd8739ae039 = (0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");


var $a7aa7f7fd6981187$export$2e2bcd8739ae039 = (0, $2531239e3a525689$export$2e2bcd8739ae039);



var $3276e9745553f254$exports = {};

$parcel$export($3276e9745553f254$exports, "globalFontWeightBold", () => $3276e9745553f254$export$47532a6f57be45d9);
$parcel$export($3276e9745553f254$exports, "globalFontWeightSemiBold", () => $3276e9745553f254$export$740ac66abb38bb83);
$parcel$export($3276e9745553f254$exports, "globalFontWeightRegular", () => $3276e9745553f254$export$90168a3412ee7f0c);
$parcel$export($3276e9745553f254$exports, "globalGradientGray20", () => $3276e9745553f254$export$9b985e69928d4804);
$parcel$export($3276e9745553f254$exports, "globalGradientGray10", () => $3276e9745553f254$export$6e4689b7cf6aeadb);
$parcel$export($3276e9745553f254$exports, "globalGradientDeepOcean1", () => $3276e9745553f254$export$c473f2d55633c7bf);
$parcel$export($3276e9745553f254$exports, "globalChartCoast30", () => $3276e9745553f254$export$bf51732c1e402305);
$parcel$export($3276e9745553f254$exports, "globalChartCoast40", () => $3276e9745553f254$export$dd6ac6c529280b28);
$parcel$export($3276e9745553f254$exports, "globalChartMermaid23", () => $3276e9745553f254$export$628bc4cedab3f39c);
$parcel$export($3276e9745553f254$exports, "globalChartMermaid33", () => $3276e9745553f254$export$12d92729ec24385a);
$parcel$export($3276e9745553f254$exports, "globalChartBrine33", () => $3276e9745553f254$export$4a7539ac23adfb7a);
$parcel$export($3276e9745553f254$exports, "globalChartBrine43", () => $3276e9745553f254$export$fb8a8a98f73ce6b1);
$parcel$export($3276e9745553f254$exports, "globalChartSeaglass17", () => $3276e9745553f254$export$60723b7193f02e02);
$parcel$export($3276e9745553f254$exports, "globalChartSeaglass27", () => $3276e9745553f254$export$795334c6456d2730);
$parcel$export($3276e9745553f254$exports, "globalChartJellyfish35", () => $3276e9745553f254$export$da6517e7d9c36003);
$parcel$export($3276e9745553f254$exports, "globalChartJellyfish45", () => $3276e9745553f254$export$3b7ffecbd7cc9aeb);
$parcel$export($3276e9745553f254$exports, "globalChartAnemone30", () => $3276e9745553f254$export$2c3279dd523ce91e);
$parcel$export($3276e9745553f254$exports, "globalChartAnemone40", () => $3276e9745553f254$export$a32ed79b0c9f894d);
$parcel$export($3276e9745553f254$exports, "globalChartSunset60", () => $3276e9745553f254$export$364c018f7a909db3);
$parcel$export($3276e9745553f254$exports, "globalChartSunset70", () => $3276e9745553f254$export$5f85a6a7c51d6890);
$parcel$export($3276e9745553f254$exports, "globalChartLionfish65", () => $3276e9745553f254$export$436b1e2e43974ada);
$parcel$export($3276e9745553f254$exports, "globalChartLionfish75", () => $3276e9745553f254$export$a9aeb5d8dac66b57);
$parcel$export($3276e9745553f254$exports, "globalOrange10", () => $3276e9745553f254$export$684e73d930ab653c);
$parcel$export($3276e9745553f254$exports, "globalOrange20", () => $3276e9745553f254$export$1181582ac6088c50);
$parcel$export($3276e9745553f254$exports, "globalOrange30", () => $3276e9745553f254$export$b2d49d7677da6748);
$parcel$export($3276e9745553f254$exports, "globalOrange40", () => $3276e9745553f254$export$b6a1b5443e554bac);
$parcel$export($3276e9745553f254$exports, "globalOrange50", () => $3276e9745553f254$export$3b8a5dc0c17f71c2);
$parcel$export($3276e9745553f254$exports, "globalOrange60", () => $3276e9745553f254$export$8b7438de76999a40);
$parcel$export($3276e9745553f254$exports, "globalOrange70", () => $3276e9745553f254$export$2b5d6b20a9c67c77);
$parcel$export($3276e9745553f254$exports, "globalOrange82", () => $3276e9745553f254$export$5afcf229520f3e);
$parcel$export($3276e9745553f254$exports, "globalOrange86", () => $3276e9745553f254$export$d61e61546d5dbc3b);
$parcel$export($3276e9745553f254$exports, "globalOrange88", () => $3276e9745553f254$export$5acbd671bcb55bbc);
$parcel$export($3276e9745553f254$exports, "globalOrange90", () => $3276e9745553f254$export$ae55d2493bfc2288);
$parcel$export($3276e9745553f254$exports, "globalOrange92", () => $3276e9745553f254$export$d92f008db791081b);
$parcel$export($3276e9745553f254$exports, "globalOrange96", () => $3276e9745553f254$export$16492d98578c318);
$parcel$export($3276e9745553f254$exports, "globalOrange98", () => $3276e9745553f254$export$3a485bc73a43c0d);
$parcel$export($3276e9745553f254$exports, "globalGreen10", () => $3276e9745553f254$export$73c61615faaec16d);
$parcel$export($3276e9745553f254$exports, "globalGreen20", () => $3276e9745553f254$export$f61d2734a97ec44d);
$parcel$export($3276e9745553f254$exports, "globalGreen30", () => $3276e9745553f254$export$db59b2d9d3b8f23);
$parcel$export($3276e9745553f254$exports, "globalGreen40", () => $3276e9745553f254$export$2fc86281a892e4e9);
$parcel$export($3276e9745553f254$exports, "globalGreen50", () => $3276e9745553f254$export$65018fb6acb6e9e);
$parcel$export($3276e9745553f254$exports, "globalGreen60", () => $3276e9745553f254$export$6f52551cdcf848f2);
$parcel$export($3276e9745553f254$exports, "globalGreen70", () => $3276e9745553f254$export$8717c4e3eb9150e5);
$parcel$export($3276e9745553f254$exports, "globalGreen82", () => $3276e9745553f254$export$c83198aa8943b17f);
$parcel$export($3276e9745553f254$exports, "globalGreen86", () => $3276e9745553f254$export$8c35a5b2f64f36d);
$parcel$export($3276e9745553f254$exports, "globalGreen88", () => $3276e9745553f254$export$6ff44857ae98393);
$parcel$export($3276e9745553f254$exports, "globalGreen90", () => $3276e9745553f254$export$8fc5d73ef8daa081);
$parcel$export($3276e9745553f254$exports, "globalGreen92", () => $3276e9745553f254$export$ca9d34853847d885);
$parcel$export($3276e9745553f254$exports, "globalGreen96", () => $3276e9745553f254$export$5e3d63bd09e2adfa);
$parcel$export($3276e9745553f254$exports, "globalGreen98", () => $3276e9745553f254$export$a31d2a5d6f4951c3);
$parcel$export($3276e9745553f254$exports, "globalRed10", () => $3276e9745553f254$export$2fa8052ddbf692db);
$parcel$export($3276e9745553f254$exports, "globalRed20", () => $3276e9745553f254$export$5ae3653bea2f6002);
$parcel$export($3276e9745553f254$exports, "globalRed30", () => $3276e9745553f254$export$ebe209ab71dc9900);
$parcel$export($3276e9745553f254$exports, "globalRed40", () => $3276e9745553f254$export$9a86551a13d806cb);
$parcel$export($3276e9745553f254$exports, "globalRed50", () => $3276e9745553f254$export$c10c79645b27877d);
$parcel$export($3276e9745553f254$exports, "globalRed60", () => $3276e9745553f254$export$3162b4069185c8ae);
$parcel$export($3276e9745553f254$exports, "globalRed70", () => $3276e9745553f254$export$b001b9d8cf2ddf0c);
$parcel$export($3276e9745553f254$exports, "globalRed82", () => $3276e9745553f254$export$2bcac13af88081c8);
$parcel$export($3276e9745553f254$exports, "globalRed86", () => $3276e9745553f254$export$72d98e4ddcb0af1b);
$parcel$export($3276e9745553f254$exports, "globalRed88", () => $3276e9745553f254$export$45fc9997e1ebd965);
$parcel$export($3276e9745553f254$exports, "globalRed90", () => $3276e9745553f254$export$f8218d553727ff09);
$parcel$export($3276e9745553f254$exports, "globalRed92", () => $3276e9745553f254$export$c31b4867424b9387);
$parcel$export($3276e9745553f254$exports, "globalRed96", () => $3276e9745553f254$export$6c46c4d114584df1);
$parcel$export($3276e9745553f254$exports, "globalRed98", () => $3276e9745553f254$export$4bd1bc01799161bf);
$parcel$export($3276e9745553f254$exports, "globalYellow10", () => $3276e9745553f254$export$b68a36b2c4312600);
$parcel$export($3276e9745553f254$exports, "globalYellow20", () => $3276e9745553f254$export$bf9058acbc7e0c03);
$parcel$export($3276e9745553f254$exports, "globalYellow30", () => $3276e9745553f254$export$af58e6c4e06fba1e);
$parcel$export($3276e9745553f254$exports, "globalYellow40", () => $3276e9745553f254$export$f5c847ebf0c3830d);
$parcel$export($3276e9745553f254$exports, "globalYellow50", () => $3276e9745553f254$export$d65df8bd9766ab30);
$parcel$export($3276e9745553f254$exports, "globalYellow60", () => $3276e9745553f254$export$6dea6221146a7695);
$parcel$export($3276e9745553f254$exports, "globalYellow70", () => $3276e9745553f254$export$97794df832fa9246);
$parcel$export($3276e9745553f254$exports, "globalYellow82", () => $3276e9745553f254$export$37a6ad6644a76e8e);
$parcel$export($3276e9745553f254$exports, "globalYellow86", () => $3276e9745553f254$export$b2cc4270764e0d91);
$parcel$export($3276e9745553f254$exports, "globalYellow88", () => $3276e9745553f254$export$145e03b0063171cf);
$parcel$export($3276e9745553f254$exports, "globalYellow90", () => $3276e9745553f254$export$2d9c2b11822ba826);
$parcel$export($3276e9745553f254$exports, "globalYellow92", () => $3276e9745553f254$export$d06c19130b7b237c);
$parcel$export($3276e9745553f254$exports, "globalYellow96", () => $3276e9745553f254$export$d2a0a2228c20f625);
$parcel$export($3276e9745553f254$exports, "globalYellow98", () => $3276e9745553f254$export$b1a4a810c6323520);
$parcel$export($3276e9745553f254$exports, "globalViolet10", () => $3276e9745553f254$export$d5f6f1514cdd87e);
$parcel$export($3276e9745553f254$exports, "globalViolet20", () => $3276e9745553f254$export$abc0c049d1d05997);
$parcel$export($3276e9745553f254$exports, "globalViolet30", () => $3276e9745553f254$export$e3e4f6af628aad6d);
$parcel$export($3276e9745553f254$exports, "globalViolet40", () => $3276e9745553f254$export$a93c9c9f412d3c5e);
$parcel$export($3276e9745553f254$exports, "globalViolet50", () => $3276e9745553f254$export$d73ff2918ee90459);
$parcel$export($3276e9745553f254$exports, "globalViolet60", () => $3276e9745553f254$export$7c691d76a2faac9e);
$parcel$export($3276e9745553f254$exports, "globalViolet70", () => $3276e9745553f254$export$9ddac4fed8e0699e);
$parcel$export($3276e9745553f254$exports, "globalViolet82", () => $3276e9745553f254$export$70b4d49a036ffa16);
$parcel$export($3276e9745553f254$exports, "globalViolet86", () => $3276e9745553f254$export$b6ae9037e4487ef7);
$parcel$export($3276e9745553f254$exports, "globalViolet88", () => $3276e9745553f254$export$cdab03f0b3cedea7);
$parcel$export($3276e9745553f254$exports, "globalViolet90", () => $3276e9745553f254$export$9a3940ef3e718482);
$parcel$export($3276e9745553f254$exports, "globalViolet92", () => $3276e9745553f254$export$602a7aa90012bac7);
$parcel$export($3276e9745553f254$exports, "globalViolet96", () => $3276e9745553f254$export$f9e1bb5a6ecf8fa1);
$parcel$export($3276e9745553f254$exports, "globalViolet98", () => $3276e9745553f254$export$9665fc79e7ccde89);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean10", () => $3276e9745553f254$export$415e2ab0a19e9f81);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean20", () => $3276e9745553f254$export$9ad9d3db52ccd355);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean30", () => $3276e9745553f254$export$17b617ddb9836542);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean40", () => $3276e9745553f254$export$664987001e0f2ea0);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean50", () => $3276e9745553f254$export$58adf4043506cd3a);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean60", () => $3276e9745553f254$export$d3adcc2d4402ccc9);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean70", () => $3276e9745553f254$export$7155de5e23ab069b);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean82", () => $3276e9745553f254$export$41ee37b64344becb);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean86", () => $3276e9745553f254$export$9b88c99aa981baee);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean88", () => $3276e9745553f254$export$7c23125fd8a70a5a);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean90", () => $3276e9745553f254$export$a46d9e94ee27516a);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean92", () => $3276e9745553f254$export$57a7b6c7405c22fc);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean96", () => $3276e9745553f254$export$8c671b06252447da);
$parcel$export($3276e9745553f254$exports, "globalDeepOcean98", () => $3276e9745553f254$export$905ab8f8acc3167f);
$parcel$export($3276e9745553f254$exports, "globalBlue10", () => $3276e9745553f254$export$df8147df7c327e97);
$parcel$export($3276e9745553f254$exports, "globalBlue20", () => $3276e9745553f254$export$23afbb4232b3ac3a);
$parcel$export($3276e9745553f254$exports, "globalBlue30", () => $3276e9745553f254$export$5fcc389c3d56da1a);
$parcel$export($3276e9745553f254$exports, "globalBlue40", () => $3276e9745553f254$export$ae23f4fa1dd8e463);
$parcel$export($3276e9745553f254$exports, "globalBlue50", () => $3276e9745553f254$export$6e85f1855ac4540b);
$parcel$export($3276e9745553f254$exports, "globalBlue60", () => $3276e9745553f254$export$8740b6c0177f90d2);
$parcel$export($3276e9745553f254$exports, "globalBlue70", () => $3276e9745553f254$export$8c220e0ccc521b52);
$parcel$export($3276e9745553f254$exports, "globalBlue82", () => $3276e9745553f254$export$694b034c84505cc0);
$parcel$export($3276e9745553f254$exports, "globalBlue86", () => $3276e9745553f254$export$107dfa3b1934715e);
$parcel$export($3276e9745553f254$exports, "globalBlue88", () => $3276e9745553f254$export$a98a55e2124bd475);
$parcel$export($3276e9745553f254$exports, "globalBlue90", () => $3276e9745553f254$export$c8bb10ac89484313);
$parcel$export($3276e9745553f254$exports, "globalBlue92", () => $3276e9745553f254$export$1ac92e121667df0a);
$parcel$export($3276e9745553f254$exports, "globalBlue96", () => $3276e9745553f254$export$416d4299ae18b901);
$parcel$export($3276e9745553f254$exports, "globalBlue98", () => $3276e9745553f254$export$3bf92297e3902f9c);
$parcel$export($3276e9745553f254$exports, "globalBlueGray10", () => $3276e9745553f254$export$db52f91b6e279a41);
$parcel$export($3276e9745553f254$exports, "globalBlueGray20", () => $3276e9745553f254$export$c2bda980025d9828);
$parcel$export($3276e9745553f254$exports, "globalBlueGray30", () => $3276e9745553f254$export$8ed151e7392922f7);
$parcel$export($3276e9745553f254$exports, "globalBlueGray40", () => $3276e9745553f254$export$f0cf2df1783c1493);
$parcel$export($3276e9745553f254$exports, "globalBlueGray50", () => $3276e9745553f254$export$c537f1eb6dbc51ff);
$parcel$export($3276e9745553f254$exports, "globalBlueGray60", () => $3276e9745553f254$export$63fb948eab7d44b0);
$parcel$export($3276e9745553f254$exports, "globalBlueGray70", () => $3276e9745553f254$export$b8bfc202936f7e3d);
$parcel$export($3276e9745553f254$exports, "globalBlueGray82", () => $3276e9745553f254$export$31ed9a0baa9a125c);
$parcel$export($3276e9745553f254$exports, "globalBlueGray86", () => $3276e9745553f254$export$fafb7a10ea280ee);
$parcel$export($3276e9745553f254$exports, "globalBlueGray88", () => $3276e9745553f254$export$b5c0ad53ffc9440b);
$parcel$export($3276e9745553f254$exports, "globalBlueGray90", () => $3276e9745553f254$export$6f8e87618ad20850);
$parcel$export($3276e9745553f254$exports, "globalBlueGray92", () => $3276e9745553f254$export$b8ccb55082565c20);
$parcel$export($3276e9745553f254$exports, "globalBlueGray96", () => $3276e9745553f254$export$c824d3ae1ea71c9d);
$parcel$export($3276e9745553f254$exports, "globalBlueGray98", () => $3276e9745553f254$export$aa19e6addb4fb53d);
$parcel$export($3276e9745553f254$exports, "globalWhite", () => $3276e9745553f254$export$eaa1ebf3c9e3051b);
$parcel$export($3276e9745553f254$exports, "globalBoxShadow1", () => $3276e9745553f254$export$da7a3b2eb1ec75df);
$parcel$export($3276e9745553f254$exports, "globalBoxShadow2", () => $3276e9745553f254$export$b585396ecd4c8629);
$parcel$export($3276e9745553f254$exports, "globalBoxShadow3", () => $3276e9745553f254$export$559abfde0b301430);
$parcel$export($3276e9745553f254$exports, "globalBoxShadowNone", () => $3276e9745553f254$export$dfa790552704c785);
$parcel$export($3276e9745553f254$exports, "globalBoxShadowFlat", () => $3276e9745553f254$export$98c600e1ecf01a39);
$parcel$export($3276e9745553f254$exports, "globalBoxShadow2Top", () => $3276e9745553f254$export$a162a9eb85be72b9);
$parcel$export($3276e9745553f254$exports, "globalFontFamiliesManrope", () => $3276e9745553f254$export$6e5fb3e2c7f33c2a);
$parcel$export($3276e9745553f254$exports, "globalFontFamiliesSanchez", () => $3276e9745553f254$export$dba883712db4d3ed);
$parcel$export($3276e9745553f254$exports, "globalFontFamiliesRoboto", () => $3276e9745553f254$export$6be74618ebefea70);
$parcel$export($3276e9745553f254$exports, "globalFontFamiliesWireframes", () => $3276e9745553f254$export$958f16642186b219);
$parcel$export($3276e9745553f254$exports, "globalLineHeights6", () => $3276e9745553f254$export$b6c70790c67285f9);
$parcel$export($3276e9745553f254$exports, "globalLineHeights8", () => $3276e9745553f254$export$48529bd7f04d40f0);
$parcel$export($3276e9745553f254$exports, "globalLineHeights10", () => $3276e9745553f254$export$f362f70cc25d5976);
$parcel$export($3276e9745553f254$exports, "globalLineHeights12", () => $3276e9745553f254$export$7399932c71904dd8);
$parcel$export($3276e9745553f254$exports, "globalLineHeights14", () => $3276e9745553f254$export$1a8e4a85adfe8299);
$parcel$export($3276e9745553f254$exports, "globalLineHeights16", () => $3276e9745553f254$export$afd7e4e7ae36c76e);
$parcel$export($3276e9745553f254$exports, "globalLineHeights18", () => $3276e9745553f254$export$e2c0f185f219e125);
$parcel$export($3276e9745553f254$exports, "globalLineHeights20", () => $3276e9745553f254$export$76961812acfcaadb);
$parcel$export($3276e9745553f254$exports, "globalLineHeights22", () => $3276e9745553f254$export$36e9845aded52da1);
$parcel$export($3276e9745553f254$exports, "globalLineHeights24", () => $3276e9745553f254$export$90605139ceb31cb5);
$parcel$export($3276e9745553f254$exports, "globalLineHeights26", () => $3276e9745553f254$export$4f2f5bdc507d88ff);
$parcel$export($3276e9745553f254$exports, "globalLineHeights28", () => $3276e9745553f254$export$38351aa0f63e13f);
$parcel$export($3276e9745553f254$exports, "globalLineHeights30", () => $3276e9745553f254$export$e5fe57b4a2ace969);
$parcel$export($3276e9745553f254$exports, "globalLineHeights32", () => $3276e9745553f254$export$eb2bc143b1eaba17);
$parcel$export($3276e9745553f254$exports, "globalLineHeights48", () => $3276e9745553f254$export$c6aca45dbeea0b6e);
$parcel$export($3276e9745553f254$exports, "globalLineHeightsPercentage125", () => $3276e9745553f254$export$522d048072fdd0);
$parcel$export($3276e9745553f254$exports, "globalBorderRadius0", () => $3276e9745553f254$export$38ead138ec412471);
$parcel$export($3276e9745553f254$exports, "globalBorderRadius2", () => $3276e9745553f254$export$b4664877dc43b7af);
$parcel$export($3276e9745553f254$exports, "globalBorderRadius4", () => $3276e9745553f254$export$8982cd794b105475);
$parcel$export($3276e9745553f254$exports, "globalBorderRadius100", () => $3276e9745553f254$export$4e217f5c9e1d122e);
$parcel$export($3276e9745553f254$exports, "globalSize1", () => $3276e9745553f254$export$581a022593b37139);
$parcel$export($3276e9745553f254$exports, "globalSize2", () => $3276e9745553f254$export$6e08a028ea88caf);
$parcel$export($3276e9745553f254$exports, "globalSize3", () => $3276e9745553f254$export$9d565ea29b9d4e);
$parcel$export($3276e9745553f254$exports, "globalSize4", () => $3276e9745553f254$export$5aa522eb884d579d);
$parcel$export($3276e9745553f254$exports, "globalSize5", () => $3276e9745553f254$export$8820cb29c786d91f);
$parcel$export($3276e9745553f254$exports, "globalSize6", () => $3276e9745553f254$export$e76f8634e42fceed);
$parcel$export($3276e9745553f254$exports, "globalSize7", () => $3276e9745553f254$export$df367bbd8d048c14);
$parcel$export($3276e9745553f254$exports, "globalSize8", () => $3276e9745553f254$export$49513a9a59edd2fb);
$parcel$export($3276e9745553f254$exports, "globalSize9", () => $3276e9745553f254$export$ef900fdc121889a3);
$parcel$export($3276e9745553f254$exports, "globalSize10", () => $3276e9745553f254$export$83009f3ef2af8902);
$parcel$export($3276e9745553f254$exports, "globalSize11", () => $3276e9745553f254$export$e356db1a74a940f1);
$parcel$export($3276e9745553f254$exports, "globalSize12", () => $3276e9745553f254$export$633ffa248d03506c);
$parcel$export($3276e9745553f254$exports, "globalSize13", () => $3276e9745553f254$export$ff1746fd06dfef9c);
$parcel$export($3276e9745553f254$exports, "globalSize14", () => $3276e9745553f254$export$792f985e3c66b82b);
$parcel$export($3276e9745553f254$exports, "globalSize17", () => $3276e9745553f254$export$39757bd68ed58bc0);
$parcel$export($3276e9745553f254$exports, "globalSize44", () => $3276e9745553f254$export$5d4ece470da030c2);
$parcel$export($3276e9745553f254$exports, "globalSize69", () => $3276e9745553f254$export$e812c4b6a0d31e02);
$parcel$export($3276e9745553f254$exports, "globalSize75", () => $3276e9745553f254$export$1667f6759fd4af1f);
$parcel$export($3276e9745553f254$exports, "globalSize94", () => $3276e9745553f254$export$c79e5da71b43f2b7);
$parcel$export($3276e9745553f254$exports, "globalSize106", () => $3276e9745553f254$export$f09309c57f8ea8db);
$parcel$export($3276e9745553f254$exports, "globalSize144", () => $3276e9745553f254$export$3686e91ef2d1609b);
$parcel$export($3276e9745553f254$exports, "globalSize194", () => $3276e9745553f254$export$9a7d2330672d94da);
$parcel$export($3276e9745553f254$exports, "globalSize208", () => $3276e9745553f254$export$69191e5d8403f6dc);
$parcel$export($3276e9745553f254$exports, "globalSize320", () => $3276e9745553f254$export$c9bc626bcb9d1702);
$parcel$export($3276e9745553f254$exports, "globalSizeHalf", () => $3276e9745553f254$export$c2ebcb19507fa384);
$parcel$export($3276e9745553f254$exports, "globalSpace0", () => $3276e9745553f254$export$28af25853b30f1d5);
$parcel$export($3276e9745553f254$exports, "globalSpace1", () => $3276e9745553f254$export$cf8146011d39494a);
$parcel$export($3276e9745553f254$exports, "globalSpace2", () => $3276e9745553f254$export$eb07efa989de8fe5);
$parcel$export($3276e9745553f254$exports, "globalSpace3", () => $3276e9745553f254$export$bf79319657db0f88);
$parcel$export($3276e9745553f254$exports, "globalSpace4", () => $3276e9745553f254$export$5905f6dbe11e7b2c);
$parcel$export($3276e9745553f254$exports, "globalSpace5", () => $3276e9745553f254$export$dc0e9ba406ec1128);
$parcel$export($3276e9745553f254$exports, "globalSpace6", () => $3276e9745553f254$export$48cdf13b4cc5ad3f);
$parcel$export($3276e9745553f254$exports, "globalSpace7", () => $3276e9745553f254$export$cef3435710b52199);
$parcel$export($3276e9745553f254$exports, "globalSpace8", () => $3276e9745553f254$export$431b2083311a15ea);
$parcel$export($3276e9745553f254$exports, "globalSpace9", () => $3276e9745553f254$export$b098505ff1a5f952);
$parcel$export($3276e9745553f254$exports, "globalSpace10", () => $3276e9745553f254$export$d39e18acdfc94a45);
$parcel$export($3276e9745553f254$exports, "globalSpace11", () => $3276e9745553f254$export$4d09869bf749903e);
$parcel$export($3276e9745553f254$exports, "globalSpace12", () => $3276e9745553f254$export$8ea49e0388a60a62);
$parcel$export($3276e9745553f254$exports, "globalSpace13", () => $3276e9745553f254$export$6819254900b8d1cf);
$parcel$export($3276e9745553f254$exports, "globalSpace14", () => $3276e9745553f254$export$8b1552f580e06aac);
$parcel$export($3276e9745553f254$exports, "globalSpace15", () => $3276e9745553f254$export$f7e6e8df6820a759);
$parcel$export($3276e9745553f254$exports, "globalSpace16", () => $3276e9745553f254$export$6b78519ba1b56b20);
$parcel$export($3276e9745553f254$exports, "globalSpaceHalf", () => $3276e9745553f254$export$aa21579cea294b7a);
$parcel$export($3276e9745553f254$exports, "globalFontSize6", () => $3276e9745553f254$export$af88d6b81a19ff0a);
$parcel$export($3276e9745553f254$exports, "globalFontSize8", () => $3276e9745553f254$export$a7fa5cf4f467a7a3);
$parcel$export($3276e9745553f254$exports, "globalFontSize10", () => $3276e9745553f254$export$19e367993efb2a85);
$parcel$export($3276e9745553f254$exports, "globalFontSize12", () => $3276e9745553f254$export$c0dbfa2a9de4cf2b);
$parcel$export($3276e9745553f254$exports, "globalFontSize14", () => $3276e9745553f254$export$7db4d44897db3aae);
$parcel$export($3276e9745553f254$exports, "globalFontSize16", () => $3276e9745553f254$export$77fa12a7f6088e8a);
$parcel$export($3276e9745553f254$exports, "globalFontSize20", () => $3276e9745553f254$export$88f405f990d50798);
$parcel$export($3276e9745553f254$exports, "globalFontSize24", () => $3276e9745553f254$export$70eddb9c5b448a1e);
$parcel$export($3276e9745553f254$exports, "globalFontSize30", () => $3276e9745553f254$export$cfed16d4b5ca2dea);
$parcel$export($3276e9745553f254$exports, "globalFontSize40", () => $3276e9745553f254$export$1d5778bc4ba49de3);
$parcel$export($3276e9745553f254$exports, "globalFontSize50", () => $3276e9745553f254$export$6b8537e4a6c85699);
$parcel$export($3276e9745553f254$exports, "globalFontSize60", () => $3276e9745553f254$export$89c52c27197613ea);
$parcel$export($3276e9745553f254$exports, "globalFontSize70", () => $3276e9745553f254$export$a8475dc9cbba9136);
$parcel$export($3276e9745553f254$exports, "globalLetterSpacing0", () => $3276e9745553f254$export$287eb463b205f73b);
$parcel$export($3276e9745553f254$exports, "globalTextCaseNone", () => $3276e9745553f254$export$98aa6b13aaaaaed4);
$parcel$export($3276e9745553f254$exports, "globalTextDecorationNone", () => $3276e9745553f254$export$c3b12835a35a3ebc);
$parcel$export($3276e9745553f254$exports, "globalTextDecorationUnderline", () => $3276e9745553f254$export$78cf32b6248297d8);
$parcel$export($3276e9745553f254$exports, "globalBorderWidth0", () => $3276e9745553f254$export$90cf649d4bdde151);
$parcel$export($3276e9745553f254$exports, "globalBorderWidth1", () => $3276e9745553f254$export$8eed865464cb9443);
$parcel$export($3276e9745553f254$exports, "globalBorderWidth2", () => $3276e9745553f254$export$5d966ef1a668534d);
$parcel$export($3276e9745553f254$exports, "globalTeal10", () => $3276e9745553f254$export$1fde20e337d78057);
$parcel$export($3276e9745553f254$exports, "globalTeal20", () => $3276e9745553f254$export$8ab6bac2cfbaa311);
$parcel$export($3276e9745553f254$exports, "globalTeal30", () => $3276e9745553f254$export$7c3268c1e9449b23);
$parcel$export($3276e9745553f254$exports, "globalTeal40", () => $3276e9745553f254$export$ac2cb8d286cd282d);
$parcel$export($3276e9745553f254$exports, "globalTeal50", () => $3276e9745553f254$export$afe30047fb949ada);
$parcel$export($3276e9745553f254$exports, "globalTeal60", () => $3276e9745553f254$export$bedb631b11c40714);
$parcel$export($3276e9745553f254$exports, "globalTeal70", () => $3276e9745553f254$export$cbb4e1767cbcc295);
$parcel$export($3276e9745553f254$exports, "globalTeal80", () => $3276e9745553f254$export$1ea24c91b8d25363);
$parcel$export($3276e9745553f254$exports, "globalTeal90", () => $3276e9745553f254$export$e48c1ae9f703ec3);
$parcel$export($3276e9745553f254$exports, "globalLavendar10", () => $3276e9745553f254$export$3b66de443e6ecd2d);
$parcel$export($3276e9745553f254$exports, "globalLavendar20", () => $3276e9745553f254$export$d1b7eb4ab1109f37);
$parcel$export($3276e9745553f254$exports, "globalLavendar30", () => $3276e9745553f254$export$6fcf2bd98a8c3471);
$parcel$export($3276e9745553f254$exports, "globalLavendar40", () => $3276e9745553f254$export$854fd1fca212ac66);
$parcel$export($3276e9745553f254$exports, "globalLavendar50", () => $3276e9745553f254$export$94792cfe955edc7c);
$parcel$export($3276e9745553f254$exports, "globalLavendar60", () => $3276e9745553f254$export$a03199dd35bdd04c);
$parcel$export($3276e9745553f254$exports, "globalLavendar70", () => $3276e9745553f254$export$c2de267ef50b3959);
$parcel$export($3276e9745553f254$exports, "globalLavendar80", () => $3276e9745553f254$export$cbb9699552d08e72);
$parcel$export($3276e9745553f254$exports, "globalLavendar90", () => $3276e9745553f254$export$926bc41ea4705265);
$parcel$export($3276e9745553f254$exports, "globalLavendar92", () => $3276e9745553f254$export$654ed5d813f21dec);
$parcel$export($3276e9745553f254$exports, "globalFushia10", () => $3276e9745553f254$export$69f18349c11e1ae6);
$parcel$export($3276e9745553f254$exports, "globalFushia20", () => $3276e9745553f254$export$2ad4e0257e372740);
$parcel$export($3276e9745553f254$exports, "globalFushia30", () => $3276e9745553f254$export$e87f916bb6428820);
$parcel$export($3276e9745553f254$exports, "globalFushia40", () => $3276e9745553f254$export$c0c1b77517485090);
$parcel$export($3276e9745553f254$exports, "globalFushia50", () => $3276e9745553f254$export$8239eaa50a0a5f95);
$parcel$export($3276e9745553f254$exports, "globalFushia60", () => $3276e9745553f254$export$77be4f078e816c57);
$parcel$export($3276e9745553f254$exports, "globalFushia70", () => $3276e9745553f254$export$92d17db692dfdb26);
$parcel$export($3276e9745553f254$exports, "globalFushia80", () => $3276e9745553f254$export$198155ce03982d4b);
$parcel$export($3276e9745553f254$exports, "globalFushia90", () => $3276e9745553f254$export$1eaa04001df46302);
$parcel$export($3276e9745553f254$exports, "muiTeal15", () => $3276e9745553f254$export$46520cc5cc636d5);
$parcel$export($3276e9745553f254$exports, "muiTeal25", () => $3276e9745553f254$export$65b52ee8779cfb86);
$parcel$export($3276e9745553f254$exports, "muiTeal50", () => $3276e9745553f254$export$15103e7803509654);
$parcel$export($3276e9745553f254$exports, "muiTeal100", () => $3276e9745553f254$export$e1e0f831fb8ef956);
$parcel$export($3276e9745553f254$exports, "muiTeal400", () => $3276e9745553f254$export$cab8599dbbafe6f0);
$parcel$export($3276e9745553f254$exports, "muiTeal500", () => $3276e9745553f254$export$eb1ba29c8ee4ce89);
$parcel$export($3276e9745553f254$exports, "muiTeal600", () => $3276e9745553f254$export$b317de730274ad6d);
$parcel$export($3276e9745553f254$exports, "muiTeal700", () => $3276e9745553f254$export$688aa6f257feb3f4);
$parcel$export($3276e9745553f254$exports, "muiTeal800", () => $3276e9745553f254$export$5bb5e616682f7dfd);
$parcel$export($3276e9745553f254$exports, "muiTeal900", () => $3276e9745553f254$export$6f48b50d16c41924);
$parcel$export($3276e9745553f254$exports, "muiLavendar100", () => $3276e9745553f254$export$8658174a5a26d8c8);
$parcel$export($3276e9745553f254$exports, "muiLavendar200", () => $3276e9745553f254$export$94cf89e29828b90d);
$parcel$export($3276e9745553f254$exports, "muiLavendar300", () => $3276e9745553f254$export$fe800a881fbd2a17);
$parcel$export($3276e9745553f254$exports, "muiLavendar400", () => $3276e9745553f254$export$86e5c257800b1ba7);
$parcel$export($3276e9745553f254$exports, "muiLavendar500", () => $3276e9745553f254$export$efcc76822b16de0);
$parcel$export($3276e9745553f254$exports, "muiLavendar600", () => $3276e9745553f254$export$e35506918d293b2d);
$parcel$export($3276e9745553f254$exports, "muiLavendar700", () => $3276e9745553f254$export$b80547edfe0328fa);
$parcel$export($3276e9745553f254$exports, "muiLavendar800", () => $3276e9745553f254$export$6f80192eefeaa148);
$parcel$export($3276e9745553f254$exports, "muiLavendar900", () => $3276e9745553f254$export$8441530762eae6d3);
$parcel$export($3276e9745553f254$exports, "muiFushia100", () => $3276e9745553f254$export$90bc334d7aee9545);
$parcel$export($3276e9745553f254$exports, "muiFushia200", () => $3276e9745553f254$export$b3f1e6c576416c1d);
$parcel$export($3276e9745553f254$exports, "muiFushia300", () => $3276e9745553f254$export$191c88ebca6ffe3c);
$parcel$export($3276e9745553f254$exports, "muiFushia400", () => $3276e9745553f254$export$1f42ab64f4a83dee);
$parcel$export($3276e9745553f254$exports, "muiFushia500", () => $3276e9745553f254$export$5fb6a51ed9b33fd0);
$parcel$export($3276e9745553f254$exports, "muiFushia600", () => $3276e9745553f254$export$126413e9cf01d9cc);
$parcel$export($3276e9745553f254$exports, "muiFushia700", () => $3276e9745553f254$export$a335b1f360803681);
$parcel$export($3276e9745553f254$exports, "muiFushia800", () => $3276e9745553f254$export$21e31efc7bd30562);
$parcel$export($3276e9745553f254$exports, "muiFushia900", () => $3276e9745553f254$export$82bb60d82e157db1);
$parcel$export($3276e9745553f254$exports, "muiGreen50", () => $3276e9745553f254$export$b583fe876073a2fe);
$parcel$export($3276e9745553f254$exports, "muiGreen500", () => $3276e9745553f254$export$f4738750a09fc45);
$parcel$export($3276e9745553f254$exports, "muiGreen900", () => $3276e9745553f254$export$f892d1b579b087f5);
$parcel$export($3276e9745553f254$exports, "muiRed50", () => $3276e9745553f254$export$a7461ee647c93d00);
$parcel$export($3276e9745553f254$exports, "muiRed500", () => $3276e9745553f254$export$7a6939cbe6750292);
$parcel$export($3276e9745553f254$exports, "muiRed900", () => $3276e9745553f254$export$f13b4f317c31e202);
$parcel$export($3276e9745553f254$exports, "muiRedOrange50", () => $3276e9745553f254$export$466eea952b10a8df);
$parcel$export($3276e9745553f254$exports, "muiRedOrange100", () => $3276e9745553f254$export$3d73f527ec37353b);
$parcel$export($3276e9745553f254$exports, "muiRedOrange200", () => $3276e9745553f254$export$848d0b3dbc4a58e9);
$parcel$export($3276e9745553f254$exports, "muiRedOrange300", () => $3276e9745553f254$export$67c22c804a444617);
$parcel$export($3276e9745553f254$exports, "muiRedOrange500", () => $3276e9745553f254$export$35c178005989be85);
$parcel$export($3276e9745553f254$exports, "muiRedOrange900", () => $3276e9745553f254$export$d156763d5698483c);
$parcel$export($3276e9745553f254$exports, "muiInfoGray50", () => $3276e9745553f254$export$1f3e8d28a4bc8087);
$parcel$export($3276e9745553f254$exports, "muiInfoGray500", () => $3276e9745553f254$export$533189fca2ec5a05);
$parcel$export($3276e9745553f254$exports, "muiInfoGray900", () => $3276e9745553f254$export$9a0d26ed3c25e7f);
$parcel$export($3276e9745553f254$exports, "muiBlue50", () => $3276e9745553f254$export$732d133811ff729f);
$parcel$export($3276e9745553f254$exports, "muiBlue500", () => $3276e9745553f254$export$2dd034e8857d984e);
$parcel$export($3276e9745553f254$exports, "muiBlue700", () => $3276e9745553f254$export$83df2e97b19f7aba);
$parcel$export($3276e9745553f254$exports, "muiBlue800", () => $3276e9745553f254$export$e84284477477fbb0);
$parcel$export($3276e9745553f254$exports, "muiBlue900", () => $3276e9745553f254$export$94a8d52af3524619);
$parcel$export($3276e9745553f254$exports, "muiGray15", () => $3276e9745553f254$export$dde3540a7c52aa62);
$parcel$export($3276e9745553f254$exports, "muiGray20", () => $3276e9745553f254$export$60dd899fb1fc8ebb);
$parcel$export($3276e9745553f254$exports, "muiGray25", () => $3276e9745553f254$export$b44ed74ac6c5e0b1);
$parcel$export($3276e9745553f254$exports, "muiGray50", () => $3276e9745553f254$export$b45cfc1807a3979c);
$parcel$export($3276e9745553f254$exports, "muiGray100", () => $3276e9745553f254$export$20d695d1c7fa5d12);
$parcel$export($3276e9745553f254$exports, "muiGray200", () => $3276e9745553f254$export$93394257d70d9c4b);
$parcel$export($3276e9745553f254$exports, "muiGray300", () => $3276e9745553f254$export$6ead472efe5cccf9);
$parcel$export($3276e9745553f254$exports, "muiGray400", () => $3276e9745553f254$export$7345959dcc3f1249);
$parcel$export($3276e9745553f254$exports, "muiGray500", () => $3276e9745553f254$export$f6fc60ebb1f0098d);
$parcel$export($3276e9745553f254$exports, "muiGray600", () => $3276e9745553f254$export$bb9c92dcc503d041);
$parcel$export($3276e9745553f254$exports, "muiGray700", () => $3276e9745553f254$export$919b4cfa2a3431d7);
$parcel$export($3276e9745553f254$exports, "muiGray800", () => $3276e9745553f254$export$3a932b816df19cf9);
$parcel$export($3276e9745553f254$exports, "muiGray900", () => $3276e9745553f254$export$df6264b18306f8ce);
$parcel$export($3276e9745553f254$exports, "aliasesSizeMicro", () => $3276e9745553f254$export$5ccfbbfe47595323);
$parcel$export($3276e9745553f254$exports, "aliasesSizeXxs", () => $3276e9745553f254$export$20f5c07ae3856232);
$parcel$export($3276e9745553f254$exports, "aliasesSizeXs", () => $3276e9745553f254$export$c8bf6e81dacfc196);
$parcel$export($3276e9745553f254$exports, "aliasesSizeS", () => $3276e9745553f254$export$99f6d89f34a0b1a0);
$parcel$export($3276e9745553f254$exports, "aliasesSizeM", () => $3276e9745553f254$export$f2d0edabd04761fb);
$parcel$export($3276e9745553f254$exports, "aliasesSizeL", () => $3276e9745553f254$export$ed3a53feec192842);
$parcel$export($3276e9745553f254$exports, "aliasesSizeXl", () => $3276e9745553f254$export$8b69e23cdf44e5c4);
$parcel$export($3276e9745553f254$exports, "aliasesSizeXxl", () => $3276e9745553f254$export$a5fd793e6ae66615);
$parcel$export($3276e9745553f254$exports, "aliasesSizeInput", () => $3276e9745553f254$export$67b8da528429660d);
$parcel$export($3276e9745553f254$exports, "aliasesSizeWidthColumn1", () => $3276e9745553f254$export$4895d0896c23a35a);
$parcel$export($3276e9745553f254$exports, "aliasesSizeWidthColumn2", () => $3276e9745553f254$export$c97d64ed641c0c68);
$parcel$export($3276e9745553f254$exports, "aliasesSizeWidthColumn3", () => $3276e9745553f254$export$496884663027a953);
$parcel$export($3276e9745553f254$exports, "aliasesSizeWidthColumn4", () => $3276e9745553f254$export$942a8415fd3bc2bd);
$parcel$export($3276e9745553f254$exports, "aliasesSizeWidthColumn6", () => $3276e9745553f254$export$d4dcd3e7a9f00b00);
$parcel$export($3276e9745553f254$exports, "aliasesSizeWidthColumn8", () => $3276e9745553f254$export$ac6d8dd750e2b03d);
$parcel$export($3276e9745553f254$exports, "aliasesSizeWidthDesktopDefault", () => $3276e9745553f254$export$ea8e199042cb733d);
$parcel$export($3276e9745553f254$exports, "aliasesSizeHeightInputDense", () => $3276e9745553f254$export$9ec87d3ea06e00a5);
$parcel$export($3276e9745553f254$exports, "aliasesSizeHeightDesktopDefault", () => $3276e9745553f254$export$145590b199e7aa08);
$parcel$export($3276e9745553f254$exports, "aliasesSizeComponentXxl", () => $3276e9745553f254$export$ea53782885816cc4);
$parcel$export($3276e9745553f254$exports, "aliasesSizeComponentXl", () => $3276e9745553f254$export$88fccbab69a23b50);
$parcel$export($3276e9745553f254$exports, "aliasesSizeComponentM", () => $3276e9745553f254$export$aeea69d04d385bac);
$parcel$export($3276e9745553f254$exports, "aliasesSizeParticle", () => $3276e9745553f254$export$1eed320f6fa53669);
$parcel$export($3276e9745553f254$exports, "aliasesBorderWidthNone", () => $3276e9745553f254$export$170fa82b897b1027);
$parcel$export($3276e9745553f254$exports, "aliasesBorderWidthDefault", () => $3276e9745553f254$export$ce76584477c56c81);
$parcel$export($3276e9745553f254$exports, "aliasesBorderWidthThick", () => $3276e9745553f254$export$59d5e2224353c9c);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightCta", () => $3276e9745553f254$export$e878cf70517bf87d);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightAvatar", () => $3276e9745553f254$export$ca532bde8b673674);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightDefault", () => $3276e9745553f254$export$d35ad0b1db66aab);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightInput", () => $3276e9745553f254$export$2c081aeb7c8eb547);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightCaption", () => $3276e9745553f254$export$b538dbdb5cc993e2);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightMicro", () => $3276e9745553f254$export$12bd9cd6158eeaff);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightLabel", () => $3276e9745553f254$export$87d099ffe187ede3);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightH1", () => $3276e9745553f254$export$45a9411d397e7014);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightH2", () => $3276e9745553f254$export$6441942a9191e8b);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightH3", () => $3276e9745553f254$export$603bbc670bd6cdb7);
$parcel$export($3276e9745553f254$exports, "aliasesLineHeightH4", () => $3276e9745553f254$export$bd4d597b9a8478ef);
$parcel$export($3276e9745553f254$exports, "aliasesFontWeightDefault", () => $3276e9745553f254$export$33b4990036285dd4);
$parcel$export($3276e9745553f254$exports, "aliasesFontWeightNeutral", () => $3276e9745553f254$export$94b8628301cfeba5);
$parcel$export($3276e9745553f254$exports, "aliasesFontWeightEmphasis", () => $3276e9745553f254$export$4251501a1fd96031);
$parcel$export($3276e9745553f254$exports, "aliasesFontFamilyDefault", () => $3276e9745553f254$export$ec958139a7af2a8d);
$parcel$export($3276e9745553f254$exports, "aliasesFontFamilyHeader", () => $3276e9745553f254$export$dfce6fb8007da48e);
$parcel$export($3276e9745553f254$exports, "aliasesFontFamilyPromo", () => $3276e9745553f254$export$68b4938ddb45a8c0);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeMicro", () => $3276e9745553f254$export$da3bf13b0e78188e);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeLabel", () => $3276e9745553f254$export$93a0f9889d302d21);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeCaption", () => $3276e9745553f254$export$cd5e6a287e658e4b);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeDefault", () => $3276e9745553f254$export$694cbbfe937eb3b2);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeH1", () => $3276e9745553f254$export$249f366dc55631e7);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeH2", () => $3276e9745553f254$export$57fd85f0d54165d7);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeH3", () => $3276e9745553f254$export$17d746d2fa0f3e26);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeH4", () => $3276e9745553f254$export$6c499f1196becaca);
$parcel$export($3276e9745553f254$exports, "aliasesFontSizeDefaultSmall", () => $3276e9745553f254$export$45081f5919e907f9);
$parcel$export($3276e9745553f254$exports, "aliasesSpaceContainerDefault", () => $3276e9745553f254$export$ea858f460f740237);
$parcel$export($3276e9745553f254$exports, "aliasesSpaceContainerDense", () => $3276e9745553f254$export$4b9604858cc8bf9b);
$parcel$export($3276e9745553f254$exports, "aliasesSpaceContainerSpacious", () => $3276e9745553f254$export$5c216d07f6313f89);
$parcel$export($3276e9745553f254$exports, "aliasesSpaceComponentDefault", () => $3276e9745553f254$export$31bcbabf8dd2f068);
$parcel$export($3276e9745553f254$exports, "aliasesSpaceComponentSpacious", () => $3276e9745553f254$export$c18af1c576b9134e);
$parcel$export($3276e9745553f254$exports, "aliasesSpaceComponentDense", () => $3276e9745553f254$export$2139653de76670a8);
$parcel$export($3276e9745553f254$exports, "aliasesSpaceComponentParticle", () => $3276e9745553f254$export$1f8b3d352ce76e2);
$parcel$export($3276e9745553f254$exports, "aliasesBorderRadiusNone", () => $3276e9745553f254$export$da181d9bc79e4a02);
$parcel$export($3276e9745553f254$exports, "aliasesBorderRadiusSharp", () => $3276e9745553f254$export$6422537c35b745d9);
$parcel$export($3276e9745553f254$exports, "aliasesBorderRadiusDefault", () => $3276e9745553f254$export$e77925bd46d7e15b);
$parcel$export($3276e9745553f254$exports, "aliasesBorderRadiusRound", () => $3276e9745553f254$export$55ec15df2cced997);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries1Default", () => $3276e9745553f254$export$53dad9b8590b2590);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries1Hover", () => $3276e9745553f254$export$2cfa48c35037e4cd);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries1Focus", () => $3276e9745553f254$export$4cc965d0c8b21c5c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries1Selected", () => $3276e9745553f254$export$c5215a7e991b1930);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries1Transparent", () => $3276e9745553f254$export$11f329bcb8162d0d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries2Default", () => $3276e9745553f254$export$403b382cc6844409);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries2Hover", () => $3276e9745553f254$export$deda6d87d502e7b9);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries2Focus", () => $3276e9745553f254$export$c74f5a5b20d20e6a);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries2Selected", () => $3276e9745553f254$export$86b18e3169467eff);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries2Transparent", () => $3276e9745553f254$export$3558da976e5d4766);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries3Default", () => $3276e9745553f254$export$46db9a5b4fa29cdb);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries3Hover", () => $3276e9745553f254$export$c7ceda4e66b9f080);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries3Focus", () => $3276e9745553f254$export$fae84847465463d4);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries3Selected", () => $3276e9745553f254$export$d33af6c1185faec2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries3Transparent", () => $3276e9745553f254$export$7ced400057edeaf3);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries4Default", () => $3276e9745553f254$export$51494f3f5dc6cffe);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries4Hover", () => $3276e9745553f254$export$7f8f0ea50825a1b7);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries4Focus", () => $3276e9745553f254$export$833baa99ed859de5);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries4Selected", () => $3276e9745553f254$export$8662dc5f96d63e1c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries4Transparent", () => $3276e9745553f254$export$f5bf3b4e8e44efda);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries5Default", () => $3276e9745553f254$export$18adc08f697e50fe);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries5Hover", () => $3276e9745553f254$export$5e8722563ff0c000);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries5Focus", () => $3276e9745553f254$export$d00e843f86f2564a);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries5Selected", () => $3276e9745553f254$export$fa36bc78b7ce543e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries5Transparent", () => $3276e9745553f254$export$3f6119e89ab4de35);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries6Default", () => $3276e9745553f254$export$e0b0cb547b1f892d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries6Hover", () => $3276e9745553f254$export$927f064bc5b07bfa);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries6Focus", () => $3276e9745553f254$export$56f2d00a015cd7a8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries6Selected", () => $3276e9745553f254$export$8b59f2dc411c59d7);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries6Transparent", () => $3276e9745553f254$export$68d3bcba77d10f82);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries7Default", () => $3276e9745553f254$export$6ff7613d4c7aeb8d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries7Hover", () => $3276e9745553f254$export$a6d09535a6dea115);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries7Focus", () => $3276e9745553f254$export$5b5bdc2dd57fd7ee);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries7Selected", () => $3276e9745553f254$export$422c1cc49a17292a);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries7Transparent", () => $3276e9745553f254$export$8722d1c809de28b3);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries8Default", () => $3276e9745553f254$export$eb43764bdf88d057);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries8Hover", () => $3276e9745553f254$export$67a542d8cd9b82dd);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries8Focus", () => $3276e9745553f254$export$d1f88ead0dc7a304);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries8Selected", () => $3276e9745553f254$export$5038a7dd0a89c7d0);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSeries8Transparent", () => $3276e9745553f254$export$fb457f52cca97850);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentSubtleDefault", () => $3276e9745553f254$export$519809f976569692);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentSubtleHover", () => $3276e9745553f254$export$c584085d5ee8de76);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentSubtleFocus", () => $3276e9745553f254$export$a788d2961d748cde);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentSubtleSelectedDefault", () => $3276e9745553f254$export$e32ea0d81272e1b6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentSubtleSelectedHover", () => $3276e9745553f254$export$d8ae6269b02938b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentSubtleDisabled", () => $3276e9745553f254$export$2f14b841cad9c767);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentNeutralDefault", () => $3276e9745553f254$export$10519f8ccd4b0b86);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentNeutralHover", () => $3276e9745553f254$export$2fa9eeb6d8e51673);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentNeutralFocus", () => $3276e9745553f254$export$ed95ed13f2c03e16);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentNeutralSelectedDefault", () => $3276e9745553f254$export$1c9be6c6205a847b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentNeutralSelectedHover", () => $3276e9745553f254$export$8b5c10f16365778c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentNeutralDisabled", () => $3276e9745553f254$export$768c1cdce28e1d12);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentEmphasisDefault", () => $3276e9745553f254$export$1a1821660ba5e5fe);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentEmphasisHover", () => $3276e9745553f254$export$663065bf2da99939);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentEmphasisFocus", () => $3276e9745553f254$export$c914cb73d8ae4e4f);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentEmphasisSelectedDefault", () => $3276e9745553f254$export$2c74ca3559bf64f);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentEmphasisSelectedHover", () => $3276e9745553f254$export$72a1027e9ca37197);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveComponentEmphasisDisabled", () => $3276e9745553f254$export$3e018292749dd934);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerSubtleDefault", () => $3276e9745553f254$export$bb278ff9c8980518);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerSubtleHover", () => $3276e9745553f254$export$36eae0c7542b8f46);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerSubtleFocus", () => $3276e9745553f254$export$96674436714104a8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerSubtleSelectedDefault", () => $3276e9745553f254$export$a48b18644600cff8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerSubtleSelectedHover", () => $3276e9745553f254$export$32f93b6101bdc552);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerSubtleDisabled", () => $3276e9745553f254$export$2896c237a2e3e079);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerNeutralDefault", () => $3276e9745553f254$export$cc6fa3dd94433a27);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerNeutralHover", () => $3276e9745553f254$export$902237779564add5);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerNeutralFocus", () => $3276e9745553f254$export$df41c8766762ac09);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerNeutralSelectedDefault", () => $3276e9745553f254$export$3f5d1438f789e95b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerNeutralSelectedHover", () => $3276e9745553f254$export$47c3cd69e3cba602);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerNeutralDisabled", () => $3276e9745553f254$export$5e39dea751a8af3e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerEmphasisDefault", () => $3276e9745553f254$export$e5fda2d14bb87245);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerEmphasisHover", () => $3276e9745553f254$export$d6a62f44a4bb6848);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerEmphasisFocus", () => $3276e9745553f254$export$77499b6ac1d78be2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerEmphasisSelectedDefault", () => $3276e9745553f254$export$1961987bbf85bc69);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerEmphasisSelectedHover", () => $3276e9745553f254$export$f563e1c4b1dfe9b6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveContainerEmphasisDisabled", () => $3276e9745553f254$export$88019076f718435e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaSubtleDefault", () => $3276e9745553f254$export$4188c5dfbd960ff6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaSubtleHover", () => $3276e9745553f254$export$6f8b1b70dce4971d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaSubtleFocus", () => $3276e9745553f254$export$51c0a5205fae8605);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaSubtleSelectedDefault", () => $3276e9745553f254$export$e3efd006787060d7);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaSubtleSelectedHover", () => $3276e9745553f254$export$fd9c87bcf2280fcc);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaSubtleDisabled", () => $3276e9745553f254$export$33c2d8ee15842362);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaNeutralDefault", () => $3276e9745553f254$export$7d9f7647b114f0ff);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaNeutralHover", () => $3276e9745553f254$export$bee26b78d3246ede);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaNeutralFocus", () => $3276e9745553f254$export$844a6b198d459d4f);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaNeutralSelectedDefault", () => $3276e9745553f254$export$c32dfb5afe8442d2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaNeutralSelectedHover", () => $3276e9745553f254$export$8c54331216764c04);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaNeutralDisabled", () => $3276e9745553f254$export$ed179d6ea18a424b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaEmphasisDefault", () => $3276e9745553f254$export$a2b7d83a97c0807b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaEmphasisHover", () => $3276e9745553f254$export$75fdb7e4365aea69);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaEmphasisFocus", () => $3276e9745553f254$export$436333264dcf080c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaEmphasisSelectedDefault", () => $3276e9745553f254$export$48fdba70460beee3);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaEmphasisSelectedHover", () => $3276e9745553f254$export$a3db82021e9802c1);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInteractiveCtaEmphasisDisabled", () => $3276e9745553f254$export$17521d5649bf845b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderLogoPlatform", () => $3276e9745553f254$export$da7e305f941f7c1b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderLogoNetwork", () => $3276e9745553f254$export$98adb0276baaf8cf);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderLogoApp", () => $3276e9745553f254$export$8420ff989cc50c37);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderLogoData", () => $3276e9745553f254$export$b8a3bfa1fcd8dbc7);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderLogoEmail", () => $3276e9745553f254$export$c49e9b4e44fd796c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderStaticComponentSubtle", () => $3276e9745553f254$export$d51f08d8d0f3a9cc);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderStaticComponentNeutral", () => $3276e9745553f254$export$1bcabe1edda14f10);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderStaticComponentEmphasis", () => $3276e9745553f254$export$10d03502f2dd5cdd);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderStaticContainerSubtle", () => $3276e9745553f254$export$52269544c67eee3a);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderStaticContainerNeutral", () => $3276e9745553f254$export$368cb14eb84c724e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderStaticContainerEmphasis", () => $3276e9745553f254$export$976ab5bc3e192772);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderErrorSubtle", () => $3276e9745553f254$export$f32dfe87536251b0);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderErrorNeutral", () => $3276e9745553f254$export$f917c18e2c0733a2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderErrorEmphasis", () => $3276e9745553f254$export$37a2561e6f52f1a6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSuccessSubtle", () => $3276e9745553f254$export$757d1267e084d85e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSuccessNeutral", () => $3276e9745553f254$export$c96234e9ac3976aa);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderSuccessEmphasis", () => $3276e9745553f254$export$2ada4242418b1ab);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderWarningSubtle", () => $3276e9745553f254$export$88e8fc65e1dc8cfd);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderWarningNeutral", () => $3276e9745553f254$export$571330183a04a679);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderWarningEmphasis", () => $3276e9745553f254$export$e2364df1760c1cd2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInfoSubtle", () => $3276e9745553f254$export$88387c1fa4550702);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInfoNeutral", () => $3276e9745553f254$export$31154090c834e808);
$parcel$export($3276e9745553f254$exports, "aliasesColorBorderInfoEmphasis", () => $3276e9745553f254$export$fd57486f12ccccc7);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInteractiveSubtle", () => $3276e9745553f254$export$ce5dfe4e5b931e4a);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInteractiveNeutral", () => $3276e9745553f254$export$958169ac176093af);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInteractiveEmphasis", () => $3276e9745553f254$export$c3458d3269390c99);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInteractiveDisabled", () => $3276e9745553f254$export$f7e100eac7e2f133);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInteractiveSelected", () => $3276e9745553f254$export$95f6ec96cc827155);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInverseEmphasis", () => $3276e9745553f254$export$657174ec69a2226a);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInverseDisabled", () => $3276e9745553f254$export$e123307e2b218889);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInverseNeutral", () => $3276e9745553f254$export$7b91367d7e807812);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextInverseSubtle", () => $3276e9745553f254$export$aa6384fd68eb0d3b);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextStaticSubtle", () => $3276e9745553f254$export$3208e2036242c233);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextStaticNeutral", () => $3276e9745553f254$export$db305d4c182a82ff);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextStaticEmphasis", () => $3276e9745553f254$export$7641b4bffb9af953);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextStaticInverse", () => $3276e9745553f254$export$635aa5d463114b08);
$parcel$export($3276e9745553f254$exports, "aliasesColorTextError", () => $3276e9745553f254$export$e5149da9067fe611);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries1Default", () => $3276e9745553f254$export$a612632118a3b91b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries1Hover", () => $3276e9745553f254$export$465d16f3f0328e03);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries1Focus", () => $3276e9745553f254$export$e11a401a4e94968e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries1Selected", () => $3276e9745553f254$export$9d6422b3a72c759f);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries1Transparent", () => $3276e9745553f254$export$5b94bccbb3b2583c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries2Default", () => $3276e9745553f254$export$b8a531ce48f1ec30);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries2Hover", () => $3276e9745553f254$export$5d4a9c2be9f03907);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries2Focus", () => $3276e9745553f254$export$3a2e5b43fc49e678);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries2Selected", () => $3276e9745553f254$export$87ffd345b881d06e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries2Transparent", () => $3276e9745553f254$export$8827af02313fafc6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries3Default", () => $3276e9745553f254$export$63971f9c83d9fbd1);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries3Hover", () => $3276e9745553f254$export$15a94504af5cb48d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries3Focus", () => $3276e9745553f254$export$ea6f57adb3b615d1);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries3Selected", () => $3276e9745553f254$export$603bede8ed38ec7c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries3Transparent", () => $3276e9745553f254$export$96ad1ff12a5eae51);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries4Default", () => $3276e9745553f254$export$3435221529653182);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries4Hover", () => $3276e9745553f254$export$6140f2a94c436fb8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries4Focus", () => $3276e9745553f254$export$13e360d171ddb1b1);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries4Selected", () => $3276e9745553f254$export$bbdd1745b1aa2bfa);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries4Transparent", () => $3276e9745553f254$export$1efbfdbe33975e65);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries5Default", () => $3276e9745553f254$export$213e10a2fa7b8f25);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries5Hover", () => $3276e9745553f254$export$f04fa375e16b056f);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries5Focus", () => $3276e9745553f254$export$118e41f6ad7c84e4);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries5Selected", () => $3276e9745553f254$export$a61605328d84ff20);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries5Transparent", () => $3276e9745553f254$export$388c04cdf17d92da);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries6Default", () => $3276e9745553f254$export$9e8d2402ccd4d487);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries6Hover", () => $3276e9745553f254$export$8ce3c3b4e69389b3);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries6Focus", () => $3276e9745553f254$export$381431d7d1cd2cdc);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries6Selected", () => $3276e9745553f254$export$1d762aa2ded48ccc);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries6Transparent", () => $3276e9745553f254$export$ed777c3dad5075f6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries7Default", () => $3276e9745553f254$export$92428370c1b865ea);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries7Hover", () => $3276e9745553f254$export$ddd43daccf223f75);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries7Focus", () => $3276e9745553f254$export$dcaa98e9517a79a9);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries7Selected", () => $3276e9745553f254$export$c00fd98671d96e13);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries7Transparent", () => $3276e9745553f254$export$d2c685c01dd428bb);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries8Default", () => $3276e9745553f254$export$17ca6c34e71101c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries8Hover", () => $3276e9745553f254$export$71bc8e3929b67885);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries8Focus", () => $3276e9745553f254$export$18b5bb98b26a75b2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries8Selected", () => $3276e9745553f254$export$b8035dad7acff593);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSeries8Transparent", () => $3276e9745553f254$export$c8abfd1d22e0782b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticComponentSubtle", () => $3276e9745553f254$export$69ba8f43cf9bd6fd);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticComponentNeutral", () => $3276e9745553f254$export$f153d7318b9ac6c1);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticComponentEmphasis", () => $3276e9745553f254$export$32bb8f83e2da4eeb);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticComponentHighlightText", () => $3276e9745553f254$export$beed09ba17395fba);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticContainerSubtle", () => $3276e9745553f254$export$ddfa67e511d310a1);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticContainerNeutral", () => $3276e9745553f254$export$ef61afb4daed05b6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticContainerEmphasis", () => $3276e9745553f254$export$fcbf5251861df7b7);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgStaticContainerBackdrop", () => $3276e9745553f254$export$e24eb567fe502262);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgNavigationPrimary", () => $3276e9745553f254$export$fd7193dce715e7a5);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgNavigationSecondary", () => $3276e9745553f254$export$f7cd4529b55f6b65);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgErrorSubtle", () => $3276e9745553f254$export$32838d580212d33c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgErrorNeutral", () => $3276e9745553f254$export$9ebf7b0a2981f15);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgErrorEmphasis", () => $3276e9745553f254$export$4711b9c0f73c9e78);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSuccessSubtle", () => $3276e9745553f254$export$e70ad4174aad5efa);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSuccessNeutral", () => $3276e9745553f254$export$49814df222dc4e11);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgSuccessEmphasis", () => $3276e9745553f254$export$7cb8bf88d5994ac6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgWarningSubtle", () => $3276e9745553f254$export$9779a7bfc57f1d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgWarningNeutral", () => $3276e9745553f254$export$41cf31ff8fe14f06);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgWarningEmphasis", () => $3276e9745553f254$export$69315608b745ccef);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInfoSubtle", () => $3276e9745553f254$export$7d3fb3a82b27444e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInfoNeutral", () => $3276e9745553f254$export$e503fb06555d356c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInfoEmphasis", () => $3276e9745553f254$export$c2715a93ce37bb6d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentSubtleDefault", () => $3276e9745553f254$export$dd95d9725323abea);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentSubtleHover", () => $3276e9745553f254$export$57bc6d84deab957a);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentSubtleFocus", () => $3276e9745553f254$export$bdf5b9913bb4f3fa);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentSubtleSelectedDefault", () => $3276e9745553f254$export$3d257524dee43873);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentSubtleSelectedHover", () => $3276e9745553f254$export$4a362d83881d9a7d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentSubtleDisabled", () => $3276e9745553f254$export$3658abd53e71b73b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentNeutralDefault", () => $3276e9745553f254$export$80e05e6d32920b95);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentNeutralHover", () => $3276e9745553f254$export$f0f8c85d17a6904c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentNeutralFocus", () => $3276e9745553f254$export$df2dcd894d47df09);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentNeutralSelectedDefault", () => $3276e9745553f254$export$88f8e1485baa4c61);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentNeutralSelectedHover", () => $3276e9745553f254$export$668bd1b85a3e6315);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentNeutralDisabled", () => $3276e9745553f254$export$b8eccab39f3850b8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentEmphasisDefault", () => $3276e9745553f254$export$b5c855fae1b28ad6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentEmphasisHover", () => $3276e9745553f254$export$98f748c76bc6e5e6);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentEmphasisFocus", () => $3276e9745553f254$export$966ce69ea0b3158d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentEmphasisSelectedDefault", () => $3276e9745553f254$export$36bc118ab0edded);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentEmphasisSelectedHover", () => $3276e9745553f254$export$6fff8a90e8eb0eaa);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveComponentEmphasisDisabled", () => $3276e9745553f254$export$788186b488c86558);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerSubtleDefault", () => $3276e9745553f254$export$75d76cc6fcb941ac);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerSubtleHover", () => $3276e9745553f254$export$5112c48026e56c83);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerSubtleFocus", () => $3276e9745553f254$export$97166a6d3215a732);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerSubtleDisabled", () => $3276e9745553f254$export$ae48a1bc62abcfbb);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerSubtleSelectedDefault", () => $3276e9745553f254$export$6acdad347d3433d2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerSubtleSelectedHover", () => $3276e9745553f254$export$271026c4bdf43872);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerNeutralDefault", () => $3276e9745553f254$export$85cad9355d106745);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerNeutralHover", () => $3276e9745553f254$export$6f8939a00778a44b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerNeutralFocus", () => $3276e9745553f254$export$69c050e0055d47e7);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerNeutralDisabled", () => $3276e9745553f254$export$f36210171c60734d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerNeutralSelectedDefault", () => $3276e9745553f254$export$2d8338132c859946);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerNeutralSelectedHover", () => $3276e9745553f254$export$ab4bc868a0e35284);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerEmphasisDefault", () => $3276e9745553f254$export$ee107e86642de023);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerEmphasisHover", () => $3276e9745553f254$export$b44f568374a0ce0);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerEmphasisFocus", () => $3276e9745553f254$export$b6d257ffaa4da9c4);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerEmphasisDisabled", () => $3276e9745553f254$export$931ef32bb11eaa45);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerEmphasisSelectedDefault", () => $3276e9745553f254$export$21b30ac68ae47cd2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveContainerEmphasisSelectedHover", () => $3276e9745553f254$export$11b1d4709f91be43);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaSubtleDefault", () => $3276e9745553f254$export$37db67f42f3e4dd2);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaSubtleHover", () => $3276e9745553f254$export$c5e9d21ac7b68d10);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaSubtleFocus", () => $3276e9745553f254$export$77aba3a97c22e449);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaSubtleSelectedDefault", () => $3276e9745553f254$export$504e1687cbb53608);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaSubtleSelectedHover", () => $3276e9745553f254$export$239eed1838553c1d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaNeutralDefault", () => $3276e9745553f254$export$cecf34cd6f8888d8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaNeutralHover", () => $3276e9745553f254$export$bf3acb3c0b34a34);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaNeutralFocus", () => $3276e9745553f254$export$fed370744d8fbf8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaNeutralSelectedDefault", () => $3276e9745553f254$export$4cce883c26bd421b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaNeutralSelectedHover", () => $3276e9745553f254$export$2805e9aa6398e22d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaEmphasisDefault", () => $3276e9745553f254$export$e5398cdbb701916d);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaEmphasisHover", () => $3276e9745553f254$export$407c0a3360630f07);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaEmphasisFocus", () => $3276e9745553f254$export$2cf287a22961d257);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaEmphasisSelectedDefault", () => $3276e9745553f254$export$8d86b0a298b93d0c);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaEmphasisSelectedHover", () => $3276e9745553f254$export$98fe9911bf35517e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgInteractiveCtaDisabled", () => $3276e9745553f254$export$f0653913d522b4de);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoEmailDefault", () => $3276e9745553f254$export$dfbedab10da73342);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoEmailLight", () => $3276e9745553f254$export$80f74912e5e2c16e);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoNetwork", () => $3276e9745553f254$export$11b87b8556d144a8);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoAppDefault", () => $3276e9745553f254$export$380739dd5aaef19b);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoAppLight", () => $3276e9745553f254$export$d5620addd245919a);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoData", () => $3276e9745553f254$export$a86a694f71504589);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoTeeth", () => $3276e9745553f254$export$39d3aed953cc66e4);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoWords", () => $3276e9745553f254$export$2bc839ad86d92f97);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgLogoPlatform", () => $3276e9745553f254$export$4b18498d98ac2b51);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgPageDefault", () => $3276e9745553f254$export$bdac8b134e31bde5);
$parcel$export($3276e9745553f254$exports, "aliasesColorBgPageNeutral", () => $3276e9745553f254$export$66bda635f6f13030);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconStaticSubtle", () => $3276e9745553f254$export$91cc85ef8f880fbf);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconStaticNeutral", () => $3276e9745553f254$export$2567089c08d07145);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconStaticEmphasis", () => $3276e9745553f254$export$7ddc7da8e4aedbc9);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconErrorSubtle", () => $3276e9745553f254$export$e9ea731e72b3c68);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconErrorNeutral", () => $3276e9745553f254$export$ac8e94ba2c43a286);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconErrorEmphasis", () => $3276e9745553f254$export$9b91ce4791dbfb9c);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconSuccessSubtle", () => $3276e9745553f254$export$3ff48969c4a6b385);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconSuccessNeutral", () => $3276e9745553f254$export$b65cebe70ae8272a);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconSuccessEmphasis", () => $3276e9745553f254$export$fa75de9cd1d80d91);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconWarningSubtle", () => $3276e9745553f254$export$9abd6e64e952d3c8);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconWarningNeutral", () => $3276e9745553f254$export$a805ba38d5e6f41d);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconWarningEmphasis", () => $3276e9745553f254$export$659615cdef30be80);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInfoSubtle", () => $3276e9745553f254$export$82ba5e115e27104);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInfoNeutral", () => $3276e9745553f254$export$e248e6c7086b9196);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInfoEmphasis", () => $3276e9745553f254$export$4aea909045a919f3);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentSubtleDefault", () => $3276e9745553f254$export$24e2c3b0b0b39b6);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentSubtleHover", () => $3276e9745553f254$export$4cdd43377f390746);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentSubtleFocus", () => $3276e9745553f254$export$4c2aeb09e7af3558);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentSubtleSelectedDefault", () => $3276e9745553f254$export$6948447257b9a2fb);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentSubtleSelectedHover", () => $3276e9745553f254$export$1886d6bd011b2628);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentSubtleDisabled", () => $3276e9745553f254$export$6f0d3bd0748f7110);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentNeutralDefault", () => $3276e9745553f254$export$1cebc993b0830ad8);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentNeutralHover", () => $3276e9745553f254$export$94bf08336f2aea93);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentNeutralFocus", () => $3276e9745553f254$export$60462e192e7be598);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentNeutralSelectedDefault", () => $3276e9745553f254$export$c283bf52b1187f2a);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentNeutralSelectedHover", () => $3276e9745553f254$export$fa11560b88288866);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentNeutralDisabled", () => $3276e9745553f254$export$6fe67d097ba9b53b);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentEmphasisDefault", () => $3276e9745553f254$export$9346c9eb56618801);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentEmphasisHover", () => $3276e9745553f254$export$20a88bf6f5ad424);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentEmphasisFocus", () => $3276e9745553f254$export$3e11f9ae2b7c8b4);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentEmphasisSelectedDefault", () => $3276e9745553f254$export$1d4bdb103b271652);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentEmphasisSelectedHover", () => $3276e9745553f254$export$16fad6bc38b83523);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveComponentEmphasisDisabled", () => $3276e9745553f254$export$6facfb5bbfcbbdc1);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaSubtleDefault", () => $3276e9745553f254$export$68a1dda24af60fe8);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaSubtleHover", () => $3276e9745553f254$export$9cda72453ce995fe);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaSubtleFocus", () => $3276e9745553f254$export$976fb57d95041b2e);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaNeutralDefault", () => $3276e9745553f254$export$1d80e0b4ec3cdc88);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaNeutralHover", () => $3276e9745553f254$export$a47e91d4907d671b);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaNeutralFocus", () => $3276e9745553f254$export$51dfe56e558b3410);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaEmphasisDefault", () => $3276e9745553f254$export$cc6aa53aa44c8b12);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaEmphasisHover", () => $3276e9745553f254$export$428c93d8ee6b3f23);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaEmphasisFocus", () => $3276e9745553f254$export$3b660da25a4df7dd);
$parcel$export($3276e9745553f254$exports, "aliasesColorIconInteractiveCtaDisabled", () => $3276e9745553f254$export$1019c561a0c3d652);
$parcel$export($3276e9745553f254$exports, "aliasesColorIllustrationGreen", () => $3276e9745553f254$export$393ed899af66269a);
$parcel$export($3276e9745553f254$exports, "aliasesColorIllustrationBlue", () => $3276e9745553f254$export$2186267c9e4b9a19);
$parcel$export($3276e9745553f254$exports, "aliasesColorIllustrationGray", () => $3276e9745553f254$export$3c006b5b617326e6);
$parcel$export($3276e9745553f254$exports, "aliasesColorIllustrationDarkGray", () => $3276e9745553f254$export$17903f872c41d3f5);
$parcel$export($3276e9745553f254$exports, "aliasesColorIllustrationFushia", () => $3276e9745553f254$export$c8281b24d2fb2531);
$parcel$export($3276e9745553f254$exports, "aliasesColorIllustrationOrange", () => $3276e9745553f254$export$f4c54cb551b3e31a);
$parcel$export($3276e9745553f254$exports, "aliasesColorBarracudaBlue", () => $3276e9745553f254$export$e95975a74000e17d);
$parcel$export($3276e9745553f254$exports, "aliasesBoxShadowDefault", () => $3276e9745553f254$export$e306266450d339da);
$parcel$export($3276e9745553f254$exports, "aliasesBoxShadowFloating", () => $3276e9745553f254$export$c727a326e5ac158d);
$parcel$export($3276e9745553f254$exports, "aliasesBoxShadowTop", () => $3276e9745553f254$export$f124d9ef132d79f1);
$parcel$export($3276e9745553f254$exports, "aliasesLetterSpacingDefault", () => $3276e9745553f254$export$a6ed37d16e5c3592);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontWeightDefault", () => $3276e9745553f254$export$1e9bf329c53e42da);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontWeightNeutral", () => $3276e9745553f254$export$8cebf529bc3d12cd);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontWeightEmphasis", () => $3276e9745553f254$export$d554c99af2e8701d);
$parcel$export($3276e9745553f254$exports, "aliasesPromoLineHeightDefault", () => $3276e9745553f254$export$7711684ec178da45);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeMicro", () => $3276e9745553f254$export$85da697736c3f546);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeCaption", () => $3276e9745553f254$export$f6f08d75449b0f4f);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeDefault", () => $3276e9745553f254$export$32766a586f34b05b);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeH1", () => $3276e9745553f254$export$4ecde25fa2a16515);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeH2", () => $3276e9745553f254$export$ad3e07fd3f6eb5e9);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeH3", () => $3276e9745553f254$export$191898ea266c6db3);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeH4", () => $3276e9745553f254$export$f7668923bd63f908);
$parcel$export($3276e9745553f254$exports, "aliasesPromoFontSizeDefaultSmall", () => $3276e9745553f254$export$dc1063802be71f6b);
$parcel$export($3276e9745553f254$exports, "themes0Id", () => $3276e9745553f254$export$74a906d5f5dbcc07);
$parcel$export($3276e9745553f254$exports, "themes0Name", () => $3276e9745553f254$export$6012d36fd86dbaa1);
$parcel$export($3276e9745553f254$exports, "themes0SelectedTokenSetsGlobals", () => $3276e9745553f254$export$e24406150fd87290);
$parcel$export($3276e9745553f254$exports, "themes0SelectedTokenSetsAliases", () => $3276e9745553f254$export$83da2f3feb571776);
$parcel$export($3276e9745553f254$exports, "themes0SelectedTokenSetsComponentsButton", () => $3276e9745553f254$export$34e6b0c7073d1e27);
$parcel$export($3276e9745553f254$exports, "themes0Group", () => $3276e9745553f254$export$5b5ea24ad2da3b16);
$parcel$export($3276e9745553f254$exports, "themes1Id", () => $3276e9745553f254$export$bc9f2dd2aa337004);
$parcel$export($3276e9745553f254$exports, "themes1Name", () => $3276e9745553f254$export$a08a8107d9ea42d7);
$parcel$export($3276e9745553f254$exports, "themes1SelectedTokenSetsGlobals", () => $3276e9745553f254$export$3fddc94fd7344d3f);
$parcel$export($3276e9745553f254$exports, "themes1SelectedTokenSetsAliases", () => $3276e9745553f254$export$d54ad359440fed8a);
$parcel$export($3276e9745553f254$exports, "themes1SelectedTokenSetsVersionV1", () => $3276e9745553f254$export$7a5c093e8fbb816b);
$parcel$export($3276e9745553f254$exports, "themes1SelectedTokenSetsComponentsButton", () => $3276e9745553f254$export$ea9c28f9f25eee8d);
$parcel$export($3276e9745553f254$exports, "themes1Group", () => $3276e9745553f254$export$7a9d9e76d788a685);
$parcel$export($3276e9745553f254$exports, "metadataTokenSetOrder0", () => $3276e9745553f254$export$4caaeecf625325c);
$parcel$export($3276e9745553f254$exports, "metadataTokenSetOrder1", () => $3276e9745553f254$export$4db8b33a483c4b6a);
$parcel$export($3276e9745553f254$exports, "metadataTokenSetOrder2", () => $3276e9745553f254$export$517e517cddbb63e4);
$parcel$export($3276e9745553f254$exports, "metadataTokenSetOrder3", () => $3276e9745553f254$export$94e839db223f2b32);
$parcel$export($3276e9745553f254$exports, "avatarRadiusRound", () => $3276e9745553f254$export$45f9825089601438);
$parcel$export($3276e9745553f254$exports, "avatarSizeS", () => $3276e9745553f254$export$6ced2fe9225bb9aa);
$parcel$export($3276e9745553f254$exports, "avatarSizeM", () => $3276e9745553f254$export$ad9035b90a500e0c);
$parcel$export($3276e9745553f254$exports, "avatarSizeL", () => $3276e9745553f254$export$981c98b80c296cae);
$parcel$export($3276e9745553f254$exports, "avatarSizeXl", () => $3276e9745553f254$export$6a70aa95d5f9e97d);
$parcel$export($3276e9745553f254$exports, "avatarSizeXxl", () => $3276e9745553f254$export$77fc7cdd633e321a);
$parcel$export($3276e9745553f254$exports, "avatarColorBgStaticSubtle", () => $3276e9745553f254$export$1d1ba85af9737700);
$parcel$export($3276e9745553f254$exports, "avatarColorBgStaticNeutral", () => $3276e9745553f254$export$9fdcda1e888251ae);
$parcel$export($3276e9745553f254$exports, "avatarColorBgStaticEmphasis", () => $3276e9745553f254$export$6e683eae248849d0);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveSubtleDefault", () => $3276e9745553f254$export$10b711493a3d638d);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveSubtleHover", () => $3276e9745553f254$export$ec4efc0809296020);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveSubtleFocus", () => $3276e9745553f254$export$574ca15a0c69dfed);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$6711cc6f6a8d7622);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$ee901060a5d95972);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveNeutralDefault", () => $3276e9745553f254$export$2eec97a97f2e4a04);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveNeutralHover", () => $3276e9745553f254$export$6a4c73b3b1874b99);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveNeutralFocus", () => $3276e9745553f254$export$f99fb7f220239678);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$74c23d76a5361d79);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$39fbb811f7522b8b);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveEmphasisDefault", () => $3276e9745553f254$export$acc506ad42389b36);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveEmphasisHover", () => $3276e9745553f254$export$3afd9cf193dbcb8a);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveEmphasisFocus", () => $3276e9745553f254$export$56a3bdf7d0fec618);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$9fe0f766dfd77681);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$51dff143e21603dd);
$parcel$export($3276e9745553f254$exports, "avatarColorBgInteractiveDisabled", () => $3276e9745553f254$export$b8cb6cd9a5387463);
$parcel$export($3276e9745553f254$exports, "avatarColorTextStaticSubtle", () => $3276e9745553f254$export$47e4978834ae40f7);
$parcel$export($3276e9745553f254$exports, "avatarColorTextStaticNeutral", () => $3276e9745553f254$export$a0e30118ba19fdb2);
$parcel$export($3276e9745553f254$exports, "avatarColorTextStaticEmphasis", () => $3276e9745553f254$export$2e98f00d0fa4bbb5);
$parcel$export($3276e9745553f254$exports, "avatarColorTextInteractiveSubtle", () => $3276e9745553f254$export$2b24a45f4e35892b);
$parcel$export($3276e9745553f254$exports, "avatarColorTextInteractiveNeutral", () => $3276e9745553f254$export$d948f9b072d01bf6);
$parcel$export($3276e9745553f254$exports, "avatarColorTextInteractiveEmphasis", () => $3276e9745553f254$export$fa82cf28ab34d28a);
$parcel$export($3276e9745553f254$exports, "avatarColorTextInteractiveDisabled", () => $3276e9745553f254$export$7b24fd576331fa4c);
$parcel$export($3276e9745553f254$exports, "avatarColorTextInteractiveSelected", () => $3276e9745553f254$export$4140cf203c357f02);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderStaticSubtle", () => $3276e9745553f254$export$35c34a4e0cfbe353);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderStaticNeutral", () => $3276e9745553f254$export$befa38c6db1cdb2d);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderStaticEmphasis", () => $3276e9745553f254$export$ac967ae90cf75bdb);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveSubtleDefault", () => $3276e9745553f254$export$ece26edc7f0c4ee3);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveSubtleHover", () => $3276e9745553f254$export$e06caac82792110c);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveSubtleFocus", () => $3276e9745553f254$export$874db53a16e8eca6);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$6996388cacfbc1c3);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$58bec168ef844174);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveNeutralDefault", () => $3276e9745553f254$export$d023e2e28c239369);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveNeutralHover", () => $3276e9745553f254$export$946657d96f7f365c);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveNeutralFocus", () => $3276e9745553f254$export$c56ab0b862450b50);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$b2a4c668920d7f26);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$bb6b9403ea569251);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveEmphasisDefault", () => $3276e9745553f254$export$ef1d10df2c03313a);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveEmphasisHover", () => $3276e9745553f254$export$ef737f5bf427c63b);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveEmphasisFocus", () => $3276e9745553f254$export$ae2775de35439b9a);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$fde44b974502cb1);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$654e39841159fe7e);
$parcel$export($3276e9745553f254$exports, "avatarColorBorderInteractiveDisabled", () => $3276e9745553f254$export$978e747ab676585c);
$parcel$export($3276e9745553f254$exports, "avatarBorderWidthDefault", () => $3276e9745553f254$export$2817c40e512049d4);
$parcel$export($3276e9745553f254$exports, "avatarFontFamily", () => $3276e9745553f254$export$8b50ef9dd01b2896);
$parcel$export($3276e9745553f254$exports, "avatarFontWeight", () => $3276e9745553f254$export$4ee7b06916c5d942);
$parcel$export($3276e9745553f254$exports, "avatarFontSizeS", () => $3276e9745553f254$export$add9cf0f5be45bb8);
$parcel$export($3276e9745553f254$exports, "avatarFontSizeM", () => $3276e9745553f254$export$c13fb80f73bb5bf5);
$parcel$export($3276e9745553f254$exports, "avatarFontSizeL", () => $3276e9745553f254$export$36412f0eae9884ab);
$parcel$export($3276e9745553f254$exports, "avatarFontSizeXl", () => $3276e9745553f254$export$9cb266ece8c6e780);
$parcel$export($3276e9745553f254$exports, "avatarFontSizeXxl", () => $3276e9745553f254$export$602010da7f82ff85);
$parcel$export($3276e9745553f254$exports, "avatarLetterSpacing", () => $3276e9745553f254$export$72007b6cbdda6c3a);
$parcel$export($3276e9745553f254$exports, "avatarTextCase", () => $3276e9745553f254$export$23b25f54fea3af4);
$parcel$export($3276e9745553f254$exports, "avatarLineHeightXxl", () => $3276e9745553f254$export$b525723c9c0fd3c2);
$parcel$export($3276e9745553f254$exports, "avatarLineHeightXl", () => $3276e9745553f254$export$a18ab4cbed1e3c31);
$parcel$export($3276e9745553f254$exports, "avatarLineHeightL", () => $3276e9745553f254$export$5e96e02743466c31);
$parcel$export($3276e9745553f254$exports, "avatarLineHeightM", () => $3276e9745553f254$export$7f7949c1794c1d34);
$parcel$export($3276e9745553f254$exports, "avatarLineHeightS", () => $3276e9745553f254$export$4f23447d88eaec3f);
$parcel$export($3276e9745553f254$exports, "avatarTextDecoration", () => $3276e9745553f254$export$cd07715ef04b96c9);
$parcel$export($3276e9745553f254$exports, "buttonBorderWidth", () => $3276e9745553f254$export$83047dd36262cb15);
$parcel$export($3276e9745553f254$exports, "buttonPadding", () => $3276e9745553f254$export$767b378a40c983d0);
$parcel$export($3276e9745553f254$exports, "buttonSpaceBetween", () => $3276e9745553f254$export$1ff376c9f129fe57);
$parcel$export($3276e9745553f254$exports, "buttonRadius", () => $3276e9745553f254$export$30a853f502f9e2c7);
$parcel$export($3276e9745553f254$exports, "buttonHeightDefault", () => $3276e9745553f254$export$b67be69c900ea369);
$parcel$export($3276e9745553f254$exports, "buttonColorBgActionBarDefault", () => $3276e9745553f254$export$f587156ff808181d);
$parcel$export($3276e9745553f254$exports, "buttonColorBgActionBarHover", () => $3276e9745553f254$export$fd9d81e02468cf0c);
$parcel$export($3276e9745553f254$exports, "buttonColorBgActionBarFocus", () => $3276e9745553f254$export$8684d5dfbbea5f2b);
$parcel$export($3276e9745553f254$exports, "buttonColorBgSubtleDefault", () => $3276e9745553f254$export$be8971e457224a5a);
$parcel$export($3276e9745553f254$exports, "buttonColorBgSubtleHover", () => $3276e9745553f254$export$8f6cc8879d3d37c4);
$parcel$export($3276e9745553f254$exports, "buttonColorBgSubtleFocus", () => $3276e9745553f254$export$e448803c843846e5);
$parcel$export($3276e9745553f254$exports, "buttonColorBgSubtleSelectedDefault", () => $3276e9745553f254$export$897cdcc0c18bc5db);
$parcel$export($3276e9745553f254$exports, "buttonColorBgSubtleSelectedHover", () => $3276e9745553f254$export$e06d5ee5e53edb47);
$parcel$export($3276e9745553f254$exports, "buttonColorBgNeutralDefault", () => $3276e9745553f254$export$699fab328727c6b6);
$parcel$export($3276e9745553f254$exports, "buttonColorBgNeutralHover", () => $3276e9745553f254$export$3c0ad4fb3a1b0ffb);
$parcel$export($3276e9745553f254$exports, "buttonColorBgNeutralFocus", () => $3276e9745553f254$export$5966559b892ee111);
$parcel$export($3276e9745553f254$exports, "buttonColorBgNeutralSelectedDefault", () => $3276e9745553f254$export$1b08e227e9d667a9);
$parcel$export($3276e9745553f254$exports, "buttonColorBgNeutralSelectedHover", () => $3276e9745553f254$export$7179773622cad25f);
$parcel$export($3276e9745553f254$exports, "buttonColorBgEmphasisDefault", () => $3276e9745553f254$export$bdf7ce7eb3df6341);
$parcel$export($3276e9745553f254$exports, "buttonColorBgEmphasisHover", () => $3276e9745553f254$export$5b8cb27bcb201dc4);
$parcel$export($3276e9745553f254$exports, "buttonColorBgEmphasisFocus", () => $3276e9745553f254$export$3f3dc155ded54e45);
$parcel$export($3276e9745553f254$exports, "buttonColorBgEmphasisSelectedDefault", () => $3276e9745553f254$export$ba27deb6cad88273);
$parcel$export($3276e9745553f254$exports, "buttonColorBgEmphasisSelectedHover", () => $3276e9745553f254$export$456505b8367dc33a);
$parcel$export($3276e9745553f254$exports, "buttonColorBgDisabled", () => $3276e9745553f254$export$eedcb4b10d336c0);
$parcel$export($3276e9745553f254$exports, "buttonColorTextActionBar", () => $3276e9745553f254$export$ff1075fa496d325b);
$parcel$export($3276e9745553f254$exports, "buttonColorTextSubtle", () => $3276e9745553f254$export$a7456311bf695db4);
$parcel$export($3276e9745553f254$exports, "buttonColorTextNeutral", () => $3276e9745553f254$export$cd05d22763540ee7);
$parcel$export($3276e9745553f254$exports, "buttonColorTextEmphasis", () => $3276e9745553f254$export$a8af6e0b3bb0ceab);
$parcel$export($3276e9745553f254$exports, "buttonColorTextDisabled", () => $3276e9745553f254$export$ea642331f78f7724);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderActionBarDefault", () => $3276e9745553f254$export$7c9eeddcc0155611);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderActionBarHover", () => $3276e9745553f254$export$70b98ceba2109d6f);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderActionBarFocus", () => $3276e9745553f254$export$32adc8c8c23f8278);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderSubtleDefault", () => $3276e9745553f254$export$53894d17111f8e4e);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderSubtleHover", () => $3276e9745553f254$export$5bee99e492dce333);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderSubtleFocus", () => $3276e9745553f254$export$4552f038cdc313b1);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderSubtleSelectedDefault", () => $3276e9745553f254$export$cbf4404a4e15c5e7);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderSubtleSelectedHover", () => $3276e9745553f254$export$23117a1b4fa2ee4a);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderNeutralDefault", () => $3276e9745553f254$export$6df9b51adfe2c892);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderNeutralHover", () => $3276e9745553f254$export$5c93c9fbb78bb2c1);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderNeutralFocus", () => $3276e9745553f254$export$e1ce320d9ab1c61);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderNeutralSelectedDefault", () => $3276e9745553f254$export$7940fcec187cb2bd);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderNeutralSelectedHover", () => $3276e9745553f254$export$d8345d4ed478774c);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderEmphasisDefault", () => $3276e9745553f254$export$68249f79b2b24f73);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderEmphasisHover", () => $3276e9745553f254$export$9ead9293289737ba);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderEmphasisFocus", () => $3276e9745553f254$export$95454f0202b5bb8a);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderEmphasisSelectedDefault", () => $3276e9745553f254$export$6f2a28348f849e77);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderEmphasisSelectedHover", () => $3276e9745553f254$export$9cc1a66c6e1f0d4d);
$parcel$export($3276e9745553f254$exports, "buttonColorBorderDisabled", () => $3276e9745553f254$export$3175a605e0140911);
$parcel$export($3276e9745553f254$exports, "buttonSplitWidth", () => $3276e9745553f254$export$ab123ccff6e55a0b);
$parcel$export($3276e9745553f254$exports, "buttonFontFamily", () => $3276e9745553f254$export$76ef6df3b64524e8);
$parcel$export($3276e9745553f254$exports, "buttonFontWeight", () => $3276e9745553f254$export$eb9380587111f46e);
$parcel$export($3276e9745553f254$exports, "buttonLineHeight", () => $3276e9745553f254$export$ca8181fe2475a0ce);
$parcel$export($3276e9745553f254$exports, "buttonFontSize", () => $3276e9745553f254$export$b37e6f1e35b3e7ab);
$parcel$export($3276e9745553f254$exports, "buttonLetterSpacing", () => $3276e9745553f254$export$8adee4da5958a9ec);
$parcel$export($3276e9745553f254$exports, "iconButtonBorderWidth", () => $3276e9745553f254$export$b0a94bcb8b47f8b5);
$parcel$export($3276e9745553f254$exports, "iconButtonSizeRoundM", () => $3276e9745553f254$export$e4b49656504a3957);
$parcel$export($3276e9745553f254$exports, "iconButtonSizeRoundInput", () => $3276e9745553f254$export$fe4627f581df3f54);
$parcel$export($3276e9745553f254$exports, "iconButtonSizeRectangleDefaultWidth", () => $3276e9745553f254$export$9b864bc8d5db3c7a);
$parcel$export($3276e9745553f254$exports, "iconButtonSizeRectangleDefaultHeight", () => $3276e9745553f254$export$3829a6ec50c0f791);
$parcel$export($3276e9745553f254$exports, "iconButtonRadiusRound", () => $3276e9745553f254$export$f4dfab5fdc242b93);
$parcel$export($3276e9745553f254$exports, "iconButtonRadiusRectangle", () => $3276e9745553f254$export$56f84bc94a249aaf);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBgSubtleDefault", () => $3276e9745553f254$export$b2a7f6dedbe8d4ae);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBgSubtleHover", () => $3276e9745553f254$export$7f5bb126a7ea906a);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBgSubtleFocus", () => $3276e9745553f254$export$e58f39eec65e0b76);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBgSubtleSelectedDefault", () => $3276e9745553f254$export$20360ceefb533fb);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBgSubtleSelectedHover", () => $3276e9745553f254$export$ea569fd99f87a06a);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBgSubtleMenuOpen", () => $3276e9745553f254$export$1c5e5838d4e8eebe);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBgDisabled", () => $3276e9745553f254$export$e79da0208dc75992);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBorderSubtleDefault", () => $3276e9745553f254$export$5ab048a991219b8c);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBorderSubtleHover", () => $3276e9745553f254$export$e5c0a5d226b4ee63);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBorderSubtleFocus", () => $3276e9745553f254$export$b06fab23153184d6);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBorderSubtleSelectedDefault", () => $3276e9745553f254$export$71ddb8bc4376788d);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBorderSubtleSelectedHover", () => $3276e9745553f254$export$67f367c1dfd5d3b7);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBorderSubtleMenuOpen", () => $3276e9745553f254$export$8d6c6c1bd7814c60);
$parcel$export($3276e9745553f254$exports, "iconButtonColorBorderDisabled", () => $3276e9745553f254$export$f67dcf708fbd73bc);
$parcel$export($3276e9745553f254$exports, "iconButtonColorTextDefault", () => $3276e9745553f254$export$a805ee3abb44f47b);
$parcel$export($3276e9745553f254$exports, "iconButtonColorTextSelected", () => $3276e9745553f254$export$7eb6272929988e2e);
$parcel$export($3276e9745553f254$exports, "iconButtonColorTextDisabled", () => $3276e9745553f254$export$4b09028d2528773c);
$parcel$export($3276e9745553f254$exports, "iconButtonSpaceBetween", () => $3276e9745553f254$export$db838e84dd688c76);
$parcel$export($3276e9745553f254$exports, "tooltipBorderWidth", () => $3276e9745553f254$export$ae915504e2a18be8);
$parcel$export($3276e9745553f254$exports, "tooltipRadius", () => $3276e9745553f254$export$a65645ba055136c8);
$parcel$export($3276e9745553f254$exports, "tooltipColorBg", () => $3276e9745553f254$export$838104e21ca5a19d);
$parcel$export($3276e9745553f254$exports, "tooltipColorBorder", () => $3276e9745553f254$export$4bb2a4cc71915256);
$parcel$export($3276e9745553f254$exports, "tooltipColorText", () => $3276e9745553f254$export$b2e919a6cbfe006e);
$parcel$export($3276e9745553f254$exports, "tooltipFontFamily", () => $3276e9745553f254$export$6e404c3c9be4c803);
$parcel$export($3276e9745553f254$exports, "tooltipFontWeight", () => $3276e9745553f254$export$341f3e22d85f986b);
$parcel$export($3276e9745553f254$exports, "tooltipLineHeight", () => $3276e9745553f254$export$9d1c9df76b2ad44b);
$parcel$export($3276e9745553f254$exports, "tooltipFontSize", () => $3276e9745553f254$export$ef0c0a0e1df557cc);
$parcel$export($3276e9745553f254$exports, "tooltipLetterSpacing", () => $3276e9745553f254$export$9d6da21b7f25ba42);
$parcel$export($3276e9745553f254$exports, "tooltipPadding", () => $3276e9745553f254$export$586ef59e988cd548);
$parcel$export($3276e9745553f254$exports, "chipRadiusRound", () => $3276e9745553f254$export$e4bf6f69d8b12729);
$parcel$export($3276e9745553f254$exports, "chipBorderWidth", () => $3276e9745553f254$export$91a69802d20d599b);
$parcel$export($3276e9745553f254$exports, "chipSizeMediumHeight", () => $3276e9745553f254$export$ad14861617df4437);
$parcel$export($3276e9745553f254$exports, "chipSizeMediumPaddingRight", () => $3276e9745553f254$export$c414cba53d02ca20);
$parcel$export($3276e9745553f254$exports, "chipSizeMediumPaddingLeft", () => $3276e9745553f254$export$947eaeddfab43373);
$parcel$export($3276e9745553f254$exports, "chipSizeMediumSpaceBetween", () => $3276e9745553f254$export$9588b2e0bbc9d556);
$parcel$export($3276e9745553f254$exports, "chipSizeLargeHeight", () => $3276e9745553f254$export$fed9a8adb39d758b);
$parcel$export($3276e9745553f254$exports, "chipSizeLargePaddingRight", () => $3276e9745553f254$export$c0f556b14789c4e6);
$parcel$export($3276e9745553f254$exports, "chipSizeLargePaddingLeft", () => $3276e9745553f254$export$d1639dad04ad0547);
$parcel$export($3276e9745553f254$exports, "chipSizeLargeSpaceBetween", () => $3276e9745553f254$export$baed45022e2a7982);
$parcel$export($3276e9745553f254$exports, "chipSizeInputHeight", () => $3276e9745553f254$export$4b76f39175f0013d);
$parcel$export($3276e9745553f254$exports, "chipSizeInputPaddingRight", () => $3276e9745553f254$export$628b4df0a363bf4d);
$parcel$export($3276e9745553f254$exports, "chipSizeInputPaddingLeft", () => $3276e9745553f254$export$2a0954c14d67929d);
$parcel$export($3276e9745553f254$exports, "chipSizeInputSpaceBetween", () => $3276e9745553f254$export$5d1500b4a57cc110);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticSubtle", () => $3276e9745553f254$export$78bb03c5be80436c);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticNeutralDefault", () => $3276e9745553f254$export$54f70ca93c994d78);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticNeutralSuccess", () => $3276e9745553f254$export$e3dd8acf7e47031b);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticNeutralError", () => $3276e9745553f254$export$e43bff698a8dfbad);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticNeutralWarning", () => $3276e9745553f254$export$6bcfcd9223df7e6);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticNeutralInfo", () => $3276e9745553f254$export$aaaa141d9a4271b6);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticEmphasisDefault", () => $3276e9745553f254$export$4550c5abe1916743);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticEmphasisSuccess", () => $3276e9745553f254$export$33de5d52a40c74bb);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticEmphasisError", () => $3276e9745553f254$export$c0ad38910caef39d);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticEmphasisWarning", () => $3276e9745553f254$export$18afb996161fdda8);
$parcel$export($3276e9745553f254$exports, "chipColorBgStaticEmphasisInfo", () => $3276e9745553f254$export$58d9b7589ec1b854);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveSubtleDefault", () => $3276e9745553f254$export$19919b03e06ddb93);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveSubtleHover", () => $3276e9745553f254$export$67b5c40e6559a7fa);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveSubtleFocus", () => $3276e9745553f254$export$12e1be37fde3ea72);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$db84367af70c1ff1);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$37249a3917b3b82f);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveNeutralDefault", () => $3276e9745553f254$export$79a5f596c2b0cc25);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveNeutralHover", () => $3276e9745553f254$export$6e18cdfeccbbdb23);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveNeutralFocus", () => $3276e9745553f254$export$a3551c8ced99a9a);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$79335b67bc26b821);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$3c8142e1e0fc9733);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveEmphasisDefault", () => $3276e9745553f254$export$10b174a9def6dceb);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveEmphasisHover", () => $3276e9745553f254$export$7a2ceca8767416a5);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveEmphasisFocus", () => $3276e9745553f254$export$56db8ce29b377bf2);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$6a6a3e2cab1bed3b);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$f8d99fb64297e05a);
$parcel$export($3276e9745553f254$exports, "chipColorBgInteractiveDisabled", () => $3276e9745553f254$export$cbeaf87373b45488);
$parcel$export($3276e9745553f254$exports, "chipColorTextErrorSubtle", () => $3276e9745553f254$export$a676f817d02f5209);
$parcel$export($3276e9745553f254$exports, "chipColorTextStaticSubtle", () => $3276e9745553f254$export$82be0988c2118f7e);
$parcel$export($3276e9745553f254$exports, "chipColorTextStaticEmphasis", () => $3276e9745553f254$export$d6f0695b99884305);
$parcel$export($3276e9745553f254$exports, "chipColorTextStaticNeutral", () => $3276e9745553f254$export$407dd87d92a51f47);
$parcel$export($3276e9745553f254$exports, "chipColorTextInteractiveNeutral", () => $3276e9745553f254$export$57b0941f92173029);
$parcel$export($3276e9745553f254$exports, "chipColorTextInteractiveSubtle", () => $3276e9745553f254$export$e93aa21fc073fa41);
$parcel$export($3276e9745553f254$exports, "chipColorTextInteractiveEmphasis", () => $3276e9745553f254$export$7ea48ba511b9e63e);
$parcel$export($3276e9745553f254$exports, "chipColorTextInteractiveSelected", () => $3276e9745553f254$export$43c8f926529b7e18);
$parcel$export($3276e9745553f254$exports, "chipColorTextDisabled", () => $3276e9745553f254$export$ca3865d8ffc5952f);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticSubtle", () => $3276e9745553f254$export$90683711fb4bef81);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticNeutralDefault", () => $3276e9745553f254$export$752f6974143a52ba);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticNeutralError", () => $3276e9745553f254$export$5008f618d8345a67);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticNeutralSuccess", () => $3276e9745553f254$export$44eb3b115a64f132);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticNeutralWarning", () => $3276e9745553f254$export$de064229fcb5defa);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticNeutralInfo", () => $3276e9745553f254$export$b0165922ab633327);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticEmphasisDefault", () => $3276e9745553f254$export$6f0b9975e44923c9);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticEmphasisSuccess", () => $3276e9745553f254$export$fc194a85a504f3c9);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticEmphasisWarning", () => $3276e9745553f254$export$da7c568ac2dab421);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticEmphasisError", () => $3276e9745553f254$export$f735272da4d7b070);
$parcel$export($3276e9745553f254$exports, "chipColorBorderStaticEmphasisInfo", () => $3276e9745553f254$export$e41bcc6142854978);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveNeutralDefault", () => $3276e9745553f254$export$2d6f5cbe33ffecaa);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveNeutralHover", () => $3276e9745553f254$export$4e936d55cc199959);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveNeutralFocus", () => $3276e9745553f254$export$e196f4e78e8dece6);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$d08dd2b917bbdcbe);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$700910abe8bd67bb);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveSubtleDefault", () => $3276e9745553f254$export$c3d0d12d7d167459);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveSubtleHover", () => $3276e9745553f254$export$cc599fb1e3e3300c);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveSubtleFocus", () => $3276e9745553f254$export$cb2419b9c16cfcdd);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$1128c8056cd9276b);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$915246f5d427a346);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveEmphasisDefault", () => $3276e9745553f254$export$1dd7d7f143fff99a);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveEmphasisHover", () => $3276e9745553f254$export$91fc644371eb38f5);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveEmphasisFocus", () => $3276e9745553f254$export$ec43172cc32e77e3);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$4600880359d615e1);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$51555e4eb1ceea4c);
$parcel$export($3276e9745553f254$exports, "chipColorBorderInteractiveDisabled", () => $3276e9745553f254$export$fc107430d597706f);
$parcel$export($3276e9745553f254$exports, "chipFontFamily", () => $3276e9745553f254$export$7d16c5378b89bd5);
$parcel$export($3276e9745553f254$exports, "chipFontWeight", () => $3276e9745553f254$export$998d3c1f7e81e9eb);
$parcel$export($3276e9745553f254$exports, "chipMFontSize", () => $3276e9745553f254$export$ed23011c0d9d2446);
$parcel$export($3276e9745553f254$exports, "chipLFontSize", () => $3276e9745553f254$export$f8867386b651d9da);
$parcel$export($3276e9745553f254$exports, "chipInputFontSize", () => $3276e9745553f254$export$1bf4e0bbd42ea607);
$parcel$export($3276e9745553f254$exports, "chipLetterSpacing", () => $3276e9745553f254$export$9c459b111fa4f4f3);
$parcel$export($3276e9745553f254$exports, "chipLineHeightL", () => $3276e9745553f254$export$3f6b29d164f2bd31);
$parcel$export($3276e9745553f254$exports, "chipLineHeightM", () => $3276e9745553f254$export$e467a06f8f022248);
$parcel$export($3276e9745553f254$exports, "chipLineHeightInput", () => $3276e9745553f254$export$8725bf5ac2c380cf);
$parcel$export($3276e9745553f254$exports, "iconSizeMicro", () => $3276e9745553f254$export$6a595734c76fe30);
$parcel$export($3276e9745553f254$exports, "iconSizeXxs", () => $3276e9745553f254$export$457c2d7fb8320c77);
$parcel$export($3276e9745553f254$exports, "iconSizeXs", () => $3276e9745553f254$export$1a2e1724738a4f36);
$parcel$export($3276e9745553f254$exports, "iconSizeS", () => $3276e9745553f254$export$8fc672cb7298d1de);
$parcel$export($3276e9745553f254$exports, "iconSizeM", () => $3276e9745553f254$export$f4d657e58ef789df);
$parcel$export($3276e9745553f254$exports, "iconSizeL", () => $3276e9745553f254$export$1a9af4c2a2e53ffe);
$parcel$export($3276e9745553f254$exports, "iconSizeXl", () => $3276e9745553f254$export$d7333ebbf97043c);
$parcel$export($3276e9745553f254$exports, "iconSizeXxl", () => $3276e9745553f254$export$35bc30912bd412e5);
$parcel$export($3276e9745553f254$exports, "iconSizeTappable", () => $3276e9745553f254$export$8527b31e4906a715);
$parcel$export($3276e9745553f254$exports, "iconColorStaticSubtle", () => $3276e9745553f254$export$5a2fe487d6396502);
$parcel$export($3276e9745553f254$exports, "iconColorStaticNeutral", () => $3276e9745553f254$export$46347942d17069d5);
$parcel$export($3276e9745553f254$exports, "iconColorStaticEmphasis", () => $3276e9745553f254$export$aba2ba25c52e742d);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveCtaSubtleDefault", () => $3276e9745553f254$export$4f9e8b52864daf82);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveCtaNeutralDefault", () => $3276e9745553f254$export$3998bea291218554);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveCtaEmphasisDefault", () => $3276e9745553f254$export$bddeb9cc658ce838);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveCtaDisabled", () => $3276e9745553f254$export$3fbef91c81a27ff7);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentSubtleDefault", () => $3276e9745553f254$export$be8504476447899);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentSubtleHover", () => $3276e9745553f254$export$aa7b4d33dda1ff3e);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentSubtleFocus", () => $3276e9745553f254$export$1eccb6bf1b45adc0);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentSubtleSelectedDefault", () => $3276e9745553f254$export$f5f294c76327e31);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentSubtleSelectedHover", () => $3276e9745553f254$export$e087e8a19001f08f);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentSubtleDisabled", () => $3276e9745553f254$export$5932a3fffc13208b);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentNeutralDefault", () => $3276e9745553f254$export$bb4efa5fbc7bc49f);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentNeutralHover", () => $3276e9745553f254$export$2598a87ffab12199);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentNeutralFocus", () => $3276e9745553f254$export$a81df3089c6d474c);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentNeutralSelectedDefault", () => $3276e9745553f254$export$3a79d547ba3a5d26);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentNeutralSelectedHover", () => $3276e9745553f254$export$85ccc16cee46224);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentNeutralDisabled", () => $3276e9745553f254$export$df7d2e4081bbb5d1);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentEmphasisDefault", () => $3276e9745553f254$export$2d15d1c7fbd172c);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentEmphasisHover", () => $3276e9745553f254$export$14cb47ca5f5d1cd6);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentEmphasisFocus", () => $3276e9745553f254$export$16da9ff5861987a7);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentEmphasisSelectedDefault", () => $3276e9745553f254$export$419eac1adb13f9fc);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentEmphasisSelectedHover", () => $3276e9745553f254$export$e2681ddb55045e4c);
$parcel$export($3276e9745553f254$exports, "iconColorInteractiveComponentEmphasisDisabled", () => $3276e9745553f254$export$5feebe6dca4c6e2f);
$parcel$export($3276e9745553f254$exports, "iconColorErrorNeutral", () => $3276e9745553f254$export$18df805cce67e76e);
$parcel$export($3276e9745553f254$exports, "iconColorErrorSubtle", () => $3276e9745553f254$export$384dc265e7feea50);
$parcel$export($3276e9745553f254$exports, "iconColorWarningNeutral", () => $3276e9745553f254$export$5168884c17b5fa13);
$parcel$export($3276e9745553f254$exports, "iconColorWarningSubtle", () => $3276e9745553f254$export$1e76832163599c23);
$parcel$export($3276e9745553f254$exports, "iconColorSuccessNeutral", () => $3276e9745553f254$export$165790c96dfe23b);
$parcel$export($3276e9745553f254$exports, "iconColorSuccessSubtle", () => $3276e9745553f254$export$2d719fd496813158);
$parcel$export($3276e9745553f254$exports, "iconColorInfoNeutral", () => $3276e9745553f254$export$83b4faef127cb7b7);
$parcel$export($3276e9745553f254$exports, "iconColorInfoSubtle", () => $3276e9745553f254$export$54d62555f8f353f9);
$parcel$export($3276e9745553f254$exports, "badgeSizeMediumRadiusRound", () => $3276e9745553f254$export$f780a2ef2c45e34d);
$parcel$export($3276e9745553f254$exports, "badgeSizeMediumBorderWidth", () => $3276e9745553f254$export$cb5734e2315e2efe);
$parcel$export($3276e9745553f254$exports, "badgeSizeMediumMinHeight", () => $3276e9745553f254$export$995f211f28f1437);
$parcel$export($3276e9745553f254$exports, "badgeSizeMediumPaddingRight", () => $3276e9745553f254$export$db164abfd7645c18);
$parcel$export($3276e9745553f254$exports, "badgeSizeMediumPaddingLeft", () => $3276e9745553f254$export$e5da4b0c5e56db5d);
$parcel$export($3276e9745553f254$exports, "badgeSizeSmallRadiusRound", () => $3276e9745553f254$export$dad9521985b6131b);
$parcel$export($3276e9745553f254$exports, "badgeSizeSmallMinHeight", () => $3276e9745553f254$export$2f90d06b52e9497);
$parcel$export($3276e9745553f254$exports, "badgeSizeSmallPaddingRight", () => $3276e9745553f254$export$253d8914fa26df10);
$parcel$export($3276e9745553f254$exports, "badgeSizeSmallPaddingLeft", () => $3276e9745553f254$export$d6f8ff389cb04136);
$parcel$export($3276e9745553f254$exports, "badgeSizeInputMinHeight", () => $3276e9745553f254$export$5e2bf4249906aa9c);
$parcel$export($3276e9745553f254$exports, "badgeColorBgErrorSubtle", () => $3276e9745553f254$export$c1c2909bedb0a7dd);
$parcel$export($3276e9745553f254$exports, "badgeColorBgStaticSubtle", () => $3276e9745553f254$export$63d9ba7538e73dff);
$parcel$export($3276e9745553f254$exports, "badgeColorBgStaticNeutral", () => $3276e9745553f254$export$f67d4fb49acb1f89);
$parcel$export($3276e9745553f254$exports, "badgeColorBgStaticEmphasis", () => $3276e9745553f254$export$2fe4aa9229f13169);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveSubtleDefault", () => $3276e9745553f254$export$c692e870557d1485);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveSubtleHover", () => $3276e9745553f254$export$54b6b20194425cd6);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveSubtleFocus", () => $3276e9745553f254$export$be70cab265492c56);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$784e486f16c66f2d);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$6da19c50ace6d610);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveSubtleDisabled", () => $3276e9745553f254$export$4d1a2e4dfe067853);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveNeutralDefault", () => $3276e9745553f254$export$987b3d1dafde78df);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveNeutralHover", () => $3276e9745553f254$export$e836365f68f36c1d);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveNeutralFocus", () => $3276e9745553f254$export$23a0fd118827e1dc);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$9919355b48dcc96d);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$e3c46fa14b4ebd10);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveNeutralDisabled", () => $3276e9745553f254$export$9bcfcb94d6adb5eb);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveEmphasisDefault", () => $3276e9745553f254$export$4c138a91262deb86);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveEmphasisHover", () => $3276e9745553f254$export$1e05bfb99ce0bab0);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveEmphasisFocus", () => $3276e9745553f254$export$440246e634610acd);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$463c36ef5e33cde);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$673c5cc0104c050);
$parcel$export($3276e9745553f254$exports, "badgeColorBgInteractiveEmphasisDisabled", () => $3276e9745553f254$export$d5b20e83a050689e);
$parcel$export($3276e9745553f254$exports, "badgeColorTextErrorSubtle", () => $3276e9745553f254$export$b329ef8c78e58195);
$parcel$export($3276e9745553f254$exports, "badgeColorTextStaticSubtle", () => $3276e9745553f254$export$c74b59fc0c00f12f);
$parcel$export($3276e9745553f254$exports, "badgeColorTextStaticEmphasis", () => $3276e9745553f254$export$b3d105834921abae);
$parcel$export($3276e9745553f254$exports, "badgeColorTextInteractiveSubtle", () => $3276e9745553f254$export$41a0ad556cd1f41e);
$parcel$export($3276e9745553f254$exports, "badgeColorTextInteractiveNeutral", () => $3276e9745553f254$export$4749334586e6fad3);
$parcel$export($3276e9745553f254$exports, "badgeColorTextInteractiveEmphasis", () => $3276e9745553f254$export$a22d0c3e2f60d443);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderErrorSubtle", () => $3276e9745553f254$export$7c9f7df759bd38d1);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderStaticSubtle", () => $3276e9745553f254$export$d02c01c4b3e77354);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderStaticNeutral", () => $3276e9745553f254$export$a9af785ad1437427);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderStaticEmphasis", () => $3276e9745553f254$export$9b017cc64a769252);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveSubtleDefault", () => $3276e9745553f254$export$ef7785f455f0ff57);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveSubtleHover", () => $3276e9745553f254$export$6037c748dfa10ac2);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveSubtleFocus", () => $3276e9745553f254$export$e3ebbb1347a60e9d);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$4af2ae34cb51f1d8);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$9105c0035b3c9dbc);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveSubtleDisabled", () => $3276e9745553f254$export$ccf0d988c28f4ac3);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveNeutralDefault", () => $3276e9745553f254$export$a152e09ad4cfa768);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveNeutralHover", () => $3276e9745553f254$export$c026cdd1f9d9818);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveNeutralFocus", () => $3276e9745553f254$export$1e6ceb099a6c182d);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$a31e532571133db1);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$b50e97467970464c);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveNeutralDisabled", () => $3276e9745553f254$export$dc0f61867c8eb438);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveEmphasisDefault", () => $3276e9745553f254$export$9ca8e072a61adfe6);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveEmphasisHover", () => $3276e9745553f254$export$b486bbf27048fca6);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveEmphasisFocus", () => $3276e9745553f254$export$d266a9d896cbc7e5);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$f3894963a227c2d1);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$e879afede95344e2);
$parcel$export($3276e9745553f254$exports, "badgeColorBorderInteractiveEmphasisDisabled", () => $3276e9745553f254$export$64e44e4f458bdd15);
$parcel$export($3276e9745553f254$exports, "badgeFontFamily", () => $3276e9745553f254$export$a62f741044aa85bb);
$parcel$export($3276e9745553f254$exports, "badgeFontWeight", () => $3276e9745553f254$export$d411dbbc5db0f8e5);
$parcel$export($3276e9745553f254$exports, "badgeMLineHeight", () => $3276e9745553f254$export$379000749f6ebe9d);
$parcel$export($3276e9745553f254$exports, "badgeMFontSize", () => $3276e9745553f254$export$ac903168df7d1c8c);
$parcel$export($3276e9745553f254$exports, "badgeSFontSize", () => $3276e9745553f254$export$4ae3397bafb779ba);
$parcel$export($3276e9745553f254$exports, "badgeSLineHeight", () => $3276e9745553f254$export$31a061c5e74d37df);
$parcel$export($3276e9745553f254$exports, "badgeLetterSpacing", () => $3276e9745553f254$export$3f73af3bf1f38889);
$parcel$export($3276e9745553f254$exports, "badgeInputLineHeight", () => $3276e9745553f254$export$655d640242b74977);
$parcel$export($3276e9745553f254$exports, "badgeInputFontSize", () => $3276e9745553f254$export$228d1ca9c77817dd);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgHeaderDefault", () => $3276e9745553f254$export$4d3f5ae03ef63815);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgHeaderSorted", () => $3276e9745553f254$export$4f5fa3d302b4eb89);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgHeaderHover", () => $3276e9745553f254$export$3aa8eef02f53a11f);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgHeaderError", () => $3276e9745553f254$export$9cee6c095c5d53f);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgHeaderSelected", () => $3276e9745553f254$export$46616e63025810c3);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgRegularDefault", () => $3276e9745553f254$export$2eb243147337e0e9);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgRegularSorted", () => $3276e9745553f254$export$ef30719fb3a37b5c);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgRegularHover", () => $3276e9745553f254$export$18dec71efe39c363);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgRegularError", () => $3276e9745553f254$export$1983392f49eb3b77);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgRegularSelected", () => $3276e9745553f254$export$f069eb93d208df24);
$parcel$export($3276e9745553f254$exports, "tableCellColorBgGrouped", () => $3276e9745553f254$export$eb1bb4481b303f23);
$parcel$export($3276e9745553f254$exports, "tableCellColorBorder", () => $3276e9745553f254$export$2054ca69e320709f);
$parcel$export($3276e9745553f254$exports, "tableCellBorderWidthBottom", () => $3276e9745553f254$export$71d1df7ff8827dd3);
$parcel$export($3276e9745553f254$exports, "tableCellDense", () => $3276e9745553f254$export$6d220a723977f960);
$parcel$export($3276e9745553f254$exports, "tableCellDefault", () => $3276e9745553f254$export$2c16a3f0e6b48836);
$parcel$export($3276e9745553f254$exports, "tableCellSpacious", () => $3276e9745553f254$export$58ecf9341fd2c423);
$parcel$export($3276e9745553f254$exports, "linkColorBgDefault", () => $3276e9745553f254$export$63860ae533ec763);
$parcel$export($3276e9745553f254$exports, "linkColorBgHover", () => $3276e9745553f254$export$8cd575c98ef7c7e3);
$parcel$export($3276e9745553f254$exports, "linkColorBgFocus", () => $3276e9745553f254$export$23b1fadb952026bb);
$parcel$export($3276e9745553f254$exports, "linkColorBgDisabled", () => $3276e9745553f254$export$6dc4bfc245f9c03f);
$parcel$export($3276e9745553f254$exports, "linkColorTextDefault", () => $3276e9745553f254$export$407ca803dcba1686);
$parcel$export($3276e9745553f254$exports, "linkColorTextHover", () => $3276e9745553f254$export$db0f7f411822f8f9);
$parcel$export($3276e9745553f254$exports, "linkColorTextFocus", () => $3276e9745553f254$export$333ac82fea827fd7);
$parcel$export($3276e9745553f254$exports, "linkColorTextDisabled", () => $3276e9745553f254$export$2a45d93c2e2c57d7);
$parcel$export($3276e9745553f254$exports, "linkColorTextVisited", () => $3276e9745553f254$export$307543bd31288d3a);
$parcel$export($3276e9745553f254$exports, "linkFontFamily", () => $3276e9745553f254$export$583bfe75ad3be530);
$parcel$export($3276e9745553f254$exports, "linkFontWeight", () => $3276e9745553f254$export$bd18f91ff949705a);
$parcel$export($3276e9745553f254$exports, "linkLetterSpacing", () => $3276e9745553f254$export$f0729e79e516d76f);
$parcel$export($3276e9745553f254$exports, "linkLineHeightDefault", () => $3276e9745553f254$export$a3037016530afa41);
$parcel$export($3276e9745553f254$exports, "linkLineHeightCaption", () => $3276e9745553f254$export$63b3bf0bcd5dec0);
$parcel$export($3276e9745553f254$exports, "linkFontSizeDefault", () => $3276e9745553f254$export$63f6e89485f022a0);
$parcel$export($3276e9745553f254$exports, "linkFontSizeCaption", () => $3276e9745553f254$export$2c39b60b9ab3c509);
$parcel$export($3276e9745553f254$exports, "linkTextDecorationUnderline", () => $3276e9745553f254$export$d20edb3b4cd46521);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgUnselectedDefault", () => $3276e9745553f254$export$1a81d73bf487bad2);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgUnselectedHover", () => $3276e9745553f254$export$66899150b01781f);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgUnselectedFocus", () => $3276e9745553f254$export$f717e38166baeb5c);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgUnselectedDisabled", () => $3276e9745553f254$export$1b8e258852406e33);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgSelectedDefault", () => $3276e9745553f254$export$6024c97884eba4d8);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgSelectedHover", () => $3276e9745553f254$export$be689acb580cdc83);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgSelectedFocus", () => $3276e9745553f254$export$49e326127c3153ea);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgSelectedDisabled", () => $3276e9745553f254$export$55f25450a0bf5e72);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgIndeterminateDefault", () => $3276e9745553f254$export$fc90332a56a8f3c);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgIndeterminateHover", () => $3276e9745553f254$export$2c6002f82a481ef3);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgIndeterminateFocus", () => $3276e9745553f254$export$d22c37eb694c13bd);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBgIndeterminateDisabled", () => $3276e9745553f254$export$fd0078d1143f7e9a);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderUnselectedDefault", () => $3276e9745553f254$export$d1033c477c3c6ff9);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderUnselectedHover", () => $3276e9745553f254$export$ce1e53725c205a2b);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderUnselectedFocus", () => $3276e9745553f254$export$be282364918d0701);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderUnselectedDisabled", () => $3276e9745553f254$export$e8d2b6a7823bd61c);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderSelectedDefault", () => $3276e9745553f254$export$69b4d96c29de7d5a);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderSelectedHover", () => $3276e9745553f254$export$d71ecf661337863e);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderSelectedFocus", () => $3276e9745553f254$export$dd2313e49d842f7c);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderSelectedDisabled", () => $3276e9745553f254$export$407193ea73d64650);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderIndeterminateDefault", () => $3276e9745553f254$export$68a64f766c3e06eb);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderIndeterminateHover", () => $3276e9745553f254$export$7bd4b125f5796f0b);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderIndeterminateFocus", () => $3276e9745553f254$export$dc235a9e36421303);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorWrapperBorderIndeterminateDisabled", () => $3276e9745553f254$export$44a93435f9e76b5f);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgUnselectedDefault", () => $3276e9745553f254$export$5114818da7303033);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgUnselectedHover", () => $3276e9745553f254$export$819bb9ecff8821f6);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgUnselectedFocus", () => $3276e9745553f254$export$9d48bca40b858c58);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgUnselectedDisabled", () => $3276e9745553f254$export$f4432833dbc2b032);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgSelectedDefault", () => $3276e9745553f254$export$5371ecf7e7c3c5fb);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgSelectedHover", () => $3276e9745553f254$export$bce78b0af6106c0d);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgSelectedFocus", () => $3276e9745553f254$export$84c6ef30066cb450);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgSelectedDisabled", () => $3276e9745553f254$export$19c89d51fe48e97e);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgIndeterminateDefault", () => $3276e9745553f254$export$b4ded087f67cfcb1);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgIndeterminateHover", () => $3276e9745553f254$export$98739c3332aa1180);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgIndeterminateFocus", () => $3276e9745553f254$export$5450679c20cb502e);
$parcel$export($3276e9745553f254$exports, "toggleControlsColorIconBgIndeterminateDisabled", () => $3276e9745553f254$export$72df667c0ea477ce);
$parcel$export($3276e9745553f254$exports, "toggleControlsSizeDefault", () => $3276e9745553f254$export$de71cd689917b4b9);
$parcel$export($3276e9745553f254$exports, "toggleControlsSizeS", () => $3276e9745553f254$export$46fd5ca6b9cb553c);
$parcel$export($3276e9745553f254$exports, "toggleControlsPadding", () => $3276e9745553f254$export$c3edf74d2870face);
$parcel$export($3276e9745553f254$exports, "toggleControlsRadiusSquare", () => $3276e9745553f254$export$b4a7b3d28ddcea06);
$parcel$export($3276e9745553f254$exports, "toggleControlsRadiusRound", () => $3276e9745553f254$export$aab87273839218af);
$parcel$export($3276e9745553f254$exports, "toggleControlsBorderWidthWrapper", () => $3276e9745553f254$export$31a25690cfb3c72b);
$parcel$export($3276e9745553f254$exports, "skeletonColorBg", () => $3276e9745553f254$export$4f243c7e47f36178);
$parcel$export($3276e9745553f254$exports, "skeletonColorBorder", () => $3276e9745553f254$export$21e1926cfd31fb34);
$parcel$export($3276e9745553f254$exports, "skeletonBorderWidthNone", () => $3276e9745553f254$export$729f8261cfc7f56f);
$parcel$export($3276e9745553f254$exports, "skeletonRadiusRound", () => $3276e9745553f254$export$841ebfb9757ebe4e);
$parcel$export($3276e9745553f254$exports, "skeletonRadiusSharp", () => $3276e9745553f254$export$9e4598db4a678250);
$parcel$export($3276e9745553f254$exports, "dividerBorderWidth", () => $3276e9745553f254$export$5c0a15ed7f937814);
$parcel$export($3276e9745553f254$exports, "dividerColor", () => $3276e9745553f254$export$6fdaa6b611356931);
$parcel$export($3276e9745553f254$exports, "dialogSizeSWidth", () => $3276e9745553f254$export$14148cd5c9a8c997);
$parcel$export($3276e9745553f254$exports, "dialogSizeMWidth", () => $3276e9745553f254$export$3c9f15c3fd95369);
$parcel$export($3276e9745553f254$exports, "dialogSizeLWidth", () => $3276e9745553f254$export$8dbca5b14d0844eb);
$parcel$export($3276e9745553f254$exports, "dialogSizeMobileWidth", () => $3276e9745553f254$export$8e20ff08973f499);
$parcel$export($3276e9745553f254$exports, "dialogBorderWidth", () => $3276e9745553f254$export$288cafde2f49d409);
$parcel$export($3276e9745553f254$exports, "dialogRadius", () => $3276e9745553f254$export$4d69bf9275adc0b4);
$parcel$export($3276e9745553f254$exports, "dialogColorBgDefault", () => $3276e9745553f254$export$15fcc38e88786dd4);
$parcel$export($3276e9745553f254$exports, "dialogColorBorderDefault", () => $3276e9745553f254$export$fc3f1c3df48b1cc4);
$parcel$export($3276e9745553f254$exports, "dialogPaddingDefault", () => $3276e9745553f254$export$a3582a1f7ae69771);
$parcel$export($3276e9745553f254$exports, "dialogPaddingSpacious", () => $3276e9745553f254$export$76c304873b7a47d1);
$parcel$export($3276e9745553f254$exports, "dialogPaddingDense", () => $3276e9745553f254$export$3be63787605bb63b);
$parcel$export($3276e9745553f254$exports, "headerFontFamily", () => $3276e9745553f254$export$6da960e179d64c7e);
$parcel$export($3276e9745553f254$exports, "headerFontWeight", () => $3276e9745553f254$export$d4ec6eea36d83142);
$parcel$export($3276e9745553f254$exports, "headerLineHeight", () => $3276e9745553f254$export$f148b6bcf802c0a0);
$parcel$export($3276e9745553f254$exports, "headerFontSize", () => $3276e9745553f254$export$8fcd22ab977bd8d8);
$parcel$export($3276e9745553f254$exports, "headerLetterSpacing", () => $3276e9745553f254$export$352a97f8e784158a);
$parcel$export($3276e9745553f254$exports, "alertBoxShadowInline", () => $3276e9745553f254$export$902221d8e98b812c);
$parcel$export($3276e9745553f254$exports, "alertBoxShadowFloating", () => $3276e9745553f254$export$e492848c875e9064);
$parcel$export($3276e9745553f254$exports, "alertBorderWidth", () => $3276e9745553f254$export$bd9a62c800d4c4a9);
$parcel$export($3276e9745553f254$exports, "alertRadius", () => $3276e9745553f254$export$76ef89a37b8ace4d);
$parcel$export($3276e9745553f254$exports, "alertPadding", () => $3276e9745553f254$export$735b1ff34fe199d4);
$parcel$export($3276e9745553f254$exports, "alertSpaceBetween", () => $3276e9745553f254$export$302ed6b9f6c0b425);
$parcel$export($3276e9745553f254$exports, "alertColorBgErrorNeutral", () => $3276e9745553f254$export$1ba594a12602b520);
$parcel$export($3276e9745553f254$exports, "alertColorBgWarningNeutral", () => $3276e9745553f254$export$bc25af37f4d9124d);
$parcel$export($3276e9745553f254$exports, "alertColorBgSuccessNeutral", () => $3276e9745553f254$export$569648afc0995710);
$parcel$export($3276e9745553f254$exports, "alertColorBgInfoNeutral", () => $3276e9745553f254$export$4c44b4e9bc0481e9);
$parcel$export($3276e9745553f254$exports, "alertColorBgInfoEmphasis", () => $3276e9745553f254$export$df27106c05b21907);
$parcel$export($3276e9745553f254$exports, "alertColorBorderErrorNeutral", () => $3276e9745553f254$export$e92b34357220e8e0);
$parcel$export($3276e9745553f254$exports, "alertColorBorderWarningNeutral", () => $3276e9745553f254$export$809bc51a80a73ffa);
$parcel$export($3276e9745553f254$exports, "alertColorBorderSuccessNeutral", () => $3276e9745553f254$export$b20e54fe63f136ec);
$parcel$export($3276e9745553f254$exports, "alertColorBorderInfoNeutral", () => $3276e9745553f254$export$aaaff3ea35504d9a);
$parcel$export($3276e9745553f254$exports, "alertColorBorderInfoEmphasis", () => $3276e9745553f254$export$d2b4b84e205366a4);
$parcel$export($3276e9745553f254$exports, "alertColorTextNeutral", () => $3276e9745553f254$export$bd02a858e71ac856);
$parcel$export($3276e9745553f254$exports, "alertColorTextEmphasis", () => $3276e9745553f254$export$9f0fea77a037b87a);
$parcel$export($3276e9745553f254$exports, "alertColorTextErrorNeutral", () => $3276e9745553f254$export$2b03536d20a3b2f6);
$parcel$export($3276e9745553f254$exports, "alertFontFamily", () => $3276e9745553f254$export$ca5110e6287a9670);
$parcel$export($3276e9745553f254$exports, "alertBodyFontWeight", () => $3276e9745553f254$export$6595d0fad08bd2b4);
$parcel$export($3276e9745553f254$exports, "alertBodyLineHeight", () => $3276e9745553f254$export$4339da1d2671e324);
$parcel$export($3276e9745553f254$exports, "alertBodyFontSize", () => $3276e9745553f254$export$891da890c43fc05e);
$parcel$export($3276e9745553f254$exports, "alertTitleFontWeight", () => $3276e9745553f254$export$ce0ddd473dd20afc);
$parcel$export($3276e9745553f254$exports, "alertTitleLineHeight", () => $3276e9745553f254$export$16dd3c4d6489ba61);
$parcel$export($3276e9745553f254$exports, "alertTitleFontSize", () => $3276e9745553f254$export$ddcf665488274808);
$parcel$export($3276e9745553f254$exports, "alertLetterSpacing", () => $3276e9745553f254$export$5bdc2b5fff62d35);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBgSelectedDefault", () => $3276e9745553f254$export$86773c375c0bb9a1);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBgSelectedHover", () => $3276e9745553f254$export$6607013dc8c505fa);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBgSelectedDisabled", () => $3276e9745553f254$export$df5495caecdcb614);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBgUnselectedDefault", () => $3276e9745553f254$export$23aa1d4fb282b9e2);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBgUnselectedHover", () => $3276e9745553f254$export$9f19810b26e253c8);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBgUnselectedDisabled", () => $3276e9745553f254$export$a1820a4b6e6de5c);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBorderSelectedDefault", () => $3276e9745553f254$export$64a5a6262510bdfe);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBorderSelectedHover", () => $3276e9745553f254$export$561d96085c937ed4);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBorderSelectedDisabled", () => $3276e9745553f254$export$c60d87bac1618e10);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBorderUnselectedDefault", () => $3276e9745553f254$export$7fabd56572773fe8);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBorderUnselectedHover", () => $3276e9745553f254$export$3f9ecbd7e63c2056);
$parcel$export($3276e9745553f254$exports, "switchKnobColorBorderUnselectedDisabled", () => $3276e9745553f254$export$a5c9bce6d83773a);
$parcel$export($3276e9745553f254$exports, "switchKnobBorderWidth", () => $3276e9745553f254$export$5e221dc1e3b0d8bf);
$parcel$export($3276e9745553f254$exports, "switchKnobRadius", () => $3276e9745553f254$export$987a18f51782dfac);
$parcel$export($3276e9745553f254$exports, "switchKnobSizeM", () => $3276e9745553f254$export$4c09818a16bf66d3);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBgSelectedDefault", () => $3276e9745553f254$export$e2b1a3f6040b3539);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBgSelectedHover", () => $3276e9745553f254$export$71201f47e9dc9666);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBgSelectedDisabled", () => $3276e9745553f254$export$6c4b9b05028ede96);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBgUnselectedDefault", () => $3276e9745553f254$export$b1d4a516e2e88fe6);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBgUnselectedHover", () => $3276e9745553f254$export$f1348024bfa310d4);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBgUnselectedDisabled", () => $3276e9745553f254$export$5d9f8f5a09ed11cc);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBorderSelectedDefault", () => $3276e9745553f254$export$c38f3967889bac93);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBorderSelectedHover", () => $3276e9745553f254$export$64092d816c16ef53);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBorderSelectedDisabled", () => $3276e9745553f254$export$7521fab9ed6230d8);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBorderUnselectedDefault", () => $3276e9745553f254$export$d4e8d359f8069dfc);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBorderUnselectedHover", () => $3276e9745553f254$export$1814043782ee69c8);
$parcel$export($3276e9745553f254$exports, "switchTrackColorBorderUnselectedDisabled", () => $3276e9745553f254$export$f17aa8a146709aa2);
$parcel$export($3276e9745553f254$exports, "switchTrackBorderWidth", () => $3276e9745553f254$export$3d1b7f700b76b19e);
$parcel$export($3276e9745553f254$exports, "switchTrackRadius", () => $3276e9745553f254$export$e33736dbca43baac);
$parcel$export($3276e9745553f254$exports, "switchTrackSizeMMinWidth", () => $3276e9745553f254$export$fa6928ff7c04c2cd);
$parcel$export($3276e9745553f254$exports, "switchTrackSizeMMinHeight", () => $3276e9745553f254$export$3a2ecb48778e609e);
$parcel$export($3276e9745553f254$exports, "menuItemColorBgDefault", () => $3276e9745553f254$export$1ced0159d1e6df39);
$parcel$export($3276e9745553f254$exports, "menuItemColorBgHover", () => $3276e9745553f254$export$f405b4ac7e3959c8);
$parcel$export($3276e9745553f254$exports, "menuItemColorBgFocus", () => $3276e9745553f254$export$7c74bcd0f7f3be40);
$parcel$export($3276e9745553f254$exports, "menuItemColorBgSelectedDefault", () => $3276e9745553f254$export$b2bbe3653cad5eb2);
$parcel$export($3276e9745553f254$exports, "menuItemColorBgSelectedHover", () => $3276e9745553f254$export$5ebb29b4abcdfb8f);
$parcel$export($3276e9745553f254$exports, "menuItemColorBgDisabled", () => $3276e9745553f254$export$a6e416f594566ded);
$parcel$export($3276e9745553f254$exports, "menuItemColorBorderDefault", () => $3276e9745553f254$export$db028a317a02353a);
$parcel$export($3276e9745553f254$exports, "menuItemColorBorderHover", () => $3276e9745553f254$export$6f5efccfe6dfd313);
$parcel$export($3276e9745553f254$exports, "menuItemColorBorderFocus", () => $3276e9745553f254$export$4fe40f383eb5faf5);
$parcel$export($3276e9745553f254$exports, "menuItemColorBorderSelectedDefault", () => $3276e9745553f254$export$71ea0e30dc1b6ba4);
$parcel$export($3276e9745553f254$exports, "menuItemColorBorderSelectedHover", () => $3276e9745553f254$export$8c4beee5a921e3c9);
$parcel$export($3276e9745553f254$exports, "menuItemColorBorderDisabled", () => $3276e9745553f254$export$35a66965267ed529);
$parcel$export($3276e9745553f254$exports, "menuItemColorTextDefault", () => $3276e9745553f254$export$7bcf618f61979316);
$parcel$export($3276e9745553f254$exports, "menuItemColorTextHover", () => $3276e9745553f254$export$a6f5b1dbfa6022b);
$parcel$export($3276e9745553f254$exports, "menuItemColorTextFocus", () => $3276e9745553f254$export$2cd9519356202e1f);
$parcel$export($3276e9745553f254$exports, "menuItemColorTextSelected", () => $3276e9745553f254$export$aa7a4ccf8d59e280);
$parcel$export($3276e9745553f254$exports, "menuItemColorTextDisabled", () => $3276e9745553f254$export$ee5e76ba05b4ab28);
$parcel$export($3276e9745553f254$exports, "menuItemBorderWidth", () => $3276e9745553f254$export$f1088235eae15437);
$parcel$export($3276e9745553f254$exports, "menuItemRadius", () => $3276e9745553f254$export$fafa860328e70ae);
$parcel$export($3276e9745553f254$exports, "menuItemPadding", () => $3276e9745553f254$export$a7a5eb1834e82687);
$parcel$export($3276e9745553f254$exports, "menuItemFontFamily", () => $3276e9745553f254$export$7d6465298d6c4692);
$parcel$export($3276e9745553f254$exports, "menuItemFontWeightDefault", () => $3276e9745553f254$export$a0f454c876af7960);
$parcel$export($3276e9745553f254$exports, "menuItemFontWeightNested", () => $3276e9745553f254$export$e2adaac19dce9831);
$parcel$export($3276e9745553f254$exports, "menuItemLineHeight", () => $3276e9745553f254$export$dddff9d395fc8f70);
$parcel$export($3276e9745553f254$exports, "menuItemFontSize", () => $3276e9745553f254$export$1dd2d60f07979c32);
$parcel$export($3276e9745553f254$exports, "menuItemLetterSpacing", () => $3276e9745553f254$export$42ae81b5c0a2fbb);
$parcel$export($3276e9745553f254$exports, "menuColorBg", () => $3276e9745553f254$export$a46db5db085db139);
$parcel$export($3276e9745553f254$exports, "menuColorBorder", () => $3276e9745553f254$export$27401163f4368ffc);
$parcel$export($3276e9745553f254$exports, "menuBorderWidth", () => $3276e9745553f254$export$96b2aad183e1f54f);
$parcel$export($3276e9745553f254$exports, "menuRadius", () => $3276e9745553f254$export$ee764dc2d555ddf6);
$parcel$export($3276e9745553f254$exports, "menuPadding", () => $3276e9745553f254$export$794d9c23b73cc47e);
$parcel$export($3276e9745553f254$exports, "menuSpaceBetween", () => $3276e9745553f254$export$3f57378f9ec9cd94);
$parcel$export($3276e9745553f254$exports, "menuBoxShadow", () => $3276e9745553f254$export$ddcc321b1a8861dd);
$parcel$export($3276e9745553f254$exports, "textfieldColorBgDefault", () => $3276e9745553f254$export$b51251547efb0d8e);
$parcel$export($3276e9745553f254$exports, "textfieldColorBgHover", () => $3276e9745553f254$export$85a890daf957fbec);
$parcel$export($3276e9745553f254$exports, "textfieldColorBgFocus", () => $3276e9745553f254$export$89e8e756190bda61);
$parcel$export($3276e9745553f254$exports, "textfieldColorBgDisabled", () => $3276e9745553f254$export$770bdd3d491ddfe6);
$parcel$export($3276e9745553f254$exports, "textfieldColorBgError", () => $3276e9745553f254$export$8e00bb2c5d8bbc3b);
$parcel$export($3276e9745553f254$exports, "textfieldColorBorderDefault", () => $3276e9745553f254$export$c21d874e9498ef82);
$parcel$export($3276e9745553f254$exports, "textfieldColorBorderHover", () => $3276e9745553f254$export$61ede0f7013c2b81);
$parcel$export($3276e9745553f254$exports, "textfieldColorBorderFocus", () => $3276e9745553f254$export$6fe37393ecda4209);
$parcel$export($3276e9745553f254$exports, "textfieldColorBorderDisabled", () => $3276e9745553f254$export$ff38bf95992f09fc);
$parcel$export($3276e9745553f254$exports, "textfieldColorBorderError", () => $3276e9745553f254$export$88cfb69c788bb860);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextEnteredDefault", () => $3276e9745553f254$export$52e86a91e2ad6034);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextEnteredDisabled", () => $3276e9745553f254$export$cca144c3f4aa7626);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextLabelDefault", () => $3276e9745553f254$export$f10f0ec496f636f7);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextLabelDisabled", () => $3276e9745553f254$export$58dfb1025a181356);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextLabelError", () => $3276e9745553f254$export$bc322de6f84fd903);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextPlaceholderDefault", () => $3276e9745553f254$export$49337470bba91ab9);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextPlaceholderDisabled", () => $3276e9745553f254$export$4a34e2a16154db83);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextHelperTextDefault", () => $3276e9745553f254$export$26aa6c0ceb7e966e);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextHelperTextDisabled", () => $3276e9745553f254$export$b816de746fb400a5);
$parcel$export($3276e9745553f254$exports, "textfieldColorTextHelperTextError", () => $3276e9745553f254$export$c02de212dbe9d176);
$parcel$export($3276e9745553f254$exports, "textfieldPadding", () => $3276e9745553f254$export$116727610d612ae4);
$parcel$export($3276e9745553f254$exports, "textfieldBorderWidth", () => $3276e9745553f254$export$71b44d15d3de46dd);
$parcel$export($3276e9745553f254$exports, "textfieldSpaceBetween", () => $3276e9745553f254$export$bace76a59986f565);
$parcel$export($3276e9745553f254$exports, "textfieldFontFamily", () => $3276e9745553f254$export$9ffe2275b011d7e1);
$parcel$export($3276e9745553f254$exports, "textfieldLineHeight", () => $3276e9745553f254$export$b0985124f4df02d2);
$parcel$export($3276e9745553f254$exports, "textfieldFontWeight", () => $3276e9745553f254$export$a315c6564df14490);
$parcel$export($3276e9745553f254$exports, "textfieldFontSize", () => $3276e9745553f254$export$aa1b94da4287d2a0);
$parcel$export($3276e9745553f254$exports, "textfieldLetterSpacing", () => $3276e9745553f254$export$e5114fa3fec26908);
$parcel$export($3276e9745553f254$exports, "textfieldRadius", () => $3276e9745553f254$export$84f5f00bc441b732);
$parcel$export($3276e9745553f254$exports, "helpTextFontFamily", () => $3276e9745553f254$export$51cb609d45dac1eb);
$parcel$export($3276e9745553f254$exports, "helpTextFontWeight", () => $3276e9745553f254$export$3827778002413131);
$parcel$export($3276e9745553f254$exports, "helpTextLineHeight", () => $3276e9745553f254$export$e67e3340791cadd4);
$parcel$export($3276e9745553f254$exports, "helpTextFontSize", () => $3276e9745553f254$export$ec94e1b644056c99);
$parcel$export($3276e9745553f254$exports, "helpTextLetterSpacing", () => $3276e9745553f254$export$f3bbd9a0f0930579);
$parcel$export($3276e9745553f254$exports, "minHeightDefault", () => $3276e9745553f254$export$33ce3a4dcea39de);
$parcel$export($3276e9745553f254$exports, "labelColorBgSubtle", () => $3276e9745553f254$export$d8e53851991cdd42);
$parcel$export($3276e9745553f254$exports, "labelColorBgNeutral", () => $3276e9745553f254$export$fe3a5cd62a598e84);
$parcel$export($3276e9745553f254$exports, "labelColorText", () => $3276e9745553f254$export$5edfe3b007b29215);
$parcel$export($3276e9745553f254$exports, "labelPadding", () => $3276e9745553f254$export$86d4c0985100dcd0);
$parcel$export($3276e9745553f254$exports, "progressContainerColorBg", () => $3276e9745553f254$export$8266cc989bac4651);
$parcel$export($3276e9745553f254$exports, "progressContainerColorBorder", () => $3276e9745553f254$export$d4bd2b0a79e3ef71);
$parcel$export($3276e9745553f254$exports, "progressFillColorBgDefault", () => $3276e9745553f254$export$4ce259255a4d70c4);
$parcel$export($3276e9745553f254$exports, "progressFillColorBgError", () => $3276e9745553f254$export$2869c51015852e03);
$parcel$export($3276e9745553f254$exports, "progressFillColorBorderDefault", () => $3276e9745553f254$export$f5e3fe890c9ff1e);
$parcel$export($3276e9745553f254$exports, "progressFillColorBorderError", () => $3276e9745553f254$export$1cfbd34f600c6efa);
$parcel$export($3276e9745553f254$exports, "linearContainerBorderWidth", () => $3276e9745553f254$export$5a252ec11a1445ad);
$parcel$export($3276e9745553f254$exports, "linearContainerRadius", () => $3276e9745553f254$export$c735ecaf581f705);
$parcel$export($3276e9745553f254$exports, "linearFillBorderWidth", () => $3276e9745553f254$export$49bf4afa6ca745e);
$parcel$export($3276e9745553f254$exports, "linearFillRadius", () => $3276e9745553f254$export$edc7fc4c8271f574);
$parcel$export($3276e9745553f254$exports, "linearSizeSMinHeight", () => $3276e9745553f254$export$253ba067522eaa91);
$parcel$export($3276e9745553f254$exports, "circularSizeS", () => $3276e9745553f254$export$c945866cf5c6fd53);
$parcel$export($3276e9745553f254$exports, "circularSizeM", () => $3276e9745553f254$export$5b8c998da32edfab);
$parcel$export($3276e9745553f254$exports, "circularSizeL", () => $3276e9745553f254$export$4cb4e758ff318324);
$parcel$export($3276e9745553f254$exports, "circularSizeXl", () => $3276e9745553f254$export$9965c30cb78bb99e);
$parcel$export($3276e9745553f254$exports, "sparklineSizeLargeMinHeight", () => $3276e9745553f254$export$73f604c81bd5b0de);
$parcel$export($3276e9745553f254$exports, "sparklineSizeLargeMinWidth", () => $3276e9745553f254$export$e2b17b1f6ba2f2c0);
$parcel$export($3276e9745553f254$exports, "sparklineSizeMediumMinHeight", () => $3276e9745553f254$export$9d31ebafe2568375);
$parcel$export($3276e9745553f254$exports, "sparklineSizeMediumMinWidth", () => $3276e9745553f254$export$65141d2099878d22);
$parcel$export($3276e9745553f254$exports, "sparklineLineColor", () => $3276e9745553f254$export$b889b193e53040e);
$parcel$export($3276e9745553f254$exports, "sparklineLineBorderWidth", () => $3276e9745553f254$export$80792f69e844dd7a);
$parcel$export($3276e9745553f254$exports, "paginationSpaceBetween", () => $3276e9745553f254$export$5ded54aa949b1fd3);
$parcel$export($3276e9745553f254$exports, "paginationPadding", () => $3276e9745553f254$export$20e329e1e9c12a82);
$parcel$export($3276e9745553f254$exports, "paginationColorBgDefault", () => $3276e9745553f254$export$e2d09706041282a2);
$parcel$export($3276e9745553f254$exports, "paginationColorBgFilled", () => $3276e9745553f254$export$7aa5ad378865fe04);
$parcel$export($3276e9745553f254$exports, "paginationColorBorderDefault", () => $3276e9745553f254$export$4c7f7f1e4a99b8b5);
$parcel$export($3276e9745553f254$exports, "paginationColorBorderBorderTop", () => $3276e9745553f254$export$acfd0f4230aa9bd);
$parcel$export($3276e9745553f254$exports, "paginationBorderWidthTop", () => $3276e9745553f254$export$33c117b123a26dc4);
$parcel$export($3276e9745553f254$exports, "tabRadius", () => $3276e9745553f254$export$427ad239b0adeca2);
$parcel$export($3276e9745553f254$exports, "tabColorBgDefaultDefault", () => $3276e9745553f254$export$8814694ab67761cf);
$parcel$export($3276e9745553f254$exports, "tabColorBgDefaultHover", () => $3276e9745553f254$export$e4759e57c938a220);
$parcel$export($3276e9745553f254$exports, "tabColorBgDefaultFocus", () => $3276e9745553f254$export$7dc99afc1861281f);
$parcel$export($3276e9745553f254$exports, "tabColorBgSelectedDefault", () => $3276e9745553f254$export$e5a7cf19fc196fc0);
$parcel$export($3276e9745553f254$exports, "tabColorBgSelectedHover", () => $3276e9745553f254$export$742357191da0915b);
$parcel$export($3276e9745553f254$exports, "tabColorBgSelectedFocus", () => $3276e9745553f254$export$d4fac41645ce7de8);
$parcel$export($3276e9745553f254$exports, "tabColorBorderDefaultDefault", () => $3276e9745553f254$export$258236cb50101bf9);
$parcel$export($3276e9745553f254$exports, "tabColorBorderDefaultHover", () => $3276e9745553f254$export$b660cdb46497535b);
$parcel$export($3276e9745553f254$exports, "tabColorBorderDefaultFocus", () => $3276e9745553f254$export$6edeb93afbabb3);
$parcel$export($3276e9745553f254$exports, "tabColorBorderSelectedDefault", () => $3276e9745553f254$export$8527b5e5f1a32759);
$parcel$export($3276e9745553f254$exports, "tabColorBorderSelectedHover", () => $3276e9745553f254$export$404f9d2e20441a64);
$parcel$export($3276e9745553f254$exports, "tabColorBorderSelectedFocus", () => $3276e9745553f254$export$cc0883bf09c21e65);
$parcel$export($3276e9745553f254$exports, "tabColorTextDefault", () => $3276e9745553f254$export$facf8ff6788b88ea);
$parcel$export($3276e9745553f254$exports, "tabColorTextSelected", () => $3276e9745553f254$export$5ba09a1a7b4af6ac);
$parcel$export($3276e9745553f254$exports, "tabPadding", () => $3276e9745553f254$export$dc278ffa79064219);
$parcel$export($3276e9745553f254$exports, "tabSpaceBetween", () => $3276e9745553f254$export$1e468d8d8b24f0a7);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalDefaultBottom", () => $3276e9745553f254$export$8a7407fa38280281);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalDefaultTop", () => $3276e9745553f254$export$362ddcf024bed54e);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalDefaultRight", () => $3276e9745553f254$export$4d9a0d275210ab6f);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalDefaultLeft", () => $3276e9745553f254$export$31a06d75aaa08bbf);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalSelectedBottom", () => $3276e9745553f254$export$3bcae2b0ac664dfb);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalSelectedTop", () => $3276e9745553f254$export$5e97a30a5d76a6eb);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalSelectedRight", () => $3276e9745553f254$export$49b56a0f736ebf80);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthHorizontalSelectedLeft", () => $3276e9745553f254$export$dcc78db97c706ed5);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalDefaultBottom", () => $3276e9745553f254$export$db0747eda20d8b11);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalDefaultTop", () => $3276e9745553f254$export$b1dd518c969a9dc2);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalDefaultRight", () => $3276e9745553f254$export$512259029c84d0f1);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalDefaultLeft", () => $3276e9745553f254$export$6f6b54dde0882c41);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalSelectedBottom", () => $3276e9745553f254$export$437187fbcaa7285b);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalSelectedTop", () => $3276e9745553f254$export$f41d59313e2e2d61);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalSelectedRight", () => $3276e9745553f254$export$15265dc7c7a51345);
$parcel$export($3276e9745553f254$exports, "tabBorderWidthVerticalSelectedLeft", () => $3276e9745553f254$export$e9d3d243807e3d2);
$parcel$export($3276e9745553f254$exports, "tabFontFamily", () => $3276e9745553f254$export$e2766d737a057e60);
$parcel$export($3276e9745553f254$exports, "tabFontWeight", () => $3276e9745553f254$export$2ddfac786be6e309);
$parcel$export($3276e9745553f254$exports, "tabFontSize", () => $3276e9745553f254$export$59bf55466e4e3745);
$parcel$export($3276e9745553f254$exports, "tabLetterSpacing", () => $3276e9745553f254$export$22bcc28ea306d2f3);
$parcel$export($3276e9745553f254$exports, "datawordMinHeight", () => $3276e9745553f254$export$b88310354d2244f3);
$parcel$export($3276e9745553f254$exports, "datawordMinWidth", () => $3276e9745553f254$export$824459960cf5a262);
$parcel$export($3276e9745553f254$exports, "datawordSpaceBetween", () => $3276e9745553f254$export$788649a55d91496e);
$parcel$export($3276e9745553f254$exports, "datawordColorUnfilledBg", () => $3276e9745553f254$export$95aa30178720092a);
$parcel$export($3276e9745553f254$exports, "datawordColorFilledBg", () => $3276e9745553f254$export$16796337c4a008dd);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBorderError", () => $3276e9745553f254$export$92929f84f89fa83);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBorderDefault", () => $3276e9745553f254$export$b2ca58ad74caacc7);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBorderHover", () => $3276e9745553f254$export$b1b662adf9714ed8);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBorderFocus", () => $3276e9745553f254$export$a212d99fcf9df17e);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBorderDisabled", () => $3276e9745553f254$export$6d1640df421fce01);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBgError", () => $3276e9745553f254$export$ca6a6b82ca40bb5a);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBgDefault", () => $3276e9745553f254$export$d781c067583bc79e);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBgHover", () => $3276e9745553f254$export$f5d14a553904785b);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBgFocus", () => $3276e9745553f254$export$8447a3259160c2ce);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorBgDisabled", () => $3276e9745553f254$export$3af2ae30823e630b);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorTextError", () => $3276e9745553f254$export$e40e3dd55bf947be);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorTextDefault", () => $3276e9745553f254$export$52388e8c4eec52d7);
$parcel$export($3276e9745553f254$exports, "selectContainerlessColorTextDisabled", () => $3276e9745553f254$export$bfc21f912830cce0);
$parcel$export($3276e9745553f254$exports, "selectContainerlessRadius", () => $3276e9745553f254$export$84f8abf314fe1bca);
$parcel$export($3276e9745553f254$exports, "selectContainerlessBorderWidth", () => $3276e9745553f254$export$299de995c72a7f6d);
$parcel$export($3276e9745553f254$exports, "selectContainerlessPadding", () => $3276e9745553f254$export$994684c23b7a2289);
$parcel$export($3276e9745553f254$exports, "selectContainerlessSpaceBetween", () => $3276e9745553f254$export$d30bba31083c3b81);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBgDefault", () => $3276e9745553f254$export$c47c10b3a195b8bb);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBgHover", () => $3276e9745553f254$export$f1591bd858270ed3);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBgSelectedDefault", () => $3276e9745553f254$export$fea961df0553afcf);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBgSelectedHover", () => $3276e9745553f254$export$e5b0c44f8687a2dd);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBgDisabled", () => $3276e9745553f254$export$ba60f029700a5b9a);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBgStartEndDefault", () => $3276e9745553f254$export$fea74d0348af746c);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBgStartEndHover", () => $3276e9745553f254$export$c0cd56cb8adeb0c7);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBorderDefault", () => $3276e9745553f254$export$4c10101c8dcd9159);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBorderHover", () => $3276e9745553f254$export$199b8a3a24f6052f);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBorderSelectedDefault", () => $3276e9745553f254$export$749561d1ff3174b6);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBorderSelectedHover", () => $3276e9745553f254$export$5b7d5394e6b2d316);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBorderDisabled", () => $3276e9745553f254$export$639d3915b8ce82b4);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBorderStartEndDefault", () => $3276e9745553f254$export$f991c2a34a669c11);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorBorderStartEndHover", () => $3276e9745553f254$export$e05aad2434815ae1);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorTextDefault", () => $3276e9745553f254$export$a5efeb0d86e557f2);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorTextDisabled", () => $3276e9745553f254$export$ac0c6ce6db4c1549);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorTextStartEnd", () => $3276e9745553f254$export$cb7b1f2bb4f70437);
$parcel$export($3276e9745553f254$exports, "datepickerDayColorTextSelected", () => $3276e9745553f254$export$5b874dfd02e0b250);
$parcel$export($3276e9745553f254$exports, "datepickerDayBorderWidthSelected", () => $3276e9745553f254$export$3cfc12423f70daae);
$parcel$export($3276e9745553f254$exports, "datepickerDayBorderWidthDefault", () => $3276e9745553f254$export$454beb38955e81fd);
$parcel$export($3276e9745553f254$exports, "datepickerDaySize", () => $3276e9745553f254$export$e159fbe87f6978e3);
$parcel$export($3276e9745553f254$exports, "datepickerDayDefault", () => $3276e9745553f254$export$423b9caf92ea785c);
$parcel$export($3276e9745553f254$exports, "datepickerDaySelected", () => $3276e9745553f254$export$ea96f43ec25cb42a);
$parcel$export($3276e9745553f254$exports, "datepickerDayFontWeight", () => $3276e9745553f254$export$3f2b695522a06851);
$parcel$export($3276e9745553f254$exports, "datepickerDayFontSize", () => $3276e9745553f254$export$11aa2bc2efe9adc2);
$parcel$export($3276e9745553f254$exports, "datepickerContainerBorderWidth", () => $3276e9745553f254$export$5277ce3303456bf2);
$parcel$export($3276e9745553f254$exports, "datepickerContainerRadius", () => $3276e9745553f254$export$e652800607db6b2);
$parcel$export($3276e9745553f254$exports, "datepickerContainerPadding", () => $3276e9745553f254$export$3f1bc1575f23a5b9);
$parcel$export($3276e9745553f254$exports, "datepickerContainerSpaceBetween", () => $3276e9745553f254$export$6779021d34866272);
$parcel$export($3276e9745553f254$exports, "datepickerContainerColorBg", () => $3276e9745553f254$export$9b25e8846de5a4c6);
$parcel$export($3276e9745553f254$exports, "datepickerContainerColorBorder", () => $3276e9745553f254$export$7ea9497196b9950c);
$parcel$export($3276e9745553f254$exports, "datepickerContainerElevationFloating", () => $3276e9745553f254$export$1286c08a066cf92a);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBgDefault", () => $3276e9745553f254$export$452d31c71a4b2c7);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBgHover", () => $3276e9745553f254$export$29dfe4c30f5bdd8e);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBgSelectedDefault", () => $3276e9745553f254$export$a9fd54786af2362e);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBgSelectedHover", () => $3276e9745553f254$export$522ef6dd6d045e1a);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBgDisabled", () => $3276e9745553f254$export$76ed2592815724ef);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBorderDefault", () => $3276e9745553f254$export$82c6bb6f9ef8ad05);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBorderHover", () => $3276e9745553f254$export$7c79603c9689498a);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBorderSelectedDefault", () => $3276e9745553f254$export$c00e26acdc998f59);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBorderSelectedHover", () => $3276e9745553f254$export$e5b79ea5d86c9947);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorBorderDisabled", () => $3276e9745553f254$export$e2940776f75e7bde);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorTextDefault", () => $3276e9745553f254$export$d17ee04829bf7e5d);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorTextDisabled", () => $3276e9745553f254$export$e5f9b7707e340c07);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorTextStartEnd", () => $3276e9745553f254$export$4b146ead4a24d4ae);
$parcel$export($3276e9745553f254$exports, "datepickerTimeColorTextSelected", () => $3276e9745553f254$export$16eea8645753ec95);
$parcel$export($3276e9745553f254$exports, "datepickerTimeDefault", () => $3276e9745553f254$export$ac43e96d39af0fe9);
$parcel$export($3276e9745553f254$exports, "datepickerTimeBorderWidthSelected", () => $3276e9745553f254$export$175ca482ed6f6bca);
$parcel$export($3276e9745553f254$exports, "datepickerTimeBorderWidthDefault", () => $3276e9745553f254$export$732efe36f538d0b5);
$parcel$export($3276e9745553f254$exports, "datepickerTimeFontSize", () => $3276e9745553f254$export$51c06af4d25b7fbd);
$parcel$export($3276e9745553f254$exports, "datepickerTimeFontWeight", () => $3276e9745553f254$export$e24e0e94fc2167b7);
$parcel$export($3276e9745553f254$exports, "datepickerTimeSpaceBetween", () => $3276e9745553f254$export$26f066c1988aa416);
$parcel$export($3276e9745553f254$exports, "datepickerTimePadding", () => $3276e9745553f254$export$9213701f1f96ce09);
$parcel$export($3276e9745553f254$exports, "datepickerFontFamily", () => $3276e9745553f254$export$4931e5b26cc04c05);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherBorderWidthDefault", () => $3276e9745553f254$export$6074a5e235cbf222);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherBorderWidthTop", () => $3276e9745553f254$export$c6fd4855184f2ce4);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherBorderWidthFocus", () => $3276e9745553f254$export$e7c8cff1096cca6b);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBgDefault", () => $3276e9745553f254$export$5f3989fc72b355c5);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBgHover", () => $3276e9745553f254$export$694c340304b6cf03);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBgSelected", () => $3276e9745553f254$export$295da88ee730d887);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBgDisabled", () => $3276e9745553f254$export$e76dfb999cb566ad);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBgFocus", () => $3276e9745553f254$export$6105cdb447f0f917);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBorderDefault", () => $3276e9745553f254$export$7504fc34155ea4ea);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBorderHover", () => $3276e9745553f254$export$8af690634ab83d08);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBorderSelected", () => $3276e9745553f254$export$b0809c34687e6321);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBorderDisabled", () => $3276e9745553f254$export$e7169e000728aae0);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorBorderFocus", () => $3276e9745553f254$export$d49751a9f9c74d95);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorTextDefault", () => $3276e9745553f254$export$11780cad30f773c3);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorTextDisabled", () => $3276e9745553f254$export$13ff4d77bf18846);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherColorTextSelected", () => $3276e9745553f254$export$dd5841622912a30);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherRadiusBottom", () => $3276e9745553f254$export$4ab353e2521798aa);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherRadiusTop", () => $3276e9745553f254$export$f564560b1c0b69a0);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherPadding", () => $3276e9745553f254$export$f8de90cd42beeba7);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherFontFamily", () => $3276e9745553f254$export$f8d96a6e6e32683b);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherFontWeight", () => $3276e9745553f254$export$33b6ba26e004869a);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherLineHeight", () => $3276e9745553f254$export$e857928a445edf3);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherFontSize", () => $3276e9745553f254$export$600f9c33474c074e);
$parcel$export($3276e9745553f254$exports, "navigationAccountSwitcherLetterspacing", () => $3276e9745553f254$export$e7ff8df7907262bb);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerPrimaryColorBg", () => $3276e9745553f254$export$ee9afb269ebcf753);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerPrimaryColorBorder", () => $3276e9745553f254$export$905dbec0b0250e3b);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerPrimaryBorderWidth", () => $3276e9745553f254$export$ce6f6641c7bb2372);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerPrimaryRadius", () => $3276e9745553f254$export$4cbe16864bd24f8c);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerPrimaryWidth", () => $3276e9745553f254$export$521605d09d8c162c);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerPrimaryPadding", () => $3276e9745553f254$export$c425de24adc2b8b8);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerPrimarySpaceBetween", () => $3276e9745553f254$export$2d128d3377891546);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerSecondaryColorBg", () => $3276e9745553f254$export$170ee3bcb8ad49a0);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerSecondaryColorBorder", () => $3276e9745553f254$export$b9184a6500088a33);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerSecondaryBorderWidth", () => $3276e9745553f254$export$a133f97fe8f7af80);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerSecondaryRadius", () => $3276e9745553f254$export$440bfa12676d4362);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerSecondaryMinWidth", () => $3276e9745553f254$export$23df00f94a7966ab);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerSecondaryPadding", () => $3276e9745553f254$export$ddc6772884310bfd);
$parcel$export($3276e9745553f254$exports, "navigationNavContainerSecondarySpaceBetween", () => $3276e9745553f254$export$da255a4cc88a4cac);
$parcel$export($3276e9745553f254$exports, "chartsSizeBarWidth", () => $3276e9745553f254$export$b580f1a61f577587);
$parcel$export($3276e9745553f254$exports, "chartsSizePoint", () => $3276e9745553f254$export$d48962f1fd8fbdea);
$parcel$export($3276e9745553f254$exports, "chartsBorderWidthBar", () => $3276e9745553f254$export$113ff81b72ae4005);
$parcel$export($3276e9745553f254$exports, "chartsBorderWidthLine", () => $3276e9745553f254$export$aff0f3036f778118);
$parcel$export($3276e9745553f254$exports, "chartsBorderWidthAxis", () => $3276e9745553f254$export$105006e16cdb4368);
$parcel$export($3276e9745553f254$exports, "chartsBorderWidthRadar", () => $3276e9745553f254$export$83edc677e0bcbaf9);
$parcel$export($3276e9745553f254$exports, "chartsBorderWidthPointDefault", () => $3276e9745553f254$export$be459879692fda29);
$parcel$export($3276e9745553f254$exports, "chartsBorderWidthPointHover", () => $3276e9745553f254$export$586c2c06158e5801);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range10", () => $3276e9745553f254$export$a8ef96955ef6555c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range20", () => $3276e9745553f254$export$97032c77bb67830c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range30", () => $3276e9745553f254$export$6577f4536230e0ea);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range40", () => $3276e9745553f254$export$87b87f0038f4c66f);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range50", () => $3276e9745553f254$export$ec1dc93077563875);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range60", () => $3276e9745553f254$export$fce98b53ab002313);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range70", () => $3276e9745553f254$export$8e949091d329a301);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range80", () => $3276e9745553f254$export$94550a5bab2b5993);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range90", () => $3276e9745553f254$export$a8757e8f89513f1);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries1Range100", () => $3276e9745553f254$export$e985323c829fd742);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range10", () => $3276e9745553f254$export$19b7230ae44bbd30);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range20", () => $3276e9745553f254$export$b08be8e4ba1d6c82);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range30", () => $3276e9745553f254$export$145e11a833c7874d);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range40", () => $3276e9745553f254$export$90cf3f223c496a71);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range50", () => $3276e9745553f254$export$6244798137efca9);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range60", () => $3276e9745553f254$export$72d20d5426576de3);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range70", () => $3276e9745553f254$export$5f909f40ccaa6cc4);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range80", () => $3276e9745553f254$export$3e47cc0b9b14ad09);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range90", () => $3276e9745553f254$export$36569f0f035d32d1);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries2Range100", () => $3276e9745553f254$export$574e12a52c1b3e12);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range10", () => $3276e9745553f254$export$74d6e4fad4bb88bf);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range20", () => $3276e9745553f254$export$189fbb2766493c36);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range30", () => $3276e9745553f254$export$428da89f5a98a232);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range40", () => $3276e9745553f254$export$60edf238c6afd1e6);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range50", () => $3276e9745553f254$export$67e9edd6baebfbce);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range60", () => $3276e9745553f254$export$ec3d0a210a5d4c2c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range70", () => $3276e9745553f254$export$f776cf7a0a505749);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range80", () => $3276e9745553f254$export$61698398be922542);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range90", () => $3276e9745553f254$export$99028bd1491db588);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries3Range100", () => $3276e9745553f254$export$f0236e2c2ceff476);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range10", () => $3276e9745553f254$export$f944771630b59cb5);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range20", () => $3276e9745553f254$export$cf875bcb83eeef36);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range30", () => $3276e9745553f254$export$d22935b11cd2da96);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range40", () => $3276e9745553f254$export$c09b5156af934baf);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range50", () => $3276e9745553f254$export$cd03abab8825767c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range60", () => $3276e9745553f254$export$49d39abb22350b45);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range70", () => $3276e9745553f254$export$2e409639998b526b);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range80", () => $3276e9745553f254$export$7431a515da39af8c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range90", () => $3276e9745553f254$export$f34384d6e022c3f3);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries4Range100", () => $3276e9745553f254$export$10372af809834eae);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range10", () => $3276e9745553f254$export$a6eae9e7146720fd);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range20", () => $3276e9745553f254$export$1645795e3158abbf);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range30", () => $3276e9745553f254$export$cb63dd0ef69328da);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range40", () => $3276e9745553f254$export$8906d6ccc1d3cf97);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range50", () => $3276e9745553f254$export$9705a2ef585a5a6c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range60", () => $3276e9745553f254$export$9a4904530e74d69b);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range70", () => $3276e9745553f254$export$84fa53d9957f1633);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range80", () => $3276e9745553f254$export$261cc78142a16d2e);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range90", () => $3276e9745553f254$export$84de24a511e4409e);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries5Range100", () => $3276e9745553f254$export$c5da345c40af16d0);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range10", () => $3276e9745553f254$export$1a43e24e8356aef8);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range20", () => $3276e9745553f254$export$80cf8aa12b9a81d3);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range30", () => $3276e9745553f254$export$f060dd68476cd8e7);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range40", () => $3276e9745553f254$export$e439d3dd32b46274);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range50", () => $3276e9745553f254$export$a300ce07e8f90e40);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range60", () => $3276e9745553f254$export$a1ef18e9668adce2);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range70", () => $3276e9745553f254$export$6bc2d1ae052bf51c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range80", () => $3276e9745553f254$export$356c38cc88c30e38);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range90", () => $3276e9745553f254$export$4448f063fed043bf);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries6Range100", () => $3276e9745553f254$export$28182ad30600cb65);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range10", () => $3276e9745553f254$export$b0f38d080d1f8f97);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range20", () => $3276e9745553f254$export$abd8f528d3152ac4);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range30", () => $3276e9745553f254$export$6314df582966a22f);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range40", () => $3276e9745553f254$export$21214bfe4d7ae8b7);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range50", () => $3276e9745553f254$export$2b5f8a9ddff4d5c4);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range60", () => $3276e9745553f254$export$b63bfe40c28df8c8);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range70", () => $3276e9745553f254$export$a288b1bef1f363d6);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range80", () => $3276e9745553f254$export$ca2242167f4cec64);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range90", () => $3276e9745553f254$export$bb1d5655a98e9de6);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries7Range100", () => $3276e9745553f254$export$113cda6f600a4ca4);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range10", () => $3276e9745553f254$export$8ec4c1f865bc4296);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range20", () => $3276e9745553f254$export$80f831c9571e7721);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range30", () => $3276e9745553f254$export$7baea4598e0903db);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range40", () => $3276e9745553f254$export$85cc5b9d5a5e8f07);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range50", () => $3276e9745553f254$export$c16430852d6ffb13);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range60", () => $3276e9745553f254$export$76289a8af80837cf);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range70", () => $3276e9745553f254$export$52b981bfeaa81760);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range80", () => $3276e9745553f254$export$8e617b33cbf4490c);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range90", () => $3276e9745553f254$export$a1aa25fd6a117918);
$parcel$export($3276e9745553f254$exports, "chartsColorSeries8Range100", () => $3276e9745553f254$export$f01739baaf9b181d);
$parcel$export($3276e9745553f254$exports, "chartsColorBorderBar", () => $3276e9745553f254$export$d90969089c78ff1a);
$parcel$export($3276e9745553f254$exports, "chartsColorBorderAxis", () => $3276e9745553f254$export$fcb89087e092a414);
$parcel$export($3276e9745553f254$exports, "chartsFontFamilyLabel", () => $3276e9745553f254$export$9bbe1e2e7d502781);
$parcel$export($3276e9745553f254$exports, "chartsFontWeightLabel", () => $3276e9745553f254$export$4a1d1c93af63034c);
$parcel$export($3276e9745553f254$exports, "chartsFontSizeLabel", () => $3276e9745553f254$export$440443a29ae7f444);
$parcel$export($3276e9745553f254$exports, "chartsLetterSpacingLabel", () => $3276e9745553f254$export$d87dd6c52509ab1c);
$parcel$export($3276e9745553f254$exports, "chartsLineHeightLabel", () => $3276e9745553f254$export$3f3169f0677cff68);
$parcel$export($3276e9745553f254$exports, "numberColorBgStaticSubtle", () => $3276e9745553f254$export$5e89ca37329331db);
$parcel$export($3276e9745553f254$exports, "numberColorBgStaticNeutral", () => $3276e9745553f254$export$2d683b41f8da6ca4);
$parcel$export($3276e9745553f254$exports, "numberColorBgStaticEmphasis", () => $3276e9745553f254$export$73731597f6e69c9d);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveSubtleDefault", () => $3276e9745553f254$export$c927c3e959fbe8b);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveSubtleHover", () => $3276e9745553f254$export$a0f7cf38a8a00f2b);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveSubtleFocus", () => $3276e9745553f254$export$29f6789a57993025);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$4ec39546e154299);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$3f64927d3a4eb9ea);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveNeutralDefault", () => $3276e9745553f254$export$cfdc6390a7fab5c8);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveNeutralHover", () => $3276e9745553f254$export$65e1e963096c903);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveNeutralFocus", () => $3276e9745553f254$export$6241dacc1b50fceb);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$fdbf6d5d010addf8);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$50b1b763cf3e7ade);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveEmphasisDefault", () => $3276e9745553f254$export$40362ccc2bdb3c26);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveEmphasisHover", () => $3276e9745553f254$export$c204c1784cc516d0);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveEmphasisFocus", () => $3276e9745553f254$export$2365ee05eae2bf7f);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$647245f05226e9f7);
$parcel$export($3276e9745553f254$exports, "numberColorBgInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$794da0ddda9a3107);
$parcel$export($3276e9745553f254$exports, "numberColorBgErrorSubtle", () => $3276e9745553f254$export$739a8d1bcdc7839d);
$parcel$export($3276e9745553f254$exports, "numberColorBorderStaticSubtle", () => $3276e9745553f254$export$94e174e73f70f159);
$parcel$export($3276e9745553f254$exports, "numberColorBorderStaticNeutral", () => $3276e9745553f254$export$788d135191815d53);
$parcel$export($3276e9745553f254$exports, "numberColorBorderStaticEmphasis", () => $3276e9745553f254$export$2f7f338c6ca49382);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveSubtleDefault", () => $3276e9745553f254$export$48e34a2ffe6a00d7);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveSubtleHover", () => $3276e9745553f254$export$22ef0123e9b7779c);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveSubtleFocus", () => $3276e9745553f254$export$606938ff76eef7ca);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$c46a37e46831cb73);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$59052749eca57609);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveNeutralDefault", () => $3276e9745553f254$export$dd96312fb32772ab);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveNeutralHover", () => $3276e9745553f254$export$eed6b1452607cf56);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveNeutralFocus", () => $3276e9745553f254$export$acced8db4ae2cf3b);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$77b24f6d99070e59);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$b34450f407ef29c6);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveEmphasisDefault", () => $3276e9745553f254$export$ac70beace51d0dd4);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveEmphasisHover", () => $3276e9745553f254$export$5c9eeed4e201b90e);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveEmphasisFocus", () => $3276e9745553f254$export$f49ed7789dc61221);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$ddf2fa79327928f);
$parcel$export($3276e9745553f254$exports, "numberColorBorderInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$f77baad962a57c8f);
$parcel$export($3276e9745553f254$exports, "numberColorTextStaticSubtle", () => $3276e9745553f254$export$98ddb5e8ed3aa914);
$parcel$export($3276e9745553f254$exports, "numberColorTextStaticNeutral", () => $3276e9745553f254$export$1530dbd1b63da1da);
$parcel$export($3276e9745553f254$exports, "numberColorTextStaticEmphasis", () => $3276e9745553f254$export$9d2d9318edad804e);
$parcel$export($3276e9745553f254$exports, "numberColorTextInteractiveSubtle", () => $3276e9745553f254$export$a83f4a80f6994355);
$parcel$export($3276e9745553f254$exports, "numberColorTextError", () => $3276e9745553f254$export$72489d62081edb03);
$parcel$export($3276e9745553f254$exports, "numberBorderRadiusDefault", () => $3276e9745553f254$export$266ec36a94b31c7b);
$parcel$export($3276e9745553f254$exports, "numberBorderRadiusRound", () => $3276e9745553f254$export$1600af1791f8b4f);
$parcel$export($3276e9745553f254$exports, "numberBorderWidthDefault", () => $3276e9745553f254$export$914b4b6244542bbf);
$parcel$export($3276e9745553f254$exports, "numberBorderWidthOutlined", () => $3276e9745553f254$export$44d950c57bc9d93);
$parcel$export($3276e9745553f254$exports, "numberFontFamily", () => $3276e9745553f254$export$be2a9d19912bffe8);
$parcel$export($3276e9745553f254$exports, "numberFontWeight", () => $3276e9745553f254$export$95492bbb433b5945);
$parcel$export($3276e9745553f254$exports, "numberLetterSpacing", () => $3276e9745553f254$export$761832cf77cf363a);
$parcel$export($3276e9745553f254$exports, "numberFontSizeMedium", () => $3276e9745553f254$export$b0eb4ef8cfa78960);
$parcel$export($3276e9745553f254$exports, "numberFontSizeSmall", () => $3276e9745553f254$export$fed43e5dcd48f2dc);
$parcel$export($3276e9745553f254$exports, "numberFontSizeInput", () => $3276e9745553f254$export$ae8f35fee23fdd6b);
$parcel$export($3276e9745553f254$exports, "numberLineHeightInput", () => $3276e9745553f254$export$8862b9c5fc58c4fc);
$parcel$export($3276e9745553f254$exports, "numberLineHeightSmall", () => $3276e9745553f254$export$50a8a424d0152755);
$parcel$export($3276e9745553f254$exports, "numberLineHeightMedium", () => $3276e9745553f254$export$bc28f5283ef6ba98);
$parcel$export($3276e9745553f254$exports, "numberHeightS", () => $3276e9745553f254$export$291904bb2e85d148);
$parcel$export($3276e9745553f254$exports, "numberHeightM", () => $3276e9745553f254$export$daf145493ab9a6de);
$parcel$export($3276e9745553f254$exports, "numberHeightInput", () => $3276e9745553f254$export$415502a94bbbbee6);
$parcel$export($3276e9745553f254$exports, "numberPaddingS", () => $3276e9745553f254$export$465097bd75bdea60);
$parcel$export($3276e9745553f254$exports, "numberPaddingM", () => $3276e9745553f254$export$42d141f7fb68da3c);
$parcel$export($3276e9745553f254$exports, "numberPaddingInput", () => $3276e9745553f254$export$5584196c725943b3);
$parcel$export($3276e9745553f254$exports, "numberMinWidthS", () => $3276e9745553f254$export$118d0bac41bf5c6f);
$parcel$export($3276e9745553f254$exports, "numberMinWidthM", () => $3276e9745553f254$export$b998fc4e363ee792);
$parcel$export($3276e9745553f254$exports, "numberMinWidthInput", () => $3276e9745553f254$export$c30418f3955f4770);
$parcel$export($3276e9745553f254$exports, "stepperSpaceBetween", () => $3276e9745553f254$export$c511e0cf300b027a);
$parcel$export($3276e9745553f254$exports, "stepperPadding", () => $3276e9745553f254$export$54041063a1bf9d9f);
$parcel$export($3276e9745553f254$exports, "scrollbarSize", () => $3276e9745553f254$export$fd2f38d8a289271e);
$parcel$export($3276e9745553f254$exports, "scrollbarKnobColorBg", () => $3276e9745553f254$export$6c2cf414b9a8b02);
$parcel$export($3276e9745553f254$exports, "scrollbarBorderRadius", () => $3276e9745553f254$export$74e8af3218f82048);
$parcel$export($3276e9745553f254$exports, "scrollbarContainerColorBg", () => $3276e9745553f254$export$d631136dbd4f130);
$parcel$export($3276e9745553f254$exports, "scrollbarSpacePadding", () => $3276e9745553f254$export$91580955f5b11a78);
$parcel$export($3276e9745553f254$exports, "listItemColorBgStaticSubtle", () => $3276e9745553f254$export$2804a19e6721cd4d);
$parcel$export($3276e9745553f254$exports, "listItemColorBgStaticNeutral", () => $3276e9745553f254$export$cd2372d2a66c08ad);
$parcel$export($3276e9745553f254$exports, "listItemColorBgStaticEmphasis", () => $3276e9745553f254$export$8ef196ecc87f7934);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveSubtleDefault", () => $3276e9745553f254$export$af7cd107f275c02a);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveSubtleHover", () => $3276e9745553f254$export$8490f4d3874147a3);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveSubtleFocus", () => $3276e9745553f254$export$b7a95a89583d4770);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$6bc9aee632a0607d);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$efbbc87ef9efc62c);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveNeutralDefault", () => $3276e9745553f254$export$5500a3415a8200bf);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveNeutralHover", () => $3276e9745553f254$export$895d192a083edbcd);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveNeutralFocus", () => $3276e9745553f254$export$f8f9f853acd8dccc);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$a2b2fba0efcb64de);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$abb81216d8ead6d6);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveEmphasisDefault", () => $3276e9745553f254$export$c18fc16fd6ce2893);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveEmphasisHover", () => $3276e9745553f254$export$9a9b411077d65d4);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveEmphasisFocus", () => $3276e9745553f254$export$84ee0041f3b78053);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$e3ae326d33644c8f);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$f2093864c9741f6c);
$parcel$export($3276e9745553f254$exports, "listItemColorBgInteractiveDisabled", () => $3276e9745553f254$export$50e035363ae06a71);
$parcel$export($3276e9745553f254$exports, "listItemColorBorderStaticDefault", () => $3276e9745553f254$export$8d5f9203840e8cea);
$parcel$export($3276e9745553f254$exports, "listItemColorBorderStaticBottomborderDefault", () => $3276e9745553f254$export$6429134805d4f7b2);
$parcel$export($3276e9745553f254$exports, "listItemColorBorderStaticBottomborderInverse", () => $3276e9745553f254$export$47bc82913eb62f9a);
$parcel$export($3276e9745553f254$exports, "listItemColorBorderInteractiveSelected", () => $3276e9745553f254$export$9a8ea6b0632902f8);
$parcel$export($3276e9745553f254$exports, "listItemColorBorderInteractiveDefault", () => $3276e9745553f254$export$9cea3abece3796dd);
$parcel$export($3276e9745553f254$exports, "listItemColorTextStatic", () => $3276e9745553f254$export$147f5a94c0d93a24);
$parcel$export($3276e9745553f254$exports, "listItemColorTextInteractive", () => $3276e9745553f254$export$30427793cdcc11f);
$parcel$export($3276e9745553f254$exports, "listItemColorTextInverse", () => $3276e9745553f254$export$8dd2be958a4f682c);
$parcel$export($3276e9745553f254$exports, "listItemColorTextDisabled", () => $3276e9745553f254$export$6941f05285867423);
$parcel$export($3276e9745553f254$exports, "listItemColorTextSelected", () => $3276e9745553f254$export$4b525576dbb2a4d);
$parcel$export($3276e9745553f254$exports, "listItemBorderWidthBottomSeparated", () => $3276e9745553f254$export$ad62b5a3f8569d6e);
$parcel$export($3276e9745553f254$exports, "listItemBorderWidthBottomDefault", () => $3276e9745553f254$export$946b06a7a267d247);
$parcel$export($3276e9745553f254$exports, "listItemHeightS", () => $3276e9745553f254$export$2400272ad19e2fe5);
$parcel$export($3276e9745553f254$exports, "listItemHeightM", () => $3276e9745553f254$export$993c88baafc7364);
$parcel$export($3276e9745553f254$exports, "listItemHeightL", () => $3276e9745553f254$export$9bebe7546b06ea6b);
$parcel$export($3276e9745553f254$exports, "listItemSpaceDense", () => $3276e9745553f254$export$e1d34ffbb73e4967);
$parcel$export($3276e9745553f254$exports, "listItemSpaceDefault", () => $3276e9745553f254$export$6c9ea1231c05ae2);
$parcel$export($3276e9745553f254$exports, "listItemSpaceSpacious", () => $3276e9745553f254$export$34e1f4c8e40a4ed4);
$parcel$export($3276e9745553f254$exports, "listItemRadiusDefault", () => $3276e9745553f254$export$6f5f0ec032a5cd2a);
$parcel$export($3276e9745553f254$exports, "popoverWidthM", () => $3276e9745553f254$export$3533b594e8a22e61);
$parcel$export($3276e9745553f254$exports, "popoverWidthL", () => $3276e9745553f254$export$3162d64b8e7996c0);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveSubtleDefault", () => $3276e9745553f254$export$904c18abb803aa9f);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveSubtleHover", () => $3276e9745553f254$export$cfbe570aaf4a5b77);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveSubtleFocus", () => $3276e9745553f254$export$ac0e121c105675cd);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$9e386e8d2c73a924);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$63daf5c1ff2410fd);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveNeutralDefault", () => $3276e9745553f254$export$2167e31118bb40d7);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveNeutralHover", () => $3276e9745553f254$export$966b83fbdad8ff13);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveNeutralFocus", () => $3276e9745553f254$export$c06450425bd9035c);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$ddde5722037bdb1a);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$544f4daa03c97c0c);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveDisabled", () => $3276e9745553f254$export$633198cc99623271);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveEmphasisDefault", () => $3276e9745553f254$export$fbbb4a5d1412c3f3);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveEmphasisHover", () => $3276e9745553f254$export$35db974a8b01923c);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveEmphasisFocus", () => $3276e9745553f254$export$42938dc8e4554ca);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$4a1178fab316a183);
$parcel$export($3276e9745553f254$exports, "cardColorBgInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$c114ec50f0f18b26);
$parcel$export($3276e9745553f254$exports, "cardColorBgStaticSubtle", () => $3276e9745553f254$export$f5465bf2d3de925d);
$parcel$export($3276e9745553f254$exports, "cardColorBgStaticNeutral", () => $3276e9745553f254$export$6053f363b9ebffff);
$parcel$export($3276e9745553f254$exports, "cardColorBgStaticEmphasis", () => $3276e9745553f254$export$f3f16eb733cd113b);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveEmphasisDefault", () => $3276e9745553f254$export$f49a1acfc2525900);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveEmphasisHover", () => $3276e9745553f254$export$514e04a8b12a1404);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveEmphasisFocus", () => $3276e9745553f254$export$95733713edee3c14);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveEmphasisSelectedDefault", () => $3276e9745553f254$export$28932b8bfce45f38);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveEmphasisSelectedHover", () => $3276e9745553f254$export$edce63b38f08b44d);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveSubtleDefault", () => $3276e9745553f254$export$fa6c9f7aabe0a2e2);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveSubtleHover", () => $3276e9745553f254$export$623652b8691265a);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveSubtleFocus", () => $3276e9745553f254$export$b8ffe5941b3130ba);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$18e765ec8d586da3);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$36f1da88e0a16b94);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveNeutralDefault", () => $3276e9745553f254$export$bbe5df2b165b1606);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveNeutralHover", () => $3276e9745553f254$export$67562899c4dd8d01);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveNeutralFocus", () => $3276e9745553f254$export$c0908d88aaa39084);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$2035a1d319e4a134);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$290823ff5c4d6a31);
$parcel$export($3276e9745553f254$exports, "cardColorBorderInteractiveDisabled", () => $3276e9745553f254$export$9a7c2ed2267bf628);
$parcel$export($3276e9745553f254$exports, "cardColorBorderStaticSubtle", () => $3276e9745553f254$export$7d32452142f66e8);
$parcel$export($3276e9745553f254$exports, "cardColorBorderStaticNeutral", () => $3276e9745553f254$export$91106c4c34773b8b);
$parcel$export($3276e9745553f254$exports, "cardColorBorderStaticEmphasis", () => $3276e9745553f254$export$78ccf4c9305987f2);
$parcel$export($3276e9745553f254$exports, "cardSpaceDense", () => $3276e9745553f254$export$9fb0c8224ca90269);
$parcel$export($3276e9745553f254$exports, "cardSpaceDefault", () => $3276e9745553f254$export$f38773b397c64fe3);
$parcel$export($3276e9745553f254$exports, "cardSpaceSpacious", () => $3276e9745553f254$export$68dfe0e438ed927f);
$parcel$export($3276e9745553f254$exports, "cardBorderWidthDefault", () => $3276e9745553f254$export$6b1192f8dbbe8ca4);
$parcel$export($3276e9745553f254$exports, "cardBorderWidthNone", () => $3276e9745553f254$export$9006004e350aae36);
$parcel$export($3276e9745553f254$exports, "cardBorderRadiusDefault", () => $3276e9745553f254$export$4933986e86984502);
$parcel$export($3276e9745553f254$exports, "cardBorderRadiusSharp", () => $3276e9745553f254$export$a08a5ca1c9e2d77);
$parcel$export($3276e9745553f254$exports, "cardBorderRadiusRound", () => $3276e9745553f254$export$4428090006cc5e8f);
$parcel$export($3276e9745553f254$exports, "cardBoxShadowDefault", () => $3276e9745553f254$export$6b437ae17434a562);
$parcel$export($3276e9745553f254$exports, "cardBoxShadowFloating", () => $3276e9745553f254$export$e439e7a9a522c8bd);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveSubtleDefault", () => $3276e9745553f254$export$f6f9c9aa81f0acb9);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveSubtleHover", () => $3276e9745553f254$export$5707e412b97a3d17);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveSubtleFocus", () => $3276e9745553f254$export$7ee0f670470f616e);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveSubtleSelectedDefault", () => $3276e9745553f254$export$602a5bdac5f15cd4);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveSubtleSelectedHover", () => $3276e9745553f254$export$a4b65a2a4760aa2e);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveNeutralDefault", () => $3276e9745553f254$export$99b6fb3a8cddfde2);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveNeutralHover", () => $3276e9745553f254$export$6f41d812463dcc26);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveNeutralFocus", () => $3276e9745553f254$export$bd26b519eb710637);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveNeutralSelectedDefault", () => $3276e9745553f254$export$8c129a8c71396c89);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveNeutralSelectedHover", () => $3276e9745553f254$export$ea53d93807b2be6c);
$parcel$export($3276e9745553f254$exports, "treeItemColorBgInteractiveDisabled", () => $3276e9745553f254$export$de181742c8a3a8ed);
$parcel$export($3276e9745553f254$exports, "treeItemColorBorderDefault", () => $3276e9745553f254$export$ac909337994ad4cc);
$parcel$export($3276e9745553f254$exports, "treeItemColorBorderSelected", () => $3276e9745553f254$export$47cee41927ea7a65);
$parcel$export($3276e9745553f254$exports, "treeItemColorTextStatic", () => $3276e9745553f254$export$29bf0efdf9aa6973);
$parcel$export($3276e9745553f254$exports, "treeItemColorTextDisabled", () => $3276e9745553f254$export$2a97efadeb1968eb);
$parcel$export($3276e9745553f254$exports, "treeItemSpaceDense", () => $3276e9745553f254$export$f074b54a1a690e59);
$parcel$export($3276e9745553f254$exports, "treeItemSpaceDefault", () => $3276e9745553f254$export$9f94c55002684827);
$parcel$export($3276e9745553f254$exports, "treeItemSpaceSpacious", () => $3276e9745553f254$export$ae05400eb6210b52);
$parcel$export($3276e9745553f254$exports, "treeItemBorderWidthBottom", () => $3276e9745553f254$export$8ea2eaf73829f82b);
$parcel$export($3276e9745553f254$exports, "treeItemBorderWidthDefault", () => $3276e9745553f254$export$5ead36882857d7b8);
/**
 * Do not edit directly
 * Generated on Fri, 06 Jun 2025 12:28:39 GMT
 */ const $3276e9745553f254$export$47532a6f57be45d9 = "700";
const $3276e9745553f254$export$740ac66abb38bb83 = "600";
const $3276e9745553f254$export$90168a3412ee7f0c = "400";
const $3276e9745553f254$export$9b985e69928d4804 = "linear-gradient(225deg, #FFF 0%, #F2F4F9 35.41%, #E7F1F6 100%);";
const $3276e9745553f254$export$6e4689b7cf6aeadb = "linear-gradient(132deg, #F0F3FA 0%, #FBFCFF 100%);";
const $3276e9745553f254$export$c473f2d55633c7bf = "linear-gradient(132deg, #29333D 0%, #001C33 100%);";
const $3276e9745553f254$export$bf51732c1e402305 = "hsl(202, 100%, 30%)";
const $3276e9745553f254$export$dd6ac6c529280b28 = "hsl(202, 100%, 40%)";
const $3276e9745553f254$export$628bc4cedab3f39c = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$12d92729ec24385a = "hsl(169, 82%, 33%)";
const $3276e9745553f254$export$4a7539ac23adfb7a = "hsl(346, 37%, 33%)";
const $3276e9745553f254$export$fb8a8a98f73ce6b1 = "hsl(346, 37%, 43%)";
const $3276e9745553f254$export$60723b7193f02e02 = "hsl(151, 46%, 17%)";
const $3276e9745553f254$export$795334c6456d2730 = "hsl(151, 46%, 27%)";
const $3276e9745553f254$export$da6517e7d9c36003 = "hsl(266, 63%, 35%)";
const $3276e9745553f254$export$3b7ffecbd7cc9aeb = "hsl(266, 63%, 45%)";
const $3276e9745553f254$export$2c3279dd523ce91e = "hsl(36, 77%, 30%)";
const $3276e9745553f254$export$a32ed79b0c9f894d = "hsl(36, 77%, 40%)";
const $3276e9745553f254$export$364c018f7a909db3 = "hsl(36, 97%, 60%)";
const $3276e9745553f254$export$5f85a6a7c51d6890 = "hsl(36, 97%, 70%)";
const $3276e9745553f254$export$436b1e2e43974ada = "hsl(301, 73%, 65%)";
const $3276e9745553f254$export$a9aeb5d8dac66b57 = "hsl(301, 73%, 75%)";
const $3276e9745553f254$export$684e73d930ab653c = "hsl(30, 70%, 10%)";
const $3276e9745553f254$export$1181582ac6088c50 = "hsl(30, 70%, 20%)";
const $3276e9745553f254$export$b2d49d7677da6748 = "hsl(30, 70%, 30%)";
const $3276e9745553f254$export$b6a1b5443e554bac = "hsl(30, 70%, 40%)";
const $3276e9745553f254$export$3b8a5dc0c17f71c2 = "hsl(30, 70%, 50%)";
const $3276e9745553f254$export$8b7438de76999a40 = "hsl(30, 70%, 60%)";
const $3276e9745553f254$export$2b5d6b20a9c67c77 = "hsl(30, 70%, 70%)";
const $3276e9745553f254$export$5afcf229520f3e = "hsl(30, 70%, 82%)";
const $3276e9745553f254$export$d61e61546d5dbc3b = "hsl(30, 70%, 86%)";
const $3276e9745553f254$export$5acbd671bcb55bbc = "hsl(30, 70%, 88%)";
const $3276e9745553f254$export$ae55d2493bfc2288 = "hsl(30, 70%, 90%)";
const $3276e9745553f254$export$d92f008db791081b = "hsl(30, 70%, 92%)";
const $3276e9745553f254$export$16492d98578c318 = "hsl(30, 70%, 96%)";
const $3276e9745553f254$export$3a485bc73a43c0d = "hsl(30, 70%, 98%)";
const $3276e9745553f254$export$73c61615faaec16d = "hsl(150, 50%, 10%)";
const $3276e9745553f254$export$f61d2734a97ec44d = "hsl(150, 50%, 20%)";
const $3276e9745553f254$export$db59b2d9d3b8f23 = "hsl(150, 50%, 30%)";
const $3276e9745553f254$export$2fc86281a892e4e9 = "hsl(150, 50%, 40%)";
const $3276e9745553f254$export$65018fb6acb6e9e = "hsl(150, 50%, 50%)";
const $3276e9745553f254$export$6f52551cdcf848f2 = "hsl(150, 50%, 60%)";
const $3276e9745553f254$export$8717c4e3eb9150e5 = "hsl(150, 50%, 70%)";
const $3276e9745553f254$export$c83198aa8943b17f = "hsl(150, 50%, 82%)";
const $3276e9745553f254$export$8c35a5b2f64f36d = "hsl(150, 50%, 86%)";
const $3276e9745553f254$export$6ff44857ae98393 = "hsl(150, 50%, 88%)";
const $3276e9745553f254$export$8fc5d73ef8daa081 = "hsl(150, 50%, 90%)";
const $3276e9745553f254$export$ca9d34853847d885 = "hsl(150, 50%, 92%)";
const $3276e9745553f254$export$5e3d63bd09e2adfa = "hsl(150, 50%, 96%)";
const $3276e9745553f254$export$a31d2a5d6f4951c3 = "hsl(150, 50%, 98%)";
const $3276e9745553f254$export$2fa8052ddbf692db = "hsl(350, 70%, 10%)";
const $3276e9745553f254$export$5ae3653bea2f6002 = "hsl(350, 70%, 20%)";
const $3276e9745553f254$export$ebe209ab71dc9900 = "hsl(350, 70%, 30%)";
const $3276e9745553f254$export$9a86551a13d806cb = "hsl(350, 70%, 40%)";
const $3276e9745553f254$export$c10c79645b27877d = "hsl(350, 70%, 50%)";
const $3276e9745553f254$export$3162b4069185c8ae = "hsl(350, 70%, 60%)";
const $3276e9745553f254$export$b001b9d8cf2ddf0c = "hsl(350, 70%, 70%)";
const $3276e9745553f254$export$2bcac13af88081c8 = "hsl(350, 70%, 82%)";
const $3276e9745553f254$export$72d98e4ddcb0af1b = "hsl(350, 70%, 86%)";
const $3276e9745553f254$export$45fc9997e1ebd965 = "hsl(350, 70%, 88%)";
const $3276e9745553f254$export$f8218d553727ff09 = "hsl(350, 70%, 90%)";
const $3276e9745553f254$export$c31b4867424b9387 = "hsl(350, 70%, 92%)";
const $3276e9745553f254$export$6c46c4d114584df1 = "hsl(350, 70%, 96%)";
const $3276e9745553f254$export$4bd1bc01799161bf = "hsl(350, 70%, 98%)";
const $3276e9745553f254$export$b68a36b2c4312600 = "hsl(50, 70%, 10%)";
const $3276e9745553f254$export$bf9058acbc7e0c03 = "hsl(50, 70%, 20%)";
const $3276e9745553f254$export$af58e6c4e06fba1e = "hsl(50, 70%, 30%)";
const $3276e9745553f254$export$f5c847ebf0c3830d = "hsl(50, 70%, 40%)";
const $3276e9745553f254$export$d65df8bd9766ab30 = "hsl(50, 70%, 50%)";
const $3276e9745553f254$export$6dea6221146a7695 = "hsl(50, 70%, 60%)";
const $3276e9745553f254$export$97794df832fa9246 = "hsl(50, 70%, 70%)";
const $3276e9745553f254$export$37a6ad6644a76e8e = "hsl(50, 70%, 82%)";
const $3276e9745553f254$export$b2cc4270764e0d91 = "hsl(50, 70%, 86%)";
const $3276e9745553f254$export$145e03b0063171cf = "hsl(50, 70%, 88%)";
const $3276e9745553f254$export$2d9c2b11822ba826 = "hsl(50, 70%, 90%)";
const $3276e9745553f254$export$d06c19130b7b237c = "hsl(50, 70%, 92%)";
const $3276e9745553f254$export$d2a0a2228c20f625 = "hsl(50, 70%, 96%)";
const $3276e9745553f254$export$b1a4a810c6323520 = "hsl(50, 70%, 98%)";
const $3276e9745553f254$export$d5f6f1514cdd87e = "hsl(270, 50%, 10%)";
const $3276e9745553f254$export$abc0c049d1d05997 = "hsl(270, 50%, 20%)";
const $3276e9745553f254$export$e3e4f6af628aad6d = "hsl(270, 50%, 30%)";
const $3276e9745553f254$export$a93c9c9f412d3c5e = "hsl(270, 50%, 40%)";
const $3276e9745553f254$export$d73ff2918ee90459 = "hsl(270, 50%, 50%)";
const $3276e9745553f254$export$7c691d76a2faac9e = "hsl(270, 50%, 60%)";
const $3276e9745553f254$export$9ddac4fed8e0699e = "hsl(270, 50%, 70%)";
const $3276e9745553f254$export$70b4d49a036ffa16 = "hsl(270, 50%, 82%)";
const $3276e9745553f254$export$b6ae9037e4487ef7 = "hsl(270, 50%, 86%)";
const $3276e9745553f254$export$cdab03f0b3cedea7 = "hsl(270, 50%, 88%)";
const $3276e9745553f254$export$9a3940ef3e718482 = "hsl(270, 50%, 90%)";
const $3276e9745553f254$export$602a7aa90012bac7 = "hsl(270, 50%, 92%)";
const $3276e9745553f254$export$f9e1bb5a6ecf8fa1 = "hsl(270, 50%, 96%)";
const $3276e9745553f254$export$9665fc79e7ccde89 = "hsl(270, 50%, 98%)";
const $3276e9745553f254$export$415e2ab0a19e9f81 = "hsl(210, 20%, 10%)";
const $3276e9745553f254$export$9ad9d3db52ccd355 = "hsl(210, 20%, 20%)";
const $3276e9745553f254$export$17b617ddb9836542 = "hsl(210, 20%, 30%)";
const $3276e9745553f254$export$664987001e0f2ea0 = "hsl(210, 20%, 40%)";
const $3276e9745553f254$export$58adf4043506cd3a = "hsl(210, 20%, 50%)";
const $3276e9745553f254$export$d3adcc2d4402ccc9 = "hsl(210, 20%, 60%)";
const $3276e9745553f254$export$7155de5e23ab069b = "hsl(210, 20%, 70%)";
const $3276e9745553f254$export$41ee37b64344becb = "hsl(210, 20%, 82%)";
const $3276e9745553f254$export$9b88c99aa981baee = "hsl(210, 20%, 86%)";
const $3276e9745553f254$export$7c23125fd8a70a5a = "hsl(210, 20%, 88%)";
const $3276e9745553f254$export$a46d9e94ee27516a = "hsl(210, 20%, 90%)";
const $3276e9745553f254$export$57a7b6c7405c22fc = "hsl(210, 20%, 92%)";
const $3276e9745553f254$export$8c671b06252447da = "hsl(210, 20%, 96%)";
const $3276e9745553f254$export$905ab8f8acc3167f = "hsl(210, 20%, 98%)";
const $3276e9745553f254$export$df8147df7c327e97 = "#001c33";
const $3276e9745553f254$export$23afbb4232b3ac3a = "hsl(207, 100%, 20%)";
const $3276e9745553f254$export$5fcc389c3d56da1a = "hsl(207, 100%, 30%)";
const $3276e9745553f254$export$ae23f4fa1dd8e463 = "hsl(207, 100%, 40%)";
const $3276e9745553f254$export$6e85f1855ac4540b = "hsl(207, 100%, 50%)";
const $3276e9745553f254$export$8740b6c0177f90d2 = "hsl(207, 100%, 60%)";
const $3276e9745553f254$export$8c220e0ccc521b52 = "hsl(207, 100%, 70%)";
const $3276e9745553f254$export$694b034c84505cc0 = "hsl(207, 100%, 82%)";
const $3276e9745553f254$export$107dfa3b1934715e = "hsl(207, 100%, 86%)";
const $3276e9745553f254$export$a98a55e2124bd475 = "hsl(207, 100%, 88%)";
const $3276e9745553f254$export$c8bb10ac89484313 = "hsl(207, 100%, 90%)";
const $3276e9745553f254$export$1ac92e121667df0a = "hsl(207, 100%, 92%)";
const $3276e9745553f254$export$416d4299ae18b901 = "hsl(207, 100%, 96%)";
const $3276e9745553f254$export$3bf92297e3902f9c = "hsl(207, 100%, 98%)";
const $3276e9745553f254$export$db52f91b6e279a41 = "hsl(200, 30%, 10%)";
const $3276e9745553f254$export$c2bda980025d9828 = "hsl(200, 30%, 20%)";
const $3276e9745553f254$export$8ed151e7392922f7 = "hsl(200, 30%, 30%)";
const $3276e9745553f254$export$f0cf2df1783c1493 = "hsl(200, 30%, 40%)";
const $3276e9745553f254$export$c537f1eb6dbc51ff = "hsl(200, 30%, 50%)";
const $3276e9745553f254$export$63fb948eab7d44b0 = "hsl(200, 30%, 60%)";
const $3276e9745553f254$export$b8bfc202936f7e3d = "hsl(200, 30%, 70%)";
const $3276e9745553f254$export$31ed9a0baa9a125c = "hsl(200, 30%, 82%)";
const $3276e9745553f254$export$fafb7a10ea280ee = "hsl(200, 30%, 86%)";
const $3276e9745553f254$export$b5c0ad53ffc9440b = "hsl(200, 30%, 88%)";
const $3276e9745553f254$export$6f8e87618ad20850 = "hsl(200, 30%, 90%)";
const $3276e9745553f254$export$b8ccb55082565c20 = "hsl(200, 30%, 92%)";
const $3276e9745553f254$export$c824d3ae1ea71c9d = "hsl(200, 30%, 96%)";
const $3276e9745553f254$export$aa19e6addb4fb53d = "hsl(200, 30%, 98%)";
const $3276e9745553f254$export$eaa1ebf3c9e3051b = "#ffffff";
const $3276e9745553f254$export$da7a3b2eb1ec75df = "0 5px 12px 2px rgba(0,0,0,0.11)";
const $3276e9745553f254$export$b585396ecd4c8629 = "0 10px 20px 0 rgba(0,0,0,0.2)";
const $3276e9745553f254$export$559abfde0b301430 = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $3276e9745553f254$export$dfa790552704c785 = "0 0 0 0 hsl(200, 30%, 86%)";
const $3276e9745553f254$export$98c600e1ecf01a39 = "0 1px 0 0 #F0F3FA";
const $3276e9745553f254$export$a162a9eb85be72b9 = "0 -8px 16px 0 rgba(0,0,0,0.16), 0 -1px 1px 0 rgba(0,0,0,0)";
const $3276e9745553f254$export$6e5fb3e2c7f33c2a = "Manrope";
const $3276e9745553f254$export$dba883712db4d3ed = "Sanchez";
const $3276e9745553f254$export$6be74618ebefea70 = "Roboto";
const $3276e9745553f254$export$958f16642186b219 = "'Sometype Mono'";
const $3276e9745553f254$export$b6c70790c67285f9 = "6px";
const $3276e9745553f254$export$48529bd7f04d40f0 = "8px";
const $3276e9745553f254$export$f362f70cc25d5976 = "10px";
const $3276e9745553f254$export$7399932c71904dd8 = "12px";
const $3276e9745553f254$export$1a8e4a85adfe8299 = "14px";
const $3276e9745553f254$export$afd7e4e7ae36c76e = "16px";
const $3276e9745553f254$export$e2c0f185f219e125 = "18px";
const $3276e9745553f254$export$76961812acfcaadb = "20px";
const $3276e9745553f254$export$36e9845aded52da1 = "22px";
const $3276e9745553f254$export$90605139ceb31cb5 = "24px";
const $3276e9745553f254$export$4f2f5bdc507d88ff = "26px";
const $3276e9745553f254$export$38351aa0f63e13f = "28px";
const $3276e9745553f254$export$e5fe57b4a2ace969 = "30px";
const $3276e9745553f254$export$eb2bc143b1eaba17 = "32px";
const $3276e9745553f254$export$c6aca45dbeea0b6e = "48px";
const $3276e9745553f254$export$522d048072fdd0 = 1.25;
const $3276e9745553f254$export$38ead138ec412471 = "0px";
const $3276e9745553f254$export$b4664877dc43b7af = "2px";
const $3276e9745553f254$export$8982cd794b105475 = "4px";
const $3276e9745553f254$export$4e217f5c9e1d122e = "100px";
const $3276e9745553f254$export$581a022593b37139 = "4px";
const $3276e9745553f254$export$6e08a028ea88caf = "8px";
const $3276e9745553f254$export$9d565ea29b9d4e = "12px";
const $3276e9745553f254$export$5aa522eb884d579d = "16px";
const $3276e9745553f254$export$8820cb29c786d91f = "20px";
const $3276e9745553f254$export$e76f8634e42fceed = "24px";
const $3276e9745553f254$export$df367bbd8d048c14 = "28px";
const $3276e9745553f254$export$49513a9a59edd2fb = "32px";
const $3276e9745553f254$export$ef900fdc121889a3 = "36px";
const $3276e9745553f254$export$83009f3ef2af8902 = "40px";
const $3276e9745553f254$export$e356db1a74a940f1 = "44px";
const $3276e9745553f254$export$633ffa248d03506c = "48px";
const $3276e9745553f254$export$ff1746fd06dfef9c = "52px";
const $3276e9745553f254$export$792f985e3c66b82b = "56px";
const $3276e9745553f254$export$39757bd68ed58bc0 = "68px";
const $3276e9745553f254$export$5d4ece470da030c2 = "176px";
const $3276e9745553f254$export$e812c4b6a0d31e02 = "276px";
const $3276e9745553f254$export$1667f6759fd4af1f = "300px";
const $3276e9745553f254$export$c79e5da71b43f2b7 = "376px";
const $3276e9745553f254$export$f09309c57f8ea8db = "424px";
const $3276e9745553f254$export$3686e91ef2d1609b = "576px";
const $3276e9745553f254$export$9a7d2330672d94da = "776px";
const $3276e9745553f254$export$69191e5d8403f6dc = "832px";
const $3276e9745553f254$export$c9bc626bcb9d1702 = "1280px";
const $3276e9745553f254$export$c2ebcb19507fa384 = "2px";
const $3276e9745553f254$export$28af25853b30f1d5 = "0px";
const $3276e9745553f254$export$cf8146011d39494a = "4px";
const $3276e9745553f254$export$eb07efa989de8fe5 = "8px";
const $3276e9745553f254$export$bf79319657db0f88 = "12px";
const $3276e9745553f254$export$5905f6dbe11e7b2c = "16px";
const $3276e9745553f254$export$dc0e9ba406ec1128 = "20px";
const $3276e9745553f254$export$48cdf13b4cc5ad3f = "24px";
const $3276e9745553f254$export$cef3435710b52199 = "28px";
const $3276e9745553f254$export$431b2083311a15ea = "32px";
const $3276e9745553f254$export$b098505ff1a5f952 = "36px";
const $3276e9745553f254$export$d39e18acdfc94a45 = "40px";
const $3276e9745553f254$export$4d09869bf749903e = "44px";
const $3276e9745553f254$export$8ea49e0388a60a62 = "48px";
const $3276e9745553f254$export$6819254900b8d1cf = "52px";
const $3276e9745553f254$export$8b1552f580e06aac = "56px";
const $3276e9745553f254$export$f7e6e8df6820a759 = "60px";
const $3276e9745553f254$export$6b78519ba1b56b20 = "64px";
const $3276e9745553f254$export$aa21579cea294b7a = "2px";
const $3276e9745553f254$export$af88d6b81a19ff0a = "6px";
const $3276e9745553f254$export$a7fa5cf4f467a7a3 = "8px";
const $3276e9745553f254$export$19e367993efb2a85 = "10px";
const $3276e9745553f254$export$c0dbfa2a9de4cf2b = "12px";
const $3276e9745553f254$export$7db4d44897db3aae = "14px";
const $3276e9745553f254$export$77fa12a7f6088e8a = "16px";
const $3276e9745553f254$export$88f405f990d50798 = "20px";
const $3276e9745553f254$export$70eddb9c5b448a1e = "24px";
const $3276e9745553f254$export$cfed16d4b5ca2dea = "30px";
const $3276e9745553f254$export$1d5778bc4ba49de3 = "40px";
const $3276e9745553f254$export$6b8537e4a6c85699 = "50px";
const $3276e9745553f254$export$89c52c27197613ea = "60px";
const $3276e9745553f254$export$a8475dc9cbba9136 = "70px";
const $3276e9745553f254$export$287eb463b205f73b = "0";
const $3276e9745553f254$export$98aa6b13aaaaaed4 = "none";
const $3276e9745553f254$export$c3b12835a35a3ebc = "none";
const $3276e9745553f254$export$78cf32b6248297d8 = "underline";
const $3276e9745553f254$export$90cf649d4bdde151 = "0px";
const $3276e9745553f254$export$8eed865464cb9443 = "1px";
const $3276e9745553f254$export$5d966ef1a668534d = "2px";
const $3276e9745553f254$export$1fde20e337d78057 = "#082b25";
const $3276e9745553f254$export$8ab6bac2cfbaa311 = "#0f574b";
const $3276e9745553f254$export$7c3268c1e9449b23 = "#178270";
const $3276e9745553f254$export$ac2cb8d286cd282d = "#1fad96";
const $3276e9745553f254$export$afe30047fb949ada = "#26d9bb";
const $3276e9745553f254$export$bedb631b11c40714 = "#52e0c9";
const $3276e9745553f254$export$cbb4e1767cbcc295 = "#7de8d6";
const $3276e9745553f254$export$1ea24c91b8d25363 = "#a8f0e4";
const $3276e9745553f254$export$e48c1ae9f703ec3 = "#d4f7f1";
const $3276e9745553f254$export$3b66de443e6ecd2d = "#0f1624";
const $3276e9745553f254$export$d1b7eb4ab1109f37 = "#1f2c47";
const $3276e9745553f254$export$6fcf2bd98a8c3471 = "#2e426b";
const $3276e9745553f254$export$854fd1fca212ac66 = "#3d588f";
const $3276e9745553f254$export$94792cfe955edc7c = "#4d6fb3";
const $3276e9745553f254$export$a03199dd35bdd04c = "#708bc2";
const $3276e9745553f254$export$c2de267ef50b3959 = "#94a8d1";
const $3276e9745553f254$export$cbb9699552d08e72 = "#b8c5e0";
const $3276e9745553f254$export$926bc41ea4705265 = "#dbe2f0";
const $3276e9745553f254$export$654ed5d813f21dec = "#e2e8f3";
const $3276e9745553f254$export$69f18349c11e1ae6 = "#260d26";
const $3276e9745553f254$export$2ad4e0257e372740 = "#4d1a4d";
const $3276e9745553f254$export$e87f916bb6428820 = "#732673";
const $3276e9745553f254$export$c0c1b77517485090 = "#939";
const $3276e9745553f254$export$8239eaa50a0a5f95 = "#bf40bf";
const $3276e9745553f254$export$77be4f078e816c57 = "#c6c";
const $3276e9745553f254$export$92d17db692dfdb26 = "#d98cd9";
const $3276e9745553f254$export$198155ce03982d4b = "#e6b3e6";
const $3276e9745553f254$export$1eaa04001df46302 = "#f2d9f2";
const $3276e9745553f254$export$46520cc5cc636d5 = "#F3FDFE";
const $3276e9745553f254$export$65b52ee8779cfb86 = "#E7FBFE";
const $3276e9745553f254$export$15103e7803509654 = "#CEF6FD";
const $3276e9745553f254$export$e1e0f831fb8ef956 = "#9EEDFC";
const $3276e9745553f254$export$cab8599dbbafe6f0 = "#00B5D1";
const $3276e9745553f254$export$eb1ba29c8ee4ce89 = "#0F98AE";
const $3276e9745553f254$export$b317de730274ad6d = "#147A8B";
const $3276e9745553f254$export$688aa6f257feb3f4 = "#105B69";
const $3276e9745553f254$export$5bb5e616682f7dfd = "#073C46";
const $3276e9745553f254$export$6f48b50d16c41924 = "#011D23";
const $3276e9745553f254$export$8658174a5a26d8c8 = "#EDE3F6";
const $3276e9745553f254$export$94cf89e29828b90d = "#D9C8E5";
const $3276e9745553f254$export$fe800a881fbd2a17 = "#C6ACD4";
const $3276e9745553f254$export$86e5c257800b1ba7 = "#B390C3";
const $3276e9745553f254$export$efcc76822b16de0 = "#A273B2";
const $3276e9745553f254$export$e35506918d293b2d = "#9253A1";
const $3276e9745553f254$export$b80547edfe0328fa = "#643479";
const $3276e9745553f254$export$6f80192eefeaa148 = "#3A1750";
const $3276e9745553f254$export$8441530762eae6d3 = "#160428";
const $3276e9745553f254$export$90bc334d7aee9545 = "#FFD8F6";
const $3276e9745553f254$export$b3f1e6c576416c1d = "#FCB7E5";
const $3276e9745553f254$export$191c88ebca6ffe3c = "#F396D4";
const $3276e9745553f254$export$1f42ab64f4a83dee = "#E974C2";
const $3276e9745553f254$export$5fb6a51ed9b33fd0 = "#E04FAF";
const $3276e9745553f254$export$126413e9cf01d9cc = "#D6269B";
const $3276e9745553f254$export$a335b1f360803681 = "#A11C74";
const $3276e9745553f254$export$21e31efc7bd30562 = "#6B0D4C";
const $3276e9745553f254$export$82bb60d82e157db1 = "#350124";
const $3276e9745553f254$export$b583fe876073a2fe = "#DBF6CA";
const $3276e9745553f254$export$f4738750a09fc45 = "#3B770E";
const $3276e9745553f254$export$f892d1b579b087f5 = "#1D4405";
const $3276e9745553f254$export$a7461ee647c93d00 = "#FFEEEE";
const $3276e9745553f254$export$7a6939cbe6750292 = "#DE3131";
const $3276e9745553f254$export$f13b4f317c31e202 = "#6F1010";
const $3276e9745553f254$export$466eea952b10a8df = "#F8ECE7";
const $3276e9745553f254$export$3d73f527ec37353b = "#FFDAC4";
const $3276e9745553f254$export$848d0b3dbc4a58e9 = "#FFB892";
const $3276e9745553f254$export$67c22c804a444617 = "#FF9563";
const $3276e9745553f254$export$35c178005989be85 = "#DF5C24";
const $3276e9745553f254$export$d156763d5698483c = "#3A1404";
const $3276e9745553f254$export$1f3e8d28a4bc8087 = "#F0F3FA";
const $3276e9745553f254$export$533189fca2ec5a05 = "#5E728D";
const $3276e9745553f254$export$9a0d26ed3c25e7f = "#263146";
const $3276e9745553f254$export$732d133811ff729f = "#e5f4ff";
const $3276e9745553f254$export$2dd034e8857d984e = "#0070cc";
const $3276e9745553f254$export$83df2e97b19f7aba = "#005499";
const $3276e9745553f254$export$e84284477477fbb0 = "#053C60";
const $3276e9745553f254$export$94a8d52af3524619 = "#001D30";
const $3276e9745553f254$export$dde3540a7c52aa62 = "#FBFBFB";
const $3276e9745553f254$export$60dd899fb1fc8ebb = "#f5f5f5";
const $3276e9745553f254$export$b44ed74ac6c5e0b1 = "#F0F0EF";
const $3276e9745553f254$export$b45cfc1807a3979c = "#E2E2E1";
const $3276e9745553f254$export$20d695d1c7fa5d12 = "#C8C8C7";
const $3276e9745553f254$export$93394257d70d9c4b = "#AFAFAE";
const $3276e9745553f254$export$6ead472efe5cccf9 = "#AFAFAE";
const $3276e9745553f254$export$7345959dcc3f1249 = "#969695";
const $3276e9745553f254$export$f6fc60ebb1f0098d = "#7D7D7D";
const $3276e9745553f254$export$bb9c92dcc503d041 = "#646464";
const $3276e9745553f254$export$919b4cfa2a3431d7 = "#4B4B4B";
const $3276e9745553f254$export$3a932b816df19cf9 = "#323232";
const $3276e9745553f254$export$df6264b18306f8ce = "#191919";
const $3276e9745553f254$export$5ccfbbfe47595323 = "4px";
const $3276e9745553f254$export$20f5c07ae3856232 = "8px";
const $3276e9745553f254$export$c8bf6e81dacfc196 = "12px";
const $3276e9745553f254$export$99f6d89f34a0b1a0 = "16px";
const $3276e9745553f254$export$f2d0edabd04761fb = "20px";
const $3276e9745553f254$export$ed3a53feec192842 = "24px";
const $3276e9745553f254$export$8b69e23cdf44e5c4 = "28px";
const $3276e9745553f254$export$a5fd793e6ae66615 = "32px";
const $3276e9745553f254$export$67b8da528429660d = "36px";
const $3276e9745553f254$export$4895d0896c23a35a = "68px";
const $3276e9745553f254$export$c97d64ed641c0c68 = "176px";
const $3276e9745553f254$export$496884663027a953 = "276px";
const $3276e9745553f254$export$942a8415fd3bc2bd = "376px";
const $3276e9745553f254$export$d4dcd3e7a9f00b00 = "576px";
const $3276e9745553f254$export$ac6d8dd750e2b03d = "776px";
const $3276e9745553f254$export$ea8e199042cb733d = "1280px";
const $3276e9745553f254$export$9ec87d3ea06e00a5 = "36px";
const $3276e9745553f254$export$145590b199e7aa08 = "832px";
const $3276e9745553f254$export$ea53782885816cc4 = "48px";
const $3276e9745553f254$export$88fccbab69a23b50 = "44px";
const $3276e9745553f254$export$aeea69d04d385bac = "36px";
const $3276e9745553f254$export$1eed320f6fa53669 = "2px";
const $3276e9745553f254$export$170fa82b897b1027 = "0px";
const $3276e9745553f254$export$ce76584477c56c81 = "1px";
const $3276e9745553f254$export$59d5e2224353c9c = "2px";
const $3276e9745553f254$export$e878cf70517bf87d = "14px";
const $3276e9745553f254$export$ca532bde8b673674 = "24px";
const $3276e9745553f254$export$d35ad0b1db66aab = "16px";
const $3276e9745553f254$export$2c081aeb7c8eb547 = "18px";
const $3276e9745553f254$export$b538dbdb5cc993e2 = "14px";
const $3276e9745553f254$export$12bd9cd6158eeaff = "12px";
const $3276e9745553f254$export$87d099ffe187ede3 = "10px";
const $3276e9745553f254$export$45a9411d397e7014 = "32px";
const $3276e9745553f254$export$6441942a9191e8b = "26px";
const $3276e9745553f254$export$603bbc670bd6cdb7 = "22px";
const $3276e9745553f254$export$bd4d597b9a8478ef = "18px";
const $3276e9745553f254$export$33b4990036285dd4 = "400";
const $3276e9745553f254$export$94b8628301cfeba5 = "600";
const $3276e9745553f254$export$4251501a1fd96031 = "700";
const $3276e9745553f254$export$ec958139a7af2a8d = "Roboto";
const $3276e9745553f254$export$dfce6fb8007da48e = "Roboto";
const $3276e9745553f254$export$68b4938ddb45a8c0 = "Roboto";
const $3276e9745553f254$export$da3bf13b0e78188e = "8px";
const $3276e9745553f254$export$93a0f9889d302d21 = "10px";
const $3276e9745553f254$export$cd5e6a287e658e4b = "12px";
const $3276e9745553f254$export$694cbbfe937eb3b2 = "14px";
const $3276e9745553f254$export$249f366dc55631e7 = "30px";
const $3276e9745553f254$export$57fd85f0d54165d7 = "24px";
const $3276e9745553f254$export$17d746d2fa0f3e26 = "20px";
const $3276e9745553f254$export$6c499f1196becaca = "16px";
const $3276e9745553f254$export$45081f5919e907f9 = "12px";
const $3276e9745553f254$export$ea858f460f740237 = "16px";
const $3276e9745553f254$export$4b9604858cc8bf9b = "8px";
const $3276e9745553f254$export$5c216d07f6313f89 = "24px";
const $3276e9745553f254$export$31bcbabf8dd2f068 = "8px";
const $3276e9745553f254$export$c18af1c576b9134e = "16px";
const $3276e9745553f254$export$2139653de76670a8 = "4px";
const $3276e9745553f254$export$1f8b3d352ce76e2 = "2px";
const $3276e9745553f254$export$da181d9bc79e4a02 = "0px";
const $3276e9745553f254$export$6422537c35b745d9 = "2px";
const $3276e9745553f254$export$e77925bd46d7e15b = "4px";
const $3276e9745553f254$export$55ec15df2cced997 = "100px";
const $3276e9745553f254$export$53dad9b8590b2590 = "hsl(202, 100%, 40%)";
const $3276e9745553f254$export$2cfa48c35037e4cd = "hsl(202, 100%, 30%)";
const $3276e9745553f254$export$4cc965d0c8b21c5c = "hsl(202, 100%, 30%)";
const $3276e9745553f254$export$c5215a7e991b1930 = "hsl(202, 100%, 30%)";
const $3276e9745553f254$export$11f329bcb8162d0d = "hsl(202 100% 40% / 0.5)"; // Used for map pins
const $3276e9745553f254$export$403b382cc6844409 = "hsl(266, 63%, 45%)";
const $3276e9745553f254$export$deda6d87d502e7b9 = "hsl(266, 63%, 35%)";
const $3276e9745553f254$export$c74f5a5b20d20e6a = "hsl(266, 63%, 35%)";
const $3276e9745553f254$export$86b18e3169467eff = "hsl(266, 63%, 35%)";
const $3276e9745553f254$export$3558da976e5d4766 = "hsl(266 63% 45% / 0.5)";
const $3276e9745553f254$export$46db9a5b4fa29cdb = "hsl(301, 73%, 75%)";
const $3276e9745553f254$export$c7ceda4e66b9f080 = "hsl(301, 73%, 65%)";
const $3276e9745553f254$export$fae84847465463d4 = "hsl(301, 73%, 65%)";
const $3276e9745553f254$export$d33af6c1185faec2 = "hsl(301, 73%, 65%)";
const $3276e9745553f254$export$7ced400057edeaf3 = "hsl(301 73% 75% / 0.5)";
const $3276e9745553f254$export$51494f3f5dc6cffe = "hsl(169, 82%, 33%)";
const $3276e9745553f254$export$7f8f0ea50825a1b7 = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$833baa99ed859de5 = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$8662dc5f96d63e1c = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$f5bf3b4e8e44efda = "hsl(169 82% 33% / 0.5)";
const $3276e9745553f254$export$18adc08f697e50fe = "hsl(346, 37%, 43%)";
const $3276e9745553f254$export$5e8722563ff0c000 = "hsl(346, 37%, 33%)";
const $3276e9745553f254$export$d00e843f86f2564a = "hsl(346, 37%, 33%)";
const $3276e9745553f254$export$fa36bc78b7ce543e = "hsl(346, 37%, 33%)";
const $3276e9745553f254$export$3f6119e89ab4de35 = "hsl(346 37% 43% / 0.5)";
const $3276e9745553f254$export$e0b0cb547b1f892d = "hsl(36, 77%, 40%)";
const $3276e9745553f254$export$927f064bc5b07bfa = "hsl(36, 77%, 30%)";
const $3276e9745553f254$export$56f2d00a015cd7a8 = "hsl(36, 77%, 30%)";
const $3276e9745553f254$export$8b59f2dc411c59d7 = "hsl(36, 77%, 30%)";
const $3276e9745553f254$export$68d3bcba77d10f82 = "hsl(36 77% 40% / 0.5)";
const $3276e9745553f254$export$6ff7613d4c7aeb8d = "hsl(151, 46%, 17%)";
const $3276e9745553f254$export$a6d09535a6dea115 = "hsl(151, 46%, 27%)";
const $3276e9745553f254$export$5b5bdc2dd57fd7ee = "hsl(151, 46%, 27%)";
const $3276e9745553f254$export$422c1cc49a17292a = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$8722d1c809de28b3 = "hsl(151 46% 27% / 0.5)";
const $3276e9745553f254$export$eb43764bdf88d057 = "hsl(36, 97%, 70%)";
const $3276e9745553f254$export$67a542d8cd9b82dd = "hsl(36, 97%, 60%)";
const $3276e9745553f254$export$d1f88ead0dc7a304 = "hsl(36, 97%, 60%)";
const $3276e9745553f254$export$5038a7dd0a89c7d0 = "hsl(36, 97%, 60%)";
const $3276e9745553f254$export$fb457f52cca97850 = "hsl(36 97% 70% / 0.5)";
const $3276e9745553f254$export$519809f976569692 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$c584085d5ee8de76 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$a788d2961d748cde = "#0070cc";
const $3276e9745553f254$export$e32ea0d81272e1b6 = "#0070cc";
const $3276e9745553f254$export$d8ae6269b02938b = "#0070cc";
const $3276e9745553f254$export$2f14b841cad9c767 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$10519f8ccd4b0b86 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$2fa9eeb6d8e51673 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$ed95ed13f2c03e16 = "#0070cc";
const $3276e9745553f254$export$1c9be6c6205a847b = "#0070cc";
const $3276e9745553f254$export$8b5c10f16365778c = "#0070cc";
const $3276e9745553f254$export$768c1cdce28e1d12 = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$1a1821660ba5e5fe = "#4B4B4B";
const $3276e9745553f254$export$663065bf2da99939 = "#4B4B4B";
const $3276e9745553f254$export$c914cb73d8ae4e4f = "#0070cc";
const $3276e9745553f254$export$2c74ca3559bf64f = "#0070cc";
const $3276e9745553f254$export$72a1027e9ca37197 = "#0070cc";
const $3276e9745553f254$export$3e018292749dd934 = "hsl(0 0% 29.4% / 0.38)";
const $3276e9745553f254$export$bb278ff9c8980518 = "#E2E2E1";
const $3276e9745553f254$export$36eae0c7542b8f46 = "#E2E2E1";
const $3276e9745553f254$export$96674436714104a8 = "#0070cc";
const $3276e9745553f254$export$a48b18644600cff8 = "#0070cc";
const $3276e9745553f254$export$32f93b6101bdc552 = "#0070cc";
const $3276e9745553f254$export$2896c237a2e3e079 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$cc6fa3dd94433a27 = "#C8C8C7";
const $3276e9745553f254$export$902237779564add5 = "#C8C8C7";
const $3276e9745553f254$export$df41c8766762ac09 = "#0070cc";
const $3276e9745553f254$export$3f5d1438f789e95b = "#0070cc";
const $3276e9745553f254$export$47c3cd69e3cba602 = "#0070cc";
const $3276e9745553f254$export$5e39dea751a8af3e = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$e5fda2d14bb87245 = "#0070cc";
const $3276e9745553f254$export$d6a62f44a4bb6848 = "#0070cc";
const $3276e9745553f254$export$77499b6ac1d78be2 = "#0070cc";
const $3276e9745553f254$export$1961987bbf85bc69 = "#0070cc";
const $3276e9745553f254$export$f563e1c4b1dfe9b6 = "#0070cc";
const $3276e9745553f254$export$88019076f718435e = "hsl(207 100% 40% / 0.38)";
const $3276e9745553f254$export$4188c5dfbd960ff6 = "hsl(207 100% 40% / 0)";
const $3276e9745553f254$export$6f8b1b70dce4971d = "hsl(200 30% 98% / 0)";
const $3276e9745553f254$export$51c0a5205fae8605 = "#0070cc";
const $3276e9745553f254$export$e3efd006787060d7 = "hsl(207 100% 40% / 0)";
const $3276e9745553f254$export$fd9c87bcf2280fcc = "#0070cc";
const $3276e9745553f254$export$33c2d8ee15842362 = "hsl(200 30% 98% / 0)";
const $3276e9745553f254$export$7d9f7647b114f0ff = "#0070cc";
const $3276e9745553f254$export$bee26b78d3246ede = "#0070cc";
const $3276e9745553f254$export$844a6b198d459d4f = "#0070cc";
const $3276e9745553f254$export$c32dfb5afe8442d2 = "#0070cc";
const $3276e9745553f254$export$8c54331216764c04 = "#0070cc";
const $3276e9745553f254$export$ed179d6ea18a424b = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$a2b7d83a97c0807b = "#0070cc";
const $3276e9745553f254$export$75fdb7e4365aea69 = "#005499";
const $3276e9745553f254$export$436333264dcf080c = "#005499";
const $3276e9745553f254$export$48fdba70460beee3 = "#005499";
const $3276e9745553f254$export$a3db82021e9802c1 = "#053C60";
const $3276e9745553f254$export$17521d5649bf845b = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$da7e305f941f7c1b = "#78B6E3";
const $3276e9745553f254$export$98adb0276baaf8cf = "#9253A1";
const $3276e9745553f254$export$8420ff989cc50c37 = "#00B5D1";
const $3276e9745553f254$export$b8a3bfa1fcd8dbc7 = "#FCB817";
const $3276e9745553f254$export$c49e9b4e44fd796c = "#7CC356";
const $3276e9745553f254$export$d51f08d8d0f3a9cc = "#E2E2E1";
const $3276e9745553f254$export$1bcabe1edda14f10 = "#C8C8C7";
const $3276e9745553f254$export$10d03502f2dd5cdd = "#646464";
const $3276e9745553f254$export$52269544c67eee3a = "#E2E2E1";
const $3276e9745553f254$export$368cb14eb84c724e = "#E2E2E1";
const $3276e9745553f254$export$976ab5bc3e192772 = "#4B4B4B";
const $3276e9745553f254$export$f32dfe87536251b0 = "#FFEEEE";
const $3276e9745553f254$export$f917c18e2c0733a2 = "#DE3131";
const $3276e9745553f254$export$37a2561e6f52f1a6 = "#6F1010";
const $3276e9745553f254$export$757d1267e084d85e = "#DBF6CA";
const $3276e9745553f254$export$c96234e9ac3976aa = "#3B770E";
const $3276e9745553f254$export$2ada4242418b1ab = "#1D4405";
const $3276e9745553f254$export$88e8fc65e1dc8cfd = "#FFDAC4";
const $3276e9745553f254$export$571330183a04a679 = "#DF5C24";
const $3276e9745553f254$export$e2364df1760c1cd2 = "#3A1404";
const $3276e9745553f254$export$88387c1fa4550702 = "#F0F3FA";
const $3276e9745553f254$export$31154090c834e808 = "#5E728D";
const $3276e9745553f254$export$fd57486f12ccccc7 = "#263146";
const $3276e9745553f254$export$ce5dfe4e5b931e4a = "#4B4B4B";
const $3276e9745553f254$export$958169ac176093af = "#191919";
const $3276e9745553f254$export$c3458d3269390c99 = "#005499";
const $3276e9745553f254$export$f7e100eac7e2f133 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$95f6ec96cc827155 = "#005499";
const $3276e9745553f254$export$657174ec69a2226a = "#ffffff";
const $3276e9745553f254$export$e123307e2b218889 = "hsl(0 0% 100% / 0.38)";
const $3276e9745553f254$export$7b91367d7e807812 = "hsl(0 0% 100% / 0.8)";
const $3276e9745553f254$export$aa6384fd68eb0d3b = "hsl(0 0% 100% / 0.65)";
const $3276e9745553f254$export$3208e2036242c233 = "#646464";
const $3276e9745553f254$export$db305d4c182a82ff = "#4B4B4B";
const $3276e9745553f254$export$7641b4bffb9af953 = "#191919";
const $3276e9745553f254$export$635aa5d463114b08 = "#ffffff";
const $3276e9745553f254$export$e5149da9067fe611 = "#6F1010";
const $3276e9745553f254$export$a612632118a3b91b = "hsl(202, 100%, 40%)";
const $3276e9745553f254$export$465d16f3f0328e03 = "hsl(202, 100%, 30%)";
const $3276e9745553f254$export$e11a401a4e94968e = "hsl(202, 100%, 30%)";
const $3276e9745553f254$export$9d6422b3a72c759f = "hsl(202, 100%, 30%)";
const $3276e9745553f254$export$5b94bccbb3b2583c = "hsl(202 100% 40% / 0.5)"; // Used for map pins
const $3276e9745553f254$export$b8a531ce48f1ec30 = "hsl(266, 63%, 45%)";
const $3276e9745553f254$export$5d4a9c2be9f03907 = "hsl(266, 63%, 35%)";
const $3276e9745553f254$export$3a2e5b43fc49e678 = "hsl(266, 63%, 35%)";
const $3276e9745553f254$export$87ffd345b881d06e = "hsl(266, 63%, 35%)";
const $3276e9745553f254$export$8827af02313fafc6 = "hsl(266 63% 45% / 0.5)";
const $3276e9745553f254$export$63971f9c83d9fbd1 = "hsl(301, 73%, 75%)";
const $3276e9745553f254$export$15a94504af5cb48d = "hsl(301, 73%, 65%)";
const $3276e9745553f254$export$ea6f57adb3b615d1 = "hsl(301, 73%, 65%)";
const $3276e9745553f254$export$603bede8ed38ec7c = "hsl(301, 73%, 65%)";
const $3276e9745553f254$export$96ad1ff12a5eae51 = "hsl(301 73% 75% / 0.5)";
const $3276e9745553f254$export$3435221529653182 = "hsl(169, 82%, 33%)";
const $3276e9745553f254$export$6140f2a94c436fb8 = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$13e360d171ddb1b1 = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$bbdd1745b1aa2bfa = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$1efbfdbe33975e65 = "hsl(169 82% 33% / 0.5)";
const $3276e9745553f254$export$213e10a2fa7b8f25 = "hsl(346, 37%, 43%)";
const $3276e9745553f254$export$f04fa375e16b056f = "hsl(346, 37%, 33%)";
const $3276e9745553f254$export$118e41f6ad7c84e4 = "hsl(346, 37%, 33%)";
const $3276e9745553f254$export$a61605328d84ff20 = "hsl(346, 37%, 33%)";
const $3276e9745553f254$export$388c04cdf17d92da = "hsl(346 37% 43% / 0.5)";
const $3276e9745553f254$export$9e8d2402ccd4d487 = "hsl(36, 77%, 40%)";
const $3276e9745553f254$export$8ce3c3b4e69389b3 = "hsl(36, 77%, 30%)";
const $3276e9745553f254$export$381431d7d1cd2cdc = "hsl(36, 77%, 30%)";
const $3276e9745553f254$export$1d762aa2ded48ccc = "hsl(36, 77%, 30%)";
const $3276e9745553f254$export$ed777c3dad5075f6 = "hsl(36 77% 40% / 0.5)";
const $3276e9745553f254$export$92428370c1b865ea = "hsl(151, 46%, 17%)";
const $3276e9745553f254$export$ddd43daccf223f75 = "hsl(151, 46%, 27%)";
const $3276e9745553f254$export$dcaa98e9517a79a9 = "hsl(151, 46%, 27%)";
const $3276e9745553f254$export$c00fd98671d96e13 = "hsl(169, 82%, 23%)";
const $3276e9745553f254$export$d2c685c01dd428bb = "hsl(151 46% 27% / 0.5)";
const $3276e9745553f254$export$17ca6c34e71101c = "hsl(36, 97%, 70%)";
const $3276e9745553f254$export$71bc8e3929b67885 = "hsl(36, 97%, 60%)";
const $3276e9745553f254$export$18b5bb98b26a75b2 = "hsl(36, 97%, 60%)";
const $3276e9745553f254$export$b8035dad7acff593 = "hsl(36, 97%, 60%)";
const $3276e9745553f254$export$c8abfd1d22e0782b = "hsl(36 97% 70% / 0.5)";
const $3276e9745553f254$export$69ba8f43cf9bd6fd = "#ffffff";
const $3276e9745553f254$export$f153d7318b9ac6c1 = "#F0F0EF";
const $3276e9745553f254$export$32bb8f83e2da4eeb = "#7D7D7D";
const $3276e9745553f254$export$beed09ba17395fba = "hsl(50, 70%, 82%)";
const $3276e9745553f254$export$ddfa67e511d310a1 = "#ffffff";
const $3276e9745553f254$export$ef61afb4daed05b6 = "#f5f5f5";
const $3276e9745553f254$export$fcbf5251861df7b7 = "#191919";
const $3276e9745553f254$export$e24eb567fe502262 = "hsl(0 0% 39.2% / 0.5)";
const $3276e9745553f254$export$fd7193dce715e7a5 = "#ffffff";
const $3276e9745553f254$export$f7cd4529b55f6b65 = "#FBFBFB";
const $3276e9745553f254$export$32838d580212d33c = "#FFEEEE";
const $3276e9745553f254$export$9ebf7b0a2981f15 = "#DE3131";
const $3276e9745553f254$export$4711b9c0f73c9e78 = "#6F1010";
const $3276e9745553f254$export$e70ad4174aad5efa = "#DBF6CA";
const $3276e9745553f254$export$49814df222dc4e11 = "#3B770E";
const $3276e9745553f254$export$7cb8bf88d5994ac6 = "#1D4405";
const $3276e9745553f254$export$9779a7bfc57f1d = "#F8ECE7";
const $3276e9745553f254$export$41cf31ff8fe14f06 = "#DF5C24";
const $3276e9745553f254$export$69315608b745ccef = "#3A1404";
const $3276e9745553f254$export$7d3fb3a82b27444e = "#F0F3FA";
const $3276e9745553f254$export$e503fb06555d356c = "#5E728D";
const $3276e9745553f254$export$c2715a93ce37bb6d = "#263146";
const $3276e9745553f254$export$dd95d9725323abea = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$57bc6d84deab957a = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$bdf5b9913bb4f3fa = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$3d257524dee43873 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$4a362d83881d9a7d = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$3658abd53e71b73b = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$80e05e6d32920b95 = "#F0F0EF";
const $3276e9745553f254$export$f0f8c85d17a6904c = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$df2dcd894d47df09 = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$88f8e1485baa4c61 = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$668bd1b85a3e6315 = "hsl(207 100% 40% / 0.5)";
const $3276e9745553f254$export$b8eccab39f3850b8 = "hsl(60 3.23% 93.9% / 0.38)";
const $3276e9745553f254$export$b5c855fae1b28ad6 = "#323232";
const $3276e9745553f254$export$98f748c76bc6e5e6 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$966ce69ea0b3158d = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$36bc118ab0edded = "#0070cc";
const $3276e9745553f254$export$6fff8a90e8eb0eaa = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$788186b488c86558 = "hsl(0 0% 19.6% / 0.38)";
const $3276e9745553f254$export$75d76cc6fcb941ac = "#ffffff";
const $3276e9745553f254$export$5112c48026e56c83 = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$97166a6d3215a732 = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$ae48a1bc62abcfbb = "#ffffff";
const $3276e9745553f254$export$6acdad347d3433d2 = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$271026c4bdf43872 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$85cad9355d106745 = "#f5f5f5";
const $3276e9745553f254$export$6f8939a00778a44b = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$69c050e0055d47e7 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$f36210171c60734d = "#F0F0EF";
const $3276e9745553f254$export$2d8338132c859946 = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$ab4bc868a0e35284 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$ee107e86642de023 = "#191919";
const $3276e9745553f254$export$b44f568374a0ce0 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$b6d257ffaa4da9c4 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$931ef32bb11eaa45 = "#AFAFAE";
const $3276e9745553f254$export$21b30ac68ae47cd2 = "#005499";
const $3276e9745553f254$export$11b1d4709f91be43 = "hsl(207 100% 30% / 0.95)";
const $3276e9745553f254$export$37db67f42f3e4dd2 = "hsl(207 100% 98% / 0)";
const $3276e9745553f254$export$c5e9d21ac7b68d10 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$77aba3a97c22e449 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$504e1687cbb53608 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$239eed1838553c1d = "hsl(207 100% 40% / 0.2)";
const $3276e9745553f254$export$cecf34cd6f8888d8 = "rgb(89.8% 95.7% 100% / 0)";
const $3276e9745553f254$export$bf3acb3c0b34a34 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$fed370744d8fbf8 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$4cce883c26bd421b = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$2805e9aa6398e22d = "hsl(207 100% 40% / 0.2)";
const $3276e9745553f254$export$e5398cdbb701916d = "#0070cc";
const $3276e9745553f254$export$407c0a3360630f07 = "#005499";
const $3276e9745553f254$export$2cf287a22961d257 = "#005499";
const $3276e9745553f254$export$8d86b0a298b93d0c = "#005499";
const $3276e9745553f254$export$98fe9911bf35517e = "#053C60";
const $3276e9745553f254$export$f0653913d522b4de = "hsl(0 0% 100% / 0.38)";
const $3276e9745553f254$export$dfbedab10da73342 = "#4A8B2C";
const $3276e9745553f254$export$80f74912e5e2c16e = "#7CC356";
const $3276e9745553f254$export$11b87b8556d144a8 = "#582C5F";
const $3276e9745553f254$export$380739dd5aaef19b = "#00758D";
const $3276e9745553f254$export$d5620addd245919a = "#00B5D1";
const $3276e9745553f254$export$a86a694f71504589 = "#DD8A03";
const $3276e9745553f254$export$39d3aed953cc66e4 = "#FFFFFF";
const $3276e9745553f254$export$2bc839ad86d92f97 = "#000006";
const $3276e9745553f254$export$4b18498d98ac2b51 = "#067CC1";
const $3276e9745553f254$export$bdac8b134e31bde5 = "#ffffff";
const $3276e9745553f254$export$66bda635f6f13030 = "#f5f5f5";
const $3276e9745553f254$export$91cc85ef8f880fbf = "#ffffff";
const $3276e9745553f254$export$2567089c08d07145 = "#AFAFAE";
const $3276e9745553f254$export$7ddc7da8e4aedbc9 = "#7D7D7D";
const $3276e9745553f254$export$e9ea731e72b3c68 = "hsl(350, 70%, 96%)";
const $3276e9745553f254$export$ac8e94ba2c43a286 = "#DE3131";
const $3276e9745553f254$export$9b91ce4791dbfb9c = "#6F1010";
const $3276e9745553f254$export$3ff48969c4a6b385 = "#DBF6CA";
const $3276e9745553f254$export$b65cebe70ae8272a = "#3B770E";
const $3276e9745553f254$export$fa75de9cd1d80d91 = "#1D4405";
const $3276e9745553f254$export$9abd6e64e952d3c8 = "#FFB892";
const $3276e9745553f254$export$a805ba38d5e6f41d = "#DF5C24";
const $3276e9745553f254$export$659615cdef30be80 = "#3A1404";
const $3276e9745553f254$export$82ba5e115e27104 = "#F0F3FA";
const $3276e9745553f254$export$e248e6c7086b9196 = "#5E728D";
const $3276e9745553f254$export$4aea909045a919f3 = "#263146";
const $3276e9745553f254$export$24e2c3b0b0b39b6 = "#E2E2E1";
const $3276e9745553f254$export$4cdd43377f390746 = "#AFAFAE";
const $3276e9745553f254$export$4c2aeb09e7af3558 = "#AFAFAE";
const $3276e9745553f254$export$6948447257b9a2fb = "#0070cc";
const $3276e9745553f254$export$1886d6bd011b2628 = "#005499";
const $3276e9745553f254$export$6f0d3bd0748f7110 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$1cebc993b0830ad8 = "#7D7D7D";
const $3276e9745553f254$export$94bf08336f2aea93 = "#4B4B4B";
const $3276e9745553f254$export$60462e192e7be598 = "#4B4B4B";
const $3276e9745553f254$export$c283bf52b1187f2a = "#0070cc";
const $3276e9745553f254$export$fa11560b88288866 = "#005499";
const $3276e9745553f254$export$6fe67d097ba9b53b = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$9346c9eb56618801 = "#4B4B4B";
const $3276e9745553f254$export$20a88bf6f5ad424 = "#191919";
const $3276e9745553f254$export$3e11f9ae2b7c8b4 = "#191919";
const $3276e9745553f254$export$1d4bdb103b271652 = "#0070cc";
const $3276e9745553f254$export$16fad6bc38b83523 = "#0070cc";
const $3276e9745553f254$export$6facfb5bbfcbbdc1 = "hsl(0 0% 29.4% / 0.38)";
const $3276e9745553f254$export$68a1dda24af60fe8 = "#0070cc";
const $3276e9745553f254$export$9cda72453ce995fe = "#005499";
const $3276e9745553f254$export$976fb57d95041b2e = "#005499";
const $3276e9745553f254$export$1d80e0b4ec3cdc88 = "#0070cc";
const $3276e9745553f254$export$a47e91d4907d671b = "#005499";
const $3276e9745553f254$export$51dfe56e558b3410 = "#005499";
const $3276e9745553f254$export$cc6aa53aa44c8b12 = "#ffffff";
const $3276e9745553f254$export$428c93d8ee6b3f23 = "#ffffff";
const $3276e9745553f254$export$3b660da25a4df7dd = "#ffffff";
const $3276e9745553f254$export$1019c561a0c3d652 = "#F0F0EF";
const $3276e9745553f254$export$393ed899af66269a = "#00B5D1";
const $3276e9745553f254$export$2186267c9e4b9a19 = "hsl(207, 100%, 40%)";
const $3276e9745553f254$export$3c006b5b617326e6 = "#C8C8C7";
const $3276e9745553f254$export$17903f872c41d3f5 = "#3A1750";
const $3276e9745553f254$export$c8281b24d2fb2531 = "#D6269B";
const $3276e9745553f254$export$f4c54cb551b3e31a = "#FFB892";
const $3276e9745553f254$export$e95975a74000e17d = "hsl(207, 100%, 40%)";
const $3276e9745553f254$export$e306266450d339da = "0 0 0 0 hsl(200, 30%, 86%)";
const $3276e9745553f254$export$c727a326e5ac158d = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $3276e9745553f254$export$f124d9ef132d79f1 = "-8px 16px 0 rgba(0,0,0,0.16), 0 -1px 1px 0 rgba(0,0,0,0)";
const $3276e9745553f254$export$a6ed37d16e5c3592 = "0";
const $3276e9745553f254$export$1e9bf329c53e42da = "400";
const $3276e9745553f254$export$8cebf529bc3d12cd = "600";
const $3276e9745553f254$export$d554c99af2e8701d = "700";
const $3276e9745553f254$export$7711684ec178da45 = 1.25;
const $3276e9745553f254$export$85da697736c3f546 = "10px";
const $3276e9745553f254$export$f6f08d75449b0f4f = "12px";
const $3276e9745553f254$export$32766a586f34b05b = "16px";
const $3276e9745553f254$export$4ecde25fa2a16515 = "50px";
const $3276e9745553f254$export$ad3e07fd3f6eb5e9 = "40px";
const $3276e9745553f254$export$191898ea266c6db3 = "30px";
const $3276e9745553f254$export$f7668923bd63f908 = "20px";
const $3276e9745553f254$export$dc1063802be71f6b = "14px";
const $3276e9745553f254$export$74a906d5f5dbcc07 = "a08f0ecdf1d566ecd1b9fdb6e63f430334c36f90";
const $3276e9745553f254$export$6012d36fd86dbaa1 = "Barracuda";
const $3276e9745553f254$export$e24406150fd87290 = "source";
const $3276e9745553f254$export$83da2f3feb571776 = "enabled";
const $3276e9745553f254$export$34e6b0c7073d1e27 = "source";
const $3276e9745553f254$export$5b5ea24ad2da3b16 = "Brand";
const $3276e9745553f254$export$bc9f2dd2aa337004 = "1ea10838fef7047bfa8454a2fe209911101832f9";
const $3276e9745553f254$export$a08a8107d9ea42d7 = "v1";
const $3276e9745553f254$export$3fddc94fd7344d3f = "enabled";
const $3276e9745553f254$export$d54ad359440fed8a = "enabled";
const $3276e9745553f254$export$7a5c093e8fbb816b = "enabled";
const $3276e9745553f254$export$ea9c28f9f25eee8d = "disabled";
const $3276e9745553f254$export$7a9d9e76d788a685 = "version";
const $3276e9745553f254$export$4caaeecf625325c = "globals";
const $3276e9745553f254$export$4db8b33a483c4b6a = "aliases";
const $3276e9745553f254$export$517e517cddbb63e4 = "components/button";
const $3276e9745553f254$export$94e839db223f2b32 = "version/v1";
const $3276e9745553f254$export$45f9825089601438 = "100px";
const $3276e9745553f254$export$6ced2fe9225bb9aa = "16px";
const $3276e9745553f254$export$ad9035b90a500e0c = "20px";
const $3276e9745553f254$export$981c98b80c296cae = "24px";
const $3276e9745553f254$export$6a70aa95d5f9e97d = "28px";
const $3276e9745553f254$export$77fc7cdd633e321a = "32px";
const $3276e9745553f254$export$1d1ba85af9737700 = "#ffffff";
const $3276e9745553f254$export$9fdcda1e888251ae = "#F0F0EF";
const $3276e9745553f254$export$6e683eae248849d0 = "#7D7D7D";
const $3276e9745553f254$export$10b711493a3d638d = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$ec4efc0809296020 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$574ca15a0c69dfed = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$6711cc6f6a8d7622 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$ee901060a5d95972 = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$2eec97a97f2e4a04 = "#F0F0EF";
const $3276e9745553f254$export$6a4c73b3b1874b99 = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$f99fb7f220239678 = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$74c23d76a5361d79 = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$39fbb811f7522b8b = "hsl(207 100% 40% / 0.5)";
const $3276e9745553f254$export$acc506ad42389b36 = "#323232";
const $3276e9745553f254$export$3afd9cf193dbcb8a = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$56a3bdf7d0fec618 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$9fe0f766dfd77681 = "#0070cc";
const $3276e9745553f254$export$51dff143e21603dd = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$b8cb6cd9a5387463 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$47e4978834ae40f7 = "#4B4B4B";
const $3276e9745553f254$export$a0e30118ba19fdb2 = "#191919";
const $3276e9745553f254$export$2e98f00d0fa4bbb5 = "#ffffff";
const $3276e9745553f254$export$2b24a45f4e35892b = "#4B4B4B";
const $3276e9745553f254$export$d948f9b072d01bf6 = "#191919";
const $3276e9745553f254$export$fa82cf28ab34d28a = "#ffffff";
const $3276e9745553f254$export$7b24fd576331fa4c = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$4140cf203c357f02 = "#005499";
const $3276e9745553f254$export$35c34a4e0cfbe353 = "#E2E2E1";
const $3276e9745553f254$export$befa38c6db1cdb2d = "#C8C8C7";
const $3276e9745553f254$export$ac967ae90cf75bdb = "#646464";
const $3276e9745553f254$export$ece26edc7f0c4ee3 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$e06caac82792110c = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$874db53a16e8eca6 = "#0070cc";
const $3276e9745553f254$export$6996388cacfbc1c3 = "#0070cc";
const $3276e9745553f254$export$58bec168ef844174 = "#0070cc";
const $3276e9745553f254$export$d023e2e28c239369 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$946657d96f7f365c = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$c56ab0b862450b50 = "#0070cc";
const $3276e9745553f254$export$b2a4c668920d7f26 = "#0070cc";
const $3276e9745553f254$export$bb6b9403ea569251 = "#0070cc";
const $3276e9745553f254$export$ef1d10df2c03313a = "#4B4B4B";
const $3276e9745553f254$export$ef737f5bf427c63b = "#4B4B4B";
const $3276e9745553f254$export$ae2775de35439b9a = "#0070cc";
const $3276e9745553f254$export$fde44b974502cb1 = "#0070cc";
const $3276e9745553f254$export$654e39841159fe7e = "#0070cc";
const $3276e9745553f254$export$978e747ab676585c = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$2817c40e512049d4 = "1px";
const $3276e9745553f254$export$8b50ef9dd01b2896 = "Roboto";
const $3276e9745553f254$export$4ee7b06916c5d942 = "600";
const $3276e9745553f254$export$add9cf0f5be45bb8 = "8px";
const $3276e9745553f254$export$c13fb80f73bb5bf5 = "12px";
const $3276e9745553f254$export$36412f0eae9884ab = "14px";
const $3276e9745553f254$export$9cb266ece8c6e780 = "14px";
const $3276e9745553f254$export$602010da7f82ff85 = "16px";
const $3276e9745553f254$export$72007b6cbdda6c3a = "0";
const $3276e9745553f254$export$23b25f54fea3af4 = "uppercase";
const $3276e9745553f254$export$b525723c9c0fd3c2 = "18px";
const $3276e9745553f254$export$a18ab4cbed1e3c31 = "16px";
const $3276e9745553f254$export$5e96e02743466c31 = "16px";
const $3276e9745553f254$export$7f7949c1794c1d34 = "14px";
const $3276e9745553f254$export$4f23447d88eaec3f = "12px";
const $3276e9745553f254$export$cd07715ef04b96c9 = "none";
const $3276e9745553f254$export$83047dd36262cb15 = "1px";
const $3276e9745553f254$export$767b378a40c983d0 = "16px";
const $3276e9745553f254$export$1ff376c9f129fe57 = "4px";
const $3276e9745553f254$export$30a853f502f9e2c7 = "4px";
const $3276e9745553f254$export$b67be69c900ea369 = "36px";
const $3276e9745553f254$export$f587156ff808181d = "hsl(207 100% 98% / 0)";
const $3276e9745553f254$export$fd9d81e02468cf0c = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$8684d5dfbbea5f2b = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$be8971e457224a5a = "hsl(207 100% 98% / 0)";
const $3276e9745553f254$export$8f6cc8879d3d37c4 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$e448803c843846e5 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$897cdcc0c18bc5db = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$e06d5ee5e53edb47 = "hsl(207 100% 40% / 0.2)";
const $3276e9745553f254$export$699fab328727c6b6 = "rgb(89.8% 95.7% 100% / 0)";
const $3276e9745553f254$export$3c0ad4fb3a1b0ffb = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$5966559b892ee111 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$1b08e227e9d667a9 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$7179773622cad25f = "hsl(207 100% 40% / 0.2)";
const $3276e9745553f254$export$bdf7ce7eb3df6341 = "#0070cc";
const $3276e9745553f254$export$5b8cb27bcb201dc4 = "#005499";
const $3276e9745553f254$export$3f3dc155ded54e45 = "#005499";
const $3276e9745553f254$export$ba27deb6cad88273 = "#005499";
const $3276e9745553f254$export$456505b8367dc33a = "#053C60";
const $3276e9745553f254$export$eedcb4b10d336c0 = "hsl(0 0% 100% / 0.38)";
const $3276e9745553f254$export$ff1075fa496d325b = "#ffffff";
const $3276e9745553f254$export$a7456311bf695db4 = "#005499";
const $3276e9745553f254$export$cd05d22763540ee7 = "#005499";
const $3276e9745553f254$export$a8af6e0b3bb0ceab = "#ffffff";
const $3276e9745553f254$export$ea642331f78f7724 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$7c9eeddcc0155611 = "hsl(207 100% 40% / 0)";
const $3276e9745553f254$export$70b98ceba2109d6f = "hsl(200 30% 98% / 0)";
const $3276e9745553f254$export$32adc8c8c23f8278 = "#0070cc";
const $3276e9745553f254$export$53894d17111f8e4e = "hsl(207 100% 40% / 0)";
const $3276e9745553f254$export$5bee99e492dce333 = "hsl(200 30% 98% / 0)";
const $3276e9745553f254$export$4552f038cdc313b1 = "#0070cc";
const $3276e9745553f254$export$cbf4404a4e15c5e7 = "hsl(207 100% 40% / 0)";
const $3276e9745553f254$export$23117a1b4fa2ee4a = "#0070cc";
const $3276e9745553f254$export$6df9b51adfe2c892 = "#0070cc";
const $3276e9745553f254$export$5c93c9fbb78bb2c1 = "#0070cc";
const $3276e9745553f254$export$e1ce320d9ab1c61 = "#0070cc";
const $3276e9745553f254$export$7940fcec187cb2bd = "#0070cc";
const $3276e9745553f254$export$d8345d4ed478774c = "#0070cc";
const $3276e9745553f254$export$68249f79b2b24f73 = "#0070cc";
const $3276e9745553f254$export$9ead9293289737ba = "#005499";
const $3276e9745553f254$export$95454f0202b5bb8a = "#005499";
const $3276e9745553f254$export$6f2a28348f849e77 = "#005499";
const $3276e9745553f254$export$9cc1a66c6e1f0d4d = "#053C60";
const $3276e9745553f254$export$3175a605e0140911 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$ab123ccff6e55a0b = "36px";
const $3276e9745553f254$export$76ef6df3b64524e8 = "Roboto";
const $3276e9745553f254$export$eb9380587111f46e = "700";
const $3276e9745553f254$export$ca8181fe2475a0ce = "14px";
const $3276e9745553f254$export$b37e6f1e35b3e7ab = "14px";
const $3276e9745553f254$export$8adee4da5958a9ec = "0";
const $3276e9745553f254$export$b0a94bcb8b47f8b5 = "0px";
const $3276e9745553f254$export$e4b49656504a3957 = "20px";
const $3276e9745553f254$export$fe4627f581df3f54 = "36px";
const $3276e9745553f254$export$9b864bc8d5db3c7a = "56px";
const $3276e9745553f254$export$3829a6ec50c0f791 = "40px";
const $3276e9745553f254$export$f4dfab5fdc242b93 = "100px";
const $3276e9745553f254$export$56f84bc94a249aaf = "4px";
const $3276e9745553f254$export$b2a7f6dedbe8d4ae = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$7f5bb126a7ea906a = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$e58f39eec65e0b76 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$20360ceefb533fb = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$ea569fd99f87a06a = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$1c5e5838d4e8eebe = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$e79da0208dc75992 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$5ab048a991219b8c = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$e5c0a5d226b4ee63 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$b06fab23153184d6 = "#0070cc";
const $3276e9745553f254$export$71ddb8bc4376788d = "#0070cc";
const $3276e9745553f254$export$67f367c1dfd5d3b7 = "#0070cc";
const $3276e9745553f254$export$8d6c6c1bd7814c60 = "#0070cc";
const $3276e9745553f254$export$f67dcf708fbd73bc = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$a805ee3abb44f47b = "#646464";
const $3276e9745553f254$export$7eb6272929988e2e = "#005499";
const $3276e9745553f254$export$4b09028d2528773c = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$db838e84dd688c76 = "4px";
const $3276e9745553f254$export$ae915504e2a18be8 = "1px";
const $3276e9745553f254$export$a65645ba055136c8 = "4px";
const $3276e9745553f254$export$838104e21ca5a19d = "#191919";
const $3276e9745553f254$export$4bb2a4cc71915256 = "#E2E2E1";
const $3276e9745553f254$export$b2e919a6cbfe006e = "#ffffff";
const $3276e9745553f254$export$6e404c3c9be4c803 = "Roboto";
const $3276e9745553f254$export$341f3e22d85f986b = "600";
const $3276e9745553f254$export$9d1c9df76b2ad44b = "14px";
const $3276e9745553f254$export$ef0c0a0e1df557cc = "12px";
const $3276e9745553f254$export$9d6da21b7f25ba42 = "0";
const $3276e9745553f254$export$586ef59e988cd548 = "4px";
const $3276e9745553f254$export$e4bf6f69d8b12729 = "100px";
const $3276e9745553f254$export$91a69802d20d599b = "1px";
const $3276e9745553f254$export$ad14861617df4437 = "24px";
const $3276e9745553f254$export$c414cba53d02ca20 = "8px";
const $3276e9745553f254$export$947eaeddfab43373 = "8px";
const $3276e9745553f254$export$9588b2e0bbc9d556 = "4px";
const $3276e9745553f254$export$fed9a8adb39d758b = "28px";
const $3276e9745553f254$export$c0f556b14789c4e6 = "8px";
const $3276e9745553f254$export$d1639dad04ad0547 = "8px";
const $3276e9745553f254$export$baed45022e2a7982 = "4px";
const $3276e9745553f254$export$4b76f39175f0013d = "36px";
const $3276e9745553f254$export$628b4df0a363bf4d = "8px";
const $3276e9745553f254$export$2a0954c14d67929d = "8px";
const $3276e9745553f254$export$5d1500b4a57cc110 = "8px";
const $3276e9745553f254$export$78bb03c5be80436c = "#ffffff";
const $3276e9745553f254$export$54f70ca93c994d78 = "#F0F0EF";
const $3276e9745553f254$export$e3dd8acf7e47031b = "#DBF6CA";
const $3276e9745553f254$export$e43bff698a8dfbad = "#FFEEEE";
const $3276e9745553f254$export$6bcfcd9223df7e6 = "#F8ECE7";
const $3276e9745553f254$export$aaaa141d9a4271b6 = "#F0F3FA";
const $3276e9745553f254$export$4550c5abe1916743 = "#7D7D7D";
const $3276e9745553f254$export$33de5d52a40c74bb = "#1D4405";
const $3276e9745553f254$export$c0ad38910caef39d = "#6F1010";
const $3276e9745553f254$export$18afb996161fdda8 = "#3A1404";
const $3276e9745553f254$export$58d9b7589ec1b854 = "#263146";
const $3276e9745553f254$export$19919b03e06ddb93 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$67b5c40e6559a7fa = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$12e1be37fde3ea72 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$db84367af70c1ff1 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$37249a3917b3b82f = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$79a5f596c2b0cc25 = "#F0F0EF";
const $3276e9745553f254$export$6e18cdfeccbbdb23 = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$a3551c8ced99a9a = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$79335b67bc26b821 = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$3c8142e1e0fc9733 = "hsl(207 100% 40% / 0.5)";
const $3276e9745553f254$export$10b174a9def6dceb = "#323232";
const $3276e9745553f254$export$7a2ceca8767416a5 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$56db8ce29b377bf2 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$6a6a3e2cab1bed3b = "#0070cc";
const $3276e9745553f254$export$f8d99fb64297e05a = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$cbeaf87373b45488 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$a676f817d02f5209 = "#6F1010";
const $3276e9745553f254$export$82be0988c2118f7e = "#4B4B4B";
const $3276e9745553f254$export$d6f0695b99884305 = "#ffffff";
const $3276e9745553f254$export$407dd87d92a51f47 = "#191919";
const $3276e9745553f254$export$57b0941f92173029 = "#191919";
const $3276e9745553f254$export$e93aa21fc073fa41 = "#4B4B4B";
const $3276e9745553f254$export$7ea48ba511b9e63e = "#ffffff";
const $3276e9745553f254$export$43c8f926529b7e18 = "#005499";
const $3276e9745553f254$export$ca3865d8ffc5952f = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$90683711fb4bef81 = "#E2E2E1";
const $3276e9745553f254$export$752f6974143a52ba = "#C8C8C7";
const $3276e9745553f254$export$5008f618d8345a67 = "#DE3131";
const $3276e9745553f254$export$44eb3b115a64f132 = "#3B770E";
const $3276e9745553f254$export$de064229fcb5defa = "#DF5C24";
const $3276e9745553f254$export$b0165922ab633327 = "#5E728D";
const $3276e9745553f254$export$6f0b9975e44923c9 = "#646464";
const $3276e9745553f254$export$fc194a85a504f3c9 = "#1D4405";
const $3276e9745553f254$export$da7c568ac2dab421 = "#3A1404";
const $3276e9745553f254$export$f735272da4d7b070 = "#6F1010";
const $3276e9745553f254$export$e41bcc6142854978 = "#263146";
const $3276e9745553f254$export$2d6f5cbe33ffecaa = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$4e936d55cc199959 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$e196f4e78e8dece6 = "#0070cc";
const $3276e9745553f254$export$d08dd2b917bbdcbe = "#0070cc";
const $3276e9745553f254$export$700910abe8bd67bb = "#0070cc";
const $3276e9745553f254$export$c3d0d12d7d167459 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$cc599fb1e3e3300c = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$cb2419b9c16cfcdd = "#0070cc";
const $3276e9745553f254$export$1128c8056cd9276b = "#0070cc";
const $3276e9745553f254$export$915246f5d427a346 = "#0070cc";
const $3276e9745553f254$export$1dd7d7f143fff99a = "#4B4B4B";
const $3276e9745553f254$export$91fc644371eb38f5 = "#4B4B4B";
const $3276e9745553f254$export$ec43172cc32e77e3 = "#0070cc";
const $3276e9745553f254$export$4600880359d615e1 = "#0070cc";
const $3276e9745553f254$export$51555e4eb1ceea4c = "#0070cc";
const $3276e9745553f254$export$fc107430d597706f = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$7d16c5378b89bd5 = "Roboto";
const $3276e9745553f254$export$998d3c1f7e81e9eb = "600";
const $3276e9745553f254$export$ed23011c0d9d2446 = "12px";
const $3276e9745553f254$export$f8867386b651d9da = "14px";
const $3276e9745553f254$export$1bf4e0bbd42ea607 = "14px";
const $3276e9745553f254$export$9c459b111fa4f4f3 = "0";
const $3276e9745553f254$export$3f6b29d164f2bd31 = "16px";
const $3276e9745553f254$export$e467a06f8f022248 = "14px";
const $3276e9745553f254$export$8725bf5ac2c380cf = "14px";
const $3276e9745553f254$export$6a595734c76fe30 = "4px";
const $3276e9745553f254$export$457c2d7fb8320c77 = "8px";
const $3276e9745553f254$export$1a2e1724738a4f36 = "12px";
const $3276e9745553f254$export$8fc672cb7298d1de = "16px";
const $3276e9745553f254$export$f4d657e58ef789df = "20px";
const $3276e9745553f254$export$1a9af4c2a2e53ffe = "24px";
const $3276e9745553f254$export$d7333ebbf97043c = "28px";
const $3276e9745553f254$export$35bc30912bd412e5 = "32px";
const $3276e9745553f254$export$8527b31e4906a715 = "36px";
const $3276e9745553f254$export$5a2fe487d6396502 = "#ffffff";
const $3276e9745553f254$export$46347942d17069d5 = "#AFAFAE";
const $3276e9745553f254$export$aba2ba25c52e742d = "#7D7D7D";
const $3276e9745553f254$export$4f9e8b52864daf82 = "#0070cc";
const $3276e9745553f254$export$3998bea291218554 = "#0070cc";
const $3276e9745553f254$export$bddeb9cc658ce838 = "#ffffff";
const $3276e9745553f254$export$3fbef91c81a27ff7 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$be8504476447899 = "#E2E2E1";
const $3276e9745553f254$export$aa7b4d33dda1ff3e = "#AFAFAE";
const $3276e9745553f254$export$1eccb6bf1b45adc0 = "#AFAFAE";
const $3276e9745553f254$export$f5f294c76327e31 = "#0070cc";
const $3276e9745553f254$export$e087e8a19001f08f = "#0070cc";
const $3276e9745553f254$export$5932a3fffc13208b = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$bb4efa5fbc7bc49f = "#7D7D7D";
const $3276e9745553f254$export$2598a87ffab12199 = "#4B4B4B";
const $3276e9745553f254$export$a81df3089c6d474c = "#4B4B4B";
const $3276e9745553f254$export$3a79d547ba3a5d26 = "#0070cc";
const $3276e9745553f254$export$85ccc16cee46224 = "#005499";
const $3276e9745553f254$export$df7d2e4081bbb5d1 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$2d15d1c7fbd172c = "#4B4B4B";
const $3276e9745553f254$export$14cb47ca5f5d1cd6 = "#191919";
const $3276e9745553f254$export$16da9ff5861987a7 = "#191919";
const $3276e9745553f254$export$419eac1adb13f9fc = "#0070cc";
const $3276e9745553f254$export$e2681ddb55045e4c = "#0070cc";
const $3276e9745553f254$export$5feebe6dca4c6e2f = "hsl(0 0% 29.4% / 0.38)";
const $3276e9745553f254$export$18df805cce67e76e = "#DE3131";
const $3276e9745553f254$export$384dc265e7feea50 = "hsl(350, 70%, 96%)";
const $3276e9745553f254$export$5168884c17b5fa13 = "#DF5C24";
const $3276e9745553f254$export$1e76832163599c23 = "#FFB892";
const $3276e9745553f254$export$165790c96dfe23b = "#3B770E";
const $3276e9745553f254$export$2d719fd496813158 = "#DBF6CA";
const $3276e9745553f254$export$83b4faef127cb7b7 = "#5E728D";
const $3276e9745553f254$export$54d62555f8f353f9 = "#F0F3FA";
const $3276e9745553f254$export$f780a2ef2c45e34d = "100px";
const $3276e9745553f254$export$cb5734e2315e2efe = "1px";
const $3276e9745553f254$export$995f211f28f1437 = "20px";
const $3276e9745553f254$export$db164abfd7645c18 = "4px";
const $3276e9745553f254$export$e5da4b0c5e56db5d = "4px";
const $3276e9745553f254$export$dad9521985b6131b = "100px";
const $3276e9745553f254$export$2f90d06b52e9497 = "16px";
const $3276e9745553f254$export$253d8914fa26df10 = "4px";
const $3276e9745553f254$export$d6f8ff389cb04136 = "4px";
const $3276e9745553f254$export$5e2bf4249906aa9c = "36px";
const $3276e9745553f254$export$c1c2909bedb0a7dd = "#FFEEEE";
const $3276e9745553f254$export$63d9ba7538e73dff = "#ffffff";
const $3276e9745553f254$export$f67d4fb49acb1f89 = "#F0F0EF";
const $3276e9745553f254$export$2fe4aa9229f13169 = "#7D7D7D";
const $3276e9745553f254$export$c692e870557d1485 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$54b6b20194425cd6 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$be70cab265492c56 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$784e486f16c66f2d = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$6da19c50ace6d610 = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$4d1a2e4dfe067853 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$987b3d1dafde78df = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$e836365f68f36c1d = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$23a0fd118827e1dc = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$9919355b48dcc96d = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$e3c46fa14b4ebd10 = "hsl(207 100% 40% / 0.5)";
const $3276e9745553f254$export$9bcfcb94d6adb5eb = "hsl(60 3.23% 93.9% / 0.38)";
const $3276e9745553f254$export$4c138a91262deb86 = "#323232";
const $3276e9745553f254$export$1e05bfb99ce0bab0 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$440246e634610acd = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$463c36ef5e33cde = "#0070cc";
const $3276e9745553f254$export$673c5cc0104c050 = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$d5b20e83a050689e = "hsl(0 0% 19.6% / 0.38)";
const $3276e9745553f254$export$b329ef8c78e58195 = "#6F1010";
const $3276e9745553f254$export$c74b59fc0c00f12f = "#4B4B4B";
const $3276e9745553f254$export$b3d105834921abae = "#ffffff";
const $3276e9745553f254$export$41a0ad556cd1f41e = "#4B4B4B";
const $3276e9745553f254$export$4749334586e6fad3 = "#191919";
const $3276e9745553f254$export$a22d0c3e2f60d443 = "#005499";
const $3276e9745553f254$export$7c9f7df759bd38d1 = "#FFEEEE";
const $3276e9745553f254$export$d02c01c4b3e77354 = "#E2E2E1";
const $3276e9745553f254$export$a9af785ad1437427 = "#C8C8C7";
const $3276e9745553f254$export$9b017cc64a769252 = "#646464";
const $3276e9745553f254$export$ef7785f455f0ff57 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$6037c748dfa10ac2 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$e3ebbb1347a60e9d = "#0070cc";
const $3276e9745553f254$export$4af2ae34cb51f1d8 = "#0070cc";
const $3276e9745553f254$export$9105c0035b3c9dbc = "#0070cc";
const $3276e9745553f254$export$ccf0d988c28f4ac3 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$a152e09ad4cfa768 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$c026cdd1f9d9818 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$1e6ceb099a6c182d = "#0070cc";
const $3276e9745553f254$export$a31e532571133db1 = "#0070cc";
const $3276e9745553f254$export$b50e97467970464c = "#0070cc";
const $3276e9745553f254$export$dc0f61867c8eb438 = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$9ca8e072a61adfe6 = "#4B4B4B";
const $3276e9745553f254$export$b486bbf27048fca6 = "#4B4B4B";
const $3276e9745553f254$export$d266a9d896cbc7e5 = "#0070cc";
const $3276e9745553f254$export$f3894963a227c2d1 = "#0070cc";
const $3276e9745553f254$export$e879afede95344e2 = "#0070cc";
const $3276e9745553f254$export$64e44e4f458bdd15 = "hsl(0 0% 29.4% / 0.38)";
const $3276e9745553f254$export$a62f741044aa85bb = "Roboto";
const $3276e9745553f254$export$d411dbbc5db0f8e5 = "600";
const $3276e9745553f254$export$379000749f6ebe9d = "16px";
const $3276e9745553f254$export$ac903168df7d1c8c = "14px";
const $3276e9745553f254$export$4ae3397bafb779ba = "12px";
const $3276e9745553f254$export$31a061c5e74d37df = "14px";
const $3276e9745553f254$export$3f73af3bf1f38889 = "0";
const $3276e9745553f254$export$655d640242b74977 = "18px";
const $3276e9745553f254$export$228d1ca9c77817dd = "14px";
const $3276e9745553f254$export$4d3f5ae03ef63815 = "#ffffff";
const $3276e9745553f254$export$4f5fa3d302b4eb89 = "#f5f5f5";
const $3276e9745553f254$export$3aa8eef02f53a11f = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$9cee6c095c5d53f = "#FFEEEE";
const $3276e9745553f254$export$46616e63025810c3 = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$2eb243147337e0e9 = "#ffffff";
const $3276e9745553f254$export$ef30719fb3a37b5c = "#f5f5f5";
const $3276e9745553f254$export$18dec71efe39c363 = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$1983392f49eb3b77 = "#FFEEEE";
const $3276e9745553f254$export$f069eb93d208df24 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$eb1bb4481b303f23 = "#f5f5f5";
const $3276e9745553f254$export$2054ca69e320709f = "#E2E2E1";
const $3276e9745553f254$export$71d1df7ff8827dd3 = "1px";
const $3276e9745553f254$export$6d220a723977f960 = "4px";
const $3276e9745553f254$export$2c16a3f0e6b48836 = "8px";
const $3276e9745553f254$export$58ecf9341fd2c423 = "16px";
const $3276e9745553f254$export$63860ae533ec763 = "hsl(207 100% 98% / 0)";
const $3276e9745553f254$export$8cd575c98ef7c7e3 = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$23b1fadb952026bb = "hsl(207 100% 40% / 0.15)";
const $3276e9745553f254$export$6dc4bfc245f9c03f = "hsl(0 0% 100% / 0.38)";
const $3276e9745553f254$export$407ca803dcba1686 = "#005499";
const $3276e9745553f254$export$db0f7f411822f8f9 = "#005499";
const $3276e9745553f254$export$333ac82fea827fd7 = "#005499";
const $3276e9745553f254$export$2a45d93c2e2c57d7 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$307543bd31288d3a = "#732673";
const $3276e9745553f254$export$583bfe75ad3be530 = "Roboto";
const $3276e9745553f254$export$bd18f91ff949705a = "600";
const $3276e9745553f254$export$f0729e79e516d76f = "0";
const $3276e9745553f254$export$a3037016530afa41 = "16px";
const $3276e9745553f254$export$63b3bf0bcd5dec0 = "14px";
const $3276e9745553f254$export$63f6e89485f022a0 = "14px";
const $3276e9745553f254$export$2c39b60b9ab3c509 = "12px";
const $3276e9745553f254$export$d20edb3b4cd46521 = "underline";
const $3276e9745553f254$export$1a81d73bf487bad2 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$66899150b01781f = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$f717e38166baeb5c = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$1b8e258852406e33 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$6024c97884eba4d8 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$be689acb580cdc83 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$49e326127c3153ea = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$55f25450a0bf5e72 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$fc90332a56a8f3c = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$2c6002f82a481ef3 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$d22c37eb694c13bd = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$fd0078d1143f7e9a = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$d1033c477c3c6ff9 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$ce1e53725c205a2b = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$be282364918d0701 = "#0070cc";
const $3276e9745553f254$export$e8d2b6a7823bd61c = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$69b4d96c29de7d5a = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$d71ecf661337863e = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$dd2313e49d842f7c = "#0070cc";
const $3276e9745553f254$export$407193ea73d64650 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$68a64f766c3e06eb = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$7bd4b125f5796f0b = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$dc235a9e36421303 = "#0070cc";
const $3276e9745553f254$export$44a93435f9e76b5f = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$5114818da7303033 = "#323232";
const $3276e9745553f254$export$819bb9ecff8821f6 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$9d48bca40b858c58 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$f4432833dbc2b032 = "hsl(0 0% 19.6% / 0.38)";
const $3276e9745553f254$export$5371ecf7e7c3c5fb = "#0070cc";
const $3276e9745553f254$export$bce78b0af6106c0d = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$84c6ef30066cb450 = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$19c89d51fe48e97e = "hsl(0 0% 19.6% / 0.38)";
const $3276e9745553f254$export$b4ded087f67cfcb1 = "#0070cc";
const $3276e9745553f254$export$98739c3332aa1180 = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$5450679c20cb502e = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$72df667c0ea477ce = "hsl(0 0% 19.6% / 0.38)";
const $3276e9745553f254$export$de71cd689917b4b9 = "20px";
const $3276e9745553f254$export$46fd5ca6b9cb553c = "16px";
const $3276e9745553f254$export$c3edf74d2870face = "4px";
const $3276e9745553f254$export$b4a7b3d28ddcea06 = "4px";
const $3276e9745553f254$export$aab87273839218af = "100px";
const $3276e9745553f254$export$31a25690cfb3c72b = "0px";
const $3276e9745553f254$export$4f243c7e47f36178 = "#F0F0EF";
const $3276e9745553f254$export$21e1926cfd31fb34 = "#E2E2E1";
const $3276e9745553f254$export$729f8261cfc7f56f = "0px";
const $3276e9745553f254$export$841ebfb9757ebe4e = "100px";
const $3276e9745553f254$export$9e4598db4a678250 = "4px";
const $3276e9745553f254$export$5c0a15ed7f937814 = "1px";
const $3276e9745553f254$export$6fdaa6b611356931 = "#C8C8C7";
const $3276e9745553f254$export$14148cd5c9a8c997 = "376px";
const $3276e9745553f254$export$3c9f15c3fd95369 = "576px";
const $3276e9745553f254$export$8dbca5b14d0844eb = "776px";
const $3276e9745553f254$export$8e20ff08973f499 = "300px";
const $3276e9745553f254$export$288cafde2f49d409 = "0px";
const $3276e9745553f254$export$4d69bf9275adc0b4 = "4px";
const $3276e9745553f254$export$15fcc38e88786dd4 = "#ffffff";
const $3276e9745553f254$export$fc3f1c3df48b1cc4 = "#E2E2E1";
const $3276e9745553f254$export$a3582a1f7ae69771 = "16px";
const $3276e9745553f254$export$76c304873b7a47d1 = "24px";
const $3276e9745553f254$export$3be63787605bb63b = "8px";
const $3276e9745553f254$export$6da960e179d64c7e = "Roboto";
const $3276e9745553f254$export$d4ec6eea36d83142 = "400";
const $3276e9745553f254$export$f148b6bcf802c0a0 = "26px";
const $3276e9745553f254$export$8fcd22ab977bd8d8 = "24px";
const $3276e9745553f254$export$352a97f8e784158a = "0";
const $3276e9745553f254$export$902221d8e98b812c = "0 0 0 0 hsl(200, 30%, 86%)";
const $3276e9745553f254$export$e492848c875e9064 = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $3276e9745553f254$export$bd9a62c800d4c4a9 = "1px";
const $3276e9745553f254$export$76ef89a37b8ace4d = "4px";
const $3276e9745553f254$export$735b1ff34fe199d4 = "16px";
const $3276e9745553f254$export$302ed6b9f6c0b425 = "8px";
const $3276e9745553f254$export$1ba594a12602b520 = "#FFEEEE";
const $3276e9745553f254$export$bc25af37f4d9124d = "#F8ECE7";
const $3276e9745553f254$export$569648afc0995710 = "#DBF6CA";
const $3276e9745553f254$export$4c44b4e9bc0481e9 = "#F0F3FA";
const $3276e9745553f254$export$df27106c05b21907 = "#263146";
const $3276e9745553f254$export$e92b34357220e8e0 = "#DE3131";
const $3276e9745553f254$export$809bc51a80a73ffa = "#DF5C24";
const $3276e9745553f254$export$b20e54fe63f136ec = "#3B770E";
const $3276e9745553f254$export$aaaff3ea35504d9a = "#5E728D";
const $3276e9745553f254$export$d2b4b84e205366a4 = "#263146";
const $3276e9745553f254$export$bd02a858e71ac856 = "#191919";
const $3276e9745553f254$export$9f0fea77a037b87a = "#ffffff";
const $3276e9745553f254$export$2b03536d20a3b2f6 = "#6F1010";
const $3276e9745553f254$export$ca5110e6287a9670 = "Roboto";
const $3276e9745553f254$export$6595d0fad08bd2b4 = "400";
const $3276e9745553f254$export$4339da1d2671e324 = "16px";
const $3276e9745553f254$export$891da890c43fc05e = "14px";
const $3276e9745553f254$export$ce0ddd473dd20afc = "700";
const $3276e9745553f254$export$16dd3c4d6489ba61 = "18px";
const $3276e9745553f254$export$ddcf665488274808 = "16px";
const $3276e9745553f254$export$5bdc2b5fff62d35 = "0";
const $3276e9745553f254$export$86773c375c0bb9a1 = "#0070cc";
const $3276e9745553f254$export$6607013dc8c505fa = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$df5495caecdcb614 = "hsl(0 0% 19.6% / 0.38)";
const $3276e9745553f254$export$23aa1d4fb282b9e2 = "#323232";
const $3276e9745553f254$export$9f19810b26e253c8 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$a1820a4b6e6de5c = "hsl(0 0% 19.6% / 0.38)";
const $3276e9745553f254$export$64a5a6262510bdfe = "#0070cc";
const $3276e9745553f254$export$561d96085c937ed4 = "#0070cc";
const $3276e9745553f254$export$c60d87bac1618e10 = "hsl(0 0% 29.4% / 0.38)";
const $3276e9745553f254$export$7fabd56572773fe8 = "#4B4B4B";
const $3276e9745553f254$export$3f9ecbd7e63c2056 = "#4B4B4B";
const $3276e9745553f254$export$a5c9bce6d83773a = "hsl(0 0% 29.4% / 0.38)";
const $3276e9745553f254$export$5e221dc1e3b0d8bf = "0px";
const $3276e9745553f254$export$987a18f51782dfac = "100px";
const $3276e9745553f254$export$4c09818a16bf66d3 = "16px";
const $3276e9745553f254$export$e2b1a3f6040b3539 = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$71201f47e9dc9666 = "hsl(207 100% 40% / 0.5)";
const $3276e9745553f254$export$6c4b9b05028ede96 = "hsl(60 3.23% 93.9% / 0.38)";
const $3276e9745553f254$export$b1d4a516e2e88fe6 = "#F0F0EF";
const $3276e9745553f254$export$f1348024bfa310d4 = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$5d9f8f5a09ed11cc = "hsl(60 3.23% 93.9% / 0.38)";
const $3276e9745553f254$export$c38f3967889bac93 = "#0070cc";
const $3276e9745553f254$export$64092d816c16ef53 = "#0070cc";
const $3276e9745553f254$export$7521fab9ed6230d8 = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$d4e8d359f8069dfc = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$1814043782ee69c8 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$f17aa8a146709aa2 = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$3d1b7f700b76b19e = "1px";
const $3276e9745553f254$export$e33736dbca43baac = "100px";
const $3276e9745553f254$export$fa6928ff7c04c2cd = "32px";
const $3276e9745553f254$export$3a2ecb48778e609e = "20px";
const $3276e9745553f254$export$1ced0159d1e6df39 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$f405b4ac7e3959c8 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$7c74bcd0f7f3be40 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$b2bbe3653cad5eb2 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$5ebb29b4abcdfb8f = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$a6e416f594566ded = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$db028a317a02353a = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$6f5efccfe6dfd313 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$4fe40f383eb5faf5 = "#0070cc";
const $3276e9745553f254$export$71ea0e30dc1b6ba4 = "#0070cc";
const $3276e9745553f254$export$8c4beee5a921e3c9 = "#0070cc";
const $3276e9745553f254$export$35a66965267ed529 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$7bcf618f61979316 = "#191919";
const $3276e9745553f254$export$a6f5b1dbfa6022b = "#191919";
const $3276e9745553f254$export$2cd9519356202e1f = "#191919";
const $3276e9745553f254$export$aa7a4ccf8d59e280 = "#005499";
const $3276e9745553f254$export$ee5e76ba05b4ab28 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$f1088235eae15437 = "0px";
const $3276e9745553f254$export$fafa860328e70ae = "4px";
const $3276e9745553f254$export$a7a5eb1834e82687 = "8px";
const $3276e9745553f254$export$7d6465298d6c4692 = "Roboto";
const $3276e9745553f254$export$a0f454c876af7960 = "700";
const $3276e9745553f254$export$e2adaac19dce9831 = "400";
const $3276e9745553f254$export$dddff9d395fc8f70 = "16px";
const $3276e9745553f254$export$1dd2d60f07979c32 = "14px";
const $3276e9745553f254$export$42ae81b5c0a2fbb = "0";
const $3276e9745553f254$export$a46db5db085db139 = "#ffffff";
const $3276e9745553f254$export$27401163f4368ffc = "#E2E2E1";
const $3276e9745553f254$export$96b2aad183e1f54f = "0px";
const $3276e9745553f254$export$ee764dc2d555ddf6 = "4px";
const $3276e9745553f254$export$794d9c23b73cc47e = "8px";
const $3276e9745553f254$export$3f57378f9ec9cd94 = "4px";
const $3276e9745553f254$export$ddcc321b1a8861dd = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $3276e9745553f254$export$b51251547efb0d8e = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$85a890daf957fbec = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$89e8e756190bda61 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$770bdd3d491ddfe6 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$8e00bb2c5d8bbc3b = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$c21d874e9498ef82 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$61ede0f7013c2b81 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$6fe37393ecda4209 = "#0070cc";
const $3276e9745553f254$export$ff38bf95992f09fc = "hsl(60 0.9% 78.2% / 0.38)";
const $3276e9745553f254$export$88cfb69c788bb860 = "#DE3131";
const $3276e9745553f254$export$52e86a91e2ad6034 = "#191919";
const $3276e9745553f254$export$cca144c3f4aa7626 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$f10f0ec496f636f7 = "#4B4B4B";
const $3276e9745553f254$export$58dfb1025a181356 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$bc322de6f84fd903 = "#6F1010";
const $3276e9745553f254$export$49337470bba91ab9 = "#646464";
const $3276e9745553f254$export$4a34e2a16154db83 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$26aa6c0ceb7e966e = "#4B4B4B";
const $3276e9745553f254$export$b816de746fb400a5 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$c02de212dbe9d176 = "#6F1010";
const $3276e9745553f254$export$116727610d612ae4 = "8px";
const $3276e9745553f254$export$71b44d15d3de46dd = "1px";
const $3276e9745553f254$export$bace76a59986f565 = "8px";
const $3276e9745553f254$export$9ffe2275b011d7e1 = "Roboto";
const $3276e9745553f254$export$b0985124f4df02d2 = "18px";
const $3276e9745553f254$export$a315c6564df14490 = "400";
const $3276e9745553f254$export$aa1b94da4287d2a0 = "14px";
const $3276e9745553f254$export$e5114fa3fec26908 = "0";
const $3276e9745553f254$export$84f5f00bc441b732 = "4px";
const $3276e9745553f254$export$51cb609d45dac1eb = "Roboto";
const $3276e9745553f254$export$3827778002413131 = "600";
const $3276e9745553f254$export$e67e3340791cadd4 = "14px";
const $3276e9745553f254$export$ec94e1b644056c99 = "12px";
const $3276e9745553f254$export$f3bbd9a0f0930579 = "0";
const $3276e9745553f254$export$33ce3a4dcea39de = "36px";
const $3276e9745553f254$export$d8e53851991cdd42 = "#ffffff";
const $3276e9745553f254$export$fe3a5cd62a598e84 = "#f5f5f5";
const $3276e9745553f254$export$5edfe3b007b29215 = "#4B4B4B";
const $3276e9745553f254$export$86d4c0985100dcd0 = "4px";
const $3276e9745553f254$export$8266cc989bac4651 = "#F0F0EF";
const $3276e9745553f254$export$d4bd2b0a79e3ef71 = "#C8C8C7";
const $3276e9745553f254$export$4ce259255a4d70c4 = "#7D7D7D";
const $3276e9745553f254$export$2869c51015852e03 = "#DE3131";
const $3276e9745553f254$export$f5e3fe890c9ff1e = "#646464";
const $3276e9745553f254$export$1cfbd34f600c6efa = "#DE3131";
const $3276e9745553f254$export$5a252ec11a1445ad = "0px";
const $3276e9745553f254$export$c735ecaf581f705 = "100px";
const $3276e9745553f254$export$49bf4afa6ca745e = "0px";
const $3276e9745553f254$export$edc7fc4c8271f574 = "100px";
const $3276e9745553f254$export$253ba067522eaa91 = "4px";
const $3276e9745553f254$export$c945866cf5c6fd53 = "16px";
const $3276e9745553f254$export$5b8c998da32edfab = "20px";
const $3276e9745553f254$export$4cb4e758ff318324 = "24px";
const $3276e9745553f254$export$9965c30cb78bb99e = "28px";
const $3276e9745553f254$export$73f604c81bd5b0de = "24px";
const $3276e9745553f254$export$e2b17b1f6ba2f2c0 = "176px";
const $3276e9745553f254$export$9d31ebafe2568375 = "24px";
const $3276e9745553f254$export$65141d2099878d22 = "68px";
const $3276e9745553f254$export$b889b193e53040e = "#646464";
const $3276e9745553f254$export$80792f69e844dd7a = "1px";
const $3276e9745553f254$export$5ded54aa949b1fd3 = "8px";
const $3276e9745553f254$export$20e329e1e9c12a82 = "8px";
const $3276e9745553f254$export$e2d09706041282a2 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$7aa5ad378865fe04 = "#ffffff";
const $3276e9745553f254$export$4c7f7f1e4a99b8b5 = "hsl(60 1.69% 88.4% / 0)";
const $3276e9745553f254$export$acfd0f4230aa9bd = "#E2E2E1";
const $3276e9745553f254$export$33c117b123a26dc4 = "1px";
const $3276e9745553f254$export$427ad239b0adeca2 = "0px";
const $3276e9745553f254$export$8814694ab67761cf = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$e4759e57c938a220 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$7dc99afc1861281f = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$e5a7cf19fc196fc0 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$742357191da0915b = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$d4fac41645ce7de8 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$258236cb50101bf9 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$b660cdb46497535b = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$6edeb93afbabb3 = "#0070cc";
const $3276e9745553f254$export$8527b5e5f1a32759 = "#0070cc";
const $3276e9745553f254$export$404f9d2e20441a64 = "#0070cc";
const $3276e9745553f254$export$cc0883bf09c21e65 = "#0070cc";
const $3276e9745553f254$export$facf8ff6788b88ea = "#191919";
const $3276e9745553f254$export$5ba09a1a7b4af6ac = "#005499";
const $3276e9745553f254$export$dc278ffa79064219 = "8px";
const $3276e9745553f254$export$1e468d8d8b24f0a7 = "8px";
const $3276e9745553f254$export$8a7407fa38280281 = "0px";
const $3276e9745553f254$export$362ddcf024bed54e = "0px";
const $3276e9745553f254$export$4d9a0d275210ab6f = "0px";
const $3276e9745553f254$export$31a06d75aaa08bbf = "0px";
const $3276e9745553f254$export$3bcae2b0ac664dfb = "2px";
const $3276e9745553f254$export$5e97a30a5d76a6eb = "0px";
const $3276e9745553f254$export$49b56a0f736ebf80 = "0px";
const $3276e9745553f254$export$dcc78db97c706ed5 = "0px";
const $3276e9745553f254$export$db0747eda20d8b11 = "0px";
const $3276e9745553f254$export$b1dd518c969a9dc2 = "0px";
const $3276e9745553f254$export$512259029c84d0f1 = "0px";
const $3276e9745553f254$export$6f6b54dde0882c41 = "0px";
const $3276e9745553f254$export$437187fbcaa7285b = "0px";
const $3276e9745553f254$export$f41d59313e2e2d61 = "0px";
const $3276e9745553f254$export$15265dc7c7a51345 = "2px";
const $3276e9745553f254$export$e9d3d243807e3d2 = "0px";
const $3276e9745553f254$export$e2766d737a057e60 = "Roboto";
const $3276e9745553f254$export$2ddfac786be6e309 = "700";
const $3276e9745553f254$export$59bf55466e4e3745 = "12px";
const $3276e9745553f254$export$22bcc28ea306d2f3 = "0";
const $3276e9745553f254$export$b88310354d2244f3 = "4px";
const $3276e9745553f254$export$824459960cf5a262 = "12px";
const $3276e9745553f254$export$788649a55d91496e = "4px";
const $3276e9745553f254$export$95aa30178720092a = "#F0F0EF";
const $3276e9745553f254$export$16796337c4a008dd = "#7D7D7D";
const $3276e9745553f254$export$92929f84f89fa83 = "#FFEEEE";
const $3276e9745553f254$export$b2ca58ad74caacc7 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$b1b662adf9714ed8 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$a212d99fcf9df17e = "#0070cc";
const $3276e9745553f254$export$6d1640df421fce01 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$ca6a6b82ca40bb5a = "#FFEEEE";
const $3276e9745553f254$export$d781c067583bc79e = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$f5d14a553904785b = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$8447a3259160c2ce = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$3af2ae30823e630b = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$e40e3dd55bf947be = "#6F1010";
const $3276e9745553f254$export$52388e8c4eec52d7 = "#191919";
const $3276e9745553f254$export$bfc21f912830cce0 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$84f8abf314fe1bca = "4px";
const $3276e9745553f254$export$299de995c72a7f6d = "0px";
const $3276e9745553f254$export$994684c23b7a2289 = "8px";
const $3276e9745553f254$export$d30bba31083c3b81 = "4px";
const $3276e9745553f254$export$c47c10b3a195b8bb = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$f1591bd858270ed3 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$fea961df0553afcf = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$e5b0c44f8687a2dd = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$ba60f029700a5b9a = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$fea74d0348af746c = "#0070cc";
const $3276e9745553f254$export$c0cd56cb8adeb0c7 = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$4c10101c8dcd9159 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$199b8a3a24f6052f = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$749561d1ff3174b6 = "#0070cc";
const $3276e9745553f254$export$5b7d5394e6b2d316 = "#0070cc";
const $3276e9745553f254$export$639d3915b8ce82b4 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$f991c2a34a669c11 = "#0070cc";
const $3276e9745553f254$export$e05aad2434815ae1 = "#0070cc";
const $3276e9745553f254$export$a5efeb0d86e557f2 = "#191919";
const $3276e9745553f254$export$ac0c6ce6db4c1549 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$cb7b1f2bb4f70437 = "#ffffff";
const $3276e9745553f254$export$5b874dfd02e0b250 = "#005499";
const $3276e9745553f254$export$3cfc12423f70daae = "1px";
const $3276e9745553f254$export$454beb38955e81fd = "0px";
const $3276e9745553f254$export$e159fbe87f6978e3 = "36px";
const $3276e9745553f254$export$423b9caf92ea785c = "0px";
const $3276e9745553f254$export$ea96f43ec25cb42a = "100px";
const $3276e9745553f254$export$3f2b695522a06851 = "600";
const $3276e9745553f254$export$11aa2bc2efe9adc2 = "12px";
const $3276e9745553f254$export$5277ce3303456bf2 = "0px";
const $3276e9745553f254$export$e652800607db6b2 = "4px";
const $3276e9745553f254$export$3f1bc1575f23a5b9 = "16px";
const $3276e9745553f254$export$6779021d34866272 = "8px";
const $3276e9745553f254$export$9b25e8846de5a4c6 = "#ffffff";
const $3276e9745553f254$export$7ea9497196b9950c = "#E2E2E1";
const $3276e9745553f254$export$1286c08a066cf92a = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $3276e9745553f254$export$452d31c71a4b2c7 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$29dfe4c30f5bdd8e = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$a9fd54786af2362e = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$522ef6dd6d045e1a = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$76ed2592815724ef = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$82c6bb6f9ef8ad05 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$7c79603c9689498a = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$c00e26acdc998f59 = "#0070cc";
const $3276e9745553f254$export$e5b79ea5d86c9947 = "#0070cc";
const $3276e9745553f254$export$e2940776f75e7bde = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$d17ee04829bf7e5d = "#191919";
const $3276e9745553f254$export$e5f9b7707e340c07 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$4b146ead4a24d4ae = "#ffffff";
const $3276e9745553f254$export$16eea8645753ec95 = "#005499";
const $3276e9745553f254$export$ac43e96d39af0fe9 = "0px";
const $3276e9745553f254$export$175ca482ed6f6bca = "0px";
const $3276e9745553f254$export$732efe36f538d0b5 = "0px";
const $3276e9745553f254$export$51c06af4d25b7fbd = "14px";
const $3276e9745553f254$export$e24e0e94fc2167b7 = "400";
const $3276e9745553f254$export$26f066c1988aa416 = "4px";
const $3276e9745553f254$export$9213701f1f96ce09 = "4px";
const $3276e9745553f254$export$4931e5b26cc04c05 = "Roboto";
const $3276e9745553f254$export$6074a5e235cbf222 = "1px";
const $3276e9745553f254$export$c6fd4855184f2ce4 = "0px";
const $3276e9745553f254$export$e7c8cff1096cca6b = "2px";
const $3276e9745553f254$export$5f3989fc72b355c5 = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$694c340304b6cf03 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$295da88ee730d887 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$e76dfb999cb566ad = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$6105cdb447f0f917 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$7504fc34155ea4ea = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$8af690634ab83d08 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$b0809c34687e6321 = "#0070cc";
const $3276e9745553f254$export$e7169e000728aae0 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$d49751a9f9c74d95 = "#0070cc";
const $3276e9745553f254$export$11780cad30f773c3 = "#191919";
const $3276e9745553f254$export$13ff4d77bf18846 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$dd5841622912a30 = "#005499";
const $3276e9745553f254$export$4ab353e2521798aa = "4px";
const $3276e9745553f254$export$f564560b1c0b69a0 = "0px";
const $3276e9745553f254$export$f8de90cd42beeba7 = "8px";
const $3276e9745553f254$export$f8d96a6e6e32683b = "Roboto";
const $3276e9745553f254$export$33b6ba26e004869a = "600";
const $3276e9745553f254$export$e857928a445edf3 = "14px";
const $3276e9745553f254$export$600f9c33474c074e = "12px";
const $3276e9745553f254$export$e7ff8df7907262bb = "0";
const $3276e9745553f254$export$ee9afb269ebcf753 = "#ffffff";
const $3276e9745553f254$export$905dbec0b0250e3b = "#E2E2E1";
const $3276e9745553f254$export$ce6f6641c7bb2372 = "1px";
const $3276e9745553f254$export$4cbe16864bd24f8c = "0px";
const $3276e9745553f254$export$521605d09d8c162c = "70px";
const $3276e9745553f254$export$c425de24adc2b8b8 = "8px";
const $3276e9745553f254$export$2d128d3377891546 = "8px";
const $3276e9745553f254$export$170ee3bcb8ad49a0 = "#FBFBFB";
const $3276e9745553f254$export$b9184a6500088a33 = "#E2E2E1";
const $3276e9745553f254$export$a133f97fe8f7af80 = "1px";
const $3276e9745553f254$export$440bfa12676d4362 = "0px";
const $3276e9745553f254$export$23df00f94a7966ab = "276px";
const $3276e9745553f254$export$ddc6772884310bfd = "8px";
const $3276e9745553f254$export$da255a4cc88a4cac = "8px";
const $3276e9745553f254$export$b580f1a61f577587 = "16px";
const $3276e9745553f254$export$d48962f1fd8fbdea = "8px";
const $3276e9745553f254$export$113ff81b72ae4005 = "1px";
const $3276e9745553f254$export$aff0f3036f778118 = "1px";
const $3276e9745553f254$export$105006e16cdb4368 = "1px";
const $3276e9745553f254$export$83edc677e0bcbaf9 = "1px";
const $3276e9745553f254$export$be459879692fda29 = "1px";
const $3276e9745553f254$export$586c2c06158e5801 = "1px";
const $3276e9745553f254$export$a8ef96955ef6555c = "hsl(202 100% 40% / 0.1)";
const $3276e9745553f254$export$97032c77bb67830c = "hsl(202 100% 40% / 0.2)";
const $3276e9745553f254$export$6577f4536230e0ea = "hsl(202 100% 40% / 0.3)";
const $3276e9745553f254$export$87b87f0038f4c66f = "hsl(202 100% 40% / 0.4)";
const $3276e9745553f254$export$ec1dc93077563875 = "hsl(202 100% 40% / 0.5)";
const $3276e9745553f254$export$fce98b53ab002313 = "hsl(202 100% 40% / 0.6)";
const $3276e9745553f254$export$8e949091d329a301 = "hsl(202 100% 40% / 0.7)";
const $3276e9745553f254$export$94550a5bab2b5993 = "hsl(202 100% 40% / 0.8)";
const $3276e9745553f254$export$a8757e8f89513f1 = "hsl(202 100% 40% / 0.9)";
const $3276e9745553f254$export$e985323c829fd742 = "hsl(202, 100%, 40%)";
const $3276e9745553f254$export$19b7230ae44bbd30 = "hsl(266 63% 45% / 0.1)";
const $3276e9745553f254$export$b08be8e4ba1d6c82 = "hsl(266 63% 45% / 0.2)";
const $3276e9745553f254$export$145e11a833c7874d = "hsl(266 63% 45% / 0.3)";
const $3276e9745553f254$export$90cf3f223c496a71 = "hsl(266 63% 45% / 0.4)";
const $3276e9745553f254$export$6244798137efca9 = "hsl(266 63% 45% / 0.5)";
const $3276e9745553f254$export$72d20d5426576de3 = "hsl(266 63% 45% / 0.6)";
const $3276e9745553f254$export$5f909f40ccaa6cc4 = "hsl(266 63% 45% / 0.7)";
const $3276e9745553f254$export$3e47cc0b9b14ad09 = "hsl(266 63% 45% / 0.8)";
const $3276e9745553f254$export$36569f0f035d32d1 = "hsl(266 63% 45% / 0.9)";
const $3276e9745553f254$export$574e12a52c1b3e12 = "hsl(266, 63%, 45%)";
const $3276e9745553f254$export$74d6e4fad4bb88bf = "hsl(301 73% 75% / 0.1)";
const $3276e9745553f254$export$189fbb2766493c36 = "hsl(301 73% 75% / 0.2)";
const $3276e9745553f254$export$428da89f5a98a232 = "hsl(301 73% 75% / 0.3)";
const $3276e9745553f254$export$60edf238c6afd1e6 = "hsl(301 73% 75% / 0.4)";
const $3276e9745553f254$export$67e9edd6baebfbce = "hsl(301 73% 75% / 0.5)";
const $3276e9745553f254$export$ec3d0a210a5d4c2c = "hsl(301 73% 75% / 0.6)";
const $3276e9745553f254$export$f776cf7a0a505749 = "hsl(301 73% 75% / 0.7)";
const $3276e9745553f254$export$61698398be922542 = "hsl(301 73% 75% / 0.8)";
const $3276e9745553f254$export$99028bd1491db588 = "hsl(301 73% 75% / 0.9)";
const $3276e9745553f254$export$f0236e2c2ceff476 = "hsl(301, 73%, 75%)";
const $3276e9745553f254$export$f944771630b59cb5 = "hsl(169 82% 33% / 0.1)";
const $3276e9745553f254$export$cf875bcb83eeef36 = "hsl(169 82% 33% / 0.2)";
const $3276e9745553f254$export$d22935b11cd2da96 = "hsl(169 82% 33% / 0.3)";
const $3276e9745553f254$export$c09b5156af934baf = "hsl(169 82% 33% / 0.4)";
const $3276e9745553f254$export$cd03abab8825767c = "hsl(169 82% 33% / 0.5)";
const $3276e9745553f254$export$49d39abb22350b45 = "hsl(169 82% 33% / 0.6)";
const $3276e9745553f254$export$2e409639998b526b = "hsl(169 82% 33% / 0.7)";
const $3276e9745553f254$export$7431a515da39af8c = "hsl(169 82% 33% / 0.8)";
const $3276e9745553f254$export$f34384d6e022c3f3 = "hsl(169 82% 33% / 0.9)";
const $3276e9745553f254$export$10372af809834eae = "hsl(169, 82%, 33%)";
const $3276e9745553f254$export$a6eae9e7146720fd = "hsl(346 37% 43% / 0.1)";
const $3276e9745553f254$export$1645795e3158abbf = "hsl(346 37% 43% / 0.2)";
const $3276e9745553f254$export$cb63dd0ef69328da = "hsl(346 37% 43% / 0.3)";
const $3276e9745553f254$export$8906d6ccc1d3cf97 = "hsl(346 37% 43% / 0.4)";
const $3276e9745553f254$export$9705a2ef585a5a6c = "hsl(346 37% 43% / 0.5)";
const $3276e9745553f254$export$9a4904530e74d69b = "hsl(346 37% 43% / 0.6)";
const $3276e9745553f254$export$84fa53d9957f1633 = "hsl(346 37% 43% / 0.7)";
const $3276e9745553f254$export$261cc78142a16d2e = "hsl(346 37% 43% / 0.8)";
const $3276e9745553f254$export$84de24a511e4409e = "hsl(346 37% 43% / 0.9)";
const $3276e9745553f254$export$c5da345c40af16d0 = "hsl(346, 37%, 43%)";
const $3276e9745553f254$export$1a43e24e8356aef8 = "hsl(36 77% 40% / 0.1)";
const $3276e9745553f254$export$80cf8aa12b9a81d3 = "hsl(36 77% 40% / 0.2)";
const $3276e9745553f254$export$f060dd68476cd8e7 = "hsl(36 77% 40% / 0.3)";
const $3276e9745553f254$export$e439d3dd32b46274 = "hsl(36 77% 40% / 0.4)";
const $3276e9745553f254$export$a300ce07e8f90e40 = "hsl(36 77% 40% / 0.5)";
const $3276e9745553f254$export$a1ef18e9668adce2 = "hsl(36 77% 40% / 0.6)";
const $3276e9745553f254$export$6bc2d1ae052bf51c = "hsl(36 77% 40% / 0.7)";
const $3276e9745553f254$export$356c38cc88c30e38 = "hsl(36 77% 40% / 0.8)";
const $3276e9745553f254$export$4448f063fed043bf = "hsl(36 77% 40% / 0.9)";
const $3276e9745553f254$export$28182ad30600cb65 = "hsl(36, 77%, 40%)";
const $3276e9745553f254$export$b0f38d080d1f8f97 = "hsl(151 46% 17% / 0.1)";
const $3276e9745553f254$export$abd8f528d3152ac4 = "hsl(151 46% 17% / 0.2)";
const $3276e9745553f254$export$6314df582966a22f = "hsl(151 46% 17% / 0.3)";
const $3276e9745553f254$export$21214bfe4d7ae8b7 = "hsl(151 46% 17% / 0.4)";
const $3276e9745553f254$export$2b5f8a9ddff4d5c4 = "hsl(151 46% 17% / 0.5)";
const $3276e9745553f254$export$b63bfe40c28df8c8 = "hsl(151 46% 17% / 0.6)";
const $3276e9745553f254$export$a288b1bef1f363d6 = "hsl(151 46% 17% / 0.7)";
const $3276e9745553f254$export$ca2242167f4cec64 = "hsl(151 46% 17% / 0.8)";
const $3276e9745553f254$export$bb1d5655a98e9de6 = "hsl(151 46% 17% / 0.9)";
const $3276e9745553f254$export$113cda6f600a4ca4 = "hsl(151, 46%, 17%)";
const $3276e9745553f254$export$8ec4c1f865bc4296 = "hsl(36 97% 70% / 0.1)";
const $3276e9745553f254$export$80f831c9571e7721 = "hsl(36 97% 70% / 0.2)";
const $3276e9745553f254$export$7baea4598e0903db = "hsl(36 97% 70% / 0.3)";
const $3276e9745553f254$export$85cc5b9d5a5e8f07 = "hsl(36 97% 70% / 0.4)";
const $3276e9745553f254$export$c16430852d6ffb13 = "hsl(36 97% 70% / 0.5)";
const $3276e9745553f254$export$76289a8af80837cf = "hsl(36 97% 70% / 0.6)";
const $3276e9745553f254$export$52b981bfeaa81760 = "hsl(36 97% 70% / 0.7)";
const $3276e9745553f254$export$8e617b33cbf4490c = "hsl(36 97% 70% / 0.8)";
const $3276e9745553f254$export$a1aa25fd6a117918 = "hsl(36 97% 70% / 0.9)";
const $3276e9745553f254$export$f01739baaf9b181d = "hsl(36, 97%, 70%)";
const $3276e9745553f254$export$d90969089c78ff1a = "#ffffff";
const $3276e9745553f254$export$fcb89087e092a414 = "#E2E2E1";
const $3276e9745553f254$export$9bbe1e2e7d502781 = "Roboto";
const $3276e9745553f254$export$4a1d1c93af63034c = "400";
const $3276e9745553f254$export$440443a29ae7f444 = "12px";
const $3276e9745553f254$export$d87dd6c52509ab1c = "0";
const $3276e9745553f254$export$3f3169f0677cff68 = "14px";
const $3276e9745553f254$export$5e89ca37329331db = "#ffffff";
const $3276e9745553f254$export$2d683b41f8da6ca4 = "#F0F0EF";
const $3276e9745553f254$export$73731597f6e69c9d = "#7D7D7D";
const $3276e9745553f254$export$c927c3e959fbe8b = "hsl(0 0% 100% / 0)";
const $3276e9745553f254$export$a0f7cf38a8a00f2b = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$29f6789a57993025 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$4ec39546e154299 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$3f64927d3a4eb9ea = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$cfdc6390a7fab5c8 = "#F0F0EF";
const $3276e9745553f254$export$65e1e963096c903 = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$6241dacc1b50fceb = "hsl(0 0% 49% / 0.2)";
const $3276e9745553f254$export$fdbf6d5d010addf8 = "hsl(207 100% 40% / 0.25)";
const $3276e9745553f254$export$50b1b763cf3e7ade = "hsl(207 100% 40% / 0.5)";
const $3276e9745553f254$export$40362ccc2bdb3c26 = "#323232";
const $3276e9745553f254$export$c204c1784cc516d0 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$2365ee05eae2bf7f = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$647245f05226e9f7 = "#0070cc";
const $3276e9745553f254$export$794da0ddda9a3107 = "hsl(207 100% 30% / 0.75)";
const $3276e9745553f254$export$739a8d1bcdc7839d = "#FFEEEE";
const $3276e9745553f254$export$94e174e73f70f159 = "#E2E2E1";
const $3276e9745553f254$export$788d135191815d53 = "#C8C8C7";
const $3276e9745553f254$export$2f7f338c6ca49382 = "#646464";
const $3276e9745553f254$export$48e34a2ffe6a00d7 = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$22ef0123e9b7779c = "hsl(0 0% 29.4% / 0.25)";
const $3276e9745553f254$export$606938ff76eef7ca = "#0070cc";
const $3276e9745553f254$export$c46a37e46831cb73 = "#0070cc";
const $3276e9745553f254$export$59052749eca57609 = "#0070cc";
const $3276e9745553f254$export$dd96312fb32772ab = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$eed6b1452607cf56 = "hsl(0 0% 29.4% / 0.5)";
const $3276e9745553f254$export$acced8db4ae2cf3b = "#0070cc";
const $3276e9745553f254$export$77b24f6d99070e59 = "#0070cc";
const $3276e9745553f254$export$b34450f407ef29c6 = "#0070cc";
const $3276e9745553f254$export$ac70beace51d0dd4 = "#4B4B4B";
const $3276e9745553f254$export$5c9eeed4e201b90e = "#4B4B4B";
const $3276e9745553f254$export$f49ed7789dc61221 = "#0070cc";
const $3276e9745553f254$export$ddf2fa79327928f = "#0070cc";
const $3276e9745553f254$export$f77baad962a57c8f = "#0070cc";
const $3276e9745553f254$export$98ddb5e8ed3aa914 = "#4B4B4B";
const $3276e9745553f254$export$1530dbd1b63da1da = "#191919";
const $3276e9745553f254$export$9d2d9318edad804e = "#ffffff";
const $3276e9745553f254$export$a83f4a80f6994355 = "#4B4B4B";
const $3276e9745553f254$export$72489d62081edb03 = "#6F1010";
const $3276e9745553f254$export$266ec36a94b31c7b = "100px";
const $3276e9745553f254$export$1600af1791f8b4f = "100px";
const $3276e9745553f254$export$914b4b6244542bbf = "0px";
const $3276e9745553f254$export$44d950c57bc9d93 = "1px";
const $3276e9745553f254$export$be2a9d19912bffe8 = "Roboto";
const $3276e9745553f254$export$95492bbb433b5945 = "600";
const $3276e9745553f254$export$761832cf77cf363a = "0";
const $3276e9745553f254$export$b0eb4ef8cfa78960 = "12px";
const $3276e9745553f254$export$fed43e5dcd48f2dc = "12px";
const $3276e9745553f254$export$ae8f35fee23fdd6b = "14px";
const $3276e9745553f254$export$8862b9c5fc58c4fc = "16px";
const $3276e9745553f254$export$50a8a424d0152755 = "14px";
const $3276e9745553f254$export$bc28f5283ef6ba98 = "14px";
const $3276e9745553f254$export$291904bb2e85d148 = "16px";
const $3276e9745553f254$export$daf145493ab9a6de = "20px";
const $3276e9745553f254$export$415502a94bbbbee6 = "36px";
const $3276e9745553f254$export$465097bd75bdea60 = "4px";
const $3276e9745553f254$export$42d141f7fb68da3c = "4px";
const $3276e9745553f254$export$5584196c725943b3 = "8px";
const $3276e9745553f254$export$118d0bac41bf5c6f = "16px";
const $3276e9745553f254$export$b998fc4e363ee792 = "20px";
const $3276e9745553f254$export$c30418f3955f4770 = "36px";
const $3276e9745553f254$export$c511e0cf300b027a = "4px";
const $3276e9745553f254$export$54041063a1bf9d9f = "4px";
const $3276e9745553f254$export$fd2f38d8a289271e = "4px";
const $3276e9745553f254$export$6c2cf414b9a8b02 = "#323232";
const $3276e9745553f254$export$74e8af3218f82048 = "100px";
const $3276e9745553f254$export$d631136dbd4f130 = "#ffffff";
const $3276e9745553f254$export$91580955f5b11a78 = "4px";
const $3276e9745553f254$export$2804a19e6721cd4d = "#ffffff";
const $3276e9745553f254$export$cd2372d2a66c08ad = "#f5f5f5";
const $3276e9745553f254$export$8ef196ecc87f7934 = "#191919";
const $3276e9745553f254$export$af7cd107f275c02a = "#ffffff";
const $3276e9745553f254$export$8490f4d3874147a3 = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$b7a95a89583d4770 = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$6bc9aee632a0607d = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$efbbc87ef9efc62c = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$5500a3415a8200bf = "#f5f5f5";
const $3276e9745553f254$export$895d192a083edbcd = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$f8f9f853acd8dccc = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$a2b2fba0efcb64de = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$abb81216d8ead6d6 = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$c18fc16fd6ce2893 = "#191919";
const $3276e9745553f254$export$9a9b411077d65d4 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$84ee0041f3b78053 = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$e3ae326d33644c8f = "#005499";
const $3276e9745553f254$export$f2093864c9741f6c = "hsl(207 100% 30% / 0.95)";
const $3276e9745553f254$export$50e035363ae06a71 = "#ffffff";
const $3276e9745553f254$export$8d5f9203840e8cea = "hsl(60 1.69% 88.4% / 0)";
const $3276e9745553f254$export$6429134805d4f7b2 = "#E2E2E1";
const $3276e9745553f254$export$47bc82913eb62f9a = "#4B4B4B";
const $3276e9745553f254$export$9a8ea6b0632902f8 = "#0070cc";
const $3276e9745553f254$export$9cea3abece3796dd = "#E2E2E1";
const $3276e9745553f254$export$147f5a94c0d93a24 = "#191919";
const $3276e9745553f254$export$30427793cdcc11f = "#191919";
const $3276e9745553f254$export$8dd2be958a4f682c = "#ffffff";
const $3276e9745553f254$export$6941f05285867423 = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$4b525576dbb2a4d = "#005499";
const $3276e9745553f254$export$ad62b5a3f8569d6e = "1px";
const $3276e9745553f254$export$946b06a7a267d247 = "0px";
const $3276e9745553f254$export$2400272ad19e2fe5 = "36px";
const $3276e9745553f254$export$993c88baafc7364 = "44px";
const $3276e9745553f254$export$9bebe7546b06ea6b = "48px";
const $3276e9745553f254$export$e1d34ffbb73e4967 = "8px";
const $3276e9745553f254$export$6c9ea1231c05ae2 = "16px";
const $3276e9745553f254$export$34e1f4c8e40a4ed4 = "24px";
const $3276e9745553f254$export$6f5f0ec032a5cd2a = "0px";
const $3276e9745553f254$export$3533b594e8a22e61 = "276px";
const $3276e9745553f254$export$3162d64b8e7996c0 = "376px";
const $3276e9745553f254$export$904c18abb803aa9f = "#ffffff";
const $3276e9745553f254$export$cfbe570aaf4a5b77 = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$ac0e121c105675cd = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$9e386e8d2c73a924 = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$63daf5c1ff2410fd = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$2167e31118bb40d7 = "#f5f5f5";
const $3276e9745553f254$export$966b83fbdad8ff13 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$c06450425bd9035c = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$ddde5722037bdb1a = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$544f4daa03c97c0c = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$633198cc99623271 = "#ffffff";
const $3276e9745553f254$export$fbbb4a5d1412c3f3 = "#191919";
const $3276e9745553f254$export$35db974a8b01923c = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$42938dc8e4554ca = "hsl(0 0% 9.8% / 0.75)";
const $3276e9745553f254$export$4a1178fab316a183 = "#005499";
const $3276e9745553f254$export$c114ec50f0f18b26 = "hsl(207 100% 30% / 0.95)";
const $3276e9745553f254$export$f5465bf2d3de925d = "#ffffff";
const $3276e9745553f254$export$6053f363b9ebffff = "#f5f5f5";
const $3276e9745553f254$export$f3f16eb733cd113b = "#191919";
const $3276e9745553f254$export$f49a1acfc2525900 = "#0070cc";
const $3276e9745553f254$export$514e04a8b12a1404 = "#0070cc";
const $3276e9745553f254$export$95733713edee3c14 = "#0070cc";
const $3276e9745553f254$export$28932b8bfce45f38 = "#0070cc";
const $3276e9745553f254$export$edce63b38f08b44d = "#0070cc";
const $3276e9745553f254$export$fa6c9f7aabe0a2e2 = "#E2E2E1";
const $3276e9745553f254$export$623652b8691265a = "#E2E2E1";
const $3276e9745553f254$export$b8ffe5941b3130ba = "#0070cc";
const $3276e9745553f254$export$18e765ec8d586da3 = "#0070cc";
const $3276e9745553f254$export$36f1da88e0a16b94 = "#0070cc";
const $3276e9745553f254$export$bbe5df2b165b1606 = "#C8C8C7";
const $3276e9745553f254$export$67562899c4dd8d01 = "#C8C8C7";
const $3276e9745553f254$export$c0908d88aaa39084 = "#0070cc";
const $3276e9745553f254$export$2035a1d319e4a134 = "#0070cc";
const $3276e9745553f254$export$290823ff5c4d6a31 = "#0070cc";
const $3276e9745553f254$export$9a7c2ed2267bf628 = "hsl(60 1.69% 88.4% / 0.38)";
const $3276e9745553f254$export$7d32452142f66e8 = "#E2E2E1";
const $3276e9745553f254$export$91106c4c34773b8b = "#E2E2E1";
const $3276e9745553f254$export$78ccf4c9305987f2 = "#4B4B4B";
const $3276e9745553f254$export$9fb0c8224ca90269 = "8px";
const $3276e9745553f254$export$f38773b397c64fe3 = "16px";
const $3276e9745553f254$export$68dfe0e438ed927f = "24px";
const $3276e9745553f254$export$6b1192f8dbbe8ca4 = "1px";
const $3276e9745553f254$export$9006004e350aae36 = "0px";
const $3276e9745553f254$export$4933986e86984502 = "4px";
const $3276e9745553f254$export$a08a5ca1c9e2d77 = "2px";
const $3276e9745553f254$export$4428090006cc5e8f = "100px";
const $3276e9745553f254$export$6b437ae17434a562 = "0 0 0 0 hsl(200, 30%, 86%)";
const $3276e9745553f254$export$e439e7a9a522c8bd = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $3276e9745553f254$export$f6f9c9aa81f0acb9 = "#ffffff";
const $3276e9745553f254$export$5707e412b97a3d17 = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$7ee0f670470f616e = "hsl(60 0.9% 78.2% / 0.15)";
const $3276e9745553f254$export$602a5bdac5f15cd4 = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$a4b65a2a4760aa2e = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$99b6fb3a8cddfde2 = "#f5f5f5";
const $3276e9745553f254$export$6f41d812463dcc26 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$bd26b519eb710637 = "hsl(60 0.62% 68.4% / 0.2)";
const $3276e9745553f254$export$8c129a8c71396c89 = "hsl(207 100% 40% / 0.05)";
const $3276e9745553f254$export$ea53d93807b2be6c = "hsl(207 100% 40% / 0.1)";
const $3276e9745553f254$export$de181742c8a3a8ed = "#ffffff";
const $3276e9745553f254$export$ac909337994ad4cc = "#E2E2E1";
const $3276e9745553f254$export$47cee41927ea7a65 = "#0070cc";
const $3276e9745553f254$export$29bf0efdf9aa6973 = "#191919";
const $3276e9745553f254$export$2a97efadeb1968eb = "hsl(0 0% 49% / 0.38)";
const $3276e9745553f254$export$f074b54a1a690e59 = "8px";
const $3276e9745553f254$export$9f94c55002684827 = "16px";
const $3276e9745553f254$export$ae05400eb6210b52 = "24px";
const $3276e9745553f254$export$8ea2eaf73829f82b = "1px";
const $3276e9745553f254$export$5ead36882857d7b8 = "0px";

var $8b8adca400ca855b$exports = {};

$parcel$export($8b8adca400ca855b$exports, "globalFontWeightBold", () => $8b8adca400ca855b$export$47532a6f57be45d9);
$parcel$export($8b8adca400ca855b$exports, "globalFontWeightSemiBold", () => $8b8adca400ca855b$export$740ac66abb38bb83);
$parcel$export($8b8adca400ca855b$exports, "globalFontWeightRegular", () => $8b8adca400ca855b$export$90168a3412ee7f0c);
$parcel$export($8b8adca400ca855b$exports, "globalGradientGray20", () => $8b8adca400ca855b$export$9b985e69928d4804);
$parcel$export($8b8adca400ca855b$exports, "globalGradientGray10", () => $8b8adca400ca855b$export$6e4689b7cf6aeadb);
$parcel$export($8b8adca400ca855b$exports, "globalGradientDeepOcean1", () => $8b8adca400ca855b$export$c473f2d55633c7bf);
$parcel$export($8b8adca400ca855b$exports, "globalChartCoast30", () => $8b8adca400ca855b$export$bf51732c1e402305);
$parcel$export($8b8adca400ca855b$exports, "globalChartCoast40", () => $8b8adca400ca855b$export$dd6ac6c529280b28);
$parcel$export($8b8adca400ca855b$exports, "globalChartMermaid23", () => $8b8adca400ca855b$export$628bc4cedab3f39c);
$parcel$export($8b8adca400ca855b$exports, "globalChartMermaid33", () => $8b8adca400ca855b$export$12d92729ec24385a);
$parcel$export($8b8adca400ca855b$exports, "globalChartBrine33", () => $8b8adca400ca855b$export$4a7539ac23adfb7a);
$parcel$export($8b8adca400ca855b$exports, "globalChartBrine43", () => $8b8adca400ca855b$export$fb8a8a98f73ce6b1);
$parcel$export($8b8adca400ca855b$exports, "globalChartSeaglass17", () => $8b8adca400ca855b$export$60723b7193f02e02);
$parcel$export($8b8adca400ca855b$exports, "globalChartSeaglass27", () => $8b8adca400ca855b$export$795334c6456d2730);
$parcel$export($8b8adca400ca855b$exports, "globalChartJellyfish35", () => $8b8adca400ca855b$export$da6517e7d9c36003);
$parcel$export($8b8adca400ca855b$exports, "globalChartJellyfish45", () => $8b8adca400ca855b$export$3b7ffecbd7cc9aeb);
$parcel$export($8b8adca400ca855b$exports, "globalChartAnemone30", () => $8b8adca400ca855b$export$2c3279dd523ce91e);
$parcel$export($8b8adca400ca855b$exports, "globalChartAnemone40", () => $8b8adca400ca855b$export$a32ed79b0c9f894d);
$parcel$export($8b8adca400ca855b$exports, "globalChartSunset60", () => $8b8adca400ca855b$export$364c018f7a909db3);
$parcel$export($8b8adca400ca855b$exports, "globalChartSunset70", () => $8b8adca400ca855b$export$5f85a6a7c51d6890);
$parcel$export($8b8adca400ca855b$exports, "globalChartLionfish65", () => $8b8adca400ca855b$export$436b1e2e43974ada);
$parcel$export($8b8adca400ca855b$exports, "globalChartLionfish75", () => $8b8adca400ca855b$export$a9aeb5d8dac66b57);
$parcel$export($8b8adca400ca855b$exports, "globalOrange10", () => $8b8adca400ca855b$export$684e73d930ab653c);
$parcel$export($8b8adca400ca855b$exports, "globalOrange20", () => $8b8adca400ca855b$export$1181582ac6088c50);
$parcel$export($8b8adca400ca855b$exports, "globalOrange30", () => $8b8adca400ca855b$export$b2d49d7677da6748);
$parcel$export($8b8adca400ca855b$exports, "globalOrange40", () => $8b8adca400ca855b$export$b6a1b5443e554bac);
$parcel$export($8b8adca400ca855b$exports, "globalOrange50", () => $8b8adca400ca855b$export$3b8a5dc0c17f71c2);
$parcel$export($8b8adca400ca855b$exports, "globalOrange60", () => $8b8adca400ca855b$export$8b7438de76999a40);
$parcel$export($8b8adca400ca855b$exports, "globalOrange70", () => $8b8adca400ca855b$export$2b5d6b20a9c67c77);
$parcel$export($8b8adca400ca855b$exports, "globalOrange82", () => $8b8adca400ca855b$export$5afcf229520f3e);
$parcel$export($8b8adca400ca855b$exports, "globalOrange86", () => $8b8adca400ca855b$export$d61e61546d5dbc3b);
$parcel$export($8b8adca400ca855b$exports, "globalOrange88", () => $8b8adca400ca855b$export$5acbd671bcb55bbc);
$parcel$export($8b8adca400ca855b$exports, "globalOrange90", () => $8b8adca400ca855b$export$ae55d2493bfc2288);
$parcel$export($8b8adca400ca855b$exports, "globalOrange92", () => $8b8adca400ca855b$export$d92f008db791081b);
$parcel$export($8b8adca400ca855b$exports, "globalOrange96", () => $8b8adca400ca855b$export$16492d98578c318);
$parcel$export($8b8adca400ca855b$exports, "globalOrange98", () => $8b8adca400ca855b$export$3a485bc73a43c0d);
$parcel$export($8b8adca400ca855b$exports, "globalGreen10", () => $8b8adca400ca855b$export$73c61615faaec16d);
$parcel$export($8b8adca400ca855b$exports, "globalGreen20", () => $8b8adca400ca855b$export$f61d2734a97ec44d);
$parcel$export($8b8adca400ca855b$exports, "globalGreen30", () => $8b8adca400ca855b$export$db59b2d9d3b8f23);
$parcel$export($8b8adca400ca855b$exports, "globalGreen40", () => $8b8adca400ca855b$export$2fc86281a892e4e9);
$parcel$export($8b8adca400ca855b$exports, "globalGreen50", () => $8b8adca400ca855b$export$65018fb6acb6e9e);
$parcel$export($8b8adca400ca855b$exports, "globalGreen60", () => $8b8adca400ca855b$export$6f52551cdcf848f2);
$parcel$export($8b8adca400ca855b$exports, "globalGreen70", () => $8b8adca400ca855b$export$8717c4e3eb9150e5);
$parcel$export($8b8adca400ca855b$exports, "globalGreen82", () => $8b8adca400ca855b$export$c83198aa8943b17f);
$parcel$export($8b8adca400ca855b$exports, "globalGreen86", () => $8b8adca400ca855b$export$8c35a5b2f64f36d);
$parcel$export($8b8adca400ca855b$exports, "globalGreen88", () => $8b8adca400ca855b$export$6ff44857ae98393);
$parcel$export($8b8adca400ca855b$exports, "globalGreen90", () => $8b8adca400ca855b$export$8fc5d73ef8daa081);
$parcel$export($8b8adca400ca855b$exports, "globalGreen92", () => $8b8adca400ca855b$export$ca9d34853847d885);
$parcel$export($8b8adca400ca855b$exports, "globalGreen96", () => $8b8adca400ca855b$export$5e3d63bd09e2adfa);
$parcel$export($8b8adca400ca855b$exports, "globalGreen98", () => $8b8adca400ca855b$export$a31d2a5d6f4951c3);
$parcel$export($8b8adca400ca855b$exports, "globalRed10", () => $8b8adca400ca855b$export$2fa8052ddbf692db);
$parcel$export($8b8adca400ca855b$exports, "globalRed20", () => $8b8adca400ca855b$export$5ae3653bea2f6002);
$parcel$export($8b8adca400ca855b$exports, "globalRed30", () => $8b8adca400ca855b$export$ebe209ab71dc9900);
$parcel$export($8b8adca400ca855b$exports, "globalRed40", () => $8b8adca400ca855b$export$9a86551a13d806cb);
$parcel$export($8b8adca400ca855b$exports, "globalRed50", () => $8b8adca400ca855b$export$c10c79645b27877d);
$parcel$export($8b8adca400ca855b$exports, "globalRed60", () => $8b8adca400ca855b$export$3162b4069185c8ae);
$parcel$export($8b8adca400ca855b$exports, "globalRed70", () => $8b8adca400ca855b$export$b001b9d8cf2ddf0c);
$parcel$export($8b8adca400ca855b$exports, "globalRed82", () => $8b8adca400ca855b$export$2bcac13af88081c8);
$parcel$export($8b8adca400ca855b$exports, "globalRed86", () => $8b8adca400ca855b$export$72d98e4ddcb0af1b);
$parcel$export($8b8adca400ca855b$exports, "globalRed88", () => $8b8adca400ca855b$export$45fc9997e1ebd965);
$parcel$export($8b8adca400ca855b$exports, "globalRed90", () => $8b8adca400ca855b$export$f8218d553727ff09);
$parcel$export($8b8adca400ca855b$exports, "globalRed92", () => $8b8adca400ca855b$export$c31b4867424b9387);
$parcel$export($8b8adca400ca855b$exports, "globalRed96", () => $8b8adca400ca855b$export$6c46c4d114584df1);
$parcel$export($8b8adca400ca855b$exports, "globalRed98", () => $8b8adca400ca855b$export$4bd1bc01799161bf);
$parcel$export($8b8adca400ca855b$exports, "globalYellow10", () => $8b8adca400ca855b$export$b68a36b2c4312600);
$parcel$export($8b8adca400ca855b$exports, "globalYellow20", () => $8b8adca400ca855b$export$bf9058acbc7e0c03);
$parcel$export($8b8adca400ca855b$exports, "globalYellow30", () => $8b8adca400ca855b$export$af58e6c4e06fba1e);
$parcel$export($8b8adca400ca855b$exports, "globalYellow40", () => $8b8adca400ca855b$export$f5c847ebf0c3830d);
$parcel$export($8b8adca400ca855b$exports, "globalYellow50", () => $8b8adca400ca855b$export$d65df8bd9766ab30);
$parcel$export($8b8adca400ca855b$exports, "globalYellow60", () => $8b8adca400ca855b$export$6dea6221146a7695);
$parcel$export($8b8adca400ca855b$exports, "globalYellow70", () => $8b8adca400ca855b$export$97794df832fa9246);
$parcel$export($8b8adca400ca855b$exports, "globalYellow82", () => $8b8adca400ca855b$export$37a6ad6644a76e8e);
$parcel$export($8b8adca400ca855b$exports, "globalYellow86", () => $8b8adca400ca855b$export$b2cc4270764e0d91);
$parcel$export($8b8adca400ca855b$exports, "globalYellow88", () => $8b8adca400ca855b$export$145e03b0063171cf);
$parcel$export($8b8adca400ca855b$exports, "globalYellow90", () => $8b8adca400ca855b$export$2d9c2b11822ba826);
$parcel$export($8b8adca400ca855b$exports, "globalYellow92", () => $8b8adca400ca855b$export$d06c19130b7b237c);
$parcel$export($8b8adca400ca855b$exports, "globalYellow96", () => $8b8adca400ca855b$export$d2a0a2228c20f625);
$parcel$export($8b8adca400ca855b$exports, "globalYellow98", () => $8b8adca400ca855b$export$b1a4a810c6323520);
$parcel$export($8b8adca400ca855b$exports, "globalViolet10", () => $8b8adca400ca855b$export$d5f6f1514cdd87e);
$parcel$export($8b8adca400ca855b$exports, "globalViolet20", () => $8b8adca400ca855b$export$abc0c049d1d05997);
$parcel$export($8b8adca400ca855b$exports, "globalViolet30", () => $8b8adca400ca855b$export$e3e4f6af628aad6d);
$parcel$export($8b8adca400ca855b$exports, "globalViolet40", () => $8b8adca400ca855b$export$a93c9c9f412d3c5e);
$parcel$export($8b8adca400ca855b$exports, "globalViolet50", () => $8b8adca400ca855b$export$d73ff2918ee90459);
$parcel$export($8b8adca400ca855b$exports, "globalViolet60", () => $8b8adca400ca855b$export$7c691d76a2faac9e);
$parcel$export($8b8adca400ca855b$exports, "globalViolet70", () => $8b8adca400ca855b$export$9ddac4fed8e0699e);
$parcel$export($8b8adca400ca855b$exports, "globalViolet82", () => $8b8adca400ca855b$export$70b4d49a036ffa16);
$parcel$export($8b8adca400ca855b$exports, "globalViolet86", () => $8b8adca400ca855b$export$b6ae9037e4487ef7);
$parcel$export($8b8adca400ca855b$exports, "globalViolet88", () => $8b8adca400ca855b$export$cdab03f0b3cedea7);
$parcel$export($8b8adca400ca855b$exports, "globalViolet90", () => $8b8adca400ca855b$export$9a3940ef3e718482);
$parcel$export($8b8adca400ca855b$exports, "globalViolet92", () => $8b8adca400ca855b$export$602a7aa90012bac7);
$parcel$export($8b8adca400ca855b$exports, "globalViolet96", () => $8b8adca400ca855b$export$f9e1bb5a6ecf8fa1);
$parcel$export($8b8adca400ca855b$exports, "globalViolet98", () => $8b8adca400ca855b$export$9665fc79e7ccde89);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean10", () => $8b8adca400ca855b$export$415e2ab0a19e9f81);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean20", () => $8b8adca400ca855b$export$9ad9d3db52ccd355);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean30", () => $8b8adca400ca855b$export$17b617ddb9836542);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean40", () => $8b8adca400ca855b$export$664987001e0f2ea0);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean50", () => $8b8adca400ca855b$export$58adf4043506cd3a);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean60", () => $8b8adca400ca855b$export$d3adcc2d4402ccc9);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean70", () => $8b8adca400ca855b$export$7155de5e23ab069b);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean82", () => $8b8adca400ca855b$export$41ee37b64344becb);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean86", () => $8b8adca400ca855b$export$9b88c99aa981baee);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean88", () => $8b8adca400ca855b$export$7c23125fd8a70a5a);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean90", () => $8b8adca400ca855b$export$a46d9e94ee27516a);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean92", () => $8b8adca400ca855b$export$57a7b6c7405c22fc);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean96", () => $8b8adca400ca855b$export$8c671b06252447da);
$parcel$export($8b8adca400ca855b$exports, "globalDeepOcean98", () => $8b8adca400ca855b$export$905ab8f8acc3167f);
$parcel$export($8b8adca400ca855b$exports, "globalBlue10", () => $8b8adca400ca855b$export$df8147df7c327e97);
$parcel$export($8b8adca400ca855b$exports, "globalBlue20", () => $8b8adca400ca855b$export$23afbb4232b3ac3a);
$parcel$export($8b8adca400ca855b$exports, "globalBlue30", () => $8b8adca400ca855b$export$5fcc389c3d56da1a);
$parcel$export($8b8adca400ca855b$exports, "globalBlue40", () => $8b8adca400ca855b$export$ae23f4fa1dd8e463);
$parcel$export($8b8adca400ca855b$exports, "globalBlue50", () => $8b8adca400ca855b$export$6e85f1855ac4540b);
$parcel$export($8b8adca400ca855b$exports, "globalBlue60", () => $8b8adca400ca855b$export$8740b6c0177f90d2);
$parcel$export($8b8adca400ca855b$exports, "globalBlue70", () => $8b8adca400ca855b$export$8c220e0ccc521b52);
$parcel$export($8b8adca400ca855b$exports, "globalBlue82", () => $8b8adca400ca855b$export$694b034c84505cc0);
$parcel$export($8b8adca400ca855b$exports, "globalBlue86", () => $8b8adca400ca855b$export$107dfa3b1934715e);
$parcel$export($8b8adca400ca855b$exports, "globalBlue88", () => $8b8adca400ca855b$export$a98a55e2124bd475);
$parcel$export($8b8adca400ca855b$exports, "globalBlue90", () => $8b8adca400ca855b$export$c8bb10ac89484313);
$parcel$export($8b8adca400ca855b$exports, "globalBlue92", () => $8b8adca400ca855b$export$1ac92e121667df0a);
$parcel$export($8b8adca400ca855b$exports, "globalBlue96", () => $8b8adca400ca855b$export$416d4299ae18b901);
$parcel$export($8b8adca400ca855b$exports, "globalBlue98", () => $8b8adca400ca855b$export$3bf92297e3902f9c);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray10", () => $8b8adca400ca855b$export$db52f91b6e279a41);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray20", () => $8b8adca400ca855b$export$c2bda980025d9828);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray30", () => $8b8adca400ca855b$export$8ed151e7392922f7);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray40", () => $8b8adca400ca855b$export$f0cf2df1783c1493);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray50", () => $8b8adca400ca855b$export$c537f1eb6dbc51ff);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray60", () => $8b8adca400ca855b$export$63fb948eab7d44b0);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray70", () => $8b8adca400ca855b$export$b8bfc202936f7e3d);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray82", () => $8b8adca400ca855b$export$31ed9a0baa9a125c);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray86", () => $8b8adca400ca855b$export$fafb7a10ea280ee);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray88", () => $8b8adca400ca855b$export$b5c0ad53ffc9440b);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray90", () => $8b8adca400ca855b$export$6f8e87618ad20850);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray92", () => $8b8adca400ca855b$export$b8ccb55082565c20);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray96", () => $8b8adca400ca855b$export$c824d3ae1ea71c9d);
$parcel$export($8b8adca400ca855b$exports, "globalBlueGray98", () => $8b8adca400ca855b$export$aa19e6addb4fb53d);
$parcel$export($8b8adca400ca855b$exports, "globalWhite", () => $8b8adca400ca855b$export$eaa1ebf3c9e3051b);
$parcel$export($8b8adca400ca855b$exports, "globalBoxShadow1", () => $8b8adca400ca855b$export$da7a3b2eb1ec75df);
$parcel$export($8b8adca400ca855b$exports, "globalBoxShadow2", () => $8b8adca400ca855b$export$b585396ecd4c8629);
$parcel$export($8b8adca400ca855b$exports, "globalBoxShadow3", () => $8b8adca400ca855b$export$559abfde0b301430);
$parcel$export($8b8adca400ca855b$exports, "globalBoxShadowNone", () => $8b8adca400ca855b$export$dfa790552704c785);
$parcel$export($8b8adca400ca855b$exports, "globalBoxShadowFlat", () => $8b8adca400ca855b$export$98c600e1ecf01a39);
$parcel$export($8b8adca400ca855b$exports, "globalBoxShadow2Top", () => $8b8adca400ca855b$export$a162a9eb85be72b9);
$parcel$export($8b8adca400ca855b$exports, "globalFontFamiliesManrope", () => $8b8adca400ca855b$export$6e5fb3e2c7f33c2a);
$parcel$export($8b8adca400ca855b$exports, "globalFontFamiliesSanchez", () => $8b8adca400ca855b$export$dba883712db4d3ed);
$parcel$export($8b8adca400ca855b$exports, "globalFontFamiliesRoboto", () => $8b8adca400ca855b$export$6be74618ebefea70);
$parcel$export($8b8adca400ca855b$exports, "globalFontFamiliesWireframes", () => $8b8adca400ca855b$export$958f16642186b219);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights6", () => $8b8adca400ca855b$export$b6c70790c67285f9);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights8", () => $8b8adca400ca855b$export$48529bd7f04d40f0);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights10", () => $8b8adca400ca855b$export$f362f70cc25d5976);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights12", () => $8b8adca400ca855b$export$7399932c71904dd8);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights14", () => $8b8adca400ca855b$export$1a8e4a85adfe8299);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights16", () => $8b8adca400ca855b$export$afd7e4e7ae36c76e);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights18", () => $8b8adca400ca855b$export$e2c0f185f219e125);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights20", () => $8b8adca400ca855b$export$76961812acfcaadb);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights22", () => $8b8adca400ca855b$export$36e9845aded52da1);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights24", () => $8b8adca400ca855b$export$90605139ceb31cb5);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights26", () => $8b8adca400ca855b$export$4f2f5bdc507d88ff);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights28", () => $8b8adca400ca855b$export$38351aa0f63e13f);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights30", () => $8b8adca400ca855b$export$e5fe57b4a2ace969);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights32", () => $8b8adca400ca855b$export$eb2bc143b1eaba17);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeights48", () => $8b8adca400ca855b$export$c6aca45dbeea0b6e);
$parcel$export($8b8adca400ca855b$exports, "globalLineHeightsPercentage125", () => $8b8adca400ca855b$export$522d048072fdd0);
$parcel$export($8b8adca400ca855b$exports, "globalBorderRadius0", () => $8b8adca400ca855b$export$38ead138ec412471);
$parcel$export($8b8adca400ca855b$exports, "globalBorderRadius2", () => $8b8adca400ca855b$export$b4664877dc43b7af);
$parcel$export($8b8adca400ca855b$exports, "globalBorderRadius4", () => $8b8adca400ca855b$export$8982cd794b105475);
$parcel$export($8b8adca400ca855b$exports, "globalBorderRadius100", () => $8b8adca400ca855b$export$4e217f5c9e1d122e);
$parcel$export($8b8adca400ca855b$exports, "globalSize1", () => $8b8adca400ca855b$export$581a022593b37139);
$parcel$export($8b8adca400ca855b$exports, "globalSize2", () => $8b8adca400ca855b$export$6e08a028ea88caf);
$parcel$export($8b8adca400ca855b$exports, "globalSize3", () => $8b8adca400ca855b$export$9d565ea29b9d4e);
$parcel$export($8b8adca400ca855b$exports, "globalSize4", () => $8b8adca400ca855b$export$5aa522eb884d579d);
$parcel$export($8b8adca400ca855b$exports, "globalSize5", () => $8b8adca400ca855b$export$8820cb29c786d91f);
$parcel$export($8b8adca400ca855b$exports, "globalSize6", () => $8b8adca400ca855b$export$e76f8634e42fceed);
$parcel$export($8b8adca400ca855b$exports, "globalSize7", () => $8b8adca400ca855b$export$df367bbd8d048c14);
$parcel$export($8b8adca400ca855b$exports, "globalSize8", () => $8b8adca400ca855b$export$49513a9a59edd2fb);
$parcel$export($8b8adca400ca855b$exports, "globalSize9", () => $8b8adca400ca855b$export$ef900fdc121889a3);
$parcel$export($8b8adca400ca855b$exports, "globalSize10", () => $8b8adca400ca855b$export$83009f3ef2af8902);
$parcel$export($8b8adca400ca855b$exports, "globalSize11", () => $8b8adca400ca855b$export$e356db1a74a940f1);
$parcel$export($8b8adca400ca855b$exports, "globalSize12", () => $8b8adca400ca855b$export$633ffa248d03506c);
$parcel$export($8b8adca400ca855b$exports, "globalSize13", () => $8b8adca400ca855b$export$ff1746fd06dfef9c);
$parcel$export($8b8adca400ca855b$exports, "globalSize14", () => $8b8adca400ca855b$export$792f985e3c66b82b);
$parcel$export($8b8adca400ca855b$exports, "globalSize17", () => $8b8adca400ca855b$export$39757bd68ed58bc0);
$parcel$export($8b8adca400ca855b$exports, "globalSize44", () => $8b8adca400ca855b$export$5d4ece470da030c2);
$parcel$export($8b8adca400ca855b$exports, "globalSize69", () => $8b8adca400ca855b$export$e812c4b6a0d31e02);
$parcel$export($8b8adca400ca855b$exports, "globalSize75", () => $8b8adca400ca855b$export$1667f6759fd4af1f);
$parcel$export($8b8adca400ca855b$exports, "globalSize94", () => $8b8adca400ca855b$export$c79e5da71b43f2b7);
$parcel$export($8b8adca400ca855b$exports, "globalSize106", () => $8b8adca400ca855b$export$f09309c57f8ea8db);
$parcel$export($8b8adca400ca855b$exports, "globalSize144", () => $8b8adca400ca855b$export$3686e91ef2d1609b);
$parcel$export($8b8adca400ca855b$exports, "globalSize194", () => $8b8adca400ca855b$export$9a7d2330672d94da);
$parcel$export($8b8adca400ca855b$exports, "globalSize208", () => $8b8adca400ca855b$export$69191e5d8403f6dc);
$parcel$export($8b8adca400ca855b$exports, "globalSize320", () => $8b8adca400ca855b$export$c9bc626bcb9d1702);
$parcel$export($8b8adca400ca855b$exports, "globalSizeHalf", () => $8b8adca400ca855b$export$c2ebcb19507fa384);
$parcel$export($8b8adca400ca855b$exports, "globalSpace0", () => $8b8adca400ca855b$export$28af25853b30f1d5);
$parcel$export($8b8adca400ca855b$exports, "globalSpace1", () => $8b8adca400ca855b$export$cf8146011d39494a);
$parcel$export($8b8adca400ca855b$exports, "globalSpace2", () => $8b8adca400ca855b$export$eb07efa989de8fe5);
$parcel$export($8b8adca400ca855b$exports, "globalSpace3", () => $8b8adca400ca855b$export$bf79319657db0f88);
$parcel$export($8b8adca400ca855b$exports, "globalSpace4", () => $8b8adca400ca855b$export$5905f6dbe11e7b2c);
$parcel$export($8b8adca400ca855b$exports, "globalSpace5", () => $8b8adca400ca855b$export$dc0e9ba406ec1128);
$parcel$export($8b8adca400ca855b$exports, "globalSpace6", () => $8b8adca400ca855b$export$48cdf13b4cc5ad3f);
$parcel$export($8b8adca400ca855b$exports, "globalSpace7", () => $8b8adca400ca855b$export$cef3435710b52199);
$parcel$export($8b8adca400ca855b$exports, "globalSpace8", () => $8b8adca400ca855b$export$431b2083311a15ea);
$parcel$export($8b8adca400ca855b$exports, "globalSpace9", () => $8b8adca400ca855b$export$b098505ff1a5f952);
$parcel$export($8b8adca400ca855b$exports, "globalSpace10", () => $8b8adca400ca855b$export$d39e18acdfc94a45);
$parcel$export($8b8adca400ca855b$exports, "globalSpace11", () => $8b8adca400ca855b$export$4d09869bf749903e);
$parcel$export($8b8adca400ca855b$exports, "globalSpace12", () => $8b8adca400ca855b$export$8ea49e0388a60a62);
$parcel$export($8b8adca400ca855b$exports, "globalSpace13", () => $8b8adca400ca855b$export$6819254900b8d1cf);
$parcel$export($8b8adca400ca855b$exports, "globalSpace14", () => $8b8adca400ca855b$export$8b1552f580e06aac);
$parcel$export($8b8adca400ca855b$exports, "globalSpace15", () => $8b8adca400ca855b$export$f7e6e8df6820a759);
$parcel$export($8b8adca400ca855b$exports, "globalSpace16", () => $8b8adca400ca855b$export$6b78519ba1b56b20);
$parcel$export($8b8adca400ca855b$exports, "globalSpaceHalf", () => $8b8adca400ca855b$export$aa21579cea294b7a);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize6", () => $8b8adca400ca855b$export$af88d6b81a19ff0a);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize8", () => $8b8adca400ca855b$export$a7fa5cf4f467a7a3);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize10", () => $8b8adca400ca855b$export$19e367993efb2a85);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize12", () => $8b8adca400ca855b$export$c0dbfa2a9de4cf2b);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize14", () => $8b8adca400ca855b$export$7db4d44897db3aae);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize16", () => $8b8adca400ca855b$export$77fa12a7f6088e8a);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize20", () => $8b8adca400ca855b$export$88f405f990d50798);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize24", () => $8b8adca400ca855b$export$70eddb9c5b448a1e);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize30", () => $8b8adca400ca855b$export$cfed16d4b5ca2dea);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize40", () => $8b8adca400ca855b$export$1d5778bc4ba49de3);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize50", () => $8b8adca400ca855b$export$6b8537e4a6c85699);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize60", () => $8b8adca400ca855b$export$89c52c27197613ea);
$parcel$export($8b8adca400ca855b$exports, "globalFontSize70", () => $8b8adca400ca855b$export$a8475dc9cbba9136);
$parcel$export($8b8adca400ca855b$exports, "globalLetterSpacing0", () => $8b8adca400ca855b$export$287eb463b205f73b);
$parcel$export($8b8adca400ca855b$exports, "globalTextCaseNone", () => $8b8adca400ca855b$export$98aa6b13aaaaaed4);
$parcel$export($8b8adca400ca855b$exports, "globalTextDecorationNone", () => $8b8adca400ca855b$export$c3b12835a35a3ebc);
$parcel$export($8b8adca400ca855b$exports, "globalTextDecorationUnderline", () => $8b8adca400ca855b$export$78cf32b6248297d8);
$parcel$export($8b8adca400ca855b$exports, "globalBorderWidth0", () => $8b8adca400ca855b$export$90cf649d4bdde151);
$parcel$export($8b8adca400ca855b$exports, "globalBorderWidth1", () => $8b8adca400ca855b$export$8eed865464cb9443);
$parcel$export($8b8adca400ca855b$exports, "globalBorderWidth2", () => $8b8adca400ca855b$export$5d966ef1a668534d);
$parcel$export($8b8adca400ca855b$exports, "globalTeal10", () => $8b8adca400ca855b$export$1fde20e337d78057);
$parcel$export($8b8adca400ca855b$exports, "globalTeal20", () => $8b8adca400ca855b$export$8ab6bac2cfbaa311);
$parcel$export($8b8adca400ca855b$exports, "globalTeal30", () => $8b8adca400ca855b$export$7c3268c1e9449b23);
$parcel$export($8b8adca400ca855b$exports, "globalTeal40", () => $8b8adca400ca855b$export$ac2cb8d286cd282d);
$parcel$export($8b8adca400ca855b$exports, "globalTeal50", () => $8b8adca400ca855b$export$afe30047fb949ada);
$parcel$export($8b8adca400ca855b$exports, "globalTeal60", () => $8b8adca400ca855b$export$bedb631b11c40714);
$parcel$export($8b8adca400ca855b$exports, "globalTeal70", () => $8b8adca400ca855b$export$cbb4e1767cbcc295);
$parcel$export($8b8adca400ca855b$exports, "globalTeal80", () => $8b8adca400ca855b$export$1ea24c91b8d25363);
$parcel$export($8b8adca400ca855b$exports, "globalTeal90", () => $8b8adca400ca855b$export$e48c1ae9f703ec3);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar10", () => $8b8adca400ca855b$export$3b66de443e6ecd2d);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar20", () => $8b8adca400ca855b$export$d1b7eb4ab1109f37);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar30", () => $8b8adca400ca855b$export$6fcf2bd98a8c3471);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar40", () => $8b8adca400ca855b$export$854fd1fca212ac66);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar50", () => $8b8adca400ca855b$export$94792cfe955edc7c);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar60", () => $8b8adca400ca855b$export$a03199dd35bdd04c);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar70", () => $8b8adca400ca855b$export$c2de267ef50b3959);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar80", () => $8b8adca400ca855b$export$cbb9699552d08e72);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar90", () => $8b8adca400ca855b$export$926bc41ea4705265);
$parcel$export($8b8adca400ca855b$exports, "globalLavendar92", () => $8b8adca400ca855b$export$654ed5d813f21dec);
$parcel$export($8b8adca400ca855b$exports, "globalFushia10", () => $8b8adca400ca855b$export$69f18349c11e1ae6);
$parcel$export($8b8adca400ca855b$exports, "globalFushia20", () => $8b8adca400ca855b$export$2ad4e0257e372740);
$parcel$export($8b8adca400ca855b$exports, "globalFushia30", () => $8b8adca400ca855b$export$e87f916bb6428820);
$parcel$export($8b8adca400ca855b$exports, "globalFushia40", () => $8b8adca400ca855b$export$c0c1b77517485090);
$parcel$export($8b8adca400ca855b$exports, "globalFushia50", () => $8b8adca400ca855b$export$8239eaa50a0a5f95);
$parcel$export($8b8adca400ca855b$exports, "globalFushia60", () => $8b8adca400ca855b$export$77be4f078e816c57);
$parcel$export($8b8adca400ca855b$exports, "globalFushia70", () => $8b8adca400ca855b$export$92d17db692dfdb26);
$parcel$export($8b8adca400ca855b$exports, "globalFushia80", () => $8b8adca400ca855b$export$198155ce03982d4b);
$parcel$export($8b8adca400ca855b$exports, "globalFushia90", () => $8b8adca400ca855b$export$1eaa04001df46302);
$parcel$export($8b8adca400ca855b$exports, "muiTeal15", () => $8b8adca400ca855b$export$46520cc5cc636d5);
$parcel$export($8b8adca400ca855b$exports, "muiTeal25", () => $8b8adca400ca855b$export$65b52ee8779cfb86);
$parcel$export($8b8adca400ca855b$exports, "muiTeal50", () => $8b8adca400ca855b$export$15103e7803509654);
$parcel$export($8b8adca400ca855b$exports, "muiTeal100", () => $8b8adca400ca855b$export$e1e0f831fb8ef956);
$parcel$export($8b8adca400ca855b$exports, "muiTeal400", () => $8b8adca400ca855b$export$cab8599dbbafe6f0);
$parcel$export($8b8adca400ca855b$exports, "muiTeal500", () => $8b8adca400ca855b$export$eb1ba29c8ee4ce89);
$parcel$export($8b8adca400ca855b$exports, "muiTeal600", () => $8b8adca400ca855b$export$b317de730274ad6d);
$parcel$export($8b8adca400ca855b$exports, "muiTeal700", () => $8b8adca400ca855b$export$688aa6f257feb3f4);
$parcel$export($8b8adca400ca855b$exports, "muiTeal800", () => $8b8adca400ca855b$export$5bb5e616682f7dfd);
$parcel$export($8b8adca400ca855b$exports, "muiTeal900", () => $8b8adca400ca855b$export$6f48b50d16c41924);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar100", () => $8b8adca400ca855b$export$8658174a5a26d8c8);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar200", () => $8b8adca400ca855b$export$94cf89e29828b90d);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar300", () => $8b8adca400ca855b$export$fe800a881fbd2a17);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar400", () => $8b8adca400ca855b$export$86e5c257800b1ba7);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar500", () => $8b8adca400ca855b$export$efcc76822b16de0);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar600", () => $8b8adca400ca855b$export$e35506918d293b2d);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar700", () => $8b8adca400ca855b$export$b80547edfe0328fa);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar800", () => $8b8adca400ca855b$export$6f80192eefeaa148);
$parcel$export($8b8adca400ca855b$exports, "muiLavendar900", () => $8b8adca400ca855b$export$8441530762eae6d3);
$parcel$export($8b8adca400ca855b$exports, "muiFushia100", () => $8b8adca400ca855b$export$90bc334d7aee9545);
$parcel$export($8b8adca400ca855b$exports, "muiFushia200", () => $8b8adca400ca855b$export$b3f1e6c576416c1d);
$parcel$export($8b8adca400ca855b$exports, "muiFushia300", () => $8b8adca400ca855b$export$191c88ebca6ffe3c);
$parcel$export($8b8adca400ca855b$exports, "muiFushia400", () => $8b8adca400ca855b$export$1f42ab64f4a83dee);
$parcel$export($8b8adca400ca855b$exports, "muiFushia500", () => $8b8adca400ca855b$export$5fb6a51ed9b33fd0);
$parcel$export($8b8adca400ca855b$exports, "muiFushia600", () => $8b8adca400ca855b$export$126413e9cf01d9cc);
$parcel$export($8b8adca400ca855b$exports, "muiFushia700", () => $8b8adca400ca855b$export$a335b1f360803681);
$parcel$export($8b8adca400ca855b$exports, "muiFushia800", () => $8b8adca400ca855b$export$21e31efc7bd30562);
$parcel$export($8b8adca400ca855b$exports, "muiFushia900", () => $8b8adca400ca855b$export$82bb60d82e157db1);
$parcel$export($8b8adca400ca855b$exports, "muiGreen50", () => $8b8adca400ca855b$export$b583fe876073a2fe);
$parcel$export($8b8adca400ca855b$exports, "muiGreen500", () => $8b8adca400ca855b$export$f4738750a09fc45);
$parcel$export($8b8adca400ca855b$exports, "muiGreen900", () => $8b8adca400ca855b$export$f892d1b579b087f5);
$parcel$export($8b8adca400ca855b$exports, "muiRed50", () => $8b8adca400ca855b$export$a7461ee647c93d00);
$parcel$export($8b8adca400ca855b$exports, "muiRed500", () => $8b8adca400ca855b$export$7a6939cbe6750292);
$parcel$export($8b8adca400ca855b$exports, "muiRed900", () => $8b8adca400ca855b$export$f13b4f317c31e202);
$parcel$export($8b8adca400ca855b$exports, "muiRedOrange50", () => $8b8adca400ca855b$export$466eea952b10a8df);
$parcel$export($8b8adca400ca855b$exports, "muiRedOrange100", () => $8b8adca400ca855b$export$3d73f527ec37353b);
$parcel$export($8b8adca400ca855b$exports, "muiRedOrange200", () => $8b8adca400ca855b$export$848d0b3dbc4a58e9);
$parcel$export($8b8adca400ca855b$exports, "muiRedOrange300", () => $8b8adca400ca855b$export$67c22c804a444617);
$parcel$export($8b8adca400ca855b$exports, "muiRedOrange500", () => $8b8adca400ca855b$export$35c178005989be85);
$parcel$export($8b8adca400ca855b$exports, "muiRedOrange900", () => $8b8adca400ca855b$export$d156763d5698483c);
$parcel$export($8b8adca400ca855b$exports, "muiInfoGray50", () => $8b8adca400ca855b$export$1f3e8d28a4bc8087);
$parcel$export($8b8adca400ca855b$exports, "muiInfoGray500", () => $8b8adca400ca855b$export$533189fca2ec5a05);
$parcel$export($8b8adca400ca855b$exports, "muiInfoGray900", () => $8b8adca400ca855b$export$9a0d26ed3c25e7f);
$parcel$export($8b8adca400ca855b$exports, "muiBlue50", () => $8b8adca400ca855b$export$732d133811ff729f);
$parcel$export($8b8adca400ca855b$exports, "muiBlue500", () => $8b8adca400ca855b$export$2dd034e8857d984e);
$parcel$export($8b8adca400ca855b$exports, "muiBlue700", () => $8b8adca400ca855b$export$83df2e97b19f7aba);
$parcel$export($8b8adca400ca855b$exports, "muiBlue800", () => $8b8adca400ca855b$export$e84284477477fbb0);
$parcel$export($8b8adca400ca855b$exports, "muiBlue900", () => $8b8adca400ca855b$export$94a8d52af3524619);
$parcel$export($8b8adca400ca855b$exports, "muiGray15", () => $8b8adca400ca855b$export$dde3540a7c52aa62);
$parcel$export($8b8adca400ca855b$exports, "muiGray20", () => $8b8adca400ca855b$export$60dd899fb1fc8ebb);
$parcel$export($8b8adca400ca855b$exports, "muiGray25", () => $8b8adca400ca855b$export$b44ed74ac6c5e0b1);
$parcel$export($8b8adca400ca855b$exports, "muiGray50", () => $8b8adca400ca855b$export$b45cfc1807a3979c);
$parcel$export($8b8adca400ca855b$exports, "muiGray100", () => $8b8adca400ca855b$export$20d695d1c7fa5d12);
$parcel$export($8b8adca400ca855b$exports, "muiGray200", () => $8b8adca400ca855b$export$93394257d70d9c4b);
$parcel$export($8b8adca400ca855b$exports, "muiGray300", () => $8b8adca400ca855b$export$6ead472efe5cccf9);
$parcel$export($8b8adca400ca855b$exports, "muiGray400", () => $8b8adca400ca855b$export$7345959dcc3f1249);
$parcel$export($8b8adca400ca855b$exports, "muiGray500", () => $8b8adca400ca855b$export$f6fc60ebb1f0098d);
$parcel$export($8b8adca400ca855b$exports, "muiGray600", () => $8b8adca400ca855b$export$bb9c92dcc503d041);
$parcel$export($8b8adca400ca855b$exports, "muiGray700", () => $8b8adca400ca855b$export$919b4cfa2a3431d7);
$parcel$export($8b8adca400ca855b$exports, "muiGray800", () => $8b8adca400ca855b$export$3a932b816df19cf9);
$parcel$export($8b8adca400ca855b$exports, "muiGray900", () => $8b8adca400ca855b$export$df6264b18306f8ce);
$parcel$export($8b8adca400ca855b$exports, "aliasesBoxShadowDefault", () => $8b8adca400ca855b$export$e306266450d339da);
$parcel$export($8b8adca400ca855b$exports, "aliasesBoxShadowFloating", () => $8b8adca400ca855b$export$c727a326e5ac158d);
$parcel$export($8b8adca400ca855b$exports, "aliasesBoxShadowTop", () => $8b8adca400ca855b$export$f124d9ef132d79f1);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeMicro", () => $8b8adca400ca855b$export$5ccfbbfe47595323);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeXxs", () => $8b8adca400ca855b$export$20f5c07ae3856232);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeXs", () => $8b8adca400ca855b$export$c8bf6e81dacfc196);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeS", () => $8b8adca400ca855b$export$99f6d89f34a0b1a0);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeM", () => $8b8adca400ca855b$export$f2d0edabd04761fb);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeL", () => $8b8adca400ca855b$export$ed3a53feec192842);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeXl", () => $8b8adca400ca855b$export$8b69e23cdf44e5c4);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeXxl", () => $8b8adca400ca855b$export$a5fd793e6ae66615);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeInput", () => $8b8adca400ca855b$export$67b8da528429660d);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeWidthColumn1", () => $8b8adca400ca855b$export$4895d0896c23a35a);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeWidthColumn2", () => $8b8adca400ca855b$export$c97d64ed641c0c68);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeWidthColumn3", () => $8b8adca400ca855b$export$496884663027a953);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeWidthColumn4", () => $8b8adca400ca855b$export$942a8415fd3bc2bd);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeWidthColumn6", () => $8b8adca400ca855b$export$d4dcd3e7a9f00b00);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeWidthColumn8", () => $8b8adca400ca855b$export$ac6d8dd750e2b03d);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeWidthDesktopDefault", () => $8b8adca400ca855b$export$ea8e199042cb733d);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeHeightInputDense", () => $8b8adca400ca855b$export$9ec87d3ea06e00a5);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeHeightDesktopDefault", () => $8b8adca400ca855b$export$145590b199e7aa08);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeComponentXxl", () => $8b8adca400ca855b$export$ea53782885816cc4);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeComponentXl", () => $8b8adca400ca855b$export$88fccbab69a23b50);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeComponentM", () => $8b8adca400ca855b$export$aeea69d04d385bac);
$parcel$export($8b8adca400ca855b$exports, "aliasesSizeParticle", () => $8b8adca400ca855b$export$1eed320f6fa53669);
$parcel$export($8b8adca400ca855b$exports, "aliasesBorderWidthNone", () => $8b8adca400ca855b$export$170fa82b897b1027);
$parcel$export($8b8adca400ca855b$exports, "aliasesBorderWidthDefault", () => $8b8adca400ca855b$export$ce76584477c56c81);
$parcel$export($8b8adca400ca855b$exports, "aliasesBorderWidthThick", () => $8b8adca400ca855b$export$59d5e2224353c9c);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightCta", () => $8b8adca400ca855b$export$e878cf70517bf87d);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightAvatar", () => $8b8adca400ca855b$export$ca532bde8b673674);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightDefault", () => $8b8adca400ca855b$export$d35ad0b1db66aab);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightInput", () => $8b8adca400ca855b$export$2c081aeb7c8eb547);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightCaption", () => $8b8adca400ca855b$export$b538dbdb5cc993e2);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightMicro", () => $8b8adca400ca855b$export$12bd9cd6158eeaff);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightLabel", () => $8b8adca400ca855b$export$87d099ffe187ede3);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightH1", () => $8b8adca400ca855b$export$45a9411d397e7014);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightH2", () => $8b8adca400ca855b$export$6441942a9191e8b);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightH3", () => $8b8adca400ca855b$export$603bbc670bd6cdb7);
$parcel$export($8b8adca400ca855b$exports, "aliasesLineHeightH4", () => $8b8adca400ca855b$export$bd4d597b9a8478ef);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontWeightDefault", () => $8b8adca400ca855b$export$33b4990036285dd4);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontWeightNeutral", () => $8b8adca400ca855b$export$94b8628301cfeba5);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontWeightEmphasis", () => $8b8adca400ca855b$export$4251501a1fd96031);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontFamilyDefault", () => $8b8adca400ca855b$export$ec958139a7af2a8d);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontFamilyHeader", () => $8b8adca400ca855b$export$dfce6fb8007da48e);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontFamilyPromo", () => $8b8adca400ca855b$export$68b4938ddb45a8c0);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeMicro", () => $8b8adca400ca855b$export$85da697736c3f546);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeCaption", () => $8b8adca400ca855b$export$f6f08d75449b0f4f);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeDefault", () => $8b8adca400ca855b$export$32766a586f34b05b);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeH1", () => $8b8adca400ca855b$export$4ecde25fa2a16515);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeH2", () => $8b8adca400ca855b$export$ad3e07fd3f6eb5e9);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeH3", () => $8b8adca400ca855b$export$191898ea266c6db3);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeH4", () => $8b8adca400ca855b$export$f7668923bd63f908);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontSizeDefaultSmall", () => $8b8adca400ca855b$export$dc1063802be71f6b);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontWeightDefault", () => $8b8adca400ca855b$export$1e9bf329c53e42da);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontWeightNeutral", () => $8b8adca400ca855b$export$8cebf529bc3d12cd);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoFontWeightEmphasis", () => $8b8adca400ca855b$export$d554c99af2e8701d);
$parcel$export($8b8adca400ca855b$exports, "aliasesPromoLineHeightDefault", () => $8b8adca400ca855b$export$7711684ec178da45);
$parcel$export($8b8adca400ca855b$exports, "aliasesSpaceContainerDefault", () => $8b8adca400ca855b$export$ea858f460f740237);
$parcel$export($8b8adca400ca855b$exports, "aliasesSpaceContainerDense", () => $8b8adca400ca855b$export$4b9604858cc8bf9b);
$parcel$export($8b8adca400ca855b$exports, "aliasesSpaceContainerSpacious", () => $8b8adca400ca855b$export$5c216d07f6313f89);
$parcel$export($8b8adca400ca855b$exports, "aliasesSpaceComponentDefault", () => $8b8adca400ca855b$export$31bcbabf8dd2f068);
$parcel$export($8b8adca400ca855b$exports, "aliasesSpaceComponentSpacious", () => $8b8adca400ca855b$export$c18af1c576b9134e);
$parcel$export($8b8adca400ca855b$exports, "aliasesSpaceComponentDense", () => $8b8adca400ca855b$export$2139653de76670a8);
$parcel$export($8b8adca400ca855b$exports, "aliasesSpaceComponentParticle", () => $8b8adca400ca855b$export$1f8b3d352ce76e2);
$parcel$export($8b8adca400ca855b$exports, "aliasesBorderRadiusNone", () => $8b8adca400ca855b$export$da181d9bc79e4a02);
$parcel$export($8b8adca400ca855b$exports, "aliasesBorderRadiusSharp", () => $8b8adca400ca855b$export$6422537c35b745d9);
$parcel$export($8b8adca400ca855b$exports, "aliasesBorderRadiusDefault", () => $8b8adca400ca855b$export$e77925bd46d7e15b);
$parcel$export($8b8adca400ca855b$exports, "aliasesBorderRadiusRound", () => $8b8adca400ca855b$export$55ec15df2cced997);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries1Default", () => $8b8adca400ca855b$export$53dad9b8590b2590);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries1Hover", () => $8b8adca400ca855b$export$2cfa48c35037e4cd);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries1Focus", () => $8b8adca400ca855b$export$4cc965d0c8b21c5c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries1Selected", () => $8b8adca400ca855b$export$c5215a7e991b1930);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries1Transparent", () => $8b8adca400ca855b$export$11f329bcb8162d0d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries2Default", () => $8b8adca400ca855b$export$403b382cc6844409);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries2Hover", () => $8b8adca400ca855b$export$deda6d87d502e7b9);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries2Focus", () => $8b8adca400ca855b$export$c74f5a5b20d20e6a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries2Selected", () => $8b8adca400ca855b$export$86b18e3169467eff);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries2Transparent", () => $8b8adca400ca855b$export$3558da976e5d4766);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries3Default", () => $8b8adca400ca855b$export$46db9a5b4fa29cdb);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries3Hover", () => $8b8adca400ca855b$export$c7ceda4e66b9f080);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries3Focus", () => $8b8adca400ca855b$export$fae84847465463d4);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries3Selected", () => $8b8adca400ca855b$export$d33af6c1185faec2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries3Transparent", () => $8b8adca400ca855b$export$7ced400057edeaf3);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries4Default", () => $8b8adca400ca855b$export$51494f3f5dc6cffe);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries4Hover", () => $8b8adca400ca855b$export$7f8f0ea50825a1b7);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries4Focus", () => $8b8adca400ca855b$export$833baa99ed859de5);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries4Selected", () => $8b8adca400ca855b$export$8662dc5f96d63e1c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries4Transparent", () => $8b8adca400ca855b$export$f5bf3b4e8e44efda);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries5Default", () => $8b8adca400ca855b$export$18adc08f697e50fe);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries5Hover", () => $8b8adca400ca855b$export$5e8722563ff0c000);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries5Focus", () => $8b8adca400ca855b$export$d00e843f86f2564a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries5Selected", () => $8b8adca400ca855b$export$fa36bc78b7ce543e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries5Transparent", () => $8b8adca400ca855b$export$3f6119e89ab4de35);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries6Default", () => $8b8adca400ca855b$export$e0b0cb547b1f892d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries6Hover", () => $8b8adca400ca855b$export$927f064bc5b07bfa);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries6Focus", () => $8b8adca400ca855b$export$56f2d00a015cd7a8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries6Selected", () => $8b8adca400ca855b$export$8b59f2dc411c59d7);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries6Transparent", () => $8b8adca400ca855b$export$68d3bcba77d10f82);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries7Default", () => $8b8adca400ca855b$export$6ff7613d4c7aeb8d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries7Hover", () => $8b8adca400ca855b$export$a6d09535a6dea115);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries7Focus", () => $8b8adca400ca855b$export$5b5bdc2dd57fd7ee);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries7Selected", () => $8b8adca400ca855b$export$422c1cc49a17292a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries7Transparent", () => $8b8adca400ca855b$export$8722d1c809de28b3);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries8Default", () => $8b8adca400ca855b$export$eb43764bdf88d057);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries8Hover", () => $8b8adca400ca855b$export$67a542d8cd9b82dd);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries8Focus", () => $8b8adca400ca855b$export$d1f88ead0dc7a304);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries8Selected", () => $8b8adca400ca855b$export$5038a7dd0a89c7d0);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSeries8Transparent", () => $8b8adca400ca855b$export$fb457f52cca97850);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentSubtleDefault", () => $8b8adca400ca855b$export$519809f976569692);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentSubtleHover", () => $8b8adca400ca855b$export$c584085d5ee8de76);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentSubtleFocus", () => $8b8adca400ca855b$export$a788d2961d748cde);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentSubtleSelectedDefault", () => $8b8adca400ca855b$export$e32ea0d81272e1b6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentSubtleSelectedHover", () => $8b8adca400ca855b$export$d8ae6269b02938b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentSubtleDisabled", () => $8b8adca400ca855b$export$2f14b841cad9c767);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentNeutralDefault", () => $8b8adca400ca855b$export$10519f8ccd4b0b86);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentNeutralHover", () => $8b8adca400ca855b$export$2fa9eeb6d8e51673);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentNeutralFocus", () => $8b8adca400ca855b$export$ed95ed13f2c03e16);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentNeutralSelectedDefault", () => $8b8adca400ca855b$export$1c9be6c6205a847b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentNeutralSelectedHover", () => $8b8adca400ca855b$export$8b5c10f16365778c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentNeutralDisabled", () => $8b8adca400ca855b$export$768c1cdce28e1d12);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentEmphasisDefault", () => $8b8adca400ca855b$export$1a1821660ba5e5fe);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentEmphasisHover", () => $8b8adca400ca855b$export$663065bf2da99939);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentEmphasisFocus", () => $8b8adca400ca855b$export$c914cb73d8ae4e4f);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentEmphasisSelectedDefault", () => $8b8adca400ca855b$export$2c74ca3559bf64f);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentEmphasisSelectedHover", () => $8b8adca400ca855b$export$72a1027e9ca37197);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveComponentEmphasisDisabled", () => $8b8adca400ca855b$export$3e018292749dd934);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerSubtleDefault", () => $8b8adca400ca855b$export$bb278ff9c8980518);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerSubtleHover", () => $8b8adca400ca855b$export$36eae0c7542b8f46);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerSubtleFocus", () => $8b8adca400ca855b$export$96674436714104a8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerSubtleDisabled", () => $8b8adca400ca855b$export$2896c237a2e3e079);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerSubtleSelectedDefault", () => $8b8adca400ca855b$export$a48b18644600cff8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerSubtleSelectedHover", () => $8b8adca400ca855b$export$32f93b6101bdc552);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerNeutralDefault", () => $8b8adca400ca855b$export$cc6fa3dd94433a27);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerNeutralHover", () => $8b8adca400ca855b$export$902237779564add5);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerNeutralFocus", () => $8b8adca400ca855b$export$df41c8766762ac09);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerNeutralDisabled", () => $8b8adca400ca855b$export$5e39dea751a8af3e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerNeutralSelectedDefault", () => $8b8adca400ca855b$export$3f5d1438f789e95b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerNeutralSelectedHover", () => $8b8adca400ca855b$export$47c3cd69e3cba602);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerEmphasisDefault", () => $8b8adca400ca855b$export$e5fda2d14bb87245);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerEmphasisHover", () => $8b8adca400ca855b$export$d6a62f44a4bb6848);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerEmphasisFocus", () => $8b8adca400ca855b$export$77499b6ac1d78be2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerEmphasisDisabled", () => $8b8adca400ca855b$export$88019076f718435e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerEmphasisSelectedDefault", () => $8b8adca400ca855b$export$1961987bbf85bc69);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveContainerEmphasisSelectedHover", () => $8b8adca400ca855b$export$f563e1c4b1dfe9b6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaSubtleDefault", () => $8b8adca400ca855b$export$4188c5dfbd960ff6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaSubtleHover", () => $8b8adca400ca855b$export$6f8b1b70dce4971d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaSubtleFocus", () => $8b8adca400ca855b$export$51c0a5205fae8605);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaSubtleSelectedDefault", () => $8b8adca400ca855b$export$e3efd006787060d7);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaSubtleSelectedHover", () => $8b8adca400ca855b$export$fd9c87bcf2280fcc);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaSubtleDisabled", () => $8b8adca400ca855b$export$33c2d8ee15842362);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaNeutralDefault", () => $8b8adca400ca855b$export$7d9f7647b114f0ff);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaNeutralHover", () => $8b8adca400ca855b$export$bee26b78d3246ede);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaNeutralFocus", () => $8b8adca400ca855b$export$844a6b198d459d4f);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaNeutralSelectedDefault", () => $8b8adca400ca855b$export$c32dfb5afe8442d2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaNeutralSelectedHover", () => $8b8adca400ca855b$export$8c54331216764c04);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaNeutralDisabled", () => $8b8adca400ca855b$export$ed179d6ea18a424b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaEmphasisDefault", () => $8b8adca400ca855b$export$a2b7d83a97c0807b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaEmphasisHover", () => $8b8adca400ca855b$export$75fdb7e4365aea69);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaEmphasisFocus", () => $8b8adca400ca855b$export$436333264dcf080c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaEmphasisSelectedDefault", () => $8b8adca400ca855b$export$48fdba70460beee3);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaEmphasisSelectedHover", () => $8b8adca400ca855b$export$a3db82021e9802c1);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInteractiveCtaEmphasisDisabled", () => $8b8adca400ca855b$export$17521d5649bf845b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderStaticComponentSubtle", () => $8b8adca400ca855b$export$d51f08d8d0f3a9cc);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderStaticComponentNeutral", () => $8b8adca400ca855b$export$1bcabe1edda14f10);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderStaticComponentEmphasis", () => $8b8adca400ca855b$export$10d03502f2dd5cdd);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderStaticContainerSubtle", () => $8b8adca400ca855b$export$52269544c67eee3a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderStaticContainerNeutral", () => $8b8adca400ca855b$export$368cb14eb84c724e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderStaticContainerEmphasis", () => $8b8adca400ca855b$export$976ab5bc3e192772);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderErrorSubtle", () => $8b8adca400ca855b$export$f32dfe87536251b0);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderErrorNeutral", () => $8b8adca400ca855b$export$f917c18e2c0733a2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderErrorEmphasis", () => $8b8adca400ca855b$export$37a2561e6f52f1a6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSuccessSubtle", () => $8b8adca400ca855b$export$757d1267e084d85e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSuccessNeutral", () => $8b8adca400ca855b$export$c96234e9ac3976aa);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderSuccessEmphasis", () => $8b8adca400ca855b$export$2ada4242418b1ab);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderWarningSubtle", () => $8b8adca400ca855b$export$88e8fc65e1dc8cfd);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderWarningNeutral", () => $8b8adca400ca855b$export$571330183a04a679);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderWarningEmphasis", () => $8b8adca400ca855b$export$e2364df1760c1cd2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInfoSubtle", () => $8b8adca400ca855b$export$88387c1fa4550702);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInfoNeutral", () => $8b8adca400ca855b$export$31154090c834e808);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderInfoEmphasis", () => $8b8adca400ca855b$export$fd57486f12ccccc7);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderLogoEmail", () => $8b8adca400ca855b$export$c49e9b4e44fd796c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderLogoPlatform", () => $8b8adca400ca855b$export$da7e305f941f7c1b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderLogoNetwork", () => $8b8adca400ca855b$export$98adb0276baaf8cf);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderLogoApp", () => $8b8adca400ca855b$export$8420ff989cc50c37);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBorderLogoData", () => $8b8adca400ca855b$export$b8a3bfa1fcd8dbc7);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInteractiveSubtle", () => $8b8adca400ca855b$export$ce5dfe4e5b931e4a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInteractiveNeutral", () => $8b8adca400ca855b$export$958169ac176093af);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInteractiveEmphasis", () => $8b8adca400ca855b$export$c3458d3269390c99);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInteractiveDisabled", () => $8b8adca400ca855b$export$f7e100eac7e2f133);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInteractiveSelected", () => $8b8adca400ca855b$export$95f6ec96cc827155);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInverseEmphasis", () => $8b8adca400ca855b$export$657174ec69a2226a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInverseDisabled", () => $8b8adca400ca855b$export$e123307e2b218889);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInverseNeutral", () => $8b8adca400ca855b$export$7b91367d7e807812);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextInverseSubtle", () => $8b8adca400ca855b$export$aa6384fd68eb0d3b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextStaticSubtle", () => $8b8adca400ca855b$export$3208e2036242c233);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextStaticNeutral", () => $8b8adca400ca855b$export$db305d4c182a82ff);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextStaticEmphasis", () => $8b8adca400ca855b$export$7641b4bffb9af953);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextStaticInverse", () => $8b8adca400ca855b$export$635aa5d463114b08);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorTextError", () => $8b8adca400ca855b$export$e5149da9067fe611);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoEmailDefault", () => $8b8adca400ca855b$export$dfbedab10da73342);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoEmailLight", () => $8b8adca400ca855b$export$80f74912e5e2c16e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoNetwork", () => $8b8adca400ca855b$export$11b87b8556d144a8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoAppDefault", () => $8b8adca400ca855b$export$380739dd5aaef19b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoAppLight", () => $8b8adca400ca855b$export$d5620addd245919a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoData", () => $8b8adca400ca855b$export$a86a694f71504589);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoTeeth", () => $8b8adca400ca855b$export$39d3aed953cc66e4);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgLogoPlatform", () => $8b8adca400ca855b$export$4b18498d98ac2b51);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries1Default", () => $8b8adca400ca855b$export$a612632118a3b91b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries1Hover", () => $8b8adca400ca855b$export$465d16f3f0328e03);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries1Focus", () => $8b8adca400ca855b$export$e11a401a4e94968e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries1Selected", () => $8b8adca400ca855b$export$9d6422b3a72c759f);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries1Transparent", () => $8b8adca400ca855b$export$5b94bccbb3b2583c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries2Default", () => $8b8adca400ca855b$export$b8a531ce48f1ec30);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries2Hover", () => $8b8adca400ca855b$export$5d4a9c2be9f03907);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries2Focus", () => $8b8adca400ca855b$export$3a2e5b43fc49e678);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries2Selected", () => $8b8adca400ca855b$export$87ffd345b881d06e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries2Transparent", () => $8b8adca400ca855b$export$8827af02313fafc6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries3Default", () => $8b8adca400ca855b$export$63971f9c83d9fbd1);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries3Hover", () => $8b8adca400ca855b$export$15a94504af5cb48d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries3Focus", () => $8b8adca400ca855b$export$ea6f57adb3b615d1);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries3Selected", () => $8b8adca400ca855b$export$603bede8ed38ec7c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries3Transparent", () => $8b8adca400ca855b$export$96ad1ff12a5eae51);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries4Default", () => $8b8adca400ca855b$export$3435221529653182);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries4Hover", () => $8b8adca400ca855b$export$6140f2a94c436fb8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries4Focus", () => $8b8adca400ca855b$export$13e360d171ddb1b1);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries4Selected", () => $8b8adca400ca855b$export$bbdd1745b1aa2bfa);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries4Transparent", () => $8b8adca400ca855b$export$1efbfdbe33975e65);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries5Default", () => $8b8adca400ca855b$export$213e10a2fa7b8f25);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries5Hover", () => $8b8adca400ca855b$export$f04fa375e16b056f);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries5Focus", () => $8b8adca400ca855b$export$118e41f6ad7c84e4);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries5Selected", () => $8b8adca400ca855b$export$a61605328d84ff20);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries5Transparent", () => $8b8adca400ca855b$export$388c04cdf17d92da);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries6Default", () => $8b8adca400ca855b$export$9e8d2402ccd4d487);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries6Hover", () => $8b8adca400ca855b$export$8ce3c3b4e69389b3);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries6Focus", () => $8b8adca400ca855b$export$381431d7d1cd2cdc);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries6Selected", () => $8b8adca400ca855b$export$1d762aa2ded48ccc);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries6Transparent", () => $8b8adca400ca855b$export$ed777c3dad5075f6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries7Default", () => $8b8adca400ca855b$export$92428370c1b865ea);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries7Hover", () => $8b8adca400ca855b$export$ddd43daccf223f75);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries7Focus", () => $8b8adca400ca855b$export$dcaa98e9517a79a9);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries7Selected", () => $8b8adca400ca855b$export$c00fd98671d96e13);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries7Transparent", () => $8b8adca400ca855b$export$d2c685c01dd428bb);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries8Default", () => $8b8adca400ca855b$export$17ca6c34e71101c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries8Hover", () => $8b8adca400ca855b$export$71bc8e3929b67885);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries8Focus", () => $8b8adca400ca855b$export$18b5bb98b26a75b2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries8Selected", () => $8b8adca400ca855b$export$b8035dad7acff593);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSeries8Transparent", () => $8b8adca400ca855b$export$c8abfd1d22e0782b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticComponentSubtle", () => $8b8adca400ca855b$export$69ba8f43cf9bd6fd);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticComponentNeutral", () => $8b8adca400ca855b$export$f153d7318b9ac6c1);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticComponentEmphasis", () => $8b8adca400ca855b$export$32bb8f83e2da4eeb);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticComponentHighlightText", () => $8b8adca400ca855b$export$beed09ba17395fba);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticContainerSubtle", () => $8b8adca400ca855b$export$ddfa67e511d310a1);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticContainerNeutral", () => $8b8adca400ca855b$export$ef61afb4daed05b6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticContainerEmphasis", () => $8b8adca400ca855b$export$fcbf5251861df7b7);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgStaticContainerBackdrop", () => $8b8adca400ca855b$export$e24eb567fe502262);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgNavigationPrimary", () => $8b8adca400ca855b$export$fd7193dce715e7a5);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgNavigationSecondary", () => $8b8adca400ca855b$export$f7cd4529b55f6b65);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgErrorSubtle", () => $8b8adca400ca855b$export$32838d580212d33c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgErrorNeutral", () => $8b8adca400ca855b$export$9ebf7b0a2981f15);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgErrorEmphasis", () => $8b8adca400ca855b$export$4711b9c0f73c9e78);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSuccessSubtle", () => $8b8adca400ca855b$export$e70ad4174aad5efa);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSuccessNeutral", () => $8b8adca400ca855b$export$49814df222dc4e11);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgSuccessEmphasis", () => $8b8adca400ca855b$export$7cb8bf88d5994ac6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgWarningSubtle", () => $8b8adca400ca855b$export$9779a7bfc57f1d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgWarningNeutral", () => $8b8adca400ca855b$export$41cf31ff8fe14f06);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgWarningEmphasis", () => $8b8adca400ca855b$export$69315608b745ccef);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInfoSubtle", () => $8b8adca400ca855b$export$7d3fb3a82b27444e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInfoNeutral", () => $8b8adca400ca855b$export$e503fb06555d356c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInfoEmphasis", () => $8b8adca400ca855b$export$c2715a93ce37bb6d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentSubtleDefault", () => $8b8adca400ca855b$export$dd95d9725323abea);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentSubtleHover", () => $8b8adca400ca855b$export$57bc6d84deab957a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentSubtleFocus", () => $8b8adca400ca855b$export$bdf5b9913bb4f3fa);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentSubtleSelectedDefault", () => $8b8adca400ca855b$export$3d257524dee43873);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentSubtleSelectedHover", () => $8b8adca400ca855b$export$4a362d83881d9a7d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentSubtleDisabled", () => $8b8adca400ca855b$export$3658abd53e71b73b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentNeutralDefault", () => $8b8adca400ca855b$export$80e05e6d32920b95);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentNeutralHover", () => $8b8adca400ca855b$export$f0f8c85d17a6904c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentNeutralFocus", () => $8b8adca400ca855b$export$df2dcd894d47df09);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentNeutralSelectedDefault", () => $8b8adca400ca855b$export$88f8e1485baa4c61);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentNeutralSelectedHover", () => $8b8adca400ca855b$export$668bd1b85a3e6315);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentNeutralDisabled", () => $8b8adca400ca855b$export$b8eccab39f3850b8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentEmphasisDefault", () => $8b8adca400ca855b$export$b5c855fae1b28ad6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentEmphasisHover", () => $8b8adca400ca855b$export$98f748c76bc6e5e6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentEmphasisFocus", () => $8b8adca400ca855b$export$966ce69ea0b3158d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentEmphasisSelectedDefault", () => $8b8adca400ca855b$export$36bc118ab0edded);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentEmphasisSelectedHover", () => $8b8adca400ca855b$export$6fff8a90e8eb0eaa);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveComponentEmphasisDisabled", () => $8b8adca400ca855b$export$788186b488c86558);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerSubtleDefault", () => $8b8adca400ca855b$export$75d76cc6fcb941ac);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerSubtleHover", () => $8b8adca400ca855b$export$5112c48026e56c83);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerSubtleFocus", () => $8b8adca400ca855b$export$97166a6d3215a732);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerSubtleSelectedDefault", () => $8b8adca400ca855b$export$6acdad347d3433d2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerSubtleSelectedHover", () => $8b8adca400ca855b$export$271026c4bdf43872);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerSubtleDisabled", () => $8b8adca400ca855b$export$ae48a1bc62abcfbb);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerNeutralDefault", () => $8b8adca400ca855b$export$85cad9355d106745);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerNeutralHover", () => $8b8adca400ca855b$export$6f8939a00778a44b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerNeutralFocus", () => $8b8adca400ca855b$export$69c050e0055d47e7);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerNeutralSelectedDefault", () => $8b8adca400ca855b$export$2d8338132c859946);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerNeutralSelectedHover", () => $8b8adca400ca855b$export$ab4bc868a0e35284);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerNeutralDisabled", () => $8b8adca400ca855b$export$f36210171c60734d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerEmphasisDefault", () => $8b8adca400ca855b$export$ee107e86642de023);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerEmphasisHover", () => $8b8adca400ca855b$export$b44f568374a0ce0);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerEmphasisFocus", () => $8b8adca400ca855b$export$b6d257ffaa4da9c4);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerEmphasisSelectedDefault", () => $8b8adca400ca855b$export$21b30ac68ae47cd2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerEmphasisSelectedHover", () => $8b8adca400ca855b$export$11b1d4709f91be43);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveContainerEmphasisDisabled", () => $8b8adca400ca855b$export$931ef32bb11eaa45);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaSubtleDefault", () => $8b8adca400ca855b$export$37db67f42f3e4dd2);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaSubtleHover", () => $8b8adca400ca855b$export$c5e9d21ac7b68d10);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaSubtleFocus", () => $8b8adca400ca855b$export$77aba3a97c22e449);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaSubtleSelectedDefault", () => $8b8adca400ca855b$export$504e1687cbb53608);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaSubtleSelectedHover", () => $8b8adca400ca855b$export$239eed1838553c1d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaNeutralDefault", () => $8b8adca400ca855b$export$cecf34cd6f8888d8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaNeutralHover", () => $8b8adca400ca855b$export$bf3acb3c0b34a34);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaNeutralFocus", () => $8b8adca400ca855b$export$fed370744d8fbf8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaNeutralSelectedDefault", () => $8b8adca400ca855b$export$4cce883c26bd421b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaNeutralSelectedHover", () => $8b8adca400ca855b$export$2805e9aa6398e22d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaEmphasisDefault", () => $8b8adca400ca855b$export$e5398cdbb701916d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaEmphasisHover", () => $8b8adca400ca855b$export$407c0a3360630f07);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaEmphasisFocus", () => $8b8adca400ca855b$export$2cf287a22961d257);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaEmphasisSelectedDefault", () => $8b8adca400ca855b$export$8d86b0a298b93d0c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaEmphasisSelectedHover", () => $8b8adca400ca855b$export$98fe9911bf35517e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgInteractiveCtaDisabled", () => $8b8adca400ca855b$export$f0653913d522b4de);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgPageDefault", () => $8b8adca400ca855b$export$bdac8b134e31bde5);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBgPageNeutral", () => $8b8adca400ca855b$export$66bda635f6f13030);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconStaticSubtle", () => $8b8adca400ca855b$export$91cc85ef8f880fbf);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconStaticNeutral", () => $8b8adca400ca855b$export$2567089c08d07145);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconStaticEmphasis", () => $8b8adca400ca855b$export$7ddc7da8e4aedbc9);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconErrorSubtle", () => $8b8adca400ca855b$export$e9ea731e72b3c68);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconErrorNeutral", () => $8b8adca400ca855b$export$ac8e94ba2c43a286);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconErrorEmphasis", () => $8b8adca400ca855b$export$9b91ce4791dbfb9c);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconSuccessSubtle", () => $8b8adca400ca855b$export$3ff48969c4a6b385);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconSuccessNeutral", () => $8b8adca400ca855b$export$b65cebe70ae8272a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconSuccessEmphasis", () => $8b8adca400ca855b$export$fa75de9cd1d80d91);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconWarningSubtle", () => $8b8adca400ca855b$export$9abd6e64e952d3c8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconWarningNeutral", () => $8b8adca400ca855b$export$a805ba38d5e6f41d);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconWarningEmphasis", () => $8b8adca400ca855b$export$659615cdef30be80);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInfoSubtle", () => $8b8adca400ca855b$export$82ba5e115e27104);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInfoNeutral", () => $8b8adca400ca855b$export$e248e6c7086b9196);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInfoEmphasis", () => $8b8adca400ca855b$export$4aea909045a919f3);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentSubtleDefault", () => $8b8adca400ca855b$export$24e2c3b0b0b39b6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentSubtleHover", () => $8b8adca400ca855b$export$4cdd43377f390746);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentSubtleFocus", () => $8b8adca400ca855b$export$4c2aeb09e7af3558);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentSubtleSelectedDefault", () => $8b8adca400ca855b$export$6948447257b9a2fb);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentSubtleSelectedHover", () => $8b8adca400ca855b$export$1886d6bd011b2628);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentSubtleDisabled", () => $8b8adca400ca855b$export$6f0d3bd0748f7110);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentNeutralDefault", () => $8b8adca400ca855b$export$1cebc993b0830ad8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentNeutralHover", () => $8b8adca400ca855b$export$94bf08336f2aea93);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentNeutralFocus", () => $8b8adca400ca855b$export$60462e192e7be598);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentNeutralSelectedDefault", () => $8b8adca400ca855b$export$c283bf52b1187f2a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentNeutralSelectedHover", () => $8b8adca400ca855b$export$fa11560b88288866);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentNeutralDisabled", () => $8b8adca400ca855b$export$6fe67d097ba9b53b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentEmphasisDefault", () => $8b8adca400ca855b$export$9346c9eb56618801);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentEmphasisHover", () => $8b8adca400ca855b$export$20a88bf6f5ad424);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentEmphasisFocus", () => $8b8adca400ca855b$export$3e11f9ae2b7c8b4);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentEmphasisSelectedDefault", () => $8b8adca400ca855b$export$1d4bdb103b271652);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentEmphasisSelectedHover", () => $8b8adca400ca855b$export$16fad6bc38b83523);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveComponentEmphasisDisabled", () => $8b8adca400ca855b$export$6facfb5bbfcbbdc1);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaSubtleDefault", () => $8b8adca400ca855b$export$68a1dda24af60fe8);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaSubtleHover", () => $8b8adca400ca855b$export$9cda72453ce995fe);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaSubtleFocus", () => $8b8adca400ca855b$export$976fb57d95041b2e);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaNeutralDefault", () => $8b8adca400ca855b$export$1d80e0b4ec3cdc88);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaNeutralHover", () => $8b8adca400ca855b$export$a47e91d4907d671b);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaNeutralFocus", () => $8b8adca400ca855b$export$51dfe56e558b3410);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaEmphasisDefault", () => $8b8adca400ca855b$export$cc6aa53aa44c8b12);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaEmphasisHover", () => $8b8adca400ca855b$export$428c93d8ee6b3f23);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaEmphasisFocus", () => $8b8adca400ca855b$export$3b660da25a4df7dd);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIconInteractiveCtaDisabled", () => $8b8adca400ca855b$export$1019c561a0c3d652);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIllustrationGreen", () => $8b8adca400ca855b$export$393ed899af66269a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIllustrationBlue", () => $8b8adca400ca855b$export$2186267c9e4b9a19);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIllustrationGray", () => $8b8adca400ca855b$export$3c006b5b617326e6);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIllustrationDarkGray", () => $8b8adca400ca855b$export$17903f872c41d3f5);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIllustrationFushia", () => $8b8adca400ca855b$export$c8281b24d2fb2531);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorIllustrationOrange", () => $8b8adca400ca855b$export$f4c54cb551b3e31a);
$parcel$export($8b8adca400ca855b$exports, "aliasesColorBarracudaBlue", () => $8b8adca400ca855b$export$e95975a74000e17d);
$parcel$export($8b8adca400ca855b$exports, "aliasesLetterSpacingDefault", () => $8b8adca400ca855b$export$a6ed37d16e5c3592);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeMicro", () => $8b8adca400ca855b$export$da3bf13b0e78188e);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeLabel", () => $8b8adca400ca855b$export$93a0f9889d302d21);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeCaption", () => $8b8adca400ca855b$export$cd5e6a287e658e4b);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeDefault", () => $8b8adca400ca855b$export$694cbbfe937eb3b2);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeH1", () => $8b8adca400ca855b$export$249f366dc55631e7);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeH2", () => $8b8adca400ca855b$export$57fd85f0d54165d7);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeH3", () => $8b8adca400ca855b$export$17d746d2fa0f3e26);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeH4", () => $8b8adca400ca855b$export$6c499f1196becaca);
$parcel$export($8b8adca400ca855b$exports, "aliasesFontSizeDefaultSmall", () => $8b8adca400ca855b$export$45081f5919e907f9);
$parcel$export($8b8adca400ca855b$exports, "themes0Id", () => $8b8adca400ca855b$export$74a906d5f5dbcc07);
$parcel$export($8b8adca400ca855b$exports, "themes0Name", () => $8b8adca400ca855b$export$6012d36fd86dbaa1);
$parcel$export($8b8adca400ca855b$exports, "themes0SelectedTokenSetsGlobals", () => $8b8adca400ca855b$export$e24406150fd87290);
$parcel$export($8b8adca400ca855b$exports, "themes0SelectedTokenSetsAliases", () => $8b8adca400ca855b$export$83da2f3feb571776);
$parcel$export($8b8adca400ca855b$exports, "themes0SelectedTokenSetsComponentsButton", () => $8b8adca400ca855b$export$34e6b0c7073d1e27);
$parcel$export($8b8adca400ca855b$exports, "themes0Group", () => $8b8adca400ca855b$export$5b5ea24ad2da3b16);
$parcel$export($8b8adca400ca855b$exports, "themes1Id", () => $8b8adca400ca855b$export$bc9f2dd2aa337004);
$parcel$export($8b8adca400ca855b$exports, "themes1Name", () => $8b8adca400ca855b$export$a08a8107d9ea42d7);
$parcel$export($8b8adca400ca855b$exports, "themes1SelectedTokenSetsGlobals", () => $8b8adca400ca855b$export$3fddc94fd7344d3f);
$parcel$export($8b8adca400ca855b$exports, "themes1SelectedTokenSetsAliases", () => $8b8adca400ca855b$export$d54ad359440fed8a);
$parcel$export($8b8adca400ca855b$exports, "themes1SelectedTokenSetsVersionV1", () => $8b8adca400ca855b$export$7a5c093e8fbb816b);
$parcel$export($8b8adca400ca855b$exports, "themes1SelectedTokenSetsComponentsButton", () => $8b8adca400ca855b$export$ea9c28f9f25eee8d);
$parcel$export($8b8adca400ca855b$exports, "themes1Group", () => $8b8adca400ca855b$export$7a9d9e76d788a685);
$parcel$export($8b8adca400ca855b$exports, "metadataTokenSetOrder0", () => $8b8adca400ca855b$export$4caaeecf625325c);
$parcel$export($8b8adca400ca855b$exports, "metadataTokenSetOrder1", () => $8b8adca400ca855b$export$4db8b33a483c4b6a);
$parcel$export($8b8adca400ca855b$exports, "metadataTokenSetOrder2", () => $8b8adca400ca855b$export$517e517cddbb63e4);
$parcel$export($8b8adca400ca855b$exports, "metadataTokenSetOrder3", () => $8b8adca400ca855b$export$94e839db223f2b32);
$parcel$export($8b8adca400ca855b$exports, "avatarRadiusRound", () => $8b8adca400ca855b$export$45f9825089601438);
$parcel$export($8b8adca400ca855b$exports, "avatarSizeS", () => $8b8adca400ca855b$export$6ced2fe9225bb9aa);
$parcel$export($8b8adca400ca855b$exports, "avatarSizeM", () => $8b8adca400ca855b$export$ad9035b90a500e0c);
$parcel$export($8b8adca400ca855b$exports, "avatarSizeL", () => $8b8adca400ca855b$export$981c98b80c296cae);
$parcel$export($8b8adca400ca855b$exports, "avatarSizeXl", () => $8b8adca400ca855b$export$6a70aa95d5f9e97d);
$parcel$export($8b8adca400ca855b$exports, "avatarSizeXxl", () => $8b8adca400ca855b$export$77fc7cdd633e321a);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgStaticSubtle", () => $8b8adca400ca855b$export$1d1ba85af9737700);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgStaticNeutral", () => $8b8adca400ca855b$export$9fdcda1e888251ae);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgStaticEmphasis", () => $8b8adca400ca855b$export$6e683eae248849d0);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveSubtleDefault", () => $8b8adca400ca855b$export$10b711493a3d638d);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveSubtleHover", () => $8b8adca400ca855b$export$ec4efc0809296020);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveSubtleFocus", () => $8b8adca400ca855b$export$574ca15a0c69dfed);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$6711cc6f6a8d7622);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$ee901060a5d95972);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveNeutralDefault", () => $8b8adca400ca855b$export$2eec97a97f2e4a04);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveNeutralHover", () => $8b8adca400ca855b$export$6a4c73b3b1874b99);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveNeutralFocus", () => $8b8adca400ca855b$export$f99fb7f220239678);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$74c23d76a5361d79);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$39fbb811f7522b8b);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$acc506ad42389b36);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveEmphasisHover", () => $8b8adca400ca855b$export$3afd9cf193dbcb8a);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$56a3bdf7d0fec618);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$9fe0f766dfd77681);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$51dff143e21603dd);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBgInteractiveDisabled", () => $8b8adca400ca855b$export$b8cb6cd9a5387463);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextStaticSubtle", () => $8b8adca400ca855b$export$47e4978834ae40f7);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextStaticNeutral", () => $8b8adca400ca855b$export$a0e30118ba19fdb2);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextStaticEmphasis", () => $8b8adca400ca855b$export$2e98f00d0fa4bbb5);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextInteractiveSubtle", () => $8b8adca400ca855b$export$2b24a45f4e35892b);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextInteractiveNeutral", () => $8b8adca400ca855b$export$d948f9b072d01bf6);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextInteractiveEmphasis", () => $8b8adca400ca855b$export$fa82cf28ab34d28a);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextInteractiveDisabled", () => $8b8adca400ca855b$export$7b24fd576331fa4c);
$parcel$export($8b8adca400ca855b$exports, "avatarColorTextInteractiveSelected", () => $8b8adca400ca855b$export$4140cf203c357f02);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderStaticSubtle", () => $8b8adca400ca855b$export$35c34a4e0cfbe353);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderStaticNeutral", () => $8b8adca400ca855b$export$befa38c6db1cdb2d);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderStaticEmphasis", () => $8b8adca400ca855b$export$ac967ae90cf75bdb);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveSubtleDefault", () => $8b8adca400ca855b$export$ece26edc7f0c4ee3);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveSubtleHover", () => $8b8adca400ca855b$export$e06caac82792110c);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveSubtleFocus", () => $8b8adca400ca855b$export$874db53a16e8eca6);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$6996388cacfbc1c3);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$58bec168ef844174);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveNeutralDefault", () => $8b8adca400ca855b$export$d023e2e28c239369);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveNeutralHover", () => $8b8adca400ca855b$export$946657d96f7f365c);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveNeutralFocus", () => $8b8adca400ca855b$export$c56ab0b862450b50);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$b2a4c668920d7f26);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$bb6b9403ea569251);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$ef1d10df2c03313a);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveEmphasisHover", () => $8b8adca400ca855b$export$ef737f5bf427c63b);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$ae2775de35439b9a);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$fde44b974502cb1);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$654e39841159fe7e);
$parcel$export($8b8adca400ca855b$exports, "avatarColorBorderInteractiveDisabled", () => $8b8adca400ca855b$export$978e747ab676585c);
$parcel$export($8b8adca400ca855b$exports, "avatarBorderWidthDefault", () => $8b8adca400ca855b$export$2817c40e512049d4);
$parcel$export($8b8adca400ca855b$exports, "avatarFontFamily", () => $8b8adca400ca855b$export$8b50ef9dd01b2896);
$parcel$export($8b8adca400ca855b$exports, "avatarFontWeight", () => $8b8adca400ca855b$export$4ee7b06916c5d942);
$parcel$export($8b8adca400ca855b$exports, "avatarFontSizeS", () => $8b8adca400ca855b$export$add9cf0f5be45bb8);
$parcel$export($8b8adca400ca855b$exports, "avatarFontSizeM", () => $8b8adca400ca855b$export$c13fb80f73bb5bf5);
$parcel$export($8b8adca400ca855b$exports, "avatarFontSizeL", () => $8b8adca400ca855b$export$36412f0eae9884ab);
$parcel$export($8b8adca400ca855b$exports, "avatarFontSizeXl", () => $8b8adca400ca855b$export$9cb266ece8c6e780);
$parcel$export($8b8adca400ca855b$exports, "avatarFontSizeXxl", () => $8b8adca400ca855b$export$602010da7f82ff85);
$parcel$export($8b8adca400ca855b$exports, "avatarLetterSpacing", () => $8b8adca400ca855b$export$72007b6cbdda6c3a);
$parcel$export($8b8adca400ca855b$exports, "avatarTextCase", () => $8b8adca400ca855b$export$23b25f54fea3af4);
$parcel$export($8b8adca400ca855b$exports, "avatarLineHeightXxl", () => $8b8adca400ca855b$export$b525723c9c0fd3c2);
$parcel$export($8b8adca400ca855b$exports, "avatarLineHeightXl", () => $8b8adca400ca855b$export$a18ab4cbed1e3c31);
$parcel$export($8b8adca400ca855b$exports, "avatarLineHeightL", () => $8b8adca400ca855b$export$5e96e02743466c31);
$parcel$export($8b8adca400ca855b$exports, "avatarLineHeightM", () => $8b8adca400ca855b$export$7f7949c1794c1d34);
$parcel$export($8b8adca400ca855b$exports, "avatarLineHeightS", () => $8b8adca400ca855b$export$4f23447d88eaec3f);
$parcel$export($8b8adca400ca855b$exports, "avatarTextDecoration", () => $8b8adca400ca855b$export$cd07715ef04b96c9);
$parcel$export($8b8adca400ca855b$exports, "buttonBorderWidth", () => $8b8adca400ca855b$export$83047dd36262cb15);
$parcel$export($8b8adca400ca855b$exports, "buttonPadding", () => $8b8adca400ca855b$export$767b378a40c983d0);
$parcel$export($8b8adca400ca855b$exports, "buttonSpaceBetween", () => $8b8adca400ca855b$export$1ff376c9f129fe57);
$parcel$export($8b8adca400ca855b$exports, "buttonRadius", () => $8b8adca400ca855b$export$30a853f502f9e2c7);
$parcel$export($8b8adca400ca855b$exports, "buttonHeightDefault", () => $8b8adca400ca855b$export$b67be69c900ea369);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgActionBarDefault", () => $8b8adca400ca855b$export$f587156ff808181d);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgActionBarHover", () => $8b8adca400ca855b$export$fd9d81e02468cf0c);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgActionBarFocus", () => $8b8adca400ca855b$export$8684d5dfbbea5f2b);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgSubtleDefault", () => $8b8adca400ca855b$export$be8971e457224a5a);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgSubtleHover", () => $8b8adca400ca855b$export$8f6cc8879d3d37c4);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgSubtleFocus", () => $8b8adca400ca855b$export$e448803c843846e5);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgSubtleSelectedDefault", () => $8b8adca400ca855b$export$897cdcc0c18bc5db);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgSubtleSelectedHover", () => $8b8adca400ca855b$export$e06d5ee5e53edb47);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgNeutralDefault", () => $8b8adca400ca855b$export$699fab328727c6b6);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgNeutralHover", () => $8b8adca400ca855b$export$3c0ad4fb3a1b0ffb);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgNeutralFocus", () => $8b8adca400ca855b$export$5966559b892ee111);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgNeutralSelectedDefault", () => $8b8adca400ca855b$export$1b08e227e9d667a9);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgNeutralSelectedHover", () => $8b8adca400ca855b$export$7179773622cad25f);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgEmphasisDefault", () => $8b8adca400ca855b$export$bdf7ce7eb3df6341);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgEmphasisHover", () => $8b8adca400ca855b$export$5b8cb27bcb201dc4);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgEmphasisFocus", () => $8b8adca400ca855b$export$3f3dc155ded54e45);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgEmphasisSelectedDefault", () => $8b8adca400ca855b$export$ba27deb6cad88273);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgEmphasisSelectedHover", () => $8b8adca400ca855b$export$456505b8367dc33a);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBgDisabled", () => $8b8adca400ca855b$export$eedcb4b10d336c0);
$parcel$export($8b8adca400ca855b$exports, "buttonColorTextActionBar", () => $8b8adca400ca855b$export$ff1075fa496d325b);
$parcel$export($8b8adca400ca855b$exports, "buttonColorTextSubtle", () => $8b8adca400ca855b$export$a7456311bf695db4);
$parcel$export($8b8adca400ca855b$exports, "buttonColorTextNeutral", () => $8b8adca400ca855b$export$cd05d22763540ee7);
$parcel$export($8b8adca400ca855b$exports, "buttonColorTextEmphasis", () => $8b8adca400ca855b$export$a8af6e0b3bb0ceab);
$parcel$export($8b8adca400ca855b$exports, "buttonColorTextDisabled", () => $8b8adca400ca855b$export$ea642331f78f7724);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderActionBarDefault", () => $8b8adca400ca855b$export$7c9eeddcc0155611);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderActionBarHover", () => $8b8adca400ca855b$export$70b98ceba2109d6f);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderActionBarFocus", () => $8b8adca400ca855b$export$32adc8c8c23f8278);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderSubtleDefault", () => $8b8adca400ca855b$export$53894d17111f8e4e);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderSubtleHover", () => $8b8adca400ca855b$export$5bee99e492dce333);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderSubtleFocus", () => $8b8adca400ca855b$export$4552f038cdc313b1);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderSubtleSelectedDefault", () => $8b8adca400ca855b$export$cbf4404a4e15c5e7);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderSubtleSelectedHover", () => $8b8adca400ca855b$export$23117a1b4fa2ee4a);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderNeutralDefault", () => $8b8adca400ca855b$export$6df9b51adfe2c892);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderNeutralHover", () => $8b8adca400ca855b$export$5c93c9fbb78bb2c1);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderNeutralFocus", () => $8b8adca400ca855b$export$e1ce320d9ab1c61);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderNeutralSelectedDefault", () => $8b8adca400ca855b$export$7940fcec187cb2bd);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderNeutralSelectedHover", () => $8b8adca400ca855b$export$d8345d4ed478774c);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderEmphasisDefault", () => $8b8adca400ca855b$export$68249f79b2b24f73);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderEmphasisHover", () => $8b8adca400ca855b$export$9ead9293289737ba);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderEmphasisFocus", () => $8b8adca400ca855b$export$95454f0202b5bb8a);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderEmphasisSelectedDefault", () => $8b8adca400ca855b$export$6f2a28348f849e77);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderEmphasisSelectedHover", () => $8b8adca400ca855b$export$9cc1a66c6e1f0d4d);
$parcel$export($8b8adca400ca855b$exports, "buttonColorBorderDisabled", () => $8b8adca400ca855b$export$3175a605e0140911);
$parcel$export($8b8adca400ca855b$exports, "buttonSplitWidth", () => $8b8adca400ca855b$export$ab123ccff6e55a0b);
$parcel$export($8b8adca400ca855b$exports, "buttonFontFamily", () => $8b8adca400ca855b$export$76ef6df3b64524e8);
$parcel$export($8b8adca400ca855b$exports, "buttonFontWeight", () => $8b8adca400ca855b$export$eb9380587111f46e);
$parcel$export($8b8adca400ca855b$exports, "buttonLineHeight", () => $8b8adca400ca855b$export$ca8181fe2475a0ce);
$parcel$export($8b8adca400ca855b$exports, "buttonFontSize", () => $8b8adca400ca855b$export$b37e6f1e35b3e7ab);
$parcel$export($8b8adca400ca855b$exports, "buttonLetterSpacing", () => $8b8adca400ca855b$export$8adee4da5958a9ec);
$parcel$export($8b8adca400ca855b$exports, "iconButtonBorderWidth", () => $8b8adca400ca855b$export$b0a94bcb8b47f8b5);
$parcel$export($8b8adca400ca855b$exports, "iconButtonSizeRoundM", () => $8b8adca400ca855b$export$e4b49656504a3957);
$parcel$export($8b8adca400ca855b$exports, "iconButtonSizeRoundInput", () => $8b8adca400ca855b$export$fe4627f581df3f54);
$parcel$export($8b8adca400ca855b$exports, "iconButtonSizeRectangleDefaultWidth", () => $8b8adca400ca855b$export$9b864bc8d5db3c7a);
$parcel$export($8b8adca400ca855b$exports, "iconButtonSizeRectangleDefaultHeight", () => $8b8adca400ca855b$export$3829a6ec50c0f791);
$parcel$export($8b8adca400ca855b$exports, "iconButtonRadiusRound", () => $8b8adca400ca855b$export$f4dfab5fdc242b93);
$parcel$export($8b8adca400ca855b$exports, "iconButtonRadiusRectangle", () => $8b8adca400ca855b$export$56f84bc94a249aaf);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBgSubtleDefault", () => $8b8adca400ca855b$export$b2a7f6dedbe8d4ae);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBgSubtleHover", () => $8b8adca400ca855b$export$7f5bb126a7ea906a);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBgSubtleFocus", () => $8b8adca400ca855b$export$e58f39eec65e0b76);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBgSubtleSelectedDefault", () => $8b8adca400ca855b$export$20360ceefb533fb);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBgSubtleSelectedHover", () => $8b8adca400ca855b$export$ea569fd99f87a06a);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBgSubtleMenuOpen", () => $8b8adca400ca855b$export$1c5e5838d4e8eebe);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBgDisabled", () => $8b8adca400ca855b$export$e79da0208dc75992);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBorderSubtleDefault", () => $8b8adca400ca855b$export$5ab048a991219b8c);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBorderSubtleHover", () => $8b8adca400ca855b$export$e5c0a5d226b4ee63);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBorderSubtleFocus", () => $8b8adca400ca855b$export$b06fab23153184d6);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBorderSubtleSelectedDefault", () => $8b8adca400ca855b$export$71ddb8bc4376788d);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBorderSubtleSelectedHover", () => $8b8adca400ca855b$export$67f367c1dfd5d3b7);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBorderSubtleMenuOpen", () => $8b8adca400ca855b$export$8d6c6c1bd7814c60);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorBorderDisabled", () => $8b8adca400ca855b$export$f67dcf708fbd73bc);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorTextDefault", () => $8b8adca400ca855b$export$a805ee3abb44f47b);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorTextSelected", () => $8b8adca400ca855b$export$7eb6272929988e2e);
$parcel$export($8b8adca400ca855b$exports, "iconButtonColorTextDisabled", () => $8b8adca400ca855b$export$4b09028d2528773c);
$parcel$export($8b8adca400ca855b$exports, "iconButtonSpaceBetween", () => $8b8adca400ca855b$export$db838e84dd688c76);
$parcel$export($8b8adca400ca855b$exports, "tooltipBorderWidth", () => $8b8adca400ca855b$export$ae915504e2a18be8);
$parcel$export($8b8adca400ca855b$exports, "tooltipRadius", () => $8b8adca400ca855b$export$a65645ba055136c8);
$parcel$export($8b8adca400ca855b$exports, "tooltipColorBg", () => $8b8adca400ca855b$export$838104e21ca5a19d);
$parcel$export($8b8adca400ca855b$exports, "tooltipColorBorder", () => $8b8adca400ca855b$export$4bb2a4cc71915256);
$parcel$export($8b8adca400ca855b$exports, "tooltipColorText", () => $8b8adca400ca855b$export$b2e919a6cbfe006e);
$parcel$export($8b8adca400ca855b$exports, "tooltipFontFamily", () => $8b8adca400ca855b$export$6e404c3c9be4c803);
$parcel$export($8b8adca400ca855b$exports, "tooltipFontWeight", () => $8b8adca400ca855b$export$341f3e22d85f986b);
$parcel$export($8b8adca400ca855b$exports, "tooltipLineHeight", () => $8b8adca400ca855b$export$9d1c9df76b2ad44b);
$parcel$export($8b8adca400ca855b$exports, "tooltipFontSize", () => $8b8adca400ca855b$export$ef0c0a0e1df557cc);
$parcel$export($8b8adca400ca855b$exports, "tooltipLetterSpacing", () => $8b8adca400ca855b$export$9d6da21b7f25ba42);
$parcel$export($8b8adca400ca855b$exports, "tooltipPadding", () => $8b8adca400ca855b$export$586ef59e988cd548);
$parcel$export($8b8adca400ca855b$exports, "chipRadiusRound", () => $8b8adca400ca855b$export$e4bf6f69d8b12729);
$parcel$export($8b8adca400ca855b$exports, "chipBorderWidth", () => $8b8adca400ca855b$export$91a69802d20d599b);
$parcel$export($8b8adca400ca855b$exports, "chipSizeMediumHeight", () => $8b8adca400ca855b$export$ad14861617df4437);
$parcel$export($8b8adca400ca855b$exports, "chipSizeMediumPaddingRight", () => $8b8adca400ca855b$export$c414cba53d02ca20);
$parcel$export($8b8adca400ca855b$exports, "chipSizeMediumPaddingLeft", () => $8b8adca400ca855b$export$947eaeddfab43373);
$parcel$export($8b8adca400ca855b$exports, "chipSizeMediumSpaceBetween", () => $8b8adca400ca855b$export$9588b2e0bbc9d556);
$parcel$export($8b8adca400ca855b$exports, "chipSizeLargeHeight", () => $8b8adca400ca855b$export$fed9a8adb39d758b);
$parcel$export($8b8adca400ca855b$exports, "chipSizeLargePaddingRight", () => $8b8adca400ca855b$export$c0f556b14789c4e6);
$parcel$export($8b8adca400ca855b$exports, "chipSizeLargePaddingLeft", () => $8b8adca400ca855b$export$d1639dad04ad0547);
$parcel$export($8b8adca400ca855b$exports, "chipSizeLargeSpaceBetween", () => $8b8adca400ca855b$export$baed45022e2a7982);
$parcel$export($8b8adca400ca855b$exports, "chipSizeInputHeight", () => $8b8adca400ca855b$export$4b76f39175f0013d);
$parcel$export($8b8adca400ca855b$exports, "chipSizeInputPaddingRight", () => $8b8adca400ca855b$export$628b4df0a363bf4d);
$parcel$export($8b8adca400ca855b$exports, "chipSizeInputPaddingLeft", () => $8b8adca400ca855b$export$2a0954c14d67929d);
$parcel$export($8b8adca400ca855b$exports, "chipSizeInputSpaceBetween", () => $8b8adca400ca855b$export$5d1500b4a57cc110);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticSubtle", () => $8b8adca400ca855b$export$78bb03c5be80436c);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticNeutralDefault", () => $8b8adca400ca855b$export$54f70ca93c994d78);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticNeutralSuccess", () => $8b8adca400ca855b$export$e3dd8acf7e47031b);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticNeutralError", () => $8b8adca400ca855b$export$e43bff698a8dfbad);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticNeutralWarning", () => $8b8adca400ca855b$export$6bcfcd9223df7e6);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticNeutralInfo", () => $8b8adca400ca855b$export$aaaa141d9a4271b6);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticEmphasisDefault", () => $8b8adca400ca855b$export$4550c5abe1916743);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticEmphasisSuccess", () => $8b8adca400ca855b$export$33de5d52a40c74bb);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticEmphasisError", () => $8b8adca400ca855b$export$c0ad38910caef39d);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticEmphasisWarning", () => $8b8adca400ca855b$export$18afb996161fdda8);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgStaticEmphasisInfo", () => $8b8adca400ca855b$export$58d9b7589ec1b854);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveSubtleDefault", () => $8b8adca400ca855b$export$19919b03e06ddb93);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveSubtleHover", () => $8b8adca400ca855b$export$67b5c40e6559a7fa);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveSubtleFocus", () => $8b8adca400ca855b$export$12e1be37fde3ea72);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$db84367af70c1ff1);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$37249a3917b3b82f);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveNeutralDefault", () => $8b8adca400ca855b$export$79a5f596c2b0cc25);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveNeutralHover", () => $8b8adca400ca855b$export$6e18cdfeccbbdb23);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveNeutralFocus", () => $8b8adca400ca855b$export$a3551c8ced99a9a);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$79335b67bc26b821);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$3c8142e1e0fc9733);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$10b174a9def6dceb);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveEmphasisHover", () => $8b8adca400ca855b$export$7a2ceca8767416a5);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$56db8ce29b377bf2);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$6a6a3e2cab1bed3b);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$f8d99fb64297e05a);
$parcel$export($8b8adca400ca855b$exports, "chipColorBgInteractiveDisabled", () => $8b8adca400ca855b$export$cbeaf87373b45488);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextErrorSubtle", () => $8b8adca400ca855b$export$a676f817d02f5209);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextStaticSubtle", () => $8b8adca400ca855b$export$82be0988c2118f7e);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextStaticEmphasis", () => $8b8adca400ca855b$export$d6f0695b99884305);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextStaticNeutral", () => $8b8adca400ca855b$export$407dd87d92a51f47);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextInteractiveNeutral", () => $8b8adca400ca855b$export$57b0941f92173029);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextInteractiveSubtle", () => $8b8adca400ca855b$export$e93aa21fc073fa41);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextInteractiveEmphasis", () => $8b8adca400ca855b$export$7ea48ba511b9e63e);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextInteractiveSelected", () => $8b8adca400ca855b$export$43c8f926529b7e18);
$parcel$export($8b8adca400ca855b$exports, "chipColorTextDisabled", () => $8b8adca400ca855b$export$ca3865d8ffc5952f);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticSubtle", () => $8b8adca400ca855b$export$90683711fb4bef81);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticNeutralDefault", () => $8b8adca400ca855b$export$752f6974143a52ba);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticNeutralError", () => $8b8adca400ca855b$export$5008f618d8345a67);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticNeutralSuccess", () => $8b8adca400ca855b$export$44eb3b115a64f132);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticNeutralWarning", () => $8b8adca400ca855b$export$de064229fcb5defa);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticNeutralInfo", () => $8b8adca400ca855b$export$b0165922ab633327);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticEmphasisDefault", () => $8b8adca400ca855b$export$6f0b9975e44923c9);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticEmphasisSuccess", () => $8b8adca400ca855b$export$fc194a85a504f3c9);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticEmphasisWarning", () => $8b8adca400ca855b$export$da7c568ac2dab421);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticEmphasisError", () => $8b8adca400ca855b$export$f735272da4d7b070);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderStaticEmphasisInfo", () => $8b8adca400ca855b$export$e41bcc6142854978);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveNeutralDefault", () => $8b8adca400ca855b$export$2d6f5cbe33ffecaa);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveNeutralHover", () => $8b8adca400ca855b$export$4e936d55cc199959);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveNeutralFocus", () => $8b8adca400ca855b$export$e196f4e78e8dece6);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$d08dd2b917bbdcbe);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$700910abe8bd67bb);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveSubtleDefault", () => $8b8adca400ca855b$export$c3d0d12d7d167459);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveSubtleHover", () => $8b8adca400ca855b$export$cc599fb1e3e3300c);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveSubtleFocus", () => $8b8adca400ca855b$export$cb2419b9c16cfcdd);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$1128c8056cd9276b);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$915246f5d427a346);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$1dd7d7f143fff99a);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveEmphasisHover", () => $8b8adca400ca855b$export$91fc644371eb38f5);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$ec43172cc32e77e3);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$4600880359d615e1);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$51555e4eb1ceea4c);
$parcel$export($8b8adca400ca855b$exports, "chipColorBorderInteractiveDisabled", () => $8b8adca400ca855b$export$fc107430d597706f);
$parcel$export($8b8adca400ca855b$exports, "chipFontFamily", () => $8b8adca400ca855b$export$7d16c5378b89bd5);
$parcel$export($8b8adca400ca855b$exports, "chipFontWeight", () => $8b8adca400ca855b$export$998d3c1f7e81e9eb);
$parcel$export($8b8adca400ca855b$exports, "chipMFontSize", () => $8b8adca400ca855b$export$ed23011c0d9d2446);
$parcel$export($8b8adca400ca855b$exports, "chipLFontSize", () => $8b8adca400ca855b$export$f8867386b651d9da);
$parcel$export($8b8adca400ca855b$exports, "chipInputFontSize", () => $8b8adca400ca855b$export$1bf4e0bbd42ea607);
$parcel$export($8b8adca400ca855b$exports, "chipLetterSpacing", () => $8b8adca400ca855b$export$9c459b111fa4f4f3);
$parcel$export($8b8adca400ca855b$exports, "chipLineHeightL", () => $8b8adca400ca855b$export$3f6b29d164f2bd31);
$parcel$export($8b8adca400ca855b$exports, "chipLineHeightM", () => $8b8adca400ca855b$export$e467a06f8f022248);
$parcel$export($8b8adca400ca855b$exports, "chipLineHeightInput", () => $8b8adca400ca855b$export$8725bf5ac2c380cf);
$parcel$export($8b8adca400ca855b$exports, "iconSizeMicro", () => $8b8adca400ca855b$export$6a595734c76fe30);
$parcel$export($8b8adca400ca855b$exports, "iconSizeXxs", () => $8b8adca400ca855b$export$457c2d7fb8320c77);
$parcel$export($8b8adca400ca855b$exports, "iconSizeXs", () => $8b8adca400ca855b$export$1a2e1724738a4f36);
$parcel$export($8b8adca400ca855b$exports, "iconSizeS", () => $8b8adca400ca855b$export$8fc672cb7298d1de);
$parcel$export($8b8adca400ca855b$exports, "iconSizeM", () => $8b8adca400ca855b$export$f4d657e58ef789df);
$parcel$export($8b8adca400ca855b$exports, "iconSizeL", () => $8b8adca400ca855b$export$1a9af4c2a2e53ffe);
$parcel$export($8b8adca400ca855b$exports, "iconSizeXl", () => $8b8adca400ca855b$export$d7333ebbf97043c);
$parcel$export($8b8adca400ca855b$exports, "iconSizeXxl", () => $8b8adca400ca855b$export$35bc30912bd412e5);
$parcel$export($8b8adca400ca855b$exports, "iconSizeTappable", () => $8b8adca400ca855b$export$8527b31e4906a715);
$parcel$export($8b8adca400ca855b$exports, "iconColorStaticSubtle", () => $8b8adca400ca855b$export$5a2fe487d6396502);
$parcel$export($8b8adca400ca855b$exports, "iconColorStaticNeutral", () => $8b8adca400ca855b$export$46347942d17069d5);
$parcel$export($8b8adca400ca855b$exports, "iconColorStaticEmphasis", () => $8b8adca400ca855b$export$aba2ba25c52e742d);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveCtaSubtleDefault", () => $8b8adca400ca855b$export$4f9e8b52864daf82);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveCtaNeutralDefault", () => $8b8adca400ca855b$export$3998bea291218554);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveCtaEmphasisDefault", () => $8b8adca400ca855b$export$bddeb9cc658ce838);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveCtaDisabled", () => $8b8adca400ca855b$export$3fbef91c81a27ff7);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentSubtleDefault", () => $8b8adca400ca855b$export$be8504476447899);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentSubtleHover", () => $8b8adca400ca855b$export$aa7b4d33dda1ff3e);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentSubtleFocus", () => $8b8adca400ca855b$export$1eccb6bf1b45adc0);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentSubtleSelectedDefault", () => $8b8adca400ca855b$export$f5f294c76327e31);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentSubtleSelectedHover", () => $8b8adca400ca855b$export$e087e8a19001f08f);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentSubtleDisabled", () => $8b8adca400ca855b$export$5932a3fffc13208b);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentNeutralDefault", () => $8b8adca400ca855b$export$bb4efa5fbc7bc49f);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentNeutralHover", () => $8b8adca400ca855b$export$2598a87ffab12199);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentNeutralFocus", () => $8b8adca400ca855b$export$a81df3089c6d474c);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentNeutralSelectedDefault", () => $8b8adca400ca855b$export$3a79d547ba3a5d26);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentNeutralSelectedHover", () => $8b8adca400ca855b$export$85ccc16cee46224);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentNeutralDisabled", () => $8b8adca400ca855b$export$df7d2e4081bbb5d1);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentEmphasisDefault", () => $8b8adca400ca855b$export$2d15d1c7fbd172c);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentEmphasisHover", () => $8b8adca400ca855b$export$14cb47ca5f5d1cd6);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentEmphasisFocus", () => $8b8adca400ca855b$export$16da9ff5861987a7);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentEmphasisSelectedDefault", () => $8b8adca400ca855b$export$419eac1adb13f9fc);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentEmphasisSelectedHover", () => $8b8adca400ca855b$export$e2681ddb55045e4c);
$parcel$export($8b8adca400ca855b$exports, "iconColorInteractiveComponentEmphasisDisabled", () => $8b8adca400ca855b$export$5feebe6dca4c6e2f);
$parcel$export($8b8adca400ca855b$exports, "iconColorErrorNeutral", () => $8b8adca400ca855b$export$18df805cce67e76e);
$parcel$export($8b8adca400ca855b$exports, "iconColorErrorSubtle", () => $8b8adca400ca855b$export$384dc265e7feea50);
$parcel$export($8b8adca400ca855b$exports, "iconColorWarningNeutral", () => $8b8adca400ca855b$export$5168884c17b5fa13);
$parcel$export($8b8adca400ca855b$exports, "iconColorWarningSubtle", () => $8b8adca400ca855b$export$1e76832163599c23);
$parcel$export($8b8adca400ca855b$exports, "iconColorSuccessNeutral", () => $8b8adca400ca855b$export$165790c96dfe23b);
$parcel$export($8b8adca400ca855b$exports, "iconColorSuccessSubtle", () => $8b8adca400ca855b$export$2d719fd496813158);
$parcel$export($8b8adca400ca855b$exports, "iconColorInfoNeutral", () => $8b8adca400ca855b$export$83b4faef127cb7b7);
$parcel$export($8b8adca400ca855b$exports, "iconColorInfoSubtle", () => $8b8adca400ca855b$export$54d62555f8f353f9);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeMediumRadiusRound", () => $8b8adca400ca855b$export$f780a2ef2c45e34d);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeMediumBorderWidth", () => $8b8adca400ca855b$export$cb5734e2315e2efe);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeMediumMinHeight", () => $8b8adca400ca855b$export$995f211f28f1437);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeMediumPaddingRight", () => $8b8adca400ca855b$export$db164abfd7645c18);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeMediumPaddingLeft", () => $8b8adca400ca855b$export$e5da4b0c5e56db5d);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeSmallRadiusRound", () => $8b8adca400ca855b$export$dad9521985b6131b);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeSmallMinHeight", () => $8b8adca400ca855b$export$2f90d06b52e9497);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeSmallPaddingRight", () => $8b8adca400ca855b$export$253d8914fa26df10);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeSmallPaddingLeft", () => $8b8adca400ca855b$export$d6f8ff389cb04136);
$parcel$export($8b8adca400ca855b$exports, "badgeSizeInputMinHeight", () => $8b8adca400ca855b$export$5e2bf4249906aa9c);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgErrorSubtle", () => $8b8adca400ca855b$export$c1c2909bedb0a7dd);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgStaticSubtle", () => $8b8adca400ca855b$export$63d9ba7538e73dff);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgStaticNeutral", () => $8b8adca400ca855b$export$f67d4fb49acb1f89);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgStaticEmphasis", () => $8b8adca400ca855b$export$2fe4aa9229f13169);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveSubtleDefault", () => $8b8adca400ca855b$export$c692e870557d1485);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveSubtleHover", () => $8b8adca400ca855b$export$54b6b20194425cd6);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveSubtleFocus", () => $8b8adca400ca855b$export$be70cab265492c56);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$784e486f16c66f2d);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$6da19c50ace6d610);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveSubtleDisabled", () => $8b8adca400ca855b$export$4d1a2e4dfe067853);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveNeutralDefault", () => $8b8adca400ca855b$export$987b3d1dafde78df);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveNeutralHover", () => $8b8adca400ca855b$export$e836365f68f36c1d);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveNeutralFocus", () => $8b8adca400ca855b$export$23a0fd118827e1dc);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$9919355b48dcc96d);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$e3c46fa14b4ebd10);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveNeutralDisabled", () => $8b8adca400ca855b$export$9bcfcb94d6adb5eb);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$4c138a91262deb86);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveEmphasisHover", () => $8b8adca400ca855b$export$1e05bfb99ce0bab0);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$440246e634610acd);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$463c36ef5e33cde);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$673c5cc0104c050);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBgInteractiveEmphasisDisabled", () => $8b8adca400ca855b$export$d5b20e83a050689e);
$parcel$export($8b8adca400ca855b$exports, "badgeColorTextErrorSubtle", () => $8b8adca400ca855b$export$b329ef8c78e58195);
$parcel$export($8b8adca400ca855b$exports, "badgeColorTextStaticSubtle", () => $8b8adca400ca855b$export$c74b59fc0c00f12f);
$parcel$export($8b8adca400ca855b$exports, "badgeColorTextStaticEmphasis", () => $8b8adca400ca855b$export$b3d105834921abae);
$parcel$export($8b8adca400ca855b$exports, "badgeColorTextInteractiveSubtle", () => $8b8adca400ca855b$export$41a0ad556cd1f41e);
$parcel$export($8b8adca400ca855b$exports, "badgeColorTextInteractiveNeutral", () => $8b8adca400ca855b$export$4749334586e6fad3);
$parcel$export($8b8adca400ca855b$exports, "badgeColorTextInteractiveEmphasis", () => $8b8adca400ca855b$export$a22d0c3e2f60d443);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderErrorSubtle", () => $8b8adca400ca855b$export$7c9f7df759bd38d1);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderStaticSubtle", () => $8b8adca400ca855b$export$d02c01c4b3e77354);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderStaticNeutral", () => $8b8adca400ca855b$export$a9af785ad1437427);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderStaticEmphasis", () => $8b8adca400ca855b$export$9b017cc64a769252);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveSubtleDefault", () => $8b8adca400ca855b$export$ef7785f455f0ff57);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveSubtleHover", () => $8b8adca400ca855b$export$6037c748dfa10ac2);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveSubtleFocus", () => $8b8adca400ca855b$export$e3ebbb1347a60e9d);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$4af2ae34cb51f1d8);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$9105c0035b3c9dbc);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveSubtleDisabled", () => $8b8adca400ca855b$export$ccf0d988c28f4ac3);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveNeutralDefault", () => $8b8adca400ca855b$export$a152e09ad4cfa768);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveNeutralHover", () => $8b8adca400ca855b$export$c026cdd1f9d9818);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveNeutralFocus", () => $8b8adca400ca855b$export$1e6ceb099a6c182d);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$a31e532571133db1);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$b50e97467970464c);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveNeutralDisabled", () => $8b8adca400ca855b$export$dc0f61867c8eb438);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$9ca8e072a61adfe6);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveEmphasisHover", () => $8b8adca400ca855b$export$b486bbf27048fca6);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$d266a9d896cbc7e5);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$f3894963a227c2d1);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$e879afede95344e2);
$parcel$export($8b8adca400ca855b$exports, "badgeColorBorderInteractiveEmphasisDisabled", () => $8b8adca400ca855b$export$64e44e4f458bdd15);
$parcel$export($8b8adca400ca855b$exports, "badgeFontFamily", () => $8b8adca400ca855b$export$a62f741044aa85bb);
$parcel$export($8b8adca400ca855b$exports, "badgeFontWeight", () => $8b8adca400ca855b$export$d411dbbc5db0f8e5);
$parcel$export($8b8adca400ca855b$exports, "badgeMLineHeight", () => $8b8adca400ca855b$export$379000749f6ebe9d);
$parcel$export($8b8adca400ca855b$exports, "badgeMFontSize", () => $8b8adca400ca855b$export$ac903168df7d1c8c);
$parcel$export($8b8adca400ca855b$exports, "badgeSFontSize", () => $8b8adca400ca855b$export$4ae3397bafb779ba);
$parcel$export($8b8adca400ca855b$exports, "badgeSLineHeight", () => $8b8adca400ca855b$export$31a061c5e74d37df);
$parcel$export($8b8adca400ca855b$exports, "badgeLetterSpacing", () => $8b8adca400ca855b$export$3f73af3bf1f38889);
$parcel$export($8b8adca400ca855b$exports, "badgeInputLineHeight", () => $8b8adca400ca855b$export$655d640242b74977);
$parcel$export($8b8adca400ca855b$exports, "badgeInputFontSize", () => $8b8adca400ca855b$export$228d1ca9c77817dd);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgHeaderDefault", () => $8b8adca400ca855b$export$4d3f5ae03ef63815);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgHeaderSorted", () => $8b8adca400ca855b$export$4f5fa3d302b4eb89);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgHeaderHover", () => $8b8adca400ca855b$export$3aa8eef02f53a11f);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgHeaderError", () => $8b8adca400ca855b$export$9cee6c095c5d53f);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgHeaderSelected", () => $8b8adca400ca855b$export$46616e63025810c3);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgRegularDefault", () => $8b8adca400ca855b$export$2eb243147337e0e9);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgRegularSorted", () => $8b8adca400ca855b$export$ef30719fb3a37b5c);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgRegularHover", () => $8b8adca400ca855b$export$18dec71efe39c363);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgRegularError", () => $8b8adca400ca855b$export$1983392f49eb3b77);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgRegularSelected", () => $8b8adca400ca855b$export$f069eb93d208df24);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBgGrouped", () => $8b8adca400ca855b$export$eb1bb4481b303f23);
$parcel$export($8b8adca400ca855b$exports, "tableCellColorBorder", () => $8b8adca400ca855b$export$2054ca69e320709f);
$parcel$export($8b8adca400ca855b$exports, "tableCellBorderWidthBottom", () => $8b8adca400ca855b$export$71d1df7ff8827dd3);
$parcel$export($8b8adca400ca855b$exports, "tableCellDense", () => $8b8adca400ca855b$export$6d220a723977f960);
$parcel$export($8b8adca400ca855b$exports, "tableCellDefault", () => $8b8adca400ca855b$export$2c16a3f0e6b48836);
$parcel$export($8b8adca400ca855b$exports, "tableCellSpacious", () => $8b8adca400ca855b$export$58ecf9341fd2c423);
$parcel$export($8b8adca400ca855b$exports, "linkColorBgDefault", () => $8b8adca400ca855b$export$63860ae533ec763);
$parcel$export($8b8adca400ca855b$exports, "linkColorBgHover", () => $8b8adca400ca855b$export$8cd575c98ef7c7e3);
$parcel$export($8b8adca400ca855b$exports, "linkColorBgFocus", () => $8b8adca400ca855b$export$23b1fadb952026bb);
$parcel$export($8b8adca400ca855b$exports, "linkColorBgDisabled", () => $8b8adca400ca855b$export$6dc4bfc245f9c03f);
$parcel$export($8b8adca400ca855b$exports, "linkColorTextDefault", () => $8b8adca400ca855b$export$407ca803dcba1686);
$parcel$export($8b8adca400ca855b$exports, "linkColorTextHover", () => $8b8adca400ca855b$export$db0f7f411822f8f9);
$parcel$export($8b8adca400ca855b$exports, "linkColorTextFocus", () => $8b8adca400ca855b$export$333ac82fea827fd7);
$parcel$export($8b8adca400ca855b$exports, "linkColorTextDisabled", () => $8b8adca400ca855b$export$2a45d93c2e2c57d7);
$parcel$export($8b8adca400ca855b$exports, "linkColorTextVisited", () => $8b8adca400ca855b$export$307543bd31288d3a);
$parcel$export($8b8adca400ca855b$exports, "linkFontFamily", () => $8b8adca400ca855b$export$583bfe75ad3be530);
$parcel$export($8b8adca400ca855b$exports, "linkFontWeight", () => $8b8adca400ca855b$export$bd18f91ff949705a);
$parcel$export($8b8adca400ca855b$exports, "linkLetterSpacing", () => $8b8adca400ca855b$export$f0729e79e516d76f);
$parcel$export($8b8adca400ca855b$exports, "linkLineHeightDefault", () => $8b8adca400ca855b$export$a3037016530afa41);
$parcel$export($8b8adca400ca855b$exports, "linkLineHeightCaption", () => $8b8adca400ca855b$export$63b3bf0bcd5dec0);
$parcel$export($8b8adca400ca855b$exports, "linkFontSizeDefault", () => $8b8adca400ca855b$export$63f6e89485f022a0);
$parcel$export($8b8adca400ca855b$exports, "linkFontSizeCaption", () => $8b8adca400ca855b$export$2c39b60b9ab3c509);
$parcel$export($8b8adca400ca855b$exports, "linkTextDecorationUnderline", () => $8b8adca400ca855b$export$d20edb3b4cd46521);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgUnselectedDefault", () => $8b8adca400ca855b$export$1a81d73bf487bad2);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgUnselectedHover", () => $8b8adca400ca855b$export$66899150b01781f);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgUnselectedFocus", () => $8b8adca400ca855b$export$f717e38166baeb5c);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgUnselectedDisabled", () => $8b8adca400ca855b$export$1b8e258852406e33);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgSelectedDefault", () => $8b8adca400ca855b$export$6024c97884eba4d8);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgSelectedHover", () => $8b8adca400ca855b$export$be689acb580cdc83);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgSelectedFocus", () => $8b8adca400ca855b$export$49e326127c3153ea);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgSelectedDisabled", () => $8b8adca400ca855b$export$55f25450a0bf5e72);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgIndeterminateDefault", () => $8b8adca400ca855b$export$fc90332a56a8f3c);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgIndeterminateHover", () => $8b8adca400ca855b$export$2c6002f82a481ef3);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgIndeterminateFocus", () => $8b8adca400ca855b$export$d22c37eb694c13bd);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBgIndeterminateDisabled", () => $8b8adca400ca855b$export$fd0078d1143f7e9a);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderUnselectedDefault", () => $8b8adca400ca855b$export$d1033c477c3c6ff9);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderUnselectedHover", () => $8b8adca400ca855b$export$ce1e53725c205a2b);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderUnselectedFocus", () => $8b8adca400ca855b$export$be282364918d0701);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderUnselectedDisabled", () => $8b8adca400ca855b$export$e8d2b6a7823bd61c);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderSelectedDefault", () => $8b8adca400ca855b$export$69b4d96c29de7d5a);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderSelectedHover", () => $8b8adca400ca855b$export$d71ecf661337863e);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderSelectedFocus", () => $8b8adca400ca855b$export$dd2313e49d842f7c);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderSelectedDisabled", () => $8b8adca400ca855b$export$407193ea73d64650);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderIndeterminateDefault", () => $8b8adca400ca855b$export$68a64f766c3e06eb);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderIndeterminateHover", () => $8b8adca400ca855b$export$7bd4b125f5796f0b);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderIndeterminateFocus", () => $8b8adca400ca855b$export$dc235a9e36421303);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorWrapperBorderIndeterminateDisabled", () => $8b8adca400ca855b$export$44a93435f9e76b5f);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgUnselectedDefault", () => $8b8adca400ca855b$export$5114818da7303033);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgUnselectedHover", () => $8b8adca400ca855b$export$819bb9ecff8821f6);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgUnselectedFocus", () => $8b8adca400ca855b$export$9d48bca40b858c58);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgUnselectedDisabled", () => $8b8adca400ca855b$export$f4432833dbc2b032);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgSelectedDefault", () => $8b8adca400ca855b$export$5371ecf7e7c3c5fb);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgSelectedHover", () => $8b8adca400ca855b$export$bce78b0af6106c0d);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgSelectedFocus", () => $8b8adca400ca855b$export$84c6ef30066cb450);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgSelectedDisabled", () => $8b8adca400ca855b$export$19c89d51fe48e97e);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgIndeterminateDefault", () => $8b8adca400ca855b$export$b4ded087f67cfcb1);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgIndeterminateHover", () => $8b8adca400ca855b$export$98739c3332aa1180);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgIndeterminateFocus", () => $8b8adca400ca855b$export$5450679c20cb502e);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsColorIconBgIndeterminateDisabled", () => $8b8adca400ca855b$export$72df667c0ea477ce);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsSizeDefault", () => $8b8adca400ca855b$export$de71cd689917b4b9);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsSizeS", () => $8b8adca400ca855b$export$46fd5ca6b9cb553c);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsPadding", () => $8b8adca400ca855b$export$c3edf74d2870face);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsRadiusSquare", () => $8b8adca400ca855b$export$b4a7b3d28ddcea06);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsRadiusRound", () => $8b8adca400ca855b$export$aab87273839218af);
$parcel$export($8b8adca400ca855b$exports, "toggleControlsBorderWidthWrapper", () => $8b8adca400ca855b$export$31a25690cfb3c72b);
$parcel$export($8b8adca400ca855b$exports, "skeletonColorBg", () => $8b8adca400ca855b$export$4f243c7e47f36178);
$parcel$export($8b8adca400ca855b$exports, "skeletonColorBorder", () => $8b8adca400ca855b$export$21e1926cfd31fb34);
$parcel$export($8b8adca400ca855b$exports, "skeletonBorderWidthNone", () => $8b8adca400ca855b$export$729f8261cfc7f56f);
$parcel$export($8b8adca400ca855b$exports, "skeletonRadiusRound", () => $8b8adca400ca855b$export$841ebfb9757ebe4e);
$parcel$export($8b8adca400ca855b$exports, "skeletonRadiusSharp", () => $8b8adca400ca855b$export$9e4598db4a678250);
$parcel$export($8b8adca400ca855b$exports, "dividerBorderWidth", () => $8b8adca400ca855b$export$5c0a15ed7f937814);
$parcel$export($8b8adca400ca855b$exports, "dividerColor", () => $8b8adca400ca855b$export$6fdaa6b611356931);
$parcel$export($8b8adca400ca855b$exports, "dialogSizeSWidth", () => $8b8adca400ca855b$export$14148cd5c9a8c997);
$parcel$export($8b8adca400ca855b$exports, "dialogSizeMWidth", () => $8b8adca400ca855b$export$3c9f15c3fd95369);
$parcel$export($8b8adca400ca855b$exports, "dialogSizeLWidth", () => $8b8adca400ca855b$export$8dbca5b14d0844eb);
$parcel$export($8b8adca400ca855b$exports, "dialogSizeMobileWidth", () => $8b8adca400ca855b$export$8e20ff08973f499);
$parcel$export($8b8adca400ca855b$exports, "dialogBorderWidth", () => $8b8adca400ca855b$export$288cafde2f49d409);
$parcel$export($8b8adca400ca855b$exports, "dialogRadius", () => $8b8adca400ca855b$export$4d69bf9275adc0b4);
$parcel$export($8b8adca400ca855b$exports, "dialogColorBgDefault", () => $8b8adca400ca855b$export$15fcc38e88786dd4);
$parcel$export($8b8adca400ca855b$exports, "dialogColorBorderDefault", () => $8b8adca400ca855b$export$fc3f1c3df48b1cc4);
$parcel$export($8b8adca400ca855b$exports, "dialogPaddingDefault", () => $8b8adca400ca855b$export$a3582a1f7ae69771);
$parcel$export($8b8adca400ca855b$exports, "dialogPaddingSpacious", () => $8b8adca400ca855b$export$76c304873b7a47d1);
$parcel$export($8b8adca400ca855b$exports, "dialogPaddingDense", () => $8b8adca400ca855b$export$3be63787605bb63b);
$parcel$export($8b8adca400ca855b$exports, "headerFontFamily", () => $8b8adca400ca855b$export$6da960e179d64c7e);
$parcel$export($8b8adca400ca855b$exports, "headerFontWeight", () => $8b8adca400ca855b$export$d4ec6eea36d83142);
$parcel$export($8b8adca400ca855b$exports, "headerLineHeight", () => $8b8adca400ca855b$export$f148b6bcf802c0a0);
$parcel$export($8b8adca400ca855b$exports, "headerFontSize", () => $8b8adca400ca855b$export$8fcd22ab977bd8d8);
$parcel$export($8b8adca400ca855b$exports, "headerLetterSpacing", () => $8b8adca400ca855b$export$352a97f8e784158a);
$parcel$export($8b8adca400ca855b$exports, "alertBoxShadowInline", () => $8b8adca400ca855b$export$902221d8e98b812c);
$parcel$export($8b8adca400ca855b$exports, "alertBoxShadowFloating", () => $8b8adca400ca855b$export$e492848c875e9064);
$parcel$export($8b8adca400ca855b$exports, "alertBorderWidth", () => $8b8adca400ca855b$export$bd9a62c800d4c4a9);
$parcel$export($8b8adca400ca855b$exports, "alertRadius", () => $8b8adca400ca855b$export$76ef89a37b8ace4d);
$parcel$export($8b8adca400ca855b$exports, "alertPadding", () => $8b8adca400ca855b$export$735b1ff34fe199d4);
$parcel$export($8b8adca400ca855b$exports, "alertSpaceBetween", () => $8b8adca400ca855b$export$302ed6b9f6c0b425);
$parcel$export($8b8adca400ca855b$exports, "alertColorBgErrorNeutral", () => $8b8adca400ca855b$export$1ba594a12602b520);
$parcel$export($8b8adca400ca855b$exports, "alertColorBgWarningNeutral", () => $8b8adca400ca855b$export$bc25af37f4d9124d);
$parcel$export($8b8adca400ca855b$exports, "alertColorBgSuccessNeutral", () => $8b8adca400ca855b$export$569648afc0995710);
$parcel$export($8b8adca400ca855b$exports, "alertColorBgInfoNeutral", () => $8b8adca400ca855b$export$4c44b4e9bc0481e9);
$parcel$export($8b8adca400ca855b$exports, "alertColorBgInfoEmphasis", () => $8b8adca400ca855b$export$df27106c05b21907);
$parcel$export($8b8adca400ca855b$exports, "alertColorBorderErrorNeutral", () => $8b8adca400ca855b$export$e92b34357220e8e0);
$parcel$export($8b8adca400ca855b$exports, "alertColorBorderWarningNeutral", () => $8b8adca400ca855b$export$809bc51a80a73ffa);
$parcel$export($8b8adca400ca855b$exports, "alertColorBorderSuccessNeutral", () => $8b8adca400ca855b$export$b20e54fe63f136ec);
$parcel$export($8b8adca400ca855b$exports, "alertColorBorderInfoNeutral", () => $8b8adca400ca855b$export$aaaff3ea35504d9a);
$parcel$export($8b8adca400ca855b$exports, "alertColorBorderInfoEmphasis", () => $8b8adca400ca855b$export$d2b4b84e205366a4);
$parcel$export($8b8adca400ca855b$exports, "alertColorTextNeutral", () => $8b8adca400ca855b$export$bd02a858e71ac856);
$parcel$export($8b8adca400ca855b$exports, "alertColorTextEmphasis", () => $8b8adca400ca855b$export$9f0fea77a037b87a);
$parcel$export($8b8adca400ca855b$exports, "alertColorTextErrorNeutral", () => $8b8adca400ca855b$export$2b03536d20a3b2f6);
$parcel$export($8b8adca400ca855b$exports, "alertFontFamily", () => $8b8adca400ca855b$export$ca5110e6287a9670);
$parcel$export($8b8adca400ca855b$exports, "alertBodyFontWeight", () => $8b8adca400ca855b$export$6595d0fad08bd2b4);
$parcel$export($8b8adca400ca855b$exports, "alertBodyLineHeight", () => $8b8adca400ca855b$export$4339da1d2671e324);
$parcel$export($8b8adca400ca855b$exports, "alertBodyFontSize", () => $8b8adca400ca855b$export$891da890c43fc05e);
$parcel$export($8b8adca400ca855b$exports, "alertTitleFontWeight", () => $8b8adca400ca855b$export$ce0ddd473dd20afc);
$parcel$export($8b8adca400ca855b$exports, "alertTitleLineHeight", () => $8b8adca400ca855b$export$16dd3c4d6489ba61);
$parcel$export($8b8adca400ca855b$exports, "alertTitleFontSize", () => $8b8adca400ca855b$export$ddcf665488274808);
$parcel$export($8b8adca400ca855b$exports, "alertLetterSpacing", () => $8b8adca400ca855b$export$5bdc2b5fff62d35);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBgSelectedDefault", () => $8b8adca400ca855b$export$86773c375c0bb9a1);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBgSelectedHover", () => $8b8adca400ca855b$export$6607013dc8c505fa);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBgSelectedDisabled", () => $8b8adca400ca855b$export$df5495caecdcb614);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBgUnselectedDefault", () => $8b8adca400ca855b$export$23aa1d4fb282b9e2);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBgUnselectedHover", () => $8b8adca400ca855b$export$9f19810b26e253c8);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBgUnselectedDisabled", () => $8b8adca400ca855b$export$a1820a4b6e6de5c);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBorderSelectedDefault", () => $8b8adca400ca855b$export$64a5a6262510bdfe);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBorderSelectedHover", () => $8b8adca400ca855b$export$561d96085c937ed4);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBorderSelectedDisabled", () => $8b8adca400ca855b$export$c60d87bac1618e10);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBorderUnselectedDefault", () => $8b8adca400ca855b$export$7fabd56572773fe8);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBorderUnselectedHover", () => $8b8adca400ca855b$export$3f9ecbd7e63c2056);
$parcel$export($8b8adca400ca855b$exports, "switchKnobColorBorderUnselectedDisabled", () => $8b8adca400ca855b$export$a5c9bce6d83773a);
$parcel$export($8b8adca400ca855b$exports, "switchKnobBorderWidth", () => $8b8adca400ca855b$export$5e221dc1e3b0d8bf);
$parcel$export($8b8adca400ca855b$exports, "switchKnobRadius", () => $8b8adca400ca855b$export$987a18f51782dfac);
$parcel$export($8b8adca400ca855b$exports, "switchKnobSizeM", () => $8b8adca400ca855b$export$4c09818a16bf66d3);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBgSelectedDefault", () => $8b8adca400ca855b$export$e2b1a3f6040b3539);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBgSelectedHover", () => $8b8adca400ca855b$export$71201f47e9dc9666);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBgSelectedDisabled", () => $8b8adca400ca855b$export$6c4b9b05028ede96);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBgUnselectedDefault", () => $8b8adca400ca855b$export$b1d4a516e2e88fe6);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBgUnselectedHover", () => $8b8adca400ca855b$export$f1348024bfa310d4);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBgUnselectedDisabled", () => $8b8adca400ca855b$export$5d9f8f5a09ed11cc);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBorderSelectedDefault", () => $8b8adca400ca855b$export$c38f3967889bac93);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBorderSelectedHover", () => $8b8adca400ca855b$export$64092d816c16ef53);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBorderSelectedDisabled", () => $8b8adca400ca855b$export$7521fab9ed6230d8);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBorderUnselectedDefault", () => $8b8adca400ca855b$export$d4e8d359f8069dfc);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBorderUnselectedHover", () => $8b8adca400ca855b$export$1814043782ee69c8);
$parcel$export($8b8adca400ca855b$exports, "switchTrackColorBorderUnselectedDisabled", () => $8b8adca400ca855b$export$f17aa8a146709aa2);
$parcel$export($8b8adca400ca855b$exports, "switchTrackBorderWidth", () => $8b8adca400ca855b$export$3d1b7f700b76b19e);
$parcel$export($8b8adca400ca855b$exports, "switchTrackRadius", () => $8b8adca400ca855b$export$e33736dbca43baac);
$parcel$export($8b8adca400ca855b$exports, "switchTrackSizeMMinWidth", () => $8b8adca400ca855b$export$fa6928ff7c04c2cd);
$parcel$export($8b8adca400ca855b$exports, "switchTrackSizeMMinHeight", () => $8b8adca400ca855b$export$3a2ecb48778e609e);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBgDefault", () => $8b8adca400ca855b$export$1ced0159d1e6df39);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBgHover", () => $8b8adca400ca855b$export$f405b4ac7e3959c8);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBgFocus", () => $8b8adca400ca855b$export$7c74bcd0f7f3be40);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBgSelectedDefault", () => $8b8adca400ca855b$export$b2bbe3653cad5eb2);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBgSelectedHover", () => $8b8adca400ca855b$export$5ebb29b4abcdfb8f);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBgDisabled", () => $8b8adca400ca855b$export$a6e416f594566ded);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBorderDefault", () => $8b8adca400ca855b$export$db028a317a02353a);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBorderHover", () => $8b8adca400ca855b$export$6f5efccfe6dfd313);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBorderFocus", () => $8b8adca400ca855b$export$4fe40f383eb5faf5);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBorderSelectedDefault", () => $8b8adca400ca855b$export$71ea0e30dc1b6ba4);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBorderSelectedHover", () => $8b8adca400ca855b$export$8c4beee5a921e3c9);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorBorderDisabled", () => $8b8adca400ca855b$export$35a66965267ed529);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorTextDefault", () => $8b8adca400ca855b$export$7bcf618f61979316);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorTextHover", () => $8b8adca400ca855b$export$a6f5b1dbfa6022b);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorTextFocus", () => $8b8adca400ca855b$export$2cd9519356202e1f);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorTextSelected", () => $8b8adca400ca855b$export$aa7a4ccf8d59e280);
$parcel$export($8b8adca400ca855b$exports, "menuItemColorTextDisabled", () => $8b8adca400ca855b$export$ee5e76ba05b4ab28);
$parcel$export($8b8adca400ca855b$exports, "menuItemBorderWidth", () => $8b8adca400ca855b$export$f1088235eae15437);
$parcel$export($8b8adca400ca855b$exports, "menuItemRadius", () => $8b8adca400ca855b$export$fafa860328e70ae);
$parcel$export($8b8adca400ca855b$exports, "menuItemPadding", () => $8b8adca400ca855b$export$a7a5eb1834e82687);
$parcel$export($8b8adca400ca855b$exports, "menuItemFontFamily", () => $8b8adca400ca855b$export$7d6465298d6c4692);
$parcel$export($8b8adca400ca855b$exports, "menuItemFontWeightDefault", () => $8b8adca400ca855b$export$a0f454c876af7960);
$parcel$export($8b8adca400ca855b$exports, "menuItemFontWeightNested", () => $8b8adca400ca855b$export$e2adaac19dce9831);
$parcel$export($8b8adca400ca855b$exports, "menuItemLineHeight", () => $8b8adca400ca855b$export$dddff9d395fc8f70);
$parcel$export($8b8adca400ca855b$exports, "menuItemFontSize", () => $8b8adca400ca855b$export$1dd2d60f07979c32);
$parcel$export($8b8adca400ca855b$exports, "menuItemLetterSpacing", () => $8b8adca400ca855b$export$42ae81b5c0a2fbb);
$parcel$export($8b8adca400ca855b$exports, "menuColorBg", () => $8b8adca400ca855b$export$a46db5db085db139);
$parcel$export($8b8adca400ca855b$exports, "menuColorBorder", () => $8b8adca400ca855b$export$27401163f4368ffc);
$parcel$export($8b8adca400ca855b$exports, "menuBorderWidth", () => $8b8adca400ca855b$export$96b2aad183e1f54f);
$parcel$export($8b8adca400ca855b$exports, "menuRadius", () => $8b8adca400ca855b$export$ee764dc2d555ddf6);
$parcel$export($8b8adca400ca855b$exports, "menuPadding", () => $8b8adca400ca855b$export$794d9c23b73cc47e);
$parcel$export($8b8adca400ca855b$exports, "menuSpaceBetween", () => $8b8adca400ca855b$export$3f57378f9ec9cd94);
$parcel$export($8b8adca400ca855b$exports, "menuBoxShadow", () => $8b8adca400ca855b$export$ddcc321b1a8861dd);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBgDefault", () => $8b8adca400ca855b$export$b51251547efb0d8e);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBgHover", () => $8b8adca400ca855b$export$85a890daf957fbec);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBgFocus", () => $8b8adca400ca855b$export$89e8e756190bda61);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBgDisabled", () => $8b8adca400ca855b$export$770bdd3d491ddfe6);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBgError", () => $8b8adca400ca855b$export$8e00bb2c5d8bbc3b);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBorderDefault", () => $8b8adca400ca855b$export$c21d874e9498ef82);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBorderHover", () => $8b8adca400ca855b$export$61ede0f7013c2b81);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBorderFocus", () => $8b8adca400ca855b$export$6fe37393ecda4209);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBorderDisabled", () => $8b8adca400ca855b$export$ff38bf95992f09fc);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorBorderError", () => $8b8adca400ca855b$export$88cfb69c788bb860);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextEnteredDefault", () => $8b8adca400ca855b$export$52e86a91e2ad6034);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextEnteredDisabled", () => $8b8adca400ca855b$export$cca144c3f4aa7626);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextLabelDefault", () => $8b8adca400ca855b$export$f10f0ec496f636f7);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextLabelDisabled", () => $8b8adca400ca855b$export$58dfb1025a181356);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextLabelError", () => $8b8adca400ca855b$export$bc322de6f84fd903);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextPlaceholderDefault", () => $8b8adca400ca855b$export$49337470bba91ab9);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextPlaceholderDisabled", () => $8b8adca400ca855b$export$4a34e2a16154db83);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextHelperTextDefault", () => $8b8adca400ca855b$export$26aa6c0ceb7e966e);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextHelperTextDisabled", () => $8b8adca400ca855b$export$b816de746fb400a5);
$parcel$export($8b8adca400ca855b$exports, "textfieldColorTextHelperTextError", () => $8b8adca400ca855b$export$c02de212dbe9d176);
$parcel$export($8b8adca400ca855b$exports, "textfieldPadding", () => $8b8adca400ca855b$export$116727610d612ae4);
$parcel$export($8b8adca400ca855b$exports, "textfieldBorderWidth", () => $8b8adca400ca855b$export$71b44d15d3de46dd);
$parcel$export($8b8adca400ca855b$exports, "textfieldSpaceBetween", () => $8b8adca400ca855b$export$bace76a59986f565);
$parcel$export($8b8adca400ca855b$exports, "textfieldFontFamily", () => $8b8adca400ca855b$export$9ffe2275b011d7e1);
$parcel$export($8b8adca400ca855b$exports, "textfieldLineHeight", () => $8b8adca400ca855b$export$b0985124f4df02d2);
$parcel$export($8b8adca400ca855b$exports, "textfieldFontWeight", () => $8b8adca400ca855b$export$a315c6564df14490);
$parcel$export($8b8adca400ca855b$exports, "textfieldFontSize", () => $8b8adca400ca855b$export$aa1b94da4287d2a0);
$parcel$export($8b8adca400ca855b$exports, "textfieldLetterSpacing", () => $8b8adca400ca855b$export$e5114fa3fec26908);
$parcel$export($8b8adca400ca855b$exports, "textfieldRadius", () => $8b8adca400ca855b$export$84f5f00bc441b732);
$parcel$export($8b8adca400ca855b$exports, "helpTextFontFamily", () => $8b8adca400ca855b$export$51cb609d45dac1eb);
$parcel$export($8b8adca400ca855b$exports, "helpTextFontWeight", () => $8b8adca400ca855b$export$3827778002413131);
$parcel$export($8b8adca400ca855b$exports, "helpTextLineHeight", () => $8b8adca400ca855b$export$e67e3340791cadd4);
$parcel$export($8b8adca400ca855b$exports, "helpTextFontSize", () => $8b8adca400ca855b$export$ec94e1b644056c99);
$parcel$export($8b8adca400ca855b$exports, "helpTextLetterSpacing", () => $8b8adca400ca855b$export$f3bbd9a0f0930579);
$parcel$export($8b8adca400ca855b$exports, "minHeightDefault", () => $8b8adca400ca855b$export$33ce3a4dcea39de);
$parcel$export($8b8adca400ca855b$exports, "labelColorBgSubtle", () => $8b8adca400ca855b$export$d8e53851991cdd42);
$parcel$export($8b8adca400ca855b$exports, "labelColorBgNeutral", () => $8b8adca400ca855b$export$fe3a5cd62a598e84);
$parcel$export($8b8adca400ca855b$exports, "labelColorText", () => $8b8adca400ca855b$export$5edfe3b007b29215);
$parcel$export($8b8adca400ca855b$exports, "labelPadding", () => $8b8adca400ca855b$export$86d4c0985100dcd0);
$parcel$export($8b8adca400ca855b$exports, "progressContainerColorBg", () => $8b8adca400ca855b$export$8266cc989bac4651);
$parcel$export($8b8adca400ca855b$exports, "progressContainerColorBorder", () => $8b8adca400ca855b$export$d4bd2b0a79e3ef71);
$parcel$export($8b8adca400ca855b$exports, "progressFillColorBgDefault", () => $8b8adca400ca855b$export$4ce259255a4d70c4);
$parcel$export($8b8adca400ca855b$exports, "progressFillColorBgError", () => $8b8adca400ca855b$export$2869c51015852e03);
$parcel$export($8b8adca400ca855b$exports, "progressFillColorBorderDefault", () => $8b8adca400ca855b$export$f5e3fe890c9ff1e);
$parcel$export($8b8adca400ca855b$exports, "progressFillColorBorderError", () => $8b8adca400ca855b$export$1cfbd34f600c6efa);
$parcel$export($8b8adca400ca855b$exports, "linearContainerBorderWidth", () => $8b8adca400ca855b$export$5a252ec11a1445ad);
$parcel$export($8b8adca400ca855b$exports, "linearContainerRadius", () => $8b8adca400ca855b$export$c735ecaf581f705);
$parcel$export($8b8adca400ca855b$exports, "linearFillBorderWidth", () => $8b8adca400ca855b$export$49bf4afa6ca745e);
$parcel$export($8b8adca400ca855b$exports, "linearFillRadius", () => $8b8adca400ca855b$export$edc7fc4c8271f574);
$parcel$export($8b8adca400ca855b$exports, "linearSizeSMinHeight", () => $8b8adca400ca855b$export$253ba067522eaa91);
$parcel$export($8b8adca400ca855b$exports, "circularSizeS", () => $8b8adca400ca855b$export$c945866cf5c6fd53);
$parcel$export($8b8adca400ca855b$exports, "circularSizeM", () => $8b8adca400ca855b$export$5b8c998da32edfab);
$parcel$export($8b8adca400ca855b$exports, "circularSizeL", () => $8b8adca400ca855b$export$4cb4e758ff318324);
$parcel$export($8b8adca400ca855b$exports, "circularSizeXl", () => $8b8adca400ca855b$export$9965c30cb78bb99e);
$parcel$export($8b8adca400ca855b$exports, "sparklineSizeLargeMinHeight", () => $8b8adca400ca855b$export$73f604c81bd5b0de);
$parcel$export($8b8adca400ca855b$exports, "sparklineSizeLargeMinWidth", () => $8b8adca400ca855b$export$e2b17b1f6ba2f2c0);
$parcel$export($8b8adca400ca855b$exports, "sparklineSizeMediumMinHeight", () => $8b8adca400ca855b$export$9d31ebafe2568375);
$parcel$export($8b8adca400ca855b$exports, "sparklineSizeMediumMinWidth", () => $8b8adca400ca855b$export$65141d2099878d22);
$parcel$export($8b8adca400ca855b$exports, "sparklineLineColor", () => $8b8adca400ca855b$export$b889b193e53040e);
$parcel$export($8b8adca400ca855b$exports, "sparklineLineBorderWidth", () => $8b8adca400ca855b$export$80792f69e844dd7a);
$parcel$export($8b8adca400ca855b$exports, "paginationSpaceBetween", () => $8b8adca400ca855b$export$5ded54aa949b1fd3);
$parcel$export($8b8adca400ca855b$exports, "paginationPadding", () => $8b8adca400ca855b$export$20e329e1e9c12a82);
$parcel$export($8b8adca400ca855b$exports, "paginationColorBgDefault", () => $8b8adca400ca855b$export$e2d09706041282a2);
$parcel$export($8b8adca400ca855b$exports, "paginationColorBgFilled", () => $8b8adca400ca855b$export$7aa5ad378865fe04);
$parcel$export($8b8adca400ca855b$exports, "paginationColorBorderDefault", () => $8b8adca400ca855b$export$4c7f7f1e4a99b8b5);
$parcel$export($8b8adca400ca855b$exports, "paginationColorBorderBorderTop", () => $8b8adca400ca855b$export$acfd0f4230aa9bd);
$parcel$export($8b8adca400ca855b$exports, "paginationBorderWidthTop", () => $8b8adca400ca855b$export$33c117b123a26dc4);
$parcel$export($8b8adca400ca855b$exports, "tabRadius", () => $8b8adca400ca855b$export$427ad239b0adeca2);
$parcel$export($8b8adca400ca855b$exports, "tabColorBgDefaultDefault", () => $8b8adca400ca855b$export$8814694ab67761cf);
$parcel$export($8b8adca400ca855b$exports, "tabColorBgDefaultHover", () => $8b8adca400ca855b$export$e4759e57c938a220);
$parcel$export($8b8adca400ca855b$exports, "tabColorBgDefaultFocus", () => $8b8adca400ca855b$export$7dc99afc1861281f);
$parcel$export($8b8adca400ca855b$exports, "tabColorBgSelectedDefault", () => $8b8adca400ca855b$export$e5a7cf19fc196fc0);
$parcel$export($8b8adca400ca855b$exports, "tabColorBgSelectedHover", () => $8b8adca400ca855b$export$742357191da0915b);
$parcel$export($8b8adca400ca855b$exports, "tabColorBgSelectedFocus", () => $8b8adca400ca855b$export$d4fac41645ce7de8);
$parcel$export($8b8adca400ca855b$exports, "tabColorBorderDefaultDefault", () => $8b8adca400ca855b$export$258236cb50101bf9);
$parcel$export($8b8adca400ca855b$exports, "tabColorBorderDefaultHover", () => $8b8adca400ca855b$export$b660cdb46497535b);
$parcel$export($8b8adca400ca855b$exports, "tabColorBorderDefaultFocus", () => $8b8adca400ca855b$export$6edeb93afbabb3);
$parcel$export($8b8adca400ca855b$exports, "tabColorBorderSelectedDefault", () => $8b8adca400ca855b$export$8527b5e5f1a32759);
$parcel$export($8b8adca400ca855b$exports, "tabColorBorderSelectedHover", () => $8b8adca400ca855b$export$404f9d2e20441a64);
$parcel$export($8b8adca400ca855b$exports, "tabColorBorderSelectedFocus", () => $8b8adca400ca855b$export$cc0883bf09c21e65);
$parcel$export($8b8adca400ca855b$exports, "tabColorTextDefault", () => $8b8adca400ca855b$export$facf8ff6788b88ea);
$parcel$export($8b8adca400ca855b$exports, "tabColorTextSelected", () => $8b8adca400ca855b$export$5ba09a1a7b4af6ac);
$parcel$export($8b8adca400ca855b$exports, "tabPadding", () => $8b8adca400ca855b$export$dc278ffa79064219);
$parcel$export($8b8adca400ca855b$exports, "tabSpaceBetween", () => $8b8adca400ca855b$export$1e468d8d8b24f0a7);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalDefaultBottom", () => $8b8adca400ca855b$export$8a7407fa38280281);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalDefaultTop", () => $8b8adca400ca855b$export$362ddcf024bed54e);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalDefaultRight", () => $8b8adca400ca855b$export$4d9a0d275210ab6f);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalDefaultLeft", () => $8b8adca400ca855b$export$31a06d75aaa08bbf);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalSelectedBottom", () => $8b8adca400ca855b$export$3bcae2b0ac664dfb);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalSelectedTop", () => $8b8adca400ca855b$export$5e97a30a5d76a6eb);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalSelectedRight", () => $8b8adca400ca855b$export$49b56a0f736ebf80);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthHorizontalSelectedLeft", () => $8b8adca400ca855b$export$dcc78db97c706ed5);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalDefaultBottom", () => $8b8adca400ca855b$export$db0747eda20d8b11);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalDefaultTop", () => $8b8adca400ca855b$export$b1dd518c969a9dc2);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalDefaultRight", () => $8b8adca400ca855b$export$512259029c84d0f1);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalDefaultLeft", () => $8b8adca400ca855b$export$6f6b54dde0882c41);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalSelectedBottom", () => $8b8adca400ca855b$export$437187fbcaa7285b);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalSelectedTop", () => $8b8adca400ca855b$export$f41d59313e2e2d61);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalSelectedRight", () => $8b8adca400ca855b$export$15265dc7c7a51345);
$parcel$export($8b8adca400ca855b$exports, "tabBorderWidthVerticalSelectedLeft", () => $8b8adca400ca855b$export$e9d3d243807e3d2);
$parcel$export($8b8adca400ca855b$exports, "tabFontFamily", () => $8b8adca400ca855b$export$e2766d737a057e60);
$parcel$export($8b8adca400ca855b$exports, "tabFontWeight", () => $8b8adca400ca855b$export$2ddfac786be6e309);
$parcel$export($8b8adca400ca855b$exports, "tabFontSize", () => $8b8adca400ca855b$export$59bf55466e4e3745);
$parcel$export($8b8adca400ca855b$exports, "tabLetterSpacing", () => $8b8adca400ca855b$export$22bcc28ea306d2f3);
$parcel$export($8b8adca400ca855b$exports, "datawordMinHeight", () => $8b8adca400ca855b$export$b88310354d2244f3);
$parcel$export($8b8adca400ca855b$exports, "datawordMinWidth", () => $8b8adca400ca855b$export$824459960cf5a262);
$parcel$export($8b8adca400ca855b$exports, "datawordSpaceBetween", () => $8b8adca400ca855b$export$788649a55d91496e);
$parcel$export($8b8adca400ca855b$exports, "datawordColorUnfilledBg", () => $8b8adca400ca855b$export$95aa30178720092a);
$parcel$export($8b8adca400ca855b$exports, "datawordColorFilledBg", () => $8b8adca400ca855b$export$16796337c4a008dd);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBorderError", () => $8b8adca400ca855b$export$92929f84f89fa83);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBorderDefault", () => $8b8adca400ca855b$export$b2ca58ad74caacc7);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBorderHover", () => $8b8adca400ca855b$export$b1b662adf9714ed8);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBorderFocus", () => $8b8adca400ca855b$export$a212d99fcf9df17e);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBorderDisabled", () => $8b8adca400ca855b$export$6d1640df421fce01);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBgError", () => $8b8adca400ca855b$export$ca6a6b82ca40bb5a);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBgDefault", () => $8b8adca400ca855b$export$d781c067583bc79e);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBgHover", () => $8b8adca400ca855b$export$f5d14a553904785b);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBgFocus", () => $8b8adca400ca855b$export$8447a3259160c2ce);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorBgDisabled", () => $8b8adca400ca855b$export$3af2ae30823e630b);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorTextError", () => $8b8adca400ca855b$export$e40e3dd55bf947be);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorTextDefault", () => $8b8adca400ca855b$export$52388e8c4eec52d7);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessColorTextDisabled", () => $8b8adca400ca855b$export$bfc21f912830cce0);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessRadius", () => $8b8adca400ca855b$export$84f8abf314fe1bca);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessBorderWidth", () => $8b8adca400ca855b$export$299de995c72a7f6d);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessPadding", () => $8b8adca400ca855b$export$994684c23b7a2289);
$parcel$export($8b8adca400ca855b$exports, "selectContainerlessSpaceBetween", () => $8b8adca400ca855b$export$d30bba31083c3b81);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBgDefault", () => $8b8adca400ca855b$export$c47c10b3a195b8bb);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBgHover", () => $8b8adca400ca855b$export$f1591bd858270ed3);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBgSelectedDefault", () => $8b8adca400ca855b$export$fea961df0553afcf);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBgSelectedHover", () => $8b8adca400ca855b$export$e5b0c44f8687a2dd);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBgDisabled", () => $8b8adca400ca855b$export$ba60f029700a5b9a);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBgStartEndDefault", () => $8b8adca400ca855b$export$fea74d0348af746c);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBgStartEndHover", () => $8b8adca400ca855b$export$c0cd56cb8adeb0c7);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBorderDefault", () => $8b8adca400ca855b$export$4c10101c8dcd9159);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBorderHover", () => $8b8adca400ca855b$export$199b8a3a24f6052f);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBorderSelectedDefault", () => $8b8adca400ca855b$export$749561d1ff3174b6);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBorderSelectedHover", () => $8b8adca400ca855b$export$5b7d5394e6b2d316);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBorderDisabled", () => $8b8adca400ca855b$export$639d3915b8ce82b4);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBorderStartEndDefault", () => $8b8adca400ca855b$export$f991c2a34a669c11);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorBorderStartEndHover", () => $8b8adca400ca855b$export$e05aad2434815ae1);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorTextDefault", () => $8b8adca400ca855b$export$a5efeb0d86e557f2);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorTextDisabled", () => $8b8adca400ca855b$export$ac0c6ce6db4c1549);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorTextStartEnd", () => $8b8adca400ca855b$export$cb7b1f2bb4f70437);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayColorTextSelected", () => $8b8adca400ca855b$export$5b874dfd02e0b250);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayBorderWidthSelected", () => $8b8adca400ca855b$export$3cfc12423f70daae);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayBorderWidthDefault", () => $8b8adca400ca855b$export$454beb38955e81fd);
$parcel$export($8b8adca400ca855b$exports, "datepickerDaySize", () => $8b8adca400ca855b$export$e159fbe87f6978e3);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayDefault", () => $8b8adca400ca855b$export$423b9caf92ea785c);
$parcel$export($8b8adca400ca855b$exports, "datepickerDaySelected", () => $8b8adca400ca855b$export$ea96f43ec25cb42a);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayFontWeight", () => $8b8adca400ca855b$export$3f2b695522a06851);
$parcel$export($8b8adca400ca855b$exports, "datepickerDayFontSize", () => $8b8adca400ca855b$export$11aa2bc2efe9adc2);
$parcel$export($8b8adca400ca855b$exports, "datepickerContainerBorderWidth", () => $8b8adca400ca855b$export$5277ce3303456bf2);
$parcel$export($8b8adca400ca855b$exports, "datepickerContainerRadius", () => $8b8adca400ca855b$export$e652800607db6b2);
$parcel$export($8b8adca400ca855b$exports, "datepickerContainerPadding", () => $8b8adca400ca855b$export$3f1bc1575f23a5b9);
$parcel$export($8b8adca400ca855b$exports, "datepickerContainerSpaceBetween", () => $8b8adca400ca855b$export$6779021d34866272);
$parcel$export($8b8adca400ca855b$exports, "datepickerContainerColorBg", () => $8b8adca400ca855b$export$9b25e8846de5a4c6);
$parcel$export($8b8adca400ca855b$exports, "datepickerContainerColorBorder", () => $8b8adca400ca855b$export$7ea9497196b9950c);
$parcel$export($8b8adca400ca855b$exports, "datepickerContainerElevationFloating", () => $8b8adca400ca855b$export$1286c08a066cf92a);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBgDefault", () => $8b8adca400ca855b$export$452d31c71a4b2c7);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBgHover", () => $8b8adca400ca855b$export$29dfe4c30f5bdd8e);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBgSelectedDefault", () => $8b8adca400ca855b$export$a9fd54786af2362e);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBgSelectedHover", () => $8b8adca400ca855b$export$522ef6dd6d045e1a);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBgDisabled", () => $8b8adca400ca855b$export$76ed2592815724ef);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBorderDefault", () => $8b8adca400ca855b$export$82c6bb6f9ef8ad05);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBorderHover", () => $8b8adca400ca855b$export$7c79603c9689498a);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBorderSelectedDefault", () => $8b8adca400ca855b$export$c00e26acdc998f59);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBorderSelectedHover", () => $8b8adca400ca855b$export$e5b79ea5d86c9947);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorBorderDisabled", () => $8b8adca400ca855b$export$e2940776f75e7bde);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorTextDefault", () => $8b8adca400ca855b$export$d17ee04829bf7e5d);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorTextDisabled", () => $8b8adca400ca855b$export$e5f9b7707e340c07);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorTextStartEnd", () => $8b8adca400ca855b$export$4b146ead4a24d4ae);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeColorTextSelected", () => $8b8adca400ca855b$export$16eea8645753ec95);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeDefault", () => $8b8adca400ca855b$export$ac43e96d39af0fe9);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeBorderWidthSelected", () => $8b8adca400ca855b$export$175ca482ed6f6bca);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeBorderWidthDefault", () => $8b8adca400ca855b$export$732efe36f538d0b5);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeFontSize", () => $8b8adca400ca855b$export$51c06af4d25b7fbd);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeFontWeight", () => $8b8adca400ca855b$export$e24e0e94fc2167b7);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimeSpaceBetween", () => $8b8adca400ca855b$export$26f066c1988aa416);
$parcel$export($8b8adca400ca855b$exports, "datepickerTimePadding", () => $8b8adca400ca855b$export$9213701f1f96ce09);
$parcel$export($8b8adca400ca855b$exports, "datepickerFontFamily", () => $8b8adca400ca855b$export$4931e5b26cc04c05);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherBorderWidthDefault", () => $8b8adca400ca855b$export$6074a5e235cbf222);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherBorderWidthTop", () => $8b8adca400ca855b$export$c6fd4855184f2ce4);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherBorderWidthFocus", () => $8b8adca400ca855b$export$e7c8cff1096cca6b);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBgDefault", () => $8b8adca400ca855b$export$5f3989fc72b355c5);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBgHover", () => $8b8adca400ca855b$export$694c340304b6cf03);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBgSelected", () => $8b8adca400ca855b$export$295da88ee730d887);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBgDisabled", () => $8b8adca400ca855b$export$e76dfb999cb566ad);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBgFocus", () => $8b8adca400ca855b$export$6105cdb447f0f917);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBorderDefault", () => $8b8adca400ca855b$export$7504fc34155ea4ea);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBorderHover", () => $8b8adca400ca855b$export$8af690634ab83d08);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBorderSelected", () => $8b8adca400ca855b$export$b0809c34687e6321);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBorderDisabled", () => $8b8adca400ca855b$export$e7169e000728aae0);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorBorderFocus", () => $8b8adca400ca855b$export$d49751a9f9c74d95);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorTextDefault", () => $8b8adca400ca855b$export$11780cad30f773c3);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorTextDisabled", () => $8b8adca400ca855b$export$13ff4d77bf18846);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherColorTextSelected", () => $8b8adca400ca855b$export$dd5841622912a30);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherRadiusBottom", () => $8b8adca400ca855b$export$4ab353e2521798aa);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherRadiusTop", () => $8b8adca400ca855b$export$f564560b1c0b69a0);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherPadding", () => $8b8adca400ca855b$export$f8de90cd42beeba7);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherFontFamily", () => $8b8adca400ca855b$export$f8d96a6e6e32683b);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherFontWeight", () => $8b8adca400ca855b$export$33b6ba26e004869a);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherLineHeight", () => $8b8adca400ca855b$export$e857928a445edf3);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherFontSize", () => $8b8adca400ca855b$export$600f9c33474c074e);
$parcel$export($8b8adca400ca855b$exports, "navigationAccountSwitcherLetterspacing", () => $8b8adca400ca855b$export$e7ff8df7907262bb);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerPrimaryColorBg", () => $8b8adca400ca855b$export$ee9afb269ebcf753);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerPrimaryColorBorder", () => $8b8adca400ca855b$export$905dbec0b0250e3b);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerPrimaryBorderWidth", () => $8b8adca400ca855b$export$ce6f6641c7bb2372);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerPrimaryRadius", () => $8b8adca400ca855b$export$4cbe16864bd24f8c);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerPrimaryWidth", () => $8b8adca400ca855b$export$521605d09d8c162c);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerPrimaryPadding", () => $8b8adca400ca855b$export$c425de24adc2b8b8);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerPrimarySpaceBetween", () => $8b8adca400ca855b$export$2d128d3377891546);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerSecondaryColorBg", () => $8b8adca400ca855b$export$170ee3bcb8ad49a0);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerSecondaryColorBorder", () => $8b8adca400ca855b$export$b9184a6500088a33);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerSecondaryBorderWidth", () => $8b8adca400ca855b$export$a133f97fe8f7af80);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerSecondaryRadius", () => $8b8adca400ca855b$export$440bfa12676d4362);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerSecondaryMinWidth", () => $8b8adca400ca855b$export$23df00f94a7966ab);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerSecondaryPadding", () => $8b8adca400ca855b$export$ddc6772884310bfd);
$parcel$export($8b8adca400ca855b$exports, "navigationNavContainerSecondarySpaceBetween", () => $8b8adca400ca855b$export$da255a4cc88a4cac);
$parcel$export($8b8adca400ca855b$exports, "chartsSizeBarWidth", () => $8b8adca400ca855b$export$b580f1a61f577587);
$parcel$export($8b8adca400ca855b$exports, "chartsSizePoint", () => $8b8adca400ca855b$export$d48962f1fd8fbdea);
$parcel$export($8b8adca400ca855b$exports, "chartsBorderWidthBar", () => $8b8adca400ca855b$export$113ff81b72ae4005);
$parcel$export($8b8adca400ca855b$exports, "chartsBorderWidthLine", () => $8b8adca400ca855b$export$aff0f3036f778118);
$parcel$export($8b8adca400ca855b$exports, "chartsBorderWidthAxis", () => $8b8adca400ca855b$export$105006e16cdb4368);
$parcel$export($8b8adca400ca855b$exports, "chartsBorderWidthRadar", () => $8b8adca400ca855b$export$83edc677e0bcbaf9);
$parcel$export($8b8adca400ca855b$exports, "chartsBorderWidthPointDefault", () => $8b8adca400ca855b$export$be459879692fda29);
$parcel$export($8b8adca400ca855b$exports, "chartsBorderWidthPointHover", () => $8b8adca400ca855b$export$586c2c06158e5801);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range10", () => $8b8adca400ca855b$export$a8ef96955ef6555c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range20", () => $8b8adca400ca855b$export$97032c77bb67830c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range30", () => $8b8adca400ca855b$export$6577f4536230e0ea);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range40", () => $8b8adca400ca855b$export$87b87f0038f4c66f);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range50", () => $8b8adca400ca855b$export$ec1dc93077563875);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range60", () => $8b8adca400ca855b$export$fce98b53ab002313);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range70", () => $8b8adca400ca855b$export$8e949091d329a301);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range80", () => $8b8adca400ca855b$export$94550a5bab2b5993);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range90", () => $8b8adca400ca855b$export$a8757e8f89513f1);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries1Range100", () => $8b8adca400ca855b$export$e985323c829fd742);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range10", () => $8b8adca400ca855b$export$19b7230ae44bbd30);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range20", () => $8b8adca400ca855b$export$b08be8e4ba1d6c82);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range30", () => $8b8adca400ca855b$export$145e11a833c7874d);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range40", () => $8b8adca400ca855b$export$90cf3f223c496a71);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range50", () => $8b8adca400ca855b$export$6244798137efca9);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range60", () => $8b8adca400ca855b$export$72d20d5426576de3);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range70", () => $8b8adca400ca855b$export$5f909f40ccaa6cc4);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range80", () => $8b8adca400ca855b$export$3e47cc0b9b14ad09);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range90", () => $8b8adca400ca855b$export$36569f0f035d32d1);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries2Range100", () => $8b8adca400ca855b$export$574e12a52c1b3e12);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range10", () => $8b8adca400ca855b$export$74d6e4fad4bb88bf);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range20", () => $8b8adca400ca855b$export$189fbb2766493c36);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range30", () => $8b8adca400ca855b$export$428da89f5a98a232);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range40", () => $8b8adca400ca855b$export$60edf238c6afd1e6);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range50", () => $8b8adca400ca855b$export$67e9edd6baebfbce);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range60", () => $8b8adca400ca855b$export$ec3d0a210a5d4c2c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range70", () => $8b8adca400ca855b$export$f776cf7a0a505749);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range80", () => $8b8adca400ca855b$export$61698398be922542);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range90", () => $8b8adca400ca855b$export$99028bd1491db588);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries3Range100", () => $8b8adca400ca855b$export$f0236e2c2ceff476);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range10", () => $8b8adca400ca855b$export$f944771630b59cb5);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range20", () => $8b8adca400ca855b$export$cf875bcb83eeef36);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range30", () => $8b8adca400ca855b$export$d22935b11cd2da96);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range40", () => $8b8adca400ca855b$export$c09b5156af934baf);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range50", () => $8b8adca400ca855b$export$cd03abab8825767c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range60", () => $8b8adca400ca855b$export$49d39abb22350b45);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range70", () => $8b8adca400ca855b$export$2e409639998b526b);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range80", () => $8b8adca400ca855b$export$7431a515da39af8c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range90", () => $8b8adca400ca855b$export$f34384d6e022c3f3);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries4Range100", () => $8b8adca400ca855b$export$10372af809834eae);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range10", () => $8b8adca400ca855b$export$a6eae9e7146720fd);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range20", () => $8b8adca400ca855b$export$1645795e3158abbf);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range30", () => $8b8adca400ca855b$export$cb63dd0ef69328da);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range40", () => $8b8adca400ca855b$export$8906d6ccc1d3cf97);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range50", () => $8b8adca400ca855b$export$9705a2ef585a5a6c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range60", () => $8b8adca400ca855b$export$9a4904530e74d69b);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range70", () => $8b8adca400ca855b$export$84fa53d9957f1633);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range80", () => $8b8adca400ca855b$export$261cc78142a16d2e);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range90", () => $8b8adca400ca855b$export$84de24a511e4409e);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries5Range100", () => $8b8adca400ca855b$export$c5da345c40af16d0);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range10", () => $8b8adca400ca855b$export$1a43e24e8356aef8);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range20", () => $8b8adca400ca855b$export$80cf8aa12b9a81d3);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range30", () => $8b8adca400ca855b$export$f060dd68476cd8e7);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range40", () => $8b8adca400ca855b$export$e439d3dd32b46274);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range50", () => $8b8adca400ca855b$export$a300ce07e8f90e40);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range60", () => $8b8adca400ca855b$export$a1ef18e9668adce2);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range70", () => $8b8adca400ca855b$export$6bc2d1ae052bf51c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range80", () => $8b8adca400ca855b$export$356c38cc88c30e38);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range90", () => $8b8adca400ca855b$export$4448f063fed043bf);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries6Range100", () => $8b8adca400ca855b$export$28182ad30600cb65);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range10", () => $8b8adca400ca855b$export$b0f38d080d1f8f97);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range20", () => $8b8adca400ca855b$export$abd8f528d3152ac4);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range30", () => $8b8adca400ca855b$export$6314df582966a22f);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range40", () => $8b8adca400ca855b$export$21214bfe4d7ae8b7);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range50", () => $8b8adca400ca855b$export$2b5f8a9ddff4d5c4);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range60", () => $8b8adca400ca855b$export$b63bfe40c28df8c8);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range70", () => $8b8adca400ca855b$export$a288b1bef1f363d6);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range80", () => $8b8adca400ca855b$export$ca2242167f4cec64);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range90", () => $8b8adca400ca855b$export$bb1d5655a98e9de6);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries7Range100", () => $8b8adca400ca855b$export$113cda6f600a4ca4);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range10", () => $8b8adca400ca855b$export$8ec4c1f865bc4296);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range20", () => $8b8adca400ca855b$export$80f831c9571e7721);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range30", () => $8b8adca400ca855b$export$7baea4598e0903db);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range40", () => $8b8adca400ca855b$export$85cc5b9d5a5e8f07);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range50", () => $8b8adca400ca855b$export$c16430852d6ffb13);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range60", () => $8b8adca400ca855b$export$76289a8af80837cf);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range70", () => $8b8adca400ca855b$export$52b981bfeaa81760);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range80", () => $8b8adca400ca855b$export$8e617b33cbf4490c);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range90", () => $8b8adca400ca855b$export$a1aa25fd6a117918);
$parcel$export($8b8adca400ca855b$exports, "chartsColorSeries8Range100", () => $8b8adca400ca855b$export$f01739baaf9b181d);
$parcel$export($8b8adca400ca855b$exports, "chartsColorBorderBar", () => $8b8adca400ca855b$export$d90969089c78ff1a);
$parcel$export($8b8adca400ca855b$exports, "chartsColorBorderAxis", () => $8b8adca400ca855b$export$fcb89087e092a414);
$parcel$export($8b8adca400ca855b$exports, "chartsFontFamilyLabel", () => $8b8adca400ca855b$export$9bbe1e2e7d502781);
$parcel$export($8b8adca400ca855b$exports, "chartsFontWeightLabel", () => $8b8adca400ca855b$export$4a1d1c93af63034c);
$parcel$export($8b8adca400ca855b$exports, "chartsFontSizeLabel", () => $8b8adca400ca855b$export$440443a29ae7f444);
$parcel$export($8b8adca400ca855b$exports, "chartsLetterSpacingLabel", () => $8b8adca400ca855b$export$d87dd6c52509ab1c);
$parcel$export($8b8adca400ca855b$exports, "chartsLineHeightLabel", () => $8b8adca400ca855b$export$3f3169f0677cff68);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgStaticSubtle", () => $8b8adca400ca855b$export$5e89ca37329331db);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgStaticNeutral", () => $8b8adca400ca855b$export$2d683b41f8da6ca4);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgStaticEmphasis", () => $8b8adca400ca855b$export$73731597f6e69c9d);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveSubtleDefault", () => $8b8adca400ca855b$export$c927c3e959fbe8b);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveSubtleHover", () => $8b8adca400ca855b$export$a0f7cf38a8a00f2b);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveSubtleFocus", () => $8b8adca400ca855b$export$29f6789a57993025);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$4ec39546e154299);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$3f64927d3a4eb9ea);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveNeutralDefault", () => $8b8adca400ca855b$export$cfdc6390a7fab5c8);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveNeutralHover", () => $8b8adca400ca855b$export$65e1e963096c903);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveNeutralFocus", () => $8b8adca400ca855b$export$6241dacc1b50fceb);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$fdbf6d5d010addf8);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$50b1b763cf3e7ade);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$40362ccc2bdb3c26);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveEmphasisHover", () => $8b8adca400ca855b$export$c204c1784cc516d0);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$2365ee05eae2bf7f);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$647245f05226e9f7);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$794da0ddda9a3107);
$parcel$export($8b8adca400ca855b$exports, "numberColorBgErrorSubtle", () => $8b8adca400ca855b$export$739a8d1bcdc7839d);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderStaticSubtle", () => $8b8adca400ca855b$export$94e174e73f70f159);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderStaticNeutral", () => $8b8adca400ca855b$export$788d135191815d53);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderStaticEmphasis", () => $8b8adca400ca855b$export$2f7f338c6ca49382);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveSubtleDefault", () => $8b8adca400ca855b$export$48e34a2ffe6a00d7);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveSubtleHover", () => $8b8adca400ca855b$export$22ef0123e9b7779c);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveSubtleFocus", () => $8b8adca400ca855b$export$606938ff76eef7ca);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$c46a37e46831cb73);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$59052749eca57609);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveNeutralDefault", () => $8b8adca400ca855b$export$dd96312fb32772ab);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveNeutralHover", () => $8b8adca400ca855b$export$eed6b1452607cf56);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveNeutralFocus", () => $8b8adca400ca855b$export$acced8db4ae2cf3b);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$77b24f6d99070e59);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$b34450f407ef29c6);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$ac70beace51d0dd4);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveEmphasisHover", () => $8b8adca400ca855b$export$5c9eeed4e201b90e);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$f49ed7789dc61221);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$ddf2fa79327928f);
$parcel$export($8b8adca400ca855b$exports, "numberColorBorderInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$f77baad962a57c8f);
$parcel$export($8b8adca400ca855b$exports, "numberColorTextStaticSubtle", () => $8b8adca400ca855b$export$98ddb5e8ed3aa914);
$parcel$export($8b8adca400ca855b$exports, "numberColorTextStaticNeutral", () => $8b8adca400ca855b$export$1530dbd1b63da1da);
$parcel$export($8b8adca400ca855b$exports, "numberColorTextStaticEmphasis", () => $8b8adca400ca855b$export$9d2d9318edad804e);
$parcel$export($8b8adca400ca855b$exports, "numberColorTextInteractiveSubtle", () => $8b8adca400ca855b$export$a83f4a80f6994355);
$parcel$export($8b8adca400ca855b$exports, "numberColorTextError", () => $8b8adca400ca855b$export$72489d62081edb03);
$parcel$export($8b8adca400ca855b$exports, "numberBorderRadiusDefault", () => $8b8adca400ca855b$export$266ec36a94b31c7b);
$parcel$export($8b8adca400ca855b$exports, "numberBorderRadiusRound", () => $8b8adca400ca855b$export$1600af1791f8b4f);
$parcel$export($8b8adca400ca855b$exports, "numberBorderWidthDefault", () => $8b8adca400ca855b$export$914b4b6244542bbf);
$parcel$export($8b8adca400ca855b$exports, "numberBorderWidthOutlined", () => $8b8adca400ca855b$export$44d950c57bc9d93);
$parcel$export($8b8adca400ca855b$exports, "numberFontFamily", () => $8b8adca400ca855b$export$be2a9d19912bffe8);
$parcel$export($8b8adca400ca855b$exports, "numberFontWeight", () => $8b8adca400ca855b$export$95492bbb433b5945);
$parcel$export($8b8adca400ca855b$exports, "numberLetterSpacing", () => $8b8adca400ca855b$export$761832cf77cf363a);
$parcel$export($8b8adca400ca855b$exports, "numberFontSizeMedium", () => $8b8adca400ca855b$export$b0eb4ef8cfa78960);
$parcel$export($8b8adca400ca855b$exports, "numberFontSizeSmall", () => $8b8adca400ca855b$export$fed43e5dcd48f2dc);
$parcel$export($8b8adca400ca855b$exports, "numberFontSizeInput", () => $8b8adca400ca855b$export$ae8f35fee23fdd6b);
$parcel$export($8b8adca400ca855b$exports, "numberLineHeightInput", () => $8b8adca400ca855b$export$8862b9c5fc58c4fc);
$parcel$export($8b8adca400ca855b$exports, "numberLineHeightSmall", () => $8b8adca400ca855b$export$50a8a424d0152755);
$parcel$export($8b8adca400ca855b$exports, "numberLineHeightMedium", () => $8b8adca400ca855b$export$bc28f5283ef6ba98);
$parcel$export($8b8adca400ca855b$exports, "numberHeightS", () => $8b8adca400ca855b$export$291904bb2e85d148);
$parcel$export($8b8adca400ca855b$exports, "numberHeightM", () => $8b8adca400ca855b$export$daf145493ab9a6de);
$parcel$export($8b8adca400ca855b$exports, "numberHeightInput", () => $8b8adca400ca855b$export$415502a94bbbbee6);
$parcel$export($8b8adca400ca855b$exports, "numberPaddingS", () => $8b8adca400ca855b$export$465097bd75bdea60);
$parcel$export($8b8adca400ca855b$exports, "numberPaddingM", () => $8b8adca400ca855b$export$42d141f7fb68da3c);
$parcel$export($8b8adca400ca855b$exports, "numberPaddingInput", () => $8b8adca400ca855b$export$5584196c725943b3);
$parcel$export($8b8adca400ca855b$exports, "numberMinWidthS", () => $8b8adca400ca855b$export$118d0bac41bf5c6f);
$parcel$export($8b8adca400ca855b$exports, "numberMinWidthM", () => $8b8adca400ca855b$export$b998fc4e363ee792);
$parcel$export($8b8adca400ca855b$exports, "numberMinWidthInput", () => $8b8adca400ca855b$export$c30418f3955f4770);
$parcel$export($8b8adca400ca855b$exports, "stepperSpaceBetween", () => $8b8adca400ca855b$export$c511e0cf300b027a);
$parcel$export($8b8adca400ca855b$exports, "stepperPadding", () => $8b8adca400ca855b$export$54041063a1bf9d9f);
$parcel$export($8b8adca400ca855b$exports, "scrollbarSize", () => $8b8adca400ca855b$export$fd2f38d8a289271e);
$parcel$export($8b8adca400ca855b$exports, "scrollbarKnobColorBg", () => $8b8adca400ca855b$export$6c2cf414b9a8b02);
$parcel$export($8b8adca400ca855b$exports, "scrollbarBorderRadius", () => $8b8adca400ca855b$export$74e8af3218f82048);
$parcel$export($8b8adca400ca855b$exports, "scrollbarContainerColorBg", () => $8b8adca400ca855b$export$d631136dbd4f130);
$parcel$export($8b8adca400ca855b$exports, "scrollbarSpacePadding", () => $8b8adca400ca855b$export$91580955f5b11a78);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgStaticSubtle", () => $8b8adca400ca855b$export$2804a19e6721cd4d);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgStaticNeutral", () => $8b8adca400ca855b$export$cd2372d2a66c08ad);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgStaticEmphasis", () => $8b8adca400ca855b$export$8ef196ecc87f7934);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveSubtleDefault", () => $8b8adca400ca855b$export$af7cd107f275c02a);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveSubtleHover", () => $8b8adca400ca855b$export$8490f4d3874147a3);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveSubtleFocus", () => $8b8adca400ca855b$export$b7a95a89583d4770);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$6bc9aee632a0607d);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$efbbc87ef9efc62c);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveNeutralDefault", () => $8b8adca400ca855b$export$5500a3415a8200bf);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveNeutralHover", () => $8b8adca400ca855b$export$895d192a083edbcd);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveNeutralFocus", () => $8b8adca400ca855b$export$f8f9f853acd8dccc);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$a2b2fba0efcb64de);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$abb81216d8ead6d6);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$c18fc16fd6ce2893);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveEmphasisHover", () => $8b8adca400ca855b$export$9a9b411077d65d4);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$84ee0041f3b78053);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$e3ae326d33644c8f);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$f2093864c9741f6c);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBgInteractiveDisabled", () => $8b8adca400ca855b$export$50e035363ae06a71);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBorderStaticDefault", () => $8b8adca400ca855b$export$8d5f9203840e8cea);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBorderStaticBottomborderDefault", () => $8b8adca400ca855b$export$6429134805d4f7b2);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBorderStaticBottomborderInverse", () => $8b8adca400ca855b$export$47bc82913eb62f9a);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBorderInteractiveSelected", () => $8b8adca400ca855b$export$9a8ea6b0632902f8);
$parcel$export($8b8adca400ca855b$exports, "listItemColorBorderInteractiveDefault", () => $8b8adca400ca855b$export$9cea3abece3796dd);
$parcel$export($8b8adca400ca855b$exports, "listItemColorTextStatic", () => $8b8adca400ca855b$export$147f5a94c0d93a24);
$parcel$export($8b8adca400ca855b$exports, "listItemColorTextInteractive", () => $8b8adca400ca855b$export$30427793cdcc11f);
$parcel$export($8b8adca400ca855b$exports, "listItemColorTextInverse", () => $8b8adca400ca855b$export$8dd2be958a4f682c);
$parcel$export($8b8adca400ca855b$exports, "listItemColorTextDisabled", () => $8b8adca400ca855b$export$6941f05285867423);
$parcel$export($8b8adca400ca855b$exports, "listItemColorTextSelected", () => $8b8adca400ca855b$export$4b525576dbb2a4d);
$parcel$export($8b8adca400ca855b$exports, "listItemBorderWidthBottomSeparated", () => $8b8adca400ca855b$export$ad62b5a3f8569d6e);
$parcel$export($8b8adca400ca855b$exports, "listItemBorderWidthBottomDefault", () => $8b8adca400ca855b$export$946b06a7a267d247);
$parcel$export($8b8adca400ca855b$exports, "listItemHeightS", () => $8b8adca400ca855b$export$2400272ad19e2fe5);
$parcel$export($8b8adca400ca855b$exports, "listItemHeightM", () => $8b8adca400ca855b$export$993c88baafc7364);
$parcel$export($8b8adca400ca855b$exports, "listItemHeightL", () => $8b8adca400ca855b$export$9bebe7546b06ea6b);
$parcel$export($8b8adca400ca855b$exports, "listItemSpaceDense", () => $8b8adca400ca855b$export$e1d34ffbb73e4967);
$parcel$export($8b8adca400ca855b$exports, "listItemSpaceDefault", () => $8b8adca400ca855b$export$6c9ea1231c05ae2);
$parcel$export($8b8adca400ca855b$exports, "listItemSpaceSpacious", () => $8b8adca400ca855b$export$34e1f4c8e40a4ed4);
$parcel$export($8b8adca400ca855b$exports, "listItemRadiusDefault", () => $8b8adca400ca855b$export$6f5f0ec032a5cd2a);
$parcel$export($8b8adca400ca855b$exports, "popoverWidthM", () => $8b8adca400ca855b$export$3533b594e8a22e61);
$parcel$export($8b8adca400ca855b$exports, "popoverWidthL", () => $8b8adca400ca855b$export$3162d64b8e7996c0);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveSubtleDefault", () => $8b8adca400ca855b$export$904c18abb803aa9f);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveSubtleHover", () => $8b8adca400ca855b$export$cfbe570aaf4a5b77);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveSubtleFocus", () => $8b8adca400ca855b$export$ac0e121c105675cd);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$9e386e8d2c73a924);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$63daf5c1ff2410fd);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveNeutralDefault", () => $8b8adca400ca855b$export$2167e31118bb40d7);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveNeutralHover", () => $8b8adca400ca855b$export$966b83fbdad8ff13);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveNeutralFocus", () => $8b8adca400ca855b$export$c06450425bd9035c);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$ddde5722037bdb1a);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$544f4daa03c97c0c);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveDisabled", () => $8b8adca400ca855b$export$633198cc99623271);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$fbbb4a5d1412c3f3);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveEmphasisHover", () => $8b8adca400ca855b$export$35db974a8b01923c);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$42938dc8e4554ca);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$4a1178fab316a183);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$c114ec50f0f18b26);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgStaticSubtle", () => $8b8adca400ca855b$export$f5465bf2d3de925d);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgStaticNeutral", () => $8b8adca400ca855b$export$6053f363b9ebffff);
$parcel$export($8b8adca400ca855b$exports, "cardColorBgStaticEmphasis", () => $8b8adca400ca855b$export$f3f16eb733cd113b);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveEmphasisDefault", () => $8b8adca400ca855b$export$f49a1acfc2525900);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveEmphasisHover", () => $8b8adca400ca855b$export$514e04a8b12a1404);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveEmphasisFocus", () => $8b8adca400ca855b$export$95733713edee3c14);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveEmphasisSelectedDefault", () => $8b8adca400ca855b$export$28932b8bfce45f38);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveEmphasisSelectedHover", () => $8b8adca400ca855b$export$edce63b38f08b44d);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveSubtleDefault", () => $8b8adca400ca855b$export$fa6c9f7aabe0a2e2);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveSubtleHover", () => $8b8adca400ca855b$export$623652b8691265a);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveSubtleFocus", () => $8b8adca400ca855b$export$b8ffe5941b3130ba);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$18e765ec8d586da3);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$36f1da88e0a16b94);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveNeutralDefault", () => $8b8adca400ca855b$export$bbe5df2b165b1606);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveNeutralHover", () => $8b8adca400ca855b$export$67562899c4dd8d01);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveNeutralFocus", () => $8b8adca400ca855b$export$c0908d88aaa39084);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$2035a1d319e4a134);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$290823ff5c4d6a31);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderInteractiveDisabled", () => $8b8adca400ca855b$export$9a7c2ed2267bf628);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderStaticSubtle", () => $8b8adca400ca855b$export$7d32452142f66e8);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderStaticNeutral", () => $8b8adca400ca855b$export$91106c4c34773b8b);
$parcel$export($8b8adca400ca855b$exports, "cardColorBorderStaticEmphasis", () => $8b8adca400ca855b$export$78ccf4c9305987f2);
$parcel$export($8b8adca400ca855b$exports, "cardSpaceDense", () => $8b8adca400ca855b$export$9fb0c8224ca90269);
$parcel$export($8b8adca400ca855b$exports, "cardSpaceDefault", () => $8b8adca400ca855b$export$f38773b397c64fe3);
$parcel$export($8b8adca400ca855b$exports, "cardSpaceSpacious", () => $8b8adca400ca855b$export$68dfe0e438ed927f);
$parcel$export($8b8adca400ca855b$exports, "cardBorderWidthDefault", () => $8b8adca400ca855b$export$6b1192f8dbbe8ca4);
$parcel$export($8b8adca400ca855b$exports, "cardBorderWidthNone", () => $8b8adca400ca855b$export$9006004e350aae36);
$parcel$export($8b8adca400ca855b$exports, "cardBorderRadiusDefault", () => $8b8adca400ca855b$export$4933986e86984502);
$parcel$export($8b8adca400ca855b$exports, "cardBorderRadiusSharp", () => $8b8adca400ca855b$export$a08a5ca1c9e2d77);
$parcel$export($8b8adca400ca855b$exports, "cardBorderRadiusRound", () => $8b8adca400ca855b$export$4428090006cc5e8f);
$parcel$export($8b8adca400ca855b$exports, "cardBoxShadowDefault", () => $8b8adca400ca855b$export$6b437ae17434a562);
$parcel$export($8b8adca400ca855b$exports, "cardBoxShadowFloating", () => $8b8adca400ca855b$export$e439e7a9a522c8bd);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveSubtleDefault", () => $8b8adca400ca855b$export$f6f9c9aa81f0acb9);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveSubtleHover", () => $8b8adca400ca855b$export$5707e412b97a3d17);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveSubtleFocus", () => $8b8adca400ca855b$export$7ee0f670470f616e);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveSubtleSelectedDefault", () => $8b8adca400ca855b$export$602a5bdac5f15cd4);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveSubtleSelectedHover", () => $8b8adca400ca855b$export$a4b65a2a4760aa2e);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveNeutralDefault", () => $8b8adca400ca855b$export$99b6fb3a8cddfde2);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveNeutralHover", () => $8b8adca400ca855b$export$6f41d812463dcc26);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveNeutralFocus", () => $8b8adca400ca855b$export$bd26b519eb710637);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveNeutralSelectedDefault", () => $8b8adca400ca855b$export$8c129a8c71396c89);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveNeutralSelectedHover", () => $8b8adca400ca855b$export$ea53d93807b2be6c);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBgInteractiveDisabled", () => $8b8adca400ca855b$export$de181742c8a3a8ed);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBorderDefault", () => $8b8adca400ca855b$export$ac909337994ad4cc);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorBorderSelected", () => $8b8adca400ca855b$export$47cee41927ea7a65);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorTextStatic", () => $8b8adca400ca855b$export$29bf0efdf9aa6973);
$parcel$export($8b8adca400ca855b$exports, "treeItemColorTextDisabled", () => $8b8adca400ca855b$export$2a97efadeb1968eb);
$parcel$export($8b8adca400ca855b$exports, "treeItemSpaceDense", () => $8b8adca400ca855b$export$f074b54a1a690e59);
$parcel$export($8b8adca400ca855b$exports, "treeItemSpaceDefault", () => $8b8adca400ca855b$export$9f94c55002684827);
$parcel$export($8b8adca400ca855b$exports, "treeItemSpaceSpacious", () => $8b8adca400ca855b$export$ae05400eb6210b52);
$parcel$export($8b8adca400ca855b$exports, "treeItemBorderWidthBottom", () => $8b8adca400ca855b$export$8ea2eaf73829f82b);
$parcel$export($8b8adca400ca855b$exports, "treeItemBorderWidthDefault", () => $8b8adca400ca855b$export$5ead36882857d7b8);
/**
 * Do not edit directly
 * Generated on Fri, 06 Jun 2025 12:28:39 GMT
 */ const $8b8adca400ca855b$export$47532a6f57be45d9 = "700";
const $8b8adca400ca855b$export$740ac66abb38bb83 = "600";
const $8b8adca400ca855b$export$90168a3412ee7f0c = "400";
const $8b8adca400ca855b$export$9b985e69928d4804 = "linear-gradient(225deg, #FFF 0%, #F2F4F9 35.41%, #E7F1F6 100%);";
const $8b8adca400ca855b$export$6e4689b7cf6aeadb = "linear-gradient(132deg, #F0F3FA 0%, #FBFCFF 100%);";
const $8b8adca400ca855b$export$c473f2d55633c7bf = "linear-gradient(132deg, #29333D 0%, #001C33 100%);";
const $8b8adca400ca855b$export$bf51732c1e402305 = "hsl(202, 100%, 30%)";
const $8b8adca400ca855b$export$dd6ac6c529280b28 = "hsl(202, 100%, 40%)";
const $8b8adca400ca855b$export$628bc4cedab3f39c = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$12d92729ec24385a = "hsl(169, 82%, 33%)";
const $8b8adca400ca855b$export$4a7539ac23adfb7a = "hsl(346, 37%, 33%)";
const $8b8adca400ca855b$export$fb8a8a98f73ce6b1 = "hsl(346, 37%, 43%)";
const $8b8adca400ca855b$export$60723b7193f02e02 = "hsl(151, 46%, 17%)";
const $8b8adca400ca855b$export$795334c6456d2730 = "hsl(151, 46%, 27%)";
const $8b8adca400ca855b$export$da6517e7d9c36003 = "hsl(266, 63%, 35%)";
const $8b8adca400ca855b$export$3b7ffecbd7cc9aeb = "hsl(266, 63%, 45%)";
const $8b8adca400ca855b$export$2c3279dd523ce91e = "hsl(36, 77%, 30%)";
const $8b8adca400ca855b$export$a32ed79b0c9f894d = "hsl(36, 77%, 40%)";
const $8b8adca400ca855b$export$364c018f7a909db3 = "hsl(36, 97%, 60%)";
const $8b8adca400ca855b$export$5f85a6a7c51d6890 = "hsl(36, 97%, 70%)";
const $8b8adca400ca855b$export$436b1e2e43974ada = "hsl(301, 73%, 65%)";
const $8b8adca400ca855b$export$a9aeb5d8dac66b57 = "hsl(301, 73%, 75%)";
const $8b8adca400ca855b$export$684e73d930ab653c = "hsl(30, 70%, 10%)";
const $8b8adca400ca855b$export$1181582ac6088c50 = "hsl(30, 70%, 20%)";
const $8b8adca400ca855b$export$b2d49d7677da6748 = "hsl(30, 70%, 30%)";
const $8b8adca400ca855b$export$b6a1b5443e554bac = "hsl(30, 70%, 40%)";
const $8b8adca400ca855b$export$3b8a5dc0c17f71c2 = "hsl(30, 70%, 50%)";
const $8b8adca400ca855b$export$8b7438de76999a40 = "hsl(30, 70%, 60%)";
const $8b8adca400ca855b$export$2b5d6b20a9c67c77 = "hsl(30, 70%, 70%)";
const $8b8adca400ca855b$export$5afcf229520f3e = "hsl(30, 70%, 82%)";
const $8b8adca400ca855b$export$d61e61546d5dbc3b = "hsl(30, 70%, 86%)";
const $8b8adca400ca855b$export$5acbd671bcb55bbc = "hsl(30, 70%, 88%)";
const $8b8adca400ca855b$export$ae55d2493bfc2288 = "hsl(30, 70%, 90%)";
const $8b8adca400ca855b$export$d92f008db791081b = "hsl(30, 70%, 92%)";
const $8b8adca400ca855b$export$16492d98578c318 = "hsl(30, 70%, 96%)";
const $8b8adca400ca855b$export$3a485bc73a43c0d = "hsl(30, 70%, 98%)";
const $8b8adca400ca855b$export$73c61615faaec16d = "hsl(150, 50%, 10%)";
const $8b8adca400ca855b$export$f61d2734a97ec44d = "hsl(150, 50%, 20%)";
const $8b8adca400ca855b$export$db59b2d9d3b8f23 = "hsl(150, 50%, 30%)";
const $8b8adca400ca855b$export$2fc86281a892e4e9 = "hsl(150, 50%, 40%)";
const $8b8adca400ca855b$export$65018fb6acb6e9e = "hsl(150, 50%, 50%)";
const $8b8adca400ca855b$export$6f52551cdcf848f2 = "hsl(150, 50%, 60%)";
const $8b8adca400ca855b$export$8717c4e3eb9150e5 = "hsl(150, 50%, 70%)";
const $8b8adca400ca855b$export$c83198aa8943b17f = "hsl(150, 50%, 82%)";
const $8b8adca400ca855b$export$8c35a5b2f64f36d = "hsl(150, 50%, 86%)";
const $8b8adca400ca855b$export$6ff44857ae98393 = "hsl(150, 50%, 88%)";
const $8b8adca400ca855b$export$8fc5d73ef8daa081 = "hsl(150, 50%, 90%)";
const $8b8adca400ca855b$export$ca9d34853847d885 = "hsl(150, 50%, 92%)";
const $8b8adca400ca855b$export$5e3d63bd09e2adfa = "hsl(150, 50%, 96%)";
const $8b8adca400ca855b$export$a31d2a5d6f4951c3 = "hsl(150, 50%, 98%)";
const $8b8adca400ca855b$export$2fa8052ddbf692db = "hsl(350, 70%, 10%)";
const $8b8adca400ca855b$export$5ae3653bea2f6002 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$ebe209ab71dc9900 = "hsl(350, 70%, 30%)";
const $8b8adca400ca855b$export$9a86551a13d806cb = "hsl(350, 70%, 40%)";
const $8b8adca400ca855b$export$c10c79645b27877d = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$3162b4069185c8ae = "hsl(350, 70%, 60%)";
const $8b8adca400ca855b$export$b001b9d8cf2ddf0c = "hsl(350, 70%, 70%)";
const $8b8adca400ca855b$export$2bcac13af88081c8 = "hsl(350, 70%, 82%)";
const $8b8adca400ca855b$export$72d98e4ddcb0af1b = "hsl(350, 70%, 86%)";
const $8b8adca400ca855b$export$45fc9997e1ebd965 = "hsl(350, 70%, 88%)";
const $8b8adca400ca855b$export$f8218d553727ff09 = "hsl(350, 70%, 90%)";
const $8b8adca400ca855b$export$c31b4867424b9387 = "hsl(350, 70%, 92%)";
const $8b8adca400ca855b$export$6c46c4d114584df1 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$4bd1bc01799161bf = "hsl(350, 70%, 98%)";
const $8b8adca400ca855b$export$b68a36b2c4312600 = "hsl(50, 70%, 10%)";
const $8b8adca400ca855b$export$bf9058acbc7e0c03 = "hsl(50, 70%, 20%)";
const $8b8adca400ca855b$export$af58e6c4e06fba1e = "hsl(50, 70%, 30%)";
const $8b8adca400ca855b$export$f5c847ebf0c3830d = "hsl(50, 70%, 40%)";
const $8b8adca400ca855b$export$d65df8bd9766ab30 = "hsl(50, 70%, 50%)";
const $8b8adca400ca855b$export$6dea6221146a7695 = "hsl(50, 70%, 60%)";
const $8b8adca400ca855b$export$97794df832fa9246 = "hsl(50, 70%, 70%)";
const $8b8adca400ca855b$export$37a6ad6644a76e8e = "hsl(50, 70%, 82%)";
const $8b8adca400ca855b$export$b2cc4270764e0d91 = "hsl(50, 70%, 86%)";
const $8b8adca400ca855b$export$145e03b0063171cf = "hsl(50, 70%, 88%)";
const $8b8adca400ca855b$export$2d9c2b11822ba826 = "hsl(50, 70%, 90%)";
const $8b8adca400ca855b$export$d06c19130b7b237c = "hsl(50, 70%, 92%)";
const $8b8adca400ca855b$export$d2a0a2228c20f625 = "hsl(50, 70%, 96%)";
const $8b8adca400ca855b$export$b1a4a810c6323520 = "hsl(50, 70%, 98%)";
const $8b8adca400ca855b$export$d5f6f1514cdd87e = "hsl(270, 50%, 10%)";
const $8b8adca400ca855b$export$abc0c049d1d05997 = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$e3e4f6af628aad6d = "hsl(270, 50%, 30%)";
const $8b8adca400ca855b$export$a93c9c9f412d3c5e = "hsl(270, 50%, 40%)";
const $8b8adca400ca855b$export$d73ff2918ee90459 = "hsl(270, 50%, 50%)";
const $8b8adca400ca855b$export$7c691d76a2faac9e = "hsl(270, 50%, 60%)";
const $8b8adca400ca855b$export$9ddac4fed8e0699e = "hsl(270, 50%, 70%)";
const $8b8adca400ca855b$export$70b4d49a036ffa16 = "hsl(270, 50%, 82%)";
const $8b8adca400ca855b$export$b6ae9037e4487ef7 = "hsl(270, 50%, 86%)";
const $8b8adca400ca855b$export$cdab03f0b3cedea7 = "hsl(270, 50%, 88%)";
const $8b8adca400ca855b$export$9a3940ef3e718482 = "hsl(270, 50%, 90%)";
const $8b8adca400ca855b$export$602a7aa90012bac7 = "hsl(270, 50%, 92%)";
const $8b8adca400ca855b$export$f9e1bb5a6ecf8fa1 = "hsl(270, 50%, 96%)";
const $8b8adca400ca855b$export$9665fc79e7ccde89 = "hsl(270, 50%, 98%)";
const $8b8adca400ca855b$export$415e2ab0a19e9f81 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$9ad9d3db52ccd355 = "hsl(210, 20%, 20%)";
const $8b8adca400ca855b$export$17b617ddb9836542 = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$664987001e0f2ea0 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$58adf4043506cd3a = "hsl(210, 20%, 50%)";
const $8b8adca400ca855b$export$d3adcc2d4402ccc9 = "hsl(210, 20%, 60%)";
const $8b8adca400ca855b$export$7155de5e23ab069b = "hsl(210, 20%, 70%)";
const $8b8adca400ca855b$export$41ee37b64344becb = "hsl(210, 20%, 82%)";
const $8b8adca400ca855b$export$9b88c99aa981baee = "hsl(210, 20%, 86%)";
const $8b8adca400ca855b$export$7c23125fd8a70a5a = "hsl(210, 20%, 88%)";
const $8b8adca400ca855b$export$a46d9e94ee27516a = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$57a7b6c7405c22fc = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$8c671b06252447da = "hsl(210, 20%, 96%)";
const $8b8adca400ca855b$export$905ab8f8acc3167f = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$df8147df7c327e97 = "#001c33";
const $8b8adca400ca855b$export$23afbb4232b3ac3a = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$5fcc389c3d56da1a = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$ae23f4fa1dd8e463 = "hsl(207, 100%, 40%)";
const $8b8adca400ca855b$export$6e85f1855ac4540b = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$8740b6c0177f90d2 = "hsl(207, 100%, 60%)";
const $8b8adca400ca855b$export$8c220e0ccc521b52 = "hsl(207, 100%, 70%)";
const $8b8adca400ca855b$export$694b034c84505cc0 = "hsl(207, 100%, 82%)";
const $8b8adca400ca855b$export$107dfa3b1934715e = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$a98a55e2124bd475 = "hsl(207, 100%, 88%)";
const $8b8adca400ca855b$export$c8bb10ac89484313 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$1ac92e121667df0a = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$416d4299ae18b901 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$3bf92297e3902f9c = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$db52f91b6e279a41 = "hsl(200, 30%, 10%)";
const $8b8adca400ca855b$export$c2bda980025d9828 = "hsl(200, 30%, 20%)";
const $8b8adca400ca855b$export$8ed151e7392922f7 = "hsl(200, 30%, 30%)";
const $8b8adca400ca855b$export$f0cf2df1783c1493 = "hsl(200, 30%, 40%)";
const $8b8adca400ca855b$export$c537f1eb6dbc51ff = "hsl(200, 30%, 50%)";
const $8b8adca400ca855b$export$63fb948eab7d44b0 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$b8bfc202936f7e3d = "hsl(200, 30%, 70%)";
const $8b8adca400ca855b$export$31ed9a0baa9a125c = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$fafb7a10ea280ee = "hsl(200, 30%, 86%)";
const $8b8adca400ca855b$export$b5c0ad53ffc9440b = "hsl(200, 30%, 88%)";
const $8b8adca400ca855b$export$6f8e87618ad20850 = "hsl(200, 30%, 90%)";
const $8b8adca400ca855b$export$b8ccb55082565c20 = "hsl(200, 30%, 92%)";
const $8b8adca400ca855b$export$c824d3ae1ea71c9d = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$aa19e6addb4fb53d = "hsl(200, 30%, 98%)";
const $8b8adca400ca855b$export$eaa1ebf3c9e3051b = "#ffffff";
const $8b8adca400ca855b$export$da7a3b2eb1ec75df = "0 5px 12px 2px rgba(0,0,0,0.11)";
const $8b8adca400ca855b$export$b585396ecd4c8629 = "0 10px 20px 0 rgba(0,0,0,0.2)";
const $8b8adca400ca855b$export$559abfde0b301430 = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $8b8adca400ca855b$export$dfa790552704c785 = "0 0 0 0 hsl(200, 30%, 86%)";
const $8b8adca400ca855b$export$98c600e1ecf01a39 = "0 1px 0 0 #F0F3FA";
const $8b8adca400ca855b$export$a162a9eb85be72b9 = "0 -8px 16px 0 rgba(0,0,0,0.16), 0 -1px 1px 0 rgba(0,0,0,0)";
const $8b8adca400ca855b$export$6e5fb3e2c7f33c2a = "Manrope";
const $8b8adca400ca855b$export$dba883712db4d3ed = "Sanchez";
const $8b8adca400ca855b$export$6be74618ebefea70 = "Roboto";
const $8b8adca400ca855b$export$958f16642186b219 = "'Sometype Mono'";
const $8b8adca400ca855b$export$b6c70790c67285f9 = "6px";
const $8b8adca400ca855b$export$48529bd7f04d40f0 = "8px";
const $8b8adca400ca855b$export$f362f70cc25d5976 = "10px";
const $8b8adca400ca855b$export$7399932c71904dd8 = "12px";
const $8b8adca400ca855b$export$1a8e4a85adfe8299 = "14px";
const $8b8adca400ca855b$export$afd7e4e7ae36c76e = "16px";
const $8b8adca400ca855b$export$e2c0f185f219e125 = "18px";
const $8b8adca400ca855b$export$76961812acfcaadb = "20px";
const $8b8adca400ca855b$export$36e9845aded52da1 = "22px";
const $8b8adca400ca855b$export$90605139ceb31cb5 = "24px";
const $8b8adca400ca855b$export$4f2f5bdc507d88ff = "26px";
const $8b8adca400ca855b$export$38351aa0f63e13f = "28px";
const $8b8adca400ca855b$export$e5fe57b4a2ace969 = "30px";
const $8b8adca400ca855b$export$eb2bc143b1eaba17 = "32px";
const $8b8adca400ca855b$export$c6aca45dbeea0b6e = "48px";
const $8b8adca400ca855b$export$522d048072fdd0 = 1.25;
const $8b8adca400ca855b$export$38ead138ec412471 = "0px";
const $8b8adca400ca855b$export$b4664877dc43b7af = "2px";
const $8b8adca400ca855b$export$8982cd794b105475 = "4px";
const $8b8adca400ca855b$export$4e217f5c9e1d122e = "100px";
const $8b8adca400ca855b$export$581a022593b37139 = "4px";
const $8b8adca400ca855b$export$6e08a028ea88caf = "8px";
const $8b8adca400ca855b$export$9d565ea29b9d4e = "12px";
const $8b8adca400ca855b$export$5aa522eb884d579d = "16px";
const $8b8adca400ca855b$export$8820cb29c786d91f = "20px";
const $8b8adca400ca855b$export$e76f8634e42fceed = "24px";
const $8b8adca400ca855b$export$df367bbd8d048c14 = "28px";
const $8b8adca400ca855b$export$49513a9a59edd2fb = "32px";
const $8b8adca400ca855b$export$ef900fdc121889a3 = "36px";
const $8b8adca400ca855b$export$83009f3ef2af8902 = "40px";
const $8b8adca400ca855b$export$e356db1a74a940f1 = "44px";
const $8b8adca400ca855b$export$633ffa248d03506c = "48px";
const $8b8adca400ca855b$export$ff1746fd06dfef9c = "52px";
const $8b8adca400ca855b$export$792f985e3c66b82b = "56px";
const $8b8adca400ca855b$export$39757bd68ed58bc0 = "68px";
const $8b8adca400ca855b$export$5d4ece470da030c2 = "176px";
const $8b8adca400ca855b$export$e812c4b6a0d31e02 = "276px";
const $8b8adca400ca855b$export$1667f6759fd4af1f = "300px";
const $8b8adca400ca855b$export$c79e5da71b43f2b7 = "376px";
const $8b8adca400ca855b$export$f09309c57f8ea8db = "424px";
const $8b8adca400ca855b$export$3686e91ef2d1609b = "576px";
const $8b8adca400ca855b$export$9a7d2330672d94da = "776px";
const $8b8adca400ca855b$export$69191e5d8403f6dc = "832px";
const $8b8adca400ca855b$export$c9bc626bcb9d1702 = "1280px";
const $8b8adca400ca855b$export$c2ebcb19507fa384 = "2px";
const $8b8adca400ca855b$export$28af25853b30f1d5 = "0px";
const $8b8adca400ca855b$export$cf8146011d39494a = "4px";
const $8b8adca400ca855b$export$eb07efa989de8fe5 = "8px";
const $8b8adca400ca855b$export$bf79319657db0f88 = "12px";
const $8b8adca400ca855b$export$5905f6dbe11e7b2c = "16px";
const $8b8adca400ca855b$export$dc0e9ba406ec1128 = "20px";
const $8b8adca400ca855b$export$48cdf13b4cc5ad3f = "24px";
const $8b8adca400ca855b$export$cef3435710b52199 = "28px";
const $8b8adca400ca855b$export$431b2083311a15ea = "32px";
const $8b8adca400ca855b$export$b098505ff1a5f952 = "36px";
const $8b8adca400ca855b$export$d39e18acdfc94a45 = "40px";
const $8b8adca400ca855b$export$4d09869bf749903e = "44px";
const $8b8adca400ca855b$export$8ea49e0388a60a62 = "48px";
const $8b8adca400ca855b$export$6819254900b8d1cf = "52px";
const $8b8adca400ca855b$export$8b1552f580e06aac = "56px";
const $8b8adca400ca855b$export$f7e6e8df6820a759 = "60px";
const $8b8adca400ca855b$export$6b78519ba1b56b20 = "64px";
const $8b8adca400ca855b$export$aa21579cea294b7a = "2px";
const $8b8adca400ca855b$export$af88d6b81a19ff0a = "6px";
const $8b8adca400ca855b$export$a7fa5cf4f467a7a3 = "8px";
const $8b8adca400ca855b$export$19e367993efb2a85 = "10px";
const $8b8adca400ca855b$export$c0dbfa2a9de4cf2b = "12px";
const $8b8adca400ca855b$export$7db4d44897db3aae = "14px";
const $8b8adca400ca855b$export$77fa12a7f6088e8a = "16px";
const $8b8adca400ca855b$export$88f405f990d50798 = "20px";
const $8b8adca400ca855b$export$70eddb9c5b448a1e = "24px";
const $8b8adca400ca855b$export$cfed16d4b5ca2dea = "30px";
const $8b8adca400ca855b$export$1d5778bc4ba49de3 = "40px";
const $8b8adca400ca855b$export$6b8537e4a6c85699 = "50px";
const $8b8adca400ca855b$export$89c52c27197613ea = "60px";
const $8b8adca400ca855b$export$a8475dc9cbba9136 = "70px";
const $8b8adca400ca855b$export$287eb463b205f73b = "0";
const $8b8adca400ca855b$export$98aa6b13aaaaaed4 = "none";
const $8b8adca400ca855b$export$c3b12835a35a3ebc = "none";
const $8b8adca400ca855b$export$78cf32b6248297d8 = "underline";
const $8b8adca400ca855b$export$90cf649d4bdde151 = "0px";
const $8b8adca400ca855b$export$8eed865464cb9443 = "1px";
const $8b8adca400ca855b$export$5d966ef1a668534d = "2px";
const $8b8adca400ca855b$export$1fde20e337d78057 = "#082b25";
const $8b8adca400ca855b$export$8ab6bac2cfbaa311 = "#0f574b";
const $8b8adca400ca855b$export$7c3268c1e9449b23 = "#178270";
const $8b8adca400ca855b$export$ac2cb8d286cd282d = "#1fad96";
const $8b8adca400ca855b$export$afe30047fb949ada = "#26d9bb";
const $8b8adca400ca855b$export$bedb631b11c40714 = "#52e0c9";
const $8b8adca400ca855b$export$cbb4e1767cbcc295 = "#7de8d6";
const $8b8adca400ca855b$export$1ea24c91b8d25363 = "#a8f0e4";
const $8b8adca400ca855b$export$e48c1ae9f703ec3 = "#d4f7f1";
const $8b8adca400ca855b$export$3b66de443e6ecd2d = "#0f1624";
const $8b8adca400ca855b$export$d1b7eb4ab1109f37 = "#1f2c47";
const $8b8adca400ca855b$export$6fcf2bd98a8c3471 = "#2e426b";
const $8b8adca400ca855b$export$854fd1fca212ac66 = "#3d588f";
const $8b8adca400ca855b$export$94792cfe955edc7c = "#4d6fb3";
const $8b8adca400ca855b$export$a03199dd35bdd04c = "#708bc2";
const $8b8adca400ca855b$export$c2de267ef50b3959 = "#94a8d1";
const $8b8adca400ca855b$export$cbb9699552d08e72 = "#b8c5e0";
const $8b8adca400ca855b$export$926bc41ea4705265 = "#dbe2f0";
const $8b8adca400ca855b$export$654ed5d813f21dec = "#e2e8f3";
const $8b8adca400ca855b$export$69f18349c11e1ae6 = "#260d26";
const $8b8adca400ca855b$export$2ad4e0257e372740 = "#4d1a4d";
const $8b8adca400ca855b$export$e87f916bb6428820 = "#732673";
const $8b8adca400ca855b$export$c0c1b77517485090 = "#939";
const $8b8adca400ca855b$export$8239eaa50a0a5f95 = "#bf40bf";
const $8b8adca400ca855b$export$77be4f078e816c57 = "#c6c";
const $8b8adca400ca855b$export$92d17db692dfdb26 = "#d98cd9";
const $8b8adca400ca855b$export$198155ce03982d4b = "#e6b3e6";
const $8b8adca400ca855b$export$1eaa04001df46302 = "#f2d9f2";
const $8b8adca400ca855b$export$46520cc5cc636d5 = "#F3FDFE";
const $8b8adca400ca855b$export$65b52ee8779cfb86 = "#E7FBFE";
const $8b8adca400ca855b$export$15103e7803509654 = "#CEF6FD";
const $8b8adca400ca855b$export$e1e0f831fb8ef956 = "#9EEDFC";
const $8b8adca400ca855b$export$cab8599dbbafe6f0 = "#00B5D1";
const $8b8adca400ca855b$export$eb1ba29c8ee4ce89 = "#0F98AE";
const $8b8adca400ca855b$export$b317de730274ad6d = "#147A8B";
const $8b8adca400ca855b$export$688aa6f257feb3f4 = "#105B69";
const $8b8adca400ca855b$export$5bb5e616682f7dfd = "#073C46";
const $8b8adca400ca855b$export$6f48b50d16c41924 = "#011D23";
const $8b8adca400ca855b$export$8658174a5a26d8c8 = "#EDE3F6";
const $8b8adca400ca855b$export$94cf89e29828b90d = "#D9C8E5";
const $8b8adca400ca855b$export$fe800a881fbd2a17 = "#C6ACD4";
const $8b8adca400ca855b$export$86e5c257800b1ba7 = "#B390C3";
const $8b8adca400ca855b$export$efcc76822b16de0 = "#A273B2";
const $8b8adca400ca855b$export$e35506918d293b2d = "#9253A1";
const $8b8adca400ca855b$export$b80547edfe0328fa = "#643479";
const $8b8adca400ca855b$export$6f80192eefeaa148 = "#3A1750";
const $8b8adca400ca855b$export$8441530762eae6d3 = "#160428";
const $8b8adca400ca855b$export$90bc334d7aee9545 = "#FFD8F6";
const $8b8adca400ca855b$export$b3f1e6c576416c1d = "#FCB7E5";
const $8b8adca400ca855b$export$191c88ebca6ffe3c = "#F396D4";
const $8b8adca400ca855b$export$1f42ab64f4a83dee = "#E974C2";
const $8b8adca400ca855b$export$5fb6a51ed9b33fd0 = "#E04FAF";
const $8b8adca400ca855b$export$126413e9cf01d9cc = "#D6269B";
const $8b8adca400ca855b$export$a335b1f360803681 = "#A11C74";
const $8b8adca400ca855b$export$21e31efc7bd30562 = "#6B0D4C";
const $8b8adca400ca855b$export$82bb60d82e157db1 = "#350124";
const $8b8adca400ca855b$export$b583fe876073a2fe = "#DBF6CA";
const $8b8adca400ca855b$export$f4738750a09fc45 = "#3B770E";
const $8b8adca400ca855b$export$f892d1b579b087f5 = "#1D4405";
const $8b8adca400ca855b$export$a7461ee647c93d00 = "#FFEEEE";
const $8b8adca400ca855b$export$7a6939cbe6750292 = "#DE3131";
const $8b8adca400ca855b$export$f13b4f317c31e202 = "#6F1010";
const $8b8adca400ca855b$export$466eea952b10a8df = "#F8ECE7";
const $8b8adca400ca855b$export$3d73f527ec37353b = "#FFDAC4";
const $8b8adca400ca855b$export$848d0b3dbc4a58e9 = "#FFB892";
const $8b8adca400ca855b$export$67c22c804a444617 = "#FF9563";
const $8b8adca400ca855b$export$35c178005989be85 = "#DF5C24";
const $8b8adca400ca855b$export$d156763d5698483c = "#3A1404";
const $8b8adca400ca855b$export$1f3e8d28a4bc8087 = "#F0F3FA";
const $8b8adca400ca855b$export$533189fca2ec5a05 = "#5E728D";
const $8b8adca400ca855b$export$9a0d26ed3c25e7f = "#263146";
const $8b8adca400ca855b$export$732d133811ff729f = "#e5f4ff";
const $8b8adca400ca855b$export$2dd034e8857d984e = "#0070cc";
const $8b8adca400ca855b$export$83df2e97b19f7aba = "#005499";
const $8b8adca400ca855b$export$e84284477477fbb0 = "#053C60";
const $8b8adca400ca855b$export$94a8d52af3524619 = "#001D30";
const $8b8adca400ca855b$export$dde3540a7c52aa62 = "#FBFBFB";
const $8b8adca400ca855b$export$60dd899fb1fc8ebb = "#f5f5f5";
const $8b8adca400ca855b$export$b44ed74ac6c5e0b1 = "#F0F0EF";
const $8b8adca400ca855b$export$b45cfc1807a3979c = "#E2E2E1";
const $8b8adca400ca855b$export$20d695d1c7fa5d12 = "#C8C8C7";
const $8b8adca400ca855b$export$93394257d70d9c4b = "#AFAFAE";
const $8b8adca400ca855b$export$6ead472efe5cccf9 = "#AFAFAE";
const $8b8adca400ca855b$export$7345959dcc3f1249 = "#969695";
const $8b8adca400ca855b$export$f6fc60ebb1f0098d = "#7D7D7D";
const $8b8adca400ca855b$export$bb9c92dcc503d041 = "#646464";
const $8b8adca400ca855b$export$919b4cfa2a3431d7 = "#4B4B4B";
const $8b8adca400ca855b$export$3a932b816df19cf9 = "#323232";
const $8b8adca400ca855b$export$df6264b18306f8ce = "#191919";
const $8b8adca400ca855b$export$e306266450d339da = "0 0 0 0 hsl(200, 30%, 86%)";
const $8b8adca400ca855b$export$c727a326e5ac158d = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $8b8adca400ca855b$export$f124d9ef132d79f1 = "-8px 16px 0 rgba(0,0,0,0.16), 0 -1px 1px 0 rgba(0,0,0,0)";
const $8b8adca400ca855b$export$5ccfbbfe47595323 = "4px";
const $8b8adca400ca855b$export$20f5c07ae3856232 = "8px";
const $8b8adca400ca855b$export$c8bf6e81dacfc196 = "12px";
const $8b8adca400ca855b$export$99f6d89f34a0b1a0 = "16px";
const $8b8adca400ca855b$export$f2d0edabd04761fb = "20px";
const $8b8adca400ca855b$export$ed3a53feec192842 = "24px";
const $8b8adca400ca855b$export$8b69e23cdf44e5c4 = "28px";
const $8b8adca400ca855b$export$a5fd793e6ae66615 = "32px";
const $8b8adca400ca855b$export$67b8da528429660d = "36px";
const $8b8adca400ca855b$export$4895d0896c23a35a = "68px";
const $8b8adca400ca855b$export$c97d64ed641c0c68 = "176px";
const $8b8adca400ca855b$export$496884663027a953 = "276px";
const $8b8adca400ca855b$export$942a8415fd3bc2bd = "376px";
const $8b8adca400ca855b$export$d4dcd3e7a9f00b00 = "576px";
const $8b8adca400ca855b$export$ac6d8dd750e2b03d = "776px";
const $8b8adca400ca855b$export$ea8e199042cb733d = "1280px";
const $8b8adca400ca855b$export$9ec87d3ea06e00a5 = "36px";
const $8b8adca400ca855b$export$145590b199e7aa08 = "832px";
const $8b8adca400ca855b$export$ea53782885816cc4 = "56px";
const $8b8adca400ca855b$export$88fccbab69a23b50 = "44px";
const $8b8adca400ca855b$export$aeea69d04d385bac = "36px";
const $8b8adca400ca855b$export$1eed320f6fa53669 = "_global.size.half";
const $8b8adca400ca855b$export$170fa82b897b1027 = "0px";
const $8b8adca400ca855b$export$ce76584477c56c81 = "1px";
const $8b8adca400ca855b$export$59d5e2224353c9c = "2px";
const $8b8adca400ca855b$export$e878cf70517bf87d = "14px";
const $8b8adca400ca855b$export$ca532bde8b673674 = "24px";
const $8b8adca400ca855b$export$d35ad0b1db66aab = "16px";
const $8b8adca400ca855b$export$2c081aeb7c8eb547 = "18px";
const $8b8adca400ca855b$export$b538dbdb5cc993e2 = "12px";
const $8b8adca400ca855b$export$12bd9cd6158eeaff = "8px";
const $8b8adca400ca855b$export$87d099ffe187ede3 = "10px";
const $8b8adca400ca855b$export$45a9411d397e7014 = "32px";
const $8b8adca400ca855b$export$6441942a9191e8b = "26px";
const $8b8adca400ca855b$export$603bbc670bd6cdb7 = "22px";
const $8b8adca400ca855b$export$bd4d597b9a8478ef = "18px";
const $8b8adca400ca855b$export$33b4990036285dd4 = "400";
const $8b8adca400ca855b$export$94b8628301cfeba5 = "600";
const $8b8adca400ca855b$export$4251501a1fd96031 = "700";
const $8b8adca400ca855b$export$ec958139a7af2a8d = "Manrope";
const $8b8adca400ca855b$export$dfce6fb8007da48e = "Manrope";
const $8b8adca400ca855b$export$68b4938ddb45a8c0 = "Manrope";
const $8b8adca400ca855b$export$85da697736c3f546 = "10px";
const $8b8adca400ca855b$export$f6f08d75449b0f4f = "12px";
const $8b8adca400ca855b$export$32766a586f34b05b = "16px";
const $8b8adca400ca855b$export$4ecde25fa2a16515 = "50px";
const $8b8adca400ca855b$export$ad3e07fd3f6eb5e9 = "40px";
const $8b8adca400ca855b$export$191898ea266c6db3 = "30px";
const $8b8adca400ca855b$export$f7668923bd63f908 = "20px";
const $8b8adca400ca855b$export$dc1063802be71f6b = "14px";
const $8b8adca400ca855b$export$1e9bf329c53e42da = "400";
const $8b8adca400ca855b$export$8cebf529bc3d12cd = "400";
const $8b8adca400ca855b$export$d554c99af2e8701d = "700";
const $8b8adca400ca855b$export$7711684ec178da45 = 1.25;
const $8b8adca400ca855b$export$ea858f460f740237 = "16px";
const $8b8adca400ca855b$export$4b9604858cc8bf9b = "8px";
const $8b8adca400ca855b$export$5c216d07f6313f89 = "24px";
const $8b8adca400ca855b$export$31bcbabf8dd2f068 = "8px";
const $8b8adca400ca855b$export$c18af1c576b9134e = "16px";
const $8b8adca400ca855b$export$2139653de76670a8 = "4px";
const $8b8adca400ca855b$export$1f8b3d352ce76e2 = "_global.space.half";
const $8b8adca400ca855b$export$da181d9bc79e4a02 = "0px";
const $8b8adca400ca855b$export$6422537c35b745d9 = "2px";
const $8b8adca400ca855b$export$e77925bd46d7e15b = "4px";
const $8b8adca400ca855b$export$55ec15df2cced997 = "100px";
const $8b8adca400ca855b$export$53dad9b8590b2590 = "hsl(202, 100%, 40%)";
const $8b8adca400ca855b$export$2cfa48c35037e4cd = "hsl(202, 100%, 30%)";
const $8b8adca400ca855b$export$4cc965d0c8b21c5c = "hsl(202, 100%, 30%)";
const $8b8adca400ca855b$export$c5215a7e991b1930 = "hsl(202, 100%, 30%)";
const $8b8adca400ca855b$export$11f329bcb8162d0d = "hsl(202 100% 40% / 0.5)"; // Used for map pins
const $8b8adca400ca855b$export$403b382cc6844409 = "hsl(266, 63%, 45%)";
const $8b8adca400ca855b$export$deda6d87d502e7b9 = "hsl(266, 63%, 35%)";
const $8b8adca400ca855b$export$c74f5a5b20d20e6a = "hsl(266, 63%, 35%)";
const $8b8adca400ca855b$export$86b18e3169467eff = "hsl(266, 63%, 35%)";
const $8b8adca400ca855b$export$3558da976e5d4766 = "hsl(266 63% 45% / 0.5)";
const $8b8adca400ca855b$export$46db9a5b4fa29cdb = "hsl(301, 73%, 75%)";
const $8b8adca400ca855b$export$c7ceda4e66b9f080 = "hsl(301, 73%, 65%)";
const $8b8adca400ca855b$export$fae84847465463d4 = "hsl(301, 73%, 65%)";
const $8b8adca400ca855b$export$d33af6c1185faec2 = "hsl(301, 73%, 65%)";
const $8b8adca400ca855b$export$7ced400057edeaf3 = "hsl(301 73% 75% / 0.5)";
const $8b8adca400ca855b$export$51494f3f5dc6cffe = "hsl(169, 82%, 33%)";
const $8b8adca400ca855b$export$7f8f0ea50825a1b7 = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$833baa99ed859de5 = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$8662dc5f96d63e1c = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$f5bf3b4e8e44efda = "hsl(169 82% 33% / 0.5)";
const $8b8adca400ca855b$export$18adc08f697e50fe = "hsl(346, 37%, 43%)";
const $8b8adca400ca855b$export$5e8722563ff0c000 = "hsl(346, 37%, 33%)";
const $8b8adca400ca855b$export$d00e843f86f2564a = "hsl(346, 37%, 33%)";
const $8b8adca400ca855b$export$fa36bc78b7ce543e = "hsl(346, 37%, 33%)";
const $8b8adca400ca855b$export$3f6119e89ab4de35 = "hsl(346 37% 43% / 0.5)";
const $8b8adca400ca855b$export$e0b0cb547b1f892d = "hsl(36, 77%, 40%)";
const $8b8adca400ca855b$export$927f064bc5b07bfa = "hsl(36, 77%, 30%)";
const $8b8adca400ca855b$export$56f2d00a015cd7a8 = "hsl(36, 77%, 30%)";
const $8b8adca400ca855b$export$8b59f2dc411c59d7 = "hsl(36, 77%, 30%)";
const $8b8adca400ca855b$export$68d3bcba77d10f82 = "hsl(36 77% 40% / 0.5)";
const $8b8adca400ca855b$export$6ff7613d4c7aeb8d = "hsl(151, 46%, 17%)";
const $8b8adca400ca855b$export$a6d09535a6dea115 = "hsl(151, 46%, 27%)";
const $8b8adca400ca855b$export$5b5bdc2dd57fd7ee = "hsl(151, 46%, 27%)";
const $8b8adca400ca855b$export$422c1cc49a17292a = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$8722d1c809de28b3 = "hsl(151 46% 27% / 0.5)";
const $8b8adca400ca855b$export$eb43764bdf88d057 = "hsl(36, 97%, 70%)";
const $8b8adca400ca855b$export$67a542d8cd9b82dd = "hsl(36, 97%, 60%)";
const $8b8adca400ca855b$export$d1f88ead0dc7a304 = "hsl(36, 97%, 60%)";
const $8b8adca400ca855b$export$5038a7dd0a89c7d0 = "hsl(36, 97%, 60%)";
const $8b8adca400ca855b$export$fb457f52cca97850 = "hsl(36 97% 70% / 0.5)";
const $8b8adca400ca855b$export$519809f976569692 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$c584085d5ee8de76 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$a788d2961d748cde = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e32ea0d81272e1b6 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$d8ae6269b02938b = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$2f14b841cad9c767 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$10519f8ccd4b0b86 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$2fa9eeb6d8e51673 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$ed95ed13f2c03e16 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$1c9be6c6205a847b = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$8b5c10f16365778c = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$768c1cdce28e1d12 = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$1a1821660ba5e5fe = "#001c33";
const $8b8adca400ca855b$export$663065bf2da99939 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$c914cb73d8ae4e4f = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$2c74ca3559bf64f = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$72a1027e9ca37197 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$3e018292749dd934 = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$bb278ff9c8980518 = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$36eae0c7542b8f46 = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$96674436714104a8 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$2896c237a2e3e079 = "hsl(200 30% 96% / 0.38)";
const $8b8adca400ca855b$export$a48b18644600cff8 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$32f93b6101bdc552 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$cc6fa3dd94433a27 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$902237779564add5 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$df41c8766762ac09 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$5e39dea751a8af3e = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$3f5d1438f789e95b = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$47c3cd69e3cba602 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e5fda2d14bb87245 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$d6a62f44a4bb6848 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$77499b6ac1d78be2 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$88019076f718435e = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$1961987bbf85bc69 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$f563e1c4b1dfe9b6 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$4188c5dfbd960ff6 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$6f8b1b70dce4971d = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$51c0a5205fae8605 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e3efd006787060d7 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$fd9c87bcf2280fcc = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$33c2d8ee15842362 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$7d9f7647b114f0ff = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$bee26b78d3246ede = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$844a6b198d459d4f = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$c32dfb5afe8442d2 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$8c54331216764c04 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$ed179d6ea18a424b = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$a2b7d83a97c0807b = "#001c33";
const $8b8adca400ca855b$export$75fdb7e4365aea69 = "#001c33";
const $8b8adca400ca855b$export$436333264dcf080c = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$48fdba70460beee3 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$a3db82021e9802c1 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$17521d5649bf845b = "hsl(200 30% 70% / 0.38)";
const $8b8adca400ca855b$export$d51f08d8d0f3a9cc = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$1bcabe1edda14f10 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$10d03502f2dd5cdd = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$52269544c67eee3a = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$368cb14eb84c724e = "hsl(210, 20%, 82%)";
const $8b8adca400ca855b$export$976ab5bc3e192772 = "hsl(210, 20%, 20%)";
const $8b8adca400ca855b$export$f32dfe87536251b0 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$f917c18e2c0733a2 = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$37a2561e6f52f1a6 = "hsl(350, 70%, 30%)";
const $8b8adca400ca855b$export$757d1267e084d85e = "hsl(150, 50%, 90%)";
const $8b8adca400ca855b$export$c96234e9ac3976aa = "hsl(150, 50%, 50%)";
const $8b8adca400ca855b$export$2ada4242418b1ab = "hsl(150, 50%, 30%)";
const $8b8adca400ca855b$export$88e8fc65e1dc8cfd = "hsl(30, 70%, 86%)";
const $8b8adca400ca855b$export$571330183a04a679 = "hsl(30, 70%, 60%)";
const $8b8adca400ca855b$export$e2364df1760c1cd2 = "hsl(30, 70%, 20%)";
const $8b8adca400ca855b$export$88387c1fa4550702 = "hsl(270, 50%, 90%)";
const $8b8adca400ca855b$export$31154090c834e808 = "hsl(270, 50%, 50%)";
const $8b8adca400ca855b$export$fd57486f12ccccc7 = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$c49e9b4e44fd796c = "#A7CBB2";
const $8b8adca400ca855b$export$da7e305f941f7c1b = "#7DCDF5";
const $8b8adca400ca855b$export$98adb0276baaf8cf = "#DCCDE0";
const $8b8adca400ca855b$export$8420ff989cc50c37 = "#A9E7EA";
const $8b8adca400ca855b$export$b8a3bfa1fcd8dbc7 = "#F7DD7A";
const $8b8adca400ca855b$export$ce5dfe4e5b931e4a = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$958169ac176093af = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$c3458d3269390c99 = "#001c33";
const $8b8adca400ca855b$export$f7e100eac7e2f133 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$95f6ec96cc827155 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$657174ec69a2226a = "#ffffff";
const $8b8adca400ca855b$export$e123307e2b218889 = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$7b91367d7e807812 = "hsl(0 0% 100% / 0.8)";
const $8b8adca400ca855b$export$aa6384fd68eb0d3b = "hsl(0 0% 100% / 0.75)";
const $8b8adca400ca855b$export$3208e2036242c233 = "hsl(210, 20%, 50%)";
const $8b8adca400ca855b$export$db305d4c182a82ff = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$7641b4bffb9af953 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$635aa5d463114b08 = "#ffffff";
const $8b8adca400ca855b$export$e5149da9067fe611 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$dfbedab10da73342 = "#C0EFCF";
const $8b8adca400ca855b$export$80f74912e5e2c16e = "#A7CBB2";
const $8b8adca400ca855b$export$11b87b8556d144a8 = "#EDE5EF";
const $8b8adca400ca855b$export$380739dd5aaef19b = "#C9F1F3";
const $8b8adca400ca855b$export$d5620addd245919a = "#A9E7EA";
const $8b8adca400ca855b$export$a86a694f71504589 = "#FEECA8";
const $8b8adca400ca855b$export$39d3aed953cc66e4 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$4b18498d98ac2b51 = "#ADE3FE";
const $8b8adca400ca855b$export$a612632118a3b91b = "hsl(202, 100%, 40%)";
const $8b8adca400ca855b$export$465d16f3f0328e03 = "hsl(202, 100%, 30%)";
const $8b8adca400ca855b$export$e11a401a4e94968e = "hsl(202, 100%, 30%)";
const $8b8adca400ca855b$export$9d6422b3a72c759f = "hsl(202, 100%, 30%)";
const $8b8adca400ca855b$export$5b94bccbb3b2583c = "hsl(202 100% 40% / 0.5)"; // Used for map pins
const $8b8adca400ca855b$export$b8a531ce48f1ec30 = "hsl(266, 63%, 45%)";
const $8b8adca400ca855b$export$5d4a9c2be9f03907 = "hsl(266, 63%, 35%)";
const $8b8adca400ca855b$export$3a2e5b43fc49e678 = "hsl(266, 63%, 35%)";
const $8b8adca400ca855b$export$87ffd345b881d06e = "hsl(266, 63%, 35%)";
const $8b8adca400ca855b$export$8827af02313fafc6 = "hsl(266 63% 45% / 0.5)";
const $8b8adca400ca855b$export$63971f9c83d9fbd1 = "hsl(301, 73%, 75%)";
const $8b8adca400ca855b$export$15a94504af5cb48d = "hsl(301, 73%, 65%)";
const $8b8adca400ca855b$export$ea6f57adb3b615d1 = "hsl(301, 73%, 65%)";
const $8b8adca400ca855b$export$603bede8ed38ec7c = "hsl(301, 73%, 65%)";
const $8b8adca400ca855b$export$96ad1ff12a5eae51 = "hsl(301 73% 75% / 0.5)";
const $8b8adca400ca855b$export$3435221529653182 = "hsl(169, 82%, 33%)";
const $8b8adca400ca855b$export$6140f2a94c436fb8 = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$13e360d171ddb1b1 = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$bbdd1745b1aa2bfa = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$1efbfdbe33975e65 = "hsl(169 82% 33% / 0.5)";
const $8b8adca400ca855b$export$213e10a2fa7b8f25 = "hsl(346, 37%, 43%)";
const $8b8adca400ca855b$export$f04fa375e16b056f = "hsl(346, 37%, 33%)";
const $8b8adca400ca855b$export$118e41f6ad7c84e4 = "hsl(346, 37%, 33%)";
const $8b8adca400ca855b$export$a61605328d84ff20 = "hsl(346, 37%, 33%)";
const $8b8adca400ca855b$export$388c04cdf17d92da = "hsl(346 37% 43% / 0.5)";
const $8b8adca400ca855b$export$9e8d2402ccd4d487 = "hsl(36, 77%, 40%)";
const $8b8adca400ca855b$export$8ce3c3b4e69389b3 = "hsl(36, 77%, 30%)";
const $8b8adca400ca855b$export$381431d7d1cd2cdc = "hsl(36, 77%, 30%)";
const $8b8adca400ca855b$export$1d762aa2ded48ccc = "hsl(36, 77%, 30%)";
const $8b8adca400ca855b$export$ed777c3dad5075f6 = "hsl(36 77% 40% / 0.5)";
const $8b8adca400ca855b$export$92428370c1b865ea = "hsl(151, 46%, 17%)";
const $8b8adca400ca855b$export$ddd43daccf223f75 = "hsl(151, 46%, 27%)";
const $8b8adca400ca855b$export$dcaa98e9517a79a9 = "hsl(151, 46%, 27%)";
const $8b8adca400ca855b$export$c00fd98671d96e13 = "hsl(169, 82%, 23%)";
const $8b8adca400ca855b$export$d2c685c01dd428bb = "hsl(151 46% 27% / 0.5)";
const $8b8adca400ca855b$export$17ca6c34e71101c = "hsl(36, 97%, 70%)";
const $8b8adca400ca855b$export$71bc8e3929b67885 = "hsl(36, 97%, 60%)";
const $8b8adca400ca855b$export$18b5bb98b26a75b2 = "hsl(36, 97%, 60%)";
const $8b8adca400ca855b$export$b8035dad7acff593 = "hsl(36, 97%, 60%)";
const $8b8adca400ca855b$export$c8abfd1d22e0782b = "hsl(36 97% 70% / 0.5)";
const $8b8adca400ca855b$export$69ba8f43cf9bd6fd = "#ffffff";
const $8b8adca400ca855b$export$f153d7318b9ac6c1 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$32bb8f83e2da4eeb = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$beed09ba17395fba = "hsl(50, 70%, 82%)";
const $8b8adca400ca855b$export$ddfa67e511d310a1 = "#ffffff";
const $8b8adca400ca855b$export$ef61afb4daed05b6 = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$fcbf5251861df7b7 = "hsl(210, 20%, 20%)";
const $8b8adca400ca855b$export$e24eb567fe502262 = "hsl(210 20% 30% / 0.5)";
const $8b8adca400ca855b$export$fd7193dce715e7a5 = "linear-gradient(132deg, #F0F3FA 0%, #FBFCFF 100%);";
const $8b8adca400ca855b$export$f7cd4529b55f6b65 = "linear-gradient(225deg, #FFF 0%, #F2F4F9 35.41%, #E7F1F6 100%);";
const $8b8adca400ca855b$export$32838d580212d33c = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$9ebf7b0a2981f15 = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$4711b9c0f73c9e78 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$e70ad4174aad5efa = "hsl(150, 50%, 90%)";
const $8b8adca400ca855b$export$49814df222dc4e11 = "hsl(150, 50%, 50%)";
const $8b8adca400ca855b$export$7cb8bf88d5994ac6 = "hsl(150, 50%, 20%)";
const $8b8adca400ca855b$export$9779a7bfc57f1d = "hsl(30, 70%, 90%)";
const $8b8adca400ca855b$export$41cf31ff8fe14f06 = "hsl(30, 70%, 50%)";
const $8b8adca400ca855b$export$69315608b745ccef = "hsl(30, 70%, 20%)";
const $8b8adca400ca855b$export$7d3fb3a82b27444e = "hsl(270, 50%, 90%)";
const $8b8adca400ca855b$export$e503fb06555d356c = "hsl(270, 50%, 50%)";
const $8b8adca400ca855b$export$c2715a93ce37bb6d = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$dd95d9725323abea = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$57bc6d84deab957a = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$bdf5b9913bb4f3fa = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$3d257524dee43873 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$4a362d83881d9a7d = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$3658abd53e71b73b = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$80e05e6d32920b95 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$f0f8c85d17a6904c = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$df2dcd894d47df09 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$88f8e1485baa4c61 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$668bd1b85a3e6315 = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$b8eccab39f3850b8 = "hsl(207 100% 96% / 0.38)";
const $8b8adca400ca855b$export$b5c855fae1b28ad6 = "#001c33";
const $8b8adca400ca855b$export$98f748c76bc6e5e6 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$966ce69ea0b3158d = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$36bc118ab0edded = "#001c33";
const $8b8adca400ca855b$export$6fff8a90e8eb0eaa = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$788186b488c86558 = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$75d76cc6fcb941ac = "#ffffff";
const $8b8adca400ca855b$export$5112c48026e56c83 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$97166a6d3215a732 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$6acdad347d3433d2 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$271026c4bdf43872 = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$ae48a1bc62abcfbb = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$85cad9355d106745 = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$6f8939a00778a44b = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$69c050e0055d47e7 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$2d8338132c859946 = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$ab4bc868a0e35284 = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$f36210171c60734d = "hsl(200 30% 96% / 0.38)";
const $8b8adca400ca855b$export$ee107e86642de023 = "#001c33";
const $8b8adca400ca855b$export$b44f568374a0ce0 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$b6d257ffaa4da9c4 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$21b30ac68ae47cd2 = "#005499";
const $8b8adca400ca855b$export$11b1d4709f91be43 = "#005499";
const $8b8adca400ca855b$export$931ef32bb11eaa45 = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$37db67f42f3e4dd2 = "hsl(207 100% 98% / 0)";
const $8b8adca400ca855b$export$c5e9d21ac7b68d10 = "hsl(207 100% 92% / 0.5)";
const $8b8adca400ca855b$export$77aba3a97c22e449 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$504e1687cbb53608 = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$239eed1838553c1d = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$cecf34cd6f8888d8 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$bf3acb3c0b34a34 = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$fed370744d8fbf8 = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$4cce883c26bd421b = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$2805e9aa6398e22d = "hsl(207, 100%, 88%)";
const $8b8adca400ca855b$export$e5398cdbb701916d = "#001c33";
const $8b8adca400ca855b$export$407c0a3360630f07 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$2cf287a22961d257 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$8d86b0a298b93d0c = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$98fe9911bf35517e = "#001c33";
const $8b8adca400ca855b$export$f0653913d522b4de = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$bdac8b134e31bde5 = "#ffffff";
const $8b8adca400ca855b$export$66bda635f6f13030 = "hsl(210, 20%, 96%)";
const $8b8adca400ca855b$export$91cc85ef8f880fbf = "#ffffff";
const $8b8adca400ca855b$export$2567089c08d07145 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$7ddc7da8e4aedbc9 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$e9ea731e72b3c68 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$ac8e94ba2c43a286 = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$9b91ce4791dbfb9c = "hsl(350, 70%, 30%)";
const $8b8adca400ca855b$export$3ff48969c4a6b385 = "hsl(150, 50%, 90%)";
const $8b8adca400ca855b$export$b65cebe70ae8272a = "hsl(150, 50%, 50%)";
const $8b8adca400ca855b$export$fa75de9cd1d80d91 = "hsl(150, 50%, 30%)";
const $8b8adca400ca855b$export$9abd6e64e952d3c8 = "hsl(30, 70%, 90%)";
const $8b8adca400ca855b$export$a805ba38d5e6f41d = "hsl(30, 70%, 50%)";
const $8b8adca400ca855b$export$659615cdef30be80 = "hsl(30, 70%, 20%)";
const $8b8adca400ca855b$export$82ba5e115e27104 = "hsl(270, 50%, 90%)";
const $8b8adca400ca855b$export$e248e6c7086b9196 = "hsl(270, 50%, 50%)";
const $8b8adca400ca855b$export$4aea909045a919f3 = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$24e2c3b0b0b39b6 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$4cdd43377f390746 = "hsl(200, 30%, 70%)";
const $8b8adca400ca855b$export$4c2aeb09e7af3558 = "hsl(200, 30%, 70%)";
const $8b8adca400ca855b$export$6948447257b9a2fb = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$1886d6bd011b2628 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$6f0d3bd0748f7110 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$1cebc993b0830ad8 = "hsl(200, 30%, 50%)";
const $8b8adca400ca855b$export$94bf08336f2aea93 = "hsl(200, 30%, 40%)";
const $8b8adca400ca855b$export$60462e192e7be598 = "hsl(200, 30%, 40%)";
const $8b8adca400ca855b$export$c283bf52b1187f2a = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$fa11560b88288866 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$6fe67d097ba9b53b = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$9346c9eb56618801 = "#001c33";
const $8b8adca400ca855b$export$20a88bf6f5ad424 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$3e11f9ae2b7c8b4 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$1d4bdb103b271652 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$16fad6bc38b83523 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$6facfb5bbfcbbdc1 = "hsl(200 30% 10% / 0.38)";
const $8b8adca400ca855b$export$68a1dda24af60fe8 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$9cda72453ce995fe = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$976fb57d95041b2e = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$1d80e0b4ec3cdc88 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$a47e91d4907d671b = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$51dfe56e558b3410 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$cc6aa53aa44c8b12 = "#ffffff";
const $8b8adca400ca855b$export$428c93d8ee6b3f23 = "#ffffff";
const $8b8adca400ca855b$export$3b660da25a4df7dd = "#ffffff";
const $8b8adca400ca855b$export$1019c561a0c3d652 = "hsl(200 30% 70% / 0.38)";
const $8b8adca400ca855b$export$393ed899af66269a = "#7de8d6";
const $8b8adca400ca855b$export$2186267c9e4b9a19 = "hsl(207, 100%, 40%)";
const $8b8adca400ca855b$export$3c006b5b617326e6 = "#dbe2f0";
const $8b8adca400ca855b$export$17903f872c41d3f5 = "#3d588f";
const $8b8adca400ca855b$export$c8281b24d2fb2531 = "#bf40bf";
const $8b8adca400ca855b$export$f4c54cb551b3e31a = "hsl(30, 70%, 82%)";
const $8b8adca400ca855b$export$e95975a74000e17d = "hsl(207, 100%, 40%)";
const $8b8adca400ca855b$export$a6ed37d16e5c3592 = "0";
const $8b8adca400ca855b$export$da3bf13b0e78188e = "8px";
const $8b8adca400ca855b$export$93a0f9889d302d21 = "10px";
const $8b8adca400ca855b$export$cd5e6a287e658e4b = "12px";
const $8b8adca400ca855b$export$694cbbfe937eb3b2 = "14px";
const $8b8adca400ca855b$export$249f366dc55631e7 = "30px";
const $8b8adca400ca855b$export$57fd85f0d54165d7 = "24px";
const $8b8adca400ca855b$export$17d746d2fa0f3e26 = "20px";
const $8b8adca400ca855b$export$6c499f1196becaca = "16px";
const $8b8adca400ca855b$export$45081f5919e907f9 = "12px";
const $8b8adca400ca855b$export$74a906d5f5dbcc07 = "a08f0ecdf1d566ecd1b9fdb6e63f430334c36f90";
const $8b8adca400ca855b$export$6012d36fd86dbaa1 = "Barracuda";
const $8b8adca400ca855b$export$e24406150fd87290 = "source";
const $8b8adca400ca855b$export$83da2f3feb571776 = "enabled";
const $8b8adca400ca855b$export$34e6b0c7073d1e27 = "source";
const $8b8adca400ca855b$export$5b5ea24ad2da3b16 = "Brand";
const $8b8adca400ca855b$export$bc9f2dd2aa337004 = "1ea10838fef7047bfa8454a2fe209911101832f9";
const $8b8adca400ca855b$export$a08a8107d9ea42d7 = "v1";
const $8b8adca400ca855b$export$3fddc94fd7344d3f = "enabled";
const $8b8adca400ca855b$export$d54ad359440fed8a = "enabled";
const $8b8adca400ca855b$export$7a5c093e8fbb816b = "enabled";
const $8b8adca400ca855b$export$ea9c28f9f25eee8d = "disabled";
const $8b8adca400ca855b$export$7a9d9e76d788a685 = "version";
const $8b8adca400ca855b$export$4caaeecf625325c = "globals";
const $8b8adca400ca855b$export$4db8b33a483c4b6a = "aliases";
const $8b8adca400ca855b$export$517e517cddbb63e4 = "components/button";
const $8b8adca400ca855b$export$94e839db223f2b32 = "version/v1";
const $8b8adca400ca855b$export$45f9825089601438 = "100px";
const $8b8adca400ca855b$export$6ced2fe9225bb9aa = "16px";
const $8b8adca400ca855b$export$ad9035b90a500e0c = "20px";
const $8b8adca400ca855b$export$981c98b80c296cae = "24px";
const $8b8adca400ca855b$export$6a70aa95d5f9e97d = "28px";
const $8b8adca400ca855b$export$77fc7cdd633e321a = "32px";
const $8b8adca400ca855b$export$1d1ba85af9737700 = "#ffffff";
const $8b8adca400ca855b$export$9fdcda1e888251ae = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$6e683eae248849d0 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$10b711493a3d638d = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$ec4efc0809296020 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$574ca15a0c69dfed = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$6711cc6f6a8d7622 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$ee901060a5d95972 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$2eec97a97f2e4a04 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$6a4c73b3b1874b99 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$f99fb7f220239678 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$74c23d76a5361d79 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$39fbb811f7522b8b = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$acc506ad42389b36 = "#001c33";
const $8b8adca400ca855b$export$3afd9cf193dbcb8a = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$56a3bdf7d0fec618 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$9fe0f766dfd77681 = "#001c33";
const $8b8adca400ca855b$export$51dff143e21603dd = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$b8cb6cd9a5387463 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$47e4978834ae40f7 = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$a0e30118ba19fdb2 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$2e98f00d0fa4bbb5 = "#ffffff";
const $8b8adca400ca855b$export$2b24a45f4e35892b = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$d948f9b072d01bf6 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$fa82cf28ab34d28a = "#ffffff";
const $8b8adca400ca855b$export$7b24fd576331fa4c = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$4140cf203c357f02 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$35c34a4e0cfbe353 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$befa38c6db1cdb2d = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$ac967ae90cf75bdb = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$ece26edc7f0c4ee3 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$e06caac82792110c = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$874db53a16e8eca6 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$6996388cacfbc1c3 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$58bec168ef844174 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$d023e2e28c239369 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$946657d96f7f365c = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$c56ab0b862450b50 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$b2a4c668920d7f26 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$bb6b9403ea569251 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$ef1d10df2c03313a = "#001c33";
const $8b8adca400ca855b$export$ef737f5bf427c63b = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$ae2775de35439b9a = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$fde44b974502cb1 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$654e39841159fe7e = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$978e747ab676585c = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$2817c40e512049d4 = "1px";
const $8b8adca400ca855b$export$8b50ef9dd01b2896 = "Manrope";
const $8b8adca400ca855b$export$4ee7b06916c5d942 = "600";
const $8b8adca400ca855b$export$add9cf0f5be45bb8 = "8px";
const $8b8adca400ca855b$export$c13fb80f73bb5bf5 = "12px";
const $8b8adca400ca855b$export$36412f0eae9884ab = "14px";
const $8b8adca400ca855b$export$9cb266ece8c6e780 = "14px";
const $8b8adca400ca855b$export$602010da7f82ff85 = "16px";
const $8b8adca400ca855b$export$72007b6cbdda6c3a = "0";
const $8b8adca400ca855b$export$23b25f54fea3af4 = "uppercase";
const $8b8adca400ca855b$export$b525723c9c0fd3c2 = "18px";
const $8b8adca400ca855b$export$a18ab4cbed1e3c31 = "16px";
const $8b8adca400ca855b$export$5e96e02743466c31 = "16px";
const $8b8adca400ca855b$export$7f7949c1794c1d34 = "12px";
const $8b8adca400ca855b$export$4f23447d88eaec3f = "8px";
const $8b8adca400ca855b$export$cd07715ef04b96c9 = "none";
const $8b8adca400ca855b$export$83047dd36262cb15 = "1px";
const $8b8adca400ca855b$export$767b378a40c983d0 = "16px";
const $8b8adca400ca855b$export$1ff376c9f129fe57 = "4px";
const $8b8adca400ca855b$export$30a853f502f9e2c7 = "4px";
const $8b8adca400ca855b$export$b67be69c900ea369 = "36px";
const $8b8adca400ca855b$export$f587156ff808181d = "hsl(207 100% 98% / 0)";
const $8b8adca400ca855b$export$fd9d81e02468cf0c = "hsl(207 100% 92% / 0.5)";
const $8b8adca400ca855b$export$8684d5dfbbea5f2b = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$be8971e457224a5a = "hsl(207 100% 98% / 0)";
const $8b8adca400ca855b$export$8f6cc8879d3d37c4 = "hsl(207 100% 92% / 0.5)";
const $8b8adca400ca855b$export$e448803c843846e5 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$897cdcc0c18bc5db = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$e06d5ee5e53edb47 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$699fab328727c6b6 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$3c0ad4fb3a1b0ffb = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$5966559b892ee111 = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$1b08e227e9d667a9 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$7179773622cad25f = "hsl(207, 100%, 88%)";
const $8b8adca400ca855b$export$bdf7ce7eb3df6341 = "#001c33";
const $8b8adca400ca855b$export$5b8cb27bcb201dc4 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$3f3dc155ded54e45 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$ba27deb6cad88273 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$456505b8367dc33a = "#001c33";
const $8b8adca400ca855b$export$eedcb4b10d336c0 = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$ff1075fa496d325b = "#ffffff";
const $8b8adca400ca855b$export$a7456311bf695db4 = "#001c33";
const $8b8adca400ca855b$export$cd05d22763540ee7 = "#001c33";
const $8b8adca400ca855b$export$a8af6e0b3bb0ceab = "#ffffff";
const $8b8adca400ca855b$export$ea642331f78f7724 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$7c9eeddcc0155611 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$70b98ceba2109d6f = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$32adc8c8c23f8278 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$53894d17111f8e4e = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$5bee99e492dce333 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$4552f038cdc313b1 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$cbf4404a4e15c5e7 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$23117a1b4fa2ee4a = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$6df9b51adfe2c892 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$5c93c9fbb78bb2c1 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$e1ce320d9ab1c61 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$7940fcec187cb2bd = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$d8345d4ed478774c = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$68249f79b2b24f73 = "#001c33";
const $8b8adca400ca855b$export$9ead9293289737ba = "#001c33";
const $8b8adca400ca855b$export$95454f0202b5bb8a = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$6f2a28348f849e77 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$9cc1a66c6e1f0d4d = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$3175a605e0140911 = "hsl(200 30% 70% / 0.38)";
const $8b8adca400ca855b$export$ab123ccff6e55a0b = "36px";
const $8b8adca400ca855b$export$76ef6df3b64524e8 = "Manrope";
const $8b8adca400ca855b$export$eb9380587111f46e = "700";
const $8b8adca400ca855b$export$ca8181fe2475a0ce = "14px";
const $8b8adca400ca855b$export$b37e6f1e35b3e7ab = "14px";
const $8b8adca400ca855b$export$8adee4da5958a9ec = "0";
const $8b8adca400ca855b$export$b0a94bcb8b47f8b5 = "0px";
const $8b8adca400ca855b$export$e4b49656504a3957 = "20px";
const $8b8adca400ca855b$export$fe4627f581df3f54 = "36px";
const $8b8adca400ca855b$export$9b864bc8d5db3c7a = "56px";
const $8b8adca400ca855b$export$3829a6ec50c0f791 = "40px";
const $8b8adca400ca855b$export$f4dfab5fdc242b93 = "100px";
const $8b8adca400ca855b$export$56f84bc94a249aaf = "4px";
const $8b8adca400ca855b$export$b2a7f6dedbe8d4ae = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$7f5bb126a7ea906a = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$e58f39eec65e0b76 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$20360ceefb533fb = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$ea569fd99f87a06a = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$1c5e5838d4e8eebe = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$e79da0208dc75992 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$5ab048a991219b8c = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$e5c0a5d226b4ee63 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$b06fab23153184d6 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$71ddb8bc4376788d = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$67f367c1dfd5d3b7 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$8d6c6c1bd7814c60 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$f67dcf708fbd73bc = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$a805ee3abb44f47b = "hsl(210, 20%, 50%)";
const $8b8adca400ca855b$export$7eb6272929988e2e = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$4b09028d2528773c = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$db838e84dd688c76 = "4px";
const $8b8adca400ca855b$export$ae915504e2a18be8 = "1px";
const $8b8adca400ca855b$export$a65645ba055136c8 = "4px";
const $8b8adca400ca855b$export$838104e21ca5a19d = "#001c33";
const $8b8adca400ca855b$export$4bb2a4cc71915256 = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$b2e919a6cbfe006e = "#ffffff";
const $8b8adca400ca855b$export$6e404c3c9be4c803 = "Manrope";
const $8b8adca400ca855b$export$341f3e22d85f986b = "600";
const $8b8adca400ca855b$export$9d1c9df76b2ad44b = "12px";
const $8b8adca400ca855b$export$ef0c0a0e1df557cc = "12px";
const $8b8adca400ca855b$export$9d6da21b7f25ba42 = "0";
const $8b8adca400ca855b$export$586ef59e988cd548 = "4px";
const $8b8adca400ca855b$export$e4bf6f69d8b12729 = "100px";
const $8b8adca400ca855b$export$91a69802d20d599b = "1px";
const $8b8adca400ca855b$export$ad14861617df4437 = "24px";
const $8b8adca400ca855b$export$c414cba53d02ca20 = "8px";
const $8b8adca400ca855b$export$947eaeddfab43373 = "8px";
const $8b8adca400ca855b$export$9588b2e0bbc9d556 = "4px";
const $8b8adca400ca855b$export$fed9a8adb39d758b = "28px";
const $8b8adca400ca855b$export$c0f556b14789c4e6 = "8px";
const $8b8adca400ca855b$export$d1639dad04ad0547 = "8px";
const $8b8adca400ca855b$export$baed45022e2a7982 = "4px";
const $8b8adca400ca855b$export$4b76f39175f0013d = "36px";
const $8b8adca400ca855b$export$628b4df0a363bf4d = "8px";
const $8b8adca400ca855b$export$2a0954c14d67929d = "8px";
const $8b8adca400ca855b$export$5d1500b4a57cc110 = "8px";
const $8b8adca400ca855b$export$78bb03c5be80436c = "#ffffff";
const $8b8adca400ca855b$export$54f70ca93c994d78 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$e3dd8acf7e47031b = "hsl(150, 50%, 90%)";
const $8b8adca400ca855b$export$e43bff698a8dfbad = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$6bcfcd9223df7e6 = "hsl(30, 70%, 90%)";
const $8b8adca400ca855b$export$aaaa141d9a4271b6 = "hsl(270, 50%, 90%)";
const $8b8adca400ca855b$export$4550c5abe1916743 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$33de5d52a40c74bb = "hsl(150, 50%, 20%)";
const $8b8adca400ca855b$export$c0ad38910caef39d = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$18afb996161fdda8 = "hsl(30, 70%, 20%)";
const $8b8adca400ca855b$export$58d9b7589ec1b854 = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$19919b03e06ddb93 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$67b5c40e6559a7fa = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$12e1be37fde3ea72 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$db84367af70c1ff1 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$37249a3917b3b82f = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$79a5f596c2b0cc25 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$6e18cdfeccbbdb23 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$a3551c8ced99a9a = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$79335b67bc26b821 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$3c8142e1e0fc9733 = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$10b174a9def6dceb = "#001c33";
const $8b8adca400ca855b$export$7a2ceca8767416a5 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$56db8ce29b377bf2 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$6a6a3e2cab1bed3b = "#001c33";
const $8b8adca400ca855b$export$f8d99fb64297e05a = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$cbeaf87373b45488 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$a676f817d02f5209 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$82be0988c2118f7e = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$d6f0695b99884305 = "#ffffff";
const $8b8adca400ca855b$export$407dd87d92a51f47 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$57b0941f92173029 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$e93aa21fc073fa41 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$7ea48ba511b9e63e = "#ffffff";
const $8b8adca400ca855b$export$43c8f926529b7e18 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$ca3865d8ffc5952f = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$90683711fb4bef81 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$752f6974143a52ba = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$5008f618d8345a67 = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$44eb3b115a64f132 = "hsl(150, 50%, 50%)";
const $8b8adca400ca855b$export$de064229fcb5defa = "hsl(30, 70%, 60%)";
const $8b8adca400ca855b$export$b0165922ab633327 = "hsl(270, 50%, 50%)";
const $8b8adca400ca855b$export$6f0b9975e44923c9 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$fc194a85a504f3c9 = "hsl(150, 50%, 30%)";
const $8b8adca400ca855b$export$da7c568ac2dab421 = "hsl(30, 70%, 20%)";
const $8b8adca400ca855b$export$f735272da4d7b070 = "hsl(350, 70%, 30%)";
const $8b8adca400ca855b$export$e41bcc6142854978 = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$2d6f5cbe33ffecaa = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$4e936d55cc199959 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$e196f4e78e8dece6 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$d08dd2b917bbdcbe = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$700910abe8bd67bb = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$c3d0d12d7d167459 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$cc599fb1e3e3300c = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$cb2419b9c16cfcdd = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$1128c8056cd9276b = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$915246f5d427a346 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$1dd7d7f143fff99a = "#001c33";
const $8b8adca400ca855b$export$91fc644371eb38f5 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$ec43172cc32e77e3 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$4600880359d615e1 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$51555e4eb1ceea4c = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$fc107430d597706f = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$7d16c5378b89bd5 = "Manrope";
const $8b8adca400ca855b$export$998d3c1f7e81e9eb = "600";
const $8b8adca400ca855b$export$ed23011c0d9d2446 = "12px";
const $8b8adca400ca855b$export$f8867386b651d9da = "14px";
const $8b8adca400ca855b$export$1bf4e0bbd42ea607 = "14px";
const $8b8adca400ca855b$export$9c459b111fa4f4f3 = "0";
const $8b8adca400ca855b$export$3f6b29d164f2bd31 = "16px";
const $8b8adca400ca855b$export$e467a06f8f022248 = "12px";
const $8b8adca400ca855b$export$8725bf5ac2c380cf = "14px";
const $8b8adca400ca855b$export$6a595734c76fe30 = "4px";
const $8b8adca400ca855b$export$457c2d7fb8320c77 = "8px";
const $8b8adca400ca855b$export$1a2e1724738a4f36 = "12px";
const $8b8adca400ca855b$export$8fc672cb7298d1de = "16px";
const $8b8adca400ca855b$export$f4d657e58ef789df = "20px";
const $8b8adca400ca855b$export$1a9af4c2a2e53ffe = "24px";
const $8b8adca400ca855b$export$d7333ebbf97043c = "28px";
const $8b8adca400ca855b$export$35bc30912bd412e5 = "32px";
const $8b8adca400ca855b$export$8527b31e4906a715 = "36px";
const $8b8adca400ca855b$export$5a2fe487d6396502 = "#ffffff";
const $8b8adca400ca855b$export$46347942d17069d5 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$aba2ba25c52e742d = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$4f9e8b52864daf82 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$3998bea291218554 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$bddeb9cc658ce838 = "#ffffff";
const $8b8adca400ca855b$export$3fbef91c81a27ff7 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$be8504476447899 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$aa7b4d33dda1ff3e = "hsl(200, 30%, 70%)";
const $8b8adca400ca855b$export$1eccb6bf1b45adc0 = "hsl(200, 30%, 70%)";
const $8b8adca400ca855b$export$f5f294c76327e31 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e087e8a19001f08f = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$5932a3fffc13208b = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$bb4efa5fbc7bc49f = "hsl(200, 30%, 50%)";
const $8b8adca400ca855b$export$2598a87ffab12199 = "hsl(200, 30%, 40%)";
const $8b8adca400ca855b$export$a81df3089c6d474c = "hsl(200, 30%, 40%)";
const $8b8adca400ca855b$export$3a79d547ba3a5d26 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$85ccc16cee46224 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$df7d2e4081bbb5d1 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$2d15d1c7fbd172c = "#001c33";
const $8b8adca400ca855b$export$14cb47ca5f5d1cd6 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$16da9ff5861987a7 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$419eac1adb13f9fc = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e2681ddb55045e4c = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$5feebe6dca4c6e2f = "hsl(200 30% 10% / 0.38)";
const $8b8adca400ca855b$export$18df805cce67e76e = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$384dc265e7feea50 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$5168884c17b5fa13 = "hsl(30, 70%, 50%)";
const $8b8adca400ca855b$export$1e76832163599c23 = "hsl(30, 70%, 90%)";
const $8b8adca400ca855b$export$165790c96dfe23b = "hsl(150, 50%, 50%)";
const $8b8adca400ca855b$export$2d719fd496813158 = "hsl(150, 50%, 90%)";
const $8b8adca400ca855b$export$83b4faef127cb7b7 = "hsl(270, 50%, 50%)";
const $8b8adca400ca855b$export$54d62555f8f353f9 = "hsl(270, 50%, 90%)";
const $8b8adca400ca855b$export$f780a2ef2c45e34d = "100px";
const $8b8adca400ca855b$export$cb5734e2315e2efe = "1px";
const $8b8adca400ca855b$export$995f211f28f1437 = "20px";
const $8b8adca400ca855b$export$db164abfd7645c18 = "4px";
const $8b8adca400ca855b$export$e5da4b0c5e56db5d = "4px";
const $8b8adca400ca855b$export$dad9521985b6131b = "100px";
const $8b8adca400ca855b$export$2f90d06b52e9497 = "16px";
const $8b8adca400ca855b$export$253d8914fa26df10 = "4px";
const $8b8adca400ca855b$export$d6f8ff389cb04136 = "4px";
const $8b8adca400ca855b$export$5e2bf4249906aa9c = "36px";
const $8b8adca400ca855b$export$c1c2909bedb0a7dd = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$63d9ba7538e73dff = "#ffffff";
const $8b8adca400ca855b$export$f67d4fb49acb1f89 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$2fe4aa9229f13169 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$c692e870557d1485 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$54b6b20194425cd6 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$be70cab265492c56 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$784e486f16c66f2d = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$6da19c50ace6d610 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$4d1a2e4dfe067853 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$987b3d1dafde78df = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$e836365f68f36c1d = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$23a0fd118827e1dc = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$9919355b48dcc96d = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$e3c46fa14b4ebd10 = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$9bcfcb94d6adb5eb = "hsl(207 100% 96% / 0.38)";
const $8b8adca400ca855b$export$4c138a91262deb86 = "#001c33";
const $8b8adca400ca855b$export$1e05bfb99ce0bab0 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$440246e634610acd = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$463c36ef5e33cde = "#001c33";
const $8b8adca400ca855b$export$673c5cc0104c050 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$d5b20e83a050689e = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$b329ef8c78e58195 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$c74b59fc0c00f12f = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$b3d105834921abae = "#ffffff";
const $8b8adca400ca855b$export$41a0ad556cd1f41e = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$4749334586e6fad3 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$a22d0c3e2f60d443 = "#001c33";
const $8b8adca400ca855b$export$7c9f7df759bd38d1 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$d02c01c4b3e77354 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$a9af785ad1437427 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$9b017cc64a769252 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$ef7785f455f0ff57 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$6037c748dfa10ac2 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$e3ebbb1347a60e9d = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$4af2ae34cb51f1d8 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$9105c0035b3c9dbc = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$ccf0d988c28f4ac3 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$a152e09ad4cfa768 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$c026cdd1f9d9818 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$1e6ceb099a6c182d = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$a31e532571133db1 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$b50e97467970464c = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$dc0f61867c8eb438 = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$9ca8e072a61adfe6 = "#001c33";
const $8b8adca400ca855b$export$b486bbf27048fca6 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$d266a9d896cbc7e5 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$f3894963a227c2d1 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e879afede95344e2 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$64e44e4f458bdd15 = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$a62f741044aa85bb = "Manrope";
const $8b8adca400ca855b$export$d411dbbc5db0f8e5 = "600";
const $8b8adca400ca855b$export$379000749f6ebe9d = "16px";
const $8b8adca400ca855b$export$ac903168df7d1c8c = "14px";
const $8b8adca400ca855b$export$4ae3397bafb779ba = "12px";
const $8b8adca400ca855b$export$31a061c5e74d37df = "12px";
const $8b8adca400ca855b$export$3f73af3bf1f38889 = "0";
const $8b8adca400ca855b$export$655d640242b74977 = "18px";
const $8b8adca400ca855b$export$228d1ca9c77817dd = "14px";
const $8b8adca400ca855b$export$4d3f5ae03ef63815 = "#ffffff";
const $8b8adca400ca855b$export$4f5fa3d302b4eb89 = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$3aa8eef02f53a11f = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$9cee6c095c5d53f = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$46616e63025810c3 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$2eb243147337e0e9 = "#ffffff";
const $8b8adca400ca855b$export$ef30719fb3a37b5c = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$18dec71efe39c363 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$1983392f49eb3b77 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$f069eb93d208df24 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$eb1bb4481b303f23 = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$2054ca69e320709f = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$71d1df7ff8827dd3 = "1px";
const $8b8adca400ca855b$export$6d220a723977f960 = "4px";
const $8b8adca400ca855b$export$2c16a3f0e6b48836 = "8px";
const $8b8adca400ca855b$export$58ecf9341fd2c423 = "16px";
const $8b8adca400ca855b$export$63860ae533ec763 = "hsl(207 100% 98% / 0)";
const $8b8adca400ca855b$export$8cd575c98ef7c7e3 = "hsl(207 100% 92% / 0.5)";
const $8b8adca400ca855b$export$23b1fadb952026bb = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$6dc4bfc245f9c03f = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$407ca803dcba1686 = "#001c33";
const $8b8adca400ca855b$export$db0f7f411822f8f9 = "#001c33";
const $8b8adca400ca855b$export$333ac82fea827fd7 = "#001c33";
const $8b8adca400ca855b$export$2a45d93c2e2c57d7 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$307543bd31288d3a = "#732673";
const $8b8adca400ca855b$export$583bfe75ad3be530 = "Manrope";
const $8b8adca400ca855b$export$bd18f91ff949705a = "600";
const $8b8adca400ca855b$export$f0729e79e516d76f = "0";
const $8b8adca400ca855b$export$a3037016530afa41 = "16px";
const $8b8adca400ca855b$export$63b3bf0bcd5dec0 = "12px";
const $8b8adca400ca855b$export$63f6e89485f022a0 = "14px";
const $8b8adca400ca855b$export$2c39b60b9ab3c509 = "12px";
const $8b8adca400ca855b$export$d20edb3b4cd46521 = "underline";
const $8b8adca400ca855b$export$1a81d73bf487bad2 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$66899150b01781f = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$f717e38166baeb5c = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$1b8e258852406e33 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$6024c97884eba4d8 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$be689acb580cdc83 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$49e326127c3153ea = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$55f25450a0bf5e72 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$fc90332a56a8f3c = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$2c6002f82a481ef3 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$d22c37eb694c13bd = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$fd0078d1143f7e9a = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$d1033c477c3c6ff9 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$ce1e53725c205a2b = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$be282364918d0701 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e8d2b6a7823bd61c = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$69b4d96c29de7d5a = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$d71ecf661337863e = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$dd2313e49d842f7c = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$407193ea73d64650 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$68a64f766c3e06eb = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$7bd4b125f5796f0b = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$dc235a9e36421303 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$44a93435f9e76b5f = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$5114818da7303033 = "#001c33";
const $8b8adca400ca855b$export$819bb9ecff8821f6 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$9d48bca40b858c58 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$f4432833dbc2b032 = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$5371ecf7e7c3c5fb = "#001c33";
const $8b8adca400ca855b$export$bce78b0af6106c0d = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$84c6ef30066cb450 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$19c89d51fe48e97e = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$b4ded087f67cfcb1 = "#001c33";
const $8b8adca400ca855b$export$98739c3332aa1180 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$5450679c20cb502e = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$72df667c0ea477ce = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$de71cd689917b4b9 = "20px";
const $8b8adca400ca855b$export$46fd5ca6b9cb553c = "16px";
const $8b8adca400ca855b$export$c3edf74d2870face = "4px";
const $8b8adca400ca855b$export$b4a7b3d28ddcea06 = "4px";
const $8b8adca400ca855b$export$aab87273839218af = "100px";
const $8b8adca400ca855b$export$31a25690cfb3c72b = "0px";
const $8b8adca400ca855b$export$4f243c7e47f36178 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$21e1926cfd31fb34 = "hsl(210, 20%, 82%)";
const $8b8adca400ca855b$export$729f8261cfc7f56f = "0px";
const $8b8adca400ca855b$export$841ebfb9757ebe4e = "100px";
const $8b8adca400ca855b$export$9e4598db4a678250 = "4px";
const $8b8adca400ca855b$export$5c0a15ed7f937814 = "1px";
const $8b8adca400ca855b$export$6fdaa6b611356931 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$14148cd5c9a8c997 = "376px";
const $8b8adca400ca855b$export$3c9f15c3fd95369 = "576px";
const $8b8adca400ca855b$export$8dbca5b14d0844eb = "776px";
const $8b8adca400ca855b$export$8e20ff08973f499 = "300px";
const $8b8adca400ca855b$export$288cafde2f49d409 = "0px";
const $8b8adca400ca855b$export$4d69bf9275adc0b4 = "4px";
const $8b8adca400ca855b$export$15fcc38e88786dd4 = "#ffffff";
const $8b8adca400ca855b$export$fc3f1c3df48b1cc4 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$a3582a1f7ae69771 = "16px";
const $8b8adca400ca855b$export$76c304873b7a47d1 = "24px";
const $8b8adca400ca855b$export$3be63787605bb63b = "8px";
const $8b8adca400ca855b$export$6da960e179d64c7e = "Manrope";
const $8b8adca400ca855b$export$d4ec6eea36d83142 = "400";
const $8b8adca400ca855b$export$f148b6bcf802c0a0 = "26px";
const $8b8adca400ca855b$export$8fcd22ab977bd8d8 = "24px";
const $8b8adca400ca855b$export$352a97f8e784158a = "0";
const $8b8adca400ca855b$export$902221d8e98b812c = "0 0 0 0 hsl(200, 30%, 86%)";
const $8b8adca400ca855b$export$e492848c875e9064 = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $8b8adca400ca855b$export$bd9a62c800d4c4a9 = "1px";
const $8b8adca400ca855b$export$76ef89a37b8ace4d = "4px";
const $8b8adca400ca855b$export$735b1ff34fe199d4 = "16px";
const $8b8adca400ca855b$export$302ed6b9f6c0b425 = "8px";
const $8b8adca400ca855b$export$1ba594a12602b520 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$bc25af37f4d9124d = "hsl(30, 70%, 90%)";
const $8b8adca400ca855b$export$569648afc0995710 = "hsl(150, 50%, 90%)";
const $8b8adca400ca855b$export$4c44b4e9bc0481e9 = "hsl(270, 50%, 90%)";
const $8b8adca400ca855b$export$df27106c05b21907 = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$e92b34357220e8e0 = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$809bc51a80a73ffa = "hsl(30, 70%, 60%)";
const $8b8adca400ca855b$export$b20e54fe63f136ec = "hsl(150, 50%, 50%)";
const $8b8adca400ca855b$export$aaaff3ea35504d9a = "hsl(270, 50%, 50%)";
const $8b8adca400ca855b$export$d2b4b84e205366a4 = "hsl(270, 50%, 20%)";
const $8b8adca400ca855b$export$bd02a858e71ac856 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$9f0fea77a037b87a = "#ffffff";
const $8b8adca400ca855b$export$2b03536d20a3b2f6 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$ca5110e6287a9670 = "Manrope";
const $8b8adca400ca855b$export$6595d0fad08bd2b4 = "400";
const $8b8adca400ca855b$export$4339da1d2671e324 = "16px";
const $8b8adca400ca855b$export$891da890c43fc05e = "14px";
const $8b8adca400ca855b$export$ce0ddd473dd20afc = "700";
const $8b8adca400ca855b$export$16dd3c4d6489ba61 = "18px";
const $8b8adca400ca855b$export$ddcf665488274808 = "16px";
const $8b8adca400ca855b$export$5bdc2b5fff62d35 = "0";
const $8b8adca400ca855b$export$86773c375c0bb9a1 = "#001c33";
const $8b8adca400ca855b$export$6607013dc8c505fa = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$df5495caecdcb614 = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$23aa1d4fb282b9e2 = "#001c33";
const $8b8adca400ca855b$export$9f19810b26e253c8 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$a1820a4b6e6de5c = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$64a5a6262510bdfe = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$561d96085c937ed4 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$c60d87bac1618e10 = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$7fabd56572773fe8 = "#001c33";
const $8b8adca400ca855b$export$3f9ecbd7e63c2056 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$a5c9bce6d83773a = "hsl(207 100% 10% / 0.38)";
const $8b8adca400ca855b$export$5e221dc1e3b0d8bf = "0px";
const $8b8adca400ca855b$export$987a18f51782dfac = "100px";
const $8b8adca400ca855b$export$4c09818a16bf66d3 = "16px";
const $8b8adca400ca855b$export$e2b1a3f6040b3539 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$71201f47e9dc9666 = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$6c4b9b05028ede96 = "hsl(207 100% 96% / 0.38)";
const $8b8adca400ca855b$export$b1d4a516e2e88fe6 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$f1348024bfa310d4 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$5d9f8f5a09ed11cc = "hsl(207 100% 96% / 0.38)";
const $8b8adca400ca855b$export$c38f3967889bac93 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$64092d816c16ef53 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$7521fab9ed6230d8 = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$d4e8d359f8069dfc = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$1814043782ee69c8 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$f17aa8a146709aa2 = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$3d1b7f700b76b19e = "1px";
const $8b8adca400ca855b$export$e33736dbca43baac = "100px";
const $8b8adca400ca855b$export$fa6928ff7c04c2cd = "32px";
const $8b8adca400ca855b$export$3a2ecb48778e609e = "20px";
const $8b8adca400ca855b$export$1ced0159d1e6df39 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$f405b4ac7e3959c8 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$7c74bcd0f7f3be40 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$b2bbe3653cad5eb2 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$5ebb29b4abcdfb8f = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$a6e416f594566ded = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$db028a317a02353a = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$6f5efccfe6dfd313 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$4fe40f383eb5faf5 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$71ea0e30dc1b6ba4 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$8c4beee5a921e3c9 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$35a66965267ed529 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$7bcf618f61979316 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$a6f5b1dbfa6022b = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$2cd9519356202e1f = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$aa7a4ccf8d59e280 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$ee5e76ba05b4ab28 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$f1088235eae15437 = "0px";
const $8b8adca400ca855b$export$fafa860328e70ae = "4px";
const $8b8adca400ca855b$export$a7a5eb1834e82687 = "8px";
const $8b8adca400ca855b$export$7d6465298d6c4692 = "Manrope";
const $8b8adca400ca855b$export$a0f454c876af7960 = "700";
const $8b8adca400ca855b$export$e2adaac19dce9831 = "400";
const $8b8adca400ca855b$export$dddff9d395fc8f70 = "16px";
const $8b8adca400ca855b$export$1dd2d60f07979c32 = "14px";
const $8b8adca400ca855b$export$42ae81b5c0a2fbb = "0";
const $8b8adca400ca855b$export$a46db5db085db139 = "#ffffff";
const $8b8adca400ca855b$export$27401163f4368ffc = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$96b2aad183e1f54f = "0px";
const $8b8adca400ca855b$export$ee764dc2d555ddf6 = "4px";
const $8b8adca400ca855b$export$794d9c23b73cc47e = "8px";
const $8b8adca400ca855b$export$3f57378f9ec9cd94 = "4px";
const $8b8adca400ca855b$export$ddcc321b1a8861dd = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $8b8adca400ca855b$export$b51251547efb0d8e = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$85a890daf957fbec = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$89e8e756190bda61 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$770bdd3d491ddfe6 = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$8e00bb2c5d8bbc3b = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$c21d874e9498ef82 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$61ede0f7013c2b81 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$6fe37393ecda4209 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$ff38bf95992f09fc = "hsl(200 30% 60% / 0.38)";
const $8b8adca400ca855b$export$88cfb69c788bb860 = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$52e86a91e2ad6034 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$cca144c3f4aa7626 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$f10f0ec496f636f7 = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$58dfb1025a181356 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$bc322de6f84fd903 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$49337470bba91ab9 = "hsl(210, 20%, 50%)";
const $8b8adca400ca855b$export$4a34e2a16154db83 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$26aa6c0ceb7e966e = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$b816de746fb400a5 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$c02de212dbe9d176 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$116727610d612ae4 = "8px";
const $8b8adca400ca855b$export$71b44d15d3de46dd = "1px";
const $8b8adca400ca855b$export$bace76a59986f565 = "8px";
const $8b8adca400ca855b$export$9ffe2275b011d7e1 = "Manrope";
const $8b8adca400ca855b$export$b0985124f4df02d2 = "18px";
const $8b8adca400ca855b$export$a315c6564df14490 = "400";
const $8b8adca400ca855b$export$aa1b94da4287d2a0 = "14px";
const $8b8adca400ca855b$export$e5114fa3fec26908 = "0";
const $8b8adca400ca855b$export$84f5f00bc441b732 = "4px";
const $8b8adca400ca855b$export$51cb609d45dac1eb = "Manrope";
const $8b8adca400ca855b$export$3827778002413131 = "600";
const $8b8adca400ca855b$export$e67e3340791cadd4 = "12px";
const $8b8adca400ca855b$export$ec94e1b644056c99 = "12px";
const $8b8adca400ca855b$export$f3bbd9a0f0930579 = "0";
const $8b8adca400ca855b$export$33ce3a4dcea39de = "36px";
const $8b8adca400ca855b$export$d8e53851991cdd42 = "#ffffff";
const $8b8adca400ca855b$export$fe3a5cd62a598e84 = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$5edfe3b007b29215 = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$86d4c0985100dcd0 = "4px";
const $8b8adca400ca855b$export$8266cc989bac4651 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$d4bd2b0a79e3ef71 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$4ce259255a4d70c4 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$2869c51015852e03 = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$f5e3fe890c9ff1e = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$1cfbd34f600c6efa = "hsl(350, 70%, 50%)";
const $8b8adca400ca855b$export$5a252ec11a1445ad = "0px";
const $8b8adca400ca855b$export$c735ecaf581f705 = "100px";
const $8b8adca400ca855b$export$49bf4afa6ca745e = "0px";
const $8b8adca400ca855b$export$edc7fc4c8271f574 = "100px";
const $8b8adca400ca855b$export$253ba067522eaa91 = "4px";
const $8b8adca400ca855b$export$c945866cf5c6fd53 = "16px";
const $8b8adca400ca855b$export$5b8c998da32edfab = "20px";
const $8b8adca400ca855b$export$4cb4e758ff318324 = "24px";
const $8b8adca400ca855b$export$9965c30cb78bb99e = "28px";
const $8b8adca400ca855b$export$73f604c81bd5b0de = "24px";
const $8b8adca400ca855b$export$e2b17b1f6ba2f2c0 = "176px";
const $8b8adca400ca855b$export$9d31ebafe2568375 = "24px";
const $8b8adca400ca855b$export$65141d2099878d22 = "68px";
const $8b8adca400ca855b$export$b889b193e53040e = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$80792f69e844dd7a = "1px";
const $8b8adca400ca855b$export$5ded54aa949b1fd3 = "8px";
const $8b8adca400ca855b$export$20e329e1e9c12a82 = "8px";
const $8b8adca400ca855b$export$e2d09706041282a2 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$7aa5ad378865fe04 = "#ffffff";
const $8b8adca400ca855b$export$4c7f7f1e4a99b8b5 = "hsl(210 20% 92% / 0)";
const $8b8adca400ca855b$export$acfd0f4230aa9bd = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$33c117b123a26dc4 = "1px";
const $8b8adca400ca855b$export$427ad239b0adeca2 = "0px";
const $8b8adca400ca855b$export$8814694ab67761cf = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$e4759e57c938a220 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$7dc99afc1861281f = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$e5a7cf19fc196fc0 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$742357191da0915b = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$d4fac41645ce7de8 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$258236cb50101bf9 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$b660cdb46497535b = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$6edeb93afbabb3 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$8527b5e5f1a32759 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$404f9d2e20441a64 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$cc0883bf09c21e65 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$facf8ff6788b88ea = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$5ba09a1a7b4af6ac = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$dc278ffa79064219 = "8px";
const $8b8adca400ca855b$export$1e468d8d8b24f0a7 = "8px";
const $8b8adca400ca855b$export$8a7407fa38280281 = "0px";
const $8b8adca400ca855b$export$362ddcf024bed54e = "0px";
const $8b8adca400ca855b$export$4d9a0d275210ab6f = "0px";
const $8b8adca400ca855b$export$31a06d75aaa08bbf = "0px";
const $8b8adca400ca855b$export$3bcae2b0ac664dfb = "2px";
const $8b8adca400ca855b$export$5e97a30a5d76a6eb = "0px";
const $8b8adca400ca855b$export$49b56a0f736ebf80 = "0px";
const $8b8adca400ca855b$export$dcc78db97c706ed5 = "0px";
const $8b8adca400ca855b$export$db0747eda20d8b11 = "0px";
const $8b8adca400ca855b$export$b1dd518c969a9dc2 = "0px";
const $8b8adca400ca855b$export$512259029c84d0f1 = "0px";
const $8b8adca400ca855b$export$6f6b54dde0882c41 = "0px";
const $8b8adca400ca855b$export$437187fbcaa7285b = "0px";
const $8b8adca400ca855b$export$f41d59313e2e2d61 = "0px";
const $8b8adca400ca855b$export$15265dc7c7a51345 = "2px";
const $8b8adca400ca855b$export$e9d3d243807e3d2 = "0px";
const $8b8adca400ca855b$export$e2766d737a057e60 = "Manrope";
const $8b8adca400ca855b$export$2ddfac786be6e309 = "700";
const $8b8adca400ca855b$export$59bf55466e4e3745 = "12px";
const $8b8adca400ca855b$export$22bcc28ea306d2f3 = "0";
const $8b8adca400ca855b$export$b88310354d2244f3 = "4px";
const $8b8adca400ca855b$export$824459960cf5a262 = "12px";
const $8b8adca400ca855b$export$788649a55d91496e = "4px";
const $8b8adca400ca855b$export$95aa30178720092a = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$16796337c4a008dd = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$92929f84f89fa83 = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$b2ca58ad74caacc7 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$b1b662adf9714ed8 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$a212d99fcf9df17e = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$6d1640df421fce01 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$ca6a6b82ca40bb5a = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$d781c067583bc79e = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$f5d14a553904785b = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$8447a3259160c2ce = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$3af2ae30823e630b = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$e40e3dd55bf947be = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$52388e8c4eec52d7 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$bfc21f912830cce0 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$84f8abf314fe1bca = "4px";
const $8b8adca400ca855b$export$299de995c72a7f6d = "0px";
const $8b8adca400ca855b$export$994684c23b7a2289 = "8px";
const $8b8adca400ca855b$export$d30bba31083c3b81 = "4px";
const $8b8adca400ca855b$export$c47c10b3a195b8bb = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$f1591bd858270ed3 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$fea961df0553afcf = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$e5b0c44f8687a2dd = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$ba60f029700a5b9a = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$fea74d0348af746c = "#001c33";
const $8b8adca400ca855b$export$c0cd56cb8adeb0c7 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$4c10101c8dcd9159 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$199b8a3a24f6052f = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$749561d1ff3174b6 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$5b7d5394e6b2d316 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$639d3915b8ce82b4 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$f991c2a34a669c11 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e05aad2434815ae1 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$a5efeb0d86e557f2 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$ac0c6ce6db4c1549 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$cb7b1f2bb4f70437 = "#ffffff";
const $8b8adca400ca855b$export$5b874dfd02e0b250 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$3cfc12423f70daae = "1px";
const $8b8adca400ca855b$export$454beb38955e81fd = "0px";
const $8b8adca400ca855b$export$e159fbe87f6978e3 = "36px";
const $8b8adca400ca855b$export$423b9caf92ea785c = "0px";
const $8b8adca400ca855b$export$ea96f43ec25cb42a = "100px";
const $8b8adca400ca855b$export$3f2b695522a06851 = "600";
const $8b8adca400ca855b$export$11aa2bc2efe9adc2 = "12px";
const $8b8adca400ca855b$export$5277ce3303456bf2 = "0px";
const $8b8adca400ca855b$export$e652800607db6b2 = "4px";
const $8b8adca400ca855b$export$3f1bc1575f23a5b9 = "16px";
const $8b8adca400ca855b$export$6779021d34866272 = "8px";
const $8b8adca400ca855b$export$9b25e8846de5a4c6 = "#ffffff";
const $8b8adca400ca855b$export$7ea9497196b9950c = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$1286c08a066cf92a = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $8b8adca400ca855b$export$452d31c71a4b2c7 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$29dfe4c30f5bdd8e = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$a9fd54786af2362e = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$522ef6dd6d045e1a = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$76ed2592815724ef = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$82c6bb6f9ef8ad05 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$7c79603c9689498a = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$c00e26acdc998f59 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e5b79ea5d86c9947 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e2940776f75e7bde = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$d17ee04829bf7e5d = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$e5f9b7707e340c07 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$4b146ead4a24d4ae = "#ffffff";
const $8b8adca400ca855b$export$16eea8645753ec95 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$ac43e96d39af0fe9 = "0px";
const $8b8adca400ca855b$export$175ca482ed6f6bca = "0px";
const $8b8adca400ca855b$export$732efe36f538d0b5 = "0px";
const $8b8adca400ca855b$export$51c06af4d25b7fbd = "14px";
const $8b8adca400ca855b$export$e24e0e94fc2167b7 = "400";
const $8b8adca400ca855b$export$26f066c1988aa416 = "4px";
const $8b8adca400ca855b$export$9213701f1f96ce09 = "4px";
const $8b8adca400ca855b$export$4931e5b26cc04c05 = "Manrope";
const $8b8adca400ca855b$export$6074a5e235cbf222 = "1px";
const $8b8adca400ca855b$export$c6fd4855184f2ce4 = "0px";
const $8b8adca400ca855b$export$e7c8cff1096cca6b = "2px";
const $8b8adca400ca855b$export$5f3989fc72b355c5 = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$694c340304b6cf03 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$295da88ee730d887 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$e76dfb999cb566ad = "hsl(200 30% 98% / 0)";
const $8b8adca400ca855b$export$6105cdb447f0f917 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$7504fc34155ea4ea = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$8af690634ab83d08 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$b0809c34687e6321 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$e7169e000728aae0 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$d49751a9f9c74d95 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$11780cad30f773c3 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$13ff4d77bf18846 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$dd5841622912a30 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$4ab353e2521798aa = "4px";
const $8b8adca400ca855b$export$f564560b1c0b69a0 = "0px";
const $8b8adca400ca855b$export$f8de90cd42beeba7 = "8px";
const $8b8adca400ca855b$export$f8d96a6e6e32683b = "Manrope";
const $8b8adca400ca855b$export$33b6ba26e004869a = "600";
const $8b8adca400ca855b$export$e857928a445edf3 = "12px";
const $8b8adca400ca855b$export$600f9c33474c074e = "12px";
const $8b8adca400ca855b$export$e7ff8df7907262bb = "0";
const $8b8adca400ca855b$export$ee9afb269ebcf753 = "linear-gradient(132deg, #F0F3FA 0%, #FBFCFF 100%);";
const $8b8adca400ca855b$export$905dbec0b0250e3b = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$ce6f6641c7bb2372 = "1px";
const $8b8adca400ca855b$export$4cbe16864bd24f8c = "0px";
const $8b8adca400ca855b$export$521605d09d8c162c = "70px";
const $8b8adca400ca855b$export$c425de24adc2b8b8 = "8px";
const $8b8adca400ca855b$export$2d128d3377891546 = "8px";
const $8b8adca400ca855b$export$170ee3bcb8ad49a0 = "linear-gradient(225deg, #FFF 0%, #F2F4F9 35.41%, #E7F1F6 100%);";
const $8b8adca400ca855b$export$b9184a6500088a33 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$a133f97fe8f7af80 = "1px";
const $8b8adca400ca855b$export$440bfa12676d4362 = "0px";
const $8b8adca400ca855b$export$23df00f94a7966ab = "276px";
const $8b8adca400ca855b$export$ddc6772884310bfd = "8px";
const $8b8adca400ca855b$export$da255a4cc88a4cac = "8px";
const $8b8adca400ca855b$export$b580f1a61f577587 = "16px";
const $8b8adca400ca855b$export$d48962f1fd8fbdea = "8px";
const $8b8adca400ca855b$export$113ff81b72ae4005 = "1px";
const $8b8adca400ca855b$export$aff0f3036f778118 = "1px";
const $8b8adca400ca855b$export$105006e16cdb4368 = "1px";
const $8b8adca400ca855b$export$83edc677e0bcbaf9 = "1px";
const $8b8adca400ca855b$export$be459879692fda29 = "1px";
const $8b8adca400ca855b$export$586c2c06158e5801 = "1px";
const $8b8adca400ca855b$export$a8ef96955ef6555c = "hsl(202 100% 40% / 0.1)";
const $8b8adca400ca855b$export$97032c77bb67830c = "hsl(202 100% 40% / 0.2)";
const $8b8adca400ca855b$export$6577f4536230e0ea = "hsl(202 100% 40% / 0.3)";
const $8b8adca400ca855b$export$87b87f0038f4c66f = "hsl(202 100% 40% / 0.4)";
const $8b8adca400ca855b$export$ec1dc93077563875 = "hsl(202 100% 40% / 0.5)";
const $8b8adca400ca855b$export$fce98b53ab002313 = "hsl(202 100% 40% / 0.6)";
const $8b8adca400ca855b$export$8e949091d329a301 = "hsl(202 100% 40% / 0.7)";
const $8b8adca400ca855b$export$94550a5bab2b5993 = "hsl(202 100% 40% / 0.8)";
const $8b8adca400ca855b$export$a8757e8f89513f1 = "hsl(202 100% 40% / 0.9)";
const $8b8adca400ca855b$export$e985323c829fd742 = "hsl(202, 100%, 40%)";
const $8b8adca400ca855b$export$19b7230ae44bbd30 = "hsl(266 63% 45% / 0.1)";
const $8b8adca400ca855b$export$b08be8e4ba1d6c82 = "hsl(266 63% 45% / 0.2)";
const $8b8adca400ca855b$export$145e11a833c7874d = "hsl(266 63% 45% / 0.3)";
const $8b8adca400ca855b$export$90cf3f223c496a71 = "hsl(266 63% 45% / 0.4)";
const $8b8adca400ca855b$export$6244798137efca9 = "hsl(266 63% 45% / 0.5)";
const $8b8adca400ca855b$export$72d20d5426576de3 = "hsl(266 63% 45% / 0.6)";
const $8b8adca400ca855b$export$5f909f40ccaa6cc4 = "hsl(266 63% 45% / 0.7)";
const $8b8adca400ca855b$export$3e47cc0b9b14ad09 = "hsl(266 63% 45% / 0.8)";
const $8b8adca400ca855b$export$36569f0f035d32d1 = "hsl(266 63% 45% / 0.9)";
const $8b8adca400ca855b$export$574e12a52c1b3e12 = "hsl(266, 63%, 45%)";
const $8b8adca400ca855b$export$74d6e4fad4bb88bf = "hsl(301 73% 75% / 0.1)";
const $8b8adca400ca855b$export$189fbb2766493c36 = "hsl(301 73% 75% / 0.2)";
const $8b8adca400ca855b$export$428da89f5a98a232 = "hsl(301 73% 75% / 0.3)";
const $8b8adca400ca855b$export$60edf238c6afd1e6 = "hsl(301 73% 75% / 0.4)";
const $8b8adca400ca855b$export$67e9edd6baebfbce = "hsl(301 73% 75% / 0.5)";
const $8b8adca400ca855b$export$ec3d0a210a5d4c2c = "hsl(301 73% 75% / 0.6)";
const $8b8adca400ca855b$export$f776cf7a0a505749 = "hsl(301 73% 75% / 0.7)";
const $8b8adca400ca855b$export$61698398be922542 = "hsl(301 73% 75% / 0.8)";
const $8b8adca400ca855b$export$99028bd1491db588 = "hsl(301 73% 75% / 0.9)";
const $8b8adca400ca855b$export$f0236e2c2ceff476 = "hsl(301, 73%, 75%)";
const $8b8adca400ca855b$export$f944771630b59cb5 = "hsl(169 82% 33% / 0.1)";
const $8b8adca400ca855b$export$cf875bcb83eeef36 = "hsl(169 82% 33% / 0.2)";
const $8b8adca400ca855b$export$d22935b11cd2da96 = "hsl(169 82% 33% / 0.3)";
const $8b8adca400ca855b$export$c09b5156af934baf = "hsl(169 82% 33% / 0.4)";
const $8b8adca400ca855b$export$cd03abab8825767c = "hsl(169 82% 33% / 0.5)";
const $8b8adca400ca855b$export$49d39abb22350b45 = "hsl(169 82% 33% / 0.6)";
const $8b8adca400ca855b$export$2e409639998b526b = "hsl(169 82% 33% / 0.7)";
const $8b8adca400ca855b$export$7431a515da39af8c = "hsl(169 82% 33% / 0.8)";
const $8b8adca400ca855b$export$f34384d6e022c3f3 = "hsl(169 82% 33% / 0.9)";
const $8b8adca400ca855b$export$10372af809834eae = "hsl(169, 82%, 33%)";
const $8b8adca400ca855b$export$a6eae9e7146720fd = "hsl(346 37% 43% / 0.1)";
const $8b8adca400ca855b$export$1645795e3158abbf = "hsl(346 37% 43% / 0.2)";
const $8b8adca400ca855b$export$cb63dd0ef69328da = "hsl(346 37% 43% / 0.3)";
const $8b8adca400ca855b$export$8906d6ccc1d3cf97 = "hsl(346 37% 43% / 0.4)";
const $8b8adca400ca855b$export$9705a2ef585a5a6c = "hsl(346 37% 43% / 0.5)";
const $8b8adca400ca855b$export$9a4904530e74d69b = "hsl(346 37% 43% / 0.6)";
const $8b8adca400ca855b$export$84fa53d9957f1633 = "hsl(346 37% 43% / 0.7)";
const $8b8adca400ca855b$export$261cc78142a16d2e = "hsl(346 37% 43% / 0.8)";
const $8b8adca400ca855b$export$84de24a511e4409e = "hsl(346 37% 43% / 0.9)";
const $8b8adca400ca855b$export$c5da345c40af16d0 = "hsl(346, 37%, 43%)";
const $8b8adca400ca855b$export$1a43e24e8356aef8 = "hsl(36 77% 40% / 0.1)";
const $8b8adca400ca855b$export$80cf8aa12b9a81d3 = "hsl(36 77% 40% / 0.2)";
const $8b8adca400ca855b$export$f060dd68476cd8e7 = "hsl(36 77% 40% / 0.3)";
const $8b8adca400ca855b$export$e439d3dd32b46274 = "hsl(36 77% 40% / 0.4)";
const $8b8adca400ca855b$export$a300ce07e8f90e40 = "hsl(36 77% 40% / 0.5)";
const $8b8adca400ca855b$export$a1ef18e9668adce2 = "hsl(36 77% 40% / 0.6)";
const $8b8adca400ca855b$export$6bc2d1ae052bf51c = "hsl(36 77% 40% / 0.7)";
const $8b8adca400ca855b$export$356c38cc88c30e38 = "hsl(36 77% 40% / 0.8)";
const $8b8adca400ca855b$export$4448f063fed043bf = "hsl(36 77% 40% / 0.9)";
const $8b8adca400ca855b$export$28182ad30600cb65 = "hsl(36, 77%, 40%)";
const $8b8adca400ca855b$export$b0f38d080d1f8f97 = "hsl(151 46% 17% / 0.1)";
const $8b8adca400ca855b$export$abd8f528d3152ac4 = "hsl(151 46% 17% / 0.2)";
const $8b8adca400ca855b$export$6314df582966a22f = "hsl(151 46% 17% / 0.3)";
const $8b8adca400ca855b$export$21214bfe4d7ae8b7 = "hsl(151 46% 17% / 0.4)";
const $8b8adca400ca855b$export$2b5f8a9ddff4d5c4 = "hsl(151 46% 17% / 0.5)";
const $8b8adca400ca855b$export$b63bfe40c28df8c8 = "hsl(151 46% 17% / 0.6)";
const $8b8adca400ca855b$export$a288b1bef1f363d6 = "hsl(151 46% 17% / 0.7)";
const $8b8adca400ca855b$export$ca2242167f4cec64 = "hsl(151 46% 17% / 0.8)";
const $8b8adca400ca855b$export$bb1d5655a98e9de6 = "hsl(151 46% 17% / 0.9)";
const $8b8adca400ca855b$export$113cda6f600a4ca4 = "hsl(151, 46%, 17%)";
const $8b8adca400ca855b$export$8ec4c1f865bc4296 = "hsl(36 97% 70% / 0.1)";
const $8b8adca400ca855b$export$80f831c9571e7721 = "hsl(36 97% 70% / 0.2)";
const $8b8adca400ca855b$export$7baea4598e0903db = "hsl(36 97% 70% / 0.3)";
const $8b8adca400ca855b$export$85cc5b9d5a5e8f07 = "hsl(36 97% 70% / 0.4)";
const $8b8adca400ca855b$export$c16430852d6ffb13 = "hsl(36 97% 70% / 0.5)";
const $8b8adca400ca855b$export$76289a8af80837cf = "hsl(36 97% 70% / 0.6)";
const $8b8adca400ca855b$export$52b981bfeaa81760 = "hsl(36 97% 70% / 0.7)";
const $8b8adca400ca855b$export$8e617b33cbf4490c = "hsl(36 97% 70% / 0.8)";
const $8b8adca400ca855b$export$a1aa25fd6a117918 = "hsl(36 97% 70% / 0.9)";
const $8b8adca400ca855b$export$f01739baaf9b181d = "hsl(36, 97%, 70%)";
const $8b8adca400ca855b$export$d90969089c78ff1a = "#ffffff";
const $8b8adca400ca855b$export$fcb89087e092a414 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$9bbe1e2e7d502781 = "Manrope";
const $8b8adca400ca855b$export$4a1d1c93af63034c = "400";
const $8b8adca400ca855b$export$440443a29ae7f444 = "12px";
const $8b8adca400ca855b$export$d87dd6c52509ab1c = "0";
const $8b8adca400ca855b$export$3f3169f0677cff68 = "12px";
const $8b8adca400ca855b$export$5e89ca37329331db = "#ffffff";
const $8b8adca400ca855b$export$2d683b41f8da6ca4 = "hsl(210, 20%, 90%)";
const $8b8adca400ca855b$export$73731597f6e69c9d = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$c927c3e959fbe8b = "hsl(0 0% 100% / 0)";
const $8b8adca400ca855b$export$a0f7cf38a8a00f2b = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$29f6789a57993025 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$4ec39546e154299 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$3f64927d3a4eb9ea = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$cfdc6390a7fab5c8 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$65e1e963096c903 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$6241dacc1b50fceb = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$fdbf6d5d010addf8 = "hsl(207, 100%, 90%)";
const $8b8adca400ca855b$export$50b1b763cf3e7ade = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$40362ccc2bdb3c26 = "#001c33";
const $8b8adca400ca855b$export$c204c1784cc516d0 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$2365ee05eae2bf7f = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$647245f05226e9f7 = "#001c33";
const $8b8adca400ca855b$export$794da0ddda9a3107 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$739a8d1bcdc7839d = "hsl(350, 70%, 96%)";
const $8b8adca400ca855b$export$94e174e73f70f159 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$788d135191815d53 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$2f7f338c6ca49382 = "hsl(210, 20%, 40%)";
const $8b8adca400ca855b$export$48e34a2ffe6a00d7 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$22ef0123e9b7779c = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$606938ff76eef7ca = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$c46a37e46831cb73 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$59052749eca57609 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$dd96312fb32772ab = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$eed6b1452607cf56 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$acced8db4ae2cf3b = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$77b24f6d99070e59 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$b34450f407ef29c6 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$ac70beace51d0dd4 = "#001c33";
const $8b8adca400ca855b$export$5c9eeed4e201b90e = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$f49ed7789dc61221 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$ddf2fa79327928f = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$f77baad962a57c8f = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$98ddb5e8ed3aa914 = "hsl(210, 20%, 30%)";
const $8b8adca400ca855b$export$1530dbd1b63da1da = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$9d2d9318edad804e = "#ffffff";
const $8b8adca400ca855b$export$a83f4a80f6994355 = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$72489d62081edb03 = "hsl(350, 70%, 20%)";
const $8b8adca400ca855b$export$266ec36a94b31c7b = "100px";
const $8b8adca400ca855b$export$1600af1791f8b4f = "100px";
const $8b8adca400ca855b$export$914b4b6244542bbf = "0px";
const $8b8adca400ca855b$export$44d950c57bc9d93 = "1px";
const $8b8adca400ca855b$export$be2a9d19912bffe8 = "Manrope";
const $8b8adca400ca855b$export$95492bbb433b5945 = "600";
const $8b8adca400ca855b$export$761832cf77cf363a = "0";
const $8b8adca400ca855b$export$b0eb4ef8cfa78960 = "12px";
const $8b8adca400ca855b$export$fed43e5dcd48f2dc = "12px";
const $8b8adca400ca855b$export$ae8f35fee23fdd6b = "14px";
const $8b8adca400ca855b$export$8862b9c5fc58c4fc = "16px";
const $8b8adca400ca855b$export$50a8a424d0152755 = "12px";
const $8b8adca400ca855b$export$bc28f5283ef6ba98 = "12px";
const $8b8adca400ca855b$export$291904bb2e85d148 = "16px";
const $8b8adca400ca855b$export$daf145493ab9a6de = "20px";
const $8b8adca400ca855b$export$415502a94bbbbee6 = "36px";
const $8b8adca400ca855b$export$465097bd75bdea60 = "4px";
const $8b8adca400ca855b$export$42d141f7fb68da3c = "4px";
const $8b8adca400ca855b$export$5584196c725943b3 = "8px";
const $8b8adca400ca855b$export$118d0bac41bf5c6f = "16px";
const $8b8adca400ca855b$export$b998fc4e363ee792 = "20px";
const $8b8adca400ca855b$export$c30418f3955f4770 = "36px";
const $8b8adca400ca855b$export$c511e0cf300b027a = "4px";
const $8b8adca400ca855b$export$54041063a1bf9d9f = "4px";
const $8b8adca400ca855b$export$fd2f38d8a289271e = "4px";
const $8b8adca400ca855b$export$6c2cf414b9a8b02 = "#001c33";
const $8b8adca400ca855b$export$74e8af3218f82048 = "100px";
const $8b8adca400ca855b$export$d631136dbd4f130 = "#ffffff";
const $8b8adca400ca855b$export$91580955f5b11a78 = "4px";
const $8b8adca400ca855b$export$2804a19e6721cd4d = "#ffffff";
const $8b8adca400ca855b$export$cd2372d2a66c08ad = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$8ef196ecc87f7934 = "hsl(210, 20%, 20%)";
const $8b8adca400ca855b$export$af7cd107f275c02a = "#ffffff";
const $8b8adca400ca855b$export$8490f4d3874147a3 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$b7a95a89583d4770 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$6bc9aee632a0607d = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$efbbc87ef9efc62c = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$5500a3415a8200bf = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$895d192a083edbcd = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$f8f9f853acd8dccc = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$a2b2fba0efcb64de = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$abb81216d8ead6d6 = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$c18fc16fd6ce2893 = "#001c33";
const $8b8adca400ca855b$export$9a9b411077d65d4 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$84ee0041f3b78053 = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$e3ae326d33644c8f = "#005499";
const $8b8adca400ca855b$export$f2093864c9741f6c = "#005499";
const $8b8adca400ca855b$export$50e035363ae06a71 = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$8d5f9203840e8cea = "hsl(210 20% 92% / 0)";
const $8b8adca400ca855b$export$6429134805d4f7b2 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$47bc82913eb62f9a = "hsl(210, 20%, 20%)";
const $8b8adca400ca855b$export$9a8ea6b0632902f8 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$9cea3abece3796dd = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$147f5a94c0d93a24 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$30427793cdcc11f = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$8dd2be958a4f682c = "#ffffff";
const $8b8adca400ca855b$export$6941f05285867423 = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$4b525576dbb2a4d = "hsl(207, 100%, 30%)";
const $8b8adca400ca855b$export$ad62b5a3f8569d6e = "1px";
const $8b8adca400ca855b$export$946b06a7a267d247 = "0px";
const $8b8adca400ca855b$export$2400272ad19e2fe5 = "36px";
const $8b8adca400ca855b$export$993c88baafc7364 = "44px";
const $8b8adca400ca855b$export$9bebe7546b06ea6b = "56px";
const $8b8adca400ca855b$export$e1d34ffbb73e4967 = "8px";
const $8b8adca400ca855b$export$6c9ea1231c05ae2 = "16px";
const $8b8adca400ca855b$export$34e1f4c8e40a4ed4 = "24px";
const $8b8adca400ca855b$export$6f5f0ec032a5cd2a = "0px";
const $8b8adca400ca855b$export$3533b594e8a22e61 = "276px";
const $8b8adca400ca855b$export$3162d64b8e7996c0 = "376px";
const $8b8adca400ca855b$export$904c18abb803aa9f = "#ffffff";
const $8b8adca400ca855b$export$cfbe570aaf4a5b77 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$ac0e121c105675cd = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$9e386e8d2c73a924 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$63daf5c1ff2410fd = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$2167e31118bb40d7 = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$966b83fbdad8ff13 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$c06450425bd9035c = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$ddde5722037bdb1a = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$544f4daa03c97c0c = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$633198cc99623271 = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$fbbb4a5d1412c3f3 = "#001c33";
const $8b8adca400ca855b$export$35db974a8b01923c = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$42938dc8e4554ca = "hsl(207, 100%, 20%)";
const $8b8adca400ca855b$export$4a1178fab316a183 = "#005499";
const $8b8adca400ca855b$export$c114ec50f0f18b26 = "#005499";
const $8b8adca400ca855b$export$f5465bf2d3de925d = "#ffffff";
const $8b8adca400ca855b$export$6053f363b9ebffff = "hsl(210, 20%, 98%)";
const $8b8adca400ca855b$export$f3f16eb733cd113b = "hsl(210, 20%, 20%)";
const $8b8adca400ca855b$export$f49a1acfc2525900 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$514e04a8b12a1404 = "hsl(200, 30%, 60%)";
const $8b8adca400ca855b$export$95733713edee3c14 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$28932b8bfce45f38 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$edce63b38f08b44d = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$fa6c9f7aabe0a2e2 = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$623652b8691265a = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$b8ffe5941b3130ba = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$18e765ec8d586da3 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$36f1da88e0a16b94 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$bbe5df2b165b1606 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$67562899c4dd8d01 = "hsl(200, 30%, 82%)";
const $8b8adca400ca855b$export$c0908d88aaa39084 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$2035a1d319e4a134 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$290823ff5c4d6a31 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$9a7c2ed2267bf628 = "hsl(200 30% 82% / 0.38)";
const $8b8adca400ca855b$export$7d32452142f66e8 = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$91106c4c34773b8b = "hsl(210, 20%, 82%)";
const $8b8adca400ca855b$export$78ccf4c9305987f2 = "hsl(210, 20%, 20%)";
const $8b8adca400ca855b$export$9fb0c8224ca90269 = "8px";
const $8b8adca400ca855b$export$f38773b397c64fe3 = "16px";
const $8b8adca400ca855b$export$68dfe0e438ed927f = "24px";
const $8b8adca400ca855b$export$6b1192f8dbbe8ca4 = "1px";
const $8b8adca400ca855b$export$9006004e350aae36 = "0px";
const $8b8adca400ca855b$export$4933986e86984502 = "4px";
const $8b8adca400ca855b$export$a08a5ca1c9e2d77 = "2px";
const $8b8adca400ca855b$export$4428090006cc5e8f = "100px";
const $8b8adca400ca855b$export$6b437ae17434a562 = "0 0 0 0 hsl(200, 30%, 86%)";
const $8b8adca400ca855b$export$e439e7a9a522c8bd = "0 12px 24px 0 rgba(0,0,0,0.2)";
const $8b8adca400ca855b$export$f6f9c9aa81f0acb9 = "#ffffff";
const $8b8adca400ca855b$export$5707e412b97a3d17 = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$7ee0f670470f616e = "hsl(207, 100%, 98%)";
const $8b8adca400ca855b$export$602a5bdac5f15cd4 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$a4b65a2a4760aa2e = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$99b6fb3a8cddfde2 = "hsl(200, 30%, 96%)";
const $8b8adca400ca855b$export$6f41d812463dcc26 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$bd26b519eb710637 = "hsl(207, 100%, 96%)";
const $8b8adca400ca855b$export$8c129a8c71396c89 = "hsl(207, 100%, 92%)";
const $8b8adca400ca855b$export$ea53d93807b2be6c = "hsl(207, 100%, 86%)";
const $8b8adca400ca855b$export$de181742c8a3a8ed = "hsl(0 0% 100% / 0.38)";
const $8b8adca400ca855b$export$ac909337994ad4cc = "hsl(210, 20%, 92%)";
const $8b8adca400ca855b$export$47cee41927ea7a65 = "hsl(207, 100%, 50%)";
const $8b8adca400ca855b$export$29bf0efdf9aa6973 = "hsl(210, 20%, 10%)";
const $8b8adca400ca855b$export$2a97efadeb1968eb = "hsl(200 30% 50% / 0.38)";
const $8b8adca400ca855b$export$f074b54a1a690e59 = "8px";
const $8b8adca400ca855b$export$9f94c55002684827 = "16px";
const $8b8adca400ca855b$export$ae05400eb6210b52 = "24px";
const $8b8adca400ca855b$export$8ea2eaf73829f82b = "1px";
const $8b8adca400ca855b$export$5ead36882857d7b8 = "0px";


const $5cffe40b21e31a28$var$useTokens = ()=>{
    var _a;
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const tokens = ((_a = theme.custom) === null || _a === void 0 ? void 0 : _a.identifier) === 'cudaLight' ? (0, $8b8adca400ca855b$exports) : (0, $3276e9745553f254$exports);
    return tokens;
};
var $5cffe40b21e31a28$export$2e2bcd8739ae039 = $5cffe40b21e31a28$var$useTokens;


function $8ca96de559714ea7$export$fddf379e22a74b00({ icon: icon, text: text }) {
    const tokens = (0, $5cffe40b21e31a28$export$2e2bcd8739ae039)();
    return (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
            container: true,
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            spacing: 1
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
            item: true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(icon, {
            fill: tokens.aliasesColorIllustrationGray
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
            item: true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
            variant: "h4"
        }, text))), [
        icon,
        text
    ]);
}
var $8ca96de559714ea7$export$2e2bcd8739ae039 = $8ca96de559714ea7$export$fddf379e22a74b00;


var $ffcf2695d9f33df9$export$2e2bcd8739ae039 = (0, $8ca96de559714ea7$export$2e2bcd8739ae039);



(0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register((0, $4049e6bf31df43d6$export$2e2bcd8739ae039), (0, $216d2bdc6f281bf6$export$e97d5dc64e999004), (0, $216d2bdc6f281bf6$export$a16ed71bf4b07672), (0, $216d2bdc6f281bf6$export$29e663ba4d09fe7), (0, $216d2bdc6f281bf6$export$ed247974535929c7), (0, $216d2bdc6f281bf6$export$e7f4e5e8656f0b93), (0, $216d2bdc6f281bf6$export$28c660c63b792dea));
function $15e5657badb589f0$export$94aefc399ef206a9({ chartDimension: chartDimension, chartData: chartData, emptyState: emptyState, hasEntries: hasEntries, barChartOptions: barChartOptions, horizontalBarChart: horizontalBarChart = false, maintainAspectRatio: maintainAspectRatio = false, customFooter: customFooter, showFooter: showFooter = true, showLegend: showLegend = false, stacked: stacked = false }) {
    const { height: height, width: width } = chartDimension;
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const tokens = (0, $5cffe40b21e31a28$export$2e2bcd8739ae039)();
    // Chart config for horizontal bar chart
    const horizontalScaleConfig = {
        x: {
            stacked: stacked,
            grid: {
                display: true
            }
        },
        y: {
            stacked: stacked,
            grid: {
                display: false
            }
        }
    };
    // Base axis of the dataset for horizontal bar chart
    const horizontalDataset = 'y';
    // Chart config for vertical bar chart
    const verticalScaleConfig = {
        x: {
            stacked: stacked,
            grid: {
                display: false
            }
        },
        y: {
            stacked: stacked,
            grid: {
                display: true
            }
        }
    };
    // Base axis of the dataset for vertical bar chart
    const verticalDataset = 'x';
    // Default footer function to get sum of all tooltip items
    const footer = (tooltipItems)=>{
        const sum = tooltipItems.reduce((acc, tooltipItem)=>acc + tooltipItem.parsed[horizontalBarChart ? 'x' : 'y'], 0);
        return `Total: ${sum}`;
    };
    const defaultChartConfig = {
        maintainAspectRatio: maintainAspectRatio,
        plugins: {
            legend: {
                display: showLegend
            },
            tooltip: {
                borderColor: theme.palette.customDivider.border.color,
                borderWidth: parseFloat(theme.palette.customDivider.border.width),
                boxPadding: 8,
                boxShadow: '0px 12px 24px 0px rgba(0, 0, 0, 0.20)',
                titleColor: tokens.aliasesColorTextStaticEmphasis,
                titleFont: {
                    size: theme.typography.fontSize,
                    weight: theme.typography.fontWeightBold
                },
                titleMarginBottom: parseFloat(tokens.aliasesSpaceContainerDefault),
                interaction: {
                    mode: 'index'
                },
                backgroundColor: tokens.aliasesColorBgStaticContainerSubtle,
                bodyColor: theme.typography.body1.color,
                bodySpacing: 8,
                padding: parseFloat(tokens.aliasesSpaceContainerDense),
                bodyFont: {
                    size: theme.typography.fontSize
                },
                usePointStyle: true,
                callbacks: {
                    footer: showFooter ? customFooter || footer : undefined
                },
                footerAlign: 'right',
                footerColor: theme.typography.body1.color,
                footerMarginTop: parseFloat(tokens.aliasesSpaceContainerDefault)
            }
        },
        indexAxis: horizontalBarChart ? horizontalDataset : verticalDataset,
        scales: horizontalBarChart ? horizontalScaleConfig : verticalScaleConfig
    };
    // if barChartOptions are provided merge them into defaultChartConfig, if not use defaultChartConfig
    const options = barChartOptions ? (0, (/*@__PURE__*/$parcel$interopDefault($82652140c2d744c1$exports)))(defaultChartConfig, barChartOptions) : defaultChartConfig;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
        container: true,
        spacing: 0,
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        style: {
            width: width,
            height: height
        }
    }, hasEntries ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e3267dd1fa7af6a7$export$bbc6c6369b38e3d1), {
        data: chartData,
        options: options
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ffcf2695d9f33df9$export$2e2bcd8739ae039), Object.assign({}, emptyState)));
}
var $15e5657badb589f0$export$2e2bcd8739ae039 = $15e5657badb589f0$export$94aefc399ef206a9;


var $12f35e2f8b869a3c$export$2e2bcd8739ae039 = (0, $15e5657badb589f0$export$2e2bcd8739ae039);


var $19b86ddc2142d157$export$2e2bcd8739ae039 = (0, $00a20d475386f68c$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");


var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $b86eb8364bb4993c$exports = {};

$parcel$defineInteropFlag($b86eb8364bb4993c$exports);

$parcel$export($b86eb8364bb4993c$exports, "getCircularProgressUtilityClass", () => $b86eb8364bb4993c$export$29cad1383b3f235d);
$parcel$export($b86eb8364bb4993c$exports, "default", () => $b86eb8364bb4993c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $19b4ac261663afa8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $19b4ac261663afa8$var$_ = (t)=>t, $19b4ac261663afa8$var$_t, $19b4ac261663afa8$var$_t2, $19b4ac261663afa8$var$_t3, $19b4ac261663afa8$var$_t4;
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t || ($19b4ac261663afa8$var$_t = $19b4ac261663afa8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t2 || ($19b4ac261663afa8$var$_t2 = $19b4ac261663afa8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b86eb8364bb4993c$export$29cad1383b3f235d), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $jjlaj.css)($19b4ac261663afa8$var$_t3 || ($19b4ac261663afa8$var$_t3 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $19b4ac261663afa8$var$circularRotateKeyframe));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $jjlaj.css)($19b4ac261663afa8$var$_t4 || ($19b4ac261663afa8$var$_t4 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $19b4ac261663afa8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $1En50.default)(props, $19b4ac261663afa8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;



var $d8seH = parcelRequire("d8seH");
// TODO:  Using the linear tokens to create the circular tokens
// Ann will create the circular tokens
const $673143a986345ecf$var$StyledCircularProgress = (0, $d8seH.default)((props)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b4ac261663afa8$export$2e2bcd8739ae039), Object.assign({}, props)))(({ theme: theme })=>({
        backgroundColor: 'transparent',
        '& .MuiCircularProgress-svg': {
            color: theme.palette.linearProgress.fill.background.default
        }
    }));
const $673143a986345ecf$var$BDSCircularProgress = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($673143a986345ecf$var$StyledCircularProgress, Object.assign({}, props));
};
var $673143a986345ecf$export$2e2bcd8739ae039 = $673143a986345ecf$var$BDSCircularProgress;


/**
 * Global state to keep track of which warnings have been shown
 */ const $600dd74f68ddb378$var$WARNINGS_STATE = {};
const $600dd74f68ddb378$export$373ccc48b6a48668 = (componentName, prop, value, defaultValue)=>{
    const warningKey = `invalidProp-${componentName}-${prop}`;
    if (!$600dd74f68ddb378$var$WARNINGS_STATE[warningKey]) {
        const message = `Warning: Invalid value '${value !== null && value !== void 0 ? value : 'undefined'}' for prop '${prop}' in component '${componentName}'.${defaultValue !== undefined ? ` Defaulting to: '${defaultValue}'.` : ''}`;
        // eslint-disable-next-line no-console
        console.warn(message);
        $600dd74f68ddb378$var$WARNINGS_STATE[warningKey] = true;
    }
};
const $600dd74f68ddb378$export$fd85fde5373f97ba = (componentName, message)=>{
    const warningKey = `deprecation-${componentName}-${message}`;
    if (!$600dd74f68ddb378$var$WARNINGS_STATE[warningKey]) {
        // eslint-disable-next-line no-console
        console.warn(`Deprecation Warning in '${componentName}': ${message}`);
        $600dd74f68ddb378$var$WARNINGS_STATE[warningKey] = true; // Mark this warning as logged
    }
};


var $5b313a59ade87c77$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5b313a59ade87c77$var$validTypes = [
    'interactiveNeutral',
    'interactiveSubtle',
    'interactiveEmphasis'
];
const $5b313a59ade87c77$var$getBaseStyles = (theme, type, disabled, selected)=>{
    return Object.assign(Object.assign({
        backgroundColor: selected ? theme.palette.button.interactive[type].background.selected.default : theme.palette.button.interactive[type].background.default,
        border: selected ? `${theme.palette.button.borderWidth} solid ${theme.palette.button.interactive[type].border.selected.default}` : `${theme.palette.button.borderWidth} solid ${theme.palette.button.interactive[type].border.default}`,
        color: theme.palette.button.interactive[type].text,
        hover: {
            backgroundColor: selected ? theme.palette.button.interactive[type].background.selected.hover : theme.palette.button.interactive[type].background.hover,
            border: selected ? `${theme.palette.button.borderWidth} solid ${theme.palette.button.interactive[type].border.selected.hover}` : `${theme.palette.button.borderWidth} solid ${theme.palette.button.interactive[type].border.hover}`
        },
        focus: {
            backgroundColor: theme.palette.button.interactive[type].background.focus,
            border: `${theme.palette.button.borderWidth} solid ${theme.palette.button.interactive[type].border.focus}`
        }
    }, disabled && {
        backgroundColor: theme.palette.button.interactive[type].background.disabled,
        border: `${theme.palette.button.borderWidth} solid ${theme.palette.button.interactive[type].border.disabled}`,
        opacity: 1
    }), {
        icon: {
            color: disabled ? theme.palette.button.interactive[type].icon.disabled : theme.palette.button.interactive[type].icon.default
        }
    });
};
const $5b313a59ade87c77$var$getButtonStyles = (theme, bdsType, disabled, selected)=>{
    // If bdsType is invalid, log the error and return undefined
    if (bdsType && !$5b313a59ade87c77$var$validTypes.includes(bdsType)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Button', 'bdsType', bdsType);
        return undefined;
    }
    // Switch for valid bdsType values
    switch(bdsType){
        case 'interactiveNeutral':
            return $5b313a59ade87c77$var$getBaseStyles(theme, 'neutral', disabled, selected);
        case 'interactiveSubtle':
            return $5b313a59ade87c77$var$getBaseStyles(theme, 'subtle', disabled, selected);
        case 'interactiveEmphasis':
            return $5b313a59ade87c77$var$getBaseStyles(theme, 'emphasis', disabled, selected);
        default:
            // This case shouldn't happen because we've already handled invalid types
            // But keeping it just in case to catch any future edge cases
            (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Button', 'bdsType', bdsType);
            return undefined;
    }
};
const $5b313a59ade87c77$var$StyledButton = (0, $d8seH.default)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'bdsType',
            'selected'
        ].includes(prop)
})(({ theme: theme, bdsType: bdsType = 'interactiveEmphasis', disabled: disabled, selected: selected })=>{
    var _a, _b;
    const buttonStyles = bdsType ? $5b313a59ade87c77$var$getButtonStyles(theme, bdsType, disabled, selected) : undefined;
    return Object.assign(Object.assign({
        borderRadius: theme.palette.button.radius,
        padding: theme.palette.button.padding,
        height: theme.palette.button.height,
        fontFamily: theme.palette.button.font.family,
        fontSize: theme.palette.button.font.size,
        fontWeight: theme.palette.button.font.weight,
        lineHeight: theme.palette.button.font.lineHeight,
        letterSpacing: theme.palette.button.font.letterSpacing,
        textTransform: 'none',
        gap: theme.palette.button.spaceBetween
    }, buttonStyles && Object.assign(Object.assign({
        backgroundColor: buttonStyles.backgroundColor,
        border: buttonStyles.border,
        color: buttonStyles.color
    }, buttonStyles.hover && {
        '&:hover': {
            backgroundColor: buttonStyles.hover.backgroundColor,
            border: buttonStyles.hover.border
        }
    }), buttonStyles.focus && {
        '&:focus': {
            backgroundColor: buttonStyles.focus.backgroundColor,
            border: buttonStyles.focus.border
        }
    })), {
        // Gap is set above
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            margin: 0,
            fill: (_b = (_a = $5b313a59ade87c77$var$getButtonStyles(theme, bdsType, disabled)) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.color
        }
    });
});
// Need to use forwardRef to pass ref to the underlying button element
// For components like Tooltip, Popover, etc. that use the ref prop to attach the element to the anchor
const $5b313a59ade87c77$var$BDSButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { children: children, disabled: disabled, isLoading: isLoading = false, bdsType: bdsType, startIcon: startIcon, endIcon: endIcon, selected: selected = false } = _a, props = $5b313a59ade87c77$var$__rest(_a, [
        "children",
        "disabled",
        "isLoading",
        "bdsType",
        "startIcon",
        "endIcon",
        "selected"
    ]);
    // Ensure props are being applied correctly
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5b313a59ade87c77$var$StyledButton, Object.assign({
        ref: ref
    }, props, {
        disabled: isLoading || disabled,
        bdsType: bdsType,
        startIcon: startIcon,
        endIcon: endIcon,
        selected: selected
    }), isLoading && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $673143a986345ecf$export$2e2bcd8739ae039), {
        // TODO: Add size prop to CircularProgress
        size: 24,
        sx: {
            position: 'absolute'
        }
    }), children);
});
$5b313a59ade87c77$var$BDSButton.displayName = 'Button';
var $5b313a59ade87c77$export$2e2bcd8739ae039 = $5b313a59ade87c77$var$BDSButton;


var $e07056a6ae53845f$export$2e2bcd8739ae039 = (0, $5b313a59ade87c77$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $23fa506264c010ed$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $23fa506264c010ed$export$2e2bcd8739ae039 = $23fa506264c010ed$var$getOverlayAlpha;



var $1iOpW = parcelRequire("1iOpW");

var $4ec306d48089c2c9$exports = {};

$parcel$defineInteropFlag($4ec306d48089c2c9$exports);

$parcel$export($4ec306d48089c2c9$exports, "getPaperUtilityClass", () => $4ec306d48089c2c9$export$29cdb466b9b6f20b);
$parcel$export($4ec306d48089c2c9$exports, "default", () => $4ec306d48089c2c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ec306d48089c2c9$export$29cdb466b9b6f20b), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $8nd05.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $8nd05.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $kTdcz.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $kTdcz.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other));
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;


var $89a1bb9709695920$exports = {};

$parcel$defineInteropFlag($89a1bb9709695920$exports);

$parcel$export($89a1bb9709695920$exports, "getCardUtilityClass", () => $89a1bb9709695920$export$f3b76d2cce458caa);
$parcel$export($89a1bb9709695920$exports, "default", () => $89a1bb9709695920$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $89a1bb9709695920$export$f3b76d2cce458caa(slot) {
    return (0, $4Cod0.default)('MuiCard', slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $beCSm.default)('MuiCard', [
    'root'
]);
var $89a1bb9709695920$export$2e2bcd8739ae039 = $89a1bb9709695920$var$cardClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $45313e7d506ce734$var$_excluded = [
    "className",
    "raised"
];
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $89a1bb9709695920$export$f3b76d2cce458caa), classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $1En50.default)(props, $45313e7d506ce734$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        raised: raised
    });
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $45313e7d506ce734$export$2e2bcd8739ae039 = $45313e7d506ce734$var$Card;



var $d8seH = parcelRequire("d8seH");



var $13b4712c1e2153fc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $13b4712c1e2153fc$var$validTypes = [
    'staticNeutral',
    'staticSubtle',
    'staticEmphasis',
    'interactiveNeutral',
    'interactiveSubtle',
    'interactiveEmphasis'
];
const $13b4712c1e2153fc$var$validPadding = [
    'default',
    'dense',
    'spacious'
];
const $13b4712c1e2153fc$var$validGap = [
    'default',
    'dense',
    'spacious'
];
const $13b4712c1e2153fc$var$validBorderRadius = [
    'default',
    'sharp',
    'round'
];
const $13b4712c1e2153fc$var$validBoxShadow = [
    'default',
    'floating'
];
const $13b4712c1e2153fc$var$validWidth = [
    'default',
    'none'
];
// Function to get card styles based on the bdsType and selected props
const $13b4712c1e2153fc$var$getCardStyles = (theme, bdsType, bdsBorderWidth, selected)=>{
    if (bdsType && !$13b4712c1e2153fc$var$validTypes.includes(bdsType)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Card', 'bdsType', bdsType);
        return undefined;
    }
    const defaultBorderWidth = theme.palette.card.border.width[bdsBorderWidth !== null && bdsBorderWidth !== void 0 ? bdsBorderWidth : 'default'];
    const stylesMap = {
        staticNeutral: {
            backgroundColor: theme.palette.card.static.neutral.background.default,
            border: `${defaultBorderWidth} solid ${theme.palette.card.static.neutral.border.default}`
        },
        staticSubtle: {
            backgroundColor: theme.palette.card.static.subtle.background.default,
            border: `${defaultBorderWidth} solid ${theme.palette.card.static.subtle.border.default}`
        },
        staticEmphasis: {
            backgroundColor: theme.palette.card.static.emphasis.background.default,
            border: `${defaultBorderWidth} solid ${theme.palette.card.static.emphasis.border.default}`
        },
        interactiveNeutral: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.card.interactive.neutral.background.selected.default : theme.palette.card.interactive.neutral.background.default,
            border: selected ? `${defaultBorderWidth} solid ${theme.palette.card.interactive.neutral.border.selected.default}` : `${defaultBorderWidth} solid ${theme.palette.card.interactive.neutral.border.default}`,
            hover: {
                backgroundColor: selected ? theme.palette.card.interactive.neutral.background.selected.hover : theme.palette.card.interactive.neutral.background.hover,
                border: selected ? `${defaultBorderWidth} solid ${theme.palette.card.interactive.neutral.border.selected.hover}` : `${defaultBorderWidth} solid ${theme.palette.card.interactive.neutral.border.hover}`
            },
            focus: {
                backgroundColor: theme.palette.card.interactive.neutral.background.focus,
                border: `${defaultBorderWidth} solid ${theme.palette.card.interactive.neutral.border.focus}`
            }
        },
        interactiveSubtle: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.card.interactive.subtle.background.selected.default : theme.palette.card.interactive.subtle.background.default,
            border: selected ? `${defaultBorderWidth} solid ${theme.palette.card.interactive.subtle.border.selected.default}` : `${defaultBorderWidth} solid ${theme.palette.card.interactive.subtle.border.default}`,
            hover: {
                backgroundColor: selected ? theme.palette.card.interactive.subtle.background.selected.hover : theme.palette.card.interactive.subtle.background.hover,
                border: selected ? `${defaultBorderWidth} solid ${theme.palette.card.interactive.subtle.border.selected.hover}` : `${defaultBorderWidth} solid ${theme.palette.card.interactive.subtle.border.hover}`
            },
            focus: {
                backgroundColor: theme.palette.card.interactive.subtle.background.focus,
                border: `${defaultBorderWidth} solid ${theme.palette.card.interactive.subtle.border.focus}`
            }
        },
        interactiveEmphasis: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.card.interactive.emphasis.background.selected.default : theme.palette.card.interactive.emphasis.background.default,
            border: selected ? `${defaultBorderWidth} solid ${theme.palette.card.interactive.emphasis.border.selected.default}` : `${defaultBorderWidth} solid ${theme.palette.card.interactive.emphasis.border.default}`,
            hover: {
                backgroundColor: selected ? theme.palette.card.interactive.emphasis.background.selected.hover : theme.palette.card.interactive.emphasis.background.hover,
                border: selected ? `${defaultBorderWidth} solid ${theme.palette.card.interactive.emphasis.border.selected.hover}` : `${defaultBorderWidth} solid ${theme.palette.card.interactive.emphasis.border.hover}`
            },
            focus: {
                backgroundColor: theme.palette.card.interactive.emphasis.background.focus,
                border: `${defaultBorderWidth} solid ${theme.palette.card.interactive.emphasis.border.focus}`
            }
        }
    };
    return stylesMap[bdsType] || undefined;
};
// Function to get border radius based on the bdsBorderRadius prop
const $13b4712c1e2153fc$var$getBorderRadius = (theme, bdsBorderRadius)=>{
    if (bdsBorderRadius && !$13b4712c1e2153fc$var$validBorderRadius.includes(bdsBorderRadius)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Card', 'bdsBorderRadius', bdsBorderRadius);
        return undefined;
    }
    return bdsBorderRadius ? theme.palette.card.border.radius[bdsBorderRadius] : undefined;
};
// Function to get box shadow based on the bdsBoxShadow prop
const $13b4712c1e2153fc$var$getBoxShadow = (theme, bdsBoxShadow)=>{
    if (bdsBoxShadow && !$13b4712c1e2153fc$var$validBoxShadow.includes(bdsBoxShadow)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Card', 'bdsBoxShadow', bdsBoxShadow);
        return undefined;
    }
    return bdsBoxShadow ? theme.palette.card.boxShadow[bdsBoxShadow] : undefined;
};
// Function to get padding based on the bdsPadding prop
const $13b4712c1e2153fc$var$getPadding = (theme, bdsPadding)=>{
    if (bdsPadding && !$13b4712c1e2153fc$var$validPadding.includes(bdsPadding)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Card', 'bdsPadding', bdsPadding);
        return undefined;
    }
    return bdsPadding ? theme.palette.card.padding[bdsPadding] : undefined;
};
// Function to get padding based on the bdsPadding prop
const $13b4712c1e2153fc$var$getGap = (theme, bdsGap)=>{
    if (bdsGap && !$13b4712c1e2153fc$var$validGap.includes(bdsGap)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Card', 'bdsGap', bdsGap);
        return undefined;
    }
    return bdsGap ? theme.palette.card.padding[bdsGap] : undefined;
};
// Function to get width based on the bdsBorderWidth prop
const $13b4712c1e2153fc$var$getWidth = (theme, bdsBorderWidth)=>{
    if (bdsBorderWidth && !$13b4712c1e2153fc$var$validWidth.includes(bdsBorderWidth)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Card', 'bdsBorderWidth', bdsBorderWidth);
        return undefined;
    }
    return bdsBorderWidth ? theme.palette.card.border.width[bdsBorderWidth] : undefined;
};
const $13b4712c1e2153fc$var$StyledCard = (0, $d8seH.default)((0, $45313e7d506ce734$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'bdsBorderRadius',
            'bdsBoxShadow',
            'bdsGap',
            'bdsPadding',
            'bdsType',
            'bdsBorderWidth',
            'disabled',
            'selected',
            'titleVariant'
        ].includes(prop)
})(({ theme: theme, bdsGap: bdsGap, bdsType: bdsType, bdsPadding: bdsPadding, bdsBorderRadius: bdsBorderRadius, bdsBoxShadow: bdsBoxShadow, bdsBorderWidth: bdsBorderWidth, selected: selected, disabled: disabled })=>{
    const cardStyles = bdsType && $13b4712c1e2153fc$var$getCardStyles(theme, bdsType, bdsBorderWidth, selected) || undefined;
    const borderRadius = bdsBorderRadius && $13b4712c1e2153fc$var$getBorderRadius(theme, bdsBorderRadius) || undefined;
    const boxShadow = bdsBoxShadow && $13b4712c1e2153fc$var$getBoxShadow(theme, bdsBoxShadow) || undefined;
    const padding = bdsPadding && $13b4712c1e2153fc$var$getPadding(theme, bdsPadding) || undefined;
    const borderWidth = bdsBorderWidth && $13b4712c1e2153fc$var$getWidth(theme, bdsBorderWidth) || undefined;
    const gap = bdsGap && $13b4712c1e2153fc$var$getGap(theme, bdsGap) || undefined;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, cardStyles), borderRadius && {
        borderRadius: borderRadius
    }), boxShadow && {
        boxShadow: boxShadow
    }), padding && {
        padding: padding
    }), borderWidth && {
        borderWidth: borderWidth
    }), gap && {
        gap: gap
    }), {
        '&:hover': (cardStyles === null || cardStyles === void 0 ? void 0 : cardStyles.hover) && {
            backgroundColor: cardStyles.hover.backgroundColor,
            border: cardStyles.hover.border
        },
        '&:focus-visible': (cardStyles === null || cardStyles === void 0 ? void 0 : cardStyles.focus) && {
            backgroundColor: cardStyles.focus.backgroundColor,
            border: cardStyles.focus.border
        }
    }), disabled && {
        cursor: 'default',
        backgroundColor: theme.palette.card.interactive.disabled.background,
        border: `${theme.palette.card.border.width[bdsBorderWidth !== null && bdsBorderWidth !== void 0 ? bdsBorderWidth : 'default']} solid ${theme.palette.card.interactive.disabled.border}`,
        opacity: 1,
        '&:hover': {},
        '&:focus-visible': {}
    });
});
const $13b4712c1e2153fc$var$BDSCard = (props)=>{
    const { bdsBorderRadius: bdsBorderRadius, bdsBoxShadow: bdsBoxShadow, bdsGap: bdsGap, bdsPadding: bdsPadding, bdsType: bdsType, bdsBorderWidth: bdsBorderWidth, children: children, disabled: disabled, onClick: onClick, selected: selected, title: title, titleVariant: titleVariant } = props, rest = $13b4712c1e2153fc$var$__rest(props, [
        "bdsBorderRadius",
        "bdsBoxShadow",
        "bdsGap",
        "bdsPadding",
        "bdsType",
        "bdsBorderWidth",
        "children",
        "disabled",
        "onClick",
        "selected",
        "title",
        "titleVariant"
    ]);
    const tokens = (0, $5cffe40b21e31a28$export$2e2bcd8739ae039)();
    // Handle click event for the card
    const handleCardClick = (event)=>{
        if (!disabled && onClick) onClick(event);
    };
    const renderTitle = ()=>{
        if (!title) return null;
        const titleColor = (bdsType === null || bdsType === void 0 ? void 0 : bdsType.includes('Emphasis')) ? tokens.aliasesColorTextInverseEmphasis : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), Object.assign({}, titleVariant && {
            variant: titleVariant
        }, titleColor && {
            sx: {
                color: titleColor
            }
        }), title);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($13b4712c1e2153fc$var$StyledCard, Object.assign({
        bdsBorderRadius: bdsBorderRadius,
        bdsBoxShadow: bdsBoxShadow,
        bdsGap: bdsGap,
        bdsPadding: bdsPadding,
        bdsType: bdsType,
        bdsBorderWidth: bdsBorderWidth,
        disabled: disabled,
        onClick: handleCardClick,
        selected: selected,
        title: title,
        titleVariant: titleVariant
    }, disabled && {
        'aria-disabled': true
    }, rest), renderTitle(), children);
};
$13b4712c1e2153fc$var$BDSCard.displayName = 'Card';
var $13b4712c1e2153fc$export$2e2bcd8739ae039 = $13b4712c1e2153fc$var$BDSCard;




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $273fd99738f3adbe$exports = {};

$parcel$defineInteropFlag($273fd99738f3adbe$exports);

$parcel$export($273fd99738f3adbe$exports, "getCardContentUtilityClass", () => $273fd99738f3adbe$export$964336739a8c7119);
$parcel$export($273fd99738f3adbe$exports, "default", () => $273fd99738f3adbe$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $273fd99738f3adbe$export$964336739a8c7119(slot) {
    return (0, $4Cod0.default)('MuiCardContent', slot);
}
const $273fd99738f3adbe$var$cardContentClasses = (0, $beCSm.default)('MuiCardContent', [
    'root'
]);
var $273fd99738f3adbe$export$2e2bcd8739ae039 = $273fd99738f3adbe$var$cardContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $28a500ea92f2665f$var$_excluded = [
    "className",
    "component"
];
const $28a500ea92f2665f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $273fd99738f3adbe$export$964336739a8c7119), classes);
};
const $28a500ea92f2665f$var$CardContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $28a500ea92f2665f$var$CardContent = /*#__PURE__*/ $acw62.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $28a500ea92f2665f$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $28a500ea92f2665f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28a500ea92f2665f$var$CardContentRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $28a500ea92f2665f$export$2e2bcd8739ae039 = $28a500ea92f2665f$var$CardContent;




var $988d519bad44ed5c$export$2e2bcd8739ae039 = (0, $13b4712c1e2153fc$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $024a60f892d3fa61$exports = {};

$parcel$defineInteropFlag($024a60f892d3fa61$exports);

$parcel$export($024a60f892d3fa61$exports, "getDividerUtilityClass", () => $024a60f892d3fa61$export$46f01d01378ec5a2);
$parcel$export($024a60f892d3fa61$exports, "default", () => $024a60f892d3fa61$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f875d00b2138afe4$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $024a60f892d3fa61$export$46f01d01378ec5a2), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kTdcz.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $1En50.default)(props, $f875d00b2138afe4$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;



var $d8seH = parcelRequire("d8seH");
const $9e9f0a0f4f19c3ed$var$StyledDivider = (0, $d8seH.default)((0, $f875d00b2138afe4$export$2e2bcd8739ae039))(({ theme: theme, orientation: orientation })=>Object.assign({
        borderColor: theme.palette.customDivider.border.color
    }, orientation === 'vertical' ? {
        borderRightWidth: theme.palette.customDivider.border.width
    } : {
        borderBottomWidth: theme.palette.customDivider.border.width
    }));
const $9e9f0a0f4f19c3ed$var$BDSDivider = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e9f0a0f4f19c3ed$var$StyledDivider, Object.assign({}, props));
};
var $9e9f0a0f4f19c3ed$export$2e2bcd8739ae039 = $9e9f0a0f4f19c3ed$var$BDSDivider;


var $753cd5b62de61f2c$export$2e2bcd8739ae039 = (0, $9e9f0a0f4f19c3ed$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");




var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");
var $e40d2047b7c1e09d$exports = {};

$parcel$defineInteropFlag($e40d2047b7c1e09d$exports);

$parcel$export($e40d2047b7c1e09d$exports, "getIconButtonUtilityClass", () => $e40d2047b7c1e09d$export$5e8702d71474f093);
$parcel$export($e40d2047b7c1e09d$exports, "default", () => $e40d2047b7c1e09d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71c322247f7fbf93$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e40d2047b7c1e09d$export$5e8702d71474f093), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $8nd05.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $8nd05.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $8nd05.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $e40d2047b7c1e09d$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $1En50.default)(props, $71c322247f7fbf93$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;




var $d8seH = parcelRequire("d8seH");

var $d94fd308e479c72d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// Helper function to get the button size based on 'bdsSize'
const $d94fd308e479c72d$var$getSize = (bdsSize, theme)=>{
    switch(bdsSize){
        case 'medium':
            return {
                width: theme.palette.iconButton.size.medium,
                height: theme.palette.iconButton.size.medium
            };
        case 'input':
            return {
                width: theme.palette.iconButton.size.input,
                height: theme.palette.iconButton.size.input
            };
        case 'rectangle':
            return {
                width: theme.palette.iconButton.size.rectangle.width,
                height: theme.palette.iconButton.size.rectangle.height
            };
        default:
            return {
                width: theme.palette.iconButton.size.input,
                height: theme.palette.iconButton.size.input
            };
    }
};
// Helper function to get the icon size based on 'bdsSize'
const $d94fd308e479c72d$var$getIconSize = (bdsSize, theme)=>{
    switch(bdsSize){
        case 'medium':
            return theme.palette.icon.size.xsmall;
        case 'input':
            return theme.palette.icon.size.medium;
        case 'rectangle':
            return theme.palette.icon.size.small;
        default:
            return theme.palette.icon.size.medium;
    }
};
const $d94fd308e479c72d$var$StyledLabel = (0, $d8seH.default)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'selected'
})(({ theme: theme, selected: selected })=>{
    const tokens = (0, $5cffe40b21e31a28$export$2e2bcd8739ae039)();
    return {
        fontFamily: theme.typography.fontFamily,
        fontSize: tokens.aliasesFontSizeMicro,
        fontWeight: theme.typography.fontWeightBold,
        // TODO: Update lineHeight to use tokens when Ann pushes update
        // lineHeight: tokens.aliasesLineHeightMicro,
        lineHeight: '12px',
        letterSpacing: tokens.aliasesLetterSpacingDefault,
        color: selected ? tokens.iconButtonColorTextSelected : tokens.iconButtonColorTextDefault,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%'
    };
});
// For the styled component to work, we need this typed as CSSObject
// and the type of the styles prop to be Interpolation<Theme>
const $d94fd308e479c72d$var$StyledIconButton = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'bdsSize',
            'selected'
        ].includes(prop)
})(({ bdsSize: bdsSize = 'input', selected: selected, theme: theme })=>{
    const iconSize = $d94fd308e479c72d$var$getIconSize(bdsSize, theme);
    const buttonSize = $d94fd308e479c72d$var$getSize(bdsSize, theme);
    return {
        // Button size (height/width)
        '&.MuiButtonBase-root': {
            height: buttonSize.height,
            width: buttonSize.width
        },
        // Icon size (height/width/fontSize)
        '& .MuiSvgIcon-root': {
            fill: 'currentColor',
            height: iconSize,
            width: iconSize,
            fontSize: iconSize
        },
        // TODO: Discuss with Ann (8px is default set by MUI)
        padding: bdsSize === 'rectangle' ? 0 : 8,
        color: selected ? theme.palette.icon.interactive.neutral.color.selected.default : theme.palette.icon.interactive.neutral.color.default,
        borderRadius: bdsSize === 'rectangle' ? theme.palette.iconButton.border.radius.rectangle : theme.palette.iconButton.border.radius.round,
        cursor: 'pointer',
        background: selected ? theme.palette.iconButton.interactive.subtle.selected.background : theme.palette.iconButton.interactive.subtle.background,
        border: `${theme.palette.iconButton.border.width} solid ${selected ? theme.palette.iconButton.interactive.subtle.selected.border : theme.palette.iconButton.interactive.subtle.border}`,
        '&:hover': {
            color: selected ? theme.palette.icon.interactive.neutral.color.selected.hover : theme.palette.icon.interactive.neutral.color.hover,
            background: selected ? theme.palette.iconButton.interactive.subtle.selected.hover.background : theme.palette.iconButton.interactive.subtle.hover.background,
            border: `${theme.palette.iconButton.border.width} solid ${selected ? theme.palette.iconButton.interactive.subtle.selected.hover.border : theme.palette.iconButton.interactive.subtle.hover.border}`
        },
        '&:focus-visible': {
            color: theme.palette.icon.interactive.neutral.color.focus,
            background: theme.palette.iconButton.interactive.subtle.background,
            border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.border}`
        },
        '&.Mui-disabled': {
            color: theme.palette.icon.interactive.neutral.color.disabled,
            background: theme.palette.iconButton.interactive.subtle.disabled.background,
            border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.disabled.border}`
        }
    };
});
// Forward ref to StyledIconButton
const $d94fd308e479c72d$var$BDSIconButton = (0, $acw62.forwardRef)((_a, ref)=>{
    var { selected: selected = false, bdsSize: bdsSize, disabled: disabled, onClick: onClick, label: label, children: children } = _a, props = $d94fd308e479c72d$var$__rest(_a, [
        "selected",
        "bdsSize",
        "disabled",
        "onClick",
        "label",
        "children"
    ]);
    const handleOnClick = (event)=>{
        if (!disabled && onClick) onClick(event);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d94fd308e479c72d$var$StyledIconButton, Object.assign({
        ref: ref,
        selected: selected,
        bdsSize: bdsSize,
        onClick: handleOnClick,
        disabled: disabled
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: (0, $5cffe40b21e31a28$export$2e2bcd8739ae039)().iconButtonSpaceBetween,
            width: '100%'
        }
    }, children, label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d94fd308e479c72d$var$StyledLabel, {
        selected: selected
    }, label)));
});
$d94fd308e479c72d$var$BDSIconButton.displayName = 'BDSIconButton';
var $d94fd308e479c72d$export$2e2bcd8739ae039 = $d94fd308e479c72d$var$BDSIconButton;


var $d00116aae00015e7$export$2e2bcd8739ae039 = (0, $d94fd308e479c72d$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $889f7a05097f3e52$var$_excluded = [
    "value"
];
const $889f7a05097f3e52$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $889f7a05097f3e52$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $1En50.default)(_ref, $889f7a05097f3e52$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($889f7a05097f3e52$var$RtlContext.Provider, (0, $8nd05.default)({
        value: value != null ? value : true
    }, props));
}
const $889f7a05097f3e52$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($889f7a05097f3e52$var$RtlContext);
    return value != null ? value : false;
};
var $889f7a05097f3e52$export$2e2bcd8739ae039 = $889f7a05097f3e52$var$RtlProvider;



var $8nd05 = parcelRequire("8nd05");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $8nd05.default)({}, otherProps, {
        ownerState: (0, $8nd05.default)({}, otherProps.ownerState, ownerState)
    });
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;



var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");





var $1En50 = parcelRequire("1En50");



var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
var $859006c2756f1ae2$exports = {};
"use strict";
'use client';
Object.defineProperty($859006c2756f1ae2$exports, "__esModule", {
    value: true
});
$859006c2756f1ae2$exports.default = void 0;

var $859006c2756f1ae2$var$React = $859006c2756f1ae2$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
function $859006c2756f1ae2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($859006c2756f1ae2$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $859006c2756f1ae2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $859006c2756f1ae2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $859006c2756f1ae2$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $859006c2756f1ae2$var$useTheme(defaultTheme = null) {
    const contextTheme = $859006c2756f1ae2$var$React.useContext($eP9YU.T);
    return !contextTheme || $859006c2756f1ae2$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $859006c2756f1ae2$var$_default = $859006c2756f1ae2$exports.default = $859006c2756f1ae2$var$useTheme;






var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");



var $8nd05 = parcelRequire("8nd05");

var $9QePP = parcelRequire("9QePP");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $8nd05.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $8nd05.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)((0, $8nd05.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $8nd05.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $8nd05.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;


'use client';
const $aa69d7725f45330b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $1En50.default)(parameters, $aa69d7725f45330b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $1d88113360503233$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $11492dca620dcaa5$exports.createPortal(children, mountNode) : mountNode
    });
});
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;


var $bb1b487b0ea8f7b1$exports = {};

$parcel$defineInteropFlag($bb1b487b0ea8f7b1$exports);

$parcel$export($bb1b487b0ea8f7b1$exports, "getPopperUtilityClass", () => $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1);
$parcel$export($bb1b487b0ea8f7b1$exports, "default", () => $bb1b487b0ea8f7b1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5a1e9a841ed0d0fc$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $5a1e9a841ed0d0fc$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $8nd05.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, (0, $8nd05.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $8nd05.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a4669aa090d445bd$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $5a1e9a841ed0d0fc$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($859006c2756f1ae2$exports)))();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $a4669aa090d445bd$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $8nd05.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, (0, $8nd05.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;





var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $7a3a319e7e555608$var$maybeReactUseId = $acw62['useId'.toString()];
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}


'use client';
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $7a3a319e7e555608$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $77aad105771eb889$export$2e2bcd8739ae039);


var $add5737403c6a16a$exports = {};

$parcel$defineInteropFlag($add5737403c6a16a$exports);

$parcel$export($add5737403c6a16a$exports, "getTooltipUtilityClass", () => $add5737403c6a16a$export$837848f5f6cee923);
$parcel$export($add5737403c6a16a$exports, "default", () => $add5737403c6a16a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96a8b4f445fd9172$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $jTnBY.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $add5737403c6a16a$export$837848f5f6cee923), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kTdcz.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $8nd05.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $8nd05.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kTdcz.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $96a8b4f445fd9172$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const enterTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const touchTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $331f3746e6346411$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $8nd05.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $8nd05.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $96a8b4f445fd9172$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $96a8b4f445fd9172$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $96a8b4f445fd9172$var$TooltipArrow;
    const popperProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(PopperComponent, (0, $8nd05.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $9QePP.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TransitionComponent, (0, $8nd05.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TooltipComponent, (0, $8nd05.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $9QePP.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(ArrowComponent, (0, $8nd05.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $9QePP.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $8nd05.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $a4669aa090d445bd$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $8nd05.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $8nd05.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;



var $d8seH = parcelRequire("d8seH");
var $eca1ef3878ce862f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $eca1ef3878ce862f$var$StyledTooltip = (0, $d8seH.default)((_a)=>{
    var { className: className } = _a, props = $eca1ef3878ce862f$var$__rest(_a, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), Object.assign({}, props, {
        classes: {
            popper: className
        }
    }));
})(({ theme: theme })=>({
        padding: theme.palette.tooltip.padding,
        '& .MuiTooltip-arrow': {
            color: theme.palette.tooltip.background.default
        },
        '& .MuiTooltip-tooltip': {
            backgroundColor: theme.palette.tooltip.background.default,
            color: theme.palette.tooltip.text,
            border: `${theme.palette.tooltip.border.width} solid ${theme.palette.tooltip.border.default}`,
            fontFamily: theme.palette.tooltip.font.family,
            fontSize: theme.palette.tooltip.font.size,
            lineHeight: theme.palette.tooltip.font.lineHeight,
            fontWeight: theme.palette.tooltip.font.weight,
            letterSpacing: theme.palette.tooltip.font.letterSpacing
        }
    }));
const $eca1ef3878ce862f$var$BDSTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { arrow: arrow = true, children: children } = _a, props = $eca1ef3878ce862f$var$__rest(_a, [
        "arrow",
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eca1ef3878ce862f$var$StyledTooltip, Object.assign({
        arrow: arrow,
        ref: ref
    }, props), children);
});
$eca1ef3878ce862f$var$BDSTooltip.displayName = 'Tooltip';
var $eca1ef3878ce862f$export$2e2bcd8739ae039 = $eca1ef3878ce862f$var$BDSTooltip;


var $13a6e721c9a8fde7$export$2e2bcd8739ae039 = (0, $eca1ef3878ce862f$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $fd904517f2a78af6$exports = {};

$parcel$defineInteropFlag($fd904517f2a78af6$exports);

$parcel$export($fd904517f2a78af6$exports, "getLinkUtilityClass", () => $fd904517f2a78af6$export$d6efab9620b78fec);
$parcel$export($fd904517f2a78af6$exports, "default", () => $fd904517f2a78af6$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd904517f2a78af6$export$d6efab9620b78fec(slot) {
    return (0, $4Cod0.default)('MuiLink', slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $beCSm.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $fd904517f2a78af6$export$2e2bcd8739ae039 = $fd904517f2a78af6$var$linkClasses;



var $9liTZ = parcelRequire("9liTZ");

var $kTdcz = parcelRequire("kTdcz");
const $204cbcbead979fad$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $204cbcbead979fad$var$transformDeprecatedColors = (color)=>{
    return $204cbcbead979fad$export$c4e140d5d351182b[color] || color;
};
const $204cbcbead979fad$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $204cbcbead979fad$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $9liTZ.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $9liTZ.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $kTdcz.alpha)(color, 0.4);
};
var $204cbcbead979fad$export$2e2bcd8739ae039 = $204cbcbead979fad$var$getTextDecoration;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $731ce78e0c47d0a7$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $jTnBY.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd904517f2a78af6$export$d6efab9620b78fec), classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $jTnBY.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $8nd05.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $8nd05.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $204cbcbead979fad$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $fd904517f2a78af6$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $1En50.default)(props, $731ce78e0c47d0a7$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handlerRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, (0, $8nd05.default)({
        color: color,
        className: (0, $9QePP.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $204cbcbead979fad$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $731ce78e0c47d0a7$export$2e2bcd8739ae039 = $731ce78e0c47d0a7$var$Link;


var $bc4cab665d22e571$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $bc4cab665d22e571$var$StyledLink = (0, $d8seH.default)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'bdsFontSize'
        ].includes(prop)
})(({ theme: theme, bdsFontSize: bdsFontSize = 'default' })=>({
        fontFamily: theme.palette.link.font.family,
        fontWeight: theme.palette.link.font.weight,
        letterSpacing: theme.palette.link.font.letterSpacing,
        fontSize: theme.palette.link.font[bdsFontSize].size,
        lineHeight: theme.palette.link.font[bdsFontSize].lineHeight,
        backgroundColor: theme.palette.link.background.default,
        color: theme.palette.link.text.default,
        textDecorationColor: theme.palette.link.text.default,
        '&:hover': {
            color: theme.palette.link.text.hover,
            backgroundColor: theme.palette.link.background.hover,
            textDecorationColor: theme.palette.link.text.hover
        },
        '&:focus': {
            color: theme.palette.link.text.focus,
            backgroundColor: theme.palette.link.background.focus
        },
        '&:disabled': {
            color: theme.palette.link.text.disabled,
            backgroundColor: theme.palette.link.background.disabled
        },
        '&:visited': {
            textDecoration: theme.palette.link.text.visited
        }
    }));
const $bc4cab665d22e571$var$BDSLink = (0, $acw62.forwardRef)((_a, ref)=>{
    var { bdsFontSize: bdsFontSize, children: children, underline: underline = 'hover', opensInNewTabOrWindow: opensInNewTabOrWindow = false } = _a, rest = $bc4cab665d22e571$var$__rest(_a, [
        "bdsFontSize",
        "children",
        "underline",
        "opensInNewTabOrWindow"
    ]);
    const target = opensInNewTabOrWindow ? '_blank' : '_top';
    const rel = opensInNewTabOrWindow ? 'noopener noreferrer' : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bc4cab665d22e571$var$StyledLink, Object.assign({
        bdsFontSize: bdsFontSize,
        ref: ref,
        underline: underline,
        target: target,
        rel: rel
    }, rest), children);
});
// This is necessary to show the name of the component
// correctly in the DevTools and Storybook.
$bc4cab665d22e571$var$BDSLink.displayName = 'Link';
var $bc4cab665d22e571$export$2e2bcd8739ae039 = $bc4cab665d22e571$var$BDSLink;


var $e0f09d44270a5eb6$export$2e2bcd8739ae039 = (0, $bc4cab665d22e571$export$2e2bcd8739ae039);


// Styled components
const $804f515446c1c181$var$MastheadContainer = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        height: 'auto',
        backgroundColor: theme.palette.background.paper,
        position: 'relative'
    }));
const $804f515446c1c181$var$BannerContent = (0, $d8seH.default)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039))({
    height: 32,
    width: '100%',
    position: 'relative'
});
const $804f515446c1c181$var$Content = (0, $d8seH.default)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'reportingMasthead'
})(({ theme: theme, reportingMasthead: reportingMasthead })=>({
        display: 'flex',
        flexGrow: 1,
        padding: reportingMasthead ? theme.palette.space.container.default : `${theme.palette.space.container.dense} ${theme.palette.space.container.spacious}`
    }));
const $804f515446c1c181$var$InnerContent = (0, $d8seH.default)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039))(({ theme: theme })=>({
        flexWrap: 'nowrap',
        gap: theme.palette.space.container.spacious
    }));
const $804f515446c1c181$var$Titles = (0, $d8seH.default)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039))({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: '2px'
});
const $804f515446c1c181$var$PageSubtitle = (0, $d8seH.default)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039))({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $804f515446c1c181$var$RightContent = (0, $d8seH.default)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: theme.palette.space.container.default
    }));
const $804f515446c1c181$var$StyledLink = (0, $d8seH.default)((0, $e0f09d44270a5eb6$export$2e2bcd8739ae039))(({ theme: theme })=>({
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: 'transparent'
        }
    }));
const $804f515446c1c181$var$HelperIcon = ({ icon: icon, tooltip: tooltip, linkContent: linkContent })=>{
    var _a, _b;
    const iconButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
        bdsSize: "input",
        "aria-label": tooltip || 'Helper Icon',
        "data-testid": "masthead-helper-icon-button"
    }, icon);
    if (linkContent) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$StyledLink, {
        href: linkContent.href,
        target: (_a = linkContent.target) !== null && _a !== void 0 ? _a : '_blank',
        rel: (_b = linkContent.rel) !== null && _b !== void 0 ? _b : 'noopener noreferrer'
    }, tooltip ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13a6e721c9a8fde7$export$2e2bcd8739ae039), {
        title: tooltip,
        placement: "top"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, iconButton)) : iconButton));
    if (tooltip) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13a6e721c9a8fde7$export$2e2bcd8739ae039), {
        title: tooltip,
        placement: "top"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, iconButton)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center",
        gap: 1
    }, iconButton);
};
const $804f515446c1c181$var$Masthead = ({ productTitle: productTitle, pageSubtitle: pageSubtitle, pageTitle: pageTitle, rightContent: rightContent, bannerContent: bannerContent, reportingMasthead: reportingMasthead = false, helperIcon: helperIcon })=>{
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$MastheadContainer, {
        "data-testid": "masthead-container",
        "data-bds": "masthead"
    }, bannerContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$BannerContent, {
        item: true,
        "data-testid": "masthead-banner"
    }, bannerContent), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$Content, {
        item: true,
        reportingMasthead: reportingMasthead,
        "data-testid": "masthead-content"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$InnerContent, {
        container: true,
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        "data-testid": "masthead-inner-content"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$Titles, {
        item: true,
        xs: rightContent ? 8 : 12,
        "data-testid": "masthead-titles"
    }, productTitle && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
        variant: "captionNeutral",
        id: "masthead-product-title"
    }, productTitle), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center",
        gap: theme.palette.space.container.dense,
        "data-testid": "masthead-title-row"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
        variant: "h1",
        component: "h1",
        id: "masthead-page-title"
    }, pageTitle), helperIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$HelperIcon, {
        icon: helperIcon.icon,
        tooltip: helperIcon.tooltip,
        linkContent: helperIcon.linkContent
    })), pageSubtitle && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$PageSubtitle, {
        variant: "body1",
        id: "masthead-page-subtitle"
    }, pageSubtitle)), rightContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($804f515446c1c181$var$RightContent, {
        item: true,
        xs: 4,
        "data-testid": "masthead-right-content"
    }, rightContent))));
};
var $804f515446c1c181$export$2e2bcd8739ae039 = $804f515446c1c181$var$Masthead;


var $e742043ac950988b$export$2e2bcd8739ae039 = (0, $804f515446c1c181$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");
var $e1ec0b0c4e143dec$exports = {};

$parcel$defineInteropFlag($e1ec0b0c4e143dec$exports);

$parcel$export($e1ec0b0c4e143dec$exports, "getPaginationUtilityClass", () => $e1ec0b0c4e143dec$export$427f1c1e2e839f85);
$parcel$export($e1ec0b0c4e143dec$exports, "default", () => $e1ec0b0c4e143dec$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e1ec0b0c4e143dec$export$427f1c1e2e839f85(slot) {
    return (0, $4Cod0.default)('MuiPagination', slot);
}
const $e1ec0b0c4e143dec$var$paginationClasses = (0, $beCSm.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $e1ec0b0c4e143dec$export$2e2bcd8739ae039 = $e1ec0b0c4e143dec$var$paginationClasses;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

'use client';
const $fcf3350ab6dcf91e$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $fcf3350ab6dcf91e$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $1En50.default)(props, $fcf3350ab6dcf91e$var$_excluded);
    const [page, setPageState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'true' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return (0, $8nd05.default)({
        items: items
    }, other);
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");


var $1iOpW = parcelRequire("1iOpW");
var $6a3264dc4d579370$exports = {};

$parcel$defineInteropFlag($6a3264dc4d579370$exports);

$parcel$export($6a3264dc4d579370$exports, "getPaginationItemUtilityClass", () => $6a3264dc4d579370$export$e4ce0a775adf2f74);
$parcel$export($6a3264dc4d579370$exports, "default", () => $6a3264dc4d579370$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6a3264dc4d579370$export$e4ce0a775adf2f74(slot) {
    return (0, $4Cod0.default)('MuiPaginationItem', slot);
}
const $6a3264dc4d579370$var$paginationItemClasses = (0, $beCSm.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $6a3264dc4d579370$export$2e2bcd8739ae039 = $6a3264dc4d579370$var$paginationItemClasses;




var $jTnBY = parcelRequire("jTnBY");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $17a626ba35acf52f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $3dba169293b5f5f0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $26ce82c6cc8a75d9$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5ef22e36056d1791$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6a273894865f8b08$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $6a273894865f8b08$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $6a273894865f8b08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $jTnBY.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $jTnBY.default)(color)}`,
            color !== 'standard' && `${variant}${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6a3264dc4d579370$export$e4ce0a775adf2f74), classes);
};
const $6a273894865f8b08$var$PaginationItemEllipsis = (0, $d8seH.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }));
const $6a273894865f8b08$var$PaginationItemPage = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'text' && {
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: (0, $8nd05.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === 'outlined' && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: (0, $8nd05.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $6a273894865f8b08$var$PaginationItemPageIcon = (0, $d8seH.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px'
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $6a273894865f8b08$var$PaginationItem = /*#__PURE__*/ $acw62.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, type: type = 'page', variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $6a273894865f8b08$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const classes = $6a273894865f8b08$var$useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, $5ef22e36056d1791$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $26ce82c6cc8a75d9$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $17a626ba35acf52f$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $3dba169293b5f5f0$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $26ce82c6cc8a75d9$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $5ef22e36056d1791$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $17a626ba35acf52f$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $3dba169293b5f5f0$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($6a273894865f8b08$var$PaginationItemPage, (0, $8nd05.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: [
            type === 'page' && page,
            Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $6a273894865f8b08$export$2e2bcd8739ae039 = $6a273894865f8b08$var$PaginationItem;



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $081224c8d3cb055f$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $081224c8d3cb055f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e1ec0b0c4e143dec$export$427f1c1e2e839f85), classes);
};
const $081224c8d3cb055f$var$PaginationRoot = (0, $d8seH.default)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $081224c8d3cb055f$var$PaginationUl = (0, $d8seH.default)('ul', {
    name: 'MuiPagination',
    slot: 'Ul',
    overridesResolver: (props, styles)=>styles.ul
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $081224c8d3cb055f$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $081224c8d3cb055f$var$Pagination = /*#__PURE__*/ $acw62.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $081224c8d3cb055f$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a273894865f8b08$export$2e2bcd8739ae039), (0, $8nd05.default)({}, item)), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $081224c8d3cb055f$var$_excluded);
    const { items: items } = (0, $fcf3350ab6dcf91e$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: 'Pagination'
    }));
    const ownerState = (0, $8nd05.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $081224c8d3cb055f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationRoot, (0, $8nd05.default)({
        "aria-label": "pagination navigation",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: renderItem((0, $8nd05.default)({}, item, {
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $081224c8d3cb055f$export$2e2bcd8739ae039 = $081224c8d3cb055f$var$Pagination;




var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $db0771a9e6a32b1d$exports = {};

$parcel$defineInteropFlag($db0771a9e6a32b1d$exports);

$parcel$export($db0771a9e6a32b1d$exports, "getChipUtilityClass", () => $db0771a9e6a32b1d$export$31444911e4ee6fdd);
$parcel$export($db0771a9e6a32b1d$exports, "default", () => $db0771a9e6a32b1d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $47d4f79319086dc5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $db0771a9e6a32b1d$export$31444911e4ee6fdd), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $8nd05.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: (0, $8nd05.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $8nd05.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: (0, $8nd05.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $kTdcz.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kTdcz.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $1En50.default)(props, $47d4f79319086dc5$var$_excluded);
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $4a35786d89db9dda$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $4a35786d89db9dda$export$2e2bcd8739ae039) ? (0, $8nd05.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62d1787512a69c15$export$2e2bcd8739ae039), {
        className: (0, $9QePP.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $9QePP.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;



var $d8seH = parcelRequire("d8seH");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9a402a389bd8b499$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');


var $478fe5b437ab8d6f$exports = {};

$parcel$defineInteropFlag($478fe5b437ab8d6f$exports);

$parcel$export($478fe5b437ab8d6f$exports, "getAvatarUtilityClass", () => $478fe5b437ab8d6f$export$ffd560f22c0ecf04);
$parcel$export($478fe5b437ab8d6f$exports, "default", () => $478fe5b437ab8d6f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $478fe5b437ab8d6f$export$ffd560f22c0ecf04(slot) {
    return (0, $4Cod0.default)('MuiAvatar', slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $beCSm.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $478fe5b437ab8d6f$export$2e2bcd8739ae039 = $478fe5b437ab8d6f$var$avatarClasses;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");




'use client';
const $49e8399bd2388464$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $49e8399bd2388464$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $49e8399bd2388464$var$_excluded3 = [
    "component"
];
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $1En50.default)(parameters, $49e8399bd2388464$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $1En50.default)(externalForwardedProps, $49e8399bd2388464$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $1En50.default)(_mergeSlotProps.props, $49e8399bd2388464$var$_excluded3);
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $8nd05.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1894f4268467302e$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $478fe5b437ab8d6f$export$ffd560f22c0ecf04), classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $d8seH.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $8nd05.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $8nd05.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $1894f4268467302e$var$AvatarImg = (0, $d8seH.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $d8seH.default)((0, $9a402a389bd8b499$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $1En50.default)(props, $1894f4268467302e$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded((0, $8nd05.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $8nd05.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $1894f4268467302e$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $8nd05.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)(ImgSlot, (0, $8nd05.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $1894f4268467302e$export$2e2bcd8739ae039 = $1894f4268467302e$var$Avatar;



var $d8seH = parcelRequire("d8seH");

var $acw62 = parcelRequire("acw62");

var $0730ee4e7c91910d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// Get icon size based on the bdsSize prop
const $0730ee4e7c91910d$var$getIconSize = (bdsSize, theme)=>{
    switch(bdsSize){
        case 'micro':
            return {
                width: theme.palette.icon.size.micro,
                height: theme.palette.icon.size.micro
            };
        case 'xxsmall':
            return {
                width: theme.palette.icon.size.xxsmall,
                height: theme.palette.icon.size.xxsmall
            };
        case 'xsmall':
            return {
                width: theme.palette.icon.size.xsmall,
                height: theme.palette.icon.size.xsmall
            };
        case 'small':
            return {
                width: theme.palette.icon.size.small,
                height: theme.palette.icon.size.small
            };
        case 'medium':
            return {
                width: theme.palette.icon.size.medium,
                height: theme.palette.icon.size.medium
            };
        case 'large':
            return {
                width: theme.palette.icon.size.large,
                height: theme.palette.icon.size.large
            };
        case 'xlarge':
            return {
                width: theme.palette.icon.size.xlarge,
                height: theme.palette.icon.size.xlarge
            };
        case 'xxlarge':
            return {
                width: theme.palette.icon.size.xxlarge,
                height: theme.palette.icon.size.xxlarge
            };
        default:
            return {
                width: theme.palette.icon.size.medium,
                height: theme.palette.icon.size.medium
            };
    }
};
// Get icon type based on the bdsType prop and other states
const $0730ee4e7c91910d$var$getIconType = (bdsType, theme, disabled, selected, isHovered, isFocused)=>{
    switch(bdsType){
        case 'errorNeutral':
            return {
                fill: theme.palette.icon.static.neutral.color.error
            };
        case 'errorSubtle':
            return {
                fill: theme.palette.icon.static.subtle.color.error
            };
        case 'errorEmphasis':
            return {
                fill: theme.palette.icon.static.emphasis.color.error
            };
        case 'warningNeutral':
            return {
                fill: theme.palette.icon.static.neutral.color.warning
            };
        case 'warningSubtle':
            return {
                fill: theme.palette.icon.static.subtle.color.warning
            };
        case 'warningEmphasis':
            return {
                fill: theme.palette.icon.static.emphasis.color.warning
            };
        case 'infoNeutral':
            return {
                fill: theme.palette.icon.static.neutral.color.info
            };
        case 'infoSubtle':
            return {
                fill: theme.palette.icon.static.subtle.color.info
            };
        case 'infoEmphasis':
            return {
                fill: theme.palette.icon.static.emphasis.color.info
            };
        case 'successNeutral':
            return {
                fill: theme.palette.icon.static.neutral.color.success
            };
        case 'successSubtle':
            return {
                fill: theme.palette.icon.static.subtle.color.success
            };
        case 'successEmphasis':
            return {
                fill: theme.palette.icon.static.emphasis.color.success
            };
        case 'staticNeutral':
            return {
                fill: theme.palette.icon.static.neutral.color.default
            };
        case 'staticEmphasis':
            return {
                fill: theme.palette.icon.static.emphasis.color.default
            };
        case 'staticSubtle':
            return {
                fill: theme.palette.icon.static.subtle.color.default
            };
        case 'interactiveNeutral':
            return Object.assign(Object.assign(Object.assign({
                fill: selected ? theme.palette.icon.interactive.neutral.color.selected.default : theme.palette.icon.interactive.neutral.color.default
            }, isHovered && {
                fill: selected ? theme.palette.icon.interactive.neutral.color.selected.hover : theme.palette.icon.interactive.neutral.color.hover
            }), isFocused && {
                fill: theme.palette.icon.interactive.neutral.color.focus
            }), disabled && {
                cursor: 'default',
                fill: theme.palette.icon.interactive.neutral.color.disabled
            });
        case 'interactiveEmphasis':
            return Object.assign(Object.assign(Object.assign({
                fill: selected ? theme.palette.icon.interactive.emphasis.color.selected.default : theme.palette.icon.interactive.emphasis.color
            }, isHovered && {
                fill: selected ? theme.palette.icon.interactive.emphasis.color.selected.hover : theme.palette.icon.interactive.emphasis.color.hover
            }), isFocused && {
                fill: theme.palette.icon.interactive.emphasis.color.focus
            }), disabled && {
                cursor: 'default',
                fill: theme.palette.icon.interactive.emphasis.color.disabled
            });
        case 'interactiveSubtle':
            return Object.assign(Object.assign(Object.assign({
                fill: selected ? theme.palette.icon.interactive.subtle.color.selected.default : theme.palette.icon.interactive.subtle.color.default
            }, isHovered && {
                fill: selected ? theme.palette.icon.interactive.subtle.color.selected.hover : theme.palette.icon.interactive.subtle.color.hover
            }), isFocused && {
                fill: theme.palette.icon.interactive.subtle.color.focus
            }), disabled && {
                cursor: 'default',
                fill: theme.palette.icon.interactive.subtle.color.disabled
            });
        default:
            return {};
    }
};
// The CustomIcon component with forwardRef applied
const $0730ee4e7c91910d$var$CustomIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { bdsSize: bdsSize = 'medium', bdsType: bdsType, bdsIcon: IconComponent, selected: selected = false, disabled: disabled = false, onClick: onClick } = _a, rest = $0730ee4e7c91910d$var$__rest(_a, [
        "bdsSize",
        "bdsType",
        "bdsIcon",
        "selected",
        "disabled",
        "onClick"
    ]);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const [isHovered, setIsHovered] = (0, $acw62.useState)(false);
    const [isFocused, setIsFocused] = (0, $acw62.useState)(false);
    const handleHover = (event)=>{
        setIsHovered(event.type === 'mouseenter');
    };
    const handleFocus = (event)=>{
        setIsFocused(event.type === 'focus');
    };
    const iconProps = Object.assign(Object.assign(Object.assign({}, $0730ee4e7c91910d$var$getIconSize(bdsSize, theme)), $0730ee4e7c91910d$var$getIconType(bdsType, theme, disabled, selected, isHovered, isFocused)), rest);
    return typeof IconComponent === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        style: iconProps,
        onBlur: handleFocus,
        onClick: onClick,
        onFocus: handleFocus,
        onMouseEnter: handleHover,
        onMouseLeave: handleHover,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: IconComponent
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IconComponent, {
        style: iconProps,
        sx: Object.assign({}, iconProps),
        onBlur: handleFocus,
        onClick: onClick,
        onFocus: handleFocus,
        onMouseEnter: handleHover,
        onMouseLeave: handleHover,
        ref: ref
    });
});
$0730ee4e7c91910d$var$CustomIcon.displayName = 'Icon';
var $0730ee4e7c91910d$export$2e2bcd8739ae039 = $0730ee4e7c91910d$var$CustomIcon;


var $b50c01cb1e657ca8$export$2e2bcd8739ae039 = (0, $0730ee4e7c91910d$export$2e2bcd8739ae039);



var $66e61be7bdc1cebd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $66e61be7bdc1cebd$var$validSizes = [
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge'
];
const $66e61be7bdc1cebd$var$validTypes = [
    'staticNeutral',
    'staticSubtle',
    'staticEmphasis',
    'interactiveNeutral',
    'interactiveSubtle',
    'interactiveEmphasis'
];
// Function to get avatar size based on the size prop
const $66e61be7bdc1cebd$var$getAvatarSize = (theme, bdsSize)=>{
    if (bdsSize && !$66e61be7bdc1cebd$var$validSizes.includes(bdsSize)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Avatar', 'bdsSize', bdsSize);
        return undefined;
    }
    const size = theme.palette.avatar.size[bdsSize];
    return {
        width: size.width,
        height: size.height,
        fontSize: size.font.size,
        lineHeight: size.font.lineHeight
    };
};
// Function to get styles based on the bdsType, disabled, and selected props
const $66e61be7bdc1cebd$var$getAvatarStyles = (theme, bdsType, selected)=>{
    if (bdsType && !$66e61be7bdc1cebd$var$validTypes.includes(bdsType)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Avatar', 'bdsType', bdsType);
        return undefined;
    }
    const defaultBorderWidth = theme.palette.avatar.border.width;
    const stylesMap = {
        staticNeutral: {
            backgroundColor: theme.palette.avatar.static.neutral.background,
            border: `${defaultBorderWidth} solid ${theme.palette.avatar.static.neutral.border}`,
            color: theme.palette.avatar.static.neutral.text
        },
        staticSubtle: {
            backgroundColor: theme.palette.avatar.static.subtle.background,
            border: `${defaultBorderWidth} solid ${theme.palette.avatar.static.subtle.border}`,
            color: theme.palette.avatar.static.subtle.text
        },
        staticEmphasis: {
            backgroundColor: theme.palette.avatar.static.emphasis.background,
            border: `${defaultBorderWidth} solid ${theme.palette.avatar.static.emphasis.border}`,
            color: theme.palette.avatar.static.emphasis.text
        },
        interactiveNeutral: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.avatar.interactive.neutral.background.selected.default : theme.palette.avatar.interactive.neutral.background.default,
            border: selected ? `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.neutral.border.selected.default}` : `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.neutral.border.default}`,
            color: theme.palette.avatar.interactive.neutral.text.default,
            hover: {
                backgroundColor: selected ? theme.palette.avatar.interactive.neutral.background.selected.hover : theme.palette.avatar.interactive.neutral.background.hover,
                border: selected ? `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.neutral.border.selected.hover}` : `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.neutral.border.hover}`
            },
            focus: {
                backgroundColor: theme.palette.avatar.interactive.neutral.background.focus,
                border: `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.neutral.border.focus}`
            }
        },
        interactiveSubtle: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.avatar.interactive.subtle.background.selected.default : theme.palette.avatar.interactive.subtle.background.default,
            border: selected ? `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.subtle.border.selected.default}` : `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.subtle.border.default}`,
            color: theme.palette.avatar.interactive.subtle.text.default,
            hover: {
                backgroundColor: selected ? theme.palette.avatar.interactive.subtle.background.selected.hover : theme.palette.avatar.interactive.subtle.background.default,
                border: selected ? `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.subtle.border.selected.hover}` : `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.subtle.border.hover}`
            },
            focus: {
                backgroundColor: theme.palette.avatar.interactive.subtle.background.focus,
                border: `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.subtle.border.focus}`
            }
        },
        interactiveEmphasis: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.avatar.interactive.emphasis.background.selected.default : theme.palette.avatar.interactive.emphasis.background.default,
            border: selected ? `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.emphasis.border.selected.default}` : `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.emphasis.border.default}`,
            color: theme.palette.avatar.interactive.emphasis.text.default,
            hover: {
                backgroundColor: selected ? theme.palette.avatar.interactive.emphasis.background.selected.hover : theme.palette.avatar.interactive.emphasis.background.default,
                border: selected ? `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.emphasis.border.selected.hover}` : `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.emphasis.border.hover}`
            },
            focus: {
                backgroundColor: theme.palette.avatar.interactive.emphasis.background.focus,
                border: `${defaultBorderWidth} solid ${theme.palette.avatar.interactive.emphasis.border.focus}`
            }
        }
    };
    return stylesMap[bdsType] || undefined;
};
const $66e61be7bdc1cebd$var$StyledAvatar = (0, $d8seH.default)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'bdsType',
            'bdsSize'
        ].includes(prop)
})(({ theme: theme, bdsType: bdsType, bdsSize: bdsSize, selected: selected, disabled: disabled })=>{
    var _a, _b, _c, _d;
    const avatarSize = bdsSize && $66e61be7bdc1cebd$var$getAvatarSize(theme, bdsSize) || undefined;
    const avatarStyles = bdsType && $66e61be7bdc1cebd$var$getAvatarStyles(theme, bdsType, selected) || undefined;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, avatarStyles), avatarSize), {
        fontFamily: theme.palette.avatar.font.family,
        fontWeight: theme.palette.avatar.font.weight,
        letterSpacing: theme.palette.avatar.font.letterSpacing,
        textTransform: theme.palette.avatar.font.textTransform,
        borderRadius: theme.palette.avatar.border.radius,
        textCase: 'uppercase',
        textDecoration: 'none',
        '&:hover': {
            background: (_a = avatarStyles === null || avatarStyles === void 0 ? void 0 : avatarStyles.hover) === null || _a === void 0 ? void 0 : _a.backgroundColor,
            border: (_b = avatarStyles === null || avatarStyles === void 0 ? void 0 : avatarStyles.hover) === null || _b === void 0 ? void 0 : _b.border
        },
        '&:focus-visible': {
            background: (_c = avatarStyles === null || avatarStyles === void 0 ? void 0 : avatarStyles.focus) === null || _c === void 0 ? void 0 : _c.backgroundColor,
            border: (_d = avatarStyles === null || avatarStyles === void 0 ? void 0 : avatarStyles.focus) === null || _d === void 0 ? void 0 : _d.border
        },
        '&.bds-chip-avatar': Object.assign({}, avatarSize)
    }), disabled && {
        cursor: 'default',
        backgroundColor: theme.palette.avatar.interactive.emphasis.background.disabled,
        border: `${theme.palette.avatar.border.width} solid ${theme.palette.avatar.interactive.emphasis.border.disabled}`,
        color: theme.palette.avatar.interactive.emphasis.text.disabled,
        opacity: 1,
        '&:hover': {},
        '&:focus-visible': {}
    }), {
        // If the avatar is used in a disabled chip, apply the disabled styles
        '.MuiChip-root.Mui-disabled &': {
            backgroundColor: theme.palette.avatar.interactive.neutral.background.disabled,
            border: `${theme.palette.avatar.border.width} solid ${theme.palette.avatar.interactive.neutral.border.disabled}`,
            color: theme.palette.avatar.interactive.neutral.text.disabled,
            opacity: 1
        }
    });
});
// Wrapper for the avatar component if used with the Chip component
// Otherwise the Chip Styles will override the Avatar styles
const $66e61be7bdc1cebd$export$c24386ba6db6b1bd = (0, $d8seH.default)('div')({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $66e61be7bdc1cebd$var$BDSAvatar = (props)=>{
    const { disabled: disabled, selected: selected, onClick: onClick, children: children, bdsType: bdsType, bdsSize: bdsSize } = props, rest = $66e61be7bdc1cebd$var$__rest(props, [
        "disabled",
        "selected",
        "onClick",
        "children",
        "bdsType",
        "bdsSize"
    ]);
    // Handle click event for the avatar
    const handleAvatarClick = (event)=>{
        event.stopPropagation();
        if (!disabled && onClick) onClick(event);
    };
    // When using the CustomIcon component as a child of BDSAvatar
    // we need to pass the selected prop to the CustomIcon
    // Clone children to pass `selected` and remove `onClick` from CustomIcon
    const clonedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child) && child.type === (0, $b50c01cb1e657ca8$export$2e2bcd8739ae039)) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            selected: selected,
            onClick: onClick
        });
        return child;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66e61be7bdc1cebd$var$StyledAvatar, Object.assign({
        onClick: handleAvatarClick,
        disabled: disabled,
        selected: selected,
        bdsSize: bdsSize,
        bdsType: bdsType
    }, rest), clonedChildren);
};
$66e61be7bdc1cebd$var$BDSAvatar.displayName = 'Avatar';
var $66e61be7bdc1cebd$export$2e2bcd8739ae039 = $66e61be7bdc1cebd$var$BDSAvatar;





var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $5611fe3170f53ae0$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $5611fe3170f53ae0$var$SvgCancel(props) {
    return $5611fe3170f53ae0$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    })), props);
}
var $5611fe3170f53ae0$export$2e2bcd8739ae039 = $5611fe3170f53ae0$var$SvgCancel;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $2ab33ba29293be74$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $2ab33ba29293be74$var$SvgCheckCircle(props) {
    return $2ab33ba29293be74$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    })), props);
}
var $2ab33ba29293be74$export$2e2bcd8739ae039 = $2ab33ba29293be74$var$SvgCheckCircle;


var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $cf8ff53917d18c25$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $cf8ff53917d18c25$var$SvgErrorOutline(props) {
    return $cf8ff53917d18c25$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    })), props);
}
var $cf8ff53917d18c25$export$2e2bcd8739ae039 = $cf8ff53917d18c25$var$SvgErrorOutline;


var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $58274d64ec6a561d$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $58274d64ec6a561d$var$SvgInfo(props) {
    return $58274d64ec6a561d$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
    })), props);
}
var $58274d64ec6a561d$export$2e2bcd8739ae039 = $58274d64ec6a561d$var$SvgInfo;


var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $9c7209868c257340$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $9c7209868c257340$var$SvgReportProblem(props) {
    return $9c7209868c257340$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    })), props);
}
var $9c7209868c257340$export$2e2bcd8739ae039 = $9c7209868c257340$var$SvgReportProblem;



const $8b1ecf02e74697e1$export$a821955ae395d337 = (theme, bdsSize)=>{
    switch(bdsSize){
        case 'medium':
            return {
                height: theme.palette.chip.size.medium.height,
                paddingLeft: theme.palette.chip.size.medium.padding.left,
                paddingRight: theme.palette.chip.size.medium.padding.right,
                fontSize: theme.palette.chip.size.medium.fontSize,
                spaceBetween: theme.palette.chip.size.medium.spaceBetween
            };
        case 'large':
            return {
                height: theme.palette.chip.size.large.height,
                paddingLeft: theme.palette.chip.size.large.padding.left,
                paddingRight: theme.palette.chip.size.large.padding.right,
                fontSize: theme.palette.chip.size.large.fontSize,
                spaceBetween: theme.palette.chip.size.large.spaceBetween
            };
        case 'input':
            return {
                height: theme.palette.chip.size.input.height,
                paddingLeft: theme.palette.chip.size.input.padding.left,
                paddingRight: theme.palette.chip.size.input.padding.right,
                fontSize: theme.palette.chip.size.input.fontSize,
                spaceBetween: theme.palette.chip.size.input.spaceBetween
            };
        default:
            (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Chip', 'bdsSize', bdsSize, 'medium');
            return $8b1ecf02e74697e1$export$a821955ae395d337(theme, 'medium');
    }
};
const $8b1ecf02e74697e1$var$getIconSize = (bdsSize)=>{
    switch(bdsSize){
        case 'medium':
            return 'xsmall';
        case 'large':
            return 'small';
        case 'input':
            return 'medium';
        default:
            return 'xsmall';
    }
};
const $8b1ecf02e74697e1$var$getStatusIcon = (bdsSize, iconType)=>{
    const capitalizedType = iconType.charAt(0).toUpperCase() + iconType.slice(1);
    const createIcon = (bdsIcon, context)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b50c01cb1e657ca8$export$2e2bcd8739ae039), {
            bdsIcon: bdsIcon,
            bdsSize: $8b1ecf02e74697e1$var$getIconSize(bdsSize),
            bdsType: `${context}${capitalizedType}`
        });
    return {
        success: createIcon((0, $2ab33ba29293be74$export$2e2bcd8739ae039), 'success'),
        warning: createIcon((0, $9c7209868c257340$export$2e2bcd8739ae039), 'warning'),
        error: createIcon((0, $cf8ff53917d18c25$export$2e2bcd8739ae039), 'error'),
        info: createIcon((0, $58274d64ec6a561d$export$2e2bcd8739ae039), 'info')
    };
};
const $8b1ecf02e74697e1$var$getStaticStyles = (theme, type, context)=>{
    if (![
        'default',
        'success',
        'warning',
        'error',
        'info'
    ].includes(context)) (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Chip', 'context', context);
    if (![
        'neutral',
        'emphasis',
        'subtle'
    ].includes(type)) (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Chip', 'type', type);
    const background = theme.palette.chip.static[type].background;
    const border = theme.palette.chip.static[type].border;
    return {
        cursor: 'none',
        backgroundColor: background[context],
        border: `${theme.palette.chip.border.width} solid ${border[context]}`,
        color: theme.palette.chip.static[type].text[context]
    };
};
const $8b1ecf02e74697e1$var$getInteractiveStyles = (theme, type, selected)=>({
        cursor: 'pointer',
        backgroundColor: selected ? theme.palette.chip.interactive[type].background.selected.default : theme.palette.chip.interactive[type].background.default,
        border: selected ? `${theme.palette.chip.border.width} solid ${theme.palette.chip.interactive[type].border.selected.default}` : `${theme.palette.chip.border.width} solid ${theme.palette.chip.interactive[type].border.default}`,
        color: theme.palette.chip.interactive[type].text,
        hover: {
            backgroundColor: selected ? theme.palette.chip.interactive[type].background.selected.hover : theme.palette.chip.interactive[type].background.hover,
            border: selected ? `${theme.palette.chip.border.width} solid ${theme.palette.chip.interactive[type].border.selected.hover}` : `${theme.palette.chip.border.width} solid ${theme.palette.chip.interactive[type].border.hover}`
        },
        focus: {
            backgroundColor: theme.palette.chip.interactive[type].background.focus,
            border: `${theme.palette.chip.border.width} solid ${theme.palette.chip.interactive[type].border.focus}`
        }
    });
const $8b1ecf02e74697e1$export$62bc4a82cbfaab4e = (theme, bdsType, bdsSize, selected)=>{
    const baseStyles = (type, context)=>$8b1ecf02e74697e1$var$getStaticStyles(theme, type, context);
    switch(bdsType){
        case 'successSubtle':
            return baseStyles('subtle', 'success');
        case 'successSubtleWithIcon':
            return Object.assign(Object.assign({}, baseStyles('subtle', 'success')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').success
            });
        case 'successNeutral':
            return baseStyles('neutral', 'success');
        case 'successNeutralWithIcon':
            return Object.assign(Object.assign({}, baseStyles('neutral', 'success')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').success
            });
        case 'successEmphasis':
            return baseStyles('emphasis', 'success');
        case 'successEmphasisWithIcon':
            return Object.assign(Object.assign({}, baseStyles('emphasis', 'success')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'subtle').success
            });
        case 'warningSubtle':
            return baseStyles('subtle', 'warning');
        case 'warningSubtleWithIcon':
            return Object.assign(Object.assign({}, baseStyles('subtle', 'warning')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').warning
            });
        case 'warningNeutral':
            return baseStyles('neutral', 'warning');
        case 'warningNeutralWithIcon':
            return Object.assign(Object.assign({}, baseStyles('neutral', 'warning')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').warning
            });
        case 'warningEmphasis':
            return baseStyles('emphasis', 'warning');
        case 'warningEmphasisWithIcon':
            return Object.assign(Object.assign({}, baseStyles('emphasis', 'warning')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'subtle').warning
            });
        case 'errorSubtle':
            return baseStyles('subtle', 'error');
        case 'errorSubtleWithIcon':
            return Object.assign(Object.assign({}, baseStyles('subtle', 'error')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').error
            });
        case 'errorNeutral':
            return baseStyles('neutral', 'error');
        case 'errorNeutralWithIcon':
            return Object.assign(Object.assign({}, baseStyles('neutral', 'error')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').error
            });
        case 'errorEmphasis':
            return baseStyles('emphasis', 'error');
        case 'errorEmphasisWithIcon':
            return Object.assign(Object.assign({}, baseStyles('emphasis', 'error')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'subtle').error
            });
        case 'infoSubtle':
            return baseStyles('subtle', 'info');
        case 'infoSubtleWithIcon':
            return Object.assign(Object.assign({}, baseStyles('subtle', 'info')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').info
            });
        case 'infoNeutral':
            return baseStyles('neutral', 'info');
        case 'infoNeutralWithIcon':
            return Object.assign(Object.assign({}, baseStyles('neutral', 'info')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'neutral').info
            });
        case 'infoEmphasis':
            return baseStyles('emphasis', 'info');
        case 'infoEmphasisWithIcon':
            return Object.assign(Object.assign({}, baseStyles('emphasis', 'info')), {
                statusIcon: $8b1ecf02e74697e1$var$getStatusIcon(bdsSize, 'subtle').info
            });
        case 'staticNeutral':
            return baseStyles('neutral', 'default');
        case 'staticSubtle':
            return baseStyles('subtle', 'default');
        case 'staticEmphasis':
            return baseStyles('emphasis', 'default');
        case 'interactiveNeutral':
            return $8b1ecf02e74697e1$var$getInteractiveStyles(theme, 'neutral', selected);
        case 'interactiveSubtle':
            return $8b1ecf02e74697e1$var$getInteractiveStyles(theme, 'subtle', selected);
        case 'interactiveEmphasis':
            return $8b1ecf02e74697e1$var$getInteractiveStyles(theme, 'emphasis', selected);
        default:
            (0, $600dd74f68ddb378$export$373ccc48b6a48668)('Chip', 'bdsType', bdsType);
            return undefined;
    }
};


var $95660ad0f4562222$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $95660ad0f4562222$var$getStyledChipStyles = ({ avatar: avatar, bdsSize: bdsSize, bdsType: bdsType, onDelete: onDelete, selected: selected, startIcon: startIcon, theme: theme })=>{
    const isInteractive = bdsType === null || bdsType === void 0 ? void 0 : bdsType.includes('interactive');
    const chipStyles = bdsType ? (0, $8b1ecf02e74697e1$export$62bc4a82cbfaab4e)(theme, bdsType, bdsSize, selected) : undefined;
    const chipSize = bdsSize ? (0, $8b1ecf02e74697e1$export$a821955ae395d337)(theme, bdsSize) : undefined;
    const statusIcon = chipStyles === null || chipStyles === void 0 ? void 0 : chipStyles.statusIcon;
    return Object.assign(Object.assign(Object.assign({
        borderWidth: theme.palette.chip.border.width,
        borderRadius: theme.palette.chip.radius,
        fontWeight: theme.palette.chip.font.weight
    }, chipSize && {
        height: chipSize.height,
        paddingLeft: chipSize.paddingLeft,
        paddingRight: chipSize.paddingRight,
        fontSize: chipSize.fontSize
    }), chipStyles && Object.assign(Object.assign({
        backgroundColor: chipStyles.backgroundColor,
        border: chipStyles.border,
        color: chipStyles.color
    }, chipStyles.hover && {
        '&:hover': {
            backgroundColor: chipStyles.hover.backgroundColor,
            border: chipStyles.hover.border
        }
    }), chipStyles.focus && {
        '&:focus-visible': {
            backgroundColor: chipStyles.focus.backgroundColor,
            border: chipStyles.focus.border
        }
    })), {
        '&.Mui-disabled': {
            opacity: 1,
            backgroundColor: theme.palette.chip.interactive.disabled.background,
            border: `${theme.palette.chip.border.width} solid ${theme.palette.chip.interactive.disabled.border}`,
            color: theme.palette.chip.text.disabled,
            cursor: 'default'
        },
        '& .bds-chip-label': {
            paddingRight: onDelete ? chipSize === null || chipSize === void 0 ? void 0 : chipSize.spaceBetween : 0,
            paddingLeft: avatar || startIcon || statusIcon ? chipSize === null || chipSize === void 0 ? void 0 : chipSize.spaceBetween : 0
        },
        '& .bds-chip-avatar': {
            padding: 0,
            margin: 0,
            width: 'unset',
            height: 'unset'
        },
        '& .bds-chip-icon': {
            cursor: isInteractive ? 'pointer' : 'default'
        }
    });
};
const $95660ad0f4562222$var$StyledChip = (0, $d8seH.default)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'bdsType',
            'bdsSize',
            'endIcon',
            'startIcon'
        ].includes(prop)
})(({ avatar: avatar, bdsSize: bdsSize, bdsType: bdsType, onDelete: onDelete, selected: selected, startIcon: startIcon, theme: theme })=>$95660ad0f4562222$var$getStyledChipStyles({
        avatar: avatar,
        bdsSize: bdsSize,
        bdsType: bdsType,
        onDelete: onDelete,
        selected: selected,
        startIcon: startIcon,
        theme: theme
    }));
const $95660ad0f4562222$var$BDSChip = (0, $acw62.memo)((props)=>{
    var _a, _b, _c;
    const { avatar: avatar, bdsSize: bdsSize = 'medium', bdsType: bdsType = 'staticNeutral', clickable: clickable = false, deleteIcon: deleteIcon, disabled: disabled, endIcon: endIcon, label: label, onClick: onClick, onDelete: onDelete, selected: selected, startIcon: startIcon } = props, rest = $95660ad0f4562222$var$__rest(props, [
        "avatar",
        "bdsSize",
        "bdsType",
        "clickable",
        "deleteIcon",
        "disabled",
        "endIcon",
        "label",
        "onClick",
        "onDelete",
        "selected",
        "startIcon"
    ]);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const spacing = endIcon ? (_b = (_a = (0, $8b1ecf02e74697e1$export$a821955ae395d337)(theme, bdsSize)) === null || _a === void 0 ? void 0 : _a.spaceBetween) !== null && _b !== void 0 ? _b : 0 : 0;
    const isStatusWithIcon = (_type)=>{
        return !!(bdsType && (bdsType === null || bdsType === void 0 ? void 0 : bdsType.endsWith('WithIcon')));
    };
    const statusIcon = bdsType && isStatusWithIcon(bdsType) ? (_c = (0, $8b1ecf02e74697e1$export$62bc4a82cbfaab4e)(theme, bdsType, bdsSize, selected)) === null || _c === void 0 ? void 0 : _c.statusIcon : undefined;
    const handleClick = (0, $acw62.useCallback)((event)=>{
        if (onClick) onClick(event);
    }, [
        onClick
    ]);
    const renderAvatar = (0, $acw62.useMemo)(()=>{
        return avatar ? (0, $acw62.cloneElement)(avatar, {
            selected: selected,
            onClick: onClick // Pass `onClick` directly to the Avatar
        }) : undefined;
    }, [
        avatar,
        selected,
        onClick
    ]);
    const isStaticChip = (0, $acw62.useMemo)(()=>{
        const staticTypes = [
            'staticEmphasis',
            'staticNeutral',
            'staticSubtle',
            'errorEmphasis',
            'errorNeutral',
            'errorSubtle',
            'infoEmphasis',
            'infoNeutral',
            'infoSubtle',
            'successEmphasis',
            'successNeutral',
            'successSubtle',
            'warningEmphasis',
            'warningNeutral',
            'warningSubtle',
            'errorEmphasisWithIcon',
            'errorNeutralWithIcon',
            'errorSubtleWithIcon',
            'infoEmphasisWithIcon',
            'infoNeutralWithIcon',
            'infoSubtleWithIcon',
            'successEmphasisWithIcon',
            'successNeutralWithIcon',
            'successSubtleWithIcon',
            'warningEmphasisWithIcon',
            'warningNeutralWithIcon',
            'warningSubtleWithIcon'
        ];
        return staticTypes.includes(bdsType);
    }, [
        bdsType
    ]);
    const isClickable = !isStaticChip && clickable;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($95660ad0f4562222$var$StyledChip, Object.assign({
        sx: {
            pointerEvents: isClickable ? 'auto' : 'none'
        },
        avatar: avatar ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66e61be7bdc1cebd$export$c24386ba6db6b1bd), null, renderAvatar) : undefined,
        bdsSize: bdsSize,
        bdsType: bdsType,
        clickable: isClickable,
        onDelete: onDelete,
        deleteIcon: onDelete && !deleteIcon ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b50c01cb1e657ca8$export$2e2bcd8739ae039), {
            bdsIcon: (0, $5611fe3170f53ae0$export$2e2bcd8739ae039),
            bdsType: "staticEmphasis",
            bdsSize: "small"
        }) : deleteIcon,
        disabled: disabled,
        endIcon: endIcon,
        startIcon: startIcon,
        icon: startIcon || statusIcon,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                alignItems: 'center',
                gap: spacing
            }
        }, label, endIcon),
        onClick: handleClick,
        selected: selected
    }, rest, {
        classes: {
            label: 'bds-chip-label',
            avatar: 'bds-chip-avatar',
            icon: 'bds-chip-icon'
        }
    }));
});
// This is necessary to show the name of the component correctly in the DevTools and Storybook.
$95660ad0f4562222$var$BDSChip.displayName = 'Chip';
var $95660ad0f4562222$export$2e2bcd8739ae039 = $95660ad0f4562222$var$BDSChip;


var $fb0d7dcff345e2ae$export$2e2bcd8739ae039 = (0, $95660ad0f4562222$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $4c8156a231c9130b$export$2e2bcd8739ae039);



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;


var $adbbc5717e0d0350$exports = {};

$parcel$defineInteropFlag($adbbc5717e0d0350$exports);

$parcel$export($adbbc5717e0d0350$exports, "getListUtilityClass", () => $adbbc5717e0d0350$export$c6bd6795ed6e3203);
$parcel$export($adbbc5717e0d0350$exports, "default", () => $adbbc5717e0d0350$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $adbbc5717e0d0350$export$c6bd6795ed6e3203), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $0200cab69b9251c8$export$2e2bcd8739ae039);




'use client';
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $aab859a020ad749e$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $0d80e79907b6bdbc$export$2e2bcd8739ae039)((0, $c10afe25107351d9$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;


var $012baef8dc9ae9d0$exports = {};

$parcel$defineInteropFlag($012baef8dc9ae9d0$exports);

$parcel$export($012baef8dc9ae9d0$exports, "getOffsetTop", () => $012baef8dc9ae9d0$export$6fcff0dc60346367);
$parcel$export($012baef8dc9ae9d0$exports, "getOffsetLeft", () => $012baef8dc9ae9d0$export$a6a488ff68b1bf7b);
$parcel$export($012baef8dc9ae9d0$exports, "PopoverRoot", () => $012baef8dc9ae9d0$export$bcce13685275fc99);
$parcel$export($012baef8dc9ae9d0$exports, "PopoverPaper", () => $012baef8dc9ae9d0$export$821346c38a2d9390);
$parcel$export($012baef8dc9ae9d0$exports, "default", () => $012baef8dc9ae9d0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");








var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039);




function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $71912e551e227707$export$2e2bcd8739ae039);





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;


var $5c4c540114ae85ab$exports = {};

$parcel$defineInteropFlag($5c4c540114ae85ab$exports);

$parcel$export($5c4c540114ae85ab$exports, "getBackdropUtilityClass", () => $5c4c540114ae85ab$export$9927a91fd93152bd);
$parcel$export($5c4c540114ae85ab$exports, "default", () => $5c4c540114ae85ab$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4838e5a14e330013$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5c4c540114ae85ab$export$9927a91fd93152bd), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4838e5a14e330013$var$BackdropRoot, (0, $8nd05.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $9QePP.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $71912e551e227707$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $71912e551e227707$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $0200cab69b9251c8$export$2e2bcd8739ae039)((0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$defaultManager = new (0, $52971d86e2bcd483$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $f86e7d122c1fa324$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $4c8156a231c9130b$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $52971d86e2bcd483$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $8nd05.default)({}, propsEventHandlers, otherHandlers);
        return (0, $8nd05.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $8nd05.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;


var $0cea91a79e26c98a$exports = {};

$parcel$defineInteropFlag($0cea91a79e26c98a$exports);

$parcel$export($0cea91a79e26c98a$exports, "getModalUtilityClass", () => $0cea91a79e26c98a$export$67960e22b12a638d);
$parcel$export($0cea91a79e26c98a$exports, "default", () => $0cea91a79e26c98a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $0cea91a79e26c98a$export$67960e22b12a638d), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const propsWithDefaults = (0, $8nd05.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $f86e7d122c1fa324$export$2e2bcd8739ae039)((0, $8nd05.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $8nd05.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0bdcbfecdf3275a2$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $8nd05.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $9QePP.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, (0, $8nd05.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f30200a1e85b3f20$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;



var $ea2c25a800e729b1$exports = {};

$parcel$defineInteropFlag($ea2c25a800e729b1$exports);

$parcel$export($ea2c25a800e729b1$exports, "getPopoverUtilityClass", () => $ea2c25a800e729b1$export$88f455dd56c95edb);
$parcel$export($ea2c25a800e729b1$exports, "default", () => $ea2c25a800e729b1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $012baef8dc9ae9d0$var$_excluded3 = [
    "slotProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ea2c25a800e729b1$export$88f455dd56c95edb), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $c10afe25107351d9$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $c10afe25107351d9$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $012baef8dc9ae9d0$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $012baef8dc9ae9d0$export$821346c38a2d9390;
    const paperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $8nd05.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $8nd05.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $1En50.default)(_useSlotProps, $012baef8dc9ae9d0$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, (0, $8nd05.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");
var $fb1e7d0ac8fac824$exports = {};

$parcel$defineInteropFlag($fb1e7d0ac8fac824$exports);

$parcel$export($fb1e7d0ac8fac824$exports, "getMenuUtilityClass", () => $fb1e7d0ac8fac824$export$2cf86a63a84fe23d);
$parcel$export($fb1e7d0ac8fac824$exports, "default", () => $fb1e7d0ac8fac824$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fb1e7d0ac8fac824$export$2cf86a63a84fe23d), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $fbb3fa0cdc277971$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $364f3db28d8d2e79$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $9QePP.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;



var $e4495f8bb3a0cc06$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e4495f8bb3a0cc06$var$BDSMenu = (_a)=>{
    var props = $e4495f8bb3a0cc06$var$__rest(_a, []);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), Object.assign({
        slotProps: {
            paper: {
                sx: {
                    elevation: 0,
                    boxShadow: theme.palette.menu.boxShadow,
                    backgroundColor: theme.palette.menu.background.color,
                    border: `${theme.palette.menu.border.width} solid`,
                    borderColor: theme.palette.menu.border.color,
                    borderRadius: theme.palette.menu.border.radius,
                    // spacebetween applies to the menu items
                    // spacebetween: theme.palette.menu.spaceBetween,
                    padding: theme.palette.menu.padding
                }
            }
        }
    }, props));
};
$e4495f8bb3a0cc06$var$BDSMenu.displayName = 'Menu';
var $e4495f8bb3a0cc06$export$2e2bcd8739ae039 = $e4495f8bb3a0cc06$var$BDSMenu;




var $08db6acf526301e1$export$2e2bcd8739ae039 = (0, $e4495f8bb3a0cc06$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");





var $9c1b7b40cd19f5fe$exports = {};

$parcel$defineInteropFlag($9c1b7b40cd19f5fe$exports);

$parcel$export($9c1b7b40cd19f5fe$exports, "getListItemIconUtilityClass", () => $9c1b7b40cd19f5fe$export$81478e24460c57f2);
$parcel$export($9c1b7b40cd19f5fe$exports, "default", () => $9c1b7b40cd19f5fe$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;


var $c01aa6ddbe5e68bd$exports = {};

$parcel$defineInteropFlag($c01aa6ddbe5e68bd$exports);

$parcel$export($c01aa6ddbe5e68bd$exports, "getListItemTextUtilityClass", () => $c01aa6ddbe5e68bd$export$1061006a0db3aeb5);
$parcel$export($c01aa6ddbe5e68bd$exports, "default", () => $c01aa6ddbe5e68bd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;


var $adff06ac3b11e066$exports = {};

$parcel$defineInteropFlag($adff06ac3b11e066$exports);

$parcel$export($adff06ac3b11e066$exports, "getMenuItemUtilityClass", () => $adff06ac3b11e066$export$515f8c67b5305377);
$parcel$export($adff06ac3b11e066$exports, "default", () => $adff06ac3b11e066$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ac984bce84b2164$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $adff06ac3b11e066$export$515f8c67b5305377), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $8nd05.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $1En50.default)(props, $1ac984bce84b2164$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, (0, $8nd05.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;



var $d8seH = parcelRequire("d8seH");
var $abf91f1ec64eab0f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $abf91f1ec64eab0f$var$BDSMenuItemStyled = (0, $d8seH.default)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'selected' && prop !== 'nested'
})(({ theme: theme, selected: selected, nested: nested })=>Object.assign(Object.assign({
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        fontFamily: theme.palette.menuItem.font.family,
        fontWeight: nested ? theme.palette.menuItem.font.weight.nested : theme.palette.menuItem.font.weight.default,
        fontSize: theme.palette.menuItem.font.size,
        lineHeight: theme.palette.menuItem.font.lineHeight,
        letterSpacing: theme.palette.menuItem.font.letterSpacing,
        justifyContent: theme.palette.menu.spaceBetween,
        backgroundColor: theme.palette.menuItem.background.color,
        borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.color}`,
        color: theme.palette.menuItem.text.color
    }, selected && {
        backgroundColor: theme.palette.menuItem.background.selected.color,
        borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.selected.color}`,
        color: theme.palette.menuItem.text.selected,
        '&:hover': {
            backgroundColor: theme.palette.menuItem.background.selected.hover,
            borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.selected.hover}`,
            color: theme.palette.menuItem.text.selected
        }
    }), {
        '&:hover': {
            backgroundColor: theme.palette.menuItem.background.hover,
            borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.hover}`,
            color: theme.palette.menuItem.text.hover
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.palette.menuItem.background.focus,
            borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.focus}`,
            color: theme.palette.menuItem.text.focus
        },
        '&.Mui-disabled': {
            color: theme.palette.menuItem.text.disabled,
            pointerEvents: 'none',
            backgroundColor: theme.palette.menuItem.background.disabled,
            borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.disabled}`
        },
        borderRadius: theme.palette.menu.border.radius,
        padding: theme.palette.menuItem.padding.default
    }));
const $abf91f1ec64eab0f$var$BDSMenuItem = (_a)=>{
    var { selected: selected = false, nested: nested = false } = _a, props = $abf91f1ec64eab0f$var$__rest(_a, [
        "selected",
        "nested"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($abf91f1ec64eab0f$var$BDSMenuItemStyled, Object.assign({
        selected: selected,
        nested: nested
    }, props));
};
$abf91f1ec64eab0f$var$BDSMenuItem.displayName = 'BDSMenuItem';
var $abf91f1ec64eab0f$export$2e2bcd8739ae039 = $abf91f1ec64eab0f$var$BDSMenuItem;


var $ea20f98bbbba0b96$export$2e2bcd8739ae039 = (0, $abf91f1ec64eab0f$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $31e7e5da10b31fc6$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $31e7e5da10b31fc6$var$SvgArrowDropDown(props) {
    return $31e7e5da10b31fc6$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M7 10l5 5 5-5z"
    })), props);
}
var $31e7e5da10b31fc6$export$2e2bcd8739ae039 = $31e7e5da10b31fc6$var$SvgArrowDropDown;



var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $b9bc1a39dd2a7fca$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $b9bc1a39dd2a7fca$var$SvgPageNext(props) {
    return $b9bc1a39dd2a7fca$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor"
    }, props), $acw62.createElement("path", {
        d: "M9.41 6L8 7.41 12.58 12 8 16.59 9.41 18l6-6-6-6z"
    })), props);
}
var $b9bc1a39dd2a7fca$export$2e2bcd8739ae039 = $b9bc1a39dd2a7fca$var$SvgPageNext;



var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $7fdd1b20e49088cd$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $7fdd1b20e49088cd$var$SvgPagePrevious(props) {
    return $7fdd1b20e49088cd$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor"
    }, props), $acw62.createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
    })), props);
}
var $7fdd1b20e49088cd$export$2e2bcd8739ae039 = $7fdd1b20e49088cd$var$SvgPagePrevious;



var $26e495bba21faabf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $26e495bba21faabf$var$BDSPagination = (_a)=>{
    var { itemsPerPage: itemsPerPage, itemsPerPageOptions: itemsPerPageOptions = [], itemsPerPageDescription: itemsPerPageDescription = 'items per page', onChange: onChange, onClickItemsPerPageOption: onClickItemsPerPageOption, onClickItemsPerPage: onClickItemsPerPage, onCloseItemsPerPage: onCloseItemsPerPage, page: page, totalItems: totalItems, isCompressed: isCompressed = false, paginationZIndex: paginationZIndex = 1, isCompressedHeader: isCompressedHeader = false, infinitePagination: infinitePagination = false } = _a, rest = $26e495bba21faabf$var$__rest(_a, [
        "itemsPerPage",
        "itemsPerPageOptions",
        "itemsPerPageDescription",
        "onChange",
        "onClickItemsPerPageOption",
        "onClickItemsPerPage",
        "onCloseItemsPerPage",
        "page",
        "totalItems",
        "isCompressed",
        "paginationZIndex",
        "isCompressedHeader",
        "infinitePagination"
    ]);
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const [currentItemsPerPage, setCurrentItemsPerPage] = (0, $acw62.useState)(itemsPerPage);
    const tokens = (0, $5cffe40b21e31a28$export$2e2bcd8739ae039)();
    const numberOfPages = (0, $acw62.useMemo)(()=>Math.ceil(totalItems / currentItemsPerPage), [
        currentItemsPerPage,
        totalItems
    ]);
    const handleClickItemsPerPage = (0, $acw62.useCallback)((event)=>{
        if (onClickItemsPerPage && typeof onClickItemsPerPage === 'function') onClickItemsPerPage(event);
        setAnchorEl(event.currentTarget);
    }, [
        onClickItemsPerPage
    ]);
    const handleMenuItemClick = (0, $acw62.useCallback)((event, itemsPerPageValue)=>{
        if (onClickItemsPerPageOption && typeof onClickItemsPerPageOption === 'function') onClickItemsPerPageOption(itemsPerPageValue);
        setCurrentItemsPerPage(itemsPerPageValue);
        onChange(event, 1); // Reset to the first page when items per page change
        setAnchorEl(null);
    }, [
        onChange,
        onClickItemsPerPageOption
    ]);
    const handleClose = (0, $acw62.useCallback)((event, reason)=>{
        if (onCloseItemsPerPage && typeof onCloseItemsPerPage === 'function') onCloseItemsPerPage(event, reason);
        setAnchorEl(null);
    }, [
        onCloseItemsPerPage
    ]);
    const handlePageChange = (0, $acw62.useCallback)((event, value)=>{
        event.preventDefault();
        if (onChange && typeof onChange === 'function') onChange(event, value);
    }, [
        onChange
    ]);
    const backPageDisabled = (0, $acw62.useMemo)(()=>page <= 1, [
        page
    ]);
    const nextPageDisabled = (0, $acw62.useMemo)(()=>currentItemsPerPage * page >= totalItems, [
        currentItemsPerPage,
        page,
        totalItems
    ]);
    const itemsChangePagination = (0, $acw62.useMemo)(()=>{
        const start = currentItemsPerPage * (page - 1) + 1;
        const end = page === numberOfPages ? totalItems : currentItemsPerPage * page;
        return `${start} - ${end} of ${totalItems} items`;
    }, [
        page,
        numberOfPages,
        totalItems,
        currentItemsPerPage
    ]);
    const StyledPagination = (0, $d8seH.default)((0, $081224c8d3cb055f$export$2e2bcd8739ae039))(({ theme: theme })=>({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiPagination-ul': {
                gap: tokens.paginationSpaceBetween
            },
            '& .MuiPaginationItem-root': {
                color: tokens.numberColorTextStaticSubtle,
                fontSize: tokens.numberFontSizeInput,
                fontWeight: tokens.numberFontWeight,
                minWidth: tokens.numberMinWidthInput,
                width: 'auto',
                paddingLeft: tokens.numberPaddingInput,
                paddingRight: tokens.numberPaddingInput,
                height: tokens.numberHeightInput,
                border: `${tokens.numberBorderWidthOutlined} solid ${tokens.numberColorBorderInteractiveSubtleDefault}`,
                borderRadius: tokens.numberBorderRadiusDefault,
                backgroundColor: tokens.numberColorBgInteractiveSubtleDefault,
                '&:hover': {
                    backgroundColor: tokens.numberColorBgInteractiveSubtleSelectedHover,
                    border: `${tokens.numberBorderWidthOutlined} solid ${tokens.numberColorBorderInteractiveSubtleHover}`
                },
                '&.FocusVisible': {
                    backgroundColor: tokens.numberColorBgInteractiveSubtleSelectedHover,
                    border: `${tokens.numberBorderWidthOutlined} solid ${tokens.numberColorBorderInteractiveSubtleSelectedHover}`
                },
                '&.Mui-selected': {
                    backgroundColor: tokens.numberColorBgInteractiveSubtleSelectedDefault,
                    border: `${tokens.numberBorderWidthOutlined} solid ${tokens.numberColorBorderInteractiveSubtleSelectedDefault}`,
                    '&:hover': {
                        backgroundColor: tokens.numberColorBgInteractiveSubtleSelectedHover,
                        border: `${tokens.numberBorderWidthOutlined} solid ${tokens.numberColorBorderInteractiveSubtleSelectedHover}`
                    },
                    '&.FocusVisible': {
                        backgroundColor: tokens.numberColorBgInteractiveSubtleSelectedHover,
                        border: `${tokens.numberBorderWidthOutlined} solid ${tokens.numberColorBorderInteractiveSubtleSelectedHover}`
                    }
                }
            },
            '& .MuiPaginationItem-root[aria-label="Go to first page"], & .MuiPaginationItem-root[aria-label="Go to last page"], & .MuiPaginationItem-root[aria-label="Go to next page"], & .MuiPaginationItem-root[aria-label="Go to previous page"]': {
                '&.MuiButtonBase-root': {
                    height: theme.palette.iconButton.size.input,
                    width: theme.palette.iconButton.size.input
                },
                '& .MuiSvgIcon-root': {
                    fill: 'currentColor',
                    height: theme.palette.icon.size.medium,
                    width: theme.palette.icon.size.medium,
                    fontSize: theme.palette.icon.size.medium
                },
                color: theme.palette.icon.interactive.neutral.color.default,
                borderRadius: theme.palette.iconButton.border.radius,
                cursor: 'pointer',
                background: theme.palette.iconButton.interactive.subtle.background,
                border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.border}`,
                '&:hover': {
                    color: theme.palette.icon.interactive.neutral.color.hover,
                    background: theme.palette.iconButton.interactive.subtle.hover.background,
                    border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.hover.border}`
                },
                '&:focus-visible': {
                    color: theme.palette.icon.interactive.neutral.color.focus,
                    background: theme.palette.iconButton.interactive.subtle.background,
                    border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.border}`
                },
                '&.Mui-disabled': {
                    color: theme.palette.icon.interactive.neutral.color.disabled,
                    border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.disabled.border}`,
                    background: theme.palette.iconButton.interactive.subtle.disabled.background,
                    opacity: 1
                },
                '&.MuiSelected': {
                    color: theme.palette.icon.interactive.neutral.color.selected.default,
                    background: theme.palette.iconButton.interactive.subtle.selected.background,
                    border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.selected.border}`,
                    '&:hover': {
                        color: theme.palette.icon.interactive.neutral.color.selected.hover,
                        background: theme.palette.iconButton.interactive.subtle.selected.hover.background,
                        border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.selected.hover.border}`
                    }
                }
            }
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
        container: true,
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        justifyContent: !isCompressed ? 'space-between' : 'flex-start',
        p: tokens.paginationPadding,
        borderTop: !isCompressed ? `${tokens.aliasesBorderWidthDefault} solid ${tokens.paginationColorBorderDefault}` : '',
        position: "sticky",
        bottom: 0,
        zIndex: paginationZIndex,
        gap: tokens.paginationSpaceBetween,
        width: "auto",
        sx: {
            background: tokens.paginationColorBgFilled
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
        item: true,
        alignItems: "center",
        display: "flex",
        gap: tokens.paginationSpaceBetween
    }, !isCompressed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StyledPagination, Object.assign({
        count: numberOfPages + +infinitePagination,
        showFirstButton: true,
        showLastButton: true,
        onChange: handlePageChange,
        page: page,
        siblingCount: 2
    }, rest)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fb0d7dcff345e2ae$export$2e2bcd8739ae039), {
        bdsSize: isCompressed ? 'medium' : 'input',
        bdsType: "interactiveSubtle",
        label: currentItemsPerPage,
        clickable: true,
        onClick: handleClickItemsPerPage,
        endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b50c01cb1e657ca8$export$2e2bcd8739ae039), {
            bdsIcon: (0, $31e7e5da10b31fc6$export$2e2bcd8739ae039),
            bdsSize: "small",
            bdsType: "staticEmphasis"
        })
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08db6acf526301e1$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        keepMounted: true,
        open: Boolean(anchorEl),
        onClose: handleClose
    }, Array.isArray(itemsPerPageOptions) && itemsPerPageOptions.map((itemsPerPageOption)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ea20f98bbbba0b96$export$2e2bcd8739ae039), {
            key: itemsPerPageOption,
            selected: itemsPerPageOption === currentItemsPerPage,
            onClick: (e)=>handleMenuItemClick(e, itemsPerPageOption)
        }, itemsPerPageOption))), isCompressed && isCompressedHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
        variant: "caption"
    }, itemsPerPageDescription)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
        item: true,
        display: "flex"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
        variant: "caption"
    }, itemsChangePagination)), isCompressed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: tokens.paginationSpaceBetween
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
        bdsSize: "medium",
        disabled: backPageDisabled,
        onClick: (event)=>handlePageChange(event, page - 1)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fdd1b20e49088cd$export$2e2bcd8739ae039), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
        bdsSize: "medium",
        disabled: nextPageDisabled,
        onClick: (event)=>handlePageChange(event, page + 1)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9bc1a39dd2a7fca$export$2e2bcd8739ae039), null))));
};
$26e495bba21faabf$var$BDSPagination.displayName = 'Pagination';
var $26e495bba21faabf$export$2e2bcd8739ae039 = $26e495bba21faabf$var$BDSPagination;


var $f23ee38ba9fa7638$export$2e2bcd8739ae039 = (0, $26e495bba21faabf$export$2e2bcd8739ae039);

var $91a4e72629291447$exports = {};

$parcel$export($91a4e72629291447$exports, "colors", () => $210a9320270ce251$exports);
$parcel$export($91a4e72629291447$exports, "Accordion", () => $5c228c234852d575$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "AccordionActions", () => $3c271b1069b6d28c$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "AccordionDetails", () => $1b78273c1c27a2e1$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "AccordionSummary", () => $1a792f5a0c37e2ab$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Alert", () => $d7b9f0ef25189a24$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "AlertTitle", () => $cbe9496169f0560d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "AppBar", () => $37a342382669398e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Autocomplete", () => $9396253983985262$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Avatar", () => $1894f4268467302e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "AvatarGroup", () => $70229258f609d599$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Backdrop", () => $4838e5a14e330013$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Badge", () => $b0a465815ebe726f$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "BottomNavigation", () => $5da68ee03f6480a6$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "BottomNavigationAction", () => $fd7b1d1a8629ce6b$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Box", () => $00a20d475386f68c$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Breadcrumbs", () => $3beee71e1808c2fa$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Button", () => $4a02bab8c70a697b$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ButtonBase", () => $4a35786d89db9dda$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ButtonGroup", () => $1c026d95d0d4d482$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Card", () => $45313e7d506ce734$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "CardActionArea", () => $8c7064036f0f2f9d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "CardActions", () => $b46a5bcac23a5f99$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "CardContent", () => $28a500ea92f2665f$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "CardHeader", () => $bc2b3dbd11553d00$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "CardMedia", () => $891b59d4b36435bb$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Checkbox", () => $12775c00f473d955$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Chip", () => $47d4f79319086dc5$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "CircularProgress", () => $19b4ac261663afa8$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ClickAwayListener", () => $f0f105dbd8c07c9e$export$58385c17fee43f89);
$parcel$export($91a4e72629291447$exports, "Collapse", () => $848dc8709a4309c5$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Container", () => $2291beb327d500f8$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "CssBaseline", () => $c3dfe91526ac04a1$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "darkScrollbar", () => $3426a3520e69a38c$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Dialog", () => $4f13784bd714c44e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "DialogActions", () => $207bc6ab7c60f4b2$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "DialogContent", () => $4fa8e9c420cdee0a$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "DialogContentText", () => $aad93085434ac13f$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "DialogTitle", () => $a6ac58aca374c76c$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Divider", () => $f875d00b2138afe4$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Drawer", () => $1ed9758f3bc045cc$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Fab", () => $2426d7556721cbb6$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Fade", () => $5e5a92158e7d9bd4$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "FilledInput", () => $bb335d5457c07f5b$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "FormControl", () => $bcd22a386c6068c0$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "FormControlLabel", () => $1a034abd43bd8eee$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "FormGroup", () => $5042f159189dda87$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "FormHelperText", () => $d23aa5c3ca6913fb$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "FormLabel", () => $9b0ab7de0d37835d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Grid", () => $9450fbc34cc5b2ea$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Unstable_Grid2", () => $92254a0e483a5b59$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Grow", () => $d6f4882a3b1c59f2$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Hidden", () => $63ab04e863ebf1a5$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Icon", () => $93c87ddcceadf9a1$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "IconButton", () => $71c322247f7fbf93$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ImageList", () => $975a1cffa46f382b$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ImageListItem", () => $aeb7a529fa95e8e4$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ImageListItemBar", () => $fb46f5873d57d468$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Input", () => $76910a07fd4ac4fe$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "InputAdornment", () => $d0c64ff513a9933f$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "InputBase", () => $69d1b2c99a8dc649$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "InputLabel", () => $09846a8ab0aba36e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "LinearProgress", () => $0fa40ac3f678fedb$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Link", () => $731ce78e0c47d0a7$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "List", () => $640cd381f5e8b3ea$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ListItem", () => $f92832698674c928$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ListItemAvatar", () => $5e1a7f5eff0ff3e8$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ListItemButton", () => $960931686a59e228$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ListItemIcon", () => $83e175cb7e49d325$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ListItemSecondaryAction", () => $9924235485c5a222$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ListItemText", () => $0d696835f9b43a35$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ListSubheader", () => $5408b2039b9d572c$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Menu", () => $364f3db28d8d2e79$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "MenuItem", () => $1ac984bce84b2164$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "MenuList", () => $fbb3fa0cdc277971$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "MobileStepper", () => $3e720f5cf13cfb0a$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Modal", () => $0bdcbfecdf3275a2$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "NativeSelect", () => $3ca2173d4de87b59$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "NoSsr", () => $397ca82a6faac65f$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "OutlinedInput", () => $d5d55d2dd82639e9$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Pagination", () => $081224c8d3cb055f$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "PaginationItem", () => $6a273894865f8b08$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Paper", () => $595185d0d7275c3b$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Popover", () => $012baef8dc9ae9d0$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Popper", () => $a4669aa090d445bd$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Portal", () => $2117883cc21a32b2$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Radio", () => $cb3af4fea2cad44e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "RadioGroup", () => $659f9ff12b4e3755$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Rating", () => $a235763b3a7014ab$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ScopedCssBaseline", () => $f88e6b262a71acad$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Select", () => $96e1233e8d06bb2d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Skeleton", () => $445470756a9ff70a$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Slide", () => $4dba6b402693f5d6$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Slider", () => $e7d362f04a4204f3$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Snackbar", () => $ef601776ba11bb1e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "SnackbarContent", () => $dbe322effc7340b4$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "SpeedDial", () => $ef91875cc443f344$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "SpeedDialAction", () => $ceac721f7000e3b1$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "SpeedDialIcon", () => $f613f9bdcf68845e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Stack", () => $231d58234d437bc0$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Step", () => $fa230948139f2492$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "StepButton", () => $2837485fb2fa495c$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "StepConnector", () => $33aca0a7deb8d615$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "StepContent", () => $a0bdd2eb216e9220$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "StepIcon", () => $09445c1bc5a83d17$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "StepLabel", () => $a38d9d8360b02e78$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Stepper", () => $0a0f8c19f5f3ee7a$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "SvgIcon", () => (parcelRequire("3ErGR")).default);
$parcel$export($91a4e72629291447$exports, "SwipeableDrawer", () => $b451cc713fab7e92$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Switch", () => $56ccc0421702a0be$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Tab", () => $e6a3a0c577f6eee9$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Table", () => $22fefd5f207422b3$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TableBody", () => $09d8a23708c3ccc9$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TableCell", () => $a71dfe9e22152ea2$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TableContainer", () => $5d7964a6269b66c8$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TableFooter", () => $ff28f43fd0d3e223$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TableHead", () => $c9c28a8e795911dc$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TablePagination", () => $effe3c7e7b91170d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TableRow", () => $22705465ad6920f8$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TableSortLabel", () => $be01c206ebbcc5af$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Tabs", () => $7be483edbed3b474$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TabScrollButton", () => $9e031514df70ea8e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TextField", () => $d8826083c5af4ea7$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "TextareaAutosize", () => $032c0e7078a9cb7d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ToggleButton", () => $ab85d69438d76ec5$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "ToggleButtonGroup", () => $7479184c3cda7f5d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Toolbar", () => $ef8072c26f712b4c$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Tooltip", () => $96a8b4f445fd9172$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Typography", () => $2531239e3a525689$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "useMediaQuery", () => $0c8dae23e679323d$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "usePagination", () => $fcf3350ab6dcf91e$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "useScrollTrigger", () => $a3399924514ccab2$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "Zoom", () => $4672437388b729f6$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "useAutocomplete", () => $23a03a376a300fc5$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "GlobalStyles", () => $03fc756f7adfd498$export$2e2bcd8739ae039);
$parcel$export($91a4e72629291447$exports, "unstable_composeClasses", () => (parcelRequire("8Indx")).default);
$parcel$export($91a4e72629291447$exports, "generateUtilityClass", () => (parcelRequire("4Cod0")).default);
$parcel$export($91a4e72629291447$exports, "generateUtilityClasses", () => (parcelRequire("beCSm")).default);
$parcel$export($91a4e72629291447$exports, "Unstable_TrapFocus", () => $f30200a1e85b3f20$export$2e2bcd8739ae039);
/**
 * @mui/material v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable import/export */ var $210a9320270ce251$exports = {};

$parcel$export($210a9320270ce251$exports, "common", () => (parcelRequire("dzxhF")).default);
$parcel$export($210a9320270ce251$exports, "red", () => (parcelRequire("ln9F4")).default);
$parcel$export($210a9320270ce251$exports, "pink", () => $0977467e0d52ba8b$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "purple", () => (parcelRequire("kSXRh")).default);
$parcel$export($210a9320270ce251$exports, "deepPurple", () => $73f5dba4a86b7528$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "indigo", () => $bece90587ed49c40$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "blue", () => (parcelRequire("bKnBV")).default);
$parcel$export($210a9320270ce251$exports, "lightBlue", () => (parcelRequire("iDVue")).default);
$parcel$export($210a9320270ce251$exports, "cyan", () => $b48a24d2f7b64288$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "teal", () => $965c51b2111f81b0$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "green", () => (parcelRequire("e4nxq")).default);
$parcel$export($210a9320270ce251$exports, "lightGreen", () => $dfd7538e53c5578e$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "lime", () => $9ca367113480e6b8$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "yellow", () => $19d1c187b7554b9f$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "amber", () => $b1a4ea7d0e15a230$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "orange", () => (parcelRequire("dMYym")).default);
$parcel$export($210a9320270ce251$exports, "deepOrange", () => $3e959950983c409e$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "brown", () => $bc1ff25570917fdc$export$2e2bcd8739ae039);
$parcel$export($210a9320270ce251$exports, "grey", () => (parcelRequire("eU5ou")).default);
$parcel$export($210a9320270ce251$exports, "blueGrey", () => $801710099648f128$export$2e2bcd8739ae039);

var $dzxhF = parcelRequire("dzxhF");

var $ln9F4 = parcelRequire("ln9F4");
const $0977467e0d52ba8b$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $0977467e0d52ba8b$export$2e2bcd8739ae039 = $0977467e0d52ba8b$var$pink;



var $kSXRh = parcelRequire("kSXRh");
const $73f5dba4a86b7528$var$deepPurple = {
    50: '#ede7f6',
    100: '#d1c4e9',
    200: '#b39ddb',
    300: '#9575cd',
    400: '#7e57c2',
    500: '#673ab7',
    600: '#5e35b1',
    700: '#512da8',
    800: '#4527a0',
    900: '#311b92',
    A100: '#b388ff',
    A200: '#7c4dff',
    A400: '#651fff',
    A700: '#6200ea'
};
var $73f5dba4a86b7528$export$2e2bcd8739ae039 = $73f5dba4a86b7528$var$deepPurple;


const $bece90587ed49c40$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $bece90587ed49c40$export$2e2bcd8739ae039 = $bece90587ed49c40$var$indigo;



var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");
const $b48a24d2f7b64288$var$cyan = {
    50: '#e0f7fa',
    100: '#b2ebf2',
    200: '#80deea',
    300: '#4dd0e1',
    400: '#26c6da',
    500: '#00bcd4',
    600: '#00acc1',
    700: '#0097a7',
    800: '#00838f',
    900: '#006064',
    A100: '#84ffff',
    A200: '#18ffff',
    A400: '#00e5ff',
    A700: '#00b8d4'
};
var $b48a24d2f7b64288$export$2e2bcd8739ae039 = $b48a24d2f7b64288$var$cyan;


const $965c51b2111f81b0$var$teal = {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    A100: '#a7ffeb',
    A200: '#64ffda',
    A400: '#1de9b6',
    A700: '#00bfa5'
};
var $965c51b2111f81b0$export$2e2bcd8739ae039 = $965c51b2111f81b0$var$teal;



var $e4nxq = parcelRequire("e4nxq");
const $dfd7538e53c5578e$var$lightGreen = {
    50: '#f1f8e9',
    100: '#dcedc8',
    200: '#c5e1a5',
    300: '#aed581',
    400: '#9ccc65',
    500: '#8bc34a',
    600: '#7cb342',
    700: '#689f38',
    800: '#558b2f',
    900: '#33691e',
    A100: '#ccff90',
    A200: '#b2ff59',
    A400: '#76ff03',
    A700: '#64dd17'
};
var $dfd7538e53c5578e$export$2e2bcd8739ae039 = $dfd7538e53c5578e$var$lightGreen;


const $9ca367113480e6b8$var$lime = {
    50: '#f9fbe7',
    100: '#f0f4c3',
    200: '#e6ee9c',
    300: '#dce775',
    400: '#d4e157',
    500: '#cddc39',
    600: '#c0ca33',
    700: '#afb42b',
    800: '#9e9d24',
    900: '#827717',
    A100: '#f4ff81',
    A200: '#eeff41',
    A400: '#c6ff00',
    A700: '#aeea00'
};
var $9ca367113480e6b8$export$2e2bcd8739ae039 = $9ca367113480e6b8$var$lime;


const $19d1c187b7554b9f$var$yellow = {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffeb3b',
    600: '#fdd835',
    700: '#fbc02d',
    800: '#f9a825',
    900: '#f57f17',
    A100: '#ffff8d',
    A200: '#ffff00',
    A400: '#ffea00',
    A700: '#ffd600'
};
var $19d1c187b7554b9f$export$2e2bcd8739ae039 = $19d1c187b7554b9f$var$yellow;


const $b1a4ea7d0e15a230$var$amber = {
    50: '#fff8e1',
    100: '#ffecb3',
    200: '#ffe082',
    300: '#ffd54f',
    400: '#ffca28',
    500: '#ffc107',
    600: '#ffb300',
    700: '#ffa000',
    800: '#ff8f00',
    900: '#ff6f00',
    A100: '#ffe57f',
    A200: '#ffd740',
    A400: '#ffc400',
    A700: '#ffab00'
};
var $b1a4ea7d0e15a230$export$2e2bcd8739ae039 = $b1a4ea7d0e15a230$var$amber;



var $dMYym = parcelRequire("dMYym");
const $3e959950983c409e$var$deepOrange = {
    50: '#fbe9e7',
    100: '#ffccbc',
    200: '#ffab91',
    300: '#ff8a65',
    400: '#ff7043',
    500: '#ff5722',
    600: '#f4511e',
    700: '#e64a19',
    800: '#d84315',
    900: '#bf360c',
    A100: '#ff9e80',
    A200: '#ff6e40',
    A400: '#ff3d00',
    A700: '#dd2c00'
};
var $3e959950983c409e$export$2e2bcd8739ae039 = $3e959950983c409e$var$deepOrange;


const $bc1ff25570917fdc$var$brown = {
    50: '#efebe9',
    100: '#d7ccc8',
    200: '#bcaaa4',
    300: '#a1887f',
    400: '#8d6e63',
    500: '#795548',
    600: '#6d4c41',
    700: '#5d4037',
    800: '#4e342e',
    900: '#3e2723',
    A100: '#d7ccc8',
    A200: '#bcaaa4',
    A400: '#8d6e63',
    A700: '#5d4037'
};
var $bc1ff25570917fdc$export$2e2bcd8739ae039 = $bc1ff25570917fdc$var$brown;



var $eU5ou = parcelRequire("eU5ou");
const $801710099648f128$var$blueGrey = {
    50: '#eceff1',
    100: '#cfd8dc',
    200: '#b0bec5',
    300: '#90a4ae',
    400: '#78909c',
    500: '#607d8b',
    600: '#546e7a',
    700: '#455a64',
    800: '#37474f',
    900: '#263238',
    A100: '#cfd8dc',
    A200: '#b0bec5',
    A400: '#78909c',
    A700: '#455a64'
};
var $801710099648f128$export$2e2bcd8739ae039 = $801710099648f128$var$blueGrey;




var $019ad789c5f8c324$exports = {};

$parcel$export($019ad789c5f8c324$exports, "experimental_sx", () => $019ad789c5f8c324$export$c593505552bdf13d);
$parcel$export($019ad789c5f8c324$exports, "THEME_ID", () => (parcelRequire("4jPsi")).default);
$parcel$export($019ad789c5f8c324$exports, "adaptV4Theme", () => $1964ad5a35c9e3e3$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "hexToRgb", () => $ef80a26abd5cc14c$export$5a544e13ad4e1fa5);
$parcel$export($019ad789c5f8c324$exports, "rgbToHex", () => $ef80a26abd5cc14c$export$34d09c4a771c46ef);
$parcel$export($019ad789c5f8c324$exports, "hslToRgb", () => $ef80a26abd5cc14c$export$29fb7152bd3f781a);
$parcel$export($019ad789c5f8c324$exports, "decomposeColor", () => $ef80a26abd5cc14c$export$677b39864803984e);
$parcel$export($019ad789c5f8c324$exports, "recomposeColor", () => $ef80a26abd5cc14c$export$211a73f2b8c10ce4);
$parcel$export($019ad789c5f8c324$exports, "getContrastRatio", () => $ef80a26abd5cc14c$export$d061e26956a60b0a);
$parcel$export($019ad789c5f8c324$exports, "getLuminance", () => $ef80a26abd5cc14c$export$c852d90bf7403b62);
$parcel$export($019ad789c5f8c324$exports, "emphasize", () => $ef80a26abd5cc14c$export$e665714f76e581fd);
$parcel$export($019ad789c5f8c324$exports, "alpha", () => $ef80a26abd5cc14c$export$58f0f39f63f3cf42);
$parcel$export($019ad789c5f8c324$exports, "darken", () => $ef80a26abd5cc14c$export$4b073707ff63303);
$parcel$export($019ad789c5f8c324$exports, "lighten", () => $ef80a26abd5cc14c$export$c0816ed86df316af);
$parcel$export($019ad789c5f8c324$exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export($019ad789c5f8c324$exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export($019ad789c5f8c324$exports, "createTheme", () => (parcelRequire("ijOKP")).default);
$parcel$export($019ad789c5f8c324$exports, "createMuiTheme", () => (parcelRequire("ijOKP")).createMuiTheme);
$parcel$export($019ad789c5f8c324$exports, "unstable_createMuiStrictModeTheme", () => $3d23504439aa8524$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "createStyles", () => $17c504046cb9a64c$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "unstable_getUnit", () => $0d35ef8a52a98e99$export$65f2564e9a9b9222);
$parcel$export($019ad789c5f8c324$exports, "unstable_toUnitless", () => $0d35ef8a52a98e99$export$8af1d214c6c2f0f1);
$parcel$export($019ad789c5f8c324$exports, "responsiveFontSizes", () => $a7b09e624fa460c3$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "duration", () => (parcelRequire("bmoVh")).duration);
$parcel$export($019ad789c5f8c324$exports, "easing", () => (parcelRequire("bmoVh")).easing);
$parcel$export($019ad789c5f8c324$exports, "useTheme", () => $0c87a2f38cd49c7a$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "useThemeProps", () => $48eb684ebe9272b4$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "styled", () => (parcelRequire("d8seH")).default);
$parcel$export($019ad789c5f8c324$exports, "experimentalStyled", () => (parcelRequire("d8seH")).default);
$parcel$export($019ad789c5f8c324$exports, "ThemeProvider", () => $c4650f6dac4940cb$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "StyledEngineProvider", () => (parcelRequire("ePWXO")).default);
$parcel$export($019ad789c5f8c324$exports, "makeStyles", () => $f1ecc062bbad3379$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "withStyles", () => $015e9f5cd865f1ca$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "withTheme", () => $ffc685059eb0526f$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "experimental_extendTheme", () => $9afe1ce524e8f62d$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "getOverlayAlpha", () => $23fa506264c010ed$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "shouldSkipGeneratingVar", () => $b87504e8f71bd950$export$2e2bcd8739ae039);
$parcel$export($019ad789c5f8c324$exports, "private_createTypography", () => (parcelRequire("d6q8u")).default);
$parcel$export($019ad789c5f8c324$exports, "private_createMixins", () => (parcelRequire("6plKN")).default);
$parcel$export($019ad789c5f8c324$exports, "private_excludeVariablesFromRoot", () => $f1b759b2363a287f$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $4jPsi = parcelRequire("4jPsi");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $2F4pg = parcelRequire("2F4pg");
var $2YDV9 = parcelRequire("2YDV9");
const $1964ad5a35c9e3e3$var$_excluded = [
    "defaultProps",
    "mixins",
    "overrides",
    "palette",
    "props",
    "styleOverrides"
], $1964ad5a35c9e3e3$var$_excluded2 = [
    "type",
    "mode"
];
function $1964ad5a35c9e3e3$export$2e2bcd8739ae039(inputTheme) {
    const { defaultProps: defaultProps = {}, mixins: mixins = {}, overrides: overrides = {}, palette: palette = {}, props: props = {}, styleOverrides: styleOverrides = {} } = inputTheme, other = (0, $1En50.default)(inputTheme, $1964ad5a35c9e3e3$var$_excluded);
    const theme = (0, $8nd05.default)({}, other, {
        components: {}
    });
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, $2YDV9.default)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, $2F4pg.default)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = (0, $8nd05.default)({
        gutters: (styles = {})=>{
            return (0, $8nd05.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, {
                [breakpoints.up('sm')]: (0, $8nd05.default)({
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3)
                }, styles[breakpoints.up('sm')])
            });
        }
    }, mixins);
    const { type: typeInput, mode: modeInput } = palette, paletteRest = (0, $1En50.default)(palette, $1964ad5a35c9e3e3$var$_excluded2);
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = (0, $8nd05.default)({
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode
    }, paletteRest);
    return theme;
}



var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ef80a26abd5cc14c$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $ef80a26abd5cc14c$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $ef80a26abd5cc14c$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $ef80a26abd5cc14c$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $ef80a26abd5cc14c$export$677b39864803984e($ef80a26abd5cc14c$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $ef80a26abd5cc14c$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $ef80a26abd5cc14c$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $ef80a26abd5cc14c$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $ef80a26abd5cc14c$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $ef80a26abd5cc14c$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $ef80a26abd5cc14c$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$ef80a26abd5cc14c$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $ef80a26abd5cc14c$export$29fb7152bd3f781a(color) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $ef80a26abd5cc14c$export$c852d90bf7403b62(color) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $ef80a26abd5cc14c$export$677b39864803984e($ef80a26abd5cc14c$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $ef80a26abd5cc14c$export$d061e26956a60b0a(foreground, background) {
    const lumA = $ef80a26abd5cc14c$export$c852d90bf7403b62(foreground);
    const lumB = $ef80a26abd5cc14c$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $ef80a26abd5cc14c$export$58f0f39f63f3cf42(color, value) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    value = $ef80a26abd5cc14c$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $ef80a26abd5cc14c$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    coefficient = $ef80a26abd5cc14c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    coefficient = $ef80a26abd5cc14c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $ef80a26abd5cc14c$export$c852d90bf7403b62(color) > 0.5 ? $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient) : $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient);
}
function $ef80a26abd5cc14c$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $ef80a26abd5cc14c$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $ef80a26abd5cc14c$export$677b39864803984e(background);
    const overlayColor = $ef80a26abd5cc14c$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $jjlaj = parcelRequire("jjlaj");
var $ePWXO = parcelRequire("ePWXO");

var $ijOKP = parcelRequire("ijOKP");

var $3z1Ay = parcelRequire("3z1Ay");

var $ijOKP = parcelRequire("ijOKP");
function $3d23504439aa8524$export$2e2bcd8739ae039(options, ...args) {
    return (0, $ijOKP.default)((0, $3z1Ay.default)({
        unstable_strictMode: true
    }, options), ...args);
}


let $17c504046cb9a64c$var$warnedOnce = false;
function $17c504046cb9a64c$export$2e2bcd8739ae039(styles) {
    if (!$17c504046cb9a64c$var$warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        $17c504046cb9a64c$var$warnedOnce = true;
    }
    return styles;
}


function $0d35ef8a52a98e99$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $0d35ef8a52a98e99$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $0d35ef8a52a98e99$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $0d35ef8a52a98e99$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $0d35ef8a52a98e99$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $8nd05 = parcelRequire("8nd05");

var $cpmCj = parcelRequire("cpmCj");

function $a7b09e624fa460c3$export$2e2bcd8739ae039(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = (0, $8nd05.default)({}, themeInput);
    theme.typography = (0, $8nd05.default)({}, theme.typography);
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $0d35ef8a52a98e99$export$ea1536a749e80563)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $0d35ef8a52a98e99$export$9623ad5dc13f2eaa)(lineHeight) && !disableAlign) throw new Error((0, $cpmCj.default)(6));
        if (!(0, $0d35ef8a52a98e99$export$9623ad5dc13f2eaa)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $0d35ef8a52a98e99$export$aec9aaffd8096b21)({
                size: value,
                grid: (0, $0d35ef8a52a98e99$export$63653082df276400)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = (0, $8nd05.default)({}, style, (0, $0d35ef8a52a98e99$export$26a139329f9dd721)({
            cssProperty: 'fontSize',
            min: minFontSize,
            max: maxFontSize,
            unit: 'rem',
            breakpoints: breakpointValues,
            transform: transform
        }));
    });
    return theme;
}



var $bmoVh = parcelRequire("bmoVh");


var $4FZD0 = parcelRequire("4FZD0");
function $414753394dff993c$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}



'use client';
function $568aba12ccdf91ea$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $414753394dff993c$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $48eb684ebe9272b4$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $568aba12ccdf91ea$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $jR9F1.default,
        themeId: (0, $4jPsi.default)
    });
}



var $d8seH = parcelRequire("d8seH");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $cc4c3bfd454df484$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $cc4c3bfd454df484$export$2e2bcd8739ae039 = $cc4c3bfd454df484$var$ThemeContext;



var $acw62 = parcelRequire("acw62");

function $429e068ad0a4eb17$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $cc4c3bfd454df484$export$2e2bcd8739ae039));
    return theme;
}


const $5a2e3fc1bffefb95$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $5a2e3fc1bffefb95$export$2e2bcd8739ae039 = $5a2e3fc1bffefb95$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $ayMG0 = parcelRequire("ayMG0");
function $ffbfb5c53e53b721$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $ffbfb5c53e53b721$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $429e068ad0a4eb17$export$2e2bcd8739ae039)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $ffbfb5c53e53b721$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $5a2e3fc1bffefb95$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc4c3bfd454df484$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $ffbfb5c53e53b721$export$2e2bcd8739ae039 = $ffbfb5c53e53b721$var$ThemeProvider;



parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");



var $3vMLS = parcelRequire("3vMLS");
parcelRequire("acw62");


parcelRequire("acw62");


var $aVZKi = parcelRequire("aVZKi");
var $5C8IU = parcelRequire("5C8IU");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $699894d3e78e9c81$var$wrapGlobalLayer(styles) {
    const serialized = (0, $5C8IU.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $699894d3e78e9c81$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $699894d3e78e9c81$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $699894d3e78e9c81$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $699894d3e78e9c81$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVZKi.default), {
        styles: globalStyles
    });
}
var $699894d3e78e9c81$export$2e2bcd8739ae039 = $699894d3e78e9c81$var$GlobalStyles;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $f69a16462c10cca0$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $3c4de721067b1c27$export$2e2bcd8739ae039)();
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $699894d3e78e9c81$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12433c9be3a4ac8d$var$EMPTY_THEME = {};
function $12433c9be3a4ac8d$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $8nd05.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $8nd05.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $8nd05.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $12433c9be3a4ac8d$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $3c4de721067b1c27$export$2e2bcd8739ae039)($12433c9be3a4ac8d$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $429e068ad0a4eb17$export$2e2bcd8739ae039)() || $12433c9be3a4ac8d$var$EMPTY_THEME;
    const engineTheme = $12433c9be3a4ac8d$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $12433c9be3a4ac8d$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $f69a16462c10cca0$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffbfb5c53e53b721$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $889f7a05097f3e52$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3vMLS.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $12433c9be3a4ac8d$export$2e2bcd8739ae039 = $12433c9be3a4ac8d$var$ThemeProvider;



var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c4650f6dac4940cb$var$_excluded = [
    "theme"
];
function $c4650f6dac4940cb$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $1En50.default)(_ref, $c4650f6dac4940cb$var$_excluded);
    const scopedTheme = themeInput[0, $4jPsi.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $8nd05.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $8nd05.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12433c9be3a4ac8d$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        themeId: scopedTheme ? (0, $4jPsi.default) : undefined,
        theme: finalTheme
    }));
}



var $cpmCj = parcelRequire("cpmCj");
function $f1ecc062bbad3379$export$2e2bcd8739ae039() {
    throw new Error((0, $cpmCj.default)(14));
}



var $cpmCj = parcelRequire("cpmCj");
function $015e9f5cd865f1ca$export$2e2bcd8739ae039() {
    throw new Error((0, $cpmCj.default)(15));
}



var $cpmCj = parcelRequire("cpmCj");
function $ffc685059eb0526f$export$2e2bcd8739ae039() {
    throw new Error((0, $cpmCj.default)(16));
}


var $aa64e0883cb2d190$exports = {};

$parcel$export($aa64e0883cb2d190$exports, "Experimental_CssVarsProvider", () => $aa64e0883cb2d190$export$99adf6d9ed169a14);
$parcel$export($aa64e0883cb2d190$exports, "useColorScheme", () => $aa64e0883cb2d190$export$6343629ee1b29116);
$parcel$export($aa64e0883cb2d190$exports, "getInitColorSchemeScript", () => $aa64e0883cb2d190$export$f9a57b4a2abf8ed);

var $8nd05 = parcelRequire("8nd05");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $3z1Ay = parcelRequire("3z1Ay");

var $aVZKi = parcelRequire("aVZKi");


/**
 * Split this component for RSC import
 */ parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $b34f26174ff1ab13$export$ff0fa3047d11164c = 'mode';
const $b34f26174ff1ab13$export$665054ea9d94dab9 = 'color-scheme';
const $b34f26174ff1ab13$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $b34f26174ff1ab13$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $b34f26174ff1ab13$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $b34f26174ff1ab13$export$665054ea9d94dab9, attribute: attribute = $b34f26174ff1ab13$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  var mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  var colorScheme = '';
  if (mode === 'system') {
    // handle system mode
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
    } else {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
    }
  }
  if (mode === 'light') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  }
  if (mode === 'dark') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  }
  if (colorScheme) {
    ${colorSchemeNode}.setAttribute('${attribute}', colorScheme);
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

'use client';
function $7bad4f7c7265e4f5$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $7bad4f7c7265e4f5$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $7bad4f7c7265e4f5$export$3caa7590cc1987bd(state) {
    return $7bad4f7c7265e4f5$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $7bad4f7c7265e4f5$var$initializeValue(key, defaultValue) {
    if (typeof window === 'undefined') return undefined;
    let value;
    try {
        value = localStorage.getItem(key) || undefined;
        if (!value) // the first time that user enters the site.
        localStorage.setItem(key, defaultValue);
    } catch (e) {
    // Unsupported
    }
    return value || defaultValue;
}
function $7bad4f7c7265e4f5$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $b34f26174ff1ab13$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $b34f26174ff1ab13$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const [state, setState] = $acw62.useState(()=>{
        const initialMode = $7bad4f7c7265e4f5$var$initializeValue(modeStorageKey, defaultMode);
        const lightColorScheme = $7bad4f7c7265e4f5$var$initializeValue(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
        const darkColorScheme = $7bad4f7c7265e4f5$var$initializeValue(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
        return {
            mode: initialMode,
            systemMode: $7bad4f7c7265e4f5$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const colorScheme = $7bad4f7c7265e4f5$export$3caa7590cc1987bd(state);
    const setMode = $acw62.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode != null ? mode : defaultMode;
            try {
                localStorage.setItem(modeStorageKey, newMode);
            } catch (e) {
            // Unsupported
            }
            return (0, $8nd05.default)({}, currentState, {
                mode: newMode,
                systemMode: $7bad4f7c7265e4f5$export$ab3d447356dfa3e5(newMode)
            });
        });
    }, [
        modeStorageKey,
        defaultMode
    ]);
    const setColorScheme = $acw62.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            try {
                localStorage.setItem(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
                localStorage.setItem(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
            } catch (e) {
            // Unsupported
            }
            return (0, $8nd05.default)({}, currentState, {
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            });
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = (0, $8nd05.default)({}, currentState);
                $7bad4f7c7265e4f5$var$processState(currentState, (mode)=>{
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-${mode}`, value);
                    } catch (e) {
                    // Unsupported
                    }
                    if (mode === 'light') newState.lightColorScheme = value;
                    if (mode === 'dark') newState.darkColorScheme = value;
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = (0, $8nd05.default)({}, currentState);
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-light`, newLightColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-dark`, newDarkColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        colorSchemeStorageKey,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $acw62.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event != null && event.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return (0, $8nd05.default)({}, currentState, {
                systemMode: systemMode
            });
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $acw62.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $acw62.useEffect(()=>{
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, []);
    // Handle when localStorage has changed
    $acw62.useEffect(()=>{
        if (storageWindow) {
            const handleStorage = (event)=>{
                const value = event.newValue;
                if (typeof event.key === 'string' && event.key.startsWith(colorSchemeStorageKey) && (!value || joinedColorSchemes.match(value))) {
                    // If the key is deleted, value will be null then reset color scheme to the default one.
                    if (event.key.endsWith('light')) setColorScheme({
                        light: value
                    });
                    if (event.key.endsWith('dark')) setColorScheme({
                        dark: value
                    });
                }
                if (event.key === modeStorageKey && (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value))) setMode(value || defaultMode);
            };
            // For syncing color-scheme changes between iframes
            storageWindow.addEventListener('storage', handleStorage);
            return ()=>{
                storageWindow.removeEventListener('storage', handleStorage);
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        modeStorageKey,
        colorSchemeStorageKey,
        joinedColorSchemes,
        defaultMode,
        storageWindow
    ]);
    return (0, $8nd05.default)({}, state, {
        colorScheme: colorScheme,
        setMode: setMode,
        setColorScheme: setColorScheme
    });
}



var $ayMG0 = parcelRequire("ayMG0");
const $8dd27611b958afb6$var$_excluded = [
    "colorSchemes",
    "components",
    "generateCssVars",
    "cssVarPrefix"
];
const $8dd27611b958afb6$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8dd27611b958afb6$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, attribute: defaultAttribute = (0, $b34f26174ff1ab13$export$14ebe5b26ee7fb38), modeStorageKey: defaultModeStorageKey = (0, $b34f26174ff1ab13$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $b34f26174ff1ab13$export$665054ea9d94dab9), defaultMode: designSystemMode = 'light', defaultColorScheme: designSystemColorScheme, disableTransitionOnChange: designSystemTransitionOnChange = false, resolveTheme: resolveTheme, excludeVariablesFromRoot: excludeVariablesFromRoot } = options;
    if (!defaultTheme.colorSchemes || typeof designSystemColorScheme === 'string' && !defaultTheme.colorSchemes[designSystemColorScheme] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.light] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.dark]) console.error(`MUI: \`${designSystemColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
    const ColorSchemeContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useColorScheme = ()=>{
        const value = $acw62.useContext(ColorSchemeContext);
        if (!value) throw new Error((0, $cpmCj.default)(19));
        return value;
    };
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp = defaultTheme, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, attribute: attribute = defaultAttribute, defaultMode: defaultMode = designSystemMode, defaultColorScheme: defaultColorScheme = designSystemColorScheme, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, colorSchemeSelector: colorSchemeSelector = ':root', disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false } = props;
        const hasMounted = $acw62.useRef(false);
        const upperTheme = (0, $429e068ad0a4eb17$export$2e2bcd8739ae039)();
        const ctx = $acw62.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const scopedTheme = themeProp[themeId];
        const _ref = scopedTheme || themeProp, { colorSchemes: colorSchemes = {}, components: components = {}, generateCssVars: generateCssVars = ()=>({
                vars: {},
                css: {}
            }), cssVarPrefix: cssVarPrefix } = _ref, restThemeProp = (0, $1En50.default)(_ref, $8dd27611b958afb6$var$_excluded);
        const allColorSchemes = Object.keys(colorSchemes);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $7bad4f7c7265e4f5$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageWindow: storageWindow
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const calculatedMode = (()=>{
            if (mode) return mode;
            // This scope occurs on the server
            if (defaultMode === 'system') return designSystemMode;
            return defaultMode;
        })();
        const calculatedColorScheme = (()=>{
            if (!colorScheme) {
                // This scope occurs on the server
                if (calculatedMode === 'dark') return defaultDarkColorScheme;
                // use light color scheme, if default mode is 'light' | 'system'
                return defaultLightColorScheme;
            }
            return colorScheme;
        })();
        // 2. Create CSS variables and store them in objects (to be generated in stylesheets in the final step)
        const { css: rootCss, vars: rootVars } = generateCssVars();
        // 3. Start composing the theme object
        const theme = (0, $8nd05.default)({}, restThemeProp, {
            components: components,
            colorSchemes: colorSchemes,
            cssVarPrefix: cssVarPrefix,
            vars: rootVars,
            getColorSchemeSelector: (targetColorScheme)=>`[${attribute}="${targetColorScheme}"] &`
        });
        // 4. Create color CSS variables and store them in objects (to be generated in stylesheets in the final step)
        //    The default color scheme stylesheet is constructed to have the least CSS specificity.
        //    The other color schemes uses selector, default as data attribute, to increase the CSS specificity so that they can override the default color scheme stylesheet.
        const defaultColorSchemeStyleSheet = {};
        const otherColorSchemesStyleSheet = {};
        Object.entries(colorSchemes).forEach(([key, scheme])=>{
            const { css: css, vars: vars } = generateCssVars(key);
            theme.vars = (0, $3z1Ay.default)(theme.vars, vars);
            if (key === calculatedColorScheme) {
                // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = (0, $8nd05.default)({}, theme[schemeKey], scheme[schemeKey]);
                    else theme[schemeKey] = scheme[schemeKey];
                });
                if (theme.palette) theme.palette.colorScheme = key;
            }
            const resolvedDefaultColorScheme = (()=>{
                if (typeof defaultColorScheme === 'string') return defaultColorScheme;
                if (defaultMode === 'dark') return defaultColorScheme.dark;
                return defaultColorScheme.light;
            })();
            if (key === resolvedDefaultColorScheme) {
                if (excludeVariablesFromRoot) {
                    const excludedVariables = {};
                    excludeVariablesFromRoot(cssVarPrefix).forEach((cssVar)=>{
                        excludedVariables[cssVar] = css[cssVar];
                        delete css[cssVar];
                    });
                    defaultColorSchemeStyleSheet[`[${attribute}="${key}"]`] = excludedVariables;
                }
                defaultColorSchemeStyleSheet[`${colorSchemeSelector}, [${attribute}="${key}"]`] = css;
            } else otherColorSchemesStyleSheet[`${colorSchemeSelector === ':root' ? '' : colorSchemeSelector}[${attribute}="${key}"]`] = css;
        });
        theme.vars = (0, $3z1Ay.default)(theme.vars, rootVars);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        $acw62.useEffect(()=>{
            if (colorScheme && colorSchemeNode) // attaches attribute to <html> because the css variables are attached to :root (html)
            colorSchemeNode.setAttribute(attribute, colorScheme);
        }, [
            colorScheme,
            attribute,
            colorSchemeNode
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $acw62.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8dd27611b958afb6$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $acw62.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $acw62.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || nested && (upperTheme == null ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVZKi.default), {
                            styles: {
                                [colorSchemeSelector]: rootCss
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVZKi.default), {
                            styles: defaultColorSchemeStyleSheet
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVZKi.default), {
                            styles: otherColorSchemesStyleSheet
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12433c9be3a4ac8d$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: resolveTheme ? resolveTheme(theme) : theme,
                    children: children
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.light;
    const defaultDarkColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $b34f26174ff1ab13$export$2e2bcd8739ae039)((0, $8nd05.default)({
            attribute: defaultAttribute,
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultMode: designSystemMode,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey
        }, params));
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $g91qR = parcelRequire("g91qR");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $86c68965abccb6a9$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}


var $8nd05 = parcelRequire("8nd05");
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}



var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $a8f9724956a5e42a$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $a8f9724956a5e42a$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $a8f9724956a5e42a$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().indexOf('opacity') >= 0) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $a8f9724956a5e42a$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $a8f9724956a5e42a$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                Object.assign(css, {
                    [cssVar]: $a8f9724956a5e42a$var$getCssValue(keys, value)
                });
                $a8f9724956a5e42a$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $a8f9724956a5e42a$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${value})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


const $fd7b2759a3ac0441$var$_excluded = [
    "colorSchemes",
    "components",
    "defaultColorScheme"
];
function $fd7b2759a3ac0441$var$prepareCssVars(theme, parserConfig) {
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, defaultColorScheme: defaultColorScheme = 'light' } = theme, otherTheme = (0, $1En50.default)(theme, $fd7b2759a3ac0441$var$_excluded);
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $a8f9724956a5e42a$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: light } = colorSchemes, otherColorSchemes = (0, $1En50.default)(colorSchemes, [
        defaultColorScheme
    ].map((0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)));
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $a8f9724956a5e42a$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (light) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $a8f9724956a5e42a$export$2e2bcd8739ae039)(light, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    const generateCssVars = (colorScheme)=>{
        var _parserConfig$getSele2;
        if (!colorScheme) {
            var _parserConfig$getSele;
            const css = (0, $8nd05.default)({}, rootCss);
            return {
                css: css,
                vars: rootVars,
                selector: (parserConfig == null || (_parserConfig$getSele = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele.call(parserConfig, colorScheme, css)) || ':root'
            };
        }
        const css = (0, $8nd05.default)({}, colorSchemesMap[colorScheme].css);
        return {
            css: css,
            vars: colorSchemesMap[colorScheme].vars,
            selector: (parserConfig == null || (_parserConfig$getSele2 = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele2.call(parserConfig, colorScheme, css)) || ':root'
        };
    };
    return {
        vars: themeVars,
        generateCssVars: generateCssVars
    };
}
var $fd7b2759a3ac0441$export$2e2bcd8739ae039 = $fd7b2759a3ac0441$var$prepareCssVars;



var $g91qR = parcelRequire("g91qR");
var $5iHq4 = parcelRequire("5iHq4");

var $kTdcz = parcelRequire("kTdcz");
function $b87504e8f71bd950$export$2e2bcd8739ae039(keys) {
    var _keys$;
    return !!keys[0].match(/(cssVarPrefix|modularCssLayers|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!((_keys$ = keys[1]) != null && _keys$.match(/(mode|contrastThreshold|tonalOffset)/));
}



var $ijOKP = parcelRequire("ijOKP");

const $9afe1ce524e8f62d$var$_excluded = [
    "colorSchemes",
    "cssVarPrefix",
    "shouldSkipGeneratingVar"
], $9afe1ce524e8f62d$var$_excluded2 = [
    "palette"
];
const $9afe1ce524e8f62d$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return undefined;
    const overlay = (0, $23fa506264c010ed$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $9afe1ce524e8f62d$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $9afe1ce524e8f62d$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $9afe1ce524e8f62d$var$toRgb(color) {
    if (!color || !color.startsWith('hsl')) return color;
    return (0, $kTdcz.hslToRgb)(color);
}
function $9afe1ce524e8f62d$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $kTdcz.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
const $9afe1ce524e8f62d$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $9afe1ce524e8f62d$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $86c68965abccb6a9$export$2e2bcd8739ae039)(cssVarPrefix);
function $9afe1ce524e8f62d$export$2e2bcd8739ae039(options = {}, ...args) {
    var _colorSchemesInput$li, _colorSchemesInput$da, _colorSchemesInput$li2, _colorSchemesInput$li3, _colorSchemesInput$da2, _colorSchemesInput$da3;
    const { colorSchemes: colorSchemesInput = {}, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $b87504e8f71bd950$export$2e2bcd8739ae039) } = options, input = (0, $1En50.default)(options, $9afe1ce524e8f62d$var$_excluded);
    const getCssVar = $9afe1ce524e8f62d$export$65418b4d9082cc44(cssVarPrefix);
    const _createThemeWithoutVa = (0, $ijOKP.default)((0, $8nd05.default)({}, input, colorSchemesInput.light && {
        palette: (_colorSchemesInput$li = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li.palette
    })), { palette: lightPalette } = _createThemeWithoutVa, muiTheme = (0, $1En50.default)(_createThemeWithoutVa, $9afe1ce524e8f62d$var$_excluded2);
    const { palette: darkPalette } = (0, $ijOKP.default)({
        palette: (0, $8nd05.default)({
            mode: 'dark'
        }, (_colorSchemesInput$da = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da.palette)
    });
    let theme = (0, $8nd05.default)({}, muiTheme, {
        cssVarPrefix: cssVarPrefix,
        getCssVar: getCssVar,
        colorSchemes: (0, $8nd05.default)({}, colorSchemesInput, {
            light: (0, $8nd05.default)({}, colorSchemesInput.light, {
                palette: lightPalette,
                opacity: (0, $8nd05.default)({
                    inputPlaceholder: 0.42,
                    inputUnderline: 0.42,
                    switchTrackDisabled: 0.12,
                    switchTrack: 0.38
                }, (_colorSchemesInput$li2 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li2.opacity),
                overlays: ((_colorSchemesInput$li3 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li3.overlays) || []
            }),
            dark: (0, $8nd05.default)({}, colorSchemesInput.dark, {
                palette: darkPalette,
                opacity: (0, $8nd05.default)({
                    inputPlaceholder: 0.5,
                    inputUnderline: 0.7,
                    switchTrackDisabled: 0.2,
                    switchTrack: 0.3
                }, (_colorSchemesInput$da2 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da2.opacity),
                overlays: ((_colorSchemesInput$da3 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da3.overlays) || $9afe1ce524e8f62d$var$defaultDarkOverlays
            })
        })
    });
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (key === 'light') {
            $9afe1ce524e8f62d$var$setColor(palette.common, 'background', '#fff');
            $9afe1ce524e8f62d$var$setColor(palette.common, 'onBackground', '#000');
        } else {
            $9afe1ce524e8f62d$var$setColor(palette.common, 'background', '#000');
            $9afe1ce524e8f62d$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $9afe1ce524e8f62d$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (key === 'light') {
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorColor', (0, $kTdcz.private_safeDarken)(palette.error.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoColor', (0, $kTdcz.private_safeDarken)(palette.info.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successColor', (0, $kTdcz.private_safeDarken)(palette.success.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningColor', (0, $kTdcz.private_safeDarken)(palette.warning.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.error.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.info.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.success.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.warning.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorStandardBg', (0, $kTdcz.private_safeLighten)(palette.error.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoStandardBg', (0, $kTdcz.private_safeLighten)(palette.info.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successStandardBg', (0, $kTdcz.private_safeLighten)(palette.success.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningStandardBg', (0, $kTdcz.private_safeLighten)(palette.warning.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $9afe1ce524e8f62d$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'primaryBg', (0, $kTdcz.private_safeLighten)(palette.primary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $kTdcz.private_safeLighten)(palette.secondary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'errorBg', (0, $kTdcz.private_safeLighten)(palette.error.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'infoBg', (0, $kTdcz.private_safeLighten)(palette.info.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'successBg', (0, $kTdcz.private_safeLighten)(palette.success.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'warningBg', (0, $kTdcz.private_safeLighten)(palette.warning.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'primaryTrack', (0, $kTdcz.private_safeLighten)(palette.primary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'secondaryTrack', (0, $kTdcz.private_safeLighten)(palette.secondary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'errorTrack', (0, $kTdcz.private_safeLighten)(palette.error.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'infoTrack', (0, $kTdcz.private_safeLighten)(palette.info.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'successTrack', (0, $kTdcz.private_safeLighten)(palette.success.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'warningTrack', (0, $kTdcz.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $kTdcz.private_safeEmphasize)(palette.background.default, 0.8);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'color', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(snackbarContentBackground)));
            $9afe1ce524e8f62d$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $kTdcz.private_safeEmphasize)(palette.background.paper, 0.15));
            $9afe1ce524e8f62d$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $kTdcz.private_safeLighten)(palette.primary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $kTdcz.private_safeLighten)(palette.secondary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'errorDisabledColor', (0, $kTdcz.private_safeLighten)(palette.error.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'infoDisabledColor', (0, $kTdcz.private_safeLighten)(palette.info.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'successDisabledColor', (0, $kTdcz.private_safeLighten)(palette.success.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'warningDisabledColor', (0, $kTdcz.private_safeLighten)(palette.warning.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.TableCell, 'border', (0, $kTdcz.private_safeLighten)((0, $kTdcz.private_safeAlpha)(palette.divider, 1), 0.88));
            $9afe1ce524e8f62d$var$setColor(palette.Tooltip, 'bg', (0, $kTdcz.private_safeAlpha)(palette.grey[700], 0.92));
        } else {
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorColor', (0, $kTdcz.private_safeLighten)(palette.error.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoColor', (0, $kTdcz.private_safeLighten)(palette.info.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successColor', (0, $kTdcz.private_safeLighten)(palette.success.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningColor', (0, $kTdcz.private_safeLighten)(palette.warning.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.error.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.info.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.success.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.warning.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorStandardBg', (0, $kTdcz.private_safeDarken)(palette.error.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoStandardBg', (0, $kTdcz.private_safeDarken)(palette.info.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successStandardBg', (0, $kTdcz.private_safeDarken)(palette.success.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningStandardBg', (0, $kTdcz.private_safeDarken)(palette.warning.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $9afe1ce524e8f62d$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'primaryBg', (0, $kTdcz.private_safeDarken)(palette.primary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $kTdcz.private_safeDarken)(palette.secondary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'errorBg', (0, $kTdcz.private_safeDarken)(palette.error.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'infoBg', (0, $kTdcz.private_safeDarken)(palette.info.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'successBg', (0, $kTdcz.private_safeDarken)(palette.success.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'warningBg', (0, $kTdcz.private_safeDarken)(palette.warning.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'primaryTrack', (0, $kTdcz.private_safeDarken)(palette.primary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'secondaryTrack', (0, $kTdcz.private_safeDarken)(palette.secondary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'errorTrack', (0, $kTdcz.private_safeDarken)(palette.error.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'infoTrack', (0, $kTdcz.private_safeDarken)(palette.info.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'successTrack', (0, $kTdcz.private_safeDarken)(palette.success.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'warningTrack', (0, $kTdcz.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $kTdcz.private_safeEmphasize)(palette.background.default, 0.98);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'color', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(snackbarContentBackground)));
            $9afe1ce524e8f62d$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $kTdcz.private_safeEmphasize)(palette.background.paper, 0.15));
            $9afe1ce524e8f62d$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $kTdcz.private_safeDarken)(palette.primary.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $kTdcz.private_safeDarken)(palette.secondary.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'errorDisabledColor', (0, $kTdcz.private_safeDarken)(palette.error.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'infoDisabledColor', (0, $kTdcz.private_safeDarken)(palette.info.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'successDisabledColor', (0, $kTdcz.private_safeDarken)(palette.success.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'warningDisabledColor', (0, $kTdcz.private_safeDarken)(palette.warning.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.TableCell, 'border', (0, $kTdcz.private_safeDarken)((0, $kTdcz.private_safeAlpha)(palette.divider, 1), 0.68));
            $9afe1ce524e8f62d$var$setColor(palette.Tooltip, 'bg', (0, $kTdcz.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $9afe1ce524e8f62d$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $9afe1ce524e8f62d$var$setColorChannel(palette.background, 'paper');
        $9afe1ce524e8f62d$var$setColorChannel(palette.common, 'background');
        $9afe1ce524e8f62d$var$setColorChannel(palette.common, 'onBackground');
        $9afe1ce524e8f62d$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $9afe1ce524e8f62d$var$setColor(palette[color], 'mainChannel', (0, $kTdcz.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.main)));
                if (colors.light) $9afe1ce524e8f62d$var$setColor(palette[color], 'lightChannel', (0, $kTdcz.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.light)));
                if (colors.dark) $9afe1ce524e8f62d$var$setColor(palette[color], 'darkChannel', (0, $kTdcz.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.dark)));
                if (colors.contrastText) $9afe1ce524e8f62d$var$setColor(palette[color], 'contrastTextChannel', (0, $kTdcz.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'primary');
                    $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar
    };
    const { vars: themeVars, generateCssVars: generateCssVars } = (0, $fd7b2759a3ac0441$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = themeVars;
    theme.generateCssVars = generateCssVars;
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $5iHq4.default), input == null ? void 0 : input.unstable_sxConfig);
    theme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    return theme;
}



var $d6q8u = parcelRequire("d6q8u");
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultMode="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(24)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index + 1}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$export$2e2bcd8739ae039 = $f1b759b2363a287f$var$excludeVariablesFromRoot;



var $4jPsi = parcelRequire("4jPsi");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $2b983880bbf899cb$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b34f26174ff1ab13$export$2e2bcd8739ae039), (0, $8nd05.default)({}, $2b983880bbf899cb$export$f84bd70098573c5c, props));
};


'use client';
const $aa64e0883cb2d190$var$defaultTheme = (0, $9afe1ce524e8f62d$export$2e2bcd8739ae039)();
const { CssVarsProvider: $aa64e0883cb2d190$export$99adf6d9ed169a14, useColorScheme: $aa64e0883cb2d190$export$6343629ee1b29116, getInitColorSchemeScript: $aa64e0883cb2d190$var$getInitColorSchemeScriptSystem } = (0, $8dd27611b958afb6$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    theme: $aa64e0883cb2d190$var$defaultTheme,
    attribute: (0, $2b983880bbf899cb$export$f84bd70098573c5c).attribute,
    colorSchemeStorageKey: (0, $2b983880bbf899cb$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $2b983880bbf899cb$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $2b983880bbf899cb$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $2b983880bbf899cb$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = (0, $8nd05.default)({}, theme, {
            typography: (0, $d6q8u.default)(theme.palette, theme.typography)
        });
        newTheme.unstable_sx = function sx(props) {
            return (0, $g91qR.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    },
    excludeVariablesFromRoot: $f1b759b2363a287f$export$2e2bcd8739ae039
});
const $aa64e0883cb2d190$export$f9a57b4a2abf8ed = $aa64e0883cb2d190$var$getInitColorSchemeScriptSystem;






var $d6q8u = parcelRequire("d6q8u");

var $6plKN = parcelRequire("6plKN");

'use client';
function $019ad789c5f8c324$export$c593505552bdf13d() {
    throw new Error((0, $cpmCj.default)(20));
}
$parcel$exportWildcard($019ad789c5f8c324$exports, $aa64e0883cb2d190$exports);


var $ce0e2c401cd11493$exports = {};

$parcel$export($ce0e2c401cd11493$exports, "unstable_ClassNameGenerator", () => $ce0e2c401cd11493$export$22e3098d13d616cd);
$parcel$export($ce0e2c401cd11493$exports, "capitalize", () => (parcelRequire("jTnBY")).default);
$parcel$export($ce0e2c401cd11493$exports, "createChainedFunction", () => $3d47321b9fcbcb38$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "createSvgIcon", () => (parcelRequire("bbT5Q")).default);
$parcel$export($ce0e2c401cd11493$exports, "debounce", () => $0f2866359d6621f3$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "deprecatedPropType", () => $c2d0a44fb35b2388$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "isMuiElement", () => $90a633ad7a979daa$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "ownerDocument", () => $c10afe25107351d9$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "ownerWindow", () => $707049eb9639aeac$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "requirePropFactory", () => $2dbb80310490cb08$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "setRef", () => $a450c11ad3ab84fa$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "unstable_useEnhancedEffect", () => $ec346974df496fc5$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "unstable_useId", () => $4105219ee6538ed1$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "unsupportedProp", () => $c4fda44a4aac44a5$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "useControlled", () => $295ecbe78b5bad73$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "useEventCallback", () => $331f3746e6346411$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "useForkRef", () => $72d5a979b2ad8bc9$export$2e2bcd8739ae039);
$parcel$export($ce0e2c401cd11493$exports, "useIsFocusVisible", () => $8fc8239a3939454e$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");

var $jTnBY = parcelRequire("jTnBY");

var $3d47321b9fcbcb38$export$2e2bcd8739ae039 = (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);



var $bbT5Q = parcelRequire("bbT5Q");

function $90f26ab63f2d7846$export$2e2bcd8739ae039(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}


var $c2d0a44fb35b2388$export$2e2bcd8739ae039 = (0, $90f26ab63f2d7846$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $37dfa52af4926933$export$2e2bcd8739ae039);




parcelRequire("8nd05");
function $239028b4b362607b$export$2e2bcd8739ae039(componentNameInError, Component) {
    return ()=>null;
}


var $2dbb80310490cb08$export$2e2bcd8739ae039 = (0, $239028b4b362607b$export$2e2bcd8739ae039);



var $a450c11ad3ab84fa$export$2e2bcd8739ae039 = (0, $c8b9145416f64bb2$export$2e2bcd8739ae039);




function $bbb247058ab0d5dc$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    return null;
}


var $c4fda44a4aac44a5$export$2e2bcd8739ae039 = (0, $bbb247058ab0d5dc$export$2e2bcd8739ae039);






'use client';
const $ce0e2c401cd11493$export$22e3098d13d616cd = {
    configure: (generator)=>{
        (0, $bnost.default).configure(generator);
    }
};


var $fcaee2cf9d6d9c3f$exports = {};

$parcel$defineInteropFlag($fcaee2cf9d6d9c3f$exports);

$parcel$export($fcaee2cf9d6d9c3f$exports, "default", () => $5c228c234852d575$export$2e2bcd8739ae039);
$parcel$export($fcaee2cf9d6d9c3f$exports, "accordionClasses", () => $e14e8c767477d992$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");





var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $bmoVh = parcelRequire("bmoVh");



var $247ae09dccc3464c$exports = {};

$parcel$defineInteropFlag($247ae09dccc3464c$exports);

$parcel$export($247ae09dccc3464c$exports, "getCollapseUtilityClass", () => $247ae09dccc3464c$export$5162da8f798e0959);
$parcel$export($247ae09dccc3464c$exports, "default", () => $247ae09dccc3464c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $247ae09dccc3464c$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $beCSm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$export$2e2bcd8739ae039 = $247ae09dccc3464c$var$collapseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $848dc8709a4309c5$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $247ae09dccc3464c$export$5162da8f798e0959), classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $8nd05.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $bmoVh.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $848dc8709a4309c5$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseRoot, (0, $8nd05.default)({
                as: component,
                className: (0, $9QePP.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $8nd05.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $8nd05.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapper, {
                    ownerState: (0, $8nd05.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapperInner, {
                        ownerState: (0, $8nd05.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$export$2e2bcd8739ae039 = $848dc8709a4309c5$var$Collapse;




var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
var $5bbfcb95732dc207$export$2e2bcd8739ae039 = $5bbfcb95732dc207$var$AccordionContext;




var $e14e8c767477d992$exports = {};

$parcel$defineInteropFlag($e14e8c767477d992$exports);

$parcel$export($e14e8c767477d992$exports, "getAccordionUtilityClass", () => $e14e8c767477d992$export$80fb6a2cb3f13b8b);
$parcel$export($e14e8c767477d992$exports, "default", () => $e14e8c767477d992$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e14e8c767477d992$export$80fb6a2cb3f13b8b(slot) {
    return (0, $4Cod0.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $beCSm.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$export$2e2bcd8739ae039 = $e14e8c767477d992$var$accordionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5c228c234852d575$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e14e8c767477d992$export$80fb6a2cb3f13b8b), classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e14e8c767477d992$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $1En50.default)(props, $5c228c234852d575$var$_excluded);
    const [expanded, setExpandedState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $8nd05.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $8nd05.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $848dc8709a4309c5$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5c228c234852d575$var$AccordionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bbfcb95732dc207$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, (0, $8nd05.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $5c228c234852d575$export$2e2bcd8739ae039 = $5c228c234852d575$var$Accordion;



$parcel$exportWildcard($fcaee2cf9d6d9c3f$exports, $e14e8c767477d992$exports);


var $04f1b704f2eaef84$exports = {};

$parcel$defineInteropFlag($04f1b704f2eaef84$exports);

$parcel$export($04f1b704f2eaef84$exports, "default", () => $3c271b1069b6d28c$export$2e2bcd8739ae039);
$parcel$export($04f1b704f2eaef84$exports, "accordionActionsClasses", () => $33049b15cd6d3df2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $33049b15cd6d3df2$exports = {};

$parcel$defineInteropFlag($33049b15cd6d3df2$exports);

$parcel$export($33049b15cd6d3df2$exports, "getAccordionActionsUtilityClass", () => $33049b15cd6d3df2$export$ea58cae7d9e3c1b0);
$parcel$export($33049b15cd6d3df2$exports, "default", () => $33049b15cd6d3df2$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $33049b15cd6d3df2$export$ea58cae7d9e3c1b0(slot) {
    return (0, $4Cod0.default)('MuiAccordionActions', slot);
}
const $33049b15cd6d3df2$var$accordionActionsClasses = (0, $beCSm.default)('MuiAccordionActions', [
    'root',
    'spacing'
]);
var $33049b15cd6d3df2$export$2e2bcd8739ae039 = $33049b15cd6d3df2$var$accordionActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3c271b1069b6d28c$var$_excluded = [
    "className",
    "disableSpacing"
];
const $3c271b1069b6d28c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $33049b15cd6d3df2$export$ea58cae7d9e3c1b0), classes);
};
const $3c271b1069b6d28c$var$AccordionActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiAccordionActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    variants: [
        {
            props: (props)=>!props.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $3c271b1069b6d28c$var$AccordionActions = /*#__PURE__*/ $acw62.forwardRef(function AccordionActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1En50.default)(props, $3c271b1069b6d28c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $3c271b1069b6d28c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3c271b1069b6d28c$var$AccordionActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $3c271b1069b6d28c$export$2e2bcd8739ae039 = $3c271b1069b6d28c$var$AccordionActions;



$parcel$exportWildcard($04f1b704f2eaef84$exports, $33049b15cd6d3df2$exports);


var $a422e3223044b655$exports = {};

$parcel$defineInteropFlag($a422e3223044b655$exports);

$parcel$export($a422e3223044b655$exports, "default", () => $1b78273c1c27a2e1$export$2e2bcd8739ae039);
$parcel$export($a422e3223044b655$exports, "accordionDetailsClasses", () => $6e4b72c3145e33d8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $6e4b72c3145e33d8$exports = {};

$parcel$defineInteropFlag($6e4b72c3145e33d8$exports);

$parcel$export($6e4b72c3145e33d8$exports, "getAccordionDetailsUtilityClass", () => $6e4b72c3145e33d8$export$a6afb527becfac26);
$parcel$export($6e4b72c3145e33d8$exports, "default", () => $6e4b72c3145e33d8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4b72c3145e33d8$export$a6afb527becfac26(slot) {
    return (0, $4Cod0.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $beCSm.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$export$2e2bcd8739ae039 = $6e4b72c3145e33d8$var$accordionDetailsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1b78273c1c27a2e1$var$_excluded = [
    "className"
];
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6e4b72c3145e33d8$export$a6afb527becfac26), classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $d8seH.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $1b78273c1c27a2e1$var$_excluded);
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $1b78273c1c27a2e1$export$2e2bcd8739ae039 = $1b78273c1c27a2e1$var$AccordionDetails;



$parcel$exportWildcard($a422e3223044b655$exports, $6e4b72c3145e33d8$exports);


var $4fb16a516036be86$exports = {};

$parcel$defineInteropFlag($4fb16a516036be86$exports);

$parcel$export($4fb16a516036be86$exports, "default", () => $1a792f5a0c37e2ab$export$2e2bcd8739ae039);
$parcel$export($4fb16a516036be86$exports, "accordionSummaryClasses", () => $d55ba52db43b55df$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $d55ba52db43b55df$exports = {};

$parcel$defineInteropFlag($d55ba52db43b55df$exports);

$parcel$export($d55ba52db43b55df$exports, "getAccordionSummaryUtilityClass", () => $d55ba52db43b55df$export$282216ad123d6580);
$parcel$export($d55ba52db43b55df$exports, "default", () => $d55ba52db43b55df$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d55ba52db43b55df$export$282216ad123d6580(slot) {
    return (0, $4Cod0.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $beCSm.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$export$2e2bcd8739ae039 = $d55ba52db43b55df$var$accordionSummaryClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a792f5a0c37e2ab$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d55ba52db43b55df$export$282216ad123d6580), classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $1En50.default)(props, $1a792f5a0c37e2ab$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $5bbfcb95732dc207$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a792f5a0c37e2ab$var$AccordionSummaryRoot, (0, $8nd05.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $9QePP.default)(classes.root, className),
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $1a792f5a0c37e2ab$export$2e2bcd8739ae039 = $1a792f5a0c37e2ab$var$AccordionSummary;



$parcel$exportWildcard($4fb16a516036be86$exports, $d55ba52db43b55df$exports);


var $0cdfa98b6f9a20c7$exports = {};

$parcel$defineInteropFlag($0cdfa98b6f9a20c7$exports);

$parcel$export($0cdfa98b6f9a20c7$exports, "default", () => $d7b9f0ef25189a24$export$2e2bcd8739ae039);
$parcel$export($0cdfa98b6f9a20c7$exports, "alertClasses", () => $1da0e229d53b4459$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");

var $1da0e229d53b4459$exports = {};

$parcel$defineInteropFlag($1da0e229d53b4459$exports);

$parcel$export($1da0e229d53b4459$exports, "getAlertUtilityClass", () => $1da0e229d53b4459$export$69aecd24bc2cf7e3);
$parcel$export($1da0e229d53b4459$exports, "default", () => $1da0e229d53b4459$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $beCSm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;



parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d7b9f0ef25189a24$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color || severity)}`,
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1da0e229d53b4459$export$69aecd24bc2cf7e3), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $kTdcz.darken) : (0, $kTdcz.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $kTdcz.lighten) : (0, $kTdcz.darken);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $8nd05.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eec239707c48bf2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $611e456547a52fc7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7987087272cca1$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76204164d2201318$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $d7b9f0ef25189a24$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $8nd05.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $8nd05.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $71c322247f7fbf93$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $f7280bbf95507cba$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d7b9f0ef25189a24$var$AlertRoot, (0, $8nd05.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, (0, $8nd05.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, (0, $8nd05.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;



'use client';
$parcel$exportWildcard($0cdfa98b6f9a20c7$exports, $1da0e229d53b4459$exports);


var $83f1cec610e0702c$exports = {};

$parcel$defineInteropFlag($83f1cec610e0702c$exports);

$parcel$export($83f1cec610e0702c$exports, "default", () => $cbe9496169f0560d$export$2e2bcd8739ae039);
$parcel$export($83f1cec610e0702c$exports, "alertTitleClasses", () => $938b1427b9e9a19f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $938b1427b9e9a19f$exports = {};

$parcel$defineInteropFlag($938b1427b9e9a19f$exports);

$parcel$export($938b1427b9e9a19f$exports, "getAlertTitleUtilityClass", () => $938b1427b9e9a19f$export$5269a5bce2c2f987);
$parcel$export($938b1427b9e9a19f$exports, "default", () => $938b1427b9e9a19f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $938b1427b9e9a19f$export$5269a5bce2c2f987(slot) {
    return (0, $4Cod0.default)('MuiAlertTitle', slot);
}
const $938b1427b9e9a19f$var$alertTitleClasses = (0, $beCSm.default)('MuiAlertTitle', [
    'root'
]);
var $938b1427b9e9a19f$export$2e2bcd8739ae039 = $938b1427b9e9a19f$var$alertTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $cbe9496169f0560d$var$_excluded = [
    "className"
];
const $cbe9496169f0560d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $938b1427b9e9a19f$export$5269a5bce2c2f987), classes);
};
const $cbe9496169f0560d$var$AlertTitleRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiAlertTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $cbe9496169f0560d$var$AlertTitle = /*#__PURE__*/ $acw62.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $cbe9496169f0560d$var$_excluded);
    const ownerState = props;
    const classes = $cbe9496169f0560d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cbe9496169f0560d$var$AlertTitleRoot, (0, $8nd05.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $cbe9496169f0560d$export$2e2bcd8739ae039 = $cbe9496169f0560d$var$AlertTitle;



'use client';
$parcel$exportWildcard($83f1cec610e0702c$exports, $938b1427b9e9a19f$exports);


var $eed1534592dd796b$exports = {};

$parcel$defineInteropFlag($eed1534592dd796b$exports);

$parcel$export($eed1534592dd796b$exports, "default", () => $37a342382669398e$export$2e2bcd8739ae039);
$parcel$export($eed1534592dd796b$exports, "appBarClasses", () => $4828cb1f30b841b0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $4828cb1f30b841b0$exports = {};

$parcel$defineInteropFlag($4828cb1f30b841b0$exports);

$parcel$export($4828cb1f30b841b0$exports, "getAppBarUtilityClass", () => $4828cb1f30b841b0$export$47a2da616e55e8e9);
$parcel$export($4828cb1f30b841b0$exports, "default", () => $4828cb1f30b841b0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4828cb1f30b841b0$export$47a2da616e55e8e9(slot) {
    return (0, $4Cod0.default)('MuiAppBar', slot);
}
const $4828cb1f30b841b0$var$appBarClasses = (0, $beCSm.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $4828cb1f30b841b0$export$2e2bcd8739ae039 = $4828cb1f30b841b0$var$appBarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $37a342382669398e$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $37a342382669398e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            `position${(0, $jTnBY.default)(position)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4828cb1f30b841b0$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $37a342382669398e$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $37a342382669398e$var$AppBarRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $8nd05.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $8nd05.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $8nd05.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $37a342382669398e$var$AppBar = /*#__PURE__*/ $acw62.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $1En50.default)(props, $37a342382669398e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $37a342382669398e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($37a342382669398e$var$AppBarRoot, (0, $8nd05.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $9QePP.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $37a342382669398e$export$2e2bcd8739ae039 = $37a342382669398e$var$AppBar;



'use client';
$parcel$exportWildcard($eed1534592dd796b$exports, $4828cb1f30b841b0$exports);


var $7b8a1da92f713a60$exports = {};

$parcel$defineInteropFlag($7b8a1da92f713a60$exports);

$parcel$export($7b8a1da92f713a60$exports, "default", () => $9396253983985262$export$2e2bcd8739ae039);
$parcel$export($7b8a1da92f713a60$exports, "createFilterOptions", () => $23a03a376a300fc5$export$f76f94b238d946d8);
$parcel$export($7b8a1da92f713a60$exports, "autocompleteClasses", () => $723a67e53eb4dc4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $23a03a376a300fc5$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $23a03a376a300fc5$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $23a03a376a300fc5$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $23a03a376a300fc5$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $23a03a376a300fc5$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $8nd05.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $8nd05.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");
var $d7f4cf29715b69dd$exports = {};

$parcel$defineInteropFlag($d7f4cf29715b69dd$exports);

$parcel$export($d7f4cf29715b69dd$exports, "getListSubheaderUtilityClass", () => $d7f4cf29715b69dd$export$6816d4fc0981ec7);
$parcel$export($d7f4cf29715b69dd$exports, "default", () => $d7f4cf29715b69dd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5408b2039b9d572c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d7f4cf29715b69dd$export$6816d4fc0981ec7), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $1En50.default)(props, $5408b2039b9d572c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;





var $80c774dd7f29b734$exports = {};

$parcel$defineInteropFlag($80c774dd7f29b734$exports);

$parcel$export($80c774dd7f29b734$exports, "getInputUtilityClass", () => $80c774dd7f29b734$export$cdb270390122322b);
$parcel$export($80c774dd7f29b734$exports, "default", () => $80c774dd7f29b734$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
var $9b9dde6aa920e08c$exports = {};

$parcel$defineInteropFlag($9b9dde6aa920e08c$exports);

$parcel$export($9b9dde6aa920e08c$exports, "getInputBaseUtilityClass", () => $9b9dde6aa920e08c$export$ef57d5c8ca2278f6);
$parcel$export($9b9dde6aa920e08c$exports, "default", () => $9b9dde6aa920e08c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;


function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;



var $6a1dc6d1d7e1816a$exports = {};

$parcel$defineInteropFlag($6a1dc6d1d7e1816a$exports);

$parcel$export($6a1dc6d1d7e1816a$exports, "getOutlinedInputUtilityClass", () => $6a1dc6d1d7e1816a$export$89922944c7227687);
$parcel$export($6a1dc6d1d7e1816a$exports, "default", () => $6a1dc6d1d7e1816a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;


var $b0b42157daacd8b1$exports = {};

$parcel$defineInteropFlag($b0b42157daacd8b1$exports);

$parcel$export($b0b42157daacd8b1$exports, "getFilledInputUtilityClass", () => $b0b42157daacd8b1$export$3331e419f1a48437);
$parcel$export($b0b42157daacd8b1$exports, "default", () => $b0b42157daacd8b1$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;



parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $723a67e53eb4dc4c$exports = {};

$parcel$defineInteropFlag($723a67e53eb4dc4c$exports);

$parcel$export($723a67e53eb4dc4c$exports, "getAutocompleteUtilityClass", () => $723a67e53eb4dc4c$export$8ee01529667e66d9);
$parcel$export($723a67e53eb4dc4c$exports, "default", () => $723a67e53eb4dc4c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;



var $jTnBY = parcelRequire("jTnBY");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $9396253983985262$var$_excluded2 = [
    "ref"
], $9396253983985262$var$_excluded3 = [
    "key"
], $9396253983985262$var$_excluded4 = [
    "key"
];
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $723a67e53eb4dc4c$export$8ee01529667e66d9), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused} .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $8nd05.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $5408b2039b9d572c$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7280bbf95507cba$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $a4669aa090d445bd$export$2e2bcd8739ae039), popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $9396253983985262$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $23a03a376a300fc5$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $1En50.default)(_getListboxProps, $9396253983985262$var$_excluded2);
    const combinedListboxRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $8nd05.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $8nd05.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $1En50.default)(_getCustomizedTagProp, $9396253983985262$var$_excluded3);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), (0, $8nd05.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $1En50.default)(props2, $9396253983985262$var$_excluded4);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", (0, $8nd05.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $8nd05.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, (0, $8nd05.default)({
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $8nd05.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, (0, $8nd05.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, (0, $8nd05.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $8nd05.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, (0, $8nd05.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $9QePP.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, (0, $8nd05.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $9QePP.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteListbox, (0, $8nd05.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;



'use client';
$parcel$exportWildcard($7b8a1da92f713a60$exports, $723a67e53eb4dc4c$exports);


var $edb1abe77b6ce3b3$exports = {};

$parcel$defineInteropFlag($edb1abe77b6ce3b3$exports);

$parcel$export($edb1abe77b6ce3b3$exports, "default", () => $1894f4268467302e$export$2e2bcd8739ae039);
$parcel$export($edb1abe77b6ce3b3$exports, "avatarClasses", () => $478fe5b437ab8d6f$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($edb1abe77b6ce3b3$exports, $478fe5b437ab8d6f$exports);


var $7cacdf50dce7d54d$exports = {};

$parcel$defineInteropFlag($7cacdf50dce7d54d$exports);

$parcel$export($7cacdf50dce7d54d$exports, "default", () => $70229258f609d599$export$2e2bcd8739ae039);
$parcel$export($7cacdf50dce7d54d$exports, "avatarGroupClasses", () => $d980bd9c21d06ae1$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $d980bd9c21d06ae1$exports = {};

$parcel$defineInteropFlag($d980bd9c21d06ae1$exports);

$parcel$export($d980bd9c21d06ae1$exports, "getAvatarGroupUtilityClass", () => $d980bd9c21d06ae1$export$e278541d928aee3a);
$parcel$export($d980bd9c21d06ae1$exports, "default", () => $d980bd9c21d06ae1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d980bd9c21d06ae1$export$e278541d928aee3a(slot) {
    return (0, $4Cod0.default)('MuiAvatarGroup', slot);
}
const $d980bd9c21d06ae1$var$avatarGroupClasses = (0, $beCSm.default)('MuiAvatarGroup', [
    'root',
    'avatar'
]);
var $d980bd9c21d06ae1$export$2e2bcd8739ae039 = $d980bd9c21d06ae1$var$avatarGroupClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $70229258f609d599$var$_excluded = [
    "children",
    "className",
    "component",
    "componentsProps",
    "max",
    "renderSurplus",
    "slotProps",
    "spacing",
    "total",
    "variant"
];
const $70229258f609d599$var$SPACINGS = {
    small: -16,
    medium: null
};
const $70229258f609d599$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d980bd9c21d06ae1$export$e278541d928aee3a), classes);
};
const $70229258f609d599$var$AvatarGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiAvatarGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $d980bd9c21d06ae1$export$2e2bcd8739ae039).avatar}`]: styles.avatar
        }, styles.root)
})(({ theme: theme, ownerState: ownerState })=>{
    const marginValue = ownerState.spacing && $70229258f609d599$var$SPACINGS[ownerState.spacing] !== undefined ? $70229258f609d599$var$SPACINGS[ownerState.spacing] : -ownerState.spacing;
    return {
        [`& .${(0, $478fe5b437ab8d6f$export$2e2bcd8739ae039).root}`]: {
            border: `2px solid ${(theme.vars || theme).palette.background.default}`,
            boxSizing: 'content-box',
            marginLeft: marginValue != null ? marginValue : -8,
            '&:last-child': {
                marginLeft: 0
            }
        },
        display: 'flex',
        flexDirection: 'row-reverse'
    };
});
const $70229258f609d599$var$AvatarGroup = /*#__PURE__*/ $acw62.forwardRef(function AvatarGroup(inProps, ref) {
    var _slotProps$additional;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatarGroup'
    });
    const { children: childrenProp, className: className, component: component = 'div', componentsProps: componentsProps = {}, max: max = 5, renderSurplus: renderSurplus, slotProps: slotProps = {}, spacing: spacing = 'medium', total: total, variant: variant = 'circular' } = props, other = (0, $1En50.default)(props, $70229258f609d599$var$_excluded);
    let clampedMax = max < 2 ? 2 : max;
    const ownerState = (0, $8nd05.default)({}, props, {
        max: max,
        spacing: spacing,
        component: component,
        variant: variant
    });
    const classes = $70229258f609d599$var$useUtilityClasses(ownerState);
    const children = $acw62.Children.toArray(childrenProp).filter((child)=>{
        return /*#__PURE__*/ $acw62.isValidElement(child);
    });
    const totalAvatars = total || children.length;
    if (totalAvatars === clampedMax) clampedMax += 1;
    clampedMax = Math.min(totalAvatars + 1, clampedMax);
    const maxAvatars = Math.min(children.length, clampedMax - 1);
    const extraAvatars = Math.max(totalAvatars - clampedMax, totalAvatars - maxAvatars, 0);
    const extraAvatarsElement = renderSurplus ? renderSurplus(extraAvatars) : `+${extraAvatars}`;
    const additionalAvatarSlotProps = (_slotProps$additional = slotProps.additionalAvatar) != null ? _slotProps$additional : componentsProps.additionalAvatar;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($70229258f609d599$var$AvatarGroupRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            extraAvatars ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), (0, $8nd05.default)({
                variant: variant
            }, additionalAvatarSlotProps, {
                className: (0, $9QePP.default)(classes.avatar, additionalAvatarSlotProps == null ? void 0 : additionalAvatarSlotProps.className),
                children: extraAvatarsElement
            })) : null,
            children.slice(0, maxAvatars).reverse().map((child)=>{
                return /*#__PURE__*/ $acw62.cloneElement(child, {
                    className: (0, $9QePP.default)(child.props.className, classes.avatar),
                    variant: child.props.variant || variant
                });
            })
        ]
    }));
});
var $70229258f609d599$export$2e2bcd8739ae039 = $70229258f609d599$var$AvatarGroup;



'use client';
$parcel$exportWildcard($7cacdf50dce7d54d$exports, $d980bd9c21d06ae1$exports);


var $8b4ec012404cb259$exports = {};

$parcel$defineInteropFlag($8b4ec012404cb259$exports);

$parcel$export($8b4ec012404cb259$exports, "default", () => $4838e5a14e330013$export$2e2bcd8739ae039);
$parcel$export($8b4ec012404cb259$exports, "backdropClasses", () => $5c4c540114ae85ab$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($8b4ec012404cb259$exports, $5c4c540114ae85ab$exports);


var $f7bda82e26c407eb$exports = {};

$parcel$defineInteropFlag($f7bda82e26c407eb$exports);

$parcel$export($f7bda82e26c407eb$exports, "default", () => $b0a465815ebe726f$export$2e2bcd8739ae039);
$parcel$export($f7bda82e26c407eb$exports, "badgeClasses", () => $64f6ef338eb74fbc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");


'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://next.mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://next.mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $0d1a8f518d4ece30$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $0d1a8f518d4ece30$export$2e2bcd8739ae039 = $0d1a8f518d4ece30$var$useBadge;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");
var $64f6ef338eb74fbc$exports = {};

$parcel$defineInteropFlag($64f6ef338eb74fbc$exports);

$parcel$export($64f6ef338eb74fbc$exports, "getBadgeUtilityClass", () => $64f6ef338eb74fbc$export$aaccef17e6dab084);
$parcel$export($64f6ef338eb74fbc$exports, "default", () => $64f6ef338eb74fbc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64f6ef338eb74fbc$export$aaccef17e6dab084(slot) {
    return (0, $4Cod0.default)('MuiBadge', slot);
}
const $64f6ef338eb74fbc$var$badgeClasses = (0, $beCSm.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $64f6ef338eb74fbc$export$2e2bcd8739ae039 = $64f6ef338eb74fbc$var$badgeClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b0a465815ebe726f$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $b0a465815ebe726f$var$RADIUS_STANDARD = 10;
const $b0a465815ebe726f$var$RADIUS_DOT = 4;
const $b0a465815ebe726f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}${(0, $jTnBY.default)(overlap)}`,
            `overlap${(0, $jTnBY.default)(overlap)}`,
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $64f6ef338eb74fbc$export$aaccef17e6dab084), classes);
};
const $b0a465815ebe726f$var$BadgeRoot = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $b0a465815ebe726f$var$BadgeBadge = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}${(0, $jTnBY.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        borderRadius: $b0a465815ebe726f$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $b0a465815ebe726f$var$RADIUS_DOT,
                    height: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    minWidth: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $64f6ef338eb74fbc$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $b0a465815ebe726f$var$Badge = /*#__PURE__*/ $acw62.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard' } = props, other = (0, $1En50.default)(props, $b0a465815ebe726f$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $0d1a8f518d4ece30$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = (0, $8nd05.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $b0a465815ebe726f$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $b0a465815ebe726f$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $b0a465815ebe726f$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(BadgeSlot, (0, $8nd05.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $b0a465815ebe726f$export$2e2bcd8739ae039 = $b0a465815ebe726f$var$Badge;



'use client';
$parcel$exportWildcard($f7bda82e26c407eb$exports, $64f6ef338eb74fbc$exports);


var $e5adbfb42ac1b374$exports = {};

$parcel$defineInteropFlag($e5adbfb42ac1b374$exports);

$parcel$export($e5adbfb42ac1b374$exports, "default", () => $5da68ee03f6480a6$export$2e2bcd8739ae039);
$parcel$export($e5adbfb42ac1b374$exports, "bottomNavigationClasses", () => $1b293a71daed0efc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $1b293a71daed0efc$exports = {};

$parcel$defineInteropFlag($1b293a71daed0efc$exports);

$parcel$export($1b293a71daed0efc$exports, "getBottomNavigationUtilityClass", () => $1b293a71daed0efc$export$5524f0b1f990b0b8);
$parcel$export($1b293a71daed0efc$exports, "default", () => $1b293a71daed0efc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1b293a71daed0efc$export$5524f0b1f990b0b8(slot) {
    return (0, $4Cod0.default)('MuiBottomNavigation', slot);
}
const $1b293a71daed0efc$var$bottomNavigationClasses = (0, $beCSm.default)('MuiBottomNavigation', [
    'root'
]);
var $1b293a71daed0efc$export$2e2bcd8739ae039 = $1b293a71daed0efc$var$bottomNavigationClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5da68ee03f6480a6$var$_excluded = [
    "children",
    "className",
    "component",
    "onChange",
    "showLabels",
    "value"
];
const $5da68ee03f6480a6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1b293a71daed0efc$export$5524f0b1f990b0b8), classes);
};
const $5da68ee03f6480a6$var$BottomNavigationRoot = (0, $d8seH.default)('div', {
    name: 'MuiBottomNavigation',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        height: 56,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5da68ee03f6480a6$var$BottomNavigation = /*#__PURE__*/ $acw62.forwardRef(function BottomNavigation(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigation'
    });
    const { children: children, className: className, component: component = 'div', onChange: onChange, showLabels: showLabels = false, value: value } = props, other = (0, $1En50.default)(props, $5da68ee03f6480a6$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        showLabels: showLabels
    });
    const classes = $5da68ee03f6480a6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5da68ee03f6480a6$var$BottomNavigationRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: $acw62.Children.map(children, (child, childIndex)=>{
            if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
            const childValue = child.props.value === undefined ? childIndex : child.props.value;
            return /*#__PURE__*/ $acw62.cloneElement(child, {
                selected: childValue === value,
                showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
                value: childValue,
                onChange: onChange
            });
        })
    }));
});
var $5da68ee03f6480a6$export$2e2bcd8739ae039 = $5da68ee03f6480a6$var$BottomNavigation;



'use client';
$parcel$exportWildcard($e5adbfb42ac1b374$exports, $1b293a71daed0efc$exports);


var $a4eae313114a1aef$exports = {};

$parcel$defineInteropFlag($a4eae313114a1aef$exports);

$parcel$export($a4eae313114a1aef$exports, "default", () => $fd7b1d1a8629ce6b$export$2e2bcd8739ae039);
$parcel$export($a4eae313114a1aef$exports, "bottomNavigationActionClasses", () => $1285bdc0c1011b3d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $1285bdc0c1011b3d$exports = {};

$parcel$defineInteropFlag($1285bdc0c1011b3d$exports);

$parcel$export($1285bdc0c1011b3d$exports, "getBottomNavigationActionUtilityClass", () => $1285bdc0c1011b3d$export$c91cad6db86415ef);
$parcel$export($1285bdc0c1011b3d$exports, "default", () => $1285bdc0c1011b3d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1285bdc0c1011b3d$export$c91cad6db86415ef(slot) {
    return (0, $4Cod0.default)('MuiBottomNavigationAction', slot);
}
const $1285bdc0c1011b3d$var$bottomNavigationActionClasses = (0, $beCSm.default)('MuiBottomNavigationAction', [
    'root',
    'iconOnly',
    'selected',
    'label'
]);
var $1285bdc0c1011b3d$export$2e2bcd8739ae039 = $1285bdc0c1011b3d$var$bottomNavigationActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fd7b1d1a8629ce6b$var$_excluded = [
    "className",
    "icon",
    "label",
    "onChange",
    "onClick",
    "selected",
    "showLabel",
    "value"
];
const $fd7b1d1a8629ce6b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, showLabel: showLabel, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ],
        label: [
            'label',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1285bdc0c1011b3d$export$c91cad6db86415ef), classes);
};
const $fd7b1d1a8629ce6b$var$BottomNavigationActionRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiBottomNavigationAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.showLabel && !ownerState.selected && styles.iconOnly
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        transition: theme.transitions.create([
            'color',
            'padding-top'
        ], {
            duration: theme.transitions.duration.short
        }),
        padding: '0px 12px',
        minWidth: 80,
        maxWidth: 168,
        color: (theme.vars || theme).palette.text.secondary,
        flexDirection: 'column',
        flex: '1'
    }, !ownerState.showLabel && !ownerState.selected && {
        paddingTop: 14
    }, !ownerState.showLabel && !ownerState.selected && !ownerState.label && {
        paddingTop: 0
    }, {
        [`&.${(0, $1285bdc0c1011b3d$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        }
    }));
const $fd7b1d1a8629ce6b$var$BottomNavigationActionLabel = (0, $d8seH.default)('span', {
    name: 'MuiBottomNavigationAction',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(12),
        opacity: 1,
        transition: 'font-size 0.2s, opacity 0.2s',
        transitionDelay: '0.1s'
    }, !ownerState.showLabel && !ownerState.selected && {
        opacity: 0,
        transitionDelay: '0s'
    }, {
        [`&.${(0, $1285bdc0c1011b3d$export$2e2bcd8739ae039).selected}`]: {
            fontSize: theme.typography.pxToRem(14)
        }
    }));
const $fd7b1d1a8629ce6b$var$BottomNavigationAction = /*#__PURE__*/ $acw62.forwardRef(function BottomNavigationAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigationAction'
    });
    const { className: className, icon: icon, label: label, onChange: onChange, onClick: onClick, value: value } = props, other = (0, $1En50.default)(props, $fd7b1d1a8629ce6b$var$_excluded);
    const ownerState = props;
    const classes = $fd7b1d1a8629ce6b$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($fd7b1d1a8629ce6b$var$BottomNavigationActionRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        focusRipple: true,
        onClick: handleChange,
        ownerState: ownerState
    }, other, {
        children: [
            icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($fd7b1d1a8629ce6b$var$BottomNavigationActionLabel, {
                className: classes.label,
                ownerState: ownerState,
                children: label
            })
        ]
    }));
});
var $fd7b1d1a8629ce6b$export$2e2bcd8739ae039 = $fd7b1d1a8629ce6b$var$BottomNavigationAction;



'use client';
$parcel$exportWildcard($a4eae313114a1aef$exports, $1285bdc0c1011b3d$exports);


var $02a57cc52715b250$exports = {};

$parcel$defineInteropFlag($02a57cc52715b250$exports);

$parcel$export($02a57cc52715b250$exports, "default", () => $00a20d475386f68c$export$2e2bcd8739ae039);
$parcel$export($02a57cc52715b250$exports, "boxClasses", () => $cf808af3a1d339c9$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($02a57cc52715b250$exports, $cf808af3a1d339c9$exports);


var $468368052d2ef018$exports = {};

$parcel$defineInteropFlag($468368052d2ef018$exports);

$parcel$export($468368052d2ef018$exports, "default", () => $3beee71e1808c2fa$export$2e2bcd8739ae039);
$parcel$export($468368052d2ef018$exports, "breadcrumbsClasses", () => $3109febd55ba98e0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e8aa9eabd3007a18$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ad5c6c214f96507f$var$_excluded = [
    "slots",
    "slotProps"
];
const $ad5c6c214f96507f$var$BreadcrumbCollapsedButton = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiBreadcrumbCollapsed'
})(({ theme: theme })=>(0, $8nd05.default)({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === 'light' ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        '&:hover, &:focus': (0, $8nd05.default)({}, theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        '&:active': (0, $8nd05.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === 'light' ? {
            backgroundColor: (0, $kTdcz.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $kTdcz.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $ad5c6c214f96507f$var$BreadcrumbCollapsedIcon = (0, $d8seH.default)((0, $e8aa9eabd3007a18$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $ad5c6c214f96507f$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $1En50.default)(props, $ad5c6c214f96507f$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedButton, (0, $8nd05.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedIcon, (0, $8nd05.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
var $ad5c6c214f96507f$export$2e2bcd8739ae039 = $ad5c6c214f96507f$var$BreadcrumbCollapsed;


var $3109febd55ba98e0$exports = {};

$parcel$defineInteropFlag($3109febd55ba98e0$exports);

$parcel$export($3109febd55ba98e0$exports, "getBreadcrumbsUtilityClass", () => $3109febd55ba98e0$export$17261110b18c8084);
$parcel$export($3109febd55ba98e0$exports, "default", () => $3109febd55ba98e0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3109febd55ba98e0$export$17261110b18c8084(slot) {
    return (0, $4Cod0.default)('MuiBreadcrumbs', slot);
}
const $3109febd55ba98e0$var$breadcrumbsClasses = (0, $beCSm.default)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $3109febd55ba98e0$export$2e2bcd8739ae039 = $3109febd55ba98e0$var$breadcrumbsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3beee71e1808c2fa$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $3beee71e1808c2fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3109febd55ba98e0$export$17261110b18c8084), classes);
};
const $3beee71e1808c2fa$var$BreadcrumbsRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $3109febd55ba98e0$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $3beee71e1808c2fa$var$BreadcrumbsOl = (0, $d8seH.default)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol',
    overridesResolver: (props, styles)=>styles.ol
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $3beee71e1808c2fa$var$BreadcrumbsSeparator = (0, $d8seH.default)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $3beee71e1808c2fa$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $3beee71e1808c2fa$var$Breadcrumbs = /*#__PURE__*/ $acw62.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/' } = props, other = (0, $1En50.default)(props, $3beee71e1808c2fa$var$_excluded);
    const [expanded, setExpanded] = $acw62.useState(false);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $3beee71e1808c2fa$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $acw62.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ad5c6c214f96507f$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $acw62.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $acw62.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsRoot, (0, $8nd05.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $3beee71e1808c2fa$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $3beee71e1808c2fa$export$2e2bcd8739ae039 = $3beee71e1808c2fa$var$Breadcrumbs;



'use client';
$parcel$exportWildcard($468368052d2ef018$exports, $3109febd55ba98e0$exports);


var $873c117b1fb2dd29$exports = {};

$parcel$defineInteropFlag($873c117b1fb2dd29$exports);

$parcel$export($873c117b1fb2dd29$exports, "default", () => $4a02bab8c70a697b$export$2e2bcd8739ae039);
$parcel$export($873c117b1fb2dd29$exports, "buttonClasses", () => $11f546081ba06ace$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($873c117b1fb2dd29$exports, $11f546081ba06ace$exports);


var $c949c943dfbcd61d$exports = {};

$parcel$defineInteropFlag($c949c943dfbcd61d$exports);

$parcel$export($c949c943dfbcd61d$exports, "default", () => $4a35786d89db9dda$export$2e2bcd8739ae039);
$parcel$export($c949c943dfbcd61d$exports, "buttonBaseClasses", () => $42d7f65840078ec1$export$2e2bcd8739ae039);
$parcel$export($c949c943dfbcd61d$exports, "touchRippleClasses", () => $755fb323846f60d4$export$2e2bcd8739ae039);



'use client';
$parcel$exportWildcard($c949c943dfbcd61d$exports, $42d7f65840078ec1$exports);
$parcel$exportWildcard($c949c943dfbcd61d$exports, $755fb323846f60d4$exports);


var $65afbe095ccffd1e$exports = {};

$parcel$defineInteropFlag($65afbe095ccffd1e$exports);

$parcel$export($65afbe095ccffd1e$exports, "default", () => $1c026d95d0d4d482$export$2e2bcd8739ae039);
$parcel$export($65afbe095ccffd1e$exports, "buttonGroupClasses", () => $9901c9510940cf3a$export$2e2bcd8739ae039);
$parcel$export($65afbe095ccffd1e$exports, "ButtonGroupContext", () => $8639dcef822d5d4c$export$2e2bcd8739ae039);
$parcel$export($65afbe095ccffd1e$exports, "ButtonGroupButtonContext", () => $25b1293270900846$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $acw62 = parcelRequire("acw62");
function $9b0e6fd5d31b1b95$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $9901c9510940cf3a$exports = {};

$parcel$defineInteropFlag($9901c9510940cf3a$exports);

$parcel$export($9901c9510940cf3a$exports, "getButtonGroupUtilityClass", () => $9901c9510940cf3a$export$b85c003f960b1f3a);
$parcel$export($9901c9510940cf3a$exports, "default", () => $9901c9510940cf3a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9901c9510940cf3a$export$b85c003f960b1f3a(slot) {
    return (0, $4Cod0.default)('MuiButtonGroup', slot);
}
const $9901c9510940cf3a$var$buttonGroupClasses = (0, $beCSm.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'vertical',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $9901c9510940cf3a$export$2e2bcd8739ae039 = $9901c9510940cf3a$var$buttonGroupClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1c026d95d0d4d482$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $1c026d95d0d4d482$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $1c026d95d0d4d482$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9901c9510940cf3a$export$b85c003f960b1f3a), classes);
};
const $1c026d95d0d4d482$var$ButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $1c026d95d0d4d482$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === 'contained' && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: 'none'
    }, ownerState.fullWidth && {
        width: '100%'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, {
        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: (0, $8nd05.default)({
            minWidth: 40,
            '&:hover': (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
                boxShadow: 'none'
            })
        }, ownerState.variant === 'contained' && {
            boxShadow: 'none'
        }),
        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: (0, $8nd05.default)({}, ownerState.orientation === 'horizontal' && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === 'text' && ownerState.orientation === 'horizontal' && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.orientation === 'vertical' && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            borderRightColor: 'transparent'
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            borderBottomColor: 'transparent'
        }, ownerState.variant === 'contained' && ownerState.orientation === 'horizontal' && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.orientation === 'vertical' && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            '&:hover': (0, $8nd05.default)({}, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
                borderRightColor: 'currentColor'
            }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
                borderBottomColor: 'currentColor'
            })
        }),
        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: (0, $8nd05.default)({}, ownerState.orientation === 'horizontal' && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            marginLeft: -1
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            marginTop: -1
        })
    }));
const $1c026d95d0d4d482$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $1c026d95d0d4d482$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $1c026d95d0d4d482$var$useUtilityClasses(ownerState);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $9b0e6fd5d31b1b95$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$ButtonGroupRoot, (0, $8nd05.default)({
        as: component,
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8639dcef822d5d4c$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25b1293270900846$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $1c026d95d0d4d482$export$2e2bcd8739ae039 = $1c026d95d0d4d482$var$ButtonGroup;





'use client';
$parcel$exportWildcard($65afbe095ccffd1e$exports, $9901c9510940cf3a$exports);


var $2b27523fd597460f$exports = {};

$parcel$defineInteropFlag($2b27523fd597460f$exports);

$parcel$export($2b27523fd597460f$exports, "default", () => $45313e7d506ce734$export$2e2bcd8739ae039);
$parcel$export($2b27523fd597460f$exports, "cardClasses", () => $89a1bb9709695920$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($2b27523fd597460f$exports, $89a1bb9709695920$exports);


var $f1408e763033c57b$exports = {};

$parcel$defineInteropFlag($f1408e763033c57b$exports);

$parcel$export($f1408e763033c57b$exports, "default", () => $8c7064036f0f2f9d$export$2e2bcd8739ae039);
$parcel$export($f1408e763033c57b$exports, "cardActionAreaClasses", () => $47d794472d40adee$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $47d794472d40adee$exports = {};

$parcel$defineInteropFlag($47d794472d40adee$exports);

$parcel$export($47d794472d40adee$exports, "getCardActionAreaUtilityClass", () => $47d794472d40adee$export$ee5828fb8c43a48e);
$parcel$export($47d794472d40adee$exports, "default", () => $47d794472d40adee$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $47d794472d40adee$export$ee5828fb8c43a48e(slot) {
    return (0, $4Cod0.default)('MuiCardActionArea', slot);
}
const $47d794472d40adee$var$cardActionAreaClasses = (0, $beCSm.default)('MuiCardActionArea', [
    'root',
    'focusVisible',
    'focusHighlight'
]);
var $47d794472d40adee$export$2e2bcd8739ae039 = $47d794472d40adee$var$cardActionAreaClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8c7064036f0f2f9d$var$_excluded = [
    "children",
    "className",
    "focusVisibleClassName"
];
const $8c7064036f0f2f9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        focusHighlight: [
            'focusHighlight'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $47d794472d40adee$export$ee5828fb8c43a48e), classes);
};
const $8c7064036f0f2f9d$var$CardActionAreaRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiCardActionArea',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        textAlign: 'inherit',
        borderRadius: 'inherit',
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: '100%',
        [`&:hover .${(0, $47d794472d40adee$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            '@media (hover: none)': {
                opacity: 0
            }
        },
        [`&.${(0, $47d794472d40adee$export$2e2bcd8739ae039).focusVisible} .${(0, $47d794472d40adee$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    }));
const $8c7064036f0f2f9d$var$CardActionAreaFocusHighlight = (0, $d8seH.default)('span', {
    name: 'MuiCardActionArea',
    slot: 'FocusHighlight',
    overridesResolver: (props, styles)=>styles.focusHighlight
})(({ theme: theme })=>({
        overflow: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 'inherit',
        opacity: 0,
        backgroundColor: 'currentcolor',
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short
        })
    }));
const $8c7064036f0f2f9d$var$CardActionArea = /*#__PURE__*/ $acw62.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActionArea'
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName } = props, other = (0, $1En50.default)(props, $8c7064036f0f2f9d$var$_excluded);
    const ownerState = props;
    const classes = $8c7064036f0f2f9d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8c7064036f0f2f9d$var$CardActionAreaRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        focusVisibleClassName: (0, $9QePP.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)($8c7064036f0f2f9d$var$CardActionAreaFocusHighlight, {
                className: classes.focusHighlight,
                ownerState: ownerState
            })
        ]
    }));
});
var $8c7064036f0f2f9d$export$2e2bcd8739ae039 = $8c7064036f0f2f9d$var$CardActionArea;



'use client';
$parcel$exportWildcard($f1408e763033c57b$exports, $47d794472d40adee$exports);


var $082203d287675024$exports = {};

$parcel$defineInteropFlag($082203d287675024$exports);

$parcel$export($082203d287675024$exports, "default", () => $b46a5bcac23a5f99$export$2e2bcd8739ae039);
$parcel$export($082203d287675024$exports, "cardActionsClasses", () => $4c5dd21dca115198$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $4c5dd21dca115198$exports = {};

$parcel$defineInteropFlag($4c5dd21dca115198$exports);

$parcel$export($4c5dd21dca115198$exports, "getCardActionsUtilityClass", () => $4c5dd21dca115198$export$2a5c27c211442e3c);
$parcel$export($4c5dd21dca115198$exports, "default", () => $4c5dd21dca115198$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4c5dd21dca115198$export$2a5c27c211442e3c(slot) {
    return (0, $4Cod0.default)('MuiCardActions', slot);
}
const $4c5dd21dca115198$var$cardActionsClasses = (0, $beCSm.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $4c5dd21dca115198$export$2e2bcd8739ae039 = $4c5dd21dca115198$var$cardActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b46a5bcac23a5f99$var$_excluded = [
    "disableSpacing",
    "className"
];
const $b46a5bcac23a5f99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4c5dd21dca115198$export$2a5c27c211442e3c), classes);
};
const $b46a5bcac23a5f99$var$CardActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $b46a5bcac23a5f99$var$CardActions = /*#__PURE__*/ $acw62.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $1En50.default)(props, $b46a5bcac23a5f99$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $b46a5bcac23a5f99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46a5bcac23a5f99$var$CardActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b46a5bcac23a5f99$export$2e2bcd8739ae039 = $b46a5bcac23a5f99$var$CardActions;



'use client';
$parcel$exportWildcard($082203d287675024$exports, $4c5dd21dca115198$exports);


var $fe806b09c0847150$exports = {};

$parcel$defineInteropFlag($fe806b09c0847150$exports);

$parcel$export($fe806b09c0847150$exports, "default", () => $28a500ea92f2665f$export$2e2bcd8739ae039);
$parcel$export($fe806b09c0847150$exports, "cardContentClasses", () => $273fd99738f3adbe$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($fe806b09c0847150$exports, $273fd99738f3adbe$exports);


var $35ff8d0aba128694$exports = {};

$parcel$defineInteropFlag($35ff8d0aba128694$exports);

$parcel$export($35ff8d0aba128694$exports, "default", () => $bc2b3dbd11553d00$export$2e2bcd8739ae039);
$parcel$export($35ff8d0aba128694$exports, "cardHeaderClasses", () => $0a6ddbf21430a4ea$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $0a6ddbf21430a4ea$exports = {};

$parcel$defineInteropFlag($0a6ddbf21430a4ea$exports);

$parcel$export($0a6ddbf21430a4ea$exports, "getCardHeaderUtilityClass", () => $0a6ddbf21430a4ea$export$f54c8b0d04b67946);
$parcel$export($0a6ddbf21430a4ea$exports, "default", () => $0a6ddbf21430a4ea$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0a6ddbf21430a4ea$export$f54c8b0d04b67946(slot) {
    return (0, $4Cod0.default)('MuiCardHeader', slot);
}
const $0a6ddbf21430a4ea$var$cardHeaderClasses = (0, $beCSm.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $0a6ddbf21430a4ea$export$2e2bcd8739ae039 = $0a6ddbf21430a4ea$var$cardHeaderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bc2b3dbd11553d00$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $bc2b3dbd11553d00$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $0a6ddbf21430a4ea$export$f54c8b0d04b67946), classes);
};
const $bc2b3dbd11553d00$var$CardHeaderRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $0a6ddbf21430a4ea$export$2e2bcd8739ae039).title}`]: styles.title,
            [`& .${(0, $0a6ddbf21430a4ea$export$2e2bcd8739ae039).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $bc2b3dbd11553d00$var$CardHeaderAvatar = (0, $d8seH.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $bc2b3dbd11553d00$var$CardHeaderAction = (0, $d8seH.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $bc2b3dbd11553d00$var$CardHeaderContent = (0, $d8seH.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    flex: '1 1 auto'
});
const $bc2b3dbd11553d00$var$CardHeader = /*#__PURE__*/ $acw62.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, className: className, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $1En50.default)(props, $bc2b3dbd11553d00$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $bc2b3dbd11553d00$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: avatar ? 'body2' : 'h5',
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: avatar ? 'body2' : 'body1',
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($bc2b3dbd11553d00$var$CardHeaderRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $ayMG0.jsx)($bc2b3dbd11553d00$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($bc2b3dbd11553d00$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $ayMG0.jsx)($bc2b3dbd11553d00$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $bc2b3dbd11553d00$export$2e2bcd8739ae039 = $bc2b3dbd11553d00$var$CardHeader;



'use client';
$parcel$exportWildcard($35ff8d0aba128694$exports, $0a6ddbf21430a4ea$exports);


var $a7ec82c27a16d3bc$exports = {};

$parcel$defineInteropFlag($a7ec82c27a16d3bc$exports);

$parcel$export($a7ec82c27a16d3bc$exports, "default", () => $891b59d4b36435bb$export$2e2bcd8739ae039);
$parcel$export($a7ec82c27a16d3bc$exports, "cardMediaClasses", () => $72f090ff2322b6ae$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $72f090ff2322b6ae$exports = {};

$parcel$defineInteropFlag($72f090ff2322b6ae$exports);

$parcel$export($72f090ff2322b6ae$exports, "getCardMediaUtilityClass", () => $72f090ff2322b6ae$export$5f5333fe417019a7);
$parcel$export($72f090ff2322b6ae$exports, "default", () => $72f090ff2322b6ae$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $72f090ff2322b6ae$export$5f5333fe417019a7(slot) {
    return (0, $4Cod0.default)('MuiCardMedia', slot);
}
const $72f090ff2322b6ae$var$cardMediaClasses = (0, $beCSm.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
var $72f090ff2322b6ae$export$2e2bcd8739ae039 = $72f090ff2322b6ae$var$cardMediaClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $891b59d4b36435bb$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $891b59d4b36435bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $72f090ff2322b6ae$export$5f5333fe417019a7), classes);
};
const $891b59d4b36435bb$var$CardMediaRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }, ownerState.isMediaComponent && {
        width: '100%'
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover'
    }));
const $891b59d4b36435bb$var$MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const $891b59d4b36435bb$var$IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const $891b59d4b36435bb$var$CardMedia = /*#__PURE__*/ $acw62.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children: children, className: className, component: component = 'div', image: image, src: src, style: style } = props, other = (0, $1En50.default)(props, $891b59d4b36435bb$var$_excluded);
    const isMediaComponent = $891b59d4b36435bb$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $8nd05.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $891b59d4b36435bb$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $891b59d4b36435bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($891b59d4b36435bb$var$CardMediaRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $891b59d4b36435bb$export$2e2bcd8739ae039 = $891b59d4b36435bb$var$CardMedia;



'use client';
$parcel$exportWildcard($a7ec82c27a16d3bc$exports, $72f090ff2322b6ae$exports);


var $7c7c690d35982c52$exports = {};

$parcel$defineInteropFlag($7c7c690d35982c52$exports);

$parcel$export($7c7c690d35982c52$exports, "default", () => $12775c00f473d955$export$2e2bcd8739ae039);
$parcel$export($7c7c690d35982c52$exports, "checkboxClasses", () => $6e1cd6b997bc70d3$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;


'use client';
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $8426ae8303951a73$export$2e2bcd8739ae039));
}




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $beCSm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f3bdb1b636c81735$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $86603163591f910a$export$baa0faa0c7ad8085), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $8Uq77.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $1En50.default)(props, $f3bdb1b636c81735$var$_excluded);
    const [checked, setCheckedState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3bdb1b636c81735$var$SwitchBaseRoot, (0, $8nd05.default)({
        component: "span",
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($f3bdb1b636c81735$var$SwitchBaseInput, (0, $8nd05.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");
var $6e1cd6b997bc70d3$exports = {};

$parcel$defineInteropFlag($6e1cd6b997bc70d3$exports);

$parcel$export($6e1cd6b997bc70d3$exports, "getCheckboxUtilityClass", () => $6e1cd6b997bc70d3$export$6c57c6e16b4063b);
$parcel$export($6e1cd6b997bc70d3$exports, "default", () => $6e1cd6b997bc70d3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $beCSm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12775c00f473d955$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6e1cd6b997bc70d3$export$6c57c6e16b4063b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).checked}, &.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8b10b2b5aaa8e54$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $122b08a8ae2faae5$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8b21cdbf539e4f$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $1En50.default)(props, $12775c00f473d955$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$CheckboxRoot, (0, $8nd05.default)({
        type: "checkbox",
        inputProps: (0, $8nd05.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;



'use client';
$parcel$exportWildcard($7c7c690d35982c52$exports, $6e1cd6b997bc70d3$exports);


var $4a998843df0ddc3a$exports = {};

$parcel$defineInteropFlag($4a998843df0ddc3a$exports);

$parcel$export($4a998843df0ddc3a$exports, "default", () => $47d4f79319086dc5$export$2e2bcd8739ae039);
$parcel$export($4a998843df0ddc3a$exports, "chipClasses", () => $db0771a9e6a32b1d$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($4a998843df0ddc3a$exports, $db0771a9e6a32b1d$exports);


var $11054b4f9cc1bbd6$exports = {};

$parcel$defineInteropFlag($11054b4f9cc1bbd6$exports);

$parcel$export($11054b4f9cc1bbd6$exports, "default", () => $19b4ac261663afa8$export$2e2bcd8739ae039);
$parcel$export($11054b4f9cc1bbd6$exports, "circularProgressClasses", () => $b86eb8364bb4993c$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($11054b4f9cc1bbd6$exports, $b86eb8364bb4993c$exports);


var $5a37cef7efb75d08$exports = {};

$parcel$defineInteropFlag($5a37cef7efb75d08$exports);

$parcel$export($5a37cef7efb75d08$exports, "default", () => $f0f105dbd8c07c9e$export$58385c17fee43f89);

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, childrenProps)
    });
}




var $bfbeac2d30cd504d$exports = {};

$parcel$defineInteropFlag($bfbeac2d30cd504d$exports);

$parcel$export($bfbeac2d30cd504d$exports, "default", () => $848dc8709a4309c5$export$2e2bcd8739ae039);
$parcel$export($bfbeac2d30cd504d$exports, "collapseClasses", () => $247ae09dccc3464c$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($bfbeac2d30cd504d$exports, $247ae09dccc3464c$exports);


var $70e06f8560e22c27$exports = {};

$parcel$defineInteropFlag($70e06f8560e22c27$exports);

$parcel$export($70e06f8560e22c27$exports, "default", () => $2291beb327d500f8$export$2e2bcd8739ae039);
$parcel$export($70e06f8560e22c27$exports, "containerClasses", () => $bf919e292c78caff$export$2e2bcd8739ae039);


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $5C8IU = parcelRequire("5C8IU");

var $3z1Ay = parcelRequire("3z1Ay");



var $8NnpI = parcelRequire("8NnpI");

var $g91qR = parcelRequire("g91qR");
const $62f65c9151f4e6ef$var$_excluded = [
    "ownerState"
], $62f65c9151f4e6ef$var$_excluded2 = [
    "variants"
], $62f65c9151f4e6ef$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $62f65c9151f4e6ef$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $62f65c9151f4e6ef$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $62f65c9151f4e6ef$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $62f65c9151f4e6ef$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $62f65c9151f4e6ef$export$35e57303dbd8a66 = (0, $8NnpI.default)();
const $62f65c9151f4e6ef$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $62f65c9151f4e6ef$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $62f65c9151f4e6ef$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $62f65c9151f4e6ef$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $62f65c9151f4e6ef$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $1En50.default)(_ref, $62f65c9151f4e6ef$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $8nd05.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$62f65c9151f4e6ef$var$processStyleArg(resolvedStyle, (0, $8nd05.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1En50.default)(resolvedStylesArg, $62f65c9151f4e6ef$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $8nd05.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $8nd05.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $62f65c9151f4e6ef$var$shallowLayer((0, $5C8IU.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $62f65c9151f4e6ef$var$shallowLayer((0, $5C8IU.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $62f65c9151f4e6ef$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $62f65c9151f4e6ef$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $62f65c9151f4e6ef$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $62f65c9151f4e6ef$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $g91qR.default)((0, $8nd05.default)({}, props, {
            theme: $62f65c9151f4e6ef$var$resolveTheme((0, $8nd05.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $5C8IU.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $62f65c9151f4e6ef$var$defaultOverridesResolver($62f65c9151f4e6ef$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1En50.default)(inputOptions, $62f65c9151f4e6ef$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $62f65c9151f4e6ef$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($62f65c9151f4e6ef$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5C8IU.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $62f65c9151f4e6ef$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $62f65c9151f4e6ef$var$processStyleArg(stylesArg, (0, $8nd05.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $62f65c9151f4e6ef$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $62f65c9151f4e6ef$var$processStyleArg(slotStyle, (0, $8nd05.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $62f65c9151f4e6ef$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $62f65c9151f4e6ef$var$processStyleArg({
                    variants: themeVariants
                }, (0, $8nd05.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $10ae0b8a52224565$var$styled = (0, $62f65c9151f4e6ef$export$2e2bcd8739ae039)();
var $10ae0b8a52224565$export$2e2bcd8739ae039 = $10ae0b8a52224565$var$styled;



var $8NnpI = parcelRequire("8NnpI");

var $ayMG0 = parcelRequire("ayMG0");
const $26f3a9e890bcae2b$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $26f3a9e890bcae2b$var$defaultTheme = (0, $8NnpI.default)();
const $26f3a9e890bcae2b$var$defaultCreateStyledComponent = (0, $10ae0b8a52224565$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $gxvzd.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $26f3a9e890bcae2b$var$useThemePropsDefault = (inProps)=>(0, $568aba12ccdf91ea$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $26f3a9e890bcae2b$var$defaultTheme
    });
const $26f3a9e890bcae2b$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $4Cod0.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $gxvzd.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, getContainerUtilityClass, classes);
};
function $26f3a9e890bcae2b$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $26f3a9e890bcae2b$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $26f3a9e890bcae2b$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $1En50.default)(props, $26f3a9e890bcae2b$var$_excluded);
        const ownerState = (0, $8nd05.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $26f3a9e890bcae2b$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $2291beb327d500f8$var$Container = (0, $26f3a9e890bcae2b$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;


var $bf919e292c78caff$exports = {};

$parcel$defineInteropFlag($bf919e292c78caff$exports);

$parcel$export($bf919e292c78caff$exports, "getContainerUtilityClass", () => $bf919e292c78caff$export$f8d08dc2abc73598);
$parcel$export($bf919e292c78caff$exports, "default", () => $bf919e292c78caff$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bf919e292c78caff$export$f8d08dc2abc73598(slot) {
    return (0, $4Cod0.default)('MuiContainer', slot);
}
const $bf919e292c78caff$var$containerClasses = (0, $beCSm.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $bf919e292c78caff$export$2e2bcd8739ae039 = $bf919e292c78caff$var$containerClasses;


'use client';
$parcel$exportWildcard($70e06f8560e22c27$exports, $bf919e292c78caff$exports);


var $84130c31a3f49bb6$exports = {};

$parcel$defineInteropFlag($84130c31a3f49bb6$exports);

$parcel$export($84130c31a3f49bb6$exports, "default", () => $c3dfe91526ac04a1$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");



var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $699894d3e78e9c81$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    }));
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c3dfe91526ac04a1$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $8nd05.default)({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $c3dfe91526ac04a1$export$32180ef41b15b513 = (theme)=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $c3dfe91526ac04a1$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $8nd05.default)({
        html: $c3dfe91526ac04a1$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $8nd05.default)({
            margin: 0
        }, $c3dfe91526ac04a1$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $c3dfe91526ac04a1$var$CssBaseline(inProps) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03fc756f7adfd498$export$2e2bcd8739ae039), {
                styles: (theme)=>$c3dfe91526ac04a1$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $c3dfe91526ac04a1$export$2e2bcd8739ae039 = $c3dfe91526ac04a1$var$CssBaseline;


'use client';


var $3426a3520e69a38c$exports = {};

$parcel$defineInteropFlag($3426a3520e69a38c$exports);

$parcel$export($3426a3520e69a38c$exports, "default", () => $3426a3520e69a38c$export$2e2bcd8739ae039);
// track, thumb and active are derived from macOS 10.15.7
const $3426a3520e69a38c$var$scrollBar = {
    track: '#2b2b2b',
    thumb: '#6b6b6b',
    active: '#959595'
};
function $3426a3520e69a38c$export$2e2bcd8739ae039(options = $3426a3520e69a38c$var$scrollBar) {
    return {
        scrollbarColor: `${options.thumb} ${options.track}`,
        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: options.track
        },
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 8,
            backgroundColor: options.thumb,
            minHeight: 24,
            border: `3px solid ${options.track}`
        },
        '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: options.track
        }
    };
}


var $dd40a9c943ba05e0$exports = {};

$parcel$defineInteropFlag($dd40a9c943ba05e0$exports);

$parcel$export($dd40a9c943ba05e0$exports, "default", () => $4f13784bd714c44e$export$2e2bcd8739ae039);
$parcel$export($dd40a9c943ba05e0$exports, "dialogClasses", () => $c5762e789acf7dcc$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");




var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $c5762e789acf7dcc$exports = {};

$parcel$defineInteropFlag($c5762e789acf7dcc$exports);

$parcel$export($c5762e789acf7dcc$exports, "getDialogUtilityClass", () => $c5762e789acf7dcc$export$2177af0aa15c34c2);
$parcel$export($c5762e789acf7dcc$exports, "default", () => $c5762e789acf7dcc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $beCSm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4f13784bd714c44e$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c5762e789acf7dcc$export$2177af0aa15c34c2), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $4f13784bd714c44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $4f13784bd714c44e$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $8nd05.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogContainer, {
                className: (0, $9QePP.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogPaper, (0, $8nd05.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $9QePP.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68187f174395cd28$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;



'use client';
$parcel$exportWildcard($dd40a9c943ba05e0$exports, $c5762e789acf7dcc$exports);


var $f5a78922775ef422$exports = {};

$parcel$defineInteropFlag($f5a78922775ef422$exports);

$parcel$export($f5a78922775ef422$exports, "default", () => $207bc6ab7c60f4b2$export$2e2bcd8739ae039);
$parcel$export($f5a78922775ef422$exports, "dialogActionsClasses", () => $3a31c1516a2c01e5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $3a31c1516a2c01e5$exports = {};

$parcel$defineInteropFlag($3a31c1516a2c01e5$exports);

$parcel$export($3a31c1516a2c01e5$exports, "getDialogActionsUtilityClass", () => $3a31c1516a2c01e5$export$5e57a444791c63be);
$parcel$export($3a31c1516a2c01e5$exports, "default", () => $3a31c1516a2c01e5$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $beCSm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $207bc6ab7c60f4b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3a31c1516a2c01e5$export$5e57a444791c63be), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1En50.default)(props, $207bc6ab7c60f4b2$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;



'use client';
$parcel$exportWildcard($f5a78922775ef422$exports, $3a31c1516a2c01e5$exports);


var $ce89efe9ad487ed1$exports = {};

$parcel$defineInteropFlag($ce89efe9ad487ed1$exports);

$parcel$export($ce89efe9ad487ed1$exports, "default", () => $4fa8e9c420cdee0a$export$2e2bcd8739ae039);
$parcel$export($ce89efe9ad487ed1$exports, "dialogContentClasses", () => $c877f2cebcabf5cb$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $c877f2cebcabf5cb$exports = {};

$parcel$defineInteropFlag($c877f2cebcabf5cb$exports);

$parcel$export($c877f2cebcabf5cb$exports, "getDialogContentUtilityClass", () => $c877f2cebcabf5cb$export$61b0ee1f05fb344e);
$parcel$export($c877f2cebcabf5cb$exports, "default", () => $c877f2cebcabf5cb$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $beCSm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;


var $f2e7257b2514744a$exports = {};

$parcel$defineInteropFlag($f2e7257b2514744a$exports);

$parcel$export($f2e7257b2514744a$exports, "getDialogTitleUtilityClass", () => $f2e7257b2514744a$export$f5d2ec7e4c47e088);
$parcel$export($f2e7257b2514744a$exports, "default", () => $f2e7257b2514744a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $beCSm.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4fa8e9c420cdee0a$var$_excluded = [
    "className",
    "dividers"
];
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c877f2cebcabf5cb$export$61b0ee1f05fb344e), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $f2e7257b2514744a$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1En50.default)(props, $4fa8e9c420cdee0a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        dividers: dividers
    });
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;



'use client';
$parcel$exportWildcard($ce89efe9ad487ed1$exports, $c877f2cebcabf5cb$exports);


var $7f970d1ffd61b921$exports = {};

$parcel$defineInteropFlag($7f970d1ffd61b921$exports);

$parcel$export($7f970d1ffd61b921$exports, "default", () => $aad93085434ac13f$export$2e2bcd8739ae039);
$parcel$export($7f970d1ffd61b921$exports, "dialogContentTextClasses", () => $64180fe1152829a7$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $64180fe1152829a7$exports = {};

$parcel$defineInteropFlag($64180fe1152829a7$exports);

$parcel$export($64180fe1152829a7$exports, "getDialogContentTextUtilityClass", () => $64180fe1152829a7$export$d9c6dc45f75b0e4f);
$parcel$export($64180fe1152829a7$exports, "default", () => $64180fe1152829a7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64180fe1152829a7$export$d9c6dc45f75b0e4f(slot) {
    return (0, $4Cod0.default)('MuiDialogContentText', slot);
}
const $64180fe1152829a7$var$dialogContentTextClasses = (0, $beCSm.default)('MuiDialogContentText', [
    'root'
]);
var $64180fe1152829a7$export$2e2bcd8739ae039 = $64180fe1152829a7$var$dialogContentTextClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $aad93085434ac13f$var$_excluded = [
    "children",
    "className"
];
const $aad93085434ac13f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $64180fe1152829a7$export$d9c6dc45f75b0e4f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $aad93085434ac13f$var$DialogContentTextRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $aad93085434ac13f$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { className: className } = props, ownerState = (0, $1En50.default)(props, $aad93085434ac13f$var$_excluded);
    const classes = $aad93085434ac13f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aad93085434ac13f$var$DialogContentTextRoot, (0, $8nd05.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $aad93085434ac13f$export$2e2bcd8739ae039 = $aad93085434ac13f$var$DialogContentText;



'use client';
$parcel$exportWildcard($7f970d1ffd61b921$exports, $64180fe1152829a7$exports);


var $fcf83d520808df6e$exports = {};

$parcel$defineInteropFlag($fcf83d520808df6e$exports);

$parcel$export($fcf83d520808df6e$exports, "default", () => $a6ac58aca374c76c$export$2e2bcd8739ae039);
$parcel$export($fcf83d520808df6e$exports, "dialogTitleClasses", () => $f2e7257b2514744a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a6ac58aca374c76c$var$_excluded = [
    "className",
    "id"
];
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f2e7257b2514744a$export$f5d2ec7e4c47e088), classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $1En50.default)(props, $a6ac58aca374c76c$var$_excluded);
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $68187f174395cd28$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, (0, $8nd05.default)({
        component: "h2",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $a6ac58aca374c76c$export$2e2bcd8739ae039 = $a6ac58aca374c76c$var$DialogTitle;



'use client';
$parcel$exportWildcard($fcf83d520808df6e$exports, $f2e7257b2514744a$exports);


var $bb9a180c0f91ff1f$exports = {};

$parcel$defineInteropFlag($bb9a180c0f91ff1f$exports);

$parcel$export($bb9a180c0f91ff1f$exports, "default", () => $f875d00b2138afe4$export$2e2bcd8739ae039);
$parcel$export($bb9a180c0f91ff1f$exports, "dividerClasses", () => $024a60f892d3fa61$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($bb9a180c0f91ff1f$exports, $024a60f892d3fa61$exports);


var $957158966c1dd989$exports = {};

$parcel$defineInteropFlag($957158966c1dd989$exports);

$parcel$export($957158966c1dd989$exports, "default", () => $1ed9758f3bc045cc$export$2e2bcd8739ae039);
$parcel$export($957158966c1dd989$exports, "drawerClasses", () => $367f15b5d414b8d7$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");












var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4dba6b402693f5d6$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4dba6b402693f5d6$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(containerProp);
    const transform = $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4dba6b402693f5d6$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $4dba6b402693f5d6$var$_excluded);
    const childrenRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $8nd05.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $8nd05.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $acw62.useCallback(()=>{
        if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                ref: handleRef,
                style: (0, $8nd05.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $4dba6b402693f5d6$export$2e2bcd8739ae039 = $4dba6b402693f5d6$var$Slide;




var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");
var $367f15b5d414b8d7$exports = {};

$parcel$defineInteropFlag($367f15b5d414b8d7$exports);

$parcel$export($367f15b5d414b8d7$exports, "getDrawerUtilityClass", () => $367f15b5d414b8d7$export$b801318a856c9cd2);
$parcel$export($367f15b5d414b8d7$exports, "default", () => $367f15b5d414b8d7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $367f15b5d414b8d7$export$b801318a856c9cd2(slot) {
    return (0, $4Cod0.default)('MuiDrawer', slot);
}
const $367f15b5d414b8d7$var$drawerClasses = (0, $beCSm.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $367f15b5d414b8d7$export$2e2bcd8739ae039 = $367f15b5d414b8d7$var$drawerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ed9758f3bc045cc$var$_excluded = [
    "BackdropProps"
], $1ed9758f3bc045cc$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $1ed9758f3bc045cc$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $1ed9758f3bc045cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $jTnBY.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $jTnBY.default)(anchor)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $367f15b5d414b8d7$export$b801318a856c9cd2), classes);
};
const $1ed9758f3bc045cc$var$DrawerRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $1ed9758f3bc045cc$var$DrawerDockedRoot = (0, $d8seH.default)('div', {
    shouldForwardProp: (0, $8Uq77.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $1ed9758f3bc045cc$var$DrawerPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $jTnBY.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $jTnBY.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === 'left' && {
        left: 0
    }, ownerState.anchor === 'top' && {
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        left: 0,
        bottom: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $1ed9758f3bc045cc$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $1ed9758f3bc045cc$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) ? $1ed9758f3bc045cc$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $1ed9758f3bc045cc$var$Drawer = /*#__PURE__*/ $acw62.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $4dba6b402693f5d6$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary' } = props, ModalProps = (0, $1En50.default)(props.ModalProps, $1ed9758f3bc045cc$var$_excluded), other = (0, $1En50.default)(props, $1ed9758f3bc045cc$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $1ed9758f3bc045cc$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $1ed9758f3bc045cc$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerPaper, (0, $8nd05.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $9QePP.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerDockedRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        direction: $1ed9758f3bc045cc$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerDockedRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerRoot, (0, $8nd05.default)({
        BackdropProps: (0, $8nd05.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $9QePP.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $1ed9758f3bc045cc$export$2e2bcd8739ae039 = $1ed9758f3bc045cc$var$Drawer;



'use client';
$parcel$exportWildcard($957158966c1dd989$exports, $367f15b5d414b8d7$exports);


var $1c63081f73fd2072$exports = {};

$parcel$defineInteropFlag($1c63081f73fd2072$exports);

$parcel$export($1c63081f73fd2072$exports, "default", () => $2426d7556721cbb6$export$2e2bcd8739ae039);
$parcel$export($1c63081f73fd2072$exports, "fabClasses", () => $a206933548dacbdf$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");
var $a206933548dacbdf$exports = {};

$parcel$defineInteropFlag($a206933548dacbdf$exports);

$parcel$export($a206933548dacbdf$exports, "getFabUtilityClass", () => $a206933548dacbdf$export$e2cfa0ca4bce1fc2);
$parcel$export($a206933548dacbdf$exports, "default", () => $a206933548dacbdf$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a206933548dacbdf$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $4Cod0.default)('MuiFab', slot);
}
const $a206933548dacbdf$var$fabClasses = (0, $beCSm.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $a206933548dacbdf$export$2e2bcd8739ae039 = $a206933548dacbdf$var$fabClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2426d7556721cbb6$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $2426d7556721cbb6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $jTnBY.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $a206933548dacbdf$export$e2cfa0ca4bce1fc2), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $2426d7556721cbb6$var$FabRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $jTnBY.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $8nd05.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $a206933548dacbdf$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === 'small' && {
        width: 40,
        height: 40
    }, ownerState.size === 'medium' && {
        width: 48,
        height: 48
    }, ownerState.variant === 'extended' && {
        borderRadius: 24,
        padding: '0 16px',
        width: 'auto',
        minHeight: 'auto',
        minWidth: 48,
        height: 48
    }, ownerState.variant === 'extended' && ownerState.size === 'small' && {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === 'extended' && ownerState.size === 'medium' && {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme: theme })=>({
        [`&.${(0, $a206933548dacbdf$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const $2426d7556721cbb6$var$Fab = /*#__PURE__*/ $acw62.forwardRef(function Fab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular' } = props, other = (0, $1En50.default)(props, $2426d7556721cbb6$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $2426d7556721cbb6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2426d7556721cbb6$var$FabRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
var $2426d7556721cbb6$export$2e2bcd8739ae039 = $2426d7556721cbb6$var$Fab;



'use client';
$parcel$exportWildcard($1c63081f73fd2072$exports, $a206933548dacbdf$exports);


var $3dce7e103df60065$exports = {};

$parcel$defineInteropFlag($3dce7e103df60065$exports);

$parcel$export($3dce7e103df60065$exports, "default", () => $5e5a92158e7d9bd4$export$2e2bcd8739ae039);

'use client';


var $cd8865c776d8094c$exports = {};

$parcel$defineInteropFlag($cd8865c776d8094c$exports);

$parcel$export($cd8865c776d8094c$exports, "default", () => $bb335d5457c07f5b$export$2e2bcd8739ae039);
$parcel$export($cd8865c776d8094c$exports, "filledInputClasses", () => $b0b42157daacd8b1$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $032c0e7078a9cb7d$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1En50.default)(props, $032c0e7078a9cb7d$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $032c0e7078a9cb7d$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;


function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}





var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $jTnBY.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9b9dde6aa920e08c$export$ef57d5c8ca2278f6), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $d8seH.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $8nd05.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03fc756f7adfd498$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $8nd05.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $032c0e7078a9cb7d$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b0b42157daacd8b1$export$3331e419f1a48437), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $8nd05.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}, .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;



'use client';
$parcel$exportWildcard($cd8865c776d8094c$exports, $b0b42157daacd8b1$exports);


var $d86eed44238f23f0$exports = {};

$parcel$defineInteropFlag($d86eed44238f23f0$exports);

$parcel$export($d86eed44238f23f0$exports, "default", () => $bcd22a386c6068c0$export$2e2bcd8739ae039);
$parcel$export($d86eed44238f23f0$exports, "useFormControl", () => $946238fa82894619$export$2e2bcd8739ae039);
$parcel$export($d86eed44238f23f0$exports, "formControlClasses", () => $ce03a37a8cfb980d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $jTnBY = parcelRequire("jTnBY");


var $ce03a37a8cfb980d$exports = {};

$parcel$defineInteropFlag($ce03a37a8cfb980d$exports);

$parcel$export($ce03a37a8cfb980d$exports, "getFormControlUtilityClasses", () => $ce03a37a8cfb980d$export$149c8b8bab2289d1);
$parcel$export($ce03a37a8cfb980d$exports, "default", () => $ce03a37a8cfb980d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ce03a37a8cfb980d$export$149c8b8bab2289d1), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $1e4827e2a850b1f0$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props, true) || (0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;




'use client';
$parcel$exportWildcard($d86eed44238f23f0$exports, $ce03a37a8cfb980d$exports);


var $d26f188d49f0430b$exports = {};

$parcel$defineInteropFlag($d26f188d49f0430b$exports);

$parcel$export($d26f188d49f0430b$exports, "default", () => $1a034abd43bd8eee$export$2e2bcd8739ae039);
$parcel$export($d26f188d49f0430b$exports, "formControlLabelClasses", () => $5cff6b4166fff27c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");



var $6hiu6 = parcelRequire("6hiu6");

var $8NnpI = parcelRequire("8NnpI");

var $lWAfe = parcelRequire("lWAfe");

var $fbH80 = parcelRequire("fbH80");

var $ayMG0 = parcelRequire("ayMG0");
const $18e20c6a989db8b9$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $18e20c6a989db8b9$var$defaultTheme = (0, $8NnpI.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $18e20c6a989db8b9$var$defaultCreateStyledComponent = (0, $10ae0b8a52224565$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $18e20c6a989db8b9$var$useThemePropsDefault(props) {
    return (0, $568aba12ccdf91ea$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $18e20c6a989db8b9$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $18e20c6a989db8b9$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $18e20c6a989db8b9$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $18e20c6a989db8b9$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $lWAfe.handleBreakpoints)({
        theme: theme
    }, (0, $lWAfe.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $fbH80.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $lWAfe.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $fbH80.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$18e20c6a989db8b9$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $fbH80.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $lWAfe.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $18e20c6a989db8b9$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $18e20c6a989db8b9$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $18e20c6a989db8b9$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($18e20c6a989db8b9$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $6hiu6.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $1En50.default)(props, $18e20c6a989db8b9$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: divider ? $18e20c6a989db8b9$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $231d58234d437bc0$var$Stack = (0, $18e20c6a989db8b9$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;




var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $5cff6b4166fff27c$exports = {};

$parcel$defineInteropFlag($5cff6b4166fff27c$exports);

$parcel$export($5cff6b4166fff27c$exports, "getFormControlLabelUtilityClasses", () => $5cff6b4166fff27c$export$717666c39ec07e12);
$parcel$export($5cff6b4166fff27c$exports, "default", () => $5cff6b4166fff27c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a034abd43bd8eee$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5cff6b4166fff27c$export$717666c39ec07e12), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $1a034abd43bd8eee$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $9QePP.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;



'use client';
$parcel$exportWildcard($d26f188d49f0430b$exports, $5cff6b4166fff27c$exports);


var $85d9ff6e52a65e06$exports = {};

$parcel$defineInteropFlag($85d9ff6e52a65e06$exports);

$parcel$export($85d9ff6e52a65e06$exports, "default", () => $5042f159189dda87$export$2e2bcd8739ae039);
$parcel$export($85d9ff6e52a65e06$exports, "formGroupClasses", () => $de580948e3d734b1$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $de580948e3d734b1$exports = {};

$parcel$defineInteropFlag($de580948e3d734b1$exports);

$parcel$export($de580948e3d734b1$exports, "getFormGroupUtilityClass", () => $de580948e3d734b1$export$d72d4cbdc30b331f);
$parcel$export($de580948e3d734b1$exports, "default", () => $de580948e3d734b1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $beCSm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5042f159189dda87$var$_excluded = [
    "className",
    "row"
];
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $de580948e3d734b1$export$d72d4cbdc30b331f), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $1En50.default)(props, $5042f159189dda87$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;



'use client';
$parcel$exportWildcard($85d9ff6e52a65e06$exports, $de580948e3d734b1$exports);


var $34da7bc50263d1b5$exports = {};

$parcel$defineInteropFlag($34da7bc50263d1b5$exports);

$parcel$export($34da7bc50263d1b5$exports, "default", () => $d23aa5c3ca6913fb$export$2e2bcd8739ae039);
$parcel$export($34da7bc50263d1b5$exports, "formHelperTextClasses", () => $a46b344d341d82c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $jTnBY = parcelRequire("jTnBY");
var $a46b344d341d82c0$exports = {};

$parcel$defineInteropFlag($a46b344d341d82c0$exports);

$parcel$export($a46b344d341d82c0$exports, "getFormHelperTextUtilityClasses", () => $a46b344d341d82c0$export$a394fa61b1d583a9);
$parcel$export($a46b344d341d82c0$exports, "default", () => $a46b344d341d82c0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a46b344d341d82c0$export$a394fa61b1d583a9), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $1En50.default)(props, $d23aa5c3ca6913fb$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;



'use client';
$parcel$exportWildcard($34da7bc50263d1b5$exports, $a46b344d341d82c0$exports);


var $98ce88637df666c4$exports = {};

$parcel$defineInteropFlag($98ce88637df666c4$exports);

$parcel$export($98ce88637df666c4$exports, "default", () => $9b0ab7de0d37835d$export$2e2bcd8739ae039);
$parcel$export($98ce88637df666c4$exports, "formLabelClasses", () => $c678fac155df4fc3$export$2e2bcd8739ae039);
var $9b0ab7de0d37835d$exports = {};

$parcel$defineInteropFlag($9b0ab7de0d37835d$exports);

$parcel$export($9b0ab7de0d37835d$exports, "FormLabelRoot", () => $9b0ab7de0d37835d$export$aa5bc7f8a4705b27);
$parcel$export($9b0ab7de0d37835d$exports, "default", () => $9b0ab7de0d37835d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $c678fac155df4fc3$exports = {};

$parcel$defineInteropFlag($c678fac155df4fc3$exports);

$parcel$export($c678fac155df4fc3$exports, "getFormLabelUtilityClasses", () => $c678fac155df4fc3$export$f7d501e40371cd17);
$parcel$export($c678fac155df4fc3$exports, "default", () => $c678fac155df4fc3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c678fac155df4fc3$export$f7d501e40371cd17), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;



'use client';
$parcel$exportWildcard($98ce88637df666c4$exports, $9b0ab7de0d37835d$exports);
$parcel$exportWildcard($98ce88637df666c4$exports, $c678fac155df4fc3$exports);


var $5d07c0b3a49e1daf$exports = {};

$parcel$defineInteropFlag($5d07c0b3a49e1daf$exports);

$parcel$export($5d07c0b3a49e1daf$exports, "default", () => $9450fbc34cc5b2ea$export$2e2bcd8739ae039);
$parcel$export($5d07c0b3a49e1daf$exports, "gridClasses", () => $f35b8acab3fc2f62$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($5d07c0b3a49e1daf$exports, $f35b8acab3fc2f62$exports);


var $201f04058620a74b$exports = {};

$parcel$defineInteropFlag($201f04058620a74b$exports);

$parcel$export($201f04058620a74b$exports, "default", () => $92254a0e483a5b59$export$2e2bcd8739ae039);
$parcel$export($201f04058620a74b$exports, "grid2Classes", () => $2bdbee5607533674$export$2e2bcd8739ae039);


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");




var $6hiu6 = parcelRequire("6hiu6");

var $8NnpI = parcelRequire("8NnpI");

var $8nd05 = parcelRequire("8nd05");
const $9dafa7d59f4fcead$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $9dafa7d59f4fcead$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $9dafa7d59f4fcead$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.indexOf(key) !== -1) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $b0888878a081f1eb$var$appendLevel(level) {
    if (!level) return '';
    return `Level${level}`;
}
function $b0888878a081f1eb$var$isNestedContainer(ownerState) {
    return ownerState.unstable_level > 0 && ownerState.container;
}
function $b0888878a081f1eb$var$createGetSelfSpacing(ownerState) {
    return function getSelfSpacing(axis) {
        return `var(--Grid-${axis}Spacing${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level)})`;
    };
}
function $b0888878a081f1eb$var$createGetParentSpacing(ownerState) {
    return function getParentSpacing(axis) {
        if (ownerState.unstable_level === 0) return `var(--Grid-${axis}Spacing)`;
        return `var(--Grid-${axis}Spacing${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level - 1)})`;
    };
}
function $b0888878a081f1eb$var$getParentColumns(ownerState) {
    if (ownerState.unstable_level === 0) return `var(--Grid-columns)`;
    return `var(--Grid-columns${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level - 1)})`;
}
const $b0888878a081f1eb$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const getSelfSpacing = $b0888878a081f1eb$var$createGetSelfSpacing(ownerState);
    const styles = {};
    (0, $9dafa7d59f4fcead$export$e04173f1577f18b7)(theme.breakpoints, ownerState.gridSize, (appendStyle, value)=>{
        let style = {};
        if (value === true) style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / ${$b0888878a081f1eb$var$getParentColumns(ownerState)}${$b0888878a081f1eb$var$isNestedContainer(ownerState) ? ` + ${getSelfSpacing('column')}` : ''})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $b0888878a081f1eb$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $9dafa7d59f4fcead$export$e04173f1577f18b7)(theme.breakpoints, ownerState.gridOffset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / ${$b0888878a081f1eb$var$getParentColumns(ownerState)})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $b0888878a081f1eb$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = $b0888878a081f1eb$var$isNestedContainer(ownerState) ? {
        [`--Grid-columns${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level)}`]: $b0888878a081f1eb$var$getParentColumns(ownerState)
    } : {
        '--Grid-columns': 12
    };
    (0, $9dafa7d59f4fcead$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        appendStyle(styles, {
            [`--Grid-columns${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level)}`]: value
        });
    });
    return styles;
};
const $b0888878a081f1eb$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $b0888878a081f1eb$var$createGetParentSpacing(ownerState);
    const styles = $b0888878a081f1eb$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-rowSpacing${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing('row')
    } : {};
    (0, $9dafa7d59f4fcead$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        var _theme$spacing;
        appendStyle(styles, {
            [`--Grid-rowSpacing${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level)}`]: typeof value === 'string' ? value : (_theme$spacing = theme.spacing) == null ? void 0 : _theme$spacing.call(theme, value)
        });
    });
    return styles;
};
const $b0888878a081f1eb$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $b0888878a081f1eb$var$createGetParentSpacing(ownerState);
    const styles = $b0888878a081f1eb$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-columnSpacing${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing('column')
    } : {};
    (0, $9dafa7d59f4fcead$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        var _theme$spacing2;
        appendStyle(styles, {
            [`--Grid-columnSpacing${$b0888878a081f1eb$var$appendLevel(ownerState.unstable_level)}`]: typeof value === 'string' ? value : (_theme$spacing2 = theme.spacing) == null ? void 0 : _theme$spacing2.call(theme, value)
        });
    });
    return styles;
};
const $b0888878a081f1eb$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $9dafa7d59f4fcead$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $b0888878a081f1eb$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    const getSelfSpacing = $b0888878a081f1eb$var$createGetSelfSpacing(ownerState);
    const getParentSpacing = $b0888878a081f1eb$var$createGetParentSpacing(ownerState);
    return (0, $8nd05.default)({
        minWidth: 0,
        boxSizing: 'border-box'
    }, ownerState.container && (0, $8nd05.default)({
        display: 'flex',
        flexWrap: 'wrap'
    }, ownerState.wrap && ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }, {
        margin: `calc(${getSelfSpacing('row')} / -2) calc(${getSelfSpacing('column')} / -2)`
    }, ownerState.disableEqualOverflow && {
        margin: `calc(${getSelfSpacing('row')} * -1) 0px 0px calc(${getSelfSpacing('column')} * -1)`
    }), (!ownerState.container || $b0888878a081f1eb$var$isNestedContainer(ownerState)) && (0, $8nd05.default)({
        padding: `calc(${getParentSpacing('row')} / 2) calc(${getParentSpacing('column')} / 2)`
    }, (ownerState.disableEqualOverflow || ownerState.parentDisableEqualOverflow) && {
        padding: `${getParentSpacing('row')} 0px 0px ${getParentSpacing('column')}`
    }));
};
const $b0888878a081f1eb$export$e2d1175061442d38 = (gridSize)=>{
    const classNames = [];
    Object.entries(gridSize).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $b0888878a081f1eb$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $b0888878a081f1eb$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};



var $ayMG0 = parcelRequire("ayMG0");
const $6eaba778cafc88ef$var$_excluded = [
    "className",
    "children",
    "columns",
    "container",
    "component",
    "direction",
    "wrap",
    "spacing",
    "rowSpacing",
    "columnSpacing",
    "disableEqualOverflow",
    "unstable_level"
];
const $6eaba778cafc88ef$var$defaultTheme = (0, $8NnpI.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $6eaba778cafc88ef$var$defaultCreateStyledComponent = (0, $10ae0b8a52224565$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $6eaba778cafc88ef$var$useThemePropsDefault(props) {
    return (0, $568aba12ccdf91ea$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $6eaba778cafc88ef$var$defaultTheme
    });
}
function $6eaba778cafc88ef$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $6eaba778cafc88ef$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $6eaba778cafc88ef$var$useThemePropsDefault, componentName: componentName = 'MuiGrid' } = options;
    const GridOverflowContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, gridSize: gridSize } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $b0888878a081f1eb$export$a7c8efbe2b138a60)(direction),
                ...(0, $b0888878a081f1eb$export$e2d1175061442d38)(gridSize),
                ...container ? (0, $b0888878a081f1eb$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const GridRoot = createStyledComponent((0, $b0888878a081f1eb$export$ccc4d4a4923f1b06), (0, $b0888878a081f1eb$export$a89c28919b8e3bb5), (0, $b0888878a081f1eb$export$68c4dad72dd49c74), (0, $b0888878a081f1eb$export$84053369756c53db), (0, $b0888878a081f1eb$export$2a0a3c01032b3f4), (0, $b0888878a081f1eb$export$810b8c3ab5d46bf), (0, $b0888878a081f1eb$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        var _inProps$columns, _inProps$spacing, _ref, _inProps$rowSpacing, _ref2, _inProps$columnSpacin, _ref3, _disableEqualOverflow;
        const theme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)();
        const themeProps = useThemeProps(inProps);
        const props = (0, $6hiu6.default)(themeProps); // `color` type conflicts with html color attribute.
        const overflow = $acw62.useContext(GridOverflowContext);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, disableEqualOverflow: themeDisableEqualOverflow, unstable_level: level = 0 } = props, rest = (0, $1En50.default)(props, $6eaba778cafc88ef$var$_excluded);
        // Because `disableEqualOverflow` can be set from the theme's defaultProps, the **nested** grid should look at the instance props instead.
        let disableEqualOverflow = themeDisableEqualOverflow;
        if (level && themeDisableEqualOverflow !== undefined) disableEqualOverflow = inProps.disableEqualOverflow;
        // collect breakpoints related props because they can be customized from the theme.
        const gridSize = {};
        const gridOffset = {};
        const other = {};
        Object.entries(rest).forEach(([key, val])=>{
            if (theme.breakpoints.values[key] !== undefined) gridSize[key] = val;
            else if (theme.breakpoints.values[key.replace('Offset', '')] !== undefined) gridOffset[key.replace('Offset', '')] = val;
            else other[key] = val;
        });
        const columns = (_inProps$columns = inProps.columns) != null ? _inProps$columns : level ? undefined : columnsProp;
        const spacing = (_inProps$spacing = inProps.spacing) != null ? _inProps$spacing : level ? undefined : spacingProp;
        const rowSpacing = (_ref = (_inProps$rowSpacing = inProps.rowSpacing) != null ? _inProps$rowSpacing : inProps.spacing) != null ? _ref : level ? undefined : rowSpacingProp;
        const columnSpacing = (_ref2 = (_inProps$columnSpacin = inProps.columnSpacing) != null ? _inProps$columnSpacin : inProps.spacing) != null ? _ref2 : level ? undefined : columnSpacingProp;
        const ownerState = (0, $8nd05.default)({}, props, {
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            gridSize: gridSize,
            gridOffset: gridOffset,
            disableEqualOverflow: (_ref3 = (_disableEqualOverflow = disableEqualOverflow) != null ? _disableEqualOverflow : overflow) != null ? _ref3 : false,
            // use context value if exists.
            parentDisableEqualOverflow: overflow // for nested grid
        });
        const classes = useUtilityClasses(ownerState, theme);
        let result = /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, (0, $8nd05.default)({
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: $acw62.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $acw62.isValidElement(child) && (0, $37dfa52af4926933$export$2e2bcd8739ae039)(child, [
                    'Grid'
                ])) {
                    var _unstable_level, _child$props;
                    return /*#__PURE__*/ $acw62.cloneElement(child, {
                        unstable_level: (_unstable_level = (_child$props = child.props) == null ? void 0 : _child$props.unstable_level) != null ? _unstable_level : level + 1
                    });
                }
                return child;
            })
        }));
        if (disableEqualOverflow !== undefined && disableEqualOverflow !== (overflow != null ? overflow : false)) // There are 2 possibilities that should wrap with the GridOverflowContext to communicate with the nested grids:
        // 1. It is the root grid with `disableEqualOverflow`.
        // 2. It is a nested grid with different `disableEqualOverflow` from the context.
        result = /*#__PURE__*/ (0, $ayMG0.jsx)(GridOverflowContext.Provider, {
            value: disableEqualOverflow,
            children: result
        });
        return result;
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $92254a0e483a5b59$var$Grid2 = (0, $6eaba778cafc88ef$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiGrid2',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    componentName: 'MuiGrid2',
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid2'
        })
});
var $92254a0e483a5b59$export$2e2bcd8739ae039 = $92254a0e483a5b59$var$Grid2;


var $dcb094eab2a3d336$exports = {};


var $2bdbee5607533674$exports = {};

$parcel$defineInteropFlag($2bdbee5607533674$exports);

$parcel$export($2bdbee5607533674$exports, "getGrid2UtilityClass", () => $2bdbee5607533674$export$1a261f9d3420df3);
$parcel$export($2bdbee5607533674$exports, "default", () => $2bdbee5607533674$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2bdbee5607533674$export$1a261f9d3420df3(slot) {
    return (0, $4Cod0.default)('MuiGrid2', slot);
}
const $2bdbee5607533674$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $2bdbee5607533674$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $2bdbee5607533674$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $2bdbee5607533674$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $2bdbee5607533674$var$grid2Classes = (0, $beCSm.default)('MuiGrid2', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$2bdbee5607533674$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$2bdbee5607533674$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$2bdbee5607533674$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$2bdbee5607533674$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$2bdbee5607533674$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$2bdbee5607533674$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$2bdbee5607533674$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$2bdbee5607533674$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $2bdbee5607533674$export$2e2bcd8739ae039 = $2bdbee5607533674$var$grid2Classes;


'use client';
$parcel$exportWildcard($201f04058620a74b$exports, $dcb094eab2a3d336$exports);
$parcel$exportWildcard($201f04058620a74b$exports, $2bdbee5607533674$exports);


var $012b35560897a029$exports = {};

$parcel$defineInteropFlag($012b35560897a029$exports);

$parcel$export($012b35560897a029$exports, "default", () => $d6f4882a3b1c59f2$export$2e2bcd8739ae039);

'use client';


var $3b8fd1b752839fb4$exports = {};

$parcel$defineInteropFlag($3b8fd1b752839fb4$exports);

$parcel$export($3b8fd1b752839fb4$exports, "default", () => $63ab04e863ebf1a5$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $0c8dae23e679323d$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $acw62.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $0c8dae23e679323d$var$maybeReactUseSyncExternalStore = $acw62.useSyncExternalStore;
function $0c8dae23e679323d$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $acw62.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $acw62.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $0c8dae23e679323d$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $0c8dae23e679323d$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $3c4de721067b1c27$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $414753394dff993c$export$2e2bcd8739ae039)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $0c8dae23e679323d$var$maybeReactUseSyncExternalStore !== undefined ? $0c8dae23e679323d$var$useMediaQueryNew : $0c8dae23e679323d$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $ayMG0 = parcelRequire("ayMG0");
const $98a73c32eec3fc68$var$_excluded = [
    "initialWidth",
    "width"
];
const $98a73c32eec3fc68$var$breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $98a73c32eec3fc68$export$da34bb2ed94165a0 = (breakpoint, width, inclusive = true)=>{
    if (inclusive) return $98a73c32eec3fc68$var$breakpointKeys.indexOf(breakpoint) <= $98a73c32eec3fc68$var$breakpointKeys.indexOf(width);
    return $98a73c32eec3fc68$var$breakpointKeys.indexOf(breakpoint) < $98a73c32eec3fc68$var$breakpointKeys.indexOf(width);
};
const $98a73c32eec3fc68$export$43a67ae92cf379e6 = (breakpoint, width, inclusive = false)=>{
    if (inclusive) return $98a73c32eec3fc68$var$breakpointKeys.indexOf(width) <= $98a73c32eec3fc68$var$breakpointKeys.indexOf(breakpoint);
    return $98a73c32eec3fc68$var$breakpointKeys.indexOf(width) < $98a73c32eec3fc68$var$breakpointKeys.indexOf(breakpoint);
};
const $98a73c32eec3fc68$var$withWidth = (options = {})=>(Component)=>{
        const { withTheme: withThemeOption = false, noSSR: noSSR = false, initialWidth: initialWidthOption } = options;
        function WithWidth(props) {
            const contextTheme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
            const theme = props.theme || contextTheme;
            const _getThemeProps = (0, $414753394dff993c$export$2e2bcd8739ae039)({
                theme: theme,
                name: 'MuiWithWidth',
                props: props
            }), { initialWidth: initialWidth, width: width } = _getThemeProps, other = (0, $1En50.default)(_getThemeProps, $98a73c32eec3fc68$var$_excluded);
            const [mountedState, setMountedState] = $acw62.useState(false);
            (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
                setMountedState(true);
            }, []);
            /**
     * innerWidth |xs      sm      md      lg      xl
     *            |-------|-------|-------|-------|------>
     * width      |  xs   |  sm   |  md   |  lg   |  xl
     */ const keys = theme.breakpoints.keys.slice().reverse();
            const widthComputed = keys.reduce((output, key)=>{
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const matches = (0, $0c8dae23e679323d$export$2e2bcd8739ae039)(theme.breakpoints.up(key));
                return !output && matches ? key : output;
            }, null);
            const more = (0, $8nd05.default)({
                width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
            }, withThemeOption ? {
                theme: theme
            } : {}, other);
            // When rendering the component on the server,
            // we have no idea about the client browser screen width.
            // In order to prevent blinks and help the reconciliation of the React tree
            // we are not rendering the child component.
            //
            // An alternative is to use the `initialWidth` property.
            if (more.width === undefined) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, (0, $8nd05.default)({}, more));
        }
        return WithWidth;
    };
var $98a73c32eec3fc68$export$2e2bcd8739ae039 = $98a73c32eec3fc68$var$withWidth;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $aa46a7e554b20bdc$var$HiddenJs(props) {
    const { children: children, only: only, width: width } = props;
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    let visible = true;
    // `only` check is faster to get out sooner if used.
    if (only) {
        if (Array.isArray(only)) for(let i = 0; i < only.length; i += 1){
            const breakpoint = only[i];
            if (width === breakpoint) {
                visible = false;
                break;
            }
        }
        else if (only && width === only) visible = false;
    }
    // Allow `only` to be combined with other props. If already hidden, no need to check others.
    if (visible) // determine visibility based on the smallest size up
    for(let i = 0; i < theme.breakpoints.keys.length; i += 1){
        const breakpoint = theme.breakpoints.keys[i];
        const breakpointUp = props[`${breakpoint}Up`];
        const breakpointDown = props[`${breakpoint}Down`];
        if (breakpointUp && (0, $98a73c32eec3fc68$export$da34bb2ed94165a0)(breakpoint, width) || breakpointDown && (0, $98a73c32eec3fc68$export$43a67ae92cf379e6)(breakpoint, width)) {
            visible = false;
            break;
        }
    }
    if (!visible) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: children
    });
}
var $aa46a7e554b20bdc$export$2e2bcd8739ae039 = (0, $98a73c32eec3fc68$export$2e2bcd8739ae039)()($aa46a7e554b20bdc$var$HiddenJs);



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $06ea04095c7a0356$export$4e2a49a61317f42(slot) {
    return (0, $4Cod0.default)('PrivateHiddenCss', slot);
}
const $06ea04095c7a0356$var$hiddenCssClasses = (0, $beCSm.default)('PrivateHiddenCss', [
    'root',
    'xlDown',
    'xlUp',
    'onlyXl',
    'lgDown',
    'lgUp',
    'onlyLg',
    'mdDown',
    'mdUp',
    'onlyMd',
    'smDown',
    'smUp',
    'onlySm',
    'xsDown',
    'xsUp',
    'onlyXs'
]);
var $06ea04095c7a0356$export$2e2bcd8739ae039 = $06ea04095c7a0356$var$hiddenCssClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $eddbbdfd7a1b9492$var$_excluded = [
    "children",
    "className",
    "only"
];
const $eddbbdfd7a1b9492$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, breakpoints: breakpoints } = ownerState;
    const slots = {
        root: [
            'root',
            ...breakpoints.map(({ breakpoint: breakpoint, dir: dir })=>{
                return dir === 'only' ? `${dir}${(0, $jTnBY.default)(breakpoint)}` : `${breakpoint}${(0, $jTnBY.default)(dir)}`;
            })
        ]
    };
    return (0, $8Indx.default)(slots, (0, $06ea04095c7a0356$export$4e2a49a61317f42), classes);
};
const $eddbbdfd7a1b9492$var$HiddenCssRoot = (0, $d8seH.default)('div', {
    name: 'PrivateHiddenCss',
    slot: 'Root'
})(({ theme: theme, ownerState: ownerState })=>{
    const hidden = {
        display: 'none'
    };
    return (0, $8nd05.default)({}, ownerState.breakpoints.map(({ breakpoint: breakpoint, dir: dir })=>{
        if (dir === 'only') return {
            [theme.breakpoints.only(breakpoint)]: hidden
        };
        return dir === 'up' ? {
            [theme.breakpoints.up(breakpoint)]: hidden
        } : {
            [theme.breakpoints.down(breakpoint)]: hidden
        };
    }).reduce((r, o)=>{
        Object.keys(o).forEach((k)=>{
            r[k] = o[k];
        });
        return r;
    }, {}));
});
/**
 * @ignore - internal component.
 */ function $eddbbdfd7a1b9492$var$HiddenCss(props) {
    const { children: children, className: className, only: only } = props, other = (0, $1En50.default)(props, $eddbbdfd7a1b9492$var$_excluded);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const breakpoints = [];
    for(let i = 0; i < theme.breakpoints.keys.length; i += 1){
        const breakpoint = theme.breakpoints.keys[i];
        const breakpointUp = other[`${breakpoint}Up`];
        const breakpointDown = other[`${breakpoint}Down`];
        if (breakpointUp) breakpoints.push({
            breakpoint: breakpoint,
            dir: 'up'
        });
        if (breakpointDown) breakpoints.push({
            breakpoint: breakpoint,
            dir: 'down'
        });
    }
    if (only) {
        const onlyBreakpoints = Array.isArray(only) ? only : [
            only
        ];
        onlyBreakpoints.forEach((breakpoint)=>{
            breakpoints.push({
                breakpoint: breakpoint,
                dir: 'only'
            });
        });
    }
    const ownerState = (0, $8nd05.default)({}, props, {
        breakpoints: breakpoints
    });
    const classes = $eddbbdfd7a1b9492$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eddbbdfd7a1b9492$var$HiddenCssRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        children: children
    });
}
var $eddbbdfd7a1b9492$export$2e2bcd8739ae039 = $eddbbdfd7a1b9492$var$HiddenCss;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $63ab04e863ebf1a5$var$_excluded = [
    "implementation",
    "lgDown",
    "lgUp",
    "mdDown",
    "mdUp",
    "smDown",
    "smUp",
    "xlDown",
    "xlUp",
    "xsDown",
    "xsUp"
];
function $63ab04e863ebf1a5$var$Hidden(props) {
    const { implementation: implementation = 'js', lgDown: lgDown = false, lgUp: lgUp = false, mdDown: mdDown = false, mdUp: mdUp = false, smDown: smDown = false, smUp: smUp = false, xlDown: xlDown = false, xlUp: xlUp = false, xsDown: xsDown = false, xsUp: xsUp = false } = props, other = (0, $1En50.default)(props, $63ab04e863ebf1a5$var$_excluded);
    if (implementation === 'js') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa46a7e554b20bdc$export$2e2bcd8739ae039), (0, $8nd05.default)({
        lgDown: lgDown,
        lgUp: lgUp,
        mdDown: mdDown,
        mdUp: mdUp,
        smDown: smDown,
        smUp: smUp,
        xlDown: xlDown,
        xlUp: xlUp,
        xsDown: xsDown,
        xsUp: xsUp
    }, other));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eddbbdfd7a1b9492$export$2e2bcd8739ae039), (0, $8nd05.default)({
        lgDown: lgDown,
        lgUp: lgUp,
        mdDown: mdDown,
        mdUp: mdUp,
        smDown: smDown,
        smUp: smUp,
        xlDown: xlDown,
        xlUp: xlUp,
        xsDown: xsDown,
        xsUp: xsUp
    }, other));
}
var $63ab04e863ebf1a5$export$2e2bcd8739ae039 = $63ab04e863ebf1a5$var$Hidden;


'use client';


var $2b59c24f9f8bf5b3$exports = {};

$parcel$defineInteropFlag($2b59c24f9f8bf5b3$exports);

$parcel$export($2b59c24f9f8bf5b3$exports, "default", () => $93c87ddcceadf9a1$export$2e2bcd8739ae039);
$parcel$export($2b59c24f9f8bf5b3$exports, "iconClasses", () => $63302c123a5539bd$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");
var $63302c123a5539bd$exports = {};

$parcel$defineInteropFlag($63302c123a5539bd$exports);

$parcel$export($63302c123a5539bd$exports, "getIconUtilityClass", () => $63302c123a5539bd$export$e7545bb336f9a5fc);
$parcel$export($63302c123a5539bd$exports, "default", () => $63302c123a5539bd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $63302c123a5539bd$export$e7545bb336f9a5fc(slot) {
    return (0, $4Cod0.default)('MuiIcon', slot);
}
const $63302c123a5539bd$var$iconClasses = (0, $beCSm.default)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $63302c123a5539bd$export$2e2bcd8739ae039 = $63302c123a5539bd$var$iconClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $93c87ddcceadf9a1$var$_excluded = [
    "baseClassName",
    "className",
    "color",
    "component",
    "fontSize"
];
const $93c87ddcceadf9a1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $63302c123a5539bd$export$e7545bb336f9a5fc), classes);
};
const $93c87ddcceadf9a1$var$IconRoot = (0, $d8seH.default)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        fontSize: ({
            inherit: 'inherit',
            small: theme.typography.pxToRem(20),
            medium: theme.typography.pxToRem(24),
            large: theme.typography.pxToRem(36)
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: ({
            primary: (theme.vars || theme).palette.primary.main,
            secondary: (theme.vars || theme).palette.secondary.main,
            info: (theme.vars || theme).palette.info.main,
            success: (theme.vars || theme).palette.success.main,
            warning: (theme.vars || theme).palette.warning.main,
            action: (theme.vars || theme).palette.action.active,
            error: (theme.vars || theme).palette.error.main,
            disabled: (theme.vars || theme).palette.action.disabled,
            inherit: undefined
        })[ownerState.color]
    }));
const $93c87ddcceadf9a1$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function Icon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName: baseClassName = 'material-icons', className: className, color: color = 'inherit', component: Component = 'span', fontSize: fontSize = 'medium' } = props, other = (0, $1En50.default)(props, $93c87ddcceadf9a1$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    });
    const classes = $93c87ddcceadf9a1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($93c87ddcceadf9a1$var$IconRoot, (0, $8nd05.default)({
        as: Component,
        className: (0, $9QePP.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref
    }, other));
});
$93c87ddcceadf9a1$var$Icon.muiName = 'Icon';
var $93c87ddcceadf9a1$export$2e2bcd8739ae039 = $93c87ddcceadf9a1$var$Icon;



'use client';
$parcel$exportWildcard($2b59c24f9f8bf5b3$exports, $63302c123a5539bd$exports);


var $5d932794c82c2fcf$exports = {};

$parcel$defineInteropFlag($5d932794c82c2fcf$exports);

$parcel$export($5d932794c82c2fcf$exports, "default", () => $71c322247f7fbf93$export$2e2bcd8739ae039);
$parcel$export($5d932794c82c2fcf$exports, "iconButtonClasses", () => $e40d2047b7c1e09d$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($5d932794c82c2fcf$exports, $e40d2047b7c1e09d$exports);


var $9f7a092074edd6d0$exports = {};

$parcel$defineInteropFlag($9f7a092074edd6d0$exports);

$parcel$export($9f7a092074edd6d0$exports, "default", () => $975a1cffa46f382b$export$2e2bcd8739ae039);
$parcel$export($9f7a092074edd6d0$exports, "imageListClasses", () => $90d45e39fe6c23d3$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $8Indx = parcelRequire("8Indx");


var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $90d45e39fe6c23d3$exports = {};

$parcel$defineInteropFlag($90d45e39fe6c23d3$exports);

$parcel$export($90d45e39fe6c23d3$exports, "getImageListUtilityClass", () => $90d45e39fe6c23d3$export$4bf8a556b1c87116);
$parcel$export($90d45e39fe6c23d3$exports, "default", () => $90d45e39fe6c23d3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $90d45e39fe6c23d3$export$4bf8a556b1c87116(slot) {
    return (0, $4Cod0.default)('MuiImageList', slot);
}
const $90d45e39fe6c23d3$var$imageListClasses = (0, $beCSm.default)('MuiImageList', [
    'root',
    'masonry',
    'quilted',
    'standard',
    'woven'
]);
var $90d45e39fe6c23d3$export$2e2bcd8739ae039 = $90d45e39fe6c23d3$var$imageListClasses;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $97ad778fce8cd0d8$var$ImageListContext = /*#__PURE__*/ $acw62.createContext({});
var $97ad778fce8cd0d8$export$2e2bcd8739ae039 = $97ad778fce8cd0d8$var$ImageListContext;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $975a1cffa46f382b$var$_excluded = [
    "children",
    "className",
    "cols",
    "component",
    "rowHeight",
    "gap",
    "style",
    "variant"
];
const $975a1cffa46f382b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $90d45e39fe6c23d3$export$4bf8a556b1c87116), classes);
};
const $975a1cffa46f382b$var$ImageListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiImageList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState })=>{
    return (0, $8nd05.default)({
        display: 'grid',
        overflowY: 'auto',
        listStyle: 'none',
        padding: 0,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch'
    }, ownerState.variant === 'masonry' && {
        display: 'block'
    });
});
const $975a1cffa46f382b$var$ImageList = /*#__PURE__*/ $acw62.forwardRef(function ImageList(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiImageList'
    });
    const { children: children, className: className, cols: cols = 2, component: component = 'ul', rowHeight: rowHeight = 'auto', gap: gap = 4, style: styleProp, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $975a1cffa46f382b$var$_excluded);
    const contextValue = $acw62.useMemo(()=>({
            rowHeight: rowHeight,
            gap: gap,
            variant: variant
        }), [
        rowHeight,
        gap,
        variant
    ]);
    $acw62.useEffect(()=>{}, []);
    const style = variant === 'masonry' ? (0, $8nd05.default)({
        columnCount: cols,
        columnGap: gap
    }, styleProp) : (0, $8nd05.default)({
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: gap
    }, styleProp);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        gap: gap,
        rowHeight: rowHeight,
        variant: variant
    });
    const classes = $975a1cffa46f382b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($975a1cffa46f382b$var$ImageListRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, classes[variant], className),
        ref: ref,
        style: style,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97ad778fce8cd0d8$export$2e2bcd8739ae039).Provider, {
            value: contextValue,
            children: children
        })
    }));
});
var $975a1cffa46f382b$export$2e2bcd8739ae039 = $975a1cffa46f382b$var$ImageList;



'use client';
$parcel$exportWildcard($9f7a092074edd6d0$exports, $90d45e39fe6c23d3$exports);


var $9462e0a2246915d8$exports = {};

$parcel$defineInteropFlag($9462e0a2246915d8$exports);

$parcel$export($9462e0a2246915d8$exports, "default", () => $aeb7a529fa95e8e4$export$2e2bcd8739ae039);
$parcel$export($9462e0a2246915d8$exports, "imageListItemClasses", () => $348e5c185e9c1cc5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $8Indx = parcelRequire("8Indx");


var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $348e5c185e9c1cc5$exports = {};

$parcel$defineInteropFlag($348e5c185e9c1cc5$exports);

$parcel$export($348e5c185e9c1cc5$exports, "getImageListItemUtilityClass", () => $348e5c185e9c1cc5$export$85358568b821ddac);
$parcel$export($348e5c185e9c1cc5$exports, "default", () => $348e5c185e9c1cc5$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $348e5c185e9c1cc5$export$85358568b821ddac(slot) {
    return (0, $4Cod0.default)('MuiImageListItem', slot);
}
const $348e5c185e9c1cc5$var$imageListItemClasses = (0, $beCSm.default)('MuiImageListItem', [
    'root',
    'img',
    'standard',
    'woven',
    'masonry',
    'quilted'
]);
var $348e5c185e9c1cc5$export$2e2bcd8739ae039 = $348e5c185e9c1cc5$var$imageListItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $aeb7a529fa95e8e4$var$_excluded = [
    "children",
    "className",
    "cols",
    "component",
    "rows",
    "style"
];
const $aeb7a529fa95e8e4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        img: [
            'img'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $348e5c185e9c1cc5$export$85358568b821ddac), classes);
};
const $aeb7a529fa95e8e4$var$ImageListItemRoot = (0, $d8seH.default)('li', {
    name: 'MuiImageListItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $348e5c185e9c1cc5$export$2e2bcd8739ae039).img}`]: styles.img
            },
            styles.root,
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        position: 'relative'
    }, ownerState.variant === 'standard' && {
        // For titlebar under list item
        display: 'flex',
        flexDirection: 'column'
    }, ownerState.variant === 'woven' && {
        height: '100%',
        alignSelf: 'center',
        '&:nth-of-type(even)': {
            height: '70%'
        }
    }, {
        [`& .${(0, $348e5c185e9c1cc5$export$2e2bcd8739ae039).img}`]: (0, $8nd05.default)({
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            display: 'block'
        }, ownerState.variant === 'standard' && {
            height: 'auto',
            flexGrow: 1
        })
    }));
const $aeb7a529fa95e8e4$var$ImageListItem = /*#__PURE__*/ $acw62.forwardRef(function ImageListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiImageListItem'
    });
    // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"
    const { children: children, className: className, cols: cols = 1, component: component = 'li', rows: rows = 1, style: style } = props, other = (0, $1En50.default)(props, $aeb7a529fa95e8e4$var$_excluded);
    const { rowHeight: rowHeight = 'auto', gap: gap, variant: variant } = $acw62.useContext((0, $97ad778fce8cd0d8$export$2e2bcd8739ae039));
    let height = 'auto';
    if (variant === 'woven') height = undefined;
    else if (rowHeight !== 'auto') height = rowHeight * rows + gap * (rows - 1);
    const ownerState = (0, $8nd05.default)({}, props, {
        cols: cols,
        component: component,
        gap: gap,
        rowHeight: rowHeight,
        rows: rows,
        variant: variant
    });
    const classes = $aeb7a529fa95e8e4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aeb7a529fa95e8e4$var$ImageListItemRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, classes[variant], className),
        ref: ref,
        style: (0, $8nd05.default)({
            height: height,
            gridColumnEnd: variant !== 'masonry' ? `span ${cols}` : undefined,
            gridRowEnd: variant !== 'masonry' ? `span ${rows}` : undefined,
            marginBottom: variant === 'masonry' ? gap : undefined,
            breakInside: variant === 'masonry' ? 'avoid' : undefined
        }, style),
        ownerState: ownerState
    }, other, {
        children: $acw62.Children.map(children, (child)=>{
            if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
            if (child.type === 'img' || (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Image'
            ])) return /*#__PURE__*/ $acw62.cloneElement(child, {
                className: (0, $9QePP.default)(classes.img, child.props.className)
            });
            return child;
        })
    }));
});
var $aeb7a529fa95e8e4$export$2e2bcd8739ae039 = $aeb7a529fa95e8e4$var$ImageListItem;



'use client';
$parcel$exportWildcard($9462e0a2246915d8$exports, $348e5c185e9c1cc5$exports);


var $1ddcf58ca2045c53$exports = {};

$parcel$defineInteropFlag($1ddcf58ca2045c53$exports);

$parcel$export($1ddcf58ca2045c53$exports, "default", () => $fb46f5873d57d468$export$2e2bcd8739ae039);
$parcel$export($1ddcf58ca2045c53$exports, "imageListItemBarClasses", () => $ac30e3552d9f386c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");
var $ac30e3552d9f386c$exports = {};

$parcel$defineInteropFlag($ac30e3552d9f386c$exports);

$parcel$export($ac30e3552d9f386c$exports, "getImageListItemBarUtilityClass", () => $ac30e3552d9f386c$export$44884823e5621662);
$parcel$export($ac30e3552d9f386c$exports, "default", () => $ac30e3552d9f386c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ac30e3552d9f386c$export$44884823e5621662(slot) {
    return (0, $4Cod0.default)('MuiImageListItemBar', slot);
}
const $ac30e3552d9f386c$var$imageListItemBarClasses = (0, $beCSm.default)('MuiImageListItemBar', [
    'root',
    'positionBottom',
    'positionTop',
    'positionBelow',
    'titleWrap',
    'titleWrapBottom',
    'titleWrapTop',
    'titleWrapBelow',
    'titleWrapActionPosLeft',
    'titleWrapActionPosRight',
    'title',
    'subtitle',
    'actionIcon',
    'actionIconActionPosLeft',
    'actionIconActionPosRight'
]);
var $ac30e3552d9f386c$export$2e2bcd8739ae039 = $ac30e3552d9f386c$var$imageListItemBarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fb46f5873d57d468$var$_excluded = [
    "actionIcon",
    "actionPosition",
    "className",
    "subtitle",
    "title",
    "position"
];
const $fb46f5873d57d468$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position, actionIcon: actionIcon, actionPosition: actionPosition } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, $jTnBY.default)(position)}`
        ],
        titleWrap: [
            'titleWrap',
            `titleWrap${(0, $jTnBY.default)(position)}`,
            actionIcon && `titleWrapActionPos${(0, $jTnBY.default)(actionPosition)}`
        ],
        title: [
            'title'
        ],
        subtitle: [
            'subtitle'
        ],
        actionIcon: [
            'actionIcon',
            `actionIconActionPos${(0, $jTnBY.default)(actionPosition)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ac30e3552d9f386c$export$44884823e5621662), classes);
};
const $fb46f5873d57d468$var$ImageListItemBarRoot = (0, $d8seH.default)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $jTnBY.default)(ownerState.position)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $8nd05.default)({
        position: 'absolute',
        left: 0,
        right: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        fontFamily: theme.typography.fontFamily
    }, ownerState.position === 'bottom' && {
        bottom: 0
    }, ownerState.position === 'top' && {
        top: 0
    }, ownerState.position === 'below' && {
        position: 'relative',
        background: 'transparent',
        alignItems: 'normal'
    });
});
const $fb46f5873d57d468$var$ImageListItemBarTitleWrap = (0, $d8seH.default)('div', {
    name: 'MuiImageListItemBar',
    slot: 'TitleWrap',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.titleWrap,
            styles[`titleWrap${(0, $jTnBY.default)(ownerState.position)}`],
            ownerState.actionIcon && styles[`titleWrapActionPos${(0, $jTnBY.default)(ownerState.actionPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $8nd05.default)({
        flexGrow: 1,
        padding: '12px 16px',
        color: (theme.vars || theme).palette.common.white,
        overflow: 'hidden'
    }, ownerState.position === 'below' && {
        padding: '6px 0 12px',
        color: 'inherit'
    }, ownerState.actionIcon && ownerState.actionPosition === 'left' && {
        paddingLeft: 0
    }, ownerState.actionIcon && ownerState.actionPosition === 'right' && {
        paddingRight: 0
    });
});
const $fb46f5873d57d468$var$ImageListItemBarTitle = (0, $d8seH.default)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Title',
    overridesResolver: (props, styles)=>styles.title
})(({ theme: theme })=>{
    return {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: '24px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
});
const $fb46f5873d57d468$var$ImageListItemBarSubtitle = (0, $d8seH.default)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Subtitle',
    overridesResolver: (props, styles)=>styles.subtitle
})(({ theme: theme })=>{
    return {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
});
const $fb46f5873d57d468$var$ImageListItemBarActionIcon = (0, $d8seH.default)('div', {
    name: 'MuiImageListItemBar',
    slot: 'ActionIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actionIcon,
            styles[`actionIconActionPos${(0, $jTnBY.default)(ownerState.actionPosition)}`]
        ];
    }
})(({ ownerState: ownerState })=>{
    return (0, $8nd05.default)({}, ownerState.actionPosition === 'left' && {
        order: -1
    });
});
const $fb46f5873d57d468$var$ImageListItemBar = /*#__PURE__*/ $acw62.forwardRef(function ImageListItemBar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiImageListItemBar'
    });
    const { actionIcon: actionIcon, actionPosition: actionPosition = 'right', className: className, subtitle: subtitle, title: title, position: position = 'bottom' } = props, other = (0, $1En50.default)(props, $fb46f5873d57d468$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        position: position,
        actionPosition: actionPosition
    });
    const classes = $fb46f5873d57d468$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($fb46f5873d57d468$var$ImageListItemBarRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($fb46f5873d57d468$var$ImageListItemBarTitleWrap, {
                ownerState: ownerState,
                className: classes.titleWrap,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarTitle, {
                        className: classes.title,
                        children: title
                    }),
                    subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarSubtitle, {
                        className: classes.subtitle,
                        children: subtitle
                    }) : null
                ]
            }),
            actionIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarActionIcon, {
                ownerState: ownerState,
                className: classes.actionIcon,
                children: actionIcon
            }) : null
        ]
    }));
});
var $fb46f5873d57d468$export$2e2bcd8739ae039 = $fb46f5873d57d468$var$ImageListItemBar;



'use client';
$parcel$exportWildcard($1ddcf58ca2045c53$exports, $ac30e3552d9f386c$exports);


var $a9f7a5eb14f1ec4f$exports = {};

$parcel$defineInteropFlag($a9f7a5eb14f1ec4f$exports);

$parcel$export($a9f7a5eb14f1ec4f$exports, "default", () => $76910a07fd4ac4fe$export$2e2bcd8739ae039);
$parcel$export($a9f7a5eb14f1ec4f$exports, "inputClasses", () => $80c774dd7f29b734$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $80c774dd7f29b734$export$cdb270390122322b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $8nd05.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}, .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;



'use client';
$parcel$exportWildcard($a9f7a5eb14f1ec4f$exports, $80c774dd7f29b734$exports);


var $6afb4578ee9180cf$exports = {};

$parcel$defineInteropFlag($6afb4578ee9180cf$exports);

$parcel$export($6afb4578ee9180cf$exports, "default", () => $d0c64ff513a9933f$export$2e2bcd8739ae039);
$parcel$export($6afb4578ee9180cf$exports, "inputAdornmentClasses", () => $f3e589c60baacdec$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");




var $d8seH = parcelRequire("d8seH");
var $f3e589c60baacdec$exports = {};

$parcel$defineInteropFlag($f3e589c60baacdec$exports);

$parcel$export($f3e589c60baacdec$exports, "getInputAdornmentUtilityClass", () => $f3e589c60baacdec$export$4b135a4b3a6c4550);
$parcel$export($f3e589c60baacdec$exports, "default", () => $f3e589c60baacdec$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3e589c60baacdec$export$4b135a4b3a6c4550), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1En50.default)(props, $d0c64ff513a9933f$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;



'use client';
$parcel$exportWildcard($6afb4578ee9180cf$exports, $f3e589c60baacdec$exports);


var $71f12fb6991c55a7$exports = {};

$parcel$defineInteropFlag($71f12fb6991c55a7$exports);

$parcel$export($71f12fb6991c55a7$exports, "default", () => $69d1b2c99a8dc649$export$2e2bcd8739ae039);
$parcel$export($71f12fb6991c55a7$exports, "inputBaseClasses", () => $9b9dde6aa920e08c$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($71f12fb6991c55a7$exports, $9b9dde6aa920e08c$exports);


var $eabe871db5ab5d36$exports = {};

$parcel$defineInteropFlag($eabe871db5ab5d36$exports);

$parcel$export($eabe871db5ab5d36$exports, "default", () => $09846a8ab0aba36e$export$2e2bcd8739ae039);
$parcel$export($eabe871db5ab5d36$exports, "inputLabelClasses", () => $9313ead0c5e2e8ca$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");




var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");
var $9313ead0c5e2e8ca$exports = {};

$parcel$defineInteropFlag($9313ead0c5e2e8ca$exports);

$parcel$export($9313ead0c5e2e8ca$exports, "getInputLabelUtilityClasses", () => $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f);
$parcel$export($9313ead0c5e2e8ca$exports, "default", () => $9313ead0c5e2e8ca$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;



'use client';
$parcel$exportWildcard($eabe871db5ab5d36$exports, $9313ead0c5e2e8ca$exports);


var $1d34600829c15c5d$exports = {};

$parcel$defineInteropFlag($1d34600829c15c5d$exports);

$parcel$export($1d34600829c15c5d$exports, "default", () => $0fa40ac3f678fedb$export$2e2bcd8739ae039);
$parcel$export($1d34600829c15c5d$exports, "linearProgressClasses", () => $fd1aab3db3503e90$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $kTdcz = parcelRequire("kTdcz");


var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $fd1aab3db3503e90$exports = {};

$parcel$defineInteropFlag($fd1aab3db3503e90$exports);

$parcel$export($fd1aab3db3503e90$exports, "getLinearProgressUtilityClass", () => $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6);
$parcel$export($fd1aab3db3503e90$exports, "default", () => $fd1aab3db3503e90$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $4Cod0.default)('MuiLinearProgress', slot);
}
const $fd1aab3db3503e90$var$linearProgressClasses = (0, $beCSm.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $fd1aab3db3503e90$export$2e2bcd8739ae039 = $fd1aab3db3503e90$var$linearProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0fa40ac3f678fedb$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $0fa40ac3f678fedb$var$_ = (t)=>t, $0fa40ac3f678fedb$var$_t, $0fa40ac3f678fedb$var$_t2, $0fa40ac3f678fedb$var$_t3, $0fa40ac3f678fedb$var$_t4, $0fa40ac3f678fedb$var$_t5, $0fa40ac3f678fedb$var$_t6;
const $0fa40ac3f678fedb$var$TRANSITION_DURATION = 4; // seconds
const $0fa40ac3f678fedb$var$indeterminate1Keyframe = (0, $jjlaj.keyframes)($0fa40ac3f678fedb$var$_t || ($0fa40ac3f678fedb$var$_t = $0fa40ac3f678fedb$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $0fa40ac3f678fedb$var$indeterminate2Keyframe = (0, $jjlaj.keyframes)($0fa40ac3f678fedb$var$_t2 || ($0fa40ac3f678fedb$var$_t2 = $0fa40ac3f678fedb$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $0fa40ac3f678fedb$var$bufferKeyframe = (0, $jjlaj.keyframes)($0fa40ac3f678fedb$var$_t3 || ($0fa40ac3f678fedb$var$_t3 = $0fa40ac3f678fedb$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $0fa40ac3f678fedb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $jTnBY.default)(color)}`
        ],
        bar1: [
            'bar',
            `barColor${(0, $jTnBY.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            variant !== 'buffer' && `barColor${(0, $jTnBY.default)(color)}`,
            variant === 'buffer' && `color${(0, $jTnBY.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6), classes);
};
const $0fa40ac3f678fedb$var$getColorShade = (theme, color)=>{
    if (color === 'inherit') return 'currentColor';
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $kTdcz.lighten)(theme.palette[color].main, 0.62) : (0, $kTdcz.darken)(theme.palette[color].main, 0.5);
};
const $0fa40ac3f678fedb$var$LinearProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        '@media print': {
            colorAdjust: 'exact'
        },
        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
        backgroundColor: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3
        }
    }, ownerState.variant === 'buffer' && {
        backgroundColor: 'transparent'
    }, ownerState.variant === 'query' && {
        transform: 'rotate(180deg)'
    }));
const $0fa40ac3f678fedb$var$LinearProgressDashed = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $0fa40ac3f678fedb$var$getColorShade(theme, ownerState.color);
    return (0, $8nd05.default)({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%'
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px'
    });
}, (0, $jjlaj.css)($0fa40ac3f678fedb$var$_t4 || ($0fa40ac3f678fedb$var$_t4 = $0fa40ac3f678fedb$var$_`
    animation: ${0} 3s infinite linear;
  `), $0fa40ac3f678fedb$var$bufferKeyframe));
const $0fa40ac3f678fedb$var$LinearProgressBar1 = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'determinate' && {
        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === 'buffer' && {
        zIndex: 1,
        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $jjlaj.css)($0fa40ac3f678fedb$var$_t5 || ($0fa40ac3f678fedb$var$_t5 = $0fa40ac3f678fedb$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $0fa40ac3f678fedb$var$indeterminate1Keyframe));
const $0fa40ac3f678fedb$var$LinearProgressBar2 = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left'
    }, ownerState.variant !== 'buffer' && {
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, ownerState.variant === 'buffer' && {
        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $jjlaj.css)($0fa40ac3f678fedb$var$_t6 || ($0fa40ac3f678fedb$var$_t6 = $0fa40ac3f678fedb$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $0fa40ac3f678fedb$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $0fa40ac3f678fedb$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate' } = props, other = (0, $1En50.default)(props, $0fa40ac3f678fedb$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $0fa40ac3f678fedb$var$useUtilityClasses(ownerState);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0fa40ac3f678fedb$var$LinearProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $0fa40ac3f678fedb$export$2e2bcd8739ae039 = $0fa40ac3f678fedb$var$LinearProgress;



'use client';
$parcel$exportWildcard($1d34600829c15c5d$exports, $fd1aab3db3503e90$exports);


var $b542247f17114115$exports = {};

$parcel$defineInteropFlag($b542247f17114115$exports);

$parcel$export($b542247f17114115$exports, "default", () => $731ce78e0c47d0a7$export$2e2bcd8739ae039);
$parcel$export($b542247f17114115$exports, "linkClasses", () => $fd904517f2a78af6$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($b542247f17114115$exports, $fd904517f2a78af6$exports);


var $d3bbc7f720921ac7$exports = {};

$parcel$defineInteropFlag($d3bbc7f720921ac7$exports);

$parcel$export($d3bbc7f720921ac7$exports, "default", () => $640cd381f5e8b3ea$export$2e2bcd8739ae039);
$parcel$export($d3bbc7f720921ac7$exports, "listClasses", () => $adbbc5717e0d0350$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($d3bbc7f720921ac7$exports, $adbbc5717e0d0350$exports);


var $cf8c523bf26d7f9a$exports = {};

$parcel$defineInteropFlag($cf8c523bf26d7f9a$exports);

$parcel$export($cf8c523bf26d7f9a$exports, "default", () => $f92832698674c928$export$2e2bcd8739ae039);
$parcel$export($cf8c523bf26d7f9a$exports, "listItemClasses", () => $b23cfd2067550897$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $kTdcz = parcelRequire("kTdcz");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");





var $b23cfd2067550897$exports = {};

$parcel$defineInteropFlag($b23cfd2067550897$exports);

$parcel$export($b23cfd2067550897$exports, "getListItemUtilityClass", () => $b23cfd2067550897$export$5682c366c0c669d9);
$parcel$export($b23cfd2067550897$exports, "default", () => $b23cfd2067550897$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;


var $a1fd72c2634274a8$exports = {};

$parcel$defineInteropFlag($a1fd72c2634274a8$exports);

$parcel$export($a1fd72c2634274a8$exports, "getListItemButtonUtilityClass", () => $a1fd72c2634274a8$export$c09531d8563c67a5);
$parcel$export($a1fd72c2634274a8$exports, "default", () => $a1fd72c2634274a8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $558d665a4b71ad4c$exports = {};

$parcel$defineInteropFlag($558d665a4b71ad4c$exports);

$parcel$export($558d665a4b71ad4c$exports, "getListItemSecondaryActionClassesUtilityClass", () => $558d665a4b71ad4c$export$ccdb26aeba48a86e);
$parcel$export($558d665a4b71ad4c$exports, "default", () => $558d665a4b71ad4c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9924235485c5a222$var$_excluded = [
    "className"
];
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $558d665a4b71ad4c$export$ccdb26aeba48a86e), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $9924235485c5a222$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f92832698674c928$var$_excluded = [
    "className"
], $f92832698674c928$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b23cfd2067550897$export$5682c366c0c669d9), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $8nd05.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $1En50.default)(props.ContainerProps, $f92832698674c928$var$_excluded), other = (0, $1En50.default)(props, $f92832698674c928$var$_excluded2);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $9QePP.default)((0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $4a35786d89db9dda$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, (0, $8nd05.default)({
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9924235485c5a222$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;



'use client';
$parcel$exportWildcard($cf8c523bf26d7f9a$exports, $b23cfd2067550897$exports);


var $4e03a092ccfc165d$exports = {};

$parcel$defineInteropFlag($4e03a092ccfc165d$exports);

$parcel$export($4e03a092ccfc165d$exports, "default", () => $5e1a7f5eff0ff3e8$export$2e2bcd8739ae039);
$parcel$export($4e03a092ccfc165d$exports, "listItemAvatarClasses", () => $9055a111c146fc9b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $9055a111c146fc9b$exports = {};

$parcel$defineInteropFlag($9055a111c146fc9b$exports);

$parcel$export($9055a111c146fc9b$exports, "getListItemAvatarUtilityClass", () => $9055a111c146fc9b$export$e4f04f80f2ce3fc0);
$parcel$export($9055a111c146fc9b$exports, "default", () => $9055a111c146fc9b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9055a111c146fc9b$export$e4f04f80f2ce3fc0(slot) {
    return (0, $4Cod0.default)('MuiListItemAvatar', slot);
}
const $9055a111c146fc9b$var$listItemAvatarClasses = (0, $beCSm.default)('MuiListItemAvatar', [
    'root',
    'alignItemsFlexStart'
]);
var $9055a111c146fc9b$export$2e2bcd8739ae039 = $9055a111c146fc9b$var$listItemAvatarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e1a7f5eff0ff3e8$var$_excluded = [
    "className"
];
const $5e1a7f5eff0ff3e8$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9055a111c146fc9b$export$e4f04f80f2ce3fc0), classes);
};
const $5e1a7f5eff0ff3e8$var$ListItemAvatarRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        minWidth: 56,
        flexShrink: 0
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $5e1a7f5eff0ff3e8$var$ListItemAvatar = /*#__PURE__*/ $acw62.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemAvatar'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $5e1a7f5eff0ff3e8$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $5e1a7f5eff0ff3e8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5e1a7f5eff0ff3e8$var$ListItemAvatarRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5e1a7f5eff0ff3e8$export$2e2bcd8739ae039 = $5e1a7f5eff0ff3e8$var$ListItemAvatar;



'use client';
$parcel$exportWildcard($4e03a092ccfc165d$exports, $9055a111c146fc9b$exports);


var $dc78ebeb7704024e$exports = {};

$parcel$defineInteropFlag($dc78ebeb7704024e$exports);

$parcel$export($dc78ebeb7704024e$exports, "default", () => $960931686a59e228$export$2e2bcd8739ae039);
$parcel$export($dc78ebeb7704024e$exports, "listItemButtonClasses", () => $a1fd72c2634274a8$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $960931686a59e228$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $960931686a59e228$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $960931686a59e228$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $a1fd72c2634274a8$export$c09531d8563c67a5), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $960931686a59e228$var$ListItemButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $960931686a59e228$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $960931686a59e228$var$ListItemButton = /*#__PURE__*/ $acw62.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $1En50.default)(props, $960931686a59e228$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $960931686a59e228$var$useUtilityClasses(ownerState);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($960931686a59e228$var$ListItemButtonRoot, (0, $8nd05.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $960931686a59e228$export$2e2bcd8739ae039 = $960931686a59e228$var$ListItemButton;



'use client';
$parcel$exportWildcard($dc78ebeb7704024e$exports, $a1fd72c2634274a8$exports);


var $1a27e69578e2c56e$exports = {};

$parcel$defineInteropFlag($1a27e69578e2c56e$exports);

$parcel$export($1a27e69578e2c56e$exports, "default", () => $83e175cb7e49d325$export$2e2bcd8739ae039);
$parcel$export($1a27e69578e2c56e$exports, "listItemIconClasses", () => $9c1b7b40cd19f5fe$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $83e175cb7e49d325$var$_excluded = [
    "className"
];
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9c1b7b40cd19f5fe$export$81478e24460c57f2), classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $83e175cb7e49d325$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $83e175cb7e49d325$export$2e2bcd8739ae039 = $83e175cb7e49d325$var$ListItemIcon;



'use client';
$parcel$exportWildcard($1a27e69578e2c56e$exports, $9c1b7b40cd19f5fe$exports);


var $377dc32070e7887f$exports = {};

$parcel$defineInteropFlag($377dc32070e7887f$exports);

$parcel$export($377dc32070e7887f$exports, "default", () => $9924235485c5a222$export$2e2bcd8739ae039);
$parcel$export($377dc32070e7887f$exports, "listItemSecondaryActionClasses", () => $558d665a4b71ad4c$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($377dc32070e7887f$exports, $558d665a4b71ad4c$exports);


var $9b22463c6c37319f$exports = {};

$parcel$defineInteropFlag($9b22463c6c37319f$exports);

$parcel$export($9b22463c6c37319f$exports, "default", () => $0d696835f9b43a35$export$2e2bcd8739ae039);
$parcel$export($9b22463c6c37319f$exports, "listItemTextClasses", () => $c01aa6ddbe5e68bd$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d696835f9b43a35$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c01aa6ddbe5e68bd$export$1061006a0db3aeb5), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $1En50.default)(props, $0d696835f9b43a35$var$_excluded);
    const { dense: dense } = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d696835f9b43a35$var$ListItemTextRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;



'use client';
$parcel$exportWildcard($9b22463c6c37319f$exports, $c01aa6ddbe5e68bd$exports);


var $0ee342703d01369e$exports = {};

$parcel$defineInteropFlag($0ee342703d01369e$exports);

$parcel$export($0ee342703d01369e$exports, "default", () => $5408b2039b9d572c$export$2e2bcd8739ae039);
$parcel$export($0ee342703d01369e$exports, "listSubheaderClasses", () => $d7f4cf29715b69dd$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($0ee342703d01369e$exports, $d7f4cf29715b69dd$exports);


var $03dfa491627f975c$exports = {};

$parcel$defineInteropFlag($03dfa491627f975c$exports);

$parcel$export($03dfa491627f975c$exports, "default", () => $364f3db28d8d2e79$export$2e2bcd8739ae039);
$parcel$export($03dfa491627f975c$exports, "menuClasses", () => $fb1e7d0ac8fac824$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($03dfa491627f975c$exports, $fb1e7d0ac8fac824$exports);


var $dd21c0ca7e345443$exports = {};

$parcel$defineInteropFlag($dd21c0ca7e345443$exports);

$parcel$export($dd21c0ca7e345443$exports, "default", () => $1ac984bce84b2164$export$2e2bcd8739ae039);
$parcel$export($dd21c0ca7e345443$exports, "menuItemClasses", () => $adff06ac3b11e066$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($dd21c0ca7e345443$exports, $adff06ac3b11e066$exports);


var $6225548018c22e00$exports = {};

$parcel$defineInteropFlag($6225548018c22e00$exports);

$parcel$export($6225548018c22e00$exports, "default", () => $fbb3fa0cdc277971$export$2e2bcd8739ae039);

'use client';


var $0e484d2d1153e25c$exports = {};

$parcel$defineInteropFlag($0e484d2d1153e25c$exports);

$parcel$export($0e484d2d1153e25c$exports, "default", () => $3e720f5cf13cfb0a$export$2e2bcd8739ae039);
$parcel$export($0e484d2d1153e25c$exports, "mobileStepperClasses", () => $3a5c9021f712a37c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");
var $3a5c9021f712a37c$exports = {};

$parcel$defineInteropFlag($3a5c9021f712a37c$exports);

$parcel$export($3a5c9021f712a37c$exports, "getMobileStepperUtilityClass", () => $3a5c9021f712a37c$export$af7da6d60955385e);
$parcel$export($3a5c9021f712a37c$exports, "default", () => $3a5c9021f712a37c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a5c9021f712a37c$export$af7da6d60955385e(slot) {
    return (0, $4Cod0.default)('MuiMobileStepper', slot);
}
const $3a5c9021f712a37c$var$mobileStepperClasses = (0, $beCSm.default)('MuiMobileStepper', [
    'root',
    'positionBottom',
    'positionTop',
    'positionStatic',
    'dots',
    'dot',
    'dotActive',
    'progress'
]);
var $3a5c9021f712a37c$export$2e2bcd8739ae039 = $3a5c9021f712a37c$var$mobileStepperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3e720f5cf13cfb0a$var$_excluded = [
    "activeStep",
    "backButton",
    "className",
    "LinearProgressProps",
    "nextButton",
    "position",
    "steps",
    "variant"
];
const $3e720f5cf13cfb0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, $jTnBY.default)(position)}`
        ],
        dots: [
            'dots'
        ],
        dot: [
            'dot'
        ],
        dotActive: [
            'dotActive'
        ],
        progress: [
            'progress'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3a5c9021f712a37c$export$af7da6d60955385e), classes);
};
const $3e720f5cf13cfb0a$var$MobileStepperRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiMobileStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $jTnBY.default)(ownerState.position)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: (theme.vars || theme).palette.background.default,
        padding: 8
    }, ownerState.position === 'bottom' && {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }, ownerState.position === 'top' && {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }));
const $3e720f5cf13cfb0a$var$MobileStepperDots = (0, $d8seH.default)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dots',
    overridesResolver: (props, styles)=>styles.dots
})(({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'dots' && {
        display: 'flex',
        flexDirection: 'row'
    }));
const $3e720f5cf13cfb0a$var$MobileStepperDot = (0, $d8seH.default)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dot',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'dotActive',
    overridesResolver: (props, styles)=>{
        const { dotActive: dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})(({ theme: theme, ownerState: ownerState, dotActive: dotActive })=>(0, $8nd05.default)({}, ownerState.variant === 'dots' && (0, $8nd05.default)({
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.action.disabled,
        borderRadius: '50%',
        width: 8,
        height: 8,
        margin: '0 2px'
    }, dotActive && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    })));
const $3e720f5cf13cfb0a$var$MobileStepperProgress = (0, $d8seH.default)((0, $0fa40ac3f678fedb$export$2e2bcd8739ae039), {
    name: 'MuiMobileStepper',
    slot: 'Progress',
    overridesResolver: (props, styles)=>styles.progress
})(({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'progress' && {
        width: '50%'
    }));
const $3e720f5cf13cfb0a$var$MobileStepper = /*#__PURE__*/ $acw62.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMobileStepper'
    });
    const { activeStep: activeStep = 0, backButton: backButton, className: className, LinearProgressProps: LinearProgressProps, nextButton: nextButton, position: position = 'bottom', steps: steps, variant: variant = 'dots' } = props, other = (0, $1En50.default)(props, $3e720f5cf13cfb0a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        activeStep: activeStep,
        position: position,
        variant: variant
    });
    let value;
    if (variant === 'progress') {
        if (steps === 1) value = 100;
        else value = Math.ceil(activeStep / (steps - 1) * 100);
    }
    const classes = $3e720f5cf13cfb0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($3e720f5cf13cfb0a$var$MobileStepperRoot, (0, $8nd05.default)({
        square: true,
        elevation: 0,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            backButton,
            variant === 'text' && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === 'dots' && /*#__PURE__*/ (0, $ayMG0.jsx)($3e720f5cf13cfb0a$var$MobileStepperDots, {
                ownerState: ownerState,
                className: classes.dots,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($3e720f5cf13cfb0a$var$MobileStepperDot, {
                        className: (0, $9QePP.default)(classes.dot, index === activeStep && classes.dotActive),
                        ownerState: ownerState,
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === 'progress' && /*#__PURE__*/ (0, $ayMG0.jsx)($3e720f5cf13cfb0a$var$MobileStepperProgress, (0, $8nd05.default)({
                ownerState: ownerState,
                className: classes.progress,
                variant: "determinate",
                value: value
            }, LinearProgressProps)),
            nextButton
        ]
    }));
});
var $3e720f5cf13cfb0a$export$2e2bcd8739ae039 = $3e720f5cf13cfb0a$var$MobileStepper;



'use client';
$parcel$exportWildcard($0e484d2d1153e25c$exports, $3a5c9021f712a37c$exports);


var $632e260cb6e75f90$exports = {};

$parcel$defineInteropFlag($632e260cb6e75f90$exports);

$parcel$export($632e260cb6e75f90$exports, "ModalManager", () => $52971d86e2bcd483$export$ce11c4ecd08cea67);
$parcel$export($632e260cb6e75f90$exports, "default", () => $0bdcbfecdf3275a2$export$2e2bcd8739ae039);
$parcel$export($632e260cb6e75f90$exports, "modalClasses", () => $0cea91a79e26c98a$export$2e2bcd8739ae039);



'use client';
$parcel$exportWildcard($632e260cb6e75f90$exports, $0cea91a79e26c98a$exports);


var $181b936a865fd5c4$exports = {};

$parcel$defineInteropFlag($181b936a865fd5c4$exports);

$parcel$export($181b936a865fd5c4$exports, "default", () => $3ca2173d4de87b59$export$2e2bcd8739ae039);
$parcel$export($181b936a865fd5c4$exports, "nativeSelectClasses", () => $49a1663d7631a8fa$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");
var $49a1663d7631a8fa$exports = {};

$parcel$defineInteropFlag($49a1663d7631a8fa$exports);

$parcel$export($49a1663d7631a8fa$exports, "getNativeSelectUtilityClasses", () => $49a1663d7631a8fa$export$1ee13051fd9e2ab5);
$parcel$export($49a1663d7631a8fa$exports, "default", () => $49a1663d7631a8fa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $49a1663d7631a8fa$export$1ee13051fd9e2ab5), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $8nd05.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;







var $1iOpW = parcelRequire("1iOpW");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3ca2173d4de87b59$var$_excluded = [
    "className",
    "children",
    "classes",
    "IconComponent",
    "input",
    "inputProps",
    "variant"
], $3ca2173d4de87b59$var$_excluded2 = [
    "root"
];
const $3ca2173d4de87b59$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $49a1663d7631a8fa$export$1ee13051fd9e2ab5), classes);
};
const $3ca2173d4de87b59$var$defaultInput = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), {});
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ const $3ca2173d4de87b59$var$NativeSelect = /*#__PURE__*/ $acw62.forwardRef(function NativeSelect(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiNativeSelect',
        props: inProps
    });
    const { className: className, children: children, classes: classesProp = {}, IconComponent: IconComponent = (0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), input: input = $3ca2173d4de87b59$var$defaultInput, inputProps: inputProps } = props, other = (0, $1En50.default)(props, $3ca2173d4de87b59$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: classesProp
    });
    const classes = $3ca2173d4de87b59$var$useUtilityClasses(ownerState);
    const otherClasses = (0, $1En50.default)(classesProp, $3ca2173d4de87b59$var$_excluded2);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(input, (0, $8nd05.default)({
            // Most of the logic is implemented in `NativeSelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent: (0, $db2c454fb2e8bc3c$export$2e2bcd8739ae039),
            inputProps: (0, $8nd05.default)({
                children: children,
                classes: otherClasses,
                IconComponent: IconComponent,
                variant: fcs.variant,
                type: undefined
            }, inputProps, input ? input.props.inputProps : {}),
            ref: ref
        }, other, {
            className: (0, $9QePP.default)(classes.root, input.props.className, className)
        }))
    });
});
$3ca2173d4de87b59$var$NativeSelect.muiName = 'Select';
var $3ca2173d4de87b59$export$2e2bcd8739ae039 = $3ca2173d4de87b59$var$NativeSelect;



'use client';
$parcel$exportWildcard($181b936a865fd5c4$exports, $49a1663d7631a8fa$exports);


var $95a7dbf177b90875$exports = {};

$parcel$defineInteropFlag($95a7dbf177b90875$exports);

$parcel$export($95a7dbf177b90875$exports, "default", () => $397ca82a6faac65f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * *   Escape hatch for broken dependencies not supporting SSR.
 * *   Improve the time-to-first paint on the client by only rendering above the fold.
 * *   Reduce the rendering time on the server.
 * *   Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/material-ui/api/no-ssr/)
 */ function $397ca82a6faac65f$var$NoSsr(props) {
    const { children: children, defer: defer = false, fallback: fallback = null } = props;
    const [mountedState, setMountedState] = $acw62.useState(false);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $acw62.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountedState ? children : fallback
    });
}
var $397ca82a6faac65f$export$2e2bcd8739ae039 = $397ca82a6faac65f$var$NoSsr;




var $d6009d8f79a7cefd$exports = {};

$parcel$defineInteropFlag($d6009d8f79a7cefd$exports);

$parcel$export($d6009d8f79a7cefd$exports, "default", () => $d5d55d2dd82639e9$export$2e2bcd8739ae039);
$parcel$export($d6009d8f79a7cefd$exports, "outlinedInputClasses", () => $6a1dc6d1d7e1816a$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6a1dc6d1d7e1816a$export$89922944c7227687), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $69d1b2c99a8dc649$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $8nd05.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).focused} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).error} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).disabled} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $746323a953600e78$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5d55d2dd82639e9$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;



'use client';
$parcel$exportWildcard($d6009d8f79a7cefd$exports, $6a1dc6d1d7e1816a$exports);


var $fb6bc293e767dac6$exports = {};

$parcel$defineInteropFlag($fb6bc293e767dac6$exports);

$parcel$export($fb6bc293e767dac6$exports, "default", () => $081224c8d3cb055f$export$2e2bcd8739ae039);
$parcel$export($fb6bc293e767dac6$exports, "paginationClasses", () => $e1ec0b0c4e143dec$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($fb6bc293e767dac6$exports, $e1ec0b0c4e143dec$exports);


var $448e339b1c87d651$exports = {};

$parcel$defineInteropFlag($448e339b1c87d651$exports);

$parcel$export($448e339b1c87d651$exports, "default", () => $6a273894865f8b08$export$2e2bcd8739ae039);
$parcel$export($448e339b1c87d651$exports, "paginationItemClasses", () => $6a3264dc4d579370$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($448e339b1c87d651$exports, $6a3264dc4d579370$exports);


var $e31a80f86c785b2c$exports = {};

$parcel$defineInteropFlag($e31a80f86c785b2c$exports);

$parcel$export($e31a80f86c785b2c$exports, "default", () => $595185d0d7275c3b$export$2e2bcd8739ae039);
$parcel$export($e31a80f86c785b2c$exports, "paperClasses", () => $4ec306d48089c2c9$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($e31a80f86c785b2c$exports, $4ec306d48089c2c9$exports);


var $236c5104463510ad$exports = {};

$parcel$defineInteropFlag($236c5104463510ad$exports);

$parcel$export($236c5104463510ad$exports, "default", () => $012baef8dc9ae9d0$export$2e2bcd8739ae039);
$parcel$export($236c5104463510ad$exports, "popoverClasses", () => $ea2c25a800e729b1$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($236c5104463510ad$exports, $012baef8dc9ae9d0$exports);
$parcel$exportWildcard($236c5104463510ad$exports, $ea2c25a800e729b1$exports);


var $ae19908c5516ff78$exports = {};

$parcel$defineInteropFlag($ae19908c5516ff78$exports);

$parcel$export($ae19908c5516ff78$exports, "default", () => $a4669aa090d445bd$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($ae19908c5516ff78$exports, $bb1b487b0ea8f7b1$exports);


var $944699a2e7967149$exports = {};

$parcel$defineInteropFlag($944699a2e7967149$exports);

$parcel$export($944699a2e7967149$exports, "default", () => $2117883cc21a32b2$export$2e2bcd8739ae039);



var $4230641a48862144$exports = {};

$parcel$defineInteropFlag($4230641a48862144$exports);

$parcel$export($4230641a48862144$exports, "default", () => $cb3af4fea2cad44e$export$2e2bcd8739ae039);
$parcel$export($4230641a48862144$exports, "radioClasses", () => $d9d692e9561f6352$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");


var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $03c2199a765ab5af$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e413843d0810bb75$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $d8seH.default)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $8Uq77.default)
})({
    position: 'relative',
    display: 'flex'
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $d8seH.default)((0, $03c2199a765ab5af$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $d8seH.default)((0, $e413843d0810bb75$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $6d9735fee3c00fe1$export$2e2bcd8739ae039 = $6d9735fee3c00fe1$var$RadioButtonIcon;



var $jTnBY = parcelRequire("jTnBY");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $f9f6bb9b992d33b5$export$2e2bcd8739ae039 = $f9f6bb9b992d33b5$var$RadioGroupContext;


'use client';
function $e9140607eee18105$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039));
}


var $d9d692e9561f6352$exports = {};

$parcel$defineInteropFlag($d9d692e9561f6352$exports);

$parcel$export($d9d692e9561f6352$exports, "getRadioUtilityClass", () => $d9d692e9561f6352$export$192f7b2363c77155);
$parcel$export($d9d692e9561f6352$exports, "default", () => $d9d692e9561f6352$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d9d692e9561f6352$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $beCSm.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$export$2e2bcd8739ae039 = $d9d692e9561f6352$var$radioClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $cb3af4fea2cad44e$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            size !== 'medium' && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8nd05.default)({}, classes, (0, $8Indx.default)(slots, (0, $d9d692e9561f6352$export$192f7b2363c77155), classes));
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className } = props, other = (0, $1En50.default)(props, $cb3af4fea2cad44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $e9140607eee18105$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $3d47321b9fcbcb38$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$RadioRoot, (0, $8nd05.default)({
        type: "radio",
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $cb3af4fea2cad44e$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $cb3af4fea2cad44e$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $cb3af4fea2cad44e$export$2e2bcd8739ae039 = $cb3af4fea2cad44e$var$Radio;



'use client';
$parcel$exportWildcard($4230641a48862144$exports, $d9d692e9561f6352$exports);


var $2331ccb4eb2af4bc$exports = {};

$parcel$defineInteropFlag($2331ccb4eb2af4bc$exports);

$parcel$export($2331ccb4eb2af4bc$exports, "default", () => $659f9ff12b4e3755$export$2e2bcd8739ae039);
$parcel$export($2331ccb4eb2af4bc$exports, "useRadioGroup", () => $e9140607eee18105$export$2e2bcd8739ae039);
$parcel$export($2331ccb4eb2af4bc$exports, "radioGroupClasses", () => $c550ce5d3f5617f8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $c550ce5d3f5617f8$exports = {};

$parcel$defineInteropFlag($c550ce5d3f5617f8$exports);

$parcel$export($c550ce5d3f5617f8$exports, "getRadioGroupUtilityClass", () => $c550ce5d3f5617f8$export$c4cff3a43f7cabb6);
$parcel$export($c550ce5d3f5617f8$exports, "default", () => $c550ce5d3f5617f8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c550ce5d3f5617f8$export$c4cff3a43f7cabb6(slot) {
    return (0, $4Cod0.default)('MuiRadioGroup', slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $beCSm.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $c550ce5d3f5617f8$export$2e2bcd8739ae039 = $c550ce5d3f5617f8$var$radioGroupClasses;







var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $659f9ff12b4e3755$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c550ce5d3f5617f8$export$c4cff3a43f7cabb6), classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $1En50.default)(props, $659f9ff12b4e3755$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), (0, $8nd05.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
var $659f9ff12b4e3755$export$2e2bcd8739ae039 = $659f9ff12b4e3755$var$RadioGroup;




'use client';
$parcel$exportWildcard($2331ccb4eb2af4bc$exports, $c550ce5d3f5617f8$exports);


var $fde33b68b1c0968e$exports = {};

$parcel$defineInteropFlag($fde33b68b1c0968e$exports);

$parcel$export($fde33b68b1c0968e$exports, "default", () => $a235763b3a7014ab$export$2e2bcd8739ae039);
$parcel$export($fde33b68b1c0968e$exports, "ratingClasses", () => $57fdaf8fdc94de34$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $1jJMI = parcelRequire("1jJMI");
const $0acaed42692b8720$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $0acaed42692b8720$export$2e2bcd8739ae039 = $0acaed42692b8720$var$visuallyHidden;




var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e974f6f757d51cd9$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $50542c5736b6354f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");
var $57fdaf8fdc94de34$exports = {};

$parcel$defineInteropFlag($57fdaf8fdc94de34$exports);

$parcel$export($57fdaf8fdc94de34$exports, "getRatingUtilityClass", () => $57fdaf8fdc94de34$export$2c22c4f65a44ac6b);
$parcel$export($57fdaf8fdc94de34$exports, "default", () => $57fdaf8fdc94de34$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $57fdaf8fdc94de34$export$2c22c4f65a44ac6b(slot) {
    return (0, $4Cod0.default)('MuiRating', slot);
}
const $57fdaf8fdc94de34$var$ratingClasses = (0, $beCSm.default)('MuiRating', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'readOnly',
    'disabled',
    'focusVisible',
    'visuallyHidden',
    'pristine',
    'label',
    'labelEmptyValueActive',
    'icon',
    'iconEmpty',
    'iconFilled',
    'iconHover',
    'iconFocus',
    'iconActive',
    'decimal'
]);
var $57fdaf8fdc94de34$export$2e2bcd8739ae039 = $57fdaf8fdc94de34$var$ratingClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a235763b3a7014ab$var$_excluded = [
    "value"
], $a235763b3a7014ab$var$_excluded2 = [
    "className",
    "defaultValue",
    "disabled",
    "emptyIcon",
    "emptyLabelText",
    "getLabelText",
    "highlightSelectedOnly",
    "icon",
    "IconContainerComponent",
    "max",
    "name",
    "onChange",
    "onChangeActive",
    "onMouseLeave",
    "onMouseMove",
    "precision",
    "readOnly",
    "size",
    "value"
];
function $a235763b3a7014ab$var$getDecimalPrecision(num) {
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $a235763b3a7014ab$var$roundValueToPrecision(value, precision) {
    if (value == null) return value;
    const nearest = Math.round(value / precision) * precision;
    return Number(nearest.toFixed($a235763b3a7014ab$var$getDecimalPrecision(precision)));
}
const $a235763b3a7014ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, size: size, readOnly: readOnly, disabled: disabled, emptyValueFocused: emptyValueFocused, focusVisible: focusVisible } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $jTnBY.default)(size)}`,
            disabled && 'disabled',
            focusVisible && 'focusVisible',
            readOnly && 'readOnly'
        ],
        label: [
            'label',
            'pristine'
        ],
        labelEmptyValue: [
            emptyValueFocused && 'labelEmptyValueActive'
        ],
        icon: [
            'icon'
        ],
        iconEmpty: [
            'iconEmpty'
        ],
        iconFilled: [
            'iconFilled'
        ],
        iconHover: [
            'iconHover'
        ],
        iconFocus: [
            'iconFocus'
        ],
        iconActive: [
            'iconActive'
        ],
        decimal: [
            'decimal'
        ],
        visuallyHidden: [
            'visuallyHidden'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $57fdaf8fdc94de34$export$2c22c4f65a44ac6b), classes);
};
const $a235763b3a7014ab$var$RatingRoot = (0, $d8seH.default)('span', {
    name: 'MuiRating',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $57fdaf8fdc94de34$export$2e2bcd8739ae039).visuallyHidden}`]: styles.visuallyHidden
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.readOnly && styles.readOnly
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        // Required to position the pristine input absolutely
        position: 'relative',
        fontSize: theme.typography.pxToRem(24),
        color: '#faaf00',
        cursor: 'pointer',
        textAlign: 'left',
        width: 'min-content',
        WebkitTapHighlightColor: 'transparent',
        [`&.${(0, $57fdaf8fdc94de34$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`&.${(0, $57fdaf8fdc94de34$export$2e2bcd8739ae039).focusVisible} .${(0, $57fdaf8fdc94de34$export$2e2bcd8739ae039).iconActive}`]: {
            outline: '1px solid #999'
        },
        [`& .${(0, $57fdaf8fdc94de34$export$2e2bcd8739ae039).visuallyHidden}`]: (0, $0acaed42692b8720$export$2e2bcd8739ae039)
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        fontSize: theme.typography.pxToRem(30)
    }, ownerState.readOnly && {
        pointerEvents: 'none'
    }));
const $a235763b3a7014ab$var$RatingLabel = (0, $d8seH.default)('label', {
    name: 'MuiRating',
    slot: 'Label',
    overridesResolver: ({ ownerState: ownerState }, styles)=>[
            styles.label,
            ownerState.emptyValueFocused && styles.labelEmptyValueActive
        ]
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        cursor: 'inherit'
    }, ownerState.emptyValueFocused && {
        top: 0,
        bottom: 0,
        position: 'absolute',
        outline: '1px solid #999',
        width: '100%'
    }));
const $a235763b3a7014ab$var$RatingIcon = (0, $d8seH.default)('span', {
    name: 'MuiRating',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.iconEmpty && styles.iconEmpty,
            ownerState.iconFilled && styles.iconFilled,
            ownerState.iconHover && styles.iconHover,
            ownerState.iconFocus && styles.iconFocus,
            ownerState.iconActive && styles.iconActive
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        // Fit wrapper to actual icon size.
        display: 'flex',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        // Fix mouseLeave issue.
        // https://github.com/facebook/react/issues/4492
        pointerEvents: 'none'
    }, ownerState.iconActive && {
        transform: 'scale(1.2)'
    }, ownerState.iconEmpty && {
        color: (theme.vars || theme).palette.action.disabled
    }));
const $a235763b3a7014ab$var$RatingDecimal = (0, $d8seH.default)('span', {
    name: 'MuiRating',
    slot: 'Decimal',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'iconActive',
    overridesResolver: (props, styles)=>{
        const { iconActive: iconActive } = props;
        return [
            styles.decimal,
            iconActive && styles.iconActive
        ];
    }
})(({ iconActive: iconActive })=>(0, $8nd05.default)({
        position: 'relative'
    }, iconActive && {
        transform: 'scale(1.2)'
    }));
function $a235763b3a7014ab$var$IconContainer(props) {
    const other = (0, $1En50.default)(props, $a235763b3a7014ab$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", (0, $8nd05.default)({}, other));
}
function $a235763b3a7014ab$var$RatingItem(props) {
    const { classes: classes, disabled: disabled, emptyIcon: emptyIcon, focus: focus, getLabelText: getLabelText, highlightSelectedOnly: highlightSelectedOnly, hover: hover, icon: icon, IconContainerComponent: IconContainerComponent, isActive: isActive, itemValue: itemValue, labelProps: labelProps, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, readOnly: readOnly, ownerState: ownerState, ratingValue: ratingValue, ratingValueRounded: ratingValueRounded } = props;
    const isFilled = highlightSelectedOnly ? itemValue === ratingValue : itemValue <= ratingValue;
    const isHovered = itemValue <= hover;
    const isFocused = itemValue <= focus;
    const isChecked = itemValue === ratingValueRounded;
    const id = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)();
    const container = /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingIcon, {
        as: IconContainerComponent,
        value: itemValue,
        className: (0, $9QePP.default)(classes.icon, isFilled ? classes.iconFilled : classes.iconEmpty, isHovered && classes.iconHover, isFocused && classes.iconFocus, isActive && classes.iconActive),
        ownerState: (0, $8nd05.default)({}, ownerState, {
            iconEmpty: !isFilled,
            iconFilled: isFilled,
            iconHover: isHovered,
            iconFocus: isFocused,
            iconActive: isActive
        }),
        children: emptyIcon && !isFilled ? emptyIcon : icon
    });
    if (readOnly) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", (0, $8nd05.default)({}, labelProps, {
        children: container
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($a235763b3a7014ab$var$RatingLabel, (0, $8nd05.default)({
                ownerState: (0, $8nd05.default)({}, ownerState, {
                    emptyValueFocused: undefined
                }),
                htmlFor: id
            }, labelProps, {
                children: [
                    container,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: getLabelText(itemValue)
                    })
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                className: classes.visuallyHidden,
                onFocus: onFocus,
                onBlur: onBlur,
                onChange: onChange,
                onClick: onClick,
                disabled: disabled,
                value: itemValue,
                id: id,
                type: "radio",
                name: name,
                checked: isChecked
            })
        ]
    });
}
const $a235763b3a7014ab$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e974f6f757d51cd9$export$2e2bcd8739ae039), {
    fontSize: "inherit"
});
const $a235763b3a7014ab$var$defaultEmptyIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50542c5736b6354f$export$2e2bcd8739ae039), {
    fontSize: "inherit"
});
function $a235763b3a7014ab$var$defaultLabelText(value) {
    return `${value} Star${value !== 1 ? 's' : ''}`;
}
const $a235763b3a7014ab$var$Rating = /*#__PURE__*/ $acw62.forwardRef(function Rating(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiRating',
        props: inProps
    });
    const { className: className, defaultValue: defaultValue = null, disabled: disabled = false, emptyIcon: emptyIcon = $a235763b3a7014ab$var$defaultEmptyIcon, emptyLabelText: emptyLabelText = 'Empty', getLabelText: getLabelText = $a235763b3a7014ab$var$defaultLabelText, highlightSelectedOnly: highlightSelectedOnly = false, icon: icon = $a235763b3a7014ab$var$defaultIcon, IconContainerComponent: IconContainerComponent = $a235763b3a7014ab$var$IconContainer, max: max = 5, name: nameProp, onChange: onChange, onChangeActive: onChangeActive, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, precision: precision = 1, readOnly: readOnly = false, size: size = 'medium', value: valueProp } = props, other = (0, $1En50.default)(props, $a235763b3a7014ab$var$_excluded2);
    const name = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(nameProp);
    const [valueDerived, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Rating'
    });
    const valueRounded = $a235763b3a7014ab$var$roundValueToPrecision(valueDerived, precision);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const [{ hover: hover, focus: focus }, setState] = $acw62.useState({
        hover: -1,
        focus: -1
    });
    let value = valueRounded;
    if (hover !== -1) value = hover;
    if (focus !== -1) value = focus;
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const rootRef = $acw62.useRef();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(focusVisibleRef, rootRef, ref);
    const handleMouseMove = (event)=>{
        if (onMouseMove) onMouseMove(event);
        const rootNode = rootRef.current;
        const { right: right, left: left, width: containerWidth } = rootNode.getBoundingClientRect();
        let percent;
        if (isRtl) percent = (right - event.clientX) / containerWidth;
        else percent = (event.clientX - left) / containerWidth;
        let newHover = $a235763b3a7014ab$var$roundValueToPrecision(max * percent + precision / 2, precision);
        newHover = (0, $1jJMI.default)(newHover, precision, max);
        setState((prev)=>prev.hover === newHover && prev.focus === newHover ? prev : {
                hover: newHover,
                focus: newHover
            });
        setFocusVisible(false);
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        const newHover = -1;
        setState({
            hover: newHover,
            focus: newHover
        });
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleChange = (event)=>{
        let newValue = event.target.value === '' ? null : parseFloat(event.target.value);
        // Give mouse priority over keyboard
        // Fix https://github.com/mui/material-ui/issues/22827
        if (hover !== -1) newValue = hover;
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    };
    const handleClear = (event)=>{
        // Ignore keyboard events
        // https://github.com/facebook/react/issues/7407
        if (event.clientX === 0 && event.clientY === 0) return;
        setState({
            hover: -1,
            focus: -1
        });
        setValueState(null);
        if (onChange && parseFloat(event.target.value) === valueRounded) onChange(event, null);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        const newFocus = parseFloat(event.target.value);
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const handleBlur = (event)=>{
        if (hover !== -1) return;
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        const newFocus = -1;
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const [emptyValueFocused, setEmptyValueFocused] = $acw62.useState(false);
    const ownerState = (0, $8nd05.default)({}, props, {
        defaultValue: defaultValue,
        disabled: disabled,
        emptyIcon: emptyIcon,
        emptyLabelText: emptyLabelText,
        emptyValueFocused: emptyValueFocused,
        focusVisible: focusVisible,
        getLabelText: getLabelText,
        icon: icon,
        IconContainerComponent: IconContainerComponent,
        max: max,
        precision: precision,
        readOnly: readOnly,
        size: size
    });
    const classes = $a235763b3a7014ab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a235763b3a7014ab$var$RatingRoot, (0, $8nd05.default)({
        ref: handleRef,
        onMouseMove: handleMouseMove,
        onMouseLeave: handleMouseLeave,
        className: (0, $9QePP.default)(classes.root, className, readOnly && 'MuiRating-readOnly'),
        ownerState: ownerState,
        role: readOnly ? 'img' : null,
        "aria-label": readOnly ? getLabelText(value) : null
    }, other, {
        children: [
            Array.from(new Array(max)).map((_, index)=>{
                const itemValue = index + 1;
                const ratingItemProps = {
                    classes: classes,
                    disabled: disabled,
                    emptyIcon: emptyIcon,
                    focus: focus,
                    getLabelText: getLabelText,
                    highlightSelectedOnly: highlightSelectedOnly,
                    hover: hover,
                    icon: icon,
                    IconContainerComponent: IconContainerComponent,
                    name: name,
                    onBlur: handleBlur,
                    onChange: handleChange,
                    onClick: handleClear,
                    onFocus: handleFocus,
                    ratingValue: value,
                    ratingValueRounded: valueRounded,
                    readOnly: readOnly,
                    ownerState: ownerState
                };
                const isActive = itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1);
                if (precision < 1) {
                    const items = Array.from(new Array(1 / precision));
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingDecimal, {
                        className: (0, $9QePP.default)(classes.decimal, isActive && classes.iconActive),
                        ownerState: ownerState,
                        iconActive: isActive,
                        children: items.map(($, indexDecimal)=>{
                            const itemDecimalValue = $a235763b3a7014ab$var$roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingItem, (0, $8nd05.default)({}, ratingItemProps, {
                                // The icon is already displayed as active
                                isActive: false,
                                itemValue: itemDecimalValue,
                                labelProps: {
                                    style: items.length - 1 === indexDecimal ? {} : {
                                        width: itemDecimalValue === value ? `${(indexDecimal + 1) * precision * 100}%` : '0%',
                                        overflow: 'hidden',
                                        position: 'absolute'
                                    }
                                }
                            }), itemDecimalValue);
                        })
                    }, itemValue);
                }
                return /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingItem, (0, $8nd05.default)({}, ratingItemProps, {
                    isActive: isActive,
                    itemValue: itemValue
                }), itemValue);
            }),
            !readOnly && !disabled && /*#__PURE__*/ (0, $ayMG0.jsxs)($a235763b3a7014ab$var$RatingLabel, {
                className: (0, $9QePP.default)(classes.label, classes.labelEmptyValue),
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: classes.visuallyHidden,
                        value: "",
                        id: `${name}-empty`,
                        type: "radio",
                        name: name,
                        checked: valueRounded == null,
                        onFocus: ()=>setEmptyValueFocused(true),
                        onBlur: ()=>setEmptyValueFocused(false),
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: emptyLabelText
                    })
                ]
            })
        ]
    }));
});
var $a235763b3a7014ab$export$2e2bcd8739ae039 = $a235763b3a7014ab$var$Rating;



$parcel$exportWildcard($fde33b68b1c0968e$exports, $57fdaf8fdc94de34$exports);


var $acaf5bc8fc7510ef$exports = {};

$parcel$defineInteropFlag($acaf5bc8fc7510ef$exports);

$parcel$export($acaf5bc8fc7510ef$exports, "default", () => $f88e6b262a71acad$export$2e2bcd8739ae039);
$parcel$export($acaf5bc8fc7510ef$exports, "scopedCssBaselineClasses", () => $ce1d54a938e4ef44$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $ce1d54a938e4ef44$exports = {};

$parcel$defineInteropFlag($ce1d54a938e4ef44$exports);

$parcel$export($ce1d54a938e4ef44$exports, "getScopedCssBaselineUtilityClass", () => $ce1d54a938e4ef44$export$a3f1a6e59bdd9d27);
$parcel$export($ce1d54a938e4ef44$exports, "default", () => $ce1d54a938e4ef44$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce1d54a938e4ef44$export$a3f1a6e59bdd9d27(slot) {
    return (0, $4Cod0.default)('MuiScopedCssBaseline', slot);
}
const $ce1d54a938e4ef44$var$scopedCssBaselineClasses = (0, $beCSm.default)('MuiScopedCssBaseline', [
    'root'
]);
var $ce1d54a938e4ef44$export$2e2bcd8739ae039 = $ce1d54a938e4ef44$var$scopedCssBaselineClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f88e6b262a71acad$var$_excluded = [
    "className",
    "component",
    "enableColorScheme"
];
const $f88e6b262a71acad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ce1d54a938e4ef44$export$a3f1a6e59bdd9d27), classes);
};
const $f88e6b262a71acad$var$ScopedCssBaselineRoot = (0, $d8seH.default)('div', {
    name: 'MuiScopedCssBaseline',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const colorSchemeStyles = {};
    if (ownerState.enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[`&${theme.getColorSchemeSelector(key).replace(/\s*&/, '')}`] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    return (0, $8nd05.default)({}, (0, $c3dfe91526ac04a1$export$c0bb0b647f701bb5)(theme, ownerState.enableColorScheme), (0, $c3dfe91526ac04a1$export$32180ef41b15b513)(theme), {
        '& *, & *::before, & *::after': {
            boxSizing: 'inherit'
        },
        '& strong, & b': {
            fontWeight: theme.typography.fontWeightBold
        }
    }, colorSchemeStyles);
});
const $f88e6b262a71acad$var$ScopedCssBaseline = /*#__PURE__*/ $acw62.forwardRef(function ScopedCssBaseline(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiScopedCssBaseline'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $f88e6b262a71acad$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $f88e6b262a71acad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f88e6b262a71acad$var$ScopedCssBaselineRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $f88e6b262a71acad$export$2e2bcd8739ae039 = $f88e6b262a71acad$var$ScopedCssBaseline;



'use client';
$parcel$exportWildcard($acaf5bc8fc7510ef$exports, $ce1d54a938e4ef44$exports);


var $9e53839d220648fc$exports = {};

$parcel$defineInteropFlag($9e53839d220648fc$exports);

$parcel$export($9e53839d220648fc$exports, "default", () => $96e1233e8d06bb2d$export$2e2bcd8739ae039);
$parcel$export($9e53839d220648fc$exports, "selectClasses", () => $844e08aea9053c4b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");




var $jTnBY = parcelRequire("jTnBY");




var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");


var $844e08aea9053c4b$exports = {};

$parcel$defineInteropFlag($844e08aea9053c4b$exports);

$parcel$export($844e08aea9053c4b$exports, "getSelectUtilityClasses", () => $844e08aea9053c4b$export$2c0c1ee5a3392e);
$parcel$export($844e08aea9053c4b$exports, "default", () => $844e08aea9053c4b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $db2c454fb2e8bc3c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $db2c454fb2e8bc3c$export$e7a817afd12a40d0));
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $844e08aea9053c4b$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = (0, $8nd05.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $8nd05.default)({}, MenuProps.slotProps, {
                    paper: (0, $8nd05.default)({}, paperProps, {
                        style: (0, $8nd05.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;










var $1iOpW = parcelRequire("1iOpW");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $96e1233e8d06bb2d$var$_excluded2 = [
    "root"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $bb335d5457c07f5b$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $db2c454fb2e8bc3c$export$2e2bcd8739ae039) : (0, $8bd650259be885cb$export$2e2bcd8739ae039);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $1En50.default)(classes, $96e1233e8d06bb2d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, (0, $1d88113360503233$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $8nd05.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $8nd05.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;



'use client';
$parcel$exportWildcard($9e53839d220648fc$exports, $844e08aea9053c4b$exports);


var $ad6f387c32d3bcf0$exports = {};

$parcel$defineInteropFlag($ad6f387c32d3bcf0$exports);

$parcel$export($ad6f387c32d3bcf0$exports, "default", () => $445470756a9ff70a$export$2e2bcd8739ae039);
$parcel$export($ad6f387c32d3bcf0$exports, "skeletonClasses", () => $8b1da808c4852549$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $jjlaj = parcelRequire("jjlaj");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $8b1da808c4852549$exports = {};

$parcel$defineInteropFlag($8b1da808c4852549$exports);

$parcel$export($8b1da808c4852549$exports, "getSkeletonUtilityClass", () => $8b1da808c4852549$export$c987db9fc844f86);
$parcel$export($8b1da808c4852549$exports, "default", () => $8b1da808c4852549$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8b1da808c4852549$export$c987db9fc844f86(slot) {
    return (0, $4Cod0.default)('MuiSkeleton', slot);
}
const $8b1da808c4852549$var$skeletonClasses = (0, $beCSm.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $8b1da808c4852549$export$2e2bcd8739ae039 = $8b1da808c4852549$var$skeletonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $445470756a9ff70a$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $445470756a9ff70a$var$_ = (t)=>t, $445470756a9ff70a$var$_t, $445470756a9ff70a$var$_t2, $445470756a9ff70a$var$_t3, $445470756a9ff70a$var$_t4;
const $445470756a9ff70a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8b1da808c4852549$export$c987db9fc844f86), classes);
};
const $445470756a9ff70a$var$pulseKeyframe = (0, $jjlaj.keyframes)($445470756a9ff70a$var$_t || ($445470756a9ff70a$var$_t = $445470756a9ff70a$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $445470756a9ff70a$var$waveKeyframe = (0, $jjlaj.keyframes)($445470756a9ff70a$var$_t2 || ($445470756a9ff70a$var$_t2 = $445470756a9ff70a$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $445470756a9ff70a$var$SkeletonRoot = (0, $d8seH.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $0d35ef8a52a98e99$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $0d35ef8a52a98e99$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $8nd05.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $jjlaj.css)($445470756a9ff70a$var$_t3 || ($445470756a9ff70a$var$_t3 = $445470756a9ff70a$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $445470756a9ff70a$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $jjlaj.css)($445470756a9ff70a$var$_t4 || ($445470756a9ff70a$var$_t4 = $445470756a9ff70a$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $445470756a9ff70a$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $445470756a9ff70a$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $1En50.default)(props, $445470756a9ff70a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $445470756a9ff70a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($445470756a9ff70a$var$SkeletonRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $8nd05.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $445470756a9ff70a$export$2e2bcd8739ae039 = $445470756a9ff70a$var$Skeleton;



'use client';
$parcel$exportWildcard($ad6f387c32d3bcf0$exports, $8b1da808c4852549$exports);


var $8a0dfba99a405f81$exports = {};

$parcel$defineInteropFlag($8a0dfba99a405f81$exports);

$parcel$export($8a0dfba99a405f81$exports, "default", () => $4dba6b402693f5d6$export$2e2bcd8739ae039);

'use client';


var $16b1b35b06ce5bdf$exports = {};

$parcel$defineInteropFlag($16b1b35b06ce5bdf$exports);

$parcel$export($16b1b35b06ce5bdf$exports, "default", () => $e7d362f04a4204f3$export$2e2bcd8739ae039);
$parcel$export($16b1b35b06ce5bdf$exports, "sliderClasses", () => $175610683d4083b7$export$2e2bcd8739ae039);
var $e7d362f04a4204f3$exports = {};

$parcel$defineInteropFlag($e7d362f04a4204f3$exports);

$parcel$export($e7d362f04a4204f3$exports, "SliderRoot", () => $e7d362f04a4204f3$export$c1a21b3b4da66aa1);
$parcel$export($e7d362f04a4204f3$exports, "SliderRail", () => $e7d362f04a4204f3$export$b02fde61a3559c2);
$parcel$export($e7d362f04a4204f3$exports, "SliderTrack", () => $e7d362f04a4204f3$export$105594979f116971);
$parcel$export($e7d362f04a4204f3$exports, "SliderThumb", () => $e7d362f04a4204f3$export$2c1b491743890dec);
$parcel$export($e7d362f04a4204f3$exports, "SliderValueLabel", () => $e7d362f04a4204f3$export$6453176f504d54f0);
$parcel$export($e7d362f04a4204f3$exports, "SliderMark", () => $e7d362f04a4204f3$export$6f85f6a3c5da6f62);
$parcel$export($e7d362f04a4204f3$exports, "SliderMarkLabel", () => $e7d362f04a4204f3$export$e6cd369965e5aa95);
$parcel$export($e7d362f04a4204f3$exports, "default", () => $e7d362f04a4204f3$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1jJMI = parcelRequire("1jJMI");

function $6dec2bf07d6d333a$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $6dec2bf07d6d333a$export$2e2bcd8739ae039 = $6dec2bf07d6d333a$var$areArraysEqual;


'use client';
const $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $9e8acd9e5bad7cc4$var$asc(a, b) {
    return a - b;
}
function $9e8acd9e5bad7cc4$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $9e8acd9e5bad7cc4$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $9e8acd9e5bad7cc4$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $9e8acd9e5bad7cc4$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($9e8acd9e5bad7cc4$var$getDecimalPrecision(step)));
}
function $9e8acd9e5bad7cc4$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($9e8acd9e5bad7cc4$var$asc);
}
function $9e8acd9e5bad7cc4$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $9e8acd9e5bad7cc4$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $6dec2bf07d6d333a$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $9e8acd9e5bad7cc4$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $9e8acd9e5bad7cc4$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
function $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone() {
    if ($9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = true;
    }
    return $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
}
function $9e8acd9e5bad7cc4$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $9e8acd9e5bad7cc4$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $acw62.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(-1);
    const [dragging, setDragging] = $acw62.useState(false);
    const moveCount = $acw62.useRef(0);
    const [valueDerived, setValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($9e8acd9e5bad7cc4$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $1jJMI.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $15e2b45accdb3531$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $acw62.useState(-1);
    const sliderRef = $acw62.useRef(null);
    const handleFocusRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute('data-index'));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue > maxMarksValue) newValue = maxMarksValue;
            else if (newValue < marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
            // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
            if (step !== null) {
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                if ((event.key === 'ArrowLeft' || event.key === 'ArrowDown') && event.shiftKey || event.key === 'PageDown') newValue = Math.max(value - shiftStep, min);
                else if ((event.key === 'ArrowRight' || event.key === 'ArrowUp') && event.shiftKey || event.key === 'PageUp') newValue = Math.min(value + shiftStep, max);
                if (newValue !== null) {
                    changeValue(event, newValue);
                    event.preventDefault();
                }
            }
            otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
        };
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $acw62.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        let newValue;
        newValue = $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max);
        if (step) newValue = $9e8acd9e5bad7cc4$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $9e8acd9e5bad7cc4$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $9e8acd9e5bad7cc4$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $9e8acd9e5bad7cc4$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $acw62.useCallback(()=>{
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $acw62.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $acw62.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $9e8acd9e5bad7cc4$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $9e8acd9e5bad7cc4$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $8nd05.default)({}, externalHandlers, ownEventHandlers);
        return (0, $8nd05.default)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $8nd05.default)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $8nd05.default)({}, externalHandlers, ownEventHandlers);
        return (0, $8nd05.default)({
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $8nd05.default)({}, (0, $0acaed42692b8720$export$2e2bcd8739ae039), {
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%'
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $9e8acd9e5bad7cc4$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $PJRTc = parcelRequire("PJRTc");

const $fef7b1c426e97238$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Slot);
};
var $fef7b1c426e97238$export$2e2bcd8739ae039 = $fef7b1c426e97238$var$shouldSpreadAdditionalProps;



var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");
var $175610683d4083b7$exports = {};

$parcel$defineInteropFlag($175610683d4083b7$exports);

$parcel$export($175610683d4083b7$exports, "getSliderUtilityClass", () => $175610683d4083b7$export$9f59f2622d5cbc2a);
$parcel$export($175610683d4083b7$exports, "default", () => $175610683d4083b7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $175610683d4083b7$export$9f59f2622d5cbc2a(slot) {
    return (0, $4Cod0.default)('MuiSlider', slot);
}
const $175610683d4083b7$var$sliderClasses = (0, $beCSm.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $175610683d4083b7$export$2e2bcd8739ae039 = $175610683d4083b7$var$sliderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1d8e4e584d12bd05$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $9QePP.default)(open && (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $1d8e4e584d12bd05$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $1d8e4e584d12bd05$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        className: (0, $9QePP.default)(children.props.className)
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e7d362f04a4204f3$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "shiftStep",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
function $e7d362f04a4204f3$var$Identity(x) {
    return x;
}
const $e7d362f04a4204f3$export$c1a21b3b4da66aa1 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $175610683d4083b7$export$2e2bcd8739ae039).thumb}, & .${(0, $175610683d4083b7$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    };
});
const $e7d362f04a4204f3$export$b02fde61a3559c2 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $e7d362f04a4204f3$export$105594979f116971 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>{
    var _theme$vars3;
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter((key)=>{
                var _theme$vars4;
                return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: (0, $8nd05.default)({}, theme.vars ? {
                        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                        borderColor: theme.vars.palette.Slider[`${color}Track`]
                    } : (0, $8nd05.default)({
                        backgroundColor: (0, $kTdcz.lighten)(theme.palette[color].main, 0.62),
                        borderColor: (0, $kTdcz.lighten)(theme.palette[color].main, 0.62)
                    }, theme.applyStyles('dark', {
                        backgroundColor: (0, $kTdcz.darken)(theme.palette[color].main, 0.5)
                    }), theme.applyStyles('dark', {
                        borderColor: (0, $kTdcz.darken)(theme.palette[color].main, 0.5)
                    })))
                }))
        ]
    };
});
const $e7d362f04a4204f3$export$2c1b491743890dec = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars5;
    return {
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter((key)=>{
                var _theme$vars6;
                return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $175610683d4083b7$export$2e2bcd8739ae039).focusVisible}`]: (0, $8nd05.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 8px ${(0, $kTdcz.alpha)(theme.palette[color].main, 0.16)}`
                        }, {
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        }),
                        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).active}`]: (0, $8nd05.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 14px ${(0, $kTdcz.alpha)(theme.palette[color].main, 0.16)}`
                        })
                    }
                }))
        ]
    };
});
const $e7d362f04a4204f3$export$6453176f504d54f0 = (0, $d8seH.default)((0, $1d8e4e584d12bd05$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme })=>(0, $8nd05.default)({
        zIndex: 1,
        whiteSpace: 'nowrap'
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    }));
const $e7d362f04a4204f3$export$6f85f6a3c5da6f62 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    }));
const $e7d362f04a4204f3$export$e6cd369965e5aa95 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    }));
const $e7d362f04a4204f3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $jTnBY.default)(color)}`,
            size && `size${(0, $jTnBY.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $jTnBY.default)(size)}`,
            color && `thumbColor${(0, $jTnBY.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $175610683d4083b7$export$9f59f2622d5cbc2a), classes);
};
const $e7d362f04a4204f3$var$Forward = ({ children: children })=>children;
const $e7d362f04a4204f3$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $e7d362f04a4204f3$var$Identity, slotProps: slotProps, slots: slots, track: track = 'normal', valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $e7d362f04a4204f3$var$Identity } = props, other = (0, $1En50.default)(props, $e7d362f04a4204f3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $9e8acd9e5bad7cc4$export$56b2c08e277f365)((0, $8nd05.default)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $e7d362f04a4204f3$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e7d362f04a4204f3$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $e7d362f04a4204f3$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $e7d362f04a4204f3$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $e7d362f04a4204f3$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $e7d362f04a4204f3$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $e7d362f04a4204f3$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $e7d362f04a4204f3$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $8nd05.default)({}, (0, $fef7b1c426e97238$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $8nd05.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $8nd05.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $8nd05.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $8nd05.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RailSlot, (0, $8nd05.default)({}, railProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, (0, $8nd05.default)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $9e8acd9e5bad7cc4$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(MarkSlot, (0, $8nd05.default)({
                            "data-index": index
                        }, markProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $8nd05.default)({}, style, markProps.style),
                            className: (0, $9QePP.default)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(MarkLabelSlot, (0, $8nd05.default)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $8nd05.default)({}, style, markLabelProps.style),
                            className: (0, $9QePP.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $9e8acd9e5bad7cc4$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $e7d362f04a4204f3$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ayMG0.jsx)(ValueLabelComponent, (0, $8nd05.default)({}, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === 'on',
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, (0, $8nd05.default)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $9QePP.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $8nd05.default)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, (0, $8nd05.default)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $e7d362f04a4204f3$export$2e2bcd8739ae039 = $e7d362f04a4204f3$var$Slider;



'use client';
$parcel$exportWildcard($16b1b35b06ce5bdf$exports, $e7d362f04a4204f3$exports);
$parcel$exportWildcard($16b1b35b06ce5bdf$exports, $175610683d4083b7$exports);


var $80c71705f119f7ad$exports = {};

$parcel$defineInteropFlag($80c71705f119f7ad$exports);

$parcel$export($80c71705f119f7ad$exports, "default", () => $ef601776ba11bb1e$export$2e2bcd8739ae039);
$parcel$export($80c71705f119f7ad$exports, "snackbarClasses", () => $f3bdc4d25b715a88$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $8nd05.default)({}, (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters), (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps));
        return (0, $8nd05.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$export$2e2bcd8739ae039 = $2d16bff1157c299f$var$useSnackbar;




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $4d2fdf4430378182$exports = {};

$parcel$defineInteropFlag($4d2fdf4430378182$exports);

$parcel$export($4d2fdf4430378182$exports, "getSnackbarContentUtilityClass", () => $4d2fdf4430378182$export$def81488db1a3216);
$parcel$export($4d2fdf4430378182$exports, "default", () => $4d2fdf4430378182$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4d2fdf4430378182$export$def81488db1a3216(slot) {
    return (0, $4Cod0.default)('MuiSnackbarContent', slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $beCSm.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $4d2fdf4430378182$export$2e2bcd8739ae039 = $4d2fdf4430378182$var$snackbarContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dbe322effc7340b4$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4d2fdf4430378182$export$def81488db1a3216), classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $kTdcz.emphasize)(theme.palette.background.default, emphasis);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $1En50.default)(props, $dbe322effc7340b4$var$_excluded);
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $dbe322effc7340b4$export$2e2bcd8739ae039 = $dbe322effc7340b4$var$SnackbarContent;


var $f3bdc4d25b715a88$exports = {};

$parcel$defineInteropFlag($f3bdc4d25b715a88$exports);

$parcel$export($f3bdc4d25b715a88$exports, "getSnackbarUtilityClass", () => $f3bdc4d25b715a88$export$6cb096457f5926f4);
$parcel$export($f3bdc4d25b715a88$exports, "default", () => $f3bdc4d25b715a88$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3bdc4d25b715a88$export$6cb096457f5926f4(slot) {
    return (0, $4Cod0.default)('MuiSnackbar', slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $beCSm.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f3bdc4d25b715a88$export$2e2bcd8739ae039 = $f3bdc4d25b715a88$var$snackbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef601776ba11bb1e$var$_excluded = [
    "onEnter",
    "onExited"
], $ef601776ba11bb1e$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3bdc4d25b715a88$export$6cb096457f5926f4), classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $8nd05.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $ef601776ba11bb1e$var$_excluded), other = (0, $1En50.default)(props, $ef601776ba11bb1e$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $2d16bff1157c299f$export$2e2bcd8739ae039)((0, $8nd05.default)({}, ownerState));
    const [exited, setExited] = $acw62.useState(true);
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0f105dbd8c07c9e$export$58385c17fee43f89), (0, $8nd05.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef601776ba11bb1e$var$SnackbarRoot, (0, $8nd05.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $ef601776ba11bb1e$export$2e2bcd8739ae039 = $ef601776ba11bb1e$var$Snackbar;



'use client';
$parcel$exportWildcard($80c71705f119f7ad$exports, $f3bdc4d25b715a88$exports);


var $6445e2a5635b1c13$exports = {};

$parcel$defineInteropFlag($6445e2a5635b1c13$exports);

$parcel$export($6445e2a5635b1c13$exports, "default", () => $dbe322effc7340b4$export$2e2bcd8739ae039);
$parcel$export($6445e2a5635b1c13$exports, "snackbarContentClasses", () => $4d2fdf4430378182$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($6445e2a5635b1c13$exports, $4d2fdf4430378182$exports);


var $edf24babb8f47c92$exports = {};

$parcel$defineInteropFlag($edf24babb8f47c92$exports);

$parcel$export($edf24babb8f47c92$exports, "default", () => $ef91875cc443f344$export$2e2bcd8739ae039);
$parcel$export($edf24babb8f47c92$exports, "speedDialClasses", () => $d7d1b0c877edfc53$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1jJMI = parcelRequire("1jJMI");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4672437388b729f6$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $4672437388b729f6$var$styles = {
    entering: {
        transform: 'none'
    },
    entered: {
        transform: 'none'
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4672437388b729f6$var$Zoom = /*#__PURE__*/ $acw62.forwardRef(function Zoom(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $4672437388b729f6$var$_excluded);
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    transform: 'scale(0)',
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $4672437388b729f6$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $4672437388b729f6$export$2e2bcd8739ae039 = $4672437388b729f6$var$Zoom;




var $jTnBY = parcelRequire("jTnBY");



var $d7d1b0c877edfc53$exports = {};

$parcel$defineInteropFlag($d7d1b0c877edfc53$exports);

$parcel$export($d7d1b0c877edfc53$exports, "getSpeedDialUtilityClass", () => $d7d1b0c877edfc53$export$b96222ae71926780);
$parcel$export($d7d1b0c877edfc53$exports, "default", () => $d7d1b0c877edfc53$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7d1b0c877edfc53$export$b96222ae71926780(slot) {
    return (0, $4Cod0.default)('MuiSpeedDial', slot);
}
const $d7d1b0c877edfc53$var$speedDialClasses = (0, $beCSm.default)('MuiSpeedDial', [
    'root',
    'fab',
    'directionUp',
    'directionDown',
    'directionLeft',
    'directionRight',
    'actions',
    'actionsClosed'
]);
var $d7d1b0c877edfc53$export$2e2bcd8739ae039 = $d7d1b0c877edfc53$var$speedDialClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef91875cc443f344$var$_excluded = [
    "ref"
], $ef91875cc443f344$var$_excluded2 = [
    "ariaLabel",
    "FabProps",
    "children",
    "className",
    "direction",
    "hidden",
    "icon",
    "onBlur",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMouseEnter",
    "onMouseLeave",
    "onOpen",
    "open",
    "openIcon",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
], $ef91875cc443f344$var$_excluded3 = [
    "ref"
];
const $ef91875cc443f344$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, direction: direction } = ownerState;
    const slots = {
        root: [
            'root',
            `direction${(0, $jTnBY.default)(direction)}`
        ],
        fab: [
            'fab'
        ],
        actions: [
            'actions',
            !open && 'actionsClosed'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d7d1b0c877edfc53$export$b96222ae71926780), classes);
};
function $ef91875cc443f344$var$getOrientation(direction) {
    if (direction === 'up' || direction === 'down') return 'vertical';
    if (direction === 'right' || direction === 'left') return 'horizontal';
    return undefined;
}
const $ef91875cc443f344$var$dialRadius = 32;
const $ef91875cc443f344$var$spacingActions = 16;
const $ef91875cc443f344$var$SpeedDialRoot = (0, $d8seH.default)('div', {
    name: 'MuiSpeedDial',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`direction${(0, $jTnBY.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.speedDial,
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none'
    }, ownerState.direction === 'up' && {
        flexDirection: 'column-reverse',
        [`& .${(0, $d7d1b0c877edfc53$export$2e2bcd8739ae039).actions}`]: {
            flexDirection: 'column-reverse',
            marginBottom: -$ef91875cc443f344$var$dialRadius,
            paddingBottom: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
        }
    }, ownerState.direction === 'down' && {
        flexDirection: 'column',
        [`& .${(0, $d7d1b0c877edfc53$export$2e2bcd8739ae039).actions}`]: {
            flexDirection: 'column',
            marginTop: -$ef91875cc443f344$var$dialRadius,
            paddingTop: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
        }
    }, ownerState.direction === 'left' && {
        flexDirection: 'row-reverse',
        [`& .${(0, $d7d1b0c877edfc53$export$2e2bcd8739ae039).actions}`]: {
            flexDirection: 'row-reverse',
            marginRight: -$ef91875cc443f344$var$dialRadius,
            paddingRight: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
        }
    }, ownerState.direction === 'right' && {
        flexDirection: 'row',
        [`& .${(0, $d7d1b0c877edfc53$export$2e2bcd8739ae039).actions}`]: {
            flexDirection: 'row',
            marginLeft: -$ef91875cc443f344$var$dialRadius,
            paddingLeft: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
        }
    }));
const $ef91875cc443f344$var$SpeedDialFab = (0, $d8seH.default)((0, $2426d7556721cbb6$export$2e2bcd8739ae039), {
    name: 'MuiSpeedDial',
    slot: 'Fab',
    overridesResolver: (props, styles)=>styles.fab
})(()=>({
        pointerEvents: 'auto'
    }));
const $ef91875cc443f344$var$SpeedDialActions = (0, $d8seH.default)('div', {
    name: 'MuiSpeedDial',
    slot: 'Actions',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actions,
            !ownerState.open && styles.actionsClosed
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        pointerEvents: 'auto'
    }, !ownerState.open && {
        transition: 'top 0s linear 0.2s',
        pointerEvents: 'none'
    }));
const $ef91875cc443f344$var$SpeedDial = /*#__PURE__*/ $acw62.forwardRef(function SpeedDial(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDial'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { ariaLabel: ariaLabel, FabProps: { ref: origDialButtonRef } = {}, children: childrenProp, className: className, direction: direction = 'up', hidden: hidden = false, icon: icon, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onOpen: onOpen, open: openProp, TransitionComponent: TransitionComponent = (0, $4672437388b729f6$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, FabProps = (0, $1En50.default)(props.FabProps, $ef91875cc443f344$var$_excluded), other = (0, $1En50.default)(props, $ef91875cc443f344$var$_excluded2);
    const [open, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'SpeedDial',
        state: 'open'
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        open: open,
        direction: direction
    });
    const classes = $ef91875cc443f344$var$useUtilityClasses(ownerState);
    const eventTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    /**
   * an index in actions.current
   */ const focusedAction = $acw62.useRef(0);
    /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */ const nextItemArrowKey = $acw62.useRef();
    /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */ const actions = $acw62.useRef([]);
    actions.current = [
        actions.current[0]
    ];
    const handleOwnFabRef = $acw62.useCallback((fabFef)=>{
        actions.current[0] = fabFef;
    }, []);
    const handleFabRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(origDialButtonRef, handleOwnFabRef);
    /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   */ const createHandleSpeedDialActionButtonRef = (dialActionIndex, origButtonRef)=>{
        return (buttonRef)=>{
            actions.current[dialActionIndex + 1] = buttonRef;
            if (origButtonRef) origButtonRef(buttonRef);
        };
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        const key = event.key.replace('Arrow', '').toLowerCase();
        const { current: nextItemArrowKeyCurrent = key } = nextItemArrowKey;
        if (event.key === 'Escape') {
            setOpenState(false);
            actions.current[0].focus();
            if (onClose) onClose(event, 'escapeKeyDown');
            return;
        }
        if ($ef91875cc443f344$var$getOrientation(key) === $ef91875cc443f344$var$getOrientation(nextItemArrowKeyCurrent) && $ef91875cc443f344$var$getOrientation(key) !== undefined) {
            event.preventDefault();
            const actionStep = key === nextItemArrowKeyCurrent ? 1 : -1;
            // stay within array indices
            const nextAction = (0, $1jJMI.default)(focusedAction.current + actionStep, 0, actions.current.length - 1);
            actions.current[nextAction].focus();
            focusedAction.current = nextAction;
            nextItemArrowKey.current = nextItemArrowKeyCurrent;
        }
    };
    $acw62.useEffect(()=>{
        // actions were closed while navigation state was not reset
        if (!open) {
            focusedAction.current = 0;
            nextItemArrowKey.current = undefined;
        }
    }, [
        open
    ]);
    const handleClose = (event)=>{
        if (event.type === 'mouseleave' && onMouseLeave) onMouseLeave(event);
        if (event.type === 'blur' && onBlur) onBlur(event);
        eventTimer.clear();
        if (event.type === 'blur') eventTimer.start(0, ()=>{
            setOpenState(false);
            if (onClose) onClose(event, 'blur');
        });
        else {
            setOpenState(false);
            if (onClose) onClose(event, 'mouseLeave');
        }
    };
    const handleClick = (event)=>{
        if (FabProps.onClick) FabProps.onClick(event);
        eventTimer.clear();
        if (open) {
            setOpenState(false);
            if (onClose) onClose(event, 'toggle');
        } else {
            setOpenState(true);
            if (onOpen) onOpen(event, 'toggle');
        }
    };
    const handleOpen = (event)=>{
        if (event.type === 'mouseenter' && onMouseEnter) onMouseEnter(event);
        if (event.type === 'focus' && onFocus) onFocus(event);
        // When moving the focus between two items,
        // a chain if blur and focus event is triggered.
        // We only handle the last event.
        eventTimer.clear();
        if (!open) // Wait for a future focus or click event
        eventTimer.start(0, ()=>{
            setOpenState(true);
            if (onOpen) {
                const eventMap = {
                    focus: 'focus',
                    mouseenter: 'mouseEnter'
                };
                onOpen(event, eventMap[event.type]);
            }
        });
    };
    // Filter the label for valid id characters.
    const id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
    const allItems = $acw62.Children.toArray(childrenProp).filter((child)=>{
        return /*#__PURE__*/ $acw62.isValidElement(child);
    });
    const children = allItems.map((child, index)=>{
        const _child$props = child.props, { FabProps: { ref: origButtonRef } = {}, tooltipPlacement: tooltipPlacementProp } = _child$props, ChildFabProps = (0, $1En50.default)(_child$props.FabProps, $ef91875cc443f344$var$_excluded3);
        const tooltipPlacement = tooltipPlacementProp || ($ef91875cc443f344$var$getOrientation(direction) === 'vertical' ? 'left' : 'top');
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            FabProps: (0, $8nd05.default)({}, ChildFabProps, {
                ref: createHandleSpeedDialActionButtonRef(index, origButtonRef)
            }),
            delay: 30 * (open ? index : allItems.length - index),
            open: open,
            tooltipPlacement: tooltipPlacement,
            id: `${id}-action-${index}`
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ef91875cc443f344$var$SpeedDialRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "presentation",
        onKeyDown: handleKeyDown,
        onBlur: handleClose,
        onFocus: handleOpen,
        onMouseEnter: handleOpen,
        onMouseLeave: handleClose,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                in: !hidden,
                timeout: transitionDuration,
                unmountOnExit: true
            }, TransitionProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef91875cc443f344$var$SpeedDialFab, (0, $8nd05.default)({
                    color: "primary",
                    "aria-label": ariaLabel,
                    "aria-haspopup": "true",
                    "aria-expanded": open,
                    "aria-controls": `${id}-actions`
                }, FabProps, {
                    onClick: handleClick,
                    className: (0, $9QePP.default)(classes.fab, FabProps.className),
                    ref: handleFabRef,
                    ownerState: ownerState,
                    children: /*#__PURE__*/ $acw62.isValidElement(icon) && (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(icon, [
                        'SpeedDialIcon'
                    ]) ? /*#__PURE__*/ $acw62.cloneElement(icon, {
                        open: open
                    }) : icon
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($ef91875cc443f344$var$SpeedDialActions, {
                id: `${id}-actions`,
                role: "menu",
                "aria-orientation": $ef91875cc443f344$var$getOrientation(direction),
                className: (0, $9QePP.default)(classes.actions, !open && classes.actionsClosed),
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});
var $ef91875cc443f344$export$2e2bcd8739ae039 = $ef91875cc443f344$var$SpeedDial;



'use client';
$parcel$exportWildcard($edf24babb8f47c92$exports, $d7d1b0c877edfc53$exports);


var $20f48d600d3ec25e$exports = {};

$parcel$defineInteropFlag($20f48d600d3ec25e$exports);

$parcel$export($20f48d600d3ec25e$exports, "default", () => $ceac721f7000e3b1$export$2e2bcd8739ae039);
$parcel$export($20f48d600d3ec25e$exports, "speedDialActionClasses", () => $dc072e92edbac389$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $jTnBY = parcelRequire("jTnBY");
var $dc072e92edbac389$exports = {};

$parcel$defineInteropFlag($dc072e92edbac389$exports);

$parcel$export($dc072e92edbac389$exports, "getSpeedDialActionUtilityClass", () => $dc072e92edbac389$export$245f94b54fb85595);
$parcel$export($dc072e92edbac389$exports, "default", () => $dc072e92edbac389$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $dc072e92edbac389$export$245f94b54fb85595(slot) {
    return (0, $4Cod0.default)('MuiSpeedDialAction', slot);
}
const $dc072e92edbac389$var$speedDialActionClasses = (0, $beCSm.default)('MuiSpeedDialAction', [
    'fab',
    'fabClosed',
    'staticTooltip',
    'staticTooltipClosed',
    'staticTooltipLabel',
    'tooltipPlacementLeft',
    'tooltipPlacementRight'
]);
var $dc072e92edbac389$export$2e2bcd8739ae039 = $dc072e92edbac389$var$speedDialActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ceac721f7000e3b1$var$_excluded = [
    "className",
    "delay",
    "FabProps",
    "icon",
    "id",
    "open",
    "TooltipClasses",
    "tooltipOpen",
    "tooltipPlacement",
    "tooltipTitle"
];
const $ceac721f7000e3b1$var$useUtilityClasses = (ownerState)=>{
    const { open: open, tooltipPlacement: tooltipPlacement, classes: classes } = ownerState;
    const slots = {
        fab: [
            'fab',
            !open && 'fabClosed'
        ],
        staticTooltip: [
            'staticTooltip',
            `tooltipPlacement${(0, $jTnBY.default)(tooltipPlacement)}`,
            !open && 'staticTooltipClosed'
        ],
        staticTooltipLabel: [
            'staticTooltipLabel'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dc072e92edbac389$export$245f94b54fb85595), classes);
};
const $ceac721f7000e3b1$var$SpeedDialActionFab = (0, $d8seH.default)((0, $2426d7556721cbb6$export$2e2bcd8739ae039), {
    name: 'MuiSpeedDialAction',
    slot: 'Fab',
    skipVariantsResolver: false,
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.fab,
            !ownerState.open && styles.fabClosed
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 8,
        color: (theme.vars || theme).palette.text.secondary,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.SpeedDialAction.fabHoverBg : (0, $kTdcz.emphasize)(theme.palette.background.paper, 0.15)
        },
        transition: `${theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter
        })}, opacity 0.8s`,
        opacity: 1
    }, !ownerState.open && {
        opacity: 0,
        transform: 'scale(0)'
    }));
const $ceac721f7000e3b1$var$SpeedDialActionStaticTooltip = (0, $d8seH.default)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.staticTooltip,
            !ownerState.open && styles.staticTooltipClosed,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.tooltipPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        [`& .${(0, $dc072e92edbac389$export$2e2bcd8739ae039).staticTooltipLabel}`]: (0, $8nd05.default)({
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.shorter
            }),
            opacity: 1
        }, !ownerState.open && {
            opacity: 0,
            transform: 'scale(0.5)'
        }, ownerState.tooltipPlacement === 'left' && {
            transformOrigin: '100% 50%',
            right: '100%',
            marginRight: 8
        }, ownerState.tooltipPlacement === 'right' && {
            transformOrigin: '0% 50%',
            left: '100%',
            marginLeft: 8
        })
    }));
const $ceac721f7000e3b1$var$SpeedDialActionStaticTooltipLabel = (0, $d8seH.default)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltipLabel',
    overridesResolver: (props, styles)=>styles.staticTooltipLabel
})(({ theme: theme })=>(0, $8nd05.default)({
        position: 'absolute'
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        boxShadow: (theme.vars || theme).shadows[1],
        color: (theme.vars || theme).palette.text.secondary,
        padding: '4px 16px',
        wordBreak: 'keep-all'
    }));
const $ceac721f7000e3b1$var$SpeedDialAction = /*#__PURE__*/ $acw62.forwardRef(function SpeedDialAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialAction'
    });
    const { className: className, delay: delay = 0, FabProps: FabProps = {}, icon: icon, id: id, open: open, TooltipClasses: TooltipClasses, tooltipOpen: tooltipOpenProp = false, tooltipPlacement: tooltipPlacement = 'left', tooltipTitle: tooltipTitle } = props, other = (0, $1En50.default)(props, $ceac721f7000e3b1$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        tooltipPlacement: tooltipPlacement
    });
    const classes = $ceac721f7000e3b1$var$useUtilityClasses(ownerState);
    const [tooltipOpen, setTooltipOpen] = $acw62.useState(tooltipOpenProp);
    const handleTooltipClose = ()=>{
        setTooltipOpen(false);
    };
    const handleTooltipOpen = ()=>{
        setTooltipOpen(true);
    };
    const transitionStyle = {
        transitionDelay: `${delay}ms`
    };
    const fab = /*#__PURE__*/ (0, $ayMG0.jsx)($ceac721f7000e3b1$var$SpeedDialActionFab, (0, $8nd05.default)({
        size: "small",
        className: (0, $9QePP.default)(classes.fab, className),
        tabIndex: -1,
        role: "menuitem",
        ownerState: ownerState
    }, FabProps, {
        style: (0, $8nd05.default)({}, transitionStyle, FabProps.style),
        children: icon
    }));
    if (tooltipOpenProp) return /*#__PURE__*/ (0, $ayMG0.jsxs)($ceac721f7000e3b1$var$SpeedDialActionStaticTooltip, (0, $8nd05.default)({
        id: id,
        ref: ref,
        className: classes.staticTooltip,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($ceac721f7000e3b1$var$SpeedDialActionStaticTooltipLabel, {
                style: transitionStyle,
                id: `${id}-label`,
                className: classes.staticTooltipLabel,
                ownerState: ownerState,
                children: tooltipTitle
            }),
            /*#__PURE__*/ $acw62.cloneElement(fab, {
                'aria-labelledby': `${id}-label`
            })
        ]
    }));
    if (!open && tooltipOpen) setTooltipOpen(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), (0, $8nd05.default)({
        id: id,
        ref: ref,
        title: tooltipTitle,
        placement: tooltipPlacement,
        onClose: handleTooltipClose,
        onOpen: handleTooltipOpen,
        open: open && tooltipOpen,
        classes: TooltipClasses
    }, other, {
        children: fab
    }));
});
var $ceac721f7000e3b1$export$2e2bcd8739ae039 = $ceac721f7000e3b1$var$SpeedDialAction;



'use client';
$parcel$exportWildcard($20f48d600d3ec25e$exports, $dc072e92edbac389$exports);


var $4ed14e9d13fe3bbe$exports = {};

$parcel$defineInteropFlag($4ed14e9d13fe3bbe$exports);

$parcel$export($4ed14e9d13fe3bbe$exports, "default", () => $f613f9bdcf68845e$export$2e2bcd8739ae039);
$parcel$export($4ed14e9d13fe3bbe$exports, "speedDialIconClasses", () => $acd358505730020e$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $275ed03e426ba761$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');


var $acd358505730020e$exports = {};

$parcel$defineInteropFlag($acd358505730020e$exports);

$parcel$export($acd358505730020e$exports, "getSpeedDialIconUtilityClass", () => $acd358505730020e$export$de8b025d97aac021);
$parcel$export($acd358505730020e$exports, "default", () => $acd358505730020e$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $acd358505730020e$export$de8b025d97aac021(slot) {
    return (0, $4Cod0.default)('MuiSpeedDialIcon', slot);
}
const $acd358505730020e$var$speedDialIconClasses = (0, $beCSm.default)('MuiSpeedDialIcon', [
    'root',
    'icon',
    'iconOpen',
    'iconWithOpenIconOpen',
    'openIcon',
    'openIconOpen'
]);
var $acd358505730020e$export$2e2bcd8739ae039 = $acd358505730020e$var$speedDialIconClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f613f9bdcf68845e$var$_excluded = [
    "className",
    "icon",
    "open",
    "openIcon"
];
const $f613f9bdcf68845e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, openIcon: openIcon } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        icon: [
            'icon',
            open && 'iconOpen',
            openIcon && open && 'iconWithOpenIconOpen'
        ],
        openIcon: [
            'openIcon',
            open && 'openIconOpen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $acd358505730020e$export$de8b025d97aac021), classes);
};
const $f613f9bdcf68845e$var$SpeedDialIconRoot = (0, $d8seH.default)('span', {
    name: 'MuiSpeedDialIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $acd358505730020e$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $acd358505730020e$export$2e2bcd8739ae039).icon}`]: ownerState.open && styles.iconOpen
            },
            {
                [`& .${(0, $acd358505730020e$export$2e2bcd8739ae039).icon}`]: ownerState.open && ownerState.openIcon && styles.iconWithOpenIconOpen
            },
            {
                [`& .${(0, $acd358505730020e$export$2e2bcd8739ae039).openIcon}`]: styles.openIcon
            },
            {
                [`& .${(0, $acd358505730020e$export$2e2bcd8739ae039).openIcon}`]: ownerState.open && styles.openIconOpen
            },
            styles.root
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>({
        height: 24,
        [`& .${(0, $acd358505730020e$export$2e2bcd8739ae039).icon}`]: (0, $8nd05.default)({
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            })
        }, ownerState.open && (0, $8nd05.default)({
            transform: 'rotate(45deg)'
        }, ownerState.openIcon && {
            opacity: 0
        })),
        [`& .${(0, $acd358505730020e$export$2e2bcd8739ae039).openIcon}`]: (0, $8nd05.default)({
            position: 'absolute',
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            transform: 'rotate(-45deg)'
        }, ownerState.open && {
            transform: 'rotate(0deg)',
            opacity: 1
        })
    }));
const $f613f9bdcf68845e$var$SpeedDialIcon = /*#__PURE__*/ $acw62.forwardRef(function SpeedDialIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialIcon'
    });
    const { className: className, icon: iconProp, openIcon: openIconProp } = props, other = (0, $1En50.default)(props, $f613f9bdcf68845e$var$_excluded);
    const ownerState = props;
    const classes = $f613f9bdcf68845e$var$useUtilityClasses(ownerState);
    function formatIcon(icon, newClassName) {
        if (/*#__PURE__*/ $acw62.isValidElement(icon)) return /*#__PURE__*/ $acw62.cloneElement(icon, {
            className: newClassName
        });
        return icon;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f613f9bdcf68845e$var$SpeedDialIconRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            openIconProp ? formatIcon(openIconProp, classes.openIcon) : null,
            iconProp ? formatIcon(iconProp, classes.icon) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $275ed03e426ba761$export$2e2bcd8739ae039), {
                className: classes.icon
            })
        ]
    }));
});
$f613f9bdcf68845e$var$SpeedDialIcon.muiName = 'SpeedDialIcon';
var $f613f9bdcf68845e$export$2e2bcd8739ae039 = $f613f9bdcf68845e$var$SpeedDialIcon;



'use client';
$parcel$exportWildcard($4ed14e9d13fe3bbe$exports, $acd358505730020e$exports);


var $e11d669415a30ea5$exports = {};

$parcel$defineInteropFlag($e11d669415a30ea5$exports);

$parcel$export($e11d669415a30ea5$exports, "default", () => $231d58234d437bc0$export$2e2bcd8739ae039);
$parcel$export($e11d669415a30ea5$exports, "stackClasses", () => $7ac564dc7b213020$export$2e2bcd8739ae039);


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $7ac564dc7b213020$export$d667a7de734a892c(slot) {
    return (0, $4Cod0.default)('MuiStack', slot);
}
const $7ac564dc7b213020$var$stackClasses = (0, $beCSm.default)('MuiStack', [
    'root'
]);
var $7ac564dc7b213020$export$2e2bcd8739ae039 = $7ac564dc7b213020$var$stackClasses;


'use client';


var $b5148d23ad5d90bb$exports = {};

$parcel$defineInteropFlag($b5148d23ad5d90bb$exports);

$parcel$export($b5148d23ad5d90bb$exports, "default", () => $fa230948139f2492$export$2e2bcd8739ae039);
$parcel$export($b5148d23ad5d90bb$exports, "stepClasses", () => $85763d6f4c7e74c7$export$2e2bcd8739ae039);
$parcel$export($b5148d23ad5d90bb$exports, "StepContext", () => $e279640208208f42$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");
var $5f75ea7f43c8474b$exports = {};

$parcel$defineInteropFlag($5f75ea7f43c8474b$exports);

$parcel$export($5f75ea7f43c8474b$exports, "useStepperContext", () => $5f75ea7f43c8474b$export$1ff9b16b13b0447);
$parcel$export($5f75ea7f43c8474b$exports, "default", () => $5f75ea7f43c8474b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * Provides information about the current step in Stepper.
 */ const $5f75ea7f43c8474b$var$StepperContext = /*#__PURE__*/ $acw62.createContext({});
function $5f75ea7f43c8474b$export$1ff9b16b13b0447() {
    return $acw62.useContext($5f75ea7f43c8474b$var$StepperContext);
}
var $5f75ea7f43c8474b$export$2e2bcd8739ae039 = $5f75ea7f43c8474b$var$StepperContext;


var $e279640208208f42$exports = {};

$parcel$defineInteropFlag($e279640208208f42$exports);

$parcel$export($e279640208208f42$exports, "useStepContext", () => $e279640208208f42$export$90d5f24cfecec416);
$parcel$export($e279640208208f42$exports, "default", () => $e279640208208f42$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * Provides information about the current step in Stepper.
 */ const $e279640208208f42$var$StepContext = /*#__PURE__*/ $acw62.createContext({});
function $e279640208208f42$export$90d5f24cfecec416() {
    return $acw62.useContext($e279640208208f42$var$StepContext);
}
var $e279640208208f42$export$2e2bcd8739ae039 = $e279640208208f42$var$StepContext;



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $85763d6f4c7e74c7$exports = {};

$parcel$defineInteropFlag($85763d6f4c7e74c7$exports);

$parcel$export($85763d6f4c7e74c7$exports, "getStepUtilityClass", () => $85763d6f4c7e74c7$export$8977e0f3c012cfac);
$parcel$export($85763d6f4c7e74c7$exports, "default", () => $85763d6f4c7e74c7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $85763d6f4c7e74c7$export$8977e0f3c012cfac(slot) {
    return (0, $4Cod0.default)('MuiStep', slot);
}
const $85763d6f4c7e74c7$var$stepClasses = (0, $beCSm.default)('MuiStep', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'completed'
]);
var $85763d6f4c7e74c7$export$2e2bcd8739ae039 = $85763d6f4c7e74c7$var$stepClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fa230948139f2492$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $fa230948139f2492$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            completed && 'completed'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $85763d6f4c7e74c7$export$8977e0f3c012cfac), classes);
};
const $fa230948139f2492$var$StepRoot = (0, $d8seH.default)('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.orientation === 'horizontal' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: 'relative'
    }));
const $fa230948139f2492$var$Step = /*#__PURE__*/ $acw62.forwardRef(function Step(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStep'
    });
    const { active: activeProp, children: children, className: className, component: component = 'div', completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $1En50.default)(props, $fa230948139f2492$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $acw62.useContext((0, $5f75ea7f43c8474b$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $acw62.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $fa230948139f2492$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $ayMG0.jsxs)($fa230948139f2492$var$StepRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e279640208208f42$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $fa230948139f2492$export$2e2bcd8739ae039 = $fa230948139f2492$var$Step;




'use client';
$parcel$exportWildcard($b5148d23ad5d90bb$exports, $85763d6f4c7e74c7$exports);
$parcel$exportWildcard($b5148d23ad5d90bb$exports, $e279640208208f42$exports);


var $e9380b273cd6ee6d$exports = {};

$parcel$defineInteropFlag($e9380b273cd6ee6d$exports);

$parcel$export($e9380b273cd6ee6d$exports, "default", () => $2837485fb2fa495c$export$2e2bcd8739ae039);
$parcel$export($e9380b273cd6ee6d$exports, "stepButtonClasses", () => $2c6cfca685d9c4a3$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $6e8b174384ed5c4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5b3e87234e6d594a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');



var $3ErGR = parcelRequire("3ErGR");
var $545def50b7760bec$exports = {};

$parcel$defineInteropFlag($545def50b7760bec$exports);

$parcel$export($545def50b7760bec$exports, "getStepIconUtilityClass", () => $545def50b7760bec$export$62a6e0748bec9297);
$parcel$export($545def50b7760bec$exports, "default", () => $545def50b7760bec$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $545def50b7760bec$export$62a6e0748bec9297(slot) {
    return (0, $4Cod0.default)('MuiStepIcon', slot);
}
const $545def50b7760bec$var$stepIconClasses = (0, $beCSm.default)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $545def50b7760bec$export$2e2bcd8739ae039 = $545def50b7760bec$var$stepIconClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $09445c1bc5a83d17$var$_circle;
const $09445c1bc5a83d17$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $09445c1bc5a83d17$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $545def50b7760bec$export$62a6e0748bec9297), classes);
};
const $09445c1bc5a83d17$var$StepIconRoot = (0, $d8seH.default)((0, $3ErGR.default), {
    name: 'MuiStepIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $545def50b7760bec$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $545def50b7760bec$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $545def50b7760bec$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $09445c1bc5a83d17$var$StepIconText = (0, $d8seH.default)('text', {
    name: 'MuiStepIcon',
    slot: 'Text',
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $09445c1bc5a83d17$var$StepIcon = /*#__PURE__*/ $acw62.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $1En50.default)(props, $09445c1bc5a83d17$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $09445c1bc5a83d17$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $9QePP.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, (0, $8nd05.default)({
            as: (0, $5b3e87234e6d594a$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, (0, $8nd05.default)({
            as: (0, $6e8b174384ed5c4f$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($09445c1bc5a83d17$var$StepIconRoot, (0, $8nd05.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $09445c1bc5a83d17$var$_circle || ($09445c1bc5a83d17$var$_circle = /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
var $09445c1bc5a83d17$export$2e2bcd8739ae039 = $09445c1bc5a83d17$var$StepIcon;




var $7a65356a062b77fd$exports = {};

$parcel$defineInteropFlag($7a65356a062b77fd$exports);

$parcel$export($7a65356a062b77fd$exports, "getStepLabelUtilityClass", () => $7a65356a062b77fd$export$9625a725551d158a);
$parcel$export($7a65356a062b77fd$exports, "default", () => $7a65356a062b77fd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $7a65356a062b77fd$export$9625a725551d158a(slot) {
    return (0, $4Cod0.default)('MuiStepLabel', slot);
}
const $7a65356a062b77fd$var$stepLabelClasses = (0, $beCSm.default)('MuiStepLabel', [
    'root',
    'horizontal',
    'vertical',
    'label',
    'active',
    'completed',
    'error',
    'disabled',
    'iconContainer',
    'alternativeLabel',
    'labelContainer'
]);
var $7a65356a062b77fd$export$2e2bcd8739ae039 = $7a65356a062b77fd$var$stepLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a38d9d8360b02e78$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $a38d9d8360b02e78$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7a65356a062b77fd$export$9625a725551d158a), classes);
};
const $a38d9d8360b02e78$var$StepLabelRoot = (0, $d8seH.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        alignItems: 'center',
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: 'column'
        },
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.orientation === 'vertical' && {
        textAlign: 'left',
        padding: '8px 0'
    }));
const $a38d9d8360b02e78$var$StepLabelLabel = (0, $d8seH.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $a38d9d8360b02e78$var$StepLabelIconContainer = (0, $d8seH.default)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer',
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: 'flex',
        paddingRight: 8,
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $a38d9d8360b02e78$var$StepLabelLabelContainer = (0, $d8seH.default)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer',
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $7a65356a062b77fd$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: 'center'
        }
    }));
const $a38d9d8360b02e78$var$StepLabel = /*#__PURE__*/ $acw62.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $1En50.default)(props, $a38d9d8360b02e78$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $acw62.useContext((0, $5f75ea7f43c8474b$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $acw62.useContext((0, $e279640208208f42$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $09445c1bc5a83d17$export$2e2bcd8739ae039);
    const ownerState = (0, $8nd05.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $a38d9d8360b02e78$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a38d9d8360b02e78$var$StepLabelRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)($a38d9d8360b02e78$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(StepIconComponent, (0, $8nd05.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($a38d9d8360b02e78$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $ayMG0.jsx)($a38d9d8360b02e78$var$StepLabelLabel, (0, $8nd05.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $9QePP.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$a38d9d8360b02e78$var$StepLabel.muiName = 'StepLabel';
var $a38d9d8360b02e78$export$2e2bcd8739ae039 = $a38d9d8360b02e78$var$StepLabel;





var $2c6cfca685d9c4a3$exports = {};

$parcel$defineInteropFlag($2c6cfca685d9c4a3$exports);

$parcel$export($2c6cfca685d9c4a3$exports, "getStepButtonUtilityClass", () => $2c6cfca685d9c4a3$export$cf88ccb13a9e566a);
$parcel$export($2c6cfca685d9c4a3$exports, "default", () => $2c6cfca685d9c4a3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2c6cfca685d9c4a3$export$cf88ccb13a9e566a(slot) {
    return (0, $4Cod0.default)('MuiStepButton', slot);
}
const $2c6cfca685d9c4a3$var$stepButtonClasses = (0, $beCSm.default)('MuiStepButton', [
    'root',
    'horizontal',
    'vertical',
    'touchRipple'
]);
var $2c6cfca685d9c4a3$export$2e2bcd8739ae039 = $2c6cfca685d9c4a3$var$stepButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2837485fb2fa495c$var$_excluded = [
    "children",
    "className",
    "icon",
    "optional"
];
const $2837485fb2fa495c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation } = ownerState;
    const slots = {
        root: [
            'root',
            orientation
        ],
        touchRipple: [
            'touchRipple'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2c6cfca685d9c4a3$export$cf88ccb13a9e566a), classes);
};
const $2837485fb2fa495c$var$StepButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiStepButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2c6cfca685d9c4a3$export$2e2bcd8739ae039).touchRipple}`]: styles.touchRipple
            },
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: '100%',
        padding: '24px 16px',
        margin: '-24px -16px',
        boxSizing: 'content-box'
    }, ownerState.orientation === 'vertical' && {
        justifyContent: 'flex-start',
        padding: '8px',
        margin: '-8px'
    }, {
        [`& .${(0, $2c6cfca685d9c4a3$export$2e2bcd8739ae039).touchRipple}`]: {
            color: 'rgba(0, 0, 0, 0.3)'
        }
    }));
const $2837485fb2fa495c$var$StepButton = /*#__PURE__*/ $acw62.forwardRef(function StepButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepButton'
    });
    const { children: children, className: className, icon: icon, optional: optional } = props, other = (0, $1En50.default)(props, $2837485fb2fa495c$var$_excluded);
    const { disabled: disabled, active: active } = $acw62.useContext((0, $e279640208208f42$export$2e2bcd8739ae039));
    const { orientation: orientation } = $acw62.useContext((0, $5f75ea7f43c8474b$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        orientation: orientation
    });
    const classes = $2837485fb2fa495c$var$useUtilityClasses(ownerState);
    const childProps = {
        icon: icon,
        optional: optional
    };
    const child = (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(children, [
        'StepLabel'
    ]) ? /*#__PURE__*/ $acw62.cloneElement(children, childProps) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a38d9d8360b02e78$export$2e2bcd8739ae039), (0, $8nd05.default)({}, childProps, {
        children: children
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2837485fb2fa495c$var$StepButtonRoot, (0, $8nd05.default)({
        focusRipple: true,
        disabled: disabled,
        TouchRippleProps: {
            className: classes.touchRipple
        },
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        "aria-current": active ? 'step' : undefined
    }, other, {
        children: child
    }));
});
var $2837485fb2fa495c$export$2e2bcd8739ae039 = $2837485fb2fa495c$var$StepButton;



'use client';
$parcel$exportWildcard($e9380b273cd6ee6d$exports, $2c6cfca685d9c4a3$exports);


var $e108709a7cb36655$exports = {};

$parcel$defineInteropFlag($e108709a7cb36655$exports);

$parcel$export($e108709a7cb36655$exports, "default", () => $33aca0a7deb8d615$export$2e2bcd8739ae039);
$parcel$export($e108709a7cb36655$exports, "stepConnectorClasses", () => $4d2463e67e3000c3$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $4d2463e67e3000c3$exports = {};

$parcel$defineInteropFlag($4d2463e67e3000c3$exports);

$parcel$export($4d2463e67e3000c3$exports, "getStepConnectorUtilityClass", () => $4d2463e67e3000c3$export$6fbaff484b0d9308);
$parcel$export($4d2463e67e3000c3$exports, "default", () => $4d2463e67e3000c3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4d2463e67e3000c3$export$6fbaff484b0d9308(slot) {
    return (0, $4Cod0.default)('MuiStepConnector', slot);
}
const $4d2463e67e3000c3$var$stepConnectorClasses = (0, $beCSm.default)('MuiStepConnector', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'active',
    'completed',
    'disabled',
    'line',
    'lineHorizontal',
    'lineVertical'
]);
var $4d2463e67e3000c3$export$2e2bcd8739ae039 = $4d2463e67e3000c3$var$stepConnectorClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $33aca0a7deb8d615$var$_excluded = [
    "className"
];
const $33aca0a7deb8d615$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            active && 'active',
            completed && 'completed',
            disabled && 'disabled'
        ],
        line: [
            'line',
            `line${(0, $jTnBY.default)(orientation)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4d2463e67e3000c3$export$6fbaff484b0d9308), classes);
};
const $33aca0a7deb8d615$var$StepConnectorRoot = (0, $d8seH.default)('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto'
    }, ownerState.orientation === 'vertical' && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: 'absolute',
        top: 12,
        left: 'calc(-50% + 20px)',
        right: 'calc(50% + 20px)'
    }));
const $33aca0a7deb8d615$var$StepConnectorLine = (0, $d8seH.default)('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $jTnBY.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $8nd05.default)({
        display: 'block',
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === 'horizontal' && {
        borderTopStyle: 'solid',
        borderTopWidth: 1
    }, ownerState.orientation === 'vertical' && {
        borderLeftStyle: 'solid',
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $33aca0a7deb8d615$var$StepConnector = /*#__PURE__*/ $acw62.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepConnector'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $33aca0a7deb8d615$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = 'horizontal' } = $acw62.useContext((0, $5f75ea7f43c8474b$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $acw62.useContext((0, $e279640208208f42$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $33aca0a7deb8d615$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($33aca0a7deb8d615$var$StepConnectorRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($33aca0a7deb8d615$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
var $33aca0a7deb8d615$export$2e2bcd8739ae039 = $33aca0a7deb8d615$var$StepConnector;



'use client';
$parcel$exportWildcard($e108709a7cb36655$exports, $4d2463e67e3000c3$exports);


var $80db82a861533602$exports = {};

$parcel$defineInteropFlag($80db82a861533602$exports);

$parcel$export($80db82a861533602$exports, "default", () => $a0bdd2eb216e9220$export$2e2bcd8739ae039);
$parcel$export($80db82a861533602$exports, "stepContentClasses", () => $41029dbb16e3c896$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $41029dbb16e3c896$exports = {};

$parcel$defineInteropFlag($41029dbb16e3c896$exports);

$parcel$export($41029dbb16e3c896$exports, "getStepContentUtilityClass", () => $41029dbb16e3c896$export$2a65e9f482ac3350);
$parcel$export($41029dbb16e3c896$exports, "default", () => $41029dbb16e3c896$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $41029dbb16e3c896$export$2a65e9f482ac3350(slot) {
    return (0, $4Cod0.default)('MuiStepContent', slot);
}
const $41029dbb16e3c896$var$stepContentClasses = (0, $beCSm.default)('MuiStepContent', [
    'root',
    'last',
    'transition'
]);
var $41029dbb16e3c896$export$2e2bcd8739ae039 = $41029dbb16e3c896$var$stepContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a0bdd2eb216e9220$var$_excluded = [
    "children",
    "className",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $a0bdd2eb216e9220$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, last: last } = ownerState;
    const slots = {
        root: [
            'root',
            last && 'last'
        ],
        transition: [
            'transition'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $41029dbb16e3c896$export$2a65e9f482ac3350), classes);
};
const $a0bdd2eb216e9220$var$StepContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiStepContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.last && styles.last
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        marginLeft: 12,
        // half icon
        paddingLeft: 20,
        // margin + half icon
        paddingRight: 8,
        borderLeft: theme.vars ? `1px solid ${theme.vars.palette.StepContent.border}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]}`
    }, ownerState.last && {
        borderLeft: 'none'
    }));
const $a0bdd2eb216e9220$var$StepContentTransition = (0, $d8seH.default)((0, $848dc8709a4309c5$export$2e2bcd8739ae039), {
    name: 'MuiStepContent',
    slot: 'Transition',
    overridesResolver: (props, styles)=>styles.transition
})({});
const $a0bdd2eb216e9220$var$StepContent = /*#__PURE__*/ $acw62.forwardRef(function StepContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepContent'
    });
    const { children: children, className: className, TransitionComponent: TransitionComponent = (0, $848dc8709a4309c5$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $a0bdd2eb216e9220$var$_excluded);
    const { orientation: orientation } = $acw62.useContext((0, $5f75ea7f43c8474b$export$2e2bcd8739ae039));
    const { active: active, last: last, expanded: expanded } = $acw62.useContext((0, $e279640208208f42$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        last: last
    });
    const classes = $a0bdd2eb216e9220$var$useUtilityClasses(ownerState);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a0bdd2eb216e9220$var$StepContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a0bdd2eb216e9220$var$StepContentTransition, (0, $8nd05.default)({
            as: TransitionComponent,
            in: active || expanded,
            className: classes.transition,
            ownerState: ownerState,
            timeout: transitionDuration,
            unmountOnExit: true
        }, TransitionProps, {
            children: children
        }))
    }));
});
var $a0bdd2eb216e9220$export$2e2bcd8739ae039 = $a0bdd2eb216e9220$var$StepContent;



'use client';
$parcel$exportWildcard($80db82a861533602$exports, $41029dbb16e3c896$exports);


var $1ff0fbd06d13ad2a$exports = {};

$parcel$defineInteropFlag($1ff0fbd06d13ad2a$exports);

$parcel$export($1ff0fbd06d13ad2a$exports, "default", () => $09445c1bc5a83d17$export$2e2bcd8739ae039);
$parcel$export($1ff0fbd06d13ad2a$exports, "stepIconClasses", () => $545def50b7760bec$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($1ff0fbd06d13ad2a$exports, $545def50b7760bec$exports);


var $931cdf5c02131bb6$exports = {};

$parcel$defineInteropFlag($931cdf5c02131bb6$exports);

$parcel$export($931cdf5c02131bb6$exports, "default", () => $a38d9d8360b02e78$export$2e2bcd8739ae039);
$parcel$export($931cdf5c02131bb6$exports, "stepLabelClasses", () => $7a65356a062b77fd$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($931cdf5c02131bb6$exports, $7a65356a062b77fd$exports);


var $3e1c1ec9d9e33247$exports = {};

$parcel$defineInteropFlag($3e1c1ec9d9e33247$exports);

$parcel$export($3e1c1ec9d9e33247$exports, "default", () => $0a0f8c19f5f3ee7a$export$2e2bcd8739ae039);
$parcel$export($3e1c1ec9d9e33247$exports, "stepperClasses", () => $569430a767235b4e$export$2e2bcd8739ae039);
$parcel$export($3e1c1ec9d9e33247$exports, "StepperContext", () => $5f75ea7f43c8474b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $569430a767235b4e$exports = {};

$parcel$defineInteropFlag($569430a767235b4e$exports);

$parcel$export($569430a767235b4e$exports, "getStepperUtilityClass", () => $569430a767235b4e$export$797947b6292e28e1);
$parcel$export($569430a767235b4e$exports, "default", () => $569430a767235b4e$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $569430a767235b4e$export$797947b6292e28e1(slot) {
    return (0, $4Cod0.default)('MuiStepper', slot);
}
const $569430a767235b4e$var$stepperClasses = (0, $beCSm.default)('MuiStepper', [
    'root',
    'horizontal',
    'vertical',
    'nonLinear',
    'alternativeLabel'
]);
var $569430a767235b4e$export$2e2bcd8739ae039 = $569430a767235b4e$var$stepperClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0a0f8c19f5f3ee7a$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $0a0f8c19f5f3ee7a$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, nonLinear: nonLinear, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            nonLinear && 'nonLinear',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $569430a767235b4e$export$797947b6292e28e1), classes);
};
const $0a0f8c19f5f3ee7a$var$StepperRoot = (0, $d8seH.default)('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.nonLinear && styles.nonLinear
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex'
    }, ownerState.orientation === 'horizontal' && {
        flexDirection: 'row',
        alignItems: 'center'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.alternativeLabel && {
        alignItems: 'flex-start'
    }));
const $0a0f8c19f5f3ee7a$var$defaultConnector = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33aca0a7deb8d615$export$2e2bcd8739ae039), {});
const $0a0f8c19f5f3ee7a$var$Stepper = /*#__PURE__*/ $acw62.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepper'
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = 'div', connector: connector = $0a0f8c19f5f3ee7a$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = 'horizontal' } = props, other = (0, $1En50.default)(props, $0a0f8c19f5f3ee7a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        nonLinear: nonLinear,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $0a0f8c19f5f3ee7a$var$useUtilityClasses(ownerState);
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $acw62.cloneElement(step, (0, $8nd05.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $acw62.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f75ea7f43c8474b$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($0a0f8c19f5f3ee7a$var$StepperRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
var $0a0f8c19f5f3ee7a$export$2e2bcd8739ae039 = $0a0f8c19f5f3ee7a$var$Stepper;




'use client';
$parcel$exportWildcard($3e1c1ec9d9e33247$exports, $569430a767235b4e$exports);
$parcel$exportWildcard($3e1c1ec9d9e33247$exports, $5f75ea7f43c8474b$exports);


var $f943077249b43968$exports = {};

$parcel$defineInteropFlag($f943077249b43968$exports);

$parcel$export($f943077249b43968$exports, "default", () => (parcelRequire("3ErGR")).default);
$parcel$export($f943077249b43968$exports, "svgIconClasses", () => (parcelRequire("aiIP4")).default);

var $3ErGR = parcelRequire("3ErGR");

var $aiIP4 = parcelRequire("aiIP4");
'use client';
$parcel$exportWildcard($f943077249b43968$exports, $aiIP4);


var $3ErGR = parcelRequire("3ErGR");
var $b471573c23b3da9a$exports = {};

$parcel$defineInteropFlag($b471573c23b3da9a$exports);

$parcel$export($b471573c23b3da9a$exports, "default", () => $b451cc713fab7e92$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");





var $1iOpW = parcelRequire("1iOpW");









var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $jTnBY = parcelRequire("jTnBY");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c42d0c4e6d0277b4$var$_excluded = [
    "anchor",
    "classes",
    "className",
    "width",
    "style"
];
const $c42d0c4e6d0277b4$var$SwipeAreaRoot = (0, $d8seH.default)('div', {
    name: 'MuiSwipeArea',
    shouldForwardProp: (0, $8Uq77.default)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.drawer - 1
    }, ownerState.anchor === 'left' && {
        right: 'auto'
    }, ownerState.anchor === 'right' && {
        left: 'auto',
        right: 0
    }, ownerState.anchor === 'top' && {
        bottom: 'auto',
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        bottom: 0,
        right: 0
    }));
/**
 * @ignore - internal component.
 */ const $c42d0c4e6d0277b4$var$SwipeArea = /*#__PURE__*/ $acw62.forwardRef(function SwipeArea(props, ref) {
    const { anchor: anchor, classes: classes = {}, className: className, width: width, style: style } = props, other = (0, $1En50.default)(props, $c42d0c4e6d0277b4$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c42d0c4e6d0277b4$var$SwipeAreaRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0, $jTnBY.default)(anchor)}`], className),
        ref: ref,
        style: (0, $8nd05.default)({
            [(0, $1ed9758f3bc045cc$export$2a62b49acb270576)(anchor) ? 'width' : 'height']: width
        }, style),
        ownerState: ownerState
    }, other));
});
var $c42d0c4e6d0277b4$export$2e2bcd8739ae039 = $c42d0c4e6d0277b4$var$SwipeArea;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b451cc713fab7e92$var$_excluded = [
    "BackdropProps"
], $b451cc713fab7e92$var$_excluded2 = [
    "anchor",
    "disableBackdropTransition",
    "disableDiscovery",
    "disableSwipeToOpen",
    "hideBackdrop",
    "hysteresis",
    "allowSwipeInChildren",
    "minFlingVelocity",
    "ModalProps",
    "onClose",
    "onOpen",
    "open",
    "PaperProps",
    "SwipeAreaProps",
    "swipeAreaWidth",
    "transitionDuration",
    "variant"
];
const $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD = 3; // px
// This is the part of the drawer displayed on touch start.
const $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL = 20; // px
// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
let $b451cc713fab7e92$var$claimedSwipeInstance = null;
function $b451cc713fab7e92$export$aad8462122ac592b() {
    $b451cc713fab7e92$var$claimedSwipeInstance = null;
}
function $b451cc713fab7e92$var$calculateCurrentX(anchor, touches, doc) {
    return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function $b451cc713fab7e92$var$calculateCurrentY(anchor, touches, containerWindow) {
    return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}
function $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperInstance) {
    return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function $b451cc713fab7e92$var$getTranslate(currentTranslate, startLocation, open, maxTranslate) {
    return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */ function $b451cc713fab7e92$var$getDomTreeShapes(element, rootNode) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
    const domTreeShapes = [];
    while(element && element !== rootNode.parentElement){
        const style = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(rootNode).getComputedStyle(element);
        if (// Ignore the scroll children if the element is absolute positioned.
        style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue('overflow-x') === 'hidden') ;
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push(element);
        element = element.parentElement;
    }
    return domTreeShapes;
}
/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */ function $b451cc713fab7e92$var$computeHasNativeHandler({ domTreeShapes: domTreeShapes, start: start, current: current, anchor: anchor }) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
    const axisProperties = {
        scrollPosition: {
            x: 'scrollLeft',
            y: 'scrollTop'
        },
        scrollLength: {
            x: 'scrollWidth',
            y: 'scrollHeight'
        },
        clientLength: {
            x: 'clientWidth',
            y: 'clientHeight'
        }
    };
    return domTreeShapes.some((shape)=>{
        // Determine if we are going backward or forward.
        let goingForward = current >= start;
        if (anchor === 'top' || anchor === 'left') goingForward = !goingForward;
        const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
        const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
        const areNotAtStart = scrollPosition > 0;
        const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) return true;
        return false;
    });
}
const $b451cc713fab7e92$var$iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const $b451cc713fab7e92$var$SwipeableDrawer = /*#__PURE__*/ $acw62.forwardRef(function SwipeableDrawer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSwipeableDrawer',
        props: inProps
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const transitionDurationDefault = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchor = 'left', disableBackdropTransition: disableBackdropTransition = false, disableDiscovery: disableDiscovery = false, disableSwipeToOpen: disableSwipeToOpen = $b451cc713fab7e92$var$iOS, hideBackdrop: hideBackdrop, hysteresis: hysteresis = 0.52, allowSwipeInChildren: allowSwipeInChildren = false, minFlingVelocity: minFlingVelocity = 450, ModalProps: { BackdropProps: BackdropProps } = {}, onClose: onClose, onOpen: onOpen, open: open = false, PaperProps: PaperProps = {}, SwipeAreaProps: SwipeAreaProps, swipeAreaWidth: swipeAreaWidth = 20, transitionDuration: transitionDuration = transitionDurationDefault, variant: variant = 'temporary' // Mobile first.
     } = props, ModalPropsProp = (0, $1En50.default)(props.ModalProps, $b451cc713fab7e92$var$_excluded), other = (0, $1En50.default)(props, $b451cc713fab7e92$var$_excluded2);
    const [maybeSwiping, setMaybeSwiping] = $acw62.useState(false);
    const swipeInstance = $acw62.useRef({
        isSwiping: null
    });
    const swipeAreaRef = $acw62.useRef();
    const backdropRef = $acw62.useRef();
    const paperRef = $acw62.useRef();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(PaperProps.ref, paperRef);
    const touchDetected = $acw62.useRef(false);
    // Ref for transition duration based on / to match swipe speed
    const calculatedDurationRef = $acw62.useRef();
    // Use a ref so the open value used is always up to date inside useCallback.
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        calculatedDurationRef.current = null;
    }, [
        open
    ]);
    const setPosition = $acw62.useCallback((translate, options = {})=>{
        const { mode: mode = null, changeTransition: changeTransition = true } = options;
        const anchorRtl = (0, $1ed9758f3bc045cc$export$830f4f08342d299e)(theme, anchor);
        const rtlTranslateMultiplier = [
            'right',
            'bottom'
        ].indexOf(anchorRtl) !== -1 ? 1 : -1;
        const horizontalSwipe = (0, $1ed9758f3bc045cc$export$2a62b49acb270576)(anchor);
        const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
        const drawerStyle = paperRef.current.style;
        drawerStyle.webkitTransform = transform;
        drawerStyle.transform = transform;
        let transition = '';
        if (mode) transition = theme.transitions.create('all', (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            easing: undefined,
            style: undefined,
            timeout: transitionDuration
        }, {
            mode: mode
        }));
        if (changeTransition) {
            drawerStyle.webkitTransition = transition;
            drawerStyle.transition = transition;
        }
        if (!disableBackdropTransition && !hideBackdrop) {
            const backdropStyle = backdropRef.current.style;
            backdropStyle.opacity = 1 - translate / $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current);
            if (changeTransition) {
                backdropStyle.webkitTransition = transition;
                backdropStyle.transition = transition;
            }
        }
    }, [
        anchor,
        disableBackdropTransition,
        hideBackdrop,
        theme,
        transitionDuration
    ]);
    const handleBodyTouchEnd = (0, $331f3746e6346411$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (!touchDetected.current) return;
        $b451cc713fab7e92$var$claimedSwipeInstance = null;
        touchDetected.current = false;
        $11492dca620dcaa5$exports.flushSync(()=>{
            setMaybeSwiping(false);
        });
        // The swipe wasn't started.
        if (!swipeInstance.current.isSwiping) {
            swipeInstance.current.isSwiping = null;
            return;
        }
        swipeInstance.current.isSwiping = null;
        const anchorRtl = (0, $1ed9758f3bc045cc$export$830f4f08342d299e)(theme, anchor);
        const horizontal = (0, $1ed9758f3bc045cc$export$2a62b49acb270576)(anchor);
        let current;
        if (horizontal) current = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0, $c10afe25107351d9$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        else current = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0, $707049eb9639aeac$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
        const maxTranslate = $b451cc713fab7e92$var$getMaxTranslate(horizontal, paperRef.current);
        const currentTranslate = $b451cc713fab7e92$var$getTranslate(current, startLocation, open, maxTranslate);
        const translateRatio = currentTranslate / maxTranslate;
        if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) // Calculate transition duration to match swipe speed
        calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
        if (open) {
            if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) onClose();
            else // Reset the position, the swipe was aborted.
            setPosition(0, {
                mode: 'exit'
            });
            return;
        }
        if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) onOpen();
        else // Reset the position, the swipe was aborted.
        setPosition($b451cc713fab7e92$var$getMaxTranslate(horizontal, paperRef.current), {
            mode: 'enter'
        });
    });
    const startMaybeSwiping = (force = false)=>{
        if (!maybeSwiping) {
            // on Safari Mobile, if you want to be able to have the 'click' event fired on child elements, nothing in the DOM can be changed.
            // this is because Safari Mobile will not fire any mouse events (still fires touch though) if the DOM changes during mousemove.
            // so do this change on first touchmove instead of touchstart
            if (force || !(disableDiscovery && allowSwipeInChildren)) $11492dca620dcaa5$exports.flushSync(()=>{
                setMaybeSwiping(true);
            });
            const horizontalSwipe = (0, $1ed9758f3bc045cc$export$2a62b49acb270576)(anchor);
            if (!open && paperRef.current) // The ref may be null when a parent component updates while swiping.
            setPosition($b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -$b451cc713fab7e92$var$DRAG_STARTED_SIGNAL), {
                changeTransition: false
            });
            swipeInstance.current.velocity = 0;
            swipeInstance.current.lastTime = null;
            swipeInstance.current.lastTranslate = null;
            swipeInstance.current.paperHit = false;
            touchDetected.current = true;
        }
    };
    const handleBodyTouchMove = (0, $331f3746e6346411$export$2e2bcd8739ae039)((nativeEvent)=>{
        // the ref may be null when a parent component updates while swiping
        if (!paperRef.current || !touchDetected.current) return;
        // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
        if ($b451cc713fab7e92$var$claimedSwipeInstance !== null && $b451cc713fab7e92$var$claimedSwipeInstance !== swipeInstance.current) return;
        startMaybeSwiping(true);
        const anchorRtl = (0, $1ed9758f3bc045cc$export$830f4f08342d299e)(theme, anchor);
        const horizontalSwipe = (0, $1ed9758f3bc045cc$export$2a62b49acb270576)(anchor);
        const currentX = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $c10afe25107351d9$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        const currentY = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $707049eb9639aeac$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        if (open && paperRef.current.contains(nativeEvent.target) && $b451cc713fab7e92$var$claimedSwipeInstance === null) {
            const domTreeShapes = $b451cc713fab7e92$var$getDomTreeShapes(nativeEvent.target, paperRef.current);
            const hasNativeHandler = $b451cc713fab7e92$var$computeHasNativeHandler({
                domTreeShapes: domTreeShapes,
                start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
                current: horizontalSwipe ? currentX : currentY,
                anchor: anchor
            });
            if (hasNativeHandler) {
                $b451cc713fab7e92$var$claimedSwipeInstance = true;
                return;
            }
            $b451cc713fab7e92$var$claimedSwipeInstance = swipeInstance.current;
        }
        // We don't know yet.
        if (swipeInstance.current.isSwiping == null) {
            const dx = Math.abs(currentX - swipeInstance.current.startX);
            const dy = Math.abs(currentY - swipeInstance.current.startY);
            const definitelySwiping = horizontalSwipe ? dx > dy && dx > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD : dy > dx && dy > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD;
            if (definitelySwiping && nativeEvent.cancelable) nativeEvent.preventDefault();
            if (definitelySwiping === true || (horizontalSwipe ? dy > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD : dx > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD)) {
                swipeInstance.current.isSwiping = definitelySwiping;
                if (!definitelySwiping) {
                    handleBodyTouchEnd(nativeEvent);
                    return;
                }
                // Shift the starting point.
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
                // Compensate for the part of the drawer displayed on touch start.
                if (!disableDiscovery && !open) {
                    if (horizontalSwipe) swipeInstance.current.startX -= $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL;
                    else swipeInstance.current.startY -= $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL;
                }
            }
        }
        if (!swipeInstance.current.isSwiping) return;
        const maxTranslate = $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current);
        let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
        if (open && !swipeInstance.current.paperHit) startLocation = Math.min(startLocation, maxTranslate);
        const translate = $b451cc713fab7e92$var$getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
        if (open) {
            if (!swipeInstance.current.paperHit) {
                const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
                if (paperHit) {
                    swipeInstance.current.paperHit = true;
                    swipeInstance.current.startX = currentX;
                    swipeInstance.current.startY = currentY;
                } else return;
            } else if (translate === 0) {
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
            }
        }
        if (swipeInstance.current.lastTranslate === null) {
            swipeInstance.current.lastTranslate = translate;
            swipeInstance.current.lastTime = performance.now() + 1;
        }
        const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;
        // Low Pass filter.
        swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
        swipeInstance.current.lastTranslate = translate;
        swipeInstance.current.lastTime = performance.now();
        // We are swiping, let's prevent the scroll event on iOS.
        if (nativeEvent.cancelable) nativeEvent.preventDefault();
        setPosition(translate);
    });
    const handleBodyTouchStart = (0, $331f3746e6346411$export$2e2bcd8739ae039)((nativeEvent)=>{
        // We are not supposed to handle this touch move.
        // Example of use case: ignore the event if there is a Slider.
        if (nativeEvent.defaultPrevented) return;
        // We can only have one node at the time claiming ownership for handling the swipe.
        if (nativeEvent.defaultMuiPrevented) return;
        // At least one element clogs the drawer interaction zone.
        if (open && (hideBackdrop || !backdropRef.current.contains(nativeEvent.target)) && !paperRef.current.contains(nativeEvent.target)) return;
        const anchorRtl = (0, $1ed9758f3bc045cc$export$830f4f08342d299e)(theme, anchor);
        const horizontalSwipe = (0, $1ed9758f3bc045cc$export$2a62b49acb270576)(anchor);
        const currentX = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $c10afe25107351d9$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        const currentY = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $707049eb9639aeac$export$2e2bcd8739ae039)(nativeEvent.currentTarget));
        if (!open) {
            var _paperRef$current;
            // logic for if swipe should be ignored:
            // if disableSwipeToOpen
            // if target != swipeArea, and target is not a child of paper ref
            // if is a child of paper ref, and `allowSwipeInChildren` does not allow it
            if (disableSwipeToOpen || !(nativeEvent.target === swipeAreaRef.current || (_paperRef$current = paperRef.current) != null && _paperRef$current.contains(nativeEvent.target) && (typeof allowSwipeInChildren === 'function' ? allowSwipeInChildren(nativeEvent, swipeAreaRef.current, paperRef.current) : allowSwipeInChildren))) return;
            if (horizontalSwipe) {
                if (currentX > swipeAreaWidth) return;
            } else if (currentY > swipeAreaWidth) return;
        }
        nativeEvent.defaultMuiPrevented = true;
        $b451cc713fab7e92$var$claimedSwipeInstance = null;
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
        startMaybeSwiping();
    });
    $acw62.useEffect(()=>{
        if (variant === 'temporary') {
            const doc = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(paperRef.current);
            doc.addEventListener('touchstart', handleBodyTouchStart);
            // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
            // It only needs to prevent scrolling on the drawer's content when open.
            // When closed, the overlay prevents scrolling.
            doc.addEventListener('touchmove', handleBodyTouchMove, {
                passive: !open
            });
            doc.addEventListener('touchend', handleBodyTouchEnd);
            return ()=>{
                doc.removeEventListener('touchstart', handleBodyTouchStart);
                doc.removeEventListener('touchmove', handleBodyTouchMove, {
                    passive: !open
                });
                doc.removeEventListener('touchend', handleBodyTouchEnd);
            };
        }
        return undefined;
    }, [
        variant,
        open,
        handleBodyTouchStart,
        handleBodyTouchMove,
        handleBodyTouchEnd
    ]);
    $acw62.useEffect(()=>()=>{
            // We need to release the lock.
            if ($b451cc713fab7e92$var$claimedSwipeInstance === swipeInstance.current) $b451cc713fab7e92$var$claimedSwipeInstance = null;
        }, []);
    $acw62.useEffect(()=>{
        if (!open) setMaybeSwiping(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ed9758f3bc045cc$export$2e2bcd8739ae039), (0, $8nd05.default)({
                open: variant === 'temporary' && maybeSwiping ? true : open,
                variant: variant,
                ModalProps: (0, $8nd05.default)({
                    BackdropProps: (0, $8nd05.default)({}, BackdropProps, {
                        ref: backdropRef
                    })
                }, variant === 'temporary' && {
                    keepMounted: true
                }, ModalPropsProp),
                hideBackdrop: hideBackdrop,
                PaperProps: (0, $8nd05.default)({}, PaperProps, {
                    style: (0, $8nd05.default)({
                        pointerEvents: variant === 'temporary' && !open && !allowSwipeInChildren ? 'none' : ''
                    }, PaperProps.style),
                    ref: handleRef
                }),
                anchor: anchor,
                transitionDuration: calculatedDurationRef.current || transitionDuration,
                onClose: onClose,
                ref: ref
            }, other)),
            !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $397ca82a6faac65f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c42d0c4e6d0277b4$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    anchor: anchor,
                    ref: swipeAreaRef,
                    width: swipeAreaWidth
                }, SwipeAreaProps))
            })
        ]
    });
});
var $b451cc713fab7e92$export$2e2bcd8739ae039 = $b451cc713fab7e92$var$SwipeableDrawer;


'use client';


var $442a3dd08ba79e73$exports = {};

$parcel$defineInteropFlag($442a3dd08ba79e73$exports);

$parcel$export($442a3dd08ba79e73$exports, "default", () => $56ccc0421702a0be$export$2e2bcd8739ae039);
$parcel$export($442a3dd08ba79e73$exports, "switchClasses", () => $5f063e1b0f6d278b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $jTnBY = parcelRequire("jTnBY");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
var $5f063e1b0f6d278b$exports = {};

$parcel$defineInteropFlag($5f063e1b0f6d278b$exports);

$parcel$export($5f063e1b0f6d278b$exports, "getSwitchUtilityClass", () => $5f063e1b0f6d278b$export$39f6debbec19b3ba);
$parcel$export($5f063e1b0f6d278b$exports, "default", () => $5f063e1b0f6d278b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $beCSm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $56ccc0421702a0be$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $jTnBY.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5f063e1b0f6d278b$export$39f6debbec19b3ba), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $kTdcz.lighten)(theme.palette[color].main, 0.62) : (0, $kTdcz.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $1En50.default)(props, $56ccc0421702a0be$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($56ccc0421702a0be$var$SwitchRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, (0, $8nd05.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $8nd05.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;



'use client';
$parcel$exportWildcard($442a3dd08ba79e73$exports, $5f063e1b0f6d278b$exports);


var $68dceac9a9a56312$exports = {};

$parcel$defineInteropFlag($68dceac9a9a56312$exports);

$parcel$export($68dceac9a9a56312$exports, "default", () => $e6a3a0c577f6eee9$export$2e2bcd8739ae039);
$parcel$export($68dceac9a9a56312$exports, "tabClasses", () => $e56e43dd06ac0faa$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $e56e43dd06ac0faa$exports = {};

$parcel$defineInteropFlag($e56e43dd06ac0faa$exports);

$parcel$export($e56e43dd06ac0faa$exports, "getTabUtilityClass", () => $e56e43dd06ac0faa$export$72aef224d6115253);
$parcel$export($e56e43dd06ac0faa$exports, "default", () => $e56e43dd06ac0faa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $beCSm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e6a3a0c577f6eee9$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e56e43dd06ac0faa$export$72aef224d6115253), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: (0, $8nd05.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $1En50.default)(props, $e6a3a0c577f6eee9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, (0, $8nd05.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;



'use client';
$parcel$exportWildcard($68dceac9a9a56312$exports, $e56e43dd06ac0faa$exports);


var $880e97827fd7145b$exports = {};

$parcel$defineInteropFlag($880e97827fd7145b$exports);

$parcel$export($880e97827fd7145b$exports, "default", () => $22fefd5f207422b3$export$2e2bcd8739ae039);
$parcel$export($880e97827fd7145b$exports, "tableClasses", () => $3e2d01fd3f88b8c8$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $3e2d01fd3f88b8c8$exports = {};

$parcel$defineInteropFlag($3e2d01fd3f88b8c8$exports);

$parcel$export($3e2d01fd3f88b8c8$exports, "getTableUtilityClass", () => $3e2d01fd3f88b8c8$export$315cb19215f77ce0);
$parcel$export($3e2d01fd3f88b8c8$exports, "default", () => $3e2d01fd3f88b8c8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $beCSm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22fefd5f207422b3$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3e2d01fd3f88b8c8$export$315cb19215f77ce0), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $8nd05.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $1En50.default)(props, $22fefd5f207422b3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e848e543ed3bf349$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, (0, $8nd05.default)({
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;



'use client';
$parcel$exportWildcard($880e97827fd7145b$exports, $3e2d01fd3f88b8c8$exports);


var $3d935658447069c3$exports = {};

$parcel$defineInteropFlag($3d935658447069c3$exports);

$parcel$export($3d935658447069c3$exports, "default", () => $09d8a23708c3ccc9$export$2e2bcd8739ae039);
$parcel$export($3d935658447069c3$exports, "tableBodyClasses", () => $9a6742b7048414d1$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $9a6742b7048414d1$exports = {};

$parcel$defineInteropFlag($9a6742b7048414d1$exports);

$parcel$export($9a6742b7048414d1$exports, "getTableBodyUtilityClass", () => $9a6742b7048414d1$export$98bd2a9b566ec665);
$parcel$export($9a6742b7048414d1$exports, "default", () => $9a6742b7048414d1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $beCSm.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09d8a23708c3ccc9$var$_excluded = [
    "className",
    "component"
];
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9a6742b7048414d1$export$98bd2a9b566ec665), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent } = props, other = (0, $1En50.default)(props, $09d8a23708c3ccc9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, (0, $8nd05.default)({
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;



'use client';
$parcel$exportWildcard($3d935658447069c3$exports, $9a6742b7048414d1$exports);


var $c9a7707bc8e823db$exports = {};

$parcel$defineInteropFlag($c9a7707bc8e823db$exports);

$parcel$export($c9a7707bc8e823db$exports, "default", () => $a71dfe9e22152ea2$export$2e2bcd8739ae039);
$parcel$export($c9a7707bc8e823db$exports, "tableCellClasses", () => $a8eb3ce62ab46dc7$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $jTnBY = parcelRequire("jTnBY");



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $a8eb3ce62ab46dc7$exports = {};

$parcel$defineInteropFlag($a8eb3ce62ab46dc7$exports);

$parcel$export($a8eb3ce62ab46dc7$exports, "getTableCellUtilityClass", () => $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b);
$parcel$export($a8eb3ce62ab46dc7$exports, "default", () => $a8eb3ce62ab46dc7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a71dfe9e22152ea2$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            padding !== 'normal' && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $kTdcz.lighten)((0, $kTdcz.alpha)(theme.palette.divider, 1), 0.88) : (0, $kTdcz.darken)((0, $kTdcz.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $a8eb3ce62ab46dc7$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1En50.default)(props, $a71dfe9e22152ea2$var$_excluded);
    const table = $acw62.useContext((0, $e848e543ed3bf349$export$2e2bcd8739ae039));
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;



'use client';
$parcel$exportWildcard($c9a7707bc8e823db$exports, $a8eb3ce62ab46dc7$exports);


var $0c34f9894e705401$exports = {};

$parcel$defineInteropFlag($0c34f9894e705401$exports);

$parcel$export($0c34f9894e705401$exports, "default", () => $5d7964a6269b66c8$export$2e2bcd8739ae039);
$parcel$export($0c34f9894e705401$exports, "tableContainerClasses", () => $fdf044e88b1c9ad4$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $fdf044e88b1c9ad4$exports = {};

$parcel$defineInteropFlag($fdf044e88b1c9ad4$exports);

$parcel$export($fdf044e88b1c9ad4$exports, "getTableContainerUtilityClass", () => $fdf044e88b1c9ad4$export$eed427986a7abdf9);
$parcel$export($fdf044e88b1c9ad4$exports, "default", () => $fdf044e88b1c9ad4$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fdf044e88b1c9ad4$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $beCSm.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$export$2e2bcd8739ae039 = $fdf044e88b1c9ad4$var$tableContainerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5d7964a6269b66c8$var$_excluded = [
    "className",
    "component"
];
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fdf044e88b1c9ad4$export$eed427986a7abdf9), classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $d8seH.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $5d7964a6269b66c8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, (0, $8nd05.default)({
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $5d7964a6269b66c8$export$2e2bcd8739ae039 = $5d7964a6269b66c8$var$TableContainer;



'use client';
$parcel$exportWildcard($0c34f9894e705401$exports, $fdf044e88b1c9ad4$exports);


var $5488d7a1a9461c14$exports = {};

$parcel$defineInteropFlag($5488d7a1a9461c14$exports);

$parcel$export($5488d7a1a9461c14$exports, "default", () => $ff28f43fd0d3e223$export$2e2bcd8739ae039);
$parcel$export($5488d7a1a9461c14$exports, "tableFooterClasses", () => $ddadd89367698db0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $ddadd89367698db0$exports = {};

$parcel$defineInteropFlag($ddadd89367698db0$exports);

$parcel$export($ddadd89367698db0$exports, "getTableFooterUtilityClass", () => $ddadd89367698db0$export$abec0e5519905f2c);
$parcel$export($ddadd89367698db0$exports, "default", () => $ddadd89367698db0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ddadd89367698db0$export$abec0e5519905f2c(slot) {
    return (0, $4Cod0.default)('MuiTableFooter', slot);
}
const $ddadd89367698db0$var$tableFooterClasses = (0, $beCSm.default)('MuiTableFooter', [
    'root'
]);
var $ddadd89367698db0$export$2e2bcd8739ae039 = $ddadd89367698db0$var$tableFooterClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ff28f43fd0d3e223$var$_excluded = [
    "className",
    "component"
];
const $ff28f43fd0d3e223$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ddadd89367698db0$export$abec0e5519905f2c), classes);
};
const $ff28f43fd0d3e223$var$TableFooterRoot = (0, $d8seH.default)('tfoot', {
    name: 'MuiTableFooter',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-footer-group'
});
const $ff28f43fd0d3e223$var$tablelvl2 = {
    variant: 'footer'
};
const $ff28f43fd0d3e223$var$defaultComponent = 'tfoot';
const $ff28f43fd0d3e223$var$TableFooter = /*#__PURE__*/ $acw62.forwardRef(function TableFooter(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableFooter'
    });
    const { className: className, component: component = $ff28f43fd0d3e223$var$defaultComponent } = props, other = (0, $1En50.default)(props, $ff28f43fd0d3e223$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $ff28f43fd0d3e223$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $ff28f43fd0d3e223$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ff28f43fd0d3e223$var$TableFooterRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $ff28f43fd0d3e223$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $ff28f43fd0d3e223$export$2e2bcd8739ae039 = $ff28f43fd0d3e223$var$TableFooter;



'use client';
$parcel$exportWildcard($5488d7a1a9461c14$exports, $ddadd89367698db0$exports);


var $bae181d386a885e4$exports = {};

$parcel$defineInteropFlag($bae181d386a885e4$exports);

$parcel$export($bae181d386a885e4$exports, "default", () => $c9c28a8e795911dc$export$2e2bcd8739ae039);
$parcel$export($bae181d386a885e4$exports, "tableHeadClasses", () => $cf1017f12785ebe4$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $cf1017f12785ebe4$exports = {};

$parcel$defineInteropFlag($cf1017f12785ebe4$exports);

$parcel$export($cf1017f12785ebe4$exports, "getTableHeadUtilityClass", () => $cf1017f12785ebe4$export$2e731cea2d1c2392);
$parcel$export($cf1017f12785ebe4$exports, "default", () => $cf1017f12785ebe4$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $4Cod0.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $beCSm.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c9c28a8e795911dc$var$_excluded = [
    "className",
    "component"
];
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cf1017f12785ebe4$export$2e731cea2d1c2392), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent } = props, other = (0, $1En50.default)(props, $c9c28a8e795911dc$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;



'use client';
$parcel$exportWildcard($bae181d386a885e4$exports, $cf1017f12785ebe4$exports);


var $80d18c8911cf744f$exports = {};

$parcel$defineInteropFlag($80d18c8911cf744f$exports);

$parcel$export($80d18c8911cf744f$exports, "default", () => $effe3c7e7b91170d$export$2e2bcd8739ae039);
$parcel$export($80d18c8911cf744f$exports, "tablePaginationClasses", () => $d6175477fd255470$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $d3b4e1a115786e57$exports = {};

$parcel$defineInteropFlag($d3b4e1a115786e57$exports);

$parcel$export($d3b4e1a115786e57$exports, "getToolbarUtilityClass", () => $d3b4e1a115786e57$export$b12cb262231eef32);
$parcel$export($d3b4e1a115786e57$exports, "default", () => $d3b4e1a115786e57$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef8072c26f712b4c$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d3b4e1a115786e57$export$b12cb262231eef32), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $1En50.default)(props, $ef8072c26f712b4c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a0648bcf9b9d5e9c$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $a0648bcf9b9d5e9c$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $a0648bcf9b9d5e9c$var$_excluded);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $17a626ba35acf52f$export$2e2bcd8739ae039);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $3dba169293b5f5f0$export$2e2bcd8739ae039);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $02d495bb1a743bb2$export$2e2bcd8739ae039);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $b3ef3be5c947a70a$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, (0, $8nd05.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, (0, $8nd05.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, (0, $8nd05.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, (0, $8nd05.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $a0648bcf9b9d5e9c$export$2e2bcd8739ae039 = $a0648bcf9b9d5e9c$var$TablePaginationActions;



var $d6175477fd255470$exports = {};

$parcel$defineInteropFlag($d6175477fd255470$exports);

$parcel$export($d6175477fd255470$exports, "getTablePaginationUtilityClass", () => $d6175477fd255470$export$909e637b22246f4c);
$parcel$export($d6175477fd255470$exports, "default", () => $d6175477fd255470$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d6175477fd255470$export$909e637b22246f4c(slot) {
    return (0, $4Cod0.default)('MuiTablePagination', slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $beCSm.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $d6175477fd255470$export$2e2bcd8739ae039 = $d6175477fd255470$var$tablePaginationClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $d8seH.default)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $d8seH.default)((0, $ef8072c26f712b4c$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $d8seH.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $d8seH.default)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $d8seH.default)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d6175477fd255470$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $a0648bcf9b9d5e9c$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $effe3c7e7b91170d$var$_excluded);
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $a71dfe9e22152ea2$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationRoot, (0, $8nd05.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($effe3c7e7b91170d$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelect, (0, $8nd05.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $8nd05.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $9QePP.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $9QePP.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $9QePP.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemComponent, (0, $8nd05.default)({}, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $effe3c7e7b91170d$export$2e2bcd8739ae039 = $effe3c7e7b91170d$var$TablePagination;



'use client';
$parcel$exportWildcard($80d18c8911cf744f$exports, $d6175477fd255470$exports);


var $59ef5e314ba45566$exports = {};

$parcel$defineInteropFlag($59ef5e314ba45566$exports);

$parcel$export($59ef5e314ba45566$exports, "default", () => $22705465ad6920f8$export$2e2bcd8739ae039);
$parcel$export($59ef5e314ba45566$exports, "tableRowClasses", () => $321d86e199abda5b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $321d86e199abda5b$exports = {};

$parcel$defineInteropFlag($321d86e199abda5b$exports);

$parcel$export($321d86e199abda5b$exports, "getTableRowUtilityClass", () => $321d86e199abda5b$export$ba0a6d6c28940107);
$parcel$export($321d86e199abda5b$exports, "default", () => $321d86e199abda5b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $beCSm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22705465ad6920f8$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $321d86e199abda5b$export$ba0a6d6c28940107), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $1En50.default)(props, $22705465ad6920f8$var$_excluded);
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;



'use client';
$parcel$exportWildcard($59ef5e314ba45566$exports, $321d86e199abda5b$exports);


var $0b7daf0e3c2d5146$exports = {};

$parcel$defineInteropFlag($0b7daf0e3c2d5146$exports);

$parcel$export($0b7daf0e3c2d5146$exports, "default", () => $be01c206ebbcc5af$export$2e2bcd8739ae039);
$parcel$export($0b7daf0e3c2d5146$exports, "tableSortLabelClasses", () => $72164616b8f12725$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $3ceb567076b478bc$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");
var $72164616b8f12725$exports = {};

$parcel$defineInteropFlag($72164616b8f12725$exports);

$parcel$export($72164616b8f12725$exports, "getTableSortLabelUtilityClass", () => $72164616b8f12725$export$645d356c89a51794);
$parcel$export($72164616b8f12725$exports, "default", () => $72164616b8f12725$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $72164616b8f12725$export$645d356c89a51794(slot) {
    return (0, $4Cod0.default)('MuiTableSortLabel', slot);
}
const $72164616b8f12725$var$tableSortLabelClasses = (0, $beCSm.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc'
]);
var $72164616b8f12725$export$2e2bcd8739ae039 = $72164616b8f12725$var$tableSortLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $be01c206ebbcc5af$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $be01c206ebbcc5af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active'
        ],
        icon: [
            'icon',
            `iconDirection${(0, $jTnBY.default)(direction)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $72164616b8f12725$export$645d356c89a51794), classes);
};
const $be01c206ebbcc5af$var$TableSortLabelRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $72164616b8f12725$export$2e2bcd8739ae039).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $72164616b8f12725$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $72164616b8f12725$export$2e2bcd8739ae039).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $be01c206ebbcc5af$var$TableSortLabelIcon = (0, $d8seH.default)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $jTnBY.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none'
    }, ownerState.direction === 'desc' && {
        transform: 'rotate(0deg)'
    }, ownerState.direction === 'asc' && {
        transform: 'rotate(180deg)'
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $be01c206ebbcc5af$var$TableSortLabel = /*#__PURE__*/ $acw62.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $3ceb567076b478bc$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $be01c206ebbcc5af$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $be01c206ebbcc5af$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($be01c206ebbcc5af$var$TableSortLabelRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($be01c206ebbcc5af$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $9QePP.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
var $be01c206ebbcc5af$export$2e2bcd8739ae039 = $be01c206ebbcc5af$var$TableSortLabel;



'use client';
$parcel$exportWildcard($0b7daf0e3c2d5146$exports, $72164616b8f12725$exports);


var $a019720230600cef$exports = {};

$parcel$defineInteropFlag($a019720230600cef$exports);

$parcel$export($a019720230600cef$exports, "default", () => $7be483edbed3b474$export$2e2bcd8739ae039);
$parcel$export($a019720230600cef$exports, "tabsClasses", () => $8a85ee70c626268d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $5929c7187933e9a1$var$cachedType;
function $5929c7187933e9a1$export$a10970ffb6510128() {
    if ($5929c7187933e9a1$var$cachedType) return $5929c7187933e9a1$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $5929c7187933e9a1$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $5929c7187933e9a1$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $5929c7187933e9a1$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $5929c7187933e9a1$var$cachedType;
}
function $5929c7187933e9a1$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $5929c7187933e9a1$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f4c90fbbf54d23af$var$_excluded = [
    "onChange"
];
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $1En50.default)(props, $f4c90fbbf54d23af$var$_excluded);
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        style: $f4c90fbbf54d23af$var$styles
    }, other, {
        ref: nodeRef
    }));
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");






var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $35c7816ebadb07c9$exports = {};

$parcel$defineInteropFlag($35c7816ebadb07c9$exports);

$parcel$export($35c7816ebadb07c9$exports, "getTabScrollButtonUtilityClass", () => $35c7816ebadb07c9$export$34861783d3c2eef8);
$parcel$export($35c7816ebadb07c9$exports, "default", () => $35c7816ebadb07c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $beCSm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9e031514df70ea8e$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $35c7816ebadb07c9$export$34861783d3c2eef8), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $35c7816ebadb07c9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $1En50.default)(props, $9e031514df70ea8e$var$_excluded);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const ownerState = (0, $8nd05.default)({
        isRtl: isRtl
    }, props);
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $b3ef3be5c947a70a$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $02d495bb1a743bb2$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, (0, $8nd05.default)({
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, (0, $8nd05.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, (0, $8nd05.default)({}, endButtonIconProps))
    }));
});
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;



var $8a85ee70c626268d$exports = {};

$parcel$defineInteropFlag($8a85ee70c626268d$exports);

$parcel$export($8a85ee70c626268d$exports, "getTabsUtilityClass", () => $8a85ee70c626268d$export$cdd93bd054dec359);
$parcel$export($8a85ee70c626268d$exports, "default", () => $8a85ee70c626268d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $beCSm.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7be483edbed3b474$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8a85ee70c626268d$export$cdd93bd054dec359), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $7be483edbed3b474$var$FlexContainer = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $f4c90fbbf54d23af$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $9e031514df70ea8e$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $1En50.default)(props, $7be483edbed3b474$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $5929c7187933e9a1$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $f2ff3c73ed46b37c$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $5929c7187933e9a1$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $331f3746e6346411$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsIndicator, (0, $8nd05.default)({}, TabIndicatorProps, {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $8nd05.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, (0, $8nd05.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;



'use client';
$parcel$exportWildcard($a019720230600cef$exports, $8a85ee70c626268d$exports);


var $805d7bedd393d559$exports = {};

$parcel$defineInteropFlag($805d7bedd393d559$exports);

$parcel$export($805d7bedd393d559$exports, "default", () => $9e031514df70ea8e$export$2e2bcd8739ae039);
$parcel$export($805d7bedd393d559$exports, "tabScrollButtonClasses", () => $35c7816ebadb07c9$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($805d7bedd393d559$exports, $35c7816ebadb07c9$exports);


var $cce2fd59bc453dc9$exports = {};

$parcel$defineInteropFlag($cce2fd59bc453dc9$exports);

$parcel$export($cce2fd59bc453dc9$exports, "default", () => $d8826083c5af4ea7$export$2e2bcd8739ae039);
$parcel$export($cce2fd59bc453dc9$exports, "textFieldClasses", () => $25a6b464d3ca38da$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");







var $25a6b464d3ca38da$exports = {};

$parcel$defineInteropFlag($25a6b464d3ca38da$exports);

$parcel$export($25a6b464d3ca38da$exports, "getTextFieldUtilityClass", () => $25a6b464d3ca38da$export$c1bdcbaf0596aeda);
$parcel$export($25a6b464d3ca38da$exports, "default", () => $25a6b464d3ca38da$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d8826083c5af4ea7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $76910a07fd4ac4fe$export$2e2bcd8739ae039),
    filled: (0, $bb335d5457c07f5b$export$2e2bcd8739ae039),
    outlined: (0, $d5d55d2dd82639e9$export$2e2bcd8739ae039)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $25a6b464d3ca38da$export$c1bdcbaf0596aeda), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $d8826083c5af4ea7$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8826083c5af4ea7$var$TextFieldRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), (0, $8nd05.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;



'use client';
$parcel$exportWildcard($cce2fd59bc453dc9$exports, $25a6b464d3ca38da$exports);


var $28e5a0c586f490cf$exports = {};

$parcel$defineInteropFlag($28e5a0c586f490cf$exports);

$parcel$export($28e5a0c586f490cf$exports, "default", () => $032c0e7078a9cb7d$export$2e2bcd8739ae039);



var $064c63e1ed87913a$exports = {};

$parcel$defineInteropFlag($064c63e1ed87913a$exports);

$parcel$export($064c63e1ed87913a$exports, "default", () => $ab85d69438d76ec5$export$2e2bcd8739ae039);
$parcel$export($064c63e1ed87913a$exports, "toggleButtonClasses", () => $254a3802f36599bb$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $254a3802f36599bb$exports = {};

$parcel$defineInteropFlag($254a3802f36599bb$exports);

$parcel$export($254a3802f36599bb$exports, "getToggleButtonUtilityClass", () => $254a3802f36599bb$export$21f89b560b65a301);
$parcel$export($254a3802f36599bb$exports, "default", () => $254a3802f36599bb$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $254a3802f36599bb$export$21f89b560b65a301(slot) {
    return (0, $4Cod0.default)('MuiToggleButton', slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $beCSm.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $254a3802f36599bb$export$2e2bcd8739ae039 = $254a3802f36599bb$var$toggleButtonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $fe0e5fe90030f3ad$var$ToggleButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $fe0e5fe90030f3ad$export$2e2bcd8739ae039 = $fe0e5fe90030f3ad$var$ToggleButtonGroupContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $e49d517bbbfb7eee$export$2e2bcd8739ae039 = $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $9775671ab3ebd2db$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ab85d69438d76ec5$var$_excluded = [
    "value"
], $ab85d69438d76ec5$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $ab85d69438d76ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $jTnBY.default)(size)}`,
            color
        ]
    };
    return (0, $8Indx.default)(slots, (0, $254a3802f36599bb$export$21f89b560b65a301), classes);
};
const $ab85d69438d76ec5$var$ToggleButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $8nd05.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`&.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === 'small' && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $ab85d69438d76ec5$var$ToggleButton = /*#__PURE__*/ $acw62.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $acw62.useContext((0, $fe0e5fe90030f3ad$export$2e2bcd8739ae039)), { value: contextValue } = _React$useContext, contextProps = (0, $1En50.default)(_React$useContext, $ab85d69438d76ec5$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $acw62.useContext((0, $e49d517bbbfb7eee$export$2e2bcd8739ae039));
    const resolvedProps = (0, $4FZD0.default)((0, $8nd05.default)({}, contextProps, {
        selected: (0, $9775671ab3ebd2db$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value } = props, other = (0, $1En50.default)(props, $ab85d69438d76ec5$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $ab85d69438d76ec5$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab85d69438d76ec5$var$ToggleButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
var $ab85d69438d76ec5$export$2e2bcd8739ae039 = $ab85d69438d76ec5$var$ToggleButton;



'use client';
$parcel$exportWildcard($064c63e1ed87913a$exports, $254a3802f36599bb$exports);


var $4df31e56c78281ac$exports = {};

$parcel$defineInteropFlag($4df31e56c78281ac$exports);

$parcel$export($4df31e56c78281ac$exports, "default", () => $7479184c3cda7f5d$export$2e2bcd8739ae039);
$parcel$export($4df31e56c78281ac$exports, "toggleButtonGroupClasses", () => $d382e18949ecbd32$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");
var $d382e18949ecbd32$exports = {};

$parcel$defineInteropFlag($d382e18949ecbd32$exports);

$parcel$export($d382e18949ecbd32$exports, "getToggleButtonGroupUtilityClass", () => $d382e18949ecbd32$export$44aa3ae5b353cef1);
$parcel$export($d382e18949ecbd32$exports, "default", () => $d382e18949ecbd32$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d382e18949ecbd32$export$44aa3ae5b353cef1(slot) {
    return (0, $4Cod0.default)('MuiToggleButtonGroup', slot);
}
const $d382e18949ecbd32$var$toggleButtonGroupClasses = (0, $beCSm.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $d382e18949ecbd32$export$2e2bcd8739ae039 = $d382e18949ecbd32$var$toggleButtonGroupClasses;






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7479184c3cda7f5d$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $7479184c3cda7f5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d382e18949ecbd32$export$44aa3ae5b353cef1), classes);
};
const $7479184c3cda7f5d$var$ToggleButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: (0, $8nd05.default)({}, ownerState.orientation === 'horizontal' ? {
            [`&.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected} + .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected} + .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            marginLeft: -1,
            borderLeft: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            marginTop: -1,
            borderTop: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
            borderLeft: '1px solid transparent'
        }
    } : {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
            borderTop: '1px solid transparent'
        }
    }));
const $7479184c3cda7f5d$var$ToggleButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value } = props, other = (0, $1En50.default)(props, $7479184c3cda7f5d$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $7479184c3cda7f5d$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $9b0e6fd5d31b1b95$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$ToggleButtonGroupRoot, (0, $8nd05.default)({
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe0e5fe90030f3ad$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e49d517bbbfb7eee$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $7479184c3cda7f5d$export$2e2bcd8739ae039 = $7479184c3cda7f5d$var$ToggleButtonGroup;



'use client';
$parcel$exportWildcard($4df31e56c78281ac$exports, $d382e18949ecbd32$exports);


var $9a4c0d9ab6473dab$exports = {};

$parcel$defineInteropFlag($9a4c0d9ab6473dab$exports);

$parcel$export($9a4c0d9ab6473dab$exports, "default", () => $ef8072c26f712b4c$export$2e2bcd8739ae039);
$parcel$export($9a4c0d9ab6473dab$exports, "toolbarClasses", () => $d3b4e1a115786e57$export$2e2bcd8739ae039);


$parcel$exportWildcard($9a4c0d9ab6473dab$exports, $d3b4e1a115786e57$exports);


var $05927828b8d9f8ec$exports = {};

$parcel$defineInteropFlag($05927828b8d9f8ec$exports);

$parcel$export($05927828b8d9f8ec$exports, "default", () => $96a8b4f445fd9172$export$2e2bcd8739ae039);
$parcel$export($05927828b8d9f8ec$exports, "tooltipClasses", () => $add5737403c6a16a$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($05927828b8d9f8ec$exports, $add5737403c6a16a$exports);


var $19e865ef3ed82f53$exports = {};

$parcel$defineInteropFlag($19e865ef3ed82f53$exports);

$parcel$export($19e865ef3ed82f53$exports, "default", () => $2531239e3a525689$export$2e2bcd8739ae039);
$parcel$export($19e865ef3ed82f53$exports, "typographyClasses", () => $837556bdf75d281f$export$2e2bcd8739ae039);


'use client';
$parcel$exportWildcard($19e865ef3ed82f53$exports, $837556bdf75d281f$exports);


var $0d3d65c0582fd03d$exports = {};

$parcel$defineInteropFlag($0d3d65c0582fd03d$exports);

$parcel$export($0d3d65c0582fd03d$exports, "default", () => $0c8dae23e679323d$export$2e2bcd8739ae039);



var $683683be0e6e5e52$exports = {};

$parcel$defineInteropFlag($683683be0e6e5e52$exports);

$parcel$export($683683be0e6e5e52$exports, "default", () => $fcf3350ab6dcf91e$export$2e2bcd8739ae039);

'use client';


var $a041a41a6f25c19c$exports = {};

$parcel$defineInteropFlag($a041a41a6f25c19c$exports);

$parcel$export($a041a41a6f25c19c$exports, "default", () => $a3399924514ccab2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
'use client';
const $a3399924514ccab2$var$_excluded = [
    "getTrigger",
    "target"
];
function $a3399924514ccab2$var$defaultTrigger(store, options) {
    const { disableHysteresis: disableHysteresis = false, threshold: threshold = 100, target: target } = options;
    const previous = store.current;
    if (target) // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
    if (!disableHysteresis && previous !== undefined) {
        if (store.current < previous) return false;
    }
    return store.current > threshold;
}
const $a3399924514ccab2$var$defaultTarget = typeof window !== 'undefined' ? window : null;
function $a3399924514ccab2$export$2e2bcd8739ae039(options = {}) {
    const { getTrigger: getTrigger = $a3399924514ccab2$var$defaultTrigger, target: target = $a3399924514ccab2$var$defaultTarget } = options, other = (0, $1En50.default)(options, $a3399924514ccab2$var$_excluded);
    const store = $acw62.useRef();
    const [trigger, setTrigger] = $acw62.useState(()=>getTrigger(store, other));
    $acw62.useEffect(()=>{
        const handleScroll = ()=>{
            setTrigger(getTrigger(store, (0, $8nd05.default)({
                target: target
            }, other)));
        };
        handleScroll(); // Re-evaluate trigger when dependencies change
        target.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return ()=>{
            target.removeEventListener('scroll', handleScroll, {
                passive: true
            });
        };
    // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        getTrigger,
        JSON.stringify(other)
    ]);
    return trigger;
}


'use client';


var $28a89151afea75ff$exports = {};

$parcel$defineInteropFlag($28a89151afea75ff$exports);

$parcel$export($28a89151afea75ff$exports, "default", () => $4672437388b729f6$export$2e2bcd8739ae039);

'use client';



var $ecb286025e88fbf5$exports = {};

$parcel$defineInteropFlag($ecb286025e88fbf5$exports);

$parcel$export($ecb286025e88fbf5$exports, "default", () => $03fc756f7adfd498$export$2e2bcd8739ae039);




var $8Indx = parcelRequire("8Indx");
var $a4e84d7603b01204$exports = {};

$parcel$defineInteropFlag($a4e84d7603b01204$exports);

$parcel$export($a4e84d7603b01204$exports, "default", () => (parcelRequire("4Cod0")).default);

var $4Cod0 = parcelRequire("4Cod0");


var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");

var $acb29f90a3f05c5b$exports = {};

$parcel$defineInteropFlag($acb29f90a3f05c5b$exports);

$parcel$export($acb29f90a3f05c5b$exports, "version", () => $acb29f90a3f05c5b$export$83d89fbfd8236492);
$parcel$export($acb29f90a3f05c5b$exports, "major", () => $acb29f90a3f05c5b$export$c7133ab33cb183d1);
$parcel$export($acb29f90a3f05c5b$exports, "minor", () => $acb29f90a3f05c5b$export$b65c007c1e3a96bd);
$parcel$export($acb29f90a3f05c5b$exports, "patch", () => $acb29f90a3f05c5b$export$b76953f99ab2be78);
$parcel$export($acb29f90a3f05c5b$exports, "preReleaseLabel", () => $acb29f90a3f05c5b$export$13fddb959422545b);
$parcel$export($acb29f90a3f05c5b$exports, "preReleaseNumber", () => $acb29f90a3f05c5b$export$5465653adacb9755);
$parcel$export($acb29f90a3f05c5b$exports, "default", () => $acb29f90a3f05c5b$export$2e2bcd8739ae039);
const $acb29f90a3f05c5b$export$83d89fbfd8236492 = "5.18.0";
const $acb29f90a3f05c5b$export$c7133ab33cb183d1 = Number("5");
const $acb29f90a3f05c5b$export$b65c007c1e3a96bd = Number("18");
const $acb29f90a3f05c5b$export$b76953f99ab2be78 = Number("0");
const $acb29f90a3f05c5b$export$13fddb959422545b = null;
const $acb29f90a3f05c5b$export$5465653adacb9755 = Number(undefined) || null;
var $acb29f90a3f05c5b$export$2e2bcd8739ae039 = $acb29f90a3f05c5b$export$83d89fbfd8236492;


$parcel$exportWildcard($91a4e72629291447$exports, $019ad789c5f8c324$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $ce0e2c401cd11493$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $fcaee2cf9d6d9c3f$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $04f1b704f2eaef84$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $a422e3223044b655$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $4fb16a516036be86$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $0cdfa98b6f9a20c7$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $83f1cec610e0702c$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $eed1534592dd796b$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $7b8a1da92f713a60$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $edb1abe77b6ce3b3$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $7cacdf50dce7d54d$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $8b4ec012404cb259$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $f7bda82e26c407eb$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $e5adbfb42ac1b374$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $a4eae313114a1aef$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $02a57cc52715b250$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $468368052d2ef018$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $873c117b1fb2dd29$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $c949c943dfbcd61d$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $65afbe095ccffd1e$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $2b27523fd597460f$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $f1408e763033c57b$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $082203d287675024$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $fe806b09c0847150$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $35ff8d0aba128694$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $a7ec82c27a16d3bc$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $7c7c690d35982c52$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $4a998843df0ddc3a$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $11054b4f9cc1bbd6$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $5a37cef7efb75d08$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $bfbeac2d30cd504d$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $70e06f8560e22c27$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $84130c31a3f49bb6$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $3426a3520e69a38c$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $dd40a9c943ba05e0$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $f5a78922775ef422$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $ce89efe9ad487ed1$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $7f970d1ffd61b921$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $fcf83d520808df6e$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $bb9a180c0f91ff1f$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $957158966c1dd989$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $1c63081f73fd2072$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $3dce7e103df60065$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $cd8865c776d8094c$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $d86eed44238f23f0$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $d26f188d49f0430b$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $85d9ff6e52a65e06$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $34da7bc50263d1b5$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $98ce88637df666c4$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $5d07c0b3a49e1daf$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $201f04058620a74b$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $012b35560897a029$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $3b8fd1b752839fb4$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $2b59c24f9f8bf5b3$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $5d932794c82c2fcf$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $9f7a092074edd6d0$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $9462e0a2246915d8$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $1ddcf58ca2045c53$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $a9f7a5eb14f1ec4f$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $6afb4578ee9180cf$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $71f12fb6991c55a7$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $eabe871db5ab5d36$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $1d34600829c15c5d$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $b542247f17114115$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $d3bbc7f720921ac7$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $cf8c523bf26d7f9a$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $4e03a092ccfc165d$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $dc78ebeb7704024e$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $1a27e69578e2c56e$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $377dc32070e7887f$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $9b22463c6c37319f$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $0ee342703d01369e$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $03dfa491627f975c$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $dd21c0ca7e345443$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $6225548018c22e00$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $0e484d2d1153e25c$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $632e260cb6e75f90$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $181b936a865fd5c4$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $95a7dbf177b90875$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $d6009d8f79a7cefd$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $fb6bc293e767dac6$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $448e339b1c87d651$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $e31a80f86c785b2c$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $236c5104463510ad$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $ae19908c5516ff78$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $944699a2e7967149$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $4230641a48862144$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $2331ccb4eb2af4bc$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $fde33b68b1c0968e$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $acaf5bc8fc7510ef$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $9e53839d220648fc$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $ad6f387c32d3bcf0$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $8a0dfba99a405f81$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $16b1b35b06ce5bdf$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $80c71705f119f7ad$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $6445e2a5635b1c13$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $edf24babb8f47c92$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $20f48d600d3ec25e$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $4ed14e9d13fe3bbe$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $e11d669415a30ea5$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $b5148d23ad5d90bb$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $e9380b273cd6ee6d$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $e108709a7cb36655$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $80db82a861533602$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $1ff0fbd06d13ad2a$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $931cdf5c02131bb6$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $3e1c1ec9d9e33247$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $f943077249b43968$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $b471573c23b3da9a$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $442a3dd08ba79e73$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $68dceac9a9a56312$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $880e97827fd7145b$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $3d935658447069c3$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $c9a7707bc8e823db$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $0c34f9894e705401$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $5488d7a1a9461c14$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $bae181d386a885e4$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $80d18c8911cf744f$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $59ef5e314ba45566$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $0b7daf0e3c2d5146$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $a019720230600cef$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $805d7bedd393d559$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $cce2fd59bc453dc9$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $28e5a0c586f490cf$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $064c63e1ed87913a$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $4df31e56c78281ac$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $9a4c0d9ab6473dab$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $05927828b8d9f8ec$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $19e865ef3ed82f53$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $0d3d65c0582fd03d$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $683683be0e6e5e52$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $a041a41a6f25c19c$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $28a89151afea75ff$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $ecb286025e88fbf5$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $a4e84d7603b01204$exports);
$parcel$exportWildcard($91a4e72629291447$exports, $acb29f90a3f05c5b$exports);


const { Paper: $2fb79573d570c877$var$Paper } = $91a4e72629291447$exports;
var $2fb79573d570c877$export$2e2bcd8739ae039 = $2fb79573d570c877$var$Paper;


const { Stack: $fc644153b517b048$var$Stack } = $91a4e72629291447$exports;
var $fc644153b517b048$export$2e2bcd8739ae039 = $fc644153b517b048$var$Stack;


var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $f20bb0148dc3991e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f20bb0148dc3991e$export$111e140b0af40b4e = (0, $d8seH.default)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'variant'
        ].includes(prop)
})(({ theme: theme, variant: variant = 'outlined' })=>Object.assign(Object.assign({
        '& .MuiInputBase-root': {
            padding: theme.palette.textField.padding,
            height: '36px',
            backgroundColor: theme.palette.textField.background.default
        },
        '& .MuiInputBase-input': {
            padding: 0,
            height: 'inherit',
            fontFamily: theme.palette.textField.font.family,
            fontSize: theme.palette.textField.font.size,
            lineHeight: theme.palette.textField.font.lineHeight,
            fontWeight: theme.palette.textField.font.weight,
            letterSpacing: theme.palette.textField.font.letterSpacing
        },
        '& .MuiInputLabel-root': {
            color: theme.palette.textField.label.text.default,
            transform: 'translate(8px, 8px) scale(1)',
            '&.Mui-disabled': {
                color: theme.palette.textField.label.text.disabled
            },
            '&.Mui-error': {
                color: theme.palette.textField.label.text.error
            }
        },
        '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)'
        },
        '& .MuiFormHelperText-root': {
            fontFamily: theme.palette.textField.helpText.font.family,
            fontSize: theme.palette.textField.helpText.font.size,
            fontWeight: theme.palette.textField.helpText.font.weight,
            lineHeight: theme.palette.textField.helpText.font.lineHeight,
            letterSpacing: theme.palette.textField.helpText.font.letterSpacing,
            color: theme.palette.textField.helpText.text.default,
            '&.Mui-disabled': {
                color: theme.palette.textField.helpText.text.disabled
            },
            '&.Mui-error': {
                color: theme.palette.textField.helpText.text.error
            }
        }
    }, variant === 'outlined' && {
        '& .MuiOutlinedInput-root': {
            borderRadius: theme.palette.textField.radius,
            '&:hover fieldset': {
                border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.hover}`
            },
            '&.Mui-focused fieldset': {
                border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.focus}`
            },
            '&.Mui-disabled fieldset': {
                border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.disabled}`
            },
            '&.Mui-error fieldset': {
                border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.error}`
            }
        }
    }), {
        '& .MuiInputAdornment-positionStart': {
            gap: theme.palette.textField.spaceBetween,
            marginLeft: `-${theme.palette.textField.spaceBetween}`
        },
        '& .MuiInputAdornment-positionEnd': {
            gap: theme.palette.textField.spaceBetween
        }
    }));
const $f20bb0148dc3991e$var$BDSTextField = (_a)=>{
    var { helperText: helperText, variant: variant } = _a, props = $f20bb0148dc3991e$var$__rest(_a, [
        "helperText",
        "variant"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f20bb0148dc3991e$export$111e140b0af40b4e, Object.assign({}, props, {
        variant: variant,
        helperText: helperText
    }));
};
var $f20bb0148dc3991e$export$2e2bcd8739ae039 = $f20bb0148dc3991e$var$BDSTextField;


var $44ba4f488ac798b2$export$2e2bcd8739ae039 = (0, $f20bb0148dc3991e$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");






const $86acb4403c5c4210$var$BDSTable = ({ customComponent: customComponent, headers: headers, rows: rows, shouldHideTableBodyBorderBottom: shouldHideTableBodyBorderBottom = true, shouldHideTableHeadBorderBottom: shouldHideTableHeadBorderBottom = true, tableBodyCellAlign: tableBodyCellAlign = 'left', tableHeaderCellAlign: tableHeaderCellAlign = 'left' })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
        component: customComponent || 'div'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
        "aria-label": "simple table"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
        sx: shouldHideTableHeadBorderBottom ? {
            [`& .${(0, $a8eb3ce62ab46dc7$export$2e2bcd8739ae039).root}`]: {
                borderBottom: 'none'
            }
        } : {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22705465ad6920f8$export$2e2bcd8739ae039), null, headers.map((header)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
            key: header,
            align: tableHeaderCellAlign
        }, header)))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
        sx: shouldHideTableBodyBorderBottom ? {
            [`& .${(0, $a8eb3ce62ab46dc7$export$2e2bcd8739ae039).root}`]: {
                borderBottom: 'none'
            }
        } : {}
    }, rows.map((row, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
            key: row.id || index
        }, Object.keys(row).map((keyName)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                align: tableBodyCellAlign,
                key: keyName
            }, row[keyName])))))));
};
var $86acb4403c5c4210$export$2e2bcd8739ae039 = $86acb4403c5c4210$var$BDSTable;


var $5e294374589e3cee$export$2e2bcd8739ae039 = (0, $86acb4403c5c4210$export$2e2bcd8739ae039);





// src/api.js


const $96e14f2a7c3555e4$var$api = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: (0, $efa0868a03d524fc$export$c3ee1e672e1e24e7),
    withCredentials: true
});
// Add a response interceptor to handle 401 errors globally
$96e14f2a7c3555e4$var$api.interceptors.response.use((response)=>response, (error)=>{
    if (error.response && error.response.status === 401) // Redirect to login page if not already there
    {
        if (window.location.pathname !== "/login") // window.location.href = "/login";
        window.location.href = `${0, $efa0868a03d524fc$export$c3ee1e672e1e24e7}/api/login/`;
    }
    return Promise.reject(error);
});
var $96e14f2a7c3555e4$export$2e2bcd8739ae039 = $96e14f2a7c3555e4$var$api;



function $abd9f2afbe2680bb$export$2e2bcd8739ae039() {
    const { state: state } = (0, $2ad2279805e583d1$export$6ccbb43953eebf8)();
    const [domain, setDomain] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [domainError, setDomainError] = (0, $acw62.useState)(false);
    const [domainHelper, setDomainHelper] = (0, $acw62.useState)('');
    const [page, setPage] = (0, $acw62.useState)(1);
    const [itemsPerPage, setItemsPerPage] = (0, $acw62.useState)(10);
    const itemsPerPageOptions = [
        10,
        20
    ];
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008) ? (0, $7939e29d663dd3ed$export$9770f232ac06a008)() : null;
    // Input sanitizer: returns true when input looks like an allowed domain or URL
    const sanitizeInput = (val)=>{
        if (!val) return false;
        const s = String(val).trim();
        // Block obvious dangerous content: script tags and dangerous schemes
        const lowered = s.toLowerCase();
        if (/<\s*script\b/.test(lowered)) return false;
        if (/^\s*(?:javascript|data|file|vbscript)\s*:/i.test(s)) return false;
        // Block standalone shell/command invocations like `ls`, `rm`, `sh`, etc.
        // Require a trailing space or end-of-string to avoid matching substrings
        // inside normal hostnames (e.g. 'searchhounds').
        const cmdPattern = /^\s*(?:ls|cat|rm|sudo|sh|bash|python|curl|wget|nc|ncat|telnet|perl|php|node|echo|touch)(?:\s|$)/i;
        if (cmdPattern.test(s)) return false;
        // Basic hostname or URL checks: allow hostnames like example.com and URLs with http/https
        try {
            // if it's a URL (starts with scheme://), ensure scheme is http/https
            if (/^\w+:\/\//.test(s)) {
                const u = new URL(s);
                const scheme = (u.protocol || '').toLowerCase();
                if (scheme !== 'http:' && scheme !== 'https:' && scheme !== 'null') return false;
                // hostname must be present and use sane characters
                if (!u.hostname || /[^\w.-]/.test(u.hostname)) return false;
                return true;
            }
        } catch (e) {
            return false;
        }
        // For non-URL inputs, block dangerous shell metacharacters and command
        // substitution characters. This runs after URL detection so valid URLs
        // containing characters like '&' or '=' in query params are allowed.
        if (/[;`$<>\n\r(){}|]/.test(s)) return false;
        // Plain hostname: allow letters, numbers, hyphen and dots (simple FQDN check)
        const asciiHost = new URL(`http://${s}`).hostname;
        if (/^[a-z0-9.-]+\.[a-z]{2,}$/i.test(asciiHost)) return true;
        return false;
    };
    // Start scan: session-based auth with CSRF
    const startScan = (0, $acw62.useCallback)(async ()=>{
        // Validate/sanitize before sending
        if (!domain || !sanitizeInput(domain)) {
            setDomainError(true);
            setDomainHelper('Please enter correct domain :https://example.com or example.com');
            return;
        }
        setDomainError(false);
        setDomainHelper('');
        setLoading(true);
        try {
            const payload = {
                domain: domain
            };
            const resp = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).post(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/scan-requests/`, payload, {
                withCredentials: true
            });
            const uuid = resp.data?.scan_result_uuid || null;
            if (uuid) navigate(`/scan-result/${uuid}`);
            else alert("Scan started but no result UUID was returned. Please try again.");
        } catch (e) {
            // Prefer structured backend message when available, otherwise show a friendly helper
            const status = e?.response?.status;
            const data = e?.response?.data || {};
            if (status === 400 && (data.error === 'invalid_domain' || typeof data.detail === 'string')) {
                setDomainError(true);
                setDomainHelper(typeof data.detail === 'string' ? data.detail : 'Please enter a valid domain');
                setLoading(false);
                return;
            }
            // Network or unexpected axios error: show friendly helper instead of throwing
            if (e?.isAxiosError) {
                setDomainError(true);
                setDomainHelper('Please enter a valid domain');
                setLoading(false);
                return;
            }
            // Other unexpected errors: fallback to alert but do not rethrow
            console.error(e);
            alert("An error occurred while starting the scan.");
        } finally{
            setLoading(false);
        }
    }, [
        domain,
        state,
        navigate
    ]);
    // The existing UI data (kept intact)
    const vulnList = Array.from({
        length: 21
    }).map((_, i)=>{
        const items = [
            {
                title: "SQL injection",
                path: "demo.com/v2/payment, 2 more instances",
                severity: "high"
            },
            {
                title: "Content Security Policy (CSP) header not set",
                path: "demo.com/v2/payment",
                severity: "medium"
            },
            {
                title: "Cross-domain misconfiguration",
                path: "demo.com/v2/payment",
                severity: "medium"
            },
            {
                title: "Missing Anti-clickjacking header",
                path: "demo.com/v2/payment",
                severity: "medium"
            },
            {
                title: "Session ID in URL rewrite",
                path: "demo.com/v2/payment",
                severity: "medium"
            },
            {
                title: "Vulnerable JS library",
                path: "demo.com/v2/payment",
                severity: "low"
            },
            {
                title: "Cookie no HttpOnly flag",
                path: "demo.com/v2/payment, 2 more instances",
                severity: "low"
            },
            {
                title: "Cookie without SameSite attribute none",
                path: "demo.com/v2/payment, 2 more instances",
                severity: "low"
            },
            {
                title: "Cookie without SameSite attribute",
                path: "demo.com/v2/payment, 2 more instances",
                severity: "low"
            },
            {
                title: "Loosely scoped cookie",
                path: "demo.com/v2/payment, 2 more instances",
                severity: "low"
            }
        ][i % 10];
        return {
            id: i + 1,
            ...items
        };
    });
    const renderSeverityBars = (sev)=>{
        const colored = sev === "high" ? 4 : sev === "medium" ? 3 : 2;
        const total = 4;
        const grey = total - colored;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                gap: 0.35,
                alignItems: 'center'
            },
            children: [
                Array.from({
                    length: colored
                }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            width: 10,
                            height: 2.8,
                            borderRadius: 0.4,
                            bgcolor: sev === 'high' ? '#d32f2f' : sev === 'medium' ? '#ff9800' : '#fbc02d'
                        }
                    }, `c-${i}`)),
                Array.from({
                    length: grey
                }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            width: 10,
                            height: 2.8,
                            borderRadius: 0.4,
                            bgcolor: '#e6e9ec'
                        }
                    }, `g-${i}`))
            ]
        });
    };
    const total = vulnList.length;
    const pageCount = Math.max(1, Math.ceil(total / itemsPerPage));
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = Math.min(total, page * itemsPerPage);
    const visible = vulnList.slice(startIndex, endIndex);
    // ...existing code...
    // Fetch previous scans from backend
    const [previousScans, setPreviousScans] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        async function fetchScans() {
            try {
                const resp = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).get(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/scan-results/`, {
                    withCredentials: true
                });
                // resp.data is expected to be a list of scan results
                // Each scan result should have: uuid, scan (with domain), scanned_at, status
                // Flatten for table
                const scans = Array.isArray(resp.data) ? resp.data : resp.data.results || [];
                setPreviousScans(scans.map((s)=>{
                    const status = s.scan?.status || s.status;
                    let statusIcon = null;
                    if (status === 'completed') statusIcon = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        title: "Completed",
                        style: {
                            color: '#2e7d32',
                            fontSize: 18,
                            display: 'inline-flex',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                    cx: "10",
                                    cy: "10",
                                    r: "10",
                                    fill: "#e8f5e9"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M6.5 10.5L9 13L14 8",
                                    stroke: "#2e7d32",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    });
                    else if (status === 'failed') statusIcon = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        title: "Failed",
                        style: {
                            color: '#d32f2f',
                            fontSize: 18,
                            display: 'inline-flex',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                    cx: "10",
                                    cy: "10",
                                    r: "10",
                                    fill: "#ffebee"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M7 7L13 13M13 7L7 13",
                                    stroke: "#d32f2f",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            ]
                        })
                    });
                    else statusIcon = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        title: "In Progress",
                        style: {
                            color: '#0288d1',
                            fontSize: 18,
                            display: 'inline-flex',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                    cx: "10",
                                    cy: "10",
                                    r: "10",
                                    fill: "#e3f2fd"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M10 5V10L13 13",
                                    stroke: "#0288d1",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            ]
                        })
                    });
                    return {
                        domain: s.scan?.domain || s.domain,
                        scanned_at: s.scanned_at ? new Date(s.scanned_at).toLocaleString() : '-',
                        status: statusIcon,
                        action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            onClick: ()=>navigate(`/scan-result/${s.uuid}`),
                            sx: {
                                color: '#0b78d1',
                                fontSize: '0.72rem',
                                cursor: 'pointer'
                            },
                            children: "View details"
                        })
                    };
                }));
            } catch (e) {
                setPreviousScans([]);
            }
        }
        fetchScans();
    }, []);
    // Keep page valid when itemsPerPage changes or total changes
    (0, $acw62.useEffect)(()=>{
        if (page > pageCount) setPage(pageCount);
    }, [
        pageCount,
        page
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
        container: true,
        spacing: 0,
        sx: {
            bgcolor: '#ffffff',
            height: '100vh',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e742043ac950988b$export$2e2bcd8739ae039), {
                    pageTitle: "Application Security Insights",
                    productTitle: "WAF-as-a-Service",
                    rightContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                        bdsType: "interactiveEmphasis",
                        "data-action": "try",
                        onClick: ()=>window.open('https://waas.barracudanetworks.com/start-trial/', '_blank', 'noopener,noreferrer'),
                        children: "Try WAF-as-a-Service now"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    sx: {
                        p: 6,
                        minHeight: 'calc(100vh - 120px)',
                        display: 'flex',
                        alignItems: 'center',
                        bgcolor: '#ffffff',
                        overflow: 'hidden'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            width: '100%',
                            maxWidth: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                variant: "h4",
                                gutterBottom: true,
                                sx: {
                                    color: '#111',
                                    fontWeight: 600,
                                    fontSize: '2rem',
                                    lineHeight: 1.2,
                                    mb: 2
                                },
                                children: "Start your free Analysis and take control of your web security"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                variant: "body2",
                                color: "text.secondary",
                                paragraph: true,
                                sx: {
                                    fontSize: '0.9rem',
                                    color: '#666',
                                    lineHeight: 1.5,
                                    mb: 3
                                },
                                children: "Our automated scanner identifies common vulnerabilities and weaknesses, delivering clear, actionable insights to help you strengthen your website's security."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fc644153b517b048$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 1.5,
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44ba4f488ac798b2$export$2e2bcd8739ae039), {
                                        placeholder: "Enter domain",
                                        variant: "outlined",
                                        size: "small",
                                        value: domain,
                                        onChange: (e)=>{
                                            setDomain(e.target.value);
                                            setDomainError(false);
                                            setDomainHelper('');
                                        },
                                        error: domainError,
                                        helperText: domainError ? domainHelper : '',
                                        FormHelperTextProps: {
                                            sx: {
                                                color: domainError ? '#1976d2' : '#1976d2',
                                                fontSize: '0.75rem',
                                                minHeight: '1.1rem'
                                            }
                                        },
                                        sx: {
                                            flex: 1,
                                            '& .MuiOutlinedInput-root': {
                                                fontSize: '0.75rem'
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#cfd8dc'
                                            },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#1976d2'
                                            },
                                            '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#1976d2'
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            startScan().catch((err)=>{
                                                setDomainError(true);
                                                setDomainHelper('Please enter a valid domain');
                                            });
                                        },
                                        disabled: loading || !domain,
                                        sx: {
                                            mt: '6px',
                                            width: 90,
                                            height: 32,
                                            backgroundColor: '#0b78d1',
                                            color: '#fff',
                                            textTransform: 'none',
                                            fontSize: '0.75rem',
                                            fontWeight: 500,
                                            '&:hover': {
                                                backgroundColor: '#096bb8'
                                            },
                                            '&.Mui-disabled': {
                                                backgroundColor: '#0b78d1',
                                                color: '#fff',
                                                opacity: 1
                                            }
                                        },
                                        children: loading ? "Starting..." : "Analyze"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                sx: {
                                    mt: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        sx: {
                                            mb: 2,
                                            fontSize: '1rem',
                                            fontWeight: 600
                                        },
                                        children: "Previous Scans"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                        sx: {
                                            maxHeight: 310,
                                            overflowY: 'auto'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86acb4403c5c4210$export$2e2bcd8739ae039), {
                                            rows: previousScans,
                                            headers: [
                                                'Domain',
                                                'Scanned At',
                                                'Status',
                                                'Action'
                                            ],
                                            shouldHideTableHeadBorderBottom: false,
                                            customComponent: (0, $2fb79573d570c877$export$2e2bcd8739ae039)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    sx: {
                        p: 10,
                        minHeight: 'calc(100vh - 70px)',
                        display: 'flex',
                        flexDirection: 'column',
                        bgcolor: '#f3f5f7',
                        overflow: 'hidden',
                        width: '100%' // right column fills full right area (blackish-white background)
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            sx: {
                                mb: 1.5,
                                alignItems: 'flex-start',
                                justifyContent: 'flex-start'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 5,
                                    container: true,
                                    direction: "column",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $988d519bad44ed5c$export$2e2bcd8739ae039), {
                                                elevation: 1,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $28a500ea92f2665f$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        p: 1.1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '0.78rem',
                                                                color: '#666',
                                                                mb: 0.4
                                                            },
                                                            children: "Security posture score"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 0.8
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontSize: '1.45rem',
                                                                        fontWeight: 600
                                                                    },
                                                                    children: "49"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontSize: '0.68rem',
                                                                        color: '#888'
                                                                    },
                                                                    children: "of 100"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: 30,
                                                                        height: 16,
                                                                        bgcolor: '#d32f2f',
                                                                        borderRadius: 0.4,
                                                                        ml: 0.3
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                color: '#0b78d1',
                                                                fontSize: '0.68rem',
                                                                mt: 0.3
                                                            },
                                                            children: "What's this?"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $988d519bad44ed5c$export$2e2bcd8739ae039), {
                                                elevation: 1,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $28a500ea92f2665f$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        p: 1.1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '0.78rem',
                                                                color: '#666',
                                                                mb: 0.4
                                                            },
                                                            children: "Vulnerabilities detected"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '1.05rem',
                                                                fontWeight: 600
                                                            },
                                                            children: "21"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $988d519bad44ed5c$export$2e2bcd8739ae039), {
                                        elevation: 1,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $28a500ea92f2665f$export$2e2bcd8739ae039), {
                                            sx: {
                                                p: 1.1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        mb: 0.6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '0.8rem',
                                                                fontWeight: 500
                                                            },
                                                            children: "Vulnerabilities by severity"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                color: '#0b78d1',
                                                                fontSize: '0.68rem',
                                                                cursor: 'pointer'
                                                            },
                                                            children: "View all \u2193"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        height: 100,
                                                        bgcolor: '#ffffff',
                                                        borderRadius: 0.6
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12f35e2f8b869a3c$export$2e2bcd8739ae039), {
                                                        chartData: {
                                                            datasets: [
                                                                {
                                                                    label: 'Sales',
                                                                    data: [
                                                                        6,
                                                                        // high
                                                                        4,
                                                                        // medium
                                                                        5,
                                                                        // low
                                                                        3 // info
                                                                    ],
                                                                    backgroundColor: [
                                                                        '#1976d2',
                                                                        '#1e88e5',
                                                                        '#64b5f6',
                                                                        '#90caf9'
                                                                    ],
                                                                    // Bar fill colors (design tokens)
                                                                    borderColor: [
                                                                        '#1565c0',
                                                                        '#1976d2',
                                                                        '#1e88e5',
                                                                        '#64b5f6'
                                                                    ],
                                                                    // Bar border colors (design tokens)
                                                                    borderWidth: 1
                                                                }
                                                            ],
                                                            labels: [
                                                                'High',
                                                                'Medium',
                                                                'Low',
                                                                'Info'
                                                            ]
                                                        },
                                                        chartDimension: {
                                                            height: 120,
                                                            width: '100%'
                                                        },
                                                        emptyState: {
                                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                "data-testid": "empty-state"
                                                            }),
                                                            text: 'Too full to eat anymore twix'
                                                        },
                                                        hasEntries: true,
                                                        showFooter: false,
                                                        barChartOptions: {
                                                            plugins: {
                                                                tooltip: {
                                                                    enabled: false
                                                                }
                                                            },
                                                            scales: {
                                                                x: {
                                                                    grid: {
                                                                        display: false,
                                                                        // Removes vertical grid lines
                                                                        drawOnChartArea: false // Removes grid lines only within the chart area
                                                                    }
                                                                },
                                                                y: {
                                                                    grid: {
                                                                        display: false,
                                                                        // Removes horizontal grid lines
                                                                        drawOnChartArea: false // Removes grid lines only within the chart area
                                                                    },
                                                                    border: {
                                                                        display: false // This hides the X-axis line
                                                                    },
                                                                    ticks: {
                                                                        display: false // This hides the Y-axis labels
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            sx: {
                                borderRadius: 1,
                                p: 0.9,
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden',
                                flex: '0 0 auto'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 0.9
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            sx: {
                                                fontSize: '0.82rem',
                                                fontWeight: 600,
                                                mb: 0.6
                                            },
                                            children: "Vulnerabilities (21)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $753cd5b62de61f2c$export$2e2bcd8739ae039), {
                                            sx: {
                                                mb: 0.4
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
                                    sx: {
                                        flex: '0 0 auto',
                                        overflow: 'visible',
                                        maxHeight: 'none'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                            children: visible.length > 0 ? visible.map((v)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        '&:hover': {
                                                            bgcolor: '#f7f8fa'
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '0.72rem',
                                                                p: 0.5,
                                                                maxWidth: 160,
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    fontWeight: 600,
                                                                    fontSize: '0.60rem'
                                                                },
                                                                children: v.title
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '0.68rem',
                                                                p: 0.5,
                                                                color: '#777',
                                                                maxWidth: 160,
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            },
                                                            children: v.path
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '0.68rem',
                                                                p: 0.5,
                                                                minWidth: 110
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontSize: '0.66rem',
                                                                        mb: 0.3
                                                                    },
                                                                    children: [
                                                                        "Severity: ",
                                                                        v.severity
                                                                    ]
                                                                }),
                                                                renderSeverityBars(v.severity)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            align: "right",
                                                            sx: {
                                                                p: 0.5
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    color: '#0b78d1',
                                                                    fontSize: '0.72rem',
                                                                    cursor: 'pointer'
                                                                },
                                                                children: "View details"
                                                            })
                                                        })
                                                    ]
                                                }, v.id)) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    colSpan: 4,
                                                    sx: {
                                                        textAlign: 'center',
                                                        p: 2,
                                                        bgcolor: '#000'
                                                    }
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        mt: 0.25,
                                        pt: 0.25,
                                        p: 0
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f23ee38ba9fa7638$export$2e2bcd8739ae039), {
                                        itemsPerPage: itemsPerPage,
                                        itemsPerPageDescription: "items per page",
                                        // itemsPerPageOptions={[
                                        //   10,
                                        //   20,
                                        //   50
                                        // ]}
                                        onChange: function noRefCheck() {},
                                        onClickItemsPerPage: function noRefCheck() {},
                                        onClickItemsPerPageOption: function noRefCheck() {},
                                        onCloseItemsPerPage: function noRefCheck() {},
                                        page: page,
                                        totalItems: pageCount,
                                        disabled: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $d8seH = parcelRequire("d8seH");

var $acw62 = parcelRequire("acw62");
var $a636998d332e123d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a636998d332e123d$var$BDSButtonGroup = (_a)=>{
    var { children: children, bdsType: bdsType } = _a, props = $a636998d332e123d$var$__rest(_a, [
        "children",
        "bdsType"
    ]);
    const StyledButtonGroup = (0, $d8seH.default)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039))(()=>({
            '&.MuiButtonGroup-button': {
                // Corrected selector
                border: '1px solid red' // Style for all buttons
            },
            '&.MuiButtonGroup-button:not(:last-child)': {
                // Remove right border for all but the last button
                borderRight: '5px'
            }
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StyledButtonGroup, Object.assign({}, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            bdsType: bdsType
        }) : child));
};
var $a636998d332e123d$export$2e2bcd8739ae039 = $a636998d332e123d$var$BDSButtonGroup;


var $ad23ec42537d0e26$export$2e2bcd8739ae039 = (0, $a636998d332e123d$export$2e2bcd8739ae039);


const { Snackbar: $6d777678abefe038$var$Snackbar, SnackbarContent: $6d777678abefe038$export$860cef82710cac7 } = $91a4e72629291447$exports;
var $6d777678abefe038$export$2e2bcd8739ae039 = $6d777678abefe038$var$Snackbar;


var $b5bc22e2b3a7b4be$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($b5bc22e2b3a7b4be$exports, "__esModule", {
    value: true
});
$b5bc22e2b3a7b4be$exports.default = void 0;

var $b5bc22e2b3a7b4be$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b5bc22e2b3a7b4be$var$_default = $b5bc22e2b3a7b4be$exports.default = (0, $b5bc22e2b3a7b4be$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92M18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1M6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
}), 'ShareOutlined');


// src/scanresult/Summary.js

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $b8dd085446ac8892$export$172a0cc583e2fcb1 = ({ props: props, size: size = 20 })=>{
    //style={{height:size, width:size}}
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        style: {
            marginRight: 4
        },
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#clip0_432_1536)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.992 0.496V0.992H1.496H0V4V7.008H3.664H7.328V4V0.992H5.832H4.336V0.496V0H3.664H2.992V0.496ZM1.328 4V5.664H3.664H6V4V2.336H3.664H1.328V4ZM2 4V4.672H2.664H3.328V4V3.328H2.664H2V4ZM4 4V4.672H4.664H5.328V4V3.328H4.664H4V4ZM7.53198 7.54802L3.344 11.736V13.868V16H5.47602H7.60802L11.796 11.812C14.0994 9.50858 15.984 7.61677 15.984 7.60797C15.984 7.58704 11.7569 3.36 11.736 3.36C11.7272 3.36 9.83538 5.24461 7.53198 7.54802ZM8.20389 8.78011L4.67179 12.3122L4.67589 13.4881L4.68 14.664L5.856 14.6681L7.032 14.6721L10.568 11.1361L14.104 7.60003L12.928 6.42402C12.2812 5.7772 11.7485 5.248 11.744 5.248C11.7396 5.248 10.1465 6.83746 8.20389 8.78011Z",
                    fill: "#7D7D7D"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_432_1536",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $b8dd085446ac8892$export$632706c06e3ec4fa = ({ props: props, size: size = 20 })=>{
    //style={{height:size, width:size}}
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        style: {
            marginRight: 4
        },
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#clip0_432_1553)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.41565 0.471404L7.94425 0L7.47285 0.471404L6.26551 1.67876L4.61627 1.23686L3.97232 1.06431L3.79977 1.70826L3.35781 3.3577L1.70875 3.79957L1.06479 3.97212L1.23734 4.61606L1.67919 6.26508L0.471405 7.47288L0 7.94428L0.471404 8.41568L1.67897 9.62321L1.23706 11.2724L1.06451 11.9164L1.70847 12.0889L3.35813 12.5309L3.80005 14.1802L3.9726 14.8242L4.61655 14.6517L6.26553 14.2098L7.47285 15.4171L7.94425 15.8885L8.41565 15.4171L9.62318 14.2097L11.2726 14.6517L11.9166 14.8242L12.0891 14.1802L12.531 12.5309L14.1807 12.0889L14.8247 11.9164L14.6521 11.2724L14.2101 9.62274L15.4171 8.41568L15.8886 7.94428L15.4171 7.47288L14.2098 6.26559L14.6518 4.61606L14.8244 3.97212L14.1804 3.79957L12.5314 3.3577L12.0894 1.70826L11.9168 1.06431L11.2729 1.23686L9.62318 1.6789L8.41565 0.471404ZM8.61078 8.96094V4.96094H7.27745V8.96094H8.61078ZM8.61078 9.96094V11.2943H7.27745V9.96094H8.61078Z",
                    fill: "#7D7D7D"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_432_1553",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $b8dd085446ac8892$export$35539789b1f054a8 = ({ props: props, size: size = 20 })=>{
    //style={{height:size, width:size}}
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        style: {
            marginRight: 4
        },
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#clip0_432_1570)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.68781 0.0226201C4.63229 0.0810201 3.69652 0.2155 2.83981 0.431884C2.52084 0.51246 1.94197 0.704092 1.68781 0.813244C0.81607 1.18769 0.266454 1.66262 0.0766942 2.20545C-0.00280983 2.43288 -0.000153834 2.29585 5.41665e-05 6.1738C0.000230166 9.65065 0.00144617 9.80369 0.0301502 9.94273C0.0963422 10.2635 0.21599 10.4696 0.503814 10.7588C0.79175 11.048 1.10204 11.2535 1.56316 11.4603C2.66644 11.955 4.20757 12.2512 6.03181 12.3193C6.49097 12.3364 7.33369 12.3333 7.35261 12.3143C7.3569 12.3101 7.34948 12.0229 7.33613 11.6762C7.32279 11.3295 7.31185 11.0332 7.31183 11.0178C7.31181 10.9916 7.27229 10.9898 6.70781 10.9896C5.7854 10.9892 5.14415 10.9459 4.31981 10.8283C3.38569 10.695 2.45074 10.428 1.90381 10.1385C1.62313 9.98993 1.38679 9.79884 1.34377 9.68566C1.32733 9.64248 1.31999 7.6938 1.33626 7.6938C1.3409 7.6938 1.42549 7.73075 1.52426 7.7759C3.30956 8.59216 6.41157 8.88328 9.15981 8.49249C10.4967 8.30241 11.6636 7.93099 12.3598 7.47395C12.9038 7.11684 13.2092 6.7315 13.3045 6.28182C13.3397 6.11558 13.3398 2.55278 13.3045 2.38529C13.2103 1.93736 12.9138 1.55724 12.3838 1.20508C11.2444 0.447948 9.05306 -0.00918793 6.60781 0.000140068C6.30421 0.00130807 5.89021 0.0114201 5.68781 0.0226201ZM6.18381 1.34329C4.26484 1.39244 2.49055 1.77956 1.6697 2.3282C1.50935 2.43537 1.34381 2.60296 1.34381 2.65812C1.34381 2.78273 1.64337 3.01872 2.03997 3.20654C3.73636 4.00998 7.14308 4.23313 9.69581 3.70804C10.5138 3.53979 11.2205 3.28772 11.6398 3.01467C11.795 2.91361 11.9349 2.78792 11.9749 2.71352L12.0046 2.65848L11.9561 2.58814C11.7854 2.34046 11.2221 2.04304 10.5198 1.8298C9.61037 1.55368 8.38292 1.37339 7.24781 1.3492C7.04101 1.3448 6.81781 1.33908 6.75181 1.33651C6.68581 1.33393 6.43021 1.33699 6.18381 1.34329ZM1.32781 5.1658C1.32781 5.65425 1.33404 5.99608 1.34337 6.02064C1.39817 6.16475 1.73564 6.40742 2.11581 6.57611C3.62337 7.24496 6.27177 7.49876 8.68244 7.20539C9.96978 7.04873 11.0945 6.71904 11.6705 6.32955C11.7885 6.24972 11.9469 6.10166 11.9775 6.0426C11.9958 6.00724 11.9998 5.84936 11.9998 5.17441V4.34945L11.8758 4.41139C11.0536 4.82209 9.64701 5.14867 8.18381 5.26859C7.21706 5.34782 6.09836 5.34782 5.15181 5.26859C3.67657 5.14512 2.397 4.8514 1.49181 4.42851L1.32781 4.35188V5.1658ZM11.6638 9.49363V9.9978H10.1678H8.67181V12.9978V15.9978H12.3358H15.9998V12.9978V9.9978H14.504H13.0083L13.004 9.4978L12.9998 8.9978L12.3318 8.99363L11.6638 8.98945V9.49363ZM9.99981 12.9978V14.6698H12.3278H14.6558V12.9978V11.3258H12.3278H9.99981V12.9978ZM10.6718 12.9978V13.6618H11.3358H11.9998V12.9978V12.3338H11.3358H10.6718V12.9978ZM12.6718 12.9978V13.6618H13.3358H13.9998V12.9978V12.3338H13.3358H12.6718V12.9978Z",
                    fill: "#7D7D7D"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_432_1570",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $b8dd085446ac8892$export$dd95157357e154db = ({ size: size = 24, color: color = 'currentColor', ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "2",
                x2: "12",
                y2: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "18",
                x2: "12",
                y2: "22"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "2",
                y1: "12",
                x2: "6",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "18",
                y1: "12",
                x2: "22",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "2",
                fill: color
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// frontend/src/utils/color.js
function $adc573943ea4ef85$export$e40673f3a590f6c4(sev) {
    const s = String(sev || '').toLowerCase();
    return s === 'high' ? 4 : s === 'medium' ? 3 : s === 'low' ? 2 : s === 'info' ? 1 : 0;
}
function $adc573943ea4ef85$export$903fb3386f46d61e(s) {
    return s === 4 ? 'High' : s === 3 ? 'Medium' : s === 2 ? 'Low' : s === 1 ? 'Info' : 'Unknown';
}
function $adc573943ea4ef85$export$b0aca466e7158400(s, isSafe) {
    if (isSafe) return '#4caf50'; // Green for safe
    return s === 4 ? '#C62828' : s === 3 ? '#FB8C00' : s === 2 ? '#FFCA28' : '#90caf9';
}
var $adc573943ea4ef85$export$2e2bcd8739ae039 = {
    getSeverityFilled: $adc573943ea4ef85$export$e40673f3a590f6c4,
    getSeverityColor: $adc573943ea4ef85$export$b0aca466e7158400,
    getSeverityText: $adc573943ea4ef85$export$903fb3386f46d61e
};



function $76f12636665395c9$export$155bcd12491a11ee({ severity: severity, isSafe: isSafe }) {
    const color = (0, $adc573943ea4ef85$export$b0aca466e7158400)(severity, isSafe);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            justifyContent: 'flex-start'
        },
        children: Array.from({
            length: 4
        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    width: 22,
                    height: 6,
                    borderRadius: i === 0 ? 3 : 0,
                    bgcolor: i < severity ? color : '#e6e9ec'
                }
            }, i))
    });
}



function $faf99d80e7ab7242$var$getScoreColor(score) {
    if (typeof score !== "number") return "#d32f2f";
    if (score >= 90) return "#2e7d32"; // green
    if (score >= 80) return "#f9a825"; // yellow
    if (score >= 60) return "#fb8c00"; // orange
    return "#d32f2f"; // red
}
function $faf99d80e7ab7242$export$2e2bcd8739ae039({ summary: summary, vulnerabilities: vulnerabilities, waf_detected: waf_detected, scrollPage: scrollPage }) {
    // Backend payload expected at: state.scanResult.data
    const data = summary || {};
    // If backend not integrated yet (empty data), fall back to mock data so the UI shows example content.
    const hasBackendData = data && Object.keys(data).length > 0;
    const mockData = (0, $acw62.useMemo)(()=>({
            security_posture_score: 90,
            target_domain: 'demo.com',
            scan_completed_at: 'Oct 1, 2025 8:00 AM',
            vulnerabilities: [
                {
                    title: 'SQL injection',
                    severity: 'high',
                    description: 'Hackers can steal, change, or delete data, and in some cases take control of the backend database.',
                    instances: 1
                },
                {
                    title: 'Content Security Policy header not set',
                    severity: 'medium',
                    description: 'CSP header missing',
                    instances: 12
                },
                {
                    title: 'Cross-domain misconfiguration',
                    severity: 'medium',
                    description: '',
                    instances: 7
                },
                {
                    title: 'Missing Anti-clickjacking header',
                    severity: 'medium',
                    description: '',
                    instances: 3
                },
                {
                    title: 'Session ID in URL rewrite',
                    severity: 'medium',
                    description: '',
                    instances: 2
                },
                {
                    title: 'Vulnerable JS library',
                    severity: 'low',
                    description: '',
                    instances: 1
                }
            ]
        }), []);
    const effectiveData = hasBackendData ? data : mockData;
    const score = typeof effectiveData.security_posture_score === "number" ? effectiveData.security_posture_score : typeof effectiveData.score === "number" ? effectiveData.score : null;
    const targetDomain = effectiveData.target_domain || effectiveData.domain || effectiveData.host || "";
    const completedOn = effectiveData.scan_completed_at || effectiveData.scanned_at || effectiveData.scan_completed_at || "";
    const vulnerabilities_detected = effectiveData?.vulnerabilities_detected || null;
    const scoreColor = $faf99d80e7ab7242$var$getScoreColor(score ?? -1);
    // compute proportional bar width based on score (0-100)
    const maxBarWidth = 160; // px for score == 100
    const safeScore = typeof score === 'number' && !Number.isNaN(score) ? Math.max(0, Math.min(100, score)) : 0;
    const barWidth = Math.round(safeScore / 100 * maxBarWidth);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                children: "Summary"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                            sx: {
                                p: 2,
                                minHeight: 120,
                                display: 'flex',
                                flexDirection: 'column'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: "Security posture score"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        mt: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "h2",
                                            sx: {
                                                fontWeight: 700,
                                                lineHeight: 1
                                            },
                                            children: typeof score === "number" ? score : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "body2",
                                            color: "text.secondary",
                                            children: "of 100"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                flex: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: maxBarWidth,
                                                height: 21,
                                                bgcolor: '#e8e9ebff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-start'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                role: "progressbar",
                                                "aria-valuenow": safeScore,
                                                "aria-valuemin": 0,
                                                "aria-valuemax": 100,
                                                sx: {
                                                    width: `${barWidth}px`,
                                                    height: 21,
                                                    bgcolor: scoreColor,
                                                    transition: 'width 300ms ease'
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                    sx: {
                                        mt: 1
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                        bdsType: 'interactiveSubtle',
                                        onClick: ()=>scrollPage(4),
                                        children: "How is this calculated?"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                            sx: {
                                p: 2,
                                minHeight: 120
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: "Vulnerabilities detected"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "h5",
                                    sx: {
                                        fontWeight: 700,
                                        mt: 1
                                    },
                                    children: vulnerabilities_detected
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                            sx: {
                                p: 2,
                                minHeight: 120
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: "WAF Detected"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "h5",
                                    sx: {
                                        width: '80%',
                                        fontWeight: 700,
                                        mt: 1
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: waf_detected?.detected ? waf_detected?.firewall : "No WAF Detected"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                            sx: {
                                p: 2,
                                minHeight: 120
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: "Scan completed on"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        mt: 1
                                    },
                                    children: completedOn ? new Date(completedOn).toLocaleString() : "-"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                sx: {
                                    p: 2,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            mb: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle1",
                                                sx: {
                                                    fontWeight: 560
                                                },
                                                children: "Vulnerabilities by severity"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                bdsType: 'interactiveSubtle',
                                                onClick: ()=>scrollPage(1),
                                                children: "View all \u2193"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            flex: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                        container: true,
                                        sx: {
                                            mt: 1,
                                            textAlign: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12f35e2f8b869a3c$export$2e2bcd8739ae039), {
                                            chartData: {
                                                datasets: [
                                                    {
                                                        label: 'Sales',
                                                        data: [
                                                            effectiveData.vulnerabilities_by_severity?.[4] ?? 0,
                                                            // high
                                                            effectiveData.vulnerabilities_by_severity?.[3] ?? 0,
                                                            // medium
                                                            effectiveData.vulnerabilities_by_severity?.[2] ?? 0,
                                                            // low
                                                            effectiveData.vulnerabilities_by_severity?.[1] ?? 0 // info
                                                        ],
                                                        backgroundColor: [
                                                            '#d32f2f',
                                                            '#fb8c00',
                                                            '#f9a825',
                                                            '#2e7d32'
                                                        ],
                                                        // Bar fill colors (design tokens)
                                                        borderColor: [
                                                            '#d32f2f',
                                                            '#fb8c00',
                                                            '#f9a825',
                                                            '#2e7d32  '
                                                        ],
                                                        // Bar border colors (design tokens)
                                                        borderWidth: 2
                                                    }
                                                ],
                                                labels: [
                                                    'High',
                                                    'Medium',
                                                    'Low',
                                                    'Info'
                                                ]
                                            },
                                            chartDimension: {
                                                height: '300px',
                                                width: '100%'
                                            },
                                            emptyState: {
                                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    "data-testid": "empty-state"
                                                }),
                                                text: 'Too full to eat anymore twix'
                                            },
                                            hasEntries: true,
                                            showFooter: false,
                                            barChartOptions: {
                                                plugins: {
                                                    tooltip: {
                                                        enabled: false
                                                    }
                                                },
                                                scales: {
                                                    x: {
                                                        grid: {
                                                            display: false,
                                                            // Removes vertical grid lines
                                                            drawOnChartArea: false // Removes grid lines only within the chart area
                                                        }
                                                    },
                                                    y: {
                                                        grid: {
                                                            display: false,
                                                            // Removes horizontal grid lines
                                                            drawOnChartArea: false // Removes grid lines only within the chart area
                                                        },
                                                        border: {
                                                            display: false // This hides the X-axis line
                                                        },
                                                        ticks: {
                                                            display: false // This hides the Y-axis labels
                                                        }
                                                    }
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                        container: true,
                                        sx: {
                                            mt: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 3,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                mt: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: 12,
                                                                        height: 12,
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#d32f2f'
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "body1",
                                                                    sx: {
                                                                        fontWeight: 500
                                                                    },
                                                                    children: summary?.vulnerabilities_by_severity?.[4]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            variant: "subtitle2",
                                                            sx: {
                                                                mt: 1,
                                                                color: '#616161',
                                                                fontWeight: 700
                                                            },
                                                            children: "Severity: high"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 3,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                mt: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: 12,
                                                                        height: 12,
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#fb8c00'
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "body1",
                                                                    sx: {
                                                                        fontWeight: 500
                                                                    },
                                                                    children: summary?.vulnerabilities_by_severity?.[3]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            variant: "subtitle2",
                                                            sx: {
                                                                mt: 1,
                                                                color: '#616161',
                                                                fontWeight: 700
                                                            },
                                                            children: "Severity: medium"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 3,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                mt: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: 12,
                                                                        height: 12,
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#f9a825'
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "body1",
                                                                    sx: {
                                                                        fontWeight: 500
                                                                    },
                                                                    children: summary?.vulnerabilities_by_severity?.[2]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            variant: "subtitle2",
                                                            sx: {
                                                                mt: 1,
                                                                color: '#616161',
                                                                fontWeight: 700
                                                            },
                                                            children: "Severity: low"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 3,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                mt: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: 12,
                                                                        height: 12,
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#2e7d32'
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "body1",
                                                                    sx: {
                                                                        fontWeight: 500
                                                                    },
                                                                    children: summary?.vulnerabilities_by_severity?.[1]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            variant: "subtitle2",
                                                            sx: {
                                                                mt: 1,
                                                                color: '#616161',
                                                                fontWeight: 700
                                                            },
                                                            children: "Severity: info"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                sx: {
                                    p: 2,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            mb: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle1",
                                                sx: {
                                                    fontWeight: 560
                                                },
                                                children: "Top risks"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                bdsType: 'interactiveSubtle',
                                                onClick: ()=>scrollPage(1),
                                                children: "View all \u2193"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 1
                                        },
                                        children: vulnerabilities.slice(0, 6).map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    py: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            children: t.attack_type_title || t.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            textAlign: 'left',
                                                            minWidth: 140,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'flex-start'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                variant: "body2",
                                                                color: "text.secondary",
                                                                sx: {
                                                                    textAlign: 'left'
                                                                },
                                                                children: [
                                                                    "Severity: ",
                                                                    (0, $adc573943ea4ef85$export$903fb3386f46d61e)(t.severity_level)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    mt: 0.5
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76f12636665395c9$export$155bcd12491a11ee), {
                                                                    severity: t.severity_level
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, t.id ?? i))
                                    }),
                                    vulnerabilities && vulnerabilities[0] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            mt: 2
                                        },
                                        style: {
                                            justifyContent: 'flex-start'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 700
                                                },
                                                children: vulnerabilities[0].attack_type_title || vulnerabilities[0].name
                                            }),
                                            vulnerabilities[0].description ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 0.5
                                                },
                                                children: vulnerabilities[0].description
                                            }) : null
                                        ]
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            }),
            waf_detected?.detected !== true ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                    sx: {
                        p: 2,
                        backgroundColor: '#fafafa'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "h6",
                            sx: {
                                fontWeight: 600,
                                mb: 1
                            },
                            children: "Attack exposure"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "body2",
                            color: "text.secondary",
                            sx: {
                                mb: 2
                            },
                            children: [
                                "There is ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "no Web Application Firewall"
                                }),
                                " detected on your domain and your web application is vulnerable to a wide range of common cyberattacks."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        sx: {
                                            p: 2,
                                            backgroundColor: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 700,
                                                    color: '#111'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8dd085446ac8892$export$172a0cc583e2fcb1), {
                                                        size: 16
                                                    }),
                                                    " Bot attack"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: "Without a WAF, automated bots can scrape data, attempt brute-force logins, or perform credential stuffing attacks."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        sx: {
                                            p: 2,
                                            backgroundColor: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 700,
                                                    color: '#111'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8dd085446ac8892$export$632706c06e3ec4fa), {
                                                        size: 16
                                                    }),
                                                    "DDoS attack"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: "Without a WAF, your application may be overwhelmed by malicious traffic, causing outages."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        sx: {
                                            p: 2,
                                            backgroundColor: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 700,
                                                    color: '#111'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8dd085446ac8892$export$35539789b1f054a8), {
                                                        size: 16
                                                    }),
                                                    "SQL injection"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: "Hackers can steal, change, or delete data, and in some cases take control of the backend database."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                    sx: {
                        p: 2,
                        backgroundColor: '#fafafa'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "h6",
                            sx: {
                                fontWeight: 600,
                                mb: 1
                            },
                            children: "WAF Detected"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "body2",
                            color: "text.secondary",
                            sx: {
                                mb: 2
                            },
                            children: "A Web Application Firewall (WAF) has been detected on your domain. This helps protect your web application from common cyberattacks."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        sx: {
                                            p: 2,
                                            backgroundColor: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 700,
                                                    color: '#111'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8dd085446ac8892$export$172a0cc583e2fcb1), {
                                                        size: 16
                                                    }),
                                                    "WAF Name"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: waf_detected?.firewall || "Unknown WAF"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        sx: {
                                            p: 2,
                                            backgroundColor: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 700,
                                                    color: '#111'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8dd085446ac8892$export$632706c06e3ec4fa), {
                                                        size: 16
                                                    }),
                                                    "Manufacturer"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: waf_detected?.manufacturer || "Unknown Manufacturer"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        sx: {
                                            p: 2,
                                            backgroundColor: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 700,
                                                    color: '#111'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8dd085446ac8892$export$35539789b1f054a8), {
                                                        size: 16
                                                    }),
                                                    "URL"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 1
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: waf_detected?.url || "Unknown URL"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
const $edff5abc0cc25a03$var$StyledSkeleton = (0, $d8seH.default)((0, $445470756a9ff70a$export$2e2bcd8739ae039))(({ theme: theme })=>({
        // Add your custom styles here
        backgroundColor: theme.palette.skeleton.background,
        border: `${theme.palette.skeleton.border.width} solid ${theme.palette.skeleton.border.default}`,
        '&.MuiSkeleton-text': {
            borderRadius: theme.palette.skeleton.border.radius.round
        },
        '&.MuiSkeleton-rectangular': {
            borderRadius: theme.palette.skeleton.border.radius.sharp
        },
        '&.MuiSkeleton-circular': {
            borderRadius: theme.palette.skeleton.border.radius.round
        },
        '&.MuiSkeleton-rounded': {
            borderRadius: theme.palette.skeleton.border.radius.round
        }
    }));
const $edff5abc0cc25a03$var$BDSSkeleton = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($edff5abc0cc25a03$var$StyledSkeleton, Object.assign({}, props));
};
// This is necessary to show the name of the component
// correctly in the DevTools and Storybook.
$edff5abc0cc25a03$var$BDSSkeleton.displayName = 'Skeleton';
var $edff5abc0cc25a03$export$2e2bcd8739ae039 = $edff5abc0cc25a03$var$BDSSkeleton;


var $23f48e995fd02484$export$2e2bcd8739ae039 = (0, $edff5abc0cc25a03$export$2e2bcd8739ae039);


function $cada76186e16b461$export$2e2bcd8739ae039({ target_domain: target_domain, scrollPage: scrollPage }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                children: "Summary"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Security posture score"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                sx: {
                                                    width: '80%',
                                                    fontWeight: 700,
                                                    lineHeight: 1
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                    variant: "text",
                                                    sx: {
                                                        fontSize: '1.5rem'
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                bdsType: 'interactiveSubtle',
                                                onClick: ()=>scrollPage(4),
                                                children: "How is this calculated?"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Vulnerabilities detected"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "h5",
                                            sx: {
                                                width: '80%',
                                                fontWeight: 700,
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                sx: {
                                                    fontSize: '1.5rem'
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 4,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Target domain"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "h5",
                                            sx: {
                                                width: '80%',
                                                fontWeight: 700,
                                                mt: 1
                                            },
                                            children: target_domain
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Scan completed on"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "h5",
                                            sx: {
                                                width: '80%',
                                                fontWeight: 700,
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                sx: {
                                                    fontSize: '1.5rem'
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        sx: {
                                            p: 2,
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    mb: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "subtitle1",
                                                        sx: {
                                                            fontWeight: 560
                                                        },
                                                        children: "Vulnerabilities by severity"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                        bdsType: 'interactiveSubtle',
                                                        onClick: ()=>scrollPage(1),
                                                        children: "View all \u2193"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    flex: 1
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                container: true,
                                                sx: {
                                                    mt: 1,
                                                    height: '300px',
                                                    width: '100%',
                                                    textAlign: 'center'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                    variant: "rectangular",
                                                    width: '80%',
                                                    height: 250
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                container: true,
                                                sx: {
                                                    mt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#1976d2'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: high"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#1e88e5'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: medium"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#64b5f6'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: low"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#bbdefb'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: info"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        sx: {
                                            p: 2,
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    mb: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "subtitle1",
                                                        sx: {
                                                            fontWeight: 560
                                                        },
                                                        children: "Top risks"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                        bdsType: 'interactiveSubtle',
                                                        onClick: ()=>scrollPage(1),
                                                        children: "View all \u2193"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    flex: 1,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 1
                                                },
                                                children: [
                                                    1,
                                                    2,
                                                    3,
                                                    4,
                                                    5
                                                ].map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            py: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                        variant: "text",
                                                                        width: 350,
                                                                        sx: {
                                                                            fontSize: '1rem'
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    textAlign: 'left',
                                                                    minWidth: 140,
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "body2",
                                                                    color: "text.secondary",
                                                                    sx: {
                                                                        textAlign: 'left'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                        variant: "text",
                                                                        width: 100,
                                                                        sx: {
                                                                            fontSize: '1rem'
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }, i))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    mt: 2
                                                },
                                                style: {
                                                    justifyContent: 'flex-start'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            fontWeight: 700
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                            variant: "text",
                                                            width: 100,
                                                            sx: {
                                                                fontSize: '1rem'
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "body2",
                                                        color: "text.secondary",
                                                        sx: {
                                                            mt: 0.5
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                            variant: "text",
                                                            width: 600,
                                                            sx: {
                                                                fontSize: '1rem'
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                            sx: {
                                p: 2,
                                backgroundColor: '#fafafa'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    sx: {
                                        fontWeight: 600,
                                        mb: 1
                                    },
                                    children: "Attack exposure"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        mb: 2
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                        variant: "rectangular",
                                        width: '100%',
                                        height: 120
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
// frontend/src/utils/drawer.js

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9c5eb05f9740712a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($9c5eb05f9740712a$exports, "__esModule", {
    value: true
});
$9c5eb05f9740712a$exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = $9c5eb05f9740712a$exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



const { Drawer: $f7e11211e1a6425c$var$Drawer } = $91a4e72629291447$exports;
var $f7e11211e1a6425c$export$2e2bcd8739ae039 = $f7e11211e1a6425c$var$Drawer;




/// <reference types="./index.d.ts" />

var $ayMG0 = parcelRequire("ayMG0");

var $ijOKP = parcelRequire("ijOKP");
var $3ErGR = parcelRequire("3ErGR");

var $acw62 = parcelRequire("acw62");
var $af9e91ea6e32034a$exports = {};
'use strict';
var $daecaa38e3584fd1$exports = {};
'use strict';
var $daecaa38e3584fd1$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $daecaa38e3584fd1$var$createStore = function createStore(createState) {
    return createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
};
var $daecaa38e3584fd1$var$vanilla = function(createState) {
    return $daecaa38e3584fd1$var$createStore(createState);
};
$daecaa38e3584fd1$exports.createStore = $daecaa38e3584fd1$var$createStore;
$daecaa38e3584fd1$exports.default = $daecaa38e3584fd1$var$vanilla;
$daecaa38e3584fd1$exports = $daecaa38e3584fd1$var$vanilla;
$daecaa38e3584fd1$exports.createStore = $daecaa38e3584fd1$var$createStore;
$daecaa38e3584fd1$exports.default = $daecaa38e3584fd1$exports;



var $acw62 = parcelRequire("acw62");
var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("i5mAx"));


var $af9e91ea6e32034a$var$useDebugValue = $acw62.useDebugValue;
var $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector = $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector;
var $af9e91ea6e32034a$var$didWarnAboutEqualityFn = false;
var $af9e91ea6e32034a$var$identity = function identity(arg) {
    return arg;
};
function $af9e91ea6e32034a$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $af9e91ea6e32034a$var$identity;
    var slice = $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $af9e91ea6e32034a$var$useDebugValue(slice);
    return slice;
}
var $af9e91ea6e32034a$var$createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? $daecaa38e3584fd1$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $af9e91ea6e32034a$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $af9e91ea6e32034a$var$create = function create(createState) {
    return createState ? $af9e91ea6e32034a$var$createImpl(createState) : $af9e91ea6e32034a$var$createImpl;
};
var $af9e91ea6e32034a$var$react = function(createState) {
    return $af9e91ea6e32034a$var$create(createState);
};
$af9e91ea6e32034a$exports.create = $af9e91ea6e32034a$var$create;
$af9e91ea6e32034a$exports.default = $af9e91ea6e32034a$var$react;
$af9e91ea6e32034a$exports.useStore = $af9e91ea6e32034a$var$useStore;
Object.keys($daecaa38e3584fd1$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($af9e91ea6e32034a$exports, k)) Object.defineProperty($af9e91ea6e32034a$exports, k, {
        enumerable: true,
        get: function() {
            return $daecaa38e3584fd1$exports[k];
        }
    });
});
$af9e91ea6e32034a$exports = $af9e91ea6e32034a$var$react;
$af9e91ea6e32034a$exports.create = $af9e91ea6e32034a$var$create;
$af9e91ea6e32034a$exports.useStore = $af9e91ea6e32034a$var$useStore;
$af9e91ea6e32034a$exports.createStore = $daecaa38e3584fd1$exports.createStore;
$af9e91ea6e32034a$exports.default = $af9e91ea6e32034a$exports;


var $e5a78797c4262d1f$exports = {};
"use strict";
var $9e6bd5018912b3a9$exports = {};
$9e6bd5018912b3a9$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9e6bd5018912b3a9$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$e5a78797c4262d1f$exports = $e5a78797c4262d1f$var$copy;


function $1395207c3d9b6054$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $1395207c3d9b6054$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $1395207c3d9b6054$var$clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $1395207c3d9b6054$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
const $1395207c3d9b6054$export$1cc789a2b9985532 = {
    scheme: 'Light Theme',
    author: 'mac gainor (https://github.com/mac-s-g)',
    base00: 'rgba(0, 0, 0, 0)',
    base01: 'rgb(245, 245, 245)',
    base02: 'rgb(235, 235, 235)',
    base03: '#93a1a1',
    base04: 'rgba(0, 0, 0, 0.3)',
    base05: '#586e75',
    base06: '#073642',
    base07: '#002b36',
    base08: '#d33682',
    base09: '#cb4b16',
    base0A: '#ffd500',
    base0B: '#859900',
    base0C: '#6c71c4',
    base0D: '#586e75',
    base0E: '#2aa198',
    base0F: '#268bd2'
};
const $1395207c3d9b6054$export$f1b992648bf9516a = {
    scheme: 'Dark Theme',
    author: 'Chris Kempson (http://chriskempson.com)',
    base00: '#181818',
    base01: '#282828',
    base02: '#383838',
    base03: '#585858',
    base04: '#b8b8b8',
    base05: '#d8d8d8',
    base06: '#e8e8e8',
    base07: '#f8f8f8',
    base08: '#ab4642',
    base09: '#dc9656',
    base0A: '#f7ca88',
    base0B: '#a1b56c',
    base0C: '#86c1b9',
    base0D: '#7cafc2',
    base0E: '#ba8baf',
    base0F: '#a16946'
};
const $1395207c3d9b6054$var$DefaultKeyRenderer = ()=>null;
$1395207c3d9b6054$var$DefaultKeyRenderer.when = ()=>false;
const $1395207c3d9b6054$var$createJsonViewerStore = (props)=>{
    return (0, $af9e91ea6e32034a$exports.create)()((set, get)=>{
        var _props_rootName, _props_indentWidth, _props_keyRenderer, _props_enableAdd, _props_enableDelete, _props_enableClipboard, _props_editable, _props_onChange, _props_onCopy, _props_onSelect, _props_onAdd, _props_onDelete, _props_defaultInspectDepth, _props_defaultInspectControl, _props_maxDisplayLength, _props_groupArraysAfterLength, _props_collapseStringsAfterLength, _props_objectSortKeys, _props_quotesOnKeys, _props_displayDataTypes, _props_displaySize, _props_displayComma, _props_highlightUpdates;
        return {
            // provided by user
            rootName: (_props_rootName = props.rootName) !== null && _props_rootName !== void 0 ? _props_rootName : 'root',
            indentWidth: (_props_indentWidth = props.indentWidth) !== null && _props_indentWidth !== void 0 ? _props_indentWidth : 3,
            keyRenderer: (_props_keyRenderer = props.keyRenderer) !== null && _props_keyRenderer !== void 0 ? _props_keyRenderer : $1395207c3d9b6054$var$DefaultKeyRenderer,
            enableAdd: (_props_enableAdd = props.enableAdd) !== null && _props_enableAdd !== void 0 ? _props_enableAdd : false,
            enableDelete: (_props_enableDelete = props.enableDelete) !== null && _props_enableDelete !== void 0 ? _props_enableDelete : false,
            enableClipboard: (_props_enableClipboard = props.enableClipboard) !== null && _props_enableClipboard !== void 0 ? _props_enableClipboard : true,
            editable: (_props_editable = props.editable) !== null && _props_editable !== void 0 ? _props_editable : false,
            onChange: (_props_onChange = props.onChange) !== null && _props_onChange !== void 0 ? _props_onChange : ()=>{},
            onCopy: (_props_onCopy = props.onCopy) !== null && _props_onCopy !== void 0 ? _props_onCopy : undefined,
            onSelect: (_props_onSelect = props.onSelect) !== null && _props_onSelect !== void 0 ? _props_onSelect : undefined,
            onAdd: (_props_onAdd = props.onAdd) !== null && _props_onAdd !== void 0 ? _props_onAdd : undefined,
            onDelete: (_props_onDelete = props.onDelete) !== null && _props_onDelete !== void 0 ? _props_onDelete : undefined,
            defaultInspectDepth: (_props_defaultInspectDepth = props.defaultInspectDepth) !== null && _props_defaultInspectDepth !== void 0 ? _props_defaultInspectDepth : 5,
            defaultInspectControl: (_props_defaultInspectControl = props.defaultInspectControl) !== null && _props_defaultInspectControl !== void 0 ? _props_defaultInspectControl : undefined,
            maxDisplayLength: (_props_maxDisplayLength = props.maxDisplayLength) !== null && _props_maxDisplayLength !== void 0 ? _props_maxDisplayLength : 30,
            groupArraysAfterLength: (_props_groupArraysAfterLength = props.groupArraysAfterLength) !== null && _props_groupArraysAfterLength !== void 0 ? _props_groupArraysAfterLength : 100,
            collapseStringsAfterLength: props.collapseStringsAfterLength === false ? Number.MAX_VALUE : (_props_collapseStringsAfterLength = props.collapseStringsAfterLength) !== null && _props_collapseStringsAfterLength !== void 0 ? _props_collapseStringsAfterLength : 50,
            objectSortKeys: (_props_objectSortKeys = props.objectSortKeys) !== null && _props_objectSortKeys !== void 0 ? _props_objectSortKeys : false,
            quotesOnKeys: (_props_quotesOnKeys = props.quotesOnKeys) !== null && _props_quotesOnKeys !== void 0 ? _props_quotesOnKeys : true,
            displayDataTypes: (_props_displayDataTypes = props.displayDataTypes) !== null && _props_displayDataTypes !== void 0 ? _props_displayDataTypes : true,
            displaySize: (_props_displaySize = props.displaySize) !== null && _props_displaySize !== void 0 ? _props_displaySize : true,
            displayComma: (_props_displayComma = props.displayComma) !== null && _props_displayComma !== void 0 ? _props_displayComma : false,
            highlightUpdates: (_props_highlightUpdates = props.highlightUpdates) !== null && _props_highlightUpdates !== void 0 ? _props_highlightUpdates : false,
            // internal state
            inspectCache: {},
            hoverPath: null,
            colorspace: $1395207c3d9b6054$export$1cc789a2b9985532,
            value: props.value,
            prevValue: undefined,
            getInspectCache: (path, nestedIndex)=>{
                const target = nestedIndex !== undefined ? path.join('.') + "[".concat(nestedIndex, "]nt") : path.join('.');
                return get().inspectCache[target];
            },
            setInspectCache: (path, action, nestedIndex)=>{
                const target = nestedIndex !== undefined ? path.join('.') + "[".concat(nestedIndex, "]nt") : path.join('.');
                set((state)=>({
                        inspectCache: {
                            ...state.inspectCache,
                            [target]: typeof action === 'function' ? action(state.inspectCache[target]) : action
                        }
                    }));
            },
            setHover: (path, nestedIndex)=>{
                set({
                    hoverPath: path ? {
                        path: path,
                        nestedIndex: nestedIndex
                    } : null
                });
            }
        };
    });
};
// @ts-expect-error we intentionally want to pass undefined to the context
// See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
const $1395207c3d9b6054$var$JsonViewerStoreContext = (0, $acw62.createContext)(undefined);
$1395207c3d9b6054$var$JsonViewerStoreContext.Provider;
const $1395207c3d9b6054$var$useJsonViewerStore = (selector, equalityFn)=>{
    const store = (0, $acw62.useContext)($1395207c3d9b6054$var$JsonViewerStoreContext);
    return (0, $af9e91ea6e32034a$exports.useStore)(store, selector, equalityFn);
};
const $1395207c3d9b6054$var$useTextColor = ()=>{
    return $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base07);
};
// reference: https://github.com/immerjs/immer/blob/main/src/utils/common.ts
const $1395207c3d9b6054$var$objectCtorString = Object.prototype.constructor.toString();
function $1395207c3d9b6054$var$isPlainObject(value) {
    if (!value || typeof value !== 'object') return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor === 'function' && Function.toString.call(Ctor) === $1395207c3d9b6054$var$objectCtorString;
}
function $1395207c3d9b6054$var$shouldShallowCopy(value) {
    if (!value) return false;
    return $1395207c3d9b6054$var$isPlainObject(value) || Array.isArray(value) || value instanceof Map || value instanceof Set;
}
function $1395207c3d9b6054$var$shallowCopy(value) {
    if (Array.isArray(value)) return Array.prototype.slice.call(value);
    if (value instanceof Set) return new Set(value);
    if (value instanceof Map) return new Map(value);
    if (typeof value === 'object' && value !== null) return Object.assign({}, value);
    return value;
}
function $1395207c3d9b6054$var$_applyValue(input, path, value) {
    let visitedMapping = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new Map();
    if (typeof input !== 'object' || input === null) {
        if (path.length !== 0) throw new Error('path is incorrect');
        return value;
    }
    const shouldCopy = $1395207c3d9b6054$var$shouldShallowCopy(input);
    if (shouldCopy) {
        let copiedInput = visitedMapping.get(input);
        if (!copiedInput) {
            copiedInput = $1395207c3d9b6054$var$shallowCopy(input);
            visitedMapping.set(input, copiedInput);
        }
        input = copiedInput;
    }
    const [key, ...restPath] = path;
    if (key !== undefined) {
        if (key === '__proto__') throw new TypeError('Modification of prototype is not allowed');
        if (restPath.length > 0) input[key] = $1395207c3d9b6054$var$_applyValue(input[key], restPath, value, visitedMapping);
        else input[key] = value;
    }
    return input;
}
/**
 * Apply a value to a given path of an object.
 */ function $1395207c3d9b6054$export$3fff2c5da070f2b5(input, path, value) {
    return $1395207c3d9b6054$var$_applyValue(input, path, value);
}
/**
 * Delete a value from a given path of an object.
 */ function $1395207c3d9b6054$export$1386afd36e937fb5(input, path, value) {
    if (typeof input !== 'object' || input === null) {
        if (path.length !== 0) throw new Error('path is incorrect');
        return value;
    }
    const shouldCopy = $1395207c3d9b6054$var$shouldShallowCopy(input);
    if (shouldCopy) input = $1395207c3d9b6054$var$shallowCopy(input);
    const [key, ...restPath] = path;
    if (key !== undefined) {
        if (key === '__proto__') throw new TypeError('Modification of prototype is not allowed');
        if (restPath.length > 0) input[key] = $1395207c3d9b6054$export$1386afd36e937fb5(input[key], restPath, value);
        else if (Array.isArray(input)) input.splice(Number(key), 1);
        else delete input[key];
    }
    return input;
}
/**
 * @deprecated use `defineDataType` instead
 */ function $1395207c3d9b6054$export$57536f3ea1c0c955(is, Component, Editor, PreComponent, PostComponent) {
    return {
        is: is,
        Component: Component,
        Editor: Editor,
        PreComponent: PreComponent,
        PostComponent: PostComponent
    };
}
/**
 * Define custom data types for any data structure
 */ function $1395207c3d9b6054$export$1f429938e027bb62(param) {
    let { is: is, serialize: serialize, deserialize: deserialize, Component: Component, Editor: Editor, PreComponent: PreComponent, PostComponent: PostComponent } = param;
    return {
        is: is,
        serialize: serialize,
        deserialize: deserialize,
        Component: Component,
        Editor: Editor,
        PreComponent: PreComponent,
        PostComponent: PostComponent
    };
}
const $1395207c3d9b6054$export$bc43bafe0f53b49c = (root, path, value)=>{
    if (root === null || value === null) return false;
    if (typeof root !== 'object') return false;
    if (typeof value !== 'object') return false;
    if (Object.is(root, value) && path.length !== 0) return '';
    const currentPath = [];
    const arr = [
        ...path
    ];
    let currentRoot = root;
    while(currentRoot !== value || arr.length !== 0){
        if (typeof currentRoot !== 'object' || currentRoot === null) return false;
        if (Object.is(currentRoot, value)) return currentPath.reduce((path, value, currentIndex)=>{
            if (typeof value === 'number') return path + "[".concat(value, "]");
            return path + "".concat(currentIndex === 0 ? '' : '.').concat(value);
        }, '');
        const target = arr.shift();
        currentPath.push(target);
        currentRoot = currentRoot[target];
    }
    return false;
};
function $1395207c3d9b6054$var$getValueSize(value) {
    if (value === null || undefined) return 0;
    else if (Array.isArray(value)) return value.length;
    else if (value instanceof Map || value instanceof Set) return value.size;
    else if (value instanceof Date) return 1;
    else if (typeof value === 'object') return Object.keys(value).length;
    else if (typeof value === 'string') return value.length;
    return 1;
}
function $1395207c3d9b6054$var$segmentArray(arr, size) {
    const result = [];
    let index = 0;
    while(index < arr.length){
        result.push(arr.slice(index, index + size));
        index += size;
    }
    return result;
}
/**
 * A safe version of `JSON.stringify` that handles circular references and BigInts.
 *
 * *This function might be changed in the future to support more types. Use it with caution.*
 *
 * @param obj A JavaScript value, usually an object or array, to be converted.
 * @param space Adds indentation, white space, and line break characters to the return-value JSON text to make it easier to read.
 * @returns
 */ function $1395207c3d9b6054$export$56831a8b9cb27763(obj, space) {
    const seenValues = [];
    function replacer(key, value) {
        // https://github.com/GoogleChromeLabs/jsbi/issues/30
        if (typeof value === 'bigint') return value.toString();
        // Map and Set are not supported by JSON.stringify
        if (value instanceof Map) {
            if ('toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
            if (value.size === 0) return {};
            if (seenValues.includes(value)) return '[Circular]';
            seenValues.push(value);
            const entries = Array.from(value.entries());
            if (entries.every((param)=>{
                let [key] = param;
                return typeof key === 'string' || typeof key === 'number';
            })) return Object.fromEntries(entries);
            // if keys are not string or number, we can't convert to object
            // fallback to default behavior
            return {};
        }
        if (value instanceof Set) {
            if ('toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
            if (seenValues.includes(value)) return '[Circular]';
            seenValues.push(value);
            return Array.from(value.values());
        }
        // https://stackoverflow.com/a/72457899
        if (typeof value === 'object' && value !== null && Object.keys(value).length) {
            const stackSize = seenValues.length;
            if (stackSize) {
                // clean up expired references
                for(let n = stackSize - 1; n >= 0 && seenValues[n][key] !== value; --n)seenValues.pop();
                if (seenValues.includes(value)) return '[Circular]';
            }
            seenValues.push(value);
        }
        return value;
    }
    return JSON.stringify(obj, replacer, space);
}
async function $1395207c3d9b6054$var$copyString(value) {
    if ('clipboard' in navigator) try {
        await navigator.clipboard.writeText(value);
    } catch  {
    // When navigator.clipboard throws an error, fallback to copy-to-clipboard package
    }
    // fallback to copy-to-clipboard when navigator.clipboard is not available
    (0, (/*@__PURE__*/$parcel$interopDefault($e5a78797c4262d1f$exports)))(value);
}
function $1395207c3d9b6054$export$fe168cf31b7a2a95(value, key) {
    if (value === null || value === undefined) return null;
    if (value instanceof Map || value instanceof WeakMap) return value.get(key);
    if (value instanceof Set) return Array.from(value)[key];
    if (value instanceof WeakSet) throw new Error('WeakSet is not supported');
    if (Array.isArray(value)) return value[Number(key)];
    if (typeof value === 'object') return value[key];
    return null;
}
/**
 * Get the value at a given path in an object.
 * Passing custom getters allows you to handle custom data structures.
 * @experimental This function is not yet stable and may change in the future.
 */ function $1395207c3d9b6054$export$964131d48d6e4d94(obj, path) {
    let customGetters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    try {
        // @ts-ignore
        return path.reduce((acc, key, index)=>{
            if (acc === null || acc === undefined) {
                console.error('Invalid path or value encountered at path', path.slice(0, index));
                throw new Error('Invalid path or value encountered');
            }
            for (const handler of customGetters){
                const currentPath = path.slice(0, index + 1);
                if (handler.is(acc, currentPath)) return handler.handler(acc, key);
            }
            return $1395207c3d9b6054$export$fe168cf31b7a2a95(acc, key);
        }, obj);
    } catch (error) {
        console.error(error);
        return null // or throw error?
        ;
    }
}
/**
 * useClipboard hook accepts one argument options in which copied status timeout duration is defined (defaults to 2000). Hook returns object with properties:
 * - copy – function to copy value to clipboard
 * - copied – value that indicates that copy handler was called less than options.timeout ms ago
 * - reset – function to clear timeout and reset copied to false
 */ function $1395207c3d9b6054$var$useClipboard() {
    let { timeout: timeout = 2000 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const copyTimeout = (0, $acw62.useRef)(null);
    const handleCopyResult = (0, $acw62.useCallback)((value)=>{
        const current = copyTimeout.current;
        if (current) window.clearTimeout(current);
        copyTimeout.current = window.setTimeout(()=>setCopied(false), timeout);
        setCopied(value);
    }, [
        timeout
    ]);
    const onCopy = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.onCopy);
    const copy = (0, $acw62.useCallback)(async (path, value)=>{
        if (typeof onCopy === 'function') try {
            await onCopy(path, value, $1395207c3d9b6054$var$copyString);
            handleCopyResult(true);
        } catch (error) {
            console.error("error when copy ".concat(path.length === 0 ? 'src' : "src[".concat(path.join('.')), "]"), error);
        }
        else try {
            const valueToCopy = $1395207c3d9b6054$export$56831a8b9cb27763(typeof value === 'function' ? value.toString() : value, '  ');
            await $1395207c3d9b6054$var$copyString(valueToCopy);
            handleCopyResult(true);
        } catch (error) {
            console.error("error when copy ".concat(path.length === 0 ? 'src' : "src[".concat(path.join('.')), "]"), error);
        }
    }, [
        handleCopyResult,
        onCopy
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setCopied(false);
        if (copyTimeout.current) clearTimeout(copyTimeout.current);
    }, []);
    return {
        copy: copy,
        reset: reset,
        copied: copied
    };
}
function $1395207c3d9b6054$var$useIsCycleReference(path, value) {
    const rootValue = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.value);
    return (0, $acw62.useMemo)(()=>$1395207c3d9b6054$export$bc43bafe0f53b49c(rootValue, path, value), [
        path,
        value,
        rootValue
    ]);
}
function $1395207c3d9b6054$var$useInspect(path, value, nestedIndex) {
    const depth = path.length;
    const isTrap = $1395207c3d9b6054$var$useIsCycleReference(path, value);
    const getInspectCache = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.getInspectCache);
    const setInspectCache = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.setInspectCache);
    const defaultInspectDepth = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.defaultInspectDepth);
    const defaultInspectControl = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.defaultInspectControl);
    (0, $acw62.useEffect)(()=>{
        const inspect = getInspectCache(path, nestedIndex);
        if (inspect !== undefined) return;
        // item with nestedIndex should not be inspected
        if (nestedIndex !== undefined) {
            setInspectCache(path, false, nestedIndex);
            return;
        }
        // do not inspect when it is a cycle reference, otherwise there will have a loop
        const shouldInspect = isTrap ? false : typeof defaultInspectControl === 'function' ? defaultInspectControl(path, value) : depth < defaultInspectDepth;
        setInspectCache(path, shouldInspect);
    }, [
        defaultInspectDepth,
        defaultInspectControl,
        depth,
        getInspectCache,
        isTrap,
        nestedIndex,
        path,
        value,
        setInspectCache
    ]);
    const [inspect, set] = (0, $acw62.useState)(()=>{
        const shouldInspect = getInspectCache(path, nestedIndex);
        if (shouldInspect !== undefined) return shouldInspect;
        if (nestedIndex !== undefined) return false;
        return isTrap ? false : typeof defaultInspectControl === 'function' ? defaultInspectControl(path, value) : depth < defaultInspectDepth;
    });
    const setInspect = (0, $acw62.useCallback)((apply)=>{
        set((oldState)=>{
            const newState = typeof apply === 'boolean' ? apply : apply(oldState);
            setInspectCache(path, newState, nestedIndex);
            return newState;
        });
    }, [
        nestedIndex,
        path,
        setInspectCache
    ]);
    return [
        inspect,
        setInspect
    ];
}
const $1395207c3d9b6054$var$DataBox = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        component: "div",
        ...props,
        sx: {
            display: 'inline-block',
            ...props.sx
        }
    });
const $1395207c3d9b6054$var$DataTypeLabel = (param)=>{
    let { dataType: dataType, enable: enable = true } = param;
    if (!enable) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataBox, {
        className: "data-type-label",
        sx: {
            mx: 0.5,
            fontSize: '0.7rem',
            opacity: 0.8,
            userSelect: 'none'
        },
        children: dataType
    });
};
/**
 * Enhanced version of `defineDataType` that creates a `DataType` with editor and a optional type label.
 * It will take care of the color and all the necessary props.
 *
 * *All of the built-in data types are defined with this function.*
 *
 * @param config.type The type name.
 * @param config.colorKey The color key in the colorspace. ('base00' - 'base0F')
 * @param config.displayTypeLabel Whether to display the type label.
 * @param config.Renderer The component to render the value.
 */ function $1395207c3d9b6054$export$e7bd156af3e9ba(param) {
    let { is: is, serialize: serialize, deserialize: deserialize, type: type, colorKey: colorKey, displayTypeLabel: displayTypeLabel = true, Renderer: Renderer } = param;
    const Render = /*#__PURE__*/ (0, $acw62.memo)(Renderer);
    const EasyType = (props)=>{
        const storeDisplayDataTypes = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.displayDataTypes);
        const color = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace[colorKey]);
        const onSelect = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.onSelect);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($1395207c3d9b6054$var$DataBox, {
            onClick: ()=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(props.path, props.value),
            sx: {
                color: color
            },
            children: [
                displayTypeLabel && storeDisplayDataTypes && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataTypeLabel, {
                    dataType: type
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataBox, {
                    className: "".concat(type, "-value"),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Render, {
                        path: props.path,
                        inspect: props.inspect,
                        setInspect: props.setInspect,
                        value: props.value,
                        prevValue: props.prevValue
                    })
                })
            ]
        });
    };
    EasyType.displayName = "easy-".concat(type, "-type");
    if (!serialize || !deserialize) return {
        is: is,
        Component: EasyType
    };
    const EasyTypeEditor = (param)=>{
        let { value: value, setValue: setValue, abortEditing: abortEditing, commitEditing: commitEditing } = param;
        const color = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace[colorKey]);
        const handleKeyDown = (0, $acw62.useCallback)((event)=>{
            if (event.key === 'Enter') {
                event.preventDefault();
                commitEditing(value);
            }
            if (event.key === 'Escape') {
                event.preventDefault();
                abortEditing();
            }
        }, [
            abortEditing,
            commitEditing,
            value
        ]);
        const handleChange = (0, $acw62.useCallback)((event)=>{
            setValue(event.target.value);
        }, [
            setValue
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), {
            autoFocus: true,
            value: value,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            size: "small",
            multiline: true,
            sx: {
                color: color,
                padding: 0.5,
                borderStyle: 'solid',
                borderColor: 'black',
                borderWidth: 1,
                fontSize: '0.8rem',
                fontFamily: 'monospace',
                display: 'inline-flex'
            }
        });
    };
    EasyTypeEditor.displayName = "easy-".concat(type, "-type-editor");
    return {
        is: is,
        serialize: serialize,
        deserialize: deserialize,
        Component: EasyType,
        Editor: EasyTypeEditor
    };
}
const $1395207c3d9b6054$export$1d5983b8af74aede = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>typeof value === 'boolean',
    type: 'bool',
    colorKey: 'base0E',
    serialize: (value)=>value.toString(),
    deserialize: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        throw new Error('Invalid boolean value');
    },
    Renderer: (param)=>{
        let { value: value } = param;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: value ? 'true' : 'false'
        });
    }
});
const $1395207c3d9b6054$var$displayOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
};
const $1395207c3d9b6054$export$da791619211328be = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>value instanceof Date,
    type: 'date',
    colorKey: 'base0D',
    Renderer: (param)=>{
        let { value: value } = param;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: value.toLocaleTimeString('en-us', $1395207c3d9b6054$var$displayOptions)
        });
    }
});
const $1395207c3d9b6054$var$functionBody = (func)=>{
    const funcString = func.toString();
    let isUsualFunction = true;
    const parenthesisPos = funcString.indexOf(')');
    const arrowPos = funcString.indexOf('=>');
    if (arrowPos !== -1 && arrowPos > parenthesisPos) isUsualFunction = false;
    if (isUsualFunction) return funcString.substring(funcString.indexOf('{', parenthesisPos) + 1, funcString.lastIndexOf('}'));
    return funcString.substring(funcString.indexOf('=>') + 2);
};
const $1395207c3d9b6054$var$functionName = (func)=>{
    const funcString = func.toString();
    const isUsualFunction = funcString.indexOf('function') !== -1;
    if (isUsualFunction) return funcString.substring(8, funcString.indexOf('{')).trim();
    return funcString.substring(0, funcString.indexOf('=>') + 2).trim();
};
const $1395207c3d9b6054$var$lb = '{';
const $1395207c3d9b6054$var$rb = '}';
const $1395207c3d9b6054$var$PreFunctionType = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $397ca82a6faac65f$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataTypeLabel, {
                dataType: "function"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "span",
                className: "data-function-start",
                sx: {
                    letterSpacing: 0.5
                },
                children: [
                    $1395207c3d9b6054$var$functionName(props.value),
                    ' ',
                    $1395207c3d9b6054$var$lb
                ]
            })
        ]
    });
};
const $1395207c3d9b6054$var$PostFunctionType = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $397ca82a6faac65f$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            component: "span",
            className: "data-function-end",
            children: $1395207c3d9b6054$var$rb
        })
    });
};
const $1395207c3d9b6054$var$FunctionType = (props)=>{
    const functionColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base05);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $397ca82a6faac65f$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            className: "data-function",
            sx: {
                display: props.inspect ? 'block' : 'inline-block',
                pl: props.inspect ? 2 : 0,
                color: functionColor
            },
            children: props.inspect ? $1395207c3d9b6054$var$functionBody(props.value) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "span",
                className: "data-function-body",
                onClick: ()=>props.setInspect(true),
                sx: {
                    '&:hover': {
                        cursor: 'pointer'
                    },
                    padding: 0.5
                },
                children: "\u2026"
            })
        })
    });
};
const $1395207c3d9b6054$export$6c6e04233ab45653 = {
    is: (value)=>typeof value === 'function',
    Component: $1395207c3d9b6054$var$FunctionType,
    PreComponent: $1395207c3d9b6054$var$PreFunctionType,
    PostComponent: $1395207c3d9b6054$var$PostFunctionType
};
const $1395207c3d9b6054$export$9d93593e0583cfae = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>value === null,
    type: 'null',
    colorKey: 'base08',
    displayTypeLabel: false,
    Renderer: ()=>{
        const backgroundColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base02);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                fontSize: '0.8rem',
                backgroundColor: backgroundColor,
                fontWeight: 'bold',
                borderRadius: '3px',
                padding: '0.5px 2px'
            },
            children: "NULL"
        });
    }
});
const $1395207c3d9b6054$var$isInt = (n)=>n % 1 === 0;
const $1395207c3d9b6054$export$dfdb91360884ac39 = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>typeof value === 'number' && isNaN(value),
    type: 'NaN',
    colorKey: 'base08',
    displayTypeLabel: false,
    serialize: ()=>'NaN',
    // allow deserialize the value back to number
    deserialize: (value)=>parseFloat(value),
    Renderer: ()=>{
        const backgroundColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base02);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                backgroundColor: backgroundColor,
                fontSize: '0.8rem',
                fontWeight: 'bold',
                borderRadius: '3px',
                padding: '0.5px 2px'
            },
            children: "NaN"
        });
    }
});
const $1395207c3d9b6054$export$f2075e4c4b847990 = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>typeof value === 'number' && !$1395207c3d9b6054$var$isInt(value) && !isNaN(value),
    type: 'float',
    colorKey: 'base0B',
    serialize: (value)=>value.toString(),
    deserialize: (value)=>parseFloat(value),
    Renderer: (param)=>{
        let { value: value } = param;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: value
        });
    }
});
const $1395207c3d9b6054$export$b6923345176fd0a7 = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>typeof value === 'number' && $1395207c3d9b6054$var$isInt(value),
    type: 'int',
    colorKey: 'base0F',
    serialize: (value)=>value.toString(),
    // allow deserialize the value to float
    deserialize: (value)=>parseFloat(value),
    Renderer: (param)=>{
        let { value: value } = param;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: value
        });
    }
});
const $1395207c3d9b6054$export$534fe34f8798b16b = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>typeof value === 'bigint',
    type: 'bigint',
    colorKey: 'base0F',
    serialize: (value)=>value.toString(),
    deserialize: (value)=>BigInt(value.replace(/\D/g, '')),
    Renderer: (param)=>{
        let { value: value } = param;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "".concat(value, "n")
        });
    }
});
const $1395207c3d9b6054$var$BaseIcon = (param)=>{
    let { d: d, ...props } = param;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: d
        })
    });
};
const $1395207c3d9b6054$var$AddBox = 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z';
const $1395207c3d9b6054$var$Check = 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z';
const $1395207c3d9b6054$var$ChevronRight = 'M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z';
const $1395207c3d9b6054$var$CircularArrows = 'M 12 2 C 10.615 1.998 9.214625 2.2867656 7.890625 2.8847656 L 8.9003906 4.6328125 C 9.9043906 4.2098125 10.957 3.998 12 4 C 15.080783 4 17.738521 5.7633175 19.074219 8.3222656 L 17.125 9 L 21.25 11 L 22.875 7 L 20.998047 7.6523438 C 19.377701 4.3110398 15.95585 2 12 2 z M 6.5097656 4.4882812 L 2.2324219 5.0820312 L 3.734375 6.3808594 C 1.6515335 9.4550558 1.3615962 13.574578 3.3398438 17 C 4.0308437 18.201 4.9801562 19.268234 6.1601562 20.115234 L 7.1699219 18.367188 C 6.3019219 17.710187 5.5922656 16.904 5.0722656 16 C 3.5320014 13.332354 3.729203 10.148679 5.2773438 7.7128906 L 6.8398438 9.0625 L 6.5097656 4.4882812 z M 19.929688 13 C 19.794687 14.08 19.450734 15.098 18.927734 16 C 17.386985 18.668487 14.531361 20.090637 11.646484 19.966797 L 12.035156 17.9375 L 8.2402344 20.511719 L 10.892578 23.917969 L 11.265625 21.966797 C 14.968963 22.233766 18.681899 20.426323 20.660156 17 C 21.355156 15.801 21.805219 14.445 21.949219 13 L 19.929688 13 z';
const $1395207c3d9b6054$var$Close = 'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z';
const $1395207c3d9b6054$var$ContentCopy = 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z';
const $1395207c3d9b6054$var$Edit = 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z';
const $1395207c3d9b6054$var$ExpandMore = 'M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z';
const $1395207c3d9b6054$var$Delete = 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5l-1-1h-5l-1 1H5v2h14V4z';
const $1395207c3d9b6054$var$AddBoxIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$AddBox,
        ...props
    });
};
const $1395207c3d9b6054$var$CheckIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$Check,
        ...props
    });
};
const $1395207c3d9b6054$var$ChevronRightIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$ChevronRight,
        ...props
    });
};
const $1395207c3d9b6054$var$CircularArrowsIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$CircularArrows,
        ...props
    });
};
const $1395207c3d9b6054$var$CloseIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$Close,
        ...props
    });
};
const $1395207c3d9b6054$var$ContentCopyIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$ContentCopy,
        ...props
    });
};
const $1395207c3d9b6054$var$EditIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$Edit,
        ...props
    });
};
const $1395207c3d9b6054$var$ExpandMoreIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$ExpandMore,
        ...props
    });
};
const $1395207c3d9b6054$var$DeleteIcon = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$BaseIcon, {
        d: $1395207c3d9b6054$var$Delete,
        ...props
    });
};
const $1395207c3d9b6054$var$objectLb = '{';
const $1395207c3d9b6054$var$arrayLb = '[';
const $1395207c3d9b6054$var$objectRb = '}';
const $1395207c3d9b6054$var$arrayRb = ']';
function $1395207c3d9b6054$var$inspectMetadata(value) {
    const length = $1395207c3d9b6054$var$getValueSize(value);
    let name = '';
    if (value instanceof Map || value instanceof Set) name = value[Symbol.toStringTag];
    if (Object.prototype.hasOwnProperty.call(value, Symbol.toStringTag)) name = value[Symbol.toStringTag];
    return "".concat(length, " Items").concat(name ? " (".concat(name, ")") : '');
}
const $1395207c3d9b6054$var$PreObjectType = (props)=>{
    const metadataColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base04);
    const textColor = $1395207c3d9b6054$var$useTextColor();
    const isArrayLike = (0, $acw62.useMemo)(()=>Array.isArray(props.value) || props.value instanceof Set, [
        props.value
    ]);
    const isEmptyValue = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$getValueSize(props.value) === 0, [
        props.value
    ]);
    const sizeOfValue = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$inspectMetadata(props.value), [
        props.value
    ]);
    const displaySize = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.displaySize);
    const shouldDisplaySize = (0, $acw62.useMemo)(()=>typeof displaySize === 'function' ? displaySize(props.path, props.value) : displaySize, [
        displaySize,
        props.path,
        props.value
    ]);
    const isTrap = $1395207c3d9b6054$var$useIsCycleReference(props.path, props.value);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        component: "span",
        className: "data-object-start",
        sx: {
            letterSpacing: 0.5
        },
        children: [
            isArrayLike ? $1395207c3d9b6054$var$arrayLb : $1395207c3d9b6054$var$objectLb,
            shouldDisplaySize && props.inspect && !isEmptyValue && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "span",
                sx: {
                    pl: 0.5,
                    fontStyle: 'italic',
                    color: metadataColor,
                    userSelect: 'none'
                },
                children: sizeOfValue
            }),
            isTrap && !props.inspect && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$CircularArrowsIcon, {
                        sx: {
                            fontSize: 12,
                            color: textColor,
                            mx: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataBox, {
                        sx: {
                            cursor: 'pointer',
                            userSelect: 'none'
                        },
                        children: isTrap
                    })
                ]
            })
        ]
    });
};
const $1395207c3d9b6054$var$PostObjectType = (props)=>{
    const metadataColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base04);
    const textColor = $1395207c3d9b6054$var$useTextColor();
    const isArrayLike = (0, $acw62.useMemo)(()=>Array.isArray(props.value) || props.value instanceof Set, [
        props.value
    ]);
    const isEmptyValue = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$getValueSize(props.value) === 0, [
        props.value
    ]);
    const sizeOfValue = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$inspectMetadata(props.value), [
        props.value
    ]);
    const displaySize = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.displaySize);
    const shouldDisplaySize = (0, $acw62.useMemo)(()=>typeof displaySize === 'function' ? displaySize(props.path, props.value) : displaySize, [
        displaySize,
        props.path,
        props.value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        component: "span",
        className: "data-object-end",
        sx: {
            lineHeight: 1.5,
            color: textColor,
            letterSpacing: 0.5,
            opacity: 0.8
        },
        children: [
            isArrayLike ? $1395207c3d9b6054$var$arrayRb : $1395207c3d9b6054$var$objectRb,
            shouldDisplaySize && (isEmptyValue || !props.inspect) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "span",
                sx: {
                    pl: 0.5,
                    fontStyle: 'italic',
                    color: metadataColor,
                    userSelect: 'none'
                },
                children: sizeOfValue
            }) : null
        ]
    });
};
function $1395207c3d9b6054$var$getIterator(value) {
    return typeof (value === null || value === void 0 ? void 0 : value[Symbol.iterator]) === 'function';
}
const $1395207c3d9b6054$var$ObjectType = (props)=>{
    const keyColor = $1395207c3d9b6054$var$useTextColor();
    const borderColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base02);
    const groupArraysAfterLength = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.groupArraysAfterLength);
    const isTrap = $1395207c3d9b6054$var$useIsCycleReference(props.path, props.value);
    const [displayLength, setDisplayLength] = (0, $acw62.useState)($1395207c3d9b6054$var$useJsonViewerStore((store)=>store.maxDisplayLength));
    const objectSortKeys = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.objectSortKeys);
    const elements = (0, $acw62.useMemo)(()=>{
        if (!props.inspect) return null;
        const value = props.value;
        const iterator = $1395207c3d9b6054$var$getIterator(value);
        // Array also has iterator, we skip it and treat it as an array as normal.
        if (iterator && !Array.isArray(value)) {
            const elements = [];
            if (value instanceof Map) {
                const lastIndex = value.size - 1;
                let index = 0;
                value.forEach((value, k)=>{
                    // fixme: key might be a object, array, or any value for the `Map<any, any>`
                    const key = k.toString();
                    const path = [
                        ...props.path,
                        key
                    ];
                    elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataKeyPair, {
                        path: path,
                        value: value,
                        prevValue: props.prevValue instanceof Map ? props.prevValue.get(k) : undefined,
                        editable: false,
                        last: index === lastIndex
                    }, key));
                    index++;
                });
            } else {
                // iterate with iterator func
                const iterator = value[Symbol.iterator]();
                let result = iterator.next();
                let count = 0;
                while(true){
                    const nextResult = iterator.next();
                    var _nextResult_done;
                    elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataKeyPair, {
                        path: [
                            ...props.path,
                            "iterator:".concat(count)
                        ],
                        value: result.value,
                        nestedIndex: count,
                        editable: false,
                        last: (_nextResult_done = nextResult.done) !== null && _nextResult_done !== void 0 ? _nextResult_done : false
                    }, count));
                    if (nextResult.done) break;
                    count++;
                    result = nextResult;
                }
            }
            return elements;
        }
        if (Array.isArray(value)) {
            const lastIndex = value.length - 1;
            // unknown[]
            if (value.length <= groupArraysAfterLength) {
                const elements = value.slice(0, displayLength).map((value, _index)=>{
                    const index = props.nestedIndex ? props.nestedIndex * groupArraysAfterLength + _index : _index;
                    const path = [
                        ...props.path,
                        index
                    ];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataKeyPair, {
                        path: path,
                        value: value,
                        prevValue: Array.isArray(props.prevValue) ? props.prevValue[index] : undefined,
                        last: _index === lastIndex
                    }, index);
                });
                if (value.length > displayLength) {
                    const rest = value.length - displayLength;
                    elements.push(/*#__PURE__*/ (0, $ayMG0.jsxs)($1395207c3d9b6054$var$DataBox, {
                        sx: {
                            cursor: 'pointer',
                            lineHeight: 1.5,
                            color: keyColor,
                            letterSpacing: 0.5,
                            opacity: 0.8,
                            userSelect: 'none'
                        },
                        onClick: ()=>setDisplayLength((length)=>length * 2),
                        children: [
                            "hidden ",
                            rest,
                            " items\u2026"
                        ]
                    }, "last"));
                }
                return elements;
            }
            const elements = $1395207c3d9b6054$var$segmentArray(value, groupArraysAfterLength);
            const prevElements = Array.isArray(props.prevValue) ? $1395207c3d9b6054$var$segmentArray(props.prevValue, groupArraysAfterLength) : undefined;
            const elementsLastIndex = elements.length - 1;
            return elements.map((list, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataKeyPair, {
                    path: props.path,
                    value: list,
                    nestedIndex: index,
                    prevValue: prevElements === null || prevElements === void 0 ? void 0 : prevElements[index],
                    last: index === elementsLastIndex
                }, index);
            });
        }
        // object
        let entries = Object.entries(value);
        if (objectSortKeys) entries = objectSortKeys === true ? entries.sort((param, param1)=>{
            let [a] = param, [b] = param1;
            return a.localeCompare(b);
        }) : entries.sort((param, param1)=>{
            let [a] = param, [b] = param1;
            return objectSortKeys(a, b);
        });
        const lastIndex = entries.length - 1;
        const elements = entries.slice(0, displayLength).map((param, index)=>{
            let [key, value] = param;
            var _props_prevValue;
            const path = [
                ...props.path,
                key
            ];
            return /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataKeyPair, {
                path: path,
                value: value,
                prevValue: (_props_prevValue = props.prevValue) === null || _props_prevValue === void 0 ? void 0 : _props_prevValue[key],
                last: index === lastIndex
            }, key);
        });
        if (entries.length > displayLength) {
            const rest = entries.length - displayLength;
            elements.push(/*#__PURE__*/ (0, $ayMG0.jsxs)($1395207c3d9b6054$var$DataBox, {
                sx: {
                    cursor: 'pointer',
                    lineHeight: 1.5,
                    color: keyColor,
                    letterSpacing: 0.5,
                    opacity: 0.8,
                    userSelect: 'none'
                },
                onClick: ()=>setDisplayLength((length)=>length * 2),
                children: [
                    "hidden ",
                    rest,
                    " items\u2026"
                ]
            }, "last"));
        }
        return elements;
    }, [
        props.inspect,
        props.value,
        props.prevValue,
        props.path,
        props.nestedIndex,
        groupArraysAfterLength,
        displayLength,
        keyColor,
        objectSortKeys
    ]);
    const marginLeft = props.inspect ? 0.6 : 0;
    const width = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.indentWidth);
    const indentWidth = props.inspect ? width - marginLeft : width;
    const isEmptyValue = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$getValueSize(props.value) === 0, [
        props.value
    ]);
    if (isEmptyValue) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "data-object",
        sx: {
            display: props.inspect ? 'block' : 'inline-block',
            pl: props.inspect ? indentWidth - 0.6 : 0,
            marginLeft: marginLeft,
            color: keyColor,
            borderLeft: props.inspect ? "1px solid ".concat(borderColor) : 'none'
        },
        children: props.inspect ? elements : !isTrap && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            component: "span",
            className: "data-object-body",
            onClick: ()=>props.setInspect(true),
            sx: {
                '&:hover': {
                    cursor: 'pointer'
                },
                padding: 0.5,
                userSelect: 'none'
            },
            children: "\u2026"
        })
    });
};
const $1395207c3d9b6054$export$2f7db372abe0e94d = {
    is: (value)=>typeof value === 'object',
    Component: $1395207c3d9b6054$var$ObjectType,
    PreComponent: $1395207c3d9b6054$var$PreObjectType,
    PostComponent: $1395207c3d9b6054$var$PostObjectType
};
const $1395207c3d9b6054$export$8c3f122088835d43 = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>typeof value === 'string',
    type: 'string',
    colorKey: 'base09',
    serialize: (value)=>value,
    deserialize: (value)=>value,
    Renderer: (props)=>{
        const [showRest, setShowRest] = (0, $acw62.useState)(false);
        const collapseStringsAfterLength = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.collapseStringsAfterLength);
        const value = showRest ? props.value : props.value.slice(0, collapseStringsAfterLength);
        const hasRest = props.value.length > collapseStringsAfterLength;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            component: "span",
            sx: {
                overflowWrap: 'anywhere',
                cursor: hasRest ? 'pointer' : 'inherit'
            },
            onClick: ()=>{
                var _window_getSelection;
                if (((_window_getSelection = window.getSelection()) === null || _window_getSelection === void 0 ? void 0 : _window_getSelection.type) === 'Range') return;
                if (hasRest) setShowRest((value)=>!value);
            },
            children: [
                '"',
                value,
                hasRest && !showRest && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    component: "span",
                    sx: {
                        padding: 0.5
                    },
                    children: "\u2026"
                }),
                '"'
            ]
        });
    }
});
const $1395207c3d9b6054$export$2e1fed12b16a49cb = $1395207c3d9b6054$export$e7bd156af3e9ba({
    is: (value)=>value === undefined,
    type: 'undefined',
    colorKey: 'base05',
    displayTypeLabel: false,
    Renderer: ()=>{
        const backgroundColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base02);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                fontSize: '0.7rem',
                backgroundColor: backgroundColor,
                borderRadius: '3px',
                padding: '0.5px 2px'
            },
            children: "undefined"
        });
    }
});
function $1395207c3d9b6054$var$memorizeDataType(dataType) {
    function compare(prevProps, nextProps) {
        var _prevProps_path, _nextProps_path;
        return Object.is(prevProps.value, nextProps.value) && prevProps.inspect && nextProps.inspect && ((_prevProps_path = prevProps.path) === null || _prevProps_path === void 0 ? void 0 : _prevProps_path.join('.')) === ((_nextProps_path = nextProps.path) === null || _nextProps_path === void 0 ? void 0 : _nextProps_path.join('.'));
    }
    dataType.Component = /*#__PURE__*/ (0, $acw62.memo)(dataType.Component, compare);
    if (dataType.Editor) dataType.Editor = /*#__PURE__*/ (0, $acw62.memo)(dataType.Editor, function compare(prevProps, nextProps) {
        return Object.is(prevProps.value, nextProps.value);
    });
    if (dataType.PreComponent) dataType.PreComponent = /*#__PURE__*/ (0, $acw62.memo)(dataType.PreComponent, compare);
    if (dataType.PostComponent) dataType.PostComponent = /*#__PURE__*/ (0, $acw62.memo)(dataType.PostComponent, compare);
    return dataType;
}
const $1395207c3d9b6054$var$predefinedTypes = [
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$1d5983b8af74aede),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$da791619211328be),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$9d93593e0583cfae),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$2e1fed12b16a49cb),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$8c3f122088835d43),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$6c6e04233ab45653),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$dfdb91360884ac39),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$b6923345176fd0a7),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$f2075e4c4b847990),
    $1395207c3d9b6054$var$memorizeDataType($1395207c3d9b6054$export$534fe34f8798b16b)
];
const $1395207c3d9b6054$var$createTypeRegistryStore = ()=>{
    return (0, $af9e91ea6e32034a$exports.createStore)()((set)=>({
            registry: $1395207c3d9b6054$var$predefinedTypes,
            registerTypes: (setState)=>{
                set((state)=>({
                        registry: typeof setState === 'function' ? setState(state.registry) : setState
                    }));
            }
        }));
};
// @ts-expect-error we intentionally want to pass undefined to the context
// See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
const $1395207c3d9b6054$var$TypeRegistryStoreContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
$1395207c3d9b6054$var$TypeRegistryStoreContext.Provider;
const $1395207c3d9b6054$var$useTypeRegistryStore = (selector, equalityFn)=>{
    const store = (0, $acw62.useContext)($1395207c3d9b6054$var$TypeRegistryStoreContext);
    return (0, $af9e91ea6e32034a$exports.useStore)(store, selector, equalityFn);
};
function $1395207c3d9b6054$var$matchTypeComponents(value, path, registry) {
    let potential;
    for (const T of registry)if (T.is(value, path)) potential = T;
    if (potential === undefined) {
        if (typeof value === 'object') return $1395207c3d9b6054$export$2f7db372abe0e94d;
        throw new Error("No type matched for value: ".concat(value));
    }
    return potential;
}
function $1395207c3d9b6054$var$useTypeComponents(value, path) {
    const registry = $1395207c3d9b6054$var$useTypeRegistryStore((store)=>store.registry);
    return (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$matchTypeComponents(value, path, registry), [
        value,
        path,
        registry
    ]);
}
const $1395207c3d9b6054$var$IconBox = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        component: "span",
        ...props,
        sx: {
            cursor: 'pointer',
            paddingLeft: '0.7rem',
            ...props.sx
        }
    });
const $1395207c3d9b6054$var$DataKeyPair = (props)=>{
    const { value: value, prevValue: prevValue, path: path, nestedIndex: nestedIndex, last: last } = props;
    const { Component: Component, PreComponent: PreComponent, PostComponent: PostComponent, Editor: Editor, serialize: serialize, deserialize: deserialize } = $1395207c3d9b6054$var$useTypeComponents(value, path);
    var _props_editable;
    const propsEditable = (_props_editable = props.editable) !== null && _props_editable !== void 0 ? _props_editable : undefined;
    const storeEditable = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.editable);
    const editable = (0, $acw62.useMemo)(()=>{
        if (storeEditable === false) return false;
        if (propsEditable === false) // props.editable is false which means we cannot provide the suitable way to edit it
        return false;
        if (typeof storeEditable === 'function') return !!storeEditable(path, value);
        return storeEditable;
    }, [
        path,
        propsEditable,
        storeEditable,
        value
    ]);
    const [tempValue, setTempValue] = (0, $acw62.useState)('');
    const depth = path.length;
    const key = path[depth - 1];
    const hoverPath = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.hoverPath);
    const isHover = (0, $acw62.useMemo)(()=>{
        return hoverPath && path.every((value, index)=>value === hoverPath.path[index] && nestedIndex === hoverPath.nestedIndex);
    }, [
        hoverPath,
        path,
        nestedIndex
    ]);
    const setHover = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.setHover);
    const root = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.value);
    const [inspect, setInspect] = $1395207c3d9b6054$var$useInspect(path, value, nestedIndex);
    const [editing, setEditing] = (0, $acw62.useState)(false);
    const onChange = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.onChange);
    const keyColor = $1395207c3d9b6054$var$useTextColor();
    const numberKeyColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base0C);
    const highlightColor = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.colorspace.base0A);
    const displayComma = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.displayComma);
    const quotesOnKeys = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.quotesOnKeys);
    const rootName = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.rootName);
    const isRoot = root === value;
    const isNumberKey = Number.isInteger(Number(key));
    const storeEnableAdd = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.enableAdd);
    const onAdd = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.onAdd);
    const enableAdd = (0, $acw62.useMemo)(()=>{
        if (!onAdd || nestedIndex !== undefined) return false;
        if (storeEnableAdd === false) return false;
        if (propsEditable === false) // props.editable is false which means we cannot provide the suitable way to edit it
        return false;
        if (typeof storeEnableAdd === 'function') return !!storeEnableAdd(path, value);
        if (Array.isArray(value) || $1395207c3d9b6054$var$isPlainObject(value)) return true;
        return false;
    }, [
        onAdd,
        nestedIndex,
        path,
        storeEnableAdd,
        propsEditable,
        value
    ]);
    const storeEnableDelete = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.enableDelete);
    const onDelete = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.onDelete);
    const enableDelete = (0, $acw62.useMemo)(()=>{
        if (!onDelete || nestedIndex !== undefined) return false;
        if (isRoot) // don't allow delete root
        return false;
        if (storeEnableDelete === false) return false;
        if (propsEditable === false) // props.editable is false which means we cannot provide the suitable way to edit it
        return false;
        if (typeof storeEnableDelete === 'function') return !!storeEnableDelete(path, value);
        return storeEnableDelete;
    }, [
        onDelete,
        nestedIndex,
        isRoot,
        path,
        storeEnableDelete,
        propsEditable,
        value
    ]);
    const enableClipboard = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.enableClipboard);
    const { copy: copy, copied: copied } = $1395207c3d9b6054$var$useClipboard();
    const highlightUpdates = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.highlightUpdates);
    const isHighlight = (0, $acw62.useMemo)(()=>{
        if (!highlightUpdates || prevValue === undefined) return false;
        // highlight if value type changed
        if (typeof value !== typeof prevValue) return true;
        if (typeof value === 'number') {
            // notice: NaN !== NaN
            if (isNaN(value) && isNaN(prevValue)) return false;
            return value !== prevValue;
        }
        // highlight if isArray changed
        if (Array.isArray(value) !== Array.isArray(prevValue)) return true;
        // not highlight object/function
        // deep compare they will be slow
        if (typeof value === 'object' || typeof value === 'function') return false;
        // highlight if not equal
        if (value !== prevValue) return true;
        return false;
    }, [
        highlightUpdates,
        prevValue,
        value
    ]);
    const highlightContainer = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        if (highlightContainer.current && isHighlight && 'animate' in highlightContainer.current) highlightContainer.current.animate([
            {
                backgroundColor: highlightColor
            },
            {
                backgroundColor: ''
            }
        ], {
            duration: 1000,
            easing: 'ease-in'
        });
    }, [
        highlightColor,
        isHighlight,
        prevValue,
        value
    ]);
    const startEditing = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        if (serialize) setTempValue(serialize(value));
        setEditing(true);
    }, [
        serialize,
        value
    ]);
    const abortEditing = (0, $acw62.useCallback)(()=>{
        setEditing(false);
        setTempValue('');
    }, [
        setEditing,
        setTempValue
    ]);
    const commitEditing = (0, $acw62.useCallback)((newValue)=>{
        setEditing(false);
        if (!deserialize) return;
        try {
            onChange(path, value, deserialize(newValue));
        } catch (e) {
        // do nothing when deserialize failed
        }
    }, [
        setEditing,
        deserialize,
        onChange,
        path,
        value
    ]);
    const actionIcons = (0, $acw62.useMemo)(()=>{
        if (editing) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$IconBox, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$CloseIcon, {
                        sx: {
                            fontSize: '.8rem'
                        },
                        onClick: abortEditing
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$IconBox, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$CheckIcon, {
                        sx: {
                            fontSize: '.8rem'
                        },
                        onClick: ()=>commitEditing(tempValue)
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                enableClipboard && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$IconBox, {
                    onClick: (event)=>{
                        event.preventDefault();
                        try {
                            copy(path, value, $1395207c3d9b6054$var$copyString);
                        } catch (e) {
                            // in some case, this will throw error
                            // fixme: `useAlert` hook
                            console.error(e);
                        }
                    },
                    children: copied ? /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$CheckIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$ContentCopyIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    })
                }),
                Editor && editable && serialize && deserialize && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$IconBox, {
                    onClick: startEditing,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$EditIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    })
                }),
                enableAdd && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$IconBox, {
                    onClick: (event)=>{
                        event.preventDefault();
                        onAdd === null || onAdd === void 0 || onAdd(path);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$AddBoxIcon, {
                        sx: {
                            fontSize: '.8rem'
                        }
                    })
                }),
                enableDelete && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$IconBox, {
                    onClick: (event)=>{
                        event.preventDefault();
                        onDelete === null || onDelete === void 0 || onDelete(path, value);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DeleteIcon, {
                        sx: {
                            fontSize: '.9rem'
                        }
                    })
                })
            ]
        });
    }, [
        Editor,
        serialize,
        deserialize,
        copied,
        copy,
        editable,
        editing,
        enableClipboard,
        enableAdd,
        enableDelete,
        tempValue,
        path,
        value,
        onAdd,
        onDelete,
        startEditing,
        abortEditing,
        commitEditing
    ]);
    const isEmptyValue = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$getValueSize(value) === 0, [
        value
    ]);
    const expandable = !isEmptyValue && !!(PreComponent && PostComponent);
    const KeyRenderer = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.keyRenderer);
    const downstreamProps = (0, $acw62.useMemo)(()=>({
            path: path,
            inspect: inspect,
            setInspect: setInspect,
            value: value,
            prevValue: prevValue,
            nestedIndex: nestedIndex
        }), [
        inspect,
        path,
        setInspect,
        value,
        prevValue,
        nestedIndex
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "data-key-pair",
        "data-testid": 'data-key-pair' + path.join('.'),
        sx: {
            userSelect: 'text'
        },
        onMouseEnter: (0, $acw62.useCallback)(()=>setHover(path, nestedIndex), [
            setHover,
            path,
            nestedIndex
        ]),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($1395207c3d9b6054$var$DataBox, {
                component: "span",
                className: "data-key",
                sx: {
                    lineHeight: 1.5,
                    color: keyColor,
                    letterSpacing: 0.5,
                    opacity: 0.8
                },
                onClick: (0, $acw62.useCallback)((event)=>{
                    if (event.isDefaultPrevented()) return;
                    if (!isEmptyValue) setInspect((state)=>!state);
                }, [
                    isEmptyValue,
                    setInspect
                ]),
                children: [
                    expandable ? inspect ? /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$ExpandMoreIcon, {
                        className: "data-key-toggle-expanded",
                        sx: {
                            fontSize: '.8rem',
                            '&:hover': {
                                cursor: 'pointer'
                            }
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$ChevronRightIcon, {
                        className: "data-key-toggle-collapsed",
                        sx: {
                            fontSize: '.8rem',
                            '&:hover': {
                                cursor: 'pointer'
                            }
                        }
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        ref: highlightContainer,
                        className: "data-key-key",
                        component: "span",
                        children: isRoot && depth === 0 ? rootName !== false ? quotesOnKeys ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                '"',
                                rootName,
                                '"'
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: rootName
                        }) : null : KeyRenderer.when(downstreamProps) ? /*#__PURE__*/ (0, $ayMG0.jsx)(KeyRenderer, {
                            ...downstreamProps
                        }) : nestedIndex === undefined && (isNumberKey ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            component: "span",
                            style: {
                                color: numberKeyColor,
                                userSelect: isNumberKey ? 'none' : 'auto'
                            },
                            children: key
                        }) : quotesOnKeys ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                '"',
                                key,
                                '"'
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: key
                        }))
                    }),
                    isRoot ? rootName !== false && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataBox, {
                        className: "data-key-colon",
                        sx: {
                            mr: 0.5
                        },
                        children: ":"
                    }) : nestedIndex === undefined && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataBox, {
                        className: "data-key-colon",
                        sx: {
                            mr: 0.5,
                            '.data-key-key:empty + &': {
                                display: 'none'
                            },
                            userSelect: isNumberKey ? 'none' : 'auto'
                        },
                        children: ":"
                    }),
                    PreComponent && /*#__PURE__*/ (0, $ayMG0.jsx)(PreComponent, {
                        ...downstreamProps
                    }),
                    isHover && expandable && inspect && actionIcons
                ]
            }),
            editing && editable ? Editor && /*#__PURE__*/ (0, $ayMG0.jsx)(Editor, {
                path: path,
                value: tempValue,
                setValue: setTempValue,
                abortEditing: abortEditing,
                commitEditing: commitEditing
            }) : Component ? /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                ...downstreamProps
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "span",
                className: "data-value-fallback",
                children: "fallback: ".concat(value)
            }),
            PostComponent && /*#__PURE__*/ (0, $ayMG0.jsx)(PostComponent, {
                ...downstreamProps
            }),
            !last && displayComma && /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataBox, {
                children: ","
            }),
            isHover && expandable && !inspect && actionIcons,
            isHover && !expandable && actionIcons,
            !isHover && editing && actionIcons
        ]
    });
};
const $1395207c3d9b6054$var$query = '(prefers-color-scheme: dark)';
function $1395207c3d9b6054$var$useThemeDetector() {
    const [isDark, setIsDark] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const listener = (e)=>setIsDark(e.matches);
        setIsDark(window.matchMedia($1395207c3d9b6054$var$query).matches);
        const queryMedia = window.matchMedia($1395207c3d9b6054$var$query);
        queryMedia.addEventListener('change', listener);
        return ()=>queryMedia.removeEventListener('change', listener);
    }, []);
    return isDark;
}
/**
 * @internal
 */ function $1395207c3d9b6054$var$useSetIfNotUndefinedEffect(key, value) {
    const { setState: setState } = (0, $acw62.useContext)($1395207c3d9b6054$var$JsonViewerStoreContext);
    (0, $acw62.useEffect)(()=>{
        if (value !== undefined) setState({
            [key]: value
        });
    }, [
        key,
        value,
        setState
    ]);
}
/**
 * @internal
 */ const $1395207c3d9b6054$var$JsonViewerInner = (props)=>{
    const { setState: setState } = (0, $acw62.useContext)($1395207c3d9b6054$var$JsonViewerStoreContext);
    (0, $acw62.useEffect)(()=>{
        setState((state)=>({
                prevValue: state.value,
                value: props.value
            }));
    }, [
        props.value,
        setState
    ]);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('rootName', props.rootName);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('indentWidth', props.indentWidth);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('keyRenderer', props.keyRenderer);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('enableAdd', props.enableAdd);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('enableDelete', props.enableDelete);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('enableClipboard', props.enableClipboard);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('editable', props.editable);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('onChange', props.onChange);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('onCopy', props.onCopy);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('onSelect', props.onSelect);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('onAdd', props.onAdd);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('onDelete', props.onDelete);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('maxDisplayLength', props.maxDisplayLength);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('groupArraysAfterLength', props.groupArraysAfterLength);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('quotesOnKeys', props.quotesOnKeys);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('displayDataTypes', props.displayDataTypes);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('displaySize', props.displaySize);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('displayComma', props.displayComma);
    $1395207c3d9b6054$var$useSetIfNotUndefinedEffect('highlightUpdates', props.highlightUpdates);
    (0, $acw62.useEffect)(()=>{
        if (props.theme === 'light') setState({
            colorspace: $1395207c3d9b6054$export$1cc789a2b9985532
        });
        else if (props.theme === 'dark') setState({
            colorspace: $1395207c3d9b6054$export$f1b992648bf9516a
        });
        else if (typeof props.theme === 'object') setState({
            colorspace: props.theme
        });
    }, [
        setState,
        props.theme
    ]);
    const themeCls = (0, $acw62.useMemo)(()=>{
        if (typeof props.theme === 'object') return 'json-viewer-theme-custom';
        return props.theme === 'dark' ? 'json-viewer-theme-dark' : 'json-viewer-theme-light';
    }, [
        props.theme
    ]);
    const onceRef = (0, $acw62.useRef)(true);
    const registerTypes = $1395207c3d9b6054$var$useTypeRegistryStore((store)=>store.registerTypes);
    if (onceRef.current) {
        const allTypes = props.valueTypes ? [
            ...$1395207c3d9b6054$var$predefinedTypes,
            ...props.valueTypes
        ] : [
            ...$1395207c3d9b6054$var$predefinedTypes
        ];
        registerTypes(allTypes);
        onceRef.current = false;
    }
    (0, $acw62.useEffect)(()=>{
        const allTypes = props.valueTypes ? [
            ...$1395207c3d9b6054$var$predefinedTypes,
            ...props.valueTypes
        ] : [
            ...$1395207c3d9b6054$var$predefinedTypes
        ];
        registerTypes(allTypes);
    }, [
        props.valueTypes,
        registerTypes
    ]);
    const value = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.value);
    const prevValue = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.prevValue);
    const emptyPath = (0, $acw62.useMemo)(()=>[], []);
    const setHover = $1395207c3d9b6054$var$useJsonViewerStore((store)=>store.setHover);
    const onMouseLeave = (0, $acw62.useCallback)(()=>setHover(null), [
        setHover
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
        elevation: 0,
        className: $1395207c3d9b6054$var$clsx(themeCls, props.className),
        style: props.style,
        sx: {
            fontFamily: 'monospace',
            userSelect: 'none',
            contentVisibility: 'auto',
            ...props.sx
        },
        onMouseLeave: onMouseLeave,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$DataKeyPair, {
            value: value,
            prevValue: prevValue,
            path: emptyPath,
            last: true
        })
    });
};
const $1395207c3d9b6054$export$84c25b2945fb8676 = function JsonViewer(props) {
    const isAutoDarkTheme = $1395207c3d9b6054$var$useThemeDetector();
    const themeType = (0, $acw62.useMemo)(()=>{
        var _props_theme;
        return props.theme === 'auto' ? isAutoDarkTheme ? 'dark' : 'light' : (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : 'light';
    }, [
        isAutoDarkTheme,
        props.theme
    ]);
    const theme = (0, $acw62.useMemo)(()=>{
        const backgroundColor = typeof themeType === 'object' ? themeType.base00 : themeType === 'dark' ? $1395207c3d9b6054$export$f1b992648bf9516a.base00 : $1395207c3d9b6054$export$1cc789a2b9985532.base00;
        const foregroundColor = typeof themeType === 'object' ? themeType.base07 : themeType === 'dark' ? $1395207c3d9b6054$export$f1b992648bf9516a.base07 : $1395207c3d9b6054$export$1cc789a2b9985532.base07;
        return (0, $ijOKP.default)({
            components: {
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundColor: backgroundColor,
                            color: foregroundColor
                        }
                    }
                }
            },
            palette: {
                mode: themeType === 'dark' ? 'dark' : 'light',
                background: {
                    default: backgroundColor
                }
            }
        });
    }, [
        themeType
    ]);
    const mixedProps = {
        ...props,
        theme: themeType
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const jsonViewerStore = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$createJsonViewerStore(props), []);
    const typeRegistryStore = (0, $acw62.useMemo)(()=>$1395207c3d9b6054$var$createTypeRegistryStore(), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4650f6dac4940cb$export$2e2bcd8739ae039), {
        theme: theme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$TypeRegistryStoreContext.Provider, {
            value: typeRegistryStore,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$JsonViewerStoreContext.Provider, {
                value: jsonViewerStore,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($1395207c3d9b6054$var$JsonViewerInner, {
                    ...mixedProps
                })
            })
        })
    });
};




var $b85022af20cb34ec$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($b85022af20cb34ec$exports, "__esModule", {
    value: true
});
$b85022af20cb34ec$exports.default = void 0;

var $b85022af20cb34ec$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b85022af20cb34ec$var$_default = $b85022af20cb34ec$exports.default = (0, $b85022af20cb34ec$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2 4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25z"
}), 'ShieldOutlined');


var $9413ea81395edf96$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($9413ea81395edf96$exports, "__esModule", {
    value: true
});
$9413ea81395edf96$exports.default = void 0;

var $9413ea81395edf96$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9413ea81395edf96$var$_default = $9413ea81395edf96$exports.default = (0, $9413ea81395edf96$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2.73 21h18.53c.77 0 1.25-.83.87-1.5l-9.27-16c-.39-.67-1.35-.67-1.73 0l-9.27 16c-.38.67.1 1.5.87 1.5M13 18h-2v-2h2zm-1-4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1"
}), 'ReportProblemRounded');


function $8d3990aef34273b6$export$2e2bcd8739ae039({ open: open, selected: selected, onClose: onClose, url: url, isSafe: isSafe }) {
    const [showJson, setShowJson] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowJson(false);
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7e11211e1a6425c$export$2e2bcd8739ae039), {
        anchor: "right",
        open: !!open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            sx: {
                width: 520,
                p: 3
            },
            role: "presentation",
            children: selected ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                variant: "h5",
                                sx: {
                                    fontWeight: 700
                                },
                                children: selected.title || selected.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                "aria-label": "close",
                                onClick: onClose,
                                sx: {
                                    color: '#d1d3d5ff'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2,
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        color: "text.secondary",
                                        sx: {
                                            fontWeight: 500,
                                            fontSize: '1rem'
                                        },
                                        children: [
                                            "Severity: ",
                                            (0, $adc573943ea4ef85$export$903fb3386f46d61e)(selected.severity_level)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76f12636665395c9$export$155bcd12491a11ee), {
                                        severity: selected.severity_level
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    px: 1.2,
                                    py: 0.4,
                                    borderRadius: '10px',
                                    background: isSafe ? 'linear-gradient(90deg, #e8f5e9 60%, #b2dfdb 100%)' : 'linear-gradient(90deg, #ffebee 60%, #ffe082 100%)',
                                    color: isSafe ? '#2e7d32' : '#d32f2f',
                                    fontWeight: 600,
                                    fontSize: '0.8rem',
                                    gap: 0.5,
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                                    border: '1px solid rgba(46,125,50,0.15)'
                                },
                                children: [
                                    isSafe ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b85022af20cb34ec$exports))), {
                                        sx: {
                                            color: '#2e7d32',
                                            fontSize: 20,
                                            mr: 0.5
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9413ea81395edf96$exports))), {
                                        sx: {
                                            color: '#d32f2f',
                                            fontSize: 20,
                                            mr: 0.5
                                        }
                                    }),
                                    isSafe ? 'Safe' : 'Risk'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2,
                            position: 'relative'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                color: "text.secondary",
                                sx: {
                                    fontWeight: 500,
                                    fontSize: '1rem'
                                },
                                children: [
                                    "Possible Attack: ",
                                    selected.attack_type_title || 'N/A'
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: '#f7fafd',
                            p: 3,
                            mb: 3,
                            boxShadow: 1,
                            borderRadius: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                variant: "h6",
                                sx: {
                                    fontWeight: 600,
                                    mb: 2
                                },
                                children: "Assessment Performed"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle2",
                                                sx: {
                                                    fontWeight: 500
                                                },
                                                children: [
                                                    "Parameters Checked: ",
                                                    selected.param
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle2",
                                                sx: {
                                                    fontWeight: 500
                                                },
                                                children: "Check Performed"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                dangerouslySetInnerHTML: {
                                                    __html: selected.assessment_details
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: '#f7fafd',
                            p: 3,
                            mb: 3,
                            boxShadow: 1,
                            borderRadius: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                variant: "h6",
                                sx: {
                                    fontWeight: 600,
                                    mb: 2
                                },
                                children: "Assessment Outcome"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            sx: {
                                                fontWeight: 500,
                                                color: isSafe ? '#2e7d32' : '#d32f2f'
                                            },
                                            children: isSafe ? "Configuration is safe" : "Configuration is vulnerable for exploit"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle2",
                                                sx: {
                                                    fontWeight: 500
                                                },
                                                children: [
                                                    "Why is this considered ",
                                                    isSafe ? "safe" : "vulnerable",
                                                    "?"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                component: "span",
                                                dangerouslySetInnerHTML: {
                                                    __html: isSafe ? selected.safe_config_description : selected.vulnerability_description
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle2",
                                                sx: {
                                                    fontWeight: 500
                                                },
                                                children: "Risk of Exploit"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                children: selected.attack_description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle2",
                                                sx: {
                                                    fontWeight: 500
                                                },
                                                children: "Mitigation"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                children: selected.mitigation
                                            })
                                        ]
                                    }),
                                    !isSafe && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle2",
                                                sx: {
                                                    fontWeight: 500
                                                },
                                                children: "Threat Category"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    gap: 2,
                                                    mt: 1,
                                                    flexWrap: 'wrap'
                                                },
                                                children: (()=>{
                                                    const cweVal = selected.cwe;
                                                    if (!cweVal && selected.cwe_id == null) return null;
                                                    const rawItems = cweVal ?? (selected.cwe_id ? [
                                                        selected.cwe_id
                                                    ] : []);
                                                    const items = Array.isArray(rawItems) ? rawItems : [
                                                        rawItems
                                                    ];
                                                    return items.map((it, idx)=>{
                                                        let label = String(it);
                                                        let num = null;
                                                        if (typeof it === 'number' || /[0-9]+$/.test(String(it))) {
                                                            num = String(it).match(/(\d+)/)[0];
                                                            label = `CWE-${num}`;
                                                        } else if (typeof it === 'object' && it !== null) {
                                                            if (it.id || it.cwe) {
                                                                num = String(it.id || it.cwe);
                                                                label = it.name ? `CWE-${num}: ${it.name}` : `CWE-${num}`;
                                                            } else label = JSON.stringify(it);
                                                        } else {
                                                            const m = String(it).match(/CWE-(\d+)/i);
                                                            if (m) num = m[1];
                                                        }
                                                        const href = num ? `https://cwe.mitre.org/data/definitions/${num}.html` : null;
                                                        return href ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                                            component: "a",
                                                            href: href,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            sx: {
                                                                p: 2,
                                                                bgcolor: '#ffffff',
                                                                borderRadius: 2,
                                                                minWidth: 220,
                                                                textDecoration: 'none',
                                                                color: 'inherit',
                                                                cursor: 'pointer',
                                                                '&:hover': {
                                                                    textDecoration: 'none'
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontWeight: 600,
                                                                        fontSize: '1.10rem',
                                                                        mb: 2.5
                                                                    },
                                                                    children: "CWE"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        mt: 1
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            fontSize: '1rem'
                                                                        },
                                                                        children: label
                                                                    })
                                                                })
                                                            ]
                                                        }, idx) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                p: 2,
                                                                bgcolor: '#ffffff',
                                                                borderRadius: 2,
                                                                minWidth: 220
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontWeight: 600,
                                                                        fontSize: '1.25rem'
                                                                    },
                                                                    children: "CWE"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        mt: 1
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            fontSize: '1rem'
                                                                        },
                                                                        children: label
                                                                    })
                                                                })
                                                            ]
                                                        }, idx);
                                                    });
                                                })()
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: '#f7fafd',
                            p: 3,
                            boxShadow: 0,
                            borderRadius: 3,
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                bdsType: "interactiveSubtle",
                                sx: {
                                    mb: 2,
                                    textTransform: 'none',
                                    fontSize: '0.95em',
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    zIndex: 2
                                },
                                onClick: ()=>setShowJson((prev)=>!prev),
                                children: showJson ? 'Show less' : 'Show more'
                            }),
                            showJson && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                sx: {
                                    mt: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        variant: "subtitle2",
                                        children: "Technical Details"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            gap: 2,
                                            mt: 4,
                                            flexWrap: 'wrap'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                            sx: {
                                                bgcolor: '#ffffff',
                                                p: 1,
                                                boxShadow: 'none',
                                                border: 'none'
                                            },
                                            children: selected.details ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1395207c3d9b6054$export$84c25b2945fb8676), {
                                                value: selected.details
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                color: "text.secondary",
                                                children: "No details available."
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "subtitle2",
                                                sx: {
                                                    fontWeight: 500
                                                },
                                                children: "Scan Details"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                children: selected.description
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        })
    });
}







function $437d13139f214e20$export$2e2bcd8739ae039({ state: state, vulnerabilities: vulnerabilities, url: url, title: title, subtitle: subtitle, isSafe: isSafe, complianceFilter: complianceFilter, setComplianceFilter: setComplianceFilter }) {
    // -------------------------
    //  APPLY FILTER
    // -------------------------
    let filteredVulnerabilities = vulnerabilities;
    if (complianceFilter) {
        const rawIds = complianceFilter.ids;
        // Normalize invalid ids → [] always
        const ids = Array.isArray(rawIds) ? rawIds.filter((id)=>typeof id === "string" && id.trim() !== "") : [];
        // If no valid ids → show nothing
        if (ids.length === 0) filteredVulnerabilities = [];
        else filteredVulnerabilities = vulnerabilities.filter((v)=>ids.includes(v.name));
    }
    // -------------------------
    //  PAGINATION SETUP
    // -------------------------
    const [drawerOpen, setDrawerOpen] = (0, $acw62.useState)(false);
    const [selected, setSelected] = (0, $acw62.useState)(null);
    const [page, setPage] = (0, $acw62.useState)(1);
    (0, $acw62.useEffect)(()=>{
        setPage(1); // reset page on filter change
    }, [
        complianceFilter
    ]);
    // -------------------------
    // Pagination calculations
    // -------------------------
    const totalCount = filteredVulnerabilities.length;
    const backendPageSize = Number(state?.scanResult?.data?.page_size ?? state?.scanResult?.data?.per_page ?? state?.scanResult?.data?.pageSize ?? 10);
    const itemsPerPage = Number.isFinite(backendPageSize) && backendPageSize > 0 ? backendPageSize : 10;
    const totalPages = Math.max(1, Math.ceil(totalCount / itemsPerPage));
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalCount);
    const pageItems = filteredVulnerabilities.slice(startIndex, endIndex);
    function goto(pageNum) {
        const p = Math.max(1, Math.min(totalPages, pageNum));
        setPage(p);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    // -------------------------
    // UI RENDER
    // -------------------------
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                gutterBottom: true,
                children: [
                    title,
                    " (",
                    totalCount,
                    ")"
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                        variant: "promoCaptionSubtle",
                        children: subtitle
                    }),
                    complianceFilter && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            background: "#1976d2",
                            // BLUE
                            color: "white",
                            // WHITE TEXT
                            borderRadius: "16px",
                            padding: "4px 10px",
                            fontSize: "12px",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            width: "fit-content"
                        },
                        children: [
                            complianceFilter.type.toUpperCase(),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                    fontWeight: 900
                                },
                                onClick: ()=>setComplianceFilter(null),
                                children: "\u2715"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    mt: 2
                },
                children: pageItems.map((v, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            container: true,
                            alignItems: "center",
                            sx: {
                                boxShadow: 0,
                                borderRadius: 2,
                                mb: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 7,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            px: 1,
                                            py: 0.5,
                                            borderRadius: 2,
                                            gap: 1,
                                            color: isSafe ? '#2e7d32' : '#d32f2f',
                                            fontWeight: 700
                                        },
                                        children: [
                                            isSafe ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    px: 1.2,
                                                    py: 0.4,
                                                    borderRadius: '10px',
                                                    background: 'linear-gradient(180deg, #e8f5e9, #d7efe0)',
                                                    color: '#2e7d32',
                                                    fontWeight: 600,
                                                    gap: 0.5,
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b85022af20cb34ec$exports))), {
                                                        sx: {
                                                            fontSize: 14
                                                        }
                                                    }),
                                                    "Safe"
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    px: 1.2,
                                                    py: 0.4,
                                                    borderRadius: '10px',
                                                    background: 'linear-gradient(90deg, #ffebee 60%)',
                                                    color: '#d32f2f',
                                                    fontWeight: 600,
                                                    gap: 0.5,
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9413ea81395edf96$exports))), {
                                                        sx: {
                                                            fontSize: 18
                                                        }
                                                    }),
                                                    "Risk"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                sx: {
                                                    fontWeight: 600
                                                },
                                                children: v.attack_type_title || v.name
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 0.5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600
                                                },
                                                children: [
                                                    "Severity: ",
                                                    (0, $adc573943ea4ef85$export$903fb3386f46d61e)(v.severity_level).toLowerCase()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76f12636665395c9$export$155bcd12491a11ee), {
                                                severity: v.severity_level
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 3,
                                    sx: {
                                        textAlign: 'right'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                        bdsType: "interactiveSubtle",
                                        onClick: ()=>{
                                            setSelected(v);
                                            setDrawerOpen(true);
                                        },
                                        children: "View details"
                                    })
                                })
                            ]
                        })
                    }, v.id ?? `${v.name}-${idx}`))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    mt: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f23ee38ba9fa7638$export$2e2bcd8739ae039), {
                    itemsPerPage: itemsPerPage,
                    page: page,
                    totalItems: totalCount,
                    onChange: (e, p)=>goto(p)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d3990aef34273b6$export$2e2bcd8739ae039), {
                url: url,
                open: drawerOpen,
                selected: selected,
                onClose: ()=>{
                    setDrawerOpen(false);
                    setSelected(null);
                },
                isSafe: isSafe
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $e64b66a0287a27e1$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($e64b66a0287a27e1$exports, "__esModule", {
    value: true
});
$e64b66a0287a27e1$exports.default = void 0;

var $e64b66a0287a27e1$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e64b66a0287a27e1$var$_default = $e64b66a0287a27e1$exports.default = (0, $e64b66a0287a27e1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');


const $810abadf40de7ce4$var$PAGE_SIZE = 20;
function $810abadf40de7ce4$var$jsonToCsv(jsonData) {
    if (!Array.isArray(jsonData) || jsonData.length === 0) return ""; // Return empty string for invalid input
    // Extract headers from the keys of the first object
    const headers = [
        "host",
        "ip"
    ];
    // Create the header row for the CSV
    const headerRow = headers.join(',');
    // Map each JSON object to a CSV row
    const rows = jsonData.map((obj)=>{
        return headers.map((header)=>{
            let value = obj[header];
            // Handle potential null/undefined values and escape commas/quotes
            if (value === null || value === undefined) value = "";
            else if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) // Enclose in double quotes and escape existing double quotes
            value = `"${value.replace(/"/g, '""')}"`;
            return value;
        }).join(',');
    });
    // Combine headers and rows
    return [
        headerRow,
        ...rows
    ].join('\r\n'); // Use \r\n for cross-platform newlines
}
function $810abadf40de7ce4$export$2e2bcd8739ae039({ subdomains: subdomains }) {
    const [search, setSearch] = (0, $acw62.useState)('');
    const [page, setPage] = (0, $acw62.useState)(1);
    const filtered = search ? subdomains.filter((d)=>d.host.toLowerCase().includes(search.toLowerCase())) : subdomains;
    const pageCount = Math.ceil(filtered.length / $810abadf40de7ce4$var$PAGE_SIZE);
    const startIdx = (page - 1) * $810abadf40de7ce4$var$PAGE_SIZE;
    const currentPageDomains = filtered.slice(startIdx, startIdx + $810abadf40de7ce4$var$PAGE_SIZE);
    const half = Math.ceil(currentPageDomains.length / 2);
    const col1 = currentPageDomains.slice(0, half);
    const col2 = currentPageDomains.slice(half);
    const handleCopy = (value)=>{
        if (navigator.clipboard) navigator.clipboard.writeText(value);
        else {
            // fallback for older browsers
            const textarea = document.createElement('textarea');
            textarea.value = value;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            mx: 'auto',
            mt: 3
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                gutterBottom: true,
                children: [
                    "Subdomains (",
                    filtered.length,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    gap: 2,
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44ba4f488ac798b2$export$2e2bcd8739ae039), {
                        label: "Search subdomains",
                        variant: "outlined",
                        size: "small",
                        sx: {
                            flex: 1
                        },
                        value: search,
                        onChange: (e)=>{
                            setSearch(e.target.value);
                            setPage(1);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                        bdsType: "interactiveNeutral",
                        onClick: ()=>{
                            const csv = $810abadf40de7ce4$var$jsonToCsv(filtered);
                            const blob = new Blob([
                                csv
                            ], {
                                type: 'text/csv'
                            });
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = 'subdomains.csv';
                            a.click();
                            URL.revokeObjectURL(url);
                        },
                        children: "Export CSV"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: col1.map((domain, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 1,
                                    pl: 1,
                                    gap: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600
                                                },
                                                children: domain?.host
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: domain?.ip || 'No IP'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
                                        size: "small",
                                        onClick: ()=>handleCopy(domain?.host),
                                        title: "Copy Host",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e64b66a0287a27e1$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }, idx))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: col2.map((domain, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 1,
                                    pl: 1,
                                    gap: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600
                                                },
                                                children: domain?.host
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: domain?.ip || 'No IP'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
                                        size: "small",
                                        onClick: ()=>handleCopy(domain?.host),
                                        title: "Copy Host",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e64b66a0287a27e1$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }, idx))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f23ee38ba9fa7638$export$2e2bcd8739ae039), {
                    itemsPerPage: $810abadf40de7ce4$var$PAGE_SIZE,
                    itemsPerPageDescription: "items per page",
                    // itemsPerPageOptions={[
                    //     10,
                    //     20,
                    //     50
                    // ]}
                    onChange: (_, value)=>setPage(value),
                    onClickItemsPerPage: function noRefCheck() {},
                    onClickItemsPerPageOption: function noRefCheck() {},
                    onCloseItemsPerPage: function noRefCheck() {},
                    page: page,
                    totalItems: filtered.length
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");

var $d75fc586a12c3cfb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d75fc586a12c3cfb$var$validSizes = [
    'small',
    'medium',
    'large'
];
const $d75fc586a12c3cfb$var$validTypes = [
    'staticNeutral',
    'staticSubtle',
    'staticEmphasis',
    'interactiveNeutral',
    'interactiveSubtle',
    'interactiveEmphasis'
];
const $d75fc586a12c3cfb$var$validPaddings = [
    'dense',
    'default',
    'spacious'
];
// Function to get list item size based on the size prop
const $d75fc586a12c3cfb$var$getListItemSize = (theme, bdsSize)=>{
    if (bdsSize && !$d75fc586a12c3cfb$var$validSizes.includes(bdsSize)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('ListItem', 'bdsSize', bdsSize);
        return undefined;
    }
    return {
        height: theme.palette.listItem.size.height[bdsSize]
    };
};
// Function to get padding or gap based on the prop
const $d75fc586a12c3cfb$var$getListItemPadding = (theme, value)=>{
    if (value && !$d75fc586a12c3cfb$var$validPaddings.includes(value)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('ListItem', 'bdsPadding/bdsGap', value);
        return undefined;
    }
    return theme.palette.listItem.padding[value];
};
// Function to get styles based on the bdsType, disabled, and selected props
const $d75fc586a12c3cfb$var$getListItemStyles = (theme, bdsType, selected, bottomBorder)=>{
    if (bdsType && !$d75fc586a12c3cfb$var$validTypes.includes(bdsType)) {
        (0, $600dd74f68ddb378$export$373ccc48b6a48668)('ListItem', 'bdsType', bdsType);
        return undefined;
    }
    const borderWidthBottom = bottomBorder ? theme.palette.listItem.border.width.bottom.separated : theme.palette.listItem.border.width.bottom.default;
    const stylesMap = {
        staticNeutral: {
            backgroundColor: theme.palette.listItem.static.neutral.background.color.default,
            borderBottom: `${borderWidthBottom} solid ${theme.palette.listItem.static.border.color.bottom.default}`,
            color: theme.palette.listItem.static.text.color.default
        },
        staticSubtle: {
            backgroundColor: theme.palette.listItem.static.subtle.background.color.default,
            borderBottom: `${borderWidthBottom} solid ${theme.palette.listItem.static.border.color.bottom.default}`,
            color: theme.palette.listItem.static.text.color.default
        },
        staticEmphasis: {
            backgroundColor: theme.palette.listItem.static.emphasis.background.color.default,
            borderBottom: `${borderWidthBottom} solid ${theme.palette.listItem.static.border.color.bottom.default}`,
            color: theme.palette.listItem.static.text.color.inverse
        },
        interactiveNeutral: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.listItem.interactive.neutral.background.color.selected.default : theme.palette.listItem.interactive.neutral.background.color.default,
            borderBottom: `${borderWidthBottom} solid ${selected ? theme.palette.listItem.interactive.border.color.selected : theme.palette.listItem.interactive.border.color.default}`,
            color: selected ? theme.palette.listItem.interactive.text.color.selected : theme.palette.listItem.interactive.text.color.default,
            hover: {
                backgroundColor: selected ? theme.palette.listItem.interactive.neutral.background.color.selected.hover : theme.palette.listItem.interactive.neutral.background.color.hover,
                color: selected ? theme.palette.listItem.interactive.text.color.selected : theme.palette.listItem.interactive.text.color.default
            },
            focus: {
                backgroundColor: theme.palette.listItem.interactive.neutral.background.color.focus,
                color: theme.palette.listItem.interactive.text.color.default
            }
        },
        interactiveSubtle: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.listItem.interactive.subtle.background.color.selected.default : theme.palette.listItem.interactive.subtle.background.color.default,
            borderBottom: `${borderWidthBottom} solid ${selected ? theme.palette.listItem.interactive.border.color.selected : theme.palette.listItem.interactive.border.color.default}`,
            color: selected ? theme.palette.listItem.interactive.text.color.selected : theme.palette.listItem.interactive.text.color.default,
            hover: {
                backgroundColor: selected ? theme.palette.listItem.interactive.subtle.background.color.selected.hover : theme.palette.listItem.interactive.subtle.background.color.hover,
                color: selected ? theme.palette.listItem.interactive.text.color.selected : theme.palette.listItem.interactive.text.color.default
            },
            focus: {
                backgroundColor: theme.palette.listItem.interactive.subtle.background.color.focus,
                color: theme.palette.listItem.interactive.text.color.default
            }
        },
        interactiveEmphasis: {
            cursor: 'pointer',
            backgroundColor: selected ? theme.palette.listItem.interactive.emphasis.background.color.selected.default : theme.palette.listItem.interactive.emphasis.background.color.default,
            borderBottom: `${borderWidthBottom} solid ${selected ? theme.palette.listItem.interactive.border.color.selected : theme.palette.listItem.interactive.border.color.default}`,
            color: selected ? theme.palette.listItem.interactive.text.color.selected : theme.palette.listItem.interactive.text.color.inverse,
            hover: {
                backgroundColor: selected ? theme.palette.listItem.interactive.emphasis.background.color.selected.hover : theme.palette.listItem.interactive.emphasis.background.color.hover,
                color: selected ? theme.palette.listItem.interactive.text.color.inverse : theme.palette.listItem.interactive.text.color.inverse
            },
            focus: {
                backgroundColor: theme.palette.listItem.interactive.emphasis.background.color.focus,
                color: theme.palette.listItem.interactive.text.color.default
            }
        }
    };
    return stylesMap[bdsType] || undefined;
};
const $d75fc586a12c3cfb$var$StyledListItem = (0, $d8seH.default)((0, $f92832698674c928$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            'bdsType',
            'bdsSize',
            'bdsPadding',
            'bdsGap',
            'bottomBorder'
        ].includes(prop)
})(({ theme: theme, bdsType: bdsType, bdsSize: bdsSize, bdsPadding: bdsPadding, bdsGap: bdsGap, selected: selected, disabled: disabled, bottomBorder: bottomBorder })=>{
    var _a, _b, _c, _d, _e, _f;
    const listItemSize = bdsSize && $d75fc586a12c3cfb$var$getListItemSize(theme, bdsSize) || undefined;
    const listItemStyles = bdsType && $d75fc586a12c3cfb$var$getListItemStyles(theme, bdsType, selected, bottomBorder) || undefined;
    const padding = bdsPadding && $d75fc586a12c3cfb$var$getListItemPadding(theme, bdsPadding) || undefined;
    const gap = bdsGap && $d75fc586a12c3cfb$var$getListItemPadding(theme, bdsGap) || undefined;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, listItemStyles), listItemSize), {
        gap: gap,
        padding: padding,
        display: 'flex',
        alignItems: 'center',
        borderRadius: theme.palette.listItem.border.radius,
        '&:hover': {
            backgroundColor: (_a = listItemStyles === null || listItemStyles === void 0 ? void 0 : listItemStyles.hover) === null || _a === void 0 ? void 0 : _a.backgroundColor,
            borderBottom: (_b = listItemStyles === null || listItemStyles === void 0 ? void 0 : listItemStyles.hover) === null || _b === void 0 ? void 0 : _b.borderBottom,
            color: (_c = listItemStyles === null || listItemStyles === void 0 ? void 0 : listItemStyles.hover) === null || _c === void 0 ? void 0 : _c.color
        },
        '&.Mui-focusVisible': {
            backgroundColor: (_d = listItemStyles === null || listItemStyles === void 0 ? void 0 : listItemStyles.focus) === null || _d === void 0 ? void 0 : _d.backgroundColor,
            borderBottom: (_e = listItemStyles === null || listItemStyles === void 0 ? void 0 : listItemStyles.focus) === null || _e === void 0 ? void 0 : _e.borderBottom,
            color: (_f = listItemStyles === null || listItemStyles === void 0 ? void 0 : listItemStyles.focus) === null || _f === void 0 ? void 0 : _f.color
        }
    }), disabled && {
        cursor: 'default',
        backgroundColor: theme.palette.listItem.interactive.disabled.background.color.default,
        color: theme.palette.listItem.interactive.disabled.text.color.default,
        pointerEvents: 'none'
    });
});
const $d75fc586a12c3cfb$var$BDSListItem = (props)=>{
    const { disabled: disabled = false, selected: selected = false, bdsType: bdsType, bdsSize: bdsSize, bdsPadding: bdsPadding, bdsGap: bdsGap, bottomBorder: bottomBorder = false } = props, rest = $d75fc586a12c3cfb$var$__rest(props, [
        "disabled",
        "selected",
        "bdsType",
        "bdsSize",
        "bdsPadding",
        "bdsGap",
        "bottomBorder"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d75fc586a12c3cfb$var$StyledListItem, Object.assign({
        disabled: disabled,
        selected: selected,
        bdsType: bdsType,
        bdsSize: bdsSize,
        bdsPadding: bdsPadding,
        bdsGap: bdsGap,
        bottomBorder: bottomBorder
    }, rest));
};
$d75fc586a12c3cfb$var$BDSListItem.displayName = 'ListItem';
var $d75fc586a12c3cfb$export$2e2bcd8739ae039 = $d75fc586a12c3cfb$var$BDSListItem;









var $815b3c422a0d7078$export$2e2bcd8739ae039 = (0, $640cd381f5e8b3ea$export$2e2bcd8739ae039);


function $0e87406f1ecac8ff$export$2e2bcd8739ae039({ title: title, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                gutterBottom: true,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "promoCaptionSubtle",
                gutterBottom: true,
                children: subtitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $815b3c422a0d7078$export$2e2bcd8739ae039), {
                    disablePadding: true,
                    children: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9
                    ].map((v, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d75fc586a12c3cfb$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 260px auto',
                                    alignItems: 'center',
                                    px: 1,
                                    columnGap: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                        disableTypography: true,
                                        primary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            sx: {
                                                fontWeight: 600,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                sx: {
                                                    fontSize: '1rem'
                                                },
                                                width: 600
                                            })
                                        }),
                                        sx: {
                                            overflow: 'hidden'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            px: 1,
                                            textAlign: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            sx: {
                                                fontSize: '1rem'
                                            },
                                            width: 200
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            justifySelf: 'end'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            sx: {
                                                fontSize: '1rem'
                                            },
                                            width: 200
                                        })
                                    })
                                ]
                            })
                        }, `${v}-${idx}`))
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $297483900a014e6a$var$PAGE_SIZE = 20;
function $297483900a014e6a$export$2e2bcd8739ae039({}) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            mx: 'auto',
            mt: 3
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                gutterBottom: true,
                children: "Subdomains"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    gap: 2,
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44ba4f488ac798b2$export$2e2bcd8739ae039), {
                        label: "Search subdomains",
                        variant: "outlined",
                        size: "small",
                        sx: {
                            flex: 1
                        },
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                        bdsType: "interactiveNeutral",
                        disabled: true,
                        children: "Export CSV"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8
                        ].map((domain, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 1,
                                    pl: 1
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                    variant: "text",
                                    sx: {
                                        fontSize: '1rem'
                                    },
                                    width: 600
                                })
                            }, idx))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8
                        ].map((domain, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 1,
                                    pl: 1
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                    variant: "text",
                                    sx: {
                                        fontSize: '1rem'
                                    },
                                    width: 600
                                })
                            }, idx))
                    })
                ]
            })
        ]
    });
}




function $c067d35c2689374b$export$2e2bcd8739ae039() {
    const { state: state } = (0, $2ad2279805e583d1$export$6ccbb43953eebf8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { uuid: uuid } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [snackbarOpen, setSnackbarOpen] = (0, $acw62.useState)(false);
    const [tabIndex, setTabIndex] = (0, $acw62.useState)(0);
    const [scanResult, setScanResult] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [scanStatus, setScanStatus] = (0, $acw62.useState)('in_progress');
    // Refs for each section and scrollable area
    const summaryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const vulnerabilitiesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const secureConfigRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scoreCalcRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollAreaRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const subDomainRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useEffect)(()=>{
        let pollingInterval = null;
        let isUnmounted = false;
        async function fetchScanResult() {
            setLoading(true);
            try {
                const resp = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/public/scan-result/${uuid}/`, {
                    withCredentials: true
                });
                setScanResult(resp.data);
                // Set scan status after receiving response
                const status = resp.data?.scan?.status;
                if ([
                    "completed",
                    "failed",
                    "cancelled"
                ].includes(status)) setScanStatus(status);
                else setScanStatus("in_progress");
                // If status is in_progress, start polling
                if (status === "in_progress" && !pollingInterval) pollingInterval = setInterval(async ()=>{
                    if (isUnmounted) return;
                    try {
                        const pollResp = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/public/scan-result/${uuid}/`, {
                            withCredentials: true
                        });
                        setScanResult(pollResp.data);
                        const pollStatus = pollResp.data?.scan?.status;
                        if ([
                            "completed",
                            "failed",
                            "cancelled"
                        ].includes(pollStatus)) {
                            setScanStatus(pollStatus);
                            clearInterval(pollingInterval);
                            pollingInterval = null;
                        }
                    } catch (e) {
                    // Optionally handle polling error
                    }
                }, 10000); // 10 seconds
                // If status is not in_progress, clear polling
                if ([
                    "completed",
                    "failed",
                    "cancelled"
                ].includes(status) && pollingInterval) {
                    clearInterval(pollingInterval);
                    pollingInterval = null;
                }
            } catch (e) {
                setScanResult(null);
                setScanStatus("failed");
                console.error("Error fetching scan result:", e);
            } finally{
                setLoading(false);
            }
        }
        if (uuid) fetchScanResult();
        return ()=>{
            isUnmounted = true;
            if (pollingInterval) clearInterval(pollingInterval);
        };
    }, [
        uuid
    ]);
    const handleSectionClick = (newValue)=>{
        setTabIndex(newValue);
        let ref = null;
        if (newValue === 0) ref = summaryRef;
        else if (newValue === 1) ref = vulnerabilitiesRef;
        else if (newValue === 2) ref = secureConfigRef;
        else if (newValue === 3) ref = subDomainRef;
        else if (newValue === 4) ref = scoreCalcRef;
        if (ref && ref.current) {
            // Find the scrollable content area
            const scrollContainer = ref.current.parentElement;
            // Height of sticky masthead + tabs (adjust if needed)
            const stickyOffset = 112; // Masthead (64px) + Tabs (48px)
            const sectionTop = ref.current.offsetTop;
            if (scrollContainer) scrollContainer.scrollTo({
                top: sectionTop - stickyOffset,
                behavior: 'smooth'
            });
            else // fallback
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };
    const handleShare = ()=>{
        if (!uuid) return;
        // Construct the public shareable URL
        const baseUrl = window.location.origin;
        const shareUrl = `${baseUrl}/public/scan-result/${uuid}`;
        if (navigator.clipboard) navigator.clipboard.writeText(shareUrl);
        else {
            // fallback for older browsers
            const textarea = document.createElement('textarea');
            textarea.value = shareUrl;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
        setSnackbarOpen(true);
    };
    // Update tabIndex on scroll
    (0, $acw62.useEffect)(()=>{
        const scrollContainer = scrollAreaRef.current;
        if (!scrollContainer) return;
        const handleScroll = ()=>{
            // Height of sticky masthead + button group
            const stickyOffset = 112;
            const scrollTop = scrollContainer.scrollTop;
            // Get top positions relative to scroll area
            const sectionTops = [
                summaryRef.current?.offsetTop ?? 0,
                vulnerabilitiesRef.current?.offsetTop ?? 0,
                secureConfigRef.current?.offsetTop ?? 0,
                subDomainRef.current?.offsetTop ?? 0,
                scoreCalcRef.current?.offsetTop ?? 0
            ];
            // Find the section whose top is closest but not greater than scrollTop + stickyOffset
            let active = 0;
            for(let i = 0; i < sectionTops.length; i++)if (scrollTop + stickyOffset >= sectionTops[i]) active = i;
            setTabIndex(active);
        };
        scrollContainer.addEventListener('scroll', handleScroll);
        return ()=>scrollContainer.removeEventListener('scroll', handleScroll);
    }, []);
    // Sticky header and tabs, scrollable content area
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 100
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e742043ac950988b$export$2e2bcd8739ae039), {
                        pageTitle: "Security Insights",
                        productTitle: "WAF-as-a-Service",
                        rightContent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    bdsType: "interactiveNeutral",
                                    "data-action": "free-trial",
                                    onClick: ()=>navigate("/scan"),
                                    children: "Start a new Analysis"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    bdsType: "interactiveEmphasis",
                                    "data-action": "try",
                                    onClick: ()=>window.open('https://waas.barracudanetworks.com/start-trial/', '_blank', 'noopener,noreferrer'),
                                    children: "Try WAF-as-a-Service now"
                                }),
                                state.isAuthenticated && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
                                    bdsSize: "input",
                                    "data-action": "share",
                                    onClick: handleShare,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5bc22e2b3a7b4be$exports))), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                        variant: "h6",
                        sx: {
                            py: 1,
                            paddingLeft: 2
                        },
                        children: scanResult?.scan?.domain || ""
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                        sx: {
                            py: 1,
                            paddingLeft: 2
                        },
                        variant: "caption",
                        color: "text.secondary",
                        children: [
                            "Completed At: ",
                            scanResult?.scan?.completed_at ? new Date(scanResult?.scan?.completed_at).toLocaleString() : "-"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d777678abefe038$export$2e2bcd8739ae039), {
                        open: snackbarOpen,
                        autoHideDuration: 2000,
                        onClose: ()=>setSnackbarOpen(false),
                        message: "Sharable link copied to clipboard!",
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        style: {
                            position: 'sticky',
                            top: 64,
                            zIndex: 99
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ad23ec42537d0e26$export$2e2bcd8739ae039), {
                            bdsType: "interactiveSubtle",
                            "aria-label": "outlined primary button group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 0,
                                    onClick: ()=>handleSectionClick(0),
                                    children: "Summary"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 1,
                                    onClick: ()=>handleSectionClick(1),
                                    children: "Vulnerabilities"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 2,
                                    onClick: ()=>handleSectionClick(2),
                                    children: "Secure Configuration"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 3,
                                    onClick: ()=>handleSectionClick(3),
                                    children: "Subdomains"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 4,
                                    onClick: ()=>handleSectionClick(4),
                                    children: "Score Calculation"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: scrollAreaRef,
                style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: 24
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: summaryRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cada76186e16b461$export$2e2bcd8739ae039), {
                            target_domain: scanResult?.scan?.domain || "",
                            scrollPage: handleSectionClick
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $faf99d80e7ab7242$export$2e2bcd8739ae039), {
                            scrollPage: handleSectionClick,
                            state: state,
                            summary: scanResult?.findings?.summary || [],
                            isLoading: loading,
                            vulnerabilities: scanResult?.findings?.vulnerabilities || [],
                            waf_detected: scanResult?.findings?.waf_detected || {}
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: "vulnerabilities-section",
                        ref: vulnerabilitiesRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e87406f1ecac8ff$export$2e2bcd8739ae039), {
                            title: "Vulnerabilities",
                            subtitle: ""
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437d13139f214e20$export$2e2bcd8739ae039), {
                            isSafe: false,
                            title: "Vulnerabilities",
                            subtitle: "",
                            state: state,
                            url: scanResult?.scan?.domain || "",
                            isLoading: loading,
                            vulnerabilities: scanResult?.findings?.vulnerabilities || []
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: secureConfigRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e87406f1ecac8ff$export$2e2bcd8739ae039), {
                            title: "Secure Configuration",
                            subtitle: "component passed security checks"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437d13139f214e20$export$2e2bcd8739ae039), {
                            isSafe: true,
                            title: "Secure Configuration",
                            subtitle: "component passed security checks",
                            state: state,
                            url: scanResult?.scan?.domain || "",
                            isLoading: loading,
                            vulnerabilities: scanResult?.findings?.secure_config || []
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: subDomainRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $297483900a014e6a$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810abadf40de7ce4$export$2e2bcd8739ae039), {
                            state: state,
                            isLoading: loading,
                            scanResult: scanResult,
                            subdomains: scanResult?.findings?.sub_domains || []
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: scoreCalcRef
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




// src/scanresult/Summary.js

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1a02591a33bb0d23$export$ac324cf78bde4699 = {
    'IIS': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#0078D7",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "3",
                y: "6",
                width: "18",
                height: "12",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "7",
                cy: "16",
                r: "1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "17",
                cy: "16",
                r: "1"
            })
        ]
    }),
    'Nginx': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#009639",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                points: "12,2 22,7 22,17 12,22 2,17 2,7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: "7",
                y: "16",
                fontSize: "7",
                fill: "#009639",
                children: "N"
            })
        ]
    }),
    'Apache': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#D22128",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4 20l8-16 8 16"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "4",
                y1: "20",
                x2: "20",
                y2: "20"
            })
        ]
    }),
    'LiteSpeed': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#00AEEF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                points: "12,2 22,12 12,22 2,12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "2",
                x2: "12",
                y2: "22"
            })
        ]
    }),
    'Tomcat': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#F8C300",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "10",
                ry: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            })
        ]
    })
};
function $1a02591a33bb0d23$export$3215381e106017a2(name) {
    const key = Object.keys($1a02591a33bb0d23$export$ac324cf78bde4699).find((k)=>name.toLowerCase().includes(k.toLowerCase()));
    return $1a02591a33bb0d23$export$ac324cf78bde4699[key] || null;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $133d8cb5b8fc5407$export$93d6d402b830d110 = {
    'PHP': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#777BB4",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "10",
                ry: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: "7",
                y: "16",
                fontSize: "7",
                fill: "#777BB4",
                children: "PHP"
            })
        ]
    }),
    'React': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#61DAFB",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "10",
                ry: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "4",
                ry: "10",
                transform: "rotate(60 12 12)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "4",
                ry: "10",
                transform: "rotate(120 12 12)"
            })
        ]
    }),
    'Node.js': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#339933",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                points: "12,2 22,7 22,17 12,22 2,17 2,7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: "7",
                y: "16",
                fontSize: "7",
                fill: "#339933",
                children: "JS"
            })
        ]
    }),
    'Python': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#3776AB",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "4",
                y: "4",
                width: "16",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: "7",
                y: "16",
                fontSize: "7",
                fill: "#3776AB",
                children: "Py"
            })
        ]
    }),
    'Java': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#007396",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "10",
                ry: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: "7",
                y: "16",
                fontSize: "7",
                fill: "#007396",
                children: "Java"
            })
        ]
    }),
    'Go': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#00ADD8",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "4",
                y: "4",
                width: "16",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: "7",
                y: "16",
                fontSize: "7",
                fill: "#00ADD8",
                children: "Go"
            })
        ]
    }),
    'Ruby': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#CC342D",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "10",
                ry: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: "7",
                y: "16",
                fontSize: "7",
                fill: "#CC342D",
                children: "Rb"
            })
        ]
    })
};
function $133d8cb5b8fc5407$export$d7cd661c42186d52(name) {
    const key = Object.keys($133d8cb5b8fc5407$export$93d6d402b830d110).find((k)=>name.toLowerCase().includes(k.toLowerCase()));
    return $133d8cb5b8fc5407$export$93d6d402b830d110[key] || null;
}







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $aa01712d5abdae9e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($aa01712d5abdae9e$exports, "__esModule", {
    value: true
});
$aa01712d5abdae9e$exports.default = void 0;

var $aa01712d5abdae9e$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $aa01712d5abdae9e$var$_default = $aa01712d5abdae9e$exports.default = (0, $aa01712d5abdae9e$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m15 9 .94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11 4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"
    }, "1")
], 'Insights');


var $2be2d5fda6f09cee$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($2be2d5fda6f09cee$exports, "__esModule", {
    value: true
});
$2be2d5fda6f09cee$exports.default = void 0;

var $2be2d5fda6f09cee$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2be2d5fda6f09cee$var$_default = $2be2d5fda6f09cee$exports.default = (0, $2be2d5fda6f09cee$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');


var $2f6164a325dd47a3$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($2f6164a325dd47a3$exports, "__esModule", {
    value: true
});
$2f6164a325dd47a3$exports.default = void 0;

var $2f6164a325dd47a3$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2f6164a325dd47a3$var$_default = $2f6164a325dd47a3$exports.default = (0, $2f6164a325dd47a3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11z"
}), 'Security');


var $ca4fd08777d4e412$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($ca4fd08777d4e412$exports, "__esModule", {
    value: true
});
$ca4fd08777d4e412$exports.default = void 0;

var $ca4fd08777d4e412$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ca4fd08777d4e412$var$_default = $ca4fd08777d4e412$exports.default = (0, $ca4fd08777d4e412$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');





function $8954be36df3cbe57$export$2e2bcd8739ae039({ open: open, onClose: onClose, ai_summary: ai_summary }) {
    if (!ai_summary) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7e11211e1a6425c$export$2e2bcd8739ae039), {
        anchor: "right",
        open: open,
        onClose: onClose,
        PaperProps: {
            sx: {
                width: '40vw',
                maxWidth: 600,
                minWidth: 350,
                p: 0,
                boxShadow: 6
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            role: "presentation",
            sx: {
                p: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        gap: 1,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "h5",
                            sx: {
                                fontWeight: 700
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aa01712d5abdae9e$exports))), {
                                    color: "primary",
                                    fontSize: "large",
                                    style: {
                                        margin: 2
                                    }
                                }),
                                "AI Security Insights"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                            "aria-label": "close",
                            onClick: onClose,
                            sx: {
                                color: '#d1d3d5ff'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $753cd5b62de61f2c$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            sx: {
                                fontWeight: 600,
                                mb: 1
                            },
                            children: "Risk Pattern"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: ai_summary.RiskPattern
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $753cd5b62de61f2c$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            sx: {
                                fontWeight: 600,
                                mb: 1
                            },
                            children: "AI Confidence"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f6164a325dd47a3$exports))), {}),
                                    label: `Confidence: ${ai_summary?.AIConfidence?.confidence_score}`,
                                    color: "success"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2be2d5fda6f09cee$exports))), {}),
                                    label: `Attack Probability: ${ai_summary?.AIConfidence?.attack_probability}`,
                                    color: "warning"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "body2",
                            sx: {
                                mt: 1
                            },
                            dangerouslySetInnerHTML: {
                                __html: ai_summary?.AIConfidence?.reasoning
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $753cd5b62de61f2c$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            sx: {
                                fontWeight: 600,
                                mb: 1
                            },
                            children: "Critical Findings"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $815b3c422a0d7078$export$2e2bcd8739ae039), {
                            children: ai_summary?.CriticalFindings?.map((finding, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d75fc586a12c3cfb$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    sx: {
                                        mb: 1,
                                        borderRadius: 2,
                                        background: '#fff7f0',
                                        boxShadow: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2be2d5fda6f09cee$exports))), {
                                                color: finding.severity === 'High' ? 'error' : 'warning'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                            disableTypography: true,
                                            primary: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontWeight: 600
                                                },
                                                dangerouslySetInnerHTML: {
                                                    __html: finding.finding
                                                }
                                            }),
                                            secondary: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        component: "span",
                                                        variant: "body2",
                                                        color: "text.secondary",
                                                        dangerouslySetInnerHTML: {
                                                            __html: finding?.impact
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            mt: 0.5,
                                                            display: 'flex',
                                                            gap: 1,
                                                            alignItems: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                                                size: "small",
                                                                label: `Severity: ${finding?.severity}`,
                                                                color: finding?.severity === 'High' ? 'error' : 'warning'
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                                                size: "small",
                                                                label: `CVSS: ${finding?.cvss_score}`,
                                                                color: "info"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, idx))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $753cd5b62de61f2c$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            sx: {
                                fontWeight: 600,
                                mb: 1
                            },
                            children: "Recommended Actions"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $815b3c422a0d7078$export$2e2bcd8739ae039), {
                            children: ai_summary?.RecommendedActions?.map((action, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d75fc586a12c3cfb$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca4fd08777d4e412$exports))), {
                                                color: "success"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                            primary: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: action
                                                }
                                            })
                                        })
                                    ]
                                }, idx))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                    sx: {
                        flexGrow: 1
                    }
                })
            ]
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


/**
 * ============================================================================
 * MAIN CLASS
 * ============================================================================
 * @hidden
 */ /**
 * Represents a relative value (percent).
 *
 * The Percent object, can be instantiated using two ways:
 *
 * * Via `new Percent(X)`.
 * * Via `am5.percent(X)`.
 *
 * You can also use shortcut functions for `0%`, `50%`, and `100%`:
 * * `am5.p0`
 * * `am5.p50`
 * * `am5.p100`
 */ class $bd0d0c10fd30006b$export$cbc348af47898b5e {
    /**
     * Constructor.
     *
     * @param percent  Percent value
     */ constructor(percent){
        this._value = percent;
    }
    /**
     * Relative value.
     *
     * E.g. 100% is 1, 50% is 0.5, etc.
     *
     * This is useful to apply transformations to other values. E.g.:
     *
     * ```TypeScript
     * let value = 256;
     * let percent = new am5.p50;
     * console.log(value * percent.value); // outputs 128
     * ```
     * ```JavaScript
     * var value = 256;
     * var percent = new am5.p50;
     * console.log(value * percent.value); // outputs 128
     * ```
     *
     * Alternatively, you can use `am5.percent()` helper function:
     *
     * ```TypeScript
     * let value = 256;
     * let percent = am5.p50;
     * console.log(value * percent.value); // outputs 128
     * ```
     * ```JavaScript
     * var value = 256;
     * var percent = am5.p50;
     * console.log(value * percent.value); // outputs 128
     * ```
     *
     * @readonly
     * @return Relative value
     */ get value() {
        return this._value / 100;
    }
    /**
     * Value in percent.
     *
     * @readonly
     * @return Percent
     */ get percent() {
        return this._value;
    }
    toString() {
        return "" + this._value + "%";
    }
    interpolate(min, max) {
        return min + this.value * (max - min);
    }
    static normalize(percent, min, max) {
        if (percent instanceof $bd0d0c10fd30006b$export$cbc348af47898b5e) return percent;
        else {
            if (min === max) return new $bd0d0c10fd30006b$export$cbc348af47898b5e(0);
            else return new $bd0d0c10fd30006b$export$cbc348af47898b5e(Math.min(Math.max((percent - min) * (1 / (max - min)), 0), 1) * 100);
        }
    }
}
function $bd0d0c10fd30006b$export$626336c2cd4b14de(value) {
    return new $bd0d0c10fd30006b$export$cbc348af47898b5e(value);
}
const $bd0d0c10fd30006b$export$3f300ce68008be7 = $bd0d0c10fd30006b$export$626336c2cd4b14de(0);
const $bd0d0c10fd30006b$export$46342ea78d85883c = $bd0d0c10fd30006b$export$626336c2cd4b14de(100);
const $bd0d0c10fd30006b$export$888d047b0ce6de72 = $bd0d0c10fd30006b$export$626336c2cd4b14de(50);
function $bd0d0c10fd30006b$export$e50269385c77c348(value) {
    return value instanceof $bd0d0c10fd30006b$export$cbc348af47898b5e;
}



/**
 * Event Dispatcher module is used for registering listeners and dispatching
 * events across amCharts system.
 */ /**
 * ============================================================================
 * IMPORTS
 * ============================================================================
 * @hidden
 */ /**
 * ============================================================================
 * IMPORTS
 * ============================================================================
 * @hidden
 */ /**
 * A collection of utility functions for various type checks and conversion
 * @hidden
 */ /**
 * ============================================================================
 * TYPE CHECK
 * ============================================================================
 * @hidden
 */ /**
 * Returns `true` if value is not a number (NaN).
 *
 * @param value Input value
 * @return Is NaN?
 */ function $f63bdea45a89cf24$export$c9f5652083b8129d(value) {
    return Number(value) !== value;
}
function $f63bdea45a89cf24$export$e2b5c5db9e2009fd(value) {
    return ({}).toString.call(value);
}
function $f63bdea45a89cf24$export$a7a9523472993e97(condition, message = "Assertion failed") {
    if (!condition) throw new Error(message);
}
function $f63bdea45a89cf24$export$a0a81dc3380ce7d3(value) {
    if (value != null && !$f63bdea45a89cf24$export$7e4aa119212bc614(value)) {
        let converted = Number(value);
        if ($f63bdea45a89cf24$export$c9f5652083b8129d(converted) && $f63bdea45a89cf24$export$844ec244b1367d54(value) && value != "" && value.match(/[0-9]+/)) {
            const newValue = value.replace(/[^0-9.\-]+/g, '');
            return value === newValue ? converted : $f63bdea45a89cf24$export$a0a81dc3380ce7d3(newValue);
        }
        return converted;
    }
    return value;
}
function $f63bdea45a89cf24$export$e67a095c620b86fe(value) {
    if ($f63bdea45a89cf24$export$871608497c498473(value)) // TODO maybe don't create a new Date ?
    return new Date(value);
    else if ($f63bdea45a89cf24$export$7e4aa119212bc614(value)) return new Date(value);
    else {
        // Try converting to number (assuming timestamp)
        let num = Number(value);
        if (!$f63bdea45a89cf24$export$7e4aa119212bc614(num)) return new Date(value);
        else return new Date(num);
    }
}
function $f63bdea45a89cf24$export$f67be9d9b0e25d7b(value) {
    // TODO handle Infinity and -Infinity
    if ($f63bdea45a89cf24$export$c9f5652083b8129d(value)) return "NaN";
    if (value === Infinity) return "Infinity";
    if (value === -Infinity) return "-Infinity";
    // Negative 0
    if (value === 0 && 1 / value === -Infinity) return "-0";
    // Preserve negative and deal with absoute values
    let negative = value < 0;
    value = Math.abs(value);
    // TODO test this
    let parsed = /^([0-9]+)(?:\.([0-9]+))?(?:e[\+\-]([0-9]+))?$/.exec("" + value);
    let digits = parsed[1];
    let decimals = parsed[2] || "";
    let res;
    // Leave the nummber as it is if it does not use exponents
    if (parsed[3] === undefined) res = decimals === "" ? digits : digits + "." + decimals;
    else {
        let exponent = +parsed[3];
        // Deal with decimals
        if (value < 1) {
            let zeros = exponent - 1;
            res = "0." + $f63bdea45a89cf24$export$76d90c956114f2c2("0", zeros) + digits + decimals;
        // Deal with integers
        } else {
            let zeros = exponent - decimals.length;
            if (zeros === 0) res = digits + decimals;
            else if (zeros < 0) res = digits + decimals.slice(0, zeros) + "." + decimals.slice(zeros);
            else res = digits + decimals + $f63bdea45a89cf24$export$76d90c956114f2c2("0", zeros);
        }
    }
    return negative ? "-" + res : res;
}
function $f63bdea45a89cf24$export$76d90c956114f2c2(string, amount) {
    return new Array(amount + 1).join(string);
}
function $f63bdea45a89cf24$export$871608497c498473(value) {
    return $f63bdea45a89cf24$export$e2b5c5db9e2009fd(value) === "[object Date]";
}
function $f63bdea45a89cf24$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $f63bdea45a89cf24$export$7e4aa119212bc614(value) {
    return typeof value === "number" && Number(value) == value;
}
function $f63bdea45a89cf24$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}
function $f63bdea45a89cf24$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
const $f63bdea45a89cf24$export$55fc5ffc49a23c34 = "__\xa7\xa7\xa7__";
const $f63bdea45a89cf24$export$cea82ace3c81ccd9 = "__\xa7\xa7\xa7\xa7__";


function $2f30431acd054e2f$export$305f7d4e9d4624f2(array, value) {
    const length = array.length;
    for(let i = 0; i < length; ++i){
        // TODO handle NaN
        if (array[i] === value) return i;
    }
    return -1;
}
function $2f30431acd054e2f$export$4154a199d7d90455(array, test) {
    const length = array.length;
    for(let i = 0; i < length; ++i){
        if (test(array[i])) return true;
    }
    return false;
}
function $2f30431acd054e2f$export$871de8747c9eaa88(array, fn) {
    const length = array.length;
    const output = new Array(length);
    for(let i = 0; i < length; ++i)output[i] = fn(array[i], i);
    return output;
}
function $2f30431acd054e2f$export$79b2f7037acddd43(array, fn) {
    const length = array.length;
    for(let i = 0; i < length; ++i)fn(array[i], i);
}
function $2f30431acd054e2f$export$a40ba8785b7efce8(array, fn) {
    let i = array.length;
    while(i > 0){
        --i;
        fn(array[i], i);
    }
}
function $2f30431acd054e2f$export$1e016427912bfd78(array, fn) {
    const length = array.length;
    for(let i = 0; i < length; ++i){
        if (!fn(array[i], i)) break;
    }
}
function $2f30431acd054e2f$export$f613292be21d0bc3(array, index) {
    const length = array.length;
    for(let i = index; i < length; ++i)array[i - index] = array[i];
    array.length = length - index;
}
function $2f30431acd054e2f$export$4c7897fafd92b108(array) {
    const length = array.length;
    return length ? array[length - 1] : undefined;
}
function $2f30431acd054e2f$export$43128fadae87b74a(array) {
    return array[0];
}
function $2f30431acd054e2f$export$21a5ca8aa77d35ff(array, element, index) {
    //if (array) {
    index = Math.max(0, Math.min(index, array.length));
    array.splice(index, 0, element);
//}
}
function $2f30431acd054e2f$export$28faab0720fecb61(array, element, index) {
    $2f30431acd054e2f$export$cd7f480d6b8286c3(array, element);
    $2f30431acd054e2f$export$21a5ca8aa77d35ff(array, element, index);
}
function $2f30431acd054e2f$export$907644183e99da16(array, input) {
    const length = input.length;
    for(let i = 0; i < length; ++i)array.push(input[i]);
}
function $2f30431acd054e2f$export$cd7f480d6b8286c3(array, element) {
    let found = false;
    let index = 0;
    for(;;){
        index = array.indexOf(element, index);
        if (index === -1) return found;
        else {
            found = true;
            array.splice(index, 1);
        }
    }
}
function $2f30431acd054e2f$export$2529f734547e2830(array, element) {
    let index = array.indexOf(element);
    if (index !== -1) {
        array.splice(index, 1);
        return true;
    } else return false;
}
function $2f30431acd054e2f$export$d947e5f4f4c48d48(array, element, toIndex) {
    // @todo this implementation must be the same as the List.moveValue method
    // @todo don't do anything if the desired index is the same as the current index
    let index = $2f30431acd054e2f$export$305f7d4e9d4624f2(array, element);
    // @todo remove all old values rather than only the first ?
    if (index !== -1) $2f30431acd054e2f$export$c36ae5e7e50e8840(array, index);
    if (toIndex == null) array.push(element);
    else $2f30431acd054e2f$export$5a98a36321617fd4(array, toIndex, element);
}
function $2f30431acd054e2f$export$e16d8520af44a096(array, element, index) {
    // Append to the end if index is not set
    if (!$f63bdea45a89cf24$export$7e4aa119212bc614(index)) array.push(element);
    else if (index === 0) array.unshift(element);
    else array.splice(index, 0, element);
}
function $2f30431acd054e2f$export$3589e1fa93f0a8a5(array, element) {
    if (array.indexOf(element) === -1) array.push(element);
}
function $2f30431acd054e2f$export$77ad94ebf1c2b9ed(array, element, index) {
    // check if exists
    let ind = array.indexOf(element);
    // remove if exists
    if (ind !== -1) array.splice(ind, 1);
    // add to end if index is not set
    if (!$f63bdea45a89cf24$export$7e4aa119212bc614(index)) array.push(element);
    else array.splice(index, 0, element);
}
function $2f30431acd054e2f$export$45b10814cc054894(input) {
    if (Array.isArray(input)) return input;
    else return [
        input
    ];
}
function $2f30431acd054e2f$export$a4f4bb6b1453fff5(array, element) {
    return $2f30431acd054e2f$export$305f7d4e9d4624f2(array, element) !== -1;
}
function $2f30431acd054e2f$export$784d13d8ee351f07(array) {
    const length = array.length;
    // It's faster to create the array with a pre-defined length
    const output = new Array(length);
    for(let i = 0; i < length; ++i)// Because the array has a pre-defined length, we have to assign rather than push
    // This is also faster than pushing
    output[i] = array[i];
    return output;
}
function $2f30431acd054e2f$export$58adb3bec8346d0f(array, start, end = array.length) {
    const output = new Array(end - start);
    for(let i = start; i < end; ++i)output[i - start] = array[i];
    return output;
}
function $2f30431acd054e2f$export$5a98a36321617fd4(array, index, value) {
    array.splice(index, 0, value);
}
function $2f30431acd054e2f$export$c36ae5e7e50e8840(array, index) {
    array.splice(index, 1);
}
function $2f30431acd054e2f$export$de3a4d4a0d731119(array, matches) {
    const length = array.length;
    for(let i = 0; i < length; ++i){
        if (matches(array[i], i)) return i;
    }
    return -1;
}
function $2f30431acd054e2f$export$226e5ded3ade49e5(array, matches) {
    let i = array.length;
    while(i > 0){
        --i;
        if (matches(array[i], i)) return i;
    }
    return -1;
}
function $2f30431acd054e2f$export$71aa6c912b956294(array, matches) {
    const index = $2f30431acd054e2f$export$de3a4d4a0d731119(array, matches);
    if (index !== -1) return array[index];
}
function $2f30431acd054e2f$export$cda8c4def7b6e027(array, matches) {
    const index = $2f30431acd054e2f$export$226e5ded3ade49e5(array, matches);
    if (index !== -1) return array[index];
}
function $2f30431acd054e2f$export$23e5dcedfce4509c(array, matches) {
    const length = array.length;
    for(let i = 0; i < length; ++i){
        const value = matches(array[i], i);
        if (value !== undefined) return value;
    }
}
function $2f30431acd054e2f$export$448332262467e042(array) {
    // https://stackoverflow.com/a/2450976/449477
    let currentIndex = array.length, temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while(0 !== currentIndex){
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
}
function $2f30431acd054e2f$export$5637f53fe994488d(array, ordering) {
    let start = 0;
    let end = array.length;
    let found = false;
    while(start < end){
        // TODO is this faster/slower than using Math.floor ?
        const pivot = start + end >> 1;
        const order = ordering(array[pivot]);
        // less
        if (order < 0) start = pivot + 1;
        else if (order === 0) {
            found = true;
            for(start = pivot + 1; start < end && ordering(array[start]) === 0; start++);
            start--;
            break;
        // more
        } else end = pivot;
    }
    return {
        found: found,
        index: start
    };
}
function $2f30431acd054e2f$export$227c6173d90c5e68(array, ordering) {
    let start = 0;
    let end = array.length;
    let found = false;
    while(start < end){
        // TODO is this faster/slower than using Math.floor ?
        const pivot = start + end >> 1;
        const order = ordering(array[pivot]);
        // less
        if (order < 0) start = pivot + 1;
        else if (order === 0) {
            found = true;
            end = pivot;
        // more
        } else end = pivot;
    }
    return {
        found: found,
        index: start
    };
}
function $2f30431acd054e2f$export$249f83d169a7c462(array, keep) {
    let i = array.length;
    while(i > 0){
        --i;
        if (!keep(array[i])) array.splice(i, 1);
    }
}


class $a363f66303166aa1$export$9a67fa5e19f51a52 {
    /**
     * Constructor.
     */ constructor(){
        this._disposed = false;
    }
    /**
     * Checks if object is disposed.
     *
     * @return Disposed?
     */ isDisposed() {
        return this._disposed;
    }
    /**
     * Disposes the object.
     */ dispose() {
        if (!this._disposed) {
            this._disposed = true;
            this._dispose();
        }
    }
}
class $a363f66303166aa1$export$6039fc6176d96e35 {
    /**
     * Constructor.
     *
     * @param dispose  Function that disposes object
     */ constructor(dispose){
        this._disposed = false;
        this._dispose = dispose;
    }
    /**
     * Checks if object is disposed.
     *
     * @return Disposed?
     */ isDisposed() {
        return this._disposed;
    }
    /**
     * Disposes the object.
     */ dispose() {
        if (!this._disposed) {
            this._disposed = true;
            this._dispose();
        }
    }
}
class $a363f66303166aa1$export$e5175346f02c1d15 extends $a363f66303166aa1$export$9a67fa5e19f51a52 {
    constructor(){
        super(...arguments);
        this._disposers = [];
    }
    _dispose() {
        $2f30431acd054e2f$export$79b2f7037acddd43(this._disposers, (x)=>{
            x.dispose();
        });
    }
}
class $a363f66303166aa1$export$9720df365053d143 extends $a363f66303166aa1$export$9a67fa5e19f51a52 {
    constructor(disposers){
        super();
        this._disposers = disposers;
    }
    _dispose() {
        $2f30431acd054e2f$export$79b2f7037acddd43(this._disposers, (x)=>{
            x.dispose();
        });
    }
    get disposers() {
        return this._disposers;
    }
}
class $a363f66303166aa1$export$1ac3b860a0f32be9 extends $a363f66303166aa1$export$9a67fa5e19f51a52 {
    _dispose() {
        if (this._disposer != null) {
            this._disposer.dispose();
            this._disposer = undefined;
        }
    }
    /**
     * Returns current value.
     *
     * @return Value
     */ get() {
        return this._value;
    }
    /**
     * Sets value and disposes previous disposer if it was set.
     *
     * @param value     New value
     * @param disposer  Disposer
     */ set(value, disposer) {
        if (this._disposer != null) this._disposer.dispose();
        this._disposer = disposer;
        this._value = value;
    }
    /**
     * Resets the disposer value.
     */ reset() {
        this.set(undefined, undefined);
    }
}
class $a363f66303166aa1$export$8a02b29de282f67f extends $a363f66303166aa1$export$6039fc6176d96e35 {
    constructor(){
        super(...arguments);
        /**
         * [_counter description]
         *
         * @todo Description
         */ this._counter = 0;
    }
    /**
     * [increment description]
     *
     * @todo Description
     */ increment() {
        // TODO throw an error if it is disposed
        ++this._counter;
        // TODO make this more efficient
        return new $a363f66303166aa1$export$6039fc6176d96e35(()=>{
            --this._counter;
            if (this._counter === 0) this.dispose();
        });
    }
}




class $7e417cbab1b21893$export$ec8b666c5fe2c75a {
    /**
     * Constructor
     */ constructor(){
        this._listeners = [];
        this._killed = [];
        this._disabled = {};
        this._iterating = 0;
        this._enabled = true;
        this._disposed = false;
    }
    /**
     * Returns if this object has been already disposed.
     *
     * @return Disposed?
     */ isDisposed() {
        return this._disposed;
    }
    /**
     * Dispose (destroy) this object.
     */ dispose() {
        if (!this._disposed) {
            this._disposed = true;
            const a = this._listeners;
            this._iterating = 1;
            this._listeners = null;
            this._disabled = null;
            try {
                $2f30431acd054e2f$export$79b2f7037acddd43(a, (x)=>{
                    x.disposer.dispose();
                });
            } finally{
                this._killed = null;
                this._iterating = null;
            }
        }
    }
    /**
     * Checks if this particular event dispatcher has any listeners set.
     *
     * @return Has listeners?
     */ hasListeners() {
        return this._listeners.length !== 0;
    }
    /**
     * Checks if this particular event dispatcher has any particular listeners set.
     *
     * @return Has particular event listeners?
     */ hasListenersByType(type) {
        return $2f30431acd054e2f$export$4154a199d7d90455(this._listeners, (x)=>(x.type === null || x.type === type) && !x.killed);
    }
    /**
     * Enable dispatching of events if they were previously disabled by
     * `disable()`.
     */ enable() {
        this._enabled = true;
    }
    /**
     * Disable dispatching of events until re-enabled by `enable()`.
     */ disable() {
        this._enabled = false;
    }
    /**
     * Enable dispatching particular event, if it was disabled before by
     * `disableType()`.
     *
     * @param type Event type
     */ enableType(type) {
        delete this._disabled[type];
    }
    /**
     * Disable dispatching of events for a certain event type.
     *
     * Optionally, can set how many dispatches to skip before automatically
     * re-enabling the dispatching.
     *
     * @param type    Event type
     * @param amount  Number of event dispatches to skip
     */ disableType(type, amount = Infinity) {
        this._disabled[type] = amount;
    }
    /**
     * Removes listener from dispatcher.
     *
     * Will throw an exception if such listener does not exists.
     *
     * @param listener Listener to remove
     */ _removeListener(listener) {
        if (this._iterating === 0) {
            const index = this._listeners.indexOf(listener);
            if (index === -1) throw new Error("Invalid state: could not remove listener");
            this._listeners.splice(index, 1);
        } else this._killed.push(listener);
    }
    /**
     * Removes existing listener by certain parameters.
     *
     * @param once         Listener's once setting
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     */ _removeExistingListener(once, type, callback, context) {
        if (this._disposed) throw new Error("EventDispatcher is disposed");
        this._eachListener((info)=>{
            if (info.once === once && // TODO is this correct ?
            info.type === type && (callback === undefined || info.callback === callback) && info.context === context) info.disposer.dispose();
        });
    }
    /**
     * Checks if dispatching for particular event type is enabled.
     *
     * @param type  Event type
     * @return Enabled?
     */ isEnabled(type) {
        if (this._disposed) throw new Error("EventDispatcher is disposed");
        // TODO is this check correct ?
        return this._enabled && this._listeners.length > 0 && this.hasListenersByType(type) && this._disabled[type] === undefined;
    }
    /**
     * Removes all listeners of a particular event type
     *
     * @param type  Listener's type
     */ removeType(type) {
        if (this._disposed) throw new Error("EventDispatcher is disposed");
        this._eachListener((info)=>{
            if (info.type === type) info.disposer.dispose();
        });
    }
    /**
     * Checks if there's already a listener with specific parameters.
     *
     * @param type      Listener's type
     * @param callback  Callback function
     * @param context   Callback context
     * @return Has listener?
     */ has(type, callback, context) {
        const index = $2f30431acd054e2f$export$de3a4d4a0d731119(this._listeners, (info)=>{
            return info.once !== true && // Ignoring "once" listeners
            info.type === type && (callback === undefined || info.callback === callback) && info.context === context;
        });
        return index !== -1;
    }
    /**
     * Checks whether event of the particular type should be dispatched.
     *
     * @param type  Event type
     * @return Dispatch?
     */ _shouldDispatch(type) {
        if (this._disposed) throw new Error("EventDispatcher is disposed");
        const count = this._disabled[type];
        if (!$f63bdea45a89cf24$export$7e4aa119212bc614(count)) return this._enabled;
        else {
            if (count <= 1) delete this._disabled[type];
            else --this._disabled[type];
            return false;
        }
    }
    /**
     * [_eachListener description]
     *
     * All of this extra code is needed when a listener is removed while iterating
     *
     * @todo Description
     * @param fn [description]
     */ _eachListener(fn) {
        ++this._iterating;
        try {
            $2f30431acd054e2f$export$79b2f7037acddd43(this._listeners, fn);
        } finally{
            --this._iterating;
            // TODO should this be inside or outside the finally ?
            if (this._iterating === 0 && this._killed.length !== 0) {
                // Remove killed listeners
                $2f30431acd054e2f$export$79b2f7037acddd43(this._killed, (killed)=>{
                    this._removeListener(killed);
                });
                this._killed.length = 0;
            }
        }
    }
    /**
     * Dispatches an event immediately without waiting for next cycle.
     *
     * @param type   Event type
     * @param event  Event object
     * @todo automatically add in type and target properties if they are missing
     */ dispatch(type, event) {
        if (this._shouldDispatch(type)) // TODO check if it's faster to use an object of listeners rather than a single big array
        // TODO if the function throws, maybe it should keep going ?
        this._eachListener((listener)=>{
            if (!listener.killed && (listener.type === null || listener.type === type)) {
                if (listener._debounceDelay) {
                    if (listener._debounceTimeout) window.clearTimeout(listener._debounceTimeout);
                    listener._debounceTimeout = window.setTimeout(()=>{
                        listener._debounceTimeout = undefined;
                        if (!listener.killed) listener.dispatch(type, event);
                    }, listener._debounceDelay);
                } else listener.dispatch(type, event);
            }
        });
    }
    /**
     * Shelves the event to be dispatched within next update cycle.
     *
     * @param type   Event type
     * @param event  Event object
     * @todo automatically add in type and target properties if they are missing
     */ /*public dispatchLater<Key extends keyof T>(type: Key, event: T[Key]): void {
        if (this._shouldDispatch(type)) {
            this._eachListener((listener) => {
                // TODO check if it's faster to use an object of listeners rather than a single big array
                if (!listener.killed && (listener.type === null || listener.type === type)) {
                    // TODO if the function throws, maybe it should keep going ?
                    // TODO dispatch during the update cycle, rather than using whenIdle
                    $async.whenIdle(() => {
                        if (!listener.killed) {
                            listener.dispatch(type, event);
                        }
                    });
                }
            });
        }
    }*/ /**
     * Creates, catalogs and returns an [[EventListener]].
     *
     * Event listener can be disposed.
     *
     * @param once         Listener's once setting
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @param dispatch
     * @returns An event listener
     */ _on(once, type, callback, context, shouldClone, dispatch, debounceDelay) {
        if (this._disposed) throw new Error("EventDispatcher is disposed");
        this._removeExistingListener(once, type, callback, context);
        const info = {
            type: type,
            callback: callback,
            context: context,
            shouldClone: shouldClone,
            dispatch: dispatch,
            killed: false,
            once: once,
            disposer: new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
                info.killed = true;
                if (info._debounceTimeout) window.clearTimeout(info._debounceTimeout);
                this._removeListener(info);
            }),
            _debounceDelay: debounceDelay
        };
        this._listeners.push(info);
        return info;
    }
    /**
     * Creates an event listener to be invoked on **any** event.
     *
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @returns A disposable event listener
     */ onAll(callback, context, shouldClone = true) {
        return this._on(false, null, callback, context, shouldClone, (_type, event)=>callback.call(context, event)).disposer;
    }
    /**
     * Creates an event listener to be invoked on a specific event type.
     *
     * ```TypeScript
     * button.events.once("click", (ev) => {
     *   console.log("Button clicked");
     * }, this);
     * ```
     * ```JavaScript
     * button.events.once("click", function(ev) {
     *   console.log("Button clicked");
     * }, this);
     * ```
     *
     * The above will invoke our custom event handler whenever series we put
     * event on is hidden.
     *
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @returns A disposable event listener
     */ on(type, callback, context, shouldClone = true) {
        return this._on(false, type, callback, context, shouldClone, (_type, event)=>callback.call(context, event)).disposer;
    }
    /**
     * Creates a debounced event listener to be invoked on a specific event type.
     *
     * ```TypeScript
     * button.events.onDebounced("click", (ev) => {
     *   console.log("Button clicked");
     * }, 500, this);
     * ```
     * ```JavaScript
     * button.events.onDebounced("click", function(ev) {
     *   console.log("Button clicked");
     * }, 500, this);
     * ```
     *
     * The above will invoke our custom event handler whenever series we put
     * event on is hidden.
     *
     * @param type           Listener's type
     * @param callback       Callback function
     * @param debounceDelay  Debounce delay in milliseconds
     * @param context        Callback context
     * @param shouldClone    Whether the listener should be copied when the EventDispatcher is copied
     * @returns A disposable event listener
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Debounced_events} for more info
     * @since 5.14.0
     */ onDebounced(type, callback, debounceDelay, context, shouldClone = true) {
        return this._on(false, type, callback, context, shouldClone, (_type, event)=>callback.call(context, event), debounceDelay).disposer;
    }
    /**
     * Creates an event listener to be invoked on a specific event type once.
     *
     * Once the event listener is invoked, it is automatically disposed.
     *
     * ```TypeScript
     * button.events.once("click", (ev) => {
     *   console.log("Button clicked");
     * }, this);
     * ```
     * ```JavaScript
     * button.events.once("click", function(ev) {
     *   console.log("Button clicked");
     * }, this);
     * ```
     *
     * The above will invoke our custom event handler the first time series we
     * put event on is hidden.
     *
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
     * @returns A disposable event listener
     */ once(type, callback, context, shouldClone = true) {
        const x = this._on(true, type, callback, context, shouldClone, (_type, event)=>{
            x.disposer.dispose();
            callback.call(context, event);
        });
        // TODO maybe this should return a different Disposer ?
        return x.disposer;
    }
    /**
     * Removes the event listener with specific parameters.
     *
     * @param type         Listener's type
     * @param callback     Callback function
     * @param context      Callback context
     */ off(type, callback, context) {
        this._removeExistingListener(false, type, callback, context);
    }
    /**
     * Copies all dispatcher parameters, including listeners, from another event
     * dispatcher.
     *
     * @param source Source event dispatcher
     * @ignore
     */ copyFrom(source) {
        if (this._disposed) throw new Error("EventDispatcher is disposed");
        if (source === this) throw new Error("Cannot copyFrom the same TargetedEventDispatcher");
        const disposers = [];
        $2f30431acd054e2f$export$79b2f7037acddd43(source._listeners, (x)=>{
            // TODO is this correct ?
            if (!x.killed && x.shouldClone) {
                if (x.type === null) disposers.push(this.onAll(x.callback, x.context));
                else if (x.once) disposers.push(this.once(x.type, x.callback, x.context));
                else disposers.push(this.on(x.type, x.callback, x.context));
            }
        });
        return new (0, $a363f66303166aa1$export$9720df365053d143)(disposers);
    }
}
class $7e417cbab1b21893$export$778360f0cf920e44 extends $7e417cbab1b21893$export$ec8b666c5fe2c75a {
    /**
     * Constructor
     *
     * @param target Event dispatcher target
     */ constructor(target){
        super();
        this.target = target;
    }
    /**
     * Copies all dispatcher parameters, including listeners, from another event
     * dispatcher.
     *
     * @param source Source event dispatcher
     * @ignore
     */ copyFrom(source) {
        if (this._disposed) throw new Error("EventDispatcher is disposed");
        if (source === this) throw new Error("Cannot copyFrom the same TargetedEventDispatcher");
        const disposers = [];
        $2f30431acd054e2f$export$79b2f7037acddd43(source._listeners, (x)=>{
            // TODO very hacky
            if (x.context === source.target) return;
            // TODO is this correct ?
            if (!x.killed && x.shouldClone) {
                if (x.type === null) disposers.push(this.onAll(x.callback, x.context));
                else if (x.once) disposers.push(this.once(x.type, x.callback, x.context));
                else disposers.push(this.on(x.type, x.callback, x.context));
            }
        });
        return new (0, $a363f66303166aa1$export$9720df365053d143)(disposers);
    }
}



function $e66f9343b5144e1a$export$ed97f33186d4b816(object) {
    return Object.keys(object);
}
function $e66f9343b5144e1a$export$3e9f948b41964866(object) {
    return Object.entries(object);
}
function $e66f9343b5144e1a$export$dc3913a2a38a46a4(object, order) {
    return $e66f9343b5144e1a$export$ed97f33186d4b816(object).sort(order);
}
function $e66f9343b5144e1a$export$784d13d8ee351f07(object) {
    return Object.assign({}, object);
}
function $e66f9343b5144e1a$export$79b2f7037acddd43(object, f) {
    $e66f9343b5144e1a$export$ed97f33186d4b816(object).forEach((key)=>{
        f(key, object[key]);
    });
}
function $e66f9343b5144e1a$export$1e016427912bfd78(object, fn) {
    for(let key in object)if ($e66f9343b5144e1a$export$94df19ecb868bc1a(object, key)) {
        if (!fn(key, object[key])) break;
    }
}
function $e66f9343b5144e1a$export$f0e38b9506e07ad4(object, fn, ord) {
    $2f30431acd054e2f$export$79b2f7037acddd43($e66f9343b5144e1a$export$dc3913a2a38a46a4(object, ord), (key)=>{
        fn(key, object[key]);
    });
}
function $e66f9343b5144e1a$export$94df19ecb868bc1a(object, key) {
    return ({}).hasOwnProperty.call(object, key);
}
function $e66f9343b5144e1a$export$b3c97e0cc54202d1(source, target) {
    $e66f9343b5144e1a$export$79b2f7037acddd43(source, (key, value)=>{
        // only if value is set
        //if ($type.hasValue(value) && !($type.hasValue((<any>target)[key]))) {
        if (value != null && target[key] == null) target[key] = value;
    });
    return target;
}


function $43e0e2dc9c95da4e$export$5bfdbf456b754132(animations) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        if (animations !== undefined) {
            const promises = [];
            $e66f9343b5144e1a$export$79b2f7037acddd43(animations, (_, animation)=>{
                promises.push(animation.waitForStop());
            });
            yield Promise.all(promises);
        }
    });
}
function $43e0e2dc9c95da4e$export$a3295358bff77e(value, min, max) {
    if (min === max) return 0;
    else return Math.min(Math.max((value - min) * (1 / (max - min)), 0), 1);
}
function $43e0e2dc9c95da4e$export$d02631cccf789723(diff, from, to) {
    return from + diff * (to - from);
}
function $43e0e2dc9c95da4e$export$f6bd804b3d805842(diff, from, to) {
    if (diff >= 1) return to;
    else return from;
}
function $43e0e2dc9c95da4e$export$71b5eeb90041857f(diff, from, to) {
    return new (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)($43e0e2dc9c95da4e$export$d02631cccf789723(diff, from.percent, to.percent));
}
function $43e0e2dc9c95da4e$export$ac63c65a91c8af0f(diff, from, to) {
    return (0, $389de129b6cd18b1$export$892596cec99bc70e).interpolate(diff, from, to);
}
function $43e0e2dc9c95da4e$export$d9af756d8d8c2d47(from, to) {
    if (typeof from === "number" && typeof to === "number") return $43e0e2dc9c95da4e$export$d02631cccf789723;
    if (from instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e) && to instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) return $43e0e2dc9c95da4e$export$71b5eeb90041857f;
    if (from instanceof (0, $389de129b6cd18b1$export$892596cec99bc70e) && to instanceof (0, $389de129b6cd18b1$export$892596cec99bc70e)) return $43e0e2dc9c95da4e$export$ac63c65a91c8af0f;
    return $43e0e2dc9c95da4e$export$f6bd804b3d805842;
}
var $43e0e2dc9c95da4e$export$d0f7a26c90cc1562;
(function(AnimationState) {
    AnimationState[AnimationState["Stopped"] = 0] = "Stopped";
    AnimationState[AnimationState["Playing"] = 1] = "Playing";
    AnimationState[AnimationState["Paused"] = 2] = "Paused";
})($43e0e2dc9c95da4e$export$d0f7a26c90cc1562 || ($43e0e2dc9c95da4e$export$d0f7a26c90cc1562 = {}));
class $43e0e2dc9c95da4e$export$2846a69d90825eae {
    constructor(entity, duration){
        this._playingDuration = null;
        this._startingTime = null;
        this._current = 0;
        this._from = 0;
        this._to = 0;
        this.events = new (0, $7e417cbab1b21893$export$ec8b666c5fe2c75a)();
        this._entity = entity;
        this._duration = duration;
    }
    _stopEvent() {
        const type = "stopped";
        if (this.events.isEnabled(type)) this.events.dispatch(type, {
            type: type,
            target: this
        });
    }
    _runAnimation(currentTime) {
        if (this._playingDuration !== null) {
            if (this._startingTime === null) {
                this._startingTime = currentTime;
                return $43e0e2dc9c95da4e$export$d0f7a26c90cc1562.Playing;
            } else {
                const diff = (currentTime - this._startingTime) / this._playingDuration;
                if (diff >= 1) {
                    this._playingDuration = null;
                    this._startingTime = null;
                    this._from = this._to;
                    this._current = this._to;
                    this._entity.markDirty();
                    this._stopEvent();
                    const type = "ended";
                    if (this.events.isEnabled(type)) this.events.dispatch(type, {
                        type: type,
                        target: this
                    });
                    return $43e0e2dc9c95da4e$export$d0f7a26c90cc1562.Stopped;
                } else {
                    this._current = $43e0e2dc9c95da4e$export$d02631cccf789723(diff, this._from, this._to);
                    this._entity.markDirty();
                    const type = "progress";
                    if (this.events.isEnabled(type)) this.events.dispatch(type, {
                        type: type,
                        target: this,
                        progress: diff
                    });
                    return $43e0e2dc9c95da4e$export$d0f7a26c90cc1562.Playing;
                }
            }
        } else return $43e0e2dc9c95da4e$export$d0f7a26c90cc1562.Stopped;
    }
    _play() {
        this._from = this._current;
        if (this._playingDuration === null) {
            this._entity._root._addAnimation(this);
            const type = "started";
            if (this.events.isEnabled(type)) this.events.dispatch(type, {
                type: type,
                target: this
            });
        } else this._startingTime = null;
        this._playingDuration = Math.abs(this._to - this._from) * this._duration;
    }
    get duration() {
        return this._duration;
    }
    set duration(value) {
        if (this._duration !== value) {
            this._duration = value;
            if (value === 0) this.jumpTo(this._to);
            else if (this._current !== this._to) this._play();
        }
    }
    get current() {
        if (this.easing) return this.easing(this._current);
        else return this._current;
    }
    stop() {
        this.jumpTo(this._current);
    }
    jumpTo(value) {
        if (this._current !== value) this._entity.markDirty();
        if (this._playingDuration !== null) this._stopEvent();
        this._playingDuration = null;
        this._startingTime = null;
        this._current = value;
        this._from = value;
        this._to = value;
    }
    tweenTo(value) {
        if (this._current === value || this._duration === 0) this.jumpTo(value);
        else if (this._to !== value) {
            this._to = value;
            this._play();
        }
    }
} /*export class AnimationValue extends AnimationTime {
    public _min: number;
    public _max: number;

    constructor(entity: Entity, duration: number, min: number, max: number) {
        super(entity, duration);
        this._min = min;
        this._max = max;
    }

    public get min(): number {
        return this._min;
    }

    public set min(value: number) {
        if (this._min !== value) {
            this._min = value;
            this._entity.markDirty();
        }
    }

    public get max(): number {
        return this._max;
    }

    public set max(value: number) {
        if (this._max !== value) {
            this._max = value;
            this._entity.markDirty();
        }
    }

    public currentValue(): number {
        return range(super.currentTime(), this._min, this._max);
    }

    public jumpToValue(value: number) {
        super.jumpToTime(normalize(value, this._min, this._max));
    }

    public tweenToValue(value: number) {
        super.tweenToTime(normalize(value, this._min, this._max));
    }
}
*/ 






function $05b1b40b69b15016$export$28ee1007e174a2a6(f) {
    if (document.readyState !== "loading") f();
    else {
        const listener = ()=>{
            if (document.readyState !== "loading") {
                document.removeEventListener("readystatechange", listener);
                f();
            }
        };
        document.addEventListener("readystatechange", listener);
    }
}
function $05b1b40b69b15016$export$f883456a56996078(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
function $05b1b40b69b15016$export$3f65cefe8380dbea(dom, type, listener, options) {
    //@todo proper type check for options: EventListenerOptions | boolean (TS for some reason gives error on passive parameter)
    dom.addEventListener(type, listener, options || false);
    return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
        dom.removeEventListener(type, listener, options || false);
    });
}
function $05b1b40b69b15016$export$6981aa66c6e2c48d(listener) {
    // TODO use matchMedia instead ?
    return $05b1b40b69b15016$export$3f65cefe8380dbea(window, "resize", (_ev)=>{
        listener();
    });
}
function $05b1b40b69b15016$export$cde6a56f9669daf6(cap) {
    switch(cap){
        case "touchevents":
            //return "ontouchstart" in document.documentElement;
            return window.hasOwnProperty("TouchEvent");
        case "pointerevents":
            return window.hasOwnProperty("PointerEvent");
        case "mouseevents":
            return window.hasOwnProperty("MouseEvent");
        case "wheelevents":
            return window.hasOwnProperty("WheelEvent");
        case "keyboardevents":
            return window.hasOwnProperty("KeyboardEvent");
    }
    return false;
}
function $05b1b40b69b15016$export$a845ff6c553b3014(event) {
    let id = event.pointerId || 0;
    return id;
}
function $05b1b40b69b15016$export$2cc7ff91bcacba5e() {
    if (document.activeElement && document.activeElement != document.body) {
        if (document.activeElement.blur) document.activeElement.blur();
        else {
            let input = document.createElement("button");
            input.style.position = "fixed";
            input.style.top = "0px";
            input.style.left = "-10000px";
            document.body.appendChild(input);
            input.focus();
            input.blur();
            document.body.removeChild(input);
        }
    }
}
function $05b1b40b69b15016$export$d7ddd398f22d79ef(el) {
    if (el) el.focus();
}
function $05b1b40b69b15016$export$e9a3efe7940d0764(key) {
    if ($05b1b40b69b15016$export$cde6a56f9669daf6("pointerevents")) return key;
    else if ($05b1b40b69b15016$export$cde6a56f9669daf6("touchevents")) switch(key){
        case "pointerover":
            return "touchstart";
        case "pointerout":
            return "touchend";
        case "pointerleave":
            return "touchend";
        case "pointerdown":
            return "touchstart";
        case "pointermove":
            return "touchmove";
        case "pointerup":
            return "touchend";
        case "click":
            return "click";
        case "dblclick":
            return "dblclick";
    }
    else if ($05b1b40b69b15016$export$cde6a56f9669daf6("mouseevents")) switch(key){
        case "pointerover":
            return "mouseover";
        case "pointerout":
            return "mouseout";
        case "pointerleave":
            return "mouseleave";
        case "pointerdown":
            return "mousedown";
        case "pointermove":
            return "mousemove";
        case "pointerup":
            return "mouseup";
        case "click":
            return "click";
        case "dblclick":
            return "dblclick";
    }
    return key;
}
function $05b1b40b69b15016$export$c4dfce035d43d1e0(ev) {
    if (typeof Touch !== "undefined" && ev instanceof Touch) return true;
    else if (typeof PointerEvent !== "undefined" && ev instanceof PointerEvent && ev.pointerType != null) switch(ev.pointerType){
        case "touch":
        case "pen":
        case 2:
            return true;
        case "mouse":
        case 4:
            return false;
        default:
            return !(ev instanceof MouseEvent);
    }
    else if (ev.type != null) {
        if (ev.type.match(/^mouse/)) return false;
    }
    return true;
}
function $05b1b40b69b15016$export$37a5fde709c1db82(dom, property, value) {
    dom.style[property] = value;
}
function $05b1b40b69b15016$export$3d2f074408bd1b82(dom, property) {
    return dom.style[property];
}
function $05b1b40b69b15016$export$e58f029f0fbfdb29(event) {
    if (event.composedPath) {
        const path = event.composedPath();
        if (path.length === 0) return null;
        else return path[0];
    } else return event.target;
}
function $05b1b40b69b15016$export$2344b14b097df817(a, b) {
    let cursor = b;
    while(true){
        if (a === cursor) return true;
        else if (cursor.parentNode === null) {
            // TODO better ShadowRoot detection
            if (cursor.host == null) return false;
            else cursor = cursor.host;
        } else cursor = cursor.parentNode;
    }
}
function $05b1b40b69b15016$export$a3b96849d75e4c53(event, target) {
    return event.target && $05b1b40b69b15016$export$2344b14b097df817(target.root.dom, event.target);
}
function $05b1b40b69b15016$export$2dc32695cee26cb(target, interactive) {
    if (interactive) target.style.pointerEvents = "auto";
    else target.style.pointerEvents = "none";
}
function $05b1b40b69b15016$export$f7a7490116b79d4d(event) {
    if (event.key !== undefined) return event.key;
    switch(event.keyCode){
        case 9:
            return "Tab";
        case 13:
            return "Enter";
        case 16:
            return "Shift";
        case 17:
            return "Control";
        case 27:
            return "Escape";
        case 32:
            return " ";
        case 37:
            return "ArrowLeft";
        case 38:
            return "ArrowUp";
        case 39:
            return "ArrowRight";
        case 40:
            return "ArrowDown";
        case 46:
            return "Delete";
    }
    return "" + event.keyCode;
}
function $05b1b40b69b15016$export$70e8259662bb498b(a) {
    let cursor = a;
    while(true)if (cursor.parentNode === null) {
        // TODO better ShadowRoot detection
        if (cursor.host != null) return cursor;
        else return null;
    } else cursor = cursor.parentNode;
}
/**
 * @ignore
 */ let $05b1b40b69b15016$var$rootStylesheet;
/**
 * @ignore Exclude from docs
 */ function $05b1b40b69b15016$var$createStylesheet(element, text, nonce = "") {
    // TODO use createElementNS ?
    const e = document.createElement("style");
    e.type = "text/css";
    if (nonce != "") e.setAttribute("nonce", nonce);
    e.textContent = text;
    if (element === null) document.head.appendChild(e);
    else element.appendChild(e);
    return e;
}
/**
 * @ignore
 */ function $05b1b40b69b15016$var$getStylesheet(element, nonce = "") {
    if (element === null) {
        if ($05b1b40b69b15016$var$rootStylesheet == null) {
            // TODO use createElementNS ?
            const e = document.createElement("style");
            e.type = "text/css";
            if (nonce != "") e.setAttribute("nonce", nonce);
            document.head.appendChild(e);
            $05b1b40b69b15016$var$rootStylesheet = e.sheet;
        }
        return $05b1b40b69b15016$var$rootStylesheet;
    } else {
        // TODO use createElementNS ?
        const e = document.createElement("style");
        e.type = "text/css";
        if (nonce != "") e.setAttribute("nonce", nonce);
        element.appendChild(e);
        return e.sheet;
    }
}
/**
 * @ignore
 */ function $05b1b40b69b15016$var$appendStylesheet(root, selector) {
    const index = root.cssRules.length;
    root.insertRule(selector + "{}", index);
    return root.cssRules[index];
}
class $05b1b40b69b15016$export$536e5d171422e262 extends (0, $a363f66303166aa1$export$9a67fa5e19f51a52) {
    /**
     * Constructor.
     *
     * @param selector  CSS selector
     * @param styles    An object of style attribute - value pairs
     */ constructor(element, selector, styles, nonce = ""){
        super();
        this._root = $05b1b40b69b15016$var$getStylesheet(element, nonce);
        try {
            this._rule = $05b1b40b69b15016$var$appendStylesheet(this._root, selector);
        } catch (err) {
            // Create an empty rule on failed selectors
            this._rule = $05b1b40b69b15016$var$appendStylesheet(this._root, ":not(*)");
        }
        $e66f9343b5144e1a$export$79b2f7037acddd43(styles, (key, value)=>{
            this.setStyle(key, value);
        });
    }
    /**
     * A CSS selector text.
     *
     * E.g.: `.myClass p`
     *
     * @param selector  CSS selector
     */ set selector(selector) {
        this._rule.selectorText = selector;
    }
    /**
     * @return CSS selector
     */ get selector() {
        return this._rule.selectorText;
    }
    // TODO test this
    _dispose() {
        // TODO a bit hacky
        const index = $2f30431acd054e2f$export$305f7d4e9d4624f2(this._root.cssRules, this._rule);
        if (index === -1) throw new Error("Could not dispose StyleRule");
        else // TODO if it's empty remove it from the DOM ?
        this._root.deleteRule(index);
    }
    /**
     * Sets the same style properties with browser-specific prefixes.
     *
     * @param name   Attribute name
     * @param value  Attribute value
     */ _setVendorPrefixName(name, value) {
        const style = this._rule.style;
        style.setProperty("-webkit-" + name, value, "");
        style.setProperty("-moz-" + name, value, "");
        style.setProperty("-ms-" + name, value, "");
        style.setProperty("-o-" + name, value, "");
        style.setProperty(name, value, "");
    }
    /**
     * Sets a value for specific style attribute.
     *
     * @param name   Attribute
     * @param value  Value
     */ setStyle(name, value) {
        if (name === "transition") this._setVendorPrefixName(name, value);
        else this._rule.style.setProperty(name, value, "");
    }
}
class $05b1b40b69b15016$export$9d753cd7ae895cce extends (0, $a363f66303166aa1$export$9a67fa5e19f51a52) {
    /**
     * Constructor.
     *
     * @param text  CSS stylesheet
     */ constructor(element, text, nonce = ""){
        super();
        this._element = $05b1b40b69b15016$var$createStylesheet(element, text, nonce);
    }
    _dispose() {
        if (this._element.parentNode) this._element.parentNode.removeChild(this._element);
    }
}
function $05b1b40b69b15016$export$d2cf6cd1dc7067d3(element, className) {
    if (!element) return;
    if (element.classList) {
        const classes = className.split(" ");
        $2f30431acd054e2f$export$79b2f7037acddd43(classes, (name)=>{
            element.classList.add(name);
        });
    } else {
        let currentClassName = element.getAttribute("class");
        if (currentClassName) element.setAttribute("class", currentClassName.split(" ").filter((item)=>{
            return item !== className;
        }).join(" ") + " " + className);
        else element.setAttribute("class", className);
    }
}
function $05b1b40b69b15016$export$c2255604a80b4506(element, className) {
    if (!element) return;
    if (element.classList) element.classList.remove(className);
    else {
        let currentClassName = element.getAttribute("class");
        if (currentClassName) element.setAttribute("class", currentClassName.split(" ").filter((item)=>{
            return item !== className;
        }).join(" "));
    }
}
function $05b1b40b69b15016$export$d81d0eca22fc682c() {
    return /apple/i.test(navigator.vendor) && "ontouchend" in document;
}
function $05b1b40b69b15016$export$48067e34605ab48a() {
    return $05b1b40b69b15016$export$d81d0eca22fc682c() ? 1 : undefined;
}
function $05b1b40b69b15016$export$302dfacf2b0a56fe(percent, full) {
    if ($f63bdea45a89cf24$export$7e4aa119212bc614(percent)) return percent;
    else if (percent != null && $f63bdea45a89cf24$export$7e4aa119212bc614(percent.value) && $f63bdea45a89cf24$export$7e4aa119212bc614(full)) return full * percent.value;
    else return 0;
}
function $05b1b40b69b15016$export$4aa4df8b0f34e5d(number) {
    let match = ('' + number).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) return 0;
    return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
}
function $05b1b40b69b15016$export$e3f9b6bf3780ff6e(value, len = 0, char = "0") {
    if (typeof value !== "string") value = value.toString();
    return len > value.length ? Array(len - value.length + 1).join(char) + value : value;
}
function $05b1b40b69b15016$export$c5557f40488c48ec(text) {
    return text.replace(/^[\s]*/, "");
}
function $05b1b40b69b15016$export$da8e5da96e287379(text) {
    return text.replace(/[\s]*$/, "");
}
function $05b1b40b69b15016$export$87c2784dc9fc4ab(text) {
    return $05b1b40b69b15016$export$c5557f40488c48ec($05b1b40b69b15016$export$da8e5da96e287379(text));
}
function $05b1b40b69b15016$export$c1942c34655b7385(text, maxLength, breakWords = false, ellipsis = "...") {
    if (text.length > maxLength) {
        // Find the last non-alphanumeric character before maxLength
        let lastNonAlphanumericIndex = maxLength - 1;
        while(lastNonAlphanumericIndex >= 0 && text.charAt(lastNonAlphanumericIndex).match(/\w/))lastNonAlphanumericIndex--;
        if (lastNonAlphanumericIndex >= 0 && breakWords == false) return text.substring(0, lastNonAlphanumericIndex + 1) + '...';
        else // If no non-alphanumeric character found, truncate without breaking words
        return text.substring(0, maxLength) + ellipsis;
    } else return text;
}
function $05b1b40b69b15016$export$f61ac8b6f1f46202(format) {
    // Undefined?
    if (typeof format === "undefined") return "string";
    // Cleanup and lowercase format
    format = format.toLowerCase().replace(/^\[[^\]]*\]/, "");
    // Remove style tags
    format = format.replace(/\[[^\]]+\]/, "");
    // Trim
    format = format.trim();
    // Check for any explicit format hints (i.e. /Date)
    let hints = format.match(/\/(date|number|duration)$/);
    if (hints) return hints[1];
    // Check for explicit hints
    if (format === "number") return "number";
    if (format === "date") return "date";
    if (format === "duration") return "duration";
    // Detect number formatting symbols
    if (format.match(/[#0]/)) return "number";
    // Detect date formatting symbols
    if (format.match(/[ymwdhnsqaxkzgtei]/)) return "date";
    // Nothing? Let's display as string
    return "string";
}
function $05b1b40b69b15016$export$1261c7bb3da8241a(format) {
    return format.replace(/\/(date|number|duration)$/i, "");
}
function $05b1b40b69b15016$export$1fbf6f199c05a66(text) {
    return text ? text.replace(/<[^>]*>/g, "") : text;
}
function $05b1b40b69b15016$export$8b58d1ab3bbf8cb5(text) {
    return text ? text.replace(/\[[^\]]*\]/g, "") : text;
}
function $05b1b40b69b15016$export$8557d5da1ec1c0d8(text) {
    return text ? $05b1b40b69b15016$export$1fbf6f199c05a66(("" + text).replace(/[\n\r]+/g, ". ")) : text;
}
/**
 * HTML tags that [[sanitizeHTML]] strips out entirely (together with their
 * contents where applicable). They can execute scripts or pull in
 * external/malicious resources and have no legitimate use inside chart labels,
 * tooltips, modal content, or export menu items.
 *
 * @ignore
 */ const $05b1b40b69b15016$var$dangerousHTMLTags = "script|iframe|frame|frameset|object|embed|applet|noscript|template|link|meta|base|form";
function $05b1b40b69b15016$export$13003bc448897200(html) {
    if (html == null || html === "") return html;
    return ("" + html)// Remove dangerous tag blocks together with their content
    .replace(new RegExp("<\\s*(" + $05b1b40b69b15016$var$dangerousHTMLTags + ")\\b[^>]*>[\\s\\S]*?<\\s*\\/\\s*\\1\\s*>", "gi"), "")// Remove any leftover or self-closing dangerous tags
    .replace(new RegExp("<\\s*\\/?\\s*(?:" + $05b1b40b69b15016$var$dangerousHTMLTags + ")\\b[^>]*>", "gi"), "")// Remove inline event handler attributes (on*=...), quoted or unquoted
    .replace(/\son[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")// Neutralize script protocols in URL-bearing attributes. Whitespace and
    // control characters are tolerated between the chars since browsers
    // ignore them when resolving a protocol (e.g. `java\tscript:`).
    .replace(/((?:href|src|xlink:href|action|formaction|data|background|poster|srcdoc|ping)\s*=\s*)(?:"[\s]*j[\s]*a[\s]*v[\s]*a[\s]*s[\s]*c[\s]*r[\s]*i[\s]*p[\s]*t[\s]*:[^"]*"|'[\s]*j[\s]*a[\s]*v[\s]*a[\s]*s[\s]*c[\s]*r[\s]*i[\s]*p[\s]*t[\s]*:[^']*'|(?:javascript|vbscript|livescript|mocha):[^\s>]*)/gi, "$1\"#\"")// Drop srcdoc entirely, as it always carries embedded markup
    .replace(/\ssrcdoc\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")// Remove inline styles that can execute scripts
    .replace(/\sstyle\s*=\s*(?:"[^"]*(?:expression|javascript:|vbscript:|behavior|-moz-binding)[^"]*"|'[^']*(?:expression|javascript:|vbscript:|behavior|-moz-binding)[^']*')/gi, "");
}
function $05b1b40b69b15016$export$4a325aa52b8c4c19(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function $05b1b40b69b15016$export$bf6109b2a75a56f3(str) {
    let result = "";
    for(let i = 0; i < str.length; i++){
        const char = str.charAt(i);
        if (char.toUpperCase() == char && i != 0) result += " ";
        result += char;
    }
    return result;
}
function $05b1b40b69b15016$export$d05bbe0328e41cc6(source) {
    // Regular expression to identify RTL characters
    const rtlChar = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    // Regular expression to capture segments ending with specific Arabic characters
    const splitPattern = /([^اأدذرزو]*[اأدذرزو])/gi;
    // Split input string into array of words or characters, including whitespace
    let segments = source.split(/(\s+)/); // Split by whitespace, capturing it
    let result = [];
    segments.forEach((segment)=>{
        if (segment.match(/^\s+$/)) {
            // If the segment is purely whitespace
            segment = " ";
            segment = "  ";
            result.push(segment);
        } else if (rtlChar.test(segment)) {
            // If the segment contains RTL characters, handle special splits
            let parts = segment.split(splitPattern).filter((part)=>part !== '');
            // Concatenate parts processed by the split pattern directly to result
            result = result.concat(parts);
        } else // Treat this segment as LTR: split into characters
        result = result.concat([
            ...segment
        ]);
    });
    return result;
}
function $05b1b40b69b15016$export$6f157f7a2f040843(date, utc = false) {
    // TODO: utc needed?
    utc;
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = date.getTime() - start.getTime() + (start.getTimezoneOffset() - date.getTimezoneOffset()) * 60000;
    const oneDay = 86400000;
    return Math.floor(diff / oneDay);
}
function $05b1b40b69b15016$export$efe19b760242b2fc(date, _utc = false) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    const firstDay = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d.getTime() - firstDay.getTime()) / 86400000 + 1) / 7);
}
function $05b1b40b69b15016$export$12d572480ceb6e58(date, _utc = false) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    const firstDay = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return firstDay.getFullYear();
}
function $05b1b40b69b15016$export$b533a84e84a6dcfa(date, utc = false) {
    const firstWeek = $05b1b40b69b15016$export$efe19b760242b2fc(new Date(date.getFullYear(), date.getMonth(), 1), utc);
    let currentWeek = $05b1b40b69b15016$export$efe19b760242b2fc(date, utc);
    if (currentWeek == 1) currentWeek = 53;
    return currentWeek - firstWeek + 1;
}
function $05b1b40b69b15016$export$c5933b95cf2ffa17(week, year, weekday = 1, utc = false) {
    let date = new Date(year, 0, 4, 0, 0, 0, 0);
    if (utc) date.setUTCFullYear(year);
    let day = week * 7 + weekday - ((date.getDay() || 7) + 3);
    return day;
}
function $05b1b40b69b15016$export$6ef1a68df5e98f69(hours, base) {
    if (hours > 12) hours -= 12;
    else if (hours === 0) hours = 12;
    return base != null ? hours + (base - 1) : hours;
}
function $05b1b40b69b15016$export$c3133dbc11f66777(date, long = false, savings = false, utc = false, timezone) {
    if (utc) return long ? "Coordinated Universal Time" : "UTC";
    else if (timezone) {
        const d1 = date.toLocaleString("en-US", {
            timeZone: timezone
        });
        const d2 = date.toLocaleString("en-US", {
            timeZone: timezone,
            timeZoneName: long ? "long" : "short"
        });
        return $05b1b40b69b15016$export$87c2784dc9fc4ab(d2.substr(d1.length));
    }
    let wotz = date.toLocaleString("UTC");
    let wtz = date.toLocaleString("UTC", {
        timeZoneName: long ? "long" : "short"
    }).substr(wotz.length);
    //wtz = wtz.replace(/[+-]+[0-9]+$/, "");
    if (savings === false) wtz = wtz.replace(/ (standard|daylight|summer|winter) /i, " ");
    return $05b1b40b69b15016$export$87c2784dc9fc4ab(wtz);
}
function $05b1b40b69b15016$export$4c9db454e2785fd9(timezone, targetDate) {
    const date = targetDate || new Date(Date.UTC(2012, 0, 1, 0, 0, 0, 0));
    const utcDate = new Date(date.toLocaleString("en-US", {
        timeZone: "UTC"
    }));
    const tzDate = new Date(date.toLocaleString("en-US", {
        timeZone: timezone
    }));
    return (tzDate.getTime() - utcDate.getTime()) / 6e4 * -1;
}
function $05b1b40b69b15016$export$8e831c751a9f504f(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}
function $05b1b40b69b15016$export$29fb7152bd3f781a(color) {
    let r, g, b;
    let h = color.h;
    let s = color.s;
    let l = color.l;
    if (s == 0) r = g = b = l; // achromatic
    else {
        let hue2rgb = function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        let p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}
function $05b1b40b69b15016$export$c85ca4f4753af384(color) {
    let r = color.r / 255;
    let g = color.g / 255;
    let b = color.b / 255;
    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let h = 0;
    let s = 0;
    let l = (max + min) / 2;
    if (max === min) h = s = 0; // achromatic
    else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $05b1b40b69b15016$export$4f0921ab3f4919ce(hsv) {
    const l = hsv.v * (1 - hsv.s / 2);
    const s = l === 0 || l === 1 ? 0 : (hsv.v - l) / Math.min(l, 1 - l);
    return {
        h: hsv.h,
        s: s,
        l: l,
        a: hsv.a
    };
}
function $05b1b40b69b15016$export$eca2dde7f2894edb(hsl) {
    const v = hsl.l + hsl.s * Math.min(hsl.l, 1 - hsl.l);
    const s = v === 0 ? 0 : 2 * (1 - hsl.l / v);
    return {
        h: hsl.h,
        s: s,
        v: v,
        a: hsl.a
    };
}
function $05b1b40b69b15016$export$c0816ed86df316af(rgb, percent) {
    if (rgb) return {
        r: Math.max(0, Math.min(255, rgb.r + $05b1b40b69b15016$export$137526ec3f31f69a(rgb.r, percent))),
        g: Math.max(0, Math.min(255, rgb.g + $05b1b40b69b15016$export$137526ec3f31f69a(rgb.g, percent))),
        b: Math.max(0, Math.min(255, rgb.b + $05b1b40b69b15016$export$137526ec3f31f69a(rgb.b, percent))),
        a: rgb.a
    };
    else // TODO is this correct ?
    return rgb;
}
function $05b1b40b69b15016$export$137526ec3f31f69a(value, percent) {
    let base = percent > 0 ? 255 - value : value;
    return Math.round(base * percent);
}
function $05b1b40b69b15016$export$382cdde3a5b8f440(rgb, percent) {
    if (rgb) {
        let base = Math.min(Math.max(rgb.r, rgb.g, rgb.b), 230);
        //let base = Math.max(rgb.r, rgb.g, rgb.b);
        let step = $05b1b40b69b15016$export$137526ec3f31f69a(base, percent);
        return {
            r: Math.max(0, Math.min(255, Math.round(rgb.r + step))),
            g: Math.max(0, Math.min(255, Math.round(rgb.g + step))),
            b: Math.max(0, Math.min(255, Math.round(rgb.b + step))),
            a: rgb.a
        };
    } else // TODO is this correct ?
    return rgb;
}
function $05b1b40b69b15016$export$a33f12938beace95(_value, percent) {
    let base = 255; //percent > 0 ? 255 - value : value;
    return Math.round(base * percent);
}
function $05b1b40b69b15016$export$44af652f4cca9039(color) {
    return (color.r * 299 + color.g * 587 + color.b * 114) / 1000 >= 128;
}
function $05b1b40b69b15016$export$5fcac96f5a87e3db(rgb, saturation) {
    if (rgb === undefined || saturation == 1) return rgb;
    let hsl = $05b1b40b69b15016$export$c85ca4f4753af384(rgb);
    hsl.s = saturation;
    return $05b1b40b69b15016$export$29fb7152bd3f781a(hsl);
}
function $05b1b40b69b15016$export$521a2e6212201f40(color, lightAlternative = {
    r: 255,
    g: 255,
    b: 255
}, darkAlternative = {
    r: 255,
    g: 255,
    b: 255
}) {
    let light = lightAlternative;
    let dark = darkAlternative;
    if ($05b1b40b69b15016$export$44af652f4cca9039(darkAlternative)) {
        light = darkAlternative;
        dark = lightAlternative;
    }
    return $05b1b40b69b15016$export$44af652f4cca9039(color) ? dark : light;
}
function $05b1b40b69b15016$export$88ad500ef99d1561(tags1, tags2) {
    if (!tags1) tags1 = [];
    return [
        ...tags1,
        ...tags2
    ].filter((value, index, self)=>{
        return self.indexOf(value) === index;
    });
}
function $05b1b40b69b15016$export$e514d95a51bdfbdf(a, b) {
    if (!b) return false;
    if (a.left != b.left) return false;
    if (a.right != b.right) return false;
    if (a.top != b.top) return false;
    if (a.bottom != b.bottom) return false;
    return true;
}



/**
 * @ignore
 */ function $389de129b6cd18b1$var$string2hex(string) {
    //string = cssColorNames[string.toLowerCase()] || string;
    if (string[0] === "#") string = string.substr(1);
    if (string.length == 3) string = string[0].repeat(2) + string[1].repeat(2) + string[2].repeat(2);
    return parseInt(string, 16);
}
function $389de129b6cd18b1$export$4e59d32275d2248b(color) {
    color = color.replace(/[ ]/g, "");
    // Init
    let matches = color.match(/^rgb\(([0-9]*),([0-9]*),([0-9]*)\)/i);
    // Try rgb() format
    if (matches) matches.push("1");
    else {
        matches = color.match(/^rgba\(([0-9]*),([0-9]*),([0-9]*),([.0-9]*)\)/i);
        if (!matches) return 0x000000;
    }
    let hex = "";
    for(let i = 1; i <= 3; i++){
        let val = parseInt(matches[i]).toString(16);
        if (val.length == 1) val = "0" + val;
        hex += val;
    }
    return $389de129b6cd18b1$var$string2hex(hex);
}
function $389de129b6cd18b1$export$35e9368ef982300f(input) {
    return $389de129b6cd18b1$export$892596cec99bc70e.fromAny(input);
}
class $389de129b6cd18b1$export$892596cec99bc70e {
    constructor(hex){
        this._hex = hex | 0;
    }
    /**
     * Color numeric value.
     */ get hex() {
        return this._hex;
    }
    /**
     * Value of color's R channel.
     * @return R value
     */ get r() {
        return this._hex >>> 16;
    }
    /**
     * Value of color's G channel.
     * @return G value
     */ get g() {
        return this._hex >> 8 & 0xFF;
    }
    /**
     * Value of color's B channel.
     * @return B value
     */ get b() {
        return this._hex & 0xFF;
    }
    /**
     * Returns color CSS representation in form of `rgba(r, g, b, a)` string.
     *
     * @param   alpha  Opacity
     * @return         CSS string
     */ toCSS(alpha = 1) {
        return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + alpha + ")";
    }
    /**
     * Returns color CSS representation in form of `#rgb` string.
     *
     * @return         CSS string
     */ toCSSHex() {
        return "#" + $05b1b40b69b15016$export$e3f9b6bf3780ff6e(this.r.toString(16), 2) + $05b1b40b69b15016$export$e3f9b6bf3780ff6e(this.g.toString(16), 2) + $05b1b40b69b15016$export$e3f9b6bf3780ff6e(this.b.toString(16), 2);
    }
    /**
     * Returns color's HSL info.
     * @param   alpha Opacity
     * @return        HSL info
     */ toHSL(alpha = 1) {
        return $05b1b40b69b15016$export$c85ca4f4753af384({
            r: this.r,
            g: this.g,
            b: this.b,
            a: alpha
        });
    }
    /**
     * Converts HSL values into a new [[Color]] object.
     *
     * @param   h H value
     * @param   s S value
     * @param   l L value
     * @return    Color object
     */ static fromHSL(h, s, l) {
        const rgb = $05b1b40b69b15016$export$29fb7152bd3f781a({
            h: h,
            s: s,
            l: l
        });
        return this.fromRGB(rgb.r, rgb.g, rgb.b);
    }
    toString() {
        return this.toCSSHex();
    }
    /**
     * Converts hex number into a new [[Color]] object.
     *
     * ```TypeScript
     * Color.fromHex(0xff0000) // red
     * ```
     * ```JavaScript
     * Color.fromHex(0xff0000) // red
     * ```
     *
     * @param   hex  Hex color
     * @return       Color
     */ static fromHex(hex) {
        return new $389de129b6cd18b1$export$892596cec99bc70e(hex);
    }
    /**
     * Converts RGB values to a new [[Color]] object.
     *
     * @param   r  R value
     * @param   g  G value
     * @param   b  B value
     * @return     Color
     */ static fromRGB(r, g, b) {
        return new $389de129b6cd18b1$export$892596cec99bc70e((b | 0) + (g << 8) + (r << 16));
    }
    /**
     * Converts RGB string to a new [[Color]] object.
     *
     * ```TypeScript
     * Color.fromString("#ff0000") // red
     * ```
     * ```JavaScript
     * Color.fromString("#ff0000") // red
     * ```
     *
     * @param   s  RGB string
     * @return     Color
     */ static fromString(s) {
        return new $389de129b6cd18b1$export$892596cec99bc70e($389de129b6cd18b1$var$string2hex(s));
    }
    /**
     * Converts CSS rgba() syntax to a new [[Color]] object.
     *
     * ```TypeScript
     * Color.fromCSS("rgba(255, 0, 0, 1)") // red
     * ```
     * ```JavaScript
     * Color.fromCSS("rgba(255, 0, 0, 1)") // red
     * ```
     *
     * @param  {string} s [description]
     * @return {Color}    [description]
     */ static fromCSS(s) {
        return new $389de129b6cd18b1$export$892596cec99bc70e($389de129b6cd18b1$export$4e59d32275d2248b(s));
    }
    /**
     * Convert to color from virtually anything.
     *
     * Will throw an exception if unable to resolve the color.
     *
     * @param   s  Source
     * @return     Color
     */ static fromAny(s) {
        if ($f63bdea45a89cf24$export$844ec244b1367d54(s)) {
            if (s[0] == "#") return $389de129b6cd18b1$export$892596cec99bc70e.fromString(s);
            else if (s.substr(0, 3) == "rgb") return $389de129b6cd18b1$export$892596cec99bc70e.fromCSS(s);
        } else if ($f63bdea45a89cf24$export$7e4aa119212bc614(s)) return $389de129b6cd18b1$export$892596cec99bc70e.fromHex(s);
        else if (s instanceof $389de129b6cd18b1$export$892596cec99bc70e) return $389de129b6cd18b1$export$892596cec99bc70e.fromHex(s.hex);
        throw new Error("Unknown color syntax: " + s);
    }
    /**
     * Returns a new [[Color]] object based on either `lightAlternative` or
     * `darkAlternative` depending on which one is more contrasting with
     * the `color`.
     *
     * @param   color             Reference color
     * @param   lightAlternative  Light color
     * @param   darkAlternative   Dark color
     * @return                    Alternative color
     */ static alternative(color, lightAlternative, darkAlternative) {
        const rgb = $05b1b40b69b15016$export$521a2e6212201f40({
            r: color.r,
            g: color.g,
            b: color.b
        }, lightAlternative ? {
            r: lightAlternative.r,
            g: lightAlternative.g,
            b: lightAlternative.b
        } : undefined, darkAlternative ? {
            r: darkAlternative.r,
            g: darkAlternative.g,
            b: darkAlternative.b
        } : undefined);
        return this.fromRGB(rgb.r, rgb.g, rgb.b);
    }
    /**
     * Returns an intermediate Color between two reference colors depending on
     * the progress (`diff`) between the two.
     *
     * @param   diff  Progress
     * @param   from  Source color
     * @param   to    Target color
     * @param   mode  Interpolation mode
     * @return        Color
     */ static interpolate(diff, from, to, mode = "rgb") {
        if (mode == "hsl") {
            const fromHSL = from.toHSL();
            const toHSL = to.toHSL();
            return $389de129b6cd18b1$export$892596cec99bc70e.fromHSL((0, $43e0e2dc9c95da4e$export$d02631cccf789723)(diff, fromHSL.h, toHSL.h), (0, $43e0e2dc9c95da4e$export$d02631cccf789723)(diff, fromHSL.s, toHSL.s), (0, $43e0e2dc9c95da4e$export$d02631cccf789723)(diff, fromHSL.l, toHSL.l));
        } else return $389de129b6cd18b1$export$892596cec99bc70e.fromRGB((0, $43e0e2dc9c95da4e$export$d02631cccf789723)(diff, from.r, to.r), (0, $43e0e2dc9c95da4e$export$d02631cccf789723)(diff, from.g, to.g), (0, $43e0e2dc9c95da4e$export$d02631cccf789723)(diff, from.b, to.b));
    }
    /**
     * Returns a new [[Color]] lightened by `percent` value.
     *
     * Use negative value to darken the color.
     *
     * @param   color    Source color
     * @param   percent  Percent
     * @return           New color
     */ static lighten(color, percent) {
        const rgb = $05b1b40b69b15016$export$c0816ed86df316af({
            r: color.r,
            g: color.g,
            b: color.b
        }, percent);
        return $389de129b6cd18b1$export$892596cec99bc70e.fromRGB(rgb.r, rgb.g, rgb.b);
    }
    /**
     * Returns a new [[Color]] brightened by `percent` value.
     *
     * Use negative value to dim the color.
     *
     * @param   color    Source color
     * @param   percent  Percent
     * @return           New color
     */ static brighten(color, percent) {
        const rgb = $05b1b40b69b15016$export$382cdde3a5b8f440({
            r: color.r,
            g: color.g,
            b: color.b
        }, percent);
        return $389de129b6cd18b1$export$892596cec99bc70e.fromRGB(rgb.r, rgb.g, rgb.b);
    }
    /**
     * Returns a new [[Color]] saturated by `percent` value.
     *
     * Value range is between `0` (fully desaturated), to `1` (full color).
     *
     * @param   color    Source color
     * @param   percent  Percent
     * @return           New color
     */ static saturate(color, percent) {
        const rgb = $05b1b40b69b15016$export$5fcac96f5a87e3db({
            r: color.r,
            g: color.g,
            b: color.b
        }, percent);
        return $389de129b6cd18b1$export$892596cec99bc70e.fromRGB(rgb.r, rgb.g, rgb.b);
    }
}

var $b4231ef84a5f8a61$exports = {};

$parcel$export($b4231ef84a5f8a61$exports, "linear", () => $b4231ef84a5f8a61$export$45db2fc2f15997e7);
$parcel$export($b4231ef84a5f8a61$exports, "quad", () => $b4231ef84a5f8a61$export$9fc5786234c4f1e);
$parcel$export($b4231ef84a5f8a61$exports, "cubic", () => $b4231ef84a5f8a61$export$bdd5293f3cf7a909);
$parcel$export($b4231ef84a5f8a61$exports, "pow", () => $b4231ef84a5f8a61$export$9c297f60e22e3389);
$parcel$export($b4231ef84a5f8a61$exports, "exp", () => $b4231ef84a5f8a61$export$b310ec824aaee37f);
$parcel$export($b4231ef84a5f8a61$exports, "sine", () => $b4231ef84a5f8a61$export$ed296354ff2387bf);
$parcel$export($b4231ef84a5f8a61$exports, "circle", () => $b4231ef84a5f8a61$export$e1d786d2f707b414);
$parcel$export($b4231ef84a5f8a61$exports, "yoyo", () => $b4231ef84a5f8a61$export$1df536d55b20c667);
$parcel$export($b4231ef84a5f8a61$exports, "out", () => $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7);
$parcel$export($b4231ef84a5f8a61$exports, "inOut", () => $b4231ef84a5f8a61$export$5a8263081d3114f8);
$parcel$export($b4231ef84a5f8a61$exports, "bounce", () => $b4231ef84a5f8a61$export$e3ce947fb98643bf);
$parcel$export($b4231ef84a5f8a61$exports, "elastic", () => $b4231ef84a5f8a61$export$e3f8198a677f57c2);
/**
 * A collection of easing functions
 *
 * Parts of this collection are taken from D3.js library (https://d3js.org/)
 */ /**
 * ============================================================================
 * IMPORTS
 * ============================================================================
 * @hidden
 */ 
const $f43e9e04b3f0548b$export$6b5c1ceb16d01dc3 = Math.PI;
const $f43e9e04b3f0548b$export$19368ff9fe7c15f9 = $f43e9e04b3f0548b$export$6b5c1ceb16d01dc3 / 2;
const $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a = $f43e9e04b3f0548b$export$6b5c1ceb16d01dc3 / 180;
const $f43e9e04b3f0548b$export$e035ae0f6b8ef5d = 180 / $f43e9e04b3f0548b$export$6b5c1ceb16d01dc3;
function $f43e9e04b3f0548b$export$2077e0241d6afd3c(value, precision, floor) {
    if (!(0, $f63bdea45a89cf24$export$7e4aa119212bc614)(precision) || precision <= 0) {
        let rounded = Math.round(value);
        if (floor) {
            if (rounded - value == 0.5) rounded--;
        }
        return rounded;
    } else {
        let d = Math.pow(10, precision);
        return Math.round(value * d) / d;
    }
}
function $f43e9e04b3f0548b$export$803ce6b71a0a94b2(value, precision) {
    if (!(0, $f63bdea45a89cf24$export$7e4aa119212bc614)(precision) || precision <= 0) return Math.ceil(value);
    else {
        let d = Math.pow(10, precision);
        return Math.ceil(value * d) / d;
    }
}
function $f43e9e04b3f0548b$export$14d154ec2f45fa18(p0, p1, p2, tensionX, tensionY) {
    return {
        x: (-p0.x + p1.x / tensionX + p2.x) * tensionX,
        y: (-p0.y + p1.y / tensionY + p2.y) * tensionY
    };
}
function $f43e9e04b3f0548b$export$e01ac8bd95dd3fa5(p1, p2, p3, tensionX, tensionY) {
    return {
        x: (p1.x + p2.x / tensionX - p3.x) * tensionX,
        y: (p1.y + p2.y / tensionY - p3.y) * tensionY
    };
}
function $f43e9e04b3f0548b$export$386b748ab02f16a0(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle) {
    return Math.sin($f43e9e04b3f0548b$export$fd1bf64c4a4ea04a * angle);
}
function $f43e9e04b3f0548b$export$fcdd3b0b3246a325(angle) {
    return Math.tan($f43e9e04b3f0548b$export$fd1bf64c4a4ea04a * angle);
}
function $f43e9e04b3f0548b$export$50d414a77b60d802(angle) {
    return Math.cos($f43e9e04b3f0548b$export$fd1bf64c4a4ea04a * angle);
}
function $f43e9e04b3f0548b$export$e3df76cf4464bc81(value) {
    value = value % 360;
    if (value < 0) value += 360;
    return value;
}
function $f43e9e04b3f0548b$export$87d7822d7a31793f(cx, cy, startAngle, endAngle, radius) {
    // Guard against non-finite angles (e.g. a radar chart whose start/end angle
    // was set to NaN or Infinity) and against a full-circle-or-more span. Without
    // this, the 90°-step loop below runs forever (Infinity) or returns NaN bounds.
    // In both cases fall back to the full-radius box so callers stay finite.
    if (!Number.isFinite(startAngle) || !Number.isFinite(endAngle) || Math.abs(endAngle - startAngle) >= 360) {
        const r = Number.isFinite(radius) ? Math.abs(radius) : 0;
        return {
            left: cx - r,
            top: cy - r,
            right: cx + r,
            bottom: cy + r
        };
    }
    let minX = Number.MAX_VALUE;
    let minY = Number.MAX_VALUE;
    let maxX = -Number.MAX_VALUE;
    let maxY = -Number.MAX_VALUE;
    let bpoints = [];
    bpoints.push($f43e9e04b3f0548b$export$7fbabd36a4c7fdd8(radius, startAngle));
    bpoints.push($f43e9e04b3f0548b$export$7fbabd36a4c7fdd8(radius, endAngle));
    let fromAngle = Math.min(Math.floor(startAngle / 90) * 90, Math.floor(endAngle / 90) * 90);
    let toAngle = Math.max(Math.ceil(startAngle / 90) * 90, Math.ceil(endAngle / 90) * 90);
    for(let angle = fromAngle; angle <= toAngle; angle += 90)if (angle >= startAngle && angle <= endAngle) bpoints.push($f43e9e04b3f0548b$export$7fbabd36a4c7fdd8(radius, angle));
    for(let i = 0; i < bpoints.length; i++){
        let pt = bpoints[i];
        if (pt.x < minX) minX = pt.x;
        if (pt.y < minY) minY = pt.y;
        if (pt.x > maxX) maxX = pt.x;
        if (pt.y > maxY) maxY = pt.y;
    }
    return {
        left: cx + minX,
        top: cy + minY,
        right: cx + maxX,
        bottom: cy + maxY
    };
}
function $f43e9e04b3f0548b$export$7fbabd36a4c7fdd8(radius, arc) {
    return {
        x: radius * $f43e9e04b3f0548b$export$50d414a77b60d802(arc),
        y: radius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(arc)
    };
}
function $f43e9e04b3f0548b$export$579a8a269cc78035(bounds) {
    const len = bounds.length;
    if (len > 0) {
        let bound = bounds[0];
        let left = bound.left;
        let top = bound.top;
        let right = bound.right;
        let bottom = bound.bottom;
        if (len > 1) for(let i = 1; i < len; i++){
            bound = bounds[i];
            left = Math.min(bound.left, left);
            right = Math.max(bound.right, right);
            top = Math.min(bound.top, top);
            bottom = Math.max(bound.bottom, bottom);
        }
        return {
            left: left,
            right: right,
            top: top,
            bottom: bottom
        };
    }
    return {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
}
function $f43e9e04b3f0548b$export$11190c390398c8e8(value, startAngle, endAngle) {
    if (startAngle > endAngle) {
        let temp = startAngle;
        startAngle = endAngle;
        endAngle = temp;
    }
    value = $f43e9e04b3f0548b$export$e3df76cf4464bc81(value);
    let count = (startAngle - $f43e9e04b3f0548b$export$e3df76cf4464bc81(startAngle)) / 360;
    if (value < startAngle) value += 360 * (count + 1);
    let maxEnd = startAngle + (endAngle - startAngle) / 2 + 180;
    let maxStart = startAngle + (endAngle - startAngle) / 2 - 180;
    if (value > endAngle) {
        if (value - 360 > startAngle) value -= 360;
        else if (value < maxEnd) value = endAngle;
        else value = startAngle;
    }
    if (value < startAngle) {
        if (value > maxStart) value = startAngle;
        else value = endAngle;
    }
    return value;
}
function $f43e9e04b3f0548b$export$4e985c1b25c164db(point, bounds) {
    if (point.x >= bounds.left && point.y >= bounds.top && point.x <= bounds.right && point.y <= bounds.bottom) return true;
    return false;
}
function $f43e9e04b3f0548b$export$b363da9ded343252(point1, point2) {
    if (!point2) point2 = {
        x: point1.x * 2,
        y: point1.y * 2
    };
    let diffX = point2.x - point1.x;
    let diffY = point2.y - point1.y;
    let angle = Math.atan2(diffY, diffX) * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d;
    if (angle < 0) angle += 360;
    return $f43e9e04b3f0548b$export$e3df76cf4464bc81(angle);
}
function $f43e9e04b3f0548b$export$7c5d545dd69e252(pointA, pointB, controlPoint, position) {
    let x = (1 - position) * (1 - position) * pointA.x + 2 * (1 - position) * position * controlPoint.x + position * position * pointB.x;
    let y = (1 - position) * (1 - position) * pointA.y + 2 * (1 - position) * position * controlPoint.y + position * position * pointB.y;
    return {
        x: x,
        y: y
    };
}
function $f43e9e04b3f0548b$export$243934d75dbc081(pointA, pointB, controlPointA, controlPointB, position) {
    let s = 1 - position;
    let x = s * s * s * pointA.x + 3 * s * s * position * controlPointA.x + 3 * s * position * position * controlPointB.x + position * position * position * pointB.x;
    let y = s * s * s * pointA.y + 3 * s * s * position * controlPointA.y + 3 * s * position * position * controlPointB.y + position * position * position * pointB.y;
    return {
        x: x,
        y: y
    };
}
function $f43e9e04b3f0548b$export$aa50121ccd6f9820(pointA, pointB, position) {
    return {
        x: pointA.x + (pointB.x - pointA.x) * position,
        y: pointA.y + (pointB.y - pointA.y) * position
    };
}
function $f43e9e04b3f0548b$export$8ca14561c8547668(location, cumulativeLengths) {
    const n = cumulativeLengths.length;
    if (n > 0) {
        const totalLength = cumulativeLengths[n - 1];
        const targetLength = location * totalLength;
        let index = 0;
        for(let i = 0; i < n; i++)if (cumulativeLengths[i] >= targetLength) {
            index = i;
            break;
        }
        const segStart = index > 0 ? cumulativeLengths[index - 1] : 0;
        const segLength = cumulativeLengths[index] - segStart;
        const t = segLength > 0 ? (targetLength - segStart) / segLength : 0;
        return {
            index: index,
            t: t
        };
    }
    return {
        index: 0,
        t: 0
    };
}
function $f43e9e04b3f0548b$export$ff7f7c97cdce86e(values, referenceValue) {
    return values.reduce(function(prev, curr) {
        return Math.abs(curr - referenceValue) < Math.abs(prev - referenceValue) ? curr : prev;
    });
}
function $f43e9e04b3f0548b$export$1e5bc424ba85580e(bounds1, bounds2) {
    const horizontalOverlap = bounds1.left < bounds2.right && bounds1.right > bounds2.left;
    const verticalOverlap = bounds1.top < bounds2.bottom && bounds1.bottom > bounds2.top;
    return horizontalOverlap && verticalOverlap;
}
function $f43e9e04b3f0548b$export$78c3736b1524effc(cx, cy, radius, radiusY, innerRadius, step, radiusStep, startAngle, endAngle) {
    let r = innerRadius + 0.01;
    startAngle = $f43e9e04b3f0548b$export$e3df76cf4464bc81(startAngle);
    endAngle = $f43e9e04b3f0548b$export$e3df76cf4464bc81(endAngle);
    let angle = startAngle * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a;
    if (endAngle < startAngle) endAngle += 360;
    let points = [];
    while(r < radius + radiusStep){
        let stepSize = step;
        if (stepSize / 2 > r) stepSize = 2 * r;
        let c = Math.max(0.01, Math.min(1, r / 200));
        stepSize = stepSize * c;
        let degrees = angle * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d;
        let point = {
            x: cx + r * Math.cos(angle),
            y: cy + r * radiusY / radius * Math.sin(angle)
        };
        points.push(point);
        r = innerRadius + 0.01 + (degrees - startAngle) / 360 * radiusStep;
        angle += 2 * Math.asin(stepSize / 2 / r);
        if (angle * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d > endAngle + 360 * Math.ceil((radius - innerRadius) / radiusStep)) break;
    }
    points.shift();
    return points;
}
function $f43e9e04b3f0548b$export$e2b16992bf4fd2ff(circle1, circle2) {
    return Math.hypot(circle1.x - circle2.x, circle1.y - circle2.y) <= circle1.radius + circle2.radius;
}


function $b4231ef84a5f8a61$export$45db2fc2f15997e7(t) {
    return t;
}
function $b4231ef84a5f8a61$export$9fc5786234c4f1e(t) {
    return t * t;
}
function $b4231ef84a5f8a61$export$bdd5293f3cf7a909(t) {
    return t * t * t;
}
function $b4231ef84a5f8a61$export$9c297f60e22e3389(t, e) {
    return Math.pow(t, e);
}
function $b4231ef84a5f8a61$export$b310ec824aaee37f(t) {
    return Math.pow(2, 10 * t - 10);
}
function $b4231ef84a5f8a61$export$ed296354ff2387bf(t) {
    return 1 - Math.cos(t * $f43e9e04b3f0548b$export$19368ff9fe7c15f9);
}
function $b4231ef84a5f8a61$export$e1d786d2f707b414(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $b4231ef84a5f8a61$export$1df536d55b20c667(ease) {
    return function(t) {
        if (t < 0.5) return ease(t * 2.0);
        else return ease((1.0 - t) * 2.0);
    };
}
function $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7(ease) {
    return function(t) {
        return 1.0 - ease(1.0 - t);
    };
}
function $b4231ef84a5f8a61$export$5a8263081d3114f8(ease) {
    return function(t) {
        if (t <= 0.5) return ease(t * 2.0) / 2.0;
        else return 1.0 - ease((1.0 - t) * 2.0) / 2.0;
    };
}
/**
 * ============================================================================
 * BOUNCE
 * ============================================================================
 * @hidden
 */ let $b4231ef84a5f8a61$var$b1 = 4 / 11, $b4231ef84a5f8a61$var$b2 = 6 / 11, $b4231ef84a5f8a61$var$b3 = 8 / 11, $b4231ef84a5f8a61$var$b4 = 3 / 4, $b4231ef84a5f8a61$var$b5 = 9 / 11, $b4231ef84a5f8a61$var$b6 = 10 / 11, $b4231ef84a5f8a61$var$b7 = 15 / 16, $b4231ef84a5f8a61$var$b8 = 21 / 22, $b4231ef84a5f8a61$var$b9 = 63 / 64, $b4231ef84a5f8a61$var$b0 = 1 / $b4231ef84a5f8a61$var$b1 / $b4231ef84a5f8a61$var$b1;
function $b4231ef84a5f8a61$export$e3ce947fb98643bf(t) {
    return 1 - $b4231ef84a5f8a61$var$bounceOut(1 - t);
}
/**
 * @ignore
 */ function $b4231ef84a5f8a61$var$bounceOut(t) {
    t;
    if (t < $b4231ef84a5f8a61$var$b1) return $b4231ef84a5f8a61$var$b0 * t * t;
    else if (t < $b4231ef84a5f8a61$var$b3) return $b4231ef84a5f8a61$var$b0 * (t -= $b4231ef84a5f8a61$var$b2) * t + $b4231ef84a5f8a61$var$b4;
    else if (t < $b4231ef84a5f8a61$var$b6) return $b4231ef84a5f8a61$var$b0 * (t -= $b4231ef84a5f8a61$var$b5) * t + $b4231ef84a5f8a61$var$b7;
    else return $b4231ef84a5f8a61$var$b0 * (t -= $b4231ef84a5f8a61$var$b8) * t + $b4231ef84a5f8a61$var$b9;
}
/**
 * ============================================================================
 * ELASTIC
 * ============================================================================
 * @hidden
 */ /**
 * @ignore
 */ let $b4231ef84a5f8a61$var$tau = 2 * Math.PI;
/**
 * @ignore
 */ let $b4231ef84a5f8a61$var$amplitude = 1;
/**
 * @ignore
 */ let $b4231ef84a5f8a61$var$period = 0.3 / $b4231ef84a5f8a61$var$tau;
/**
 * @ignore
 */ let $b4231ef84a5f8a61$var$s = Math.asin(1 / $b4231ef84a5f8a61$var$amplitude) * $b4231ef84a5f8a61$var$period;
function $b4231ef84a5f8a61$export$e3f8198a677f57c2(t) {
    let v = t;
    return $b4231ef84a5f8a61$var$amplitude * Math.pow(2, 10 * --v) * Math.sin(($b4231ef84a5f8a61$var$s - v) / $b4231ef84a5f8a61$var$period);
}






class $dad453b54c84e86c$export$7254cc27399e90bd {
    constructor(entity, settings){
        this._userSettings = {};
        this._entity = entity;
        this._settings = settings;
        $e66f9343b5144e1a$export$79b2f7037acddd43(settings, (key)=>{
            this._userSettings[key] = true;
        });
    }
    get(key, fallback) {
        const value = this._settings[key];
        if (value !== undefined) return value;
        else return fallback;
    }
    /**
     * @ignore
     */ setRaw(key, value) {
        this._settings[key] = value;
    }
    /**
     * Sets a setting `value` for the specified `key` to be set when the state
     * is applied.
     *
     * @param   key       Setting key
     * @param   value     Setting value
     * @return            Setting value
     */ set(key, value) {
        this._userSettings[key] = true;
        this.setRaw(key, value);
    }
    /**
     * Removes a setting value for the specified `key`.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param   key       Setting key
     */ remove(key) {
        delete this._userSettings[key];
        delete this._settings[key];
    }
    /**
     * Sets multiple settings at once.
     *
     * `settings` must be an object with key: value pairs.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param settings Settings
     */ setAll(settings) {
        $e66f9343b5144e1a$export$3e9f948b41964866(settings).forEach(([key, value])=>{
            this.set(key, value);
        });
    }
    _eachSetting(f) {
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._settings, f);
    }
    /**
     * Applies the state to the target element.
     *
     * All setting values are set immediately.
     */ apply() {
        const seen = {};
        seen["stateAnimationEasing"] = true;
        seen["stateAnimationDuration"] = true;
        const defaultState = this._entity.states.lookup("default");
        this._eachSetting((key, value)=>{
            if (!seen[key]) {
                seen[key] = true;
                // save values to default state
                if (this !== defaultState) {
                    if (!(key in defaultState._settings)) defaultState._settings[key] = this._entity.get(key);
                }
                this._entity.set(key, value);
            }
        });
    }
    /**
     * Applies the state to the target element.
     *
     * Returns an object representing all [[Animation]] objects created for
     * each setting key transition.
     *
     * @return           Animations
     */ applyAnimate(duration) {
        if (duration == null) duration = this._settings.stateAnimationDuration;
        if (duration == null) duration = this.get("stateAnimationDuration", this._entity.get("stateAnimationDuration", 0));
        let easing = this._settings.stateAnimationEasing;
        if (easing == null) easing = this.get("stateAnimationEasing", this._entity.get("stateAnimationEasing", $b4231ef84a5f8a61$export$bdd5293f3cf7a909));
        const defaultState = this._entity.states.lookup("default");
        const seen = {};
        seen["stateAnimationEasing"] = true;
        seen["stateAnimationDuration"] = true;
        const animations = {};
        this._eachSetting((key, value)=>{
            if (!seen[key]) {
                seen[key] = true;
                // save values to default state
                if (this != defaultState) {
                    if (!(key in defaultState._settings)) defaultState._settings[key] = this._entity.get(key);
                }
                const animation = this._entity.animate({
                    key: key,
                    to: value,
                    duration: duration,
                    easing: easing
                });
                if (animation) animations[key] = animation;
            }
        });
        return animations;
    }
}
class $dad453b54c84e86c$export$47283907dceba392 {
    constructor(entity){
        this._states = {};
        this._entity = entity;
    }
    /**
     * Checks if a state by `name` exists. Returns it there is one.
     *
     * @param  name  State name
     * @return       State
     */ lookup(name) {
        return this._states[name];
    }
    /**
     * Sets supplied `settings` on a state by the `name`.
     *
     * If such state does not yet exists, it is created.
     *
     * @param   name      State name
     * @param   settings  Settings
     * @return            New State
     */ create(name, settings) {
        const state = this._states[name];
        if (state) {
            state.setAll(settings);
            return state;
        } else {
            const state = new $dad453b54c84e86c$export$7254cc27399e90bd(this._entity, settings);
            this._states[name] = state;
            return state;
        }
    }
    /**
     * Removes the state called `name`.
     *
     * @param   name      State name
     */ remove(name) {
        delete this._states[name];
    }
    /**
     * Applies a named state to the target element.
     *
     * @param  newState  State name
     */ apply(newState) {
        const state = this._states[newState];
        if (state) state.apply();
        this._entity._applyState(newState);
    }
    /**
     * Applies a named state to the element.
     *
     * Returns an object representing all [[Animation]] objects created for
     * each setting key transition.
     *
     * @param   newState  State name
     * @return            Animations
     */ applyAnimate(newState, duration) {
        let animations;
        const state = this._states[newState];
        if (state) animations = state.applyAnimate(duration);
        this._entity._applyStateAnimated(newState, duration);
        return animations;
    }
}


/**
 * @ignore
 */ class $ca44c6881f0f20f2$export$4d9facee29974f3 {
    constructor(){
        /**
         * Currently running version of amCharts.
         */ this.version = "5.20.2";
        /**
         * List of applied licenses.
         * @ignore
         */ this.licenses = [];
        /**
         * Entities that have their `id` setting set.
         */ this.entitiesById = {};
        /**
         * All created [[Root]] elements.
         */ this.rootElements = [];
        /**
         * Automatically dispose a [[Root]] element if it exists in the target container.
         *
         * @since 5.14.4
         */ this.autoDispose = false;
    }
}
const $ca44c6881f0f20f2$export$4bb7493d241fd8a5 = new $ca44c6881f0f20f2$export$4d9facee29974f3();
function $ca44c6881f0f20f2$export$ba39f222840336cc(license) {
    $ca44c6881f0f20f2$export$4bb7493d241fd8a5.licenses.push(license);
}
function $ca44c6881f0f20f2$export$f2057baa9f9c7ff0() {
    let root;
    while(root = $ca44c6881f0f20f2$export$4bb7493d241fd8a5.rootElements.pop())root.dispose();
}
function $ca44c6881f0f20f2$export$c2104fb60145748d(id) {
    let found;
    $ca44c6881f0f20f2$export$4bb7493d241fd8a5.rootElements.forEach((item)=>{
        if (item.dom.id == id) found = item;
    });
    return found;
}





/**
 * @ignore
 */ function $919e90129af4490b$export$398604a469f7de9a(left, right) {
    if (left === right) return 0;
    else if (left < right) return -1;
    else return 1;
}
function $919e90129af4490b$export$cb07857b027678fa(left, right, f) {
    const leftLength = left.length;
    const rightLength = right.length;
    const length = Math.min(leftLength, rightLength);
    for(let i = 0; i < length; ++i){
        const order = f(left[i], right[i]);
        if (order !== 0) return order;
    }
    return $919e90129af4490b$export$398604a469f7de9a(leftLength, rightLength);
}
function $919e90129af4490b$export$66c1ae025e96b4bc(order) {
    if (order < 0) return 1;
    else if (order > 0) return -1;
    else return 0;
}
function $919e90129af4490b$export$608e63ca0eb1cfcc(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
}


class $baeade534ece7f4c$export$aa533d00238abcca {
    constructor(entity){
        this._callbacks = {};
        this._disabled = {};
        this._entity = entity;
    }
    /**
     * Add a function (`callback`) that will modify value for setting `key`.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/adapters/} for more info
     */ add(key, callback) {
        let callbacks = this._callbacks[key];
        if (callbacks === undefined) callbacks = this._callbacks[key] = [];
        callbacks.push(callback);
        this._entity._markDirtyKey(key);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            if ($2f30431acd054e2f$export$2529f734547e2830(callbacks, callback)) this._entity._markDirtyKey(key);
        });
    }
    /**
     * Removes all adapters for the specific key.
     *
     * @since 5.1.0
     */ remove(key) {
        const callbacks = this._callbacks[key];
        if (callbacks !== undefined) {
            delete this._callbacks[key];
            if (callbacks.length !== 0) this._entity._markDirtyKey(key);
        }
    }
    /**
     * Enables (previously disabled) adapters for specific key.
     *
     * @since 5.1.0
     */ enable(key) {
        if (this._disabled[key]) {
            delete this._disabled[key];
            this._entity._markDirtyKey(key);
        }
    }
    /**
     * Disables all adapters for specific key.
     *
     * @since 5.1.0
     */ disable(key) {
        if (!this._disabled[key]) {
            this._disabled[key] = true;
            this._entity._markDirtyKey(key);
        }
    }
    /**
     * @ignore
     */ fold(key, value) {
        if (!this._disabled[key]) {
            const callbacks = this._callbacks[key];
            if (callbacks !== undefined) for(let i = 0, len = callbacks.length; i < len; ++i)value = callbacks[i](value, this._entity, key);
        }
        return value;
    }
}
class $baeade534ece7f4c$export$c35d437ae5945fcd {
    constructor(animation, from, to, duration, easing, loops, startingTime){
        this._time = 0;
        this._stopped = false;
        this._playing = true;
        this.events = new (0, $7e417cbab1b21893$export$ec8b666c5fe2c75a)();
        this._animation = animation;
        this._from = from;
        this._to = to;
        this._duration = duration;
        this._easing = easing;
        this._loops = loops;
        this._interpolate = (0, $43e0e2dc9c95da4e$export$d9af756d8d8c2d47)(from, to);
        this._oldTime = startingTime;
    }
    get to() {
        return this._to;
    }
    get from() {
        return this._from;
    }
    get playing() {
        return this._playing;
    }
    get stopped() {
        return this._stopped;
    }
    stop() {
        if (!this._stopped) {
            this._stopped = true;
            this._playing = false;
            if (this.events.isEnabled("stopped")) this.events.dispatch("stopped", {
                type: "stopped",
                target: this
            });
        }
    }
    pause() {
        this._playing = false;
        this._oldTime = null;
    }
    play() {
        if (!this._stopped && !this._playing) {
            this._playing = true;
            this._animation._startAnimation();
        }
    }
    get percentage() {
        return this._time / this._duration;
    }
    waitForStop() {
        return new Promise((resolve, _reject)=>{
            if (this._stopped) resolve();
            else {
                const listener = ()=>{
                    stopped.dispose();
                    resolve();
                };
                const stopped = this.events.on("stopped", listener);
            }
        });
    }
    _checkEnded() {
        if (this._loops > 1) {
            --this._loops;
            return false;
        } else return true;
    }
    _run(currentTime) {
        if (this._oldTime !== null) {
            this._time += currentTime - this._oldTime;
            if (this._time > this._duration) this._time = this._duration;
        }
        this._oldTime = currentTime;
    }
    _reset(currentTime) {
        this._oldTime = currentTime;
        this._time = 0;
    }
    _value(diff) {
        if (diff <= 0) return this._from;
        const eased = this._easing(diff);
        if (eased >= 0.999999) return this._to;
        if (eased <= 0.000001) return this._from;
        return this._interpolate(eased, this._from, this._to);
    }
}
/**
 * @ignore
 */ let $baeade534ece7f4c$var$counter = 0;
class $baeade534ece7f4c$export$c72f6eaae7b9adff {
    constructor(settings){
        /**
         * Unique ID.
         */ this.uid = ++$baeade534ece7f4c$var$counter;
        this._privateSettings = {};
        this._settingEvents = {};
        this._privateSettingEvents = {};
        this._debouncedSettingEvents = {};
        this._debouncedPrivateSettingEvents = {};
        this._prevSettings = {};
        this._prevPrivateSettings = {};
        this._animatingSettings = {};
        this._animatingPrivateSettings = {};
        this._disposed = false;
        // TODO move this into Entity
        this._userProperties = {};
        /**
         * If this is set to `false` then disposing does nothing, it's a no-op.
         */ this.enableDispose = true;
        this._settings = settings;
    }
    _checkDirty() {
        $e66f9343b5144e1a$export$ed97f33186d4b816(this._settings).forEach((key)=>{
            this._userProperties[key] = true;
            this._markDirtyKey(key);
        });
    }
    /**
     * @ignore
     */ resetUserSettings() {
        this._userProperties = {};
    }
    _runAnimation(currentTime) {
        let state = (0, $43e0e2dc9c95da4e$export$d0f7a26c90cc1562).Stopped;
        if (!this.isDisposed()) {
            let playing = false;
            let paused = false;
            $e66f9343b5144e1a$export$79b2f7037acddd43(this._animatingSettings, (key, animation)=>{
                if (animation.stopped) this._stopAnimation(key);
                else if (animation.playing) {
                    animation._run(currentTime);
                    const diff = animation.percentage;
                    if (diff >= 1) {
                        if (animation._checkEnded()) this.set(key, animation._value(1));
                        else {
                            playing = true;
                            animation._reset(currentTime);
                            this._set(key, animation._value(1));
                        }
                    } else {
                        playing = true;
                        this._set(key, animation._value(diff));
                    }
                } else paused = true;
            });
            $e66f9343b5144e1a$export$79b2f7037acddd43(this._animatingPrivateSettings, (key, animation)=>{
                if (animation.stopped) this._stopAnimationPrivate(key);
                else if (animation.playing) {
                    animation._run(currentTime);
                    const diff = animation.percentage;
                    if (diff >= 1) {
                        if (animation._checkEnded()) this.setPrivate(key, animation._value(1));
                        else {
                            playing = true;
                            animation._reset(currentTime);
                            this._setPrivate(key, animation._value(1));
                        }
                    } else {
                        playing = true;
                        this._setPrivate(key, animation._value(diff));
                    }
                } else paused = true;
            });
            if (playing) state = (0, $43e0e2dc9c95da4e$export$d0f7a26c90cc1562).Playing;
            else if (paused) state = (0, $43e0e2dc9c95da4e$export$d0f7a26c90cc1562).Paused;
        }
        return state;
    }
    _markDirtyKey(_key) {
        this.markDirty();
    }
    _markDirtyPrivateKey(_key) {
        this.markDirty();
    }
    /**
     * Sets a callback function to invoke when specific key of settings changes
     * or is set.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key       Settings key
     * @param   callback  Callback
     * @return            Disposer for event
     */ on(key, callback) {
        let events = this._settingEvents[key];
        if (events === undefined) events = this._settingEvents[key] = [];
        events.push(callback);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            $2f30431acd054e2f$export$2529f734547e2830(events, callback);
            if (events.length === 0) delete this._settingEvents[key];
        });
    }
    /**
     * Removes a callback for when value of a setting changes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key       Private settings key
     * @param   callback  Callback
     * @since 5.9.2
     */ off(key, callback) {
        let events = this._settingEvents[key];
        if (events !== undefined && callback !== undefined) $2f30431acd054e2f$export$2529f734547e2830(events, callback);
        else delete this._settingEvents[key];
    }
    _onDebouncedHelper(map, key, callback, delay) {
        let events = map[key];
        if (events === undefined) events = map[key] = [];
        const entry = {
            cb: callback,
            delay: delay
        };
        events.push(entry);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            if (entry.timeout) window.clearTimeout(entry.timeout);
            $2f30431acd054e2f$export$2529f734547e2830(events, entry);
            if (events.length === 0) delete map[key];
        });
    }
    _offDebouncedHelper(map, key, callback) {
        const events = map[key];
        if (events !== undefined) {
            if (callback !== undefined) {
                const index = $2f30431acd054e2f$export$de3a4d4a0d731119(events, (e)=>e.cb === callback);
                if (index !== -1) {
                    const entry = events[index];
                    if (entry.timeout) window.clearTimeout(entry.timeout);
                    events.splice(index, 1);
                    if (events.length === 0) delete map[key];
                }
            } else {
                $2f30431acd054e2f$export$79b2f7037acddd43(events, (entry)=>{
                    if (entry.timeout) window.clearTimeout(entry.timeout);
                });
                delete map[key];
            }
        }
    }
    /**
     * Sets a debounced callback function to invoke when specific key of settings
     * changes or is set. The callback fires only once even if the setting is changed
     * multiple times within the debounce delay.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key            Settings key
     * @param   callback       Callback
     * @param   debounceDelay  Debounce delay in milliseconds
     * @return                 Disposer for event
     */ onDebounced(key, callback, debounceDelay) {
        return this._onDebouncedHelper(this._debouncedSettingEvents, key, callback, debounceDelay);
    }
    /**
     * Removes a debounced callback for when value of a setting changes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key       Settings key
     * @param   callback  Callback
     */ offDebounced(key, callback) {
        this._offDebouncedHelper(this._debouncedSettingEvents, key, callback);
    }
    /**
     * Sets a callback function to invoke when specific key of private settings
     * changes or is set.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key       Private settings key
     * @param   callback  Callback
     * @return            Disposer for event
     */ onPrivate(key, callback) {
        let events = this._privateSettingEvents[key];
        if (events === undefined) events = this._privateSettingEvents[key] = [];
        events.push(callback);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            $2f30431acd054e2f$export$2529f734547e2830(events, callback);
            if (events.length === 0) delete this._privateSettingEvents[key];
        });
    }
    /**
     * Removes a callback for when value of a private setting changes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key       Private settings key
     * @param   callback  Callback
     * @since 5.9.2
     */ offPrivate(key, callback) {
        let events = this._privateSettingEvents[key];
        if (events !== undefined && callback !== undefined) $2f30431acd054e2f$export$2529f734547e2830(events, callback);
        else delete this._privateSettingEvents[key];
    }
    /**
     * Sets a debounced callback function to invoke when specific key of private
     * settings changes or is set. The callback fires only once even if the setting
     * is changed multiple times within the debounce delay.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key            Private settings key
     * @param   callback       Callback
     * @param   debounceDelay  Debounce delay in milliseconds
     * @return                 Disposer for event
     */ onPrivateDebounced(key, callback, debounceDelay) {
        return this._onDebouncedHelper(this._debouncedPrivateSettingEvents, key, callback, debounceDelay);
    }
    /**
     * Removes a debounced callback for when value of a private setting changes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
     * @param   key       Private settings key
     * @param   callback  Callback
     */ offDebouncedPrivate(key, callback) {
        this._offDebouncedHelper(this._debouncedPrivateSettingEvents, key, callback);
    }
    /**
     * @ignore
     */ getRaw(key, fallback) {
        const value = this._settings[key];
        if (value !== undefined) return value;
        else return fallback;
    }
    /**
     * Returns `true` if the setting exists.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param   key        Settings key
     * @return  {boolean}  Key exists
     */ has(key) {
        return key in this._settings;
    }
    get(key, fallback) {
        return this.getRaw(key, fallback);
    }
    _sendKeyEvent(key, value) {
        const events = this._settingEvents[key];
        if (events !== undefined) $2f30431acd054e2f$export$79b2f7037acddd43(events, (callback)=>{
            callback(value, this, key);
        });
        const debouncedEvents = this._debouncedSettingEvents[key];
        if (debouncedEvents !== undefined) $2f30431acd054e2f$export$79b2f7037acddd43(debouncedEvents, (entry)=>{
            if (entry.timeout) window.clearTimeout(entry.timeout);
            entry.timeout = window.setTimeout(()=>{
                entry.timeout = undefined;
                entry.cb(value, this, key);
            }, entry.delay);
        });
    }
    _sendPrivateKeyEvent(key, value) {
        const events = this._privateSettingEvents[key];
        if (events !== undefined) $2f30431acd054e2f$export$79b2f7037acddd43(events, (callback)=>{
            callback(value, this, key);
        });
        const debouncedEvents = this._debouncedPrivateSettingEvents[key];
        if (debouncedEvents !== undefined) $2f30431acd054e2f$export$79b2f7037acddd43(debouncedEvents, (entry)=>{
            if (entry.timeout) window.clearTimeout(entry.timeout);
            entry.timeout = window.setTimeout(()=>{
                entry.timeout = undefined;
                entry.cb(value, this, key);
            }, entry.delay);
        });
    }
    /**
     * @ignore
     */ _setRaw(key, old, value) {
        this._prevSettings[key] = old;
        this._sendKeyEvent(key, value);
    }
    /**
     * @ignore
     */ setRaw(key, value) {
        const old = this._settings[key];
        this._settings[key] = value;
        if (old !== value) this._setRaw(key, old, value);
    }
    /**
     * @ignore
     */ _set(key, value) {
        const old = this._settings[key];
        this._settings[key] = value;
        if (old !== value) {
            this._setRaw(key, old, value);
            this._markDirtyKey(key);
        }
    }
    _stopAnimation(key) {
        const animation = this._animatingSettings[key];
        if (animation) {
            delete this._animatingSettings[key];
            animation.stop();
        }
    }
    /**
     * Sets a setting `value` for the specified `key`, and returns the same `value`.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param   key       Setting key
     * @param   value     Setting value
     * @return            Setting value
     */ set(key, value) {
        this._set(key, value);
        this._stopAnimation(key);
        return value;
    }
    /**
     * Removes a setting value for the specified `key`;
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param   key       Setting key
     */ remove(key) {
        if (key in this._settings) {
            this._prevSettings[key] = this._settings[key];
            delete this._settings[key];
            this._sendKeyEvent(key, undefined);
            this._markDirtyKey(key);
        }
        this._stopAnimation(key);
    }
    /**
     * Removes all keys;
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     */ removeAll() {
        $2f30431acd054e2f$export$79b2f7037acddd43($e66f9343b5144e1a$export$ed97f33186d4b816(this._settings), (key)=>{
            this.remove(key);
        });
    }
    /**
     * Returns a value of a private setting.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/#Private_settings} for more info
     */ getPrivate(key, fallback) {
        const value = this._privateSettings[key];
        if (value !== undefined) return value;
        else return fallback;
    }
    /**
     * @ignore
     */ _setPrivateRaw(key, old, value) {
        this._prevPrivateSettings[key] = old;
        this._sendPrivateKeyEvent(key, value);
    }
    /**
     * @ignore
     */ setPrivateRaw(key, value) {
        const old = this._privateSettings[key];
        this._privateSettings[key] = value;
        if (old !== value) this._setPrivateRaw(key, old, value);
    }
    /**
     * @ignore
     */ _setPrivate(key, value) {
        const old = this._privateSettings[key];
        this._privateSettings[key] = value;
        if (old !== value) {
            this._setPrivateRaw(key, old, value);
            this._markDirtyPrivateKey(key);
        }
    }
    _stopAnimationPrivate(key) {
        const animation = this._animatingPrivateSettings[key];
        if (animation) {
            animation.stop();
            delete this._animatingPrivateSettings[key];
        }
    }
    /**
     * @ignore
     */ setPrivate(key, value) {
        this._setPrivate(key, value);
        this._stopAnimationPrivate(key);
        return value;
    }
    /**
     * @ignore
     */ removePrivate(key) {
        if (key in this._privateSettings) {
            this._prevPrivateSettings[key] = this._privateSettings[key];
            delete this._privateSettings[key];
            this._markDirtyPrivateKey(key);
        }
        this._stopAnimationPrivate(key);
    }
    /**
     * Sets multiple settings at once.
     *
     * `settings` must be an object with key: value pairs.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param settings Settings
     */ setAll(settings) {
        $e66f9343b5144e1a$export$79b2f7037acddd43(settings, (key, value)=>{
            this.set(key, value);
        });
    }
    /**
     * Animates setting values from current/start values to new ones.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/animations/#Animating_settings} for more info
     * @param   options  Animation options
     * @return           Animation object
     */ animate(options) {
        const key = options.key;
        const to = options.to;
        const duration = options.duration || 0;
        const loops = options.loops || 1;
        const from = options.from === undefined ? this.get(key) : options.from;
        const easing = options.easing === undefined ? $b4231ef84a5f8a61$export$45db2fc2f15997e7 : options.easing;
        if (duration === 0) this.set(key, to);
        else if (from === undefined || from === to) this.set(key, to);
        else {
            this.set(key, from);
            const animation = this._animatingSettings[key] = new $baeade534ece7f4c$export$c35d437ae5945fcd(this, from, to, duration, easing, loops, this._animationTime());
            this._startAnimation();
            return animation;
        }
        const animation = new $baeade534ece7f4c$export$c35d437ae5945fcd(this, from, to, duration, easing, loops, null);
        animation.stop();
        return animation;
    }
    /**
     * @ignore
     */ animatePrivate(options) {
        const key = options.key;
        const to = options.to;
        const duration = options.duration || 0;
        const loops = options.loops || 1;
        const from = options.from === undefined ? this.getPrivate(key) : options.from;
        const easing = options.easing === undefined ? $b4231ef84a5f8a61$export$45db2fc2f15997e7 : options.easing;
        if (duration === 0) this.setPrivate(key, to);
        else if (from === undefined || from === to) this.setPrivate(key, to);
        else {
            this.setPrivate(key, from);
            const animation = this._animatingPrivateSettings[key] = new $baeade534ece7f4c$export$c35d437ae5945fcd(this, from, to, duration, easing, loops, this._animationTime());
            this._startAnimation();
            return animation;
        }
        const animation = new $baeade534ece7f4c$export$c35d437ae5945fcd(this, from, to, duration, easing, loops, null);
        animation.stop();
        return animation;
    }
    _dispose() {}
    /**
     * Returns `true` if this element is disposed.
     *
     * @return Disposed
     */ isDisposed() {
        return this._disposed;
    }
    /**
     * Disposes this object.
     */ dispose() {
        if (this.enableDispose && !this._disposed) {
            this._disposed = true;
            this._dispose();
        }
    }
}
class $baeade534ece7f4c$export$bc644a473284d944 extends $baeade534ece7f4c$export$c72f6eaae7b9adff {
    /**
     * IMPORTANT! Do not instantiate this class via `new Class()` syntax.
     *
     * Use static method `Class.new()` instead.
     *
     * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
     * @ignore
     */ constructor(root, settings, isReal, templates = []){
        super(settings);
        this.states = new (0, $dad453b54c84e86c$export$47283907dceba392)(this);
        this.adapters = new $baeade534ece7f4c$export$aa533d00238abcca(this);
        this.events = this._createEvents();
        this._userPrivateProperties = {};
        this._dirty = {};
        this._dirtyPrivate = {};
        // Templates for the themes
        this._templates = [];
        // Default themes which can be overridden by the user's themes
        this._defaultThemes = [];
        // Disposers for all of the templates
        this._templateDisposers = [];
        this._disposers = [];
        // Whether the template setup function should be run
        this._runSetup = true;
        this._disposerProperties = {};
        if (!isReal) throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
        this._root = root;
        this._internalTemplates = templates;
        if (settings.id) this._registerId(settings.id);
    }
    /**
     * Use this method to create an instance of this class.
     *
     * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
     * @param   root      Root element
     * @param   settings  Settings
     * @param   template  Template
     * @return            Instantiated object
     */ static new(root, settings, template) {
        const x = new this(root, settings, true);
        x._template = template;
        x._afterNew();
        return x;
    }
    static _new(root, settings, templates = []) {
        const x = new this(root, settings, true, templates);
        x._afterNew();
        return x;
    }
    _afterNew() {
        this._checkDirty();
        let shouldApply = false;
        const template = this._template;
        if (template) {
            shouldApply = true;
            template._setObjectTemplate(this);
        }
        $2f30431acd054e2f$export$79b2f7037acddd43(this._internalTemplates, (template)=>{
            shouldApply = true;
            template._setObjectTemplate(this);
        });
        if (shouldApply) this._applyTemplates(false);
        this.states.create("default", {});
        this._setDefaults();
    }
    // This is the same as _afterNew, except it also applies the themes.
    // This should only be used for classes which don't have a parent (because they extend from Entity and not Sprite).
    _afterNewApplyThemes() {
        this._checkDirty();
        const template = this._template;
        if (template) template._setObjectTemplate(this);
        $2f30431acd054e2f$export$79b2f7037acddd43(this._internalTemplates, (template)=>{
            template._setObjectTemplate(this);
        });
        this.states.create("default", {});
        this._setDefaults();
        this._applyThemes();
    }
    _createEvents() {
        return new (0, $7e417cbab1b21893$export$ec8b666c5fe2c75a)();
    }
    /**
     * @ignore
     */ get classNames() {
        return this.constructor.classNames;
    }
    /**
     * @ignore
     */ get className() {
        return this.constructor.className;
    }
    _setDefaults() {}
    _setDefaultFn(key, f) {
        const value = this.get(key);
        if (value) return value;
        else {
            const value = f();
            this.set(key, value);
            return value;
        }
    }
    _setDefault(key, value) {
        if (!this.has(key)) super.set(key, value);
    }
    _setRawDefault(key, value) {
        if (!this.has(key)) super.setRaw(key, value);
    }
    _clearDirty() {
        $e66f9343b5144e1a$export$ed97f33186d4b816(this._dirty).forEach((key)=>{
            this._dirty[key] = false;
        });
        $e66f9343b5144e1a$export$ed97f33186d4b816(this._dirtyPrivate).forEach((key)=>{
            this._dirtyPrivate[key] = false;
        });
    }
    /**
     * @ignore
     */ isDirty(key) {
        return !!this._dirty[key];
    }
    /**
     * @ignore
     */ isPrivateDirty(key) {
        return !!this._dirtyPrivate[key];
    }
    _markDirtyKey(key) {
        this._dirty[key] = true;
        super._markDirtyKey(key);
    }
    _markDirtyPrivateKey(key) {
        this._dirtyPrivate[key] = true;
        super._markDirtyKey(key);
    }
    /**
     * Checks if element is of certain class (or inherits one).
     *
     * @param   type  Class name to check
     * @return {boolean} Is of class?
     */ isType(type) {
        return this.classNames.indexOf(type) !== -1;
    }
    _pushPropertyDisposer(key, disposer) {
        let disposers = this._disposerProperties[key];
        if (disposers === undefined) disposers = this._disposerProperties[key] = [];
        disposers.push(disposer);
        return disposer;
    }
    _disposeProperty(key) {
        const disposers = this._disposerProperties[key];
        if (disposers !== undefined) {
            $2f30431acd054e2f$export$79b2f7037acddd43(disposers, (disposer)=>{
                disposer.dispose();
            });
            delete this._disposerProperties[key];
        }
    }
    /**
     * @todo needs description
     * @param  value  Template
     */ set template(value) {
        const template = this._template;
        if (template !== value) {
            this._template = value;
            if (template) template._removeObjectTemplate(this);
            if (value) value._setObjectTemplate(this);
            this._applyTemplates();
        }
    }
    get template() {
        return this._template;
    }
    /**
     * @ignore
     */ markDirty() {
        this._root._addDirtyEntity(this);
    }
    _startAnimation() {
        this._root._addAnimation(this);
    }
    _animationTime() {
        return this._root.animationTime;
    }
    _applyState(_name) {}
    _applyStateAnimated(_name, _duration) {}
    get(key, fallback) {
        const value = this.adapters.fold(key, this._settings[key]);
        if (value !== undefined) return value;
        else return fallback;
    }
    /**
     * @ignore
     */ isUserSetting(key) {
        return this._userProperties[key] || false;
    }
    /**
     * Sets a setting `value` for the specified `key`, and returns the same `value`.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param   key       Setting key
     * @param   value     Setting value
     * @return            Setting value
     */ set(key, value) {
        this._userProperties[key] = true;
        return super.set(key, value);
    }
    /**
     * @ignore
     */ setRaw(key, value) {
        this._userProperties[key] = true;
        super.setRaw(key, value);
    }
    /**
     * Sets a setting `value` for the specified `key` only if the value for this key was not set previously using set method, and returns the same `value`.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param   key       Setting key
     * @param   value     Setting value
     * @return            Setting value
     */ _setSoft(key, value) {
        if (!this._userProperties[key]) return super.set(key, value);
        return value;
    }
    /**
     * Removes a setting value for the specified `key`.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
     * @param   key       Setting key
     */ remove(key) {
        delete this._userProperties[key];
        this._removeTemplateProperty(key);
    }
    /**
     * @ignore
     */ setPrivate(key, value) {
        this._userPrivateProperties[key] = true;
        return super.setPrivate(key, value);
    }
    /**
     * @ignore
     */ setPrivateRaw(key, value) {
        this._userPrivateProperties[key] = true;
        super.setPrivateRaw(key, value);
    }
    /**
     * @ignore
     */ removePrivate(key) {
        delete this._userPrivateProperties[key];
        this._removeTemplatePrivateProperty(key);
    }
    _setTemplateProperty(template, key, value) {
        if (!this._userProperties[key]) {
            const match = this._findTemplateByKey(key);
            if (template === match) super.set(key, value);
        }
    }
    _setTemplatePrivateProperty(template, key, value) {
        if (!this._userPrivateProperties[key]) {
            const match = this._findTemplateByPrivateKey(key);
            if (template === match) super.setPrivate(key, value);
        }
    }
    _removeTemplateProperty(key) {
        if (!this._userProperties[key]) {
            const match = this._findTemplateByKey(key);
            if (match) // TODO don't stop the animation if the property didn't change
            super.set(key, match._settings[key]);
            else super.remove(key);
        }
    }
    _removeTemplatePrivateProperty(key) {
        if (!this._userPrivateProperties[key]) {
            const match = this._findTemplateByPrivateKey(key);
            if (match) // TODO don't stop the animation if the property didn't change
            super.setPrivate(key, match._privateSettings[key]);
            else super.removePrivate(key);
        }
    }
    _walkParents(f) {
        f(this._root._rootContainer);
        f(this);
    }
    // TODO faster version of this method which is specialized to just 1 key
    _applyStateByKey(name) {
        const other = this.states.create(name, {});
        const seen = {};
        this._eachTemplate((template)=>{
            const state = template.states.lookup(name);
            if (state) state._apply(other, seen);
        });
        $e66f9343b5144e1a$export$79b2f7037acddd43(other._settings, (key)=>{
            if (!seen[key] && !other._userSettings[key]) other.remove(key);
        });
    }
    _applyTemplate(template, state) {
        this._templateDisposers.push(template._apply(this, state));
        $e66f9343b5144e1a$export$79b2f7037acddd43(template._settings, (key, value)=>{
            if (!state.settings[key] && !this._userProperties[key]) {
                state.settings[key] = true;
                super.set(key, value);
            }
        });
        $e66f9343b5144e1a$export$79b2f7037acddd43(template._privateSettings, (key, value)=>{
            if (!state.privateSettings[key] && !this._userPrivateProperties[key]) {
                state.privateSettings[key] = true;
                super.setPrivate(key, value);
            }
        });
        if (this._runSetup && template.setup) {
            this._runSetup = false;
            template.setup(this);
        }
    }
    /**
     * Calls the closure with each template and returns the first template which is true
     */ _findStaticTemplate(f) {
        if (this._template) {
            if (f(this._template)) return this._template;
        }
    }
    _eachTemplate(f) {
        this._findStaticTemplate((template)=>{
            f(template);
            return false;
        });
        // _internalTemplates is sorted with most specific to the right
        $2f30431acd054e2f$export$a40ba8785b7efce8(this._internalTemplates, f);
        // _templates is sorted with most specific to the left
        $2f30431acd054e2f$export$79b2f7037acddd43(this._templates, f);
    }
    _applyTemplates(remove = true) {
        if (remove) this._disposeTemplates();
        const state = {
            settings: {},
            privateSettings: {},
            states: {}
        };
        this._eachTemplate((template)=>{
            this._applyTemplate(template, state);
        });
        if (remove) {
            $e66f9343b5144e1a$export$79b2f7037acddd43(this._settings, (key)=>{
                if (!this._userProperties[key] && !state.settings[key]) super.remove(key);
            });
            $e66f9343b5144e1a$export$79b2f7037acddd43(this._privateSettings, (key)=>{
                if (!this._userPrivateProperties[key] && !state.privateSettings[key]) super.removePrivate(key);
            });
        }
    }
    _findTemplate(f) {
        const value = this._findStaticTemplate(f);
        if (value === undefined) {
            // _internalTemplates is sorted with most specific to the right
            const value = $2f30431acd054e2f$export$cda8c4def7b6e027(this._internalTemplates, f);
            if (value === undefined) // _templates is sorted with most specific to the left
            return $2f30431acd054e2f$export$71aa6c912b956294(this._templates, f);
            else return value;
        } else return value;
    }
    _findTemplateByKey(key) {
        return this._findTemplate((template)=>{
            return key in template._settings;
        });
    }
    _findTemplateByPrivateKey(key) {
        return this._findTemplate((template)=>{
            return key in template._privateSettings;
        });
    }
    _disposeTemplates() {
        $2f30431acd054e2f$export$79b2f7037acddd43(this._templateDisposers, (disposer)=>{
            disposer.dispose();
        });
        this._templateDisposers.length = 0;
    }
    _removeTemplates() {
        $2f30431acd054e2f$export$79b2f7037acddd43(this._templates, (template)=>{
            template._removeObjectTemplate(this);
        });
        this._templates.length = 0;
    }
    _applyThemes(force = false) {
        if (this.get("ignoreThemes")) return false;
        let isConnected = false;
        const defaults = [];
        let themes = [];
        const themeTags = new Set();
        const tags = this.get("themeTagsSelf");
        if (tags) $2f30431acd054e2f$export$79b2f7037acddd43(tags, (tag)=>{
            themeTags.add(tag);
        });
        this._walkParents((entity)=>{
            if (entity === this._root._rootContainer) isConnected = true;
            if (entity._defaultThemes.length > 0) defaults.push(entity._defaultThemes);
            const theme = entity.get("themes");
            if (theme) themes.push(theme);
            const tags = entity.get("themeTags");
            if (tags) $2f30431acd054e2f$export$79b2f7037acddd43(tags, (tag)=>{
                themeTags.add(tag);
            });
        });
        themes = defaults.concat(themes);
        this._removeTemplates();
        if (isConnected || force) $2f30431acd054e2f$export$a40ba8785b7efce8(this.classNames, (name)=>{
            const allRules = [];
            $2f30431acd054e2f$export$79b2f7037acddd43(themes, (themes)=>{
                $2f30431acd054e2f$export$79b2f7037acddd43(themes, (theme)=>{
                    const rules = theme._lookupRules(name);
                    if (rules) $2f30431acd054e2f$export$a40ba8785b7efce8(rules, (rule)=>{
                        const matches = rule.tags.every((tag)=>{
                            return themeTags.has(tag);
                        });
                        if (matches) {
                            const result = $2f30431acd054e2f$export$227c6173d90c5e68(allRules, (x)=>{
                                const order = $919e90129af4490b$export$398604a469f7de9a(rule.tags.length, x.tags.length);
                                if (order === 0) return $919e90129af4490b$export$cb07857b027678fa(rule.tags, x.tags, $919e90129af4490b$export$398604a469f7de9a);
                                else return order;
                            });
                            allRules.splice(result.index, 0, rule);
                        }
                    });
                });
            });
            $2f30431acd054e2f$export$79b2f7037acddd43(allRules, (rule)=>{
                this._templates.push(rule.template);
                rule.template._setObjectTemplate(this);
            });
        });
        this._applyTemplates();
        if (isConnected || force) // This causes it to only run the setup function the first time that the themes are applied
        this._runSetup = false;
        return isConnected || force;
    }
    _changed() {}
    _beforeChanged() {
        if (this.isDirty("id")) {
            const id = this.get("id");
            if (id) this._registerId(id);
            const prevId = this._prevSettings.id;
            if (prevId) {
                delete this._root.entitiesById[prevId];
                delete (0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).entitiesById[prevId];
            }
        }
    }
    _registerId(id) {
        if (this._root.entitiesById[id] && this._root.entitiesById[id] !== this) throw new Error("An entity with id \"" + id + "\" already exists.");
        this._root.entitiesById[id] = this;
        (0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).entitiesById[id] = this;
    }
    _afterChanged() {}
    /**
     * @ignore
     */ addDisposer(disposer) {
        this._disposers.push(disposer);
        return disposer;
    }
    _dispose() {
        super._dispose();
        const template = this._template;
        if (template) template._removeObjectTemplate(this);
        $2f30431acd054e2f$export$79b2f7037acddd43(this._internalTemplates, (template)=>{
            template._removeObjectTemplate(this);
        });
        this._removeTemplates();
        this._disposeTemplates();
        this.events.dispose();
        this._disposers.forEach((x)=>{
            x.dispose();
        });
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._disposerProperties, (_, disposers)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(disposers, (disposer)=>{
                disposer.dispose();
            });
        });
        const id = this.get("id");
        if (id) {
            delete this._root.entitiesById[id];
            delete (0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).entitiesById[id];
        }
    }
    /**
     * Creates and returns a "disposable" timeout.
     *
     * @param   fn     Callback
     * @param   delay  Delay in milliseconds
     * @return         Timeout disposer
     */ setTimeout(fn, delay) {
        const id = setTimeout(()=>{
            this.removeDispose(disposer);
            fn();
        }, delay);
        const disposer = new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            clearTimeout(id);
        });
        this._disposers.push(disposer);
        return disposer;
    }
    /**
     * @ignore
     */ removeDispose(target) {
        if (!this.isDisposed()) {
            let index = $2f30431acd054e2f$export$305f7d4e9d4624f2(this._disposers, target);
            if (index > -1) this._disposers.splice(index, 1);
        }
        target.dispose();
    }
    /**
     * @ignore
     */ hasTag(tag) {
        return $2f30431acd054e2f$export$305f7d4e9d4624f2(this.get("themeTags", []), tag) !== -1;
    }
    /**
     * @ignore
     */ addTag(tag) {
        if (!this.hasTag(tag)) {
            const tags = this.get("themeTags", []);
            tags.push(tag);
            this.set("themeTags", tags);
        }
    }
    /**
     * @ignore
     */ removeTag(tag) {
        if (this.hasTag(tag)) {
            const tags = this.get("themeTags", []);
            $2f30431acd054e2f$export$cd7f480d6b8286c3(tags, tag);
            this.set("themeTags", tags);
        }
    }
    _t(text, locale, ...rest) {
        return this._root.language.translate(text, locale, ...rest);
    }
    /**
     * An instance of [[Root]] object.
     *
     * @readonly
     * @since 5.0.6
     * @return Root object
     */ get root() {
        return this._root;
    }
}
$baeade534ece7f4c$export$bc644a473284d944.className = "Entity";
$baeade534ece7f4c$export$bc644a473284d944.classNames = [
    "Entity"
];


class $2a4eebd6f0f9cb85$export$3d3dd8f63ff0f876 extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    _afterNew() {
        // Applying themes because gradient will not have parent
        super._afterNewApplyThemes();
    }
    /**
     * @ignore
     */ getFill(_target) {
        return {
            addColorStop: (_offset, _color)=>{}
        };
    }
    _changed() {
        super._changed();
    //if (this.isDirty("target") && this.get("target")) {
    //	this.get("target")!.events.on("boundschanged", () => {
    //	});
    //}
    }
    /**
     * @ignore
     */ getBounds(target) {
        const gradientTarget = this.get("target");
        if (gradientTarget) {
            let bounds = gradientTarget.globalBounds();
            const p0 = target.toLocal({
                x: bounds.left,
                y: bounds.top
            });
            const p1 = target.toLocal({
                x: bounds.right,
                y: bounds.top
            });
            const p2 = target.toLocal({
                x: bounds.right,
                y: bounds.bottom
            });
            const p3 = target.toLocal({
                x: bounds.left,
                y: bounds.bottom
            });
            return {
                left: Math.min(p0.x, p1.x, p2.x, p3.x),
                top: Math.min(p0.y, p1.y, p2.y, p3.y),
                right: Math.max(p0.x, p1.x, p2.x, p3.x),
                bottom: Math.max(p0.y, p1.y, p2.y, p3.y)
            };
        }
        return target._display.getLocalBounds();
    }
}
$2a4eebd6f0f9cb85$export$3d3dd8f63ff0f876.className = "Gradient";
$2a4eebd6f0f9cb85$export$3d3dd8f63ff0f876.classNames = (0, $baeade534ece7f4c$export$bc644a473284d944).classNames.concat([
    $2a4eebd6f0f9cb85$export$3d3dd8f63ff0f876.className
]);






class $228fee2a29e47fc5$export$39a41c7169757633 extends (0, $2a4eebd6f0f9cb85$export$3d3dd8f63ff0f876) {
    /**
     * @ignore
     */ getFill(target) {
        const rotation = this.get("rotation", 0);
        let bounds = this.getBounds(target);
        let l = bounds.left || 0;
        let r = bounds.right || 0;
        let t = bounds.top || 0;
        let b = bounds.bottom || 0;
        let cos = $f43e9e04b3f0548b$export$50d414a77b60d802(rotation);
        let sin = $f43e9e04b3f0548b$export$5de3937cb4b592ed(rotation);
        let w = cos * (r - l);
        let h = sin * (b - t);
        if (w == 0) w = 1;
        if (h == 0) h = 1;
        let longer = Math.max(w, h);
        const gradient = this._root._renderer.createLinearGradient(l, t, l + longer * cos, t + longer * sin);
        const stops = this.get("stops");
        if (stops) {
            let i = 0;
            $2f30431acd054e2f$export$79b2f7037acddd43(stops, (stop)=>{
                let offset = stop.offset;
                if (!$f63bdea45a89cf24$export$7e4aa119212bc614(offset)) offset = i / (stops.length - 1);
                let opacity = stop.opacity;
                if (!$f63bdea45a89cf24$export$7e4aa119212bc614(opacity)) opacity = 1;
                let color = stop.color;
                if (color) {
                    const lighten = stop.lighten;
                    if (lighten) color = (0, $389de129b6cd18b1$export$892596cec99bc70e).lighten(color, lighten);
                    const brighten = stop.brighten;
                    if (brighten) color = (0, $389de129b6cd18b1$export$892596cec99bc70e).brighten(color, brighten);
                    gradient.addColorStop(offset, 'rgba(' + color.r + ',' + color.g + ',' + color.b + ',' + opacity + ')');
                }
                i++;
            });
        }
        return gradient;
    }
}
$228fee2a29e47fc5$export$39a41c7169757633.className = "LinearGradient";
$228fee2a29e47fc5$export$39a41c7169757633.classNames = (0, $2a4eebd6f0f9cb85$export$3d3dd8f63ff0f876).classNames.concat([
    $228fee2a29e47fc5$export$39a41c7169757633.className
]);




/**
 * Checks if specific index fits into length.
 *
 * @param index  Index
 * @param len    Length
 * @ignore
 */ function $ddd3cfc9bee47cd2$var$checkBounds(index, len) {
    if (!(index >= 0 && index < len)) throw new Error("Index out of bounds: " + index);
}
class $ddd3cfc9bee47cd2$export$54c2e3dc7acea9f5 {
    /**
     * Constructor
     *
     * @param initial  Inital list of values to add to list
     */ constructor(initial = []){
        this.events = new (0, $7e417cbab1b21893$export$ec8b666c5fe2c75a)();
        this._values = initial;
    }
    /**
     * An array of values in the list.
     *
     * Do not use this property to add values. Rather use dedicated methods, like
     * `push()`, `removeIndex()`, etc.
     *
     * @readonly
     * @return List values
     */ get values() {
        return this._values;
    }
    /**
     * Checks if list contains specific item reference.
     *
     * @param item  Item to search for
     * @return `true` if found, `false` if not found
     */ contains(value) {
        return this._values.indexOf(value) !== -1;
    }
    /**
     * Removes specific item from the list.
     *
     * @param item An item to remove
     */ removeValue(value) {
        let i = 0;
        let length = this._values.length;
        while(i < length)// TODO handle NaN
        if (this._values[i] === value) {
            this.removeIndex(i);
            --length;
        } else ++i;
    }
    /**
     * Searches the list for specific item and returns its index.
     *
     * @param item  An item to search for
     * @return Index or -1 if not found
     */ indexOf(value) {
        return $2f30431acd054e2f$export$305f7d4e9d4624f2(this._values, value);
    }
    /**
     * Number of items in list.
     *
     * @readonly
     * @return Number of items
     */ get length() {
        return this._values.length;
    }
    /**
     * Checks if there's a value at specific index.
     *
     * @param index  Index
     * @return Value exists?
     */ hasIndex(index) {
        return index >= 0 && index < this._values.length;
    }
    /**
     * Returns an item at specified index.
     *
     * @param index  Index
     * @return List item
     */ getIndex(index) {
        return this._values[index];
    }
    _onPush(newValue) {
        if (this.events.isEnabled("push")) this.events.dispatch("push", {
            type: "push",
            target: this,
            newValue: newValue
        });
    }
    _onInsertIndex(index, newValue) {
        if (this.events.isEnabled("insertIndex")) this.events.dispatch("insertIndex", {
            type: "insertIndex",
            target: this,
            index: index,
            newValue: newValue
        });
    }
    _onSetIndex(index, oldValue, newValue) {
        if (this.events.isEnabled("setIndex")) this.events.dispatch("setIndex", {
            type: "setIndex",
            target: this,
            index: index,
            oldValue: oldValue,
            newValue: newValue
        });
    }
    _onSwap(a, b) {
        if (this.events.isEnabled("swap")) this.events.dispatch("swap", {
            type: "swap",
            target: this,
            a: a,
            b: b
        });
    }
    _onRemoveIndex(index, oldValue) {
        if (this.events.isEnabled("removeIndex")) this.events.dispatch("removeIndex", {
            type: "removeIndex",
            target: this,
            index: index,
            oldValue: oldValue
        });
    }
    _onMoveIndex(oldIndex, newIndex, value) {
        if (this.events.isEnabled("moveIndex")) this.events.dispatch("moveIndex", {
            type: "moveIndex",
            target: this,
            oldIndex: oldIndex,
            newIndex: newIndex,
            value: value
        });
    }
    _onClear(oldValues) {
        if (this.events.isEnabled("clear")) this.events.dispatch("clear", {
            type: "clear",
            target: this,
            oldValues: oldValues
        });
    }
    /**
     * Sets value at specific index.
     *
     * If there's already a value at the index, it is overwritten.
     *
     * @param index  Index
     * @param value  New value
     * @return New value
     */ setIndex(index, value) {
        $ddd3cfc9bee47cd2$var$checkBounds(index, this._values.length);
        const oldValue = this._values[index];
        // Do nothing if the old value and the new value are the same
        if (oldValue !== value) {
            this._values[index] = value;
            this._onSetIndex(index, oldValue, value);
        }
        return oldValue;
    }
    /**
     * Adds an item to the list at a specific index, which pushes all the other
     * items further down the list.
     *
     * @param index Index
     * @param item  An item to add
     */ insertIndex(index, value) {
        $ddd3cfc9bee47cd2$var$checkBounds(index, this._values.length + 1);
        $2f30431acd054e2f$export$5a98a36321617fd4(this._values, index, value);
        this._onInsertIndex(index, value);
        return value;
    }
    /**
     * Swaps indexes of two items in the list.
     *
     * @param a  Item 1
     * @param b  Item 2
     */ swap(a, b) {
        const len = this._values.length;
        $ddd3cfc9bee47cd2$var$checkBounds(a, len);
        $ddd3cfc9bee47cd2$var$checkBounds(b, len);
        if (a !== b) {
            const value_a = this._values[a];
            const value_b = this._values[b];
            this._values[a] = value_b;
            this._values[b] = value_a;
            this._onSwap(value_a, value_b);
        }
    }
    /**
     * Removes a value at specific index.
     *
     * @param index  Index of value to remove
     * @return Removed value
     */ removeIndex(index) {
        $ddd3cfc9bee47cd2$var$checkBounds(index, this._values.length);
        const oldValue = this._values[index];
        $2f30431acd054e2f$export$c36ae5e7e50e8840(this._values, index);
        this._onRemoveIndex(index, oldValue);
        return oldValue;
    }
    /**
     * Moves an item to a specific index within the list.
     *
     * If the index is not specified it will move the item to the end of the
     * list.
     *
     * @param value  Item to move
     * @param index  Index to place item at
     */ moveValue(value, toIndex) {
        // TODO don't do anything if the desired index is the same as the current index
        let index = this.indexOf(value);
        // TODO remove all old values rather than only the first ?
        if (index !== -1) {
            $2f30431acd054e2f$export$c36ae5e7e50e8840(this._values, index);
            if (toIndex == null) {
                const toIndex = this._values.length;
                this._values.push(value);
                this._onMoveIndex(index, toIndex, value);
            } else {
                $2f30431acd054e2f$export$5a98a36321617fd4(this._values, toIndex, value);
                this._onMoveIndex(index, toIndex, value);
            }
        } else if (toIndex == null) {
            this._values.push(value);
            this._onPush(value);
        } else {
            $2f30431acd054e2f$export$5a98a36321617fd4(this._values, toIndex, value);
            this._onInsertIndex(toIndex, value);
        }
        return value;
    }
    /**
     * Adds an item to the end of the list.
     *
     * @param item  An item to add
     */ push(value) {
        this._values.push(value);
        this._onPush(value);
        return value;
    }
    /**
     * Adds an item as a first item in the list.
     *
     * @param item  An item to add
     */ unshift(value) {
        this.insertIndex(0, value);
        return value;
    }
    /**
     * Adds multiple items to the list.
     *
     * @param items  An Array of items to add
     */ pushAll(values) {
        $2f30431acd054e2f$export$79b2f7037acddd43(values, (value)=>{
            this.push(value);
        });
    }
    /**
     * Copies and adds items from abother list.
     *
     * @param source  A list top copy items from
     */ copyFrom(source) {
        this.pushAll(source._values);
    }
    /**
     * Returns the last item from the list, and removes it.
     *
     * @return Item
     */ pop() {
        let index = this._values.length - 1;
        return index < 0 ? undefined : this.removeIndex(this._values.length - 1);
    }
    /**
     * Returns the first item from the list, and removes it.
     *
     * @return Item
     */ shift() {
        return this._values.length ? this.removeIndex(0) : undefined;
    }
    /**
     * Sets multiple items to the list.
     *
     * All current items are removed.
     *
     * @param newArray  New items
     */ setAll(newArray) {
        const old = this._values;
        this._values = [];
        this._onClear(old);
        $2f30431acd054e2f$export$79b2f7037acddd43(newArray, (value)=>{
            this._values.push(value);
            this._onPush(value);
        });
    }
    /**
     * Removes all items from the list.
     */ clear() {
        this.setAll([]);
    }
    /**
     * Returns an ES6 iterator for the list.
     */ *[Symbol.iterator]() {
        const length = this._values.length;
        for(let i = 0; i < length; ++i)yield this._values[i];
    }
    /**
     * Calls `f` for each element in the list.
     *
     * `f` should have at least one parameter defined which will get a current
     * item, with optional second argument - index.
     */ each(f) {
        $2f30431acd054e2f$export$79b2f7037acddd43(this._values, f);
    }
    /**
     * Calls `f` for each element in the list, from right to left.
     *
     * `f` should have at least one parameter defined which will get a current
     * item, with optional second argument - index.
     */ eachReverse(f) {
        $2f30431acd054e2f$export$a40ba8785b7efce8(this._values, f);
    }
}
class $ddd3cfc9bee47cd2$export$82bb93f974543403 extends $ddd3cfc9bee47cd2$export$54c2e3dc7acea9f5 {
    constructor(){
        super(...arguments);
        /**
         * Automatically disposes elements that are removed from the list.
         *
         * @default true
         */ this.autoDispose = true;
        this._disposed = false;
    }
    /**
     * Swaps indexes of two items in the list.
     *
     * @param a  Item 1
     * @param b  Item 2
     */ swap(a, b) {
        const currentAutoDispose = this.autoDispose;
        this.autoDispose = false;
        super.swap(a, b);
        this.autoDispose = currentAutoDispose;
    }
    _onSetIndex(index, oldValue, newValue) {
        if (this.autoDispose) oldValue.dispose();
        super._onSetIndex(index, oldValue, newValue);
    }
    _onRemoveIndex(index, oldValue) {
        if (this.autoDispose) oldValue.dispose();
        super._onRemoveIndex(index, oldValue);
    }
    _onClear(oldValues) {
        if (this.autoDispose) $2f30431acd054e2f$export$79b2f7037acddd43(oldValues, (x)=>{
            x.dispose();
        });
        super._onClear(oldValues);
    }
    _dispose() {
        if (this.autoDispose) $2f30431acd054e2f$export$79b2f7037acddd43(this._values, (x)=>{
            x.dispose();
        });
    }
    isDisposed() {
        return this._disposed;
    }
    dispose() {
        if (!this._disposed) {
            this._disposed = true;
            this._dispose();
        }
    }
}
class $ddd3cfc9bee47cd2$export$92d9ebaedf6ba994 extends $ddd3cfc9bee47cd2$export$82bb93f974543403 {
    constructor(template, make){
        super();
        this.template = template;
        this.make = make;
    }
    _dispose() {
        super._dispose();
        if (this.autoDispose) this.template.dispose();
    }
}



class $5e30d142a93206ce$export$dca3b0875bd9a954 extends (0, $ddd3cfc9bee47cd2$export$54c2e3dc7acea9f5) {
    constructor(container){
        super();
        this._disposed = false;
        this._container = container;
        this._events = this.events.onAll((change)=>{
            if (change.type === "clear") $2f30431acd054e2f$export$79b2f7037acddd43(change.oldValues, (x)=>{
                this._onRemoved(x);
            });
            else if (change.type === "push") this._onInserted(change.newValue);
            else if (change.type === "setIndex") {
                this._onRemoved(change.oldValue);
                this._onInserted(change.newValue, change.index);
            } else if (change.type === "insertIndex") this._onInserted(change.newValue, change.index);
            else if (change.type === "removeIndex") this._onRemoved(change.oldValue);
            else if (change.type === "moveIndex") {
                this._onRemoved(change.value);
                this._onInserted(change.value, change.newIndex);
            } else throw new Error("Unknown IListEvent type");
        });
    }
    _onInserted(child, index) {
        child._setParent(this._container, true);
        const childrenDisplay = this._container._childrenDisplay;
        if (index === undefined) childrenDisplay.addChild(child._display);
        else childrenDisplay.addChildAt(child._display, index);
    }
    _onRemoved(child) {
        this._container._childrenDisplay.removeChild(child._display);
        this._container.markDirtyBounds();
        this._container.markDirty();
    }
    /**
     * Returns `true` if obejct is disposed.
     */ isDisposed() {
        return this._disposed;
    }
    /**
     * Permanently dispose this object.
     */ dispose() {
        if (!this._disposed) {
            this._disposed = true;
            this._events.dispose();
            $2f30431acd054e2f$export$79b2f7037acddd43(this.values, (child)=>{
                child.dispose();
            });
        }
    }
}










function $2d9a18dcb72760f7$var$disposeSettings(settings) {
    $e66f9343b5144e1a$export$79b2f7037acddd43(settings, (_key, value)=>{
        if ($f63bdea45a89cf24$export$a6cdc56e425d0d0a(value) && typeof value.dispose === "function") {
            value.enableDispose = true;
            value.dispose();
        }
    });
}
class $2d9a18dcb72760f7$export$39a8ed24daf9361f {
    constructor(name, template, settings){
        this._name = name;
        this._template = template;
        this._settings = settings;
    }
    _dispose() {
        $2d9a18dcb72760f7$var$disposeSettings(this._settings);
    }
    get(key, fallback) {
        const value = this._settings[key];
        if (value !== undefined) return value;
        else return fallback;
    }
    set(key, value) {
        this._settings[key] = value;
        // TODO maybe only do this if the value changed ?
        this._template._stateChanged(this._name);
    }
    remove(key) {
        delete this._settings[key];
        // TODO maybe only do this if the value changed ?
        this._template._stateChanged(this._name);
    }
    setAll(settings) {
        $e66f9343b5144e1a$export$ed97f33186d4b816(settings).forEach((key)=>{
            this._settings[key] = settings[key];
        });
        this._template._stateChanged(this._name);
    }
    _apply(other, seen) {
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._settings, (key, value)=>{
            if (!seen[key] && !other._userSettings[key]) {
                seen[key] = true;
                other.setRaw(key, value);
            }
        });
    }
}
class $2d9a18dcb72760f7$export$d10b0e89859ffbd4 {
    constructor(template){
        this._states = {};
        this._template = template;
    }
    _dispose() {
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._states, (_key, state)=>{
            state._dispose();
        });
    }
    lookup(name) {
        return this._states[name];
    }
    create(name, settings) {
        const state = this._states[name];
        if (state) {
            state.setAll(settings);
            return state;
        } else {
            const state = new $2d9a18dcb72760f7$export$39a8ed24daf9361f(name, this._template, settings);
            this._states[name] = state;
            this._template._stateChanged(name);
            return state;
        }
    }
    remove(name) {
        delete this._states[name];
        this._template._stateChanged(name);
    }
    _apply(entity, state) {
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._states, (key, value)=>{
            let seen = state.states[key];
            if (seen == null) seen = state.states[key] = {};
            const other = entity.states.create(key, {});
            value._apply(other, seen);
        });
    }
}
class $2d9a18dcb72760f7$export$a331a2a1dc9c3ce4 {
    constructor(){
        this._callbacks = {};
    }
    add(key, callback) {
        let callbacks = this._callbacks[key];
        if (callbacks === undefined) callbacks = this._callbacks[key] = [];
        callbacks.push(callback);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            $2f30431acd054e2f$export$2529f734547e2830(callbacks, callback);
            if (callbacks.length === 0) delete this._callbacks[key];
        });
    }
    remove(key) {
        const callbacks = this._callbacks[key];
        if (callbacks !== undefined) delete this._callbacks[key];
    }
    _apply(entity) {
        const disposers = [];
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._callbacks, (key, callbacks)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(callbacks, (callback)=>{
                disposers.push(entity.adapters.add(key, callback));
            });
        });
        return new (0, $a363f66303166aa1$export$9720df365053d143)(disposers);
    }
}
class $2d9a18dcb72760f7$export$14416b8d99d47caa {
    constructor(settings, isReal){
        this._disposed = false;
        this._privateSettings = {};
        // TODO code duplication with Properties
        this._settingEvents = {};
        this._privateSettingEvents = {};
        this._entities = [];
        this.states = new $2d9a18dcb72760f7$export$d10b0e89859ffbd4(this);
        this.adapters = new $2d9a18dcb72760f7$export$a331a2a1dc9c3ce4();
        this.events = new (0, $7e417cbab1b21893$export$ec8b666c5fe2c75a)();
        if (!isReal) throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
        this._settings = settings;
    }
    /**
     * Use this method to create an instance of this class.
     *
     * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
     * @param   root      Root element
     * @param   settings  Settings
     * @param   template  Template
     * @return            Instantiated object
     */ static new(settings) {
        return new $2d9a18dcb72760f7$export$14416b8d99d47caa(settings, true);
    }
    _dispose() {
        $2d9a18dcb72760f7$var$disposeSettings(this._settings);
        $2d9a18dcb72760f7$var$disposeSettings(this._privateSettings);
    }
    /**
     * Returns `true` if this element is disposed.
     *
     * @return Disposed
     */ isDisposed() {
        return this._disposed;
    }
    /**
     * Disposes this object.
     */ dispose() {
        if (!this._disposed) {
            this._disposed = true;
            this._dispose();
        }
    }
    _checkDisposed() {
        if (this._disposed) throw new Error("Template is disposed");
    }
    /**
     * Array of all entities using this template.
     */ get entities() {
        return this._entities;
    }
    get(key, fallback) {
        this._checkDisposed();
        const value = this._settings[key];
        if (value !== undefined) return value;
        else return fallback;
    }
    setRaw(key, value) {
        this._checkDisposed();
        this._settings[key] = value;
    }
    set(key, value) {
        this._checkDisposed();
        if (this._settings[key] !== value) {
            this.setRaw(key, value);
            this._entities.forEach((entity)=>{
                entity._setTemplateProperty(this, key, value);
            });
        }
    }
    remove(key) {
        this._checkDisposed();
        if (key in this._settings) {
            delete this._settings[key];
            this._entities.forEach((entity)=>{
                entity._removeTemplateProperty(key);
            });
        }
    }
    removeAll() {
        this._checkDisposed();
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._settings, (key, _value)=>{
            this.remove(key);
        });
    }
    getPrivate(key, fallback) {
        this._checkDisposed();
        const value = this._privateSettings[key];
        if (value !== undefined) return value;
        else return fallback;
    }
    setPrivateRaw(key, value) {
        this._checkDisposed();
        this._privateSettings[key] = value;
        return value;
    }
    setPrivate(key, value) {
        this._checkDisposed();
        if (this._privateSettings[key] !== value) {
            this.setPrivateRaw(key, value);
            this._entities.forEach((entity)=>{
                entity._setTemplatePrivateProperty(this, key, value);
            });
        }
        return value;
    }
    removePrivate(key) {
        this._checkDisposed();
        if (key in this._privateSettings) {
            delete this._privateSettings[key];
            this._entities.forEach((entity)=>{
                entity._removeTemplatePrivateProperty(key);
            });
        }
    }
    setAll(value) {
        this._checkDisposed();
        $e66f9343b5144e1a$export$79b2f7037acddd43(value, (key, value)=>{
            this.set(key, value);
        });
    }
    // TODO code duplication with Properties
    on(key, callback) {
        this._checkDisposed();
        let events = this._settingEvents[key];
        if (events === undefined) events = this._settingEvents[key] = [];
        events.push(callback);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            $2f30431acd054e2f$export$2529f734547e2830(events, callback);
            if (events.length === 0) delete this._settingEvents[key];
        });
    }
    // TODO code duplication with Properties
    onPrivate(key, callback) {
        this._checkDisposed();
        let events = this._privateSettingEvents[key];
        if (events === undefined) events = this._privateSettingEvents[key] = [];
        events.push(callback);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            $2f30431acd054e2f$export$2529f734547e2830(events, callback);
            if (events.length === 0) delete this._privateSettingEvents[key];
        });
    }
    _apply(entity, state) {
        this._checkDisposed();
        const disposers = [];
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._settingEvents, (key, events)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(events, (event)=>{
                disposers.push(entity.on(key, event));
            });
        });
        $e66f9343b5144e1a$export$79b2f7037acddd43(this._privateSettingEvents, (key, events)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(events, (event)=>{
                disposers.push(entity.onPrivate(key, event));
            });
        });
        this.states._apply(entity, state);
        disposers.push(this.adapters._apply(entity));
        disposers.push(entity.events.copyFrom(this.events));
        return new (0, $a363f66303166aa1$export$9720df365053d143)(disposers);
    }
    _setObjectTemplate(entity) {
        this._checkDisposed();
        this._entities.push(entity);
    }
    _removeObjectTemplate(entity) {
        //this._checkDisposed();
        $2f30431acd054e2f$export$cd7f480d6b8286c3(this._entities, entity);
    }
    _stateChanged(name) {
        this._checkDisposed();
        this._entities.forEach((entity)=>{
            entity._applyStateByKey(name);
        });
    }
}











//import { populateString } from "../util/PopulateString";
/**
 * An [[EventDispatcher]] for [[Sprite]].
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/events/} for more info
 */ class $d3b9c83dc790fa66$var$SpriteEventDispatcher extends (0, $7e417cbab1b21893$export$ec8b666c5fe2c75a) {
    constructor(sprite){
        super();
        this._rendererDisposers = {};
        this._dispatchParents = true;
        this._sprite = sprite;
    }
    _makePointerEvent(key, event) {
        return {
            type: key,
            originalEvent: event.event,
            point: event.point,
            simulated: event.simulated,
            native: event.native,
            target: this._sprite
        };
    }
    _onRenderer(key, dispatch) {
        // TODO: is this OK? it'd be good not to require to set this on each individual element
        this._sprite.set("interactive", true);
        this._sprite._display.interactive = true;
        let events = this._rendererDisposers[key];
        if (events === undefined) {
            const disposer = this._sprite._display.on(key, (e)=>{
                dispatch.call(this, e);
            });
            events = this._rendererDisposers[key] = new (0, $a363f66303166aa1$export$8a02b29de282f67f)(()=>{
                delete this._rendererDisposers[key];
                disposer.dispose();
            });
        }
        return events.increment();
    }
    _on(once, type, callback, context, shouldClone, dispatch, debounceDelay) {
        const info = super._on(once, type, callback, context, shouldClone, dispatch, debounceDelay);
        const rendererEvent = $d3b9c83dc790fa66$var$SpriteEventDispatcher.RENDERER_EVENTS[type];
        if (rendererEvent !== undefined) info.disposer = new (0, $a363f66303166aa1$export$9720df365053d143)([
            info.disposer,
            this._onRenderer(type, rendererEvent)
        ]);
        return info;
    }
    /**
     * Will stop any bubbling up of the event to element's parents.
     *
     * Should be called in an event handler, e.g.:
     *
     * ```TypeScript
     * element.events.on("pointerdown", function(ev) {
     *   // Do something here and prevent from "pointerdown" bubbling up
     *   // ...
     *   ev.target.events.stopParentDispatch();
     * });
     * ```
     * ```JavaScript
     * element.events.on("pointerdown", function(ev) {
     *   // Do something here and prevent from "pointerdown" bubbling up
     *   // ...
     *   ev.target.events.stopParentDispatch();
     * });
     * ```
     */ stopParentDispatch() {
        this._dispatchParents = false;
    }
    /**
     * @ignore
     */ dispatchParents(type, event) {
        const old = this._dispatchParents;
        this._dispatchParents = true;
        try {
            this.dispatch(type, event);
            if (this._dispatchParents && this._sprite.parent) this._sprite.parent.events.dispatchParents(type, event);
        } finally{
            this._dispatchParents = old;
        }
    }
}
$d3b9c83dc790fa66$var$SpriteEventDispatcher.RENDERER_EVENTS = {
    "click": function(event) {
        if (this.isEnabled("click") && !this._sprite.isDragging() && this._sprite._hasDown() && !this._sprite._hasMoved(this._makePointerEvent("click", event))) this.dispatch("click", this._makePointerEvent("click", event));
    },
    "rightclick": function(event) {
        if (this.isEnabled("rightclick")) this.dispatch("rightclick", this._makePointerEvent("rightclick", event));
    },
    "middleclick": function(event) {
        if (this.isEnabled("middleclick")) this.dispatch("middleclick", this._makePointerEvent("middleclick", event));
    },
    "dblclick": function(event) {
        this.dispatchParents("dblclick", this._makePointerEvent("dblclick", event));
    },
    "pointerover": function(event) {
        const sprite = this._sprite;
        let dispatch = true;
        if (sprite.getPrivate("trustBounds")) {
            sprite._getBounds();
            const bounds = sprite.globalBounds();
            if (sprite.isType("Graphics")) {
                const strokeWidth = sprite.get("strokeWidth", 1) / 2;
                if (strokeWidth >= 1) {
                    bounds.left -= strokeWidth;
                    bounds.right += strokeWidth;
                    bounds.top -= strokeWidth;
                    bounds.bottom += strokeWidth;
                }
            }
            if (!$f43e9e04b3f0548b$export$4e985c1b25c164db(event.point, bounds)) {
                dispatch = false;
                sprite._root._renderer.removeHovering(sprite._display);
            }
        }
        if (dispatch && this.isEnabled("pointerover")) this.dispatch("pointerover", this._makePointerEvent("pointerover", event));
    },
    "pointerout": function(event) {
        if (this.isEnabled("pointerout")) this.dispatch("pointerout", this._makePointerEvent("pointerout", event));
    },
    "pointerdown": function(event) {
        this.dispatchParents("pointerdown", this._makePointerEvent("pointerdown", event));
    },
    "pointerup": function(event) {
        if (this.isEnabled("pointerup")) this.dispatch("pointerup", this._makePointerEvent("pointerup", event));
    },
    "globalpointerup": function(event) {
        if (this.isEnabled("globalpointerup")) this.dispatch("globalpointerup", this._makePointerEvent("globalpointerup", event));
    },
    "globalpointermove": function(event) {
        if (this.isEnabled("globalpointermove")) this.dispatch("globalpointermove", this._makePointerEvent("globalpointermove", event));
    },
    "globalpointerdown": function(event) {
        if (this.isEnabled("globalpointerdown")) this.dispatch("globalpointerdown", this._makePointerEvent("globalpointerdown", event));
    },
    "wheel": function(event) {
        this.dispatchParents("wheel", {
            type: "wheel",
            target: this._sprite,
            originalEvent: event.event,
            point: event.point
        });
    }
};
class $d3b9c83dc790fa66$export$3075603db8e6204c extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    constructor(){
        super(...arguments);
        this._adjustedLocalBounds = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this._localBounds = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this._sizeDirty = false;
        // Will be true only when dragging
        this._isDragging = false;
        this._isHidden = false;
        this._isShowing = false;
        this._isHiding = false;
        this._isDown = false;
        this._downPoints = {};
    }
    _afterNew() {
        this.setPrivateRaw("visible", true);
        super._afterNew();
    }
    /**
     * Marks some setting as dirty. Could be used to trigger adapter.
     * @param key
     */ markDirtyKey(key) {
        this._markDirtyKey(key);
    }
    _markDirtyKey(key) {
        super._markDirtyKey(key);
        if (key == "x" || key == "y" || key == "dx" || key == "dy") {
            this.markDirtyBounds();
            this._addPercentagePositionChildren();
            this.markDirtyPosition();
        }
    }
    _markDirtyPrivateKey(key) {
        super._markDirtyPrivateKey(key);
        if (key == "x" || key == "y") this.markDirtyPosition();
    }
    _removeTemplateField() {
        if (this._templateField) this._templateField._removeObjectTemplate(this);
    }
    _createEvents() {
        return new $d3b9c83dc790fa66$var$SpriteEventDispatcher(this);
    }
    _processTemplateField() {
        let template;
        const field = this.get("templateField");
        if (field) {
            const dataItem = this.dataItem;
            if (dataItem) {
                const context = dataItem.dataContext;
                if (context) {
                    template = context[field];
                    if (!(template instanceof (0, $2d9a18dcb72760f7$export$14416b8d99d47caa)) && template) template = (0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new(template);
                }
            }
        }
        if (this._templateField !== template) {
            this._removeTemplateField();
            this._templateField = template;
            if (template) template._setObjectTemplate(this);
            this._applyTemplates();
        }
    }
    // TODO change this to run before the element is added to the parent, so that way
    //      it doesn't need to apply the themes twice
    _setDataItem(dataItem) {
        const oldDataItem = this._dataItem;
        this._dataItem = dataItem;
        this._processTemplateField();
        const eventType = "dataitemchanged";
        if (dataItem != oldDataItem) {
            if (this.events.isEnabled(eventType)) this.events.dispatch(eventType, {
                type: eventType,
                target: this,
                oldDataItem: oldDataItem,
                newDataItem: dataItem
            });
        }
    }
    /**
     * A [[DataItem]] used for this element.
     *
     * NOTE: data item is being assigned automatically in most cases where it
     * matters. Use this accessor to set data item only if you know what you're
     * doing.
     *
     * @param  value  Data item
     */ set dataItem(value) {
        this._setDataItem(value);
    }
    /**
     * @return DataItem
     */ get dataItem() {
        if (this._dataItem) return this._dataItem;
        else {
            let parent = this._parent;
            while(parent){
                if (parent._dataItem) return parent._dataItem;
                else parent = parent._parent;
            }
        }
    }
    _addPercentageSizeChildren() {
        let parent = this.parent;
        if (parent) {
            if (this.get("width") instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e) || this.get("height") instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) $2f30431acd054e2f$export$3589e1fa93f0a8a5(parent._percentageSizeChildren, this);
            else $2f30431acd054e2f$export$2529f734547e2830(parent._percentageSizeChildren, this);
        }
    }
    _addPercentagePositionChildren() {
        let parent = this.parent;
        if (parent) {
            if (this.get("x") instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e) || this.get("y") instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) $2f30431acd054e2f$export$3589e1fa93f0a8a5(parent._percentagePositionChildren, this);
            else $2f30431acd054e2f$export$2529f734547e2830(parent._percentagePositionChildren, this);
        }
    }
    /**
     * @ignore
     */ markDirtyPosition() {
        this._root._addDirtyPosition(this);
    }
    updatePivotPoint() {
        const bounds = this._localBounds;
        if (bounds) {
            const centerX = this.get("centerX");
            if (centerX != null) this._display.pivot.x = bounds.left + $05b1b40b69b15016$export$302dfacf2b0a56fe(centerX, bounds.right - bounds.left);
            const centerY = this.get("centerY");
            if (centerY != null) this._display.pivot.y = bounds.top + $05b1b40b69b15016$export$302dfacf2b0a56fe(centerY, bounds.bottom - bounds.top);
        }
    }
    _beforeChanged() {
        super._beforeChanged();
        // handling states in beforeChanged, otherwise states is not applied without animated theme
        this._handleStates();
        if (this.isDirty("tooltip")) {
            const previous = this._prevSettings.tooltip;
            if (previous) previous.dispose();
        }
        if (this.isDirty("layer") || this.isDirty("layerMargin")) {
            this._display.setLayer(this.get("layer"), this.get("layerMargin"));
            this.markDirtyLayer();
        }
        if (this.isDirty("tooltipPosition")) {
            const tooltipMoveDp = this._tooltipMoveDp;
            if (tooltipMoveDp) {
                tooltipMoveDp.dispose();
                this._tooltipMoveDp = undefined;
            }
            const tooltipPointerDp = this._tooltipPointerDp;
            if (tooltipPointerDp) {
                tooltipPointerDp.dispose();
                this._tooltipPointerDp = undefined;
            }
            if (this.get("tooltipPosition") == "pointer") {
                if (this.isHover()) this._tooltipMoveDp = this.events.on("globalpointermove", (e)=>{
                    this.showTooltip(e.point);
                });
                this._tooltipPointerDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                    this.events.on("pointerover", ()=>{
                        this._tooltipMoveDp = this.events.on("globalpointermove", (e)=>{
                            this.showTooltip(e.point);
                        });
                    }),
                    this.events.on("pointerout", ()=>{
                        const tooltipMoveDp = this._tooltipMoveDp;
                        if (tooltipMoveDp) {
                            tooltipMoveDp.dispose();
                            this._tooltipMoveDp = undefined;
                        }
                    })
                ]);
            }
        }
    }
    _handleStates() {
        //if (!this._statesHandled) {
        if (this.isDirty("active")) {
            if (this.get("active")) {
                this.states.applyAnimate("active");
                this.set("ariaChecked", true);
            } else {
                if (!this.isHidden()) this.states.applyAnimate("default");
                this.set("ariaChecked", false);
            }
            this.markDirtyAccessibility();
        }
        if (this.isDirty("disabled")) {
            if (this.get("disabled")) {
                this.states.applyAnimate("disabled");
                this.set("ariaChecked", false);
            } else {
                if (!this.isHidden()) this.states.applyAnimate("default");
                this.set("ariaChecked", true);
            }
            this.markDirtyAccessibility();
        }
    //	this._statesHandled = true;
    //}
    }
    _changed() {
        super._changed();
        const display = this._display;
        const events = this.events;
        if (this.isDirty("draggable")) {
            const draggable = this.get("draggable");
            if (draggable) {
                this.set("interactive", true);
                this._dragDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                    events.on("pointerdown", (ev)=>{
                        this.dragStart(ev);
                    }),
                    events.on("globalpointermove", (ev)=>{
                        this.dragMove(ev);
                    }),
                    events.on("globalpointerup", (ev)=>{
                        this.dragStop(ev);
                    })
                ]);
            } else if (this._dragDp) {
                this._dragDp.dispose();
                this._dragDp = undefined;
            }
            display.cancelTouch = draggable ? true : false;
        }
        if (this.isDirty("tooltipText") || this.isDirty("tooltipHTML") || this.isDirty("showTooltipOn")) {
            const tooltipText = this.get("tooltipText");
            const tooltipHTML = this.get("tooltipHTML");
            const showTooltipOn = this.get("showTooltipOn", "hover");
            if (this._tooltipDp) {
                this._tooltipDp.dispose();
                this._tooltipDp = undefined;
            }
            if (tooltipText || tooltipHTML) {
                if (showTooltipOn == "click") {
                    this._tooltipDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                        events.on("click", ()=>{
                            this.setTimeout(()=>{
                                const tooltip = this.getTooltip();
                                if (tooltip && !tooltip.isHidden() && tooltip.get("tooltipTarget") === this) this.hideTooltip();
                                else this.showTooltip();
                            }, 10);
                        }),
                        $05b1b40b69b15016$export$3f65cefe8380dbea(document, "click", (_ev)=>{
                            this.hideTooltip();
                        })
                    ]);
                    this._disposers.push(this._tooltipDp);
                } else if (showTooltipOn == "always") ;
                else {
                    this._tooltipDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                        events.on("pointerover", ()=>{
                            this.showTooltip();
                        }),
                        events.on("pointerout", ()=>{
                            this.hideTooltip();
                        })
                    ]);
                    this._disposers.push(this._tooltipDp);
                }
            }
        }
        if (this.isDirty("toggleKey")) {
            let toggleKey = this.get("toggleKey");
            if (toggleKey && toggleKey != "none") this._toggleDp = events.on("click", ()=>{
                if (!this._isDragging) this.set(toggleKey, !this.get(toggleKey));
            });
            else if (this._toggleDp) {
                this._toggleDp.dispose();
                this._toggleDp = undefined;
            }
        }
        if (this.isDirty("opacity")) {
            display.alpha = Math.max(0, this.get("opacity", 1));
            if (this.get("focusable")) this.markDirtyAccessibility();
        }
        if (this.isDirty("rotation")) {
            this.markDirtyBounds();
            display.angle = this.get("rotation", 0);
        }
        if (this.isDirty("scale")) {
            this.markDirtyBounds();
            display.scale = this.get("scale", 0);
        }
        if (this.isDirty("centerX") || this.isDirty("centerY")) {
            this.markDirtyBounds();
            this.updatePivotPoint();
        }
        if (this.isDirty("visible") || this.isPrivateDirty("visible") || this.isDirty("forceHidden")) {
            if (!this.get("visible") || !this.getPrivate("visible") || this.get("forceHidden")) {
                display.visible = false;
                this.hideTooltip();
            } else display.visible = true;
            this.markDirtyBounds();
            if (this.get("focusable")) this.markDirtyAccessibility();
        }
        if (this.isDirty("width") || this.isDirty("height")) {
            this.markDirtyBounds();
            this._addPercentageSizeChildren();
            const parent = this.parent;
            if (parent) {
                if (this.isDirty("width") && this.get("width") instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e) || this.isDirty("height") && this.get("height") instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                    parent.markDirty();
                    parent._prevWidth = 0;
                }
            }
            this._sizeDirty = true;
        }
        if (this.isDirty("maxWidth") || this.isDirty("maxHeight") || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("minWidth") || this.isDirty("minHeight") || this.isPrivateDirty("maxWidth") || this.isPrivateDirty("maxHeight") || this.isPrivateDirty("minWidth") || this.isPrivateDirty("minHeight") || this.isDirty("marginLeft") || this.isDirty("marginTop") || this.isDirty("marginRight") || this.isDirty("marginBottom")) {
            this.markDirtyBounds();
            this._sizeDirty = true;
        }
        if (this._sizeDirty) this._updateSize();
        if (this.isDirty("wheelable")) {
            const wheelable = this.get("wheelable");
            if (wheelable) this.set("interactive", true);
            display.wheelable = wheelable ? true : false;
        }
        // Accessibility
        if (this.isDirty("tabindexOrder") || this.isDirty("focusableGroup")) {
            if (this.get("focusable")) this._root._registerTabindexOrder(this);
            else this._root._unregisterTabindexOrder(this);
        }
        if (this.isDirty("filter")) //this.markDirtyBounds();
        display.filter = this.get("filter");
        let filter = this.get("filter", "");
        if (this.isDirty("blur")) {
            const blur = this.get("blur", 0);
            if (blur != 0) filter += " blur(" + blur + "px)";
        }
        if (this.isDirty("saturate")) {
            const saturate = this.get("saturate", 1);
            if (saturate != 1) filter += " saturate(" + saturate + ")";
        }
        if (this.isDirty("brightness")) {
            const brightness = this.get("brightness", 1);
            if (brightness != 1) filter += " brightness(" + brightness + ")";
        }
        if (this.isDirty("contrast")) {
            const contrast = this.get("contrast", 1);
            if (contrast != 1) filter += " contrast(" + contrast + ")";
        }
        if (this.isDirty("sepia")) {
            const sepia = this.get("sepia", 0);
            if (sepia != 0) filter += " sepia(" + sepia + ")";
        }
        if (this.isDirty("hue")) {
            const hue = this.get("hue", 0);
            if (hue != 0) filter += " hue-rotate(" + hue + "deg)";
        }
        if (this.isDirty("invert")) {
            const invert = this.get("invert", 0);
            if (invert != 0) filter += " invert(" + invert + ")";
        }
        if (filter) display.filter = filter;
        if (this.isDirty("cursorOverStyle")) display.cursorOverStyle = this.get("cursorOverStyle");
        if (this.isDirty("hoverOnFocus")) {
            if (this.get("hoverOnFocus")) this._focusDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                events.on("focus", ()=>{
                    // TODO: proper hover, not just tooltip
                    this.showTooltip();
                }),
                events.on("blur", ()=>{
                    // TODO: proper hover, not just tooltip
                    this.hideTooltip();
                })
            ]);
            else if (this._focusDp) {
                this._focusDp.dispose();
                this._focusDp = undefined;
            }
        }
        if (this.isDirty("focusable")) {
            if (this.get("focusable")) this._root._registerTabindexOrder(this);
            else this._root._unregisterTabindexOrder(this);
            this.markDirtyAccessibility();
            this._disposers.push(events.on("blur", ()=>{
                this.setPrivateRaw("touchHovering", false);
            }));
            this._disposers.push(events.once("boundschanged", ()=>{
                // We might need to do this to re-evaluate accessibility attributes
                // once the element gains size (bounds)
                this.markDirtyAccessibility();
            }));
        }
        if (this.isPrivateDirty("focusable")) this.markDirtyAccessibility();
        if (this.isDirty("role") || this.isDirty("ariaLive") || this.isDirty("ariaChecked") || this.isDirty("ariaHidden") || this.isDirty("ariaOrientation") || this.isDirty("ariaValueNow") || this.isDirty("ariaValueMin") || this.isDirty("ariaValueMax") || this.isDirty("ariaValueText") || this.isDirty("ariaLabel") || this.isDirty("ariaControls")) // display.accessibility.ariaLabel = populateString(this, this.get("ariaLabel", ""));
        // @todo make sure ariaLabel gets populated in Root
        this.markDirtyAccessibility();
        if (this.isDirty("exportable")) display.exportable = this.get("exportable");
        if (this.isDirty("interactive")) {
            const events = this.events;
            if (this.get("interactive") && !events.isDisposed()) this._hoverDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                events.on("click", (ev)=>{
                    if ($05b1b40b69b15016$export$c4dfce035d43d1e0(ev.originalEvent)) {
                        if (!this.getPrivate("touchHovering")) this.setTimeout(()=>{
                            this._handleOver();
                            if (this.get("tooltipText") || this.get("tooltipHTML")) this.showTooltip();
                            this.setPrivateRaw("touchHovering", true);
                            this.events.dispatch("pointerover", {
                                type: "pointerover",
                                target: ev.target,
                                originalEvent: ev.originalEvent,
                                point: ev.point,
                                simulated: ev.simulated
                            });
                        }, 10);
                    }
                }),
                events.on("globalpointerup", (ev)=>{
                    if ($05b1b40b69b15016$export$c4dfce035d43d1e0(ev.originalEvent)) {
                        if (this.getPrivate("touchHovering")) {
                            this._handleOut();
                            if (this.get("tooltipText") || this.get("tooltipHTML")) this.hideTooltip();
                            this.setPrivateRaw("touchHovering", false);
                            this.events.dispatch("pointerout", {
                                type: "pointerout",
                                target: ev.target,
                                originalEvent: ev.originalEvent,
                                point: ev.point,
                                simulated: ev.simulated
                            });
                        }
                    }
                    if (this._isDown) this._handleUp(ev);
                //this._isDown = false;
                }),
                events.on("pointerover", ()=>{
                    this._handleOver();
                }),
                events.on("pointerout", ()=>{
                    this._handleOut();
                }),
                events.on("pointerdown", (e)=>{
                    this._handleDown(e);
                })
            ]);
            else {
                this._display.interactive = false;
                if (this._hoverDp) {
                    this._hoverDp.dispose();
                    this._hoverDp = undefined;
                }
            }
        }
        if (this.isDirty("forceInactive")) this._display.inactive = this.get("forceInactive", null);
        if (this.get("showTooltipOn") == "always" && this._display.visible) this.showTooltip();
    }
    /**
     * @ignore
     * @todo should this be user-accessible?
     */ dragStart(e) {
        this._dragEvent = e;
        this.events.stopParentDispatch();
    }
    /**
     * @ignore
     * @todo should this be user-accessible?
     */ dragStop(e) {
        this._dragEvent = undefined;
        this._dragPoint = undefined;
        this.events.stopParentDispatch();
        if (this._isDragging) {
            this._isDragging = false;
            const type = "dragstop";
            if (this.events.isEnabled(type)) this.events.dispatch(type, {
                type: type,
                target: this,
                originalEvent: e.originalEvent,
                point: e.point,
                simulated: e.simulated
            });
        }
    }
    _handleOver() {
        if (!this.isHidden()) {
            if (this.get("active") && this.states.lookup("hoverActive")) this.states.applyAnimate("hoverActive");
            else if (this.get("disabled") && this.states.lookup("hoverDisabled")) this.states.applyAnimate("hoverDisabled");
            else this.states.applyAnimate("hover");
            if (this.get("draggable") && this._isDown && this.states.lookup("down")) this.states.applyAnimate("down");
        }
    }
    _handleOut() {
        if (!this.isHidden()) {
            if (this.get("active") && this.states.lookup("active")) this.states.applyAnimate("active");
            else if (this.get("disabled") && this.states.lookup("disabled")) this.states.applyAnimate("disabled");
            else if (this.states.lookup("hover") || this.states.lookup("hoverActive")) this.states.applyAnimate("default");
            if (this.get("draggable") && this._isDown && this.states.lookup("down")) this.states.applyAnimate("down");
        }
    }
    _handleUp(e) {
        if (!this.isHidden()) {
            if (this.get("active") && this.states.lookup("active")) this.states.applyAnimate("active");
            else if (this.get("disabled") && this.states.lookup("disabled")) this.states.applyAnimate("disabled");
            else if (this.states.lookup("down")) {
                if (this.isHover()) this.states.applyAnimate("hover");
                else this.states.applyAnimate("default");
            }
            // @todo remove this once migrated to _downPoints
            this._downPoint = undefined;
            const pointerId = $05b1b40b69b15016$export$a845ff6c553b3014(e.originalEvent);
            delete this._downPoints[pointerId];
            if ($e66f9343b5144e1a$export$ed97f33186d4b816(this._downPoints).length == 0) this._isDown = false;
        }
    }
    _hasMoved(e) {
        // @todo remove this once migrated to _downPoints
        // if (this._downPoint) {
        // 	const x = Math.abs(this._downPoint.x - e.point.x);
        // 	const y = Math.abs(this._downPoint.y - e.point.y);
        // 	return (x > 5) || (y > 5);
        // }
        const pointerId = $05b1b40b69b15016$export$a845ff6c553b3014(e.originalEvent);
        const downPoint = this._downPoints[pointerId];
        if (downPoint) {
            const x = Math.abs(downPoint.x - e.point.x);
            const y = Math.abs(downPoint.y - e.point.y);
            return x > 5 || y > 5;
        }
        return false;
    }
    _hasDown() {
        return $e66f9343b5144e1a$export$ed97f33186d4b816(this._downPoints).length > 0;
    }
    _handleDown(e) {
        const parent = this.parent;
        if (parent && !this.get("draggable")) parent._handleDown(e);
        if (this.get("interactive") && !this.isHidden()) {
            if (this.states.lookup("down")) this.states.applyAnimate("down");
            this._downPoint = {
                x: e.point.x,
                y: e.point.y
            };
            // @todo remove this once migrated to _downPoints
            this._isDown = true;
            const pointerId = $05b1b40b69b15016$export$a845ff6c553b3014(e.originalEvent);
            this._downPoints[pointerId] = {
                x: e.point.x,
                y: e.point.y
            };
        }
    }
    /**
     * @ignore
     * @todo should this be user-accessible?
     */ dragMove(e) {
        let dragEvent = this._dragEvent;
        if (dragEvent) {
            if (dragEvent.simulated && !e.simulated) return true;
            let angle = 0;
            let parent = this.parent;
            let scale = 1;
            while(parent != null){
                angle += parent.get("rotation", 0);
                parent = parent.parent;
                if (parent) scale *= parent.get("scale", 1);
            }
            let x = (e.point.x - dragEvent.point.x) / scale;
            let y = (e.point.y - dragEvent.point.y) / scale;
            const events = this.events;
            if (dragEvent.simulated && !this._isDragging) {
                this._isDragging = true;
                this._dragEvent = e;
                this._dragPoint = {
                    x: this.x(),
                    y: this.y()
                };
                const type = "dragstart";
                if (events.isEnabled(type)) events.dispatch(type, {
                    type: type,
                    target: this,
                    originalEvent: e.originalEvent,
                    point: e.point,
                    simulated: e.simulated
                });
            }
            if (this._isDragging) {
                let dragPoint = this._dragPoint;
                this.set("x", dragPoint.x + x * $f43e9e04b3f0548b$export$50d414a77b60d802(angle) + y * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle));
                this.set("y", dragPoint.y + y * $f43e9e04b3f0548b$export$50d414a77b60d802(angle) - x * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle));
                const type = "dragged";
                if (events.isEnabled(type)) events.dispatch(type, {
                    type: type,
                    target: this,
                    originalEvent: e.originalEvent,
                    point: e.point,
                    simulated: e.simulated
                });
            } else if (Math.hypot(x, y) > 5) {
                this._isDragging = true;
                this._dragEvent = e;
                this._dragPoint = {
                    x: this.x(),
                    y: this.y()
                };
                const type = "dragstart";
                if (events.isEnabled(type)) events.dispatch(type, {
                    type: type,
                    target: this,
                    originalEvent: e.originalEvent,
                    point: e.point,
                    simulated: e.simulated
                });
            }
        }
    }
    _updateSize() {}
    _getBounds() {
        this._localBounds = this._display.getLocalBounds();
    }
    /**
     * Returns depth (how deep in the hierachy of the content tree) of this
     * element.
     *
     * @return Depth
     */ depth() {
        let self = this.parent;
        let depth = 0;
        while(true){
            if (self) {
                ++depth;
                self = self.parent;
            } else return depth;
        }
    }
    /**
     * @ignore
     */ markDirtySize() {
        this._sizeDirty = true;
        this.markDirty();
    }
    /**
     * @ignore
     */ markDirtyBounds() {
        const display = this._display;
        if (this.get("isMeasured")) {
            this._root._addDirtyBounds(this);
            display.isMeasured = true;
            display.invalidateBounds();
            const parent = this.parent;
            if (parent && this.get("position") != "absolute") {
                if (parent.get("width") == null || parent.get("height") == null || parent.get("layout")) parent.markDirtyBounds();
            }
            if (this.get("focusable")) this.markDirtyAccessibility();
        }
    }
    /**
     * @ignore
     */ markDirtyAccessibility() {
        //if (this._root.focused(this)) {
        this._root._invalidateAccessibility(this);
    //}
    }
    /**
     * @ignore
     */ markDirtyLayer() {
        //this._display.markDirtyLayer(this.isDirty("opacity") || this.isDirty("visible")); https://codepen.io/team/amcharts/pen/gOWZPmP <- problems
        this._display.markDirtyLayer(true);
    }
    /**
     * @ignore
     */ markDirty() {
        super.markDirty();
        this.markDirtyLayer();
    }
    _updateBounds() {
        const oldBounds = this._adjustedLocalBounds;
        let newBounds;
        // if display.visible == false, it still returns bounds
        if (!this.get("visible") || !this.getPrivate("visible") || this.get("forceHidden")) {
            newBounds = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            };
            this._localBounds = newBounds;
            this._adjustedLocalBounds = newBounds;
        } else {
            this._getBounds();
            this._fixMinBounds(this._localBounds);
            this.updatePivotPoint();
            this._adjustedLocalBounds = this._display.getAdjustedBounds(this._localBounds);
            newBounds = this._adjustedLocalBounds;
        }
        if (!oldBounds || oldBounds.left !== newBounds.left || oldBounds.top !== newBounds.top || oldBounds.right !== newBounds.right || oldBounds.bottom !== newBounds.bottom) {
            const eventType = "boundschanged";
            if (this.events.isEnabled(eventType)) this.events.dispatch(eventType, {
                type: eventType,
                target: this
            });
            if (this.parent) {
                this.parent.markDirty();
                this.parent.markDirtyBounds();
            }
            // Update tooltip position together with the Sprite
            if (this.getPrivate("showingTooltip")) this.showTooltip();
        }
    }
    _fixMinBounds(bounds) {
        let minWidth = this.get("minWidth", this.getPrivate("minWidth"));
        let minHeight = this.get("minHeight", this.getPrivate("minHeight"));
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(minWidth)) {
            if (bounds.right - bounds.left < minWidth) bounds.right = bounds.left + minWidth;
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(minHeight)) {
            if (bounds.bottom - bounds.top < minHeight) bounds.bottom = bounds.top + minHeight;
        }
        let privateWidth = this.getPrivate("width");
        let privateHeight = this.getPrivate("height");
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(privateWidth)) {
            if (privateWidth > 0) bounds.right = bounds.left + privateWidth;
            else bounds.left = bounds.right + privateWidth;
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(privateHeight)) {
            if (privateHeight > 0) bounds.bottom = bounds.top + privateHeight;
            else bounds.top = bounds.bottom + privateHeight;
        }
    }
    _removeParent(parent) {
        if (parent) {
            parent.children.removeValue(this);
            $2f30431acd054e2f$export$2529f734547e2830(parent._percentageSizeChildren, this);
            $2f30431acd054e2f$export$2529f734547e2830(parent._percentagePositionChildren, this);
        }
    }
    _clearDirty() {
        super._clearDirty();
        this._sizeDirty = false;
    //this._statesHandled = false;
    }
    /**
     * Simulate hover over element.
     */ hover() {
        if (!this.isDisposed()) {
            this.showTooltip();
            this._handleOver();
        }
    }
    /**
     * Simulate unhover over element.
     */ unhover() {
        if (!this.isDisposed()) {
            this.hideTooltip();
            this._handleOut();
        }
    }
    /**
     * Shows element's [[Tooltip]].
     */ showTooltip(point) {
        if (!this.isDisposed()) {
            const tooltip = this.getTooltip();
            const tooltipText = this.get("tooltipText");
            const tooltipHTML = this.get("tooltipHTML");
            if ((tooltipText || tooltipHTML) && tooltip) {
                const tooltipPosition = this.get("tooltipPosition");
                const tooltipTarget = this.getPrivate("tooltipTarget", this);
                if (tooltipPosition == "fixed" || !point) {
                    this._display._setMatrix();
                    point = this.toGlobal(tooltipTarget._getTooltipPoint());
                }
                if (tooltipPosition == "pointer") {
                    const lastTooltipCoords = this.getPrivate("lastTooltipCoords");
                    if (lastTooltipCoords && lastTooltipCoords.x == point.x && lastTooltipCoords.y == point.y) return;
                    else this.setPrivate("lastTooltipCoords", point);
                }
                tooltip.set("pointTo", point);
                tooltip.set("tooltipTarget", tooltipTarget);
                if (!tooltip.get("x")) tooltip.set("x", point.x);
                if (!tooltip.get("y")) tooltip.set("y", point.y);
                if (tooltipText) tooltip.label.set("text", tooltipText);
                if (tooltipHTML) tooltip.label.set("html", tooltipHTML);
                const dataItem = this.dataItem;
                if (dataItem) tooltip.label._setDataItem(dataItem);
                if (this.get("showTooltipOn") == "always" && (point.x < 0 || point.x > this._root.width() || point.y < 0 || point.y > this._root.height())) {
                    this.hideTooltip();
                    return;
                }
                tooltip.label.text.markDirtyText();
                const promise = tooltip.show();
                this.setPrivateRaw("showingTooltip", true);
                return promise;
            }
        }
    }
    /**
     * Hides element's [[Tooltip]].
     */ hideTooltip() {
        const tooltip = this.getTooltip();
        if (tooltip) {
            this.removePrivate("lastTooltipCoords");
            if (tooltip.get("tooltipTarget") == this.getPrivate("tooltipTarget", this) || this.get("tooltip") == tooltip) {
                let timeout = tooltip.get("keepTargetHover") && tooltip.get("stateAnimationDuration", 0) == 0 ? 400 : undefined;
                const promise = tooltip.hide(timeout);
                this.setPrivateRaw("showingTooltip", false);
                return promise;
            }
        }
    }
    _getTooltipPoint() {
        const bounds = this._localBounds;
        if (bounds) {
            let x = 0;
            let y = 0;
            if (!this.get("isMeasured")) {
                x = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("tooltipX", 0), this.width());
                y = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("tooltipY", 0), this.height());
            } else {
                x = bounds.left + $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("tooltipX", 0), bounds.right - bounds.left);
                y = bounds.top + $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("tooltipY", 0), bounds.bottom - bounds.top);
            }
            return {
                x: x,
                y: y
            };
        }
        return {
            x: 0,
            y: 0
        };
    }
    /**
     * Returns [[Tooltip]] used for this element.
     *
     * @return Tooltip
     */ getTooltip() {
        let tooltip = this.get("tooltip");
        if (!tooltip) {
            let parent = this.parent;
            if (parent) return parent.getTooltip();
        } else return tooltip;
    }
    _updatePosition() {
        const parent = this.parent;
        let dx = this.get("dx", 0);
        let dy = this.get("dy", 0);
        let x = this.get("x");
        let _x = this.getPrivate("x");
        let xx = 0;
        let yy = 0;
        const position = this.get("position");
        if (x instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
            if (parent) x = parent.innerWidth() * x.value + parent.get("paddingLeft", 0);
            else x = 0;
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(x)) xx = x + dx;
        else {
            if (_x != null) xx = _x;
            else if (parent) {
                if (position == "relative") xx = parent.get("paddingLeft", 0) + dx;
            }
        }
        let y = this.get("y");
        let _y = this.getPrivate("y");
        if (y instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
            if (parent) y = parent.innerHeight() * y.value + parent.get("paddingTop", 0);
            else y = 0;
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(y)) yy = y + dy;
        else {
            if (_y != null) yy = _y;
            else if (parent) {
                if (position == "relative") yy = parent.get("paddingTop", 0) + dy;
            }
        }
        const display = this._display;
        if (display.x != xx || display.y != yy) {
            display.invalidateBounds();
            display.x = xx;
            display.y = yy;
            const eventType = "positionchanged";
            if (this.events.isEnabled(eventType)) this.events.dispatch(eventType, {
                type: eventType,
                target: this
            });
        }
        // Update tooltip position together with the Sprite
        if (this.getPrivate("showingTooltip")) this.showTooltip();
    }
    /**
     * Returns element's actual X position in pixels.
     *
     * @return X (px)
     */ x() {
        let x = this.get("x");
        let _x = this.getPrivate("x");
        const parent = this.parent;
        if (parent) {
            if (x instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) return $05b1b40b69b15016$export$302dfacf2b0a56fe(x, parent.innerWidth()) + parent.get("paddingLeft", 0);
            else {
                if (!$f63bdea45a89cf24$export$7e4aa119212bc614(x)) {
                    if (_x != null) return _x;
                    else return parent.get("paddingLeft", this._display.x);
                } else return x;
            }
        }
        return this._display.x;
    }
    /**
     * Returns element's actual Y position in pixels.
     *
     * @return Y (px)
     */ y() {
        let _y = this.getPrivate("y");
        if (_y != null) return _y;
        let y = this.get("y");
        const parent = this.parent;
        if (parent) {
            if (y instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) return $05b1b40b69b15016$export$302dfacf2b0a56fe(y, parent.innerHeight()) + parent.get("paddingTop", 0);
            else {
                if (!$f63bdea45a89cf24$export$7e4aa119212bc614(y)) {
                    if (_y != null) return _y;
                    else return parent.get("paddingTop", this._display.y);
                } else return y;
            }
        }
        return this._display.y;
    }
    _dispose() {
        super._dispose();
        this._display.dispose();
        this._removeTemplateField();
        this._removeParent(this.parent);
        this._root._removeFocusElement(this);
        const tooltip = this.get("tooltip");
        if (tooltip) tooltip.dispose();
        this.markDirty();
    }
    /**
     * @ignore
     */ adjustedLocalBounds() {
        this._fixMinBounds(this._adjustedLocalBounds);
        return this._adjustedLocalBounds;
    }
    /**
     * Returns local coordinates of the element's bounds.
     *
     * @ignore
     * @return Global bounds
     */ localBounds() {
        return this._localBounds;
    }
    /**
     * Returns adjusted local coordinates of the element's bounds.
     *
     * @ignore
     * @return Global bounds
     */ bounds() {
        const bounds = this._adjustedLocalBounds;
        const x = this.x();
        const y = this.y();
        return {
            left: bounds.left + x,
            right: bounds.right + x,
            top: bounds.top + y,
            bottom: bounds.bottom + y
        };
    }
    /**
     * Returns global coordinates of the element's bounds.
     *
     * @ignore
     * @return Global bounds
     */ globalBounds() {
        const bounds = this.localBounds();
        const p0 = this.toGlobal({
            x: bounds.left,
            y: bounds.top
        });
        const p1 = this.toGlobal({
            x: bounds.right,
            y: bounds.top
        });
        const p2 = this.toGlobal({
            x: bounds.right,
            y: bounds.bottom
        });
        const p3 = this.toGlobal({
            x: bounds.left,
            y: bounds.bottom
        });
        return {
            left: Math.min(p0.x, p1.x, p2.x, p3.x),
            top: Math.min(p0.y, p1.y, p2.y, p3.y),
            right: Math.max(p0.x, p1.x, p2.x, p3.x),
            bottom: Math.max(p0.y, p1.y, p2.y, p3.y)
        };
    }
    _onShow(_duration) {}
    _onHide(_duration) {}
    /**
     * Plays initial reveal animation regardless if element is currently hidden
     * or visible.
     *
     * @param   duration  Duration of the animation in milliseconds
     * @param   delay     Delay showing of the element by X milliseconds
     * @return            Promise
     */ appear(duration, delay) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            yield this.hide(0);
            if (delay) return new Promise((success, _error)=>{
                this.setTimeout(()=>{
                    success(this.show(duration));
                }, delay);
            });
            else return this.show(duration);
        });
    }
    /**
     * Shows currently hidden element and returns a `Promise` which completes
     * when all showing animations are finished.
     *
     * ```TypeScript
     * series.show().then(function(ev) {
     *   console.log("Series is now fully visible");
     * })
     * ```
     * ```JavaScript
     * series.show().then(function(ev) {
     *   console.log("Series is now fully visible");
     * })
     * ```
     *
     * @return Promise
     */ show(duration) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if (!this._isShowing) {
                this._isHidden = false;
                this._isShowing = true;
                this._isHiding = false;
                if (this.states.lookup("default").get("visible")) this.set("visible", true);
                this._onShow(duration);
                const animations = this.states.applyAnimate("default", duration);
                yield (0, $43e0e2dc9c95da4e$export$5bfdbf456b754132)(animations);
                this._isShowing = false;
            }
        });
    }
    /**
     * Hides the element and returns a `Promise` which completes when all hiding
     * animations are finished.
     *
     * ```TypeScript
     * series.hide().then(function(ev) {
     *   console.log("Series finished hiding");
     * })
     * ```
     * ```JavaScript
     * series.hide().then(function(ev) {
     *   console.log("Series finished hiding");
     * })
     * ```
     *
     * @return Promise
     */ hide(duration) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if (!this._isHiding && !this._isHidden) {
                this._isHiding = true;
                this._isShowing = false;
                let state = this.states.lookup("hidden");
                if (!state) state = this.states.create("hidden", {
                    "opacity": 0,
                    "visible": false
                });
                this._isHidden = true;
                this._onHide(duration);
                const animations = this.states.applyAnimate("hidden", duration);
                yield (0, $43e0e2dc9c95da4e$export$5bfdbf456b754132)(animations);
                this._isHiding = false;
            }
        });
    }
    /**
     * Returns `true` if this element is currently hidden.
     *
     * @return Is hidden?
     */ isHidden() {
        return this._isHidden;
    }
    /**
     * Returns `true` if this element is currently animating to a default state.
     *
     * @return Is showing?
     */ isShowing() {
        return this._isShowing;
    }
    /**
     * Returns `true` if this element is currently animating to a hidden state.
     *
     * @return Is hiding?
     */ isHiding() {
        return this._isHiding;
    }
    /**
     * Returns `true` if this element is currently hovered by a pointer.
     *
     * @return Is hovered?
     */ isHover() {
        return this._display.hovering();
    }
    /**
     * Returns `true` if this element does currently have focus.
     *
     * @return Is focused?
     */ isFocus() {
        return this._root.focused(this);
    }
    /**
     * Returns `true` if this element is currently being dragged.
     *
     * @return Is dragged?
     */ isDragging() {
        return this._isDragging;
    }
    /**
     * Returns `false` if if either public or private setting `visible` is set
     * to `false`, or `forceHidden` is set to `true`.
     *
     * @return Visible?
     */ isVisible() {
        if (this.get("visible") && this.getPrivate("visible") && !this.get("forceHidden")) return true;
        return false;
    }
    /**
     * Same as `isVisible()`, except it checks all ascendants, too.
     *
     * @since 5.2.7
     * @return Visible?
     */ isVisibleDeep() {
        return this._parent ? this._parent.isVisibleDeep() && this.isVisible() : this.isVisible();
    }
    /**
     * Returns an actual opacity of the element, taking into account all parents.
     *
     * @return Opacity
     * @since 5.2.11
     */ compositeOpacity() {
        const opacity = this.get("opacity", 1);
        return this._parent ? this._parent.compositeOpacity() * opacity : opacity;
    }
    /**
     * Returns an actual scale of the element, taking into account all parents.
     *
     * @return Opacity
     * @since 5.9.2
     */ compositeScale() {
        const scale = this.get("scale", 1);
        return this._parent ? this._parent.compositeScale() * scale : scale;
    }
    /**
     * Returns an actual roation of the element, taking into account all parents.
     *
     * @return Opacity
     * @since 5.9.2
     */ compositeRotation() {
        const rotation = this.get("rotation", 0);
        return this._parent ? this._parent.compositeRotation() + rotation : rotation;
    }
    /**
     * Returns width of this element in pixels.
     *
     * @return Width (px)
     */ width() {
        let width = this.get("width");
        let maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
        let minWidth = this.get("minWidth", this.getPrivate("minWidth"));
        let privateWidth = this.getPrivate("width");
        let w = 0;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(privateWidth)) w = privateWidth;
        else {
            if (width == null) {
                if (this._adjustedLocalBounds) w = this._adjustedLocalBounds.right - this._adjustedLocalBounds.left;
            } else {
                if (width instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                    const parent = this.parent;
                    if (parent) w = parent.innerWidth() * width.value;
                    else w = this._root.width() * width.value;
                } else if ($f63bdea45a89cf24$export$7e4aa119212bc614(width)) w = width;
            }
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(minWidth)) w = Math.max(minWidth, w);
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxWidth)) w = Math.min(maxWidth, w);
        return w;
    }
    /**
     * Returns maximum allowed width of this element in pixels.
     *
     * @return Maximum width (px)
     */ maxWidth() {
        let maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxWidth)) return maxWidth;
        else {
            let width = this.get("width");
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(width)) return width;
        }
        const parent = this.parent;
        if (parent) return parent.innerWidth();
        return this._root.width();
    }
    /**
     * Returns maximum allowed height of this element in pixels.
     *
     * @return Maximum height (px)
     */ maxHeight() {
        let maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxHeight)) return maxHeight;
        else {
            let height = this.get("height");
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(height)) return height;
        }
        const parent = this.parent;
        if (parent) return parent.innerHeight();
        return this._root.height();
    }
    /**
     * Returns height of this element in pixels.
     *
     * @return Height (px)
     */ height() {
        let height = this.get("height");
        let maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
        let minHeight = this.get("minHeight", this.getPrivate("minHeight"));
        let privateHeight = this.getPrivate("height");
        let h = 0;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(privateHeight)) h = privateHeight;
        else {
            if (height == null) {
                if (this._adjustedLocalBounds) h = this._adjustedLocalBounds.bottom - this._adjustedLocalBounds.top;
            } else {
                if (height instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                    const parent = this.parent;
                    if (parent) h = parent.innerHeight() * height.value;
                    else h = this._root.height() * height.value;
                } else if ($f63bdea45a89cf24$export$7e4aa119212bc614(height)) h = height;
            }
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(minHeight)) h = Math.max(minHeight, h);
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxHeight)) h = Math.min(maxHeight, h);
        return h;
    }
    _findStaticTemplate(f) {
        // templateField overrides template
        if (this._templateField && f(this._templateField)) return this._templateField;
        return super._findStaticTemplate(f);
    }
    _walkParents(f) {
        if (this._parent || this._virtualParent) this._walkParent(f);
    }
    _walkParent(f) {
        if (this._parent) this._parent._walkParent(f);
        else if (this._virtualParent) this._virtualParent._walkParent(f);
        f(this);
    }
    set virtualParent(parent) {
        if (this._virtualParent !== parent) {
            this._virtualParent = parent;
            this._applyThemes();
        }
    }
    /**
     * Parent [[Container]] of this element.
     *
     * @return Parent container
     */ get parent() {
        return this._parent;
    }
    _setParent(parent, updateChildren = false) {
        const prevParent = this._parent;
        if (parent !== prevParent) {
            this.markDirtyBounds();
            parent.markDirty();
            this._parent = parent;
            if (updateChildren) {
                this._removeParent(prevParent);
                if (parent) {
                    this._addPercentageSizeChildren();
                    this._addPercentagePositionChildren();
                }
            }
            this.markDirtyPosition();
            this._applyThemes();
        }
    }
    /**
     * Returns an instance of [[NumberFormatter]] used in this element.
     *
     * If this element does not have it set, global one form [[Root]] is used.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
     * @return NumberFormatter instace
     */ getNumberFormatter() {
        return this.get("numberFormatter", this._root.numberFormatter);
    }
    /**
     * Returns an instance of [[DateFormatter]] used in this element.
     *
     * If this element does not have it set, global one form [[Root]] is used.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
     * @return DateFormatter instace
     */ getDateFormatter() {
        return this.get("dateFormatter", this._root.dateFormatter);
    }
    /**
     * Returns an instance of [[DurationFormatter]] used in this element.
     *
     * If this element does not have it set, global one form [[Root]] is used.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
     * @return DurationFormatter instace
     */ getDurationFormatter() {
        return this.get("durationFormatter", this._root.durationFormatter);
    }
    /**
     * Converts X/Y coordinate within this element to a global coordinate.
     *
     * @param  point  Local coordinate
     * @return        Global coordinate
     */ toGlobal(point) {
        return this._display.toGlobal(point);
    }
    /**
     * Converts global X/Y coordinate to a coordinate within this element.
     *
     * @param  point  Global coordinate
     * @return        Local coordinate
     */ toLocal(point) {
        return this._display.toLocal(point);
    }
    _getDownPoint() {
        const id = this._getDownPointId();
        if (id) return this._downPoints[id];
    }
    _getDownPointId() {
        if (this._downPoints) return $e66f9343b5144e1a$export$dc3913a2a38a46a4(this._downPoints, (a, b)=>{
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
        })[0];
    }
    /**
     * Moves sprite to the end of the parent's children array.
     *
     * Depending on `layout` setting of the parten container, it may effect the
     * positioning or overlapping order of the elements.
     */ toFront() {
        const parent = this.parent;
        if (parent) parent.children.moveValue(this, parent.children.length - 1);
    }
    /**
     * Moves sprite to the beginning of the parent's children array.
     *
     * Depending on `layout` setting of the parten container, it may effect the
     * positioning or overlapping order of the elements.
     */ toBack() {
        const parent = this.parent;
        if (parent) parent.children.moveValue(this, 0);
    }
}
$d3b9c83dc790fa66$export$3075603db8e6204c.className = "Sprite";
$d3b9c83dc790fa66$export$3075603db8e6204c.classNames = (0, $baeade534ece7f4c$export$bc644a473284d944).classNames.concat([
    $d3b9c83dc790fa66$export$3075603db8e6204c.className
]);



class $49f0d49e061737b8$export$47606a6ae3eaed8e extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    constructor(){
        super(...arguments);
        this._display = this._root._renderer.makeGraphics();
        this._backgroundDisplay = this._root._renderer.makeGraphics();
        this._clear = false;
    }
    _afterNew() {
        // Applying themes because pattern will not have parent
        super._afterNewApplyThemes();
    }
    get pattern() {
        return this._pattern;
    }
    _draw() {}
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("repetition") || this.isDirty("width") || this.isDirty("height") || this.isDirty("rotation") || this.isDirty("strokeWidth") || this.isDirty("strokeDasharray") || this.isDirty("strokeDashoffset") || this.isDirty("colorOpacity") || this.isDirty("fillOpacity")) this._clear = true;
        this._checkDirtyFill();
    }
    _checkDirtyFill() {
        if (this.isDirty("color") || this.isDirty("fill")) this._clear = true;
    }
    _changed() {
        super._changed();
        if (this._clear) {
            const repetition = this.get("repetition", "");
            const width = this.get("width", 100);
            const height = this.get("height", 100);
            const fill = this.get("fill");
            const fillOpacity = this.get("fillOpacity", 1);
            const backgroundDisplay = this._backgroundDisplay;
            const display = this._display;
            display.clear();
            backgroundDisplay.clear();
            if (fill && fillOpacity > 0) {
                backgroundDisplay.beginFill(fill, fillOpacity);
                backgroundDisplay.drawRect(0, 0, width, height);
                backgroundDisplay.endFill();
            }
            display.angle = this.get("rotation", 0);
            //display.pivot = { x: width / 2, y: height / 2 };
            this._draw();
            this._pattern = this._root._renderer.createPattern(display, backgroundDisplay, repetition, width, height);
        }
        this._clear = false;
    }
}
$49f0d49e061737b8$export$47606a6ae3eaed8e.className = "Pattern";
$49f0d49e061737b8$export$47606a6ae3eaed8e.classNames = (0, $baeade534ece7f4c$export$bc644a473284d944).classNames.concat([
    $49f0d49e061737b8$export$47606a6ae3eaed8e.className
]);


class $f6091197791da1d7$export$1b09ebb7c225c9a8 extends (0, $49f0d49e061737b8$export$47606a6ae3eaed8e) {
    _beforeChanged() {
        super._beforeChanged();
        this._clear = true;
        if (this.isDirty("src")) this._load();
        const canvas = this.get("canvas");
        if (canvas) {
            this.set("width", canvas.width);
            this.set("height", canvas.height);
        }
    }
    _draw() {
        super._draw();
        const colorOpacity = this.get("colorOpacity");
        if (colorOpacity !== undefined) this._display.alpha = Math.max(0, colorOpacity);
        const image = this._image;
        if (image) {
            const patternWidth = this.get("width", 100);
            const patternHeight = this.get("height", 100);
            // Fit
            const fit = this.get("fit", "image");
            let width = 0;
            let height = 0;
            if (fit == "pattern") {
                width = patternWidth;
                height = patternHeight;
                this.markDirty();
            } else {
                width = image.width;
                height = image.height;
                if (fit == "image") {
                    this.set("width", width);
                    this.set("height", height);
                }
            }
            // Position
            const centered = this.get("centered", true);
            let x = 0;
            let y = 0;
            if (centered) {
                x = patternWidth / 2 - width / 2;
                y = patternHeight / 2 - height / 2;
            }
            this._display.image(image, width, height, x, y);
        }
        const canvas = this.get("canvas");
        if (canvas) this._display.image(canvas, canvas.width, canvas.height, 0, 0);
    }
    _load() {
        const src = this.get("src");
        if (src) {
            const image = new Image();
            //image.crossOrigin = "Anonymous";
            image.src = src;
            image.decode().then(()=>{
                this._image = image;
                this._draw();
                if (this.events.isEnabled("loaded")) this.events.dispatch("loaded", {
                    type: "loaded",
                    target: this
                });
            }).catch((_error)=>{
            // TODO: maybe raise error?
            });
        }
    }
}
$f6091197791da1d7$export$1b09ebb7c225c9a8.className = "PicturePattern";
$f6091197791da1d7$export$1b09ebb7c225c9a8.classNames = (0, $49f0d49e061737b8$export$47606a6ae3eaed8e).classNames.concat([
    $f6091197791da1d7$export$1b09ebb7c225c9a8.className
]);



/**
 * From https://github.com/pixijs/pixi.js/blob/3dd0ff9a935f0bc13a09aefff9eb2872f02c51b9/packages/canvas/canvas-renderer/src/utils/mapCanvasBlendModesToPixi.ts#L13
 */ var $26f287a8eb69ba00$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["ADD"] = "lighter";
    BlendMode["COLOR"] = "color";
    BlendMode["COLOR_BURN"] = "color-burn";
    BlendMode["COLOR_DODGE"] = "color-dodge";
    BlendMode["DARKEN"] = "darken";
    BlendMode["DIFFERENCE"] = "difference";
    BlendMode["DST_OVER"] = "destination-over";
    BlendMode["EXCLUSION"] = "exclusion";
    BlendMode["HARD_LIGHT"] = "hard-light";
    BlendMode["HUE"] = "hue";
    BlendMode["LIGHTEN"] = "lighten";
    BlendMode["LUMINOSITY"] = "luminosity";
    BlendMode["MULTIPLY"] = "multiply";
    BlendMode["NORMAL"] = "source-over";
    BlendMode["OVERLAY"] = "overlay";
    BlendMode["SATURATION"] = "saturation";
    BlendMode["SCREEN"] = "screen";
    BlendMode["SOFT_LIGHT"] = "soft-light";
    BlendMode["SRC_ATOP"] = "source-atop";
    BlendMode["XOR"] = "xor";
})($26f287a8eb69ba00$export$c9b8fe72ac71821 || ($26f287a8eb69ba00$export$c9b8fe72ac71821 = {}));




const $2ffdafbe1fe6a946$export$c2fbc8c3b8eba2bd = [
    "fill",
    "fillOpacity",
    "stroke",
    "strokeWidth",
    "strokeOpacity",
    "fillPattern",
    "strokePattern",
    "fillGradient",
    "strokeGradient",
    "strokeDasharray",
    "strokeDashoffset",
    "shadowBlur",
    "shadowColor",
    "shadowOpacity",
    "shadowOffsetX",
    "shadowOffsetY",
    "blur",
    "sepia",
    "invert",
    "brightness",
    "hue",
    "contrast",
    "saturate"
];
class $2ffdafbe1fe6a946$export$29d3e417456abdad extends (0, $d3b9c83dc790fa66$export$3075603db8e6204c) {
    constructor(){
        super(...arguments);
        this._display = this._root._renderer.makeGraphics();
        this._clear = false;
    }
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("draw") || this.isDirty("svgPath")) this.markDirtyBounds();
        if (this.isDirty("fill") || this.isDirty("stroke") || this.isDirty("visible") || this.isDirty("forceHidden") || this.isDirty("scale") || this.isDirty("fillGradient") || this.isDirty("strokeGradient") || this.isDirty("fillPattern") || this.isDirty("strokePattern") || this.isDirty("fillOpacity") || this.isDirty("strokeOpacity") || this.isDirty("strokeWidth") || this.isDirty("draw") || this.isDirty("blendMode") || this.isDirty("strokeDasharray") || this.isDirty("strokeDashoffset") || this.isDirty("svgPath") || this.isDirty("lineJoin") || this.isDirty("lineCap") || this.isDirty("shadowColor") || this.isDirty("shadowBlur") || this.isDirty("shadowOffsetX") || this.isDirty("shadowOffsetY") || this.isDirty("shadowOpacity")) this._clear = true;
        this._display.crisp = this.get("crisp", false);
        if (this.isDirty("fillGradient")) {
            const gradient = this.get("fillGradient");
            if (gradient) {
                this._display.isMeasured = true;
                const gradientTarget = gradient.get("target");
                if (gradientTarget) {
                    this._disposers.push(gradientTarget.events.on("boundschanged", ()=>{
                        this._markDirtyKey("fill");
                    }));
                    this._disposers.push(gradientTarget.events.on("positionchanged", ()=>{
                        this._markDirtyKey("fill");
                    }));
                }
            }
        }
        if (this.isDirty("strokeGradient")) {
            const gradient = this.get("strokeGradient");
            if (gradient) {
                this._display.isMeasured = true;
                const gradientTarget = gradient.get("target");
                if (gradientTarget) {
                    this._disposers.push(gradientTarget.events.on("boundschanged", ()=>{
                        this._markDirtyKey("stroke");
                    }));
                    this._disposers.push(gradientTarget.events.on("positionchanged", ()=>{
                        this._markDirtyKey("stroke");
                    }));
                }
            }
        }
    }
    _changed() {
        super._changed();
        if (this._clear) {
            this.markDirtyBounds();
            this.markDirtyLayer();
            this._display.clear();
            let strokeDasharray = this.get("strokeDasharray");
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(strokeDasharray)) {
                if (strokeDasharray < 0.5) strokeDasharray = [
                    0
                ];
                else strokeDasharray = [
                    strokeDasharray
                ];
            }
            this._display.setLineDash(strokeDasharray);
            const strokeDashoffset = this.get("strokeDashoffset");
            if (strokeDashoffset) this._display.setLineDashOffset(strokeDashoffset);
            const blendMode = this.get("blendMode", (0, $26f287a8eb69ba00$export$c9b8fe72ac71821).NORMAL);
            this._display.blendMode = blendMode;
            const draw = this.get("draw");
            if (draw && typeof draw === "function") draw(this._display, this);
            const svgPath = this.get("svgPath");
            if (svgPath != null) this._display.svgPath(svgPath);
        }
    }
    _afterChanged() {
        super._afterChanged();
        if (this._clear) {
            const fill = this.get("fill");
            const fillGradient = this.get("fillGradient");
            const fillPattern = this.get("fillPattern");
            const fillOpacity = this.get("fillOpacity");
            const stroke = this.get("stroke");
            const strokeGradient = this.get("strokeGradient");
            const strokePattern = this.get("strokePattern");
            const shadowColor = this.get("shadowColor");
            const shadowBlur = this.get("shadowBlur");
            const shadowOffsetX = this.get("shadowOffsetX");
            const shadowOffsetY = this.get("shadowOffsetY");
            const shadowOpacity = this.get("shadowOpacity");
            if (shadowColor && (shadowBlur || shadowOffsetX || shadowOffsetY)) this._display.shadow(shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY, shadowOpacity);
            if (fill && !fillGradient) {
                this._display.beginFill(fill, fillOpacity);
                this._display.endFill();
            }
            if (fillGradient) {
                if (fill) {
                    const stops = fillGradient.get("stops", []);
                    if (stops.length) $2f30431acd054e2f$export$79b2f7037acddd43(stops, (stop)=>{
                        if ((!stop.color || stop.colorInherited) && fill) {
                            stop.color = fill;
                            stop.colorInherited = true;
                        }
                        if (stop.opacity == null || stop.opacityInherited) {
                            stop.opacity = fillOpacity;
                            stop.opacityInherited = true;
                        }
                    });
                }
                const gradient = fillGradient.getFill(this);
                if (gradient) {
                    this._display.beginFill(gradient, fillOpacity);
                    this._display.endFill();
                }
            }
            if (fillPattern) {
                const pattern = fillPattern.pattern;
                if (pattern) {
                    this._display.beginFill(pattern, fillOpacity);
                    this._display.endFill();
                    if (fillPattern instanceof (0, $f6091197791da1d7$export$1b09ebb7c225c9a8)) fillPattern.events.once("loaded", ()=>{
                        this._clear = true;
                        this.markDirty();
                    });
                }
            }
            if (stroke || strokeGradient || strokePattern) {
                const strokeOpacity = this.get("strokeOpacity");
                let strokeWidth = this.get("strokeWidth", 1);
                if (this.get("nonScalingStroke")) strokeWidth = strokeWidth / this.get("scale", 1);
                if (this.get("crisp")) strokeWidth /= this._root._renderer.resolution;
                const lineJoin = this.get("lineJoin");
                const lineCap = this.get("lineCap");
                if (stroke && !strokeGradient) {
                    this._display.lineStyle(strokeWidth, stroke, strokeOpacity, lineJoin, lineCap);
                    this._display.endStroke();
                }
                if (strokeGradient) {
                    const stops = strokeGradient.get("stops", []);
                    if (stops.length) $2f30431acd054e2f$export$79b2f7037acddd43(stops, (stop)=>{
                        if ((!stop.color || stop.colorInherited) && stroke) {
                            stop.color = stroke;
                            stop.colorInherited = true;
                        }
                        if (stop.opacity == null || stop.opacityInherited) {
                            stop.opacity = strokeOpacity;
                            stop.opacityInherited = true;
                        }
                    });
                    const gradient = strokeGradient.getFill(this);
                    if (gradient) {
                        this._display.lineStyle(strokeWidth, gradient, strokeOpacity, lineJoin, lineCap);
                        this._display.endStroke();
                    }
                }
                if (strokePattern) {
                    /*
                    let changed = false;
                    
                    if (stroke && (!strokePattern.get("color") || strokePattern.get("colorInherited"))) {
                        strokePattern.set("color", stroke);
                        strokePattern.set("colorInherited", true);
                        changed = true;
                    }
                    if (changed) {
                        // @todo: is this OK?
                        strokePattern._changed();
                    }
                    */ let pattern = strokePattern.pattern;
                    if (pattern) {
                        this._display.lineStyle(strokeWidth, pattern, strokeOpacity, lineJoin, lineCap);
                        this._display.endStroke();
                        if (strokePattern instanceof (0, $f6091197791da1d7$export$1b09ebb7c225c9a8)) strokePattern.events.once("loaded", ()=>{
                            this._clear = true;
                            this.markDirty();
                        });
                    }
                }
            }
            if (this.getPrivate("showingTooltip")) this.showTooltip();
        }
        this._clear = false;
    }
}
$2ffdafbe1fe6a946$export$29d3e417456abdad.className = "Graphics";
$2ffdafbe1fe6a946$export$29d3e417456abdad.classNames = (0, $d3b9c83dc790fa66$export$3075603db8e6204c).classNames.concat([
    $2ffdafbe1fe6a946$export$29d3e417456abdad.className
]);


class $9e0cea1ea085e274$export$4617fb02663045ef extends (0, $2ffdafbe1fe6a946$export$29d3e417456abdad) {
    _afterNew() {
        super._afterNew();
        this._display.isMeasured = true;
        this.setPrivateRaw("trustBounds", true);
    }
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("width") || this.isDirty("height") || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("containStroke")) this._clear = true;
    }
    _changed() {
        super._changed();
        if (this._clear && !this.get("draw")) this._draw();
    }
    _draw() {
        let w = this.width();
        let h = this.height();
        let x = 0;
        let y = 0;
        let wSign = w / Math.abs(w);
        let hSign = h / Math.abs(h);
        if (this.get("containStroke", false)) {
            const strokeWidth = this.get("strokeWidth", 0);
            w -= strokeWidth * wSign;
            h -= strokeWidth * hSign;
            x += strokeWidth / 2 * wSign;
            y += strokeWidth / 2 * hSign;
        }
        this._display.drawRect(x, y, w, h);
    }
    _updateSize() {
        this.markDirty();
        this._clear = true;
    }
}
$9e0cea1ea085e274$export$4617fb02663045ef.className = "Rectangle";
$9e0cea1ea085e274$export$4617fb02663045ef.classNames = (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).classNames.concat([
    $9e0cea1ea085e274$export$4617fb02663045ef.className
]);



function $df0987941167623a$export$a435655d785c1180(container, f) {
    if (container.get("reverseChildren", false)) container.children.eachReverse(f);
    else container.children.each(f);
}
class $df0987941167623a$export$c84671f46d6a1ca extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
}
$df0987941167623a$export$c84671f46d6a1ca.className = "Layout";
$df0987941167623a$export$c84671f46d6a1ca.classNames = (0, $baeade534ece7f4c$export$bc644a473284d944).classNames.concat([
    $df0987941167623a$export$c84671f46d6a1ca.className
]);




class $ce42d27226ec20a0$export$8be7400f61e793f0 extends (0, $df0987941167623a$export$c84671f46d6a1ca) {
    /**
     * @ignore
     */ updateContainer(container) {
        let paddingLeft = container.get("paddingLeft", 0);
        let availableWidth = container.innerWidth();
        let totalPercent = 0;
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.isVisible()) {
                if (child.get("position") == "relative") {
                    let childWidth = child.get("width");
                    if (childWidth instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                        totalPercent += childWidth.value;
                        let w = availableWidth * childWidth.value;
                        let minWidth = child.get("minWidth", child.getPrivate("minWidth", -Infinity));
                        if (minWidth > w) {
                            availableWidth -= minWidth;
                            totalPercent -= childWidth.value;
                        }
                        let maxWidth = child.get("maxWidth", child.getPrivate("maxWidth", Infinity));
                        if (w > maxWidth) {
                            availableWidth -= maxWidth;
                            totalPercent -= childWidth.value;
                        }
                    } else {
                        if (!$f63bdea45a89cf24$export$7e4aa119212bc614(childWidth)) childWidth = child.width();
                        availableWidth -= childWidth + child.get("marginLeft", 0) + child.get("marginRight", 0);
                    }
                }
            }
        });
        if (availableWidth <= 0 || availableWidth == Infinity) availableWidth = .1;
        //if (availableWidth > 0) {
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.isVisible()) {
                if (child.get("position") == "relative") {
                    let childWidth = child.get("width");
                    if (childWidth instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                        let privateWidth = availableWidth * childWidth.value / totalPercent - child.get("marginLeft", 0) - child.get("marginRight", 0);
                        let minWidth = child.get("minWidth", child.getPrivate("minWidth", -Infinity));
                        let maxWidth = child.get("maxWidth", child.getPrivate("maxWidth", Infinity));
                        privateWidth = Math.min(Math.max(minWidth, privateWidth), maxWidth);
                        child.setPrivate("width", privateWidth);
                    } else if (child._prevSettings.width instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) child.setPrivate("width", undefined);
                }
            }
        });
        //}
        let prevX = paddingLeft;
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.get("position") == "relative") {
                if (child.isVisible()) {
                    let bounds = child.adjustedLocalBounds();
                    let marginLeft = child.get("marginLeft", 0);
                    let marginRight = child.get("marginRight", 0);
                    let maxWidth = child.get("maxWidth");
                    let left = bounds.left;
                    let right = bounds.right;
                    if (maxWidth) {
                        if (right - left > maxWidth) right = left + maxWidth;
                    }
                    let x = prevX + marginLeft - left;
                    child.setPrivate("x", x);
                    prevX = x + right + marginRight;
                } else child.setPrivate("x", undefined);
            }
        });
    }
}
$ce42d27226ec20a0$export$8be7400f61e793f0.className = "HorizontalLayout";
$ce42d27226ec20a0$export$8be7400f61e793f0.classNames = (0, $df0987941167623a$export$c84671f46d6a1ca).classNames.concat([
    $ce42d27226ec20a0$export$8be7400f61e793f0.className
]);





class $b05f413a7bdbea0f$export$e4d3124dc23dc9c9 extends (0, $df0987941167623a$export$c84671f46d6a1ca) {
    /**
     * @ignore
     */ updateContainer(container) {
        let paddingTop = container.get("paddingTop", 0);
        let availableHeight = container.innerHeight();
        let totalPercent = 0;
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.isVisible()) {
                if (child.get("position") == "relative") {
                    let childHeight = child.get("height");
                    if (childHeight instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                        totalPercent += childHeight.value;
                        let h = availableHeight * childHeight.value;
                        let minHeight = child.get("minHeight", child.getPrivate("minHeight", -Infinity));
                        if (minHeight > h) {
                            availableHeight -= minHeight;
                            totalPercent -= childHeight.value;
                        }
                        let maxHeight = child.get("maxHeight", child.getPrivate("maxHeight", Infinity));
                        if (h > maxHeight) {
                            availableHeight -= maxHeight;
                            totalPercent -= childHeight.value;
                        }
                    } else {
                        if (!$f63bdea45a89cf24$export$7e4aa119212bc614(childHeight)) childHeight = child.height();
                        availableHeight -= childHeight + child.get("marginTop", 0) + child.get("marginBottom", 0);
                    }
                }
            }
        });
        if (availableHeight <= 0 || availableHeight == Infinity) availableHeight = .1;
        //if (availableHeight > 0) {
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.isVisible()) {
                if (child.get("position") == "relative") {
                    let childHeight = child.get("height");
                    if (childHeight instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                        let privateHeight = availableHeight * childHeight.value / totalPercent - child.get("marginTop", 0) - child.get("marginBottom", 0);
                        let minHeight = child.get("minHeight", child.getPrivate("minHeight", -Infinity));
                        let maxHeight = child.get("maxHeight", child.getPrivate("maxHeight", Infinity));
                        privateHeight = Math.min(Math.max(minHeight, privateHeight), maxHeight);
                        child.setPrivate("height", privateHeight);
                    } else if (child._prevSettings.height instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) child.setPrivate("height", undefined);
                }
            }
        });
        //}
        let prevY = paddingTop;
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.get("position") == "relative") {
                if (child.isVisible()) {
                    let bounds = child.adjustedLocalBounds();
                    let marginTop = child.get("marginTop", 0);
                    let top = bounds.top;
                    let bottom = bounds.bottom;
                    let maxHeight = child.get("maxHeight");
                    if (maxHeight) {
                        if (bottom - top > maxHeight) bottom = top + maxHeight;
                    }
                    let marginBottom = child.get("marginBottom", 0);
                    let y = prevY + marginTop - top;
                    child.setPrivate("y", y);
                    prevY = y + bottom + marginBottom;
                } else child.setPrivate("y", undefined);
            }
        });
    }
}
$b05f413a7bdbea0f$export$e4d3124dc23dc9c9.className = "VerticalLayout";
$b05f413a7bdbea0f$export$e4d3124dc23dc9c9.classNames = (0, $df0987941167623a$export$c84671f46d6a1ca).classNames.concat([
    $b05f413a7bdbea0f$export$e4d3124dc23dc9c9.className
]);





class $9961b4caf46ffbfc$export$7d2b12578154a735 extends (0, $df0987941167623a$export$c84671f46d6a1ca) {
    _afterNew() {
        this._setRawDefault("maxColumns", Number.MAX_VALUE);
        super._afterNew();
    }
    /**
     * @ignore
     */ updateContainer(container) {
        let paddingLeft = container.get("paddingLeft", 0);
        let paddingRight = container.get("paddingRight", 0);
        let paddingTop = container.get("paddingTop", 0);
        let availableWidth = container.maxWidth() - paddingLeft - paddingRight;
        let minCellWidth = availableWidth;
        let maxCellWidth = 1;
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.get("visible") && child.getPrivate("visible") && !child.get("forceHidden")) {
                if (child.get("position") != "absolute") {
                    let childWidth = child.width();
                    if (childWidth < minCellWidth) minCellWidth = childWidth;
                    if (childWidth > maxCellWidth) maxCellWidth = childWidth;
                }
            }
        });
        minCellWidth = $f43e9e04b3f0548b$export$386b748ab02f16a0(minCellWidth, 1, availableWidth);
        maxCellWidth = $f43e9e04b3f0548b$export$386b748ab02f16a0(maxCellWidth, 1, availableWidth);
        let columnCount = 1;
        if (this.get("fixedWidthGrid")) columnCount = availableWidth / maxCellWidth;
        else columnCount = availableWidth / minCellWidth;
        columnCount = Math.max(1, Math.floor(columnCount));
        columnCount = Math.min(this.get("maxColumns", Number.MAX_VALUE), columnCount);
        let columnWidths = this.getColumnWidths(container, columnCount, maxCellWidth, availableWidth);
        let prevY = paddingTop;
        let column = 0;
        let maxRowHeight = 0;
        columnCount = columnWidths.length;
        let prevX = paddingLeft;
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            if (child.get("position") == "relative" && child.isVisible()) {
                const marginTop = child.get("marginTop", 0);
                const marginBottom = child.get("marginBottom", 0);
                let bounds = child.adjustedLocalBounds();
                let marginLeft = child.get("marginLeft", 0);
                let marginRight = child.get("marginRight", 0);
                let x = prevX + marginLeft - bounds.left;
                let y = prevY + marginTop - bounds.top;
                child.setPrivate("x", x);
                child.setPrivate("y", y);
                prevX += columnWidths[column] + marginRight;
                maxRowHeight = Math.max(maxRowHeight, child.height() + marginTop + marginBottom);
                column++;
                if (column >= columnCount) {
                    column = 0;
                    prevX = paddingLeft;
                    prevY += maxRowHeight;
                    maxRowHeight = 0;
                }
            }
        });
    }
    /**
     * @ignore
     */ getColumnWidths(container, columnCount, maxCellWidth, availableWidth) {
        let totalWidth = 0;
        let columnWidths = [];
        let column = 0;
        (0, $df0987941167623a$export$a435655d785c1180)(container, (child)=>{
            let bounds = child.adjustedLocalBounds();
            if (child.get("position") != "absolute" && child.isVisible()) {
                if (this.get("fixedWidthGrid")) columnWidths[column] = maxCellWidth;
                else columnWidths[column] = Math.max(columnWidths[column] | 0, bounds.right - bounds.left + child.get("marginLeft", 0) + child.get("marginRight", 0));
                if (column < container.children.length - 1) {
                    column++;
                    if (column == columnCount) column = 0;
                }
            }
        });
        $2f30431acd054e2f$export$79b2f7037acddd43(columnWidths, (w)=>{
            totalWidth += w;
        });
        if (totalWidth > availableWidth) {
            if (columnCount > 2) {
                columnCount -= 1;
                return this.getColumnWidths(container, columnCount, maxCellWidth, availableWidth);
            } else return [
                availableWidth
            ];
        }
        return columnWidths;
    }
}
$9961b4caf46ffbfc$export$7d2b12578154a735.className = "GridLayout";
$9961b4caf46ffbfc$export$7d2b12578154a735.classNames = (0, $df0987941167623a$export$c84671f46d6a1ca).classNames.concat([
    $9961b4caf46ffbfc$export$7d2b12578154a735.className
]);


/** @ignore */ /** */ 




class $4b06370a9416d0ab$export$cfc95f342033cc43 {
    /**
     * Replaces brackets with temporary placeholders.
     *
     * @ignore Exclude from docs
     * @param text  Input text
     * @return Escaped text
     */ static escape(text) {
        return text.replace(/\[\[/g, this.prefix + "1").replace(/([^\/\]]{1})\]\]/g, "$1" + this.prefix + "2").replace(/\]\]/g, this.prefix + "2").replace(/\{\{/g, this.prefix + "3").replace(/\}\}/g, this.prefix + "4").replace(/\'\'/g, this.prefix + "5");
    }
    /**
     * Replaces placeholders back to brackets.
     *
     * @ignore Exclude from docs
     * @param text  Escaped text
     * @return Unescaped text
     */ static unescape(text) {
        return text.replace(new RegExp(this.prefix + "1", "g"), "[[").replace(new RegExp(this.prefix + "2", "g"), "]]").replace(new RegExp(this.prefix + "3", "g"), "{{").replace(new RegExp(this.prefix + "4", "g"), "}}").replace(new RegExp(this.prefix + "5", "g"), "''");
    }
    /**
     * Cleans up the text text for leftover double square brackets.
     *
     * @ignore Exclude from docs
     * @param text  Input text
     * @return Cleaned up text
     */ static cleanUp(text) {
        return text.replace(/\[\[/g, "[").replace(/\]\]/g, "]").replace(/\{\{/g, "{").replace(/\}\}/g, "}").replace(/\'\'/g, "'");
    }
    /**
     * Splits string into chunks. (style blocks, quoted blocks, regular blocks)
     *
     * If the second parameter `quotedBlocks` is set to `true` this method will
     * also single out text blocks enclosed within single quotes that no
     * formatting should be applied to, and they should be displayed as is.
     *
     * Default for the above is `false`, so that you can use single quote in text
     * without escaping it.
     *
     * If enabled, single quotes can be escaped by doubling it - adding two
     * single quotes, which will be replaced by a one single quote in the final
     * output.
     *
     * @ignore Exclude from docs
     * @param text          Text to chunk
     * @param quotedBlocks  Use quoted blocks
     * @param noFormatting  Formatting blocks will be treated as regular text
     * @return Array of string chunks
     */ static chunk(text, quotedBlocks = false, noFormatting = false) {
        // Init result
        let res = [];
        // Replace double (escaped) square spaces and quotes with temporary codes
        text = this.escape(text);
        // Deal with style blocks
        let chunks = quotedBlocks ? text.split("'") : [
            text
        ];
        for(let i = 0; i < chunks.length; i++){
            let chunk = chunks[i];
            // Empty?
            if (chunk === "") continue;
            if (i % 2 === 0) {
                // Text outside quotes
                // Parse for style blocks which are "text" chunks, the rest chunks are
                // "value"
                chunk = chunk.replace(/\]\[/g, "]" + $f63bdea45a89cf24$export$55fc5ffc49a23c34 + "[");
                chunk = chunk.replace(/\[\]/g, "[ ]");
                let chunks2 = chunk.split(/[\[\]]+/);
                for(let i2 = 0; i2 < chunks2.length; i2++){
                    let chunk2 = this.cleanUp(this.unescape(chunks2[i2]));
                    // Placeholder?
                    if (chunk2 === $f63bdea45a89cf24$export$55fc5ffc49a23c34) continue;
                    // Empty?
                    if (chunk2 === "") continue;
                    // Block or value
                    if (i2 % 2 === 0) res.push({
                        "type": "value",
                        "text": chunk2
                    });
                    else res.push({
                        "type": noFormatting ? "value" : "format",
                        "text": "[" + chunk2 + "]"
                    });
                }
            } else {
                // A text within doublequotes
                // All chunks are "text"
                let chunks2 = chunk.split(/[\[\]]+/);
                for(let i2 = 0; i2 < chunks2.length; i2++){
                    let chunk2 = this.cleanUp(this.unescape(chunks2[i2]));
                    // Empty?
                    if (chunk2 === "") continue;
                    // Block or text
                    if (i2 % 2 === 0) res.push({
                        "type": "text",
                        "text": chunk2
                    });
                    else if (this.isImage(chunk2)) res.push({
                        "type": "image",
                        "text": "[" + chunk2 + "]"
                    });
                    else res.push({
                        "type": "format",
                        "text": "[" + chunk2 + "]"
                    });
                }
            }
        }
        return res;
    }
    /**
     * Checks if supplied format contains image information and should be
     * formatted as such.
     * I.e.: `[img: myImage.png]`
     *
     * @ignore
     * @param  text  Format
     * @return true if it is an image
     */ static isImage(text) {
        return text.match(/img[ ]?:/) ? true : false;
    }
    static getTextStyle(style) {
        // let textStyle: string[] = [];
        // let textFill: string | undefined;
        let format = {};
        if (style == "" || style == "[ ]") return {};
        // Pre-process quoted text
        const q = style.match(/('[^']*')|("[^"]*")/gi);
        if (q) for(let i = 0; i < q.length; i++)style = style.replace(q[i], q[i].replace(/['"]*/g, "").replace(/[ ]+/g, "+"));
        // Get style parts
        let b = style.match(/([\w\-]*:[\s]?[^;\s\]]*)|(\#[\w]{1,6})|([\w\-]+)|(\/)/gi);
        // Empty?
        if (!b) return {};
        // Check each part
        for(let i = 0; i < b.length; i++){
            if (b[i].match(/^(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)$/i)) format.fontWeight = b[i];
            else if (b[i].match(/^(underline|line-through)$/i)) format.textDecoration = b[i];
            else if (b[i] == "/") ;
            else if (!b[i].match(/:/)) // Color
            format.fill = (0, $389de129b6cd18b1$export$892596cec99bc70e).fromString(b[i]);
            else {
                const p = b[i].replace("+", " ").split(/:[ ]*/);
                format[p[0]] = p[1];
            //textStyle.push(b[i].replace(/^[a-zA-Z]:[ ]*/, ""));
            //b[i] = b[i].replace(/\+/g, " ");
            }
        }
        return format;
    }
}
$4b06370a9416d0ab$export$cfc95f342033cc43.prefix = "__amcharts__";


function $8d45a8a77dcd0f75$export$6a40ef019a0fa5f6(target, string) {
    if (string != null) {
        string = "" + string;
        string = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).escape(string);
        let tags = string.match(/\{([^}]+)\}/g);
        let i;
        if (tags) for(i = 0; i < tags.length; i++){
            let tag = tags[i].replace(/\{([^}]+)\}/, "$1");
            let value = $8d45a8a77dcd0f75$export$137bf301edaceb2e(target, tag, "");
            if (value == null) value = "";
            string = string.split(tags[i]).join(value);
        }
        string = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).unescape(string);
    } else string = "";
    // TODO: apply adapter?
    return string;
}
function $8d45a8a77dcd0f75$export$137bf301edaceb2e(target, tagName, format) {
    let value;
    const dataItem = target.dataItem;
    // Parse parts
    let parts = [];
    let reg = /(format[a-zA-Z]*)\((.*)\)|([^.]+)/g;
    let matches;
    while(true){
        matches = reg.exec(tagName);
        if (matches === null) break;
        if (matches[3]) {
            // Simple property
            parts.push({
                prop: matches[3]
            });
            // Check if maybe we should force a formatter on this value
            const dateFields = target.getDateFormatter().get("dateFields", []);
            const numericFields = target.getNumberFormatter().get("numericFields", []);
            const durationFields = target.getDurationFormatter().get("durationFields", []);
            if (dateFields.indexOf(matches[3]) !== -1) parts.push({
                method: "formatDate",
                params: []
            });
            else if (numericFields.indexOf(matches[3]) !== -1) parts.push({
                method: "formatNumber",
                params: []
            });
            else if (durationFields.indexOf(matches[3]) !== -1) parts.push({
                method: "formatDuration",
                params: []
            });
        } else {
            // Method
            // Parse parameters
            let params = [];
            if ($05b1b40b69b15016$export$87c2784dc9fc4ab(matches[2]) != "") {
                let reg2 = /'([^']*)'|"([^"]*)"|([0-9\-]+)/g;
                let matches2;
                while(true){
                    matches2 = reg2.exec(matches[2]);
                    if (matches2 === null) break;
                    params.push(matches2[1] || matches2[2] || matches2[3]);
                }
            }
            parts.push({
                method: matches[1],
                params: params
            });
        }
    }
    // Check if we can retrieve the value from data item
    if (dataItem) {
        // Check values
        value = $8d45a8a77dcd0f75$export$1aee974227db7753(target, parts, dataItem._settings);
        // Check properties
        if (value == null || $f63bdea45a89cf24$export$a6cdc56e425d0d0a(value)) value = $8d45a8a77dcd0f75$export$1aee974227db7753(target, parts, dataItem);
        // Check data context
        let dataContext = dataItem.dataContext;
        if (value == null && dataContext) {
            value = $8d45a8a77dcd0f75$export$1aee974227db7753(target, parts, dataContext);
            // Maybe it's a literal dot-separated name of the key in dataContext?
            if (value == null) value = $8d45a8a77dcd0f75$export$1aee974227db7753(target, [
                {
                    prop: tagName
                }
            ], dataContext);
            // scond data context level sometimes exist (tree map)
            if (value == null && dataContext.dataContext) value = $8d45a8a77dcd0f75$export$1aee974227db7753(target, parts, dataContext.dataContext);
        }
        // Check component's data item
        if (value == null && dataItem.component && dataItem.component.dataItem !== dataItem) value = $8d45a8a77dcd0f75$export$137bf301edaceb2e(dataItem.component, tagName, format);
    }
    // Check sprite's properties
    if (value == null) value = $8d45a8a77dcd0f75$export$1aee974227db7753(target, parts, target);
    // Finally, check the parent
    if (value == null && target.parent) value = $8d45a8a77dcd0f75$export$137bf301edaceb2e(target.parent, tagName, format);
    return value;
}
function $8d45a8a77dcd0f75$export$a8196fa36b2cb4b4(target, prop) {
    const customData = target.getPrivate("customData");
    if ($f63bdea45a89cf24$export$a6cdc56e425d0d0a(customData)) return customData[prop];
}
function $8d45a8a77dcd0f75$export$1aee974227db7753(target, parts, object, format) {
    let current = object;
    let formatApplied = false;
    for(let i = 0, len = parts.length; i < len; i++){
        let part = parts[i];
        if (part.prop) {
            // Regular property
            if (current instanceof (0, $d3b9c83dc790fa66$export$3075603db8e6204c)) {
                let tmp = current.get(part.prop);
                if (tmp == null) tmp = current.getPrivate(part.prop);
                if (tmp == null) tmp = $8d45a8a77dcd0f75$export$a8196fa36b2cb4b4(current, part.prop);
                if (tmp == null) tmp = current[part.prop];
                current = tmp;
            } else if (current.get) {
                let tmp = current.get(part.prop);
                if (tmp == null) tmp = current[part.prop];
                current = tmp;
            } else current = current[part.prop];
            if (current == null) // Not set, return undefined
            return;
        } else // Method
        switch(part.method){
            case "formatNumber":
                let numberValue = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(current);
                if (numberValue != null) {
                    current = target.getNumberFormatter().format(numberValue, format || part.params[0] || undefined);
                    formatApplied = true;
                }
                break;
            case "formatDate":
                let dateValue = $f63bdea45a89cf24$export$e67a095c620b86fe(current);
                if (!$f63bdea45a89cf24$export$871608497c498473(dateValue) || $f63bdea45a89cf24$export$c9f5652083b8129d(dateValue.getTime())) // Was not able to get date out of value, quitting and letting
                // calling method try another value
                return;
                if (dateValue != null) {
                    current = target.getDateFormatter().format(dateValue, format || part.params[0] || undefined);
                    formatApplied = true;
                }
                break;
            case "formatDuration":
                let durationValue = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(current);
                if (durationValue != null) {
                    current = target.getDurationFormatter().format(durationValue, format || part.params[0] || undefined, part.params[1] || undefined);
                    formatApplied = true;
                }
                break;
            case "urlEncode":
            case "encodeURIComponent":
                current = encodeURIComponent(current);
                break;
            default:
                if (current[part.method]) current[part.method].apply(object, part.params);
                break;
        }
    }
    // Apply default format if it wasn't applied explicitly
    if (!formatApplied) {
        let formatParts = [
            {
                method: "",
                params: format
            }
        ];
        if (format == null) {
            // Format is not set
            // Determine from the type of the value
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(current)) {
                formatParts[0].method = "formatNumber";
                formatParts[0].params = "";
            } else if ($f63bdea45a89cf24$export$871608497c498473(current)) {
                formatParts[0].method = "formatDate";
                formatParts[0].params = "";
            }
        } else {
            // Format set
            // Try to determine formatter based on the format
            let formatterType = $05b1b40b69b15016$export$f61ac8b6f1f46202(format);
            // format
            if (formatterType === "number") formatParts[0].method = "formatNumber";
            else if (formatterType === "date") formatParts[0].method = "formatDate";
            else if (formatterType === "duration") formatParts[0].method = "formatDuration";
        }
        // Apply format
        if (formatParts[0].method) current = $8d45a8a77dcd0f75$export$1aee974227db7753(target, formatParts, current);
    }
    return current;
}





class $5de502da8a72d65e$export$42a852a2b6b56249 extends (0, $d3b9c83dc790fa66$export$3075603db8e6204c) {
    constructor(){
        super(...arguments);
        this._display = this._root._renderer.makeContainer();
        this._childrenDisplay = this._root._renderer.makeContainer();
        /**
         * List of Container's child elements.
         */ this.children = new (0, $5e30d142a93206ce$export$dca3b0875bd9a954)(this);
        this._percentageSizeChildren = [];
        this._percentagePositionChildren = [];
        this._prevWidth = 0;
        this._prevHeight = 0;
        this._contentWidth = 0;
        this._contentHeight = 0;
        this._childrenPrep = false;
        this._childrenUpdt = false;
    }
    _afterNew() {
        super._afterNew();
        this._display.addChild(this._childrenDisplay);
    }
    _afterChanged() {
        super._afterChanged();
        this._childrenPrep = false;
        this._childrenUpdt = false;
    }
    _dispose() {
        $2f30431acd054e2f$export$a40ba8785b7efce8(this.allChildren(), (child)=>{
            child.dispose();
        });
        if (this.getPrivate("htmlElement")) this._root._removeHTMLContent(this);
        super._dispose();
    }
    _beforeChanged() {
        if (!this._childrenPrep) this._prepareChildren();
        if (!this._childrenUpdt) this._updateChildren();
        super._beforeChanged();
    }
    _changed() {
        super._changed();
        if (this.isDirty("interactiveChildren")) this._display.interactiveChildren = this.get("interactiveChildren", false);
        if (this.isDirty("layout")) {
            this._prevWidth = 0;
            this._prevHeight = 0;
            this.markDirtyBounds();
            if (this._prevSettings.layout) this.children.each((child)=>{
                child.removePrivate("x");
                child.removePrivate("y");
            });
        }
        if (this.isDirty("paddingTop") || this.isDirty("paddingBottom") || this.isDirty("paddingLeft") || this.isDirty("paddingRight")) {
            this.children.each((child)=>{
                child.markDirtyPosition();
            });
            this.markDirtyBounds();
        }
        if (this.isDirty("maskContent")) {
            const childrenDisplay = this._childrenDisplay;
            let contentMask = this._contentMask;
            if (this.get("maskContent")) {
                if (!contentMask) {
                    contentMask = (0, $9e0cea1ea085e274$export$4617fb02663045ef).new(this._root, {
                        x: -0.5,
                        y: -0.5,
                        width: this.width() + 1,
                        height: this.height() + 1
                    });
                    this._contentMask = contentMask;
                    childrenDisplay.addChildAt(contentMask._display, 0);
                    childrenDisplay.mask = contentMask._display;
                }
            } else if (contentMask) {
                childrenDisplay.removeChild(contentMask._display);
                childrenDisplay.mask = null;
                contentMask.dispose();
                this._contentMask = undefined;
            }
        }
    }
    _updateSize() {
        super._updateSize();
        $2f30431acd054e2f$export$79b2f7037acddd43(this._percentageSizeChildren, (child)=>{
            child._updateSize();
        });
        $2f30431acd054e2f$export$79b2f7037acddd43(this._percentagePositionChildren, (child)=>{
            child.markDirtyPosition();
            child._updateSize();
        });
        this.updateBackground();
    }
    updateBackground() {
        const background = this.get("background");
        let bounds = this._localBounds;
        if (bounds && !this.isHidden()) {
            let x = bounds.left;
            let y = bounds.top;
            let w = bounds.right - x;
            let h = bounds.bottom - y;
            let maxWidth = this.get("maxWidth");
            let maxHeight = this.get("maxHeight");
            if (maxHeight) {
                if (h > maxHeight) h = maxHeight;
            }
            if (maxWidth) {
                if (w > maxWidth) w = maxWidth;
            }
            let width = this.width();
            let height = this.height();
            if (background) {
                background.setAll({
                    width: w,
                    height: h,
                    x: x,
                    y: y
                });
                if (this._display.interactive) background._display.interactive = true;
            }
            const contentMask = this._contentMask;
            if (contentMask) contentMask.setAll({
                width: width + 1,
                height: height + 1
            });
            const verticalScrollbar = this.get("verticalScrollbar");
            if (verticalScrollbar) {
                verticalScrollbar.set("height", height);
                verticalScrollbar.set("x", width - verticalScrollbar.width() - verticalScrollbar.get("marginRight", 0));
                verticalScrollbar.set("end", verticalScrollbar.get("start", 0) + height / this._contentHeight);
                /**
                 * ruins scrollToChild
                let start = verticalScrollbar.get("start", 0);
                let end = verticalScrollbar.get("end", 1);

                if (start > 1 - end) {
                    verticalScrollbar.set("start", Math.max(0, end - height / this._contentHeight));
                }
                else {
                    verticalScrollbar.set("end", Math.min(1, start + height / this._contentHeight));
                }
                    */ const bg = verticalScrollbar.get("background");
                if (bg) bg.setAll({
                    width: verticalScrollbar.width(),
                    height: height
                });
                let visible = true;
                if (this._contentHeight <= height) visible = false;
                verticalScrollbar.setPrivate("visible", visible);
            }
        }
    }
    _applyThemes(force = false) {
        if (super._applyThemes(force)) {
            this.eachChildren((child)=>{
                child._applyThemes(force);
            });
            return true;
        } else return false;
    }
    _applyState(name) {
        super._applyState(name);
        if (this.get("setStateOnChildren")) this.eachChildren((child)=>{
            child.states.apply(name);
        });
    }
    _applyStateAnimated(name, duration) {
        super._applyStateAnimated(name, duration);
        if (this.get("setStateOnChildren")) this.eachChildren((child)=>{
            child.states.applyAnimate(name, duration);
        });
    }
    /**
     * Returns container's inner width (width without padding) in pixels.
     *
     * @return Inner width (px)
     */ innerWidth() {
        return this.width() - this.get("paddingRight", 0) - this.get("paddingLeft", 0);
    }
    /**
     * Returns container's inner height (height without padding) in pixels.
     *
     * @return Inner height (px)
     */ innerHeight() {
        return this.height() - this.get("paddingTop", 0) - this.get("paddingBottom", 0);
    }
    _getBounds() {
        if (!this.get("html")) {
            let width = this.get("width");
            let height = this.get("height");
            let pWidth = this.getPrivate("width");
            let pHeight = this.getPrivate("height");
            let bounds = {
                left: 0,
                top: 0,
                right: this.width(),
                bottom: this.height()
            };
            let layout = this.get("layout");
            let horizontal = false;
            let vertical = false;
            if (layout instanceof (0, $ce42d27226ec20a0$export$8be7400f61e793f0) || layout instanceof (0, $9961b4caf46ffbfc$export$7d2b12578154a735)) horizontal = true;
            if (layout instanceof (0, $b05f413a7bdbea0f$export$e4d3124dc23dc9c9)) vertical = true;
            if ((width != null || pWidth != null) && (height != null || pHeight != null) && !this.get("verticalScrollbar")) ;
            else {
                let m = Number.MAX_VALUE;
                let l = m;
                let r = -m;
                let t = m;
                let b = -m;
                const paddingLeft = this.get("paddingLeft", 0);
                const paddingTop = this.get("paddingTop", 0);
                const paddingRight = this.get("paddingRight", 0);
                const paddingBottom = this.get("paddingBottom", 0);
                this.children.each((child)=>{
                    if (child.get("position") != "absolute" && child.get("isMeasured")) {
                        let childBounds = child.adjustedLocalBounds();
                        let childX = child.x();
                        let childY = child.y();
                        let cl = childX + childBounds.left;
                        let cr = childX + childBounds.right;
                        let ct = childY + childBounds.top;
                        let cb = childY + childBounds.bottom;
                        if (horizontal) {
                            cl -= child.get("marginLeft", 0);
                            cr += child.get("marginRight", 0);
                        }
                        if (vertical) {
                            ct -= child.get("marginTop", 0);
                            cb += child.get("marginBottom", 0);
                        }
                        if (cl < l) l = cl;
                        if (cr > r) r = cr;
                        if (ct < t) t = ct;
                        if (cb > b) b = cb;
                    }
                });
                if (l == m) l = 0;
                if (r == -m) r = 0;
                if (t == m) t = 0;
                if (b == -m) b = 0;
                bounds.left = l - paddingLeft;
                bounds.top = t - paddingTop;
                bounds.right = r + paddingRight;
                bounds.bottom = b + paddingBottom;
                const minWidth = this.get("minWidth");
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(minWidth) && minWidth > 0) {
                    if (bounds.right - bounds.left < minWidth) {
                        if (bounds.right >= minWidth) bounds.left = bounds.right - minWidth;
                        else bounds.right = bounds.left + minWidth;
                    }
                }
                const minHeight = this.get("minHeight");
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(minHeight) && minHeight > 0) {
                    if (bounds.bottom - bounds.top < minHeight) {
                        if (bounds.bottom >= minHeight) bounds.top = bounds.bottom - minHeight;
                        else bounds.bottom = bounds.top + minHeight;
                    }
                }
            }
            this._contentWidth = bounds.right - bounds.left;
            this._contentHeight = bounds.bottom - bounds.top;
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(width)) {
                bounds.left = 0;
                bounds.right = width;
            }
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(pWidth)) {
                bounds.left = 0;
                bounds.right = pWidth;
            }
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(height)) {
                bounds.top = 0;
                bounds.bottom = height;
            }
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(pHeight)) {
                bounds.top = 0;
                bounds.bottom = pHeight;
            }
            this._localBounds = bounds;
        } else {
            let bounds = this._localBounds;
            if (bounds) {
                this._contentWidth = bounds.right - bounds.left;
                this._contentHeight = bounds.bottom - bounds.top;
            }
        }
    }
    _updateBounds() {
        const layout = this.get("layout");
        if (layout) layout.updateContainer(this);
        super._updateBounds();
        this.updateBackground();
    }
    /**
     * @ignore
     */ markDirty() {
        super.markDirty();
        this._root._addDirtyParent(this);
    }
    _prepareChildren() {
        this._childrenPrep = true;
        const innerWidth = this.innerWidth();
        const innerHeight = this.innerHeight();
        if (innerWidth != this._prevWidth || innerHeight != this._prevHeight) {
            let layout = this.get("layout");
            let horizontal = false;
            let vertical = false;
            if (layout) {
                if (layout instanceof (0, $ce42d27226ec20a0$export$8be7400f61e793f0) || layout instanceof (0, $9961b4caf46ffbfc$export$7d2b12578154a735)) horizontal = true;
                if (layout instanceof (0, $b05f413a7bdbea0f$export$e4d3124dc23dc9c9)) vertical = true;
            }
            $2f30431acd054e2f$export$79b2f7037acddd43(this._percentageSizeChildren, (child)=>{
                if (!horizontal) {
                    let width = child.get("width");
                    if (width instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) child.setPrivate("width", width.value * innerWidth);
                }
                if (!vertical) {
                    let height = child.get("height");
                    if (height instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) child.setPrivate("height", height.value * innerHeight);
                }
            });
            $2f30431acd054e2f$export$79b2f7037acddd43(this._percentagePositionChildren, (child)=>{
                child.markDirtyPosition();
                child.markDirtyBounds();
            });
            this._prevWidth = innerWidth;
            this._prevHeight = innerHeight;
            this._sizeDirty = true;
            this.updateBackground();
        }
    //this._handleStates();
    }
    _updateHTMLContent() {
        const html = this.get("html", "");
        if (html && html !== "") this._root._setHTMLContent(this, (0, $8d45a8a77dcd0f75$export$6a40ef019a0fa5f6)(this, html));
        else this._root._removeHTMLContent(this);
        this._root._positionHTMLElement(this);
    }
    /**
     * If scrolling is enabled on the Container (by adding `verticalScrollbar`)
     * the Container will scroll in such way so that target element becomes
     * visible if its currently outside of view.
     *
     * @param  child  Target child
     * @since 5.10.5
     */ scrollToChild(child) {
        const verticalScrollbar = this.get("verticalScrollbar");
        if (verticalScrollbar) {
            let y = child.y();
            let h = this.innerHeight();
            let ch = child.height();
            let contentH = this._contentHeight;
            let max = 1 - (h - ch / 2) / contentH;
            if (y + ch * .7 + this._childrenDisplay.y > h || y - ch * .3 + this._childrenDisplay.y < 0) {
                let pos = Math.max(0, Math.min(max, (y - ch / 2) / contentH));
                verticalScrollbar.animate({
                    key: "start",
                    to: pos,
                    duration: verticalScrollbar.get("animationDuration", 0),
                    easing: verticalScrollbar.get("animationEasing")
                });
            }
        }
    }
    _updateChildren() {
        this._childrenUpdt = true;
        if (this.isDirty("html")) this._updateHTMLContent();
        if (this.isDirty("verticalScrollbar")) {
            const verticalScrollbar = this.get("verticalScrollbar");
            if (verticalScrollbar) {
                verticalScrollbar._setParent(this);
                verticalScrollbar.startGrip.setPrivate("visible", false);
                verticalScrollbar.endGrip.setPrivate("visible", false);
                this.set("maskContent", true);
                this.set("paddingRight", verticalScrollbar.width() + verticalScrollbar.get("marginRight", 0) + verticalScrollbar.get("marginLeft", 0));
                let background = this.get("background");
                if (!background) background = this.set("background", (0, $9e0cea1ea085e274$export$4617fb02663045ef).new(this._root, {
                    themeTags: [
                        "background"
                    ],
                    fillOpacity: 0,
                    fill: this._root.interfaceColors.get("alternativeBackground")
                }));
                this._vsbd0 = this.events.on("wheel", (event)=>{
                    const wheelEvent = event.originalEvent;
                    // Ignore wheel event if it is happening on a non-chart element, e.g. if
                    // some page element is over the chart.
                    if ($05b1b40b69b15016$export$a3b96849d75e4c53(wheelEvent, this)) wheelEvent.preventDefault();
                    else return;
                    let shiftY = wheelEvent.deltaY / 5000;
                    const start = verticalScrollbar.get("start", 0);
                    const end = verticalScrollbar.get("end", 1);
                    if (start + shiftY <= 0) shiftY = -start;
                    if (end + shiftY >= 1) shiftY = 1 - end;
                    if (start + shiftY >= 0 && end + shiftY <= 1) {
                        verticalScrollbar.set("start", start + shiftY);
                        verticalScrollbar.set("end", end + shiftY);
                    }
                });
                this._disposers.push(this._vsbd0);
                this._vsbd1 = verticalScrollbar.events.on("rangechanged", ()=>{
                    let h = this._contentHeight;
                    const childrenDisplay = this._childrenDisplay;
                    const contentMask = this._contentMask;
                    childrenDisplay.y = -verticalScrollbar.get("start", 0) * h;
                    childrenDisplay.markDirtyLayer();
                    if (contentMask) {
                        contentMask._display.y = -childrenDisplay.y;
                        childrenDisplay.mask = contentMask._display;
                    }
                });
                this._disposers.push(this._vsbd1);
                this._display.addChild(verticalScrollbar._display);
            } else {
                const previous = this._prevSettings.verticalScrollbar;
                if (previous) {
                    this._display.removeChild(previous._display);
                    if (this._vsbd0) this._vsbd0.dispose();
                    if (this._vsbd1) this._vsbd1.dispose();
                    const childrenDisplay = this._childrenDisplay;
                    childrenDisplay.y = 0;
                    this.setPrivate("height", undefined);
                    this.set("maskContent", false);
                    this.set("paddingRight", undefined);
                }
            }
        }
        if (this.isDirty("background")) {
            // TODO maybe this should dispose ?
            const previous = this._prevSettings["background"];
            if (previous) this._display.removeChild(previous._display);
            const background = this.get("background");
            if (background instanceof (0, $d3b9c83dc790fa66$export$3075603db8e6204c)) {
                background.set("isMeasured", false);
                background._setParent(this);
                this._display.addChildAt(background._display, 0);
                // Rectangle / RoundedRectangle backgrounds render sharper edges and
                // strokes when crisp; default it on unless the user set it explicitly.
                if (background instanceof (0, $9e0cea1ea085e274$export$4617fb02663045ef) && !background.isUserSetting("crisp")) background.set("crisp", true);
            }
        }
        if (this.isDirty("mask")) {
            const mask = this.get("mask");
            const previous = this._prevSettings["mask"];
            if (previous) {
                this._display.removeChild(previous._display);
                if (previous != mask) previous.dispose();
            }
            if (mask) {
                const parent = mask.parent;
                if (parent) parent.children.removeValue(mask);
                mask._setParent(this);
                this._display.addChildAt(mask._display, 0);
                this._childrenDisplay.mask = mask._display;
            } else // mask removed: clear the clip, otherwise the children keep being
            // clipped by the (now disposed) previous mask display. Fall back to
            // the content mask if `maskContent` is in effect.
            this._childrenDisplay.mask = this._contentMask ? this._contentMask._display : null;
        }
    }
    _processTemplateField() {
        super._processTemplateField();
        this.children.each((child)=>{
            child._processTemplateField();
        });
    }
    /**
     * @ignore
     */ walkChildren(f) {
        this.children.each((child, index)=>{
            if (child instanceof $5de502da8a72d65e$export$42a852a2b6b56249) child.walkChildren(f);
            f(child, index);
        });
    }
    eachChildren(f) {
        const background = this.get("background");
        if (background) f(background);
        const verticalScrollbar = this.get("verticalScrollbar");
        if (verticalScrollbar) f(verticalScrollbar);
        const mask = this.get("mask");
        if (mask) f(mask);
        this.children.values.forEach((child)=>{
            f(child);
        });
    }
    allChildren() {
        const output = [];
        this.eachChildren((x)=>{
            output.push(x);
        });
        return output;
    }
    _setDataItem(dataItem) {
        const updated = dataItem !== this._dataItem;
        super._setDataItem(dataItem);
        const html = this.get("html", "");
        if (html && html !== "" && updated) this._root._setHTMLContent(this, (0, $8d45a8a77dcd0f75$export$6a40ef019a0fa5f6)(this, html));
    }
    contentWidth() {
        return this._contentWidth;
    }
    contentHeight() {
        return this._contentHeight;
    }
}
$5de502da8a72d65e$export$42a852a2b6b56249.className = "Container";
$5de502da8a72d65e$export$42a852a2b6b56249.classNames = (0, $d3b9c83dc790fa66$export$3075603db8e6204c).classNames.concat([
    $5de502da8a72d65e$export$42a852a2b6b56249.className
]);







class $991c10b390813ab6$export$5f1af8db9871e1d6 extends (0, $d3b9c83dc790fa66$export$3075603db8e6204c) {
    constructor(){
        super(...arguments);
        this.textStyle = this._root._renderer.makeTextStyle();
        this._display = this._root._renderer.makeText("", this.textStyle);
        this._textStyles = [
            "textAlign",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "fontStyle",
            "fontVariant",
            "textDecoration",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY",
            "shadowOpacity",
            // "leading",
            // "letterSpacing",
            "lineHeight",
            "baselineRatio",
            //"padding",
            // "stroke",
            // "strokeThickness",
            // "trim",
            // "wordWrap",
            "direction",
            "textBaseline",
            "oversizedBehavior",
            "breakWords",
            "ellipsis",
            "minScale",
            "maxChars"
        ];
    }
    _updateBounds() {
        if (!this.get("text")) {
            let newBounds = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            };
            this._adjustedLocalBounds = newBounds;
        } else {
            super._updateBounds();
            let fillGradient = this.get("fillGradient");
            if (fillGradient) this._display.style.fill = fillGradient.getFill(this);
        }
    }
    _changed() {
        super._changed();
        this._display.clear();
        let textStyle = this.textStyle;
        if (this.isDirty("opacity")) {
            let opacity = this.get("opacity", 1);
            this._display.alpha = opacity;
        }
        if (this.isDirty("text") || this.isDirty("populateText")) {
            this._display.text = this._getText();
            this.markDirtyBounds();
            if (this.get("role") == "tooltip") this._root.updateTooltip(this);
        }
        if (this.isPrivateDirty("tooltipElement")) {
            const tooltipElement = this.getPrivate("tooltipElement");
            if (tooltipElement) this._disposers.push(new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
                this._root._removeTooltipElement(this);
            }));
        }
        if (this.isDirty("width")) {
            textStyle.wordWrapWidth = this.width();
            this.markDirtyBounds();
        }
        if (this.isDirty("oversizedBehavior")) {
            textStyle.oversizedBehavior = this.get("oversizedBehavior", "none");
            this._display.invalidateVisibility();
            this.markDirtyBounds();
        }
        if (this.isDirty("breakWords")) {
            textStyle.breakWords = this.get("breakWords", false);
            this.markDirtyBounds();
        }
        if (this.isDirty("ellipsis")) {
            textStyle.ellipsis = this.get("ellipsis");
            this.markDirtyBounds();
        }
        if (this.isDirty("ignoreFormatting")) {
            textStyle.ignoreFormatting = this.get("ignoreFormatting", false);
            this.markDirtyBounds();
        }
        if (this.isDirty("minScale")) {
            textStyle.minScale = this.get("minScale", 0);
            this.markDirtyBounds();
        }
        if (this.isDirty("fill") || this.isDirty("fillGradient")) {
            const fill = this.get("fill");
            const fillGradient = this.get("fillGradient");
            const fillOpacity = this.get("fillOpacity");
            if (fillGradient) {
                if (fill) {
                    const stops = fillGradient.get("stops", []);
                    if (stops.length) $2f30431acd054e2f$export$79b2f7037acddd43(stops, (stop)=>{
                        if ((!stop.color || stop.colorInherited) && fill) {
                            stop.color = fill;
                            stop.colorInherited = true;
                        }
                        if (stop.opacity == null || stop.opacityInherited) {
                            stop.opacity = fillOpacity;
                            stop.opacityInherited = true;
                        }
                    });
                }
                textStyle.fill = fillGradient.getFill(this);
            } else if (fill) textStyle.fill = fill;
        }
        if (this.isDirty("fillOpacity")) {
            let fillOpacity = this.get("fillOpacity", 1);
            if (fillOpacity) textStyle.fillOpacity = fillOpacity;
        }
        if (this.isDirty("maxWidth") || this.isPrivateDirty("maxWidth")) {
            textStyle.maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
            this.markDirtyBounds();
        }
        if (this.isDirty("maxHeight") || this.isPrivateDirty("maxHeight")) {
            textStyle.maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
            this.markDirtyBounds();
        }
        $2f30431acd054e2f$export$79b2f7037acddd43(this._textStyles, (styleName)=>{
            if (this._dirty[styleName]) {
                textStyle[styleName] = this.get(styleName);
                this.markDirtyBounds();
            }
        });
        textStyle["fontSize"] = this.get("fontSize");
        textStyle["fontFamily"] = this.get("fontFamily");
        this._display.style = textStyle;
        if (this.isDirty("role") && this.get("role") == "tooltip") this._root.updateTooltip(this);
    }
    _getText() {
        let text = this.get("text", "");
        if (this.get("maxChars")) text = $05b1b40b69b15016$export$c1942c34655b7385(text, this.get("maxChars", 100000000), this.get("breakWords"), this.get("ellipsis"));
        return this.get("populateText") ? (0, $8d45a8a77dcd0f75$export$6a40ef019a0fa5f6)(this, text) : text;
    }
    _getAccessibleText() {
        const ariaLabel = this.get("ariaLabel");
        if (ariaLabel !== undefined) return this.get("populateText") ? (0, $8d45a8a77dcd0f75$export$6a40ef019a0fa5f6)(this, ariaLabel) : ariaLabel;
        return this._getText();
    }
    /**
     * Forces the text to be re-evaluated and re-populated.
     */ markDirtyText() {
        this._display.text = this._getText();
        if (this.get("role") == "tooltip") this._root.updateTooltip(this);
        this.markDirtyBounds();
        this.markDirty();
    }
    _setDataItem(dataItem) {
        super._setDataItem(dataItem);
        if (this.get("populateText")) this.markDirtyText();
    }
    getNumberFormatter() {
        if (this.parent) return this.parent.getNumberFormatter();
        else return super.getNumberFormatter();
    }
    getDateFormatter() {
        if (this.parent) return this.parent.getDateFormatter();
        else return super.getDateFormatter();
    }
    getDurationFormatter() {
        if (this.parent) return this.parent.getDurationFormatter();
        else return super.getDurationFormatter();
    }
}
$991c10b390813ab6$export$5f1af8db9871e1d6.className = "Text";
$991c10b390813ab6$export$5f1af8db9871e1d6.classNames = (0, $d3b9c83dc790fa66$export$3075603db8e6204c).classNames.concat([
    $991c10b390813ab6$export$5f1af8db9871e1d6.className
]);






/** @ignore */ /** */ 

/**
 * @ignore
 */ class $fcc21c9236571fac$var$Native {
    constructor(){
        this._targets = [];
        this._observer = new ResizeObserver((entries)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(entries, (entry)=>{
                $2f30431acd054e2f$export$79b2f7037acddd43(this._targets, (x)=>{
                    if (x.target === entry.target) x.callback();
                });
            });
        });
    }
    addTarget(target, callback) {
        this._observer.observe(target, {
            box: "border-box"
        });
        this._targets.push({
            target: target,
            callback: callback
        });
    }
    removeTarget(target) {
        this._observer.unobserve(target);
        $2f30431acd054e2f$export$249f83d169a7c462(this._targets, (x)=>{
            return x.target !== target;
        });
    }
}
/**
 * @ignore
 */ class $fcc21c9236571fac$var$Raf {
    constructor(){
        this._timer = null;
        this._targets = [];
    }
    addTarget(target, callback) {
        if (this._timer === null) {
            let lastTime = null;
            const loop = ()=>{
                const currentTime = Date.now();
                if (lastTime === null || currentTime > lastTime + $fcc21c9236571fac$var$Raf.delay) {
                    lastTime = currentTime;
                    $2f30431acd054e2f$export$79b2f7037acddd43(this._targets, (x)=>{
                        let newSize = x.target.getBoundingClientRect();
                        if (newSize.width !== x.size.width || newSize.height !== x.size.height) {
                            x.size = newSize;
                            x.callback();
                        }
                    });
                }
                if (this._targets.length === 0) this._timer = null;
                else this._timer = requestAnimationFrame(loop);
            };
            this._timer = requestAnimationFrame(loop);
        }
        // We start off with fake bounds so that sensor always kicks in
        let size = {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            x: 0,
            y: 0
        };
        this._targets.push({
            target: target,
            callback: callback,
            size: size
        });
    }
    removeTarget(target) {
        $2f30431acd054e2f$export$249f83d169a7c462(this._targets, (x)=>{
            return x.target !== target;
        });
        if (this._targets.length === 0) {
            if (this._timer !== null) {
                cancelAnimationFrame(this._timer);
                this._timer = null;
            }
        }
    }
}
$fcc21c9236571fac$var$Raf.delay = 200;
/**
 * @ignore
 */ let $fcc21c9236571fac$var$observer = null;
/**
 * @ignore
 */ function $fcc21c9236571fac$var$makeSensor() {
    if ($fcc21c9236571fac$var$observer === null) {
        if (typeof ResizeObserver !== "undefined") $fcc21c9236571fac$var$observer = new $fcc21c9236571fac$var$Native();
        else $fcc21c9236571fac$var$observer = new $fcc21c9236571fac$var$Raf();
    }
    return $fcc21c9236571fac$var$observer;
}
class $fcc21c9236571fac$export$99e7f5e92b1f0cf9 {
    constructor(element, callback){
        this._disposed = false;
        this._sensor = $fcc21c9236571fac$var$makeSensor();
        this._element = element;
        // This is needed because we need to know when the window is zoomed
        this._listener = $05b1b40b69b15016$export$6981aa66c6e2c48d(callback);
        this._sensor.addTarget(element, callback);
    }
    isDisposed() {
        return this._disposed;
    }
    dispose() {
        if (!this._disposed) {
            this._disposed = true;
            this._sensor.removeTarget(this._element);
            this._listener.dispose();
        }
    }
    get sensor() {
        return this._sensor;
    }
}



class $78e10ff73ddf6061$export$8dce48c3552f8697 extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
}
$78e10ff73ddf6061$export$8dce48c3552f8697.className = "InterfaceColors";
$78e10ff73ddf6061$export$8dce48c3552f8697.classNames = (0, $baeade534ece7f4c$export$bc644a473284d944).classNames.concat([
    $78e10ff73ddf6061$export$8dce48c3552f8697.className
]);










class $f15f09c5037802f9$export$b04be29aa201d4f5 extends (0, $5de502da8a72d65e$export$42a852a2b6b56249) {
    constructor(){
        super(...arguments);
        this._textKeys = [
            "text",
            "fill",
            "fillGradient",
            "fillOpacity",
            "textAlign",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "fontStyle",
            "fontVariant",
            "textDecoration",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY",
            "shadowOpacity",
            // "leading",
            // "letterSpacing",
            "lineHeight",
            "baselineRatio",
            //"padding",
            // "stroke",
            // "strokeThickness",
            // "trim",
            // "wordWrap",
            "direction",
            "textBaseline",
            "oversizedBehavior",
            "breakWords",
            "ellipsis",
            "minScale",
            "populateText",
            "role",
            "ignoreFormatting",
            "maxChars",
            "ariaLabel"
        ];
    }
    /**
     * @ignore Text is not to be used directly
     */ get text() {
        return this._text;
    }
    _afterNew() {
        super._afterNew();
        this._makeText();
        $2f30431acd054e2f$export$79b2f7037acddd43(this._textKeys, (property)=>{
            const propValue = this._getTextKeyValue(property);
            if (propValue != undefined) this._text.set(property, propValue);
        });
        if (this.get("html", "") !== "") this._text.set("text", "");
        this.onPrivate("maxWidth", ()=>{
            this._setMaxDimentions();
        });
        this.onPrivate("maxHeight", ()=>{
            this._setMaxDimentions();
        });
    }
    _makeText() {
        this._text = this.children.push((0, $991c10b390813ab6$export$5f1af8db9871e1d6).new(this._root, {}));
    }
    /**
     * Returns the value to push downstream to the [[Text]] for a given key.
     *
     * For the font settings (`fontFamily`/`fontSize`/`fontWeight`) the label's
     * own value is used only when it was explicitly set on the label
     * (`isUserSetting`) or when there is no matching `Root` setting. Otherwise a
     * `Root`-level default takes precedence, so it overrides theme values but
     * never an explicit per-label value.
     */ _getTextKeyValue(property) {
        if (property === "fontFamily" || property === "fontSize" || property === "fontWeight") {
            if (!this.isUserSetting(property)) {
                const rootValue = this._root.settings[property];
                if (rootValue != undefined) return rootValue;
            }
        }
        return this.get(property);
    }
    _updateChildren() {
        super._updateChildren();
        const text = this._text;
        $2f30431acd054e2f$export$79b2f7037acddd43(this._textKeys, (property)=>{
            this._text.set(property, this._getTextKeyValue(property));
        });
        if (this.isDirty("maxWidth") || this.isDirty("maxHeight") || this.isDirty("rotation")) this._setMaxDimentions();
        // Do not show regular text if HTML is used
        if (this.get("html", "") !== "") text.set("text", "");
        else {
            text.set("text", this.get("text"));
            this._maybeUpdateHTMLColor();
        }
        if (this.isDirty("fill") || this.isDirty("fillGradient")) this._maybeUpdateHTMLColor();
        if (this.isDirty("textAlign") || this.isDirty("width")) {
            const textAlign = this.get("textAlign");
            let x;
            if (this.get("width") != null) {
                if (textAlign == "right") x = (0, $bd0d0c10fd30006b$export$46342ea78d85883c);
                else if (textAlign == "center") x = (0, $bd0d0c10fd30006b$export$888d047b0ce6de72);
                else x = 0;
            } else {
                if (textAlign == "left" || textAlign == "start") x = this.get("paddingLeft", 0);
                else if (textAlign == "right" || textAlign == "end") x = -this.get("paddingRight", 0);
            }
            text.set("x", x);
        }
        const background = this.get("background");
        if (background) background.setPrivate("visible", text._display.textVisible);
    }
    _maybeUpdateHTMLColor() {
        const htmlElement = this.getPrivate("htmlElement");
        if (htmlElement && this.get("fill")) htmlElement.style.color = this.get("fill").toCSSHex();
    }
    _setMaxDimentions() {
        const rotation = this.get("rotation");
        const vertical = rotation == 90 || rotation == 270 || rotation == -90;
        const text = this._text;
        const maxWidth = this.get("maxWidth", this.getPrivate("maxWidth", Infinity));
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxWidth)) text.set(vertical ? "maxHeight" : "maxWidth", maxWidth - this.get("paddingTop", 0) - this.get("paddingBottom", 0));
        else text.set(vertical ? "maxHeight" : "maxWidth", undefined);
        const maxHeight = this.get("maxHeight", this.getPrivate("maxHeight", Infinity));
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxHeight)) text.set(vertical ? "maxWidth" : "maxHeight", maxHeight - this.get("paddingLeft", 0) - this.get("paddingRight", 0));
        else text.set(vertical ? "maxWidth" : "maxHeight", undefined);
        this.root.events.once("frameended", ()=>{
            text.markDirtyBounds();
        });
    }
    _setDataItem(dataItem) {
        super._setDataItem(dataItem);
        this._markDirtyKey("text");
        this._markDirtyKey("html");
        const text = this._text;
        if (text.get("populateText")) text.markDirtyText();
        const html = this.get("html");
        if (html && html !== "") this._updateHTMLContent();
    }
    /**
     * Returns text with populated placeholders and formatting if `populateText` is
     * set to `true`.
     *
     * @return Populated text
     */ getText() {
        return this._text._getText();
    }
    /**
     * Returns "aria-label" text with populated placeholders and formatting
     * if `populateText` is set to `true`.
     *
     * @return Populated text
     */ getAccessibleText() {
        return this._text._getAccessibleText();
    }
}
$f15f09c5037802f9$export$b04be29aa201d4f5.className = "Label";
$f15f09c5037802f9$export$b04be29aa201d4f5.classNames = (0, $5de502da8a72d65e$export$42a852a2b6b56249).classNames.concat([
    $f15f09c5037802f9$export$b04be29aa201d4f5.className
]);




class $b7e6ca628a07e093$export$458c0690b0cc8182 extends (0, $2ffdafbe1fe6a946$export$29d3e417456abdad) {
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("pointerBaseWidth") || this.isDirty("cornerRadius") || this.isDirty("pointerLength") || this.isDirty("pointerX") || this.isDirty("pointerY") || this.isDirty("width") || this.isDirty("height")) this._clear = true;
    }
    _changed() {
        super._changed();
        if (this._clear) {
            this.markDirtyBounds();
            let w = this.width();
            let h = this.height();
            if (w > 0 && h > 0) {
                let cr = this.get("cornerRadius", 8);
                cr = $f43e9e04b3f0548b$export$386b748ab02f16a0(cr, 0, Math.min(w / 2, h / 2));
                let x = this.get("pointerX", 0);
                let y = this.get("pointerY", 0);
                let bwh = this.get("pointerBaseWidth", 15) / 2;
                // corner coordinates
                // top left
                let xtl = 0;
                let ytl = 0;
                // top right
                let xtr = w;
                let ytr = 0;
                // bottom right
                let xbr = w;
                let ybr = h;
                // bottom left
                let xbl = 0;
                let ybl = h;
                // find stem base side: http://$math.stackexchange.com/questions/274712/calculate-on-which-side-of-straign-line-is-dot-located
                // d=(x−x1)(y2−y1)−(y−y1)(x2−x1)
                let d1 = (x - xtl) * (ybr - ytl) - (y - ytl) * (xbr - xtl);
                let d2 = (x - xbl) * (ytr - ybl) - (y - ybl) * (xtr - xbl);
                const display = this._display;
                // top
                display.moveTo(cr, 0);
                if (d1 > 0 && d2 > 0) {
                    let stemX = Math.round($f43e9e04b3f0548b$export$386b748ab02f16a0(x, cr + bwh, w - bwh - cr));
                    y = $f43e9e04b3f0548b$export$386b748ab02f16a0(y, -Infinity, 0);
                    display.lineTo(stemX - bwh, 0);
                    display.lineTo(x, y);
                    display.lineTo(stemX + bwh, 0);
                }
                display.lineTo(w - cr, 0);
                display.arcTo(w, 0, w, cr, cr);
                // right
                if (d1 > 0 && d2 < 0) {
                    let stemY = Math.round($f43e9e04b3f0548b$export$386b748ab02f16a0(y, cr + bwh, h - bwh - cr));
                    x = $f43e9e04b3f0548b$export$386b748ab02f16a0(x, w, Infinity);
                    display.lineTo(w, cr);
                    display.lineTo(w, Math.max(stemY - bwh, cr));
                    display.lineTo(x, y);
                    display.lineTo(w, stemY + bwh);
                }
                display.lineTo(w, h - cr);
                display.arcTo(w, h, w - cr, h, cr);
                // bottom
                if (d1 < 0 && d2 < 0) {
                    let stemX = Math.round($f43e9e04b3f0548b$export$386b748ab02f16a0(x, cr + bwh, w - bwh - cr));
                    y = $f43e9e04b3f0548b$export$386b748ab02f16a0(y, h, Infinity);
                    display.lineTo(w - cr, h);
                    display.lineTo(stemX + bwh, h);
                    display.lineTo(x, y);
                    display.lineTo(stemX - bwh, h);
                }
                display.lineTo(cr, h);
                display.arcTo(0, h, 0, h - cr, cr);
                // left
                if (d1 < 0 && d2 > 0) {
                    let stemY = Math.round($f43e9e04b3f0548b$export$386b748ab02f16a0(y, cr + bwh, h - cr - bwh));
                    x = $f43e9e04b3f0548b$export$386b748ab02f16a0(x, -Infinity, 0);
                    display.lineTo(0, h - cr);
                    display.lineTo(0, stemY + bwh);
                    display.lineTo(x, y);
                    display.lineTo(0, Math.max(stemY - bwh, cr));
                }
                display.lineTo(0, cr);
                display.arcTo(0, 0, cr, 0, cr);
                display.closePath();
            }
        }
    }
}
$b7e6ca628a07e093$export$458c0690b0cc8182.className = "PointedRectangle";
$b7e6ca628a07e093$export$458c0690b0cc8182.classNames = (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).classNames.concat([
    $b7e6ca628a07e093$export$458c0690b0cc8182.className
]);








class $670fc48e4ddbc086$export$28c660c63b792dea extends (0, $5de502da8a72d65e$export$42a852a2b6b56249) {
    constructor(root, settings, isReal, templates = []){
        super(root, settings, isReal, templates);
        this._fx = 0;
        this._fy = 0;
        this._w = 0;
        this._h = 0;
        this._htmlContentHovered = false;
    }
    _afterNew() {
        this._settings.themeTags = $05b1b40b69b15016$export$88ad500ef99d1561(this._settings.themeTags, [
            "tooltip"
        ]);
        super._afterNew();
        const background = this._setDefaultFn("background", ()=>{
            return (0, $b7e6ca628a07e093$export$458c0690b0cc8182).new(this._root, {});
        });
        background.set("themeTags", [
            "tooltip",
            "background"
        ]);
        this._label = this.children.push((0, $f15f09c5037802f9$export$b04be29aa201d4f5).new(this._root, {}));
        this._disposers.push(this._label.events.on("boundschanged", ()=>{
            this._updateBackground();
        }));
        this._disposers.push(this.on("bounds", ()=>{
            this._updateBackground();
        }));
        this._updateTextColor();
        this._root.tooltipContainer.children.push(this);
        this.hide(0);
        this._disposers.push(this.label.onPrivate("htmlElement", (htmlElement)=>{
            if (htmlElement) {
                this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(htmlElement, "pointerover", (_ev)=>{
                    this._htmlContentHovered = true;
                }));
                this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(htmlElement, "pointerout", (_ev)=>{
                    this._htmlContentHovered = false;
                }));
            }
        }));
        this.on("visible", (_ev)=>{
            this._handleReaderAnnouncement();
        });
        this.label.events.on("dataitemchanged", (_ev)=>{
            this._handleReaderAnnouncement();
        });
        this._root._tooltips.push(this);
    }
    _handleReaderAnnouncement() {
        if (this.get("readerAnnounce") && this.isVisibleDeep()) this._root.readerAlert(this.label.getAccessibleText());
    }
    /**
     * A [[Label]] element for the tooltip.
     *
     * @readonly
     * @return Label
     */ get label() {
        return this._label;
    }
    /**
     * Permanently disposes the tooltip.
     */ _dispose() {
        super._dispose();
        $2f30431acd054e2f$export$cd7f480d6b8286c3(this._root._tooltips, this);
    }
    _updateChildren() {
        super._updateChildren();
        if (this.isDirty("pointerOrientation") || this.isPrivateDirty("minWidth") || this.isPrivateDirty("minHeight")) this.get("background")._markDirtyKey("width");
        const labelText = this.get("labelText");
        if (labelText != null) this.label.set("text", this.get("labelText"));
        const labelHTML = this.get("labelHTML");
        if (labelHTML != null) this.label.set("html", this.get("labelHTML"));
        const labelAriaLabel = this.get("labelAriaLabel");
        if (labelAriaLabel != null) this.label.set("ariaLabel", this.get("labelAriaLabel"));
    }
    _changed() {
        super._changed();
        if (this.isDirty("pointTo") || this.isDirty("pointerOrientation")) // can't compare to previous, as sometimes pointTo is set twice (when pointer moves, so the position won't be udpated)
        this._updateBackground();
        if (this.isDirty("tooltipTarget")) this.updateBackgroundColor();
        if (this.isDirty("keepTargetHover")) {
            const keephover = this.get("keepTargetHover");
            if (keephover) {
                const bg = this.get("background");
                this._keepHoverDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                    bg.events.on("pointerover", (_ev)=>{
                        let target = this.get("tooltipTarget");
                        if (target) {
                            if (target.parent && target.parent.getPrivate("tooltipTarget") == target) target = target.parent;
                            target.hover();
                        }
                    }),
                    bg.events.on("pointerout", (_ev)=>{
                        let target = this.get("tooltipTarget");
                        if (target) {
                            if (target.parent && target.parent.getPrivate("tooltipTarget") == target) target = target.parent;
                            if (!this._htmlContentHovered) target.unhover();
                        }
                    })
                ]);
                this.label.onPrivate("htmlElement", (htmlElement)=>{
                    if (this._keepHoverDp && htmlElement) this._keepHoverDp.disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(htmlElement, "pointerleave", (ev)=>{
                        const outEvent = this.root._renderer.getEvent(ev);
                        bg.events.dispatch("pointerout", {
                            type: "pointerout",
                            originalEvent: outEvent.event,
                            point: outEvent.point,
                            simulated: false,
                            target: bg
                        });
                    }));
                });
            } else if (this._keepHoverDp) {
                this._keepHoverDp.dispose();
                this._keepHoverDp = undefined;
            }
        }
    }
    _onShow() {
        super._onShow();
        this.updateBackgroundColor();
    }
    updateBackgroundColor() {
        let tooltipTarget = this.get("tooltipTarget");
        const background = this.get("background");
        let fill;
        let stroke;
        if (tooltipTarget && background) {
            fill = tooltipTarget.get("fill");
            stroke = tooltipTarget.get("stroke");
            if (fill == null) fill = stroke;
            if (this.get("getFillFromSprite")) {
                if (this._fillDp) this._fillDp.dispose();
                if (fill != null) background.set("fill", fill);
                this._fillDp = tooltipTarget.on("fill", (fill)=>{
                    if (fill != null) {
                        background.set("fill", fill);
                        this._updateTextColor(fill);
                    }
                });
                this._disposers.push(this._fillDp);
            }
            if (this.get("getFillGradientFromSprite")) {
                if (this._fillGrDp) this._fillGrDp.dispose();
                let fillGradient = tooltipTarget.get("fillGradient");
                if (fillGradient != null) background.set("fillGradient", fillGradient);
                this._fillGrDp = tooltipTarget.on("fillGradient", (fillGradient)=>{
                    if (fillGradient != null) background.set("fillGradient", fillGradient);
                });
                this._disposers.push(this._fillGrDp);
            }
            if (this.get("getStrokeFromSprite")) {
                if (this._strokeDp) this._strokeDp.dispose();
                if (fill != null) background.set("stroke", fill);
                this._strokeDp = tooltipTarget.on("fill", (fill)=>{
                    if (fill != null) background.set("stroke", fill);
                });
                this._disposers.push(this._strokeDp);
            }
            if (this.get("getLabelFillFromSprite")) {
                if (this._labelDp) this._labelDp.dispose();
                if (fill != null) this.label.set("fill", fill);
                this._labelDp = tooltipTarget.on("fill", (fill)=>{
                    if (fill != null) this.label.set("fill", fill);
                });
                this._disposers.push(this._labelDp);
            }
        }
        this._updateTextColor(fill);
    }
    _updateTextColor(fill) {
        if (this.get("autoTextColor")) {
            if (fill == null) fill = this.get("background").get("fill");
            if (fill == null) fill = this._root.interfaceColors.get("background");
            if (fill instanceof (0, $389de129b6cd18b1$export$892596cec99bc70e)) this.label.set("fill", (0, $389de129b6cd18b1$export$892596cec99bc70e).alternative(fill, this._root.interfaceColors.get("alternativeText"), this._root.interfaceColors.get("text")));
        }
    }
    _setDataItem(dataItem) {
        super._setDataItem(dataItem);
        this.label._setDataItem(dataItem);
    }
    _updateBackground() {
        super.updateBackground();
        const parent = this._root.container;
        if (parent) {
            let cw = 0.5;
            let ch = 0.5;
            let centerX = this.get("centerX");
            if (centerX instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) cw = centerX.value;
            let centerY = this.get("centerY");
            if (centerY instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) ch = centerY.value;
            let parentW = parent.width();
            let parentH = parent.height();
            let tooltipContainer = this.parent;
            let xx = 0;
            let yy = 0;
            if (tooltipContainer) {
                xx = tooltipContainer.x();
                yy = tooltipContainer.y();
                const layerMargin = tooltipContainer.get("layerMargin");
                if (layerMargin) {
                    xx += layerMargin.left || 0;
                    yy += layerMargin.top || 0;
                    parentW += (layerMargin.left || 0) + (layerMargin.right || 0);
                    parentH += (layerMargin.top || 0) + (layerMargin.bottom || 0);
                }
            }
            const bounds = this.get("bounds", {
                left: -xx,
                top: -yy,
                right: parentW - xx,
                bottom: parentH - yy
            });
            this._updateBounds();
            let w = this.width();
            let h = this.height();
            // use old w and h,as when tooltip is hidden, these are 0 and unneeded animation happens
            if (w === 0) w = this._w;
            if (h === 0) h = this._h;
            let pointTo = this.get("pointTo", {
                x: parentW / 2,
                y: parentH / 2
            });
            let x = pointTo.x;
            let y = pointTo.y;
            let pointerOrientation = this.get("pointerOrientation");
            let background = this.get("background");
            let pointerLength = 0;
            let bgStrokeSizeY = 0;
            let bgStrokeSizeX = 0;
            if (background instanceof (0, $b7e6ca628a07e093$export$458c0690b0cc8182)) {
                pointerLength = background.get("pointerLength", 0);
                bgStrokeSizeY = background.get("strokeWidth", 0) / 2;
                bgStrokeSizeX = bgStrokeSizeY;
                background.set("width", w);
                background.set("height", h);
            }
            let pointerX = 0;
            let pointerY = 0;
            let boundsW = bounds.right - bounds.left;
            let boundsH = bounds.bottom - bounds.top;
            // horizontal
            if (pointerOrientation == "horizontal" || pointerOrientation == "left" || pointerOrientation == "right") {
                bgStrokeSizeY = 0;
                if (pointerOrientation == "horizontal") {
                    if (x > bounds.left + boundsW / 2) {
                        x -= w * (1 - cw) + pointerLength;
                        bgStrokeSizeX *= -1;
                    } else x += w * cw + pointerLength;
                } else if (pointerOrientation == "left") x += w * (1 - cw) + pointerLength;
                else {
                    x -= w * cw + pointerLength;
                    bgStrokeSizeX *= -1;
                }
            } else {
                bgStrokeSizeX = 0;
                if (pointerOrientation == "vertical") {
                    if (y > bounds.top + h / 2 + pointerLength) y -= h * (1 - ch) + pointerLength;
                    else {
                        y += h * ch + pointerLength;
                        bgStrokeSizeY *= -1;
                    }
                } else if (pointerOrientation == "down") y -= h * (1 - ch) + pointerLength;
                else {
                    y += h * ch + pointerLength;
                    bgStrokeSizeY *= -1;
                }
            }
            x = $f43e9e04b3f0548b$export$386b748ab02f16a0(x, bounds.left + w * cw, bounds.left + boundsW - w * (1 - cw)) + bgStrokeSizeX;
            y = $f43e9e04b3f0548b$export$386b748ab02f16a0(y, bounds.top + h * ch, bounds.top + boundsH - h * (1 - ch)) - bgStrokeSizeY;
            pointerX = pointTo.x - x + w * cw + bgStrokeSizeX;
            pointerY = pointTo.y - y + h * ch - bgStrokeSizeY;
            this._fx = x;
            this._fy = y;
            const animationDuration = this.get("animationDuration", 0);
            if (animationDuration > 0 && this.get("visible") && this.get("opacity") > 0.1) {
                const animationEasing = this.get("animationEasing");
                this.animate({
                    key: "x",
                    to: x,
                    duration: animationDuration,
                    easing: animationEasing
                });
                this.animate({
                    key: "y",
                    to: y,
                    duration: animationDuration,
                    easing: animationEasing
                });
            } else {
                this.set("x", x);
                this.set("y", y);
            }
            if (background instanceof (0, $b7e6ca628a07e093$export$458c0690b0cc8182)) {
                background.set("pointerX", pointerX);
                background.set("pointerY", pointerY);
            }
            if (w > 0) this._w = w;
            if (h > 0) this._h = h;
        }
    }
}
$670fc48e4ddbc086$export$28c660c63b792dea.className = "Tooltip";
$670fc48e4ddbc086$export$28c660c63b792dea.classNames = (0, $5de502da8a72d65e$export$42a852a2b6b56249).classNames.concat([
    $670fc48e4ddbc086$export$28c660c63b792dea.className
]);







class $b20322a184511108$export$cc77c4ff7e8673c5 extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    _setDefaults() {
        // Defaults
        this._setDefault("negativeBase", 0);
        this._setDefault("numberFormat", "#,###.#####");
        this._setDefault("smallNumberThreshold", 1.00);
        const bns = "_big_number_suffix_";
        const sns = "_small_number_suffix_";
        const bs = "_byte_suffix_";
        this._setDefault("bigNumberPrefixes", [
            {
                "number": 1e+3,
                "suffix": this._t(bns + "3")
            },
            {
                "number": 1e+6,
                "suffix": this._t(bns + "6")
            },
            {
                "number": 1e+9,
                "suffix": this._t(bns + "9")
            },
            {
                "number": 1e+12,
                "suffix": this._t(bns + "12")
            },
            {
                "number": 1e+15,
                "suffix": this._t(bns + "15")
            },
            {
                "number": 1e+18,
                "suffix": this._t(bns + "18")
            },
            {
                "number": 1e+21,
                "suffix": this._t(bns + "21")
            },
            {
                "number": 1e+24,
                "suffix": this._t(bns + "24")
            }
        ]);
        this._setDefault("smallNumberPrefixes", [
            {
                "number": 1e-24,
                "suffix": this._t(sns + "24")
            },
            {
                "number": 1e-21,
                "suffix": this._t(sns + "21")
            },
            {
                "number": 1e-18,
                "suffix": this._t(sns + "18")
            },
            {
                "number": 1e-15,
                "suffix": this._t(sns + "15")
            },
            {
                "number": 1e-12,
                "suffix": this._t(sns + "12")
            },
            {
                "number": 1e-9,
                "suffix": this._t(sns + "9")
            },
            {
                "number": 1e-6,
                "suffix": this._t(sns + "6")
            },
            {
                "number": 1e-3,
                "suffix": this._t(sns + "3")
            }
        ]);
        this._setDefault("bytePrefixes", [
            {
                "number": 1,
                suffix: this._t(bs + "B")
            },
            {
                "number": 1024,
                suffix: this._t(bs + "KB")
            },
            {
                "number": 1048576,
                suffix: this._t(bs + "MB")
            },
            {
                "number": 1073741824,
                suffix: this._t(bs + "GB")
            },
            {
                "number": 1099511627776,
                suffix: this._t(bs + "TB")
            },
            {
                "number": 1125899906842624,
                suffix: this._t(bs + "PB")
            }
        ]);
        super._setDefaults();
    }
    _beforeChanged() {
        super._beforeChanged();
    }
    /**
     * Formats the number according to specific format.
     *
     * @param value   Value to format
     * @param format  Format to apply
     * @return Formatted number
     */ format(value, format, precision) {
        // no format passed in or "Number"
        if (format == null || $f63bdea45a89cf24$export$844ec244b1367d54(format) && format.toLowerCase() === "number") format = this.get("numberFormat", "");
        // Init return value
        let formatted;
        // Cast to number just in case
        // TODO: maybe use better casting
        let source = Number(value);
        // Is it a built-in format or Intl.NumberFormatOptions
        if ($f63bdea45a89cf24$export$a6cdc56e425d0d0a(format)) try {
            if (this.get("intlLocales")) return new Intl.NumberFormat(this.get("intlLocales"), format).format(source);
            else return new Intl.NumberFormat(undefined, format).format(source);
        } catch (e) {
            return "Invalid";
        }
        else {
            // Clean format
            format = $05b1b40b69b15016$export$1261c7bb3da8241a(format);
            // Get format info (it will also deal with parser caching)
            let info = this.parseFormat(format, this._root.language);
            // format and replace the number
            let details;
            if (source > this.get("negativeBase")) details = info.positive;
            else if (source < this.get("negativeBase")) details = info.negative;
            else details = info.zero;
            // Adjust precision
            if (precision != null && !details.mod) {
                details = $e66f9343b5144e1a$export$784d13d8ee351f07(details);
                details.decimals.active = source == 0 ? 0 : precision;
            }
            // Format
            formatted = details.template.split($f63bdea45a89cf24$export$55fc5ffc49a23c34).join(this.applyFormat(source, details));
        }
        if (this.get("forceLTR") === true) formatted = "\u200E" + formatted;
        return formatted;
    }
    /**
     * Parses supplied format into structured object which can be used to format
     * the number.
     *
     * @param format Format string, i.e. "#,###.00"
     * @param language Language
     * @ignore
     */ parseFormat(format, language) {
        // Check cache
        // TODO
        // let cached = this.getCache(format);
        // if (cached != null) {
        // 	return cached;
        // }
        const thousandSeparator = language.translateEmpty("_thousandSeparator");
        const decimalSeparator = language.translateEmpty("_decimalSeparator");
        // init format parse info holder
        let info = {
            "positive": {
                "thousands": {
                    "active": -1,
                    "passive": -1,
                    "interval": -1,
                    "separator": thousandSeparator
                },
                "decimals": {
                    "active": -1,
                    "passive": -1,
                    "separator": decimalSeparator
                },
                "template": "",
                "source": "",
                "parsed": false
            },
            "negative": {
                "thousands": {
                    "active": -1,
                    "passive": -1,
                    "interval": -1,
                    "separator": thousandSeparator
                },
                "decimals": {
                    "active": -1,
                    "passive": -1,
                    "separator": decimalSeparator
                },
                "template": "",
                "source": "",
                "parsed": false
            },
            "zero": {
                "thousands": {
                    "active": -1,
                    "passive": -1,
                    "interval": -1,
                    "separator": thousandSeparator
                },
                "decimals": {
                    "active": -1,
                    "passive": -1,
                    "separator": decimalSeparator
                },
                "template": "",
                "source": "",
                "parsed": false
            }
        };
        // Escape double vertical bars (that mean display one vertical bar)
        format = format.replace("||", $f63bdea45a89cf24$export$cea82ace3c81ccd9);
        // Split it up and deal with different formats
        let parts = format.split("|");
        info.positive.source = parts[0];
        if (typeof parts[2] === "undefined") info.zero = info.positive;
        else info.zero.source = parts[2];
        if (typeof parts[1] === "undefined") info.negative = info.positive;
        else info.negative.source = parts[1];
        // Parse each
        $e66f9343b5144e1a$export$79b2f7037acddd43(info, (_part, item)=>{
            // Already parsed
            if (item.parsed) return;
            // Check cached
            // TODO
            // if (typeof this.getCache(item.source) !== "undefined") {
            // 	info[part] = this.getCache(item.source);
            // 	return;
            // }
            // Begin parsing
            let partFormat = item.source;
            // Just "Number"?
            if (partFormat.toLowerCase() === "number") partFormat = this.get("numberFormat", "#,###.#####");
            // Let TextFormatter split into chunks
            let chunks = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).chunk(partFormat, true);
            for(let i = 0; i < chunks.length; i++){
                let chunk = chunks[i];
                // replace back double vertical bar
                chunk.text = chunk.text.replace($f63bdea45a89cf24$export$cea82ace3c81ccd9, "|");
                if (chunk.type === "value") {
                    // Parse format
                    // Look for codes
                    let matches = chunk.text.match(/[#0.,]+[ ]?[abespABESP%!]?[abespABESP‰!]?/);
                    if (matches) {
                        if (matches === null || matches[0] === "") // no codes here - assume string
                        // nothing to do here
                        item.template += chunk.text;
                        else {
                            // look for the format modifiers at the end
                            let mods = matches[0].match(/[abespABESP%‰!]{2}|[abespABESP%‰]{1}$/);
                            if (mods) {
                                item.mod = mods[0].toLowerCase();
                                item.modSpacing = matches[0].match(/[ ]{1}[abespABESP%‰!]{1}$/) ? true : false;
                            }
                            // break the format up
                            let a = matches[0].split(".");
                            // Deal with thousands
                            if (a[0] === "") ;
                            else {
                                // Counts
                                item.thousands.active = (a[0].match(/0/g) || []).length;
                                item.thousands.passive = (a[0].match(/\#/g) || []).length + item.thousands.active;
                                // Separator interval
                                let b = a[0].split(",");
                                if (b.length === 1) ;
                                else {
                                    // Use length fo the last chunk as thousands length
                                    item.thousands.interval = (b.pop() || "").length;
                                    if (item.thousands.interval === 0) item.thousands.interval = -1;
                                }
                            }
                            // Deal with decimals
                            if (typeof a[1] === "undefined") ;
                            else {
                                // Counts
                                item.decimals.active = (a[1].match(/0/g) || []).length;
                                item.decimals.passive = (a[1].match(/\#/g) || []).length + item.decimals.active;
                            }
                            // Add special code to template
                            item.template += chunk.text.split(matches[0]).join($f63bdea45a89cf24$export$55fc5ffc49a23c34);
                        }
                    }
                } else // Quoted string - take it as it is
                item.template += chunk.text;
            }
            // Apply style formatting
            //item.template = getTextFormatter().format(item.template, this.outputFormat);
            // Save cache
            // TODO
            //this.setCache(item.source, item);
            // Mark this as parsed
            item.parsed = true;
        });
        // Save cache (the whole thing)
        // TODO
        //this.setCache(format, info);
        return info;
    }
    /**
     * Applies parsed format to a numeric value.
     *
     * @param value    Value
     * @param details  Parsed format as returned by parseFormat()
     * @return Formatted number
     * @ignore
     */ applyFormat(value, details) {
        // Use absolute values
        let negative = value < 0;
        value = Math.abs(value);
        // Recalculate according to modifier
        let prefix = "", suffix = "";
        let mods = details.mod ? details.mod.split("") : [];
        if (mods.indexOf("b") !== -1) {
            let a = this.applyPrefix(value, this.get("bytePrefixes"), mods.indexOf("!") !== -1);
            value = a[0];
            prefix = a[1];
            suffix = a[2];
            if (details.modSpacing) suffix = " " + suffix;
        } else if (mods.indexOf("a") !== -1) {
            let a = this.applyPrefix(value, value < this.get("smallNumberThreshold") ? this.get("smallNumberPrefixes") : this.get("bigNumberPrefixes"), mods.indexOf("!") !== -1);
            value = a[0];
            prefix = a[1];
            suffix = a[2];
            if (details.modSpacing) suffix = " " + suffix;
        } else if (mods.indexOf("p") !== -1) {
            let ol = Math.min(value.toString().length + 2, 21);
            //value *= 100;
            value = parseFloat(value.toPrecision(ol));
            prefix = this._root.language.translate("_percentPrefix");
            suffix = this._root.language.translate("_percentSuffix");
            if (prefix == "" && suffix == "") suffix = "%";
        } else if (mods.indexOf("%") !== -1) {
            let ol = Math.min(value.toString().length + 2, 21);
            value *= 100;
            value = parseFloat(value.toPrecision(ol));
            suffix = "%";
        } else if (mods.indexOf("\u2030") !== -1) {
            let ol = Math.min(value.toString().length + 3, 21);
            value *= 1000;
            value = parseFloat(value.toPrecision(ol));
            suffix = "\u2030";
        }
        // Round to passive
        if (mods.indexOf("e") !== -1) {
            // convert the value to exponential
            let exp;
            if (details.decimals.passive >= 0) exp = value.toExponential(details.decimals.passive).split("e");
            else exp = value.toExponential().split("e");
            value = Number(exp[0]);
            suffix = "e" + exp[1];
            if (details.modSpacing) suffix = " " + suffix;
        } else if (details.decimals.passive === 0) value = Math.round(value);
        else if (details.decimals.passive > 0) {
            const decimals = $05b1b40b69b15016$export$4aa4df8b0f34e5d(value);
            if (decimals > 0) {
                const d = Math.pow(10, details.decimals.passive);
                value = Math.round(parseFloat((value * d).toFixed(decimals))) / d;
            }
        }
        // Init return value
        let res = "";
        // Calc integer and decimal parts
        let a = $f63bdea45a89cf24$export$f67be9d9b0e25d7b(value).split(".");
        // Format integers
        let ints = a[0];
        // Pad integers to active length
        if (ints.length < details.thousands.active) ints = Array(details.thousands.active - ints.length + 1).join("0") + ints;
        // Insert thousands separators
        if (details.thousands.interval > 0) {
            let ip = [];
            let intsr = ints.split("").reverse().join("");
            for(let i = 0, len = ints.length; i <= len; i += details.thousands.interval){
                let c = intsr.substr(i, details.thousands.interval).split("").reverse().join("");
                if (c !== "") ip.unshift(c);
            }
            ints = ip.join(details.thousands.separator);
        }
        // Add integers
        res += ints;
        // Add decimals
        if (a.length === 1) a.push("");
        let decs = a[1];
        // Fill zeros?
        if (decs.length < details.decimals.active) decs += Array(details.decimals.active - decs.length + 1).join("0");
        if (decs !== "") res += details.decimals.separator + decs;
        // Can't have empty return value
        if (res === "") res = "0";
        // Add minus sign back
        if (value !== 0 && negative && mods.indexOf("s") === -1) res = "-" + res;
        // Add suffixes/prefixes
        if (prefix) res = prefix + res;
        if (suffix) res += suffix;
        return res;
    }
    applyPrefix(value, prefixes, force = false) {
        let newvalue = value;
        let prefix = "";
        let suffix = "";
        let applied = false;
        let k = 1;
        for(let i = 0, len = prefixes.length; i < len; i++)if (prefixes[i].number <= value) {
            if (prefixes[i].number === 0) newvalue = 0;
            else {
                newvalue = value / prefixes[i].number;
                k = prefixes[i].number;
            }
            prefix = prefixes[i].prefix;
            suffix = prefixes[i].suffix;
            applied = true;
        }
        if (!applied && force && prefixes.length && value != 0) {
            // Prefix was not applied. Use the first prefix.
            newvalue = value / prefixes[0].number;
            prefix = prefixes[0].prefix;
            suffix = prefixes[0].suffix;
            applied = true;
        }
        if (applied) newvalue = parseFloat(newvalue.toPrecision(Math.min(k.toString().length + Math.floor(newvalue).toString().replace(/[^0-9]*/g, "").length, 21)));
        return [
            newvalue,
            prefix,
            suffix
        ];
    }
    /**
     * Replaces brackets with temporary placeholders.
     *
     * @ignore Exclude from docs
     * @param text  Input text
     * @return Escaped text
     */ escape(text) {
        return text.replace("||", $f63bdea45a89cf24$export$cea82ace3c81ccd9);
    }
    /**
     * Replaces placeholders back to brackets.
     *
     * @ignore Exclude from docs
     * @param text  Escaped text
     * @return Unescaped text
     */ unescape(text) {
        return text.replace($f63bdea45a89cf24$export$cea82ace3c81ccd9, "|");
    }
}




function $3f31d8df1b17230f$var$parseDate(timezone, date) {
    let year = 0;
    let month = 0;
    let day = 1;
    let hour = 0;
    let minute = 0;
    let second = 0;
    let millisecond = 0;
    let weekday = 0;
    timezone.formatToParts(date).forEach((x)=>{
        switch(x.type){
            case "year":
                year = +x.value;
                break;
            case "month":
                month = +x.value - 1;
                break;
            case "day":
                day = +x.value;
                break;
            case "hour":
                hour = +x.value;
                break;
            case "minute":
                minute = +x.value;
                break;
            case "second":
                second = +x.value;
                break;
            case "fractionalSecond":
                millisecond = +x.value;
                break;
            case "weekday":
                switch(x.value){
                    case "Sun":
                        weekday = 0;
                        break;
                    case "Mon":
                        weekday = 1;
                        break;
                    case "Tue":
                        weekday = 2;
                        break;
                    case "Wed":
                        weekday = 3;
                        break;
                    case "Thu":
                        weekday = 4;
                        break;
                    case "Fri":
                        weekday = 5;
                        break;
                    case "Sat":
                        weekday = 6;
                        break;
                }
        }
    });
    if (hour === 24) hour = 0;
    return {
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond,
        weekday: weekday
    };
}
function $3f31d8df1b17230f$var$toUTCDate(timezone, date) {
    const { year: year, month: month, day: day, hour: hour, minute: minute, second: second, millisecond: millisecond } = $3f31d8df1b17230f$var$parseDate(timezone, date);
    return Date.UTC(year, month, day, hour, minute, second, millisecond);
}
class $3f31d8df1b17230f$export$5242477c0ef6dc66 {
    constructor(timezone, isReal){
        if (!isReal) throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
        this.name = timezone;
        this._utc = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: "UTC",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            weekday: "short",
            fractionalSecondDigits: 3
        });
        this._dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            weekday: "short",
            fractionalSecondDigits: 3
        });
    }
    /**
     * Use this method to create an instance of this class.
     *
     * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
     * @param   timezone  IANA timezone
     * @return            Instantiated object
     */ static new(timezone) {
        return new this(timezone, true);
    }
    convertLocal(date) {
        const offset = this.offsetUTC(date);
        const userOffset = date.getTimezoneOffset();
        const output = new Date(date);
        output.setUTCMinutes(output.getUTCMinutes() - (offset - userOffset));
        const newUserOffset = output.getTimezoneOffset();
        if (userOffset != newUserOffset) output.setUTCMinutes(output.getUTCMinutes() + newUserOffset - userOffset);
        return output;
    }
    offsetUTC(date) {
        const utc = $3f31d8df1b17230f$var$toUTCDate(this._utc, date);
        const dtf = $3f31d8df1b17230f$var$toUTCDate(this._dtf, date);
        return (utc - dtf) / 60000;
    }
    parseDate(date) {
        return $3f31d8df1b17230f$var$parseDate(this._dtf, date);
    }
}




class $31c1b4011aa9c6de$export$ad991b66133851cf extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    _setDefaults() {
        // Defaults
        this._setDefault("capitalize", true);
        this._setDefault("dateFormat", "yyyy-MM-dd");
        super._setDefaults();
    }
    _beforeChanged() {
        super._beforeChanged();
    }
    /**
     * Formats a source `Date` object into string format
     * @param   source          inpout date
     * @param   format          Output format
     * @param   ignoreTimezone  Ignore timezone?
     * @return                  Formatted date
     */ format(source, format, ignoreTimezone = false) {
        // Locale?
        // TODO
        // No format passed in or it's empty
        if (typeof format === "undefined" || format === "") format = this.get("dateFormat", "yyyy-MM-dd");
        // Init return value
        let formatted;
        // Cast?
        // TODO: decide if we need to cast
        let date = source;
        // Is it a built-in format or Intl.DateTimeFormat
        if ($f63bdea45a89cf24$export$a6cdc56e425d0d0a(format)) try {
            const locales = this.get("intlLocales");
            if (locales) return new Intl.DateTimeFormat(locales, format).format(date);
            else return new Intl.DateTimeFormat(undefined, format).format(date);
        } catch (e) {
            return "Invalid";
        }
        // get format info (it will also deal with parser caching)
        let info = this.parseFormat(format);
        // Should we apply custom time zone?
        const timezone = this._root.timezone;
        let originalDate = date;
        if (timezone && !this._root.utc && !ignoreTimezone) date = timezone.convertLocal(date);
        // Check if it's a valid date
        if (!$f63bdea45a89cf24$export$7e4aa119212bc614(date.getTime())) // TODO translation
        //return this._t("Invalid date");
        return "Invalid date";
        // Apply format
        formatted = this.applyFormat(date, info, ignoreTimezone, originalDate);
        // Capitalize
        if (this.get("capitalize")) formatted = formatted.replace(/^.{1}/, formatted.substr(0, 1).toUpperCase());
        // We're done
        return formatted;
    }
    /**
     * Applies format to Date.
     *
     * @param date      Date object
     * @param info      Parsed format information
     * @return Formatted date string
     */ applyFormat(date, info, ignoreTimezone = false, originalDate) {
        // Init return value
        let res = info.template;
        // Get values
        let fullYear, month, weekday, day, hours, minutes, seconds, milliseconds, timestamp = date.getTime();
        if (this._root.utc && !ignoreTimezone) {
            fullYear = date.getUTCFullYear();
            month = date.getUTCMonth();
            weekday = date.getUTCDay();
            day = date.getUTCDate();
            hours = date.getUTCHours();
            minutes = date.getUTCMinutes();
            seconds = date.getUTCSeconds();
            milliseconds = date.getUTCMilliseconds();
        } else {
            fullYear = date.getFullYear();
            month = date.getMonth();
            weekday = date.getDay();
            day = date.getDate();
            hours = date.getHours();
            minutes = date.getMinutes();
            seconds = date.getSeconds();
            milliseconds = date.getMilliseconds();
        }
        // Go through each part and format/replace it in template
        for(let i = 0, len = info.parts.length; i < len; i++){
            let value = "";
            switch(info.parts[i]){
                case "G":
                    value = this._t(fullYear < 0 ? "_era_bc" : "_era_ad");
                    break;
                case "yyyy":
                    value = Math.abs(fullYear).toString();
                    if (fullYear < 0) value += this._t("_era_bc");
                    break;
                case "yyy":
                case "yy":
                case "y":
                    value = Math.abs(fullYear).toString().substr(-info.parts[i].length);
                    if (fullYear < 0) value += this._t("_era_bc");
                    break;
                case "YYYY":
                case "YYY":
                case "YY":
                case "Y":
                    let year = $05b1b40b69b15016$export$12d572480ceb6e58(date, this._root.utc);
                    if (info.parts[i] == "YYYY") value = Math.abs(year).toString();
                    else value = Math.abs(year).toString().substr(-info.parts[i].length);
                    if (year < 0) value += this._t("_era_bc");
                    break;
                case "u":
                    break;
                case "q":
                    value = "" + Math.ceil((date.getMonth() + 1) / 3);
                    break;
                case "MMMMM":
                    value = this._t(this._getMonth(month)).substr(0, 1);
                    break;
                case "MMMM":
                    value = this._t(this._getMonth(month));
                    break;
                case "MMM":
                    value = this._t(this._getShortMonth(month));
                    break;
                case "MM":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(month + 1, 2, "0");
                    break;
                case "M":
                    value = (month + 1).toString();
                    break;
                case "ww":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e($05b1b40b69b15016$export$efe19b760242b2fc(date, this._root.utc), 2, "0");
                    break;
                case "w":
                    value = $05b1b40b69b15016$export$efe19b760242b2fc(date, this._root.utc).toString();
                    break;
                case "W":
                    value = $05b1b40b69b15016$export$b533a84e84a6dcfa(date, this._root.utc).toString();
                    break;
                case "dd":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(day, 2, "0");
                    break;
                case "d":
                    value = day.toString();
                    break;
                case "DD":
                case "DDD":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e($05b1b40b69b15016$export$6f157f7a2f040843(date, this._root.utc).toString(), info.parts[i].length, "0");
                    break;
                case "D":
                    value = $05b1b40b69b15016$export$6f157f7a2f040843(date, this._root.utc).toString();
                    break;
                case "F":
                    break;
                case "g":
                    break;
                case "t":
                    value = this._root.language.translateFunc("_dateOrd").call(this, day);
                    break;
                case "E":
                    value = (weekday || 7).toString();
                    break;
                case "EE":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e((weekday || 7).toString(), 2, "0");
                    break;
                case "EEE":
                case "eee":
                    value = this._t(this._getShortWeekday(weekday));
                    break;
                case "EEEE":
                case "eeee":
                    value = this._t(this._getWeekday(weekday));
                    break;
                case "EEEEE":
                case "eeeee":
                    value = this._t(this._getShortWeekday(weekday)).substr(0, 1);
                    break;
                case "e":
                case "ee":
                    value = (weekday - (this._root.locale.firstDayOfWeek || 1) + 1).toString();
                    if (info.parts[i] == "ee") value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(value, 2, "0");
                    break;
                case "a":
                    if (hours >= 12) value = this._t("PM");
                    else value = this._t("AM");
                    break;
                case "aa":
                    if (hours >= 12) value = this._t("P.M.");
                    else value = this._t("A.M.");
                    break;
                case "aaa":
                    if (hours >= 12) value = this._t("P");
                    else value = this._t("A");
                    break;
                case "h":
                    value = $05b1b40b69b15016$export$6ef1a68df5e98f69(hours).toString();
                    break;
                case "hh":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e($05b1b40b69b15016$export$6ef1a68df5e98f69(hours), 2, "0");
                    break;
                case "H":
                    value = hours.toString();
                    break;
                case "HH":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(hours, 2, "0");
                    break;
                case "K":
                    value = $05b1b40b69b15016$export$6ef1a68df5e98f69(hours, 0).toString();
                    break;
                case "KK":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e($05b1b40b69b15016$export$6ef1a68df5e98f69(hours, 0), 2, "0");
                    break;
                case "k":
                    value = (hours + 1).toString();
                    break;
                case "kk":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(hours + 1, 2, "0");
                    break;
                case "m":
                    value = minutes.toString();
                    break;
                case "mm":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(minutes, 2, "0");
                    break;
                case "s":
                    value = seconds.toString();
                    break;
                case "ss":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(seconds, 2, "0");
                    break;
                case "S":
                case "SS":
                case "SSS":
                    value = Math.round(milliseconds / 1000 * Math.pow(10, info.parts[i].length)).toString();
                    break;
                case "x":
                    value = timestamp.toString();
                    break;
                case "n":
                case "nn":
                case "nnn":
                    value = $05b1b40b69b15016$export$e3f9b6bf3780ff6e(milliseconds, info.parts[i].length, "0");
                    break;
                case "z":
                    value = $05b1b40b69b15016$export$c3133dbc11f66777(originalDate || date, false, false, this._root.utc, this._root.timezone ? this._root.timezone.name : undefined).replace(/[+-]+[0-9]+$/, "");
                    break;
                case "zz":
                    value = $05b1b40b69b15016$export$c3133dbc11f66777(originalDate || date, true, false, this._root.utc, this._root.timezone ? this._root.timezone.name : undefined);
                    break;
                case "zzz":
                    value = $05b1b40b69b15016$export$c3133dbc11f66777(originalDate || date, false, true, this._root.utc, this._root.timezone ? this._root.timezone.name : undefined).replace(/[+-]+[0-9]+$/, "");
                    break;
                case "zzzz":
                    value = $05b1b40b69b15016$export$c3133dbc11f66777(originalDate || date, true, true, this._root.utc, this._root.timezone ? this._root.timezone.name : undefined);
                    break;
                case "Z":
                case "ZZ":
                    let timezone = this._root.utc ? "UTC" : this._root.timezone;
                    if (timezone instanceof (0, $3f31d8df1b17230f$export$5242477c0ef6dc66)) timezone = timezone.name;
                    const offset = timezone ? $05b1b40b69b15016$export$4c9db454e2785fd9(timezone, originalDate || date) : date.getTimezoneOffset();
                    let tz = Math.abs(offset) / 60;
                    let tzh = Math.floor(tz);
                    let tzm = tz * 60 - tzh * 60;
                    if (this._root.utc) {
                        tzh = 0;
                        tzm = 0;
                    }
                    if (info.parts[i] == "Z") {
                        value = "GMT";
                        value += offset > 0 ? "-" : "+";
                        value += $05b1b40b69b15016$export$e3f9b6bf3780ff6e(tzh, 2) + ":" + $05b1b40b69b15016$export$e3f9b6bf3780ff6e(tzm, 2);
                    } else {
                        value = offset > 0 ? "-" : "+";
                        value += $05b1b40b69b15016$export$e3f9b6bf3780ff6e(tzh, 2) + $05b1b40b69b15016$export$e3f9b6bf3780ff6e(tzm, 2);
                    }
                    break;
                case "i":
                    value = date.toISOString();
                    break;
                case "I":
                    value = date.toUTCString();
                    break;
            }
            res = res.replace($f63bdea45a89cf24$export$55fc5ffc49a23c34, value);
        }
        return res;
    }
    /**
     * Parses format into structured infromation.
     *
     * @param format Format template
     */ parseFormat(format) {
        // Check cache
        // TODO: implement caching of the parsed format
        // Init format parse info holder
        let info = {
            "template": "",
            "parts": []
        };
        // Let TextFormatter split into chunks
        let chunks = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).chunk(format, true);
        for(let i = 0; i < chunks.length; i++){
            let chunk = chunks[i];
            if (chunk.type === "value") {
                // Just "Date"?
                if (chunk.text.match(/^date$/i)) {
                    let dateFormat = this.get("dateFormat", "yyyy-MM-dd");
                    if (!$f63bdea45a89cf24$export$844ec244b1367d54(dateFormat)) dateFormat = "yyyy-MM-dd";
                    chunk.text = dateFormat;
                }
                // Find all possible parts
                let matches = chunk.text.match(/G|yyyy|yyy|yy|y|YYYY|YYY|YY|Y|u|q|MMMMM|MMMM|MMM|MM|M|ww|w|W|dd|d|DDD|DD|D|F|g|EEEEE|EEEE|EEE|EE|E|eeeee|eeee|eee|ee|e|aaa|aa|a|hh|h|HH|H|KK|K|kk|k|mm|m|ss|s|SSS|SS|S|A|zzzz|zzz|zz|z|ZZ|Z|t|x|nnn|nn|n|i|I/g);
                // Found?
                if (matches) // Populate template
                for(let x = 0; x < matches.length; x++){
                    info.parts.push(matches[x]);
                    chunk.text = chunk.text.replace(matches[x], $f63bdea45a89cf24$export$55fc5ffc49a23c34);
                }
            }
            // Apply to template
            info.template += chunk.text;
        }
        // Save cache
        // TODO
        return info;
    }
    _months() {
        return [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
    }
    _getMonth(index) {
        return this._months()[index];
    }
    _shortMonths() {
        return [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May(short)",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
    }
    _getShortMonth(index) {
        return this._shortMonths()[index];
    }
    _weekdays() {
        return [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
    }
    _getWeekday(index) {
        return this._weekdays()[index];
    }
    _shortWeekdays() {
        return [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ];
    }
    _getShortWeekday(index) {
        return this._shortWeekdays()[index];
    }
    parse(source, format, utc) {
        // If UTC is not supplied, use Root setting
        if (typeof utc === "undefined") utc = this._root.utc;
        // Is it already a Date
        if (source instanceof Date) return source;
        // Is it a numeric timestamp
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(source)) return new Date(source);
        // Are we parsing a timestamp?
        if (format == "x") return new Date(parseInt(source));
        // No? Let's check if it's string, and try converting to it if nec
        if (!$f63bdea45a89cf24$export$844ec244b1367d54(source)) source = source.toString();
        // Init return value
        let res;
        // Init RegEx for parsing
        let reg = "";
        // Clean format
        format = $05b1b40b69b15016$export$1261c7bb3da8241a(format);
        // Clip format to length of the source string
        format = format.substr(0, source.length);
        // Parse format
        let info = this.parseFormat(format);
        // Init parsed items holder
        let parsedIndexes = {
            "year": -1,
            "year3": -1,
            "year2": -1,
            "year1": -1,
            "month": -1,
            "monthShort": -1,
            "monthLong": -1,
            "weekdayShort": -1,
            "weekdayLong": -1,
            "day": -1,
            "yearDay": -1,
            "week": -1,
            "hourBase0": -1,
            "hour12Base0": -1,
            "hourBase1": -1,
            "hour12Base1": -1,
            "minute": -1,
            "second": -1,
            "millisecond": -1,
            "millisecondDigits": -1,
            "am": -1,
            "zone": -1,
            "timestamp": -1,
            "iso": -1
        };
        // Init values
        let resValues = {
            "year": 1970,
            "month": 0,
            "day": 1,
            "hour": 0,
            "minute": 0,
            "second": 0,
            "millisecond": 0,
            "timestamp": null,
            "offset": 0,
            "utc": utc
        };
        // Index adjuster
        let indexAdjust = 0;
        let index = 0;
        // Iterate through all of the parts
        for(let i = 0; i < info.parts.length; i++){
            // Set current match index
            index = i + indexAdjust + 1;
            switch(info.parts[i]){
                case "yyyy":
                case "YYYY":
                    reg += "([0-9]{4})";
                    parsedIndexes.year = index;
                    break;
                case "yyy":
                case "YYY":
                    reg += "([0-9]{3})";
                    parsedIndexes.year3 = index;
                    break;
                case "yy":
                case "YY":
                    reg += "([0-9]{2})";
                    parsedIndexes.year2 = index;
                    break;
                case "y":
                case "Y":
                    reg += "([0-9]{1})";
                    parsedIndexes.year1 = index;
                    break;
                case "MMMM":
                    reg += "(" + this.getStringList(this._months()).join("|") + ")";
                    parsedIndexes.monthLong = index;
                    break;
                case "MMM":
                    reg += "(" + this.getStringList(this._shortMonths()).join("|") + ")";
                    parsedIndexes.monthShort = index;
                    break;
                case "MM":
                case "M":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.month = index;
                    break;
                case "ww":
                case "w":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.week = index;
                    break;
                case "dd":
                case "d":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.day = index;
                    break;
                case "DDD":
                case "DD":
                case "D":
                    reg += "([0-9]{3}|[0-9]{2}|[0-9]{1})";
                    parsedIndexes.yearDay = index;
                    break;
                case "dddd":
                    reg += "(" + this.getStringList(this._weekdays()).join("|") + ")";
                    parsedIndexes.weekdayLong = index;
                    break;
                case "ddd":
                    reg += "(" + this.getStringList(this._shortWeekdays()).join("|") + ")";
                    parsedIndexes.weekdayShort = index;
                    break;
                case "aaa":
                case "aa":
                case "a":
                    // TODO: fix (escape regex)
                    reg += "(" + this.getStringList([
                        "AM",
                        "PM",
                        "A\.M\.",
                        "P\.M\.",
                        "A",
                        "P"
                    ]).join("|") + ")";
                    parsedIndexes.am = index;
                    break;
                case "hh":
                case "h":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.hour12Base1 = index;
                    break;
                case "HH":
                case "H":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.hourBase0 = index;
                    break;
                case "KK":
                case "K":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.hour12Base0 = index;
                    break;
                case "kk":
                case "k":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.hourBase1 = index;
                    break;
                case "mm":
                case "m":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.minute = index;
                    break;
                case "ss":
                case "s":
                    reg += "([0-9]{2}|[0-9]{1})";
                    parsedIndexes.second = index;
                    break;
                case "SSS":
                case "SS":
                case "S":
                    reg += "([0-9]{3}|[0-9]{2}|[0-9]{1})";
                    parsedIndexes.millisecond = index;
                    parsedIndexes.millisecondDigits = info.parts[i].length;
                    break;
                case "nnn":
                case "nn":
                case "n":
                    reg += "([0-9]{3}|[0-9]{2}|[0-9]{1})";
                    parsedIndexes.millisecond = index;
                    break;
                case "x":
                    reg += "([0-9]{1,})";
                    parsedIndexes.timestamp = index;
                    break;
                case "Z":
                    reg += "GMT([-+]+[0-9]{2}:[0-9]{2})";
                    parsedIndexes.zone = index;
                    break;
                case "ZZ":
                    reg += "([\\-+]+[0-9]{2}[0-9]{2})";
                    parsedIndexes.zone = index;
                    break;
                case "i":
                    reg += "([0-9]{4})-?([0-9]{2})-?([0-9]{2})T?([0-9]{2}):?([0-9]{2}):?([0-9]{2})\\.?([0-9]{0,3})([zZ]|[+\\-][0-9]{2}:?[0-9]{2}|$)";
                    parsedIndexes.iso = index;
                    indexAdjust += 7;
                    break;
                case "G":
                case "YYYY":
                case "YYY":
                case "YY":
                case "Y":
                case "MMMMM":
                case "W":
                case "EEEEE":
                case "EEEE":
                case "EEE":
                case "EE":
                case "E":
                case "eeeee":
                case "eeee":
                case "eee":
                case "ee":
                case "e":
                case "zzzz":
                case "zzz":
                case "zz":
                case "z":
                case "t":
                    // Ignore
                    indexAdjust--;
                    break;
            }
            reg += "[^0-9]*";
        }
        // Try matching
        let regex = new RegExp(reg);
        let matches = source.match(regex);
        if (matches) {
            // Populate the date object
            // Full year
            if (parsedIndexes.year > -1) resValues.year = parseInt(matches[parsedIndexes.year]);
            // 3-digit year
            if (parsedIndexes.year3 > -1) {
                let val = parseInt(matches[parsedIndexes.year3]);
                val += 1000;
                resValues.year = val;
            }
            // 2-digit year
            if (parsedIndexes.year2 > -1) {
                let val = parseInt(matches[parsedIndexes.year2]);
                if (val > 50) val += 1000;
                else val += 2000;
                resValues.year = val;
            }
            // 1-digit year
            if (parsedIndexes.year1 > -1) {
                let val = parseInt(matches[parsedIndexes.year1]);
                val = Math.floor(new Date().getFullYear() / 10) * 10 + val;
                resValues.year = val;
            }
            // Full month
            if (parsedIndexes.monthLong > -1) resValues.month = this.resolveMonth(matches[parsedIndexes.monthLong]);
            // Short month
            if (parsedIndexes.monthShort > -1) resValues.month = this.resolveShortMonth(matches[parsedIndexes.monthShort]);
            // Numeric month
            if (parsedIndexes.month > -1) resValues.month = parseInt(matches[parsedIndexes.month]) - 1;
            // Weekday
            // @todo
            // Week
            if (parsedIndexes.week > -1 && parsedIndexes.day === -1) {
                // We parse weeks ONLY if day is not explicitly set
                // TODO: this needs work
                // (but maybe later - I can hardly imagine anyone passing their dates in weeks)
                resValues.month = 0;
                resValues.day = $05b1b40b69b15016$export$c5933b95cf2ffa17(parseInt(matches[parsedIndexes.week]), resValues.year, 1, utc);
            }
            // Day
            if (parsedIndexes.day > -1) resValues.day = parseInt(matches[parsedIndexes.day]);
            // Year day
            if (parsedIndexes.yearDay > -1) {
                resValues.month = 0;
                resValues.day = parseInt(matches[parsedIndexes.yearDay]);
            }
            // 24 Hour (0-23)
            if (parsedIndexes.hourBase0 > -1) resValues.hour = parseInt(matches[parsedIndexes.hourBase0]);
            // 24 Hour (1-24)
            if (parsedIndexes.hourBase1 > -1) resValues.hour = parseInt(matches[parsedIndexes.hourBase1]) - 1;
            // 12 Hour (0-11)
            if (parsedIndexes.hour12Base0 > -1) {
                let val = parseInt(matches[parsedIndexes.hour12Base0]);
                if (val == 11) val = 0;
                if (parsedIndexes.am > -1 && !this.isAm(matches[parsedIndexes.am])) val += 12;
                resValues.hour = val;
            }
            // 12 Hour (1-12)
            if (parsedIndexes.hour12Base1 > -1) {
                let val = parseInt(matches[parsedIndexes.hour12Base1]);
                if (val == 12) val = 0;
                if (parsedIndexes.am > -1 && !this.isAm(matches[parsedIndexes.am])) val += 12;
                resValues.hour = val;
            }
            // Minute
            if (parsedIndexes.minute > -1) resValues.minute = parseInt(matches[parsedIndexes.minute]);
            // Second
            if (parsedIndexes.second > -1) resValues.second = parseInt(matches[parsedIndexes.second]);
            // Millisecond
            if (parsedIndexes.millisecond > -1) {
                let val = parseInt(matches[parsedIndexes.millisecond]);
                if (parsedIndexes.millisecondDigits == 2) val *= 10;
                else if (parsedIndexes.millisecondDigits == 1) val *= 100;
                resValues.millisecond = val;
            }
            // Timestamp
            if (parsedIndexes.timestamp > -1) {
                resValues.timestamp = parseInt(matches[parsedIndexes.timestamp]);
                const ts = new Date(resValues.timestamp);
                resValues.year = ts.getUTCFullYear();
                resValues.month = ts.getUTCMonth();
                resValues.day = ts.getUTCDate();
                resValues.hour = ts.getUTCHours();
                resValues.minute = ts.getUTCMinutes();
                resValues.second = ts.getUTCSeconds();
                resValues.millisecond = ts.getUTCMilliseconds();
            }
            // Adjust time zone
            if (parsedIndexes.zone > -1) resValues.offset = this.resolveTimezoneOffset(new Date(resValues.year, resValues.month, resValues.day), matches[parsedIndexes.zone]);
            // ISO
            if (parsedIndexes.iso > -1) {
                resValues.year = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(matches[parsedIndexes.iso + 0]);
                resValues.month = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(matches[parsedIndexes.iso + 1]) - 1;
                resValues.day = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(matches[parsedIndexes.iso + 2]);
                resValues.hour = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(matches[parsedIndexes.iso + 3]);
                resValues.minute = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(matches[parsedIndexes.iso + 4]);
                resValues.second = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(matches[parsedIndexes.iso + 5]);
                resValues.millisecond = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(matches[parsedIndexes.iso + 6]);
                if (matches[parsedIndexes.iso + 7] == "Z" || matches[parsedIndexes.iso + 7] == "z") resValues.utc = true;
                else if (matches[parsedIndexes.iso + 7] != "") resValues.offset = this.resolveTimezoneOffset(new Date(resValues.year, resValues.month, resValues.day), matches[parsedIndexes.iso + 7]);
            }
            // Create Date object
            if (resValues.utc) res = new Date(Date.UTC(resValues.year, resValues.month, resValues.day, resValues.hour, resValues.minute, resValues.second, resValues.millisecond));
            else res = new Date(resValues.year, resValues.month, resValues.day, resValues.hour, resValues.minute + resValues.offset, resValues.second, resValues.millisecond);
        } else // Didn't match anything
        // Let's try dropping it into Date constructor and hope for the best
        res = new Date(source);
        return res;
    }
    resolveTimezoneOffset(date, zone) {
        let value = zone.match(/([+\-]?)([0-9]{2}):?([0-9]{2})/);
        if (value) {
            let match = zone.match(/([+\-]?)([0-9]{2}):?([0-9]{2})/);
            let dir = match[1];
            let hour = match[2];
            let minute = match[3];
            let offset = parseInt(hour) * 60 + parseInt(minute);
            // Adjust offset
            // Making it negative does not seem to make sense, but it's right
            // because of how JavaScript calculates GMT offsets
            if (dir == "+") offset *= -1;
            // Check the difference in offset
            let originalOffset = (date || new Date()).getTimezoneOffset();
            let diff = offset - originalOffset;
            return diff;
        }
        return 0;
    }
    /**
     * Resolves month name (i.e. "December") into a month number (11).
     *
     * @param value  Month name
     * @return Month number
     */ resolveMonth(value) {
        // Let's try English first
        let month = this._months().indexOf(value);
        if (month > -1) return month;
        // Try the translation
        if (!this._root.language.isDefault()) {
            month = this._root.language.translateAll(this._months()).indexOf(value);
            if (month > -1) return month;
        }
        return 0;
    }
    /**
     * Resolves short month name (i.e. "Dec") into a month number.
     *
     * @param value  Short month name
     * @return Month number
     */ resolveShortMonth(value) {
        // Let's try English first
        let month = this._shortMonths().indexOf(value);
        if (month > -1) return month;
        // Maybe long month (workaround for May)
        month = this._months().indexOf(value);
        if (month > -1) return month;
        // Try the translation
        if (this._root.language && !this._root.language.isDefault()) {
            month = this._root.language.translateAll(this._shortMonths()).indexOf(value);
            if (month > -1) return month;
        }
        return 0;
    }
    /**
     * Checks if passed in string represents AM/PM notation in many of its
     * versions.
     *
     * @param value  Source string
     * @return Is it AM/PM?
     */ isAm(value) {
        let list = this.getStringList([
            "AM",
            "A.M.",
            "A"
        ]);
        return list.indexOf(value.toUpperCase()) > -1;
    }
    /**
     * Translates list of strings.
     *
     * @param list  Source strings
     * @return Translated strings
     */ getStringList(list) {
        let res = [];
        for(let i = 0; i < list.length; i++)// translate?
        if (this._root.language) res.push($05b1b40b69b15016$export$4a325aa52b8c4c19(this._t(list[i])));
        else res.push($05b1b40b69b15016$export$4a325aa52b8c4c19(list[i]));
        return res;
    }
}







class $e14cdfadb6108833$export$cee2d4e6b36ce468 extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    constructor(){
        super(...arguments);
        /**
         * Collection of aliases for units.
         */ this._unitAliases = {
            "Y": "y",
            "D": "d",
            "H": "h",
            "K": "h",
            "k": "h",
            "n": "S"
        };
    }
    _setDefaults() {
        const dmillisecond = "_duration_millisecond";
        const dsecond = "_duration_second";
        const dminute = "_duration_minute";
        const dhour = "_duration_hour";
        const dday = "_duration_day";
        const dweek = "_duration_week";
        const dmonth = "_duration_month";
        const dyear = "_duration_year";
        const asecond = "_second";
        const aminute = "_minute";
        const ahour = "_hour";
        const aday = "_day";
        const aweek = "_week";
        const amonth = "_week";
        const ayear = "_year";
        // Defaults
        this._setDefault("negativeBase", 0);
        this._setDefault("baseUnit", "second");
        this._setDefault("durationFormats", {
            "millisecond": {
                "millisecond": this._t(dmillisecond),
                "second": this._t(dmillisecond + asecond),
                "minute": this._t(dmillisecond + aminute),
                "hour": this._t(dmillisecond + ahour),
                "day": this._t(dmillisecond + aday),
                "week": this._t(dmillisecond + aweek),
                "month": this._t(dmillisecond + amonth),
                "year": this._t(dmillisecond + ayear)
            },
            "second": {
                "second": this._t(dsecond),
                "minute": this._t(dsecond + aminute),
                "hour": this._t(dsecond + ahour),
                "day": this._t(dsecond + aday),
                "week": this._t(dsecond + aweek),
                "month": this._t(dsecond + amonth),
                "year": this._t(dsecond + ayear)
            },
            "minute": {
                "minute": this._t(dminute),
                "hour": this._t(dminute + ahour),
                "day": this._t(dminute + aday),
                "week": this._t(dminute + aweek),
                "month": this._t(dminute + amonth),
                "year": this._t(dminute + ayear)
            },
            "hour": {
                "hour": this._t(dhour),
                "day": this._t(dhour + aday),
                "week": this._t(dhour + aweek),
                "month": this._t(dhour + amonth),
                "year": this._t(dhour + ayear)
            },
            "day": {
                "day": this._t(dday),
                "week": this._t(dday + aweek),
                "month": this._t(dday + amonth),
                "year": this._t(dday + ayear)
            },
            "week": {
                "week": this._t(dweek),
                "month": this._t(dweek + amonth),
                "year": this._t(dweek + ayear)
            },
            "month": {
                "month": this._t(dmonth),
                "year": this._t(dmonth + ayear)
            },
            "year": {
                "year": this._t(dyear)
            }
        });
        super._setDefaults();
    }
    _beforeChanged() {
        super._beforeChanged();
    }
    /**
     * Formats the number as duration.
     *
     * For example `1000` (base unit seconds) would be converted to `16:40` as in
     * 16 minutes and 40 seconds.
     *
     * @param value   Value to format
     * @param format  Format to apply
     * @param base    Override base unit
     * @return Formatted number
     */ format(value, format, base) {
        // no base unit?
        let baseUnit = base || this.get("baseUnit");
        // no format passed in or empty
        if (typeof format === "undefined" || format === "") {
            if (this.get("durationFormat") != null) format = this.get("durationFormat");
            else format = this.getFormat($f63bdea45a89cf24$export$a0a81dc3380ce7d3(value), undefined, baseUnit);
        }
        // Clean format
        format = $05b1b40b69b15016$export$1261c7bb3da8241a(format);
        // get format info (it will also deal with parser caching)
        let info = this.parseFormat(format, baseUnit);
        // cast to number just in case
        // TODO: maybe use better casting
        let source = Number(value);
        // format and replace the number
        let details;
        if (source > this.get("negativeBase")) details = info.positive;
        else if (source < this.get("negativeBase")) details = info.negative;
        else details = info.zero;
        // Format
        let formatted = this.applyFormat(source, details);
        // Apply color?
        if (details.color !== "") formatted = "[" + details.color + "]" + formatted + "[/]";
        return formatted;
    }
    /**
     * Parses supplied format into structured object which can be used to format
     * the number.
     *
     * @param format  Format string, i.e. "#,###.00"
     * @param base    Override base unit
     * @return Parsed information
     */ parseFormat(format, base) {
        // Check cache
        // TODO
        // let cached = this.getCache(format);
        // if (cached != null) {
        // 	return cached;
        // }
        // no base unit?
        let baseUnit = base || this.get("baseUnit");
        // Initialize duration parsing info
        let info = {
            "positive": {
                "color": "",
                "template": "",
                "parts": [],
                "source": "",
                "baseUnit": baseUnit,
                "parsed": false,
                "absolute": false
            },
            "negative": {
                "color": "",
                "template": "",
                "parts": [],
                "source": "",
                "baseUnit": baseUnit,
                "parsed": false,
                "absolute": false
            },
            "zero": {
                "color": "",
                "template": "",
                "parts": [],
                "source": "",
                "baseUnit": baseUnit,
                "parsed": false,
                "absolute": false
            }
        };
        // Escape double vertical bars (that mean display one vertical bar)
        format = format.replace("||", $f63bdea45a89cf24$export$cea82ace3c81ccd9);
        // Split it up and deal with different formats
        let parts = format.split("|");
        info.positive.source = parts[0];
        if (typeof parts[2] === "undefined") info.zero = info.positive;
        else info.zero.source = parts[2];
        if (typeof parts[1] === "undefined") info.negative = info.positive;
        else info.negative.source = parts[1];
        // Parse each
        $e66f9343b5144e1a$export$79b2f7037acddd43(info, (_part, item)=>{
            // Already parsed
            if (item.parsed) return;
            // Check cached
            // TODO
            // if (typeof this.getCache(item.source) !== "undefined") {
            // 	info[part] = this.getCache(item.source);
            // 	return;
            // }
            // Begin parsing
            let partFormat = item.source;
            // Check for [] directives
            let dirs = [];
            dirs = item.source.match(/^\[([^\]]*)\]/);
            if (dirs && dirs.length && dirs[0] !== "") {
                partFormat = item.source.substr(dirs[0].length);
                item.color = dirs[1];
            }
            // Let TextFormatter split into chunks
            let chunks = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).chunk(partFormat, true);
            for(let i = 0; i < chunks.length; i++){
                let chunk = chunks[i];
                // replace back double vertical bar
                chunk.text = chunk.text.replace($f63bdea45a89cf24$export$cea82ace3c81ccd9, "|");
                if (chunk.type === "value") {
                    // Just "Duration"?
                    // if (chunk.text.toLowerCase() === "duration") {
                    // 	chunk.text = durationFormat;
                    // }
                    // Check for "a" (absolute) modifier
                    if (chunk.text.match(/[yYMdDwhHKkmsSn]+a/)) {
                        item.absolute = true;
                        chunk.text = chunk.text.replace(/([yYMdDwhHKkmsSn]+)a/, "$1");
                    }
                    // Find all possible parts
                    let matches = chunk.text.match(/y+|Y+|M+|d+|D+|w+|h+|H+|K+|k+|m+|s+|S+|n+/g);
                    if (matches) // Populate template
                    for(let x = 0; x < matches.length; x++){
                        // Is it an alias?
                        if (matches[x] == null) matches[x] = this._unitAliases[matches[x]];
                        item.parts.push(matches[x]);
                        chunk.text = chunk.text.replace(matches[x], $f63bdea45a89cf24$export$55fc5ffc49a23c34);
                    }
                }
                // Apply to template
                item.template += chunk.text;
            }
            // Apply style formatting
            //item.template = TextFormatter.format(item.template, this.outputFormat);
            // Save cache
            // TODO
            //this.setCache(item.source, item);
            // Mark this as parsed
            item.parsed = true;
        });
        // Save cache (the whole thing)
        // TODO
        //this.setCache(format, info);
        return info;
    }
    /**
     * Applies parsed format to a numeric value.
     *
     * @param value    Value
     * @param details  Parsed format as returned by {parseFormat}
     * @return Formatted duration
     */ applyFormat(value, details) {
        // Use absolute values
        let negative = !details.absolute && value < this.get("negativeBase");
        value = Math.abs(value);
        // Recalculate to milliseconds
        let tstamp = this.toTimeStamp(value, details.baseUnit);
        // Init return value
        let res = details.template;
        const values = {
            millisecond: 0,
            second: 0,
            minute: 0,
            hour: 0,
            day: 0,
            week: 0,
            month: 0,
            year: 0
        };
        // Iterate through duration parts
        for(let i = 0, len = details.parts.length; i < len; i++){
            // Gather the part
            let part = details.parts[i];
            let unit = this._toTimeUnit(part.substr(0, 1));
            // Calculate current unit value
            let ints;
            const unitValue = this._getUnitValue(unit);
            if (i < len - 1) ints = Math.floor(tstamp / unitValue);
            else ints = Math.round(tstamp / unitValue);
            values[unit] += ints;
            // Reduce timestamp
            tstamp -= ints * unitValue;
        }
        // Check if we have full unit that we need to bump up to higher unit
        $e66f9343b5144e1a$export$79b2f7037acddd43(values, (unit, value)=>{
            if (unit == "millisecond" && value == 1000) {
                values["second"]++;
                values["millisecond"] = 0;
            } else if (unit == "second" && value == 60) {
                values["minute"]++;
                values["second"] = 0;
            } else if (unit == "minute" && value == 60) {
                values["hour"]++;
                values["minute"] = 0;
            } else if (unit == "hour" && value == 24) {
                values["day"]++;
                values["hour"] = 0;
            } else if (unit == "day" && value == 7 && details.parts.indexOf("w") !== -1) {
                values["week"]++;
                values["day"] = 0;
            } else if (unit == "day" && value == 30) {
                values["month"]++;
                values["day"] = 0;
            } else if (unit == "month" && value == 12) {
                values["year"]++;
                values["month"] = 0;
            }
        // if (val > 0) {
        // 	res = res.replace($type.PLACEHOLDER, $utils.padString(val, 2, "0"));
        // }
        // else {
        // 	res = res.replace($type.PLACEHOLDER, "");
        // }
        });
        // Iterate again
        for(let i = 0, len = details.parts.length; i < len; i++){
            // Gather the part
            let part = details.parts[i];
            let unit = this._toTimeUnit(part.substr(0, 1));
            let digits = part.length;
            // Calculate current unit value
            res = res.replace($f63bdea45a89cf24$export$55fc5ffc49a23c34, $05b1b40b69b15016$export$e3f9b6bf3780ff6e(values[unit], digits, "0"));
        }
        // Reapply negative sign
        if (negative) res = "-" + res;
        return res;
    }
    /**
     * Converts numeric value to timestamp in milliseconds.
     *
     * @param value     A source value
     * @param baseUnit  Base unit the source value is in: "q", "s", "i", "h", "d", "w", "m", "y"
     * @return Value representation as a timestamp in milliseconds
     */ toTimeStamp(value, baseUnit) {
        return value * this._getUnitValue(baseUnit);
    }
    _toTimeUnit(code) {
        switch(code){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
                return "hour";
            case "d":
                return "day";
            case "w":
                return "week";
            case "M":
                return "month";
            case "y":
                return "year";
        }
    }
    /**
     * Returns appropriate default format for the value.
     *
     * If `maxValue` is sepcified, it will use that value to determine the time
     * unit for the format.
     *
     * For example if your `baseUnit` is `"second"` and you pass in `10`, you
     * will get `"10"`.
     *
     * However, you might want it to be formatted in the context of bigger scale,
     * say 10 minutes (600 seconds). If you pass in `600` as `maxValue`, all
     * values, including small ones will use format with minutes, e.g.:
     * `00:10`, `00:50`, `12: 30`, etc.
     *
     * @param value     Value to format
     * @param maxValue  Maximum value to be used to determine format
     * @param baseUnit  Base unit of the value
     * @return Format
     */ getFormat(value, maxValue, baseUnit) {
        // Is format override set?
        if (this.get("durationFormat") != null) return this.get("durationFormat");
        // Get base unit
        if (!baseUnit) baseUnit = this.get("baseUnit");
        if (maxValue != null && value != maxValue) {
            value = Math.abs(value);
            maxValue = Math.abs(maxValue);
            let maxUnit = this.getValueUnit(Math.max(value, maxValue), baseUnit);
            return this.get("durationFormats")[baseUnit][maxUnit];
        } else {
            let unit = this.getValueUnit(value, baseUnit);
            return this.get("durationFormats")[baseUnit][unit];
        }
    }
    /**
     * Returns value's closest denominator time unit, e.g 100 seconds is
     * `"minute"`, while 59 seconds would still be `second`.
     *
     * @param value     Source duration value
     * @param baseUnit  Base unit
     * @return Denominator
     */ getValueUnit(value, baseUnit) {
        // Get base unit
        if (!baseUnit) baseUnit = this.get("baseUnit");
        // Convert to milliseconds
        let currentUnit;
        let ms = this.getMilliseconds(value, baseUnit);
        $e66f9343b5144e1a$export$1e016427912bfd78(this._getUnitValues(), (key, val)=>{
            if (key == baseUnit || currentUnit) {
                let num = ms / val;
                if (num <= 1) {
                    if (!currentUnit) currentUnit = key;
                    return false;
                }
                currentUnit = key;
            }
            return true;
        });
        return currentUnit;
    }
    /**
     * Converts value to milliseconds according to `baseUnit`.
     *
     * @param value     Source duration value
     * @param baseUnit  Base unit
     * @return Value in milliseconds
     */ getMilliseconds(value, baseUnit) {
        // Get base unit
        if (!baseUnit) baseUnit = this.get("baseUnit");
        return value * this._getUnitValue(baseUnit);
    }
    _getUnitValue(timeUnit) {
        return this._getUnitValues()[timeUnit];
    }
    _getUnitValues() {
        return {
            "millisecond": 1,
            "second": 1000,
            "minute": 60000,
            "hour": 3600000,
            "day": 86400000,
            "week": 604800000,
            "month": 2592000000,
            "year": 31536000000
        };
    }
}





/**
 * amCharts 5 locale
 *
 * Locale: en
 * Language: International English
 * Author: Martynas Majeris
 *
 * Follow instructions in [on this page](https://www.amcharts.com/docs/v5/tutorials/creating-translations/) to make corrections or add new translations.
 *
 * ---
 * Edit but leave the header section above this line. You can remove any
 * subsequent comment sections.
 * ---
 *
 * Use this file as a template to create translations. Leave the key part in
 * English intact. Fill the value with a translation.
 *
 * Empty string means no translation, so default "International English"
 * will be used.
 *
 * If you need the translation to literally be an empty string, use `null`
 * instead.
 *
 * IMPORTANT:
 * When translating make good effort to keep the translation length
 * at least the same chartcount as the English, especially for short prompts.
 *
 * Having significantly longer prompts may distort the actual charts.
 *
 * NOTE:
 * Some prompts - like months or weekdays - come in two versions: full and
 * shortened.
 *
 * If there's no official shortened version of these in your language, and it
 * would not be possible to invent such short versions that don't seem weird
 * to native speakers of that language, fill those with the same as full
 * version.
 *
 * PLACEHOLDERS:
 * Some prompts have placeholders like "%1". Those will be replaced by actual
 * values during translation and should be retained in the translated prompts.
 *
 * Placeholder positions may be changed to better suit structure of the
 * sentence.
 *
 * For example "From %1 to %2", when actually used will replace "%1" with an
 * actual value representing range start, and "%2" will be replaced by end
 * value.
 *
 * E.g. in a Scrollbar for Value axis "From %1 to %2" will become
 * "From 100 to 200". You may translate "From" and "to", as well as re-arrange
 * the order of the prompt itself, but make sure the "%1" and "%2" remain, in
 * places where they will make sense.
 *
 * Save the file as language_LOCALE, i.e. `en_GB.ts`, `fr_FR.ts`, etc.
 */ var $8ced240747ebccef$export$2e2bcd8739ae039 = {
    "firstDayOfWeek": 1,
    // Number formatting options.
    // 
    // Please check with the local standards which separator is accepted to be
    // used for separating decimals, and which for thousands.
    "_decimalSeparator": ".",
    "_thousandSeparator": ",",
    // Position of the percent sign in numbers
    "_percentPrefix": null,
    "_percentSuffix": "%",
    // Suffixes for numbers
    // When formatting numbers, big or small numers might be reformatted to
    // shorter version, by applying a suffix.
    // 
    // For example, 1000000 might become "1m".
    // Or 1024 might become "1KB" if we're formatting byte numbers.
    // 
    // This section defines such suffixes for all such cases.
    "_big_number_suffix_3": "k",
    "_big_number_suffix_6": "M",
    "_big_number_suffix_9": "G",
    "_big_number_suffix_12": "T",
    "_big_number_suffix_15": "P",
    "_big_number_suffix_18": "E",
    "_big_number_suffix_21": "Z",
    "_big_number_suffix_24": "Y",
    "_small_number_suffix_3": "m",
    "_small_number_suffix_6": "\u03BC",
    "_small_number_suffix_9": "n",
    "_small_number_suffix_12": "p",
    "_small_number_suffix_15": "f",
    "_small_number_suffix_18": "a",
    "_small_number_suffix_21": "z",
    "_small_number_suffix_24": "y",
    "_byte_suffix_B": "B",
    "_byte_suffix_KB": "KB",
    "_byte_suffix_MB": "MB",
    "_byte_suffix_GB": "GB",
    "_byte_suffix_TB": "TB",
    "_byte_suffix_PB": "PB",
    // Default date formats for various periods.
    // 
    // This should reflect official or de facto formatting universally accepted
    // in the country translation is being made for
    // Available format codes here:
    // https://www.amcharts.com/docs/v5/concepts/formatters/formatting-dates/#Format_codes
    // 
    // This will be used when formatting date/time for particular granularity,
    // e.g. "_date_hour" will be shown whenever we need to show time as hours.
    // 
    // "date" is used as in default date format when showing standalone dates.
    "_date": "yyyy-MM-dd",
    "_date_millisecond": "mm:ss SSS",
    "_date_millisecond_full": "HH:mm:ss SSS",
    "_date_second": "HH:mm:ss",
    "_date_second_full": "HH:mm:ss",
    "_date_minute": "HH:mm",
    "_date_minute_full": "HH:mm - MMM dd, yyyy",
    "_date_hour": "HH:mm",
    "_date_hour_short": "HH",
    "_date_hour_full": "HH:mm - MMM dd, yyyy",
    "_date_day": "MMM dd",
    "_date_day_full": "MMM dd, yyyy",
    "_date_week": "ww",
    "_date_week_full": "MMM dd, yyyy",
    "_date_month": "MMM",
    "_date_month_full": "MMM, yyyy",
    "_date_year": "yyyy",
    // Default duration formats for various base units.
    // 
    // This will be used by DurationFormatter to format numeric values into
    // duration.
    // 
    // Notice how each duration unit comes in several versions. This is to ensure
    // that each base unit is shown correctly.
    // 
    // For example, if we have baseUnit set to "second", meaning our duration is
    // in seconds.
    // 
    // If we pass in `50` to formatter, it will know that we have just 50 seconds
    // (less than a minute) so it will use format in `"_duration_second"` ("ss"),
    // and the formatted result will be in like `"50"`.
    // 
    // If we pass in `70`, which is more than a minute, the formatter will switch
    // to `"_duration_second_minute"` ("mm:ss"), resulting in "01:10" formatted
    // text.
    // 
    // Available codes here:
    // https://www.amcharts.com/docs/v4/concepts/formatters/formatting-duration/#Available_Codes
    "_duration_millisecond": "SSS",
    "_duration_millisecond_second": "ss.SSS",
    "_duration_millisecond_minute": "mm:ss SSS",
    "_duration_millisecond_hour": "hh:mm:ss SSS",
    "_duration_millisecond_day": "d'd' mm:ss SSS",
    "_duration_millisecond_week": "d'd' mm:ss SSS",
    "_duration_millisecond_month": "M'm' dd'd' mm:ss SSS",
    "_duration_millisecond_year": "y'y' MM'm' dd'd' mm:ss SSS",
    "_duration_second": "ss",
    "_duration_second_minute": "mm:ss",
    "_duration_second_hour": "hh:mm:ss",
    "_duration_second_day": "d'd' hh:mm:ss",
    "_duration_second_week": "d'd' hh:mm:ss",
    "_duration_second_month": "M'm' dd'd' hh:mm:ss",
    "_duration_second_year": "y'y' MM'm' dd'd' hh:mm:ss",
    "_duration_minute": "mm",
    "_duration_minute_hour": "hh:mm",
    "_duration_minute_day": "d'd' hh:mm",
    "_duration_minute_week": "d'd' hh:mm",
    "_duration_minute_month": "M'm' dd'd' hh:mm",
    "_duration_minute_year": "y'y' MM'm' dd'd' hh:mm",
    "_duration_hour": "hh'h'",
    "_duration_hour_day": "d'd' hh'h'",
    "_duration_hour_week": "d'd' hh'h'",
    "_duration_hour_month": "M'm' dd'd' hh'h'",
    "_duration_hour_year": "y'y' MM'm' dd'd' hh'h'",
    "_duration_day": "d'd'",
    "_duration_day_week": "d'd'",
    "_duration_day_month": "M'm' dd'd'",
    "_duration_day_year": "y'y' MM'm' dd'd'",
    "_duration_week": "w'w'",
    "_duration_week_month": "w'w'",
    "_duration_week_year": "w'w'",
    "_duration_month": "M'm'",
    "_duration_month_year": "y'y' MM'm'",
    "_duration_year": "y'y'",
    // Era translations
    "_era_ad": "AD",
    "_era_bc": "BC",
    // Day part, used in 12-hour formats, e.g. 5 P.M.
    // Please note that these come in 3 variants:
    // * one letter (e.g. "A")
    // * two letters (e.g. "AM")
    // * two letters with dots (e.g. "A.M.")
    // 
    // All three need to to be translated even if they are all the same. Some
    // users might use one, some the other.
    "A": "",
    "P": "",
    "AM": "",
    "PM": "",
    "A.M.": "",
    "P.M.": "",
    // Date-related stuff.
    // 
    // When translating months, if there's a difference, use the form which is
    // best for a full date, e.g. as you would use it in "2018 January 1".
    // 
    // Note that May is listed twice. This is because in English May is the same
    // in both long and short forms, while in other languages it may not be the
    // case. Translate "May" to full word, while "May(short)" to shortened
    // version.
    // 
    // Should month names and weekdays be capitalized or not?
    // 
    // Rule of thumb is this: if the names should always be capitalized,
    // regardless of name position within date ("January", "21st January 2018",
    // etc.) use capitalized names. Otherwise enter all lowercase.
    // 
    // The date formatter will automatically capitalize names if they are the
    // first (or only) word in resulting date.
    "January": "",
    "February": "",
    "March": "",
    "April": "",
    "May": "",
    "June": "",
    "July": "",
    "August": "",
    "September": "",
    "October": "",
    "November": "",
    "December": "",
    "Jan": "",
    "Feb": "",
    "Mar": "",
    "Apr": "",
    "May(short)": "May",
    "Jun": "",
    "Jul": "",
    "Aug": "",
    "Sep": "",
    "Oct": "",
    "Nov": "",
    "Dec": "",
    // Weekdays.
    "Sunday": "",
    "Monday": "",
    "Tuesday": "",
    "Wednesday": "",
    "Thursday": "",
    "Friday": "",
    "Saturday": "",
    "Sun": "",
    "Mon": "",
    "Tue": "",
    "Wed": "",
    "Thu": "",
    "Fri": "",
    "Sat": "",
    // Date ordinal function.
    // 
    // This is used when adding number ordinal when formatting days in dates.
    // 
    // E.g. "January 1st", "February 2nd".
    // 
    // The function accepts day number, and returns a string to be added to the
    // day, like in default English translation, if we pass in 2, we will receive
    // "nd" back.
    "_dateOrd": function(day) {
        let res = "th";
        if (day < 11 || day > 13) switch(day % 10){
            case 1:
                res = "st";
                break;
            case 2:
                res = "nd";
                break;
            case 3:
                res = "rd";
                break;
        }
        return res;
    },
    // Various chart controls.
    // Shown as a tooltip on zoom out button.
    "Zoom Out": "",
    // Timeline buttons
    "Play": "",
    "Stop": "",
    // Chart's Legend screen reader title.
    "Legend": "",
    // Legend's item screen reader indicator.
    "Press ENTER to toggle": "",
    // Shown when the chart is busy loading something.
    "Loading": "",
    // Shown as the first button in the breadcrumb navigation, e.g.:
    // Home > First level > ...
    "Home": "",
    // Chart types.
    // Those are used as default screen reader titles for the main chart element
    // unless developer has set some more descriptive title.
    "Chart": "",
    "Serial chart": "",
    "X/Y chart": "",
    "Pie chart": "",
    "Gauge chart": "",
    "Radar chart": "",
    "Sankey diagram": "",
    "Flow diagram": "",
    "Chord diagram": "",
    "TreeMap chart": "",
    "Force directed tree": "",
    "Sliced chart": "",
    // Series types.
    // Used to name series by type for screen readers if they do not have their
    // name set.
    "Series": "",
    "Candlestick Series": "",
    "OHLC Series": "",
    "Column Series": "",
    "Line Series": "",
    "Pie Slice Series": "",
    "Funnel Series": "",
    "Pyramid Series": "",
    "X/Y Series": "",
    // Map-related stuff.
    "Map": "",
    "Press ENTER to zoom in": "",
    "Press ENTER to zoom out": "",
    "Use arrow keys to zoom in and out": "",
    "Use plus and minus keys on your keyboard to zoom in and out": "",
    // Export-related stuff.
    // These prompts are used in Export menu labels.
    // 
    // "Export" is the top-level menu item.
    // 
    // "Image", "Data", "Print" as second-level indicating type of export
    // operation.
    // 
    // Leave actual format untranslated, unless you absolutely know that they
    // would convey more meaning in some other way.
    "Export": "",
    "Image": "",
    "Data": "",
    "Print": "",
    "Press ENTER or use arrow keys to navigate": "",
    "Press ENTER to open": "",
    "Press ENTER to print.": "",
    "Press ENTER to export as %1.": "",
    "(Press ESC to close this message)": "",
    "Image Export Complete": "",
    "Export operation took longer than expected. Something might have gone wrong.": "",
    "Saved from": "",
    "PNG": "",
    "JPG": "",
    "GIF": "",
    "SVG": "",
    "PDF": "",
    "JSON": "",
    "CSV": "",
    "XLSX": "",
    "HTML": "",
    // Scrollbar-related stuff.
    // 
    // Scrollbar is a control which can zoom and pan the axes on the chart.
    // 
    // Each scrollbar has two grips: left or right (for horizontal scrollbar) or
    // upper and lower (for vertical one).
    // 
    // Prompts change in relation to whether Scrollbar is vertical or horizontal.
    // 
    // The final section is used to indicate the current range of selection.
    "Use TAB to select grip buttons or left and right arrows to change selection": "",
    "Use left and right arrows to move selection": "",
    "Use left and right arrows to move left selection": "",
    "Use left and right arrows to move right selection": "",
    "Use TAB select grip buttons or up and down arrows to change selection": "",
    "Use up and down arrows to move selection": "",
    "Use up and down arrows to move lower selection": "",
    "Use up and down arrows to move upper selection": "",
    "From %1 to %2": "",
    "From %1": "",
    "To %1": "",
    // Data loader-related.
    "No parser available for file: %1": "",
    "Error parsing file: %1": "",
    "Unable to load file: %1": "",
    "Invalid date": "",
    // Common actions
    "Close": "",
    "Minimize": "",
    "Confirm": ""
};


class $a5f7473fad5303dc$export$ce4fe1c9e6520c1a extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    _setDefaults() {
        this.setPrivate("defaultLocale", (0, $8ced240747ebccef$export$2e2bcd8739ae039));
        super._setDefaults();
    }
    /**
     * Returns a prompt translation.
     *
     * @param   prompt   Prompt to translate
     * @param   locale   Target locale
     * @param   ...rest  Parameters
     * @return           Translation
     */ translate(prompt, locale, ...rest) {
        // Get langauge
        if (!locale) locale = this._root.locale || this.getPrivate("defaultLocale");
        // Init translation
        let translation = prompt;
        let value = locale[prompt];
        // Try to look for the translation
        if (value === null) translation = "";
        else if (value != null) // It might be an empty string
        {
            if (value) translation = value;
        } else if (locale !== this.getPrivate("defaultLocale")) // Try to look in default language
        return this.translate(prompt, this.getPrivate("defaultLocale"), ...rest);
        // Replace %1, %2, etc params
        if (rest.length) for(let len = rest.length, i = 0; i < len; ++i)translation = translation.split("%" + (i + 1)).join(rest[i]);
        // Return the translation
        return translation;
    }
    /**
     * Returns a prompt translation, including custom prompts.
     *
     * @param   prompt   Prompt to translate
     * @param   locale   Target locale
     * @param   ...rest  Parameters
     * @return           Translation
     */ translateAny(prompt, locale, ...rest) {
        return this.translate(prompt, locale, ...rest);
    }
    /**
     * Add a custom prompt to locale.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/locales/creating-translations/#Extending_locale_with_custom_prompts}
     * @param  prompt       Source prompt
     * @param  translation  Tanslation
     * @param  locale       Target locale
     */ setTranslationAny(prompt, translation, locale) {
        const localeTarget = locale || this._root.locale;
        localeTarget[prompt] = translation;
    }
    /**
     * Add a batch of custom prompts.
     *
     * @since 5.3.3
     * @see {@link https://www.amcharts.com/docs/v5/concepts/locales/creating-translations/#Extending_locale_with_custom_prompts}
     * @param  translations  Translations
     * @param  locale        Target locale
     */ setTranslationsAny(translations, locale) {
        $e66f9343b5144e1a$export$79b2f7037acddd43(translations, (key, val)=>{
            this.setTranslationAny(key, val, locale);
        });
    }
    translateEmpty(prompt, locale, ...rest) {
        let translation = this.translate(prompt, locale, ...rest);
        return translation == prompt ? "" : translation;
    }
    translateFunc(prompt, locale) {
        if (this._root.locale[prompt]) return this._root.locale[prompt];
        // Try to look in default language
        if (locale !== this.getPrivate("defaultLocale")) return this.translateFunc(prompt, this.getPrivate("defaultLocale"));
        // Fail - return empty function
        return ()=>{
            return "";
        };
    }
    /**
     * Translates a btach of prompts.
     *
     * @param  list    Array of prompts to translate
     * @param  locale  Target locale
     * @return         Array of translations
     */ translateAll(list, locale) {
        // Translate all items in the list
        if (!this.isDefault()) return $2f30431acd054e2f$export$871de8747c9eaa88(list, (x)=>this.translate(x, locale));
        else return list;
    }
    /**
     * Returns `true` if the currently selected locale is a default locale.
     *
     * @return `true` if locale is default; `false` if it is not.
     */ isDefault() {
        return this.getPrivate("defaultLocale") === this._root.locale;
    }
}






class $a953e95d35d4141a$export$14faa19a0f3bbeb2 {
    constructor(root, isReal){
        this._rules = {};
        this._root = root;
        if (!isReal) throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
    }
    /**
     * Use this method to create an instance of this class.
     *
     * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
     * @param   root      Root element
     * @param   settings  Settings
     * @param   template  Template
     * @return            Instantiated object
     */ static new(root) {
        const x = new this(root, true);
        x.setupDefaultRules();
        return x;
    }
    setupDefaultRules() {}
    /**
     * Looks up the rules for a specific theme class.
     *
     * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
     * @param   themeClass Theme class
     * @return             Array<IRule<A>>
     */ _lookupRules(themeClass) {
        return this._rules[themeClass];
    }
    /**
     * Creates a [[Template]] for specific theme class and tags.
     *
     * NOTE: the difference from `rule()` is that `ruleRaw()` does not do any
     * type checks.
     *
     * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
     * @param   themeClass Theme class
     * @param   themeTags  Theme tags
     * @return             Template
     */ ruleRaw(themeClass, themeTags = []) {
        let rules = this._rules[themeClass];
        if (!rules) rules = this._rules[themeClass] = [];
        themeTags.sort($919e90129af4490b$export$398604a469f7de9a);
        const { index: index, found: found } = $2f30431acd054e2f$export$5637f53fe994488d(rules, (x)=>{
            const order = $919e90129af4490b$export$398604a469f7de9a(x.tags.length, themeTags.length);
            if (order === 0) return $919e90129af4490b$export$cb07857b027678fa(x.tags, themeTags, $919e90129af4490b$export$398604a469f7de9a);
            else return order;
        });
        if (found) return rules[index].template;
        else {
            const template = (0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new({});
            rules.splice(index, 0, {
                tags: themeTags,
                template: template
            });
            return template;
        }
    }
    /**
     * Creates a [[Template]] for specific theme class and tags.
     *
     * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
     * @param   themeClass Theme class
     * @param   themeTags  Theme tags
     * @return             Template
     */ rule(themeClass, themeTags = []) {
        return this.ruleRaw(themeClass, themeTags);
    }
}







function $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, key, ic, name) {
    // TODO this shouldn't use get, figure out a better way
    rule.set(key, ic.get(name));
    ic.on(name, (value)=>{
        rule.set(key, value);
    });
}
class $c53b0c859cf33b39$export$48bc85c4a6e4243b extends (0, $a953e95d35d4141a$export$14faa19a0f3bbeb2) {
    setupDefaultRules() {
        super.setupDefaultRules();
        const language = this._root.language;
        const ic = this._root.interfaceColors;
        const horizontalLayout = this._root.horizontalLayout;
        const verticalLayout = this._root.verticalLayout;
        const r = this.rule.bind(this);
        /**
         * ========================================================================
         * core
         * ========================================================================
         */ r("InterfaceColors").setAll({
            stroke: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xe5e5e5),
            fill: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xf3f3f3),
            primaryButton: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x6794dc),
            primaryButtonHover: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x6771dc),
            primaryButtonDown: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x68dc76),
            primaryButtonActive: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x68dc76),
            primaryButtonDisabled: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xdadada),
            primaryButtonTextDisabled: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xffffff),
            primaryButtonText: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xffffff),
            primaryButtonStroke: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xffffff),
            secondaryButton: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xd9d9d9),
            secondaryButtonHover: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xa3a3a3),
            secondaryButtonDown: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x8d8d8d),
            secondaryButtonActive: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xe6e6e6),
            secondaryButtonText: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000),
            secondaryButtonStroke: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xffffff),
            grid: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000),
            background: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xffffff),
            alternativeBackground: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000),
            text: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000),
            alternativeText: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xffffff),
            disabled: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xadadad),
            positive: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x50b300),
            negative: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xb30000)
        });
        {
            const rule = r("ColorSet");
            rule.setAll({
                passOptions: {
                    hue: 0.05,
                    saturation: 0,
                    lightness: 0
                },
                colors: [
                    (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x67b7dc)
                ],
                step: 1,
                //baseColor: Color.fromRGB(103, 183, 220),
                //count: 20,
                reuse: false,
                startIndex: 0
            });
            rule.setPrivate("currentStep", 0);
            rule.setPrivate("currentPass", 0);
        }
        r("Entity").setAll({
            stateAnimationDuration: 0,
            stateAnimationEasing: $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7($b4231ef84a5f8a61$export$bdd5293f3cf7a909)
        });
        r("Component").setAll({
            interpolationDuration: 0,
            interpolationEasing: $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7($b4231ef84a5f8a61$export$bdd5293f3cf7a909)
        });
        r("Sprite").setAll({
            visible: true,
            scale: 1,
            opacity: 1,
            rotation: 0,
            position: "relative",
            tooltipX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            tooltipY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            tooltipPosition: "fixed",
            isMeasured: true
        });
        r("Sprite").states.create("default", {
            "visible": true,
            opacity: 1
        });
        r("Container").setAll({
            interactiveChildren: true,
            setStateOnChildren: false
        });
        r("Graphics").setAll({
            strokeWidth: 1
        });
        r("Chart").setAll({
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            interactiveChildren: false
        });
        r("ZoomableContainer").setAll({
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            wheelable: true,
            pinchZoom: true,
            maxZoomLevel: 32,
            minZoomLevel: 1,
            zoomStep: 2,
            animationEasing: $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7($b4231ef84a5f8a61$export$bdd5293f3cf7a909),
            animationDuration: 600,
            maxPanOut: 0.4
        });
        r("ZoomableContainer", [
            "serialchartcontainer"
        ]).setAll({
            wheelable: false,
            pinchZoom: false,
            maskContent: true
        });
        /**
         * ------------------------------------------------------------------------
         * core: alignment
         * ------------------------------------------------------------------------
         */ r("Sprite", [
            "horizontal",
            "center"
        ]).setAll({
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            x: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72)
        });
        r("Sprite", [
            "vertical",
            "center"
        ]).setAll({
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72)
        });
        r("Container", [
            "horizontal",
            "layout"
        ]).setAll({
            layout: horizontalLayout
        });
        r("Container", [
            "vertical",
            "layout"
        ]).setAll({
            layout: verticalLayout
        });
        /**
         * ------------------------------------------------------------------------
         * core: patterns
         * ------------------------------------------------------------------------
         */ r("Pattern").setAll({
            repetition: "repeat",
            width: 50,
            height: 50,
            rotation: 0,
            fillOpacity: 1
        });
        r("LinePattern").setAll({
            gap: 6,
            colorOpacity: 1,
            width: 49,
            height: 49
        });
        r("RectanglePattern").setAll({
            gap: 6,
            checkered: false,
            centered: true,
            maxWidth: 5,
            maxHeight: 5,
            width: 48,
            height: 48,
            strokeWidth: 0
        });
        r("CirclePattern").setAll({
            gap: 5,
            checkered: false,
            centered: false,
            radius: 3,
            strokeWidth: 0,
            width: 45,
            height: 45
        });
        r("GrainPattern").setAll({
            width: 200,
            height: 200,
            colors: [
                (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000)
            ],
            size: 1,
            horizontalGap: 0,
            verticalGap: 0,
            density: 1,
            minOpacity: 0,
            maxOpacity: 0.2
        });
        {
            const rule = r("PatternSet");
            rule.setAll({
                step: 1
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "color", ic, "stroke");
        }
        /**
         * ------------------------------------------------------------------------
         * core: gradients
         * ------------------------------------------------------------------------
         */ r("LinearGradient").setAll({
            rotation: 90
        });
        /**
         * ------------------------------------------------------------------------
         * core: Legend
         * ------------------------------------------------------------------------
         */ r("Legend").setAll({
            fillField: "fill",
            strokeField: "stroke",
            nameField: "name",
            layout: (0, $9961b4caf46ffbfc$export$7d2b12578154a735).new(this._root, {}),
            layer: 30,
            clickTarget: "itemContainer"
        });
        // Class: Container
        r("Container", [
            "legend",
            "item",
            "itemcontainer"
        ]).setAll({
            paddingLeft: 5,
            paddingRight: 5,
            paddingBottom: 5,
            paddingTop: 5,
            layout: horizontalLayout,
            setStateOnChildren: true,
            interactiveChildren: false,
            ariaChecked: true,
            focusable: true,
            ariaLabel: language.translate("Press ENTER to toggle"),
            role: "checkbox"
        });
        {
            const rule = r("Rectangle", [
                "legend",
                "item",
                "background"
            ]);
            rule.setAll({
                fillOpacity: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "background");
        }
        r("Container", [
            "legend",
            "marker"
        ]).setAll({
            setStateOnChildren: true,
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingTop: 0,
            width: 18,
            height: 18
        });
        r("RoundedRectangle", [
            "legend",
            "marker",
            "rectangle"
        ]).setAll({
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            cornerRadiusBL: 3,
            cornerRadiusTL: 3,
            cornerRadiusBR: 3,
            cornerRadiusTR: 3
        });
        {
            const rule = r("RoundedRectangle", [
                "legend",
                "marker",
                "rectangle"
            ]).states.create("disabled", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "disabled");
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "disabled");
        }
        r("Label", [
            "legend",
            "label"
        ]).setAll({
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            marginLeft: 5,
            paddingRight: 0,
            paddingLeft: 0,
            paddingTop: 0,
            paddingBottom: 0,
            populateText: true
        });
        {
            const rule = r("Label", [
                "legend",
                "label"
            ]).states.create("disabled", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "disabled");
        }
        r("Label", [
            "legend",
            "value",
            "label"
        ]).setAll({
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            marginLeft: 5,
            paddingRight: 0,
            paddingLeft: 0,
            paddingTop: 0,
            paddingBottom: 0,
            width: 50,
            centerX: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            populateText: true
        });
        {
            const rule = r("Label", [
                "legend",
                "value",
                "label"
            ]).states.create("disabled", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "disabled");
        }
        /**
         * ------------------------------------------------------------------------
         * core: HeatLegend
         * ------------------------------------------------------------------------
         */ r("HeatLegend").setAll({
            stepCount: 1
        });
        r("RoundedRectangle", [
            "heatlegend",
            "marker"
        ]).setAll({
            cornerRadiusTR: 0,
            cornerRadiusBR: 0,
            cornerRadiusTL: 0,
            cornerRadiusBL: 0
        });
        r("RoundedRectangle", [
            "vertical",
            "heatlegend",
            "marker"
        ]).setAll({
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            width: 15
        });
        r("RoundedRectangle", [
            "horizontal",
            "heatlegend",
            "marker"
        ]).setAll({
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: 15
        });
        r("HeatLegend", [
            "vertical"
        ]).setAll({
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("HeatLegend", [
            "horizontal"
        ]).setAll({
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("Label", [
            "heatlegend",
            "start"
        ]).setAll({
            paddingLeft: 5,
            paddingRight: 5,
            paddingTop: 5,
            paddingBottom: 5
        });
        r("Label", [
            "heatlegend",
            "end"
        ]).setAll({
            paddingLeft: 5,
            paddingRight: 5,
            paddingTop: 5,
            paddingBottom: 5
        });
        /**
         * ------------------------------------------------------------------------
         * core: Labels
         * ------------------------------------------------------------------------
         */ {
            const rule = r("Label");
            rule.setAll({
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 10,
                paddingRight: 10,
                fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
                fontSize: "1em",
                populateText: false
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "text");
        }
        r("RadialLabel").setAll({
            textType: "regular",
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            inside: false,
            radius: 0,
            baseRadius: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            orientation: "auto",
            textAlign: "center"
        });
        r("EditableLabel").setAll({
            editOn: "click",
            //setStateOnChildren: true,
            themeTags: [
                "editablelabel"
            ],
            multiLine: true
        });
        r("RoundedRectangle", [
            "editablelabel",
            "background"
        ]).setAll({
            fillOpacity: 0,
            fill: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000),
            cornerRadiusBL: 3,
            cornerRadiusBR: 3,
            cornerRadiusTL: 3,
            cornerRadiusTR: 3,
            strokeOpacity: 0,
            stroke: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000)
        });
        r("RoundedRectangle", [
            "editablelabel",
            "background"
        ]).states.create("active", {
            strokeOpacity: 0.2
        });
        /**
         * ------------------------------------------------------------------------
         * core: Elements and shapes
         * ------------------------------------------------------------------------
         */ r("RoundedRectangle").setAll({
            cornerRadiusTL: 8,
            cornerRadiusBL: 8,
            cornerRadiusTR: 8,
            cornerRadiusBR: 8
        });
        r("PointedRectangle").setAll({
            pointerBaseWidth: 15,
            pointerLength: 10,
            cornerRadius: 8
        });
        r("Slice").setAll({
            shiftRadius: 0,
            dRadius: 0,
            dInnerRadius: 0
        });
        {
            const rule = r("Tick");
            rule.setAll({
                strokeOpacity: .15,
                isMeasured: false,
                length: 4.5,
                position: "absolute",
                crisp: true
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "grid");
        }
        r("Bullet").setAll({
            locationX: 0.5,
            locationY: 0.5
        });
        /**
         * ------------------------------------------------------------------------
         * core: Tooltip
         * ------------------------------------------------------------------------
         */ r("Tooltip").setAll({
            position: "absolute",
            getFillFromSprite: true,
            getStrokeFromSprite: false,
            autoTextColor: true,
            paddingTop: 9,
            paddingBottom: 8,
            paddingLeft: 10,
            paddingRight: 10,
            marginBottom: 5,
            pointerOrientation: "vertical",
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            animationEasing: $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7($b4231ef84a5f8a61$export$bdd5293f3cf7a909),
            exportable: false
        });
        // system tooltip
        r("Tooltip", [
            "system"
        ]).setAll({
            pointerOrientation: "horizontal",
            paddingTop: 4,
            paddingRight: 7,
            paddingBottom: 4,
            paddingLeft: 7
        });
        {
            const rule = r("PointedRectangle", [
                "tooltip",
                "system",
                "background"
            ]);
            rule.setAll({
                strokeOpacity: 0.3
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "background");
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "grid");
        }
        r("Label", [
            "tooltip",
            "system"
        ]).setAll({
            fontSize: 12,
            fill: ic.get("background")
        });
        r("Polygon").setAll({
            animationEasing: $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7($b4231ef84a5f8a61$export$bdd5293f3cf7a909)
        });
        r("Link").setAll({
            cornerRadius: 8,
            setStateOnChildren: true
        });
        {
            const rule = r("OrthogonalLine", [
                "link",
                "line"
            ]);
            rule.setAll({
                isMeasured: false,
                crisp: true
            });
            const stateActive = rule.states.create("active", {
                strokeWidth: 2
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(stateActive, "stroke", ic, "negative");
        }
        r("OrthogonalLine", [
            "link",
            "hit"
        ]).setAll({
            strokeWidth: 10,
            opacity: 0,
            strokeOpacity: 0
        });
        {
            const rule = r("OrthogonalLine");
            rule.setAll({
                strokeWidth: 1,
                strokeOpacity: 1,
                cornerRadius: 10
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "grid");
        }
        {
            const rule = r("Triangle", [
                "link"
            ]);
            rule.setAll({
                width: 14,
                height: 10,
                centerY: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "grid");
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "grid");
            rule.states.create("default", {
                stateAnimationDuration: 0
            });
            const state = rule.states.create("active", {
                stateAnimationDuration: 0,
                stroke: (0, $389de129b6cd18b1$export$35e9368ef982300f)(0xffffff),
                strokeWidth: 2
            });
            // draw circle and x inside
            state.set("draw", (display)=>{
                display.arc(0, 0, 11, 0, Math.PI * 2);
                display.moveTo(-4, -4);
                display.lineTo(4, 4);
                display.moveTo(4, -4);
                display.lineTo(-4, 4);
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(state, "fill", ic, "negative");
        }
        {
            const rule = r("PointedRectangle", [
                "tooltip",
                "background"
            ]);
            rule.setAll({
                strokeOpacity: 0.9,
                cornerRadius: 4,
                pointerLength: 4,
                pointerBaseWidth: 8,
                fillOpacity: 0.9,
                stroke: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xffffff)
            });
        }
        {
            const rule = r("Label", [
                "tooltip"
            ]);
            rule.setAll({
                role: "tooltip",
                populateText: true,
                paddingRight: 0,
                paddingTop: 0,
                paddingLeft: 0,
                paddingBottom: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "alternativeText");
        }
        /**
         * ------------------------------------------------------------------------
         * core: Button
         * ------------------------------------------------------------------------
         */ r("Button").setAll({
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 10,
            paddingRight: 10,
            interactive: true,
            layout: horizontalLayout,
            interactiveChildren: false,
            setStateOnChildren: true,
            focusable: true
        });
        r("Button").states.create("hover", {});
        r("Button").states.create("down", {
            stateAnimationDuration: 0
        });
        r("Button").states.create("active", {});
        r("Button").states.create("disabled", {
            forceInactive: true
        });
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background"
            ]);
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButton");
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "primaryButtonStroke");
        }
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background"
            ]).states.create("hover", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonHover");
        }
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background"
            ]).states.create("down", {
                stateAnimationDuration: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonDown");
        }
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background"
            ]).states.create("active", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonActive");
        }
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background"
            ]).states.create("disabled", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonDisabled");
        }
        {
            const rule = r("Graphics", [
                "button",
                "icon"
            ]).states.create("disabled", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonTextDisabled");
        }
        {
            const rule = r("Label", [
                "button"
            ]).states.create("disabled", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonTextDisabled");
        }
        {
            const rule = r("Graphics", [
                "button",
                "icon"
            ]);
            rule.setAll({
                forceInactive: true
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "primaryButtonText");
        }
        {
            const rule = r("Label", [
                "button"
            ]);
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonText");
        }
        /**
         * ------------------------------------------------------------------------
         * ConfirmButton
         * ------------------------------------------------------------------------
         */ r("ConfirmButton").setAll({
            toggleKey: "active",
            setStateOnChildren: true,
            label: (0, $f15f09c5037802f9$export$b04be29aa201d4f5).new(this._root, {
                text: language.translate("Confirm"),
                forceHidden: true
            })
        });
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background",
                "confirm"
            ]).states.create("active", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "negative");
        }
        r("Label", [
            "button",
            "confirm"
        ]).setAll({
            paddingTop: 0,
            paddingBottom: 0,
            paddingRight: 3,
            paddingLeft: 5
        });
        r("Label", [
            "button",
            "confirm"
        ]).states.create("default", {
            stateAnimationDuration: 0
        });
        r("Label", [
            "button",
            "confirm"
        ]).states.create("active", {
            forceHidden: false,
            stateAnimationDuration: 0
        });
        {
            const rule = r("Graphics", [
                "icon",
                "confirm",
                "button"
            ]);
            rule.setAll({
                stateAnimationDuration: 0
            });
            rule.states.create("default", {
                stateAnimationDuration: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "primaryButtonText");
        }
        {
            const rule = r("Graphics", [
                "icon",
                "confirm",
                "button"
            ]).states.create("active", {
                svgPath: "M -5 1 L 0 6 L 8 -5",
                strokeWidth: 2
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "primaryButtonText");
        }
        {
            const rule = r("Graphics", [
                "icon",
                "confirm",
                "button",
                "secondary"
            ]).states.create("active", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "primaryButtonText");
        }
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background",
                "confirm",
                "secondary"
            ]).states.create("active", {
                fillOpacity: 1
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "negative");
        }
        {
            const rule = r("RoundedRectangle", [
                "button",
                "background",
                "confirm",
                "secondary"
            ]).states.create("hoverActive", {
                fillOpacity: 1
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "negative");
        }
        // required
        r("Button", [
            "button",
            "confirm"
        ]).states.create("hoverActive", {});
        /**
         * ------------------------------------------------------------------------
         * charts/xy: ZoomOutButton
         * ------------------------------------------------------------------------
         */ r("Button", [
            "zoom"
        ]).setAll({
            paddingTop: 18,
            paddingBottom: 18,
            paddingLeft: 12,
            paddingRight: 12,
            centerX: 46,
            centerY: -10,
            y: 0,
            x: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            role: "button",
            ariaLabel: language.translate("Zoom Out"),
            layer: 30
        });
        {
            const rule = r("RoundedRectangle", [
                "background",
                "button",
                "zoom"
            ]);
            rule.setAll({
                cornerRadiusBL: 40,
                cornerRadiusBR: 40,
                cornerRadiusTL: 40,
                cornerRadiusTR: 40
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButton");
        }
        {
            const rule = r("RoundedRectangle", [
                "background",
                "button",
                "zoom"
            ]).states.create("hover", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonHover");
        }
        {
            const rule = r("RoundedRectangle", [
                "background",
                "button",
                "zoom"
            ]).states.create("down", {
                stateAnimationDuration: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonDown");
        }
        {
            const rule = r("Graphics", [
                "icon",
                "button",
                "zoom"
            ]);
            rule.setAll({
                crisp: true,
                strokeOpacity: 0.7,
                draw: (display)=>{
                    display.moveTo(0, 0);
                    display.lineTo(12, 0);
                }
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "primaryButtonText");
        }
        /**
         * ------------------------------------------------------------------------
         * core: ResizeButton
         * ------------------------------------------------------------------------
         */ r("Button", [
            "resize"
        ]).setAll({
            paddingTop: 9,
            paddingBottom: 9,
            paddingLeft: 13,
            paddingRight: 13,
            draggable: true,
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            position: "absolute",
            role: "slider",
            ariaValueMin: "0",
            ariaValueMax: "100",
            ariaLabel: language.translate("Use up and down arrows to move selection")
        });
        {
            const rule = r("RoundedRectangle", [
                "background",
                "resize",
                "button"
            ]);
            rule.setAll({
                cornerRadiusBL: 40,
                cornerRadiusBR: 40,
                cornerRadiusTL: 40,
                cornerRadiusTR: 40
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "secondaryButton");
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "secondaryButtonStroke");
        }
        {
            const rule = r("RoundedRectangle", [
                "background",
                "resize",
                "button"
            ]).states.create("hover", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "secondaryButtonHover");
        }
        {
            const rule = r("RoundedRectangle", [
                "background",
                "resize",
                "button"
            ]).states.create("down", {
                stateAnimationDuration: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "secondaryButtonDown");
        }
        {
            const rule = r("Graphics", [
                "resize",
                "button",
                "icon"
            ]);
            rule.setAll({
                interactive: false,
                crisp: true,
                strokeOpacity: 0.5,
                draw: (display)=>{
                    display.moveTo(0, 0.5);
                    display.lineTo(0, 12.5);
                    display.moveTo(4, 0.5);
                    display.lineTo(4, 12.5);
                }
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "secondaryButtonText");
        }
        r("Button", [
            "resize",
            "vertical"
        ]).setAll({
            rotation: 90,
            cursorOverStyle: "ns-resize"
        });
        r("Button", [
            "resize",
            "horizontal"
        ]).setAll({
            cursorOverStyle: "ew-resize"
        });
        /**
         * ------------------------------------------------------------------------
         * core: PlayButton
         * ------------------------------------------------------------------------
         */ r("Button", [
            "play"
        ]).setAll({
            paddingTop: 13,
            paddingBottom: 13,
            paddingLeft: 14,
            paddingRight: 14,
            ariaLabel: language.translate("Play"),
            toggleKey: "active"
        });
        {
            const rule = r("RoundedRectangle", [
                "play",
                "background"
            ]);
            rule.setAll({
                strokeOpacity: 0.5,
                cornerRadiusBL: 100,
                cornerRadiusBR: 100,
                cornerRadiusTL: 100,
                cornerRadiusTR: 100
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButton");
        }
        {
            const rule = r("Graphics", [
                "play",
                "icon"
            ]);
            rule.setAll({
                stateAnimationDuration: 0,
                dx: 1,
                draw: (display)=>{
                    display.moveTo(0, -5);
                    display.lineTo(8, 0);
                    display.lineTo(0, 5);
                    display.lineTo(0, -5);
                }
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonText");
        }
        r("Graphics", [
            "play",
            "icon"
        ]).states.create("default", {
            stateAnimationDuration: 0
        });
        r("Graphics", [
            "play",
            "icon"
        ]).states.create("active", {
            stateAnimationDuration: 0,
            draw: (display)=>{
                display.moveTo(-4, -5);
                display.lineTo(-1, -5);
                display.lineTo(-1, 5);
                display.lineTo(-4, 5);
                display.lineTo(-4, -5);
                display.moveTo(4, -5);
                display.lineTo(1, -5);
                display.lineTo(1, 5);
                display.lineTo(4, 5);
                display.lineTo(4, -5);
            }
        });
        /**
         * ------------------------------------------------------------------------
         * core: SwitchButton
         * ------------------------------------------------------------------------
         */ r("Button", [
            "switch"
        ]).setAll({
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 4,
            paddingRight: 4,
            ariaLabel: language.translate("Press ENTER to toggle"),
            toggleKey: "active",
            width: 40,
            height: 24,
            layout: null
        });
        {
            const rule = r("RoundedRectangle", [
                "switch",
                "background"
            ]);
            rule.setAll({
                strokeOpacity: 0.5,
                cornerRadiusBL: 100,
                cornerRadiusBR: 100,
                cornerRadiusTL: 100,
                cornerRadiusTR: 100
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButton");
        }
        {
            const rule = r("Circle", [
                "switch",
                "icon"
            ]);
            rule.setAll({
                radius: 8,
                centerY: 0,
                centerX: 0,
                dx: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButtonText");
        }
        r("Graphics", [
            "switch",
            "icon"
        ]).states.create("active", {
            dx: 16
        });
        /**
         * ------------------------------------------------------------------------
         * core: Scrollbar
         * ------------------------------------------------------------------------
         */ r("Scrollbar").setAll({
            start: 0,
            end: 1,
            layer: 30,
            animationEasing: $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7($b4231ef84a5f8a61$export$bdd5293f3cf7a909)
        });
        r("Scrollbar", [
            "vertical"
        ]).setAll({
            marginRight: 13,
            marginLeft: 13,
            minWidth: 12,
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("Scrollbar", [
            "horizontal"
        ]).setAll({
            marginTop: 13,
            marginBottom: 13,
            minHeight: 12,
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        this.rule("Button", [
            "scrollbar"
        ]).setAll({
            exportable: false
        });
        {
            const rule = r("RoundedRectangle", [
                "scrollbar",
                "main",
                "background"
            ]);
            rule.setAll({
                cornerRadiusTL: 8,
                cornerRadiusBL: 8,
                cornerRadiusTR: 8,
                cornerRadiusBR: 8,
                fillOpacity: 0.8
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "fill");
        }
        {
            const rule = r("RoundedRectangle", [
                "scrollbar",
                "thumb"
            ]);
            rule.setAll({
                role: "slider",
                ariaLive: "polite",
                position: "absolute",
                draggable: true
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "secondaryButton");
        }
        {
            const rule = r("RoundedRectangle", [
                "scrollbar",
                "thumb"
            ]).states.create("hover", {});
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "secondaryButtonHover");
        }
        {
            const rule = r("RoundedRectangle", [
                "scrollbar",
                "thumb"
            ]).states.create("down", {
                stateAnimationDuration: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "secondaryButtonDown");
        }
        r("RoundedRectangle", [
            "scrollbar",
            "thumb",
            "vertical"
        ]).setAll({
            x: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            ariaLabel: language.translate("Use up and down arrows to move selection")
        });
        r("RoundedRectangle", [
            "scrollbar",
            "thumb",
            "horizontal"
        ]).setAll({
            y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            ariaLabel: language.translate("Use left and right arrows to move selection")
        });
        // @todo: is this needed? used to be "ContentScrollbar"
        // r("Scrollbar", ["content?"]).setAll({
        // 	marginRight: 0,
        // 	marginLeft: 5,
        // 	layer: 5
        // });
        /**
         * ========================================================================
         * charts/xy
         * ========================================================================
         *
         * This needs to be in DefaultTheme because it's the only theme that is
         * automatically applied to Root, and tooltips different ancestors
         * than actual charts using them.
         */ {
            const rule = r("PointedRectangle", [
                "axis",
                "tooltip",
                "background"
            ]);
            rule.setAll({
                cornerRadius: 0
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "alternativeBackground");
        }
        r("Label", [
            "axis",
            "tooltip"
        ]).setAll({
            role: undefined
        });
        r("Label", [
            "axis",
            "tooltip",
            "y"
        ]).setAll({
            textAlign: "right"
        });
        r("Label", [
            "axis",
            "tooltip",
            "y",
            "opposite"
        ]).setAll({
            textAlign: "left"
        });
        r("Label", [
            "axis",
            "tooltip",
            "x"
        ]).setAll({
            textAlign: "center"
        });
        r("Tooltip", [
            "categoryaxis"
        ]).setAll({
            labelText: "{category}"
        });
        /**
         * ------------------------------------------------------------------------
         * Shapes
         * ------------------------------------------------------------------------
         */ // Class: Graphics
        r("Star").setAll({
            spikes: 5,
            innerRadius: 5,
            radius: 10
        });
        // STOCK
        r("Tooltip", [
            "stock"
        ]).setAll({
            paddingTop: 6,
            paddingBottom: 5,
            paddingLeft: 7,
            paddingRight: 7
        });
        r("Tooltip", [
            'indicator'
        ]).setAll({
            forceHidden: true
        });
        r("PointedRectangle", [
            "tooltip",
            "stock",
            "axis"
        ]).setAll({
            pointerLength: 0,
            pointerBaseWidth: 0,
            cornerRadius: 3
        });
        r("Label", [
            "tooltip",
            "stock"
        ]).setAll({
            fontSize: "0.8em"
        });
        // resizer
        r("SpriteResizer").setAll({
            rotationStep: 10,
            isMeasured: false
        });
        {
            const rule = r("Container", [
                "resizer",
                "grip"
            ]);
            rule.states.create("hover", {});
        }
        {
            const rule = r("RoundedRectangle", [
                "resizer",
                "grip"
            ]);
            rule.setAll({
                strokeOpacity: 0.7,
                strokeWidth: 1,
                fillOpacity: 1,
                width: 12,
                height: 12
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "background");
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "alternativeBackground");
        }
        {
            const rule = r("RoundedRectangle", [
                "resizer",
                "grip",
                "outline"
            ]);
            rule.setAll({
                strokeOpacity: 0,
                fillOpacity: 0,
                width: 20,
                height: 20
            });
            rule.states.create("hover", {
                fillOpacity: 0.3
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "alternativeBackground");
        }
        r("RoundedRectangle", [
            "resizer",
            "grip",
            "left"
        ]).setAll({
            cornerRadiusBL: 0,
            cornerRadiusBR: 0,
            cornerRadiusTL: 0,
            cornerRadiusTR: 0
        });
        r("RoundedRectangle", [
            "resizer",
            "grip",
            "right"
        ]).setAll({
            cornerRadiusBL: 0,
            cornerRadiusBR: 0,
            cornerRadiusTL: 0,
            cornerRadiusTR: 0
        });
        {
            const rule = r("Rectangle", [
                "resizer",
                "rectangle"
            ]);
            rule.setAll({
                strokeDasharray: [
                    2,
                    2
                ],
                strokeOpacity: 0.5,
                strokeWidth: 1
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "stroke", ic, "alternativeBackground");
        }
        r("Graphics", [
            "button",
            "plus",
            "icon"
        ]).setAll({
            x: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            draw: (display)=>{
                display.moveTo(-4, 0);
                display.lineTo(4, 0);
                display.moveTo(0, -4);
                display.lineTo(0, 4);
            }
        });
        r("Graphics", [
            "button",
            "minus",
            "icon"
        ]).setAll({
            x: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            draw: (display)=>{
                display.moveTo(-4, 0);
                display.lineTo(4, 0);
            }
        });
        r("Graphics", [
            "button",
            "home",
            "icon"
        ]).setAll({
            x: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            svgPath: "M 8 -1 L 6 -1 L 6 7 L 2 7 L 2 1 L -2 1 L -2 7 L -6 7 L -6 -1 L -8 -1 L 0 -9 L 8 -1 Z M 8 -1"
        });
        r("Button", [
            "zoomtools"
        ]).setAll({
            marginTop: 1,
            marginBottom: 2
        });
        r("ZoomTools").setAll({
            x: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            centerX: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            y: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            centerY: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            paddingRight: 10,
            paddingBottom: 10
        });
        // Progress pie
        r("ProgressPie").setAll({
            radius: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            width: 50,
            height: 50,
            centerX: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(-50),
            centerY: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(-50),
            innerRadius: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(85),
            numberFormat: "#."
        });
        {
            const rule = r("Label", [
                "progresspie"
            ]);
            rule.setAll({
                centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
                centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
                fontSize: "0.75em"
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButton");
        }
        {
            const rule = r("Circle", [
                "progresspie"
            ]);
            rule.setAll({
                fillOpacity: 0.5
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "background");
        }
        {
            const rule = r("Slice", [
                "progresspie"
            ]);
            rule.setAll({
                startAngle: -90
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButton");
        }
        {
            const rule = r("Slice", [
                "progresspie",
                "background"
            ]);
            rule.setAll({
                fillOpacity: 0.2,
                arc: 360
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "primaryButton");
        }
        // Numeric stepper
        r("EditableLabel", [
            "numericstepper"
        ]).setAll({
            y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            multiLine: false,
            marginRight: 2
        });
        {
            const rule = r("Container", [
                "numericstepper",
                "buttons"
            ]);
            rule.setAll({
                layout: this._root.verticalLayout,
                centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
                y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
                marginRight: 10,
                opacity: 0
            });
            rule.states.create("active", {
                opacity: 1
            });
            rule.states.create("default", {
                opacity: 0
            });
        }
        {
            const rule = r("Triangle", [
                "numericstepper"
            ]);
            rule.setAll({
                width: 17,
                height: 11,
                marginTop: 3,
                marginBottom: 3,
                strokeWidth: 5,
                strokeOpacity: 0,
                cursorOverStyle: "pointer"
            });
            $c53b0c859cf33b39$export$130a5dc1bc9cd8e1(rule, "fill", ic, "secondaryButton");
        }
        {
            const rule = r("Triangle", [
                "downbutton"
            ]);
            rule.setAll({
                rotation: 180
            });
        }
    }
}


/** @ignore */ /** */ 

/**
 * Modified from Pixi:
 *
 * The MIT License
 *
 * Copyright (c) 2013-2017 Mathew Groves, Chad Engler
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * @ignore
 */ class $182117fd0d651ae2$export$5b12bf1653c0dd85 {
    constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
     * Sets the matrix based on all the available properties
     */ setTransform(x, y, pivotX, pivotY, rotation, scale = 1) {
        this.a = Math.cos(rotation) * scale;
        this.b = Math.sin(rotation) * scale;
        this.c = -Math.sin(rotation) * scale;
        this.d = Math.cos(rotation) * scale;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
    }
    /**
     * Get a new position with the current transformation applied.
     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
     */ apply(origin) {
        return {
            x: this.a * origin.x + this.c * origin.y + this.tx,
            y: this.b * origin.x + this.d * origin.y + this.ty
        };
    }
    /**
     * Get a new position with the inverse of the current transformation applied.
     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
     */ applyInverse(origin) {
        const id = 1 / (this.a * this.d + this.c * -this.b);
        return {
            x: this.d * id * origin.x + -this.c * id * origin.y + (this.ty * this.c - this.tx * this.d) * id,
            y: this.a * id * origin.y + -this.b * id * origin.x + (-this.ty * this.a + this.tx * this.b) * id
        };
    }
    /**
     * Appends the given Matrix to this Matrix.
     */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
    }
    /**
     * Prepends the given Matrix to this Matrix.
     */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
    }
    /**
     * Copies the other matrix's properties into this matrix
     */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
    }
}










var $2661fd5dfc261885$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $2661fd5dfc261885$var$TAU = Math.PI * 2;
var $2661fd5dfc261885$var$mapToEllipse = function mapToEllipse(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
    var x = _ref.x, y = _ref.y;
    x *= rx;
    y *= ry;
    var xp = cosphi * x - sinphi * y;
    var yp = sinphi * x + cosphi * y;
    return {
        x: xp + centerx,
        y: yp + centery
    };
};
var $2661fd5dfc261885$var$approxUnitArc = function approxUnitArc(ang1, ang2) {
    // If 90 degree circular arc, use a constant
    // as derived from http://spencermortensen.com/articles/bezier-circle
    var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    var x1 = Math.cos(ang1);
    var y1 = Math.sin(ang1);
    var x2 = Math.cos(ang1 + ang2);
    var y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
};
var $2661fd5dfc261885$var$vectorAngle = function vectorAngle(ux, uy, vx, vy) {
    var sign = ux * vy - uy * vx < 0 ? -1 : 1;
    var dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
var $2661fd5dfc261885$var$getArcCenter = function getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
    var rxsq = Math.pow(rx, 2);
    var rysq = Math.pow(ry, 2);
    var pxpsq = Math.pow(pxp, 2);
    var pypsq = Math.pow(pyp, 2);
    var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
    if (radicant < 0) radicant = 0;
    radicant /= rxsq * pypsq + rysq * pxpsq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    var centerxp = radicant * rx / ry * pyp;
    var centeryp = radicant * -ry / rx * pxp;
    var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
    var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
    var vx1 = (pxp - centerxp) / rx;
    var vy1 = (pyp - centeryp) / ry;
    var vx2 = (-pxp - centerxp) / rx;
    var vy2 = (-pyp - centeryp) / ry;
    var ang1 = $2661fd5dfc261885$var$vectorAngle(1, 0, vx1, vy1);
    var ang2 = $2661fd5dfc261885$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $2661fd5dfc261885$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $2661fd5dfc261885$var$TAU;
    return [
        centerx,
        centery,
        ang1,
        ang2
    ];
};
var $2661fd5dfc261885$var$arcToBezier = function arcToBezier(_ref2) {
    var px = _ref2.px, py = _ref2.py, cx = _ref2.cx, cy = _ref2.cy, rx = _ref2.rx, ry = _ref2.ry, _ref2$xAxisRotation = _ref2.xAxisRotation, xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation, _ref2$largeArcFlag = _ref2.largeArcFlag, largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag, _ref2$sweepFlag = _ref2.sweepFlag, sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;
    var curves = [];
    if (rx === 0 || ry === 0) return [];
    var sinphi = Math.sin(xAxisRotation * $2661fd5dfc261885$var$TAU / 360);
    var cosphi = Math.cos(xAxisRotation * $2661fd5dfc261885$var$TAU / 360);
    var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
    var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return [];
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    var _getArcCenter = $2661fd5dfc261885$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp), _getArcCenter2 = $2661fd5dfc261885$var$_slicedToArray(_getArcCenter, 4), centerx = _getArcCenter2[0], centery = _getArcCenter2[1], ang1 = _getArcCenter2[2], ang2 = _getArcCenter2[3];
    // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
    // 1.0000000001. This causes `segments` to be greater than one, which is an
    // unecessary split, and adds extra points to the bezier curve. To alleviate
    // this issue, we round to 1.0 when the ratio is close to 1.0.
    var ratio = Math.abs(ang2) / ($2661fd5dfc261885$var$TAU / 4);
    if (Math.abs(1.0 - ratio) < 0.0000001) ratio = 1.0;
    var segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    for(var i = 0; i < segments; i++){
        curves.push($2661fd5dfc261885$var$approxUnitArc(ang1, ang2));
        ang1 += ang2;
    }
    return curves.map(function(curve) {
        var _mapToEllipse = $2661fd5dfc261885$var$mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery), x1 = _mapToEllipse.x, y1 = _mapToEllipse.y;
        var _mapToEllipse2 = $2661fd5dfc261885$var$mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery), x2 = _mapToEllipse2.x, y2 = _mapToEllipse2.y;
        var _mapToEllipse3 = $2661fd5dfc261885$var$mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery), x = _mapToEllipse3.x, y = _mapToEllipse3.y;
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            x: x,
            y: y
        };
    });
};
var $2661fd5dfc261885$export$2e2bcd8739ae039 = $2661fd5dfc261885$var$arcToBezier;


/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$checkArgs(name, actual, expected) {
    if (actual !== expected) throw new Error("Required " + expected + " arguments for " + name + " but got " + actual);
}
/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$checkMinArgs(name, actual, expected) {
    if (actual < expected) throw new Error("Required at least " + expected + " arguments for " + name + " but got " + actual);
}
/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$checkEvenArgs(name, actual, expected) {
    $217bcb2fe88d1cdd$var$checkMinArgs(name, actual, expected);
    if (actual % expected !== 0) throw new Error("Arguments for " + name + " must be in pairs of " + expected);
}
/**
 * @ignore
 * This splits the flag so that way 0017 will be processed as 0 0 17
 *
 * This is important for weird paths like `M17 5A1 1 0 0017 30 1 1 0 0017 5`
 */ function $217bcb2fe88d1cdd$var$splitArcFlags(args) {
    for(let i = 0; i < args.length; i += 7){
        let index = i + 3;
        let flag = args[index];
        if (flag.length > 1) {
            const a = /^([01])([01])(.*)$/.exec(flag);
            if (a !== null) {
                args.splice(index, 0, a[1]);
                ++index;
                args.splice(index, 0, a[2]);
                ++index;
                if (a[3].length > 0) args[index] = a[3];
                else args.splice(index, 1);
            }
        }
        ++index;
        flag = args[index];
        if (flag.length > 1) {
            const a = /^([01])(.+)$/.exec(flag);
            if (a !== null) {
                args.splice(index, 0, a[1]);
                ++index;
                args[index] = a[2];
            }
        }
    }
}
/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$assertBinary(value) {
    if (value === 0 || value === 1) return value;
    else throw new Error("Flag must be 0 or 1");
}
//  1 -> 0xffffff * (2 / 2)
//  2 -> 0xffffff * (1 / 2)
//
//  3 -> 0xffffff * (3 / 4)
//  4 -> 0xffffff * (1 / 4)
//
//  5 -> 0xffffff * (7 / 8)
//  6 -> 0xffffff * (5 / 8)
//  7 -> 0xffffff * (3 / 8)
//  8 -> 0xffffff * (1 / 8)
//
//  9 -> 0xffffff * (15 / 16)
// 10 -> 0xffffff * (13 / 16)
// 11 -> 0xffffff * (11 / 16)
// 12 -> 0xffffff *  (9 / 16)
// 13 -> 0xffffff *  (7 / 16)
// 14 -> 0xffffff *  (5 / 16)
// 15 -> 0xffffff *  (3 / 16)
// 16 -> 0xffffff *  (1 / 16)
// @todo remove this old color distribution algo if the new one pans out
/*function distributeId(id: number): number {
    if (id === 1) {
        return 0x000001;

    } else {
        // Finds the closest power of 2
        const base = Math.pow(2, Math.ceil(Math.log(id) / Math.log(2)));

        // Translates the id into an odd fraction index
        const index = ((base - id) * 2) + 1;

        // TODO is Math.round correct ?
        return Math.round(0xffffff * (index / base));
    }
}*/ /**
 * Function by smeans:
 * https://lowcode.life/generating-unique-contrasting-colors-in-javascript/
 * @ignore
 */ function $217bcb2fe88d1cdd$var$distributeId(id) {
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 24; i++){
        rgb[i % 3] <<= 1;
        rgb[i % 3] |= id & 0x01;
        id >>= 1;
    }
    return (rgb[0] | 0) + (rgb[1] << 8) + (rgb[2] << 16);
}
/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$eachTargets(hitTarget, f) {
    for(;;){
        if (hitTarget.interactive) {
            if (!f(hitTarget)) break;
        }
        if (hitTarget._parent) hitTarget = hitTarget._parent;
        else break;
    }
}
// TODO feature detection for mouse/touch/pointer
/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$onPointerEvent(element, name, f) {
    return $05b1b40b69b15016$export$3f65cefe8380dbea(element, $05b1b40b69b15016$export$e9a3efe7940d0764(name), (event)=>{
        const target = $05b1b40b69b15016$export$e58f029f0fbfdb29(event);
        let touches = event.touches;
        if (touches) {
            if (touches.length == 0) touches = event.changedTouches;
            f($2f30431acd054e2f$export$784d13d8ee351f07(touches), target);
        } else f([
            event
        ], target);
    });
}
/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$isTainted(image) {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.drawImage(image, 0, 0, 1, 1);
    try {
        context.getImageData(0, 0, 1, 1);
        return false;
    } catch (err) {
        console.warn("Image \"" + image.src + "\" is loaded from different host and is not covered by CORS policy. For more information about the implications read here: https://www.amcharts.com/docs/v5/concepts/cors");
        return true;
    }
}
/**
 * This is needed to workaround a bug in iOS which causes it to not GC canvas elements.
 *
 * @ignore
 */ function $217bcb2fe88d1cdd$var$clearCanvas(view) {
    view.width = 0;
    view.height = 0;
    view.style.width = "0px";
    view.style.height = "0px";
}
/**
 * Aligns the coordinate to the pixel, so it renders crisp
 *
 * @ignore
 */ function $217bcb2fe88d1cdd$var$crisp(x) {
    return Math.floor(x) + .5;
}
class $217bcb2fe88d1cdd$export$5a134e2faa19e404 {
    constructor(){
        this._x = 0;
        this._y = 0;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    set x(value) {
        this._x = value;
    }
    set y(value) {
        this._y = value;
    }
}
class $217bcb2fe88d1cdd$export$e0e1ad123bfa6ff4 extends (0, $a363f66303166aa1$export$9a67fa5e19f51a52) {
    constructor(renderer){
        super();
        this.mask = null;
        this.visible = true;
        this.exportable = true;
        this.interactive = false;
        this.inactive = null;
        this.wheelable = false;
        this.cancelTouch = false;
        this.isMeasured = false;
        this.buttonMode = false;
        this.alpha = 1;
        this.compoundAlpha = 1;
        this.angle = 0;
        this.scale = 1;
        this.x = 0;
        this.y = 0;
        this.crisp = false;
        this.pivot = new $217bcb2fe88d1cdd$export$5a134e2faa19e404();
        this._localMatrix = new (0, $182117fd0d651ae2$export$5b12bf1653c0dd85)();
        this._matrix = new (0, $182117fd0d651ae2$export$5b12bf1653c0dd85)();
        // TODO can this be replaced with _localMatrix ?
        this._uMatrix = new (0, $182117fd0d651ae2$export$5b12bf1653c0dd85)();
        // Cached transform inputs for _setMatrix memoization (NaN forces first compute)
        this._mx = NaN;
        this._my = NaN;
        this._mpx = NaN;
        this._mpy = NaN;
        this._mAngle = NaN;
        this._mScale = NaN;
        this._renderer = renderer;
    }
    subStatus(status) {
        return {
            inactive: this.inactive == null ? status.inactive : this.inactive,
            layer: this._layer || status.layer
        };
    }
    _dispose() {
        this._renderer._removeObject(this);
        this.getLayer().dirty = true;
    }
    getCanvas() {
        return this.getLayer().view;
    }
    getLayer() {
        let self = this;
        for(;;){
            if (self._layer) return self._layer;
            else if (self._parent) self = self._parent;
            else return this._renderer.defaultLayer;
        }
    }
    setLayer(order, margin) {
        if (order == null) this._layer = undefined;
        else {
            const visible = true;
            this._layer = this._renderer.getLayer(order, visible);
            this._layer.visible = visible;
            this._layer.margin = margin;
            if (margin) $05b1b40b69b15016$export$2dc32695cee26cb(this._layer.view, false);
            this._renderer._ghostLayer.setMargin(this._renderer.layers);
            if (this._parent) this._parent.registerChildLayer(this._layer);
            this._layer.dirty = true;
            this._renderer.resizeLayer(this._layer);
            this._renderer.resizeGhost();
        }
    }
    markDirtyLayer() {
        this.getLayer().dirty = true;
    }
    clear() {
        this.invalidateBounds();
    }
    invalidateBounds() {
        this._localBounds = undefined;
    }
    _addBounds(_bounds) {}
    _getColorId() {
        if (this._colorId === undefined) this._colorId = this._renderer.paintId(this);
        return this._colorId;
    }
    _isInteractive(status) {
        return !status.inactive && (this.interactive || this._renderer._forceInteractive > 0);
    }
    _isInteractiveMask(status) {
        return this._isInteractive(status);
    }
    contains(child) {
        for(;;){
            if (child === this) return true;
            else if (child._parent) child = child._parent;
            else return false;
        }
    }
    toGlobal(point) {
        return this._matrix.apply(point);
    }
    toLocal(point) {
        return this._matrix.applyInverse(point);
    }
    getLocalMatrix() {
        this._uMatrix.setTransform(0, 0, this.pivot.x, this.pivot.y, this.angle * Math.PI / 180, this.scale);
        return this._uMatrix;
    }
    getLocalBounds() {
        if (!this._localBounds) {
            const bn = 10000000;
            this._localBounds = {
                left: bn,
                top: bn,
                right: -bn,
                bottom: -bn
            };
            this._addBounds(this._localBounds);
        }
        return this._localBounds;
    }
    getAdjustedBounds(bounds) {
        this._setMatrix();
        const matrix = this.getLocalMatrix();
        const p0 = matrix.apply({
            x: bounds.left,
            y: bounds.top
        });
        const p1 = matrix.apply({
            x: bounds.right,
            y: bounds.top
        });
        const p2 = matrix.apply({
            x: bounds.right,
            y: bounds.bottom
        });
        const p3 = matrix.apply({
            x: bounds.left,
            y: bounds.bottom
        });
        return {
            left: Math.min(p0.x, p1.x, p2.x, p3.x),
            top: Math.min(p0.y, p1.y, p2.y, p3.y),
            right: Math.max(p0.x, p1.x, p2.x, p3.x),
            bottom: Math.max(p0.y, p1.y, p2.y, p3.y)
        };
    }
    on(key, callback, context) {
        if (this.interactive) return this._renderer._addEvent(this, key, callback, context);
        else return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{});
    }
    _setMatrix() {
        const px = this.pivot.x;
        const py = this.pivot.y;
        // Only rebuild the local matrix (the sin/cos cost) when an input changed.
        if (this.x !== this._mx || this.y !== this._my || px !== this._mpx || py !== this._mpy || this.angle !== this._mAngle || this.scale !== this._mScale) {
            this._localMatrix.setTransform(this.x, this.y, px, py, // Converts degrees to radians
            this.angle * Math.PI / 180, this.scale);
            this._mx = this.x;
            this._my = this.y;
            this._mpx = px;
            this._mpy = py;
            this._mAngle = this.angle;
            this._mScale = this.scale;
        }
        // Prepend stays unconditional: cheap, and always reflects the parent's
        // current world matrix (render() guarantees the parent was updated first).
        this._matrix.copyFrom(this._localMatrix);
        if (this._parent) this._matrix.prepend(this._parent._matrix);
    }
    _transform(context, resolution) {
        const m = this._matrix;
        let tx = m.tx * resolution;
        let ty = m.ty * resolution;
        if (this.crisp) {
            tx = $217bcb2fe88d1cdd$var$crisp(tx);
            ty = $217bcb2fe88d1cdd$var$crisp(ty);
        }
        context.setTransform(m.a * resolution, m.b * resolution, m.c * resolution, m.d * resolution, tx, ty);
    }
    _transformMargin(context, resolution, margin) {
        const m = this._matrix;
        context.setTransform(m.a * resolution, m.b * resolution, m.c * resolution, m.d * resolution, (m.tx + margin.left) * resolution, (m.ty + margin.top) * resolution);
    }
    _transformLayer(context, resolution, layer) {
        if (layer.margin) this._transformMargin(context, layer.scale || resolution, layer.margin);
        else this._transform(context, layer.scale || resolution);
    }
    render(status, targetGhostLayer = 0) {
        if (this.visible && (this.exportable !== false || !this._renderer._omitTainted)) {
            this._setMatrix();
            const subStatus = this.subStatus(status);
            const resolution = this._renderer.resolution;
            const layers = this._renderer.layers;
            const ghostLayer = this._renderer._ghostLayer;
            const ghostContext = ghostLayer.context;
            const mask = this.mask;
            if (mask) mask._setMatrix();
            // TODO improve this
            $2f30431acd054e2f$export$79b2f7037acddd43(layers, (layer)=>{
                if (layer) {
                    const context = layer.context;
                    context.save();
                    // We must apply the mask before we transform the element
                    if (mask) {
                        mask._transformLayer(context, resolution, layer);
                        mask._runPath(context);
                        context.clip();
                    }
                    context.globalAlpha = this.compoundAlpha * this.alpha;
                    this._transformLayer(context, resolution, layer);
                    if (this.filter) context.filter = this.filter;
                }
            });
            ghostContext.save();
            // We must apply the mask before we transform the element
            if (mask && this._isInteractiveMask(subStatus)) {
                mask._transformMargin(ghostContext, resolution, ghostLayer.margin);
                mask._runPath(ghostContext);
                ghostContext.clip();
            }
            this._transformMargin(ghostContext, resolution, ghostLayer.margin);
            if (subStatus.layer.order > 0 && !targetGhostLayer) $2f30431acd054e2f$export$d947e5f4f4c48d48(this._renderer._deferredGhostLayers, subStatus.layer.order);
            this._render(subStatus, targetGhostLayer);
            ghostContext.restore();
            $2f30431acd054e2f$export$79b2f7037acddd43(layers, (layer)=>{
                if (layer) layer.context.restore();
            });
        }
    }
    _render(status, _targetGhostLayer = 0) {
        if (this.exportable === false) status.layer.tainted = true;
    }
    _ghostOnly(targetGhostLayer = 0) {
        return targetGhostLayer > 0 ? true : false;
    }
    _drawGhost(status, targetGhostLayer = 0) {
        const interactive = this._isInteractive(status);
        const order = status.layer.order || 0;
        return interactive && (order == 0 && !this._ghostOnly(targetGhostLayer) || order == targetGhostLayer) ? true : false;
    }
    hovering() {
        return this._renderer._hovering.has(this);
    }
    dragging() {
        return this._renderer._dragging.some((x)=>x.value === this);
    }
    shouldCancelTouch() {
        const renderer = this._renderer;
        if (renderer.tapToActivate && !renderer._touchActive) return false;
        if (this.cancelTouch) return true;
        else if (this._parent) return this._parent.shouldCancelTouch();
        return false;
    }
}
class $217bcb2fe88d1cdd$export$b859d337447d8a21 extends $217bcb2fe88d1cdd$export$e0e1ad123bfa6ff4 {
    constructor(){
        super(...arguments);
        this.interactiveChildren = true;
        this._children = [];
    }
    _isInteractiveMask(status) {
        return this.interactiveChildren || super._isInteractiveMask(status);
    }
    addChild(child) {
        child._parent = this;
        this._children.push(child);
        if (child._layer) this.registerChildLayer(child._layer);
    }
    addChildAt(child, index) {
        child._parent = this;
        this._children.splice(index, 0, child);
        if (child._layer) this.registerChildLayer(child._layer);
    }
    removeChild(child) {
        child._parent = undefined;
        $2f30431acd054e2f$export$2529f734547e2830(this._children, child);
    }
    _render(status, targetGhostLayer) {
        super._render(status);
        const renderer = this._renderer;
        if (this.interactive && this.interactiveChildren) ++renderer._forceInteractive;
        $2f30431acd054e2f$export$79b2f7037acddd43(this._children, (child)=>{
            child.compoundAlpha = this.compoundAlpha * this.alpha;
            child.render(status, targetGhostLayer);
        });
        if (this.interactive && this.interactiveChildren) --renderer._forceInteractive;
    }
    registerChildLayer(layer) {
        if (!this._childLayers) this._childLayers = [];
        $2f30431acd054e2f$export$3589e1fa93f0a8a5(this._childLayers, layer);
        if (this._parent) this._parent.registerChildLayer(layer);
    }
    markDirtyLayer(deep = false) {
        super.markDirtyLayer();
        if (deep && this._childLayers) $2f30431acd054e2f$export$79b2f7037acddd43(this._childLayers, (layer)=>layer.dirty = true);
    }
    _dispose() {
        super._dispose();
        if (this._childLayers) $2f30431acd054e2f$export$79b2f7037acddd43(this._childLayers, (layer)=>{
            layer.dirty = true;
        });
    }
}
/**
 * @ignore
 */ function $217bcb2fe88d1cdd$var$setPoint(bounds, point) {
    bounds.left = Math.min(bounds.left, point.x);
    bounds.top = Math.min(bounds.top, point.y);
    bounds.right = Math.max(bounds.right, point.x);
    bounds.bottom = Math.max(bounds.bottom, point.y);
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$Op {
    colorize(_context, _forceColor) {}
    colorizeGhost(context, forceColor) {
        this.colorize(context, forceColor);
    }
    path(_context) {}
    pathGhost(context) {
        this.path(context);
    }
    addBounds(_bounds) {}
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$BeginPath extends $217bcb2fe88d1cdd$var$Op {
    colorize(context, _forceColor) {
        context.beginPath();
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$BeginFill extends $217bcb2fe88d1cdd$var$Op {
    constructor(color){
        super();
        this.color = color;
    }
    colorize(context, forceColor) {
        if (forceColor !== undefined) context.fillStyle = forceColor;
        else context.fillStyle = this.color;
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$EndFill extends $217bcb2fe88d1cdd$var$Op {
    constructor(clearShadow){
        super();
        this.clearShadow = clearShadow;
    }
    colorize(context, _forceColor) {
        context.fill();
        if (this.clearShadow) {
            context.shadowColor = "";
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        }
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$EndStroke extends $217bcb2fe88d1cdd$var$Op {
    colorize(context, _forceColor) {
        context.stroke();
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$LineStyle extends $217bcb2fe88d1cdd$var$Op {
    constructor(width, color, lineJoin, lineCap){
        super();
        this.width = width;
        this.color = color;
        this.lineJoin = lineJoin;
        this.lineCap = lineCap;
    }
    colorize(context, forceColor) {
        if (forceColor !== undefined) context.strokeStyle = forceColor;
        else context.strokeStyle = this.color;
        context.lineWidth = this.width;
        if (this.lineJoin) context.lineJoin = this.lineJoin;
        if (this.lineCap) context.lineCap = this.lineCap;
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$LineDash extends $217bcb2fe88d1cdd$var$Op {
    constructor(dash){
        super();
        this.dash = dash;
    }
    colorize(context, _forceColor) {
        context.setLineDash(this.dash);
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$LineDashOffset extends $217bcb2fe88d1cdd$var$Op {
    constructor(dashOffset){
        super();
        this.dashOffset = dashOffset;
    }
    colorize(context, _forceColor) {
        context.lineDashOffset = this.dashOffset;
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$DrawRect extends $217bcb2fe88d1cdd$var$Op {
    constructor(x, y, width, height){
        super();
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    path(context) {
        context.rect(this.x, this.y, this.width, this.height);
    }
    addBounds(bounds) {
        const l = this.x;
        const t = this.y;
        const r = l + this.width;
        const b = t + this.height;
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: l,
            y: t
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: r,
            y: t
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: l,
            y: b
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: r,
            y: b
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$DrawCircle extends $217bcb2fe88d1cdd$var$Op {
    constructor(x, y, radius){
        super();
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    path(context) {
        context.moveTo(this.x + this.radius, this.y);
        context.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
    }
    // TODO handle skewing and rotation
    addBounds(bounds) {
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.x - this.radius,
            y: this.y - this.radius
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.x + this.radius,
            y: this.y + this.radius
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$DrawEllipse extends $217bcb2fe88d1cdd$var$Op {
    constructor(x, y, radiusX, radiusY){
        super();
        this.x = x;
        this.y = y;
        this.radiusX = radiusX;
        this.radiusY = radiusY;
    }
    path(context) {
        context.ellipse(0, 0, this.radiusX, this.radiusY, 0, 0, Math.PI * 2);
    }
    // TODO handle skewing and rotation
    addBounds(bounds) {
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.x - this.radiusX,
            y: this.y - this.radiusY
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.x + this.radiusX,
            y: this.y + this.radiusY
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$Arc extends $217bcb2fe88d1cdd$var$Op {
    constructor(cx, cy, radius, startAngle, endAngle, anticlockwise){
        super();
        this.cx = cx;
        this.cy = cy;
        this.radius = radius;
        this.startAngle = startAngle;
        this.endAngle = endAngle;
        this.anticlockwise = anticlockwise;
    }
    path(context) {
        if (this.radius > 0) context.arc(this.cx, this.cy, this.radius, this.startAngle, this.endAngle, this.anticlockwise);
    }
    addBounds(bounds) {
        let arcBounds = $f43e9e04b3f0548b$export$87d7822d7a31793f(this.cx, this.cy, this.startAngle * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d, this.endAngle * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d, this.radius);
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: arcBounds.left,
            y: arcBounds.top
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: arcBounds.right,
            y: arcBounds.bottom
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$ArcTo extends $217bcb2fe88d1cdd$var$Op {
    constructor(x1, y1, x2, y2, radius){
        super();
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
        this.radius = radius;
    }
    path(context) {
        if (this.radius > 0) context.arcTo(this.x1, this.y1, this.x2, this.y2, this.radius);
    }
    // TODO: add points
    addBounds(_bounds) {
    /*
        // not finished
        https://math.stackexchange.com/questions/1781438/finding-the-center-of-a-circle-given-two-points-and-a-radius-algebraically

        if (prevPoint) {
            let x1 = prevPoint.x;
            let y1 = prevPoint.y;
            let x2 = this.x2;
            let y2 = this.y2;
            let r = this.radius;

            let xa = (x2 - x1) / 2;
            let ya = (y2 - y1) / 2;

            let x0 = x1 + xa;
            let y0 = y1 + ya;

            let a = Math.hypot(xa, ya);
            let b = Math.sqrt(r * r - a * a);

            let cx = x0 + b * ya / a;
            let cy = y0 - b * xa / a;

            console.log(cx, cy);
        }*/ }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$LineTo extends $217bcb2fe88d1cdd$var$Op {
    constructor(x, y){
        super();
        this.x = x;
        this.y = y;
    }
    path(context) {
        context.lineTo(this.x, this.y);
    }
    addBounds(bounds) {
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.x,
            y: this.y
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$MoveTo extends $217bcb2fe88d1cdd$var$Op {
    constructor(x, y){
        super();
        this.x = x;
        this.y = y;
    }
    path(context) {
        context.moveTo(this.x, this.y);
    }
    addBounds(bounds) {
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.x,
            y: this.y
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$ClosePath extends $217bcb2fe88d1cdd$var$Op {
    path(context) {
        context.closePath();
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$BezierCurveTo extends $217bcb2fe88d1cdd$var$Op {
    constructor(cpX, cpY, cpX2, cpY2, toX, toY){
        super();
        this.cpX = cpX;
        this.cpY = cpY;
        this.cpX2 = cpX2;
        this.cpY2 = cpY2;
        this.toX = toX;
        this.toY = toY;
    }
    path(context) {
        context.bezierCurveTo(this.cpX, this.cpY, this.cpX2, this.cpY2, this.toX, this.toY);
    }
    // TODO: OK?
    addBounds(bounds) {
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.cpX,
            y: this.cpY
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.cpX2,
            y: this.cpY2
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.toX,
            y: this.toY
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$QuadraticCurveTo extends $217bcb2fe88d1cdd$var$Op {
    constructor(cpX, cpY, toX, toY){
        super();
        this.cpX = cpX;
        this.cpY = cpY;
        this.toX = toX;
        this.toY = toY;
    }
    path(context) {
        context.quadraticCurveTo(this.cpX, this.cpY, this.toX, this.toY);
    }
    // TODO: OK?
    addBounds(bounds) {
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.cpX,
            y: this.cpY
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.toX,
            y: this.toY
        });
    }
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$Shadow extends $217bcb2fe88d1cdd$var$Op {
    constructor(color, blur, offsetX, offsetY, opacity){
        super();
        this.color = color;
        this.blur = blur;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.opacity = opacity;
    }
    colorize(context, _forceColor) {
        if (this.opacity) context.fillStyle = this.color;
        context.shadowColor = this.color;
        context.shadowBlur = this.blur;
        context.shadowOffsetX = this.offsetX;
        context.shadowOffsetY = this.offsetY;
    }
    colorizeGhost(_context, _forceColor) {}
}
/**
 * @ignore
 */ class $217bcb2fe88d1cdd$var$GraphicsImage extends $217bcb2fe88d1cdd$var$Op {
    constructor(image, width, height, x, y){
        super();
        this.image = image;
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
    }
    path(context) {
        context.drawImage(this.image, this.x, this.y, this.width, this.height);
    }
    // TODO: OK?
    addBounds(bounds) {
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.x,
            y: this.y
        });
        $217bcb2fe88d1cdd$var$setPoint(bounds, {
            x: this.width,
            y: this.height
        });
    }
}
class $217bcb2fe88d1cdd$export$51df14243a6273b2 extends $217bcb2fe88d1cdd$export$e0e1ad123bfa6ff4 {
    constructor(){
        super(...arguments);
        this._operations = [];
        this.blendMode = (0, $26f287a8eb69ba00$export$c9b8fe72ac71821).NORMAL;
        this._hasShadows = false;
    }
    clear() {
        super.clear();
        this._operations.length = 0;
    }
    _pushOp(op) {
        this._operations.push(op);
    }
    beginFill(color, alpha = 1) {
        this._fillAlpha = alpha;
        if (color) {
            if (color instanceof (0, $389de129b6cd18b1$export$892596cec99bc70e)) this._pushOp(new $217bcb2fe88d1cdd$var$BeginFill(color.toCSS(alpha)));
            else {
                this.isMeasured = true;
                this._pushOp(new $217bcb2fe88d1cdd$var$BeginFill(color));
            }
        } else this._pushOp(new $217bcb2fe88d1cdd$var$BeginFill("rgba(0, 0, 0, " + alpha + ")"));
    }
    endFill() {
        this._pushOp(new $217bcb2fe88d1cdd$var$EndFill(this._hasShadows));
    }
    endStroke() {
        this._pushOp(new $217bcb2fe88d1cdd$var$EndStroke());
    }
    beginPath() {
        this._pushOp(new $217bcb2fe88d1cdd$var$BeginPath());
    }
    lineStyle(width = 0, color, alpha = 1, lineJoin, lineCap) {
        this._strokeAlpha = alpha;
        if (color) {
            if (color instanceof (0, $389de129b6cd18b1$export$892596cec99bc70e)) this._pushOp(new $217bcb2fe88d1cdd$var$LineStyle(width, color.toCSS(alpha), lineJoin, lineCap));
            else this._pushOp(new $217bcb2fe88d1cdd$var$LineStyle(width, color, lineJoin, lineCap));
        } else this._pushOp(new $217bcb2fe88d1cdd$var$LineStyle(width, "rgba(0, 0, 0, " + alpha + ")", lineJoin, lineCap));
    }
    setLineDash(dash) {
        this._pushOp(new $217bcb2fe88d1cdd$var$LineDash(dash ? dash : []));
    }
    setLineDashOffset(dashOffset = 0) {
        this._pushOp(new $217bcb2fe88d1cdd$var$LineDashOffset(dashOffset));
    }
    drawRect(x, y, width, height) {
        this._pushOp(new $217bcb2fe88d1cdd$var$DrawRect(x, y, width, height));
    }
    drawCircle(x, y, radius) {
        this._pushOp(new $217bcb2fe88d1cdd$var$DrawCircle(x, y, radius));
    }
    drawEllipse(x, y, radiusX, radiusY) {
        this._pushOp(new $217bcb2fe88d1cdd$var$DrawEllipse(x, y, radiusX, radiusY));
    }
    arc(cx, cy, radius, startAngle, endAngle, anticlockwise = false) {
        this._pushOp(new $217bcb2fe88d1cdd$var$Arc(cx, cy, radius, startAngle, endAngle, anticlockwise));
    }
    arcTo(x1, y1, x2, y2, radius) {
        this._pushOp(new $217bcb2fe88d1cdd$var$ArcTo(x1, y1, x2, y2, radius));
    }
    lineTo(x, y) {
        this._pushOp(new $217bcb2fe88d1cdd$var$LineTo(x, y));
    }
    moveTo(x, y) {
        this._pushOp(new $217bcb2fe88d1cdd$var$MoveTo(x, y));
    }
    bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
        this._pushOp(new $217bcb2fe88d1cdd$var$BezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY));
    }
    quadraticCurveTo(cpX, cpY, toX, toY) {
        this._pushOp(new $217bcb2fe88d1cdd$var$QuadraticCurveTo(cpX, cpY, toX, toY));
    }
    closePath() {
        this._pushOp(new $217bcb2fe88d1cdd$var$ClosePath());
    }
    shadow(color, blur = 0, offsetX = 0, offsetY = 0, opacity) {
        this._hasShadows = true;
        this._pushOp(new $217bcb2fe88d1cdd$var$Shadow(opacity ? color.toCSS(opacity) : color.toCSS(this._fillAlpha || this._strokeAlpha), blur, offsetX, offsetY));
    }
    image(image, width, height, x, y) {
        this._pushOp(new $217bcb2fe88d1cdd$var$GraphicsImage(image, width, height, x, y));
    }
    // https://svgwg.org/svg2-draft/paths.html#DProperty
    // TODO better error checking
    svgPath(path) {
        let x = 0;
        let y = 0;
        let cpx = null;
        let cpy = null;
        let qcpx = null;
        let qcpy = null;
        const SEGMENTS_REGEXP = /([MmZzLlHhVvCcSsQqTtAa])([^MmZzLlHhVvCcSsQqTtAa]*)/g;
        const ARGS_REGEXP = /[\u0009\u0020\u000A\u000C\u000D]*([\+\-]?[0-9]*\.?[0-9]+(?:[eE][\+\-]?[0-9]+)?)[\u0009\u0020\u000A\u000C\u000D]*,?/g;
        // Hack needed to undo any operations if the SVG parsing fails
        const length = this._operations.length;
        try {
            let match;
            while((match = SEGMENTS_REGEXP.exec(path)) !== null){
                const name = match[1];
                const rest = match[2];
                const args = [];
                while((match = ARGS_REGEXP.exec(rest)) !== null)args.push(match[1]);
                // Reset control point
                if (name !== "S" && name !== "s" && name !== "C" && name !== "c") {
                    cpx = null;
                    cpy = null;
                }
                // Reset control point
                if (name !== "Q" && name !== "q" && name !== "T" && name !== "t") {
                    qcpx = null;
                    qcpy = null;
                }
                switch(name){
                    case "M":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 2);
                        x = +args[0];
                        y = +args[1];
                        this.moveTo(x, y);
                        for(let i = 2; i < args.length; i += 2){
                            x = +args[i];
                            y = +args[i + 1];
                            this.lineTo(x, y);
                        }
                        break;
                    case "m":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 2);
                        x += +args[0];
                        y += +args[1];
                        this.moveTo(x, y);
                        for(let i = 2; i < args.length; i += 2){
                            x += +args[i];
                            y += +args[i + 1];
                            this.lineTo(x, y);
                        }
                        break;
                    case "L":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 2);
                        for(let i = 0; i < args.length; i += 2){
                            x = +args[i];
                            y = +args[i + 1];
                            this.lineTo(x, y);
                        }
                        break;
                    case "l":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 2);
                        for(let i = 0; i < args.length; i += 2){
                            x += +args[i];
                            y += +args[i + 1];
                            this.lineTo(x, y);
                        }
                        break;
                    case "H":
                        $217bcb2fe88d1cdd$var$checkMinArgs(name, args.length, 1);
                        for(let i = 0; i < args.length; ++i){
                            x = +args[i];
                            this.lineTo(x, y);
                        }
                        break;
                    case "h":
                        $217bcb2fe88d1cdd$var$checkMinArgs(name, args.length, 1);
                        for(let i = 0; i < args.length; ++i){
                            x += +args[i];
                            this.lineTo(x, y);
                        }
                        break;
                    case "V":
                        $217bcb2fe88d1cdd$var$checkMinArgs(name, args.length, 1);
                        for(let i = 0; i < args.length; ++i){
                            y = +args[i];
                            this.lineTo(x, y);
                        }
                        break;
                    case "v":
                        $217bcb2fe88d1cdd$var$checkMinArgs(name, args.length, 1);
                        for(let i = 0; i < args.length; ++i){
                            y += +args[i];
                            this.lineTo(x, y);
                        }
                        break;
                    case "C":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 6);
                        for(let i = 0; i < args.length; i += 6){
                            const x1 = +args[i];
                            const y1 = +args[i + 1];
                            cpx = +args[i + 2];
                            cpy = +args[i + 3];
                            x = +args[i + 4];
                            y = +args[i + 5];
                            this.bezierCurveTo(x1, y1, cpx, cpy, x, y);
                        }
                        break;
                    case "c":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 6);
                        for(let i = 0; i < args.length; i += 6){
                            const x1 = +args[i] + x;
                            const y1 = +args[i + 1] + y;
                            cpx = +args[i + 2] + x;
                            cpy = +args[i + 3] + y;
                            x += +args[i + 4];
                            y += +args[i + 5];
                            this.bezierCurveTo(x1, y1, cpx, cpy, x, y);
                        }
                        break;
                    case "S":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 4);
                        if (cpx === null || cpy === null) {
                            cpx = x;
                            cpy = y;
                        }
                        for(let i = 0; i < args.length; i += 4){
                            const x1 = 2 * x - cpx;
                            const y1 = 2 * y - cpy;
                            cpx = +args[i];
                            cpy = +args[i + 1];
                            x = +args[i + 2];
                            y = +args[i + 3];
                            this.bezierCurveTo(x1, y1, cpx, cpy, x, y);
                        }
                        break;
                    case "s":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 4);
                        if (cpx === null || cpy === null) {
                            cpx = x;
                            cpy = y;
                        }
                        for(let i = 0; i < args.length; i += 4){
                            const x1 = 2 * x - cpx;
                            const y1 = 2 * y - cpy;
                            cpx = +args[i] + x;
                            cpy = +args[i + 1] + y;
                            x += +args[i + 2];
                            y += +args[i + 3];
                            this.bezierCurveTo(x1, y1, cpx, cpy, x, y);
                        }
                        break;
                    case "Q":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 4);
                        for(let i = 0; i < args.length; i += 4){
                            qcpx = +args[i];
                            qcpy = +args[i + 1];
                            x = +args[i + 2];
                            y = +args[i + 3];
                            this.quadraticCurveTo(qcpx, qcpy, x, y);
                        }
                        break;
                    case "q":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 4);
                        for(let i = 0; i < args.length; i += 4){
                            qcpx = +args[i] + x;
                            qcpy = +args[i + 1] + y;
                            x += +args[i + 2];
                            y += +args[i + 3];
                            this.quadraticCurveTo(qcpx, qcpy, x, y);
                        }
                        break;
                    case "T":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 2);
                        if (qcpx === null || qcpy === null) {
                            qcpx = x;
                            qcpy = y;
                        }
                        for(let i = 0; i < args.length; i += 2){
                            qcpx = 2 * x - qcpx;
                            qcpy = 2 * y - qcpy;
                            x = +args[i];
                            y = +args[i + 1];
                            this.quadraticCurveTo(qcpx, qcpy, x, y);
                        }
                        break;
                    case "t":
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 2);
                        if (qcpx === null || qcpy === null) {
                            qcpx = x;
                            qcpy = y;
                        }
                        for(let i = 0; i < args.length; i += 2){
                            qcpx = 2 * x - qcpx;
                            qcpy = 2 * y - qcpy;
                            x += +args[i];
                            y += +args[i + 1];
                            this.quadraticCurveTo(qcpx, qcpy, x, y);
                        }
                        break;
                    case "A":
                    case "a":
                        const relative = name === "a";
                        $217bcb2fe88d1cdd$var$splitArcFlags(args);
                        $217bcb2fe88d1cdd$var$checkEvenArgs(name, args.length, 7);
                        for(let i = 0; i < args.length; i += 7){
                            let cx = +args[i + 5];
                            let cy = +args[i + 6];
                            if (relative) {
                                cx += x;
                                cy += y;
                            }
                            const bs = (0, $2661fd5dfc261885$export$2e2bcd8739ae039)({
                                px: x,
                                py: y,
                                rx: +args[i],
                                ry: +args[i + 1],
                                xAxisRotation: +args[i + 2],
                                largeArcFlag: $217bcb2fe88d1cdd$var$assertBinary(+args[i + 3]),
                                sweepFlag: $217bcb2fe88d1cdd$var$assertBinary(+args[i + 4]),
                                cx: cx,
                                cy: cy
                            });
                            $2f30431acd054e2f$export$79b2f7037acddd43(bs, (b)=>{
                                this.bezierCurveTo(b.x1, b.y1, b.x2, b.y2, b.x, b.y);
                                x = b.x;
                                y = b.y;
                            });
                        }
                        break;
                    case "Z":
                    case "z":
                        $217bcb2fe88d1cdd$var$checkArgs(name, args.length, 0);
                        this.closePath();
                        break;
                }
            }
        } catch (e) {
            // Undo any operations back to before `svgPath` was called
            this._operations.length = length;
            console.warn("Error when parsing svgPath:\n  " + e.message + "\n" + path);
        }
    }
    _runPath(context) {
        context.beginPath();
        $2f30431acd054e2f$export$79b2f7037acddd43(this._operations, (op)=>{
            op.path(context);
        });
    }
    _render(status, targetGhostLayer = 0) {
        super._render(status);
        const layerDirty = status.layer.dirty;
        const interactive = this._isInteractive(status);
        const ghostOnly = this._ghostOnly(targetGhostLayer);
        const drawGhost = this._drawGhost(status, targetGhostLayer);
        if (layerDirty || interactive || ghostOnly) {
            const context = status.layer.context;
            const ghostContext = this._renderer._ghostLayer.context;
            if (layerDirty && !ghostOnly) {
                context.globalCompositeOperation = this.blendMode;
                context.beginPath();
            }
            let color;
            if (drawGhost) {
                ghostContext.beginPath();
                color = this._getColorId();
            }
            $2f30431acd054e2f$export$79b2f7037acddd43(this._operations, (op)=>{
                if (layerDirty && !ghostOnly) {
                    op.path(context);
                    op.colorize(context, undefined);
                }
                if (drawGhost) {
                    op.pathGhost(ghostContext);
                    op.colorizeGhost(ghostContext, color);
                }
            });
        }
    }
    renderDetached(context) {
        if (this.visible) {
            this._setMatrix();
            context.save();
            // We must apply the mask before we transform the element
            const mask = this.mask;
            if (mask) {
                mask._setMatrix();
                mask._transform(context, 1);
                mask._runPath(context);
                context.clip();
            }
            // TODO handle compoundAlpha somehow ?
            context.globalAlpha = this.compoundAlpha * this.alpha;
            this._transform(context, 1);
            if (this.filter) context.filter = this.filter;
            context.globalCompositeOperation = this.blendMode;
            context.beginPath();
            $2f30431acd054e2f$export$79b2f7037acddd43(this._operations, (op)=>{
                op.path(context);
                op.colorize(context, undefined);
            });
            context.restore();
        }
    }
    _addBounds(bounds) {
        if (this.visible && this.isMeasured) $2f30431acd054e2f$export$79b2f7037acddd43(this._operations, (op)=>{
            op.addBounds(bounds);
        });
    }
}
class $217bcb2fe88d1cdd$export$3def536413f544ed extends $217bcb2fe88d1cdd$export$e0e1ad123bfa6ff4 {
    constructor(renderer, text, style){
        super(renderer);
        this.resolution = 1;
        this.textVisible = true;
        this._originalScale = 1;
        this.text = text;
        this.style = style;
    }
    invalidateBounds() {
        super.invalidateBounds();
        this._textInfo = undefined;
    }
    invalidateVisibility() {
        this.textVisible = true;
        this.scale = this._originalScale || 1;
    }
    _shared(context) {
        if (this.style.textAlign) context.textAlign = this.style.textAlign;
        if (this.style.direction) context.direction = this.style.direction;
        if (this.style.textBaseline) context.textBaseline = this.style.textBaseline;
    }
    _prerender(status, ignoreGhost = false, ignoreFontWeight = false) {
        super._render(status);
        const context = status.layer.context;
        const ghostContext = this._renderer._ghostLayer.context;
        // Font style
        const style = this.style;
        let fontStyle = this._getFontStyle(undefined, ignoreFontWeight);
        context.font = fontStyle;
        if (this._isInteractive(status) && !ignoreGhost) ghostContext.font = fontStyle;
        // Other parameters
        if (style.fill) {
            if (style.fill instanceof (0, $389de129b6cd18b1$export$892596cec99bc70e)) context.fillStyle = style.fill.toCSS(style.fillOpacity != undefined ? style.fillOpacity : 1);
            else context.fillStyle = style.fill;
        }
        if (style.shadowColor) status.layer.context.shadowColor = style.shadowColor.toCSS(style.shadowOpacity || 1);
        if (style.shadowBlur) status.layer.context.shadowBlur = style.shadowBlur;
        if (style.shadowOffsetX) status.layer.context.shadowOffsetX = style.shadowOffsetX;
        if (style.shadowOffsetY) status.layer.context.shadowOffsetY = style.shadowOffsetY;
        this._shared(context);
        if (this._isInteractive(status) && !ignoreGhost) {
            ghostContext.fillStyle = this._getColorId();
            this._shared(ghostContext);
        }
    }
    _getFontStyle(style2, ignoreFontWeight = false) {
        // Process defaults
        const style = this.style;
        let fontStyle = [];
        if (style2 && style2.fontVariant) fontStyle.push(style2.fontVariant);
        else if (style.fontVariant) fontStyle.push(style.fontVariant);
        if (!ignoreFontWeight) {
            if (style2 && style2.fontWeight) fontStyle.push(style2.fontWeight);
            else if (style.fontWeight) fontStyle.push(style.fontWeight);
        }
        if (style2 && style2.fontStyle) fontStyle.push(style2.fontStyle);
        else if (style.fontStyle) fontStyle.push(style.fontStyle);
        if (style2 && style2.fontSize) {
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(style2.fontSize)) style2.fontSize = style2.fontSize + "px";
            fontStyle.push(style2.fontSize);
        } else if (style.fontSize) {
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(style.fontSize)) style.fontSize = style.fontSize + "px";
            fontStyle.push(style.fontSize);
        }
        if (style.fontFamily == "inherit") fontStyle.push(getComputedStyle(this._renderer.view).getPropertyValue("font-family"));
        else if (style2 && style2.fontFamily) fontStyle.push(style2.fontFamily);
        else if (style.fontFamily) fontStyle.push(style.fontFamily);
        else if (fontStyle.length) fontStyle.push("Arial");
        return fontStyle.join(" ");
    }
    _render(status, targetGhostLayer = 0) {
        // We need measurements in order to properly position text for alignment
        if (!this._textInfo) this._measure(status);
        if (this.textVisible) {
            const interactive = this._isInteractive(status);
            const context = status.layer.context;
            const layerDirty = status.layer.dirty;
            const ghostContext = this._renderer._ghostLayer.context;
            const ghostOnly = this._ghostOnly(targetGhostLayer);
            const drawGhost = this._drawGhost(status, targetGhostLayer);
            context.save();
            ghostContext.save();
            this._prerender(status);
            // const lines = this.text.toString().replace(/\r/g, "").split(/\n/);
            // const x = this._localBounds && (this._localBounds.left < 0) ? Math.abs(this._localBounds.left) : 0;
            // Process text info produced by _measure()
            $2f30431acd054e2f$export$79b2f7037acddd43(this._textInfo, (line, _index)=>{
                $2f30431acd054e2f$export$79b2f7037acddd43(line.textChunks, (chunk, _index)=>{
                    // Set style
                    if (chunk.style) {
                        context.save();
                        ghostContext.save();
                        if (!ghostOnly) context.font = chunk.style;
                        if (this._isInteractive(status)) ghostContext.font = chunk.style;
                    }
                    if (chunk.fill) {
                        context.save();
                        if (!ghostOnly) context.fillStyle = chunk.fill.toCSS();
                    // Color does not affect ghostContext so we not set it
                    }
                    // Draw text
                    if (layerDirty && !ghostOnly) context.fillText(chunk.text, chunk.offsetX, line.offsetY + chunk.offsetY);
                    // Draw underline
                    if (chunk.textDecoration == "underline" || chunk.textDecoration == "line-through") {
                        let thickness = 1;
                        let offset = 1;
                        let fontSize = chunk.height;
                        const oversizedBehavior = this.style.oversizedBehavior || "";
                        if ([
                            "truncate",
                            "wrap",
                            "wrap-no-break"
                        ].indexOf(oversizedBehavior) > -1) {
                            // Measure actual width of the text so the line fits
                            const metrics = this._measureText(chunk.text, context);
                            chunk.width = metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight;
                        }
                        let offsetX = chunk.offsetX;
                        switch(this.style.textAlign){
                            case "right":
                            case "end":
                                offsetX -= chunk.width;
                                break;
                            case "center":
                                offsetX -= chunk.width / 2;
                                break;
                        }
                        if (chunk.style) {
                            const format = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).getTextStyle(chunk.style);
                            switch(format.fontWeight){
                                case "bolder":
                                case "bold":
                                case "700":
                                case "800":
                                case "900":
                                    thickness = 2;
                                    break;
                            }
                        }
                        if (fontSize) offset = fontSize / 20;
                        let y;
                        if (chunk.textDecoration == "line-through") y = thickness + line.offsetY + chunk.offsetY - chunk.height / 2;
                        else y = thickness + offset * 1.5 + line.offsetY + chunk.offsetY;
                        y = $217bcb2fe88d1cdd$var$crisp(y);
                        if (!ghostOnly) {
                            context.save();
                            context.beginPath();
                            if (chunk.fill) context.strokeStyle = chunk.fill.toCSS();
                            else if (this.style.fill && this.style.fill instanceof (0, $389de129b6cd18b1$export$892596cec99bc70e)) context.strokeStyle = this.style.fill.toCSS();
                            context.lineWidth = thickness * offset;
                            context.moveTo(offsetX, y);
                            context.lineTo(offsetX + chunk.width, y);
                            context.stroke();
                            context.restore();
                        }
                    }
                    if (interactive && this.interactive && drawGhost) // Draw text in ghost canvas ONLY if it is set as interactive
                    // explicitly. This way we avoid hit test anomalies caused by anti
                    // aliasing of text.
                    ghostContext.fillText(chunk.text, chunk.offsetX, line.offsetY + chunk.offsetY);
                    if (chunk.fill) context.restore();
                    // Reset style
                    if (chunk.style) {
                        context.restore();
                        ghostContext.restore();
                    }
                });
            });
            context.restore();
            ghostContext.restore();
        }
    }
    _addBounds(bounds) {
        if (this.visible && this.isMeasured) {
            //if (this._textVisible) {
            const x = this._measure({
                inactive: this.inactive,
                layer: this.getLayer()
            });
            $217bcb2fe88d1cdd$var$setPoint(bounds, {
                x: x.left,
                y: x.top
            });
            $217bcb2fe88d1cdd$var$setPoint(bounds, {
                x: x.right,
                y: x.bottom
            });
        //}
        }
    }
    _ignoreFontWeight() {
        return /apple/i.test(navigator.vendor);
    }
    _measure(status) {
        const context = status.layer.context;
        const ghostContext = this._renderer._ghostLayer.context;
        const rtl = this.style.direction == "rtl";
        // Reset text info
        this._textInfo = [];
        // Init
        const oversizedBehavior = this.style.oversizedBehavior;
        const maxWidth = this.style.maxWidth;
        const truncate = $f63bdea45a89cf24$export$7e4aa119212bc614(maxWidth) && oversizedBehavior == "truncate";
        const wrap = $f63bdea45a89cf24$export$7e4aa119212bc614(maxWidth) && (oversizedBehavior == "wrap" || oversizedBehavior == "wrap-no-break");
        // Pre-render
        context.save();
        ghostContext.save();
        this._prerender(status, true, this._ignoreFontWeight());
        // Get default font metrix
        const refText = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ";
        // Split up text into lines
        const lines = this.text.toString().replace(/\r/g, "").split(/\n/);
        let styleRestored = true;
        let minX = 0;
        let maxX = 0;
        // Iterate through the lines
        let offsetY = 0;
        let currentStyle;
        $2f30431acd054e2f$export$79b2f7037acddd43(lines, (line, _index)=>{
            // Split up line into format/value chunks
            let chunks;
            if (line == "") chunks = [
                {
                    type: "value",
                    text: ""
                }
            ];
            else chunks = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).chunk(line, false, this.style.ignoreFormatting);
            while(chunks.length > 0){
                // Init line object
                let lineInfo = {
                    offsetY: offsetY,
                    ascent: 0,
                    width: 0,
                    height: 0,
                    left: 0,
                    right: 0,
                    textChunks: []
                };
                // Measure reference text
                const metrics = this._measureText(refText, context);
                const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
                lineInfo.height = height;
                lineInfo.ascent = metrics.actualBoundingBoxAscent;
                let currentFormat;
                let currentDecoration = this.style.textDecoration;
                let currentFill;
                let currentChunkWidth;
                let skipFurtherText = false;
                let firstTextChunk = true;
                let leftoverChunks = [];
                let currentVerticalAlign;
                //let offsetX = 0;
                //let chunk;
                //while(chunk = chunks.shift()) {
                $2f30431acd054e2f$export$1e016427912bfd78(chunks, (chunk, index)=>{
                    // Format chunk
                    if (chunk.type == "format") {
                        if (chunk.text == "[/]") {
                            if (!styleRestored) {
                                context.restore();
                                ghostContext.restore();
                                styleRestored = true;
                            }
                            currentFill = undefined;
                            currentStyle = undefined;
                            currentChunkWidth = undefined;
                            currentDecoration = this.style.textDecoration;
                            currentVerticalAlign = undefined;
                            currentFormat = chunk.text;
                        } else {
                            if (!styleRestored) {
                                context.restore();
                                ghostContext.restore();
                            }
                            let format = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).getTextStyle(chunk.text);
                            const fontStyle = this._getFontStyle(format);
                            context.save();
                            ghostContext.save();
                            context.font = fontStyle;
                            currentStyle = fontStyle;
                            currentFormat = chunk.text;
                            if (format.textDecoration) currentDecoration = format.textDecoration;
                            if (format.fill) currentFill = format.fill;
                            if (format.width) currentChunkWidth = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(format.width);
                            if (format.verticalAlign) currentVerticalAlign = format.verticalAlign;
                            styleRestored = false;
                            // Measure reference text after change of format
                            const metrics = this._measureText(refText, context);
                            const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
                            if (height > lineInfo.height) lineInfo.height = height;
                            if (metrics.actualBoundingBoxAscent > lineInfo.ascent) lineInfo.ascent = metrics.actualBoundingBoxAscent;
                        }
                    } else if (chunk.type == "value" && !skipFurtherText) {
                        // Measure
                        const metrics = this._measureText(chunk.text, context);
                        let chunkWidth = metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight;
                        // Check for fit
                        if (truncate) {
                            this.truncated = undefined;
                            // Break words?
                            let breakWords = firstTextChunk || this.style.breakWords || false;
                            // Measure ellipsis and check if it fits
                            const ellipsis = this.style.ellipsis || "";
                            const ellipsisMetrics = this._measureText(ellipsis, context);
                            const ellipsisWidth = ellipsisMetrics.actualBoundingBoxLeft + ellipsisMetrics.actualBoundingBoxRight;
                            // Check fit
                            if (lineInfo.width + chunkWidth > maxWidth) {
                                const excessWidth = maxWidth - lineInfo.width - ellipsisWidth;
                                chunk.text = this._truncateText(context, chunk.text, excessWidth, breakWords);
                                chunk.text += ellipsis;
                                skipFurtherText = true;
                                this.truncated = true;
                            }
                        } else if (wrap) // Check fit
                        {
                            if (lineInfo.width + chunkWidth > maxWidth) {
                                const excessWidth = maxWidth - lineInfo.width;
                                const tmpText = this._truncateText(context, chunk.text, excessWidth, false, firstTextChunk && this.style.oversizedBehavior != "wrap-no-break");
                                if (tmpText == "") {
                                    // Unable to fit a single letter - hide the whole label
                                    this.textVisible = true;
                                    return false;
                                }
                                // _truncateText() may return text that still overflows (a single
                                // word wider than the remaining space when word-breaking is not
                                // allowed). If the line already has content, move the WHOLE chunk
                                // to the next line instead of letting it overflow.
                                if (!firstTextChunk) {
                                    const tmpMetrics = this._measureText($05b1b40b69b15016$export$87c2784dc9fc4ab(tmpText), context);
                                    const tmpWidth = tmpMetrics.actualBoundingBoxLeft + tmpMetrics.actualBoundingBoxRight;
                                    if (tmpWidth > excessWidth) {
                                        leftoverChunks = chunks.slice(index);
                                        if (currentFormat) leftoverChunks.unshift({
                                            type: "format",
                                            text: currentFormat
                                        });
                                        chunks = [];
                                        return false;
                                    }
                                }
                                //skipFurtherText = true;
                                //Add remaining chunks for the next line
                                leftoverChunks = chunks.slice(index + 1);
                                //Add remaining text of current chunk if it was forced-cut
                                if ($05b1b40b69b15016$export$87c2784dc9fc4ab(tmpText) != $05b1b40b69b15016$export$87c2784dc9fc4ab(chunk.text)) {
                                    leftoverChunks.unshift({
                                        type: "value",
                                        text: chunk.text.substr(tmpText.length)
                                    });
                                    if (currentFormat) leftoverChunks.unshift({
                                        type: "format",
                                        text: currentFormat
                                    });
                                }
                                // Set current chunk (truncated)
                                chunk.text = $05b1b40b69b15016$export$87c2784dc9fc4ab(tmpText);
                                chunks = [];
                                skipFurtherText = true;
                            }
                        }
                        // Chunk width?
                        let leftBoundMod = 1;
                        let rightBoundMod = 1;
                        if (currentStyle && currentChunkWidth && currentChunkWidth > chunkWidth) {
                            // increase horizontal bounding boxes accordingly
                            const boundsMod = chunkWidth / currentChunkWidth;
                            switch(this.style.textAlign){
                                case "right":
                                case "end":
                                    leftBoundMod = boundsMod;
                                    break;
                                case "center":
                                    leftBoundMod = boundsMod;
                                    rightBoundMod = boundsMod;
                                    break;
                                default:
                                    rightBoundMod = boundsMod;
                            }
                            chunkWidth = currentChunkWidth;
                        }
                        const chunkHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
                        if (chunkHeight > lineInfo.height) lineInfo.height = chunkHeight;
                        if (metrics.actualBoundingBoxAscent > lineInfo.ascent) lineInfo.ascent = metrics.actualBoundingBoxAscent;
                        lineInfo.width += chunkWidth;
                        lineInfo.left += metrics.actualBoundingBoxLeft / leftBoundMod;
                        lineInfo.right += metrics.actualBoundingBoxRight / rightBoundMod;
                        lineInfo.textChunks.push({
                            style: currentStyle,
                            fill: currentFill,
                            text: chunk.text,
                            width: chunkWidth,
                            height: chunkHeight,
                            left: metrics.actualBoundingBoxLeft,
                            right: metrics.actualBoundingBoxRight,
                            ascent: metrics.actualBoundingBoxAscent,
                            offsetX: 0,
                            offsetY: 0,
                            textDecoration: currentDecoration,
                            verticalAlign: currentVerticalAlign
                        });
                        //offsetX += chunkWidth;
                        firstTextChunk = false;
                    }
                    leftoverChunks;
                    return true;
                //}
                });
                if (this.style.lineHeight instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                    lineInfo.height *= this.style.lineHeight.value;
                    lineInfo.ascent *= this.style.lineHeight.value;
                } else {
                    lineInfo.height *= this.style.lineHeight || 1.2;
                    lineInfo.ascent *= this.style.lineHeight || 1.2;
                }
                if (minX < lineInfo.left) minX = lineInfo.left;
                if (maxX < lineInfo.right) maxX = lineInfo.right;
                this._textInfo.push(lineInfo);
                //lineInfo.offsetY += lineInfo.ascent;
                offsetY += lineInfo.height;
                // Reset chunks so that it can proceed to the next line
                chunks = leftoverChunks || [];
            }
        });
        if (!styleRestored) {
            context.restore();
            ghostContext.restore();
        }
        // Adjust chunk internal offsets
        $2f30431acd054e2f$export$79b2f7037acddd43(this._textInfo, (lineInfo, _index)=>{
            let currentChunkOffset = 0;
            $2f30431acd054e2f$export$79b2f7037acddd43(lineInfo.textChunks, (chunk)=>{
                chunk.offsetX = currentChunkOffset + chunk.left - lineInfo.left;
                chunk.offsetY += lineInfo.height - lineInfo.height * (this.style.baselineRatio || 0.19);
                currentChunkOffset += chunk.width * (rtl ? -1 : 1);
                if (chunk.verticalAlign) switch(chunk.verticalAlign){
                    case "super":
                        chunk.offsetY -= lineInfo.height / 2 - chunk.height / 2;
                        break;
                    case "sub":
                        chunk.offsetY += chunk.height / 2;
                        break;
                }
            });
        });
        const bounds = {
            left: rtl ? -maxX : -minX,
            top: 0,
            right: rtl ? minX : maxX,
            bottom: offsetY
        };
        // We need to fit?
        if (oversizedBehavior !== "none") {
            const ratio = this._fitRatio(bounds, oversizedBehavior == "truncate");
            if (ratio < 1) {
                if (oversizedBehavior == "fit") {
                    if ($f63bdea45a89cf24$export$7e4aa119212bc614(this.style.minScale) && ratio < this.style.minScale) {
                        this.textVisible = false;
                        bounds.left = 0;
                        bounds.top = 0;
                        bounds.right = 0;
                        bounds.bottom = 0;
                    } else {
                        if (!this._originalScale) this._originalScale = this.scale;
                        this.scale = ratio;
                        this.textVisible = true;
                    }
                } else if (oversizedBehavior == "hide") {
                    this.textVisible = false;
                    bounds.left = 0;
                    bounds.top = 0;
                    bounds.right = 0;
                    bounds.bottom = 0;
                } else {
                    switch(this.style.textAlign){
                        case "right":
                        case "end":
                            bounds.left = rtl ? maxWidth : -maxWidth;
                            bounds.right = 0;
                            break;
                        case "center":
                            bounds.left = -maxWidth / 2;
                            bounds.right = maxWidth / 2;
                            break;
                        default:
                            bounds.left = 0;
                            bounds.right = rtl ? -maxWidth : maxWidth;
                    }
                    this.scale = this._originalScale || 1;
                    this._originalScale = undefined;
                    this.textVisible = true;
                }
            } else {
                this.scale = this._originalScale || 1;
                this._originalScale = undefined;
                this.textVisible = true;
            }
        }
        context.restore();
        ghostContext.restore();
        return bounds;
    }
    _fitRatio(bounds, horizontalOnly = false) {
        const maxW = this.style.maxWidth;
        const maxH = horizontalOnly ? undefined : this.style.maxHeight;
        if (!$f63bdea45a89cf24$export$7e4aa119212bc614(maxW) && !$f63bdea45a89cf24$export$7e4aa119212bc614(maxH)) return 1;
        const w = bounds.right - bounds.left;
        const h = bounds.bottom - bounds.top;
        return Math.min(maxW / w || 1, maxH / h || 1);
    }
    _truncateText(context, text, maxWidth, breakWords = false, fallbackBreakWords = true) {
        let width;
        do {
            if (breakWords) text = text.slice(0, -1);
            else {
                // A comma directly followed by a digit is a numeric separator (e.g.
                // "1,200,300"), not a word boundary - keep such numbers unbroken.
                let tmp = text.replace(/(?:[^,;:!?\\\/\s​]|,(?=\d))+[,;:!?\\\/\s​]*$/g, "");
                if ((tmp == "" || tmp === text) && fallbackBreakWords) breakWords = true;
                else if (tmp == "") return text;
                else text = tmp;
            }
            const metrics = this._measureText(text, context);
            width = metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight;
        }while (width > maxWidth && text != "");
        return text;
    }
    _measureText(text, context) {
        let metrics = context.measureText(text);
        let fakeMetrics = {};
        if (metrics.actualBoundingBoxAscent == null) {
            const div = document.createElement("div");
            div.innerText = text;
            div.style.visibility = "hidden";
            div.style.position = "absolute";
            div.style.top = "-1000000px;";
            div.style.fontFamily = this.style.fontFamily || "";
            div.style.fontSize = this.style.fontSize + "";
            document.body.appendChild(div);
            const bbox = div.getBoundingClientRect();
            document.body.removeChild(div);
            const h = bbox.height;
            const w = metrics.width;
            let left = 0;
            let right = w;
            fakeMetrics = {
                actualBoundingBoxAscent: h,
                actualBoundingBoxDescent: 0,
                actualBoundingBoxLeft: left,
                actualBoundingBoxRight: right,
                fontBoundingBoxAscent: h,
                fontBoundingBoxDescent: 0,
                width: w
            };
        //return fake;
        } else fakeMetrics = {
            actualBoundingBoxAscent: metrics.actualBoundingBoxAscent,
            actualBoundingBoxDescent: metrics.actualBoundingBoxDescent,
            actualBoundingBoxLeft: metrics.actualBoundingBoxLeft,
            actualBoundingBoxRight: metrics.actualBoundingBoxRight,
            fontBoundingBoxAscent: metrics.actualBoundingBoxAscent,
            fontBoundingBoxDescent: metrics.actualBoundingBoxDescent,
            width: metrics.width
        };
        const w = metrics.width;
        switch(this.style.textAlign){
            case "right":
            case "end":
                fakeMetrics.actualBoundingBoxLeft = w;
                fakeMetrics.actualBoundingBoxRight = 0;
                break;
            case "center":
                fakeMetrics.actualBoundingBoxLeft = w / 2;
                fakeMetrics.actualBoundingBoxRight = w / 2;
                break;
            default:
                fakeMetrics.actualBoundingBoxLeft = 0;
                fakeMetrics.actualBoundingBoxRight = w;
        }
        return fakeMetrics;
    }
}
class $217bcb2fe88d1cdd$export$14f1f3efc2895a7c {
    constructor(){
        // leading?: number;
        // letterSpacing?: number;
        this.lineHeight = (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(120);
        this.baselineRatio = 0.19;
        this.oversizedBehavior = "none";
        this.breakWords = false;
        this.ellipsis = "\u2026";
        this.ignoreFormatting = false;
    }
}
class $217bcb2fe88d1cdd$export$6f70e6edef4626e6 extends $217bcb2fe88d1cdd$export$3def536413f544ed {
    constructor(){
        super(...arguments);
        this.textType = "circular";
        this.inside = false;
        this.orientation = "auto";
        this.kerning = 0;
        this._textReversed = false;
    }
    _render(status, targetGhostLayer = 0) {
        switch(this.textType){
            case "circular":
                this._renderCircular(status, targetGhostLayer);
                break;
            default:
                super._render(status, targetGhostLayer);
                break;
        }
    }
    _renderCircular(status, targetGhostLayer = 0) {
        if (this.textVisible) {
            this._prerender(status);
            const interactive = this._isInteractive(status);
            const context = status.layer.context;
            const layerDirty = status.layer.dirty;
            const ghostContext = this._renderer._ghostLayer.context;
            // Savepoint
            context.save();
            if (interactive) ghostContext.save();
            // We need measurements in order to properly position text for alignment
            if (!this._textInfo) this._measure(status);
            // Init
            let radius = this.radius || 0;
            let startAngle = this.startAngle || 0;
            let deltaAngle = 0;
            let orientation = this.orientation;
            let inward = orientation == "auto" ? "auto" : orientation == "inward";
            const inside = this.inside;
            const align = this.style.textAlign || "left";
            const kerning = this.kerning || 0;
            let clockwise = align == "left" ? 1 : -1;
            const shouldReverse = !this._textReversed;
            const ghostOnly = this._ghostOnly(targetGhostLayer);
            const drawGhost = this._drawGhost(status, targetGhostLayer);
            // Check if we need to invert the whole stuff
            if (inward == "auto") {
                // Calc max angle so we know whether we need to flip it
                let maxAngle = 0;
                let midAngle = 0;
                $2f30431acd054e2f$export$79b2f7037acddd43(this._textInfo, (line, _index)=>{
                    const deltaAngle = startAngle + line.width / (radius - line.height) / 2 * -clockwise;
                    if (deltaAngle > maxAngle) maxAngle = deltaAngle;
                });
                if (align == "left") midAngle = (maxAngle + deltaAngle / 2) * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d;
                else if (align == "right") midAngle = (maxAngle - deltaAngle / 2) * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d;
                else midAngle = startAngle * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d;
                midAngle = $f43e9e04b3f0548b$export$e3df76cf4464bc81(midAngle);
                inward = midAngle >= 270 || midAngle <= 90;
            }
            if (inward == true && shouldReverse) {
                this._textInfo.reverse();
                this._textReversed = true;
            }
            // if ((inward == false && align == "left") || (inward == true && align == "right")) {
            // 	clockwise *= -1;
            // }
            // Process text info produced by _measure()
            $2f30431acd054e2f$export$79b2f7037acddd43(this._textInfo, (line, _index)=>{
                const textHeight = line.height;
                // Adjust radius (for `inside = false`)
                // Radius adjustment for `inside = false` is below the line calculation
                if (!inside) radius += textHeight;
                // Reverse letters if we're painting them counter-clockwise
                if ((clockwise == -1 && inward || clockwise == 1 && !inward) && shouldReverse) line.textChunks.reverse();
                // Init angles
                let lineStartAngle = startAngle;
                deltaAngle = 0;
                // Adjust for center-align
                if (align == "center") {
                    lineStartAngle += line.width / (radius - textHeight) / 2 * -clockwise;
                    deltaAngle = lineStartAngle - startAngle;
                }
                // if (inward == "auto") {
                // 	let midAngle;
                // 	if (align == "left") {
                // 		midAngle = (lineStartAngle + deltaAngle / 2) * $math.DEGREES;
                // 	}
                // 	else if () {
                // 		midAngle = (lineStartAngle - deltaAngle / 2) * $math.DEGREES;
                // 	}
                // 	inward = (midAngle >= 270) || (midAngle <= 90);
                // }
                // Rotate letters if they are facing outward
                lineStartAngle += Math.PI * (inward ? 0 : 1); // Rotate 180 if outward
                // Savepoint
                context.save();
                if (interactive) ghostContext.save();
                // Assume starting angle
                if (!ghostOnly) context.rotate(lineStartAngle);
                if (interactive) ghostContext.rotate(lineStartAngle);
                let angleShift = 0;
                $2f30431acd054e2f$export$79b2f7037acddd43(line.textChunks, (chunk, _index)=>{
                    // Draw the letter
                    const char = chunk.text;
                    const charWidth = chunk.width;
                    // Rotate half a letter
                    angleShift = charWidth / 2 / (radius - textHeight) * clockwise;
                    if (!ghostOnly) context.rotate(angleShift);
                    if (interactive) ghostContext.rotate(angleShift);
                    // Set style
                    if (chunk.style) {
                        context.save();
                        ghostContext.save();
                        if (!ghostOnly) context.font = chunk.style;
                        if (interactive) ghostContext.font = chunk.style;
                    }
                    if (chunk.fill) {
                        context.save();
                        if (!ghostOnly) context.fillStyle = chunk.fill.toCSS();
                    // Color does not affect ghostContext so we not set it
                    }
                    // Center letters
                    if (!ghostOnly) {
                        context.textBaseline = "middle";
                        context.textAlign = "center";
                    }
                    if (interactive) {
                        ghostContext.textBaseline = "middle";
                        ghostContext.textAlign = "center";
                    }
                    // Plop the letter
                    if (layerDirty && !ghostOnly) context.fillText(char, 0, (inward ? 1 : -1) * (0 - radius + textHeight / 2));
                    if (interactive && drawGhost) ghostContext.fillText(char, 0, (inward ? 1 : -1) * (0 - radius + textHeight / 2));
                    if (chunk.fill) context.restore();
                    // Reset style
                    if (chunk.style) {
                        context.restore();
                        ghostContext.restore();
                    }
                    // Rotate half a letter and add spacing
                    angleShift = (charWidth / 2 + kerning) / (radius - textHeight) * clockwise;
                    if (!ghostOnly) context.rotate(angleShift);
                    if (interactive) ghostContext.rotate(angleShift);
                });
                // Restore angle
                context.restore();
                if (interactive) ghostContext.restore();
                // Adjust radius (for `inside = true`)
                if (inside) radius -= textHeight;
            });
            // Restore
            context.restore();
            if (interactive) ghostContext.restore();
        }
    }
    _measure(status) {
        switch(this.textType){
            case "circular":
                return this._measureCircular(status);
            default:
                return super._measure(status);
        }
    }
    _measureCircular(status) {
        const context = status.layer.context;
        const ghostContext = this._renderer._ghostLayer.context;
        const rtl = this.style.direction == "rtl";
        const oversizedBehavior = this.style.oversizedBehavior;
        const maxWidth = this.style.maxWidth;
        const truncate = $f63bdea45a89cf24$export$7e4aa119212bc614(maxWidth) && oversizedBehavior == "truncate";
        const ellipsis = this.style.ellipsis || "";
        let ellipsisMetrics;
        //const wrap = $type.isNumber(maxWidth) && (oversizedBehavior == "wrap" || oversizedBehavior == "wrap-no-break");
        // Reset text info
        this.textVisible = true;
        this._textInfo = [];
        this._textReversed = false;
        // Pre-render
        context.save();
        ghostContext.save();
        this._prerender(status, true);
        // Split up text into lines
        const lines = this.text.toString().replace(/\r/g, "").split(/\n/);
        let styleRestored = true;
        let totalWidth = 0;
        // Iterate through the lines
        let offsetY = 0;
        $2f30431acd054e2f$export$79b2f7037acddd43(lines, (line, _index)=>{
            // Split up line into format/value chunks
            let chunks = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).chunk(line, false, this.style.ignoreFormatting);
            // Init line object
            let lineInfo = {
                offsetY: offsetY,
                ascent: 0,
                width: 0,
                height: 0,
                left: 0,
                right: 0,
                textChunks: []
            };
            let currentStyle;
            let currentFill;
            let currentChunkWidth;
            //while(chunk = chunks.shift()) {
            $2f30431acd054e2f$export$79b2f7037acddd43(chunks, (chunk, _index)=>{
                // Format chunk
                if (chunk.type == "format") {
                    if (chunk.text == "[/]") {
                        if (!styleRestored) {
                            context.restore();
                            ghostContext.restore();
                            styleRestored = true;
                        }
                        currentFill = undefined;
                        currentStyle = undefined;
                        currentChunkWidth = undefined;
                    } else {
                        let format = (0, $4b06370a9416d0ab$export$cfc95f342033cc43).getTextStyle(chunk.text);
                        const fontStyle = this._getFontStyle(format);
                        context.save();
                        ghostContext.save();
                        context.font = fontStyle;
                        currentStyle = fontStyle;
                        if (format.fill) currentFill = format.fill;
                        if (format.width) currentChunkWidth = $f63bdea45a89cf24$export$a0a81dc3380ce7d3(format.width);
                        styleRestored = false;
                    }
                    if (truncate) ellipsisMetrics = this._measureText(ellipsis, context);
                } else if (chunk.type == "value") {
                    // Measure each letter
                    let chars = chunk.text.match(/./ug) || [];
                    if (rtl) {
                        chars = $05b1b40b69b15016$export$d05bbe0328e41cc6(chunk.text);
                        chars.reverse();
                    }
                    for(let i = 0; i < chars.length; i++){
                        const char = chars[i];
                        // Measure
                        const metrics = this._measureText(char, context);
                        let chunkWidth = metrics.width;
                        // Chunk width?
                        if (currentStyle && currentChunkWidth && currentChunkWidth > chunkWidth) chunkWidth = currentChunkWidth;
                        const chunkHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
                        if (chunkHeight > lineInfo.height) lineInfo.height = chunkHeight;
                        if (metrics.actualBoundingBoxAscent > lineInfo.ascent) lineInfo.ascent = metrics.actualBoundingBoxAscent;
                        totalWidth += chunkWidth;
                        // Handle oversized behavior
                        if (truncate) {
                            // Measure ellipsis and check if it fits
                            if (!ellipsisMetrics) ellipsisMetrics = this._measureText(ellipsis, context);
                            const ellipsisWidth = ellipsisMetrics.actualBoundingBoxLeft + ellipsisMetrics.actualBoundingBoxRight;
                            //totalWidth += ellipsisWidth;
                            if (totalWidth + ellipsisWidth > maxWidth) {
                                if (lineInfo.textChunks.length == 1) this.textVisible = false;
                                else {
                                    lineInfo.width += ellipsisWidth;
                                    lineInfo.left += ellipsisMetrics.actualBoundingBoxLeft;
                                    lineInfo.right += ellipsisMetrics.actualBoundingBoxRight;
                                    lineInfo.textChunks.push({
                                        style: currentStyle,
                                        fill: currentFill,
                                        text: ellipsis,
                                        width: ellipsisWidth,
                                        height: chunkHeight + ellipsisMetrics.actualBoundingBoxDescent,
                                        left: ellipsisMetrics.actualBoundingBoxLeft,
                                        right: ellipsisMetrics.actualBoundingBoxRight,
                                        ascent: ellipsisMetrics.actualBoundingBoxAscent,
                                        offsetX: 0,
                                        offsetY: chunkHeight,
                                        textDecoration: undefined
                                    });
                                }
                                break;
                            }
                        }
                        lineInfo.width += chunkWidth;
                        lineInfo.left += metrics.actualBoundingBoxLeft;
                        lineInfo.right += metrics.actualBoundingBoxRight;
                        lineInfo.textChunks.push({
                            style: currentStyle,
                            fill: currentFill,
                            text: char,
                            width: chunkWidth,
                            height: chunkHeight + metrics.actualBoundingBoxDescent,
                            left: metrics.actualBoundingBoxLeft,
                            right: metrics.actualBoundingBoxRight,
                            ascent: metrics.actualBoundingBoxAscent,
                            offsetX: 0,
                            offsetY: chunkHeight,
                            textDecoration: undefined
                        });
                        rtl;
                    }
                }
            });
            if (this.style.lineHeight instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) lineInfo.height *= this.style.lineHeight.value;
            else lineInfo.height *= this.style.lineHeight || 1.2;
            this._textInfo.push(lineInfo);
            //lineInfo.offsetY += lineInfo.ascent;
            offsetY += lineInfo.height;
        });
        if (!styleRestored) {
            context.restore();
            ghostContext.restore();
        }
        if (oversizedBehavior == "hide" && totalWidth > maxWidth) this.textVisible = false;
        // Adjust chunk internal offsets
        $2f30431acd054e2f$export$79b2f7037acddd43(this._textInfo, (lineInfo)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(lineInfo.textChunks, (chunk)=>{
                chunk.offsetY += Math.round((lineInfo.height - chunk.height + (lineInfo.ascent - chunk.ascent)) / 2);
            });
        });
        context.restore();
        ghostContext.restore();
        return {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
    }
}
class $217bcb2fe88d1cdd$export$e53fcdbfdf4d0d97 extends $217bcb2fe88d1cdd$export$e0e1ad123bfa6ff4 {
    constructor(renderer, image){
        super(renderer);
        this.image = image;
    }
    _dispose() {
        super._dispose();
        if (this._imageMask) $217bcb2fe88d1cdd$var$clearCanvas(this._imageMask);
    }
    getLocalBounds() {
        if (!this._localBounds) {
            let w = 0;
            let h = 0;
            if (this.width) w = this.width;
            if (this.height) h = this.height;
            this._localBounds = {
                left: 0,
                top: 0,
                right: w,
                bottom: h
            };
            this._addBounds(this._localBounds);
        }
        return this._localBounds;
    }
    _render(status, targetGhostLayer = 0) {
        super._render(status);
        if (this.image) {
            if (this.tainted === undefined) {
                this.tainted = $217bcb2fe88d1cdd$var$isTainted(this.image);
                status.layer.tainted = true;
            }
            if (this.tainted && this._renderer._omitTainted) return;
            const ghostOnly = this._ghostOnly(targetGhostLayer);
            const drawGhost = this._drawGhost(status, targetGhostLayer);
            if (status.layer.dirty && !ghostOnly) {
                if (this.shadowColor) status.layer.context.shadowColor = this.shadowColor.toCSS(this.shadowOpacity || 1);
                if (this.shadowBlur) status.layer.context.shadowBlur = this.shadowBlur;
                if (this.shadowOffsetX) status.layer.context.shadowOffsetX = this.shadowOffsetX;
                if (this.shadowOffsetY) status.layer.context.shadowOffsetY = this.shadowOffsetY;
                // TODO should this round ?
                const width = this.width || this.image.naturalWidth;
                const height = this.height || this.image.naturalHeight;
                status.layer.context.drawImage(this.image, 0, 0, width, height);
            }
            if (this.interactive && this._isInteractive(status) && drawGhost) {
                const mask = this._getMask(this.image);
                this._renderer._ghostLayer.context.drawImage(mask, 0, 0);
            }
        }
    }
    clear() {
        super.clear();
        this.image = undefined;
        this._imageMask = undefined;
    }
    _getMask(image) {
        if (this._imageMask === undefined) {
            // TODO should this round ?
            const width = this.width || image.naturalWidth;
            const height = this.height || image.naturalHeight;
            // We need to create a second canvas because destination-in clears out the entire canvas
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const context = canvas.getContext("2d");
            context.imageSmoothingEnabled = false;
            context.fillStyle = this._getColorId();
            context.fillRect(0, 0, width, height);
            if (!$217bcb2fe88d1cdd$var$isTainted(image)) {
                context.globalCompositeOperation = "destination-in";
                context.drawImage(image, 0, 0, width, height);
            }
            this._imageMask = canvas;
        }
        return this._imageMask;
    }
}
class $217bcb2fe88d1cdd$export$4e9e47eb662c1d9f {
    constructor(event, originalPoint, point, bbox){
        this.event = event;
        this.originalPoint = originalPoint;
        this.point = point;
        this.bbox = bbox;
        this.simulated = false;
        this.native = true;
        if ($05b1b40b69b15016$export$cde6a56f9669daf6("touchevents") && event instanceof Touch) this.id = event.identifier;
        else this.id = null;
    }
}
class $217bcb2fe88d1cdd$export$7adc20298958481a extends (0, $a363f66303166aa1$export$e5175346f02c1d15) {
    constructor(resolution){
        super();
        this.view = document.createElement("div");
        this._layerDom = document.createElement("div");
        this.layers = [];
        this._dirtyLayers = [];
        this.defaultLayer = this.getLayer(0);
        this._ghostLayer = new $217bcb2fe88d1cdd$var$GhostLayer();
        this._deferredGhostLayers = [];
        this._patternCanvas = document.createElement("canvas");
        this._patternContext = this._patternCanvas.getContext("2d");
        this._realWidth = 0;
        this._realHeight = 0;
        this._calculatedWidth = 0;
        this._calculatedHeight = 0;
        this.interactionsEnabled = true;
        this._listeners = {};
        this._events = {};
        this._colorId = 0;
        this._colorMap = {};
        this._forceInteractive = 0;
        this._omitTainted = false;
        // TODO this should store the Id as well
        this._hovering = new Set();
        this._dragging = [];
        this._mousedown = [];
        this.tapToActivate = false;
        this.tapToActivateTimeout = 3000;
        this._touchActive = false;
        if (resolution == null) this.resolution = window.devicePixelRatio;
        else this.resolution = resolution;
        this.view.style.position = "absolute";
        this.view.setAttribute("aria-hidden", "true");
        this.view.appendChild(this._layerDom);
        this._disposers.push(new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            $e66f9343b5144e1a$export$79b2f7037acddd43(this._events, (_key, events)=>{
                events.disposer.dispose();
            });
            $2f30431acd054e2f$export$79b2f7037acddd43(this.layers, (layer)=>{
                $217bcb2fe88d1cdd$var$clearCanvas(layer.view);
                if (layer.exportableView) $217bcb2fe88d1cdd$var$clearCanvas(layer.exportableView);
            });
            $217bcb2fe88d1cdd$var$clearCanvas(this._ghostLayer.view);
            $217bcb2fe88d1cdd$var$clearCanvas(this._patternCanvas);
        }));
        /*
        this._disposers.push($utils.addEventListener(this._ghostLayer.view, "click", (originalEvent: MouseEvent) => {
            const event = this.getEvent(originalEvent);
            const target = this._getHitTarget(event.originalPoint, event.bbox);
            console.debug(target);
        }));
        */ // Monitor for possible pixel ratio changes (when page is zoomed)
        this._disposers.push($05b1b40b69b15016$export$6981aa66c6e2c48d(()=>{
            if (resolution == null) this.resolution = window.devicePixelRatio;
        }));
        // We need this in order top prevent default touch gestures when dragging
        // draggable elements
        if ($05b1b40b69b15016$export$cde6a56f9669daf6("touchevents")) {
            const listener = (ev)=>{
                if (this._dragging.length !== 0) $2f30431acd054e2f$export$1e016427912bfd78(this._dragging, (item)=>{
                    if (item.value.shouldCancelTouch()) {
                        ev.preventDefault();
                        return false;
                    }
                    return true;
                });
                // If touch down happends, delay touch out
                if (this._touchActiveTimeout) this._delayTouchDeactivate();
            };
            this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(window, "touchstart", listener, {
                passive: false
            }));
            this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(this.view, "touchstart", listener, {
                passive: false
            }));
            this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(this.view, "touchmove", ()=>{
                // If touch is moving, delay touch out
                if (this._touchActiveTimeout) this._delayTouchDeactivate();
            }, {
                passive: true
            }));
            this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(window, "click", (_ev)=>{
                this._touchActive = false;
            }, {
                passive: true
            }));
            this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(this.view, "click", (_ev)=>{
                window.setTimeout(()=>{
                    this._touchActive = true;
                    this._delayTouchDeactivate();
                }, 100);
            }, {
                passive: true
            }));
        }
        // Prevent scrolling of the window when hovering on "wheelable" object
        if ($05b1b40b69b15016$export$cde6a56f9669daf6("wheelevents")) this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(this.view, "wheel", (ev)=>{
            let prevent = false;
            this._hovering.forEach((obj)=>{
                if (obj.wheelable) {
                    prevent = true;
                    return false;
                }
            });
            if (prevent) ev.preventDefault();
        }, {
            passive: false
        }));
    }
    /*protected _mouseMoveThrottler: Throttler = new Throttler(() => {
        this._dispatchGlobalMousemove(this._lastPointerMoveEvent.event, this._lastPointerMoveEvent.native);
    });
    */ resetImageArray() {
        this._ghostLayer.imageArray = undefined;
    }
    _delayTouchDeactivate() {
        if (this._touchActiveTimeout) clearTimeout(this._touchActiveTimeout);
        if (this.tapToActivateTimeout > 0) this._touchActiveTimeout = window.setTimeout(()=>{
            this._touchActive = false;
        }, this.tapToActivateTimeout);
    }
    get debugGhostView() {
        return !!this._ghostLayer.view.parentNode;
    }
    set debugGhostView(value) {
        if (value) {
            if (!this._ghostLayer.view.parentNode) this.view.appendChild(this._ghostLayer.view);
        } else if (this._ghostLayer.view.parentNode) this._ghostLayer.view.parentNode.removeChild(this._ghostLayer.view);
    }
    createLinearGradient(x1, y1, x2, y2) {
        return this.defaultLayer.context.createLinearGradient(x1, y1, x2, y2);
    }
    createRadialGradient(x1, y1, radius1, x2, y2, radius2) {
        return this.defaultLayer.context.createRadialGradient(x1, y1, radius1, x2, y2, radius2);
    }
    createPattern(graphics, background, repetition, width, height) {
        // const patternCanvas = document.createElement("canvas");
        // const patternContext = patternCanvas.getContext("2d")!;
        // patternCanvas.width = width;
        // patternCanvas.height = height;
        // if (fill) {
        // 	patternContext.fillStyle = fill.toCSS();
        // 	patternContext.fillRect(0, 0, patternCanvas.width, patternCanvas.height);
        // }
        // const layer = {
        // 	view: patternCanvas,
        // 	context: patternContext,
        // 	visible: true,
        // 	order: 0,
        // 	width: width,
        // 	height: height,
        // 	dirty: true
        // };
        // // patternContext.arc(0, 0, 50, 0, .5 * Math.PI);
        // // patternContext.stroke();
        // image.targetLayer = layer;
        // image.render(layer);
        //this._layerDom.appendChild(patternCanvas);
        this._patternCanvas.width = width;
        this._patternCanvas.height = height;
        this._patternContext.clearRect(0, 0, width, height);
        // patternCanvas.style.width = width * this.resolution + "px";
        // patternCanvas.style.height = height * this.resolution + "px";
        background.renderDetached(this._patternContext);
        graphics.renderDetached(this._patternContext);
        return this._patternContext.createPattern(this._patternCanvas, repetition);
    }
    makeContainer() {
        return new $217bcb2fe88d1cdd$export$b859d337447d8a21(this);
    }
    makeGraphics() {
        return new $217bcb2fe88d1cdd$export$51df14243a6273b2(this);
    }
    makeText(text, style) {
        return new $217bcb2fe88d1cdd$export$3def536413f544ed(this, text, style);
    }
    makeTextStyle() {
        return new $217bcb2fe88d1cdd$export$14f1f3efc2895a7c();
    }
    makeRadialText(text, style) {
        return new $217bcb2fe88d1cdd$export$6f70e6edef4626e6(this, text, style);
    }
    makePicture(image) {
        return new $217bcb2fe88d1cdd$export$e53fcdbfdf4d0d97(this, image);
    }
    resizeLayer(layer) {
        layer.resize(this._calculatedWidth, this._calculatedHeight, this._calculatedWidth, this._calculatedHeight, this.resolution);
    }
    resizeGhost() {
        this._ghostLayer.resize(this._calculatedWidth, this._calculatedHeight, this._calculatedWidth, this._calculatedHeight, this.resolution);
    }
    resize(realWidth, realHeight, calculatedWidth, calculatedHeight) {
        this._realWidth = realWidth;
        this._realHeight = realHeight;
        this._calculatedWidth = calculatedWidth;
        this._calculatedHeight = calculatedHeight;
        $2f30431acd054e2f$export$79b2f7037acddd43(this.layers, (layer)=>{
            if (layer) {
                layer.dirty = true;
                this.resizeLayer(layer);
            }
        });
        this.resizeGhost();
        this.view.style.width = calculatedWidth + "px";
        this.view.style.height = calculatedHeight + "px";
    }
    createDetachedLayer(willReadFrequently = false) {
        const view = document.createElement("canvas");
        const context = view.getContext("2d", {
            willReadFrequently: willReadFrequently
        });
        const layer = new $217bcb2fe88d1cdd$export$7b8f87dabf3b6ee0(view, context);
        view.style.position = "absolute";
        view.style.top = "0px";
        view.style.left = "0px";
        return layer;
    }
    getLayerByOrder(order) {
        const layers = this.layers;
        const length = layers.length;
        for(let i = 0; i < length; i++){
            const layer = layers[i];
            if (layer.order == order) return layer;
        }
    }
    getLayer(order, visible = true) {
        let existingLayer = this.getLayerByOrder(order);
        if (existingLayer) return existingLayer;
        const layer = this.createDetachedLayer(order == 99);
        layer.order = order;
        layer.visible = visible;
        layer.view.className = "am5-layer-" + order;
        if (layer.visible) this.resizeLayer(layer);
        const layers = this.layers;
        layers.push(layer);
        layers.sort((a, b)=>{
            if (a.order > b.order) return 1;
            else if (a.order < b.order) return -1;
            else return 0;
        });
        const length = layers.length;
        const layerIndex = $2f30431acd054e2f$export$305f7d4e9d4624f2(layers, layer);
        let next;
        for(let i = layerIndex + 1; i < length; i++)if (layers[i].visible) {
            next = layers[i];
            break;
        }
        if (layer.visible) {
            if (next === undefined) this._layerDom.appendChild(layer.view);
            else this._layerDom.insertBefore(layer.view, next.view);
        }
        return layer;
    }
    render(root) {
        this._dirtyLayers.length = 0;
        this._deferredGhostLayers = [];
        $2f30431acd054e2f$export$79b2f7037acddd43(this.layers, (layer)=>{
            if (layer) {
                if (layer.dirty && layer.visible) {
                    this._dirtyLayers.push(layer);
                    layer.clear();
                }
            }
        });
        this._ghostLayer.clear();
        root.render({
            inactive: null,
            layer: this.defaultLayer
        });
        const deferredGhostLayers = this._deferredGhostLayers;
        if (deferredGhostLayers.length) {
            deferredGhostLayers.sort((a, b)=>a - b);
            $2f30431acd054e2f$export$79b2f7037acddd43(deferredGhostLayers, (layerx)=>{
                root.render({
                    inactive: null,
                    layer: this.defaultLayer
                }, layerx);
            });
        }
        this._ghostLayer.context.restore();
        //setTimeout(() => {
        // Remove this after the Chrome bug is fixed:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1279394
        $2f30431acd054e2f$export$79b2f7037acddd43(this.layers, (layer)=>{
            if (layer) {
                const context = layer.context;
                context.beginPath();
                context.moveTo(0, 0);
                context.stroke();
            }
        });
        $2f30431acd054e2f$export$79b2f7037acddd43(this._dirtyLayers, (layer)=>{
            layer.context.restore();
            layer.dirty = false;
        });
        //}, 100)
        if (this._hovering.size && this._lastPointerMoveEvent) {
            const { events: events, target: target, native: native } = this._lastPointerMoveEvent;
            //this._mouseMoveThrottler.run();
            $2f30431acd054e2f$export$79b2f7037acddd43(events, (event)=>{
                this._dispatchGlobalMousemove(event, target, native);
            });
        }
    }
    paintId(obj) {
        const id = $217bcb2fe88d1cdd$var$distributeId(++this._colorId);
        const color = (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(id).toCSS();
        this._colorMap[color] = obj;
        return color;
    }
    _removeObject(obj) {
        if (obj._colorId !== undefined) delete this._colorMap[obj._colorId];
    }
    // protected _identifyObjectByColor(colorId: number): CanvasDisplayObject | undefined {
    // 	return this._colorMap[colorId];
    // }
    _adjustBoundingBox(bbox) {
        const margin = this._ghostLayer.margin;
        return new DOMRect(-margin.left, -margin.top, bbox.width + margin.left + margin.right, bbox.height + margin.top + margin.bottom);
    }
    getEvent(originalEvent, adjustPoint = true) {
        const bbox = this.view.getBoundingClientRect();
        const x = originalEvent.clientX || 0;
        const y = originalEvent.clientY || 0;
        const widthScale = this._calculatedWidth / this._realWidth;
        const heightScale = this._calculatedHeight / this._realHeight;
        const originalPoint = {
            x: x - bbox.left,
            y: y - bbox.top
        };
        const point = {
            x: (x - (adjustPoint ? bbox.left : 0)) * widthScale,
            y: (y - (adjustPoint ? bbox.top : 0)) * heightScale
        };
        return new $217bcb2fe88d1cdd$export$4e9e47eb662c1d9f(originalEvent, originalPoint, point, this._adjustBoundingBox(bbox));
    }
    _getHitTarget(point, bbox, target) {
        if (bbox.width === 0 || bbox.height === 0 || point.x < bbox.left || point.x > bbox.right || point.y < bbox.top || point.y > bbox.bottom) return;
        if (!target || !this._layerDom.contains(target)) return;
        const pixel = this._ghostLayer.getImageData(point, bbox);
        if (pixel.data[0] === 0 && pixel.data[1] === 0 && pixel.data[2] === 0) return false;
        const colorId = (0, $389de129b6cd18b1$export$892596cec99bc70e).fromRGB(pixel.data[0], pixel.data[1], pixel.data[2]).toCSS();
        const hit = this._colorMap[colorId];
        return hit;
    }
    getObjectAtPoint(point) {
        const data = this._ghostLayer.getImageArray(point);
        if (data[0] === 0 && data[1] === 0 && data[2] === 0) return undefined;
        const colorId = (0, $389de129b6cd18b1$export$892596cec99bc70e).fromRGB(data[0], data[1], data[2]).toCSS();
        const hit = this._colorMap[colorId];
        return hit;
    }
    _withEvents(key, f) {
        const events = this._events[key];
        if (events !== undefined) {
            events.dispatching = true;
            try {
                f(events);
            } finally{
                events.dispatching = false;
                if (events.cleanup) {
                    events.cleanup = false;
                    $2f30431acd054e2f$export$249f83d169a7c462(events.callbacks, (callback)=>{
                        return !callback.disposed;
                    });
                    if (events.callbacks.length === 0) {
                        events.disposer.dispose();
                        delete this._events[key];
                    }
                }
            }
        }
    }
    _dispatchEventAll(key, event) {
        if (!this.interactionsEnabled) return;
        this._withEvents(key, (events)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(events.callbacks, (callback)=>{
                if (!callback.disposed) callback.callback.call(callback.context, event);
            });
        });
    }
    _dispatchEvent(key, target, event) {
        if (!this.interactionsEnabled) return false;
        let dispatched = false;
        this._withEvents(key, (events)=>{
            $2f30431acd054e2f$export$79b2f7037acddd43(events.callbacks, (callback)=>{
                if (!callback.disposed && callback.object === target) {
                    callback.callback.call(callback.context, event);
                    dispatched = true;
                }
            });
        });
        return dispatched;
    }
    _dispatchMousedown(originalEvent, originalTarget) {
        const button = originalEvent.button;
        if (button != 0 && button != 2 && button != 1 && button !== undefined) // Ignore non-primary mouse buttons
        return;
        const event = this.getEvent(originalEvent);
        const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
        if (target) {
            const id = event.id;
            let dragged = false;
            $217bcb2fe88d1cdd$var$eachTargets(target, (obj)=>{
                const info = {
                    id: id,
                    value: obj
                };
                this._mousedown.push(info);
                if (!dragged && this._dispatchEvent("pointerdown", obj, event)) {
                    // Only dispatch the first element which matches
                    dragged = true;
                    const has = this._dragging.some((x)=>{
                        return x.value === obj && x.id === id;
                    });
                    if (!has) this._dragging.push(info);
                }
                return true;
            });
        }
        // Target-independent, mirroring globalpointermove/globalpointerup.
        this._dispatchEventAll("globalpointerdown", event);
    }
    _dispatchGlobalMousemove(originalEvent, originalTarget, native) {
        const event = this.getEvent(originalEvent);
        const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
        event.native = native;
        if (target) {
            this._hovering.forEach((obj)=>{
                if (!obj.contains(target)) {
                    this._hovering.delete(obj);
                    if (obj.cursorOverStyle) $05b1b40b69b15016$export$37a5fde709c1db82(document.body, "cursor", obj._replacedCursorStyle);
                    this._dispatchEvent("pointerout", obj, event);
                }
            });
            if (event.native) $217bcb2fe88d1cdd$var$eachTargets(target, (obj)=>{
                if (!this._hovering.has(obj)) {
                    this._hovering.add(obj);
                    if (obj.cursorOverStyle) {
                        obj._replacedCursorStyle = $05b1b40b69b15016$export$3d2f074408bd1b82(document.body, "cursor");
                        $05b1b40b69b15016$export$37a5fde709c1db82(document.body, "cursor", obj.cursorOverStyle);
                    }
                    this._dispatchEvent("pointerover", obj, event);
                }
                return true;
            });
        //} else if (target === false) {
        } else {
            this._hovering.forEach((obj)=>{
                if (obj.cursorOverStyle) $05b1b40b69b15016$export$37a5fde709c1db82(document.body, "cursor", obj._replacedCursorStyle);
                this._dispatchEvent("pointerout", obj, event);
            });
            this._hovering.clear();
        }
        this._dispatchEventAll("globalpointermove", event);
    }
    removeHovering(graphics) {
        this._hovering.delete(graphics);
        if (graphics.cursorOverStyle) $05b1b40b69b15016$export$37a5fde709c1db82(document.body, "cursor", graphics._replacedCursorStyle);
    }
    _dispatchGlobalMouseup(originalEvent, native) {
        const event = this.getEvent(originalEvent);
        event.native = native;
        //const target = this._getHitTarget(event.originalPoint);
        this._dispatchEventAll("globalpointerup", event);
    }
    _dispatchDragMove(originalEvent) {
        if (this._dragging.length !== 0) {
            const event = this.getEvent(originalEvent);
            const id = event.id;
            this._dragging.forEach((obj)=>{
                if (obj.id === id) this._dispatchEvent("pointermove", obj.value, event);
            });
        }
    }
    _dispatchDragEnd(originalEvent, originalTarget) {
        const button = originalEvent.button;
        let clickevent;
        if (button == 0 || button === undefined) clickevent = "click";
        else if (button == 2) clickevent = "rightclick";
        else if (button == 1) clickevent = "middleclick";
        else // Ignore non-primary mouse buttons
        return;
        const event = this.getEvent(originalEvent);
        const id = event.id;
        if (this._mousedown.length !== 0) {
            const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
            if (target) this._mousedown.forEach((obj)=>{
                if (obj.id === id && obj.value.contains(target)) this._dispatchEvent(clickevent, obj.value, event);
            });
            this._mousedown.length = 0;
        }
        if (this._dragging.length !== 0) {
            this._dragging.forEach((obj)=>{
                if (obj.id === id) this._dispatchEvent("pointerup", obj.value, event);
            });
            this._dragging.length = 0;
        }
    }
    _dispatchDoubleClick(originalEvent, originalTarget) {
        const event = this.getEvent(originalEvent);
        const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
        if (target) $217bcb2fe88d1cdd$var$eachTargets(target, (obj)=>{
            if (this._dispatchEvent("dblclick", obj, event)) return false;
            else return true;
        });
    }
    _dispatchWheel(originalEvent, originalTarget) {
        const event = this.getEvent(originalEvent);
        const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
        if (target) $217bcb2fe88d1cdd$var$eachTargets(target, (obj)=>{
            if (this._dispatchEvent("wheel", obj, event)) return false;
            else return true;
        });
    }
    _makeSharedEvent(key, f) {
        if (this._listeners[key] === undefined) {
            const listener = f();
            this._listeners[key] = new (0, $a363f66303166aa1$export$8a02b29de282f67f)(()=>{
                delete this._listeners[key];
                listener.dispose();
            });
        }
        return this._listeners[key].increment();
    }
    _onPointerEvent(name, f) {
        let native = false;
        let timer = null;
        function clear() {
            timer = null;
            native = false;
        }
        return new (0, $a363f66303166aa1$export$9720df365053d143)([
            new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
                if (timer !== null) clearTimeout(timer);
                clear();
            }),
            $05b1b40b69b15016$export$3f65cefe8380dbea(this.view, $05b1b40b69b15016$export$e9a3efe7940d0764(name), (_)=>{
                native = true;
                if (timer !== null) clearTimeout(timer);
                timer = window.setTimeout(clear, 0);
            }),
            $217bcb2fe88d1cdd$var$onPointerEvent(window, name, (ev, target)=>{
                if (timer !== null) {
                    clearTimeout(timer);
                    timer = null;
                }
                f(ev, target, native);
                native = false;
            })
        ]);
    }
    // This ensures that only a single DOM event is added (e.g. only a single mousemove event listener)
    _initEvent(key) {
        switch(key){
            case "globalpointermove":
            case "pointerover":
            case "pointerout":
                return this._makeSharedEvent("pointermove", ()=>{
                    const listener = (events, target, native)=>{
                        this._lastPointerMoveEvent = {
                            events: events,
                            target: target,
                            native: native
                        };
                        $2f30431acd054e2f$export$79b2f7037acddd43(events, (event)=>{
                            this._dispatchGlobalMousemove(event, target, native);
                        });
                    };
                    return new (0, $a363f66303166aa1$export$9720df365053d143)([
                        this._onPointerEvent("pointerdown", listener),
                        this._onPointerEvent("pointermove", listener)
                    ]);
                });
            case "globalpointerup":
                return this._makeSharedEvent("pointerup", ()=>{
                    const mouseup = this._onPointerEvent("pointerup", (events, target, native)=>{
                        $2f30431acd054e2f$export$79b2f7037acddd43(events, (event)=>{
                            this._dispatchGlobalMouseup(event, native);
                        });
                        this._lastPointerMoveEvent = {
                            events: events,
                            target: target,
                            native: native
                        };
                    });
                    const pointercancel = this._onPointerEvent("pointercancel", (events, target, native)=>{
                        $2f30431acd054e2f$export$79b2f7037acddd43(events, (event)=>{
                            this._dispatchGlobalMouseup(event, native);
                        });
                        this._lastPointerMoveEvent = {
                            events: events,
                            target: target,
                            native: native
                        };
                    });
                    return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
                        mouseup.dispose();
                        pointercancel.dispose();
                    });
                });
            case "click":
            case "rightclick":
            case "middleclick":
            case "pointerdown":
            /*
                return this._makeSharedEvent("pointerdown", () => {
                    return this._onPointerEvent("pointerdown", (event, target, native) => {
                        this._lastPointerMoveEvent = { event, target, native };
                        this._dispatchMousedown(event)
                    });
                });
            */ // Must share the "pointerdown" bundle: a separate one would win the
            // slot and leave later subscribers without dragmove/dragend.
            case "globalpointerdown":
            case "pointermove":
            case "pointerup":
                return this._makeSharedEvent("pointerdown", ()=>{
                    //const throttler = new Throttler();
                    const mousedown = this._onPointerEvent("pointerdown", (events, target)=>{
                        $2f30431acd054e2f$export$79b2f7037acddd43(events, (ev)=>{
                            this._dispatchMousedown(ev, target);
                        });
                    });
                    // TODO handle throttling properly for multitouch
                    const mousemove = this._onPointerEvent("pointermove", (ev)=>{
                        //throttler.throttle(() => {
                        $2f30431acd054e2f$export$79b2f7037acddd43(ev, (ev)=>{
                            this._dispatchDragMove(ev);
                        });
                    //});
                    });
                    const mouseup = this._onPointerEvent("pointerup", (ev, target)=>{
                        $2f30431acd054e2f$export$79b2f7037acddd43(ev, (ev)=>{
                            this._dispatchDragEnd(ev, target);
                        });
                    });
                    const pointercancel = this._onPointerEvent("pointercancel", (ev, target)=>{
                        $2f30431acd054e2f$export$79b2f7037acddd43(ev, (ev)=>{
                            this._dispatchDragEnd(ev, target);
                        });
                    });
                    return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
                        mousedown.dispose();
                        mousemove.dispose();
                        mouseup.dispose();
                        pointercancel.dispose();
                    });
                });
            case "dblclick":
                return this._makeSharedEvent("dblclick", ()=>{
                    return this._onPointerEvent("dblclick", (ev, target)=>{
                        $2f30431acd054e2f$export$79b2f7037acddd43(ev, (ev)=>{
                            this._dispatchDoubleClick(ev, target);
                        });
                    });
                });
            case "wheel":
                return this._makeSharedEvent("wheel", ()=>{
                    return $05b1b40b69b15016$export$3f65cefe8380dbea(this.view, $05b1b40b69b15016$export$e9a3efe7940d0764("wheel"), (event)=>{
                        this._dispatchWheel(event, $05b1b40b69b15016$export$e58f029f0fbfdb29(event));
                    }, {
                        passive: false
                    });
                });
        }
    }
    _addEvent(object, key, callback, context) {
        let events = this._events[key];
        if (events === undefined) events = this._events[key] = {
            disposer: this._initEvent(key),
            callbacks: [],
            dispatching: false,
            cleanup: false
        };
        const listener = {
            object: object,
            context: context,
            callback: callback,
            disposed: false
        };
        events.callbacks.push(listener);
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            listener.disposed = true;
            if (events.dispatching) events.cleanup = true;
            else {
                $2f30431acd054e2f$export$2529f734547e2830(events.callbacks, listener);
                if (events.callbacks.length === 0) {
                    events.disposer.dispose();
                    delete this._events[key];
                }
            }
        });
    }
    getCanvas(root, options) {
        // Make sure everything is rendered
        this.render(root);
        if (!options) options = {};
        let scale = this.resolution;
        let canvasWidth = Math.floor(this._calculatedWidth * this.resolution);
        let canvasHeight = Math.floor(this._calculatedHeight * this.resolution);
        // Check if we need to scale
        if (options.minWidth && options.minWidth > canvasWidth) {
            let minScale = options.minWidth / canvasWidth;
            if (minScale > scale) scale = minScale * this.resolution;
        }
        if (options.minHeight && options.minHeight > canvasHeight) {
            let minScale = options.minHeight / canvasHeight;
            if (minScale > scale) scale = minScale * this.resolution;
        }
        if (options.maxWidth && options.maxWidth < canvasWidth) {
            let maxScale = options.maxWidth / canvasWidth;
            if (maxScale < scale) scale = maxScale * this.resolution;
        }
        if (options.maxHeight && options.maxHeight > canvasHeight) {
            let maxScale = options.maxHeight / canvasHeight;
            if (maxScale < scale) scale = maxScale * this.resolution;
        }
        // Check if we need to compensate for pixel ratio
        if (options.maintainPixelRatio) scale /= this.resolution;
        // Init list canvases to remove from DOM after export
        const canvases = [];
        // Set up new canvas for export
        let forceRender = false;
        const canvas = document.createElement("canvas");
        if (scale != this.resolution) {
            forceRender = true;
            canvasWidth = canvasWidth * scale / this.resolution;
            canvasHeight = canvasHeight * scale / this.resolution;
        }
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        // Add to DOM so it inherits CSS
        canvas.style.position = "fixed";
        canvas.style.top = "-10000px";
        this.view.appendChild(canvas);
        canvases.push(canvas);
        // Context
        const context = canvas.getContext("2d");
        let width = 0;
        let height = 0;
        let needRerender = false;
        $2f30431acd054e2f$export$79b2f7037acddd43(this.layers, (layer)=>{
            if (layer && layer.visible) {
                if (layer.tainted || forceRender) {
                    needRerender = true;
                    layer.exportableView = layer.view;
                    layer.exportableContext = layer.context;
                    layer.view = document.createElement("canvas");
                    // Add to DOM so it inherits CSS
                    layer.view.style.position = "fixed";
                    layer.view.style.top = "-10000px";
                    this.view.appendChild(layer.view);
                    canvases.push(layer.view);
                    let extraX = 0;
                    let extraY = 0;
                    if (layer.margin) {
                        extraX += layer.margin.left || 0 + layer.margin.right || 0;
                        extraY += layer.margin.top || 0 + layer.margin.bottom || 0;
                    }
                    layer.view.width = canvasWidth + extraX;
                    layer.view.height = canvasHeight + extraY;
                    layer.context = layer.view.getContext("2d");
                    layer.dirty = true;
                    layer.scale = scale;
                }
            }
        });
        if (needRerender) {
            this._omitTainted = true;
            this.render(root);
            this._omitTainted = false;
        }
        $2f30431acd054e2f$export$79b2f7037acddd43(this.layers, (layer)=>{
            if (layer && layer.visible) {
                // Layer is fine. Just plop it into our target canvas
                let x = 0;
                let y = 0;
                if (layer.margin) {
                    x = -(layer.margin.left || 0) * this.resolution;
                    y = -(layer.margin.top || 0) * this.resolution;
                }
                context.drawImage(layer.view, x, y);
                // Restore layer original canvas
                if (layer.exportableView) {
                    layer.view = layer.exportableView;
                    layer.exportableView = undefined;
                }
                if (layer.exportableContext) {
                    layer.context = layer.exportableContext;
                    layer.exportableContext = undefined;
                }
                if (width < layer.view.clientWidth) width = layer.view.clientWidth;
                if (height < layer.view.clientHeight) height = layer.view.clientHeight;
                layer.scale = undefined;
            }
        });
        canvas.style.width = width + "px";
        canvas.style.height = height + "px";
        $2f30431acd054e2f$export$79b2f7037acddd43(canvases, (canvas)=>{
            canvas.style.position = "";
            canvas.style.top = "";
            this.view.removeChild(canvas);
        });
        return canvas;
    }
}
class $217bcb2fe88d1cdd$var$GhostLayer {
    constructor(){
        this.margin = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this._resolution = 1;
        this._width = 0;
        this._height = 0;
        this.view = document.createElement("canvas");
        this.context = this.view.getContext("2d", {
            alpha: false,
            willReadFrequently: true
        });
        this.context.imageSmoothingEnabled = false;
        this.view.style.position = "absolute";
        this.view.style.top = "0px";
        this.view.style.left = "0px";
    }
    resize(canvasWidth, canvasHeight, domWidth, domHeight, resolution) {
        this._resolution = resolution;
        canvasWidth += this.margin.left + this.margin.right;
        canvasHeight += this.margin.top + this.margin.bottom;
        // TODO this should take into account calculateSize
        domWidth += this.margin.left + this.margin.right;
        domHeight += this.margin.top + this.margin.bottom;
        this.view.style.left = -this.margin.left + "px";
        this.view.style.top = -this.margin.top + "px";
        this._width = Math.floor(canvasWidth * resolution);
        this._height = Math.floor(canvasHeight * resolution);
        this.view.width = this._width;
        this.view.style.width = domWidth + "px";
        this.view.height = this._height;
        this.view.style.height = domHeight + "px";
    }
    getImageData(point, bbox) {
        return this.context.getImageData(// TODO should this round ?
        Math.round((point.x - bbox.left) / bbox.width * this._width), Math.round((point.y - bbox.top) / bbox.height * this._height), 1, 1);
    }
    getImageArray(point) {
        if (!this.imageArray) this.imageArray = this.context.getImageData(0, 0, this._width, this._height).data;
        const data = this.imageArray;
        const x = Math.round(point.x * this._resolution);
        const y = Math.round(point.y * this._resolution);
        const i = (y * this._width + x) * 4;
        return [
            data[i],
            data[i + 1],
            data[i + 2],
            data[i + 3]
        ];
    }
    setMargin(layers) {
        this.margin.left = 0;
        this.margin.right = 0;
        this.margin.top = 0;
        this.margin.bottom = 0;
        $2f30431acd054e2f$export$79b2f7037acddd43(layers, (layer)=>{
            if (layer.margin) {
                this.margin.left = Math.max(this.margin.left, layer.margin.left);
                this.margin.right = Math.max(this.margin.right, layer.margin.right);
                this.margin.top = Math.max(this.margin.top, layer.margin.top);
                this.margin.bottom = Math.max(this.margin.bottom, layer.margin.bottom);
            }
        });
    }
    clear() {
        this.context.save();
        this.context.fillStyle = '#000';
        this.context.fillRect(0, 0, this._width, this._height);
    }
}
class $217bcb2fe88d1cdd$export$7b8f87dabf3b6ee0 {
    constructor(view, context){
        this.tainted = true;
        this.order = 0;
        this.visible = true;
        this.dirty = true;
        this._width = 0;
        this._height = 0;
        this.view = view;
        this.context = context;
    }
    resize(canvasWidth, canvasHeight, domWidth, domHeight, resolution) {
        // TODO should this take into account calculateSize ?
        if (this.width != null) {
            canvasWidth = this.width;
            domWidth = this.width;
        }
        // TODO should this take into account calculateSize ?
        if (this.height != null) {
            canvasHeight = this.height;
            domHeight = this.height;
        }
        if (this.margin) {
            canvasWidth += this.margin.left + this.margin.right;
            canvasHeight += this.margin.top + this.margin.bottom;
            // TODO this should take into account calculateSize
            domWidth += this.margin.left + this.margin.right;
            domHeight += this.margin.top + this.margin.bottom;
            this.view.style.left = -this.margin.left + "px";
            this.view.style.top = -this.margin.top + "px";
        } else {
            this.view.style.left = "0px";
            this.view.style.top = "0px";
        }
        this._width = Math.floor(canvasWidth * resolution);
        this._height = Math.floor(canvasHeight * resolution);
        this.view.width = this._width;
        this.view.style.width = domWidth + "px";
        this.view.height = this._height;
        this.view.style.height = domHeight + "px";
    }
    clear() {
        this.context.save();
        this.context.clearRect(0, 0, this._width, this._height);
    }
}













function $7803fe0a06c1ef65$var$rAF(fps, callback) {
    if (fps == null) requestAnimationFrame(callback);
    else setTimeout(()=>{
        requestAnimationFrame(callback);
    }, 1000 / fps);
}
class $7803fe0a06c1ef65$export$be92b6f5f03c0fe9 {
    constructor(id, settings = {}, isReal){
        this._isDirty = false;
        this._isDirtyParents = false;
        this._isDirtyAnimation = false;
        this._dirty = {};
        this._dirtyParents = {};
        this._dirtyBounds = {};
        this._dirtyPositions = {};
        this._ticker = null;
        this._tickers = [];
        this._updateTick = true;
        this.skipRenderFrame = false;
        /**
         * Root's event dispatcher.
         *
         * @see {@link https://www.amcharts.com/docs/v5/concepts/events/} for more info
         */ this.events = new (0, $7e417cbab1b21893$export$ec8b666c5fe2c75a)();
        /**
         * @ignore
         * @todo needs description
         */ this.animationTime = null;
        this._animations = [];
        // Locale-related
        /**
         * @ignore
         */ this.language = (0, $a5f7473fad5303dc$export$ce4fe1c9e6520c1a).new(this, {});
        /**
         * Locale used by the chart.
         *
         * @see {@link https://www.amcharts.com/docs/v5/concepts/locales/}
         */ this.locale = (0, $8ced240747ebccef$export$2e2bcd8739ae039);
        // Date-time related
        /**
         * Use UTC when formatting date/time.
         *
         * @see {@link https://www.amcharts.com/docs/v5/concepts/formatters/formatting-dates/#utc-and-time-zones} for more info
         */ this.utc = false;
        /**
         * Number formatter.
         *
         * @see {@link https://www.amcharts.com/docs/v5/concepts/formatters/formatting-numbers/} for more info
         */ this.numberFormatter = (0, $b20322a184511108$export$cc77c4ff7e8673c5).new(this, {});
        /**
         * Date/time formatter.
         *
         * @see {@link https://www.amcharts.com/docs/v5/concepts/formatters/formatting-dates/} for more info
         */ this.dateFormatter = (0, $31c1b4011aa9c6de$export$ad991b66133851cf).new(this, {});
        /**
         * Duration formatter.
         *
         * @see {@link https://www.amcharts.com/docs/v5/concepts/formatters/formatting-dates/} for more info
         */ this.durationFormatter = (0, $e14cdfadb6108833$export$cee2d4e6b36ce468).new(this, {});
        // Accessibility
        /**
         * Global tab index for using for the whole chart
         *
         * @see {@link https://www.amcharts.com/docs/v5/concepts/accessibility/} for more info
         */ this.tabindex = 0;
        //@todo maybe make this better
        this._tabindexes = [];
        this._a11yD = false;
        this._focusElementDirty = false;
        this._skipNextGroupJump = true;
        /**
         * An instance of vertical layout object that can be used to set `layout` setting
         * of a [[Container]].
         *
         * @default VerticalLayout.new()
         */ this.verticalLayout = (0, $b05f413a7bdbea0f$export$e4d3124dc23dc9c9).new(this, {});
        /**
         * An instance of horizontal layout object that can be used to set `layout` setting
         * of a [[Container]].
         *
         * @default HorizontalLayout.new()
         */ this.horizontalLayout = (0, $ce42d27226ec20a0$export$8be7400f61e793f0).new(this, {});
        /**
         * An instance of grid layout object that can be used to set `layout` setting
         * of a [[Container]].
         *
         * @default VerticalLayout.new()
         */ this.gridLayout = (0, $9961b4caf46ffbfc$export$7d2b12578154a735).new(this, {});
        this._paused = false;
        /**
         * Indicates whether chart should resized automatically when parent container
         * width and/or height changes.
         *
         * If disabled (`autoResize = false`) you can make the chart resize manually
         * by calling root element's `resize()` method.
         */ this.autoResize = true;
        this._fontHash = [];
        this._isDisposed = false;
        this._disposers = [];
        this._tooltips = [];
        this._htmlEnabledContainers = [];
        /**
         * Entities that have their `id` setting set.
         *
         * @since 5.11.0
         */ this.entitiesById = {};
        if (!isReal) throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
        this._settings = settings;
        if (settings.accessible == false) this._a11yD = true;
        if (settings.useSafeResolution == null) settings.useSafeResolution = true;
        if (settings.sanitizeHTML == null) settings.sanitizeHTML = true;
        let resolution;
        if (settings.useSafeResolution) resolution = $05b1b40b69b15016$export$48067e34605ab48a();
        this._renderer = new (0, $217bcb2fe88d1cdd$export$7adc20298958481a)(resolution);
        let dom;
        if (id instanceof HTMLElement) dom = id;
        else dom = document.getElementById(id);
        $2f30431acd054e2f$export$79b2f7037acddd43((0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).rootElements, (root)=>{
            if (root.dom === dom) {
                if ((0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).autoDispose) root.dispose();
                else throw new Error("You cannot have multiple Roots on the same DOM node");
            }
        });
        this.interfaceColors = (0, $78e10ff73ddf6061$export$8dce48c3552f8697).new(this, {});
        if (dom === null) throw new Error("Could not find HTML element with id `" + id + "`");
        this.dom = dom;
        let inner = document.createElement("div");
        inner.style.position = "relative";
        inner.style.width = "100%";
        inner.style.height = "100%";
        dom.appendChild(inner);
        const tooltipContainerBounds = settings.tooltipContainerBounds;
        if (tooltipContainerBounds) this._tooltipContainerSettings = tooltipContainerBounds;
        this._inner = inner;
        this._updateComputedStyles();
        (0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).rootElements.push(this);
    }
    static new(id, settings) {
        const root = new $7803fe0a06c1ef65$export$be92b6f5f03c0fe9(id, settings, true);
        root._init();
        return root;
    }
    moveDOM(id) {
        let dom;
        if (id instanceof HTMLElement) dom = id;
        else dom = document.getElementById(id);
        if (dom) {
            while(this.dom.childNodes.length > 0)dom.appendChild(this.dom.childNodes[0]);
            this.dom = dom;
            this._initResizeSensor();
            this.resize();
        }
    }
    _handleLogo() {
        if (this._logo) {
            const w = this.dom.offsetWidth;
            const h = this.dom.offsetHeight;
            if (w <= 150 || h <= 60) this._logo.hide();
            else this._logo.show();
        }
    }
    _showBranding() {
        if (!this._logo) {
            const logo = this.tooltipContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this, {
                interactive: true,
                interactiveChildren: false,
                position: "absolute",
                setStateOnChildren: true,
                paddingTop: 9,
                paddingRight: 9,
                paddingBottom: 9,
                paddingLeft: 9,
                scale: .6,
                y: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(100),
                centerY: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
                tooltipY: 10,
                tooltipText: "Created using amCharts 5",
                tooltipX: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
                cursorOverStyle: "pointer",
                background: (0, $9e0cea1ea085e274$export$4617fb02663045ef).new(this, {
                    fill: (0, $389de129b6cd18b1$export$35e9368ef982300f)(0x474758),
                    fillOpacity: 0,
                    tooltipY: 5
                })
            }));
            logo.set("tooltip", this.systemTooltip);
            logo.events.on("click", ()=>{
                window.open("https://www.amcharts.com/", "_blank");
            });
            logo.states.create("hover", {});
            const m = logo.children.push((0, $2ffdafbe1fe6a946$export$29d3e417456abdad).new(this, {
                stroke: (0, $389de129b6cd18b1$export$35e9368ef982300f)(0xcccccc),
                strokeWidth: 3,
                svgPath: "M5 25 L13 25h13.6c3.4 0 6 0 10.3-4.3s5.2-12 8.6-12c3.4 0 4.3 8.6 7.7 8.6M83.4 25H79.8c-3.4 0-6 0-10.3-4.3s-5.2-12-8.6-12-4.3 8.6-7.7 8.6",
                dx: -50,
                strokeOpacity: 0
            }));
            m.states.create("hover", {
                stroke: (0, $389de129b6cd18b1$export$35e9368ef982300f)(0x3CABFF)
            });
            const a = logo.children.push((0, $2ffdafbe1fe6a946$export$29d3e417456abdad).new(this, {
                stroke: (0, $389de129b6cd18b1$export$35e9368ef982300f)(0x888888),
                strokeWidth: 3,
                svgPath: "M83.4 25h-31C37 25 39.5 4.4 28.4 4.4S18.9 24.2 4.3 25H0",
                dx: 50,
                strokeOpacity: 0
            }));
            const easing = $b4231ef84a5f8a61$export$ca49d7cd8ea40ba7($b4231ef84a5f8a61$export$bdd5293f3cf7a909);
            const duration = 1500;
            logo.setTimeout(()=>{
                a.animate({
                    key: "strokeOpacity",
                    to: 1,
                    duration: duration,
                    easing: easing
                });
                a.animate({
                    key: "dx",
                    to: 0,
                    duration: duration,
                    easing: easing
                });
                m.animate({
                    key: "dx",
                    to: 0,
                    duration: duration,
                    easing: easing
                });
                m.animate({
                    key: "strokeOpacity",
                    to: 1,
                    duration: duration,
                    easing: easing
                });
            }, 3000);
            a.states.create("hover", {
                stroke: (0, $389de129b6cd18b1$export$35e9368ef982300f)(0x474758)
            });
            this._logo = logo;
            this._handleLogo();
        }
    }
    _getRealSize() {
        return this.dom.getBoundingClientRect();
    }
    _getCalculatedSize(rect) {
        if (this._settings.calculateSize) return this._settings.calculateSize(rect);
        else return {
            width: rect.width,
            height: rect.height
        };
    }
    _init() {
        const settings = this._settings;
        if (settings.accessible !== false) {
            if (settings.focusable) {
                this._inner.setAttribute("focusable", "true");
                this._inner.setAttribute("tabindex", this.tabindex + "");
            }
            if (settings.ariaLabel) this._inner.setAttribute("aria-label", settings.ariaLabel);
            if (settings.role) this._inner.setAttribute("role", settings.role);
        }
        const renderer = this._renderer;
        const rect = this._getRealSize();
        const size = this._getCalculatedSize(rect);
        const width = Math.floor(size.width);
        const height = Math.floor(size.height);
        const realWidth = Math.floor(rect.width);
        const realHeight = Math.floor(rect.height);
        const rootContainer = (0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this, {
            visible: true,
            width: width,
            height: height
        });
        this._rootContainer = rootContainer;
        this._rootContainer._defaultThemes.push((0, $c53b0c859cf33b39$export$48bc85c4a6e4243b).new(this));
        const container = rootContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this, {
            visible: true,
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        }));
        this.container = container;
        renderer.resize(realWidth, realHeight, width, height);
        //@todo: better appendChild - refer
        this._inner.appendChild(renderer.view);
        // TODO: TMP TMP TMP for testing only, remove
        //renderer.debugGhostView = true;
        this._initResizeSensor();
        // HTML content holder
        const htmlElementContainer = document.createElement("div");
        this._htmlElementContainer = htmlElementContainer;
        htmlElementContainer.className = "am5-html-container";
        htmlElementContainer.style.position = "absolute";
        htmlElementContainer.style.pointerEvents = "none";
        if (!this._tooltipContainerSettings) htmlElementContainer.style.overflow = "hidden";
        this._inner.appendChild(htmlElementContainer);
        if (this._a11yD !== true) {
            // Create element which is used to make announcements to screen reader
            const readerAlertElement = document.createElement("div");
            readerAlertElement.className = "am5-reader-container";
            readerAlertElement.setAttribute("role", "alert");
            // readerAlertElement.style.zIndex = "-100000";
            // readerAlertElement.style.opacity = "0";
            // readerAlertElement.style.top = "0";
            readerAlertElement.style.position = "absolute";
            readerAlertElement.style.width = "1px";
            readerAlertElement.style.height = "1px";
            readerAlertElement.style.overflow = "hidden";
            readerAlertElement.style.clip = "rect(1px, 1px, 1px, 1px)";
            this._readerAlertElement = readerAlertElement;
            this._inner.appendChild(this._readerAlertElement);
            const focusElementContainer = document.createElement("div");
            focusElementContainer.className = "am5-focus-container";
            focusElementContainer.style.position = "absolute";
            focusElementContainer.style.pointerEvents = "none";
            focusElementContainer.style.top = "0px";
            focusElementContainer.style.left = "0px";
            focusElementContainer.style.overflow = "hidden";
            focusElementContainer.style.width = width + "px";
            focusElementContainer.style.height = height + "px";
            focusElementContainer.setAttribute("role", "graphics-document");
            if (settings.ariaLabel) focusElementContainer.setAttribute("aria-label", settings.ariaLabel);
            $05b1b40b69b15016$export$2dc32695cee26cb(focusElementContainer, false);
            this._focusElementContainer = focusElementContainer;
            this._inner.appendChild(this._focusElementContainer);
            const tooltipElementContainer = document.createElement("div");
            this._tooltipElementContainer = tooltipElementContainer;
            tooltipElementContainer.className = "am5-tooltip-container";
            this._inner.appendChild(tooltipElementContainer);
            // Add keyboard events for accessibility, e.g. simulating drag with arrow
            // keys and click with ENTER
            if ($05b1b40b69b15016$export$cde6a56f9669daf6("keyboardevents")) {
                this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(window, "keydown", (ev)=>{
                    const eventKey = $05b1b40b69b15016$export$f7a7490116b79d4d(ev);
                    if (eventKey == "Shift") this._isShift = true;
                    else if (eventKey == "Tab") this._isShift = ev.shiftKey;
                }));
                this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(window, "keyup", (ev)=>{
                    const eventKey = $05b1b40b69b15016$export$f7a7490116b79d4d(ev);
                    if (eventKey == "Shift") this._isShift = false;
                }));
                this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(focusElementContainer, "click", ()=>{
                    // Some screen readers convert ENTER (and some SPACE) press whil on
                    // focused element to a "click" event, preventing actual "keydown"
                    // event from firing. We're using this "click" event to still
                    // generate internal click events.
                    const focusedSprite = this._focusedSprite;
                    if (focusedSprite) {
                        const announceText = focusedSprite.get("clickAnnounceText", "");
                        if (announceText !== "") this.readerAlert(announceText);
                        const downEvent = renderer.getEvent(new MouseEvent("click"));
                        focusedSprite.events.dispatch("click", {
                            type: "click",
                            originalEvent: downEvent.event,
                            point: downEvent.point,
                            simulated: true,
                            target: focusedSprite
                        });
                    }
                }));
                this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(focusElementContainer, "keydown", (ev)=>{
                    const focusedSprite = this._focusedSprite;
                    if (focusedSprite) {
                        if (ev.key == "Escape") {
                            // ESC pressed - lose current focus
                            $05b1b40b69b15016$export$2cc7ff91bcacba5e();
                            this._focusedSprite = undefined;
                        }
                        let dragOffsetX = 0;
                        let dragOffsetY = 0;
                        // TODO: figure out if using bogus MouseEvent is fine, or it will
                        // fail on some platforms
                        const eventKey = $05b1b40b69b15016$export$f7a7490116b79d4d(ev);
                        switch(eventKey){
                            case "Enter":
                            case " ":
                                const announceText = focusedSprite.get("clickAnnounceText", "");
                                if (announceText !== "") this.readerAlert(announceText);
                                if (eventKey == " " && focusedSprite.get("role") != "checkbox") return;
                                ev.preventDefault();
                                const downEvent = renderer.getEvent(new MouseEvent("mouse"));
                                focusedSprite.events.dispatch("click", {
                                    type: "click",
                                    originalEvent: downEvent.event,
                                    point: downEvent.point,
                                    simulated: true,
                                    target: focusedSprite
                                });
                                return;
                            case "ArrowLeft":
                                dragOffsetX = -6;
                                break;
                            case "ArrowRight":
                                dragOffsetX = 6;
                                break;
                            case "ArrowUp":
                                dragOffsetY = -6;
                                break;
                            case "ArrowDown":
                                dragOffsetY = 6;
                                break;
                            default:
                                return;
                        }
                        if (dragOffsetX != 0 || dragOffsetY != 0) {
                            ev.preventDefault();
                            if (!focusedSprite.isDragging()) {
                                // Start dragging
                                this._keyboardDragPoint = {
                                    x: 0,
                                    y: 0
                                };
                                const downEvent = renderer.getEvent(new MouseEvent("mousedown", {
                                    clientX: 0,
                                    clientY: 0
                                }));
                                downEvent.point = {
                                    x: 0,
                                    y: 0
                                };
                                if (focusedSprite.events.isEnabled("pointerdown")) focusedSprite.events.dispatch("pointerdown", {
                                    type: "pointerdown",
                                    originalEvent: downEvent.event,
                                    point: downEvent.point,
                                    simulated: true,
                                    target: focusedSprite
                                });
                            }
                            // Move incrementally
                            const dragPoint = this._keyboardDragPoint;
                            dragPoint.x += dragOffsetX;
                            dragPoint.y += dragOffsetY;
                            const moveEvent = renderer.getEvent(new MouseEvent("mousemove", {
                                clientX: dragPoint.x,
                                clientY: dragPoint.y
                            }), false);
                            if (focusedSprite.events.isEnabled("globalpointermove")) focusedSprite.events.dispatch("globalpointermove", {
                                type: "globalpointermove",
                                originalEvent: moveEvent.event,
                                point: moveEvent.point,
                                simulated: true,
                                target: focusedSprite
                            });
                        }
                    }
                }));
                this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(focusElementContainer, "keyup", (ev)=>{
                    if (this._focusedSprite) {
                        const focusedSprite = this._focusedSprite;
                        const eventKey = $05b1b40b69b15016$export$f7a7490116b79d4d(ev);
                        switch(eventKey){
                            case "ArrowLeft":
                            case "ArrowRight":
                            case "ArrowUp":
                            case "ArrowDown":
                                if (focusedSprite.isDragging()) {
                                    // Simulate drag stop
                                    const dragPoint = this._keyboardDragPoint;
                                    const upEvent = renderer.getEvent(new MouseEvent("mouseup", {
                                        clientX: dragPoint.x,
                                        clientY: dragPoint.y
                                    }));
                                    if (focusedSprite.events.isEnabled("globalpointerup")) focusedSprite.events.dispatch("globalpointerup", {
                                        type: "globalpointerup",
                                        originalEvent: upEvent.event,
                                        point: upEvent.point,
                                        simulated: true,
                                        target: focusedSprite
                                    });
                                    //this._positionFocusElement(focusedSprite);
                                    this._keyboardDragPoint = undefined;
                                    // @todo dispatch mouseup event instead of calling dragStop?
                                    // this._dispatchEvent("globalpointerup", target, upEvent);
                                    return;
                                } else if (focusedSprite.get("focusableGroup")) {
                                    // Find next item in focusable group
                                    const group = focusedSprite.get("focusableGroup");
                                    const items = this._tabindexes.filter((item)=>{
                                        return item.get("focusableGroup") == group && item.getPrivate("focusable") !== false && item.isVisibleDeep() ? true : false;
                                    });
                                    let index = items.indexOf(focusedSprite);
                                    const lastIndex = items.length - 1;
                                    index += eventKey == "ArrowRight" || eventKey == "ArrowDown" ? 1 : -1;
                                    if (index < 0) index = lastIndex;
                                    else if (index > lastIndex) index = 0;
                                    $05b1b40b69b15016$export$d7ddd398f22d79ef(items[index].getPrivate("focusElement").dom);
                                }
                                break;
                            case "Tab":
                                const group = focusedSprite.get("focusableGroup");
                                if (group && this._isShift) {
                                    if (!this._skipNextGroupJump) {
                                        this._focusNext(focusedSprite.getPrivate("focusElement").dom, -1, group);
                                        this._skipNextGroupJump = true;
                                    }
                                    return;
                                }
                                break;
                        }
                    }
                }));
            }
        }
        this._startTicker();
        this.setThemes([]);
        this._addTooltip();
        if (!this._hasLicense()) this._showBranding();
    }
    /**
     * Returns an instance of a universal [[Tooltip]] instance.
     * @since 5.14.0
     */ get systemTooltip() {
        if (!this._systemTooltip) {
            const tooltip = (0, $670fc48e4ddbc086$export$28c660c63b792dea).new(this, {
                themeTags: [
                    "system"
                ]
            });
            this._systemTooltip = tooltip;
        }
        return this._systemTooltip;
    }
    _initResizeSensor() {
        if (this._resizeSensorDisposer) this._resizeSensorDisposer.dispose();
        this._resizeSensorDisposer = new (0, $fcc21c9236571fac$export$99e7f5e92b1f0cf9)(this.dom, ()=>{
            if (this.autoResize) this.resize();
        });
        this._disposers.push(this._resizeSensorDisposer);
    }
    /**
     * If automatic resizing of char is disabled (`root.autoResize = false`), it
     * can be resized manually by calling this method.
     */ resize() {
        const rect = this._getRealSize();
        const size = this._getCalculatedSize(rect);
        const w = Math.floor(size.width);
        const h = Math.floor(size.height);
        if (w > 0 && h > 0) {
            const realWidth = Math.floor(rect.width);
            const realHeight = Math.floor(rect.height);
            const htmlElementContainer = this._htmlElementContainer;
            htmlElementContainer.style.width = w + "px";
            htmlElementContainer.style.height = h + "px";
            if (this._a11yD !== true) {
                const focusElementContainer = this._focusElementContainer;
                focusElementContainer.style.width = w + "px";
                focusElementContainer.style.height = h + "px";
            }
            this._renderer.resize(realWidth, realHeight, w, h);
            const rootContainer = this._rootContainer;
            rootContainer.setPrivate("width", w);
            rootContainer.setPrivate("height", h);
            this._render();
            this._handleLogo();
        }
    }
    /**
     * Re-applies the current `_settings` to the live `Root` and its sub-objects
     * without tearing anything down.
     *
     * Unlike `_init()`, this creates no new containers, DOM elements, or event
     * listeners. Use it after changing settings on an already-initialized `Root`
     * (e.g. from a parsed `root` config section).
     *
     * NOTE: `accessible` can only be turned off (matching constructor behavior);
     * it cannot be re-enabled on a live `Root`.
     *
     * @ignore
     */ _reapplySettings() {
        const settings = this._settings;
        // Renderer resolution (`useSafeResolution`). `getSafeResolution()` returns
        // `undefined` off iOS, which means "use the device pixel ratio".
        const safeResolution = $05b1b40b69b15016$export$48067e34605ab48a();
        this._renderer.resolution = settings.useSafeResolution && safeResolution != null ? safeResolution : window.devicePixelRatio;
        // Tooltip container bounds.
        if (settings.tooltipContainerBounds) this._tooltipContainerSettings = settings.tooltipContainerBounds;
        if (this._htmlElementContainer) this._htmlElementContainer.style.overflow = settings.tooltipContainerBounds ? "" : "hidden";
        // Accessibility can only be disabled, never re-enabled on a live `Root`.
        if (settings.accessible === false) this._a11yD = true;
        // Inner element ARIA / focus attributes.
        if (!this._a11yD) {
            const inner = this._inner;
            if (settings.focusable) {
                inner.setAttribute("focusable", "true");
                inner.setAttribute("tabindex", this.tabindex + "");
            } else {
                inner.removeAttribute("focusable");
                inner.removeAttribute("tabindex");
            }
            if (settings.ariaLabel != null) inner.setAttribute("aria-label", settings.ariaLabel);
            else inner.removeAttribute("aria-label");
            if (settings.role != null) inner.setAttribute("role", settings.role);
            else inner.removeAttribute("role");
        }
        // `focusPadding`, `sanitizeHTML` and `calculateSize` are read from
        // `_settings` on demand, so they need no explicit re-application.
        // Force every element to re-run its update cycle so values derived from
        // Root settings downstream (e.g. label fonts pulled from `fontFamily`/
        // `fontSize`/`fontWeight`) are re-applied. `markDirty()` on a `Container`
        // re-runs its `_updateChildren()`, which is where those values are pushed.
        if (this._rootContainer) {
            this._rootContainer.markDirty();
            this._rootContainer.walkChildren((child)=>{
                child.markDirty();
            });
        }
        // Push the new resolution / calculated size to the renderer and re-render.
        this._render();
    }
    /**
     * Root's settings.
     */ get settings() {
        return this._settings;
    }
    _render() {
        if (this.skipRenderFrame) {
            this.skipRenderFrame = false;
            return;
        }
        this._renderer.render(this._rootContainer._display);
        if (this._focusElementDirty) {
            this._updateCurrentFocus();
            this._focusElementDirty = false;
        }
    }
    _runTickers(currentTime) {
        $2f30431acd054e2f$export$79b2f7037acddd43(this._tickers, (f)=>{
            f(currentTime);
        });
    }
    _runAnimations(currentTime) {
        let running = 0;
        $2f30431acd054e2f$export$249f83d169a7c462(this._animations, (animation)=>{
            const state = animation._runAnimation(currentTime);
            if (state === (0, $43e0e2dc9c95da4e$export$d0f7a26c90cc1562).Stopped) return false;
            else if (state === (0, $43e0e2dc9c95da4e$export$d0f7a26c90cc1562).Playing) {
                ++running;
                return true;
            } else return true;
        });
        this._isDirtyAnimation = false;
        return running === 0;
    }
    _runDirties() {
        //console.time("tick");
        let allParents = {};
        while(this._isDirtyParents){
            // This must be before calling _prepareChildren
            this._isDirtyParents = false;
            $e66f9343b5144e1a$export$3e9f948b41964866(this._dirtyParents).forEach(([key, parent])=>{
                delete this._dirtyParents[key];
                if (!parent.isDisposed()) {
                    allParents[parent.uid] = parent;
                    parent._prepareChildren();
                }
            });
        }
        $e66f9343b5144e1a$export$3e9f948b41964866(allParents).forEach(([_key, parent])=>{
            parent._updateChildren();
        });
        const objects = [];
        //		console.log("_beforeChanged")
        $e66f9343b5144e1a$export$3e9f948b41964866(this._dirty).forEach(([key, entity])=>{
            if (entity.isDisposed()) delete this._dirty[key];
            else {
                objects.push(entity);
                entity._beforeChanged();
            }
        });
        //		console.log("_changed")
        objects.forEach((entity)=>{
            entity._changed();
            delete this._dirty[entity.uid];
            entity._clearDirty();
        });
        this._isDirty = false;
        const depths = {};
        const bounds = [];
        $e66f9343b5144e1a$export$3e9f948b41964866(this._dirtyBounds).forEach(([key, entity])=>{
            delete this._dirtyBounds[key];
            if (!entity.isDisposed()) {
                depths[entity.uid] = entity.depth();
                bounds.push(entity);
            }
        });
        this._positionHTMLElements();
        // High depth -> low depth
        bounds.sort((x, y)=>{
            return $919e90129af4490b$export$398604a469f7de9a(depths[y.uid], depths[x.uid]);
        });
        //		console.log("_updateBounds")
        bounds.forEach((entity)=>{
            entity._updateBounds();
        });
        //		console.log("_updatePosition")
        const dirtyPositions = this._dirtyPositions;
        $e66f9343b5144e1a$export$3e9f948b41964866(dirtyPositions).forEach(([key, sprite])=>{
            delete dirtyPositions[key];
            if (!sprite.isDisposed()) sprite._updatePosition();
        });
        //		console.log("_afterChanged")
        objects.forEach((entity)=>{
            entity._afterChanged();
        });
        $e66f9343b5144e1a$export$3e9f948b41964866(allParents).forEach(([_key, parent])=>{
            parent._childrenPrep = false;
            parent._childrenUpdt = false;
        });
    //console.timeEnd("tick");
    }
    _renderFrame(currentTime) {
        if (this._updateTick) {
            if (this.events.isEnabled("framestarted")) this.events.dispatch("framestarted", {
                type: "framestarted",
                target: this,
                timestamp: currentTime
            });
            this._checkComputedStyles();
            this._runTickers(currentTime);
            const animationDone = this._runAnimations(currentTime);
            this._runDirties();
            this._render();
            this._renderer.resetImageArray();
            this._positionHTMLElements();
            if (this.events.isEnabled("frameended")) this.events.dispatch("frameended", {
                type: "frameended",
                target: this,
                timestamp: currentTime
            });
            return this._tickers.length === 0 && animationDone && !this._isDirtyAnimation && !this._isDirty;
        } else return true;
    }
    _runTicker(currentTime, now) {
        if (!this.isDisposed()) {
            this.animationTime = currentTime;
            const done = this._renderFrame(currentTime);
            // No more work to do
            if (done) {
                this._ticker = null;
                this.animationTime = null;
            } else if (!this._paused) {
                if (now) this._ticker;
                else $7803fe0a06c1ef65$var$rAF(this.fps, this._ticker);
            }
        }
    }
    _runTickerNow(timeout = 10000) {
        if (!this.isDisposed()) {
            const endTime = performance.now() + timeout;
            for(;;){
                const currentTime = performance.now();
                if (currentTime >= endTime) {
                    this.animationTime = null;
                    break;
                }
                this.animationTime = currentTime;
                const done = this._renderFrame(currentTime);
                if (done) {
                    this.animationTime = null;
                    break;
                }
            }
        }
    }
    _startTicker() {
        if (this._ticker === null) {
            this.animationTime = null;
            this._ticker = (currentTime)=>{
                this._runTicker(currentTime);
            };
            $7803fe0a06c1ef65$var$rAF(this.fps, this._ticker);
        }
    }
    /**
     * Returns whether the root is updating or not.
     */ get updateTick() {
        return this._updateTick;
    }
    /**
     * Enables or disables the root updating.
     */ set updateTick(value) {
        this._updateTick = value;
        if (value) this._startTicker();
    }
    _addDirtyEntity(entity) {
        this._isDirty = true;
        if (this._dirty[entity.uid] === undefined) this._dirty[entity.uid] = entity;
        this._startTicker();
    }
    _addDirtyParent(parent) {
        this._isDirty = true;
        this._isDirtyParents = true;
        if (this._dirtyParents[parent.uid] === undefined) this._dirtyParents[parent.uid] = parent;
        this._startTicker();
    }
    _addDirtyBounds(entity) {
        this._isDirty = true;
        if (this._dirtyBounds[entity.uid] === undefined) this._dirtyBounds[entity.uid] = entity;
        this._startTicker();
    }
    _addDirtyPosition(sprite) {
        this._isDirty = true;
        if (this._dirtyPositions[sprite.uid] === undefined) this._dirtyPositions[sprite.uid] = sprite;
        this._startTicker();
    }
    _addAnimation(animation) {
        this._isDirtyAnimation = true;
        // TODO use numeric id instead
        if (this._animations.indexOf(animation) === -1) this._animations.push(animation);
        this._startTicker();
    }
    _markDirty() {
        this._isDirty = true;
    }
    _markDirtyRedraw() {
        this.events.once("frameended", ()=>{
            this._isDirty = true;
            this._startTicker();
        });
    }
    eachFrame(f) {
        this._tickers.push(f);
        this._startTicker();
        return new (0, $a363f66303166aa1$export$6039fc6176d96e35)(()=>{
            $2f30431acd054e2f$export$2529f734547e2830(this._tickers, f);
        });
    }
    markDirtyGlobal(container) {
        if (!container) container = this.container;
        container.walkChildren((child)=>{
            if (child instanceof (0, $5de502da8a72d65e$export$42a852a2b6b56249)) this.markDirtyGlobal(child);
            child.markDirty();
            child.markDirtyBounds();
        });
    }
    /**
     * Returns width of the target container, in pixels.
     *
     * @return Width
     */ width() {
        // TODO make this more efficient, maybe just return the renderer's width ?
        return Math.floor(this._getCalculatedSize(this._getRealSize()).width);
    }
    /**
     * Returns height of the target container, in pixels.
     *
     * @return Height
     */ height() {
        // TODO make this more efficient, maybe just return the renderer's height ?
        return Math.floor(this._getCalculatedSize(this._getRealSize()).height);
    }
    /**
     * Disposes root and all the content in it.
     */ dispose() {
        if (!this._isDisposed) {
            this._isDisposed = true;
            this._rootContainer.dispose();
            this._renderer.dispose();
            this.horizontalLayout.dispose();
            this.verticalLayout.dispose();
            this.interfaceColors.dispose();
            $2f30431acd054e2f$export$79b2f7037acddd43(this._disposers, (x)=>{
                x.dispose();
            });
            if (this._inner) $05b1b40b69b15016$export$f883456a56996078(this._inner);
            $2f30431acd054e2f$export$cd7f480d6b8286c3((0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).rootElements, this);
        }
    }
    /**
     * Returns `true` if root element is disposed.
     *
     * @return Disposed?
     */ isDisposed() {
        return this._isDisposed;
    }
    /**
     * Triggers screen reader read out a message.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/accessibility/} for more info
     * @param  text  Alert text
     */ readerAlert(text) {
        if (this._a11yD !== true) {
            const element = this._readerAlertElement;
            text = $05b1b40b69b15016$export$1fbf6f199c05a66(text);
            if (element.innerHTML == text) element.innerHTML = "";
            element.innerHTML = text;
        }
    }
    /**
     * Sets themes to be used for the chart.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/themes/} for more info
     * @param  themes  A list of themes
     */ setThemes(themes) {
        this._rootContainer.set("themes", themes);
        // otherwise new themes are not applied
        const tooltipContainer = this.tooltipContainer;
        if (tooltipContainer) tooltipContainer._applyThemes();
        // @todo review this
        const interfaceColors = this.interfaceColors;
        if (interfaceColors) interfaceColors._applyThemes();
    }
    _addTooltip() {
        if (!this.tooltipContainer) {
            const tooltipContainerSettings = this._tooltipContainerSettings;
            const tooltipContainer = this._rootContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this, {
                position: "absolute",
                isMeasured: false,
                width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
                height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
                layer: tooltipContainerSettings ? 35 : 30,
                layerMargin: tooltipContainerSettings ? tooltipContainerSettings : undefined
            }));
            this.tooltipContainer = tooltipContainer;
            const tooltip = (0, $670fc48e4ddbc086$export$28c660c63b792dea).new(this, {});
            this.container.set("tooltip", tooltip);
            tooltip.hide(0);
            this._tooltip = tooltip;
        }
    }
    /**
     * Accesibility
     */ _registerTabindexOrder(target) {
        if (this._a11yD == true) return;
        if (target.get("focusable")) $2f30431acd054e2f$export$3589e1fa93f0a8a5(this._tabindexes, target);
        else $2f30431acd054e2f$export$cd7f480d6b8286c3(this._tabindexes, target);
        this._invalidateTabindexes();
    }
    _unregisterTabindexOrder(target) {
        if (this._a11yD == true) return;
        $2f30431acd054e2f$export$cd7f480d6b8286c3(this._tabindexes, target);
        this._invalidateTabindexes();
    }
    _invalidateTabindexes() {
        if (this._a11yD == true) return;
        this._tabindexes.sort((a, b)=>{
            const aindex = a.get("tabindexOrder", 0);
            const bindex = b.get("tabindexOrder", 0);
            if (aindex == bindex) return 0;
            else if (aindex > bindex) return 1;
            else return -1;
        });
        const groups = [];
        $2f30431acd054e2f$export$79b2f7037acddd43(this._tabindexes, (item, index)=>{
            if (!item.getPrivate("focusElement")) this._makeFocusElement(index, item);
            else this._moveFocusElement(index, item);
            const group = item.get("focusableGroup");
            if (group && item.getPrivate("focusable") !== false) {
                if (groups.indexOf(group) !== -1) // Non-first element in the group, make it not directly focusable
                item.getPrivate("focusElement").dom.setAttribute("tabindex", "-1");
                else groups.push(group);
            }
        });
    }
    _updateCurrentFocus() {
        if (this._a11yD == true) return;
        if (this._focusedSprite) {
            this._decorateFocusElement(this._focusedSprite);
            this._positionFocusElement(this._focusedSprite);
        }
    }
    _decorateFocusElement(target, focusElement) {
        if (this._a11yD == true) return;
        // Decorate with proper accessibility attributes
        if (!focusElement) focusElement = target.getPrivate("focusElement").dom;
        if (!focusElement) return;
        const role = target.get("role");
        if (role) focusElement.setAttribute("role", role);
        else focusElement.removeAttribute("role");
        const ariaLabel = target.get("ariaLabel");
        if (ariaLabel) {
            const label = (0, $8d45a8a77dcd0f75$export$6a40ef019a0fa5f6)(target, ariaLabel);
            focusElement.setAttribute("aria-label", label);
        } else focusElement.removeAttribute("aria-label");
        const ariaLive = target.get("ariaLive");
        if (ariaLive) focusElement.setAttribute("aria-live", ariaLive);
        else focusElement.removeAttribute("aria-live");
        const ariaChecked = target.get("ariaChecked");
        if (ariaChecked != null && role && [
            "checkbox",
            "option",
            "radio",
            "menuitemcheckbox",
            "menuitemradio",
            "treeitem"
        ].indexOf(role) !== -1) focusElement.setAttribute("aria-checked", ariaChecked ? "true" : "false");
        else focusElement.removeAttribute("aria-checked");
        const ariaCurrent = target.get("ariaCurrent");
        if (ariaCurrent != null) focusElement.setAttribute("aria-current", ariaCurrent);
        else focusElement.removeAttribute("aria-current");
        const ariaSelected = target.get("ariaSelected");
        if (ariaSelected != null && role && [
            "gridcell",
            "option",
            "row",
            "tab",
            "columnheader",
            "rowheader",
            "treeitem"
        ].indexOf(role) !== -1) focusElement.setAttribute("aria-selected", ariaSelected ? "true" : "false");
        else focusElement.removeAttribute("aria-selected");
        if (target.get("ariaHidden")) focusElement.setAttribute("aria-hidden", "true");
        else focusElement.removeAttribute("aria-hidden");
        const ariaOrientation = target.get("ariaOrientation");
        if (ariaOrientation) focusElement.setAttribute("aria-orientation", ariaOrientation);
        else focusElement.removeAttribute("aria-orientation");
        const ariaValueNow = target.get("ariaValueNow");
        if (ariaValueNow) focusElement.setAttribute("aria-valuenow", ariaValueNow);
        else focusElement.removeAttribute("aria-valuenow");
        const ariaValueMin = target.get("ariaValueMin");
        if (ariaValueMin) focusElement.setAttribute("aria-valuemin", ariaValueMin);
        else focusElement.removeAttribute("aria-valuemin");
        const ariaValueMax = target.get("ariaValueMax");
        if (ariaValueMax) focusElement.setAttribute("aria-valuemax", ariaValueMax);
        else focusElement.removeAttribute("aria-valuemax");
        const ariaValueText = target.get("ariaValueText");
        if (ariaValueText) focusElement.setAttribute("aria-valuetext", ariaValueText);
        else focusElement.removeAttribute("aria-valuetext");
        const ariaControls = target.get("ariaControls");
        if (ariaControls) focusElement.setAttribute("aria-controls", ariaControls);
        else focusElement.removeAttribute("aria-controls");
        if (target.get("visible") && target.get("opacity") !== 0 && target.get("role") != "tooltip" && !target.isHidden() && target.getPrivate("focusable") !== false && (target.height() || target.width())) {
            if (focusElement.getAttribute("tabindex") != "-1") focusElement.setAttribute("tabindex", "" + this.tabindex);
            focusElement.removeAttribute("aria-hidden");
        } else {
            focusElement.removeAttribute("tabindex");
            focusElement.setAttribute("aria-hidden", "true");
        }
    }
    _makeFocusElement(index, target) {
        if (target.getPrivate("focusElement") || this._a11yD == true) return;
        // Init
        const focusElement = document.createElement("div");
        if (target.get("role") != "tooltip") focusElement.tabIndex = this.tabindex;
        focusElement.style.position = "absolute";
        $05b1b40b69b15016$export$2dc32695cee26cb(focusElement, false);
        const disposers = [];
        target.setPrivate("focusElement", {
            dom: focusElement,
            disposers: disposers
        });
        this._decorateFocusElement(target);
        disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(focusElement, "focus", (ev)=>{
            this._handleFocus(ev);
        }));
        disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(focusElement, "blur", (ev)=>{
            this._handleBlur(ev);
        }));
        this._moveFocusElement(index, target);
    }
    _removeFocusElement(target) {
        if (this._a11yD == true) return;
        $2f30431acd054e2f$export$cd7f480d6b8286c3(this._tabindexes, target);
        const focusElement = target.getPrivate("focusElement");
        if (focusElement) {
            const container = this._focusElementContainer;
            container.removeChild(focusElement.dom);
            $2f30431acd054e2f$export$79b2f7037acddd43(focusElement.disposers, (x)=>{
                x.dispose();
            });
        }
    }
    _hideFocusElement(target) {
        if (this._a11yD == true) return;
        const focusElement = target.getPrivate("focusElement");
        focusElement.dom.style.display = "none";
    }
    _moveFocusElement(index, target) {
        if (this._a11yD == true) return;
        // Get container
        const container = this._focusElementContainer;
        const focusElement = target.getPrivate("focusElement").dom;
        if (focusElement === this._focusElementContainer.children[index]) // Nothing to do
        return;
        const next = this._focusElementContainer.children[index + 1];
        if (next) container.insertBefore(focusElement, next);
        else container.append(focusElement);
    }
    _positionFocusElement(target) {
        if (this._a11yD == true || target == undefined) return;
        this._focusElementContainer.scrollTop = 0;
        const bounds = target.globalBounds();
        let width = bounds.right == bounds.left ? target.width() : bounds.right - bounds.left;
        let height = bounds.top == bounds.bottom ? target.height() : bounds.bottom - bounds.top;
        const padding = this._settings.focusPadding !== undefined ? this._settings.focusPadding : 2;
        let x = bounds.left - padding;
        let y = bounds.top - padding;
        if (width < 0) {
            x += width;
            width = Math.abs(width);
        }
        if (height < 0) {
            y += height;
            height = Math.abs(height);
        }
        const focusElement = target.getPrivate("focusElement").dom;
        focusElement.style.top = y + "px";
        focusElement.style.left = x + "px";
        focusElement.style.width = width + padding * 2 + "px";
        focusElement.style.height = height + padding * 2 + "px";
    }
    _getSpriteByFocusElement(target) {
        let found;
        $2f30431acd054e2f$export$1e016427912bfd78(this._tabindexes, (item, _index)=>{
            if (item.getPrivate("focusElement").dom === target) {
                found = item;
                return false;
            }
            return true;
        });
        return found;
    }
    _handleFocus(ev) {
        if (this._a11yD == true) return;
        // Get element
        //const focused = this._tabindexes[index];
        const focused = this._getSpriteByFocusElement(ev.target);
        if (!focused) return;
        // Jump over hidden elements
        if (!focused.isVisibleDeep()) {
            this._focusNext(ev.target, this._isShift ? -1 : 1);
            return;
        }
        // Size and position
        this._positionFocusElement(focused);
        //this._decorateFocusElement(focused);
        this._focusedSprite = focused;
        if (focused.events.isEnabled("focus")) focused.events.dispatch("focus", {
            type: "focus",
            originalEvent: ev,
            target: focused
        });
        if (focused.getPrivate("focusElement").dom.tabIndex == -1) this._skipNextGroupJump = false;
    }
    _focusNext(el, direction, group) {
        if (this._a11yD == true) return;
        const rootNode = this.dom.getRootNode ? this.dom.getRootNode() : null;
        let queryRoot = this.dom.ownerDocument || document;
        if (rootNode) {
            if (typeof ShadowRoot !== "undefined" && rootNode instanceof ShadowRoot) queryRoot = rootNode;
            else if (rootNode instanceof Document) queryRoot = rootNode;
        }
        const focusableElements = Array.from(queryRoot.querySelectorAll([
            'a[href]',
            'area[href]',
            'button:not([disabled])',
            'details',
            'input:not([disabled])',
            'iframe:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[contentEditable=""]',
            '[contentEditable="true"]',
            '[contentEditable="TRUE"]',
            '[tabindex]:not([tabindex^="-"])'
        ].join(',')));
        let index = focusableElements.indexOf(el) + direction;
        if (index < 0) index = focusableElements.length - 1;
        else if (index >= focusableElements.length) index = 0;
        const targetElement = focusableElements[index];
        if (group && direction == -1) {
            const target = this._getSpriteByFocusElement(targetElement);
            if (target && target.get("focusableGroup") == group) {
                this._focusNext(targetElement, direction);
                return;
            }
        }
        if (targetElement) targetElement.focus();
    }
    _handleBlur(ev) {
        if (this._a11yD == true) return;
        const focused = this._focusedSprite;
        if (focused && !focused.isDisposed() && focused.events.isEnabled("blur")) focused.events.dispatch("blur", {
            type: "blur",
            originalEvent: ev,
            target: focused
        });
        this._focusedSprite = undefined;
    }
    /**
     * @ignore
     */ updateTooltip(target) {
        if (this._a11yD == true) return;
        const text = $05b1b40b69b15016$export$8b58d1ab3bbf8cb5($05b1b40b69b15016$export$1fbf6f199c05a66(target._getText()));
        let tooltipElement = target.getPrivate("tooltipElement");
        if (target.get("role") == "tooltip" && text != "") {
            if (!tooltipElement) tooltipElement = this._makeTooltipElement(target);
            if (tooltipElement.innerHTML != text) tooltipElement.innerHTML = text;
            tooltipElement.setAttribute("aria-hidden", target.isVisibleDeep() ? "false" : "true");
        } else if (tooltipElement) {
            tooltipElement.remove();
            target.removePrivate("tooltipElement");
        }
    }
    _makeTooltipElement(target) {
        const container = this._tooltipElementContainer;
        const tooltipElement = document.createElement("div");
        tooltipElement.style.position = "absolute";
        tooltipElement.style.width = "1px";
        tooltipElement.style.height = "1px";
        tooltipElement.style.overflow = "hidden";
        tooltipElement.style.clip = "rect(1px, 1px, 1px, 1px)";
        $05b1b40b69b15016$export$2dc32695cee26cb(tooltipElement, false);
        this._decorateFocusElement(target, tooltipElement);
        container.append(tooltipElement);
        target.setPrivate("tooltipElement", tooltipElement);
        return tooltipElement;
    }
    _removeTooltipElement(target) {
        if (this._a11yD == true) return;
        const tooltipElement = target.getPrivate("tooltipElement");
        if (tooltipElement) {
            const parent = tooltipElement.parentElement;
            if (parent) parent.removeChild(tooltipElement);
        }
    }
    _invalidateAccessibility(target) {
        if (this._a11yD == true) return;
        this._focusElementDirty = true;
        const focusElement = target.getPrivate("focusElement");
        if (target.get("focusable")) {
            if (focusElement) {
                this._decorateFocusElement(target);
                if (this._focusedSprite === target) this._positionFocusElement(target);
            }
        } else if (focusElement) this._removeFocusElement(target);
    //this.updateCurrentFocus();
    }
    /**
     * Returns `true` if `target` is currently focused.
     *
     * @param   target  Target
     * @return          Focused?
     */ focused(target) {
        return this._focusedSprite === target;
    }
    /**
     * Converts document coordinates to coordinates withing root element.
     *
     * @param   point  Document point
     * @return         Root point
     */ documentPointToRoot(point) {
        const rect = this._getRealSize();
        const size = this._getCalculatedSize(rect);
        const scaleWidth = size.width / rect.width;
        const scaleHeight = size.height / rect.height;
        return {
            x: (point.x - rect.left) * scaleWidth,
            y: (point.y - rect.top) * scaleHeight
        };
    }
    /**
     * Converts root coordinates to document
     *
     * @param   point  Document point
     * @return         Root point
     */ rootPointToDocument(point) {
        const rect = this._getRealSize();
        const size = this._getCalculatedSize(rect);
        const scaleWidth = size.width / rect.width;
        const scaleHeight = size.height / rect.height;
        return {
            x: point.x / scaleWidth + rect.left,
            y: point.y / scaleHeight + rect.top
        };
    }
    /**
     * @ignore
     */ addDisposer(disposer) {
        this._disposers.push(disposer);
        return disposer;
    }
    _updateComputedStyles() {
        const styles = window.getComputedStyle(this.dom);
        const oldFonts = this._fontHash;
        const newFonts = $e66f9343b5144e1a$export$ed97f33186d4b816(styles).flatMap((k)=>{
            var _a;
            return typeof k === "string" && k.startsWith("font") ? [
                (_a = styles[k]) === null || _a === void 0 ? void 0 : _a.toString()
            ] : [];
        });
        if (oldFonts.length !== newFonts.length) {
            this._fontHash = newFonts;
            return true;
        }
        for(let i = 0; i < oldFonts.length; i++)if (oldFonts[i] !== newFonts[i]) {
            this._fontHash = newFonts;
            return true;
        }
        return false;
    }
    _checkComputedStyles() {
        if (this._updateComputedStyles()) this._invalidateLabelBounds(this.container);
    }
    _invalidateLabelBounds(target) {
        if (target instanceof (0, $5de502da8a72d65e$export$42a852a2b6b56249)) target.children.each((child)=>{
            this._invalidateLabelBounds(child);
        });
        else if (target instanceof (0, $991c10b390813ab6$export$5f1af8db9871e1d6)) target.markDirtyBounds();
    }
    /**
     * To all the clever heads out there. Yes, we did not make any attempts to
     * scramble this.
     *
     * This is a part of a tool meant for our users to manage their commercial
     * licenses for removal of amCharts branding from charts.
     *
     * The only legit way to do so is to purchase a commercial license for amCharts:
     * https://www.amcharts.com/online-store/
     *
     * Removing or altering this code, or disabling amCharts branding in any other
     * way is against the license and thus illegal.
     */ _hasLicense() {
        for(let i = 0; i < (0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).licenses.length; i++){
            if ((0, $ca44c6881f0f20f2$export$4bb7493d241fd8a5).licenses[i].match(/^AM5C.{5,}/i)) return true;
        }
        return false;
    }
    _licenseApplied() {
        if (this._logo) this._logo.set("forceHidden", true);
    }
    /**
     * @ignore
     */ get debugGhostView() {
        return this._renderer.debugGhostView;
    }
    /**
     * @ignore
     */ set debugGhostView(value) {
        this._renderer.debugGhostView = value;
    }
    /**
     * Set this to `true` if you need chart to require first a tap onto it before
     * touch gesture related functionality like zoom/pan is turned on.
     *
     * @see {@link https://www.amcharts.com/docs/v5/getting-started/root-element/#Touch_related_options} for more info
     * @default false
     * @since 5.2.9
     * @param  value  Needs a tap to activate touch functions
     */ set tapToActivate(value) {
        this._renderer.tapToActivate = value;
    }
    /**
     * @return Needs a tap to activate touch functions
     */ get tapToActivate() {
        return this._renderer.tapToActivate;
    }
    /**
     * If `tapToActivate` is set to `true`, this setting will determine number
     * of milliseconds the chart will stay "active", before releasing the
     * controls back to the page.
     *
     * @see {@link https://www.amcharts.com/docs/v5/getting-started/root-element/#Touch_related_options} for more info
     * @default 3000
     * @since 5.2.9
     * @param  value  Timeout
     */ set tapToActivateTimeout(value) {
        this._renderer.tapToActivateTimeout = value;
    }
    /**
     * @return Timeout
     */ get tapToActivateTimeout() {
        return this._renderer.tapToActivateTimeout;
    }
    _makeHTMLElement(target) {
        // Get container
        const container = this._htmlElementContainer;
        // Init
        const htmlElement = document.createElement("div");
        target.setPrivate("htmlElement", htmlElement);
        // Should we put this into a wrapper?
        let needWrapper = false;
        let wrapperTarget;
        target._walkParents((parent)=>{
            if (parent.get("verticalScrollbar")) {
                needWrapper = true;
                wrapperTarget = parent;
                return false;
            }
        });
        let htmlElementWrapper;
        if (needWrapper) {
            htmlElementWrapper = document.createElement("div");
            target.setPrivate("htmlElementWrapper", htmlElementWrapper);
            target.setPrivate("wrapperContainer", wrapperTarget);
            htmlElementWrapper.style.position = "absolute";
            htmlElementWrapper.style.overflow = "hidden";
            htmlElementWrapper.style.boxSizing = "border-box";
            htmlElementWrapper.style.top = "0px";
            htmlElementWrapper.style.left = "0px";
            htmlElementWrapper.style.width = "100%";
            htmlElementWrapper.style.height = "100%";
            wrapperTarget.events.on("boundschanged", ()=>{
                this._positionHTMLElement(target);
            });
        }
        //htmlElement.tabIndex = this.tabindex;
        htmlElement.style.position = "absolute";
        htmlElement.style.overflow = "auto";
        htmlElement.style.boxSizing = "border-box";
        $05b1b40b69b15016$export$2dc32695cee26cb(htmlElement, target.get("interactive", false));
        // Translate events
        if (target.events.isEnabled("click")) {
            $05b1b40b69b15016$export$2dc32695cee26cb(htmlElement, true);
            this._disposers.push($05b1b40b69b15016$export$3f65cefe8380dbea(htmlElement, "click", (ev)=>{
                const downEvent = this._renderer.getEvent(ev);
                target.events.dispatch("click", {
                    type: "click",
                    originalEvent: downEvent.event,
                    point: downEvent.point,
                    simulated: false,
                    target: target
                });
            }));
        }
        this._positionHTMLElement(target);
        if (needWrapper) {
            htmlElementWrapper.append(htmlElement);
            container.append(htmlElementWrapper);
        } else container.append(htmlElement);
        $2f30431acd054e2f$export$3589e1fa93f0a8a5(this._htmlEnabledContainers, target);
        return htmlElement;
    }
    _positionHTMLElements() {
        $2f30431acd054e2f$export$79b2f7037acddd43(this._htmlEnabledContainers, (target)=>{
            this._positionHTMLElement(target);
        });
    }
    _positionHTMLElement(target) {
        const htmlElementWrapper = target.getPrivate("htmlElementWrapper");
        if (htmlElementWrapper) {
            const wrapperTarget = target.getPrivate("wrapperContainer");
            if (wrapperTarget) {
                const bounds = wrapperTarget.globalBounds();
                htmlElementWrapper.style.clipPath = "rect(" + bounds.top + "px " + bounds.right + "px " + bounds.bottom + "px " + bounds.left + "px)";
            }
        }
        const htmlElement = target.getPrivate("htmlElement");
        if (htmlElement) {
            // Translate settings
            const visualSettings = [
                "paddingTop",
                "paddingRight",
                "paddingBottom",
                "paddingLeft",
                "minWidth",
                "minHeight",
                "maxWidth",
                "maxHeight"
            ];
            $2f30431acd054e2f$export$79b2f7037acddd43(visualSettings, (setting)=>{
                const value = target.get(setting);
                if (value) htmlElement.style[setting] = value + "px";
                else htmlElement.style[setting] = "";
            });
            const strtingSettings = [
                "fontFamily",
                "fontSize",
                "fontStyle",
                "fontWeight",
                "fontStyle",
                "fontVariant",
                "textDecoration"
            ];
            $2f30431acd054e2f$export$79b2f7037acddd43(strtingSettings, (setting)=>{
                const value = target.get(setting);
                if (value) {
                    if (setting == "fontSize" && !$f63bdea45a89cf24$export$844ec244b1367d54(value)) htmlElement.style[setting] = value + "px";
                    else htmlElement.style[setting] = value + "";
                } else htmlElement.style[setting] = "";
            });
            // Init and reset scale / rotation
            const scale = target.compositeScale() || 1;
            const rotation = target.compositeRotation() || 0;
            htmlElement.style.transform = "";
            htmlElement.style.transformOrigin = "";
            // Deal with opacity
            const opacity = target.compositeOpacity();
            setTimeout(()=>{
                htmlElement.style.opacity = opacity + "";
            }, 10);
            const visible = target.isVisibleDeep();
            if (visible) htmlElement.style.display = "block";
            // Deal with position
            // const bounds = target.globalBounds();
            // htmlElement.style.top = (bounds.top) + "px";
            // htmlElement.style.left = (bounds.left) + "px";
            let pos = {
                x: target.x() + target.get("dx", 0),
                y: target.y() + target.get("dy", 0)
            };
            if (target.parent) pos = target.parent.toGlobal(pos);
            htmlElement.style.top = pos.y + "px";
            htmlElement.style.left = pos.x + "px";
            // Use width/height if those are set
            const width = target.get("width");
            const height = target.get("height");
            let w = 0;
            let h = 0;
            if (width) w = target.width();
            if (height) h = target.height();
            if (!width || !height) {
                htmlElement.style.position = "fixed";
                htmlElement.style.width = "";
                htmlElement.style.height = "";
                const bbox = htmlElement.getBoundingClientRect();
                htmlElement.style.position = "absolute";
                if (!width) w = bbox.width;
                if (!height) h = bbox.height;
                let lw = w / scale;
                let lh = h / scale;
                let cx = target.get("centerX", 0);
                let cy = target.get("centerY", 0);
                let ll = 0;
                let lr = 0;
                let lt = 0;
                let lb = 0;
                if (cx instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                    ll = -cx.value * lw;
                    lr = (1 - cx.value) * lw;
                } else {
                    ll = -cx;
                    lr = lw - cx;
                }
                if (cy instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                    lt = -cy.value * lh;
                    lb = (1 - cy.value) * lh;
                } else {
                    lt = -cy;
                    lb = lh - cy;
                }
                target._localBounds = {
                    left: ll,
                    right: lr,
                    top: lt,
                    bottom: lb
                };
                let previousBounds = target._adjustedLocalBounds;
                let newBounds = target._display.getAdjustedBounds(target._localBounds);
                target._adjustedLocalBounds = newBounds;
                // compare each value of the bounds
                if (previousBounds.left !== newBounds.left || previousBounds.right !== newBounds.right || previousBounds.top !== newBounds.top || previousBounds.bottom !== newBounds.bottom) target.markDirtyBounds();
            }
            if (w > 0) htmlElement.style.minWidth = w + "px";
            if (h > 0) htmlElement.style.minHeight = h + "px";
            // Hide or show
            if (!visible || opacity == 0) htmlElement.style.display = "none";
            // Center position
            const x = target.get("centerX", 0);
            const originX = (0, $bd0d0c10fd30006b$export$e50269385c77c348)(x) ? x.percent + "%" : x + "px";
            const y = target.get("centerY", 0);
            const originY = (0, $bd0d0c10fd30006b$export$e50269385c77c348)(y) ? y.percent + "%" : y + "px";
            if (x || y) htmlElement.style.transform = "translate(-" + originX + ", -" + originY + ")" + htmlElement.style.transform;
            // Deal with scale
            if (scale != 1) htmlElement.style.transform += "scale(" + scale + ")";
            if (rotation != 0) htmlElement.style.transform += " rotate(" + rotation + "deg)";
            if (htmlElement.style.transform != "") htmlElement.style.transformOrigin = originX + " " + originY;
        }
    }
    /**
     * Sanitizes HTML content before it gets injected via `innerHTML`, unless
     * sanitization is disabled via the `sanitizeHTML` setting.
     *
     * @ignore
     */ _sanitizeHTML(html) {
        return this._settings.sanitizeHTML ? $05b1b40b69b15016$export$13003bc448897200(html) : html;
    }
    _setHTMLContent(target, html) {
        let htmlElement = target.getPrivate("htmlElement");
        if (!htmlElement) {
            htmlElement = this._makeHTMLElement(target);
            if (!this.autoResize) this.resize();
        }
        const sanitized = this._sanitizeHTML(html);
        if (htmlElement.innerHTML != sanitized) htmlElement.innerHTML = sanitized;
    }
    _removeHTMLContent(target) {
        const htmlElementWrapper = target.getPrivate("htmlElementWrapper");
        const htmlElement = target.getPrivate("htmlElement");
        if (htmlElementWrapper) {
            this._htmlElementContainer.removeChild(htmlElementWrapper);
            target.removePrivate("htmlElement");
            target.removePrivate("htmlElementWrapper");
            target.removePrivate("wrapperContainer");
        } else if (htmlElement) {
            this._htmlElementContainer.removeChild(htmlElement);
            target.removePrivate("htmlElement");
            target.removePrivate("wrapperContainer");
        }
        $2f30431acd054e2f$export$cd7f480d6b8286c3(this._htmlEnabledContainers, target);
    }
}


class $0fc741c57fd16af1$export$5a465592bfe74b48 extends (0, $2ffdafbe1fe6a946$export$29d3e417456abdad) {
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("width") || this.isDirty("height") || this.isPrivateDirty("width") || this.isPrivateDirty("height")) this._clear = true;
    }
    _changed() {
        super._changed();
        if (this._clear && !this.get("draw")) this._draw();
    }
    _draw() {
        const w = this.width();
        const h = this.height();
        const display = this._display;
        display.moveTo(-w / 2, h / 2);
        display.lineTo(0, -h / 2);
        display.lineTo(w / 2, h / 2);
        display.lineTo(-w / 2, h / 2);
        display.closePath();
    }
    _updateSize() {
        this.markDirty();
        this._clear = true;
    }
}
$0fc741c57fd16af1$export$5a465592bfe74b48.className = "Triangle";
$0fc741c57fd16af1$export$5a465592bfe74b48.classNames = (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).classNames.concat([
    $0fc741c57fd16af1$export$5a465592bfe74b48.className
]);




class $1194f786ec2822b3$export$21e43085bc6b0522 extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    _beforeChanged() {
        super._beforeChanged();
        const sprite = this.get("sprite");
        if (this.isDirty("sprite")) {
            if (sprite) {
                sprite.setAll({
                    position: "absolute",
                    role: "figure"
                });
                this._disposers.push(sprite);
            }
        }
        if (this.isDirty("location")) {
            const dataItem = sprite.dataItem;
            if (this.axis && sprite && dataItem) this.axis._prepareDataItem(dataItem);
        }
    }
    _dispose() {
        const axis = this.axis;
        if (axis) $e66f9343b5144e1a$export$79b2f7037acddd43(axis._bullets, (key, bullet)=>{
            if (bullet.uid == this.uid) delete axis._bullets[key];
        });
        super._dispose();
    }
}
$1194f786ec2822b3$export$21e43085bc6b0522.className = "AxisBullet";
$1194f786ec2822b3$export$21e43085bc6b0522.classNames = (0, $baeade534ece7f4c$export$bc644a473284d944).classNames.concat([
    $1194f786ec2822b3$export$21e43085bc6b0522.className
]);





class $90e96dbd0e98a250$export$c241a244b7e1601c extends (0, $ddd3cfc9bee47cd2$export$54c2e3dc7acea9f5) {
    /**
     * @ignore
     */ incrementRef() {}
    /**
     * @ignore
     */ decrementRef() {}
    _onPush(newValue) {
        if (this.processor) this.processor.processRow(newValue);
        super._onPush(newValue);
    }
    _onInsertIndex(index, newValue) {
        if (this.processor) this.processor.processRow(newValue);
        super._onInsertIndex(index, newValue);
    }
    _onSetIndex(index, oldValue, newValue) {
        if (this.processor) this.processor.processRow(newValue);
        super._onSetIndex(index, oldValue, newValue);
    }
}
class $90e96dbd0e98a250$export$aeba00a98acce503 {
    constructor(value){
        this._value = value;
    }
    incrementRef() {}
    decrementRef() {}
}




class $255dd6cbbf32a3ff$export$e9ab04247990d50b extends (0, $baeade534ece7f4c$export$c72f6eaae7b9adff) {
    constructor(component, dataContext, settings){
        super(settings);
        this.dataContext = dataContext;
        this.component = component;
        this._settings.visible = true;
        this._checkDirty();
    }
    /**
     * @ignore
     */ markDirty() {
        this.component.markDirtyValues(this);
    }
    _startAnimation() {
        this.component._root._addAnimation(this);
    }
    _animationTime() {
        return this.component._root.animationTime;
    }
    _dispose() {
        if (this.component) this.component.disposeDataItem(this);
        super._dispose();
    }
    /**
     * Shows a data item that's currently hidden.
     */ show(duration) {
        this.setRaw("visible", true);
        if (this.component) this.component.showDataItem(this, duration);
    }
    /**
     * Hides a data item that's currently visible.
     */ hide(duration) {
        this.setRaw("visible", false);
        if (this.component) this.component.hideDataItem(this, duration);
    }
    isHidden() {
        return !this.get("visible");
    }
}
class $255dd6cbbf32a3ff$export$16fa2f45be04daa8 extends (0, $5de502da8a72d65e$export$42a852a2b6b56249) {
    constructor(){
        super(...arguments);
        this._data = new (0, $90e96dbd0e98a250$export$c241a244b7e1601c)();
        this._dataItems = [];
        this._mainDataItems = this._dataItems;
        this.valueFields = [];
        this.fields = [
            "id"
        ];
        this._valuesDirty = false;
        this._dataChanged = false;
        this._dataGrouped = false;
        /**
         * Indicates if the component has already been initialized.
         */ this.inited = false;
    }
    /**
     * Component's data.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/data/} for more info
     */ set data(data) {
        data.incrementRef();
        this._data.decrementRef();
        this._data = data;
    }
    /**
     * @return  Data
     */ get data() {
        return this._data;
    }
    _dispose() {
        super._dispose();
        this._data.decrementRef();
    }
    _onDataClear() {}
    _afterNew() {
        super._afterNew();
        this._data.incrementRef();
        this._updateFields();
        this._disposers.push(this.data.events.onAll((change)=>{
            const dataItems = this._mainDataItems;
            this.markDirtyValues();
            this._markDirtyGroup();
            this._dataChanged = true;
            if (change.type === "clear") {
                $2f30431acd054e2f$export$79b2f7037acddd43(dataItems, (dataItem)=>{
                    dataItem.dispose();
                });
                dataItems.length = 0;
                this._onDataClear();
            } else if (change.type === "push") {
                const dataItem = new $255dd6cbbf32a3ff$export$e9ab04247990d50b(this, change.newValue, this._makeDataItem(change.newValue));
                dataItems.push(dataItem);
                this.processDataItem(dataItem);
            } else if (change.type === "setIndex") {
                const dataItem = dataItems[change.index];
                const properties = this._makeDataItem(change.newValue);
                if (dataItem.bullets && dataItem.bullets.length == 0) dataItem.bullets = undefined;
                $e66f9343b5144e1a$export$3e9f948b41964866(properties).forEach(([key, value])=>{
                    if (dataItem.get(key) == value) return;
                    dataItem.animate({
                        key: key,
                        to: value,
                        duration: this.get("interpolationDuration", 0),
                        easing: this.get("interpolationEasing")
                    });
                });
                dataItem.dataContext = change.newValue;
            } else if (change.type === "insertIndex") {
                const dataItem = new $255dd6cbbf32a3ff$export$e9ab04247990d50b(this, change.newValue, this._makeDataItem(change.newValue));
                dataItems.splice(change.index, 0, dataItem);
                this.processDataItem(dataItem);
            } else if (change.type === "removeIndex") {
                const dataItem = dataItems[change.index];
                dataItem.dispose();
                dataItems.splice(change.index, 1);
            } else if (change.type === "moveIndex") {
                const dataItem = dataItems[change.oldIndex];
                dataItems.splice(change.oldIndex, 1);
                dataItems.splice(change.newIndex, 0, dataItem);
            } else throw new Error("Unknown IStreamEvent type");
            this._afterDataChange();
        }));
    }
    _postUpdateData() {}
    /**
     * Updates existing data in the component without disposing old data items. If there are more data items than before, new ones will be created. If there are less, old ones will be removed.
     * @param data
     */ updateData(data) {
        let ii = 0;
        $2f30431acd054e2f$export$79b2f7037acddd43(data, (dataObject, index)=>{
            const dataItem = this.dataItems[index];
            if (!dataItem) this.data.push(dataObject);
            else {
                const dataContext = dataItem.dataContext;
                if (dataContext) $e66f9343b5144e1a$export$3e9f948b41964866(dataObject).forEach(([key, value])=>{
                    dataContext[key] = value;
                });
                const properties = this._makeDataItem(dataContext);
                $e66f9343b5144e1a$export$3e9f948b41964866(properties).forEach(([key, value])=>{
                    var _a;
                    if (dataItem.get(key) != value) {
                        dataItem.set(key, value);
                        const workingKey = (_a = this._valueFieldsF[key]) === null || _a === void 0 ? void 0 : _a.workingKey;
                        if (workingKey) dataItem.set(workingKey, value);
                    }
                });
            }
            ii = index;
        });
        for(let i = this.dataItems.length - 1; i > ii; i--){
            const dataItem = this.dataItems[i];
            $2f30431acd054e2f$export$cd7f480d6b8286c3(this.dataItems, dataItem);
            dataItem.dispose();
        }
        this._postUpdateData();
    }
    _updateFields() {
        if (this.valueFields) {
            this._valueFields = [];
            this._valueFieldsF = {};
            $2f30431acd054e2f$export$79b2f7037acddd43(this.valueFields, (key)=>{
                const field = this.get(key + "Field");
                if (field) {
                    this._valueFields.push(key);
                    this._valueFieldsF[key] = {
                        fieldKey: key + "Field",
                        workingKey: key + "Working"
                    };
                }
            });
        }
        if (this.fields) {
            this._fields = [];
            this._fieldsF = {};
            $2f30431acd054e2f$export$79b2f7037acddd43(this.fields, (key)=>{
                const field = this.get(key + "Field");
                if (field) {
                    this._fields.push(key);
                    this._fieldsF[key] = key + "Field";
                }
            });
        }
    }
    /**
     * A list of component's data items.
     *
     * @return  Data items
     */ get dataItems() {
        return this._dataItems;
    }
    processDataItem(_dataItem) {}
    _makeDataItem(data) {
        //const output: this["_dataItemSettings"] = {};
        const output = {}; // temporary to solve error
        if (this._valueFields) $2f30431acd054e2f$export$79b2f7037acddd43(this._valueFields, (key)=>{
            const field = this.get(this._valueFieldsF[key].fieldKey);
            output[key] = data[field];
            output[this._valueFieldsF[key].workingKey] = output[key];
        });
        if (this._fields) $2f30431acd054e2f$export$79b2f7037acddd43(this._fields, (key)=>{
            const field = this.get(this._fieldsF[key]);
            output[key] = data[field];
        });
        return output;
    }
    /**
     * Creates a new data item and processes it.
     *
     * @param   data         Data item settings
     * @param   dataContext  Data context
     * @return               New data item
     */ makeDataItem(data, dataContext) {
        let dataItem = new $255dd6cbbf32a3ff$export$e9ab04247990d50b(this, dataContext, data);
        this.processDataItem(dataItem);
        return dataItem;
    }
    /**
     * Adds new explicit data item to series.
     *
     * @param   data         Data item settings
     * @param   dataContext  Data context
     * @return               New data item
     */ pushDataItem(data, dataContext) {
        const dataItem = this.makeDataItem(data, dataContext);
        this._mainDataItems.push(dataItem);
        return dataItem;
    }
    /**
     * @ignore
     */ disposeDataItem(_dataItem) {}
    /**
     * Shows component's data item.
     *
     * @param   dataItem   Data item
     * @param   _duration  Animation duration in milliseconds
     * @return             Promise
     */ showDataItem(dataItem, _duration) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            dataItem.set("visible", true);
        });
    }
    /**
     * Hides component's data item.
     *
     * @param   dataItem   Data item
     * @param   _duration  Animation duration in milliseconds
     * @return             Promise
     */ hideDataItem(dataItem, _duration) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            dataItem.set("visible", false);
        });
    }
    _clearDirty() {
        super._clearDirty();
        this._valuesDirty = false;
    }
    _afterDataChange() {}
    _afterChanged() {
        super._afterChanged();
        if (this._dataChanged) {
            const type = "datavalidated";
            if (this.events.isEnabled(type)) this.events.dispatch(type, {
                type: type,
                target: this
            });
            this._dataChanged = false;
        }
        if (this._valuesDirty) {
            const type = "valueschanged";
            if (this.events.isEnabled(type)) this.events.dispatch(type, {
                type: type,
                target: this
            });
        }
        this.inited = true;
    }
    /**
     * Forces a repaint of the element which relies on data.
     *
     * @since 5.0.21
     */ markDirtyValues(_dataItem) {
        this.markDirty();
        this._valuesDirty = true;
    }
    _markDirtyGroup() {
        this._dataGrouped = false;
    }
    /**
     * @ignore
     */ markDirtySize() {
        this._sizeDirty = true;
        this.markDirty();
    }
    /**
     * Looks up and returns a data item by its ID.
     *
     * @param   id  ID
     * @return      Data item
     */ getDataItemById(id) {
        return $2f30431acd054e2f$export$71aa6c912b956294(this.dataItems, (dataItem)=>{
            return dataItem.get("id") == id;
        });
    }
}
$255dd6cbbf32a3ff$export$16fa2f45be04daa8.className = "Component";
$255dd6cbbf32a3ff$export$16fa2f45be04daa8.classNames = (0, $5de502da8a72d65e$export$42a852a2b6b56249).classNames.concat([
    $255dd6cbbf32a3ff$export$16fa2f45be04daa8.className
]);










class $339e015cec6c2240$export$d06866a9fb0606da extends (0, $255dd6cbbf32a3ff$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this._series = [];
        this._isPanning = false;
        /**
         * Array of minor data items.
         */ this.minorDataItems = [];
        /**
         * A [[Container]] that holds all the axis label elements.
         *
         * @default Container.new()
         */ this.labelsContainer = this.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {}));
        /**
         * A [[Container]] that holds all the axis grid and fill elements.
         *
         * @default Container.new()
         */ this.gridContainer = (0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        /**
         * A [[Container]] that holds axis grid elements which goes above the series.
         *
         * @default Container.new()
         */ this.topGridContainer = (0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        /**
         * A [[Container]] that holds all the axis bullet elements.
         *
         * @default new Container
         */ this.bulletsContainer = this.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            isMeasured: false,
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            position: "absolute"
        }));
        this._rangesDirty = false;
        this._panStart = 0;
        this._panEnd = 1;
        this._skipSync = false;
        /**
         * A list of axis ranges.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/} for more info
         * @default new List()
         */ this.axisRanges = new (0, $ddd3cfc9bee47cd2$export$54c2e3dc7acea9f5)();
        this._seriesAxisRanges = [];
        this._cursorPosition = -1;
        this._seriesValuesDirty = false;
        this._seriesAdded = false;
        /**
         * A container above the axis that can be used to add additional stuff into
         * it. For example a legend, label, or an icon.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-headers/} for more info
         * @default new Container
         */ this.axisHeader = this.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            themeTags: [
                "axis",
                "header"
            ],
            position: "absolute",
            background: (0, $9e0cea1ea085e274$export$4617fb02663045ef).new(this._root, {
                themeTags: [
                    "header",
                    "background"
                ],
                fill: this._root.interfaceColors.get("background")
            })
        }));
        this._bullets = {};
    }
    /**
     * @ignore
     * Returns `true` if this axis is currently sync-driven (and therefore its
     * `start`/`end` and rendered grid should reflect the synced bounds even
     * when they exceed the axis data range).
     */ _isSynced() {
        return false;
    }
    _dispose() {
        // these could be in other parents, so disposing just in case
        this.gridContainer.dispose();
        this.topGridContainer.dispose();
        this.bulletsContainer.dispose();
        this.labelsContainer.dispose();
        this.axisHeader.dispose();
        super._dispose();
    }
    _afterNew() {
        super._afterNew();
        this.setPrivate("updateScrollbar", true);
        this._disposers.push(this.axisRanges.events.onAll((change)=>{
            if (change.type === "clear") $2f30431acd054e2f$export$79b2f7037acddd43(change.oldValues, (dataItem)=>{
                dataItem.dispose();
            });
            else if (change.type === "push") this._processAxisRange(change.newValue, [
                "range"
            ]);
            else if (change.type === "setIndex") this._processAxisRange(change.newValue, [
                "range"
            ]);
            else if (change.type === "insertIndex") this._processAxisRange(change.newValue, [
                "range"
            ]);
            else if (change.type === "removeIndex") this.disposeDataItem(change.oldValue);
            else if (change.type === "moveIndex") this._processAxisRange(change.value, [
                "range"
            ]);
            else throw new Error("Unknown IStreamEvent type");
        }));
        const renderer = this.get("renderer");
        if (renderer) {
            renderer.axis = this;
            renderer.processAxis();
        }
        this.children.push(renderer);
        this._createGhostLabel();
    }
    _createGhostLabel() {
        const renderer = this.get("renderer");
        const ghostLabel = renderer.makeLabel(new (0, $255dd6cbbf32a3ff$export$e9ab04247990d50b)(this, undefined, {}), []);
        ghostLabel.adapters.disable("text");
        ghostLabel.setAll({
            opacity: 0,
            tooltipText: undefined,
            tooltipHTML: undefined,
            interactive: false
        });
        ghostLabel.events.disable();
        this.ghostLabel = ghostLabel;
    }
    _updateFinals(_start, _end) {}
    /**
     * Zooms the axis to relative locations.
     *
     * Both `start` and `end` are relative: 0 means start of the axis, 1 - end.
     *
     * @param   start     Relative start
     * @param   end       Relative end
     * @param   duration  Duration of the zoom animation in milliseconds
     * @return            Zoom animation
     */ zoom(start, end, duration, priority) {
        if (this.get("zoomable", true)) {
            this._updateFinals(start, end);
            if (this.get("start") !== start || this.get("end") != end) {
                let sAnimation = this._sAnimation;
                let eAnimation = this._eAnimation;
                if (start > end) [start, end] = [
                    end,
                    start
                ];
                if (!this._isSynced()) {
                    let maxDeviation = this.get("maxDeviation", 0.5) * Math.min(1, end - start);
                    if (start < -maxDeviation) start = -maxDeviation;
                    if (end > 1 + maxDeviation) end = 1 + maxDeviation;
                }
                let maxZoomFactor = this.getPrivate("maxZoomFactor", this.get("maxZoomFactor", 100));
                let maxZoomFactorReal = maxZoomFactor;
                if (!$f63bdea45a89cf24$export$7e4aa119212bc614(duration)) duration = this.get("interpolationDuration", 0);
                if (!priority) priority = "end";
                if (end === 1 && start !== 0) {
                    if (start < this.get("start", 0)) priority = "start";
                    else priority = "end";
                }
                if (start === 0 && end !== 1) {
                    if (end > this.get("end", 1)) priority = "end";
                    else priority = "start";
                }
                let minZoomCount = this.get("minZoomCount", 0);
                const dataItems = this.dataItems;
                if (dataItems && dataItems.length < minZoomCount) minZoomCount = dataItems.length;
                let maxZoomCount = this.get("maxZoomCount", Infinity);
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(minZoomCount)) maxZoomFactor = maxZoomFactorReal / minZoomCount;
                let minZoomFactor = 1;
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxZoomCount)) minZoomFactor = maxZoomFactorReal / maxZoomCount;
                // need one more
                if (start > end) [start, end] = [
                    end,
                    start
                ];
                // most likely we are dragging left scrollbar grip here, so we tend to modify end
                if (priority === "start") {
                    if (maxZoomCount > 0) // add to the end
                    {
                        if (1 / (end - start) < minZoomFactor) end = start + 1 / minZoomFactor;
                    }
                    // add to the end
                    if (1 / (end - start) > maxZoomFactor) end = start + 1 / maxZoomFactor;
                    //unless end is > 0
                    if (end > 1 && end - start < 1 / maxZoomFactor) //end = 1;
                    start = end - 1 / maxZoomFactor;
                } else {
                    if (maxZoomCount > 0) // add to the end
                    {
                        if (1 / (end - start) < minZoomFactor) start = end - 1 / minZoomFactor;
                    }
                    // remove from start
                    if (1 / (end - start) > maxZoomFactor) start = end - 1 / maxZoomFactor;
                    if (start < 0 && end - start < 1 / maxZoomFactor) //start = 0;
                    end = start + 1 / maxZoomFactor;
                }
                if (1 / (end - start) > maxZoomFactor) end = start + 1 / maxZoomFactor;
                if (1 / (end - start) > maxZoomFactor) start = end - 1 / maxZoomFactor;
                if (maxZoomCount != null && minZoomCount != null && start == this.get("start") && end == this.get("end")) {
                    const chart = this.chart;
                    if (chart) chart._handleAxisSelection(this, true);
                }
                if ((sAnimation && sAnimation.playing && sAnimation.to == start || this.get("start") == start) && (eAnimation && eAnimation.playing && eAnimation.to == end || this.get("end") == end)) return;
                if (duration > 0) {
                    let easing = this.get("interpolationEasing");
                    let sAnimation, eAnimation;
                    if (this.get("start") != start) sAnimation = this.animate({
                        key: "start",
                        to: start,
                        duration: duration,
                        easing: easing
                    });
                    if (this.get("end") != end) eAnimation = this.animate({
                        key: "end",
                        to: end,
                        duration: duration,
                        easing: easing
                    });
                    this._sAnimation = sAnimation;
                    this._eAnimation = eAnimation;
                    if (sAnimation) return sAnimation;
                    else if (eAnimation) return eAnimation;
                } else {
                    this.set("start", start);
                    this.set("end", end);
                    this.root.events.once("frameended", ()=>{
                        this.markDirtyKey("start");
                    });
                }
            } else {
                if (this._sAnimation) this._sAnimation.stop();
                if (this._eAnimation) this._eAnimation.stop();
            }
        }
    }
    /**
     * A list of series using this axis.
     *
     * @return Series
     */ get series() {
        return this._series;
    }
    _processAxisRange(dataItem, themeTags) {
        dataItem.setRaw("isRange", true);
        this._createAssets(dataItem, themeTags);
        this._rangesDirty = true;
        this._prepareDataItem(dataItem);
        const above = dataItem.get("above");
        const container = this.topGridContainer;
        const grid = dataItem.get("grid");
        if (above && grid) container.children.moveValue(grid);
        const fill = dataItem.get("axisFill");
        if (above && fill) container.children.moveValue(fill);
    }
    _prepareDataItem(_dataItem, _index) {}
    /**
     * @ignore
     */ markDirtyExtremes() {}
    /**
     * @ignore
     */ markDirtySelectionExtremes() {}
    _calculateTotals() {}
    _updateAxisRanges() {
        this._bullets = {};
        this.axisRanges.each((axisRange)=>{
            this._prepareDataItem(axisRange);
        });
        $2f30431acd054e2f$export$79b2f7037acddd43(this._seriesAxisRanges, (axisRange)=>{
            this._prepareDataItem(axisRange);
        });
    }
    _prepareChildren() {
        super._prepareChildren();
        const ghostLabel = this.ghostLabel;
        if (ghostLabel) {
            if (this.get("fixAxisSize")) ghostLabel.set("visible", true);
            else ghostLabel.set("visible", false);
        }
        if (this.isDirty("start") || this.isDirty("end")) {
            const chart = this.chart;
            if (chart) chart._updateCursor();
            let start = this.get("start", 0);
            let end = this.get("end", 1);
            if (!this._isSynced()) {
                let maxDeviation = this.get("maxDeviation", 0.5) * Math.min(1, end - start);
                if (start < -maxDeviation) {
                    let delta = start + maxDeviation;
                    start = -maxDeviation;
                    this.setRaw("start", start);
                    if (this.isDirty("end")) this.setRaw("end", end - delta);
                }
                if (end > 1 + maxDeviation) {
                    let delta = end - 1 - maxDeviation;
                    end = 1 + maxDeviation;
                    this.setRaw("end", end);
                    if (this.isDirty("start")) this.setRaw("start", start - delta);
                }
            }
        }
        const renderer = this.get("renderer");
        renderer._start = this.get("start");
        renderer._end = this.get("end");
        renderer._inversed = renderer.get("inversed", false);
        renderer._axisLength = renderer.axisLength() / (renderer._end - renderer._start);
        renderer._updateLC();
        if (this.isDirty("tooltip")) {
            const tooltip = this.get("tooltip");
            if (tooltip) {
                const rendererTags = renderer.get("themeTags");
                tooltip.addTag("axis");
                tooltip.addTag(this.className.toLowerCase());
                tooltip._applyThemes();
                if (rendererTags) {
                    tooltip.set("themeTags", $05b1b40b69b15016$export$88ad500ef99d1561(tooltip.get("themeTags"), rendererTags));
                    tooltip.label._applyThemes();
                }
            }
        }
    }
    _updateTooltipBounds() {
        const tooltip = this.get("tooltip");
        if (tooltip) this.get("renderer").updateTooltipBounds(tooltip);
    }
    _updateBounds() {
        super._updateBounds();
        this._updateTooltipBounds();
    }
    /**
     * @ignore
     */ processChart(chart) {
        this.chart = chart;
        const renderer = this.get("renderer");
        renderer.chart = chart;
        chart.gridContainer.children.push(this.gridContainer);
        chart.topGridContainer.children.push(this.topGridContainer);
        chart.axisHeadersContainer.children.push(this.axisHeader);
        this.on("start", ()=>{
            chart._handleAxisSelection(this);
        });
        this.on("end", ()=>{
            chart._handleAxisSelection(this);
        });
        chart.plotContainer.onPrivate("width", ()=>{
            this.markDirtySize();
        });
        chart.plotContainer.onPrivate("height", ()=>{
            this.markDirtySize();
        });
        chart.processAxis(this);
    }
    /**
     * @ignore
     */ hideDataItem(dataItem) {
        this._toggleFHDataItem(dataItem, true);
        return super.hideDataItem(dataItem);
    }
    /**
     * @ignore
     */ showDataItem(dataItem) {
        this._toggleFHDataItem(dataItem, false);
        return super.showDataItem(dataItem);
    }
    _toggleFHDataItem(dataItem, forceHidden) {
        const fh = "forceHidden";
        const label = dataItem.get("label");
        if (label) label.set(fh, forceHidden);
        const grid = dataItem.get("grid");
        if (grid) grid.set(fh, forceHidden);
        const tick = dataItem.get("tick");
        if (tick) tick.set(fh, forceHidden);
        const axisFill = dataItem.get("axisFill");
        if (axisFill) axisFill.set(fh, forceHidden);
        const bullet = dataItem.get("bullet");
        if (bullet) {
            const sprite = bullet.get("sprite");
            if (sprite) sprite.set(fh, forceHidden);
        }
    }
    _toggleDataItem(dataItem, visible) {
        const label = dataItem.get("label");
        const v = "visible";
        if (label) label.setPrivate(v, visible);
        const grid = dataItem.get("grid");
        if (grid) grid.setPrivate(v, visible);
        const tick = dataItem.get("tick");
        if (tick) tick.setPrivate(v, visible);
        const axisFill = dataItem.get("axisFill");
        if (axisFill) axisFill.setPrivate(v, visible);
        const bullet = dataItem.get("bullet");
        if (bullet) {
            const sprite = bullet.get("sprite");
            if (sprite) sprite.setPrivate(v, visible);
        }
    }
    _createAssets(dataItem, tags, minor) {
        var _a, _b, _c;
        const renderer = this.get("renderer");
        let m = "minor";
        const label = dataItem.get("label");
        if (!label) renderer.makeLabel(dataItem, tags);
        else {
            let themeTags = label.get("themeTags");
            let remove = false;
            if (minor) {
                if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) == -1) remove = true;
            } else if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) != -1) remove = true;
            if (remove) {
                (_a = label.parent) === null || _a === void 0 || _a.children.removeValue(label);
                renderer.makeLabel(dataItem, tags);
                label.dispose();
                renderer.labels.removeValue(label);
            }
        }
        const grid = dataItem.get("grid");
        if (!grid) renderer.makeGrid(dataItem, tags);
        else {
            let themeTags = grid.get("themeTags");
            let remove = false;
            if (minor) {
                if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) == -1) remove = true;
            } else if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) != -1) remove = true;
            if (remove) {
                (_b = grid.parent) === null || _b === void 0 || _b.children.removeValue(grid);
                renderer.makeGrid(dataItem, tags);
                grid.dispose();
                renderer.grid.removeValue(grid);
            }
        }
        const tick = dataItem.get("tick");
        if (!tick) renderer.makeTick(dataItem, tags);
        else {
            let remove = false;
            let themeTags = tick.get("themeTags");
            if (minor) {
                if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) == -1) remove = true;
            } else if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) != -1) remove = true;
            if (remove) {
                (_c = tick.parent) === null || _c === void 0 || _c.children.removeValue(tick);
                renderer.makeTick(dataItem, tags);
                tick.dispose();
                renderer.ticks.removeValue(tick);
            }
        }
        if (!minor && !dataItem.get("axisFill")) renderer.makeAxisFill(dataItem, tags);
        else if (minor && !dataItem.get("axisFill") && this.get("minorAxisFillsEnabled")) renderer.makeAxisFill(dataItem, tags);
        this._processBullet(dataItem);
    }
    _processBullet(dataItem) {
        let bullet = dataItem.get("bullet");
        let axisBullet = this.get("bullet");
        if (!bullet && axisBullet && !dataItem.get("isRange")) bullet = axisBullet(this._root, this, dataItem);
        if (bullet) {
            bullet.axis = this;
            const sprite = bullet.get("sprite");
            if (sprite) {
                sprite._setDataItem(dataItem);
                dataItem.setRaw("bullet", bullet);
                if (!sprite.parent) this.bulletsContainer.children.push(sprite);
            }
        }
    }
    _afterChanged() {
        super._afterChanged();
        const chart = this.chart;
        if (chart) {
            chart._updateChartLayout();
            chart.axisHeadersContainer.markDirtySize();
        }
        this.get("renderer")._updatePositions();
        this._seriesAdded = false;
    }
    /**
     * @ignore
     */ disposeDataItem(dataItem) {
        super.disposeDataItem(dataItem);
        const renderer = this.get("renderer");
        const label = dataItem.get("label");
        if (label) {
            renderer.labels.removeValue(label);
            label.dispose();
        }
        const tick = dataItem.get("tick");
        if (tick) {
            renderer.ticks.removeValue(tick);
            tick.dispose();
        }
        const grid = dataItem.get("grid");
        if (grid) {
            renderer.grid.removeValue(grid);
            grid.dispose();
        }
        const axisFill = dataItem.get("axisFill");
        if (axisFill) {
            renderer.axisFills.removeValue(axisFill);
            axisFill.dispose();
        }
        const bullet = dataItem.get("bullet");
        if (bullet) bullet.dispose();
    }
    _updateGhost() {
        this.setPrivate("cellWidth", this.getCellWidthPosition() * this.get("renderer").axisLength());
        const ghostLabel = this.ghostLabel;
        if (ghostLabel) {
            if (!ghostLabel.isHidden()) {
                const bounds = ghostLabel.localBounds();
                const gWidth = Math.ceil(bounds.right - bounds.left);
                let text = ghostLabel.get("text");
                $2f30431acd054e2f$export$79b2f7037acddd43(this.dataItems, (dataItem)=>{
                    const label = dataItem.get("label");
                    if (label && !label.isHidden()) {
                        const bounds = label.localBounds();
                        const w = Math.ceil(bounds.right - bounds.left);
                        if (w > gWidth) text = label.text._getText();
                    }
                });
                ghostLabel.set("text", text);
            }
            let start = this.get("start", 0);
            let end = this.get("end", 1);
            this.get("renderer").updateLabel(ghostLabel, start + (end - start) * 0.5);
        }
    }
    _handleCursorPosition(position, snapToSeries) {
        const renderer = this.get("renderer");
        position = renderer.toAxisPosition(position);
        this._cursorPosition = position;
        this._snapToSeries = snapToSeries;
        this.updateTooltip();
    }
    /**
     * Can be called when axis zoom changes and you need to update tooltip
     * position.
     */ updateTooltip() {
        const snapToSeries = this._snapToSeries;
        let position = this._cursorPosition;
        const tooltip = this.get("tooltip");
        const renderer = this.get("renderer");
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(position)) {
            $2f30431acd054e2f$export$79b2f7037acddd43(this.series, (series)=>{
                if (series.get("baseAxis") === this) {
                    const dataItem = this.getSeriesItem(series, position, this.get("tooltipLocation"));
                    if (snapToSeries && snapToSeries.indexOf(series) != -1) {
                        series.updateLegendMarker(dataItem);
                        series.updateLegendValue(dataItem);
                        series._settings.tooltipDataItem = dataItem;
                    } else {
                        series.showDataItemTooltip(dataItem);
                        series.setRaw("tooltipDataItem", dataItem);
                    }
                }
            });
            if (this.get("snapTooltip")) position = this.roundAxisPosition(position, this.get("tooltipLocation", 0.5));
            this.setPrivateRaw("tooltipPosition", position);
            if (tooltip) {
                renderer.updateTooltipBounds(tooltip);
                if (!$f63bdea45a89cf24$export$c9f5652083b8129d(position)) {
                    this._updateTooltipText(tooltip, position);
                    renderer.positionTooltip(tooltip, position);
                    if (position < this.get("start", 0) || position > this.get("end", 1)) tooltip.hide(0);
                    else tooltip.show(0);
                } else tooltip.hide(0);
            }
        }
    }
    _updateTooltipText(tooltip, position) {
        tooltip.label.set("text", this.getTooltipText(position));
    }
    /**
     * @ignore
     */ roundAxisPosition(position, _location) {
        return position;
    }
    _handleSeriesRemoved() {}
    /**
     * @ignore
     */ handleCursorShow() {
        let tooltip = this.get("tooltip");
        if (tooltip) tooltip.show();
    }
    /**
     * @ignore
     */ handleCursorHide() {
        let tooltip = this.get("tooltip");
        if (tooltip) tooltip.hide();
    }
    /**
     * @ignore
     */ processSeriesDataItem(_dataItem, _fields) {}
    _clearDirty() {
        super._clearDirty();
        this._sizeDirty = false;
        this._rangesDirty = false;
    }
    /**
     * Converts pixel coordinate to a relative position on axis.
     *
     * @param   coordinate  Coordinate
     * @return              Relative position
     */ coordinateToPosition(coordinate) {
        const renderer = this.get("renderer");
        return renderer.toAxisPosition(coordinate / renderer.axisLength());
    }
    /**
     * Converts relative position of the plot area to relative position of the
     * axis with zoom taken into account.
     *
     * @param position Position
     * @return Relative position
     */ toAxisPosition(position) {
        return this.get("renderer").toAxisPosition(position);
    }
    /**
     * Converts relative position of the axis to a global position taking current
     * zoom into account (opposite to what `toAxisPosition` does).
     *
     * @since 5.4.2
     * @param position Position
     * @return Global position
     */ toGlobalPosition(position) {
        return this.get("renderer").toGlobalPosition(position);
    }
    /**
     * Adjusts position with inversed taken into account.
     *
     * @ignore
     */ fixPosition(position) {
        return this.get("renderer").fixPosition(position);
    }
    /**
     * @ignore
     */ shouldGap(_dataItem, _nextItem, _autoGapCount, _fieldName) {
        return false;
    }
    /**
     * Creates and returns an axis range object.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/} for more info
     * @param   axisDataItem  Axis data item
     * @return                Axis range
     */ createAxisRange(axisDataItem) {
        return this.axisRanges.push(axisDataItem);
    }
    /**
     * @ignore
     */ _groupSeriesData(_series) {}
    /**
     * Returns relative position between two grid lines of the axis.
     *
     * @return Position
     */ getCellWidthPosition() {
        return 0.05;
    }
}
$339e015cec6c2240$export$d06866a9fb0606da.className = "Axis";
$339e015cec6c2240$export$d06866a9fb0606da.classNames = (0, $255dd6cbbf32a3ff$export$16fa2f45be04daa8).classNames.concat([
    $339e015cec6c2240$export$d06866a9fb0606da.className
]);







class $382dcb8802c42596$export$aa40340ad42cdd20 extends (0, $339e015cec6c2240$export$d06866a9fb0606da) {
    constructor(){
        super(...arguments);
        this._dirtyExtremes = false;
        this._dirtySelectionExtremes = false;
        this._dseHandled = false;
        this._deltaMinMax = 1;
        this._baseValue = 0;
        this._minLogAdjusted = 1;
    }
    /**
     * @ignore
     */ markDirtyExtremes() {
        this._dirtyExtremes = true;
        this.markDirty();
    }
    /**
     * @ignore
     */ markDirtySelectionExtremes() {
        this._dirtySelectionExtremes = true;
        this.markDirty();
    }
    _isSynced() {
        return this.get("syncWithAxis") != null;
    }
    _afterNew() {
        this._settings.themeTags = $05b1b40b69b15016$export$88ad500ef99d1561(this._settings.themeTags, [
            "axis"
        ]);
        this.setPrivateRaw("name", "value");
        this.addTag("value");
        super._afterNew();
    }
    _prepareChildren() {
        var _a;
        super._prepareChildren();
        if (this.isDirty("syncWithAxis")) {
            let previousValue = this._prevSettings.syncWithAxis;
            if (previousValue) {
                if (this._syncDp) this._syncDp.dispose();
            }
            let syncWithAxis = this.get("syncWithAxis");
            if (syncWithAxis) {
                // Re-sync whenever any of the source axis's sync inputs change.
                // With autoZoom the sync target is the visible selection; without
                // it the axis holds its full range and only the full extremes
                // need recomputing. Mark dirty (not just a flag) so this axis is
                // queued even when the source publishes after its update pass.
                const resync = ()=>{
                    if (this.get("autoZoom", true)) this.markDirtySelectionExtremes();
                    else this.markDirtyExtremes();
                };
                this._syncDp = new (0, $a363f66303166aa1$export$9720df365053d143)([
                    syncWithAxis.onPrivate("selectionMinFinal", resync),
                    syncWithAxis.onPrivate("selectionMaxFinal", resync),
                    syncWithAxis.onPrivate("selectionStepFinal", resync),
                    syncWithAxis.onPrivate("minFinal", resync),
                    syncWithAxis.onPrivate("maxFinal", resync),
                    // Step can change on its own (e.g. a resize changes
                    // gridCount while min/max stay the same)
                    syncWithAxis.onPrivate("step", resync)
                ]);
            }
        }
        // `syncZeros` changes how the synced axis' min/max align (via `_syncAxes`),
        // so re-run both the full and selection extremes when it changes. Set flags
        // directly to avoid re-entering `_prepareChildren` while it is still dirty.
        if (this.isDirty("syncZeros")) {
            this._dirtyExtremes = true;
            this._dirtySelectionExtremes = true;
        }
        let someDirty = false;
        if (this.isDirty("min") || this.isDirty("max") || this.isDirty("maxPrecision") || this.isDirty("numberFormat")) {
            someDirty = true;
            (_a = this.ghostLabel) === null || _a === void 0 || _a.set("text", "");
        }
        // If a sync recompute only changes the step (e.g. a resize changed
        // gridCount while min/max stayed the same), nothing else marks the
        // range dirty, so track the step explicitly for the render gate below.
        const prevSelectionStepFinal = this.getPrivate("selectionStepFinal");
        //if (this._dirtyExtremes || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("min") || this.isDirty("max") || this.isDirty("extraMin") || this.isDirty("extraMax") || this.isDirty("logarithmic") || this.isDirty("treatZeroAs") || this.isDirty("baseValue") || this.isDirty("strictMinMax") || this.isDirty("maxPrecision")) {
        if (this._sizeDirty || this._dirtyExtremes || this._valuesDirty || someDirty || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("extraMin") || this.isDirty("extraMax") || this.isDirty("logarithmic") || this.isDirty("treatZeroAs") || this.isDirty("baseValue") || this.isDirty("strictMinMax") || this.isDirty("strictMinMaxSelection")) {
            this._getMinMax();
            this._dirtyExtremes = false;
        }
        this._handleSizeDirty();
        if (this._dirtySelectionExtremes && !this._isPanning && this.get("autoZoom", true)) {
            const chart = this.chart;
            let getMM = false;
            // #1563
            if (chart) {
                const letter = this.get("renderer").getPrivate("letter");
                if (letter == "Y") chart.xAxes.each((axis)=>{
                    if (axis.className != "ValueAxis") getMM = true;
                });
                else if (letter == "X") chart.yAxes.each((axis)=>{
                    if (axis.className != "ValueAxis") getMM = true;
                });
            }
            if (getMM) this._getSelectionMinMax();
            this._dirtySelectionExtremes = false;
        }
        this._groupData();
        if (this._sizeDirty || this._valuesDirty || this.isDirty("start") || this.isDirty("end") || this.isPrivateDirty("min") || this.isPrivateDirty("selectionMax") || this.isPrivateDirty("selectionMin") || this.isPrivateDirty("max") || this.isPrivateDirty("step") || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("logarithmic") || prevSelectionStepFinal !== this.getPrivate("selectionStepFinal")) {
            this._handleRangeChange();
            this._prepareAxisItems();
            this._updateAxisRanges();
        }
        this._baseValue = this.baseValue();
    }
    _handleSizeDirty() {
        if (this._sizeDirty && !this._dseHandled) {
            this._dirtySelectionExtremes = true;
            this._dseHandled = true;
            if (this.getPrivate("selectionMinFinal") != this.getPrivate("selectionMin") || this.getPrivate("selectionMaxFinal") != this.getPrivate("selectionMax")) this._dirtySelectionExtremes = false;
        }
    }
    _clearDirty() {
        super._clearDirty();
        this._dseHandled = false;
    }
    _groupData() {}
    /**
     * Logarithmic grid values are computed via `Math.pow(10, ...)`, which
     * carries floating-point noise (e.g. `4999.999999999999` instead of
     * `5000`). Round to ~10 significant digits so the grid values (and their
     * labels) come out clean; a format without a decimal directive (e.g.
     * `"#,###"`) would otherwise pass the noisy fraction straight through.
     */ _cleanLogValue(value) {
        if (!(value > 0)) return value;
        const decCount = 10 - Math.floor(Math.log(value) * Math.LOG10E);
        // $math.round computes Math.pow(10, decCount), which overflows to
        // Infinity for extremely small values (reachable via the 1e-50 seed
        // in _prepareAxisItems) and would turn the value into NaN. Such
        // values are off scale anyway, so leave them as is.
        if (decCount > 280) return value;
        return $f43e9e04b3f0548b$export$2077e0241d6afd3c(value, decCount);
    }
    _formatText(value) {
        const numberFormat = this.get("numberFormat");
        const formatter = this.getNumberFormatter();
        let text = "";
        if (numberFormat) text = formatter.format(value, numberFormat);
        else {
            // On a logarithmic axis every grid label is a different magnitude,
            // and the default number format keeps at most 5 decimals, so a
            // smaller value (e.g. 1e-8) would be rounded away to "0". Give such
            // values a format with just enough decimals to show them in full.
            // Values the default format can show keep the regular path, so
            // their labels stay exactly as before.
            let logDecimals = 0;
            if (this.get("logarithmic") && $f63bdea45a89cf24$export$7e4aa119212bc614(value) && value != 0) logDecimals = Math.min($05b1b40b69b15016$export$4aa4df8b0f34e5d(value), 20);
            if (logDecimals > 5) text = formatter.format(value, "#,###." + new Array(logDecimals + 1).join("#"));
            else text = formatter.format(value, undefined, this.getPrivate("stepDecimalPlaces"));
        }
        return text;
    }
    _prepareAxisItems() {
        const min = this.getPrivate("min");
        const max = this.getPrivate("max");
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(min) && $f63bdea45a89cf24$export$7e4aa119212bc614(max)) {
            const logarithmic = this.get("logarithmic");
            const step = this.getPrivate("step");
            const selectionMin = this.getPrivate("selectionMin");
            const selectionMax = this.getPrivate("selectionMax") + step;
            let value = selectionMin - step;
            let differencePower = 1;
            let minLog = min;
            if (logarithmic) {
                value = this._minLogAdjusted;
                if (value < selectionMin) while(value < selectionMin)value += step;
                minLog = value;
                if (minLog <= 0) {
                    let minRealLog = this._minRealLog;
                    if (!$f63bdea45a89cf24$export$7e4aa119212bc614(minRealLog)) minRealLog = 1;
                    minLog = Math.pow(10, Math.log(minRealLog) * Math.LOG10E);
                    if (step < 1) {
                        if ($f63bdea45a89cf24$export$7e4aa119212bc614(this._minRealLog)) minLog = this._minRealLog;
                        else minLog = Math.pow(10, -50);
                    }
                }
                differencePower = Math.log(selectionMax - step) * Math.LOG10E - Math.log(minLog) * Math.LOG10E;
                if (differencePower > 2) value = Math.pow(10, Math.log(minLog) * Math.LOG10E - 50);
            }
            /// minor grid
            const renderer = this.get("renderer");
            const minorLabelsEnabled = renderer.get("minorLabelsEnabled");
            const minorGridEnabled = renderer.get("minorGridEnabled", minorLabelsEnabled);
            let stepPower = Math.pow(10, Math.floor(Math.log(Math.abs(step)) * Math.LOG10E));
            const stepAdjusted = Math.round(step / stepPower);
            let minorGridCount = 2;
            if ($f43e9e04b3f0548b$export$2077e0241d6afd3c(stepAdjusted / 5, 10) % 1 == 0) minorGridCount = 5;
            if ($f43e9e04b3f0548b$export$2077e0241d6afd3c(stepAdjusted / 10, 10) % 1 == 0) minorGridCount = 10;
            let minorStep = step / minorGridCount;
            // end of minor grid
            let i = 0;
            let m = 0;
            let previous = -Infinity;
            const gridCount = this.get("renderer").gridCount();
            while(value < selectionMax){
                let dataItem;
                if (this.dataItems.length < i + 1) {
                    dataItem = new (0, $255dd6cbbf32a3ff$export$e9ab04247990d50b)(this, undefined, {});
                    this._dataItems.push(dataItem);
                    this.processDataItem(dataItem);
                } else dataItem = this.dataItems[i];
                this._createAssets(dataItem, []);
                this._toggleDataItem(dataItem, true);
                const itemValue = logarithmic ? this._cleanLogValue(value) : value;
                dataItem.setRaw("value", itemValue);
                const label = dataItem.get("label");
                if (label) label.set("text", this._formatText(itemValue));
                this._prepareDataItem(dataItem);
                let nextValue = value;
                if (!logarithmic) nextValue += step;
                else if (differencePower > 2) {
                    const targetGridCount = Math.max(1, gridCount);
                    // how many log "powers" (decades) one major grid line should jump
                    const x = Math.max(1, Math.ceil(differencePower / targetGridCount));
                    // use stepped exponent so total major items stays around gridCount
                    const exponent = Math.log(minLog) * Math.LOG10E + (i + 1) * x - 50;
                    nextValue = Math.pow(10, exponent);
                } else nextValue += step;
                // minor grid
                if (minorGridEnabled) {
                    let minorValue = value + minorStep;
                    if (logarithmic) {
                        if (differencePower > 2) {
                            let minorMinMaxStep = this._adjustMinMax(value, nextValue, 10);
                            minorStep = minorMinMaxStep.step;
                        }
                        minorValue = value + minorStep;
                    }
                    while(minorValue < nextValue - step * 0.00000000001){
                        let minorDataItem;
                        if (this.minorDataItems.length < m + 1) {
                            minorDataItem = new (0, $255dd6cbbf32a3ff$export$e9ab04247990d50b)(this, undefined, {});
                            this.minorDataItems.push(minorDataItem);
                            this.processDataItem(minorDataItem);
                        } else minorDataItem = this.minorDataItems[m];
                        this._createAssets(minorDataItem, [
                            "minor"
                        ], true);
                        this._toggleDataItem(minorDataItem, true);
                        const minorItemValue = logarithmic ? this._cleanLogValue(minorValue) : minorValue;
                        minorDataItem.setRaw("value", minorItemValue);
                        const minorLabel = minorDataItem.get("label");
                        if (minorLabel && minorLabelsEnabled) minorLabel.set("text", this._formatText(minorItemValue));
                        this._prepareDataItem(minorDataItem);
                        // Hide the minor label after `_prepareDataItem`: it calls
                        // `toggleVisibility`, which would otherwise re-show the label.
                        if (minorLabel && !minorLabelsEnabled) minorLabel.setPrivate("visible", false);
                        minorValue += minorStep;
                        m++;
                    }
                }
                value = nextValue;
                if (previous == value) break;
                let stepPower = Math.pow(10, Math.floor(Math.log(Math.abs(step)) * Math.LOG10E));
                if (stepPower < 1 && !logarithmic) {
                    // exponent is less then 1 too. Count decimals of exponent
                    let decCount = Math.round(Math.abs(Math.log(Math.abs(stepPower)) * Math.LOG10E)) + 2;
                    // round value to avoid floating point issues
                    value = $f43e9e04b3f0548b$export$2077e0241d6afd3c(value, decCount);
                }
                i++;
                // #103520
                if (logarithmic && differencePower <= 2) {
                    if (value - step < step) value = step;
                }
                previous = value;
            }
            for(let j = i; j < this.dataItems.length; j++)this._toggleDataItem(this.dataItems[j], false);
            for(let j = m; j < this.minorDataItems.length; j++)this._toggleDataItem(this.minorDataItems[j], false);
            $2f30431acd054e2f$export$79b2f7037acddd43(this.series, (series)=>{
                if (series.inited) series._markDirtyAxes();
            });
            this._updateGhost();
        }
    }
    _prepareDataItem(dataItem, count) {
        let renderer = this.get("renderer");
        let value = dataItem.get("value");
        let endValue = dataItem.get("endValue");
        let position = this.valueToPosition(value);
        let endPosition = position;
        let fillEndPosition = this.valueToPosition(value + this.getPrivate("step"));
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(endValue)) {
            endPosition = this.valueToPosition(endValue);
            fillEndPosition = endPosition;
        }
        if (dataItem.get("isRange")) {
            if (endValue == null) fillEndPosition = position;
        }
        let labelEndPosition = endPosition;
        let labelEndValue = dataItem.get("labelEndValue");
        if (labelEndValue != null) labelEndPosition = this.valueToPosition(labelEndValue);
        renderer.updateLabel(dataItem.get("label"), position, labelEndPosition, count);
        const grid = dataItem.get("grid");
        renderer.updateGrid(grid, position, endPosition);
        if (grid) {
            if (value == this.get("baseValue", 0)) {
                grid.addTag("base");
                grid._applyThemes();
            } else if (grid.hasTag("base")) {
                grid.removeTag("base");
                grid._applyThemes();
            }
        }
        renderer.updateTick(dataItem.get("tick"), position, labelEndPosition, count);
        renderer.updateFill(dataItem.get("axisFill"), position, fillEndPosition);
        this._processBullet(dataItem);
        renderer.updateBullet(dataItem.get("bullet"), position, endPosition);
        if (!dataItem.get("isRange")) {
            const fillRule = this.get("fillRule");
            if (fillRule) fillRule(dataItem);
        }
    }
    _handleRangeChange() {
        let selectionMin = this.positionToValue(this.get("start", 0));
        let selectionMax = this.positionToValue(this.get("end", 1));
        let step;
        if (this._isSynced()) {
            // Honor the bounds/step that _syncAxes already computed; _adjustMinMax
            // would otherwise pick its own gridCount-driven step and silently
            // break the sync.
            selectionMin = this.getPrivate("selectionMinFinal", selectionMin);
            selectionMax = this.getPrivate("selectionMaxFinal", selectionMax);
            const stepFinal = this.getPrivate("selectionStepFinal");
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(stepFinal) && stepFinal > 0 && stepFinal < Infinity) step = stepFinal;
            else // Sync hasn't produced a usable step yet (e.g. first render
            // pass); a fixed or degenerate step here could make
            // _prepareAxisItems generate a near-infinite number of items.
            step = this._adjustMinMax(selectionMin, selectionMax, this.get("renderer").gridCount(), true).step;
            const stepDecimalPlaces = $05b1b40b69b15016$export$4aa4df8b0f34e5d(step);
            this.setPrivateRaw("stepDecimalPlaces", stepDecimalPlaces);
        } else {
            const gridCount = this.get("renderer").gridCount();
            let minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount, true);
            let stepDecimalPlaces = $05b1b40b69b15016$export$4aa4df8b0f34e5d(minMaxStep.step);
            this.setPrivateRaw("stepDecimalPlaces", stepDecimalPlaces);
            selectionMin = $f43e9e04b3f0548b$export$2077e0241d6afd3c(selectionMin, stepDecimalPlaces);
            selectionMax = $f43e9e04b3f0548b$export$2077e0241d6afd3c(selectionMax, stepDecimalPlaces);
            minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount, true);
            step = minMaxStep.step;
            selectionMin = minMaxStep.min;
            selectionMax = minMaxStep.max;
        }
        if (this.getPrivate("selectionMin") !== selectionMin || this.getPrivate("selectionMax") !== selectionMax || this.getPrivate("step") !== step) {
            // do not change to setPrivate, will cause SO
            this.setPrivateRaw("selectionMin", selectionMin);
            this.setPrivateRaw("selectionMax", selectionMax);
            this.setPrivateRaw("step", step);
        }
    }
    /**
     * Converts a relative position to a corresponding numeric value from axis
     * scale.
     *
     * @param   position  Relative position
     * @return            Value
     */ positionToValue(position) {
        const min = this.getPrivate("min");
        const max = this.getPrivate("max");
        if (!this.get("logarithmic")) return position * (max - min) + min;
        else return Math.pow(Math.E, (position * (Math.log(max) * Math.LOG10E - Math.log(min) * Math.LOG10E) + Math.log(min) * Math.LOG10E) / Math.LOG10E);
    }
    /**
     * Convers value to a relative position on axis.
     *
     * @param   value  Value
     * @return         Relative position
     */ valueToPosition(value) {
        const min = this.getPrivate("min");
        const max = this.getPrivate("max");
        if (!this.get("logarithmic")) return (value - min) / (max - min);
        else {
            if (value <= 0) {
                let treatZeroAs = this.get("treatZeroAs");
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(treatZeroAs)) value = treatZeroAs;
            }
            return (Math.log(value) * Math.LOG10E - Math.log(min) * Math.LOG10E) / (Math.log(max) * Math.LOG10E - Math.log(min) * Math.LOG10E);
        }
    }
    /**
     * @ignore
     */ valueToFinalPosition(value) {
        const min = this.getPrivate("minFinal");
        const max = this.getPrivate("maxFinal");
        if (!this.get("logarithmic")) return (value - min) / (max - min);
        else {
            if (value <= 0) {
                let treatZeroAs = this.get("treatZeroAs");
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(treatZeroAs)) value = treatZeroAs;
            }
            return (Math.log(value) * Math.LOG10E - Math.log(min) * Math.LOG10E) / (Math.log(max) * Math.LOG10E - Math.log(min) * Math.LOG10E);
        }
    }
    /**
     * Returns X coordinate in pixels corresponding to specific value.
     *
     * @param   value     Numeric value
     * @param   location  Location
     * @param   baseValue Base value
     * @return            X coordinate
     */ getX(value, location, baseValue) {
        value = baseValue + (value - baseValue) * location;
        const position = this.valueToPosition(value);
        return this._settings.renderer.positionToCoordinate(position);
    }
    /**
     * Returns X coordinate in pixels corresponding to specific value.
     *
     * @param   value     Numeric value
     * @param   location  Location
     * @param   baseValue Base value
     * @return            X coordinate
     */ getY(value, location, baseValue) {
        value = baseValue + (value - baseValue) * location;
        const position = this.valueToPosition(value);
        return this._settings.renderer.positionToCoordinate(position);
    }
    /**
     * @ignore
     */ getDataItemCoordinateX(dataItem, field, _cellLocation, axisLocation) {
        return this._settings.renderer.positionToCoordinate(this.getDataItemPositionX(dataItem, field, _cellLocation, axisLocation));
    }
    /**
     * @ignore
     */ getDataItemPositionX(dataItem, field, _cellLocation, axisLocation) {
        let value = dataItem.get(field);
        const stackToItem = dataItem.get("stackToItemX");
        if (stackToItem) {
            const series = dataItem.component;
            value = value * axisLocation + series.getStackedXValueWorking(dataItem, field);
        } else value = this._baseValue + (value - this._baseValue) * axisLocation;
        return this.valueToPosition(value);
    }
    /**
     * @ignore
     */ getDataItemCoordinateY(dataItem, field, _cellLocation, axisLocation) {
        return this._settings.renderer.positionToCoordinate(this.getDataItemPositionY(dataItem, field, _cellLocation, axisLocation));
    }
    /**
     * @ignore
     */ getDataItemPositionY(dataItem, field, _cellLocation, axisLocation) {
        let value = dataItem.get(field);
        const stackToItem = dataItem.get("stackToItemY");
        if (stackToItem) {
            const series = dataItem.component;
            value = value * axisLocation + series.getStackedYValueWorking(dataItem, field);
        } else value = this._baseValue + (value - this._baseValue) * axisLocation;
        return this.valueToPosition(value);
    }
    /**
     * Returns relative position of axis' `baseValue`.
     *
     * @return  Base value position
     */ basePosition() {
        return this.valueToPosition(this.baseValue());
    }
    /**
     * Base value of the [[ValueAxis]], which determines positive and negative
     * values.
     *
     * @return Base value
     */ baseValue() {
        const min = Math.min(this.getPrivate("minFinal", -Infinity), this.getPrivate("selectionMin", -Infinity));
        const max = Math.max(this.getPrivate("maxFinal", Infinity), this.getPrivate("selectionMax", Infinity));
        let baseValue = this.get("baseValue", 0);
        if (baseValue < min) baseValue = min;
        if (baseValue > max) baseValue = max;
        return baseValue;
    }
    /**
     * @ignore
     */ cellEndValue(value) {
        return value;
    }
    fixSmallStep(step) {
        // happens because of floating point error
        if (1 + step === 1) {
            step *= 2;
            return this.fixSmallStep(step);
        }
        return step;
    }
    _fixMin(min) {
        return min;
    }
    _fixMax(max) {
        return max;
    }
    _calculateTotals() {
        if (this.get("calculateTotals")) {
            let series = this.series[0];
            if (series) {
                let startIndex = series.startIndex();
                if (series.dataItems.length > 0) {
                    if (startIndex > 0) startIndex--;
                    let endIndex = series.endIndex();
                    if (endIndex < series.dataItems.length) endIndex++;
                    let field;
                    let vc;
                    if (series.get("yAxis") == this) {
                        field = "valueY";
                        vc = "vcy";
                    } else if (series.get("xAxis") == this) {
                        field = "valueX";
                        vc = "vcx";
                    }
                    let fieldWorking = field + "Working";
                    if (field) {
                        let seriesCount = this.series.length;
                        let includedSeries = [];
                        let vcValues = [];
                        for(let s = 0; s < seriesCount; s++){
                            let ser = this.series[s];
                            if (!ser.get("excludeFromTotal")) {
                                includedSeries.push(ser);
                                vcValues.push(ser.get(vc));
                            }
                        }
                        let len = includedSeries.length;
                        let fieldTotal = field + "Total";
                        let fieldSum = field + "Sum";
                        let fieldTotalPercent = field + "TotalPercent";
                        for(let i = startIndex; i < endIndex; i++){
                            let sum = 0;
                            let total = 0;
                            for(let s = 0; s < len; s++){
                                let dataItem = includedSeries[s].dataItems[i];
                                if (dataItem) {
                                    let value = dataItem.get(fieldWorking) * vcValues[s];
                                    if (!$f63bdea45a89cf24$export$c9f5652083b8129d(value)) {
                                        sum += value;
                                        total += Math.abs(value);
                                    }
                                }
                            }
                            for(let s = 0; s < len; s++){
                                let dataItem = includedSeries[s].dataItems[i];
                                if (dataItem) {
                                    let value = dataItem.get(fieldWorking) * vcValues[s];
                                    if (!$f63bdea45a89cf24$export$c9f5652083b8129d(value)) {
                                        dataItem.set(fieldTotal, total);
                                        dataItem.set(fieldSum, sum);
                                        dataItem.set(fieldTotalPercent, total == 0 ? 0 : value / total * 100);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    _getSelectionMinMax() {
        const min = this.getPrivate("minFinal");
        const max = this.getPrivate("maxFinal");
        const minDefined = this.get("min");
        const maxDefined = this.get("max");
        let extraMin = this.get("extraMin", 0);
        let extraMax = this.get("extraMax", 0);
        if (this.get("logarithmic")) {
            if (this.get("extraMin") == null) extraMin = 0.1;
            if (this.get("extraMax") == null) extraMax = 0.2;
        }
        const gridCount = this.get("renderer").gridCount();
        const selectionStrictMinMax = this.get("strictMinMaxSelection");
        let strictMinMax = this.get("strictMinMax");
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(min) && $f63bdea45a89cf24$export$7e4aa119212bc614(max)) {
            let selectionMin = max;
            let selectionMax = min;
            $2f30431acd054e2f$export$79b2f7037acddd43(this.series, (series)=>{
                if (!series.get("ignoreMinMax")) {
                    let seriesMin;
                    let seriesMax;
                    const outOfSelection = series.getPrivate("outOfSelection");
                    if (series.get("xAxis") === this) {
                        if (!outOfSelection) {
                            let minX = series.getPrivate("minX");
                            let maxX = series.getPrivate("maxX");
                            // solves #90085
                            if (series.startIndex() != 0 || series.endIndex() != series.dataItems.length) {
                                minX = undefined;
                                maxX = undefined;
                            }
                            seriesMin = series.getPrivate("selectionMinX", minX);
                            seriesMax = series.getPrivate("selectionMaxX", maxX);
                        }
                    } else if (series.get("yAxis") === this) {
                        if (!outOfSelection) {
                            let minY = series.getPrivate("minY");
                            let maxY = series.getPrivate("maxY");
                            // solves #90085
                            if (series.startIndex() != 0 || series.endIndex() != series.dataItems.length) {
                                minY = undefined;
                                maxY = undefined;
                            }
                            seriesMin = series.getPrivate("selectionMinY", minY);
                            seriesMax = series.getPrivate("selectionMaxY", maxY);
                        }
                    }
                    if (!series.isHidden() && !series.isShowing()) {
                        if ($f63bdea45a89cf24$export$7e4aa119212bc614(seriesMin)) selectionMin = Math.min(selectionMin, seriesMin);
                        if ($f63bdea45a89cf24$export$7e4aa119212bc614(seriesMax)) selectionMax = Math.max(selectionMax, seriesMax);
                    }
                }
            });
            this.axisRanges.each((range)=>{
                if (range.get("affectsMinMax")) {
                    let value = range.get("value");
                    if (value != null) {
                        selectionMin = Math.min(selectionMin, value);
                        selectionMax = Math.max(selectionMax, value);
                    }
                    value = range.get("endValue");
                    if (value != null) {
                        selectionMin = Math.min(selectionMin, value);
                        selectionMax = Math.max(selectionMax, value);
                    }
                }
            });
            if (selectionMin > selectionMax) [selectionMin, selectionMax] = [
                selectionMax,
                selectionMin
            ];
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(minDefined)) {
                if (strictMinMax) selectionMin = minDefined;
                else selectionMin = min;
            } else if (strictMinMax) {
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(this._minReal)) selectionMin = this._minReal;
            }
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxDefined)) {
                if (strictMinMax) selectionMax = maxDefined;
                else selectionMax = max;
            } else if (strictMinMax) {
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(this._maxReal)) selectionMax = this._maxReal;
            }
            if (selectionMin === selectionMax) {
                let smin = selectionMin;
                selectionMin -= this._deltaMinMax;
                selectionMax += this._deltaMinMax;
                if (selectionMin < min) {
                    let d = smin - min;
                    if (d == 0) d = this._deltaMinMax;
                    selectionMin = smin - d;
                    selectionMax = smin + d;
                    strictMinMax = true;
                }
                let minMaxStep2 = this._adjustMinMax(selectionMin, selectionMax, gridCount, strictMinMax);
                selectionMin = minMaxStep2.min;
                selectionMax = minMaxStep2.max;
            }
            let selectionMinReal = selectionMin;
            let selectionMaxReal = selectionMax;
            let delta = selectionMax - selectionMin;
            selectionMin -= delta * extraMin;
            selectionMax += delta * extraMax;
            let minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount);
            selectionMin = minMaxStep.min;
            selectionMax = minMaxStep.max;
            selectionMin = $f43e9e04b3f0548b$export$386b748ab02f16a0(selectionMin, min, max);
            selectionMax = $f43e9e04b3f0548b$export$386b748ab02f16a0(selectionMax, min, max);
            // do it for the second time !important
            minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount, true);
            if (!strictMinMax) {
                selectionMin = minMaxStep.min;
                selectionMax = minMaxStep.max;
            }
            const syncWithAxis = this.get("syncWithAxis");
            if (syncWithAxis) {
                minMaxStep = this._syncAxes(selectionMin, selectionMax, minMaxStep.step, syncWithAxis.getPrivate("selectionMinFinal", syncWithAxis.getPrivate("minFinal", 0)), syncWithAxis.getPrivate("selectionMaxFinal", syncWithAxis.getPrivate("maxFinal", 1)), syncWithAxis.getPrivate("selectionStepFinal", syncWithAxis.getPrivate("step", 1)));
                selectionMin = minMaxStep.min;
                selectionMax = minMaxStep.max;
            }
            if (strictMinMax && !syncWithAxis) {
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(minDefined)) selectionMin = Math.max(selectionMin, minDefined);
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxDefined)) selectionMax = Math.min(selectionMax, maxDefined);
            }
            if (selectionStrictMinMax && !syncWithAxis) {
                selectionMin = selectionMinReal - (selectionMaxReal - selectionMinReal) * extraMin;
                selectionMax = selectionMaxReal + (selectionMaxReal - selectionMinReal) * extraMax;
            }
            if (strictMinMax && !syncWithAxis) {
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(minDefined)) selectionMin = minDefined;
                else selectionMin = selectionMinReal;
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxDefined)) selectionMax = maxDefined;
                else selectionMax = selectionMaxReal;
                if (selectionMax - selectionMin <= 0.00000001) {
                    selectionMin -= this._deltaMinMax;
                    selectionMax += this._deltaMinMax;
                }
                let delta = selectionMax - selectionMin;
                selectionMin -= delta * extraMin;
                selectionMax += delta * extraMax;
            }
            if (this.get("logarithmic")) {
                if (selectionMin <= 0) selectionMin = selectionMinReal * (1 - Math.min(extraMin, 0.99));
                if (selectionMin < min) selectionMin = min;
                if (selectionMax > max) selectionMax = max;
            }
            let len = Math.min(20, Math.ceil(Math.log(this.getPrivate("maxZoomFactor", 100) + 1) / Math.LN10) + 2);
            let start = $f43e9e04b3f0548b$export$2077e0241d6afd3c(this.valueToFinalPosition(selectionMin), len);
            let end = $f43e9e04b3f0548b$export$2077e0241d6afd3c(this.valueToFinalPosition(selectionMax), len);
            this.setPrivateRaw("selectionMinFinal", selectionMin);
            this.setPrivateRaw("selectionMaxFinal", selectionMax);
            this.setPrivateRaw("selectionStepFinal", minMaxStep.step);
            this.zoom(start, end);
        }
    }
    _getMinMax() {
        let minDefined = this.get("min");
        let maxDefined = this.get("max");
        let min = Infinity;
        let max = -Infinity;
        let extraMin = this.get("extraMin", 0);
        let extraMax = this.get("extraMax", 0);
        if (this.get("logarithmic")) {
            if (!this.get("strictMinMax")) {
                if (this.get("extraMin") == null) extraMin = 0.1;
                if (this.get("extraMax") == null) extraMax = 0.2;
            }
        }
        let minDiff = Infinity;
        $2f30431acd054e2f$export$79b2f7037acddd43(this.series, (series)=>{
            if (!series.get("ignoreMinMax")) {
                let seriesMin;
                let seriesMax;
                if (series.get("xAxis") === this) {
                    seriesMin = series.getPrivate("minX");
                    seriesMax = series.getPrivate("maxX");
                } else if (series.get("yAxis") === this) {
                    seriesMin = series.getPrivate("minY");
                    seriesMax = series.getPrivate("maxY");
                }
                if ($f63bdea45a89cf24$export$7e4aa119212bc614(seriesMin) && $f63bdea45a89cf24$export$7e4aa119212bc614(seriesMax)) {
                    min = Math.min(min, seriesMin);
                    max = Math.max(max, seriesMax);
                    let diff = seriesMax - seriesMin;
                    if (diff <= 0) diff = Math.abs(seriesMax / 100);
                    if (diff < minDiff) minDiff = diff;
                }
            }
        });
        this.axisRanges.each((range)=>{
            if (range.get("affectsMinMax")) {
                let value = range.get("value");
                if (value != null) {
                    min = Math.min(min, value);
                    max = Math.max(max, value);
                }
                value = range.get("endValue");
                if (value != null) {
                    min = Math.min(min, value);
                    max = Math.max(max, value);
                }
            }
        });
        if (this.get("logarithmic")) {
            let treatZeroAs = this.get("treatZeroAs");
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(treatZeroAs)) {
                if (min <= 0) min = treatZeroAs;
            }
            if (min <= 0) new Error("Logarithmic value axis can not have values <= 0.");
        }
        if (min === 0 && max === 0) {
            max = 0.9;
            min = -0.9;
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(minDefined)) min = minDefined;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxDefined)) max = maxDefined;
        // meaning no min/max found on series/ranges and no min/max was defined
        if (min === Infinity || max === -Infinity) {
            this.setPrivate("minFinal", undefined);
            this.setPrivate("maxFinal", undefined);
            return;
        }
        if (min > max) [min, max] = [
            max,
            min
        ];
        const initialMin = min;
        const initialMax = max;
        // adapter
        let minAdapted = this.adapters.fold("min", min);
        let maxAdapted = this.adapters.fold("max", max);
        this._minRealLog = min;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(minAdapted)) min = minAdapted;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxAdapted)) max = maxAdapted;
        // DateAxis does some magic here
        min = this._fixMin(min);
        max = this._fixMax(max);
        // this happens if starLocation and endLocation are 0.5 and DateAxis has only one date
        if (max - min <= 1 / Math.pow(10, 15)) {
            if (max - min !== 0) this._deltaMinMax = (max - min) / 2;
            else this._getDelta(max);
            min -= this._deltaMinMax;
            max += this._deltaMinMax;
        }
        // add extras
        min -= (max - min) * extraMin;
        max += (max - min) * extraMax;
        if (this.get("logarithmic")) {
            // don't let min go below 0 if real min is >= 0
            if (min < 0 && initialMin >= 0) min = 0;
            // don't let max go above 0 if real max is <= 0
            if (max > 0 && initialMax <= 0) max = 0;
        }
        this._minReal = min;
        this._maxReal = max;
        let strictMinMax = this.get("strictMinMax");
        let strictMinMaxSelection = this.get("strictMinMaxSelection", false);
        if (strictMinMaxSelection) strictMinMax = strictMinMaxSelection;
        let strict = strictMinMax;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxDefined)) strict = true;
        let gridCount = this.get("renderer").gridCount();
        let minMaxStep = this._adjustMinMax(min, max, gridCount, strict);
        min = minMaxStep.min;
        max = minMaxStep.max;
        // do it for the second time with strict true (importat!)
        minMaxStep = this._adjustMinMax(min, max, gridCount, true);
        min = minMaxStep.min;
        max = minMaxStep.max;
        // return min max if strict
        if (strictMinMax) {
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(minDefined)) min = minDefined;
            else min = this._minReal;
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxDefined)) max = maxDefined;
            else max = this._maxReal;
            if (max - min <= 0.00000001) {
                min -= this._deltaMinMax;
                max += this._deltaMinMax;
            }
            let delta = max - min;
            min -= delta * extraMin;
            max += delta * extraMax;
        }
        minAdapted = this.adapters.fold("min", min);
        maxAdapted = this.adapters.fold("max", max);
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(minAdapted)) min = minAdapted;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxAdapted)) max = maxAdapted;
        if (minDiff == Infinity) minDiff = max - min;
        // this is to avoid floating point number error
        let decCount = Math.round(Math.abs(Math.log(Math.abs(max - min)) * Math.LOG10E)) + 5;
        min = $f43e9e04b3f0548b$export$2077e0241d6afd3c(min, decCount);
        max = $f43e9e04b3f0548b$export$2077e0241d6afd3c(max, decCount);
        const syncWithAxis = this.get("syncWithAxis");
        if (syncWithAxis) {
            minMaxStep = this._syncAxes(min, max, minMaxStep.step, syncWithAxis.getPrivate("minFinal", syncWithAxis.getPrivate("min", 0)), syncWithAxis.getPrivate("maxFinal", syncWithAxis.getPrivate("max", 1)), syncWithAxis.getPrivate("step", 1));
            min = minMaxStep.min;
            max = minMaxStep.max;
            // Without autoZoom the axis holds its full range, so the synced
            // full range is also its selection. Publish it so that
            // _handleRangeChange renders the synced step and so that axes
            // synced to this one get notified. With autoZoom the selection is
            // computed in _getSelectionMinMax instead.
            if (!this.get("autoZoom", true)) {
                this.setPrivateRaw("selectionMinFinal", min);
                this.setPrivateRaw("selectionMaxFinal", max);
                this.setPrivateRaw("selectionStepFinal", minMaxStep.step);
            }
        }
        this.setPrivateRaw("maxZoomFactor", Math.max(1, Math.ceil((max - min) / minDiff * this.get("maxZoomFactor", 100))));
        this._fixZoomFactor();
        if (this.get("logarithmic")) {
            this._minLogAdjusted = min;
            min = this._minReal;
            max = this._maxReal;
            if (min <= 0) min = initialMin * (1 - Math.min(extraMin, 0.99));
        }
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(min) && $f63bdea45a89cf24$export$7e4aa119212bc614(max)) {
            if (this.getPrivate("minFinal") !== min || this.getPrivate("maxFinal") !== max) {
                this.setPrivate("minFinal", min);
                this.setPrivate("maxFinal", max);
                this._saveMinMax(min, max);
                const duration = this.get("interpolationDuration", 0);
                const easing = this.get("interpolationEasing");
                this.animatePrivate({
                    key: "min",
                    to: min,
                    duration: duration,
                    easing: easing
                });
                this.animatePrivate({
                    key: "max",
                    to: max,
                    duration: duration,
                    easing: easing
                });
            }
        }
    }
    _fixZoomFactor() {}
    _getDelta(max) {
        // the number by which we need to raise 10 to get difference
        let exponent = Math.log(Math.abs(max)) * Math.LOG10E;
        // here we find a number which is power of 10 and has the same count of numbers as difference has
        let power = Math.pow(10, Math.floor(exponent));
        // reduce this number by 10 times
        power = power / 10;
        this._deltaMinMax = power;
    }
    _saveMinMax(_min, _max) {}
    _adjustMinMax(min, max, gridCount, strictMode) {
        // will fail if 0
        if (gridCount <= 1) gridCount = 1;
        gridCount = Math.round(gridCount);
        let initialMin = min;
        let initialMax = max;
        let difference = max - min;
        // in case min and max is the same, use max
        if (difference === 0) difference = Math.abs(max);
        // the number by which we need to raise 10 to get difference
        let exponent = Math.log(Math.abs(difference)) * Math.LOG10E;
        // here we find a number which is power of 10 and has the same count of numbers as difference has
        let power = Math.pow(10, Math.floor(exponent));
        // reduce this number by 10 times
        power = power / 10;
        let extra = power;
        if (strictMode) extra = 0;
        // round down min
        if (strictMode) {
            min = Math.floor(min / power) * power;
            // round up max
            max = Math.ceil(max / power) * power;
        } else {
            min = Math.ceil(min / power) * power - extra;
            // round up max
            max = Math.floor(max / power) * power + extra;
        }
        // don't let min go below 0 if real min is >= 0
        if (min < 0 && initialMin >= 0) min = 0;
        // don't let max go above 0 if real max is <= 0
        if (max > 0 && initialMax <= 0) max = 0;
        exponent = Math.log(Math.abs(difference)) * Math.LOG10E;
        power = Math.pow(10, Math.floor(exponent));
        power = power / 100; // used to be 10 in v4, but this caused issue that there could be limited number of grids with even very small minGridDistance
        // approximate difference between two grid lines
        let step = Math.ceil(difference / gridCount / power) * power;
        let stepPower = Math.pow(10, Math.floor(Math.log(Math.abs(step)) * Math.LOG10E));
        // the step should divide by  2, 5, and 10.
        let stepDivisor = Math.ceil(step / stepPower); // number 0 - 10
        if (stepDivisor > 5) stepDivisor = 10;
        else if (stepDivisor <= 5 && stepDivisor > 2) stepDivisor = 5;
        // now get real step
        step = Math.ceil(step / (stepPower * stepDivisor)) * stepPower * stepDivisor;
        let maxPrecision = this.get("maxPrecision");
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxPrecision)) {
            let ceiledStep = $f43e9e04b3f0548b$export$803ce6b71a0a94b2(step, maxPrecision);
            if (maxPrecision < Number.MAX_VALUE && step !== ceiledStep) {
                step = ceiledStep;
                if (step == 0) step = 1;
            }
        }
        let decCount = 0;
        // in case numbers are smaller than 1
        if (stepPower < 1) {
            // exponent is less then 1 too. Count decimals of exponent
            decCount = Math.round(Math.abs(Math.log(Math.abs(stepPower)) * Math.LOG10E)) + 1;
            // round step
            step = $f43e9e04b3f0548b$export$2077e0241d6afd3c(step, decCount);
        }
        // final min and max
        let minCount = Math.floor(min / step);
        min = $f43e9e04b3f0548b$export$2077e0241d6afd3c(step * minCount, decCount);
        let maxCount;
        if (!strictMode) maxCount = Math.ceil(max / step);
        else maxCount = Math.floor(max / step);
        if (maxCount === minCount) maxCount++;
        max = $f43e9e04b3f0548b$export$2077e0241d6afd3c(step * maxCount, decCount);
        if (max < initialMax) max = max + step;
        if (min > initialMin) min = min - step;
        step = this.fixSmallStep(step);
        return {
            min: min,
            max: max,
            step: step
        };
    }
    /**
     * Returns text to be used in an axis tooltip for specific relative position.
     *
     * @param   position  Position
     * @return            Tooltip text
     */ getTooltipText(position, _adjustPosition) {
        const numberFormat = this.get("tooltipNumberFormat", this.get("numberFormat"));
        const formatter = this.getNumberFormatter();
        const extraDecimals = this.get("extraTooltipPrecision", 0);
        const decimals = this.getPrivate("stepDecimalPlaces", 0) + extraDecimals;
        const value = $f43e9e04b3f0548b$export$2077e0241d6afd3c(this.positionToValue(position), decimals);
        if (numberFormat) return formatter.format(value, numberFormat);
        else return formatter.format(value, undefined, decimals);
    }
    /**
     * Returns a data item from series that is closest to the `position`.
     *
     * @param   series    Series
     * @param   position  Relative position
     * @return            Data item
     */ getSeriesItem(series, position) {
        let fieldName = this.getPrivate("name") + this.get("renderer").getPrivate("letter");
        let value = this.positionToValue(position);
        let index = undefined;
        let oldDiff;
        $2f30431acd054e2f$export$79b2f7037acddd43(series.dataItems, (dataItem, i)=>{
            const diff = Math.abs(dataItem.get(fieldName) - value);
            if (index === undefined || diff < oldDiff) {
                index = i;
                oldDiff = diff;
            }
        });
        if (index != null) return series.dataItems[index];
    }
    /**
     * Zooms the axis to specific `start` and `end` values.
     *
     * Optional `duration` specifies duration of zoom animation in milliseconds.
     *
     * @param  start     Start value
     * @param  end       End value
     * @param  duration  Duration in milliseconds
     */ zoomToValues(start, end, duration) {
        const min = this.getPrivate("minFinal", this.getPrivate("min", 0));
        const max = this.getPrivate("maxFinal", this.getPrivate("max", 1));
        if (this.getPrivate("min") != null && this.getPrivate("max") != null) this.zoom((start - min) / (max - min), (end - min) / (max - min), duration);
    }
    /**
     * Syncs with a target axis.
     *
     * @param  min  Min
     * @param  max  Max
     * @param  step Step
     */ _syncAxes(min, max, step, syncMin, syncMax, syncStep) {
        let axis = this.get("syncWithAxis");
        if (axis) {
            let targetCount = Math.round((syncMax - syncMin) / syncStep);
            if ($f63bdea45a89cf24$export$7e4aa119212bc614(targetCount) && targetCount > 0 && targetCount < Infinity) {
                if (this.get("syncZeros") && syncMin <= 0 && syncMax >= 0) {
                    // Count intervals below/above zero on source axis
                    let belowCount = Math.round((0 - syncMin) / syncStep);
                    let aboveCount = targetCount - belowCount;
                    // Find the smallest nice step that covers this axis's
                    // data on both sides with the same below/above split
                    let rawStep = 0;
                    if (belowCount > 0 && min < 0) rawStep = Math.abs(min) / belowCount;
                    if (aboveCount > 0 && max > 0) rawStep = Math.max(rawStep, max / aboveCount);
                    // Fallback: if one side has no data but has intervals
                    if (rawStep == 0) rawStep = (max - min) / targetCount;
                    // A degenerate range would produce a zero/NaN step; keep
                    // the axis's own min/max/step in that case
                    if (rawStep > 0 && rawStep < Infinity) {
                        step = this._niceStep(rawStep);
                        min = -step * belowCount;
                        max = step * aboveCount;
                    }
                } else {
                    // Regular grid count sync (no zero alignment)
                    let rawStep = (max - min) / targetCount;
                    // A degenerate range would produce a zero/NaN step; keep
                    // the axis's own min/max/step in that case
                    if (rawStep > 0 && rawStep < Infinity) {
                        step = this._niceStep(rawStep);
                        // Snap min/max to step boundaries ensuring data coverage
                        let newMin = Math.floor(min / step) * step;
                        let newMax = newMin + step * targetCount;
                        // Ensure max covers the data
                        if (newMax < max) {
                            newMin = Math.ceil(max / step) * step - step * targetCount;
                            newMax = newMin + step * targetCount;
                        }
                        // Preserve zero boundaries
                        if (min >= 0 && newMin < 0) {
                            newMin = 0;
                            newMax = step * targetCount;
                        }
                        if (max <= 0 && newMax > 0) {
                            newMax = 0;
                            newMin = -(step * targetCount);
                        }
                        min = newMin;
                        max = newMax;
                    }
                }
            }
        }
        return {
            min: min,
            max: max,
            step: step
        };
    }
    /**
     * Rounds a raw step value up to the nearest "nice" number
     * (1, 2, 5, 10, 20, 50, etc.), respecting maxPrecision.
     */ _niceStep(rawStep) {
        // A zero/NaN/negative step would stall axis item generation downstream,
        // so never let one through
        if (!$f63bdea45a89cf24$export$7e4aa119212bc614(rawStep) || rawStep <= 0 || rawStep == Infinity) return 1;
        let stepPower = Math.pow(10, Math.floor(Math.log(Math.abs(rawStep)) * Math.LOG10E));
        let normalized = rawStep / stepPower;
        if (normalized <= 1) normalized = 1;
        else if (normalized <= 2) normalized = 2;
        else if (normalized <= 5) normalized = 5;
        else normalized = 10;
        let step = normalized * stepPower;
        // stepPower can underflow to 0 for extremely small raw steps
        if (!(step > 0 && step < Infinity)) step = rawStep;
        let maxPrecision = this.get("maxPrecision");
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxPrecision)) {
            let ceiledStep = $f43e9e04b3f0548b$export$803ce6b71a0a94b2(step, maxPrecision);
            if (maxPrecision < Number.MAX_VALUE && step !== ceiledStep) {
                step = ceiledStep;
                if (step == 0) step = 1;
            }
        }
        return step;
    }
    /**
     * Returns relative position between two grid lines of the axis.
     *
     * @return Position
     */ getCellWidthPosition() {
        let max = this.getPrivate("selectionMax", this.getPrivate("max"));
        let min = this.getPrivate("selectionMin", this.getPrivate("min"));
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(max) && $f63bdea45a89cf24$export$7e4aa119212bc614(min)) return this.getPrivate("step", 1) / (max - min);
        return 0.05;
    }
    /**
     * @ignore
     */ nextPosition(count) {
        if (count == null) count = 1;
        if (this.get("renderer").getPrivate("letter") == "Y") count *= -1;
        let value = this.positionToValue(this.getPrivate("tooltipPosition", 0));
        value += this.getPrivate("step", 1) * count;
        value = $f43e9e04b3f0548b$export$386b748ab02f16a0(value, this.getPrivate("selectionMin", 0), this.getPrivate("selectionMax", 1));
        return this.toGlobalPosition(this.valueToPosition(value));
    }
}
$382dcb8802c42596$export$aa40340ad42cdd20.className = "ValueAxis";
$382dcb8802c42596$export$aa40340ad42cdd20.classNames = (0, $339e015cec6c2240$export$d06866a9fb0606da).classNames.concat([
    $382dcb8802c42596$export$aa40340ad42cdd20.className
]);





function $59cb0344df9474fa$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


const $f0560c970166d25b$export$2335f513bbd82c6d = Math.abs;
const $f0560c970166d25b$export$b8b770ee6a0d9760 = Math.atan2;
const $f0560c970166d25b$export$50d414a77b60d802 = Math.cos;
const $f0560c970166d25b$export$8960430cfd85939f = Math.max;
const $f0560c970166d25b$export$96ec731ed4dcb222 = Math.min;
const $f0560c970166d25b$export$5de3937cb4b592ed = Math.sin;
const $f0560c970166d25b$export$eba8049fb5020b81 = Math.sqrt;
const $f0560c970166d25b$export$6c421550c66a327d = 1e-12;
const $f0560c970166d25b$export$18c7bea995a110f = Math.PI;
const $f0560c970166d25b$export$e51408a300e8929a = $f0560c970166d25b$export$18c7bea995a110f / 2;
const $f0560c970166d25b$export$a4b4b4d4d776fe92 = 2 * $f0560c970166d25b$export$18c7bea995a110f;
function $f0560c970166d25b$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f0560c970166d25b$export$18c7bea995a110f : Math.acos(x);
}
function $f0560c970166d25b$export$41726bdb1fc63f(x) {
    return x >= 1 ? $f0560c970166d25b$export$e51408a300e8929a : x <= -1 ? -$f0560c970166d25b$export$e51408a300e8929a : Math.asin(x);
}


const $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $c9f66a4d1c06b373$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $c9f66a4d1c06b373$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $c9f66a4d1c06b373$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $c9f66a4d1c06b373$var$append : $c9f66a4d1c06b373$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._append`A${r},${r},0,${+(da >= $c9f66a4d1c06b373$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $c9f66a4d1c06b373$export$bb654e07daaf8c3a() {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$c9f66a4d1c06b373$export$bb654e07daaf8c3a.prototype = $c9f66a4d1c06b373$export$4b2950bdac9b6ee9.prototype;
function $c9f66a4d1c06b373$export$e181c6ece8d9cc5f(digits = 3) {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9(+digits);
}


function $5c3aa3aea2c844cf$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $c9f66a4d1c06b373$export$4b2950bdac9b6ee9)(digits);
}


function $b196a0c5210e8c70$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $b196a0c5210e8c70$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $b196a0c5210e8c70$var$arcStartAngle(d) {
    return d.startAngle;
}
function $b196a0c5210e8c70$var$arcEndAngle(d) {
    return d.endAngle;
}
function $b196a0c5210e8c70$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $b196a0c5210e8c70$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $f0560c970166d25b$export$6c421550c66a327d)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $b196a0c5210e8c70$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $f0560c970166d25b$export$eba8049fb5020b81)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $f0560c970166d25b$export$eba8049fb5020b81)((0, $f0560c970166d25b$export$8960430cfd85939f)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $b196a0c5210e8c70$export$2e2bcd8739ae039() {
    var innerRadius = $b196a0c5210e8c70$var$arcInnerRadius, outerRadius = $b196a0c5210e8c70$var$arcOuterRadius, cornerRadius = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $b196a0c5210e8c70$var$arcStartAngle, endAngle = $b196a0c5210e8c70$var$arcEndAngle, padAngle = $b196a0c5210e8c70$var$arcPadAngle, context = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $f0560c970166d25b$export$e51408a300e8929a), a1 = endAngle.apply(this, arguments) - (0, $f0560c970166d25b$export$e51408a300e8929a), da = (0, $f0560c970166d25b$export$2335f513bbd82c6d)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $f0560c970166d25b$export$6c421550c66a327d))) context.moveTo(0, 0);
        else if (da > (0, $f0560c970166d25b$export$a4b4b4d4d776fe92) - (0, $f0560c970166d25b$export$6c421550c66a327d)) {
            context.moveTo(r1 * (0, $f0560c970166d25b$export$50d414a77b60d802)(a0), r1 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $f0560c970166d25b$export$6c421550c66a327d)) {
                context.moveTo(r0 * (0, $f0560c970166d25b$export$50d414a77b60d802)(a1), r0 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $f0560c970166d25b$export$6c421550c66a327d) && (padRadius ? +padRadius.apply(this, arguments) : (0, $f0560c970166d25b$export$eba8049fb5020b81)(r0 * r0 + r1 * r1)), rc = (0, $f0560c970166d25b$export$96ec731ed4dcb222)((0, $f0560c970166d25b$export$2335f513bbd82c6d)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $f0560c970166d25b$export$6c421550c66a327d)) {
                var p0 = (0, $f0560c970166d25b$export$41726bdb1fc63f)(rp / r0 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(ap)), p1 = (0, $f0560c970166d25b$export$41726bdb1fc63f)(rp / r1 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(ap));
                if ((da0 -= p0 * 2) > (0, $f0560c970166d25b$export$6c421550c66a327d)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $f0560c970166d25b$export$6c421550c66a327d)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $f0560c970166d25b$export$50d414a77b60d802)(a01), y01 = r1 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a01), x10 = r0 * (0, $f0560c970166d25b$export$50d414a77b60d802)(a10), y10 = r0 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a10);
            // Apply rounded corners?
            if (rc > (0, $f0560c970166d25b$export$6c421550c66a327d)) {
                var x11 = r1 * (0, $f0560c970166d25b$export$50d414a77b60d802)(a11), y11 = r1 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a11), x00 = r0 * (0, $f0560c970166d25b$export$50d414a77b60d802)(a00), y00 = r0 * (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $f0560c970166d25b$export$18c7bea995a110f)) {
                    if (oc = $b196a0c5210e8c70$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $f0560c970166d25b$export$5de3937cb4b592ed)((0, $f0560c970166d25b$export$fd6306be3fde5b04)((ax * bx + ay * by) / ((0, $f0560c970166d25b$export$eba8049fb5020b81)(ax * ax + ay * ay) * (0, $f0560c970166d25b$export$eba8049fb5020b81)(bx * bx + by * by))) / 2), lc = (0, $f0560c970166d25b$export$eba8049fb5020b81)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $f0560c970166d25b$export$96ec731ed4dcb222)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $f0560c970166d25b$export$96ec731ed4dcb222)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $f0560c970166d25b$export$6c421550c66a327d))) context.moveTo(x01, y01);
            else if (rc1 > (0, $f0560c970166d25b$export$6c421550c66a327d)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $f0560c970166d25b$export$6c421550c66a327d)) || !(da0 > (0, $f0560c970166d25b$export$6c421550c66a327d))) context.lineTo(x10, y10);
            else if (rc0 > (0, $f0560c970166d25b$export$6c421550c66a327d)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $f0560c970166d25b$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $f0560c970166d25b$export$18c7bea995a110f) / 2;
        return [
            (0, $f0560c970166d25b$export$50d414a77b60d802)(a) * r,
            (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}



class $73fc4ed9ee1a8a47$export$b3f2e2de3a8baa1e extends (0, $2ffdafbe1fe6a946$export$29d3e417456abdad) {
    constructor(){
        super(...arguments);
        /**
         * @ignore
         */ this.ix = 0;
        /**
         * @ignore
         */ this.iy = 0;
        this._generator = (0, $b196a0c5210e8c70$export$2e2bcd8739ae039)();
    }
    _getTooltipPoint() {
        let tooltipX = this.get("tooltipX");
        let tooltipY = this.get("tooltipY");
        let x = 0;
        let y = 0;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(tooltipX)) x = tooltipX;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(tooltipY)) y = tooltipY;
        let radius = this.get("radius", 0);
        let innerRadius = this.get("innerRadius", 0);
        let dRadius = this.get("dRadius", 0);
        let dInnerRadius = this.get("dInnerRadius", 0);
        radius += dRadius;
        innerRadius += dInnerRadius;
        if (innerRadius < 0) innerRadius = radius + innerRadius;
        if (tooltipX instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) x = this.ix * (innerRadius + (radius - innerRadius) * tooltipX.value);
        if (tooltipY instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) y = this.iy * (innerRadius + (radius - innerRadius) * tooltipY.value);
        if (this.get("arc") >= 360 && innerRadius == 0) {
            x = 0;
            y = 0;
        }
        return {
            x: x,
            y: y
        };
    }
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("radius") || this.isDirty("arc") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("dRadius") || this.isDirty("dInnerRadius") || this.isDirty("cornerRadius") || this.isDirty("shiftRadius")) this._clear = true;
    }
    _changed() {
        super._changed();
        if (this._clear) {
            let startAngle = this.get("startAngle", 0);
            let arc = this.get("arc", 0);
            const generator = this._generator;
            if (arc < 0) {
                startAngle = startAngle + arc;
                arc = arc * -1;
            }
            if (arc > 0.1) generator.cornerRadius(this.get("cornerRadius", 0));
            generator.context(this._display);
            let radius = this.get("radius", 0);
            let innerRadius = this.get("innerRadius", 0);
            let dRadius = this.get("dRadius", 0);
            let dInnerRadius = this.get("dInnerRadius", 0);
            radius += dRadius;
            innerRadius += dInnerRadius;
            if (innerRadius < 0) innerRadius = radius + innerRadius;
            generator({
                innerRadius: innerRadius,
                outerRadius: radius,
                startAngle: (startAngle + 90) * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a,
                endAngle: (startAngle + arc + 90) * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a
            });
            let middleAngle = startAngle + arc / 2;
            this.ix = $f43e9e04b3f0548b$export$50d414a77b60d802(middleAngle);
            this.iy = $f43e9e04b3f0548b$export$5de3937cb4b592ed(middleAngle);
            const shiftRadius = this.get("shiftRadius", 0);
            this.setRaw("dx", this.ix * shiftRadius);
            this.setRaw("dy", this.iy * shiftRadius);
            this.markDirtyPosition();
        }
    }
}
$73fc4ed9ee1a8a47$export$b3f2e2de3a8baa1e.className = "Slice";
$73fc4ed9ee1a8a47$export$b3f2e2de3a8baa1e.classNames = (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).classNames.concat([
    $73fc4ed9ee1a8a47$export$b3f2e2de3a8baa1e.className
]);






/** @ignore */ /** */ 
function $9055db4ce319c6cf$export$995b8e4067146932(display, segments) {
    for(let s = 0, len = segments.length; s < len; s++){
        const groups = segments[s];
        if (groups.length > 0) {
            let firstGroup = groups[0];
            if (firstGroup.length > 0) {
                let firstPoint = firstGroup[0];
                display.moveTo(firstPoint.x, firstPoint.y);
                for(let g = 0, len = groups.length; g < len; g++)$9055db4ce319c6cf$export$53f1d5ea8de3d7c(display, groups[g]);
            }
        }
    }
}
function $9055db4ce319c6cf$export$53f1d5ea8de3d7c(display, points) {
    for(let p = 0, len = points.length; p < len; p++){
        const point = points[p];
        display.lineTo(point.x, point.y);
    }
}
function $9055db4ce319c6cf$export$75f1ccd6dc32e80a(display, point) {
    display.moveTo(point.x, point.y);
}
function $9055db4ce319c6cf$export$42ffd38884aecdac(display) {
    display.clear();
}
function $9055db4ce319c6cf$export$23b0b861a576c00(display, segments, tensionX, tensionY) {
    for(let s = 0, len = segments.length; s < len; s++){
        const groups = segments[s];
        if (groups.length > 0) {
            let firstGroup = groups[0];
            if (firstGroup.length > 0) {
                let firstPoint = firstGroup[0];
                display.moveTo(firstPoint.x, firstPoint.y);
                for(let g = 0, len = groups.length; g < len; g++){
                    const points = groups[g];
                    if (points.length > 0) display.lineTo(points[0].x, points[0].y);
                    $9055db4ce319c6cf$export$9e290bf4077abbf3(display, points, tensionX, tensionY);
                }
            }
        }
    }
}
function $9055db4ce319c6cf$export$9e290bf4077abbf3(display, points, tensionX, tensionY) {
    for(let i = points.length - 1; i > 0; i--){
        let p0 = points[i];
        let p1 = points[i - 1];
        if (Math.abs(p0.x - p1.x) < 0.1 && Math.abs(p0.y - p1.y) < 0.1) points.splice(i - 1, 1);
    }
    if (points.length < 3 || tensionX >= 1 && tensionY >= 1) {
        $9055db4ce319c6cf$export$53f1d5ea8de3d7c(display, points);
        return;
    }
    tensionX = 1 - tensionX + 0.00001;
    tensionY = 1 - tensionY + 0.00001;
    let first = points[0];
    let last = points[points.length - 1];
    let closed = false;
    if ($f43e9e04b3f0548b$export$2077e0241d6afd3c(first.x, 3) == $f43e9e04b3f0548b$export$2077e0241d6afd3c(last.x) && $f43e9e04b3f0548b$export$2077e0241d6afd3c(first.y) == $f43e9e04b3f0548b$export$2077e0241d6afd3c(last.y)) closed = true;
    // Can't moveTo here, as it wont be possible to have fill then.
    let path = "";
    for(let i = 0, len = points.length - 1; i < len; i++){
        let p0 = points[i - 1];
        let p1 = points[i];
        let p2 = points[i + 1];
        let p3 = points[i + 2];
        if (i === 0) {
            if (closed) p0 = points[len - 2];
            else p0 = points[0];
        } else if (i == len - 1) {
            if (closed) p3 = points[1];
            else p3 = p2;
        }
        let controlPointA = $f43e9e04b3f0548b$export$14d154ec2f45fa18(p0, p1, p2, tensionX, tensionY);
        let controlPointB = $f43e9e04b3f0548b$export$e01ac8bd95dd3fa5(p1, p2, p3, tensionX, tensionY);
        display.bezierCurveTo(controlPointA.x, controlPointA.y, controlPointB.x, controlPointB.y, p2.x, p2.y);
    }
    return path;
}


class $cd9431ab7e2bff85$export$17d680238e50603e extends (0, $2ffdafbe1fe6a946$export$29d3e417456abdad) {
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("points") || this.isDirty("segments") || this._sizeDirty || this.isPrivateDirty("width") || this.isPrivateDirty("height")) this._clear = true;
    }
    _changed() {
        super._changed();
        if (this._clear) {
            const points = this.get("points");
            const segments = this.get("segments");
            if (points && points.length > 0) {
                let point = points[0];
                this._display.moveTo(point.x, point.y);
                $9055db4ce319c6cf$export$995b8e4067146932(this._display, [
                    [
                        points
                    ]
                ]);
            } else if (segments) $9055db4ce319c6cf$export$995b8e4067146932(this._display, segments);
            else if (!this.get("draw")) {
                let w = this.width();
                let h = this.height();
                this._display.moveTo(0, 0);
                this._display.lineTo(w, h);
            }
        }
    }
}
$cd9431ab7e2bff85$export$17d680238e50603e.className = "Line";
$cd9431ab7e2bff85$export$17d680238e50603e.classNames = (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).classNames.concat([
    $cd9431ab7e2bff85$export$17d680238e50603e.className
]);


class $49027cca2c82fbee$export$b1778e7c62739fdb extends (0, $cd9431ab7e2bff85$export$17d680238e50603e) {
}
$49027cca2c82fbee$export$b1778e7c62739fdb.className = "Tick";
$49027cca2c82fbee$export$b1778e7c62739fdb.classNames = (0, $cd9431ab7e2bff85$export$17d680238e50603e).classNames.concat([
    $49027cca2c82fbee$export$b1778e7c62739fdb.className
]);


class $933fc6e07cb964fb$export$3704f81c1ca961a8 extends (0, $49027cca2c82fbee$export$b1778e7c62739fdb) {
    constructor(){
        super(...arguments);
        this._tickPoints = [];
    }
}
$933fc6e07cb964fb$export$3704f81c1ca961a8.className = "AxisTick";
$933fc6e07cb964fb$export$3704f81c1ca961a8.classNames = (0, $49027cca2c82fbee$export$b1778e7c62739fdb).classNames.concat([
    $933fc6e07cb964fb$export$3704f81c1ca961a8.className
]);



class $60fcd1eac3e00d95$export$ef2184bd89960b14 extends (0, $2ffdafbe1fe6a946$export$29d3e417456abdad) {
    _beforeChanged() {
        super._beforeChanged();
        if (this.isPrivateDirty("width") || this.isPrivateDirty("height")) this._clear = true;
    }
}
$60fcd1eac3e00d95$export$ef2184bd89960b14.className = "Grid";
$60fcd1eac3e00d95$export$ef2184bd89960b14.classNames = (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).classNames.concat([
    $60fcd1eac3e00d95$export$ef2184bd89960b14.className
]);



class $9da2bb3c80f0a987$export$921c750a0983d74c extends (0, $f15f09c5037802f9$export$b04be29aa201d4f5) {
    constructor(){
        super(...arguments);
        this._tickPoints = [];
    }
}
$9da2bb3c80f0a987$export$921c750a0983d74c.className = "AxisLabel";
$9da2bb3c80f0a987$export$921c750a0983d74c.classNames = (0, $f15f09c5037802f9$export$b04be29aa201d4f5).classNames.concat([
    $9da2bb3c80f0a987$export$921c750a0983d74c.className
]);



class $a176f9805e22b838$export$87a89e68eb3f5304 extends (0, $2ffdafbe1fe6a946$export$29d3e417456abdad) {
    constructor(){
        super(...arguments);
        // save for quick access
        this._axisLength = 100;
        this._start = 0;
        this._end = 1;
        this._inversed = false;
        this._minSize = 0;
        this._lc = 1;
        this._ls = 0;
        /**
         * A list of ticks in the axis.
         *
         * `ticks.template` can be used to configure ticks.
         *
         * @default new ListTemplate<AxisTick>
         */ this.ticks = this.addDisposer(new (0, $ddd3cfc9bee47cd2$export$92d9ebaedf6ba994)((0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new({}), ()=>(0, $933fc6e07cb964fb$export$3704f81c1ca961a8)._new(this._root, {
                themeTags: $05b1b40b69b15016$export$88ad500ef99d1561(this.ticks.template.get("themeTags", []), this.get("themeTags", []))
            }, [
                this.ticks.template
            ])));
        /**
         * A list of grid elements in the axis.
         *
         * `grid.template` can be used to configure grid.
         *
         * @default new ListTemplate<Grid>
         */ this.grid = this.addDisposer(new (0, $ddd3cfc9bee47cd2$export$92d9ebaedf6ba994)((0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new({}), ()=>(0, $60fcd1eac3e00d95$export$ef2184bd89960b14)._new(this._root, {
                themeTags: $05b1b40b69b15016$export$88ad500ef99d1561(this.grid.template.get("themeTags", []), this.get("themeTags", []))
            }, [
                this.grid.template
            ])));
        /**
         * A list of fills in the axis.
         *
         * `axisFills.template` can be used to configure axis fills.
         *
         * @default new ListTemplate<Graphics>
         */ this.axisFills = this.addDisposer(new (0, $ddd3cfc9bee47cd2$export$92d9ebaedf6ba994)((0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new({}), ()=>(0, $2ffdafbe1fe6a946$export$29d3e417456abdad)._new(this._root, {
                themeTags: $05b1b40b69b15016$export$88ad500ef99d1561(this.axisFills.template.get("themeTags", [
                    "axis",
                    "fill"
                ]), this.get("themeTags", []))
            }, [
                this.axisFills.template
            ])));
        /**
         * A list of labels in the axis.
         *
         * `labels.template` can be used to configure axis labels.
         *
         * @default new ListTemplate<AxisLabel>
         */ this.labels = this.addDisposer(new (0, $ddd3cfc9bee47cd2$export$92d9ebaedf6ba994)((0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new({}), ()=>(0, $9da2bb3c80f0a987$export$921c750a0983d74c)._new(this._root, {
                themeTags: $05b1b40b69b15016$export$88ad500ef99d1561(this.labels.template.get("themeTags", []), this.get("themeTags", []))
            }, [
                this.labels.template
            ])));
    }
    /**
     * @ignore
     */ makeTick(dataItem, themeTags) {
        const tick = this.ticks.make();
        tick._setDataItem(dataItem);
        dataItem.setRaw("tick", tick);
        tick.set("themeTags", $05b1b40b69b15016$export$88ad500ef99d1561(tick.get("themeTags"), themeTags));
        this.axis.labelsContainer.children.push(tick);
        this.ticks.push(tick);
        return tick;
    }
    /**
     * @ignore
     */ makeGrid(dataItem, themeTags) {
        const grid = this.grid.make();
        grid._setDataItem(dataItem);
        dataItem.setRaw("grid", grid);
        grid.set("themeTags", $05b1b40b69b15016$export$88ad500ef99d1561(grid.get("themeTags"), themeTags));
        this.axis.gridContainer.children.push(grid);
        this.grid.push(grid);
        return grid;
    }
    /**
     * @ignore
     */ makeAxisFill(dataItem, themeTags) {
        const axisFill = this.axisFills.make();
        axisFill._setDataItem(dataItem);
        axisFill.set("themeTags", $05b1b40b69b15016$export$88ad500ef99d1561(axisFill.get("themeTags"), themeTags));
        this.axis.gridContainer.children.push(axisFill);
        dataItem.setRaw("axisFill", axisFill);
        this.axisFills.push(axisFill);
        return axisFill;
    }
    /**
     * @ignore
     */ makeLabel(dataItem, themeTags) {
        const label = this.labels.make();
        label.set("themeTags", $05b1b40b69b15016$export$88ad500ef99d1561(label.get("themeTags"), themeTags));
        if (dataItem.get("isRange")) this.axis.labelsContainer.children.push(label);
        else this.axis.labelsContainer.children.moveValue(label, 0);
        label._setDataItem(dataItem);
        dataItem.setRaw("label", label);
        this.labels.push(label);
        return label;
    }
    axisLength() {
        return 0;
    }
    /**
     * @ignore
     */ gridCount() {
        return this.axisLength() / this.get("minGridDistance", 50);
    }
    _updatePositions() {}
    _afterNew() {
        super._afterNew();
        this.set("isMeasured", false);
        const thumb = this.thumb;
        if (thumb) {
            this._disposers.push(thumb.events.on("pointerdown", (event)=>{
                this._handleThumbDown(event);
            }));
            this._disposers.push(thumb.events.on("globalpointerup", (event)=>{
                this._handleThumbUp(event);
            }));
            this._disposers.push(thumb.events.on("globalpointermove", (event)=>{
                this._handleThumbMove(event);
            }));
        }
    }
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("minGridDistance")) this.root.events.once("frameended", ()=>{
            this.axis.markDirtySize();
        });
    }
    _changed() {
        super._changed();
        if (this.isDirty("pan")) {
            const thumb = this.thumb;
            if (thumb) {
                const labelsContainer = this.axis.labelsContainer;
                const pan = this.get("pan");
                if (pan == "zoom") labelsContainer.children.push(thumb);
                else if (pan == "none") labelsContainer.children.removeValue(thumb);
            }
        }
    }
    _handleThumbDown(event) {
        this._thumbDownPoint = this.toLocal(event.point);
        const axis = this.axis;
        this._downStart = axis.get("start");
        this._downEnd = axis.get("end");
    }
    _handleThumbUp(_event) {
        this._thumbDownPoint = undefined;
    }
    _handleThumbMove(event) {
        const downPoint = this._thumbDownPoint;
        if (downPoint) {
            const point = this.toLocal(event.point);
            const downStart = this._downStart;
            const downEnd = this._downEnd;
            const extra = this._getPan(point, downPoint) * Math.min(1, downEnd - downStart) / 2 * this.get("panSensitivity", 1);
            this.axis.zoom(downStart - extra, downEnd + extra, 0);
        }
    }
    _getPan(_point1, _point2) {
        return 0;
    }
    /**
     * Converts relative position (0-1) on axis to a pixel coordinate.
     *
     * @param position  Position (0-1)
     * @return Coordinate (px)
     */ positionToCoordinate(position) {
        if (this._inversed) return (this._end - position) * this._axisLength;
        else return (position - this._start) * this._axisLength;
    }
    /**
     * @ignore
     */ updateTooltipBounds(_tooltip) {}
    _updateSize() {
        this.markDirty();
        this._clear = true;
    }
    /**
     * @ignore
     */ toAxisPosition(position) {
        const start = this._start || 0;
        const end = this._end || 1;
        position = position * (end - start);
        if (!this.get("inversed")) position = start + position;
        else position = end - position;
        return position;
    }
    /**
     * @ignore
     */ toGlobalPosition(position) {
        const start = this._start || 0;
        const end = this._end || 1;
        if (!this.get("inversed")) position = position - start;
        else position = end - position;
        position = position / (end - start);
        return position;
    }
    /**
     * @ignore
     */ fixPosition(position) {
        if (this.get("inversed")) return 1 - position;
        return position;
    }
    /**
     * @ignore
     */ _updateLC() {}
    toggleVisibility(sprite, position, minPosition, maxPosition) {
        let axis = this.axis;
        const start = axis.get("start", 0);
        const end = axis.get("end", 1);
        let updatedStart = start + (end - start) * (minPosition - 0.0001);
        let updatedEnd = start + (end - start) * (maxPosition + 0.0001);
        if (position < updatedStart || position > updatedEnd) sprite.setPrivate("visible", false);
        else sprite.setPrivate("visible", true);
    }
    _positionTooltip(tooltip, point) {
        const chart = this.chart;
        if (chart) {
            tooltip.set("pointTo", this._display.toGlobal(point));
            if (!chart.inPlot(point)) tooltip.hide();
        }
    }
    processAxis() {}
}
$a176f9805e22b838$export$87a89e68eb3f5304.className = "AxisRenderer";
$a176f9805e22b838$export$87a89e68eb3f5304.classNames = (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).classNames.concat([
    $a176f9805e22b838$export$87a89e68eb3f5304.className
]);


// import * as $object from "../util/Object";




class $39e5dc47e724d48e$export$7cdbd34b7ebc2fd7 extends (0, $991c10b390813ab6$export$5f1af8db9871e1d6) {
    constructor(){
        super(...arguments);
        this._display = this._root._renderer.makeRadialText("", this.textStyle);
    }
    _afterNew() {
        super._afterNew();
    }
    _beforeChanged() {
        super._beforeChanged();
        this._display.clear();
        if (this.isDirty("textType")) {
            this._display.textType = this.get("textType");
            this.markDirtyBounds();
        }
        if (this.isDirty("radius")) {
            this._display.radius = this.get("radius");
            this.markDirtyBounds();
        }
        if (this.isDirty("startAngle")) {
            this._display.startAngle = (this.get("startAngle", 0) + 90) * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a;
            this.markDirtyBounds();
        }
        if (this.isDirty("inside")) {
            this._display.inside = this.get("inside");
            this.markDirtyBounds();
        }
        if (this.isDirty("orientation")) {
            this._display.orientation = this.get("orientation");
            this.markDirtyBounds();
        }
        if (this.isDirty("kerning")) {
            this._display.kerning = this.get("kerning");
            this.markDirtyBounds();
        }
    }
}
$39e5dc47e724d48e$export$7cdbd34b7ebc2fd7.className = "RadialText";
$39e5dc47e724d48e$export$7cdbd34b7ebc2fd7.classNames = (0, $991c10b390813ab6$export$5f1af8db9871e1d6).classNames.concat([
    $39e5dc47e724d48e$export$7cdbd34b7ebc2fd7.className
]);




class $28ca4495ad4c299d$export$5060ffe494e9b741 extends (0, $f15f09c5037802f9$export$b04be29aa201d4f5) {
    constructor(){
        super(...arguments);
        this._flipped = false;
    }
    _afterNew() {
        this._textKeys.push("textType", "kerning");
        super._afterNew();
    }
    _makeText() {
        this._text = this.children.push((0, $39e5dc47e724d48e$export$7cdbd34b7ebc2fd7).new(this._root, {}));
    }
    /**
     * Returns base radius in pixels.
     *
     * @return Base radius
     */ baseRadius() {
        const radiusPrivate = this.getPrivate("radius", 0);
        const innerRadiusPrivate = this.getPrivate("innerRadius", 0);
        const baseRadius = this.get("baseRadius", 0);
        return innerRadiusPrivate + $05b1b40b69b15016$export$302dfacf2b0a56fe(baseRadius, radiusPrivate - innerRadiusPrivate);
    }
    /**
     * Returns radius adjustment in pixels.
     *
     * @return Radius
     */ radius() {
        const inside = this.get("inside", false);
        return this.baseRadius() + this.get("radius", 0) * (inside ? -1 : 1);
    }
    _updateChildren() {
        super._updateChildren();
        if (this.isDirty("baseRadius") || this.isPrivateDirty("radius") || this.isPrivateDirty("innerRadius") || this.isDirty("labelAngle") || this.isDirty("radius") || this.isDirty("inside") || this.isDirty("orientation") || this.isDirty("textType")) {
            const textType = this.get("textType", "adjusted");
            const inside = this.get("inside", false);
            const orientation = this.get("orientation");
            let labelAngle = $f43e9e04b3f0548b$export$e3df76cf4464bc81(this.get("labelAngle", 0));
            this._text.set("startAngle", this.get("labelAngle", 0));
            this._text.set("inside", inside);
            const sin = $f43e9e04b3f0548b$export$5de3937cb4b592ed(labelAngle);
            const cos = $f43e9e04b3f0548b$export$50d414a77b60d802(labelAngle);
            let baseRadius = this.baseRadius();
            let radius = this.radius();
            this._display.angle = 0;
            if (textType == "circular") {
                this.setAll({
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                });
                this.setRaw("x", undefined);
                this.setRaw("y", undefined);
                // Circular labels are handled and positioned differently
                this._text.set("orientation", orientation);
                this._text.set("radius", radius);
            } else {
                if (baseRadius == 0) {
                    labelAngle = 0;
                    radius = 0;
                }
                // Positioning of radial/regular labels are teh same
                let x = radius * cos;
                let y = radius * sin;
                if (textType == "radial") {
                    this.setRaw("x", x);
                    this.setRaw("y", y);
                    if (labelAngle < 90 || labelAngle > 270 || orientation != "auto") {
                        this._display.angle = labelAngle; // + 90;
                        this._flipped = false;
                    } else {
                        this._display.angle = labelAngle + 180;
                        this._flipped = true;
                    }
                    this._dirty.rotation = false;
                } else if (textType == "adjusted") {
                    this.setRaw("centerX", (0, $bd0d0c10fd30006b$export$888d047b0ce6de72));
                    this.setRaw("centerY", (0, $bd0d0c10fd30006b$export$888d047b0ce6de72));
                    this.setRaw("x", x);
                    this.setRaw("y", y);
                } else if (textType == "regular") {
                    this.setRaw("x", x);
                    this.setRaw("y", y);
                }
            }
            this.markDirtyPosition();
            this.markDirtyBounds();
        }
    }
    _updatePosition() {
        const textType = this.get("textType", "regular");
        const inside = this.get("inside", false);
        let dx = 0;
        let dy = 0;
        let labelAngle = this.get("labelAngle", 0);
        let bounds = this.localBounds();
        let w = bounds.right - bounds.left;
        let h = bounds.bottom - bounds.top;
        if (textType == "radial") {
            if (this._flipped) {
                let centerX = this.get("centerX");
                if (centerX instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) w = w * (1 - centerX.value * 2);
                dx = w * $f43e9e04b3f0548b$export$50d414a77b60d802(labelAngle);
                dy = w * $f43e9e04b3f0548b$export$5de3937cb4b592ed(labelAngle);
            }
        } else if (!inside && textType == "adjusted") {
            dx = w / 2 * $f43e9e04b3f0548b$export$50d414a77b60d802(labelAngle);
            dy = h / 2 * $f43e9e04b3f0548b$export$5de3937cb4b592ed(labelAngle);
        }
        this.setRaw("dx", dx);
        this.setRaw("dy", dy);
        super._updatePosition();
    }
    /**
     * @ignore
     */ get text() {
        return this._text;
    }
}
$28ca4495ad4c299d$export$5060ffe494e9b741.className = "RadialLabel";
$28ca4495ad4c299d$export$5060ffe494e9b741.classNames = (0, $f15f09c5037802f9$export$b04be29aa201d4f5).classNames.concat([
    $28ca4495ad4c299d$export$5060ffe494e9b741.className
]);


class $3c0f0ff17a6747df$export$6dc76296f5df13b7 extends (0, $28ca4495ad4c299d$export$5060ffe494e9b741) {
    constructor(){
        super(...arguments);
        this._tickPoints = [];
    }
}
$3c0f0ff17a6747df$export$6dc76296f5df13b7.className = "AxisLabelRadial";
$3c0f0ff17a6747df$export$6dc76296f5df13b7.classNames = (0, $28ca4495ad4c299d$export$5060ffe494e9b741).classNames.concat([
    $3c0f0ff17a6747df$export$6dc76296f5df13b7.className
]);








class $16b0ca8bc17cd5c1$export$18bab3c2540b790a extends (0, $a176f9805e22b838$export$87a89e68eb3f5304) {
    constructor(){
        super(...arguments);
        /**
         * A list of labels in the axis.
         *
         * `labels.template` can be used to configure labels.
         *
         * @default new ListTemplate<AxisLabelRadial>
         */ this.labels = this.addDisposer(new (0, $ddd3cfc9bee47cd2$export$92d9ebaedf6ba994)((0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new({}), ()=>(0, $3c0f0ff17a6747df$export$6dc76296f5df13b7)._new(this._root, {
                themeTags: $05b1b40b69b15016$export$88ad500ef99d1561(this.labels.template.get("themeTags", []), this.get("themeTags", []))
            }, [
                this.labels.template
            ])));
        /**
         * A list of fills in the axis.
         *
         * `axisFills.template` can be used to configure axis fills.
         *
         * @default new ListTemplate<Slice>
         */ this.axisFills = this.addDisposer(new (0, $ddd3cfc9bee47cd2$export$92d9ebaedf6ba994)((0, $2d9a18dcb72760f7$export$14416b8d99d47caa).new({}), ()=>(0, $73fc4ed9ee1a8a47$export$b3f2e2de3a8baa1e)._new(this._root, {
                themeTags: $05b1b40b69b15016$export$88ad500ef99d1561(this.axisFills.template.get("themeTags", [
                    "fill"
                ]), this.get("themeTags", []))
            }, [
                this.axisFills.template
            ])));
        this._fillGenerator = (0, $b196a0c5210e8c70$export$2e2bcd8739ae039)();
    }
    _afterNew() {
        this._settings.themeTags = $05b1b40b69b15016$export$88ad500ef99d1561(this._settings.themeTags, [
            "renderer",
            "circular"
        ]);
        super._afterNew();
        this.setPrivateRaw("letter", "X");
        this.setRaw("position", "absolute");
    }
    _changed() {
        super._changed();
        if (this.isDirty("radius") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("endAngle")) this.updateLayout();
    }
    /**
     * @ignore
     */ processAxis() {
        super.processAxis();
        const axis = this.axis;
        axis.labelsContainer.set("isMeasured", false);
    }
    /**
     * @ignore
     */ updateLayout() {
        const chart = this.chart;
        if (chart) {
            const radius = chart.getPrivate("radius", 0);
            let r = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("radius", (0, $bd0d0c10fd30006b$export$46342ea78d85883c)), radius);
            if (r < 0) r = radius + r;
            this.setPrivate("radius", r);
            let ir = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("innerRadius", chart.getPrivate("innerRadius", 0)), radius) * chart.getPrivate("irModifyer", 1);
            if (ir < 0) ir = r + ir;
            this.setPrivate("innerRadius", ir);
            let startAngle = this.get("startAngle", chart.get("startAngle", -90));
            let endAngle = this.get("endAngle", chart.get("endAngle", 270));
            this.setPrivate("startAngle", startAngle);
            this.setPrivate("endAngle", endAngle);
            this.set("draw", (display)=>{
                const p0 = this.positionToPoint(0);
                display.moveTo(p0.x, p0.y);
                if (startAngle > endAngle) [startAngle, endAngle] = [
                    endAngle,
                    startAngle
                ];
                display.arc(0, 0, r, startAngle * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a, endAngle * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a);
            });
            this.axis.markDirtySize();
        }
    }
    /**
     * @ignore
     */ updateGrid(grid, position, endPosition) {
        if (grid) {
            if (position == null) position = 0;
            let location = grid.get("location", 0.5);
            if (endPosition != null && endPosition != position) position = position + (endPosition - position) * location;
            let radius = this.getPrivate("radius", 0);
            let innerRadius = this.getPrivate("innerRadius", 0);
            let angle = this.positionToAngle(position);
            this.toggleVisibility(grid, position, 0, 1);
            if (radius != null) grid.set("draw", (display)=>{
                display.moveTo(innerRadius * $f43e9e04b3f0548b$export$50d414a77b60d802(angle), innerRadius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle));
                display.lineTo(radius * $f43e9e04b3f0548b$export$50d414a77b60d802(angle), radius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle));
            });
        }
    }
    /**
     * Converts relative position to angle.
     *
     * @param   position  Position
     * @return            Angle
     */ positionToAngle(position) {
        const axis = this.axis;
        const startAngle = this.getPrivate("startAngle", 0);
        const endAngle = this.getPrivate("endAngle", 360);
        const start = axis.get("start", 0);
        const end = axis.get("end", 1);
        let arc = (endAngle - startAngle) / (end - start);
        let angle;
        if (this.get("inversed")) angle = startAngle + (end - position) * arc;
        else angle = startAngle + (position - start) * arc;
        return angle;
    }
    // do not delete
    _handleOpposite() {}
    /**
     * Converts relative position to an X/Y coordinate.
     *
     * @param   position  Position
     * @return            Point
     */ positionToPoint(position) {
        const radius = this.getPrivate("radius", 0);
        const angle = this.positionToAngle(position);
        return {
            x: radius * $f43e9e04b3f0548b$export$50d414a77b60d802(angle),
            y: radius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle)
        };
    }
    /**
     * @ignore
     */ updateLabel(label, position, endPosition, count) {
        if (label) {
            if (position == null) position = 0;
            let location = 0.5;
            if (count != null && count > 1) location = label.get("multiLocation", location);
            else location = label.get("location", location);
            if (endPosition != null && endPosition != position) position = position + (endPosition - position) * location;
            const radius = this.getPrivate("radius", 0);
            const innerRadius = this.getPrivate("innerRadius", 0);
            const angle = this.positionToAngle(position);
            label.setPrivate("radius", radius);
            label.setPrivate("innerRadius", innerRadius);
            label.set("labelAngle", angle);
            this.toggleVisibility(label, position, label.get("minPosition", 0), label.get("maxPosition", 1));
        }
    }
    /**
     * @ignore
     */ fillDrawMethod(fill, startAngle, endAngle) {
        fill.set("draw", (display)=>{
            if (startAngle == null) startAngle = this.getPrivate("startAngle", 0);
            if (endAngle == null) endAngle = this.getPrivate("endAngle", 0);
            const y0 = this.getPrivate("innerRadius", 0);
            const y1 = this.getPrivate("radius", 0);
            this._fillGenerator.context(display);
            this._fillGenerator({
                innerRadius: y0,
                outerRadius: y1,
                startAngle: (startAngle + 90) * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a,
                endAngle: (endAngle + 90) * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a
            });
        });
    }
    /**
     * @ignore
     */ updateTick(tick, position, endPosition, count) {
        if (tick) {
            if (position == null) position = 0;
            let location = 0.5;
            if (count != null && count > 1) location = tick.get("multiLocation", location);
            else location = tick.get("location", location);
            if (endPosition != null && endPosition != position) position = position + (endPosition - position) * location;
            let length = tick.get("length", 0);
            const inside = tick.get("inside");
            if (inside) length *= -1;
            let radius = this.getPrivate("radius", 0);
            let angle = this.positionToAngle(position);
            this.toggleVisibility(tick, position, tick.get("minPosition", 0), tick.get("maxPosition", 1));
            if (radius != null) tick.set("draw", (display)=>{
                display.moveTo(radius * $f43e9e04b3f0548b$export$50d414a77b60d802(angle), radius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle));
                radius += length;
                display.lineTo(radius * $f43e9e04b3f0548b$export$50d414a77b60d802(angle), radius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle));
            });
        }
    }
    /**
     * @ignore
     */ updateBullet(bullet, position, endPosition) {
        if (bullet) {
            const sprite = bullet.get("sprite");
            if (sprite) {
                if (position == null) position = 0;
                let location = bullet.get("location", 0.5);
                if (endPosition != null && endPosition != position) position = position + (endPosition - position) * location;
                let radius = this.getPrivate("radius", 0);
                let angle = this.positionToAngle(position);
                this.toggleVisibility(sprite, position, 0, 1);
                sprite.setAll({
                    rotation: angle,
                    x: radius * $f43e9e04b3f0548b$export$50d414a77b60d802(angle),
                    y: radius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle)
                });
            }
        }
    }
    /**
     * @ignore
     */ updateFill(fill, position, endPosition) {
        if (fill) {
            if (position == null) position = 0;
            if (endPosition == null) endPosition = 1;
            let startAngle = this.fitAngle(this.positionToAngle(position));
            let endAngle = this.fitAngle(this.positionToAngle(endPosition));
            fill.setAll({
                startAngle: startAngle,
                arc: endAngle - startAngle
            });
            fill._setSoft("innerRadius", this.getPrivate("innerRadius"));
            fill._setSoft("radius", this.getPrivate("radius"));
        }
    }
    /**
     * @ignore
     */ fitAngle(angle) {
        const startAngle = this.getPrivate("startAngle", 0);
        const endAngle = this.getPrivate("endAngle", 0);
        const minAngle = Math.min(startAngle, endAngle);
        const maxAngle = Math.max(startAngle, endAngle);
        if (angle < minAngle) angle = minAngle;
        if (angle > maxAngle) angle = maxAngle;
        return angle;
    }
    /**
     * Returns axis length in pixels.
     *
     * @return Length
     */ axisLength() {
        return Math.abs(this.getPrivate("radius", 0) * Math.PI * 2 * (this.getPrivate("endAngle", 360) - this.getPrivate("startAngle", 0)) / 360);
    }
    /**
     * @ignore
     */ positionTooltip(tooltip, position) {
        let radius = this.getPrivate("radius", 0);
        const angle = this.positionToAngle(position);
        //return tooltip.set("pointTo", this.axis._display.toGlobal({ x: radius * $math.cos(angle), y: radius * $math.sin(angle) }));
        this._positionTooltip(tooltip, {
            x: radius * $f43e9e04b3f0548b$export$50d414a77b60d802(angle),
            y: radius * $f43e9e04b3f0548b$export$5de3937cb4b592ed(angle)
        });
    }
    /**
     * @ignore
     */ updateTooltipBounds(_tooltip) {}
}
$16b0ca8bc17cd5c1$export$18bab3c2540b790a.className = "AxisRendererCircular";
$16b0ca8bc17cd5c1$export$18bab3c2540b790a.classNames = (0, $a176f9805e22b838$export$87a89e68eb3f5304).classNames.concat([
    $16b0ca8bc17cd5c1$export$18bab3c2540b790a.className
]);





class $4149193acbdcf042$export$6f10372297739289 extends (0, $5de502da8a72d65e$export$42a852a2b6b56249) {
    constructor(){
        super(...arguments);
        /**
         * A "hand" element.
         *
         * @default Graphics.new()
         */ this.hand = this.children.push((0, $2ffdafbe1fe6a946$export$29d3e417456abdad).new(this._root, {
            themeTags: [
                "hand"
            ]
        }));
        /**
         * A "pin" element (hand's base).
         *
         * @default Graphics.new()
         */ this.pin = this.children.push((0, $2ffdafbe1fe6a946$export$29d3e417456abdad).new(this._root, {
            themeTags: [
                "pin"
            ]
        }));
    }
    _afterNew() {
        this._settings.themeTags = $05b1b40b69b15016$export$88ad500ef99d1561(this._settings.themeTags, [
            "clock"
        ]);
        super._afterNew();
        // to be redrawn when size changes
        this.set("width", (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(1));
        this.adapters.add("x", ()=>{
            return 0;
        });
        this.adapters.add("y", ()=>{
            return 0;
        });
        this.pin.set("draw", (display, graphics)=>{
            const parent = graphics.parent;
            if (parent) {
                const dataItem = parent.dataItem;
                if (dataItem) {
                    const axis = dataItem.component;
                    if (axis) {
                        const chart = axis.chart;
                        if (chart) {
                            const cr = chart.getPrivate("radius", 0);
                            let r = $05b1b40b69b15016$export$302dfacf2b0a56fe(parent.get("pinRadius", 0), cr);
                            if (r < 0) r = cr + r;
                            display.moveTo(r, 0);
                            display.arc(0, 0, r, 0, 360);
                        }
                    }
                }
            }
        });
        this.hand.set("draw", (display, graphics)=>{
            const parent = graphics.parent;
            if (parent) {
                let bullet = parent.parent;
                // to be redrawn when size changes
                if (bullet) bullet.set("width", (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(1));
                const dataItem = parent.dataItem;
                if (dataItem) {
                    const axis = dataItem.component;
                    if (axis) {
                        const chart = axis.chart;
                        if (chart) {
                            const bw = parent.get("bottomWidth", 10) / 2;
                            const tw = parent.get("topWidth", 0) / 2;
                            const cr = chart.getPrivate("radius", 0);
                            let r = $05b1b40b69b15016$export$302dfacf2b0a56fe(parent.get("radius", 0), cr);
                            if (r < 0) r = cr + r;
                            let ir = parent.get("innerRadius", 0);
                            if (ir instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) ir = $05b1b40b69b15016$export$302dfacf2b0a56fe(ir, cr);
                            else {
                                if (ir < 0) {
                                    if (ir < 0) ir = r + ir;
                                }
                            }
                            display.moveTo(ir, -bw);
                            display.lineTo(r, -tw);
                            display.lineTo(r, tw);
                            display.lineTo(ir, bw);
                            display.lineTo(ir, -bw);
                        }
                    }
                }
            }
        });
    }
    _prepareChildren() {
        super._prepareChildren();
        this.hand._markDirtyKey("fill");
        this.pin._markDirtyKey("fill");
    }
}
$4149193acbdcf042$export$6f10372297739289.className = "ClockHand";
$4149193acbdcf042$export$6f10372297739289.classNames = (0, $5de502da8a72d65e$export$42a852a2b6b56249).classNames.concat([
    $4149193acbdcf042$export$6f10372297739289.className
]);




class $d278d8c41fa854a5$export$a03e00c38b25f181 extends (0, $a953e95d35d4141a$export$14faa19a0f3bbeb2) {
    setupDefaultRules() {
        super.setupDefaultRules();
        const r = this.rule.bind(this);
        const ic = this._root.interfaceColors;
        /**
         * ========================================================================
         * charts/radar
         * ========================================================================
         */ r("RadarChart").setAll({
            radius: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(80),
            innerRadius: 0,
            startAngle: -90,
            endAngle: 270
        });
        r("RadarColumnSeries").setAll({
            clustered: true
        });
        r("Slice", [
            "radar",
            "column",
            "series"
        ]).setAll({
            width: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(80),
            height: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(80)
        });
        r("RadarLineSeries").setAll({
            connectEnds: true
        });
        r("SmoothedRadarLineSeries").setAll({
            tension: 0.5
        });
        r("AxisRendererRadial").setAll({
            minGridDistance: 40,
            axisAngle: -90,
            inversed: false,
            cellStartLocation: 0,
            cellEndLocation: 1
        });
        r("AxisRendererCircular").setAll({
            minGridDistance: 100,
            inversed: false,
            cellStartLocation: 0,
            cellEndLocation: 1
        });
        r("RadialLabel", [
            "circular"
        ]).setAll({
            textType: "circular",
            paddingTop: 1,
            paddingRight: 0,
            paddingBottom: 1,
            paddingLeft: 0,
            centerX: 0,
            centerY: 0,
            radius: 8
        });
        r("AxisLabelRadial", [
            "category"
        ]).setAll({
            text: "{category}",
            populateText: true
        });
        r("RadialLabel", [
            "radial"
        ]).setAll({
            textType: "regular",
            centerX: 0,
            textAlign: "right"
        });
        r("RadarChart", [
            "gauge"
        ]).setAll({
            startAngle: 180,
            endAngle: 360,
            innerRadius: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(90)
        });
        r("ClockHand").setAll({
            topWidth: 1,
            bottomWidth: 10,
            radius: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(90),
            pinRadius: 10
        });
        {
            const rule = r("Graphics", [
                "clock",
                "hand"
            ]);
            rule.setAll({
                fillOpacity: 1
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "alternativeBackground");
        }
        {
            const rule = r("Graphics", [
                "clock",
                "pin"
            ]);
            rule.setAll({
                fillOpacity: 1
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "alternativeBackground");
        }
    }
}







class $02b848ff4571bf92$export$8bc2de8f21739450 extends (0, $baeade534ece7f4c$export$bc644a473284d944) {
    //protected _currentPass: number = 0;
    _afterNew() {
        // Applying themes because color set will not have parent
        super._afterNewApplyThemes();
        this._dirty["colors"] = false;
    }
    _beforeChanged() {
        if (this.isDirty("colors")) this.reset();
    }
    /**
     * @ignore
     */ generateColors() {
        this.setPrivate("currentPass", this.getPrivate("currentPass", 0) + 1);
        const pass = this.getPrivate("currentPass");
        const colors = this.get("colors", [
            this.get("baseColor", (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0xff0000))
        ]);
        if (!this.getPrivate("numColors")) this.setPrivate("numColors", colors.length);
        //const len = colors.length;
        const len = this.getPrivate("numColors");
        //const start = len - this.getPrivate("numColors")!;
        const start = 0;
        const passOptions = this.get("passOptions");
        const reuse = this.get("reuse");
        for(let i = start; i < len; i++)if (reuse) colors.push(colors[i]);
        else {
            const hsl = colors[i].toHSL();
            let h = hsl.h + (passOptions.hue || 0) * pass;
            while(h > 1)h -= 1;
            let s = hsl.s + (passOptions.saturation || 0) * pass;
            //if (s > 1) s -= Math.floor(s);
            if (s > 1) s = 1;
            if (s < 0) s = 0;
            let l = hsl.l + (passOptions.lightness || 0) * pass;
            //if (l > 1) l -= Math.floor(l);
            while(l > 1)l -= 1;
            colors.push((0, $389de129b6cd18b1$export$892596cec99bc70e).fromHSL(h, s, l));
        }
    }
    /**
     * Returns a [[Color]] at specific index.
     *
     * If there's no color at this index, a new color is generated.
     *
     * @param   index  Index
     * @return         Color
     */ getIndex(index) {
        const colors = this.get("colors", []);
        const saturation = this.get("saturation");
        if (index >= colors.length) {
            this.generateColors();
            return this.getIndex(index);
        }
        return saturation != null ? (0, $389de129b6cd18b1$export$892596cec99bc70e).saturate(colors[index], saturation) : colors[index];
    }
    /**
     * Returns next [[Color]] in the list.
     *
     * If the list is out of colors, new ones are generated dynamically.
     */ next() {
        let currentStep = this.getPrivate("currentStep", this.get("startIndex", 0));
        this.setPrivate("currentStep", currentStep + this.get("step", 1));
        return this.getIndex(currentStep);
    }
    /**
     * Resets counter to the start of the list, so the next call for `next()` will
     * return the first color.
     */ reset() {
        this.setPrivate("currentStep", this.get("startIndex", 0));
        this.setPrivate("currentPass", 0);
    }
}
$02b848ff4571bf92$export$8bc2de8f21739450.className = "ColorSet";
$02b848ff4571bf92$export$8bc2de8f21739450.classNames = (0, $baeade534ece7f4c$export$bc644a473284d944).classNames.concat([
    $02b848ff4571bf92$export$8bc2de8f21739450.className
]);



/**
 * ============================================================================
 * IMPORTS
 * ============================================================================
 * @hidden
 */ 

function $044e947ddeb3ef4e$export$e772c8ff12451969(ms) {
    return new Promise((resolve, _reject)=>{
        setTimeout(resolve, ms);
    });
}
let $044e947ddeb3ef4e$export$270e05b25614e92 = {
    millisecond: 1,
    second: 1000,
    minute: 60000,
    hour: 3600000,
    day: 86400000,
    week: 604800000,
    month: 365.242 / 12 * 86400000,
    year: 31536000000
};
function $044e947ddeb3ef4e$export$59766ade6f9ae7(unit) {
    switch(unit){
        case "year":
            return;
        case "month":
            return "year";
        case "week":
            return "month";
        case "day":
            return "month"; // not a mistake
        case "hour":
            return "day";
        case "minute":
            return "hour";
        case "second":
            return "minute";
        case "millisecond":
            return "second";
    }
}
function $044e947ddeb3ef4e$export$75bba95db5c3e753(unit, count) {
    if (count == null) count = 1;
    return $044e947ddeb3ef4e$export$270e05b25614e92[unit] * count;
}
function $044e947ddeb3ef4e$export$fa068918b4463826(interval) {
    if (interval) return $044e947ddeb3ef4e$export$270e05b25614e92[interval.timeUnit] * interval.count;
    return 0;
}
function $044e947ddeb3ef4e$export$30437b15666123f5(interval, date, firstDateOfWeek, utc, timezone) {
    const unit = interval.timeUnit;
    const count = interval.count;
    if (unit == "hour" || unit == "minute" || unit == "second" || unit == "millisecond") return $044e947ddeb3ef4e$export$270e05b25614e92[interval.timeUnit] * interval.count;
    else {
        const firstTime = $044e947ddeb3ef4e$export$2077e0241d6afd3c(new Date(date.getTime()), unit, count, firstDateOfWeek, utc, undefined, timezone).getTime();
        let lastTime = firstTime + count * $044e947ddeb3ef4e$export$75bba95db5c3e753(unit) * 1.05;
        lastTime = $044e947ddeb3ef4e$export$2077e0241d6afd3c(new Date(lastTime), unit, 1, firstDateOfWeek, utc, undefined, timezone).getTime();
        return lastTime - firstTime;
    }
}
function $044e947ddeb3ef4e$export$461939dd4422153() {
    return new Date();
}
function $044e947ddeb3ef4e$export$1428f42a7de81803() {
    return $044e947ddeb3ef4e$export$461939dd4422153().getTime();
}
function $044e947ddeb3ef4e$export$784d13d8ee351f07(date) {
    return new Date(date.getTime()); // todo: check if this is ok. new Date(date) used to strip milliseconds on FF in v3
}
function $044e947ddeb3ef4e$export$ed507f5b8a2be44d(timeOne, timeTwo, unit, utc, timezone) {
    // quick
    if (timeTwo - timeOne > $044e947ddeb3ef4e$export$75bba95db5c3e753(unit, 1.2)) return true;
    let dateOne = new Date(timeOne);
    let dateTwo = new Date(timeTwo);
    if (timezone) {
        dateOne = timezone.convertLocal(dateOne);
        dateTwo = timezone.convertLocal(dateTwo);
    }
    let timeZoneOffset1 = 0;
    let timeZoneOffset2 = 0;
    if (!utc && unit != "millisecond") {
        timeZoneOffset1 = dateOne.getTimezoneOffset();
        dateOne.setUTCMinutes(dateOne.getUTCMinutes() - timeZoneOffset1);
        timeZoneOffset2 = dateTwo.getTimezoneOffset();
        dateTwo.setUTCMinutes(dateTwo.getUTCMinutes() - timeZoneOffset2);
    }
    let changed = false;
    switch(unit){
        case "year":
            if (dateOne.getUTCFullYear() != dateTwo.getUTCFullYear()) changed = true;
            break;
        case "month":
            if (dateOne.getUTCFullYear() != dateTwo.getUTCFullYear()) changed = true;
            else if (dateOne.getUTCMonth() != dateTwo.getUTCMonth()) changed = true;
            break;
        case "day":
            if (dateOne.getUTCMonth() != dateTwo.getUTCMonth()) changed = true;
            else if (dateOne.getUTCDate() != dateTwo.getUTCDate()) changed = true;
            break;
        case "hour":
            if (dateOne.getUTCHours() != dateTwo.getUTCHours()) changed = true;
            break;
        case "minute":
            if (dateOne.getUTCMinutes() != dateTwo.getUTCMinutes()) changed = true;
            break;
        case "second":
            if (dateOne.getUTCSeconds() != dateTwo.getUTCSeconds()) changed = true;
            break;
        case "millisecond":
            if (dateOne.getTime() != dateTwo.getTime()) changed = true;
            break;
    }
    if (changed) return changed;
    let nextUnit = $044e947ddeb3ef4e$export$59766ade6f9ae7(unit);
    if (nextUnit) return $044e947ddeb3ef4e$export$ed507f5b8a2be44d(timeOne, timeTwo, nextUnit, utc, timezone);
    else return false;
}
function $044e947ddeb3ef4e$export$e16d8520af44a096(date, unit, count, utc, timezone) {
    let timeZoneOffset = 0;
    if (!utc && unit != "millisecond") {
        timeZoneOffset = date.getTimezoneOffset();
        if (timezone) timeZoneOffset -= timezone.offsetUTC(date);
        date.setUTCMinutes(date.getUTCMinutes() - timeZoneOffset);
    }
    switch(unit){
        case "day":
            let day = date.getUTCDate();
            date.setUTCDate(day + count);
            break;
        case "second":
            let seconds = date.getUTCSeconds();
            date.setUTCSeconds(seconds + count);
            break;
        case "millisecond":
            let milliseconds = date.getUTCMilliseconds();
            date.setUTCMilliseconds(milliseconds + count);
            break;
        case "hour":
            let hours = date.getUTCHours();
            date.setUTCHours(hours + count);
            break;
        case "minute":
            let minutes = date.getUTCMinutes();
            date.setUTCMinutes(minutes + count);
            break;
        case "year":
            let year = date.getUTCFullYear();
            date.setUTCFullYear(year + count);
            break;
        case "month":
            const endDays = date.getUTCDate();
            const startDays = new Date(date.getUTCFullYear(), date.getUTCMonth(), 0).getUTCDate();
            let month = date.getUTCMonth();
            if (endDays > startDays) date.setUTCMonth(month + count, startDays);
            else date.setUTCMonth(month + count);
            break;
        case "week":
            let wday = date.getUTCDate();
            date.setUTCDate(wday + count * 7);
            break;
    }
    if (!utc && unit != "millisecond") {
        date.setUTCMinutes(date.getUTCMinutes() + timeZoneOffset);
        if (unit == "day" || unit == "week" || unit == "month" || unit == "year") {
            let newTimeZoneOffset = date.getTimezoneOffset();
            if (timezone) newTimeZoneOffset += timezone.offsetUTC(date);
            if (newTimeZoneOffset != timeZoneOffset) {
                let diff = newTimeZoneOffset - timeZoneOffset;
                date.setUTCMinutes(date.getUTCMinutes() + diff);
                // solves issues if new time falls back to old time zone
                if (date.getTimezoneOffset() != newTimeZoneOffset) date.setUTCMinutes(date.getUTCMinutes() - diff);
            }
        }
    }
    return date;
}
function $044e947ddeb3ef4e$export$6efaf5e40ccb9786(time, unit, count, root, firstTime) {
    let firstDate;
    if (firstTime != null) firstDate = new Date(firstTime);
    return $044e947ddeb3ef4e$export$2077e0241d6afd3c(new Date(time), unit, count, root.locale.firstDayOfWeek, root.utc, firstDate, root.timezone).getTime();
}
function $044e947ddeb3ef4e$export$2077e0241d6afd3c(date, unit, count, firstDateOfWeek, utc, firstDate, timezone) {
    if (!timezone || utc) {
        let timeZoneOffset = 0;
        if (!utc && unit != "millisecond") {
            timeZoneOffset = date.getTimezoneOffset();
            date.setUTCMinutes(date.getUTCMinutes() - timeZoneOffset);
        }
        switch(unit){
            case "day":
                let day = date.getUTCDate();
                if (count > 1) //	day = Math.floor(day / count) * count;
                {
                    if (firstDate) {
                        firstDate = $044e947ddeb3ef4e$export$2077e0241d6afd3c(firstDate, "day", 1);
                        let difference = date.getTime() - firstDate.getTime();
                        let unitCount = Math.floor(difference / $044e947ddeb3ef4e$export$75bba95db5c3e753("day") / count);
                        let duration = $044e947ddeb3ef4e$export$75bba95db5c3e753("day", unitCount * count);
                        date.setTime(firstDate.getTime() + duration - timeZoneOffset * $044e947ddeb3ef4e$export$75bba95db5c3e753("minute"));
                    }
                } else date.setUTCDate(day);
                date.setUTCHours(0, 0, 0, 0);
                break;
            case "second":
                let seconds = date.getUTCSeconds();
                if (count > 1) seconds = Math.floor(seconds / count) * count;
                date.setUTCSeconds(seconds, 0);
                break;
            case "millisecond":
                if (count == 1) return date; // much better for perf!
                let milliseconds = date.getUTCMilliseconds();
                milliseconds = Math.floor(milliseconds / count) * count;
                date.setUTCMilliseconds(milliseconds);
                break;
            case "hour":
                let hours = date.getUTCHours();
                if (count > 1) hours = Math.floor(hours / count) * count;
                date.setUTCHours(hours, 0, 0, 0);
                break;
            case "minute":
                let minutes = date.getUTCMinutes();
                if (count > 1) minutes = Math.floor(minutes / count) * count;
                date.setUTCMinutes(minutes, 0, 0);
                break;
            case "month":
                let month = date.getUTCMonth();
                if (count > 1) // only do this if count is 2, 3, 4, and 6
                {
                    if (count == 2 || count == 3 || count == 4 || count == 6) month = Math.floor(month / count) * count;
                }
                date.setUTCMonth(month, 1);
                date.setUTCHours(0, 0, 0, 0);
                break;
            case "year":
                let year = date.getUTCFullYear();
                if (count > 1) year = Math.floor(year / count) * count;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                break;
            case "week":
                if (count > 1) {
                    if (firstDate) {
                        firstDate = $044e947ddeb3ef4e$export$2077e0241d6afd3c(firstDate, "week", 1);
                        let difference = date.getTime() - firstDate.getTime();
                        let unitCount = Math.floor(difference / $044e947ddeb3ef4e$export$75bba95db5c3e753("week") / count);
                        let duration = $044e947ddeb3ef4e$export$75bba95db5c3e753("week", unitCount * count);
                        date.setTime(firstDate.getTime() + duration - timeZoneOffset * $044e947ddeb3ef4e$export$75bba95db5c3e753("minute"));
                    }
                }
                let wday = date.getUTCDate();
                let weekDay = date.getUTCDay();
                if (!$f63bdea45a89cf24$export$7e4aa119212bc614(firstDateOfWeek)) firstDateOfWeek = 1;
                if (weekDay >= firstDateOfWeek) wday = wday - weekDay + firstDateOfWeek;
                else wday = wday - (7 + weekDay) + firstDateOfWeek;
                date.setUTCDate(wday);
                date.setUTCHours(0, 0, 0, 0);
                break;
        }
        if (!utc && unit != "millisecond") {
            date.setUTCMinutes(date.getUTCMinutes() + timeZoneOffset);
            if (unit == "day" || unit == "week" || unit == "month" || unit == "year") {
                let newTimeZoneOffset = date.getTimezoneOffset();
                if (newTimeZoneOffset != timeZoneOffset) {
                    let diff = newTimeZoneOffset - timeZoneOffset;
                    date.setUTCMinutes(date.getUTCMinutes() + diff);
                }
            }
        }
        return date;
    } else {
        if (isNaN(date.getTime())) return date;
        let initialTime = date.getTime();
        let tzoffset = timezone.offsetUTC(date);
        let timeZoneOffset = date.getTimezoneOffset();
        let parsedDate = timezone.parseDate(date);
        let year = parsedDate.year;
        let month = parsedDate.month;
        let day = parsedDate.day;
        let hour = parsedDate.hour;
        let minute = parsedDate.minute;
        let second = parsedDate.second;
        let millisecond = parsedDate.millisecond;
        let weekday = parsedDate.weekday;
        let offsetDif = tzoffset - timeZoneOffset;
        switch(unit){
            case "day":
                if (count > 1 && firstDate) {
                    firstDate = $044e947ddeb3ef4e$export$2077e0241d6afd3c(firstDate, "day", 1, firstDateOfWeek, utc, undefined, timezone);
                    let difference = date.getTime() - firstDate.getTime();
                    let unitCount = Math.floor(difference / $044e947ddeb3ef4e$export$75bba95db5c3e753("day") / count);
                    let duration = $044e947ddeb3ef4e$export$75bba95db5c3e753("day", unitCount * count);
                    date.setTime(firstDate.getTime() + duration);
                    parsedDate = timezone.parseDate(date);
                    year = parsedDate.year;
                    month = parsedDate.month;
                    day = parsedDate.day;
                }
                hour = 0;
                minute = offsetDif;
                second = 0;
                millisecond = 0;
                break;
            case "second":
                minute += offsetDif;
                if (count > 1) second = Math.floor(second / count) * count;
                millisecond = 0;
                break;
            case "millisecond":
                minute += offsetDif;
                if (count > 1) millisecond = Math.floor(millisecond / count) * count;
                break;
            case "hour":
                if (count > 1) hour = Math.floor(hour / count) * count;
                minute = offsetDif;
                second = 0;
                millisecond = 0;
                break;
            case "minute":
                if (count > 1) minute = Math.floor(minute / count) * count;
                minute += offsetDif;
                second = 0;
                millisecond = 0;
                break;
            case "month":
                if (count > 1) month = Math.floor(month / count) * count;
                day = 1;
                hour = 0;
                minute = offsetDif;
                second = 0;
                millisecond = 0;
                break;
            case "year":
                if (count > 1) year = Math.floor(year / count) * count;
                month = 0;
                day = 1;
                hour = 0;
                minute = offsetDif;
                second = 0;
                millisecond = 0;
                break;
            case "week":
                if (!$f63bdea45a89cf24$export$7e4aa119212bc614(firstDateOfWeek)) firstDateOfWeek = 1;
                if (weekday >= firstDateOfWeek) day = day - weekday + firstDateOfWeek;
                else day = day - (7 + weekday) + firstDateOfWeek;
                hour = 0;
                minute = offsetDif;
                second = 0;
                millisecond = 0;
                break;
        }
        date = new Date(year, month, day, hour, minute, second, millisecond);
        // fix to solve #101989
        const newTime = date.getTime();
        let hDuration = 3600000;
        if (unit == "hour") hDuration = 3600000 * count;
        if (newTime + hDuration <= initialTime) {
            if (unit == "hour" || unit == "minute" || unit == "second" || unit == "millisecond") date = new Date(newTime + hDuration);
        }
        // end of fix
        let newTimeZoneOffset = date.getTimezoneOffset();
        let newTzoffset = timezone.offsetUTC(date);
        let newDiff = newTzoffset - newTimeZoneOffset;
        if (newDiff != offsetDif) date.setTime(date.getTime() + (newDiff - offsetDif) * 60000);
        return date;
    }
}
function $044e947ddeb3ef4e$export$86b75a3dd85e9516(index, duration, gridCount, intervals) {
    let gridInterval = intervals[index];
    let intervalDuration = $044e947ddeb3ef4e$export$fa068918b4463826(gridInterval);
    let lastIndex = intervals.length - 1;
    if (index >= lastIndex) return Object.assign({}, intervals[lastIndex]);
    let count = Math.ceil(duration / intervalDuration);
    if (duration < intervalDuration && index > 0) return Object.assign({}, intervals[index - 1]);
    if (count <= gridCount) return Object.assign({}, intervals[index]);
    else {
        if (index + 1 < intervals.length) return $044e947ddeb3ef4e$export$86b75a3dd85e9516(index + 1, duration, gridCount, intervals);
        else return Object.assign({}, intervals[index]);
    }
}
function $044e947ddeb3ef4e$export$e04e41a1e24ffd3f(date, unit) {
    switch(unit){
        case "day":
            return date.getDate();
        case "second":
            return date.getSeconds();
        case "millisecond":
            return date.getMilliseconds();
        case "hour":
            return date.getHours();
        case "minute":
            return date.getMinutes();
        case "month":
            return date.getMonth();
        case "year":
            return date.getFullYear();
        case "week":
            return $05b1b40b69b15016$export$efe19b760242b2fc(date);
    }
}






class $8ff28373ed1fac0e$export$3407b11010d1bc82 extends (0, $a953e95d35d4141a$export$14faa19a0f3bbeb2) {
    setupDefaultRules() {
        super.setupDefaultRules();
        const ic = this._root.interfaceColors;
        const language = this._root.language;
        const r = this.rule.bind(this);
        /**
         * ========================================================================
         * charts/xy
         * ========================================================================
         */ r("XYChart").setAll({
            colors: (0, $02b848ff4571bf92$export$8bc2de8f21739450).new(this._root, {}),
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 16,
            paddingBottom: 16,
            panX: false,
            panY: false,
            wheelStep: 0.25,
            arrangeTooltips: true,
            pinchZoomX: false,
            pinchZoomY: false
        });
        r("XYSeries").setAll({
            legendLabelText: "{name}"
        });
        r("Rectangle", [
            "plotbackground",
            "xy",
            "background"
        ]).setAll({
            fill: (0, $389de129b6cd18b1$export$892596cec99bc70e).fromHex(0x000000),
            fillOpacity: 0
        });
        /**
         * ------------------------------------------------------------------------
         * charts/xy: XYChartScrollbar
         * ------------------------------------------------------------------------
         */ r("XYChart", [
            "scrollbar",
            "chart"
        ]).setAll({
            paddingBottom: 0,
            paddingLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            colors: (0, $02b848ff4571bf92$export$8bc2de8f21739450).new(this._root, {
                saturation: 0
            })
        });
        {
            const rule = r("Graphics", [
                "scrollbar",
                "overlay"
            ]);
            rule.setAll({
                fillOpacity: 0.5
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "background");
        }
        // Class: RoundedRectangle
        r("RoundedRectangle", [
            "xy",
            "scrollbar",
            "thumb"
        ]).setAll({
            cornerRadiusTR: 0,
            cornerRadiusTL: 0,
            cornerRadiusBR: 0,
            cornerRadiusBL: 0,
            fillOpacity: 0,
            focusable: true
        });
        r("RoundedRectangle", [
            "xy",
            "scrollbar",
            "thumb"
        ]).states.create("hover", {
            fillOpacity: 0.4
        });
        r("RoundedRectangle", [
            "xy",
            "scrollbar",
            "chart",
            "background"
        ]).setAll({
            cornerRadiusTL: 0,
            cornerRadiusBL: 0,
            cornerRadiusTR: 0,
            cornerRadiusBR: 0
        });
        r("RoundedRectangle", [
            "xy",
            "scrollbar",
            "chart",
            "background",
            "resize",
            "button"
        ]).setAll({
            cornerRadiusBL: 40,
            cornerRadiusBR: 40,
            cornerRadiusTL: 40,
            cornerRadiusTR: 40
        });
        r("AxisRendererX", [
            "xy",
            "chart",
            "scrollbar"
        ]).setAll({
            strokeOpacity: 0,
            inside: true
        });
        r("AxisRendererY", [
            "xy",
            "chart",
            "scrollbar"
        ]).setAll({
            strokeOpacity: 0,
            inside: true,
            minGridDistance: 5
        });
        r("AxisLabel", [
            "xy",
            "scrollbar",
            "x"
        ]).setAll({
            opacity: 0.5,
            centerY: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            minPosition: 0.01,
            maxPosition: 0.99,
            fontSize: "0.8em"
        });
        r("AxisLabel", [
            "category"
        ]).setAll({
            text: "{category}",
            populateText: true
        });
        r("AxisLabel", [
            "x"
        ]).setAll({
            centerY: 0
        });
        r("AxisLabel", [
            "x",
            "inside"
        ]).setAll({
            centerY: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("AxisLabel", [
            "x",
            "inside",
            "opposite"
        ]).setAll({
            centerY: 0
        });
        r("AxisLabel", [
            "x",
            "opposite"
        ]).setAll({
            centerY: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("AxisLabel", [
            "y"
        ]).setAll({
            centerX: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("AxisLabel", [
            "y",
            "inside"
        ]).setAll({
            centerX: 0
        });
        r("AxisLabel", [
            "y",
            "inside",
            "opposite"
        ]).setAll({
            centerX: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("AxisLabel", [
            "y",
            "opposite"
        ]).setAll({
            centerX: 0
        });
        r("AxisLabel", [
            "minor"
        ]).setAll({
            fontSize: "0.6em"
        });
        r("AxisLabel", [
            "xy",
            "scrollbar",
            "y"
        ]).setAll({
            visible: false
        });
        // Class: Grid
        r("Grid", [
            "xy",
            "scrollbar",
            "y"
        ]).setAll({
            visible: false
        });
        // Class: Grid
        r("Grid", [
            "xy",
            "scrollbar",
            "x"
        ]).setAll({
            opacity: 0.5
        });
        /**
         * ------------------------------------------------------------------------
         * charts/xy: Cursor
         * ------------------------------------------------------------------------
         */ r("XYCursor").setAll({
            behavior: "none",
            layer: 30,
            exportable: false,
            snapToSeriesBy: "xy",
            moveThreshold: 1
        });
        {
            const rule = r("Grid", [
                "cursor",
                "x"
            ]);
            rule.setAll({
                forceInactive: true,
                strokeOpacity: 0.8,
                strokeDasharray: [
                    2,
                    2
                ],
                role: "slider",
                ariaLabel: language.translate("Use left and right arrows to move selection")
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "alternativeBackground");
        }
        {
            const rule = r("Grid", [
                "cursor",
                "y"
            ]);
            rule.setAll({
                forceInactive: true,
                strokeOpacity: 0.8,
                strokeDasharray: [
                    2,
                    2
                ],
                role: "slider",
                ariaLabel: language.translate("Use up and down arrows to move selection")
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "alternativeBackground");
        }
        {
            const rule = r("Graphics", [
                "cursor",
                "selection"
            ]);
            rule.setAll({
                fillOpacity: 0.15
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "alternativeBackground");
        }
        /**
         * ------------------------------------------------------------------------
         * charts/xy: Axes
         * ------------------------------------------------------------------------
         */ r("Axis").setAll({
            zoomOut: true,
            start: 0,
            end: 1,
            minZoomCount: 1,
            maxZoomCount: Infinity,
            maxZoomFactor: 1000,
            maxDeviation: 0.1,
            snapTooltip: true,
            tooltipLocation: 0.5,
            panX: true,
            panY: true,
            zoomX: true,
            zoomY: true,
            fixAxisSize: true
        });
        r("AxisLabel").setAll({
            location: 0.5,
            multiLocation: 0,
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            centerY: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 5,
            paddingRight: 5
        });
        // The following is deprecated following text measuring updates in 5.0.5
        // r("AxisLabel", ["y"]).setAll({
        // 	textAlign: "right"
        // });
        // r("AxisLabel", ["y", "opposite"]).setAll({
        // 	textAlign: "left"
        // });
        r("Container", [
            "axis",
            "header"
        ]).setAll({
            layer: 30
        });
        r("Rectangle", [
            "axis",
            "header",
            "background"
        ]).setAll({
            crisp: true
        });
        {
            const rule = r("AxisRenderer");
            rule.setAll({
                crisp: true,
                strokeOpacity: 0
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "grid");
        }
        r("AxisRendererX").setAll({
            minGridDistance: 120,
            opposite: false,
            inversed: false,
            cellStartLocation: 0,
            cellEndLocation: 1,
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("AxisRendererY").setAll({
            minGridDistance: 40,
            opposite: false,
            inversed: false,
            cellStartLocation: 0,
            cellEndLocation: 1,
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        {
            const rule = r("Rectangle", [
                "axis",
                "thumb",
                "zoomgrip"
            ]);
            rule.setAll({
                fillOpacity: 0
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "alternativeBackground");
            rule.states.create("hover", {
                fillOpacity: 0.1
            });
        }
        r("Rectangle", [
            "axis",
            "thumb",
            "x",
            "zoomgrip"
        ]).setAll({
            cursorOverStyle: "ew-resize"
        });
        r("Rectangle", [
            "axis",
            "thumb",
            "y",
            "zoomgrip"
        ]).setAll({
            cursorOverStyle: "ns-resize"
        });
        {
            const rule = r("Grid");
            rule.setAll({
                location: 0,
                strokeOpacity: 0.15,
                crisp: true
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "grid");
        }
        {
            const rule = r("Grid", [
                "minor"
            ]);
            rule.setAll({
                location: 0,
                strokeOpacity: 0.07,
                crisp: true
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "grid");
        }
        r("Grid", [
            "base"
        ]).setAll({
            strokeOpacity: 0.3
        });
        {
            const rule = r("Graphics", [
                "axis",
                "fill"
            ]);
            rule.setAll({
                visible: false,
                isMeasured: false,
                position: "absolute",
                fillOpacity: 0.05
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "alternativeBackground");
        }
        r("Graphics", [
            "axis",
            "fill",
            "range"
        ]).setAll({
            isMeasured: true
        });
        // hides all elements of series axis range
        r("Graphics", [
            "series",
            "fill",
            "range"
        ]).setAll({
            visible: false,
            isMeasured: true
        });
        r("Grid", [
            "series",
            "range"
        ]).setAll({
            visible: false
        });
        r("AxisTick", [
            "series",
            "range"
        ]).setAll({
            visible: false
        });
        r("AxisLabel", [
            "series",
            "range"
        ]).setAll({
            visible: false
        });
        {
            const rule = r("AxisTick");
            rule.setAll({
                location: 0.5,
                multiLocation: 0,
                strokeOpacity: 1,
                isMeasured: false,
                position: "absolute",
                visible: false
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "grid");
        }
        r("CategoryAxis").setAll({
            startLocation: 0,
            endLocation: 1,
            fillRule: (dataItem, index)=>{
                const axisFill = dataItem.get("axisFill");
                if (axisFill) {
                    if (!$f63bdea45a89cf24$export$7e4aa119212bc614(index) || index % 2 == 0) axisFill.setPrivate("visible", true);
                    else axisFill.setPrivate("visible", false);
                }
            }
        });
        const gridIntervals = [
            {
                timeUnit: "millisecond",
                count: 1
            },
            {
                timeUnit: "millisecond",
                count: 5
            },
            {
                timeUnit: "millisecond",
                count: 10
            },
            {
                timeUnit: "millisecond",
                count: 50
            },
            {
                timeUnit: "millisecond",
                count: 100
            },
            {
                timeUnit: "millisecond",
                count: 500
            },
            {
                timeUnit: "second",
                count: 1
            },
            {
                timeUnit: "second",
                count: 5
            },
            {
                timeUnit: "second",
                count: 10
            },
            {
                timeUnit: "second",
                count: 30
            },
            {
                timeUnit: "minute",
                count: 1
            },
            {
                timeUnit: "minute",
                count: 5
            },
            {
                timeUnit: "minute",
                count: 10
            },
            {
                timeUnit: "minute",
                count: 15
            },
            {
                timeUnit: "minute",
                count: 30
            },
            {
                timeUnit: "hour",
                count: 1
            },
            {
                timeUnit: "hour",
                count: 3
            },
            {
                timeUnit: "hour",
                count: 6
            },
            {
                timeUnit: "hour",
                count: 12
            },
            {
                timeUnit: "day",
                count: 1
            },
            {
                timeUnit: "day",
                count: 2
            },
            {
                timeUnit: "day",
                count: 3
            },
            {
                timeUnit: "day",
                count: 4
            },
            {
                timeUnit: "day",
                count: 5
            },
            {
                timeUnit: "week",
                count: 1
            },
            {
                timeUnit: "month",
                count: 1
            },
            {
                timeUnit: "month",
                count: 2
            },
            {
                timeUnit: "month",
                count: 3
            },
            {
                timeUnit: "month",
                count: 6
            },
            {
                timeUnit: "year",
                count: 1
            },
            {
                timeUnit: "year",
                count: 2
            },
            {
                timeUnit: "year",
                count: 5
            },
            {
                timeUnit: "year",
                count: 10
            },
            {
                timeUnit: "year",
                count: 50
            },
            {
                timeUnit: "year",
                count: 100
            },
            {
                timeUnit: "year",
                count: 200
            },
            {
                timeUnit: "year",
                count: 500
            },
            {
                timeUnit: "year",
                count: 1000
            },
            {
                timeUnit: "year",
                count: 2000
            },
            {
                timeUnit: "year",
                count: 5000
            },
            {
                timeUnit: "year",
                count: 10000
            },
            {
                timeUnit: "year",
                count: 100000
            }
        ];
        const dateFormats = {
            "millisecond": language.translate("_date_millisecond"),
            "second": language.translate("_date_second"),
            "minute": language.translate("_date_minute"),
            "hour": language.translate("_date_hour"),
            "day": language.translate("_date_day"),
            "week": language.translate("_date_day"),
            "month": language.translate("_date_month"),
            "year": language.translate("_date_year")
        };
        const periodChangeDateFormats = {
            "millisecond": language.translate("_date_millisecond"),
            "second": language.translate("_date_second"),
            "minute": language.translate("_date_minute"),
            "hour": language.translate("_date_day"),
            "day": language.translate("_date_day"),
            "week": language.translate("_date_day"),
            "month": language.translate("_date_month") + " " + language.translate("_date_year"),
            "year": language.translate("_date_year")
        };
        const tooltipDateFormats = {
            "millisecond": language.translate("_date_millisecond_full"),
            "second": language.translate("_date_second_full"),
            "minute": language.translate("_date_minute_full"),
            "hour": language.translate("_date_hour_full"),
            "day": language.translate("_date_day_full"),
            "week": language.translate("_date_week_full"),
            "month": language.translate("_date_month_full"),
            "year": language.translate("_date_year")
        };
        r("CategoryDateAxis").setAll({
            markUnitChange: true,
            gridIntervals: $2f30431acd054e2f$export$784d13d8ee351f07(gridIntervals),
            dateFormats: $e66f9343b5144e1a$export$784d13d8ee351f07(dateFormats),
            periodChangeDateFormats: $e66f9343b5144e1a$export$784d13d8ee351f07(periodChangeDateFormats)
        });
        r("DateAxis").setAll({
            maxZoomFactor: null,
            strictMinMax: true,
            startLocation: 0,
            endLocation: 1,
            markUnitChange: true,
            groupData: false,
            groupCount: 500,
            skipFirstMinor: true,
            weekLabelLocation: 0,
            gridIntervals: $2f30431acd054e2f$export$784d13d8ee351f07(gridIntervals),
            dateFormats: $e66f9343b5144e1a$export$784d13d8ee351f07(dateFormats),
            periodChangeDateFormats: $e66f9343b5144e1a$export$784d13d8ee351f07(periodChangeDateFormats),
            tooltipDateFormats: tooltipDateFormats,
            groupIntervals: [
                {
                    timeUnit: "millisecond",
                    count: 1
                },
                {
                    timeUnit: "millisecond",
                    count: 10
                },
                {
                    timeUnit: "millisecond",
                    count: 100
                },
                {
                    timeUnit: "second",
                    count: 1
                },
                {
                    timeUnit: "second",
                    count: 10
                },
                {
                    timeUnit: "minute",
                    count: 1
                },
                {
                    timeUnit: "minute",
                    count: 10
                },
                {
                    timeUnit: "hour",
                    count: 1
                },
                {
                    timeUnit: "day",
                    count: 1
                },
                {
                    timeUnit: "week",
                    count: 1
                },
                {
                    timeUnit: "month",
                    count: 1
                },
                {
                    timeUnit: "year",
                    count: 1
                }
            ],
            fillRule: (dataItem)=>{
                const axisFill = dataItem.get("axisFill");
                if (axisFill) {
                    const axis = dataItem.component;
                    const value = dataItem.get("value");
                    const endValue = dataItem.get("endValue");
                    const intervalDuration = axis.intervalDuration();
                    const baseInterval = axis.getPrivate("baseInterval");
                    const gridInterval = axis.getPrivate("gridInterval", baseInterval);
                    let min = axis.getPrivate("min", 0);
                    min = $044e947ddeb3ef4e$export$2077e0241d6afd3c(new Date(min), gridInterval.timeUnit, gridInterval.count, this._root.locale.firstDayOfWeek, this._root.utc, undefined, this._root.timezone).getTime();
                    if (value != null && endValue != null) {
                        const val = Math.round(Math.round((value - min) / intervalDuration)) / 2;
                        if (val == Math.round(val)) axisFill.setPrivate("visible", true);
                        else axisFill.setPrivate("visible", false);
                    }
                }
            }
        });
        r("GaplessDateAxis").setAll({
            fillRule: (dataItem)=>{
                const axisFill = dataItem.get("axisFill");
                if (axisFill) {
                    const index = dataItem.get("index");
                    let visible = false;
                    if (!$f63bdea45a89cf24$export$7e4aa119212bc614(index) || index % 2 == 0) visible = true;
                    axisFill.setPrivate("visible", visible);
                }
            }
        });
        r("ValueAxis").setAll({
            baseValue: 0,
            logarithmic: false,
            strictMinMax: false,
            autoZoom: true,
            fillRule: (dataItem)=>{
                const axisFill = dataItem.get("axisFill");
                if (axisFill) {
                    const axis = dataItem.component;
                    const value = dataItem.get("value");
                    const step = axis.getPrivate("step");
                    if ($f63bdea45a89cf24$export$7e4aa119212bc614(value) && $f63bdea45a89cf24$export$7e4aa119212bc614(step)) {
                        if ($f43e9e04b3f0548b$export$2077e0241d6afd3c(value / step / 2, 5) == Math.round(value / step / 2)) axisFill.setPrivate("visible", false);
                        else axisFill.setPrivate("visible", true);
                    }
                }
            }
        });
        r("DurationAxis").setAll({
            baseUnit: "second"
        });
        /**
         * ------------------------------------------------------------------------
         * charts/xy: Series
         * ------------------------------------------------------------------------
         */ r("XYSeries").setAll({
            maskBullets: true,
            stackToNegative: true,
            locationX: 0.5,
            locationY: 0.5,
            snapTooltip: false,
            openValueXGrouped: "open",
            openValueYGrouped: "open",
            valueXGrouped: "close",
            valueYGrouped: "close",
            seriesTooltipTarget: "series"
        });
        r("BaseColumnSeries").setAll({
            adjustBulletPosition: true
        });
        r("ColumnSeries").setAll({
            clustered: true
        });
        r("RoundedRectangle", [
            "series",
            "column"
        ]).setAll({
            position: "absolute",
            isMeasured: false,
            width: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(70),
            height: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(70),
            strokeWidth: 1,
            strokeOpacity: 1,
            cornerRadiusBL: 0,
            cornerRadiusTL: 0,
            cornerRadiusBR: 0,
            cornerRadiusTR: 0,
            fillOpacity: 1,
            role: "figure"
        });
        r("LineSeries").setAll({
            connect: true,
            autoGapCount: 1.1,
            stackToNegative: false
        });
        r("Graphics", [
            "series",
            "stroke"
        ]).setAll({
            position: "absolute",
            strokeWidth: 1,
            strokeOpacity: 1,
            isMeasured: false
        });
        r("Graphics", [
            "series",
            "fill"
        ]).setAll({
            visible: false,
            fillOpacity: 0,
            position: "absolute",
            strokeWidth: 0,
            strokeOpacity: 0,
            isMeasured: false
        });
        r("Graphics", [
            "line",
            "series",
            "legend",
            "marker",
            "stroke"
        ]).setAll({
            draw: (display, sprite)=>{
                const parent = sprite.parent;
                if (parent) {
                    const h = parent.height();
                    const w = parent.width();
                    display.moveTo(0, h / 2);
                    display.lineTo(w, h / 2);
                }
            }
        });
        {
            const rule = r("Graphics", [
                "line",
                "series",
                "legend",
                "marker",
                "stroke"
            ]).states.create("disabled", {});
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "disabled");
        }
        r("Graphics", [
            "line",
            "series",
            "legend",
            "marker",
            "fill"
        ]).setAll({
            draw: (display, sprite)=>{
                const parent = sprite.parent;
                if (parent) {
                    const h = parent.height();
                    const w = parent.width();
                    display.moveTo(0, 0);
                    display.lineTo(w, 0);
                    display.lineTo(w, h);
                    display.lineTo(0, h);
                    display.lineTo(0, 0);
                }
            }
        });
        {
            const rule = r("Graphics", [
                "line",
                "series",
                "legend",
                "marker",
                "fill"
            ]).states.create("disabled", {});
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "disabled");
        }
        r("SmoothedXYLineSeries").setAll({
            tension: 0.5
        });
        r("SmoothedXLineSeries").setAll({
            tension: 0.5
        });
        r("SmoothedYLineSeries").setAll({
            tension: 0.5
        });
        r("Candlestick").setAll({
            position: "absolute",
            isMeasured: false,
            width: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(50),
            height: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(50),
            strokeWidth: 1,
            strokeOpacity: 1,
            cornerRadiusBL: 0,
            cornerRadiusTL: 0,
            cornerRadiusBR: 0,
            cornerRadiusTR: 0,
            fillOpacity: 1,
            role: "figure"
        });
        r("OHLC").setAll({
            width: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(80),
            height: (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(80)
        });
        r("CandlestickSeries").setAll({
            lowValueXGrouped: "low",
            lowValueYGrouped: "low",
            highValueXGrouped: "high",
            highValueYGrouped: "high",
            openValueXGrouped: "open",
            openValueYGrouped: "open",
            valueXGrouped: "close",
            valueYGrouped: "close"
        });
        // These rules can be used for regular columns, too
        {
            const rule = r("Rectangle", [
                "column",
                "autocolor"
            ]).states.create("riseFromOpen", {});
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "positive");
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "positive");
        }
        {
            const rule = r("Rectangle", [
                "column",
                "autocolor"
            ]).states.create("dropFromOpen", {});
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "negative");
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "negative");
        }
        // Hollow
        r("Rectangle", [
            "column",
            "autocolor",
            "pro"
        ]).states.create("riseFromOpen", {
            fillOpacity: 0
        });
        r("Rectangle", [
            "column",
            "autocolor",
            "pro"
        ]).states.create("dropFromOpen", {
            fillOpacity: 1
        });
        {
            const rule = r("Rectangle", [
                "column",
                "autocolor",
                "pro"
            ]).states.create("riseFromPrevious", {});
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "positive");
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "positive");
        }
        {
            const rule = r("Rectangle", [
                "column",
                "autocolor",
                "pro"
            ]).states.create("dropFromPrevious", {});
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "fill", ic, "negative");
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "negative");
        }
        // AXIS RANGE GRIP
        {
            const rule = r("RoundedRectangle", [
                "rangegrip"
            ]);
            rule.setAll({
                strokeOpacity: 0,
                fillOpacity: 0,
                strokeWidth: 1,
                width: 12,
                height: 12
            });
        }
        {
            const rule = r("Graphics", [
                "rangegrip",
                "button",
                "icon"
            ]);
            rule.setAll({
                interactive: false,
                crisp: true,
                strokeOpacity: 0.5,
                draw: (display)=>{
                    display.moveTo(0, 0.5);
                    display.lineTo(0, 12.5);
                    display.moveTo(2, 0.5);
                    display.lineTo(2, 12.5);
                    display.moveTo(4, 0.5);
                    display.lineTo(4, 12.5);
                }
            });
            (0, $c53b0c859cf33b39$export$130a5dc1bc9cd8e1)(rule, "stroke", ic, "secondaryButtonText");
        }
        r("Button", [
            "rangegrip"
        ]).setAll({
            draggable: true,
            paddingTop: 0,
            paddingBottom: 0
        });
        r("Button", [
            "rangegrip",
            "vertical"
        ]).setAll({
            rotation: 90,
            cursorOverStyle: "ns-resize",
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72)
        });
        r("Button", [
            "rangegrip",
            "horizontal"
        ]).setAll({
            cursorOverStyle: "ew-resize",
            centerX: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72)
        });
        r("Button", [
            "rangegrip",
            "vertical",
            "left"
        ]).setAll({
            centerY: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
        r("Button", [
            "rangegrip",
            "vertical",
            "right"
        ]).setAll({
            centerY: 0
        });
        r("Button", [
            "rangegrip",
            "horizontal",
            "top"
        ]).setAll({
            centerY: 0
        });
        r("Button", [
            "rangegrip",
            "horizontal",
            "bottom"
        ]).setAll({
            centerY: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
    }
}






class $b0a754c78cd99ef8$export$acaa6426d77a227e extends (0, $5de502da8a72d65e$export$42a852a2b6b56249) {
    constructor(){
        super(...arguments);
        /**
         * A [[Container]] chart places its elements in.
         *
         * @default Container.new()
         */ this.chartContainer = this.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            interactiveChildren: false
        }));
        /**
         * A [[Container]] chart places its bullets in.
         *
         * @default Container.new()
         */ this.bulletsContainer = (0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            interactiveChildren: false,
            isMeasured: false,
            position: "absolute",
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        });
    }
}
$b0a754c78cd99ef8$export$acaa6426d77a227e.className = "Chart";
$b0a754c78cd99ef8$export$acaa6426d77a227e.classNames = (0, $5de502da8a72d65e$export$42a852a2b6b56249).classNames.concat([
    $b0a754c78cd99ef8$export$acaa6426d77a227e.className
]);






class $1c8dfb8f6e7d32bb$export$8a5e8f3f92395502 extends (0, $b0a754c78cd99ef8$export$acaa6426d77a227e) {
    constructor(){
        super(...arguments);
        /**
         * A [[Container]] where chart will store all series.
         *
         * @default Container.new()
         */ this.seriesContainer = (0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            isMeasured: false
        });
        /**
         * A list of chart's series.
         */ this.series = new (0, $ddd3cfc9bee47cd2$export$82bb93f974543403)();
    }
    _afterNew() {
        super._afterNew();
        this._disposers.push(this.series);
        const children = this.seriesContainer.children;
        this._disposers.push(this.series.events.onAll((change)=>{
            if (change.type === "clear") {
                $2f30431acd054e2f$export$79b2f7037acddd43(change.oldValues, (series)=>{
                    this._removeSeries(series);
                });
                const colors = this.get("colors");
                if (colors) colors.reset();
                const patterns = this.get("patterns");
                if (patterns) patterns.reset();
            } else if (change.type === "push") {
                children.moveValue(change.newValue);
                this._processSeries(change.newValue);
            } else if (change.type === "setIndex") {
                children.setIndex(change.index, change.newValue);
                this._processSeries(change.newValue);
            } else if (change.type === "insertIndex") {
                children.insertIndex(change.index, change.newValue);
                this._processSeries(change.newValue);
            } else if (change.type === "removeIndex") this._removeSeries(change.oldValue);
            else if (change.type === "moveIndex") {
                children.moveValue(change.value, change.newIndex);
                this._processSeries(change.value);
            } else if (change.type === "swap") {
                const a = change.a;
                const b = change.b;
                const aIndex = this.series.indexOf(a);
                const bIndex = this.series.indexOf(b);
                children.moveValue(a, bIndex);
                children.moveValue(b, aIndex);
                this.series.each((series)=>{
                    this._processSeries(series);
                    series.markDirtyValues();
                });
            } else throw new Error("Unknown IListEvent type");
        }));
    }
    _processSeries(series) {
        series.chart = this;
        series._placeBulletsContainer(this);
    }
    _removeSeries(series) {
        series._handleRemoved();
        if (!series.isDisposed()) {
            this.seriesContainer.children.removeValue(series);
            series._removeBulletsContainer();
        }
    }
}
$1c8dfb8f6e7d32bb$export$8a5e8f3f92395502.className = "SerialChart";
$1c8dfb8f6e7d32bb$export$8a5e8f3f92395502.classNames = (0, $b0a754c78cd99ef8$export$acaa6426d77a227e).classNames.concat([
    $1c8dfb8f6e7d32bb$export$8a5e8f3f92395502.className
]);








class $2f85a21744f68190$export$d55ab2e3dc5a4263 extends (0, $9e0cea1ea085e274$export$4617fb02663045ef) {
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("cornerRadiusTL") || this.isDirty("cornerRadiusTR") || this.isDirty("cornerRadiusBR") || this.isDirty("cornerRadiusBL")) this._clear = true;
    }
    _draw() {
        let width = this.width();
        let height = this.height();
        let wSign = width / Math.abs(width);
        let hSign = height / Math.abs(height);
        let x = 0;
        let y = 0;
        const strokeWidth = this.get("strokeWidth", 0);
        if (this.get("containStroke", false)) {
            width -= wSign * strokeWidth;
            height -= hSign * strokeWidth;
            x += wSign * strokeWidth / 2;
            y += hSign * strokeWidth / 2;
        }
        let w = width;
        let h = height;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(w) && $f63bdea45a89cf24$export$7e4aa119212bc614(h)) {
            let minSide = Math.min(w, h) / 2;
            let crtl = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("cornerRadiusTL", 8), minSide);
            let crtr = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("cornerRadiusTR", 8), minSide);
            let crbr = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("cornerRadiusBR", 8), minSide);
            let crbl = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("cornerRadiusBL", 8), minSide);
            let maxcr = Math.min(Math.abs(w / 2), Math.abs(h / 2));
            crtl = $f43e9e04b3f0548b$export$386b748ab02f16a0(crtl, 0, maxcr);
            crtr = $f43e9e04b3f0548b$export$386b748ab02f16a0(crtr, 0, maxcr);
            crbr = $f43e9e04b3f0548b$export$386b748ab02f16a0(crbr, 0, maxcr);
            crbl = $f43e9e04b3f0548b$export$386b748ab02f16a0(crbl, 0, maxcr);
            const display = this._display;
            display.moveTo(x + crtl * wSign, y);
            display.lineTo(x + w - crtr * wSign, y);
            if (crtr > 0) display.arcTo(x + w, y, x + w, y + crtr * hSign, crtr);
            display.lineTo(x + w, y + h - crbr * hSign);
            if (crbr > 0) display.arcTo(x + w, y + h, x + w - crbr * wSign, y + h, crbr);
            display.lineTo(x + crbl * wSign, y + h);
            if (crbl > 0) display.arcTo(x, y + h, x, y + h - crbl * hSign, crbl);
            display.lineTo(x, y + crtl * hSign);
            if (crtl > 0) display.arcTo(x, y, x + crtl * wSign, y, crtl);
            display.closePath();
        }
    }
}
$2f85a21744f68190$export$d55ab2e3dc5a4263.className = "RoundedRectangle";
$2f85a21744f68190$export$d55ab2e3dc5a4263.classNames = (0, $9e0cea1ea085e274$export$4617fb02663045ef).classNames.concat([
    $2f85a21744f68190$export$d55ab2e3dc5a4263.className
]);




class $f8fc56a6232808fd$export$353f5b6fc5456de1 extends (0, $5de502da8a72d65e$export$42a852a2b6b56249) {
    _afterNew() {
        this._settings.themeTags = $05b1b40b69b15016$export$88ad500ef99d1561(this._settings.themeTags, [
            "button"
        ]);
        super._afterNew();
        if (!this._settings.background) this.set("background", (0, $2f85a21744f68190$export$d55ab2e3dc5a4263).new(this._root, {
            themeTags: $05b1b40b69b15016$export$88ad500ef99d1561(this._settings.themeTags, [
                "background"
            ])
        }));
        this.setPrivate("trustBounds", true);
    }
    _prepareChildren() {
        super._prepareChildren();
        if (this.isDirty("icon")) {
            const previous = this._prevSettings.icon;
            const icon = this.get("icon");
            if (icon !== previous) {
                this._disposeProperty("icon");
                if (previous) previous.dispose();
                if (icon) this.children.push(icon);
                this._prevSettings.icon = icon;
            }
        }
        if (this.isDirty("label")) {
            const previous = this._prevSettings.label;
            const label = this.get("label");
            if (label !== previous) {
                this._disposeProperty("label");
                if (previous) previous.dispose();
                if (label) this.children.push(label);
                this._prevSettings.label = label;
            }
        }
    }
}
$f8fc56a6232808fd$export$353f5b6fc5456de1.className = "Button";
$f8fc56a6232808fd$export$353f5b6fc5456de1.classNames = (0, $5de502da8a72d65e$export$42a852a2b6b56249).classNames.concat([
    $f8fc56a6232808fd$export$353f5b6fc5456de1.className
]);









class $f33aa5eed78e4f07$export$64cf36d276346559 extends (0, $1c8dfb8f6e7d32bb$export$8a5e8f3f92395502) {
    constructor(){
        super(...arguments);
        /**
         * A list of horizontal axes.
         */ this.xAxes = new (0, $ddd3cfc9bee47cd2$export$82bb93f974543403)();
        /**
         * A list of vertical axes.
         */ this.yAxes = new (0, $ddd3cfc9bee47cd2$export$82bb93f974543403)();
        /**
         * A [[Container]] located on top of the chart, used to store top horizontal
         * axes.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.topAxesContainer = this.chartContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            layout: this._root.verticalLayout
        }));
        /**
         * A [[Container]] located in the middle the chart, used to store vertical axes
         * and plot area container.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.yAxesAndPlotContainer = this.chartContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            layout: this._root.horizontalLayout
        }));
        /**
         * A [[Container]] located on bottom of the chart, used to store bottom
         * horizontal axes.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.bottomAxesContainer = this.chartContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            layout: this._root.verticalLayout
        }));
        /**
         * A [[Container]] located on left of the chart, used to store left-hand
         * vertical axes.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.leftAxesContainer = this.yAxesAndPlotContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            layout: this._root.horizontalLayout
        }));
        /**
         * A [[Container]] located in the middle of the chart, used to store plotContainer and topPlotContainer
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.plotsContainer = this.yAxesAndPlotContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            maskContent: false
        }));
        /**
         * A [[Container]] located in the middle of the chart, used to store actual
         * plots (series).
         *
         * NOTE: `plotContainer` will automatically have its `background` preset. If
         * you need to modify background or outline for chart's plot area, you can
         * use `plotContainer.get("background")` for that.*
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.plotContainer = this.plotsContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        }));
        /**
         * A [[Container]] used for any elements that need to be displayed over
         * regular `plotContainer`.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.topPlotContainer = this.plotsContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c)
        }));
        /**
         * A [[Container]] axis grid elements are stored in.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.gridContainer = this.plotContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            isMeasured: false
        }));
        /**
         * A [[Container]] axis background grid elements are stored in.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.topGridContainer = (0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            width: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            isMeasured: false
        });
        /**
         * A [[Container]] located on right of the chart, used to store right-hand
         * vertical axes.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
         * @default Container.new()
         */ this.rightAxesContainer = this.yAxesAndPlotContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            height: (0, $bd0d0c10fd30006b$export$46342ea78d85883c),
            layout: this._root.horizontalLayout
        }));
        /**
         * A [[Container]] axis headers are stored in.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-headers/} for more info
         * @default Container.new()
         */ this.axisHeadersContainer = this.plotContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {}));
        /**
         * A button that is shown when chart is not fully zoomed out.
         *
         * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/zoom-and-pan/#Zoom_out_button} for more info
         * @default Button.new()
         */ this.zoomOutButton = this.topPlotContainer.children.push((0, $f8fc56a6232808fd$export$353f5b6fc5456de1).new(this._root, {
            themeTags: [
                "zoom"
            ],
            icon: (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).new(this._root, {
                themeTags: [
                    "button",
                    "icon"
                ]
            })
        }));
        this._movePoint = {
            x: 0,
            y: 0
        };
        this._movePoints = {};
    }
    _afterNew() {
        this._defaultThemes.push((0, $8ff28373ed1fac0e$export$3407b11010d1bc82).new(this._root));
        super._afterNew();
        this._disposers.push(this.xAxes);
        this._disposers.push(this.yAxes);
        const root = this._root;
        let verticalLayout = this._root.verticalLayout;
        const zoomOutButton = this.zoomOutButton;
        zoomOutButton.events.on("click", ()=>{
            this.zoomOut();
        });
        zoomOutButton.hide(0);
        zoomOutButton.states.lookup("default").set("opacity", 1);
        this.chartContainer.set("layout", verticalLayout);
        const plotContainer = this.plotContainer;
        plotContainer.children.push(this.seriesContainer);
        this._disposers.push(this._processAxis(this.xAxes, this.bottomAxesContainer));
        this._disposers.push(this._processAxis(this.yAxes, this.leftAxesContainer));
        plotContainer.children.push(this.topGridContainer);
        plotContainer.children.push(this.bulletsContainer);
        // Setting trasnparent background so that full body of the plot container
        // is interactive
        plotContainer.set("interactive", true);
        plotContainer.set("interactiveChildren", false);
        plotContainer.set("background", (0, $9e0cea1ea085e274$export$4617fb02663045ef).new(root, {
            themeTags: [
                "plotbackground",
                "xy",
                "background"
            ]
        }));
        this._disposers.push(plotContainer.events.on("pointerdown", (event)=>{
            this._handlePlotDown(event);
        }));
        this._disposers.push(plotContainer.events.on("globalpointerup", (event)=>{
            this._handlePlotUp(event);
        }));
        this._disposers.push(plotContainer.events.on("globalpointermove", (event)=>{
            this._handlePlotMove(event);
        }));
        this._maskGrid();
        this._setUpTouch();
    }
    _beforeChanged() {
        super._beforeChanged();
        if (this.isDirty("pinchZoomX") || this.isDirty("pinchZoomY") || this.get("panX") || this.get("panY")) this._setUpTouch();
    }
    _setUpTouch() {
        if (!this.plotContainer._display.cancelTouch) this.plotContainer._display.cancelTouch = this.get("pinchZoomX") || this.get("pinchZoomY") || this.get("panX") || this.get("panY") ? true : false;
    }
    _maskGrid() {
        this.gridContainer.set("maskContent", true);
        this.topGridContainer.set("maskContent", true);
    }
    _removeSeries(series) {
        series._unstack();
        if (series._posXDp) series._posXDp.dispose();
        if (series._posYDp) series._posYDp.dispose();
        series.set("baseAxis", undefined);
        const xAxis = series.get("xAxis");
        if (xAxis) {
            $2f30431acd054e2f$export$cd7f480d6b8286c3(xAxis.series, series);
            xAxis.markDirtyExtremes();
        }
        const yAxis = series.get("yAxis");
        if (yAxis) {
            $2f30431acd054e2f$export$cd7f480d6b8286c3(yAxis.series, series);
            yAxis.markDirtyExtremes();
        }
        const cursor = this.get("cursor");
        if (cursor) {
            const snapToSeries = cursor.get("snapToSeries");
            if (snapToSeries) $2f30431acd054e2f$export$cd7f480d6b8286c3(snapToSeries, series);
        }
        super._removeSeries(series);
    }
    _applyThemes(force = false) {
        const colors = this.get("colors");
        if (colors) colors.reset();
        const changed = super._applyThemes(force);
        return changed;
    }
    /**
     * This method is invoked when mouse wheel is used over chart's plot
     * container, and handles zooming/pan.
     *
     * You can invoke this method manually, if you need to mimic chart's wheel
     * behavior over other elements of the chart.
     */ handleWheel(event) {
        const wheelX = this.get("wheelX");
        const wheelY = this.get("wheelY");
        const plotContainer = this.plotContainer;
        const wheelEvent = event.originalEvent;
        // Ignore wheel event if it is happening on a non-chart element, e.g. if
        // some page element is over the chart.
        let prevent = false;
        if ($05b1b40b69b15016$export$a3b96849d75e4c53(wheelEvent, this)) prevent = true;
        else return;
        const plotPoint = plotContainer.toLocal(event.point);
        const wheelStep = this.get("wheelStep", 0.2);
        const shiftY = wheelEvent.deltaY / 100;
        const shiftX = wheelEvent.deltaX / 100;
        const wheelZoomPositionX = this.get("wheelZoomPositionX");
        const wheelZoomPositionY = this.get("wheelZoomPositionY");
        if ((wheelX === "zoomX" || wheelX === "zoomXY") && shiftX != 0) this.xAxes.each((axis)=>{
            if (axis.get("zoomX")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let position = axis.fixPosition(plotPoint.x / plotContainer.width());
                if (wheelZoomPositionX != null) position = wheelZoomPositionX;
                let maxDeviation = axis.get("maxDeviation", 0);
                let newStart = Math.min(1 + maxDeviation, Math.max(-maxDeviation, start - wheelStep * (end - start) * shiftX * position));
                let newEnd = Math.max(-maxDeviation, Math.min(1 + maxDeviation, end + wheelStep * (end - start) * shiftX * (1 - position)));
                if (newStart == start && newEnd == end) prevent = false;
                if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) this._handleWheelAnimation(axis.zoom(newStart, newEnd));
                else prevent = false;
            }
        });
        if ((wheelY === "zoomX" || wheelY === "zoomXY") && shiftY != 0) this.xAxes.each((axis)=>{
            if (axis.get("zoomX")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let position = axis.fixPosition(plotPoint.x / plotContainer.width());
                if (wheelZoomPositionX != null) position = wheelZoomPositionX;
                let maxDeviation = axis.get("maxDeviation", 0);
                let newStart = Math.min(1 + maxDeviation, Math.max(-maxDeviation, start - wheelStep * (end - start) * shiftY * position));
                let newEnd = Math.max(-maxDeviation, Math.min(1 + maxDeviation, end + wheelStep * (end - start) * shiftY * (1 - position)));
                if (newStart == start && newEnd == end) prevent = false;
                if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) this._handleWheelAnimation(axis.zoom(newStart, newEnd));
                else prevent = false;
            }
        });
        if ((wheelX === "zoomY" || wheelX === "zoomXY") && shiftX != 0) this.yAxes.each((axis)=>{
            if (axis.get("zoomY")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let position = axis.fixPosition(plotPoint.y / plotContainer.height());
                if (wheelZoomPositionY != null) position = wheelZoomPositionY;
                let maxDeviation = axis.get("maxDeviation", 0);
                let newStart = Math.min(1 + maxDeviation, Math.max(-maxDeviation, start - wheelStep * (end - start) * shiftX * position));
                let newEnd = Math.max(-maxDeviation, Math.min(1 + maxDeviation, end + wheelStep * (end - start) * shiftX * (1 - position)));
                if (newStart == start && newEnd == end) prevent = false;
                if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) this._handleWheelAnimation(axis.zoom(newStart, newEnd));
                else prevent = false;
            }
        });
        if ((wheelY === "zoomY" || wheelY === "zoomXY") && shiftY != 0) this.yAxes.each((axis)=>{
            if (axis.get("zoomY")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let position = axis.fixPosition(plotPoint.y / plotContainer.height());
                if (wheelZoomPositionY != null) position = wheelZoomPositionY;
                let maxDeviation = axis.get("maxDeviation", 0);
                let newStart = Math.min(1 + maxDeviation, Math.max(-maxDeviation, start - wheelStep * (end - start) * shiftY * position));
                let newEnd = Math.max(-maxDeviation, Math.min(1 + maxDeviation, end + wheelStep * (end - start) * shiftY * (1 - position)));
                if (newStart == start && newEnd == end) prevent = false;
                if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) this._handleWheelAnimation(axis.zoom(newStart, newEnd));
                else prevent = false;
            }
        });
        if ((wheelX === "panX" || wheelX === "panXY") && shiftX != 0) this.xAxes.each((axis)=>{
            if (axis.get("panX")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftX;
                let newStart = start + delta;
                let newEnd = end + delta;
                let se = this._fixWheel(newStart, newEnd);
                newStart = se[0];
                newEnd = se[1];
                if (newStart == start && newEnd == end) prevent = false;
                this._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
        });
        if ((wheelY === "panX" || wheelY === "panXY") && shiftY != 0) this.xAxes.each((axis)=>{
            if (axis.get("panX")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftY;
                let newStart = start + delta;
                let newEnd = end + delta;
                let se = this._fixWheel(newStart, newEnd);
                newStart = se[0];
                newEnd = se[1];
                if (newStart == start && newEnd == end) prevent = false;
                this._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
        });
        if ((wheelX === "panY" || wheelX === "panXY") && shiftX != 0) this.yAxes.each((axis)=>{
            if (axis.get("panY")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftX;
                let newStart = start + delta;
                let newEnd = end + delta;
                let se = this._fixWheel(newStart, newEnd);
                newStart = se[0];
                newEnd = se[1];
                if (newStart == start && newEnd == end) prevent = false;
                this._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
        });
        if ((wheelY === "panY" || wheelY === "panXY") && shiftY != 0) this.yAxes.each((axis)=>{
            if (axis.get("panY")) {
                let start = axis.get("start");
                let end = axis.get("end");
                let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftY;
                let newStart = start - delta;
                let newEnd = end - delta;
                let se = this._fixWheel(newStart, newEnd);
                newStart = se[0];
                newEnd = se[1];
                if (newStart == start && newEnd == end) prevent = false;
                this._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
        });
        if (prevent) wheelEvent.preventDefault();
    }
    _handleSetWheel() {
        const wheelX = this.get("wheelX");
        const wheelY = this.get("wheelY");
        const plotContainer = this.plotContainer;
        if (wheelX !== "none" || wheelY !== "none") {
            this._wheelDp = plotContainer.events.on("wheel", (event)=>{
                const wheelEvent = event.originalEvent;
                if (wheelX !== "none" && Math.abs(wheelEvent.deltaX) != 0 || wheelY !== "none" && Math.abs(wheelEvent.deltaY) != 0) this.handleWheel(event);
            });
            this._disposers.push(this._wheelDp);
        } else if (this._wheelDp) this._wheelDp.dispose();
    }
    _getWheelSign(axis) {
        let sign = 1;
        if (axis.get("renderer").get("inversed")) sign = -1;
        return sign;
    }
    _fixWheel(start, end) {
        const diff = end - start;
        if (start < 0) {
            start = 0;
            end = start + diff;
        }
        if (end > 1) {
            end = 1;
            start = end - diff;
        }
        return [
            start,
            end
        ];
    }
    _handlePlotDown(event) {
        const originalEvent = event.originalEvent;
        if (originalEvent.button == 2) return;
        const plotContainer = this.plotContainer;
        let local = plotContainer.toLocal(event.point);
        if (this.get("pinchZoomX") || this.get("pinchZoomY")) {
            const pointerId = originalEvent.pointerId;
            if (pointerId) {
                if ($e66f9343b5144e1a$export$ed97f33186d4b816(plotContainer._downPoints).length > 0) {
                    const xAxis = this.xAxes.getIndex(0);
                    const yAxis = this.yAxes.getIndex(0);
                    if (xAxis) {
                        this._downStartX = xAxis.get("start", 0);
                        this._downEndX = xAxis.get("end", 1);
                    }
                    if (yAxis) {
                        this._downStartY = yAxis.get("start", 0);
                        this._downEndY = yAxis.get("end", 1);
                    }
                }
            }
        }
        if (this.get("panX") || this.get("panY")) {
            if (local.x >= 0 && local.y >= 0 && local.x <= plotContainer.width() && local.y <= this.height()) {
                //this._downPoint = local;
                this._downPoint = {
                    x: originalEvent.clientX,
                    y: originalEvent.clientY
                };
                const panX = this.get("panX");
                const panY = this.get("panY");
                if (panX) this.xAxes.each((axis)=>{
                    axis._panStart = axis.get("start");
                    axis._panEnd = axis.get("end");
                });
                if (panY) this.yAxes.each((axis)=>{
                    axis._panStart = axis.get("start");
                    axis._panEnd = axis.get("end");
                });
                const eventType = "panstarted";
                if (this.events.isEnabled(eventType)) this.events.dispatch(eventType, {
                    type: eventType,
                    target: this,
                    originalEvent: event.originalEvent
                });
            }
        }
    }
    _handleWheelAnimation(animation) {
        if (animation) animation.events.on("stopped", ()=>{
            this._dispatchWheelAnimation();
        });
        else this._dispatchWheelAnimation();
    }
    _dispatchWheelAnimation() {
        const eventType = "wheelended";
        if (this.events.isEnabled(eventType)) this.events.dispatch(eventType, {
            type: eventType,
            target: this
        });
    }
    _handlePlotUp(event) {
        const downPoint = this._downPoint;
        if (downPoint) {
            if (this.get("panX") || this.get("panY")) {
                if (event.originalEvent.clientX == downPoint.x && event.originalEvent.clientY == downPoint.y) {
                    const eventType = "pancancelled";
                    if (this.events.isEnabled(eventType)) this.events.dispatch(eventType, {
                        type: eventType,
                        target: this,
                        originalEvent: event.originalEvent
                    });
                }
                const eventType = "panended";
                if (this.events.isEnabled(eventType)) this.events.dispatch(eventType, {
                    type: eventType,
                    target: this,
                    originalEvent: event.originalEvent
                });
            }
        }
        // TODO: handle multitouch
        this._downPoint = undefined;
        this.xAxes.each((xAxis)=>{
            xAxis._isPanning = false;
        });
        this.yAxes.each((yAxis)=>{
            yAxis._isPanning = false;
        });
    }
    _handlePlotMove(event) {
        const plotContainer = this.plotContainer;
        if (this.get("pinchZoomX") || this.get("pinchZoomY")) {
            const touchEvent = event.originalEvent;
            const pointerId = touchEvent.pointerId;
            if (pointerId) {
                this._movePoints[pointerId] = event.point;
                if ($e66f9343b5144e1a$export$ed97f33186d4b816(plotContainer._downPoints).length > 1) {
                    this._handlePinch();
                    return;
                }
            }
        }
        let downPoint = this._downPoint;
        if (downPoint) {
            downPoint = plotContainer.toLocal(this._root.documentPointToRoot(downPoint));
            let local = plotContainer.toLocal(event.point);
            const panX = this.get("panX");
            const panY = this.get("panY");
            if (panX) {
                let scrollbarX = this.get("scrollbarX");
                if (scrollbarX) scrollbarX.events.disableType("rangechanged");
                this.xAxes.each((axis)=>{
                    if (axis.get("panX")) {
                        axis._isPanning = true;
                        //const maxDeviation = axis.get("maxDeviation", 0);
                        let panStart = axis._panStart;
                        let panEnd = axis._panEnd;
                        let difference = panEnd - panStart;
                        let deltaX = difference * (downPoint.x - local.x) / plotContainer.width();
                        if (axis.get("renderer").get("inversed")) deltaX *= -1;
                        let start = panStart + deltaX;
                        let end = panEnd + deltaX;
                        if (end - start < 1 + axis.get("maxDeviation", 1) * 2) {
                            axis.set("start", start);
                            axis.set("end", end);
                        }
                    }
                });
                if (scrollbarX) scrollbarX.events.enableType("rangechanged");
            }
            if (panY) {
                let scrollbarY = this.get("scrollbarY");
                if (scrollbarY) scrollbarY.events.disableType("rangechanged");
                this.yAxes.each((axis)=>{
                    if (axis.get("panY")) {
                        axis._isPanning = true;
                        //const maxDeviation = axis.get("maxDeviation", 0);
                        let panStart = axis._panStart;
                        let panEnd = axis._panEnd;
                        let difference = panEnd - panStart;
                        let deltaY = difference * (downPoint.y - local.y) / plotContainer.height();
                        if (axis.get("renderer").get("inversed")) deltaY *= -1;
                        let start = panStart - deltaY;
                        let end = panEnd - deltaY;
                        if (end - start < 1 + axis.get("maxDeviation", 1) * 2) {
                            axis.set("start", start);
                            axis.set("end", end);
                        }
                    }
                });
                if (scrollbarY) scrollbarY.events.enableType("rangechanged");
            }
        }
    }
    _handlePinch() {
        const plotContainer = this.plotContainer;
        let i = 0;
        let downPoints = [];
        let movePoints = [];
        $e66f9343b5144e1a$export$79b2f7037acddd43(plotContainer._downPoints, (k, point)=>{
            downPoints[i] = point;
            let movePoint = this._movePoints[k];
            if (movePoint) movePoints[i] = movePoint;
            i++;
        });
        if (downPoints.length > 1 && movePoints.length > 1) {
            const w = plotContainer.width();
            const h = plotContainer.height();
            let downPoint0 = downPoints[0];
            let downPoint1 = downPoints[1];
            let movePoint0 = movePoints[0];
            let movePoint1 = movePoints[1];
            if (downPoint0 && downPoint1 && movePoint0 && movePoint1) {
                movePoint0 = plotContainer.toLocal(movePoint0);
                movePoint1 = plotContainer.toLocal(movePoint1);
                downPoint0 = plotContainer.toLocal(downPoint0);
                downPoint1 = plotContainer.toLocal(downPoint1);
                if (this.get("pinchZoomX")) {
                    const downStartX = this._downStartX;
                    const downEndX = this._downEndX;
                    if (downStartX != null && downEndX != null) {
                        if (downPoint0.x > downPoint1.x) {
                            [downPoint0, downPoint1] = [
                                downPoint1,
                                downPoint0
                            ];
                            [movePoint0, movePoint1] = [
                                movePoint1,
                                movePoint0
                            ];
                        }
                        let downPos0 = downStartX + downPoint0.x / w * (downEndX - downStartX);
                        let downPos1 = downStartX + downPoint1.x / w * (downEndX - downStartX);
                        let movePos0 = downStartX + movePoint0.x / w * (downEndX - downStartX);
                        let movePos1 = downStartX + movePoint1.x / w * (downEndX - downStartX);
                        let initialDistance = Math.max(0.001, downPos1 - downPos0);
                        let currentDistance = Math.max(0.001, movePos1 - movePos0);
                        let d = initialDistance / currentDistance;
                        let s = downStartX * d + downPos0 - movePos0 * d;
                        let e = downEndX * d + downPos1 - movePos1 * d;
                        this.xAxes.each((xAxis)=>{
                            let sa = xAxis.fixPosition(s);
                            let ea = xAxis.fixPosition(e);
                            xAxis.zoom(sa, ea, 0);
                        });
                    }
                }
                if (this.get("pinchZoomY")) {
                    const downStartY = this._downStartY;
                    const downEndY = this._downEndY;
                    if (downStartY != null && downEndY != null) {
                        if (downPoint0.y < downPoint1.y) {
                            [downPoint0, downPoint1] = [
                                downPoint1,
                                downPoint0
                            ];
                            [movePoint0, movePoint1] = [
                                movePoint1,
                                movePoint0
                            ];
                        }
                        let downPos0 = downStartY + (1 - downPoint0.y / h) * (downEndY - downStartY);
                        let downPos1 = downStartY + (1 - downPoint1.y / h) * (downEndY - downStartY);
                        let movePos0 = downStartY + (1 - movePoint0.y / h) * (downEndY - downStartY);
                        let movePos1 = downStartY + (1 - movePoint1.y / h) * (downEndY - downStartY);
                        let initialDistance = Math.max(0.001, downPos1 - downPos0);
                        let currentDistance = Math.max(0.001, movePos1 - movePos0);
                        let d = initialDistance / currentDistance;
                        let s = downStartY * d + downPos0 - movePos0 * d;
                        let e = downEndY * d + downPos1 - movePos1 * d;
                        this.yAxes.each((yAxis)=>{
                            let sa = yAxis.fixPosition(s);
                            let ea = yAxis.fixPosition(e);
                            yAxis.zoom(sa, ea, 0);
                        });
                    }
                }
            }
        }
    }
    _handleCursorPosition() {
        const cursor = this.get("cursor");
        if (cursor) {
            const cursorPoint = cursor.getPrivate("point");
            let snapToSeries = cursor.get("snapToSeries");
            if (cursor._downPoint) snapToSeries = undefined;
            if (snapToSeries && cursorPoint) {
                const snapToSeriesBy = cursor.get("snapToSeriesBy");
                const dataItems = [];
                $2f30431acd054e2f$export$79b2f7037acddd43(snapToSeries, (series)=>{
                    if (!series.isHidden() && !series.isHiding()) {
                        if (snapToSeriesBy != "x!" && snapToSeriesBy != "y!") {
                            const startIndex = series.startIndex();
                            const endIndex = series.endIndex();
                            for(let i = startIndex; i < endIndex; i++){
                                const dataItem = series.dataItems[i];
                                if (dataItem && !dataItem.isHidden()) dataItems.push(dataItem);
                            }
                        } else {
                            const tooltipDataItem = series.get("tooltipDataItem");
                            if (tooltipDataItem) dataItems.push(tooltipDataItem);
                        }
                    }
                });
                let minDistance = Infinity;
                let closestItem;
                $2f30431acd054e2f$export$79b2f7037acddd43(dataItems, (dataItem)=>{
                    const point = dataItem.get("point");
                    if (point) {
                        let distance = 0;
                        if (snapToSeriesBy == "x" || snapToSeriesBy == "x!") distance = Math.abs(cursorPoint.x - point.x);
                        else if (snapToSeriesBy == "y" || snapToSeriesBy == "y!") distance = Math.abs(cursorPoint.y - point.y);
                        else distance = Math.hypot(cursorPoint.x - point.x, cursorPoint.y - point.y);
                        if (distance < minDistance) {
                            minDistance = distance;
                            closestItem = dataItem;
                        }
                    }
                });
                $2f30431acd054e2f$export$79b2f7037acddd43(snapToSeries, (series)=>{
                    const tooltip = series.get("tooltip");
                    if (tooltip) tooltip._setDataItem(undefined);
                });
                if (closestItem) {
                    let series = closestItem.component;
                    series.showDataItemTooltip(closestItem);
                    series.setRaw("tooltipDataItem", closestItem);
                    const point = closestItem.get("point");
                    if (point) // removing x and y to solve #72225
                    cursor.handleMove(series.toGlobal({
                        x: point.x - series.x(),
                        y: point.y - series.y()
                    }), true);
                }
            }
        }
    }
    _updateCursor() {
        let cursor = this.get("cursor");
        if (cursor) cursor.updateCursor();
    }
    _addCursor(cursor) {
        this.plotContainer.children.push(cursor);
    }
    _prepareChildren() {
        super._prepareChildren();
        this.series.each((series)=>{
            this._colorize(series);
        });
        if (this.isDirty("wheelX") || this.isDirty("wheelY")) this._handleSetWheel();
        if (this.isDirty("cursor")) {
            const previous = this._prevSettings.cursor;
            const cursor = this.get("cursor");
            if (cursor !== previous) {
                this._disposeProperty("cursor");
                if (previous) previous.dispose();
                if (cursor) {
                    cursor._setChart(this);
                    this._addCursor(cursor);
                    this._pushPropertyDisposer("cursor", cursor.events.on("selectended", ()=>{
                        this._handleCursorSelectEnd();
                    }));
                }
                //this.setRaw("cursor", cursor) // to reset previous value
                this._prevSettings.cursor = cursor;
            }
        }
        if (this.isDirty("scrollbarX")) {
            const previous = this._prevSettings.scrollbarX;
            const scrollbarX = this.get("scrollbarX");
            if (scrollbarX !== previous) {
                this._disposeProperty("scrollbarX");
                if (previous) previous.dispose();
                if (scrollbarX) {
                    this._placeScrollbar("scrollbarX", scrollbarX, this.topAxesContainer, this.bottomAxesContainer);
                    this._pushPropertyDisposer("scrollbarX", scrollbarX.events.on("rangechanged", (e)=>{
                        this._handleScrollbar(this.xAxes, e.start, e.end, e.grip);
                    }));
                    this._pushPropertyDisposer("scrollbarX", scrollbarX.events.on("released", ()=>{
                        this.xAxes.each((axis)=>{
                            if (axis.get("zoomable")) this._handleAxisSelection(axis);
                        });
                    }));
                    // Used to populate `ariaLabel` with meaningful values
                    scrollbarX.setPrivate("positionTextFunction", (position)=>{
                        const axis = this.xAxes.getIndex(0);
                        return axis ? axis.getTooltipText(position, false) || "" : "";
                    });
                }
                this._prevSettings.scrollbarX = scrollbarX;
            }
        }
        if (this.isDirty("scrollbarY")) {
            const previous = this._prevSettings.scrollbarY;
            const scrollbarY = this.get("scrollbarY");
            if (scrollbarY !== previous) {
                this._disposeProperty("scrollbarY");
                if (previous) previous.dispose();
                if (scrollbarY) {
                    this._placeScrollbar("scrollbarY", scrollbarY, this.rightAxesContainer, this.leftAxesContainer, true);
                    this._pushPropertyDisposer("scrollbarY", scrollbarY.events.on("rangechanged", (e)=>{
                        this._handleScrollbar(this.yAxes, e.start, e.end, e.grip);
                    }));
                    this._pushPropertyDisposer("scrollbarY", scrollbarY.events.on("released", ()=>{
                        this.yAxes.each((axis)=>{
                            if (axis.get("zoomable")) this._handleAxisSelection(axis);
                        });
                    }));
                    // Used to populate `ariaLabel` with meaningful values
                    scrollbarY.setPrivate("positionTextFunction", (position)=>{
                        const axis = this.yAxes.getIndex(0);
                        return axis ? axis.getTooltipText(position, false) || "" : "";
                    });
                }
                this._prevSettings.scrollbarY = scrollbarY;
            }
        }
        this._handleZoomOut();
    }
    /**
     * Puts a scrollbar into one of two containers, depending on its `opposite`
     * setting, and moves it over if the setting changes later. `unshift` is for
     * the left container, which fills left to right, so the scrollbar has to go
     * in at the front to end up outside the axes.
     *
     * @ignore
     */ _placeScrollbar(key, scrollbar, container, oppositeContainer, unshift) {
        const place = ()=>{
            const opposite = scrollbar.get("opposite");
            const target = opposite ? oppositeContainer : container;
            const children = target.children;
            const index = opposite && unshift ? 0 : children.length - 1;
            if (scrollbar.parent != target || children.indexOf(scrollbar) != index) {
                // A vertical layout only ever sets a child's private `y` and a
                // horizontal one only `x`, so whatever the new container does not
                // own would keep the value the previous one gave it. Drop both, the
                // same way a container resets its children when its own layout
                // changes.
                scrollbar.removePrivate("x");
                scrollbar.removePrivate("y");
                if (opposite && unshift) children.moveValue(scrollbar, 0);
                else children.moveValue(scrollbar);
                // Inserting a child only marks the container it came from, so make
                // the receiving side re-measure and lay out again.
                target.markDirtyBounds();
                // A vertical scrollbar changes the width of the left/right
                // containers, which the top/bottom padding is derived from. Those
                // widths only settle once the layout has run, hence the wait.
                this._root.events.once("frameended", ()=>{
                    if (!this.isDisposed()) this._updateChartLayout();
                });
            }
        };
        if (!scrollbar.parent) place();
        this._pushPropertyDisposer(key, scrollbar.on("opposite", ()=>{
            // only move scrollbars the chart placed itself
            const parent = scrollbar.parent;
            if (parent == container || parent == oppositeContainer) place();
        }));
    }
    _processSeries(series) {
        super._processSeries(series);
        const xAxis = series.get("xAxis");
        const yAxis = series.get("yAxis");
        $2f30431acd054e2f$export$d947e5f4f4c48d48(xAxis.series, series);
        $2f30431acd054e2f$export$d947e5f4f4c48d48(yAxis.series, series);
        series._posXDp = series.addDisposer(xAxis.events.on("positionchanged", ()=>{
            series._fixPosition();
        }));
        series._posYDp = series.addDisposer(yAxis.events.on("positionchanged", ()=>{
            series._fixPosition();
        }));
        if (!series.get("baseAxis")) {
            if (yAxis.isType("CategoryAxis") || yAxis.isType("DateAxis")) series.set("baseAxis", yAxis);
            else series.set("baseAxis", xAxis);
        }
        if (series.get("stacked")) {
            series._markDirtyKey("stacked");
            $2f30431acd054e2f$export$79b2f7037acddd43(series.dataItems, (dataItem)=>{
                dataItem.set("stackToItemY", undefined);
                dataItem.set("stackToItemX", undefined);
            });
        }
        series._markDirtyAxes();
        yAxis.markDirtyExtremes();
        xAxis.markDirtyExtremes();
        xAxis._seriesAdded = true;
        yAxis._seriesAdded = true;
        this._colorize(series);
    }
    _colorize(series) {
        const colorSet = this.get("colors");
        if (colorSet) {
            if (series.get("fill") == null) {
                const color = colorSet.next();
                series._setSoft("stroke", color);
                series._setSoft("fill", color);
            }
        }
        const patternSet = this.get("patterns");
        if (patternSet) {
            if (series.get("fillPattern") == null) {
                const pattern = patternSet.next();
                series._setSoft("fillPattern", pattern);
            }
        }
        // Cycle stroke widths / dash arrays for line series (those that have a
        // `strokes` list), keyed by the series' position — so line series can be
        // told apart by weight and dashiness without relying on color.
        const strokeWidths = this.get("strokeWidths");
        const strokeDasharrays = this.get("strokeDasharrays");
        if (strokeWidths || strokeDasharrays) {
            const strokes = series.strokes;
            if (strokes && strokes.template) {
                const index = this.series.indexOf(series);
                if (strokeWidths && strokeWidths.length > 0) strokes.template.set("strokeWidth", strokeWidths[index % strokeWidths.length]);
                if (strokeDasharrays && strokeDasharrays.length > 0) strokes.template.set("strokeDasharray", strokeDasharrays[index % strokeDasharrays.length]);
            }
        }
    }
    _handleCursorSelectEnd() {
        const cursor = this.get("cursor");
        const behavior = cursor.get("behavior");
        const downPositionX = cursor.getPrivate("downPositionX", 0);
        const downPositionY = cursor.getPrivate("downPositionY", 0);
        const positionX = Math.min(1, Math.max(0, cursor.getPrivate("positionX", 0.5)));
        const positionY = Math.min(1, Math.max(0, cursor.getPrivate("positionY", 0.5)));
        this.xAxes.each((axis)=>{
            if (behavior === "zoomX" || behavior === "zoomXY") {
                let position0 = axis.toAxisPosition(downPositionX);
                let position1 = axis.toAxisPosition(positionX);
                axis.zoom(position0, position1);
            }
            axis.setPrivate("updateScrollbar", true);
        });
        this.yAxes.each((axis)=>{
            if (behavior === "zoomY" || behavior === "zoomXY") {
                let position0 = axis.toAxisPosition(downPositionY);
                let position1 = axis.toAxisPosition(positionY);
                axis.zoom(position0, position1);
            }
            axis.setPrivate("updateScrollbar", true);
        });
    }
    _handleScrollbar(axes, start, end, priority) {
        axes.each((axis)=>{
            let axisStart = axis.fixPosition(start);
            let axisEnd = axis.fixPosition(end);
            let zoomAnimation = axis.zoom(axisStart, axisEnd, undefined, priority);
            const updateScrollbar = "updateScrollbar";
            axis.setPrivateRaw(updateScrollbar, false);
            if (zoomAnimation) zoomAnimation.events.on("stopped", ()=>{
                axis.setPrivateRaw(updateScrollbar, true);
            });
            else axis.setPrivateRaw(updateScrollbar, true);
        });
    }
    _processAxis(axes, container) {
        return axes.events.onAll((change)=>{
            if (change.type === "clear") $2f30431acd054e2f$export$79b2f7037acddd43(change.oldValues, (axis)=>{
                this._removeAxis(axis);
            });
            else if (change.type === "push") {
                container.children.push(change.newValue);
                change.newValue.processChart(this);
            } else if (change.type === "setIndex") {
                container.children.setIndex(change.index, change.newValue);
                change.newValue.processChart(this);
            } else if (change.type === "insertIndex") {
                container.children.insertIndex(change.index, change.newValue);
                change.newValue.processChart(this);
            } else if (change.type === "removeIndex") this._removeAxis(change.oldValue);
            else if (change.type === "moveIndex") {
                container.children.moveValue(change.value, change.newIndex);
                change.value.processChart(this);
            } else throw new Error("Unknown IListEvent type");
        });
    }
    _removeAxis(axis) {
        if (!axis.isDisposed()) {
            const axisParent = axis.parent;
            if (axisParent) axisParent.children.removeValue(axis);
            const gridContainer = axis.gridContainer;
            const gridParent = gridContainer.parent;
            if (gridParent) gridParent.children.removeValue(gridContainer);
            const topGridContainer = axis.topGridContainer;
            const topGridParent = topGridContainer.parent;
            if (topGridParent) topGridParent.children.removeValue(topGridContainer);
        }
    }
    _updateChartLayout() {
        const left = this.leftAxesContainer.width();
        const right = this.rightAxesContainer.width();
        const bottomAxesContainer = this.bottomAxesContainer;
        bottomAxesContainer.set("paddingLeft", left);
        bottomAxesContainer.set("paddingRight", right);
        const topAxesContainer = this.topAxesContainer;
        topAxesContainer.set("paddingLeft", left);
        topAxesContainer.set("paddingRight", right);
    }
    /**
     * @ignore
     */ processAxis(axis) {
        var cursor = this.get("cursor");
        if (cursor) {
            this.addDisposer(axis.on("start", ()=>{
                this._updateCursor();
            }));
            this.addDisposer(axis.on("end", ()=>{
                this._updateCursor();
            }));
        }
    }
    _handleAxisSelection(axis, force) {
        let start = axis.fixPosition(axis.get("start", 0));
        let end = axis.fixPosition(axis.get("end", 1));
        if (start > end) [start, end] = [
            end,
            start
        ];
        if (this.xAxes.indexOf(axis) != -1) {
            if (force || axis.getPrivate("updateScrollbar")) {
                let scrollbarX = this.get("scrollbarX");
                if (scrollbarX && (!scrollbarX.getPrivate("isBusy") || force)) {
                    scrollbarX.setRaw("start", start);
                    scrollbarX.setRaw("end", end);
                    scrollbarX.updateGrips();
                }
            }
        } else if (this.yAxes.indexOf(axis) != -1) {
            if (force || axis.getPrivate("updateScrollbar")) {
                let scrollbarY = this.get("scrollbarY");
                if (scrollbarY && (!scrollbarY.getPrivate("isBusy") || force)) {
                    scrollbarY.setRaw("start", start);
                    scrollbarY.setRaw("end", end);
                    scrollbarY.updateGrips();
                }
            }
        }
        this._handleZoomOut();
    }
    _handleZoomOut() {
        let zoomOutButton = this.zoomOutButton;
        if (zoomOutButton && zoomOutButton.parent) {
            let visible = false;
            this.xAxes.each((axis)=>{
                if (axis.get("zoomOut", true) && !axis._isSynced()) {
                    if ($f43e9e04b3f0548b$export$2077e0241d6afd3c(axis.get("start", 0), 5) != 0 || $f43e9e04b3f0548b$export$2077e0241d6afd3c(axis.get("end", 1), 5) != 1) visible = true;
                }
            });
            this.yAxes.each((axis)=>{
                if (axis.get("zoomOut", true) && !axis._isSynced()) {
                    if ($f43e9e04b3f0548b$export$2077e0241d6afd3c(axis.get("start", 0), 5) != 0 || $f43e9e04b3f0548b$export$2077e0241d6afd3c(axis.get("end", 1), 5) != 1) visible = true;
                }
            });
            if (visible) {
                if (zoomOutButton.isHidden()) zoomOutButton.show();
            } else zoomOutButton.hide();
        }
    }
    /**
     * Checks if point is within plot area.
     *
     * @param   point  Reference point
     * @return         Is within plot area?
     */ inPlot(point) {
        const plotContainer = this.plotContainer;
        const otherCharts = this.getPrivate("otherCharts", this._otherCharts);
        const global = plotContainer.toGlobal(point);
        if (point.x >= -0.5 && point.y >= -0.5 && point.x <= plotContainer.width() + 0.5 && point.y <= plotContainer.height() + 0.5) return true;
        if (otherCharts) for(let i = otherCharts.length - 1; i >= 0; i--){
            const chart = otherCharts[i];
            if (chart != this) {
                const chartPlotContainer = chart.plotContainer;
                const documentPoint = this._root.rootPointToDocument(global);
                const chartRoot = chart._root.documentPointToRoot(documentPoint);
                const local = chartPlotContainer.toLocal(chartRoot);
                if (local.x >= -0.1 && local.y >= -0.1 && local.x <= chartPlotContainer.width() + 0.1 && local.y <= chartPlotContainer.height() + 0.1) return true;
            }
        }
        return false;
    }
    /**
     * @ignore
     */ arrangeTooltips() {
        const plotContainer = this.plotContainer;
        const w = plotContainer.width();
        const h = plotContainer.height();
        let hh = this.height();
        const bounds = this._root.tooltipContainer.get("layerMargin");
        if (bounds) {
            if (bounds.bottom > hh) hh = bounds.bottom;
        }
        let plotT = plotContainer._display.toGlobal({
            x: 0,
            y: 0
        });
        let plotB = plotContainer._display.toGlobal({
            x: w,
            y: h
        });
        const tooltips = [];
        let sum = 0;
        let minDistance = Infinity;
        let movePoint = this._movePoint;
        let maxTooltipDistance = this.get("maxTooltipDistance");
        let maxTooltipDistanceBy = this.get("maxTooltipDistanceBy", "xy");
        let closest;
        let closestPoint;
        if ($f63bdea45a89cf24$export$7e4aa119212bc614(maxTooltipDistance)) this.series.each((series)=>{
            if (!series.isHidden()) {
                const tooltip = series.get("tooltip");
                if (tooltip) {
                    let point = tooltip.get("pointTo");
                    if (point) {
                        let distance = Math.hypot(movePoint.x - point.x, movePoint.y - point.y);
                        if (maxTooltipDistanceBy == "x") distance = Math.abs(movePoint.x - point.x);
                        else if (maxTooltipDistanceBy == "y") distance = Math.abs(movePoint.y - point.y);
                        if (distance < minDistance) {
                            minDistance = distance;
                            closest = series;
                            closestPoint = point;
                        }
                    }
                }
            }
        });
        const tooltipSeries = [];
        this.series.each((series)=>{
            const tooltip = series.get("tooltip");
            if (tooltip && !tooltip.get("forceHidden")) {
                let hidden = false;
                let point = tooltip.get("pointTo");
                if (point) {
                    if (maxTooltipDistance >= 0) {
                        let point = tooltip.get("pointTo");
                        if (point && closestPoint) {
                            if (series != closest) {
                                let distance = Math.hypot(closestPoint.x - point.x, closestPoint.y - point.y);
                                if (maxTooltipDistanceBy == "x") distance = Math.abs(closestPoint.x - point.x);
                                else if (maxTooltipDistanceBy == "y") distance = Math.abs(closestPoint.y - point.y);
                                if (distance > maxTooltipDistance) hidden = true;
                            }
                        }
                    } else if (maxTooltipDistance == -1) {
                        if (series != closest) hidden = true;
                    }
                    if (!this.inPlot(this._tooltipToLocal(point)) || !tooltip.dataItem) hidden = true;
                    else if (!hidden) sum += point.y;
                    if (hidden || series.isHidden() || series.isHiding()) tooltip.hide(0);
                    else {
                        tooltip.show();
                        tooltips.push(tooltip);
                        tooltipSeries.push(series);
                    }
                }
            }
        });
        this.setPrivate("tooltipSeries", tooltipSeries);
        if (this.get("arrangeTooltips")) {
            let totalTooltipH = 0;
            let tooltipCount = 0;
            const tooltipContainer = this._root.tooltipContainer;
            const count = tooltips.length;
            const average = sum / count;
            if (average > h / 2 + plotT.y) {
                tooltips.sort((a, b)=>$919e90129af4490b$export$608e63ca0eb1cfcc(b.get("pointTo").y, a.get("pointTo").y));
                let prevY = plotB.y;
                $2f30431acd054e2f$export$79b2f7037acddd43(tooltips, (tooltip)=>{
                    let height = tooltip.height();
                    tooltipCount++;
                    totalTooltipH += height;
                    let centerY = tooltip.get("centerY");
                    if (centerY instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) height *= centerY.value;
                    height += tooltip.get("marginBottom", 0);
                    tooltip.set("bounds", {
                        left: plotT.x,
                        top: plotT.y,
                        right: plotB.x,
                        bottom: prevY
                    });
                    tooltip.setPrivate("customData", {
                        left: plotT.x,
                        top: plotT.y,
                        right: plotB.x,
                        bottom: prevY
                    });
                    prevY = Math.min(prevY - height, tooltip._fy - height);
                    if (tooltip.parent == tooltipContainer) tooltipContainer.children.moveValue(tooltip, 0);
                });
                if (prevY < 0) {
                    tooltips.reverse();
                    let prevBottom = prevY;
                    $2f30431acd054e2f$export$79b2f7037acddd43(tooltips, (tooltip)=>{
                        tooltipCount++;
                        let bounds = tooltip.get("bounds");
                        if (bounds) {
                            let top = bounds.top - prevY;
                            let bottom = bounds.bottom - prevY;
                            if (top < prevBottom) {
                                top = prevBottom;
                                bottom = top + tooltip.height();
                            }
                            tooltip.set("bounds", {
                                left: bounds.left,
                                top: top,
                                right: bounds.right,
                                bottom: bottom
                            });
                            prevBottom = bounds.bottom - prevY + tooltip.get("marginBottom", 0);
                        }
                    });
                }
            } else {
                tooltips.reverse();
                tooltips.sort((a, b)=>$919e90129af4490b$export$608e63ca0eb1cfcc(a.get("pointTo").y, b.get("pointTo").y));
                let prevY = 0;
                $2f30431acd054e2f$export$79b2f7037acddd43(tooltips, (tooltip)=>{
                    tooltipCount++;
                    let height = tooltip.height();
                    totalTooltipH += height;
                    let centerY = tooltip.get("centerY");
                    if (centerY instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) height *= centerY.value;
                    height += tooltip.get("marginBottom", 0);
                    tooltip.set("bounds", {
                        left: plotT.x,
                        top: prevY,
                        right: plotB.x,
                        bottom: Math.max(plotT.y + hh, prevY + height)
                    });
                    if (tooltip.parent == tooltipContainer) tooltipContainer.children.moveValue(tooltip, 0);
                    prevY = Math.max(prevY + height, tooltip._fy + height);
                });
                if (prevY > hh) {
                    tooltips.reverse();
                    let prevBottom = hh;
                    $2f30431acd054e2f$export$79b2f7037acddd43(tooltips, (tooltip)=>{
                        tooltipCount++;
                        let bounds = tooltip.get("bounds");
                        if (bounds) {
                            let top = bounds.top - (hh - prevY);
                            let bottom = bounds.bottom - (hh - prevY);
                            if (bottom > prevBottom) {
                                bottom = prevBottom;
                                top = bottom - tooltip.height();
                            }
                            tooltip.set("bounds", {
                                left: bounds.left,
                                top: top,
                                right: bounds.right,
                                bottom: bottom
                            });
                            prevBottom = bottom - tooltip.height() - tooltip.get("marginBottom", 0);
                        }
                    });
                }
            }
            if (totalTooltipH == 0 && tooltipCount > 0) this._disposers.push(this.root.events.once("frameended", ()=>{
                this.arrangeTooltips();
            }));
        }
    }
    _tooltipToLocal(point) {
        return this.plotContainer.toLocal(point);
    }
    /**
     * Fully zooms out the chart.
     */ zoomOut() {
        this.xAxes.each((axis)=>{
            if (axis.get("zoomOut", true) && !axis._isSynced()) {
                axis.setPrivate("updateScrollbar", true);
                axis.zoom(0, 1);
            }
        });
        this.yAxes.each((axis)=>{
            if (axis.get("zoomOut", true) && !axis._isSynced()) {
                axis.setPrivate("updateScrollbar", true);
                axis.zoom(0, 1);
            }
        });
    }
    _dispose() {
        super._dispose();
        // Explicitly disposing cursor to avoid memory leak of cursor adding
        // keyboard events after parent chart has been disposed
        const cursor = this.get("cursor");
        if (cursor) cursor.dispose();
    }
}
$f33aa5eed78e4f07$export$64cf36d276346559.className = "XYChart";
$f33aa5eed78e4f07$export$64cf36d276346559.classNames = (0, $1c8dfb8f6e7d32bb$export$8a5e8f3f92395502).classNames.concat([
    $f33aa5eed78e4f07$export$64cf36d276346559.className
]);








class $fbb6fde45272a972$export$24a912b4d2f9c840 extends (0, $f33aa5eed78e4f07$export$64cf36d276346559) {
    constructor(){
        super(...arguments);
        /**
         * [[Container]] where radar-related elements go.
         *
         * @default Container.new()
         */ this.radarContainer = this.plotContainer.children.push((0, $5de502da8a72d65e$export$42a852a2b6b56249).new(this._root, {
            x: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72),
            y: (0, $bd0d0c10fd30006b$export$888d047b0ce6de72)
        }));
        this._arcGenerator = (0, $b196a0c5210e8c70$export$2e2bcd8739ae039)();
        this._maxRadius = 1;
    }
    _afterNew() {
        this._defaultThemes.push((0, $d278d8c41fa854a5$export$a03e00c38b25f181).new(this._root));
        super._afterNew();
        const radarContainer = this.radarContainer;
        const gridContainer = this.gridContainer;
        const topGridContainer = this.topGridContainer;
        const seriesContainer = this.seriesContainer;
        const bulletsContainer = this.bulletsContainer;
        radarContainer.children.pushAll([
            gridContainer,
            seriesContainer,
            topGridContainer,
            bulletsContainer
        ]);
        seriesContainer.set("mask", (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).new(this._root, {}));
        gridContainer.set("mask", (0, $2ffdafbe1fe6a946$export$29d3e417456abdad).new(this._root, {}));
        this._disposers.push(this.plotContainer.events.on("boundschanged", ()=>{
            this._updateRadius();
        }));
    }
    _maskGrid() {}
    _prepareChildren() {
        super._prepareChildren();
        if (this._sizeDirty || this.isDirty("radius") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("endAngle")) {
            const chartContainer = this.chartContainer;
            const w = chartContainer.innerWidth();
            const h = chartContainer.innerHeight();
            const startAngle = this.get("startAngle", 0);
            const endAngle = this.get("endAngle", 0);
            const innerRadius = this.get("innerRadius");
            let bounds = $f43e9e04b3f0548b$export$87d7822d7a31793f(0, 0, startAngle, endAngle, 1);
            const wr = w / (bounds.right - bounds.left);
            const hr = h / (bounds.bottom - bounds.top);
            let innerBounds = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            };
            if (innerRadius instanceof (0, $bd0d0c10fd30006b$export$cbc348af47898b5e)) {
                let value = innerRadius.value;
                let mr = Math.min(wr, hr);
                value = Math.max(mr * value, mr - Math.min(h, w)) / mr;
                innerBounds = $f43e9e04b3f0548b$export$87d7822d7a31793f(0, 0, startAngle, endAngle, value);
                this.setPrivateRaw("irModifyer", value / innerRadius.value);
            }
            bounds = $f43e9e04b3f0548b$export$579a8a269cc78035([
                bounds,
                innerBounds
            ]);
            this._maxRadius = Math.max(0, Math.min(wr, hr));
            const radius = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("radius", 0), this._maxRadius);
            this.radarContainer.setAll({
                dy: -radius * (bounds.bottom + bounds.top) / 2,
                dx: -radius * (bounds.right + bounds.left) / 2
            });
            this._updateRadius();
        }
    }
    _addCursor(cursor) {
        this.radarContainer.children.push(cursor);
    }
    // do not delete
    _updateRadius() {
        const radius = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("radius", (0, $bd0d0c10fd30006b$export$626336c2cd4b14de)(80)), this._maxRadius);
        this.setPrivateRaw("radius", radius);
        let innerRadius = $05b1b40b69b15016$export$302dfacf2b0a56fe(this.get("innerRadius", 0), radius);
        if (innerRadius < 0) innerRadius = radius + innerRadius;
        this.setPrivateRaw("innerRadius", innerRadius);
        this.xAxes.each((axis)=>{
            const renderer = axis.get("renderer");
            renderer.updateLayout();
        });
        this.yAxes.each((axis)=>{
            const renderer = axis.get("renderer");
            renderer.updateLayout();
        });
        this._updateMask(this.seriesContainer, innerRadius, radius);
        this._updateMask(this.gridContainer, innerRadius, radius);
        this.series.each((series)=>{
            if (series.get("maskBullets")) this._updateMask(series.bulletsContainer, innerRadius, radius);
            else series.bulletsContainer.remove("mask");
        });
        const cursor = this.get("cursor");
        if (cursor) cursor.updateLayout();
    }
    /**
     * @ignore
     */ _updateMask(container, innerRadius, radius) {
        const mask = container.get("mask");
        if (mask) mask.set("draw", (display)=>{
            this._arcGenerator.context(display);
            this._arcGenerator({
                innerRadius: innerRadius,
                outerRadius: radius + .5,
                startAngle: (this.get("startAngle", 0) + 90) * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a,
                endAngle: (this.get("endAngle", 0) + 90) * $f43e9e04b3f0548b$export$fd1bf64c4a4ea04a
            });
        });
    }
    /**
     * @ignore
     */ processAxis(axis) {
        this.radarContainer.children.push(axis);
    }
    _processSeries(series) {
        super._processSeries(series);
        this._updateRadius();
    }
    /**
     * @ignore
     */ inPlot(point, radius, innerRadius) {
        const r = Math.hypot(point.x, point.y);
        const angle = $f43e9e04b3f0548b$export$e3df76cf4464bc81(Math.atan2(point.y, point.x) * $f43e9e04b3f0548b$export$e035ae0f6b8ef5d);
        let startAngle = $f43e9e04b3f0548b$export$e3df76cf4464bc81(this.get("startAngle", 0));
        let endAngle = $f43e9e04b3f0548b$export$e3df76cf4464bc81(this.get("endAngle", 0));
        let inArc = false;
        if (startAngle < endAngle) {
            if (startAngle < angle && angle < endAngle) inArc = true;
        }
        if (startAngle > endAngle) {
            if (angle > startAngle) inArc = true;
            if (angle < endAngle) inArc = true;
        }
        if (startAngle == endAngle) inArc = true;
        if (!inArc) return false;
        if (radius == null) radius = this.getPrivate("radius", 0);
        if (innerRadius == null) innerRadius = this.getPrivate("innerRadius", 0);
        if (innerRadius > radius) [innerRadius, radius] = [
            radius,
            innerRadius
        ];
        if (r <= radius + .5 && r >= innerRadius - .5) return true;
        return false;
    }
    _tooltipToLocal(point) {
        return this.radarContainer._display.toLocal(point);
    }
    _handlePinch() {}
}
$fbb6fde45272a972$export$24a912b4d2f9c840.className = "RadarChart";
$fbb6fde45272a972$export$24a912b4d2f9c840.classNames = (0, $f33aa5eed78e4f07$export$64cf36d276346559).classNames.concat([
    $fbb6fde45272a972$export$24a912b4d2f9c840.className
]);



class $494ee18a07f9d214$export$5711c0e6e21f0015 extends (0, $a953e95d35d4141a$export$14faa19a0f3bbeb2) {
    setupDefaultRules() {
        super.setupDefaultRules();
        this.rule("Component").setAll({
            interpolationDuration: 600
        });
        this.rule("Hierarchy").set("animationDuration", 600);
        this.rule("Scrollbar").set("animationDuration", 600);
        this.rule("Tooltip").set("animationDuration", 300);
        this.rule("MapChart").set("animationDuration", 1000);
        this.rule("MapChart").set("wheelDuration", 300);
        this.rule("Entity").setAll({
            stateAnimationDuration: 600
        });
        this.rule("Sprite").states.create("default", {
            stateAnimationDuration: 600
        });
        this.rule("Tooltip", [
            "axis"
        ]).setAll({
            animationDuration: 200
        });
        this.rule("WordCloud").set("animationDuration", 500);
        this.rule("Polygon").set("animationDuration", 600);
        this.rule("ArcDiagram").set("animationDuration", 600);
    }
}


var $9d25110d47889dc5$export$2e2bcd8739ae039 = (0, $494ee18a07f9d214$export$5711c0e6e21f0015);


function $3586cc5121635bf3$export$2e2bcd8739ae039({ value: value = 50, width: width = "100%", height: height = 180 }) {
    const chartRef = (0, $acw62.useRef)(null);
    const axisItemRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const root = $7803fe0a06c1ef65$export$be92b6f5f03c0fe9.new(chartRef.current);
        root._logo?.dispose();
        root.setThemes([
            (0, $9d25110d47889dc5$export$2e2bcd8739ae039).new(root)
        ]);
        // -----------------------
        // Chart
        // -----------------------
        const chart = root.container.children.push($fbb6fde45272a972$export$24a912b4d2f9c840.new(root, {
            startAngle: 180,
            endAngle: 360,
            panX: false,
            panY: false
        }));
        //  allow needle to escape masking
        chart.set("maskBullets", false);
        // ensure needle renders above arc
        chart.bulletsContainer.set("layer", 20);
        // Axis Renderer (ARC)
        const axisRenderer = $16b0ca8bc17cd5c1$export$18bab3c2540b790a.new(root, {
            innerRadius: $bd0d0c10fd30006b$export$626336c2cd4b14de(78),
            strokeWidth: 60,
            strokeOpacity: 1,
            minGridDistance: 17,
            strokeGradient: $228fee2a29e47fc5$export$39a41c7169757633.new(root, {
                rotation: 0,
                stops: [
                    {
                        offset: 0.0,
                        color: $389de129b6cd18b1$export$35e9368ef982300f(0xe53935)
                    },
                    {
                        offset: 0.3,
                        color: $389de129b6cd18b1$export$35e9368ef982300f(0xe53935)
                    },
                    {
                        offset: 0.4,
                        color: $389de129b6cd18b1$export$35e9368ef982300f(0xe53935)
                    },
                    {
                        offset: 0.55,
                        color: $389de129b6cd18b1$export$35e9368ef982300f(0xfb8c00)
                    },
                    {
                        offset: 0.8,
                        color: $389de129b6cd18b1$export$35e9368ef982300f(0xfb8c00)
                    },
                    {
                        offset: 1.0,
                        color: $389de129b6cd18b1$export$35e9368ef982300f(0x43a047)
                    }
                ]
            })
        });
        // remove inner ticks & grid lines
        axisRenderer.ticks.template.setAll({
            visible: false
        });
        axisRenderer.grid.template.setAll({
            visible: false
        });
        axisRenderer.labels.template.setAll({
            fontSize: 10,
            fontWeight: "700",
            radius: 17,
            fill: $389de129b6cd18b1$export$35e9368ef982300f(0x000000)
        });
        // Axis
        const xAxis = chart.xAxes.push($382dcb8802c42596$export$aa40340ad42cdd20.new(root, {
            min: 0,
            max: 100,
            strictMinMax: true,
            renderer: axisRenderer
        }));
        const allowedValues = [
            0,
            20,
            40,
            60,
            80,
            100
        ];
        const valueLabels = {
            0: "        Poor",
            20: "",
            40: "Bad ",
            60: "Average",
            80: "Good",
            100: "Excellent"
        };
        axisRenderer.labels.template.adapters.add("text", (_, target)=>{
            const v = target.dataItem?.get("value");
            return allowedValues.includes(v) ? valueLabels[v] : "";
        });
        axisRenderer.labels.template.adapters.add("rotation", (rotation, target)=>{
            const v = target.dataItem?.get("value");
            return v === 40 ? -22 : rotation;
        });
        axisRenderer.labels.template.adapters.add("rotation", (rotation, target)=>{
            const v = target.dataItem?.get("value");
            return v === 60 ? -18 : rotation;
        });
        axisRenderer.labels.template.adapters.add("rotation", (rotation, target)=>{
            const v = target.dataItem?.get("value");
            return v === 80 ? -15 : rotation;
        });
        axisRenderer.labels.template.adapters.add("rotation", (rotation, target)=>{
            const v = target.dataItem?.get("value");
            return v === 100 ? -10.8 : rotation;
        });
        // Clock Hand (NEEDLE)
        const clockHand = $4149193acbdcf042$export$6f10372297739289.new(root, {
            radius: $bd0d0c10fd30006b$export$626336c2cd4b14de(110),
            // NORMAL length (not extended)
            topWidth: 0.1,
            bottomWidth: 8,
            pinRadius: 7
        });
        // Needle colors (use your existing ones if already defined)
        const NEEDLE_FILL = $389de129b6cd18b1$export$35e9368ef982300f(0x2B2B2B); // soft black
        const NEEDLE_BORDER = $389de129b6cd18b1$export$35e9368ef982300f(0x000000); // darker border
        // Small triangle at the needle tip
        const tipTriangle = $0fc741c57fd16af1$export$5a465592bfe74b48.new(root, {
            width: 8,
            height: 8,
            fill: NEEDLE_FILL,
            stroke: NEEDLE_BORDER,
            strokeWidth: 1,
            centerX: $bd0d0c10fd30006b$export$626336c2cd4b14de(50),
            centerY: $bd0d0c10fd30006b$export$626336c2cd4b14de(100),
            dy: -5
        });
        // pink needle
        clockHand.hand.setAll({
            fill: NEEDLE_FILL,
            stroke: NEEDLE_BORDER,
            //  border color
            strokeWidth: 2,
            //  border thickness
            shadowColor: NEEDLE_BORDER
        });
        // center pin
        clockHand.pin.setAll({
            fill: NEEDLE_FILL,
            stroke: NEEDLE_BORDER,
            strokeWidth: 0.8
        });
        const axisDataItem = xAxis.makeDataItem({});
        axisDataItem.set("value", 0);
        axisDataItem.set("bullet", $1194f786ec2822b3$export$21e43085bc6b0522.new(root, {
            sprite: clockHand
        }));
        xAxis.createAxisRange(axisDataItem);
        axisDataItem.get("grid").set("visible", false);
        axisItemRef.current = axisDataItem;
        root.events.once("frameended", ()=>{
            chart.bulletsContainer.children.moveValue(clockHand, chart.bulletsContainer.children.length - 1);
        });
        axisDataItem.animate({
            key: "value",
            to: value,
            duration: 900,
            easing: $b4231ef84a5f8a61$exports.out($b4231ef84a5f8a61$exports.cubic)
        });
        chart.appear(600, 100);
        return ()=>root.dispose();
    }, []);
    // Update animation
    (0, $acw62.useEffect)(()=>{
        if (axisItemRef.current) axisItemRef.current.animate({
            key: "value",
            to: value,
            duration: 700,
            easing: $b4231ef84a5f8a61$exports.out($b4231ef84a5f8a61$exports.cubic)
        });
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: width,
            height: height
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: chartRef,
            style: {
                width: "100%",
                height: "100%"
            }
        })
    });
}



// const GREEN = 'rgba(1, 224, 16, 1)';
// const GREEN_FADE = 'rgba(1, 224, 16, 0.2)';
// const RED = 'rgba(211, 47, 47, 1)';
// const RED_FADE = 'rgba(211, 47, 47, 0.2)';
// const YELLOW = 'rgba(255, 235, 59, 1)';
// const YELLOW_FADE = 'rgba(255, 235, 59, 0.2)';
// const ORANGE = 'rgba(255, 152, 0, 1)';
// const ORANGE_FADE = 'rgba(255, 152, 0, 0.2)';
const $c3756055f1448610$var$GREEN = '#2e7d32';
const $c3756055f1448610$var$GREEN_FADE = '#2e7d32';
const $c3756055f1448610$var$RED = '#d32f2f';
const $c3756055f1448610$var$RED_FADE = '#d32f2f';
const $c3756055f1448610$var$YELLOW = '#f9a825';
const $c3756055f1448610$var$YELLOW_FADE = '#f9a825';
const $c3756055f1448610$var$ORANGE = '#fb8c00';
const $c3756055f1448610$var$ORANGE_FADE = '#fb8c00';
function $c3756055f1448610$var$getScoreColor(score) {
    if (typeof score !== "number") return "#d32f2f";
    if (score >= 90) return $c3756055f1448610$var$GREEN; // green
    if (score >= 80) return $c3756055f1448610$var$YELLOW; // yellow
    if (score >= 60) return $c3756055f1448610$var$ORANGE; // orange
    return $c3756055f1448610$var$RED; // red
}
function $c3756055f1448610$export$2e2bcd8739ae039({ ai_summary: ai_summary, summary: summary, framework_summary: framework_summary, vulnerabilities: vulnerabilities, waf_detected: waf_detected, scrollPage: scrollPage, sub_domains_count: sub_domains_count }) {
    // Backend payload expected at: state.scanResult.data
    const data = summary || {};
    const [aiInsightsOpen, setAiInsightsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [drawerOpen, setDrawerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // If backend not integrated yet (empty data), fall back to mock data so the UI shows example content.
    const hasBackendData = data && Object.keys(data).length > 0;
    const mockData = (0, $acw62.useMemo)(()=>({
            security_posture_score: 90,
            target_domain: 'demo.com',
            scan_completed_at: 'Oct 1, 2025 8:00 AM',
            vulnerabilities: [
                {
                    title: 'SQL injection',
                    severity: 'high',
                    description: 'Hackers can steal, change, or delete data, and in some cases take control of the backend database.',
                    instances: 1
                },
                {
                    title: 'Content Security Policy header not set',
                    severity: 'medium',
                    description: 'CSP header missing',
                    instances: 12
                },
                {
                    title: 'Cross-domain misconfiguration',
                    severity: 'medium',
                    description: '',
                    instances: 7
                },
                {
                    title: 'Missing Anti-clickjacking header',
                    severity: 'medium',
                    description: '',
                    instances: 3
                },
                {
                    title: 'Session ID in URL rewrite',
                    severity: 'medium',
                    description: '',
                    instances: 2
                },
                {
                    title: 'Vulnerable JS library',
                    severity: 'low',
                    description: '',
                    instances: 1
                }
            ]
        }), []);
    const effectiveData = hasBackendData ? data : mockData;
    const score = typeof effectiveData.security_posture_score === "number" ? effectiveData.security_posture_score : typeof effectiveData.score === "number" ? effectiveData.score : null;
    const targetDomain = effectiveData.target_domain || effectiveData.domain || effectiveData.host || "";
    const completedOn = effectiveData.scan_completed_at || effectiveData.scanned_at || effectiveData.scan_completed_at || "";
    const vulnerabilities_detected = effectiveData?.vulnerabilities_detected || null;
    const scoreColor = $c3756055f1448610$var$getScoreColor(score ?? -1);
    // compute proportional bar width based on score (0-100)
    const maxBarWidth = 300; // px for score == 100
    const safeScore = typeof score === 'number' && !Number.isNaN(score) ? Math.max(0, Math.min(100, score)) : 0;
    const barWidth = Math.round(safeScore / 100 * maxBarWidth);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                container: true,
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 1,
                        item: true,
                        xs: 12,
                        md: 3,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 130,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            container: true,
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                    xs: 11,
                                                    item: true,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "subtitle1",
                                                        sx: {
                                                            fontWeight: 560
                                                        },
                                                        children: "Overall Application Security Health"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                    xs: 1,
                                                    item: true,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "subtitle1",
                                                        sx: {
                                                            fontWeight: 560
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                mt: 3.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3586cc5121635bf3$export$2e2bcd8739ae039), {
                                                    value: safeScore,
                                                    width: 280,
                                                    height: 150
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        mt: 1
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "h3",
                                                        sx: {
                                                            fontWeight: 600,
                                                            lineHeight: 1
                                                        },
                                                        children: (()=>{
                                                            if (typeof score === "number") {
                                                                if (score >= 100) return "Excellent";
                                                                if (score >= 75) return "Good";
                                                                if (score >= 50) return "Average";
                                                                if (score >= 25) return "Bad";
                                                                return "Poor";
                                                            }
                                                            return "-";
                                                        })()
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        mt: 1
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 130
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                        container: true,
                                        alignItems: "center",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                xs: 11,
                                                item: true,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    variant: "subtitle1",
                                                    sx: {
                                                        fontWeight: 560
                                                    },
                                                    children: "Non-Compliance Risks"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                xs: 1,
                                                item: true,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    variant: "subtitle1",
                                                    sx: {
                                                        fontWeight: 560
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                md: 3,
                                                container: true,
                                                item: true,
                                                spacing: 2,
                                                alignContent: "center",
                                                justifyContent: "center",
                                                direction: "column",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                            bdsType: "interactiveSubtle",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                scrollPage(1, 'soc_2', summary?.compliance_scanner_map?.soc_2 || []);
                                                            },
                                                            sx: {
                                                                p: 0,
                                                                minWidth: 'auto',
                                                                width: '30px',
                                                                height: '30px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                variant: "h3",
                                                                sx: {
                                                                    fontWeight: 700,
                                                                    textAlign: 'center'
                                                                },
                                                                children: summary?.compliance_score?.soc_2 || 0
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            textAlign: 'center'
                                                        },
                                                        children: "SOC 2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                md: 3,
                                                container: true,
                                                item: true,
                                                spacing: 2,
                                                alignContent: "center",
                                                justifyContent: "center",
                                                direction: "column",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                            bdsType: "interactiveSubtle",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                scrollPage(1, 'gdpr', summary?.compliance_scanner_map?.gdpr || []);
                                                            },
                                                            sx: {
                                                                p: 0,
                                                                minWidth: 'auto',
                                                                width: '30px',
                                                                height: '30px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                variant: "h3",
                                                                sx: {
                                                                    fontWeight: 700,
                                                                    textAlign: 'center'
                                                                },
                                                                children: summary?.compliance_score?.gdpr || 0
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            textAlign: 'center'
                                                        },
                                                        children: "GDPR"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                md: 3,
                                                container: true,
                                                item: true,
                                                spacing: 2,
                                                alignContent: "center",
                                                justifyContent: "center",
                                                direction: "column",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                            bdsType: "interactiveSubtle",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                scrollPage(1, 'pci_dss', summary?.compliance_scanner_map?.pci_dss || []);
                                                            },
                                                            sx: {
                                                                p: 0,
                                                                minWidth: 'auto',
                                                                width: '30px',
                                                                height: '30px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                variant: "h3",
                                                                sx: {
                                                                    fontWeight: 700,
                                                                    textAlign: 'center'
                                                                },
                                                                children: summary?.compliance_score?.pci_dss || 0
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            textAlign: 'center'
                                                        },
                                                        children: "PCI DSS"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                md: 3,
                                                container: true,
                                                item: true,
                                                spacing: 2,
                                                alignContent: "center",
                                                justifyContent: "center",
                                                direction: "column",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                            bdsType: "interactiveSubtle",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                scrollPage(1, 'hipaa', summary?.compliance_scanner_map?.hipaa || []);
                                                            },
                                                            sx: {
                                                                p: 0,
                                                                minWidth: 'auto',
                                                                width: '30px',
                                                                height: '30px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                variant: "h3",
                                                                sx: {
                                                                    fontWeight: 700,
                                                                    textAlign: 'center'
                                                                },
                                                                children: summary?.compliance_score?.hipaa || 0
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        md: 12,
                                                        sx: {
                                                            textAlign: 'center'
                                                        },
                                                        children: "HIPAA"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 1,
                        item: true,
                        xs: 12,
                        md: 9,
                        style: {
                            height: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 5,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            item: true,
                                            md: 12,
                                            display: "flex",
                                            flexDirection: "column",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    variant: "subtitle1",
                                                    sx: {
                                                        fontWeight: 560
                                                    },
                                                    children: "Total Vulnerabilities"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    variant: "h1",
                                                    color: "text.primary",
                                                    sx: {
                                                        fontWeight: 500,
                                                        mt: 0.9,
                                                        ml: 3
                                                    },
                                                    children: vulnerabilities_detected !== null ? vulnerabilities_detected : '-'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                mb: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    variant: "subtitle1",
                                                    sx: {
                                                        fontWeight: 560
                                                    },
                                                    children: "Vulnerabilities by severity "
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                    bdsType: 'interactiveSubtle',
                                                    onClick: ()=>scrollPage(1),
                                                    children: "View all \u2193"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            container: true,
                                            sx: {
                                                mt: 1,
                                                textAlign: 'center'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12f35e2f8b869a3c$export$2e2bcd8739ae039), {
                                                chartData: {
                                                    datasets: [
                                                        {
                                                            label: 'Total Vulnerabilities:' + (vulnerabilities_detected !== null ? ` ${vulnerabilities_detected}` : ''),
                                                            data: [
                                                                effectiveData.vulnerabilities_by_severity?.[4] ?? 0,
                                                                // high
                                                                effectiveData.vulnerabilities_by_severity?.[3] ?? 0,
                                                                // medium
                                                                effectiveData.vulnerabilities_by_severity?.[2] ?? 0,
                                                                // low
                                                                effectiveData.vulnerabilities_by_severity?.[1] ?? 0 // info
                                                            ],
                                                            backgroundColor: [
                                                                '#1976d2',
                                                                '#1e88e5',
                                                                '#64b5f6',
                                                                '#90caf9'
                                                            ],
                                                            // Bar fill colors (design tokens)
                                                            borderColor: [
                                                                '#1976d2',
                                                                '#1e88e5',
                                                                '#64b5f6',
                                                                '#90caf9'
                                                            ],
                                                            // Bar border colors (design tokens)
                                                            borderWidth: .1,
                                                            barThickness: 40
                                                        }
                                                    ],
                                                    labels: [
                                                        'High',
                                                        'Medium',
                                                        'Low',
                                                        'Info'
                                                    ]
                                                },
                                                chartDimension: {
                                                    height: '230px',
                                                    width: '100%'
                                                },
                                                emptyState: {
                                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        "data-testid": "empty-state"
                                                    }),
                                                    text: 'Too full to eat anymore twix'
                                                },
                                                hasEntries: true,
                                                showFooter: false,
                                                showLegend: false,
                                                barChartOptions: {
                                                    plugins: {
                                                        tooltip: {
                                                            enabled: false
                                                        }
                                                    },
                                                    scales: {
                                                        x: {
                                                            grid: {
                                                                display: false,
                                                                // Removes vertical grid lines
                                                                drawOnChartArea: false // Removes grid lines only within the chart area
                                                            }
                                                        },
                                                        y: {
                                                            grid: {
                                                                display: false,
                                                                // Removes horizontal grid lines
                                                                drawOnChartArea: false // Removes grid lines only within the chart area
                                                            },
                                                            border: {
                                                                display: false // This hides the X-axis line
                                                            },
                                                            ticks: {
                                                                display: false // This hides the Y-axis labels
                                                            }
                                                        }
                                                    }
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            container: true,
                                            sx: {
                                                mt: 0.5,
                                                ml: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            display: 'inline-block',
                                                            padding: '2px 4px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            marginRight: '40px',
                                                            marginTop: '10px',
                                                            background: '#1976d2',
                                                            color: 'white'
                                                        },
                                                        children: [
                                                            "High: ",
                                                            summary?.vulnerabilities_by_severity?.[4]
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            display: 'inline-block',
                                                            padding: '2px 4px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            marginRight: '40px',
                                                            marginTop: '10px',
                                                            background: '#1e88e5',
                                                            color: 'white'
                                                        },
                                                        children: [
                                                            "Medium: ",
                                                            summary?.vulnerabilities_by_severity?.[3]
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            display: 'inline-block',
                                                            padding: '2px 4px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            marginRight: '40px',
                                                            marginTop: '10px',
                                                            background: '#64b5f6',
                                                            color: 'white'
                                                        },
                                                        children: [
                                                            "Low: ",
                                                            summary?.vulnerabilities_by_severity?.[2]
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            display: 'inline-block',
                                                            padding: '2px 4px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            marginRight: '40px',
                                                            marginTop: '10px',
                                                            background: '#90caf9',
                                                            color: 'white'
                                                        },
                                                        children: [
                                                            "Info: ",
                                                            summary?.vulnerabilities_by_severity?.[1]
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 7,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                mb: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    variant: "subtitle1",
                                                    sx: {
                                                        fontWeight: 560
                                                    },
                                                    children: "Top 5 risks "
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                    bdsType: 'interactiveSubtle',
                                                    onClick: ()=>scrollPage(1),
                                                    children: "View all \u2193"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1.1
                                            },
                                            children: vulnerabilities.slice(0, 5).map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    spacing: 0,
                                                    sx: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        py: 0.6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            md: 4,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                variant: "subtitle1",
                                                                noWrap: true,
                                                                children: t.attack_type_title || t.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            md: 4,
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                gap: 0.5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "body2",
                                                                    color: "text.secondary",
                                                                    children: [
                                                                        "Severity: ",
                                                                        (0, $adc573943ea4ef85$export$903fb3386f46d61e)(t.severity_level)
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76f12636665395c9$export$155bcd12491a11ee), {
                                                                    severity: t.severity_level
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            md: 4,
                                                            sx: {
                                                                display: 'flex',
                                                                justifyContent: 'flex-end'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                                bdsType: "interactiveSubtle",
                                                                onClick: ()=>{
                                                                    setSelected(t);
                                                                    setDrawerOpen(true);
                                                                },
                                                                children: "View details"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            md: 12,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }, i))
                                        }),
                                        vulnerabilities && vulnerabilities[0] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                mt: 1
                                            },
                                            style: {
                                                justifyContent: 'flex-start'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        fontWeight: 700
                                                    },
                                                    children: vulnerabilities[0].attack_type_title || vulnerabilities[0].name
                                                }),
                                                vulnerabilities[0].description ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        maxHeight: '40px',
                                                        overflowY: 'auto',
                                                        mt: 0.5,
                                                        pr: 1
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "body2",
                                                        color: "text.secondary",
                                                        children: vulnerabilities[0].description
                                                    })
                                                }) : null
                                            ]
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            (()=>{
                // Determine which Attack Surface items are present (excluding Sub Domains)
                const attackSurfaceItems = [
                    framework_summary?.web_server?.display_name,
                    framework_summary?.programming_languages?.display_name,
                    framework_summary?.web_framework?.display_name
                ].filter(Boolean);
                const onlySubdomain = !attackSurfaceItems.length && sub_domains_count !== undefined;
                // Set md values based on presence
                const attackSurfaceMd = onlySubdomain ? 3.5 : 5.4;
                const wafMd = onlySubdomain ? 8.5 : 6.6;
                // Build Attack Surface items array for rendering
                const attackSurfaceRenderItems = [
                    framework_summary?.web_server?.display_name && {
                        label: "Web Server",
                        value: framework_summary.web_server.display_name
                    },
                    framework_summary?.programming_languages?.display_name && {
                        label: "Programming Language",
                        value: framework_summary.programming_languages.display_name
                    },
                    framework_summary?.web_framework?.display_name && {
                        label: "Web Framework",
                        value: framework_summary.web_framework.display_name
                    },
                    sub_domains_count !== undefined && {
                        label: "Sub Domains",
                        value: sub_domains_count,
                        clickable: true
                    }
                ].filter(Boolean).slice(0, 4);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: attackSurfaceMd,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                sx: {
                                    p: 2,
                                    minHeight: 150
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        variant: "subtitle1",
                                        sx: {
                                            fontWeight: 560,
                                            mb: 1
                                        },
                                        children: "Attack Surface"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        children: attackSurfaceRenderItems.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                md: 6,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            variant: "body2",
                                                            color: "text.secondary",
                                                            children: [
                                                                item.label,
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                            bdsType: "interactiveSubtle",
                                                            sx: {
                                                                p: 1
                                                            },
                                                            onClick: item.clickable ? ()=>scrollPage(3) : undefined,
                                                            children: item.value
                                                        })
                                                    ]
                                                })
                                            }, index))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            md: wafMd,
                            children: waf_detected?.detected !== true ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                sx: {
                                    minHeight: 150,
                                    p: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        sx: {
                                            fontWeight: 600
                                        },
                                        children: "Attack exposure"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            mb: 1
                                        },
                                        children: [
                                            "There is ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "no Web Application Firewall"
                                            }),
                                            " detected on your domain and your web application is vulnerable to a wide range of common cyberattacks."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 0,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 2,
                                                md: 4,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        fontWeight: 700,
                                                        color: '#111'
                                                    },
                                                    children: " Bot attack"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 2,
                                                md: 4,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        fontWeight: 700,
                                                        color: '#111'
                                                    },
                                                    children: " DDoS attack"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 2,
                                                md: 4,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        fontWeight: 700,
                                                        color: '#111'
                                                    },
                                                    children: " SQL injection"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                sx: {
                                    minHeight: 150,
                                    p: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        sx: {
                                            fontWeight: 600
                                        },
                                        children: "WAF Detected"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            mb: 1
                                        },
                                        children: "A Web Application Firewall (WAF) has been detected on your domain. This helps protect your web application from common cyberattacks."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            gap: '40px',
                                            alignItems: 'center',
                                            flexWrap: 'nowrap',
                                            mt: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    gap: '8px',
                                                    alignItems: 'center',
                                                    flex: 1,
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            fontWeight: 700,
                                                            color: '#070606ff',
                                                            whiteSpace: 'nowrap'
                                                        },
                                                        children: "WAF Name:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        },
                                                        children: waf_detected?.firewall || "Unknown WAF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    gap: '8px',
                                                    alignItems: 'center',
                                                    flex: 1,
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            fontWeight: 700,
                                                            color: '#111',
                                                            whiteSpace: 'nowrap'
                                                        },
                                                        children: "Manufacturer:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        },
                                                        children: waf_detected?.manufacturer || "Unknown Manufacturer"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            })(),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d3990aef34273b6$export$2e2bcd8739ae039), {
                url: 'url',
                open: drawerOpen,
                selected: selected,
                onClose: ()=>{
                    setDrawerOpen(false);
                    setSelected(null);
                },
                isSafe: false
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

function $b972ba95501e1ea8$export$2e2bcd8739ae039({ target_domain: target_domain, scrollPage: scrollPage }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                children: "Summary"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Security posture score"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                sx: {
                                                    width: '80%',
                                                    fontWeight: 700,
                                                    lineHeight: 1
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                    variant: "text",
                                                    sx: {
                                                        fontSize: '1.5rem'
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                            sx: {
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                bdsType: 'interactiveSubtle',
                                                onClick: ()=>scrollPage(4),
                                                children: "How is this calculated?"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Vulnerabilities detected"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "h5",
                                            sx: {
                                                width: '80%',
                                                fontWeight: 700,
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                sx: {
                                                    fontSize: '1.5rem'
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 4,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Target domain"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "h5",
                                            sx: {
                                                width: '80%',
                                                fontWeight: 700,
                                                mt: 1
                                            },
                                            children: target_domain
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2,
                                        minHeight: 120
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: "Scan completed on"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                            variant: "h5",
                                            sx: {
                                                width: '80%',
                                                fontWeight: 700,
                                                mt: 1
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                sx: {
                                                    fontSize: '1.5rem'
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        sx: {
                                            p: 2,
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    mb: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "subtitle1",
                                                        sx: {
                                                            fontWeight: 560
                                                        },
                                                        children: "Vulnerabilities by severity"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                        bdsType: 'interactiveSubtle',
                                                        onClick: ()=>scrollPage(1),
                                                        children: "View all \u2193"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    flex: 1
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                container: true,
                                                sx: {
                                                    mt: 1,
                                                    height: '300px',
                                                    width: '100%',
                                                    textAlign: 'center'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                    variant: "rectangular",
                                                    width: '80%',
                                                    height: 250
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                container: true,
                                                sx: {
                                                    mt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#1976d2'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: high"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#1e88e5'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: medium"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#64b5f6'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: low"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 3,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        mt: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#bbdefb'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            sx: {
                                                                                fontWeight: 500
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                                variant: "circular",
                                                                                width: 25,
                                                                                height: 25
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "subtitle2",
                                                                    sx: {
                                                                        mt: 1,
                                                                        color: '#616161',
                                                                        fontWeight: 700
                                                                    },
                                                                    children: "Severity: info"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                                        sx: {
                                            p: 2,
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    mb: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "subtitle1",
                                                        sx: {
                                                            fontWeight: 560
                                                        },
                                                        children: "Top risks"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                        bdsType: 'interactiveSubtle',
                                                        onClick: ()=>scrollPage(1),
                                                        children: "View all \u2193"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    flex: 1,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 1
                                                },
                                                children: [
                                                    1,
                                                    2,
                                                    3,
                                                    4,
                                                    5
                                                ].map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            py: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                        variant: "text",
                                                                        width: 350,
                                                                        sx: {
                                                                            fontSize: '1rem'
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    textAlign: 'left',
                                                                    minWidth: 140,
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                                    variant: "body2",
                                                                    color: "text.secondary",
                                                                    sx: {
                                                                        textAlign: 'left'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                                        variant: "text",
                                                                        width: 100,
                                                                        sx: {
                                                                            fontSize: '1rem'
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }, i))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    mt: 2
                                                },
                                                style: {
                                                    justifyContent: 'flex-start'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            fontWeight: 700
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                            variant: "text",
                                                            width: 100,
                                                            sx: {
                                                                fontSize: '1rem'
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        variant: "body2",
                                                        color: "text.secondary",
                                                        sx: {
                                                            mt: 0.5
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                                            variant: "text",
                                                            width: 600,
                                                            sx: {
                                                                fontSize: '1rem'
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2fb79573d570c877$export$2e2bcd8739ae039), {
                            sx: {
                                p: 2,
                                backgroundColor: '#fafafa'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    sx: {
                                        fontWeight: 600,
                                        mb: 1
                                    },
                                    children: "Attack exposure"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        mb: 2
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23f48e995fd02484$export$2e2bcd8739ae039), {
                                        variant: "rectangular",
                                        width: '100%',
                                        height: 120
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



// src/scanresult/ScoreCalculation.js

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");








function $69a8fa9b6969fb52$export$2e2bcd8739ae039({ state: state }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "h5",
                gutterBottom: true,
                children: "Score calculation"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                paragraph: true,
                children: [
                    "When you initiate a scan, the Barracuda Website Vulnerability Scanner automatically runs a comprehensive set of vulnerability checks against your application. These checks are designed to detect common security weaknesses and misconfigurations by comparing your website's setup against industry best practices and standards.",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "   Each check is scored individually, and your application receives a numerical score based on the results. A higher score indicates stronger security and better alignment with recommended security actions."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "h6",
                gutterBottom: true,
                children: "Understanding your score"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "ul",
                sx: {
                    pl: 3,
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: "Passed checks contribute their full score."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: "Failed checks contribute zero."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: "The total score reflects the sum of all passed checks."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: "Security posture score = Total score / Sum of maximum possible scores for all checks"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "h6",
                gutterBottom: true,
                children: "Example scan result calculation"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                paragraph: true,
                children: "Let's say the scanner runs 5 checks, each assigned a maximum score based on its potential impact on your website's security"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                paragraph: true,
                color: "text.secondary",
                children: "Check 1 maximum score = 9 \xa0\xa0 Check 2 maximum score = 8 \xa0\xa0 Check 3 maximum score = 8 \xa0\xa0 Check 4 maximum score = 7 \xa0\xa0 Check 5 maximum score = 6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                    size: "small",
                    style: {
                        width: "50%",
                        marginRight: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Check"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Status"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Score"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Check 1"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Passed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Check 2"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Failed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Check 3"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Passed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "8"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Check 4"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Passed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Check 5"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Failed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "0"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                paragraph: true,
                children: [
                    "Total score = 9 + 0 + 8 + 7 + 0 = 24",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Maximum possible score = 9 + 8 + 8 + 7 + 6 = 38",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Security posture score = (24 / 38) x 100 = 63%"
                ]
            })
        ]
    });
}






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");







function $0bce5c0fad5cf29b$export$2e2bcd8739ae039({ state: state, vulnerabilities: vulnerabilities, url: url, title: title, subtitle: subtitle, isSafe: isSafe }) {
    const totalCount = vulnerabilities.length;
    // determine items per page from backend if provided, otherwise default to 10
    const backendPageSize = Number(state?.scanResult?.data?.page_size ?? state?.scanResult?.data?.per_page ?? state?.scanResult?.data?.pageSize ?? 10);
    const itemsPerPage = Number.isFinite(backendPageSize) && backendPageSize > 0 ? backendPageSize : 10;
    const totalPages = Math.max(1, Math.ceil(totalCount / itemsPerPage));
    const [page, setPage] = (0, $acw62.useState)(1);
    const [drawerOpen, setDrawerOpen] = (0, $acw62.useState)(false);
    const [selected, setSelected] = (0, $acw62.useState)(null);
    const allowedNames = [
        "Internet Address Records",
        "Hidden Site Discovery",
        "Address Signing Check",
        "Website History Check",
        "Server Location Check"
    ];
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalCount);
    const pageItems = vulnerabilities.slice(startIndex, endIndex);
    function goto(pageNum) {
        const p = Math.max(1, Math.min(totalPages, pageNum));
        setPage(p);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "h5",
                gutterBottom: true,
                children: [
                    title,
                    " (",
                    totalCount,
                    ")"
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                variant: "promoCaptionSubtle",
                gutterBottom: true,
                children: subtitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            mt: 2
                        },
                        children: pageItems.map((v, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                    container: true,
                                    alignItems: "center",
                                    sx: {
                                        position: 'relative',
                                        boxShadow: 0,
                                        borderRadius: 2,
                                        mb: 1,
                                        transition: 'box-shadow 0.2s, border-left-color 0.2s'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 7,
                                            sx: {
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    px: 1,
                                                    py: 0.5,
                                                    borderRadius: 2,
                                                    // bgcolor: isSafe ? '#e8f5e9' : '#ffebee',
                                                    color: isSafe ? '#2e7d32' : '#d32f2f',
                                                    fontWeight: 700,
                                                    fontSize: '0.9rem',
                                                    gap: 1
                                                },
                                                children: [
                                                    isSafe ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            px: 1.2,
                                                            py: 0.4,
                                                            borderRadius: '10px',
                                                            background: 'linear-gradient(180deg, #e8f5e9 0%, #d7efe0 100%)',
                                                            color: '#2e7d32',
                                                            fontWeight: 600,
                                                            fontSize: '0.8rem',
                                                            gap: 0.5,
                                                            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                                                            border: '1px solid rgba(46,125,50,0.15)'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b85022af20cb34ec$exports))), {
                                                                sx: {
                                                                    fontSize: 14
                                                                }
                                                            }),
                                                            "Safe"
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            px: 1.2,
                                                            py: 0.4,
                                                            borderRadius: '10px',
                                                            background: 'linear-gradient(90deg, #ffebee 60%)',
                                                            color: '#d32f2f',
                                                            fontWeight: 600,
                                                            fontSize: '0.8rem',
                                                            gap: 0.5,
                                                            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                                                            border: '1px solid rgba(46,125,50,0.15)'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9413ea81395edf96$exports))), {
                                                                sx: {
                                                                    fontSize: 18
                                                                }
                                                            }),
                                                            "Risk"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            fontWeight: 600
                                                        },
                                                        children: v?.attack_type_title || v?.name
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 2,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 0.5,
                                                    width: '100%'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            width: '90%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                                            variant: "body2",
                                                            sx: {
                                                                fontWeight: 600
                                                            },
                                                            children: [
                                                                "Severity: ",
                                                                String((0, $adc573943ea4ef85$export$903fb3386f46d61e)(v.severity_level) ?? '').toLowerCase()
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76f12636665395c9$export$155bcd12491a11ee), {
                                                        severity: v.severity_level,
                                                        isSafe: isSafe
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 3,
                                            sx: {
                                                textAlign: 'right'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                                bdsType: "interactiveSubtle",
                                                onClick: ()=>{
                                                    setSelected(v);
                                                    setDrawerOpen(true);
                                                },
                                                children: "View details"
                                            })
                                        })
                                    ]
                                })
                            }, v.id ?? `${v.title}-${startIndex + idx}`))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f23ee38ba9fa7638$export$2e2bcd8739ae039), {
                                itemsPerPage: itemsPerPage,
                                itemsPerPageDescription: "items per page",
                                // itemsPerPageOptions={[
                                //   10,
                                //   20,
                                //   50
                                // ]}
                                onChange: (e, p)=>goto(p),
                                onClickItemsPerPage: function noRefCheck() {},
                                onClickItemsPerPageOption: function noRefCheck() {},
                                onCloseItemsPerPage: function noRefCheck() {},
                                page: page,
                                totalItems: totalCount
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d3990aef34273b6$export$2e2bcd8739ae039), {
                        url: url,
                        open: drawerOpen,
                        selected: selected,
                        onClose: ()=>{
                            setDrawerOpen(false);
                            setSelected(null);
                        },
                        isSafe: isSafe
                    })
                ]
            })
        ]
    });
}





function $5cc98ed63bfbab01$export$2e2bcd8739ae039() {
    const { state: state } = (0, $2ad2279805e583d1$export$6ccbb43953eebf8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { uuid: uuid } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [snackbarOpen, setSnackbarOpen] = (0, $acw62.useState)(false);
    const [tabIndex, setTabIndex] = (0, $acw62.useState)(0);
    const [scanResult, setScanResult] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [scanStatus, setScanStatus] = (0, $acw62.useState)('in_progress');
    const [complianceFilter, setComplianceFilter] = (0, $acw62.useState)(null);
    // Refs for each section and scrollable area
    const summaryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const vulnerabilitiesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const secureConfigRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scoreCalcRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollAreaRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const subDomainRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useEffect)(()=>{
        let pollingInterval = null;
        let isUnmounted = false;
        async function fetchScanResult() {
            setLoading(true);
            try {
                const resp = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).get(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/public/scan-result/${uuid}/`, {
                    withCredentials: true
                });
                setScanResult(resp.data);
                // Set scan status after receiving response
                const status = resp.data?.scan?.status;
                if ([
                    "completed",
                    "failed",
                    "cancelled"
                ].includes(status)) setScanStatus(status);
                else setScanStatus("in_progress");
                // If status is in_progress, start polling
                if (status === "in_progress" && !pollingInterval) pollingInterval = setInterval(async ()=>{
                    if (isUnmounted) return;
                    try {
                        const pollResp = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).get(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/public/scan-result/${uuid}/`, {
                            withCredentials: true
                        });
                        setScanResult(pollResp.data);
                        const pollStatus = pollResp.data?.scan?.status;
                        if ([
                            "completed",
                            "failed",
                            "cancelled"
                        ].includes(pollStatus)) {
                            setScanStatus(pollStatus);
                            clearInterval(pollingInterval);
                            pollingInterval = null;
                        }
                    } catch (e) {
                    // Optionally handle polling error
                    }
                }, 10000); // 10 seconds
                // If status is not in_progress, clear polling
                if ([
                    "completed",
                    "failed",
                    "cancelled"
                ].includes(status) && pollingInterval) {
                    clearInterval(pollingInterval);
                    pollingInterval = null;
                }
            } catch (e) {
                setScanResult(null);
                setScanStatus("failed");
                console.error("Error fetching scan result:", e);
            } finally{
                setLoading(false);
            }
        }
        if (uuid) fetchScanResult();
        return ()=>{
            isUnmounted = true;
            if (pollingInterval) clearInterval(pollingInterval);
        };
    }, [
        uuid
    ]);
    const handleSectionClick = (newValue, complianceType = null, idList = null)=>{
        // User clicked a compliance button in Summary
        if (newValue === 1 && complianceType && idList) setComplianceFilter({
            type: complianceType,
            ids: idList
        });
        else if (newValue === 1 && !complianceType) setComplianceFilter(null); // CLEAR FILTER
        setTabIndex(newValue);
        let ref = null;
        if (newValue === 0) ref = summaryRef;
        else if (newValue === 1) ref = vulnerabilitiesRef;
        else if (newValue === 2) ref = secureConfigRef;
        else if (newValue === 3) ref = subDomainRef;
        else if (newValue === 4) ref = scoreCalcRef;
        if (ref?.current) {
            const scrollContainer = ref.current.parentElement;
            const stickyOffset = 144;
            const sectionTop = ref.current.offsetTop;
            if (scrollContainer) scrollContainer.scrollTo({
                top: sectionTop - stickyOffset,
                behavior: "smooth"
            });
        }
    };
    const handleShare = ()=>{
        if (!uuid) return;
        // Construct the public shareable URL
        const baseUrl = window.location.origin;
        const shareUrl = `${baseUrl}/public/scan-result/${uuid}`;
        if (navigator.clipboard) navigator.clipboard.writeText(shareUrl);
        else {
            // fallback for older browsers
            const textarea = document.createElement('textarea');
            textarea.value = shareUrl;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
        setSnackbarOpen(true);
    };
    // useEffect(() => {
    //   const handleClick = (e) => {
    //     // If the user clicked a GDPR button, do NOT reset
    //     if (e.target.closest(".no-reset")) return;
    //     setComplianceFilter(null);
    //   };
    //   document.addEventListener("click", handleClick);
    //   return () => document.removeEventListener("click", handleClick);
    // }, []);
    // Update tabIndex on scroll
    (0, $acw62.useEffect)(()=>{
        const scrollContainer = scrollAreaRef.current;
        if (!scrollContainer) return;
        const handleScroll = ()=>{
            // Height of sticky masthead + button group
            const stickyOffset = 164;
            const scrollTop = scrollContainer.scrollTop;
            // Get top positions relative to scroll area
            const sectionTops = [
                summaryRef.current?.offsetTop ?? 0,
                vulnerabilitiesRef.current?.offsetTop ?? 0,
                secureConfigRef.current?.offsetTop ?? 0,
                subDomainRef.current?.offsetTop ?? 0,
                scoreCalcRef.current?.offsetTop ?? 0
            ];
            // Find the section whose top is closest but not greater than scrollTop + stickyOffset
            let active = 0;
            for(let i = 0; i < sectionTops.length; i++)if (scrollTop + stickyOffset >= sectionTops[i]) active = i;
            setTabIndex(active);
        };
        scrollContainer.addEventListener('scroll', handleScroll);
        return ()=>scrollContainer.removeEventListener('scroll', handleScroll);
    }, []);
    // Sticky header and tabs, scrollable content area
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
        style: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d777678abefe038$export$2e2bcd8739ae039), {
                open: snackbarOpen,
                autoHideDuration: 2000,
                onClose: ()=>setSnackbarOpen(false),
                message: "Sharable link copied to clipboard!",
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 100
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e742043ac950988b$export$2e2bcd8739ae039), {
                        pageTitle: "Security Insights" + (scanResult?.scan?.domain ? ` - ${scanResult.scan.domain}` : ""),
                        productTitle: "WAF-as-a-Service",
                        belowContent: null,
                        rightContent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    bdsType: "interactiveNeutral",
                                    "data-action": "free-trial",
                                    onClick: ()=>navigate("/scan"),
                                    children: "Start a new Analysis"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    bdsType: "interactiveEmphasis",
                                    "data-action": "try",
                                    onClick: ()=>window.open('https://www.barracuda.com/products/application-protection/try-free', '_blank', 'noopener,noreferrer'),
                                    children: "Try WAF-as-a-Service now"
                                }),
                                state.isAuthenticated && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
                                    bdsSize: "input",
                                    "data-action": "share",
                                    onClick: handleShare,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5bc22e2b3a7b4be$exports))), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 5,
                        alignItems: "center",
                        sx: {
                            pl: 3,
                            pb: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        sx: {
                                            paddingLeft: 3
                                        },
                                        variant: "subtitle2",
                                        color: "text.secondary",
                                        children: [
                                            " Completed At: ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: scanResult?.scan?.completed_at ? new Date(scanResult?.scan?.completed_at).toLocaleString() : "-"
                                            })
                                        ]
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        sx: {
                                            paddingLeft: 3
                                        },
                                        variant: "subtitle2",
                                        color: "text.secondary",
                                        children: [
                                            " Issues: ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: scanResult?.findings?.summary?.vulnerabilities_detected ? scanResult?.findings?.summary?.vulnerabilities_detected : "-"
                                            })
                                        ]
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                                item: true,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
                                        sx: {
                                            paddingLeft: 3
                                        },
                                        variant: "subtitle2",
                                        color: "text.secondary",
                                        children: [
                                            " WAF: ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: scanResult?.findings?.waf_detected?.detected !== true ? "No WAF detected" : scanResult?.findings?.waf_detected?.manufacturer
                                            })
                                        ]
                                    }),
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        style: {
                            position: 'sticky',
                            top: 64,
                            zIndex: 99
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ad23ec42537d0e26$export$2e2bcd8739ae039), {
                            bdsType: "interactiveSubtle",
                            "aria-label": "outlined primary button group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 0,
                                    onClick: ()=>handleSectionClick(0),
                                    children: "Summary"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 1,
                                    onClick: ()=>handleSectionClick(1),
                                    children: "Vulnerabilities"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 2,
                                    onClick: ()=>handleSectionClick(2),
                                    children: "Secure Configuration"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07056a6ae53845f$export$2e2bcd8739ae039), {
                                    selected: tabIndex === 3,
                                    onClick: ()=>handleSectionClick(3),
                                    children: "Subdomains"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                ref: scrollAreaRef,
                style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        ref: summaryRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b972ba95501e1ea8$export$2e2bcd8739ae039), {
                            target_domain: scanResult?.scan?.domain || "",
                            scrollPage: handleSectionClick
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3756055f1448610$export$2e2bcd8739ae039), {
                            scrollPage: handleSectionClick,
                            state: state,
                            ai_summary: scanResult?.ai_summary || null,
                            summary: scanResult?.findings?.summary || {},
                            framework_summary: scanResult?.findings?.framework_info?.report_summary || {},
                            isLoading: loading,
                            vulnerabilities: scanResult?.findings?.vulnerabilities || [],
                            waf_detected: scanResult?.findings?.waf_detected || {},
                            sub_domains_count: scanResult?.findings?.sub_domains?.length || 0
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        ref: vulnerabilitiesRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e87406f1ecac8ff$export$2e2bcd8739ae039), {
                            title: "Possible Attacks",
                            subtitle: "You are Vulnerable to following Attacks"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437d13139f214e20$export$2e2bcd8739ae039), {
                            isSafe: false,
                            title: "Possible Attacks",
                            subtitle: "You are Vulnerable to following Attacks",
                            state: state,
                            url: scanResult?.scan?.domain || "",
                            isLoading: loading,
                            vulnerabilities: scanResult?.findings?.vulnerabilities || [],
                            complianceFilter: complianceFilter,
                            setComplianceFilter: setComplianceFilter
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        ref: secureConfigRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e87406f1ecac8ff$export$2e2bcd8739ae039), {
                            title: "Secure Configuration",
                            subtitle: "component passed security checks"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bce5c0fad5cf29b$export$2e2bcd8739ae039), {
                            isSafe: true,
                            title: "Secure Configuration",
                            subtitle: "component passed security checks",
                            state: state,
                            url: scanResult?.scan?.domain || "",
                            isLoading: loading,
                            vulnerabilities: scanResult?.findings?.secure_config || []
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        ref: subDomainRef,
                        children: loading || scanStatus === 'in_progress' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $297483900a014e6a$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810abadf40de7ce4$export$2e2bcd8739ae039), {
                            state: state,
                            isLoading: loading,
                            scanResult: scanResult,
                            subdomains: scanResult?.findings?.sub_domains || []
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4556e4fc82adeb27$export$2e2bcd8739ae039), {
                        ref: scoreCalcRef
                    })
                ]
            })
        ]
    });
}


// src/ProtectedRoute.js

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $cd19b870fe618da7$export$2e2bcd8739ae039({ children: children }) {
    const { state: state } = (0, $2ad2279805e583d1$export$6ccbb43953eebf8)();
    if (!state.isAuthenticated) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
    return children;
}



var $ayMG0 = parcelRequire("ayMG0");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $f856d4b25f0d5241$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $f856d4b25f0d5241$var$SvgMenuVertical(props) {
    return $f856d4b25f0d5241$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor"
    }, props), $acw62.createElement("path", {
        d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    })), props);
}
var $f856d4b25f0d5241$export$2e2bcd8739ae039 = $f856d4b25f0d5241$var$SvgMenuVertical;



var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
const $93e253ffb1a2b421$var$CrossFadeBase = (0, $d8seH.default)('div')({
    transition: 'opacity 0.5s, visibility 0.5s',
    width: '100%'
});
const $93e253ffb1a2b421$var$PreviousContent = (0, $d8seH.default)($93e253ffb1a2b421$var$CrossFadeBase)({
    opacity: 0,
    height: 0,
    overflowY: 'visible',
    visibility: 'hidden'
});
const $93e253ffb1a2b421$var$ActiveContent = (0, $d8seH.default)($93e253ffb1a2b421$var$CrossFadeBase)({
    opacity: 1
});
const $93e253ffb1a2b421$var$UpcomingContent = (0, $d8seH.default)($93e253ffb1a2b421$var$CrossFadeBase)({
    opacity: 0
});
const $93e253ffb1a2b421$export$d78c8c6074541cf2 = (props)=>{
    const { children: children } = props;
    const contentQueue = (0, $acw62.useRef)([
        null
    ]);
    const contentKeys = (0, $acw62.useRef)([
        1
    ]);
    contentQueue.current = [
        children,
        contentQueue.current[0]
    ];
    contentKeys.current = [
        contentKeys.current[0] + 1,
        contentKeys.current[0]
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($93e253ffb1a2b421$var$PreviousContent, {
        key: contentKeys.current[1]
    }, contentQueue.current[1]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($93e253ffb1a2b421$var$ActiveContent, {
        key: contentKeys.current[0]
    }, contentQueue.current[0]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($93e253ffb1a2b421$var$UpcomingContent, {
        key: contentKeys.current[0] + 1
    }, null));
};


/**
 * @component NavigationBarRoutesItem
 * @description A component that renders a navigation bar item with an icon, label, and optional menu.
 * It can be used to create a navigation bar with various items that can be clicked or interacted with.
 * @example
 * <NavigationBarRoutesItem
 *   label="Home"
 *   icon={<HomeIcon />}
 *   onClick={() => console.log('Home clicked')}
 * />
 */ 
var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $d8seH = parcelRequire("d8seH");

var $99b4e398c911b097$export$2e2bcd8739ae039 = (0, $66e61be7bdc1cebd$export$2e2bcd8739ae039);





// Define the styled component
const $676b4c950c7554ce$var$StyledBox = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        justifyContent: 'center',
        alignContent: 'center',
        display: 'flex',
        flexWrap: 'wrap'
    }));
const $676b4c950c7554ce$var$StyledIconButton = (0, $d8seH.default)((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'focused' && prop !== 'isMenuOpen'
})(({ theme: theme, selected: selected, isMenuOpen: isMenuOpen, focused: focused })=>Object.assign({}, selected && focused && isMenuOpen && {
        backgroundColor: theme.palette.iconButton.interactive.subtle.menuOpen.background,
        border: `${theme.palette.iconButton.border.width} solid ${theme.palette.iconButton.interactive.subtle.menuOpen.border}`
    }));
const $676b4c950c7554ce$var$NavigationContent = ({ label: label, icon: icon, onClick: onClick, disabled: disabled, id: id, active: active, focused: focused, initials: initials, isMenuOpen: isMenuOpen, handleKeyDown: handleKeyDown })=>{
    if (icon) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($676b4c950c7554ce$var$StyledIconButton, {
        bdsSize: "rectangle",
        label: label,
        focused: !!focused,
        onClick: onClick,
        disabled: disabled,
        id: id,
        selected: active || focused,
        "data-testid": `icon-button-${(0, $f1q41.kebabCase)(label)}`,
        "aria-label": `icon-button-${(0, $f1q41.kebabCase)(label)}`,
        isMenuOpen: isMenuOpen,
        onKeyDown: handleKeyDown,
        tabIndex: disabled ? -1 : 0,
        role: "button"
    }, icon);
    /*
     * If no icon, render Avatar (for profile or fallback)
     * TODO: future improvement: Add a prop to allow the user to pass a custom avatar component
     * to be used instead of the default Avatar component.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99b4e398c911b097$export$2e2bcd8739ae039), {
        bdsType: "interactiveSubtle",
        bdsSize: "xxlarge",
        onClick: onClick,
        disabled: disabled,
        id: id,
        selected: active || focused,
        "data-testid": `avatar-button-${(0, $f1q41.kebabCase)(label)}`,
        "aria-label": `avatar-button-${(0, $f1q41.kebabCase)(label)}`,
        role: "button",
        onKeyDown: handleKeyDown,
        tabIndex: disabled ? -1 : 0
    }, initials || (label ? label[0] : '?'));
};
const $676b4c950c7554ce$export$10e3c5f065457301 = ({ active: active, onClick: onClick, icon: icon, label: label, disabled: disabled, id: id, focused: focused, initials: initials, isMenuOpen: isMenuOpen, path: path, isFinalPath: isFinalPath, href: href, openInNewTab: openInNewTab })=>{
    const handleKeyDown = (event)=>{
        if (disabled) return;
        if (event.key === 'Enter' || event.key === ' ') {
            if (onClick && !href) {
                event.preventDefault();
                onClick();
            }
        }
    };
    const handleClick = (e)=>{
        if (disabled) return;
        if (onClick && !href) {
            e.preventDefault();
            onClick();
        }
    };
    const content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($676b4c950c7554ce$var$NavigationContent, Object.assign({}, {
        label: label,
        icon: icon,
        onClick: onClick,
        disabled: disabled,
        id: id,
        active: active,
        focused: focused,
        initials: initials,
        isMenuOpen: isMenuOpen,
        handleKeyDown: handleKeyDown
    }));
    const renderLinkOrContent = ()=>{
        if (disabled) return content;
        if (isFinalPath || href || path) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            href: href || path,
            onClick: handleClick,
            style: {
                textDecoration: 'none'
            },
            "aria-label": `Navigate to ${label}`,
            /**
                 * We set the tabIndex to -1 to prevent the link from being focusable
                 * The focus is handled above by the NavigationBarRoutesItem component
                 */ tabIndex: -1,
            onKeyDown: handleKeyDown,
            target: openInNewTab ? '_blank' : undefined,
            rel: openInNewTab ? 'noopener noreferrer' : undefined
        }, content);
        return content;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($676b4c950c7554ce$var$StyledBox, {
        "data-testid": "navigation-bar-routes-item"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13a6e721c9a8fde7$export$2e2bcd8739ae039), {
        title: label,
        placement: "right",
        arrow: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, renderLinkOrContent())));
};



var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");



const $4b5d50e682fa1b8f$var$StyledNavigationBarContaineer = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(()=>{
    const tokens = (0, $5cffe40b21e31a28$export$2e2bcd8739ae039)();
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.navigationNavContainerPrimarySpaceBetween,
        flex: 0,
        height: '100%'
    };
});
const $4b5d50e682fa1b8f$export$8b35e682a6c3608b = (props)=>{
    const { routes: routes, setSubmenuRoute: setSubmenuRoute, activeIndexes: activeIndexes, focusedIndexes: focusedIndexes, onNavigate: onNavigate, isMenuOpen: isMenuOpen } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4b5d50e682fa1b8f$var$StyledNavigationBarContaineer, {
        "data-testid": "navigation-bar-routes"
    }, routes.map((route, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $676b4c950c7554ce$export$10e3c5f065457301), {
            label: route.name,
            key: route.path,
            onClick: ()=>{
                setSubmenuRoute(route, index);
                if (!route.children && route.path) {
                    console.log('Navigating to:', route.path, route.name);
                    onNavigate(route.path, route.name);
                }
            },
            isFinalPath: !route.children,
            path: route.path,
            icon: route.icon,
            active: activeIndexes.includes(index),
            focused: focusedIndexes.includes(index),
            disabled: route.disabled,
            isMenuOpen: isMenuOpen
        })));
};



var $d8seH = parcelRequire("d8seH");

const $5573d5370a766bd5$export$d411c7f00c0ca820 = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        minWidth: theme.palette.navigation.container.primary.width,
        flexBasis: theme.palette.navigation.container.primary.width,
        background: theme.palette.navigation.container.primary.background.default,
        borderRight: `${theme.palette.navigation.container.primary.border.width} solid ${theme.palette.navigation.container.primary.border.default}`
    }));
const $5573d5370a766bd5$export$e118dcc3d99361f8 = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: theme.palette.space.container.spacious,
        paddingBottom: theme.palette.space.container.default,
        gap: theme.palette.navigation.container.primary.spaceBetween
    }));
const $5573d5370a766bd5$export$edde5c03500f568f = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        gap: theme.palette.space.container.dense,
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center'
    }));
const $5573d5370a766bd5$export$3ef458fcda7c721d = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        gap: theme.palette.navigation.container.primary.spaceBetween,
        marginTop: 'auto',
        alignContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.palette.space.container.dense
    }));
const $5573d5370a766bd5$export$ddffa5524c4a4a0 = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        gap: theme.palette.navigation.container.primary.spaceBetween,
        alignContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.palette.space.container.default
    }));
const $5573d5370a766bd5$export$a09d580bab04e05 = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'open'
})(({ theme: theme, open: open })=>({
        background: open ? theme.palette.navigation.container.secondary.background.default : 'transparent',
        borderRightColor: theme.palette.navigation.container.secondary.border.default,
        borderRightStyle: 'solid',
        borderRightWidth: open ? theme.palette.navigation.container.secondary.border.width : 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        marginRight: open ? -parseFloat(theme.palette.navigation.container.secondary.width) : 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.25s, margin-right 0.25s',
        width: open ? theme.palette.navigation.container.secondary.width : 0,
        zIndex: 2
    }));
const $5573d5370a766bd5$export$9e0f41ae7b3abed3 = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))({
    position: 'absolute',
    top: 0,
    left: 342,
    width: 'calc(100% - 342px)',
    height: '100%',
    opacity: 0
});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");



var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $ed87875217ed4342$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $ed87875217ed4342$var$SvgArrowRight(props) {
    return $ed87875217ed4342$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor"
    }, props), $acw62.createElement("path", {
        d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"
    })), props);
}
var $ed87875217ed4342$export$2e2bcd8739ae039 = $ed87875217ed4342$var$SvgArrowRight;


var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $e28f2daf6252d49a$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $e28f2daf6252d49a$var$SvgExpandLess(props) {
    return $e28f2daf6252d49a$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    })), props);
}
var $e28f2daf6252d49a$export$2e2bcd8739ae039 = $e28f2daf6252d49a$var$SvgExpandLess;


var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $ce894d4904784746$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $ce894d4904784746$var$SvgExpandMore(props) {
    return $ce894d4904784746$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })), props);
}
var $ce894d4904784746$export$2e2bcd8739ae039 = $ce894d4904784746$var$SvgExpandMore;





var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");



var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $b577ecea93b07337$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $b577ecea93b07337$var$SvgClose(props) {
    return $b577ecea93b07337$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor"
    }, props), $acw62.createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
    })), props);
}
var $b577ecea93b07337$export$2e2bcd8739ae039 = $b577ecea93b07337$var$SvgClose;




var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $26cd3be04bc521db$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');


const $c6c3e0bbfee757aa$var$StyledDiv = (0, $d8seH.default)('div')(({ theme: theme })=>({
        paddingLeft: theme.palette.space.container.default,
        // TODO: Talk to Ann about the close icon not aligning with the list item icons
        paddingRight: theme.palette.space.container.default,
        height: '100%'
    }));
const $c6c3e0bbfee757aa$var$StyledNavigationSubmenu = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>{
    return {
        display: 'flex',
        flexDirection: 'column',
        width: theme.palette.navigation.container.secondary.width,
        height: '100vh',
        gap: theme.palette.navigation.container.secondary.spaceBetween,
        background: theme.palette.menuItem.background.color,
        padding: `0 ${theme.palette.navigation.container.secondary.padding} ${theme.palette.navigation.container.secondary.padding}`
    };
});
const $c6c3e0bbfee757aa$var$StyledTitle = (0, $d8seH.default)((props)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), Object.assign({
        component: "div",
        variant: "h3"
    }, props)))(({ theme: theme })=>{
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.palette.space.container.default} ${theme.palette.space.container.default} ${theme.palette.space.container.dense} ${theme.palette.space.container.default}`,
        '& .title-container': {
            display: 'flex',
            alignItems: 'center',
            gap: theme.palette.space.container.default
        }
    };
});
const $c6c3e0bbfee757aa$export$519403991fbac1 = ({ title: title, onClose: onClose, children: children, handleBack: handleBack })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c6c3e0bbfee757aa$var$StyledNavigationSubmenu, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c6c3e0bbfee757aa$var$StyledTitle, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "title-container"
    }, handleBack && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
        bdsSize: "input",
        onClick: handleBack,
        "data-testid": "back-button"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26cd3be04bc521db$export$2e2bcd8739ae039), null)), title), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d00116aae00015e7$export$2e2bcd8739ae039), {
        bdsSize: "input",
        onClick: onClose,
        "data-testid": "close-button"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b577ecea93b07337$export$2e2bcd8739ae039), null))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c6c3e0bbfee757aa$var$StyledDiv, null, children));
};


const $ad860d3759353198$var$StyledListItemIcon = (0, $d8seH.default)((0, $83e175cb7e49d325$export$2e2bcd8739ae039))(({ theme: theme })=>({
        minWidth: 0,
        padding: 0,
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiSvgIcon-root': {
            fill: theme.palette.icon.static.emphasis.color,
            width: theme.palette.icon.size.small,
            height: theme.palette.icon.size.small,
            fontSize: theme.palette.icon.size.small
        }
    }));
const $ad860d3759353198$var$StyledMenuItem = (0, $d8seH.default)((0, $ea20f98bbbba0b96$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'nested'
})(({ nested: nested, theme: theme })=>Object.assign({
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: theme.typography.fontWeightBold
    }, nested && {
        paddingLeft: theme.palette.menuItem.padding.nested
    }));
const $ad860d3759353198$var$matchLocation = (basePath, pathname)=>{
    if (!basePath || !pathname) return false;
    return pathname.startsWith(basePath);
};
const $ad860d3759353198$var$toCamelCase = (str)=>str.trim().replace(/[^a-zA-Z0-9]+(.)/g, (_, chr)=>chr.toUpperCase()).replace(/^(.)/, (_, chr)=>chr.toLowerCase());
const $ad860d3759353198$export$8765015479f6b5cf = ({ route: route, currentPath: currentPath, onNavigate: onNavigate, onClose: onClose })=>{
    const [expandedItems, setExpandedItems] = (0, $acw62.useState)(new Set());
    const [menuStack, setMenuStack] = (0, $acw62.useState)([
        route
    ]);
    const currentMenu = menuStack[menuStack.length - 1];
    const expandedSet = (0, $acw62.useMemo)(()=>{
        const expandedSet = new Set();
        const expandParentAndChildren = (routes, currentPath)=>{
            routes.forEach((subroute)=>{
                if (subroute.expanded) expandedSet.add(subroute.name);
                if (subroute.path && $ad860d3759353198$var$matchLocation(subroute.path, currentPath)) expandedSet.add(subroute.name);
                if (subroute.children) {
                    expandParentAndChildren(subroute.children, currentPath);
                    if (subroute.children.some((child)=>expandedSet.has(child.name))) expandedSet.add(subroute.name);
                }
            });
        };
        expandParentAndChildren(route.children || [], currentPath);
        return expandedSet;
    }, [
        currentPath,
        route.children
    ]);
    (0, $acw62.useEffect)(()=>{
        setExpandedItems(expandedSet);
    }, [
        expandedSet
    ]);
    const handleItemClick = (event, isFinalChild, subroute, routeId, isFirstLevel)=>{
        // Handle final child navigation
        if (isFinalChild && subroute.path) {
            event.preventDefault(); // Prevent default link behavior
            onNavigate(subroute.path, subroute.name); // Navigate to the subroute path
            return;
        }
        // Toggle expansion of first-level items with children
        if (isFirstLevel && subroute.children) {
            toggleExpansion(routeId);
            return;
        }
        // Navigate to a submenu if it has children
        if (subroute.children) navigateToSubMenu(subroute);
    };
    // Helper function to toggle expansion of a route
    const toggleExpansion = (routeId)=>{
        setExpandedItems((prevExpanded)=>{
            const newExpanded = new Set(prevExpanded);
            newExpanded.has(routeId) ? newExpanded.delete(routeId) : newExpanded.add(routeId);
            return newExpanded;
        });
    };
    // Helper function to navigate to a submenu
    const navigateToSubMenu = (subroute)=>{
        setMenuStack((prevStack)=>[
                ...prevStack,
                subroute
            ]);
    };
    const handleBack = ()=>{
        setMenuStack((prevStack)=>prevStack.slice(0, -1));
    };
    const renderMenuItem = (subroute, routeId, isFirstLevel, nested)=>{
        var _a, _b;
        const isFinalChild = !((_a = subroute.children) === null || _a === void 0 ? void 0 : _a.length);
        const hasChildren = !!((_b = subroute.children) === null || _b === void 0 ? void 0 : _b.length);
        const isExpanded = expandedItems.has(routeId) || !!subroute.expanded;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad860d3759353198$var$StyledMenuItem, {
            "data-testid": $ad860d3759353198$var$toCamelCase(subroute.name),
            nested: !!nested,
            key: subroute.name,
            onClick: (event)=>handleItemClick(event, isFinalChild, subroute, routeId, isFirstLevel),
            disabled: subroute.disabled,
            selected: !!subroute.path && $ad860d3759353198$var$matchLocation(subroute.path, currentPath),
            tabIndex: 0
        }, subroute.icon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad860d3759353198$var$StyledListItemIcon, null, subroute.icon), subroute.path ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            /*
                 ** Set tabIndex to -1 to prevent the link from being focusable
                 ** focus is handled above by the MenuItem component
                 */ component: "a",
            tabIndex: -1,
            href: subroute.path,
            style: {
                textDecoration: 'none',
                color: 'inherit',
                flex: 1
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d696835f9b43a35$export$2e2bcd8739ae039), null, subroute.name)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d696835f9b43a35$export$2e2bcd8739ae039), null, subroute.name), isFirstLevel && hasChildren ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad860d3759353198$var$StyledListItemIcon, null, isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e28f2daf6252d49a$export$2e2bcd8739ae039), null) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce894d4904784746$export$2e2bcd8739ae039), null)) : hasChildren && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad860d3759353198$var$StyledListItemIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed87875217ed4342$export$2e2bcd8739ae039), null)));
    };
    const renderSubMenu = (subroute, parentId, nestedLevel)=>{
        const isFirstLevelItem = nestedLevel === 0;
        const isExpanded = expandedItems.has(parentId);
        return isFirstLevelItem && subroute.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: subroute.name
        }, renderMenuItem(subroute, parentId, true, false), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $848dc8709a4309c5$export$2e2bcd8739ae039), {
            in: isExpanded
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            sx: {
                paddingLeft: 2
            }
        }, subroute.children.map((subsubroute)=>renderSubMenu(subsubroute, subsubroute.name, nestedLevel + 1))))) : renderMenuItem(subroute, parentId, false);
    };
    const renderMenu = (menu)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            sx: {
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column'
            }
        }, (_a = menu.children) === null || _a === void 0 ? void 0 : _a.map((subroute)=>renderSubMenu(subroute, subroute.name, 0)));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c3e0bbfee757aa$export$519403991fbac1), {
        handleBack: menuStack.length > 1 ? handleBack : undefined,
        title: currentMenu.name,
        onClose: onClose
    }, renderMenu(currentMenu));
};



const $e34a636f1cb52668$export$f0c43fc56f71e169 = ({ submenuState: submenuState, routes: routes, topOptions: topOptions, options: options, visibleRoutesCount: visibleRoutesCount, currentPath: currentPath, onNavigate: onNavigate, setSubmenuClosed: setSubmenuClosed })=>{
    if (!submenuState.active) return null;
    const { type: type, index: index } = submenuState.active;
    switch(type){
        case 'route':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad860d3759353198$export$8765015479f6b5cf), {
                "data-testid": "navigation-bar-routes-menu",
                route: routes[index],
                currentPath: currentPath,
                onNavigate: onNavigate,
                onClose: setSubmenuClosed
            });
        case 'topOption':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c3e0bbfee757aa$export$519403991fbac1), {
                title: topOptions[index].name,
                onClose: setSubmenuClosed
            }, topOptions[index].menu);
        case 'option':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6c3e0bbfee757aa$export$519403991fbac1), {
                title: options[index].name,
                onClose: setSubmenuClosed
            }, options[index].menu);
        case 'overflowed':
            {
                /* Get the overflowed routes */ /* Slice the routes to get the overflowed routes */ const overflowedRoutes = routes.slice(visibleRoutesCount).map((route)=>Object.assign(Object.assign({}, route), {
                        icon: route.icon
                    }));
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad860d3759353198$export$8765015479f6b5cf), {
                    "data-testid": "navigation-bar-routes-menu",
                    route: {
                        /* Create a dummy route for the "More" button */ icon: null,
                        name: 'More',
                        path: '/more-options',
                        /* Pass the overflowed routes as children */ children: overflowedRoutes.map((route)=>{
                            if (route.children) return Object.assign(Object.assign({}, route), {
                                /* Set the path to undefined for routes with children */ /* otherwise the route will be treated as a leaf node */ path: undefined
                            });
                            /* Return the route of the parent */ return route;
                        })
                    },
                    currentPath: currentPath,
                    onNavigate: onNavigate,
                    onClose: setSubmenuClosed
                });
            }
        default:
            return null;
    }
};


const $3e9e37a860cfa953$var$matchLocation = (basePath, pathname)=>{
    const pattern = new RegExp(`^${basePath}($|[/#?])`);
    return !!pattern.test(pathname);
};
const $3e9e37a860cfa953$export$214ae410b202e65a = (props)=>{
    var _a, _b, _c, _d;
    const { routes: routes = [], topOptions: topOptions = [], options: options = [], logo: logo, currentPath: currentPath, onNavigate: onNavigate } = props;
    const anchorRef = (0, $acw62.useRef)(null);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const [submenuState, setSubmenuState] = (0, $acw62.useState)({
        open: false
    });
    const productContainerRef = (0, $acw62.useRef)(null);
    const globalContainerRef = (0, $acw62.useRef)(null);
    const topContainerRef = (0, $acw62.useRef)(null);
    const logoContainerRef = (0, $acw62.useRef)(null);
    const [overflowed, setOverflowed] = (0, $acw62.useState)(false);
    const [visibleRoutesCount, setVisibleRoutesCount] = (0, $acw62.useState)(0); // Track the number of visible routes
    const additionalPadding = 100;
    const checkOverflow = ()=>{
        var _a, _b, _c;
        // Ensure each ref has a value; if any ref is missing, we treat it as 0
        const anchorHeight = ((_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
        const topContainerHeight = ((_b = topContainerRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0;
        const globalContainerHeight = ((_c = globalContainerRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) || 0;
        // Calculate the total available height
        const totalHeight = anchorHeight - topContainerHeight - globalContainerHeight - additionalPadding;
        // Check how many routes can fit in the remaining space
        const routeHeight = 50;
        const maxVisibleItems = Math.floor(totalHeight / routeHeight);
        setVisibleRoutesCount(maxVisibleItems);
        // Ensure maxVisibleItems is at least 0
        const safeMaxVisibleItems = Math.max(0, maxVisibleItems);
        // Check if we have overflow
        const isOverflowing = routes.length > safeMaxVisibleItems;
        setOverflowed(isOverflowing);
        setVisibleRoutesCount(safeMaxVisibleItems);
    };
    // Initial setup and window resizing handling
    (0, $acw62.useEffect)(()=>{
        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(()=>{
                checkOverflow(); // Recalculate overflow when resizing
            });
            // Start observing the anchor container
            if (anchorRef.current) resizeObserver.observe(anchorRef.current);
            // Initial check
            checkOverflow();
            return ()=>{
                // Clean up
                if (anchorRef.current) resizeObserver.unobserve(anchorRef.current);
                resizeObserver.disconnect();
            };
        } else {
            // Fallback for environments without ResizeObserver
            window.addEventListener('resize', checkOverflow);
            checkOverflow(); // Initial check on mount
            return ()=>{
                window.removeEventListener('resize', checkOverflow);
            };
        }
    }, [
        routes
    ]);
    // Function to find the active route index based on the current path and type
    const findActiveIndex = (routes, currentPath)=>{
        const checkRoute = (route)=>{
            if (route.path && $3e9e37a860cfa953$var$matchLocation(route.path, currentPath)) return true;
            if (route.children && Array.isArray(route.children)) for (const child of route.children){
                if (checkRoute(child)) return true;
            }
            return false;
        };
        return routes.findIndex((route)=>checkRoute(route));
    };
    // Get the active route index for both top options and regular routes
    const activeRouteIndex = findActiveIndex(routes, currentPath);
    // Handle submenu for route or option
    const setRouteSubmenu = (0, $acw62.useCallback)((index, type)=>{
        setSubmenuState((currentState)=>({
                open: true,
                active: {
                    index: index,
                    type: type
                },
                last: currentState.active
            }));
    }, [
        setSubmenuState
    ]);
    const setOverflowedSubmenu = (0, $acw62.useCallback)(()=>{
        setSubmenuState((currentState)=>({
                open: true,
                active: {
                    index: routes.length,
                    type: 'overflowed'
                },
                last: currentState.active
            }));
    }, [
        setSubmenuState
    ]);
    const setOptionSubmenu = (0, $acw62.useCallback)((index, type)=>{
        setSubmenuState((currentState)=>({
                open: true,
                active: {
                    index: index,
                    type: type
                },
                last: currentState.active
            }));
    }, [
        setSubmenuState
    ]);
    const setSubmenuClosed = (0, $acw62.useCallback)(()=>{
        setSubmenuState({
            open: false,
            active: undefined,
            last: undefined
        });
    }, [
        setSubmenuState
    ]);
    (0, $acw62.useEffect)(()=>{
        setSubmenuClosed();
    }, [
        currentPath
    ]);
    const processedOptions = (0, $acw62.useMemo)(()=>options.map((option)=>Object.assign(Object.assign({}, option), {
                icon: 'icon' in option ? option.icon : undefined,
                initials: 'initials' in option ? option.initials : undefined
            })), [
        options
    ]);
    const handleClick = (0, $acw62.useCallback)((index, type)=>{
        setOptionSubmenu(index, type);
    }, []);
    /* Set isMenuOpen based on submenuState */ const isMenuOpen = submenuState.open;
    const isCurrentPathInVisibleRoutes = routes.slice(0, visibleRoutesCount).some((route)=>{
        var _a;
        return $3e9e37a860cfa953$var$matchLocation((_a = route.path) !== null && _a !== void 0 ? _a : '', currentPath);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5573d5370a766bd5$export$d411c7f00c0ca820), {
        ref: anchorRef,
        "data-testid": "navigation-bar-root-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "row",
        sx: {
            height: '100%'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        sx: {
            height: '100%'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5573d5370a766bd5$export$e118dcc3d99361f8), {
        ref: logoContainerRef,
        flexDirection: "column",
        "data-testid": "navigation-bar-logo-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(logo, {
        width: theme.palette.icon.size.xlarge,
        height: theme.palette.icon.size.xlarge,
        viewBox: '0 0 56 56' // TODO: Investigate why this is needed
    })), topOptions.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5573d5370a766bd5$export$ddffa5524c4a4a0), {
        ref: topContainerRef,
        "data-testid": "navigation-bar-top-container"
    }, topOptions.map((option, index)=>{
        var _a, _b, _c, _d;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $676b4c950c7554ce$export$10e3c5f065457301), {
            label: option.name,
            key: option.name,
            onClick: ()=>{
                // Only set the submenu state if the option has a menu
                if (option.menu) handleClick(index, 'topOption');
                // If the user passes in an onClick (option.onClick exists), call that as well
                if (option.onClick) option.onClick();
                if (option.path) onNavigate(option.path, option.name);
            },
            active: !!(((_a = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _a === void 0 ? void 0 : _a.type) === 'topOption' && index === ((_b = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _b === void 0 ? void 0 : _b.index) || option.path && $3e9e37a860cfa953$var$matchLocation(option.path, currentPath)),
            disabled: option.disabled,
            focused: !!(((_c = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _c === void 0 ? void 0 : _c.type) === 'topOption' && index === ((_d = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _d === void 0 ? void 0 : _d.index) || option.path && $3e9e37a860cfa953$var$matchLocation(option.path, currentPath)),
            icon: option.icon,
            isMenuOpen: isMenuOpen,
            href: option.href,
            path: option.path,
            openInNewTab: option.openInNewTab
        });
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $753cd5b62de61f2c$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        sx: {
            paddingBottom: theme.palette.space.container.dense
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5573d5370a766bd5$export$edde5c03500f568f), {
        ref: productContainerRef,
        display: "flex",
        flexDirection: "column",
        "data-testid": "navigation-bar-product-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b5d50e682fa1b8f$export$8b35e682a6c3608b), {
        routes: routes.slice(0, visibleRoutesCount),
        setSubmenuRoute: (route, index)=>{
            if (route === null || route === void 0 ? void 0 : route.children) setRouteSubmenu(index, 'route');
            else setSubmenuClosed();
        },
        activeIndexes: [
            activeRouteIndex
        ],
        focusedIndexes: [
            ((_a = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _a === void 0 ? void 0 : _a.type) === 'route' && ((_b = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _b === void 0 ? void 0 : _b.index) || -1
        ],
        onNavigate: onNavigate,
        isMenuOpen: isMenuOpen
    }), overflowed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $676b4c950c7554ce$export$10e3c5f065457301), {
        label: "More",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f856d4b25f0d5241$export$2e2bcd8739ae039), null),
        onClick: setOverflowedSubmenu,
        active: ((_c = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _c === void 0 ? void 0 : _c.type) === 'overflowed' || !isCurrentPathInVisibleRoutes,
        focused: ((_d = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _d === void 0 ? void 0 : _d.type) === 'overflowed',
        isMenuOpen: isMenuOpen
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5573d5370a766bd5$export$3ef458fcda7c721d), {
        ref: globalContainerRef,
        "data-testid": "navigation-bar-global-container"
    }, processedOptions.map((option, index)=>{
        var _a, _b, _c, _d;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $676b4c950c7554ce$export$10e3c5f065457301), {
            label: option.name,
            key: option.name,
            onClick: ()=>{
                handleClick(index, 'option');
                // If the user passing in an onClick (option.onClick exists), call that as well
                if (option.onClick) option.onClick();
            },
            active: ((_a = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _a === void 0 ? void 0 : _a.type) === 'option' && index === ((_b = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _b === void 0 ? void 0 : _b.index),
            disabled: option.disabled,
            focused: ((_c = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _c === void 0 ? void 0 : _c.type) === 'option' && index === ((_d = submenuState === null || submenuState === void 0 ? void 0 : submenuState.active) === null || _d === void 0 ? void 0 : _d.index),
            icon: option.icon,
            initials: option.initials,
            isMenuOpen: isMenuOpen
        });
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5573d5370a766bd5$export$a09d580bab04e05), {
        open: submenuState.open,
        "data-testid": "navigation-bar-submenu"
    }, submenuState.active && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93e253ffb1a2b421$export$d78c8c6074541cf2), null, (0, $e34a636f1cb52668$export$f0c43fc56f71e169)({
        submenuState: submenuState,
        routes: routes,
        topOptions: topOptions,
        options: options,
        visibleRoutesCount: visibleRoutesCount,
        currentPath: currentPath,
        onNavigate: onNavigate,
        setSubmenuClosed: setSubmenuClosed
    })))), submenuState.open && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5573d5370a766bd5$export$9e0f41ae7b3abed3), {
        role: "presentation",
        onClick: setSubmenuClosed
    })));
};


var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");





const $e37265b169f5c41f$var$StyledListItemIcon = (0, $d8seH.default)((0, $83e175cb7e49d325$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&.MuiListItemIcon-root': {
            minWidth: 0,
            padding: 0,
            margin: 0
        },
        '& .MuiSvgIcon-root': {
            fill: theme.palette.icon.interactive.neutral.color.default,
            width: theme.palette.icon.size.small,
            height: theme.palette.icon.size.small,
            fontSize: theme.palette.icon.size.small
        }
    }));
const $e37265b169f5c41f$var$StyledAvatarbox = (0, $d8seH.default)((0, $19b86ddc2142d157$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: theme.palette.space.container.dense,
        overflowWrap: 'anywhere',
        marginBottom: theme.palette.space.container.spacious
    }));
const $e37265b169f5c41f$export$b04dd99d751ebb47 = ({ name: name, email: email, initials: initials, menuItems: menuItems, footer: footer })=>{
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const handleKeyDown = (event, item)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            if (item.disabled) return;
            if (item.onClick) item.onClick();
        }
    };
    const getFooterItems = (footer)=>{
        return [
            ...footer.customItems || [],
            ...footer.serial ? [
                {
                    label: footer.serialText || 'Serial',
                    value: footer.serial
                }
            ] : [],
            ...footer.version ? [
                {
                    label: footer.versionText || 'Version',
                    value: footer.version
                }
            ] : [],
            ...footer.expirationDate ? [
                {
                    label: footer.expirationDateText || 'Exp date',
                    value: footer.expirationDate
                }
            ] : []
        ];
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        "data-testid": "profile-menu",
        role: "menu",
        "aria-label": "Profile menu"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        "data-testid": "profile-menu-contents"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e37265b169f5c41f$var$StyledAvatarbox, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99b4e398c911b097$export$2e2bcd8739ae039), {
        bdsType: "staticEmphasis",
        bdsSize: "xxlarge",
        "aria-hidden": "true"
    }, initials), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        flexGrow: 1
    }, name && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
        variant: "h4",
        sx: {
            fontWeight: theme.typography.fontWeightBold
        }
    }, name), email && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
        variant: "body1"
    }, email))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        gap: theme.palette.space.container.dense,
        role: "menu",
        "aria-label": "Profile menu items"
    }, menuItems && menuItems.map((item, index)=>{
        const menuItemContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abf91f1ec64eab0f$export$2e2bcd8739ae039), {
            key: `${item.name}-${index}`,
            onClick: item.onClick,
            disabled: item.disabled,
            onKeyDown: (e)=>handleKeyDown(e, item),
            role: "menuitem",
            /**
                         * The tabIndex is set to -1 for items with href to prevent them from being focusable
                         * Otherwise focus will be set in the href link
                         */ tabIndex: item.href ? -1 : 0,
            sx: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: theme.palette.space.container.dense,
                textDecoration: 'none',
                color: 'inherit'
            }
        }, item.icon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e37265b169f5c41f$var$StyledListItemIcon, {
            "aria-hidden": "true"
        }, item.icon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d696835f9b43a35$export$2e2bcd8739ae039), null, item.name), item.endIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e37265b169f5c41f$var$StyledListItemIcon, {
            "aria-hidden": "true"
        }, item.endIcon));
        if (item.href) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
            component: "a",
            tabIndex: 0,
            key: item.name,
            href: item.disabled ? undefined : item.href,
            target: item.openInNewTab && !item.disabled ? '_blank' : undefined,
            rel: item.openInNewTab && !item.disabled ? 'noopener noreferrer' : undefined,
            sx: {
                textDecoration: 'none',
                '&:focus-visible': {
                    backgroundColor: theme.palette.menuItem.background.focus,
                    border: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.focus} !important`,
                    color: theme.palette.menuItem.text.focus,
                    outline: 'none'
                }
            },
            onClick: (e)=>{
                if (!item.disabled && item.onClick) item.onClick();
            }
        }, menuItemContent);
        return menuItemContent;
    }))), footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19b86ddc2142d157$export$2e2bcd8739ae039), {
        flexDirection: "column",
        display: "flex",
        marginTop: "auto",
        "data-testid": "profile-menu-footer",
        gap: theme.palette.space.component.particle,
        role: "contentinfo",
        "aria-label": "Profile menu footer"
    }, getFooterItems(footer).map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7aa7f7fd6981187$export$2e2bcd8739ae039), {
            key: `footer-item-${index}`,
            variant: "caption"
        }, item.label, " ", item.value))));
};




var $acw62 = parcelRequire("acw62");
function $5b5aa24d1cdeb6fc$var$SvgFaviconApp(props) {
    return $acw62.createElement("svg", Object.assign({
        width: 56,
        height: 56,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $acw62.createElement("path", {
        d: "M.698 0h54.604c.385 0 .698.312.698.698v45.819A9.446 9.446 0 0146.523 56H.698A.698.698 0 010 55.295V.698C0 .312.313 0 .698 0z",
        fill: "#00B5D1"
    }), $acw62.createElement("path", {
        d: "M3 3h50v43.143A6.857 6.857 0 0146.143 53H3V3z",
        fill: "#00758D"
    }), $acw62.createElement("path", {
        d: "M18.951 40H12c0-11.397 2.958-18.632 2.958-18.632C13.997 33.628 18.951 40 18.951 40zM47 13s-22.052 9.01-26.14 27h18.56S26.087 36.39 47 13z",
        fill: "#fff"
    }));
}
var $5b5aa24d1cdeb6fc$export$2e2bcd8739ae039 = $5b5aa24d1cdeb6fc$var$SvgFaviconApp;



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e9a3624359562419$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4"
}), 'PermIdentity');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e49d9602abbd19b8$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m20.41 8.41-4.83-4.83c-.37-.37-.88-.58-1.41-.58H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.42M7 7h7v2H7zm10 10H7v-2h10zm0-4H7v-2h10z"
}), 'TextSnippet');



var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $0bd093982ef4cd64$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $0bd093982ef4cd64$var$SvgExitToApp(props) {
    return $0bd093982ef4cd64$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 00-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    })), props);
}
var $0bd093982ef4cd64$export$2e2bcd8739ae039 = $0bd093982ef4cd64$var$SvgExitToApp;


var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");
function $368290fe8628efa1$var$wrapWithSvgIcon(component, props) {
    return $acw62.createElement((0, $3ErGR.default), Object.assign({}, props), component);
}
function $368290fe8628efa1$var$SvgOpenInNew(props) {
    return $368290fe8628efa1$var$wrapWithSvgIcon($acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        width: 24
    }, props), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    })), props);
}
var $368290fe8628efa1$export$2e2bcd8739ae039 = $368290fe8628efa1$var$SvgOpenInNew;


const $c86cb51e53ca2de1$var$NavigationPanel = ({ email: email, name: name, logout: logout, serial: serial, build: build, authenticated: authenticated })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const pathname = window.location.pathname;
    const nav_options = !authenticated ? [] : [
        {
            name: 'Profile',
            initials: $c86cb51e53ca2de1$var$generateInitials(name),
            menu: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e37265b169f5c41f$export$b04dd99d751ebb47), {
                initials: $c86cb51e53ca2de1$var$generateInitials(name),
                name: name,
                email: email,
                menuItems: [
                    {
                        name: 'Manage account',
                        href: 'https://login.barracudanetworks.com/',
                        openInNewTab: true,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9a3624359562419$export$2e2bcd8739ae039), {}),
                        endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $368290fe8628efa1$export$2e2bcd8739ae039), {})
                    },
                    {
                        name: 'Privacy Policy',
                        href: 'https://www.barracuda.com/legal/privacy',
                        openInNewTab: true,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e49d9602abbd19b8$export$2e2bcd8739ae039), {})
                    },
                    {
                        name: 'Sign Out',
                        onClick: logout,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bd093982ef4cd64$export$2e2bcd8739ae039), {})
                    }
                ],
                footer: {
                    serial: serial,
                    version: build
                }
            })
        }
    ];
    const route_options = !authenticated ? [] : [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e9e37a860cfa953$export$214ae410b202e65a), {
            title: "WAFaaS",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5b5aa24d1cdeb6fc$export$2e2bcd8739ae039), {}),
            options: nav_options,
            routes: route_options,
            currentPath: pathname,
            onNavigate: (path)=>{
                navigate(path);
            }
        })
    });
};
var $c86cb51e53ca2de1$export$2e2bcd8739ae039 = $c86cb51e53ca2de1$var$NavigationPanel;
function $c86cb51e53ca2de1$var$generateInitials(name) {
    if (!name) return '';
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    // Handle empty string after trimming
    if (parts.length === 0) return '';
    // For single word
    if (parts.length === 1) {
        const word = parts[0];
        // If word has at least 2 characters, take first two
        if (word.length >= 2) return word.slice(0, 2).toUpperCase();
        // If word has only 1 character, return just that
        return word[0].toUpperCase();
    }
    // For multiple words, take first letter of first two words
    return (parts[0][0] + parts[1][0]).toUpperCase();
}






function $3fabe20ade4a0886$export$2e2bcd8739ae039() {
    const { state: state, dispatch: dispatch } = (0, $2ad2279805e583d1$export$6ccbb43953eebf8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const handleLogout = async ()=>{
        try {
            await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).get(`${(0, $efa0868a03d524fc$export$c3ee1e672e1e24e7)}/api/logout/`, {
                withCredentials: true
            });
        } catch (e) {
        // Ignore errors, proceed with logout
        }
        dispatch((0, $2ad2279805e583d1$export$a0973bcfe11b05c9)());
        window.location.href = (0, $efa0868a03d524fc$export$ff2cc6c005e01ca4);
        window.location.replace((0, $efa0868a03d524fc$export$ff2cc6c005e01ca4));
        console.log("Redirecting to logout URL:", (0, $efa0868a03d524fc$export$ff2cc6c005e01ca4));
        navigate("/login");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "base-layout",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
            style: {
                display: 'flex',
                height: '100vh',
                width: '100vw'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c86cb51e53ca2de1$export$2e2bcd8739ae039), {
                    email: state.user.email,
                    name: state.user.email,
                    logout: handleLogout,
                    authenticated: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    style: {
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");



function $eb38dfe79ad63906$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "base-layout",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
            style: {
                display: 'flex',
                height: '100vh',
                width: '100vw'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c86cb51e53ca2de1$export$2e2bcd8739ae039), {
                    email: '',
                    name: '',
                    authenticated: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    style: {
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
                })
            ]
        })
    });
}


function $8b488dbcce1c14ef$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/login",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a348570ca60b2ed3$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/scan/error",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05c4794dfd083e32$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd19b870fe618da7$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fabe20ade4a0886$export$2e2bcd8739ae039), {})
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/scan",
                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abd9f2afbe2680bb$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/scan-result/:uuid",
                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5cc98ed63bfbab01$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb38dfe79ad63906$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/public/scan-result/:uuid",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5cc98ed63bfbab01$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a348570ca60b2ed3$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");




var $ijOKP = parcelRequire("ijOKP");

var $7fcc7f5e18fb956e$export$2e2bcd8739ae039 = {
    // COMMON
    black: '#000000',
    white: '#FFFFFF',
    // CHART COLORS
    chartBlue: '#00B5D1',
    chartBlueDark: '#33A0D8',
    chartGray: '#425160',
    chartRed: '#F05336',
    chartBarracudaGreen: '#29A37A',
    chartBarracudaOrange: '#FFCC66',
    chartBarracudaLightBlue: '#0DCCF2',
    chartBarracudaDarkBlue: '#265973',
    chartBarracudalightPurple: '#B1A3F5',
    chartBarracudaDarkPurple: '#660AC2',
    chartBarracudaTan: '#E0CCB8',
    chartBarracudaMagenta: '#AD1FAD',
    chartBarracudaMossGreen: '#B1A3F5',
    chartBarracudaPink: '#F5A3F5',
    chartBarracudaDarkOranage: '#E65D19',
    chartBarracudaDarkBrown: '#734D26',
    // BLUE (Hue 200)
    blue050: '#E4F4FF',
    blue100: '#C8E9FF',
    blue200: '#A1D3F3',
    blue300: '#7CBDE6',
    blue400: '#56A7DA',
    blue500: '#2F92CE',
    blue600: '#067CC1',
    blue700: '#0A5D91',
    blue800: '#053C60',
    blue900: '#001D30',
    // COASTAL SAND
    coastalSand025: '#FAF9F4',
    coastalSand050: '#F5F3E9',
    coastalSand100: '#E9E6D9',
    coastalSand150: '#DED9C9',
    coastalSand200: '#D1CEBF',
    coastalSand300: '#B7B7A9',
    coastalSand400: '#9B9D93',
    coastalSand500: '#81827C',
    coastalSand600: '#676864',
    coastalSand700: '#4D4E4C',
    coastalSand800: '#343433',
    coastalSand900: '#1A1A1A',
    // DEEP OCEAN
    deepOcean050: '#E1E8F6',
    deepOcean100: '#CDD7EB',
    deepOcean150: '#BAC8E0',
    deepOcean200: '#A8B9D5',
    deepOcean025: '#F0F3FA',
    deepOcean300: '#8EA1BD',
    deepOcean400: '#7589A5',
    deepOcean500: '#5E728D',
    deepOcean600: '#4A5B76',
    deepOcean700: '#37465E',
    deepOcean800: '#263146',
    deepOcean900: '#1B1C23',
    // FOREST (Hue 140)
    forest050: '#DDF7E6',
    forest100: '#BDEFCE',
    forest200: '#93DAAB',
    forest300: '#6DC58B',
    forest400: '#49B06C',
    forest500: '#279B4F',
    forest600: '#088634',
    forest700: '#096528',
    forest800: '#04431A',
    forest900: '#00210B',
    // GREEN (Hue 100)
    green100: '#C4EDA7',
    green200: '#9FD86E',
    green300: '#82C341',
    green400: '#66AA28',
    green050: '#DBF6CA',
    green500: '#4E9018',
    green600: '#3B770E',
    green700: '#2B5E08',
    green800: '#1D4405',
    green900: '#112B03',
    // HUMPBACK GRAY
    humpbackGray025: '#F3F8FB',
    humpbackGray050: '#E7F1F6',
    humpbackGray100: '#D5E4EB',
    humpbackGray150: '#C4D8E1',
    humpbackGray200: '#B4CBD6',
    humpbackGray300: '#9BB3BE',
    humpbackGray400: '#829AA7',
    humpbackGray500: '#6B828F',
    humpbackGray600: '#566978',
    humpbackGray700: '#425160',
    humpbackGray800: '#333740',
    humpbackGray900: '#1D1D20',
    // INDIGO (Hue 230)
    indigo050: '#F1F3FB',
    indigo100: '#E4E7F6',
    indigo200: '#C8CDE5',
    indigo300: '#ADB3D4',
    indigo400: '#9199C3',
    indigo500: '#747EB2',
    indigo600: '#5460A1',
    indigo700: '#343F79',
    indigo800: '#182150',
    indigo900: '#040A28',
    // MAGENTA (Hue 320)
    magenta050: '#FFECFB',
    magenta100: '#FFD8F6',
    magenta200: '#FCB7E5',
    magenta300: '#F396D4',
    magenta400: '#E974C2',
    magenta500: '#E04FAF',
    magenta600: '#D6269B',
    magenta700: '#A11C74',
    magenta800: '#6B0D4C',
    magenta900: '#350124',
    // ORANGE (Hue 29)
    orange050v2: '#F8ECE7',
    orange050: '#FFEDD0',
    orange100: '#FFE6AE',
    orange200: '#FFD271',
    orange300: '#FFC63B',
    orange400: '#DDA021',
    orange500: '#BB7F11',
    orange600: '#996109',
    orange700: '#774705',
    orange800: '#563003',
    orange900: '#341C03',
    // PINK (Hue 305)
    pink050: '#FEEDFB',
    pink100: '#FDDCF8',
    pink200: '#EFBEE8',
    pink300: '#E19FD9',
    pink400: '#D481CA',
    pink500: '#C660BB',
    pink600: '#B83DAC',
    pink700: '#8A287F',
    pink800: '#5C1252',
    pink900: '#2E0328',
    // PURPLE (Hue 264)
    purple050: '#F5F1FB',
    purple100: '#EDE3F6',
    purple200: '#D9C8E5',
    purple300: '#C6ACD4',
    purple400: '#B390C3',
    purple500: '#A273B2',
    purple600: '#9253A1',
    purple700: '#643479',
    purple800: '#3A1750',
    purple900: '#160428',
    // RED (Hue 0)
    red050: '#FFEEEE',
    red100: '#FFDDDD',
    red200: '#FFBEBE',
    red300: '#F79F9F',
    red400: '#EF7E7E',
    red500: '#E65A5A',
    red600: '#DE3131',
    red700: '#A72323',
    red800: '#6F1010',
    red900: '#380202',
    // RED ORANGE (Hue 18)
    redOrange050: '#FFE8DA',
    redOrange100: '#FFDAC4',
    redOrange200: '#FFB892',
    redOrange300: '#FF9563',
    redOrange400: '#FF763B',
    redOrange500: '#DF5C24',
    redOrange600: '#B94615',
    redOrange700: '#90330C',
    redOrange800: '#652307',
    redOrange900: '#3A1404',
    // ROSE (Hue 346)
    rose050: '#FFEDF1',
    rose100: '#FFDCE3',
    rose200: '#F6BDC7',
    rose300: '#EB9EAA',
    rose400: '#E07E8C',
    rose500: '#D45C6B',
    rose600: '#C93645',
    rose700: '#972534',
    rose800: '#64111F',
    rose900: '#32020C',
    // SCALE GRAY
    scaleGray025: '#F7F7F7',
    scaleGray050: '#EFF0EF',
    scaleGray100: '#E2E2E1',
    scaleGray150: '#D4D4D3',
    scaleGray200: '#C8C8C7',
    scaleGray300: '#AFAFAE',
    scaleGray400: '#969695',
    scaleGray500: '#7D7D7D',
    scaleGray600: '#646464',
    scaleGray700: '#4B4B4B',
    scaleGray800: '#323232',
    scaleGray900: '#191919',
    // SKY BLUE (Hue 190)
    skyBlue050: '#CEF6FD',
    skyBlue100: '#9EEDFC',
    skyBlue200: '#66DAEE',
    skyBlue300: '#31C7DF',
    skyBlue400: '#00B5D1',
    skyBlue500: '#0F98AE',
    skyBlue600: '#147A8B',
    skyBlue700: '#105B69',
    skyBlue800: '#073C46',
    skyBlue900: '#011D23',
    // TEAL (Hue 168)
    teal050: '#C2F6EC',
    teal100: '#96EEDE',
    teal200: '#57D9C4',
    teal300: '#25C5AD',
    teal400: '#00B098',
    teal500: '#009680',
    teal600: '#007B68',
    teal700: '#006151',
    teal800: '#00473A',
    teal900: '#012C24',
    // VIOLET (Hue 290)
    violet050: '#FCEFFF',
    violet100: '#F9DFFE',
    violet200: '#E9C2F1',
    violet300: '#DAA5E4',
    violet400: '#CA87D7',
    violet500: '#B967CA',
    violet600: '#A944BD',
    violet700: '#971CB0',
    violet800: '#640D75',
    violet900: '#31013B',
    // YELLOW (Hue 57)
    yellow050: '#FFFCD1',
    yellow100: '#FEFAB3',
    yellow200: '#F2EB7B',
    yellow300: '#E6DC4C',
    yellow400: '#C8BE2F',
    yellow500: '#A9A11C',
    yellow600: '#8B8410',
    yellow700: '#6D6709',
    yellow800: '#4E4A05',
    yellow900: '#302E03',
    highlightYellow: '#FFF0A3',
    // YELLOW GREEN (Hue 64)
    yellowGreen050: '#F4F5E1',
    yellowGreen100: '#E9EBC5',
    yellowGreen200: '#D1D59E',
    yellowGreen300: '#BABE7A',
    yellowGreen400: '#A3A758',
    yellowGreen500: '#8C9138',
    yellowGreen600: '#757A1A',
    yellowGreen700: '#575C13',
    yellowGreen800: '#3A3D09',
    yellowGreen900: '#1D1E01',
    // ----------------------
    // OLD UI COLORS - should get phased out.
    barracudaBlue: '#0088CE',
    barracudaBlue40: '#99CFEB',
    barracudaBlue60: '#66B8E2',
    barracudaBlue80: '#33A0D8',
    barracudaBlueDark: '#007AB8',
    barracudaTeal: '#00B098',
    barracudaTeal40: '#99DFD6',
    barracudaTeal60: '#66D0C1',
    barracudaTeal80: '#33C0AD',
    barracudaTealDark: '#009984',
    skyBlue: '#00B5D1',
    skyBlue40: '#99E1ED',
    skyBlue60: '#66D3E3',
    skyBlue80: '#33C4DA',
    skyBlueDark: '#009CB4',
    barracudaBlack: '#000006',
    barracudaBlack30: '#B2B2B2',
    barracudaBlack50: '#7F7F82',
    barracudaBlack70: '#4C4C50',
    barracudaBlack90: '#19191E',
    backgroundDark: '#1D1E2B',
    backgroundLight: '#F7F7F7',
    disabled: '#AAAAAA',
    disabledText: '#DDDDDD',
    uiElement: '#DDDDDD',
    hoverGray: '#EDEDED',
    hoverBlue: '#D8ECF7',
    hoverBorder: '#6E6E6E',
    overlay: 'rgba(0, 0, 6, 0.5)',
    statusCritical: '#E34050',
    statusWarning: '#EEAA48',
    statusSuccess: '#95CC66',
    statusInformational: '#5F5F5F',
    bgEmailProtection: '#172619',
    bgAppCloudSecurity: '#002D3B',
    bgNetworkSecurity: '#161521',
    bgDataProtection: '#28160D',
    breakerWhite: '#FFFFFF',
    scaleGray: '#D4D4D3',
    coastalSand: '#DED9C9',
    sunriseYellow: '#FFF387',
    starfishOrange: '#FDB913',
    seagrassGreen: '#82C341',
    coralOrange: '#F05336',
    octopusPurple: '#9253A1',
    humpbackGray: '#425160',
    deepOcean: '#263146'
};


const $d351e5d3980944f1$var$alertPalette = (tokens)=>{
    return {
        padding: tokens.alertPadding,
        spaceBetween: tokens.alertSpaceBetween,
        boxShadow: {
            inline: tokens.alertBoxShadowInline,
            floating: tokens.alertBoxShadowFloating
        },
        border: {
            width: tokens.alertBorderWidth,
            radius: tokens.alertRadius
        },
        neutral: {
            text: tokens.alertColorTextNeutral,
            error: {
                text: tokens.alertColorTextErrorNeutral,
                background: tokens.alertColorBgErrorNeutral,
                border: tokens.alertColorBorderErrorNeutral
            },
            warning: {
                background: tokens.alertColorBgWarningNeutral,
                border: tokens.alertColorBorderWarningNeutral
            },
            info: {
                background: tokens.alertColorBgInfoNeutral,
                border: tokens.alertColorBorderInfoNeutral
            },
            success: {
                background: tokens.alertColorBgSuccessNeutral,
                border: tokens.alertColorBorderSuccessNeutral
            }
        },
        emphasis: {
            text: tokens.aliasesColorTextStaticInverse,
            info: {
                background: tokens.alertColorBgInfoEmphasis,
                border: tokens.alertColorBorderInfoEmphasis
            }
        },
        font: {
            family: tokens.alertFontFamily,
            size: tokens.aliasesFontSizeDefault,
            weight: tokens.aliasesFontWeightDefault,
            lineHeight: tokens.aliasesLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault,
            title: {
                size: tokens.alertTitleFontSize,
                weight: tokens.alertTitleFontWeight,
                lineHeight: tokens.alertTitleLineHeight
            }
        }
    };
};
var $d351e5d3980944f1$export$2e2bcd8739ae039 = $d351e5d3980944f1$var$alertPalette;


const $a66003c32b50e10c$var$avatarPalette = (tokens)=>{
    return {
        font: {
            family: tokens.avatarFontFamily,
            weight: tokens.avatarFontWeight,
            fontWeight: tokens.avatarFontWeight,
            letterSpacing: tokens.avatarLetterSpacing,
            textTransform: tokens.avatarTextCase
        },
        border: {
            width: tokens.avatarBorderWidthDefault,
            radius: tokens.avatarRadiusRound
        },
        size: {
            small: {
                width: tokens.avatarSizeS,
                height: tokens.avatarSizeS,
                font: {
                    size: tokens.avatarFontSizeS,
                    lineHeight: tokens.avatarLineHeightS
                }
            },
            medium: {
                width: tokens.avatarSizeM,
                height: tokens.avatarSizeM,
                font: {
                    size: tokens.avatarFontSizeM,
                    lineHeight: tokens.avatarLineHeightM
                }
            },
            large: {
                width: tokens.avatarSizeL,
                height: tokens.avatarSizeL,
                font: {
                    size: tokens.avatarFontSizeL,
                    lineHeight: tokens.avatarLineHeightL
                }
            },
            xlarge: {
                width: tokens.avatarSizeXl,
                height: tokens.avatarSizeXl,
                font: {
                    size: tokens.avatarFontSizeXl,
                    lineHeight: tokens.avatarLineHeightXl
                }
            },
            xxlarge: {
                width: tokens.avatarSizeXxl,
                height: tokens.avatarSizeXxl,
                font: {
                    size: tokens.avatarFontSizeXxl,
                    lineHeight: tokens.avatarLineHeightXxl
                }
            }
        },
        static: {
            neutral: {
                background: tokens.avatarColorBgStaticNeutral,
                border: tokens.avatarColorBorderStaticNeutral,
                text: tokens.avatarColorTextStaticNeutral
            },
            emphasis: {
                background: tokens.avatarColorBgStaticEmphasis,
                border: tokens.avatarColorBorderStaticEmphasis,
                text: tokens.avatarColorTextStaticEmphasis
            },
            subtle: {
                background: tokens.avatarColorBgStaticSubtle,
                border: tokens.avatarColorBorderStaticSubtle,
                text: tokens.avatarColorTextStaticSubtle
            }
        },
        interactive: {
            emphasis: {
                background: {
                    default: tokens.avatarColorBgInteractiveEmphasisDefault,
                    disabled: tokens.avatarColorBgInteractiveDisabled,
                    focus: tokens.avatarColorBgInteractiveEmphasisFocus,
                    hover: tokens.avatarColorBgInteractiveEmphasisHover,
                    selected: {
                        default: tokens.avatarColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.avatarColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.avatarColorBorderInteractiveEmphasisDefault,
                    disabled: tokens.avatarColorBorderInteractiveDisabled,
                    focus: tokens.avatarColorBorderInteractiveEmphasisFocus,
                    hover: tokens.avatarColorBorderInteractiveEmphasisHover,
                    selected: {
                        default: tokens.avatarColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.avatarColorBorderInteractiveEmphasisSelectedHover
                    }
                },
                text: {
                    default: tokens.avatarColorTextInteractiveEmphasis,
                    disabled: tokens.avatarColorTextInteractiveDisabled
                }
            },
            neutral: {
                background: {
                    default: tokens.avatarColorBgInteractiveNeutralDefault,
                    disabled: tokens.avatarColorBgInteractiveDisabled,
                    focus: tokens.avatarColorBgInteractiveNeutralFocus,
                    hover: tokens.avatarColorBgInteractiveNeutralHover,
                    selected: {
                        default: tokens.avatarColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.avatarColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.avatarColorBorderInteractiveNeutralDefault,
                    disabled: tokens.avatarColorBorderInteractiveDisabled,
                    focus: tokens.avatarColorBorderInteractiveNeutralFocus,
                    hover: tokens.avatarColorBorderInteractiveNeutralHover,
                    selected: {
                        default: tokens.avatarColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.avatarColorBorderInteractiveNeutralSelectedHover
                    }
                },
                text: {
                    default: tokens.avatarColorTextInteractiveNeutral,
                    disabled: tokens.avatarColorTextInteractiveDisabled
                }
            },
            subtle: {
                background: {
                    default: tokens.avatarColorBgInteractiveSubtleDefault,
                    disabled: tokens.avatarColorBgInteractiveDisabled,
                    focus: tokens.avatarColorBgInteractiveSubtleFocus,
                    hover: tokens.avatarColorBgInteractiveSubtleHover,
                    selected: {
                        default: tokens.avatarColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.avatarColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.avatarColorBorderInteractiveSubtleDefault,
                    disabled: tokens.avatarColorBorderInteractiveDisabled,
                    focus: tokens.avatarColorBorderInteractiveSubtleFocus,
                    hover: tokens.avatarColorBorderInteractiveSubtleHover,
                    selected: {
                        default: tokens.avatarColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.avatarColorBorderInteractiveSubtleSelectedHover
                    }
                },
                text: {
                    default: tokens.avatarColorTextInteractiveSubtle,
                    disabled: tokens.avatarColorTextInteractiveDisabled
                }
            },
            disabled: {
                background: tokens.avatarColorBgInteractiveDisabled,
                border: tokens.avatarColorBorderInteractiveDisabled,
                text: tokens.avatarColorTextInteractiveDisabled
            }
        }
    };
};
var $a66003c32b50e10c$export$2e2bcd8739ae039 = $a66003c32b50e10c$var$avatarPalette;


const $56642ff99bf45454$var$badgePalette = (tokens)=>{
    return {
        font: {
            family: tokens.badgeFontFamily,
            weight: tokens.badgeFontWeight
        },
        size: {
            medium: {
                border: {
                    radius: tokens.badgeSizeMediumRadiusRound,
                    width: tokens.badgeSizeMediumBorderWidth
                },
                height: tokens.badgeSizeMediumMinHeight,
                paddingLeft: tokens.badgeSizeMediumPaddingLeft,
                paddingRight: tokens.badgeSizeMediumPaddingRight,
                font: {
                    size: tokens.badgeMFontSize,
                    lineHeight: tokens.badgeMLineHeight
                }
            },
            small: {
                border: {
                    radius: tokens.badgeSizeSmallRadiusRound
                },
                height: tokens.badgeSizeSmallMinHeight,
                paddingLeft: tokens.badgeSizeSmallPaddingLeft,
                paddingRight: tokens.badgeSizeSmallPaddingRight,
                font: {
                    size: tokens.badgeSFontSize,
                    lineHeight: tokens.badgeSLineHeight
                }
            },
            input: {
                height: tokens.badgeSizeInputMinHeight,
                font: {
                    size: tokens.badgeInputFontSize,
                    lineHeight: tokens.badgeInputLineHeight
                }
            }
        },
        interactive: {
            neutral: {
                text: tokens.badgeColorTextInteractiveNeutral,
                background: {
                    default: tokens.badgeColorBgInteractiveNeutralDefault,
                    hover: tokens.badgeColorBgInteractiveNeutralHover,
                    focus: tokens.badgeColorBgInteractiveNeutralFocus,
                    disabled: tokens.badgeColorBgInteractiveNeutralDisabled,
                    selected: {
                        default: tokens.badgeColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.badgeColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.badgeColorBorderInteractiveNeutralDefault,
                    hover: tokens.badgeColorBorderInteractiveNeutralHover,
                    focus: tokens.badgeColorBorderInteractiveNeutralFocus,
                    disabled: tokens.badgeColorBorderInteractiveNeutralDisabled,
                    selected: {
                        default: tokens.badgeColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.badgeColorBorderInteractiveNeutralSelectedHover
                    }
                }
            },
            subtle: {
                text: tokens.badgeColorTextInteractiveSubtle,
                background: {
                    default: tokens.badgeColorBgInteractiveSubtleDefault,
                    hover: tokens.badgeColorBgInteractiveSubtleHover,
                    focus: tokens.badgeColorBgInteractiveSubtleFocus,
                    disabled: tokens.badgeColorBgInteractiveSubtleDisabled,
                    selected: {
                        default: tokens.badgeColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.badgeColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.badgeColorBorderInteractiveSubtleDefault,
                    hover: tokens.badgeColorBorderInteractiveSubtleHover,
                    focus: tokens.badgeColorBorderInteractiveSubtleFocus,
                    disabled: tokens.badgeColorBorderInteractiveSubtleDisabled,
                    selected: {
                        default: tokens.badgeColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.badgeColorBorderInteractiveSubtleSelectedHover
                    }
                }
            },
            emphasis: {
                text: tokens.badgeColorTextInteractiveEmphasis,
                background: {
                    default: tokens.badgeColorBgInteractiveEmphasisDefault,
                    hover: tokens.badgeColorBgInteractiveEmphasisHover,
                    focus: tokens.badgeColorBgInteractiveEmphasisFocus,
                    disabled: tokens.badgeColorBgInteractiveEmphasisDisabled,
                    selected: {
                        default: tokens.badgeColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.badgeColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.badgeColorBorderInteractiveEmphasisDefault,
                    hover: tokens.badgeColorBorderInteractiveEmphasisHover,
                    focus: tokens.badgeColorBorderInteractiveEmphasisFocus,
                    disabled: tokens.badgeColorBorderInteractiveEmphasisDisabled,
                    selected: {
                        default: tokens.badgeColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.badgeColorBorderInteractiveEmphasisSelectedHover
                    }
                }
            }
        },
        error: {
            subtle: {
                text: tokens.badgeColorTextErrorSubtle,
                background: tokens.badgeColorBgErrorSubtle,
                border: tokens.badgeColorBorderErrorSubtle
            }
        },
        static: {
            subtle: {
                text: tokens.badgeColorTextStaticSubtle,
                background: tokens.badgeColorBgStaticSubtle,
                border: tokens.badgeColorBorderStaticSubtle
            },
            emphasis: {
                text: tokens.badgeColorTextStaticEmphasis,
                background: tokens.badgeColorBgStaticEmphasis,
                border: tokens.badgeColorBorderStaticEmphasis
            },
            neutral: {
                background: tokens.badgeColorBgStaticNeutral,
                border: tokens.badgeColorBorderStaticNeutral
            }
        }
    };
};
var $56642ff99bf45454$export$2e2bcd8739ae039 = $56642ff99bf45454$var$badgePalette;


const $77a15c8f4ff219cb$var$buttonPalette = (tokens)=>{
    return {
        padding: tokens.buttonPadding,
        borderWidth: tokens.buttonBorderWidth,
        spaceBetween: tokens.buttonSpaceBetween,
        radius: tokens.buttonRadius,
        height: tokens.buttonHeightDefault,
        font: {
            family: tokens.buttonFontFamily,
            size: tokens.buttonFontSize,
            weight: tokens.buttonFontWeight,
            lineHeight: tokens.buttonLineHeight,
            letterSpacing: tokens.buttonLetterSpacing
        },
        actionBar: {
            background: {
                default: tokens.buttonColorBgActionBarDefault,
                hover: tokens.buttonColorBgActionBarHover,
                focus: tokens.buttonColorBgActionBarFocus,
                disabled: tokens.buttonColorBgDisabled
            },
            border: {
                default: tokens.buttonColorBorderActionBarDefault,
                hover: tokens.buttonColorBorderActionBarHover,
                focus: tokens.buttonColorBorderActionBarFocus,
                disabled: tokens.buttonColorBorderDisabled
            },
            text: tokens.buttonColorTextActionBar
        },
        interactive: {
            subtle: {
                background: {
                    default: tokens.buttonColorBgSubtleDefault,
                    hover: tokens.buttonColorBgSubtleHover,
                    focus: tokens.buttonColorBgSubtleFocus,
                    disabled: tokens.buttonColorBgDisabled,
                    selected: {
                        default: tokens.buttonColorBgSubtleSelectedDefault,
                        hover: tokens.buttonColorBgSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.buttonColorBorderSubtleDefault,
                    hover: tokens.buttonColorBorderSubtleHover,
                    focus: tokens.buttonColorBorderSubtleFocus,
                    disabled: tokens.buttonColorBorderDisabled,
                    selected: {
                        default: tokens.buttonColorBorderSubtleSelectedDefault,
                        hover: tokens.buttonColorBorderSubtleSelectedHover
                    }
                },
                text: tokens.buttonColorTextSubtle,
                icon: {
                    default: tokens.iconColorInteractiveCtaSubtleDefault,
                    disabled: tokens.iconColorInteractiveCtaDisabled
                }
            },
            emphasis: {
                background: {
                    default: tokens.buttonColorBgEmphasisDefault,
                    hover: tokens.buttonColorBgEmphasisHover,
                    focus: tokens.buttonColorBgEmphasisFocus,
                    disabled: tokens.buttonColorBgDisabled,
                    selected: {
                        default: tokens.buttonColorBgEmphasisSelectedDefault,
                        hover: tokens.buttonColorBgEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.buttonColorBorderEmphasisDefault,
                    hover: tokens.buttonColorBorderEmphasisHover,
                    focus: tokens.buttonColorBorderEmphasisFocus,
                    disabled: tokens.buttonColorBorderDisabled,
                    selected: {
                        default: tokens.buttonColorBorderEmphasisSelectedDefault,
                        hover: tokens.buttonColorBorderEmphasisSelectedHover
                    }
                },
                text: tokens.buttonColorTextEmphasis,
                icon: {
                    default: tokens.iconColorInteractiveCtaEmphasisDefault,
                    disabled: tokens.iconColorInteractiveCtaDisabled
                }
            },
            neutral: {
                background: {
                    default: tokens.buttonColorBgNeutralDefault,
                    hover: tokens.buttonColorBgNeutralHover,
                    focus: tokens.buttonColorBgNeutralFocus,
                    disabled: tokens.buttonColorBgDisabled,
                    selected: {
                        default: tokens.buttonColorBgNeutralSelectedDefault,
                        hover: tokens.buttonColorBgNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.buttonColorBorderNeutralDefault,
                    hover: tokens.buttonColorBorderNeutralHover,
                    focus: tokens.buttonColorBorderNeutralFocus,
                    disabled: tokens.buttonColorBorderDisabled,
                    selected: {
                        default: tokens.buttonColorBorderNeutralSelectedDefault,
                        hover: tokens.buttonColorBorderNeutralSelectedHover
                    }
                },
                text: tokens.buttonColorTextNeutral,
                icon: {
                    default: tokens.iconColorInteractiveCtaNeutralDefault,
                    disabled: tokens.iconColorInteractiveCtaDisabled
                }
            }
        }
    };
};
var $77a15c8f4ff219cb$export$2e2bcd8739ae039 = $77a15c8f4ff219cb$var$buttonPalette;


const $cee12c1b7e20bf42$var$cardPalette = (tokens)=>{
    return {
        border: {
            width: {
                default: tokens.cardBorderWidthDefault,
                none: tokens.cardBorderWidthNone
            },
            radius: {
                default: tokens.cardBorderRadiusDefault,
                sharp: tokens.cardBorderRadiusSharp,
                round: tokens.cardBorderRadiusRound
            }
        },
        boxShadow: {
            default: tokens.cardBoxShadowDefault,
            floating: tokens.cardBoxShadowFloating
        },
        padding: {
            default: tokens.cardSpaceDefault,
            dense: tokens.cardSpaceDense,
            spacious: tokens.cardSpaceSpacious
        },
        interactive: {
            subtle: {
                background: {
                    default: tokens.cardColorBgInteractiveSubtleDefault,
                    hover: tokens.cardColorBgInteractiveSubtleHover,
                    focus: tokens.cardColorBgInteractiveSubtleFocus,
                    selected: {
                        default: tokens.cardColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.cardColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.cardColorBorderInteractiveSubtleDefault,
                    hover: tokens.cardColorBorderInteractiveSubtleHover,
                    focus: tokens.cardColorBorderInteractiveSubtleFocus,
                    selected: {
                        default: tokens.cardColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.cardColorBorderInteractiveSubtleSelectedHover
                    }
                }
            },
            emphasis: {
                background: {
                    default: tokens.cardColorBgInteractiveEmphasisDefault,
                    hover: tokens.cardColorBgInteractiveEmphasisHover,
                    focus: tokens.cardColorBgInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.cardColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.cardColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.cardColorBorderInteractiveEmphasisDefault,
                    hover: tokens.cardColorBorderInteractiveEmphasisHover,
                    focus: tokens.cardColorBorderInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.cardColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.cardColorBorderInteractiveEmphasisSelectedHover
                    }
                }
            },
            neutral: {
                background: {
                    default: tokens.cardColorBgInteractiveNeutralDefault,
                    hover: tokens.cardColorBgInteractiveNeutralHover,
                    focus: tokens.cardColorBgInteractiveNeutralFocus,
                    selected: {
                        default: tokens.cardColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.cardColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.cardColorBorderInteractiveNeutralDefault,
                    hover: tokens.cardColorBorderInteractiveNeutralHover,
                    focus: tokens.cardColorBorderInteractiveNeutralFocus,
                    selected: {
                        default: tokens.cardColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.cardColorBorderInteractiveNeutralSelectedHover
                    }
                }
            },
            disabled: {
                background: tokens.cardColorBgInteractiveDisabled,
                border: tokens.cardColorBorderInteractiveDisabled
            }
        },
        static: {
            subtle: {
                background: {
                    default: tokens.cardColorBgStaticSubtle
                },
                border: {
                    default: tokens.cardColorBorderStaticSubtle
                }
            },
            emphasis: {
                background: {
                    default: tokens.cardColorBgStaticEmphasis
                },
                border: {
                    default: tokens.cardColorBorderStaticEmphasis
                }
            },
            neutral: {
                background: {
                    default: tokens.cardColorBgStaticNeutral
                },
                border: {
                    default: tokens.cardColorBorderStaticNeutral
                }
            }
        }
    };
};
var $cee12c1b7e20bf42$export$2e2bcd8739ae039 = $cee12c1b7e20bf42$var$cardPalette;


const $90f69bedd3a89f82$var$chipPalette = (tokens)=>{
    return {
        font: {
            family: tokens.chipFontFamily,
            weight: tokens.chipFontWeight,
            letterSpacing: tokens.chipLetterSpacing
        },
        size: {
            medium: {
                height: tokens.chipSizeMediumHeight,
                padding: {
                    right: tokens.chipSizeMediumPaddingRight,
                    left: tokens.chipSizeMediumPaddingLeft
                },
                spaceBetween: tokens.chipSizeMediumSpaceBetween,
                fontSize: tokens.chipMFontSize
            },
            large: {
                height: tokens.chipSizeLargeHeight,
                padding: {
                    right: tokens.chipSizeLargePaddingRight,
                    left: tokens.chipSizeLargePaddingLeft
                },
                spaceBetween: tokens.chipSizeLargeSpaceBetween,
                fontSize: tokens.chipLFontSize
            },
            input: {
                height: tokens.chipSizeInputHeight,
                padding: {
                    right: tokens.chipSizeInputPaddingRight,
                    left: tokens.chipSizeInputPaddingLeft
                },
                spaceBetween: tokens.chipSizeInputSpaceBetween,
                fontSize: tokens.chipInputFontSize
            }
        },
        radius: tokens.chipRadiusRound,
        border: {
            width: tokens.chipBorderWidth
        },
        // START TODO: talk to Ann about naming conventions
        text: {
            disabled: tokens.chipColorTextDisabled,
            error: tokens.chipColorTextErrorSubtle
        },
        // END TODO: talk to Ann about naming conventions
        static: {
            neutral: {
                text: {
                    default: tokens.chipColorTextStaticNeutral,
                    error: tokens.chipColorTextErrorSubtle,
                    success: tokens.chipColorTextStaticNeutral,
                    warning: tokens.chipColorTextStaticNeutral,
                    info: tokens.chipColorTextStaticNeutral
                },
                background: {
                    default: tokens.chipColorBgStaticNeutralDefault,
                    success: tokens.chipColorBgStaticNeutralSuccess,
                    warning: tokens.chipColorBgStaticNeutralWarning,
                    error: tokens.chipColorBgStaticNeutralError,
                    info: tokens.chipColorBgStaticNeutralInfo
                },
                border: {
                    default: tokens.chipColorBorderStaticNeutralDefault,
                    success: tokens.chipColorBorderStaticNeutralSuccess,
                    warning: tokens.chipColorBorderStaticNeutralWarning,
                    error: tokens.chipColorBorderStaticNeutralError,
                    info: tokens.chipColorBorderStaticNeutralInfo
                }
            },
            emphasis: {
                text: {
                    default: tokens.chipColorTextStaticEmphasis,
                    error: tokens.chipColorTextStaticEmphasis,
                    success: tokens.chipColorTextStaticEmphasis,
                    warning: tokens.chipColorTextStaticEmphasis,
                    info: tokens.chipColorTextStaticEmphasis
                },
                background: {
                    default: tokens.chipColorBgStaticEmphasisDefault,
                    success: tokens.chipColorBgStaticEmphasisSuccess,
                    warning: tokens.chipColorBgStaticEmphasisWarning,
                    error: tokens.chipColorBgStaticEmphasisError,
                    info: tokens.chipColorBgStaticEmphasisInfo
                },
                border: {
                    default: tokens.chipColorBorderStaticEmphasisDefault,
                    success: tokens.chipColorBorderStaticEmphasisSuccess,
                    warning: tokens.chipColorBorderStaticEmphasisWarning,
                    error: tokens.chipColorBorderStaticEmphasisError,
                    info: tokens.chipColorBorderStaticEmphasisInfo
                }
            },
            // TODO: Talk to Ann, these all use the same
            subtle: {
                text: {
                    default: tokens.chipColorTextStaticSubtle,
                    error: tokens.chipColorTextStaticNeutral,
                    success: tokens.chipColorTextStaticSubtle,
                    warning: tokens.chipColorTextStaticSubtle,
                    info: tokens.chipColorTextStaticSubtle
                },
                background: {
                    default: tokens.chipColorBgStaticSubtle,
                    success: tokens.chipColorBgStaticSubtle,
                    warning: tokens.chipColorBgStaticSubtle,
                    error: tokens.chipColorBgStaticSubtle,
                    info: tokens.chipColorBgStaticSubtle
                },
                border: {
                    default: tokens.chipColorBorderStaticSubtle,
                    success: tokens.chipColorBorderStaticSubtle,
                    warning: tokens.chipColorBorderStaticSubtle,
                    error: tokens.chipColorBorderStaticSubtle,
                    info: tokens.chipColorBorderStaticSubtle
                }
            }
        },
        interactive: {
            neutral: {
                text: tokens.chipColorTextInteractiveNeutral,
                background: {
                    default: tokens.chipColorBgInteractiveNeutralDefault,
                    hover: tokens.chipColorBgInteractiveNeutralHover,
                    focus: tokens.chipColorBgInteractiveNeutralFocus,
                    selected: {
                        default: tokens.chipColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.chipColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.chipColorBorderInteractiveNeutralDefault,
                    hover: tokens.chipColorBorderInteractiveNeutralHover,
                    focus: tokens.chipColorBorderInteractiveNeutralFocus,
                    disabled: tokens.chipColorBorderInteractiveDisabled,
                    selected: {
                        default: tokens.chipColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.chipColorBorderInteractiveNeutralSelectedHover
                    }
                }
            },
            emphasis: {
                text: tokens.chipColorTextInteractiveEmphasis,
                background: {
                    default: tokens.chipColorBgInteractiveEmphasisDefault,
                    hover: tokens.chipColorBgInteractiveEmphasisHover,
                    focus: tokens.chipColorBgInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.chipColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.chipColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.chipColorBorderInteractiveEmphasisDefault,
                    hover: tokens.chipColorBorderInteractiveEmphasisHover,
                    focus: tokens.chipColorBorderInteractiveEmphasisFocus,
                    disabled: tokens.chipColorBorderInteractiveDisabled,
                    selected: {
                        default: tokens.chipColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.chipColorBorderInteractiveEmphasisSelectedHover
                    }
                }
            },
            subtle: {
                text: tokens.chipColorTextInteractiveSubtle,
                background: {
                    default: tokens.chipColorBgInteractiveSubtleDefault,
                    hover: tokens.chipColorBgInteractiveSubtleHover,
                    focus: tokens.chipColorBgInteractiveSubtleFocus,
                    selected: {
                        default: tokens.chipColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.chipColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.chipColorBorderInteractiveSubtleDefault,
                    hover: tokens.chipColorBorderInteractiveSubtleHover,
                    focus: tokens.chipColorBorderInteractiveSubtleFocus,
                    disabled: tokens.chipColorBorderInteractiveDisabled,
                    selected: {
                        default: tokens.chipColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.chipColorBorderInteractiveSubtleSelectedHover
                    }
                }
            },
            disabled: {
                background: tokens.chipColorBgInteractiveDisabled,
                border: tokens.chipColorBorderInteractiveDisabled
            }
        }
    };
};
var $90f69bedd3a89f82$export$2e2bcd8739ae039 = $90f69bedd3a89f82$var$chipPalette;


const $fcba45ae4d942e45$var$dialogPalette = (tokens)=>{
    return {
        padding: {
            dense: tokens.dialogPaddingDense,
            default: tokens.dialogPaddingDefault,
            spacious: tokens.dialogPaddingSpacious
        },
        width: {
            small: tokens.dialogSizeSWidth,
            medium: tokens.dialogSizeMWidth,
            large: tokens.dialogSizeLWidth
        },
        border: {
            width: tokens.dialogBorderWidth,
            radius: tokens.dialogRadius,
            color: {
                default: tokens.dialogColorBorderDefault
            }
        },
        background: {
            color: {
                default: tokens.dialogColorBgDefault
            }
        }
    };
};
var $fcba45ae4d942e45$export$2e2bcd8739ae039 = $fcba45ae4d942e45$var$dialogPalette;


const $03e1c3364b7a6336$var$dividerPalette = (tokens)=>{
    return {
        border: {
            width: tokens.dividerBorderWidth,
            color: tokens.dividerColor
        }
    };
};
var $03e1c3364b7a6336$export$2e2bcd8739ae039 = $03e1c3364b7a6336$var$dividerPalette;


const $284ab52022351cf0$export$1d244cf9afde24a9 = (tokens)=>{
    return {
        border: {
            width: tokens.iconButtonBorderWidth,
            radius: {
                round: tokens.iconButtonRadiusRound,
                rectangle: tokens.iconButtonRadiusRectangle
            }
        },
        size: {
            medium: tokens.iconButtonSizeRoundM,
            input: tokens.iconButtonSizeRoundInput,
            rectangle: {
                height: tokens.iconButtonSizeRectangleDefaultHeight,
                width: tokens.iconButtonSizeRectangleDefaultWidth
            }
        },
        interactive: {
            subtle: {
                menuOpen: {
                    background: tokens.iconButtonColorBgSubtleMenuOpen,
                    border: tokens.iconButtonColorBorderSubtleMenuOpen
                },
                main: tokens.iconButtonColorBgSubtleDefault,
                background: tokens.iconButtonColorBgSubtleDefault,
                border: tokens.iconButtonColorBorderSubtleDefault,
                hover: {
                    background: tokens.iconButtonColorBgSubtleHover,
                    border: tokens.iconButtonColorBorderSubtleHover
                },
                focus: {
                    background: tokens.iconButtonColorBgSubtleFocus,
                    border: tokens.iconButtonColorBorderSubtleFocus
                },
                disabled: {
                    background: tokens.iconButtonColorBgDisabled,
                    border: tokens.iconButtonColorBorderDisabled
                },
                selected: {
                    background: tokens.iconButtonColorBgSubtleSelectedDefault,
                    border: tokens.iconButtonColorBorderSubtleSelectedDefault,
                    hover: {
                        background: tokens.iconButtonColorBgSubtleSelectedHover,
                        border: tokens.iconButtonColorBorderSubtleSelectedHover
                    }
                }
            }
        }
    };
};
var $284ab52022351cf0$export$2e2bcd8739ae039 = $284ab52022351cf0$export$1d244cf9afde24a9;


const $a97d51c35d27f0b7$var$iconPalette = (tokens)=>{
    return {
        size: {
            micro: tokens.iconSizeMicro,
            xxsmall: tokens.iconSizeXxs,
            xsmall: tokens.iconSizeXs,
            small: tokens.iconSizeS,
            medium: tokens.iconSizeM,
            large: tokens.iconSizeL,
            xlarge: tokens.iconSizeXl,
            xxlarge: tokens.iconSizeXxl
        },
        static: {
            neutral: {
                color: {
                    default: tokens.iconColorStaticNeutral,
                    error: tokens.iconColorErrorNeutral,
                    warning: tokens.iconColorWarningNeutral,
                    info: tokens.iconColorInfoNeutral,
                    success: tokens.iconColorSuccessNeutral
                }
            },
            emphasis: {
                color: {
                    default: tokens.iconColorStaticEmphasis,
                    error: tokens.iconColorErrorNeutral,
                    warning: tokens.iconColorWarningNeutral,
                    info: tokens.iconColorInfoNeutral,
                    success: tokens.iconColorSuccessNeutral
                }
            },
            subtle: {
                color: {
                    default: tokens.iconColorStaticSubtle,
                    error: tokens.iconColorErrorSubtle,
                    warning: tokens.iconColorWarningSubtle,
                    info: tokens.iconColorInfoSubtle,
                    success: tokens.iconColorSuccessSubtle
                }
            }
        },
        interactive: {
            neutral: {
                color: {
                    default: tokens.iconColorInteractiveComponentNeutralDefault,
                    hover: tokens.iconColorInteractiveComponentNeutralHover,
                    focus: tokens.iconColorInteractiveComponentNeutralFocus,
                    disabled: tokens.iconColorInteractiveComponentNeutralDisabled,
                    selected: {
                        default: tokens.iconColorInteractiveComponentNeutralSelectedDefault,
                        hover: tokens.iconColorInteractiveComponentNeutralSelectedHover
                    }
                }
            },
            emphasis: {
                color: {
                    default: tokens.iconColorInteractiveComponentEmphasisDefault,
                    hover: tokens.iconColorInteractiveComponentEmphasisHover,
                    focus: tokens.iconColorInteractiveComponentEmphasisFocus,
                    disabled: tokens.iconColorInteractiveComponentEmphasisDisabled,
                    selected: {
                        default: tokens.iconColorInteractiveComponentEmphasisSelectedDefault,
                        hover: tokens.iconColorInteractiveComponentEmphasisSelectedHover
                    }
                }
            },
            subtle: {
                color: {
                    default: tokens.iconColorInteractiveComponentSubtleDefault,
                    hover: tokens.iconColorInteractiveComponentSubtleHover,
                    focus: tokens.iconColorInteractiveComponentSubtleFocus,
                    disabled: tokens.iconColorInteractiveComponentSubtleDisabled,
                    selected: {
                        default: tokens.iconColorInteractiveComponentSubtleSelectedDefault,
                        hover: tokens.iconColorInteractiveComponentSubtleSelectedHover
                    }
                }
            }
        },
        error: {
            neutral: {
                color: tokens.iconColorErrorNeutral
            }
        },
        warning: {
            neutral: {
                color: tokens.iconColorWarningNeutral
            }
        },
        success: {
            neutral: {
                color: tokens.iconColorSuccessNeutral
            }
        },
        info: {
            neutral: {
                color: tokens.iconColorInfoNeutral
            }
        }
    };
};
var $a97d51c35d27f0b7$export$2e2bcd8739ae039 = $a97d51c35d27f0b7$var$iconPalette;


const $4c5f0a3878c8720e$var$linearProgressPalette = (tokens)=>{
    return {
        height: tokens.linearSizeSMinHeight,
        fill: {
            border: {
                radius: tokens.linearFillRadius,
                width: tokens.linearFillBorderWidth,
                default: tokens.progressFillColorBorderDefault,
                error: tokens.progressFillColorBorderError
            },
            background: {
                default: tokens.progressFillColorBgDefault,
                error: tokens.progressFillColorBgError
            }
        },
        container: {
            border: {
                radius: tokens.linearContainerRadius,
                width: tokens.linearContainerBorderWidth,
                default: tokens.progressContainerColorBorder
            },
            background: {
                default: tokens.progressContainerColorBg
            }
        }
    };
};
var $4c5f0a3878c8720e$export$2e2bcd8739ae039 = $4c5f0a3878c8720e$var$linearProgressPalette;


const $d320b5a01b7a514f$var$linkPalette = (tokens)=>{
    return {
        font: {
            family: tokens.linkFontFamily,
            weight: tokens.linkFontWeight,
            letterSpacing: tokens.linkLetterSpacing,
            caption: {
                size: tokens.linkFontSizeCaption,
                lineHeight: tokens.linkLineHeightCaption
            },
            default: {
                size: tokens.linkFontSizeDefault,
                lineHeight: tokens.linkLineHeightDefault
            }
        },
        background: {
            default: tokens.linkColorBgDefault,
            hover: tokens.linkColorBgHover,
            focus: tokens.linkColorBgFocus,
            disabled: tokens.linkColorBgDisabled
        },
        text: {
            default: tokens.linkColorTextDefault,
            hover: tokens.linkColorTextHover,
            focus: tokens.linkColorTextFocus,
            disabled: tokens.linkColorTextDisabled,
            visited: tokens.linkColorTextVisited
        }
    };
};
var $d320b5a01b7a514f$export$2e2bcd8739ae039 = $d320b5a01b7a514f$var$linkPalette;


const $92b07c7988c9e1a7$var$listItemPalette = (tokens)=>{
    return {
        size: {
            height: {
                small: tokens.listItemHeightS,
                medium: tokens.listItemHeightM,
                large: tokens.listItemHeightL
            }
        },
        padding: {
            dense: tokens.listItemSpaceDense,
            default: tokens.listItemSpaceDefault,
            spacious: tokens.listItemSpaceSpacious
        },
        border: {
            radius: tokens.listItemRadiusDefault,
            width: {
                bottom: {
                    default: tokens.listItemBorderWidthBottomDefault,
                    separated: tokens.listItemBorderWidthBottomSeparated
                }
            }
        },
        static: {
            text: {
                color: {
                    default: tokens.listItemColorTextStatic,
                    inverse: tokens.listItemColorTextInverse
                }
            },
            border: {
                color: {
                    default: tokens.listItemColorBorderStaticDefault,
                    bottom: {
                        default: tokens.listItemColorBorderStaticBottomborderDefault,
                        inverse: tokens.listItemColorBorderStaticBottomborderInverse
                    }
                }
            },
            subtle: {
                background: {
                    color: {
                        default: tokens.listItemColorBgStaticSubtle
                    }
                }
            },
            neutral: {
                background: {
                    color: {
                        default: tokens.listItemColorBgStaticNeutral
                    }
                }
            },
            emphasis: {
                background: {
                    color: {
                        default: tokens.listItemColorBgStaticEmphasis
                    }
                }
            }
        },
        interactive: {
            text: {
                color: {
                    default: tokens.listItemColorTextInteractive,
                    selected: tokens.listItemColorTextSelected,
                    inverse: tokens.listItemColorTextInverse
                }
            },
            border: {
                color: {
                    selected: tokens.listItemColorBorderInteractiveSelected,
                    default: tokens.listItemColorBorderInteractiveDefault
                }
            },
            subtle: {
                background: {
                    color: {
                        default: tokens.listItemColorBgInteractiveSubtleDefault,
                        hover: tokens.listItemColorBgInteractiveSubtleHover,
                        focus: tokens.listItemColorBgInteractiveSubtleFocus,
                        selected: {
                            default: tokens.listItemColorBgInteractiveSubtleSelectedDefault,
                            hover: tokens.listItemColorBgInteractiveSubtleSelectedHover
                        }
                    }
                }
            },
            neutral: {
                background: {
                    color: {
                        default: tokens.listItemColorBgInteractiveNeutralDefault,
                        hover: tokens.listItemColorBgInteractiveNeutralHover,
                        focus: tokens.listItemColorBgInteractiveNeutralFocus,
                        selected: {
                            default: tokens.listItemColorBgInteractiveNeutralSelectedDefault,
                            hover: tokens.listItemColorBgInteractiveNeutralSelectedHover
                        }
                    }
                }
            },
            emphasis: {
                background: {
                    color: {
                        default: tokens.listItemColorBgInteractiveEmphasisDefault,
                        hover: tokens.listItemColorBgInteractiveEmphasisHover,
                        focus: tokens.listItemColorBgInteractiveEmphasisFocus,
                        selected: {
                            default: tokens.listItemColorBgInteractiveEmphasisSelectedDefault,
                            hover: tokens.listItemColorBgInteractiveEmphasisSelectedHover
                        }
                    }
                }
            },
            disabled: {
                background: {
                    color: {
                        default: tokens.listItemColorBgInteractiveDisabled
                    }
                },
                text: {
                    color: {
                        default: tokens.listItemColorTextDisabled
                    }
                }
            }
        }
    };
};
var $92b07c7988c9e1a7$export$2e2bcd8739ae039 = $92b07c7988c9e1a7$var$listItemPalette;


const $0d021b6e14b25f6f$var$menuItemPallete = (tokens)=>{
    return {
        font: {
            family: tokens.menuItemFontFamily,
            weight: {
                default: tokens.menuItemFontWeightDefault,
                nested: tokens.menuItemFontWeightNested
            },
            size: tokens.menuItemFontSize,
            lineHeight: tokens.menuItemLineHeight,
            letterSpacing: tokens.menuItemLetterSpacing
        },
        background: {
            color: tokens.menuItemColorBgDefault,
            hover: tokens.menuItemColorBgHover,
            selected: {
                color: tokens.menuItemColorBgSelectedDefault,
                hover: tokens.menuItemColorBgSelectedHover
            },
            disabled: tokens.menuItemColorBgDisabled,
            focus: tokens.menuItemColorBgFocus
        },
        border: {
            color: tokens.menuItemColorBorderDefault,
            hover: tokens.menuItemColorBorderHover,
            selected: {
                color: tokens.menuItemColorBorderSelectedDefault,
                hover: tokens.menuItemColorBorderSelectedHover
            },
            disabled: tokens.menuItemColorBorderDisabled,
            focus: tokens.menuItemColorBorderFocus,
            width: tokens.menuItemBorderWidth,
            radius: tokens.menuItemRadius
        },
        text: {
            color: tokens.menuItemColorTextDefault,
            hover: tokens.menuItemColorTextHover,
            selected: tokens.menuItemColorTextSelected,
            disabled: tokens.menuItemColorTextDisabled,
            focus: tokens.menuItemColorTextFocus
        },
        padding: {
            default: tokens.menuItemPadding,
            // TODO: Tokenize this value
            nested: '16px'
        }
    };
};
var $0d021b6e14b25f6f$export$2e2bcd8739ae039 = $0d021b6e14b25f6f$var$menuItemPallete;


const $1192598d22019c55$var$menuPallete = (tokens)=>{
    return {
        background: {
            color: tokens.menuColorBg
        },
        border: {
            color: tokens.menuColorBorder,
            width: tokens.menuBorderWidth,
            radius: tokens.menuRadius
        },
        padding: tokens.menuPadding,
        spaceBetween: tokens.menuSpaceBetween,
        boxShadow: tokens.menuBoxShadow
    };
};
var $1192598d22019c55$export$2e2bcd8739ae039 = $1192598d22019c55$var$menuPallete;


const $4c38ce0e67f9e264$var$navigationPalette = (tokens)=>{
    return {
        container: {
            primary: {
                background: {
                    default: tokens.navigationNavContainerPrimaryColorBg
                },
                border: {
                    width: tokens.navigationNavContainerPrimaryBorderWidth,
                    default: tokens.navigationNavContainerPrimaryColorBorder,
                    radius: tokens.navigationNavContainerPrimaryRadius
                },
                padding: tokens.navigationNavContainerPrimaryPadding,
                width: tokens.navigationNavContainerPrimaryWidth,
                spaceBetween: tokens.navigationNavContainerPrimarySpaceBetween
            },
            secondary: {
                background: {
                    default: tokens.navigationNavContainerSecondaryColorBg
                },
                border: {
                    width: tokens.navigationNavContainerSecondaryBorderWidth,
                    default: tokens.navigationNavContainerSecondaryColorBorder,
                    radius: tokens.navigationNavContainerSecondaryRadius
                },
                padding: tokens.navigationNavContainerSecondaryPadding,
                width: tokens.navigationNavContainerSecondaryMinWidth,
                spaceBetween: tokens.navigationNavContainerSecondarySpaceBetween
            }
        },
        logo: {
            paddingTop: tokens.aliasesSpaceContainerSpacious,
            paddingBottom: tokens.aliasesSpaceContainerDefault
        },
        accountSwitcher: {
            border: {
                width: tokens.navigationAccountSwitcherBorderWidthDefault,
                radius: {
                    top: tokens.navigationAccountSwitcherRadiusTop,
                    bottom: tokens.navigationAccountSwitcherRadiusBottom
                }
            },
            font: {
                family: tokens.navigationAccountSwitcherFontFamily,
                size: tokens.navigationAccountSwitcherFontSize,
                weight: tokens.navigationAccountSwitcherFontWeight,
                lineHeight: tokens.navigationAccountSwitcherLineHeight,
                letterSpacing: tokens.navigationAccountSwitcherLetterspacing
            },
            color: {
                background: {
                    default: tokens.navigationAccountSwitcherColorBgDefault,
                    hover: tokens.navigationAccountSwitcherColorBgHover,
                    disabled: tokens.navigationAccountSwitcherColorBgDisabled,
                    selected: tokens.navigationAccountSwitcherColorBgSelected,
                    focus: tokens.navigationAccountSwitcherColorBgFocus
                },
                border: {
                    default: tokens.navigationAccountSwitcherColorBorderDefault,
                    hover: tokens.navigationAccountSwitcherColorBorderHover,
                    disabled: tokens.navigationAccountSwitcherColorBorderDisabled,
                    selected: tokens.navigationAccountSwitcherColorBorderSelected,
                    focus: tokens.navigationAccountSwitcherColorBorderFocus
                },
                text: {
                    default: tokens.navigationAccountSwitcherColorTextDefault,
                    disabled: tokens.navigationAccountSwitcherColorTextDisabled,
                    selected: tokens.navigationAccountSwitcherColorTextSelected
                }
            }
        }
    };
};
var $4c38ce0e67f9e264$export$2e2bcd8739ae039 = $4c38ce0e67f9e264$var$navigationPalette;


const $e99dac04e8017010$var$numberPalette = (tokens)=>{
    return {
        border: {
            width: {
                default: tokens.numberBorderWidthDefault,
                outlined: tokens.numberBorderWidthOutlined
            },
            radius: {
                default: tokens.numberBorderRadiusDefault,
                round: tokens.numberBorderRadiusRound
            }
        },
        size: {
            small: {
                height: tokens.numberHeightS,
                width: tokens.numberMinWidthS,
                padding: tokens.numberPaddingS
            },
            medium: {
                height: tokens.numberHeightM,
                width: tokens.numberMinWidthM,
                padding: tokens.numberPaddingM
            },
            input: {
                height: tokens.numberHeightInput,
                width: tokens.numberMinWidthInput,
                padding: tokens.numberPaddingInput
            }
        },
        font: {
            family: tokens.numberFontFamily,
            weight: tokens.numberFontWeight,
            letterSpacing: tokens.numberLetterSpacing,
            small: {
                size: tokens.numberFontSizeSmall,
                lineHeight: tokens.numberLineHeightSmall
            },
            medium: {
                size: tokens.numberFontSizeMedium,
                lineHeight: tokens.numberLineHeightMedium
            },
            input: {
                size: tokens.numberFontSizeInput,
                lineHeight: tokens.numberLineHeightInput
            }
        },
        static: {
            subtle: {
                background: tokens.numberColorBgStaticSubtle,
                border: tokens.numberColorBorderStaticSubtle,
                text: tokens.numberColorTextStaticSubtle
            },
            emphasis: {
                background: tokens.numberColorBgStaticEmphasis,
                border: tokens.numberColorBorderStaticEmphasis,
                text: tokens.numberColorTextStaticEmphasis
            },
            neutral: {
                background: tokens.numberColorBgStaticNeutral,
                border: tokens.numberColorBorderStaticNeutral,
                text: tokens.numberColorTextStaticNeutral
            }
        },
        interactive: {
            subtle: {
                background: {
                    default: tokens.numberColorBgInteractiveSubtleDefault,
                    hover: tokens.numberColorBgInteractiveSubtleHover,
                    focus: tokens.numberColorBgInteractiveSubtleFocus,
                    selected: {
                        default: tokens.numberColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.numberColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.numberColorBorderInteractiveSubtleDefault,
                    hover: tokens.numberColorBorderInteractiveSubtleHover,
                    focus: tokens.numberColorBorderInteractiveSubtleFocus,
                    selected: {
                        default: tokens.numberColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.numberColorBorderInteractiveSubtleSelectedHover
                    }
                },
                text: tokens.numberColorTextInteractiveSubtle
            },
            neutral: {
                background: {
                    default: tokens.numberColorBgInteractiveNeutralDefault,
                    hover: tokens.numberColorBgInteractiveNeutralHover,
                    focus: tokens.numberColorBgInteractiveNeutralFocus,
                    selected: {
                        default: tokens.numberColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.numberColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.numberColorBorderInteractiveNeutralDefault,
                    hover: tokens.numberColorBorderInteractiveNeutralHover,
                    focus: tokens.numberColorBorderInteractiveNeutralFocus,
                    selected: {
                        default: tokens.numberColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.numberColorBorderInteractiveNeutralSelectedHover
                    }
                },
                text: tokens.numberColorTextInteractiveSubtle
            },
            emphasis: {
                background: {
                    default: tokens.numberColorBgInteractiveEmphasisDefault,
                    hover: tokens.numberColorBgInteractiveEmphasisHover,
                    focus: tokens.numberColorBgInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.numberColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.numberColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.numberColorBorderInteractiveEmphasisDefault,
                    hover: tokens.numberColorBorderInteractiveEmphasisHover,
                    focus: tokens.numberColorBorderInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.numberColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.numberColorBorderInteractiveEmphasisSelectedHover
                    }
                },
                text: tokens.numberColorTextInteractiveSubtle
            }
        },
        error: {
            subtle: {
                background: {
                    default: tokens.numberColorBgErrorSubtle
                },
                text: tokens.numberColorTextError
            }
        }
    };
};
var $e99dac04e8017010$export$2e2bcd8739ae039 = $e99dac04e8017010$var$numberPalette;


const $a9ebd75b6eb013d5$var$selectPalette = (tokens)=>{
    return {
        container: {
            padding: tokens.textfieldPadding,
            border: {
                // TODO: ask Ann about rednaming to border radius
                radius: tokens.textfieldRadius,
                width: tokens.textfieldBorderWidth,
                default: tokens.textfieldColorBorderDefault,
                hover: tokens.textfieldColorBorderHover,
                focus: tokens.textfieldColorBorderFocus,
                disabled: tokens.textfieldColorBorderDisabled,
                error: tokens.textfieldColorBorderError
            },
            background: {
                default: tokens.textfieldColorBgDefault,
                hover: tokens.textfieldColorBgHover,
                focus: tokens.textfieldColorBgFocus,
                disabled: tokens.textfieldColorBgDisabled,
                error: tokens.textfieldColorBgError
            },
            text: {
                default: tokens.textfieldColorTextEnteredDefault,
                disabled: tokens.textfieldColorTextEnteredDisabled,
                error: tokens.textfieldColorTextLabelError,
                label: {
                    default: tokens.textfieldColorTextLabelDefault,
                    disabled: tokens.textfieldColorTextLabelDisabled,
                    error: tokens.textfieldColorTextLabelError
                },
                placeholder: {
                    default: tokens.textfieldColorTextPlaceholderDefault,
                    disabled: tokens.textfieldColorTextPlaceholderDisabled
                },
                helperText: {
                    default: tokens.textfieldColorTextHelperTextDefault,
                    disabled: tokens.textfieldColorTextHelperTextDisabled
                }
            }
        },
        containerless: {
            padding: tokens.selectContainerlessPadding,
            border: {
                radius: tokens.selectContainerlessRadius,
                width: tokens.selectContainerlessBorderWidth,
                default: tokens.selectContainerlessColorBorderDefault,
                hover: tokens.selectContainerlessColorBorderHover,
                focus: tokens.selectContainerlessColorBorderFocus,
                disabled: tokens.selectContainerlessColorBorderDisabled,
                error: tokens.selectContainerlessColorBorderError
            },
            background: {
                default: tokens.selectContainerlessColorBgDefault,
                hover: tokens.selectContainerlessColorBgHover,
                focus: tokens.selectContainerlessColorBgFocus,
                disabled: tokens.selectContainerlessColorBgDisabled,
                error: tokens.selectContainerlessColorBgError
            },
            text: {
                default: tokens.selectContainerlessColorTextDefault,
                disabled: tokens.selectContainerlessColorTextDisabled,
                error: tokens.selectContainerlessColorTextError
            }
        }
    };
};
var $a9ebd75b6eb013d5$export$2e2bcd8739ae039 = $a9ebd75b6eb013d5$var$selectPalette;


const $12410328b12e67e8$var$sizePalette = (tokens)=>{
    return {
        width: {
            column: {
                column1: tokens.aliasesSizeWidthColumn1,
                column2: tokens.aliasesSizeWidthColumn2,
                column3: tokens.aliasesSizeWidthColumn3,
                column4: tokens.aliasesSizeWidthColumn4,
                column6: tokens.aliasesSizeWidthColumn6,
                column8: tokens.aliasesSizeWidthColumn8
            },
            desktop: {
                default: tokens.aliasesSizeWidthDesktopDefault
            }
        },
        height: {
            input: {
                dense: tokens.aliasesSizeHeightInputDense
            },
            desktop: {
                default: tokens.aliasesSizeHeightDesktopDefault
            }
        },
        component: {
            xxlarge: tokens.aliasesSizeComponentXxl,
            xlarge: tokens.aliasesSizeComponentXl,
            medium: tokens.aliasesSizeComponentM
        }
    };
};
var $12410328b12e67e8$export$2e2bcd8739ae039 = $12410328b12e67e8$var$sizePalette;


const $cec65a54921179c3$var$skeletonPalette = (tokens)=>{
    return {
        background: tokens.skeletonColorBg,
        border: {
            default: tokens.skeletonColorBorder,
            width: tokens.skeletonBorderWidthNone,
            radius: {
                round: tokens.skeletonRadiusRound,
                sharp: tokens.skeletonRadiusSharp
            }
        }
    };
};
var $cec65a54921179c3$export$2e2bcd8739ae039 = $cec65a54921179c3$var$skeletonPalette;


const $d84982b4e2b7da8a$export$eafa69b831644b49 = (tokens)=>{
    return {
        container: {
            default: tokens.aliasesSpaceContainerDefault,
            dense: tokens.aliasesSpaceContainerDense,
            spacious: tokens.aliasesSpaceContainerSpacious
        },
        component: {
            default: tokens.aliasesSpaceComponentDefault,
            dense: tokens.aliasesSpaceComponentDense,
            spacious: tokens.aliasesSpaceComponentSpacious,
            particle: tokens.aliasesSpaceComponentParticle
        }
    };
};
var $d84982b4e2b7da8a$export$2e2bcd8739ae039 = $d84982b4e2b7da8a$export$eafa69b831644b49;


const $3eb6f3abdd87d512$var$stepperPalette = (tokens)=>{
    return {
        spaceBetween: tokens.stepperSpaceBetween,
        padding: tokens.stepperPadding
    };
};
var $3eb6f3abdd87d512$export$2e2bcd8739ae039 = $3eb6f3abdd87d512$var$stepperPalette;


const $7362dfc90b35e0f0$var$switchPalette = (tokens)=>{
    return {
        knob: {
            size: {
                medium: tokens.switchKnobSizeM
            },
            background: {
                selected: {
                    default: tokens.switchKnobColorBgSelectedDefault,
                    hover: tokens.switchKnobColorBgSelectedHover,
                    disabled: tokens.switchKnobColorBgSelectedDisabled
                },
                unselected: {
                    default: tokens.switchKnobColorBgUnselectedDefault,
                    hover: tokens.switchKnobColorBgUnselectedHover,
                    disabled: tokens.switchKnobColorBgUnselectedDisabled
                }
            },
            border: {
                width: tokens.switchKnobBorderWidth,
                radius: tokens.switchKnobRadius,
                selected: {
                    default: tokens.switchKnobColorBorderSelectedDefault,
                    hover: tokens.switchKnobColorBorderSelectedHover,
                    disabled: tokens.switchKnobColorBorderSelectedDisabled
                },
                unselected: {
                    default: tokens.switchKnobColorBorderUnselectedDefault,
                    hover: tokens.switchKnobColorBorderUnselectedHover,
                    disabled: tokens.switchKnobColorBorderUnselectedDisabled
                }
            }
        },
        track: {
            size: {
                medium: {
                    width: tokens.switchTrackSizeMMinWidth,
                    height: tokens.switchTrackSizeMMinHeight
                }
            },
            background: {
                selected: {
                    default: tokens.switchTrackColorBgSelectedDefault,
                    hover: tokens.switchTrackColorBgSelectedHover,
                    disabled: tokens.switchTrackColorBgSelectedDisabled
                },
                unselected: {
                    default: tokens.switchTrackColorBgUnselectedDefault,
                    hover: tokens.switchTrackColorBgUnselectedHover,
                    disabled: tokens.switchTrackColorBgUnselectedDisabled
                }
            },
            border: {
                width: tokens.switchTrackBorderWidth,
                radius: tokens.switchTrackRadius,
                selected: {
                    default: tokens.switchTrackColorBorderSelectedDefault,
                    hover: tokens.switchTrackColorBorderSelectedHover,
                    disabled: tokens.switchTrackColorBorderSelectedDisabled
                },
                unselected: {
                    default: tokens.switchTrackColorBorderUnselectedDefault,
                    hover: tokens.switchTrackColorBorderUnselectedHover,
                    disabled: tokens.switchTrackColorBorderUnselectedDisabled
                }
            }
        }
    };
};
var $7362dfc90b35e0f0$export$2e2bcd8739ae039 = $7362dfc90b35e0f0$var$switchPalette;


const $52d9ab92ecd86a6b$var$tabPalette = (tokens)=>{
    return {
        padding: tokens.tabPadding,
        spaceBetween: tokens.tabSpaceBetween,
        font: {
            fontFamily: tokens.tabFontFamily,
            fontSize: tokens.tabFontSize,
            fontWeight: tokens.tabFontWeight
        },
        background: {
            default: tokens.tabColorBgDefaultDefault,
            hover: tokens.tabColorBgDefaultHover,
            focus: tokens.tabColorBgDefaultFocus,
            selected: {
                default: tokens.tabColorBgSelectedDefault,
                hover: tokens.tabColorBgSelectedHover,
                focus: tokens.tabColorBgSelectedFocus
            }
        },
        border: {
            default: tokens.tabColorBorderDefaultDefault,
            hover: tokens.tabColorBorderDefaultHover,
            focus: tokens.tabColorBorderDefaultFocus,
            selected: {
                default: tokens.tabColorBorderSelectedDefault,
                hover: tokens.tabColorBorderSelectedHover,
                focus: tokens.tabColorBorderSelectedFocus
            },
            radius: tokens.tabRadius,
            width: {
                horizontal: {
                    bottom: tokens.tabBorderWidthHorizontalDefaultBottom,
                    top: tokens.tabBorderWidthHorizontalDefaultTop,
                    left: tokens.tabBorderWidthHorizontalDefaultLeft,
                    right: tokens.tabBorderWidthHorizontalDefaultRight,
                    selected: {
                        bottom: tokens.tabBorderWidthHorizontalSelectedBottom,
                        top: tokens.tabBorderWidthHorizontalSelectedTop,
                        left: tokens.tabBorderWidthHorizontalSelectedLeft,
                        right: tokens.tabBorderWidthHorizontalSelectedRight
                    }
                },
                vertical: {
                    bottom: tokens.tabBorderWidthVerticalDefaultBottom,
                    top: tokens.tabBorderWidthVerticalDefaultTop,
                    left: tokens.tabBorderWidthVerticalDefaultLeft,
                    right: tokens.tabBorderWidthVerticalDefaultRight,
                    selected: {
                        bottom: tokens.tabBorderWidthVerticalSelectedBottom,
                        top: tokens.tabBorderWidthVerticalSelectedTop,
                        left: tokens.tabBorderWidthVerticalSelectedLeft,
                        right: tokens.tabBorderWidthVerticalSelectedRight
                    }
                }
            }
        },
        text: {
            default: tokens.tabColorTextDefault,
            selected: tokens.tabColorTextSelected
        }
    };
};
var $52d9ab92ecd86a6b$export$2e2bcd8739ae039 = $52d9ab92ecd86a6b$var$tabPalette;


const $683cb7ccfb4b5ab8$var$textFieldPalette = (tokens)=>{
    return {
        radius: tokens.textfieldRadius,
        padding: tokens.textfieldPadding,
        spaceBetween: tokens.textfieldSpaceBetween,
        font: {
            family: tokens.textfieldFontFamily,
            size: tokens.textfieldFontSize,
            lineHeight: tokens.textfieldLineHeight,
            weight: tokens.textfieldFontWeight,
            letterSpacing: tokens.textfieldLetterSpacing
        },
        background: {
            default: tokens.textfieldColorBgDefault,
            hover: tokens.textfieldColorBgHover,
            focus: tokens.textfieldColorBgFocus,
            disabled: tokens.textfieldColorBgDisabled,
            error: tokens.textfieldColorBgError
        },
        border: {
            width: tokens.textfieldBorderWidth,
            default: tokens.textfieldColorBorderDefault,
            hover: tokens.textfieldColorBorderHover,
            focus: tokens.textfieldColorBorderFocus,
            disabled: tokens.textfieldColorBorderDisabled,
            error: tokens.textfieldColorBorderError
        },
        helpText: {
            font: {
                family: tokens.helpTextFontFamily,
                size: tokens.helpTextFontSize,
                weight: tokens.helpTextFontWeight,
                lineHeight: tokens.helpTextLineHeight,
                letterSpacing: tokens.helpTextLetterSpacing
            },
            text: {
                default: tokens.textfieldColorTextHelperTextDefault,
                disabled: tokens.textfieldColorTextHelperTextDisabled,
                error: tokens.textfieldColorTextHelperTextError
            }
        },
        label: {
            text: {
                default: tokens.textfieldColorTextLabelDefault,
                disabled: tokens.textfieldColorTextLabelDisabled,
                error: tokens.textfieldColorTextLabelError
            }
        },
        placeholder: {
            text: {
                default: tokens.textfieldColorTextPlaceholderDefault,
                disabled: tokens.textfieldColorTextPlaceholderDisabled
            }
        },
        textEntered: {
            text: {
                default: tokens.textfieldColorTextEnteredDefault,
                disabled: tokens.textfieldColorTextEnteredDisabled
            }
        }
    };
};
var $683cb7ccfb4b5ab8$export$2e2bcd8739ae039 = $683cb7ccfb4b5ab8$var$textFieldPalette;


const $79c4526adf541008$var$toggleControlsPalette = (tokens)=>{
    return {
        size: {
            default: tokens.toggleControlsSizeDefault,
            small: tokens.toggleControlsSizeS
        },
        padding: tokens.toggleControlsPadding,
        border: {
            width: tokens.toggleControlsBorderWidthWrapper,
            radius: {
                square: tokens.toggleControlsRadiusSquare,
                round: tokens.toggleControlsRadiusRound
            }
        },
        wrapper: {
            unselected: {
                background: {
                    default: tokens.toggleControlsColorWrapperBgUnselectedDefault,
                    hover: tokens.toggleControlsColorWrapperBgUnselectedHover,
                    focus: tokens.toggleControlsColorWrapperBgUnselectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBgUnselectedDisabled
                },
                border: {
                    default: tokens.toggleControlsColorWrapperBorderUnselectedDefault,
                    hover: tokens.toggleControlsColorWrapperBorderUnselectedHover,
                    focus: tokens.toggleControlsColorWrapperBorderUnselectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBorderUnselectedDisabled
                }
            },
            selected: {
                background: {
                    default: tokens.toggleControlsColorWrapperBgSelectedDefault,
                    hover: tokens.toggleControlsColorWrapperBgSelectedHover,
                    focus: tokens.toggleControlsColorWrapperBgSelectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBgSelectedDisabled
                },
                border: {
                    default: tokens.toggleControlsColorWrapperBorderSelectedDefault,
                    hover: tokens.toggleControlsColorWrapperBorderSelectedHover,
                    focus: tokens.toggleControlsColorWrapperBorderSelectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBorderSelectedDisabled
                }
            },
            indeterminate: {
                background: {
                    default: tokens.toggleControlsColorWrapperBgIndeterminateDefault,
                    hover: tokens.toggleControlsColorWrapperBgIndeterminateHover,
                    focus: tokens.toggleControlsColorWrapperBgIndeterminateFocus,
                    disabled: tokens.toggleControlsColorWrapperBgIndeterminateDisabled
                },
                border: {
                    default: tokens.toggleControlsColorWrapperBorderIndeterminateDefault,
                    hover: tokens.toggleControlsColorWrapperBorderIndeterminateHover,
                    focus: tokens.toggleControlsColorWrapperBorderIndeterminateFocus,
                    disabled: tokens.toggleControlsColorWrapperBorderIndeterminateDisabled
                }
            }
        },
        icon: {
            unselected: {
                background: {
                    default: tokens.toggleControlsColorIconBgUnselectedDefault,
                    hover: tokens.toggleControlsColorIconBgUnselectedHover,
                    focus: tokens.toggleControlsColorIconBgUnselectedFocus,
                    disabled: tokens.toggleControlsColorIconBgUnselectedDisabled
                }
            },
            selected: {
                background: {
                    default: tokens.toggleControlsColorIconBgSelectedDefault,
                    hover: tokens.toggleControlsColorIconBgSelectedHover,
                    focus: tokens.toggleControlsColorIconBgSelectedFocus,
                    disabled: tokens.toggleControlsColorIconBgSelectedDisabled
                }
            },
            indeterminate: {
                background: {
                    default: tokens.toggleControlsColorIconBgIndeterminateDefault,
                    hover: tokens.toggleControlsColorIconBgIndeterminateHover,
                    focus: tokens.toggleControlsColorIconBgIndeterminateFocus,
                    disabled: tokens.toggleControlsColorIconBgIndeterminateDisabled
                }
            }
        }
    };
};
var $79c4526adf541008$export$2e2bcd8739ae039 = $79c4526adf541008$var$toggleControlsPalette;


const $83acb7a2e58c4cdc$var$tooltipPalette = (tokens)=>{
    return {
        padding: tokens.tooltipPadding,
        font: {
            family: tokens.tooltipFontFamily,
            size: tokens.tooltipFontSize,
            lineHeight: tokens.tooltipLineHeight,
            weight: tokens.tooltipFontWeight,
            letterSpacing: tokens.tooltipLetterSpacing
        },
        border: {
            width: tokens.tooltipBorderWidth,
            radius: tokens.tooltipRadius,
            default: tokens.tooltipColorBorder
        },
        background: {
            default: tokens.tooltipColorBg
        },
        text: tokens.tooltipColorText
    };
};
var $83acb7a2e58c4cdc$export$2e2bcd8739ae039 = $83acb7a2e58c4cdc$var$tooltipPalette;


function $6bfd8d6935be102a$export$2e2bcd8739ae039(Tokens) {
    return {
        alert: (0, $d351e5d3980944f1$export$2e2bcd8739ae039)(Tokens),
        avatar: (0, $a66003c32b50e10c$export$2e2bcd8739ae039)(Tokens),
        badge: (0, $56642ff99bf45454$export$2e2bcd8739ae039)(Tokens),
        button: (0, $77a15c8f4ff219cb$export$2e2bcd8739ae039)(Tokens),
        card: (0, $cee12c1b7e20bf42$export$2e2bcd8739ae039)(Tokens),
        chip: (0, $90f69bedd3a89f82$export$2e2bcd8739ae039)(Tokens),
        customDivider: (0, $03e1c3364b7a6336$export$2e2bcd8739ae039)(Tokens),
        dialog: (0, $fcba45ae4d942e45$export$2e2bcd8739ae039)(Tokens),
        icon: (0, $a97d51c35d27f0b7$export$2e2bcd8739ae039)(Tokens),
        iconButton: (0, $284ab52022351cf0$export$2e2bcd8739ae039)(Tokens),
        linearProgress: (0, $4c5f0a3878c8720e$export$2e2bcd8739ae039)(Tokens),
        link: (0, $d320b5a01b7a514f$export$2e2bcd8739ae039)(Tokens),
        listItem: (0, $92b07c7988c9e1a7$export$2e2bcd8739ae039)(Tokens),
        menu: (0, $1192598d22019c55$export$2e2bcd8739ae039)(Tokens),
        menuItem: (0, $0d021b6e14b25f6f$export$2e2bcd8739ae039)(Tokens),
        navigation: (0, $4c38ce0e67f9e264$export$2e2bcd8739ae039)(Tokens),
        number: (0, $e99dac04e8017010$export$2e2bcd8739ae039)(Tokens),
        select: (0, $a9ebd75b6eb013d5$export$2e2bcd8739ae039)(Tokens),
        size: (0, $12410328b12e67e8$export$2e2bcd8739ae039)(Tokens),
        skeleton: (0, $cec65a54921179c3$export$2e2bcd8739ae039)(Tokens),
        space: (0, $d84982b4e2b7da8a$export$2e2bcd8739ae039)(Tokens),
        stepper: (0, $3eb6f3abdd87d512$export$2e2bcd8739ae039)(Tokens),
        switch: (0, $7362dfc90b35e0f0$export$2e2bcd8739ae039)(Tokens),
        tab: (0, $52d9ab92ecd86a6b$export$2e2bcd8739ae039)(Tokens),
        textField: (0, $683cb7ccfb4b5ab8$export$2e2bcd8739ae039)(Tokens),
        toggleControls: (0, $79c4526adf541008$export$2e2bcd8739ae039)(Tokens),
        tooltip: (0, $83acb7a2e58c4cdc$export$2e2bcd8739ae039)(Tokens),
        // static
        common: {
            black: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).black,
            white: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        },
        primary: {
            light: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).blue500,
            main: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).blue600,
            dark: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).blue700,
            contrastText: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        },
        secondary: {
            light: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).scaleGray500,
            main: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).scaleGray600,
            dark: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).scaleGray700,
            contrastText: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        },
        error: {
            light: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).red300,
            main: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).red600,
            dark: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).red700,
            contrastText: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        },
        warning: {
            light: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).redOrange300,
            main: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).redOrange600,
            dark: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).redOrange700,
            contrastText: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        },
        info: {
            light: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).deepOcean300,
            main: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).deepOcean600,
            dark: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).deepOcean700,
            contrastText: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        },
        success: {
            light: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).green300,
            main: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).green600,
            dark: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).green700,
            contrastText: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        },
        text: {
            primary: Tokens.aliasesColorTextStaticEmphasis,
            secondary: Tokens.aliasesColorTextStaticSubtle,
            disabled: Tokens.aliasesColorTextInteractiveDisabled
        },
        background: {
            default: Tokens.aliasesColorBgStaticContainerSubtle,
            paper: (0, $7fcc7f5e18fb956e$export$2e2bcd8739ae039).white
        }
    };
}


const $98b57d0074acaad7$var$generateCaption = (tokens)=>({
        fontFamily: tokens.aliasesFontFamilyDefault,
        fontSize: tokens.aliasesFontSizeCaption,
        lineHeight: tokens.aliasesLineHeightCaption,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    });
const $98b57d0074acaad7$var$generatePromoCaption = (tokens)=>({
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeCaption,
        lineHeight: '125%',
        letterSpacing: tokens.aliasesLetterSpacingDefault
    });
const $98b57d0074acaad7$var$generateTypography = (tokens)=>({
        fontWeightBold: tokens.aliasesFontWeightEmphasis,
        fontWeightMedium: tokens.aliasesFontWeightNeutral,
        fontWeightRegular: tokens.aliasesFontWeightDefault,
        fontWeightLight: tokens.aliasesFontWeightDefault,
        fontSize: parseFloat(tokens.aliasesFontSizeDefault),
        h1: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyHeader,
            fontSize: tokens.aliasesFontSizeH1,
            fontWeight: tokens.aliasesFontWeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault,
            lineHeight: tokens.aliasesLineHeightH1
        },
        h2: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyHeader,
            fontSize: tokens.aliasesFontSizeH2,
            fontWeight: tokens.aliasesFontWeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault,
            lineHeight: tokens.aliasesLineHeightH2
        },
        h3: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyHeader,
            fontSize: tokens.aliasesFontSizeH3,
            fontWeight: tokens.aliasesFontWeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault,
            lineHeight: tokens.aliasesLineHeightH3
        },
        h4: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyDefault,
            fontSize: tokens.aliasesFontSizeH4,
            fontWeight: tokens.aliasesFontWeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault,
            lineHeight: tokens.aliasesLineHeightH4
        },
        caption: Object.assign(Object.assign({}, $98b57d0074acaad7$var$generateCaption(tokens)), {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontWeight: tokens.aliasesFontWeightEmphasis
        }),
        captionNeutral: Object.assign(Object.assign({}, $98b57d0074acaad7$var$generateCaption(tokens)), {
            color: tokens.aliasesColorTextStaticSubtle,
            fontWeight: tokens.aliasesFontWeightNeutral
        }),
        captionSubtle: Object.assign(Object.assign({}, $98b57d0074acaad7$var$generateCaption(tokens)), {
            color: tokens.aliasesColorTextStaticSubtle,
            fontWeight: tokens.aliasesFontWeightDefault
        }),
        body1: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyDefault,
            fontSize: tokens.aliasesFontSizeDefault,
            fontWeight: tokens.aliasesFontWeightDefault,
            lineHeight: tokens.aliasesLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        body1Bold: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyDefault,
            fontSize: tokens.aliasesFontSizeDefault,
            fontWeight: tokens.aliasesFontWeightEmphasis,
            lineHeight: tokens.aliasesLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        micro: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyDefault,
            fontSize: tokens.aliasesFontSizeMicro,
            fontWeight: tokens.aliasesFontWeightDefault,
            lineHeight: tokens.aliasesLineHeightMicro,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        promoH1: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyPromo,
            fontSize: tokens.aliasesPromoFontSizeH1,
            fontWeight: tokens.aliasesPromoFontWeightDefault,
            lineHeight: tokens.aliasesPromoLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        promoH2: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyPromo,
            fontSize: tokens.aliasesPromoFontSizeH2,
            fontWeight: tokens.aliasesPromoFontWeightDefault,
            lineHeight: tokens.aliasesPromoLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        promoH3: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyPromo,
            fontSize: tokens.aliasesPromoFontSizeH3,
            fontWeight: tokens.aliasesPromoFontWeightDefault,
            lineHeight: tokens.aliasesPromoLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        promoH4: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyPromo,
            fontSize: tokens.aliasesPromoFontSizeH4,
            fontWeight: tokens.aliasesPromoFontWeightDefault,
            lineHeight: tokens.aliasesPromoLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        promoBody1: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyPromo,
            fontSize: tokens.aliasesPromoFontSizeDefault,
            fontWeight: tokens.aliasesPromoFontWeightDefault,
            lineHeight: tokens.aliasesPromoLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        promoBody1Bold: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyPromo,
            fontSize: tokens.aliasesPromoFontSizeDefault,
            fontWeight: tokens.aliasesPromoFontWeightEmphasis,
            lineHeight: tokens.aliasesPromoLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault
        },
        promoCaption: Object.assign(Object.assign({}, $98b57d0074acaad7$var$generatePromoCaption(tokens)), {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontWeight: tokens.aliasesPromoFontWeightEmphasis
        }),
        promoCaptionNeutral: Object.assign(Object.assign({}, $98b57d0074acaad7$var$generatePromoCaption(tokens)), {
            color: tokens.aliasesColorTextStaticSubtle,
            fontWeight: tokens.aliasesPromoFontWeightNeutral
        }),
        promoCaptionSubtle: Object.assign(Object.assign({}, $98b57d0074acaad7$var$generatePromoCaption(tokens)), {
            color: tokens.aliasesColorTextStaticSubtle,
            fontWeight: tokens.aliasesPromoFontWeightDefault
        }),
        promoMicro: {
            color: tokens.aliasesColorTextStaticEmphasis,
            fontFamily: tokens.aliasesFontFamilyPromo,
            fontSize: tokens.aliasesPromoFontSizeMicro,
            fontWeight: tokens.aliasesPromoFontWeightEmphasis,
            lineHeight: '125%',
            letterSpacing: tokens.aliasesLetterSpacingDefault
        }
    });
var $98b57d0074acaad7$export$2e2bcd8739ae039 = $98b57d0074acaad7$var$generateTypography;


const $62238ea45f497d85$var$themeFont = 'Manrope';
const $62238ea45f497d85$var$palette = (0, $6bfd8d6935be102a$export$2e2bcd8739ae039)($8b8adca400ca855b$exports);
const $62238ea45f497d85$var$typography = (0, $98b57d0074acaad7$export$2e2bcd8739ae039)($8b8adca400ca855b$exports);
const $62238ea45f497d85$var$cudaLight = (0, $ijOKP.default)({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    WebkitFontSmoothing: 'antialiased',
                    textRendering: 'optimizeLegibility',
                    fontSynthesis: 'none'
                },
                body: {
                    WebkitFontSmoothing: 'antialiased',
                    textRendering: 'optimizeLegibility',
                    fontSynthesis: 'none',
                    fontFamily: $62238ea45f497d85$var$themeFont
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                thumb: {
                    backgroundColor: $8b8adca400ca855b$exports.switchKnobColorBgUnselectedDefault,
                    '&$checked': {
                        backgroundColor: $8b8adca400ca855b$exports.switchKnobColorBgSelectedDefault
                    },
                    borderWidth: $8b8adca400ca855b$exports.switchKnobBorderWidth,
                    borderRadius: $8b8adca400ca855b$exports.switchKnobRadius
                },
                track: {
                    backgroundColor: $8b8adca400ca855b$exports.switchTrackColorBgUnselectedDefault,
                    '&$checked': {
                        backgroundColor: $8b8adca400ca855b$exports.switchTrackColorBgSelectedDefault
                    },
                    borderWidth: $8b8adca400ca855b$exports.switchTrackBorderWidth,
                    borderRadius: $8b8adca400ca855b$exports.switchTrackRadius
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: $8b8adca400ca855b$exports.buttonRadius,
                    borderWidth: $8b8adca400ca855b$exports.buttonBorderWidth,
                    fontFamily: $62238ea45f497d85$var$themeFont
                },
                containedPrimary: {
                    boxShadow: 'none',
                    backgroundColor: $8b8adca400ca855b$exports.buttonColorBgEmphasisDefault,
                    color: $8b8adca400ca855b$exports.buttonColorTextEmphasis,
                    '&:hover': {
                        backgroundColor: $8b8adca400ca855b$exports.buttonColorBgEmphasisHover
                    },
                    '&:disabled': {
                        backgroundColor: $8b8adca400ca855b$exports.buttonColorBgDisabled,
                        color: $8b8adca400ca855b$exports.buttonColorTextDisabled
                    }
                },
                containedSecondary: {
                    boxShadow: 'none',
                    backgroundColor: $8b8adca400ca855b$exports.buttonColorBgNeutralDefault,
                    color: $8b8adca400ca855b$exports.buttonColorTextNeutral,
                    '&:hover': {
                        backgroundColor: $8b8adca400ca855b$exports.buttonColorBgNeutralHover
                    },
                    '&:disabled': {
                        backgroundColor: $8b8adca400ca855b$exports.buttonColorBgDisabled,
                        color: $8b8adca400ca855b$exports.buttonColorTextDisabled
                    }
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderWidth: $8b8adca400ca855b$exports.alertBorderWidth,
                    borderRadius: $8b8adca400ca855b$exports.alertRadius
                },
                standardWarning: {
                    backgroundColor: $8b8adca400ca855b$exports.alertColorBgWarningNeutral,
                    border: $8b8adca400ca855b$exports.alertColorBorderWarningNeutral
                },
                standardError: {
                    backgroundColor: $8b8adca400ca855b$exports.alertColorBgErrorNeutral,
                    border: $8b8adca400ca855b$exports.alertColorBorderErrorNeutral
                },
                standardInfo: {
                    backgroundColor: $8b8adca400ca855b$exports.alertColorBgInfoNeutral,
                    border: $8b8adca400ca855b$exports.alertColorBorderInfoNeutral
                },
                standardSuccess: {
                    backgroundColor: $8b8adca400ca855b$exports.alertColorBgSuccessNeutral,
                    border: $8b8adca400ca855b$exports.alertColorBorderSuccessNeutral
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    borderRadius: $8b8adca400ca855b$exports.avatarRadiusRound,
                    borderWidth: $8b8adca400ca855b$exports.avatarBorderWidthDefault
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeSmall: {
                    height: $8b8adca400ca855b$exports.iconSizeS,
                    width: $8b8adca400ca855b$exports.iconSizeS
                },
                sizeMedium: {
                    height: $8b8adca400ca855b$exports.iconSizeM,
                    width: $8b8adca400ca855b$exports.iconSizeM
                },
                sizeLarge: {
                    height: $8b8adca400ca855b$exports.iconSizeL,
                    width: $8b8adca400ca855b$exports.iconSizeL
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: $8b8adca400ca855b$exports.chipRadiusRound,
                    borderWidth: $8b8adca400ca855b$exports.chipBorderWidth,
                    fontFamily: $62238ea45f497d85$var$themeFont
                },
                colorPrimary: {
                    backgroundColor: $8b8adca400ca855b$exports.chipColorBgInteractiveEmphasisDefault,
                    border: $8b8adca400ca855b$exports.chipColorBorderInteractiveEmphasisDefault,
                    '&.disabled': {
                        backgroundColor: $8b8adca400ca855b$exports.chipColorBgInteractiveDisabled,
                        border: $8b8adca400ca855b$exports.chipColorBorderInteractiveDisabled
                    }
                },
                colorSecondary: {
                    backgroundColor: $8b8adca400ca855b$exports.chipColorBgInteractiveNeutralDefault,
                    border: $8b8adca400ca855b$exports.chipColorBorderInteractiveNeutralDefault
                }
            }
        }
    },
    custom: {
        identifier: 'cudaLight'
    },
    palette: $62238ea45f497d85$var$palette,
    typography: $62238ea45f497d85$var$typography
});
var $62238ea45f497d85$export$2e2bcd8739ae039 = $62238ea45f497d85$var$cudaLight;



var $ijOKP = parcelRequire("ijOKP");



const $f77291b032ba1dcf$var$palette = (0, $6bfd8d6935be102a$export$2e2bcd8739ae039)($3276e9745553f254$exports);
const $f77291b032ba1dcf$var$typography = (0, $98b57d0074acaad7$export$2e2bcd8739ae039)($3276e9745553f254$exports);
const $f77291b032ba1dcf$var$themeFont = '"Roboto", "Helvetica", "Arial", sans-serif';
const $f77291b032ba1dcf$var$baseMui = (0, $ijOKP.default)({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    WebkitFontSmoothing: 'antialiased',
                    textRendering: 'optimizeLegibility',
                    fontSynthesis: 'none'
                },
                body: {
                    WebkitFontSmoothing: 'antialiased',
                    textRendering: 'optimizeLegibility',
                    fontSynthesis: 'none',
                    fontFamily: $f77291b032ba1dcf$var$themeFont
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                thumb: {
                    backgroundColor: $3276e9745553f254$exports.switchKnobColorBgUnselectedDefault,
                    '&$checked': {
                        backgroundColor: $3276e9745553f254$exports.switchKnobColorBgSelectedDefault
                    },
                    borderWidth: $3276e9745553f254$exports.switchKnobBorderWidth,
                    borderRadius: $3276e9745553f254$exports.switchKnobRadius
                },
                track: {
                    backgroundColor: $3276e9745553f254$exports.switchTrackColorBgUnselectedDefault,
                    '&$checked': {
                        backgroundColor: $3276e9745553f254$exports.switchTrackColorBgSelectedDefault
                    },
                    borderWidth: $3276e9745553f254$exports.switchTrackBorderWidth,
                    borderRadius: $3276e9745553f254$exports.switchTrackRadius
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: $3276e9745553f254$exports.buttonRadius,
                    borderWidth: $3276e9745553f254$exports.buttonBorderWidth,
                    fontFamily: $f77291b032ba1dcf$var$themeFont
                },
                containedPrimary: {
                    boxShadow: 'none',
                    backgroundColor: $3276e9745553f254$exports.buttonColorBgEmphasisDefault,
                    color: $3276e9745553f254$exports.buttonColorTextEmphasis,
                    '&:hover': {
                        backgroundColor: $3276e9745553f254$exports.buttonColorBgEmphasisHover
                    },
                    '&:disabled': {
                        backgroundColor: $3276e9745553f254$exports.buttonColorBgDisabled,
                        color: $3276e9745553f254$exports.buttonColorTextDisabled
                    }
                },
                containedSecondary: {
                    boxShadow: 'none',
                    backgroundColor: $3276e9745553f254$exports.buttonColorBgNeutralDefault,
                    color: $3276e9745553f254$exports.buttonColorTextNeutral,
                    '&:hover': {
                        backgroundColor: $3276e9745553f254$exports.buttonColorBgNeutralHover
                    },
                    '&:disabled': {
                        backgroundColor: $3276e9745553f254$exports.buttonColorBgDisabled,
                        color: $3276e9745553f254$exports.buttonColorTextDisabled
                    }
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderWidth: $3276e9745553f254$exports.alertBorderWidth,
                    borderRadius: $3276e9745553f254$exports.alertRadius
                },
                standardWarning: {
                    backgroundColor: $3276e9745553f254$exports.alertColorBgWarningNeutral,
                    border: $3276e9745553f254$exports.alertColorBorderWarningNeutral
                },
                standardError: {
                    backgroundColor: $3276e9745553f254$exports.alertColorBgErrorNeutral,
                    border: $3276e9745553f254$exports.alertColorBorderErrorNeutral
                },
                standardInfo: {
                    backgroundColor: $3276e9745553f254$exports.alertColorBgInfoNeutral,
                    border: $3276e9745553f254$exports.alertColorBorderInfoNeutral
                },
                standardSuccess: {
                    backgroundColor: $3276e9745553f254$exports.alertColorBgSuccessNeutral,
                    border: $3276e9745553f254$exports.alertColorBorderSuccessNeutral
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    borderRadius: $3276e9745553f254$exports.avatarRadiusRound
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeSmall: {
                    height: $3276e9745553f254$exports.iconSizeS,
                    width: $3276e9745553f254$exports.iconSizeS
                },
                sizeMedium: {
                    height: $3276e9745553f254$exports.iconSizeM,
                    width: $3276e9745553f254$exports.iconSizeM
                },
                sizeLarge: {
                    height: $3276e9745553f254$exports.iconSizeL,
                    width: $3276e9745553f254$exports.iconSizeL
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: $3276e9745553f254$exports.chipRadiusRound,
                    borderWidth: $3276e9745553f254$exports.chipBorderWidth,
                    fontFamily: $f77291b032ba1dcf$var$themeFont
                },
                colorPrimary: {
                    backgroundColor: $3276e9745553f254$exports.chipColorBgInteractiveEmphasisDefault,
                    border: $3276e9745553f254$exports.chipColorBorderInteractiveEmphasisDefault,
                    '&.disabled': {
                        backgroundColor: $3276e9745553f254$exports.chipColorBgInteractiveDisabled,
                        border: $3276e9745553f254$exports.chipColorBorderInteractiveDisabled
                    }
                },
                colorSecondary: {
                    backgroundColor: $3276e9745553f254$exports.chipColorBgInteractiveNeutralDefault,
                    border: $3276e9745553f254$exports.chipColorBorderInteractiveNeutralDefault
                }
            }
        }
    },
    custom: {
        identifier: 'baseMui'
    },
    palette: $f77291b032ba1dcf$var$palette,
    typography: $f77291b032ba1dcf$var$typography
});
var $f77291b032ba1dcf$export$2e2bcd8739ae039 = $f77291b032ba1dcf$var$baseMui;


function $364a79af96a8cbfc$export$2e2bcd8739ae039({ children: children, useBdsTheme: useBdsTheme = true, useCssReset: useCssReset = true, selectedBdsTheme: selectedBdsTheme = 'baseMui', themeConfig: themeConfig = {}, fontFamilyOverride: fontFamilyOverride = '' }) {
    let theme = {};
    if (useBdsTheme) theme = selectedBdsTheme === 'baseMui' ? (0, $f77291b032ba1dcf$export$2e2bcd8739ae039) : (0, $62238ea45f497d85$export$2e2bcd8739ae039);
    const typography = Object.assign(Object.assign({}, theme.typography || {}), {
        fontFamily: fontFamilyOverride || (theme.typography ? theme.typography.fontFamily : 'Roboto, sans-serif' // Default will get changed to a token
        )
    });
    theme = Object.assign(Object.assign(Object.assign({}, theme), {
        typography: typography
    }), themeConfig);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4650f6dac4940cb$export$2e2bcd8739ae039), {
        theme: theme
    }, useCssReset ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c3dfe91526ac04a1$export$2e2bcd8739ae039), null) : null, children);
}


function $4c8cda5d2c6d1d8b$var$App() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364a79af96a8cbfc$export$2e2bcd8739ae039), {
        useBdsTheme: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad2279805e583d1$export$3b5c74f3f11c675d), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b488dbcce1c14ef$export$2e2bcd8739ae039), {})
            })
        })
    });
}
var $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = $4c8cda5d2c6d1d8b$var$App;


const $35da740d59af89ba$var$container = document.getElementById("app");
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($35da740d59af89ba$var$container);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=app.d6ed8a91.js.map
